_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[71,25,28,29,40,42],{

/***/ "+82i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productPriceRemoteResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");





var productPriceRemoteResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_PRICE_REMOTE */ "lb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var resortId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_3__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var query = "query {\n      bookingCriteria(resortId: \"".concat(resortId, "\") {\n        departureCities {\n          label: name\n          value\n        }\n        durations\n        initialTransport(resortId: \"").concat(resortId, "\")\n      }\n      config {\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_1__[/* priceRemote */ "d"](), "\n      }\n      product: resort(").concat(productArgs, ") {\n        badgeIcon\n        category\n        color\n        comfort\n        comfortLabel\n        destination {\n          country\n        }\n        id\n        isExplicitEC\n        isJoyview\n        name\n        relatedDestinations\n        type\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_PRODUCT_PRICE_REMOTE */ "rc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "+BJN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

function props() {
  return {
    componentId: function componentId() {
      return "collapse-panel-".concat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["random"])(1000, 10000));
    },
    collapseLabel: function collapseLabel(_ref) {
      var collapseLabels = _ref.collapseLabels;
      return collapseLabels.collapse || '';
    },
    expandLabel: function expandLabel(_ref2) {
      var collapseLabels = _ref2.collapseLabels;
      return collapseLabels.expand || '';
    },
    displayed: function displayed() {
      return true;
    }
  };
}

/***/ }),

/***/ "+IAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productWellnessLegacyResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productWellnessLegacyResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_WELLNESS */ "ub"],
  props: function props() {
    return {
      displayed: function displayed(props) {
        var _props$spa$;

        return Boolean(props === null || props === void 0 ? void 0 : (_props$spa$ = props.spa[0]) === null || _props$spa$ === void 0 ? void 0 : _props$spa$.activities[0]);
      }
    };
  },
  resolve: function resolve(appContext, props, pageContext, location) {
    var productId = props.resortId;
    var urlParams = location.urlParams;
    var categoriesForSpaArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams, {
      categoryId: 'SPA'
    });
    var categoriesForSpaDetailArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams, {
      tags: 'SPA_DETAIL'
    });
    var query = "query {\n      spa: categories(".concat(categoriesForSpaArgs, "){\n        activities {\n          description\n          equipments { name description }\n          logo\n          footnotes\n          ageInMonths { min }\n        }\n      }\n      spaDetail: categories(").concat(categoriesForSpaDetailArgs, "){\n        id\n        name\n        activities { id name image included description duration adultsOnly ageInMonths { min } }\n      }\n      config {\n        common {\n          participants {\n            year {\n              _0\n              _1\n              n\n            }\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_WELLNESS */ "Fc"]
    });
  }
};

/***/ }),

/***/ "+MSq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productImageMapResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productImageMapResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_IMAGE_MAP */ "N"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var productId = props.resortId;
    var resortArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, location.urlParams);
    var query = "query {resort(".concat(resortArgs, ") {name mapUrl}}");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_IMAGE_MAP */ "jc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "+Rc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaTrigger; });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("XiOS");
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("RPju");
/* harmony import */ var _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("YZTm");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("/Mt0");
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("m1JM");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRdV");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("U6GL");
/* harmony import */ var _frameworks_form_inputs_input_button_InputButton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("W+NJ");
/* harmony import */ var _frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("U2fG");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;














var CriteriaTrigger = function CriteriaTrigger(props) {
  var _useResponsive = Object(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_7__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_2__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0];

  var pageContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_3__[/* ReactPageContext */ "a"]);
  var rootRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])();
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_9__[/* useTracking */ "a"])();
  var buttons = props.buttons.map(function (btnProps) {
    var children = btnProps.children,
        allOtherProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(btnProps, ["children"]);

    return __jsx("div", {
      key: Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_8__[/* generateUniqueId */ "b"])([btnProps.theme, btnProps.color, btnProps.colorBg, btnProps.colorBorder], 'criteria-btn-')
    }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_11__[/* Button */ "a"], allOtherProps, children));
  });
  var criteriaDropdownOrLayer = isDesktop ? __jsx("div", {
    className: "flex flex-2"
  }, __jsx(_frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_12__[/* DropDown */ "a"], {
    className: "flex-1 mx-2",
    contentStyle: {
      minWidth: props.dropDownMinWidth || 300
    },
    isExpanded: props.isOpen,
    onClose: props.onClose,
    rootRef: rootRef,
    theme: "hollow"
  }, function () {
    return __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, props.children, !!buttons.length && __jsx("div", {
      className: "flex p-3 items-center justify-between bg-transparent border-t"
    }, buttons), props.reassurance.shouldDisplay && __jsx("div", {
      className: "text-gray-light mt-0 border-t-1 mx-2 py-2 text-sm text-left"
    }, props.reassurance.text));
  })) : __jsx(_frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_14__[/* Layer */ "b"], {
    ariaLabelledby: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_4__[/* ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER */ "n"],
    buttonLeft: {
      iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].LEFT_ARROW,
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "f"])('common.backNavigation'),
      onClick: props.onClose
    },
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "f"])('common.close'),
    hasAnimateEnter: true,
    header: __jsx("div", {
      className: "text-center font-normal text-xl text-gray-darker",
      dangerouslySetInnerHTML: {
        __html: criteriaContext.layerHeader
      },
      id: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_4__[/* ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER */ "n"]
    }),
    onClose: props.onClose
  }, __jsx("div", {
    className: "scroll-y",
    style: {
      height: "calc(100% - ".concat(buttons.length > 0 ? '70px' : '0px', ")")
    }
  }, props.children, props.reassurance.shouldDisplay && __jsx("div", {
    className: "text-gray-light mt-4 lg:mt-0 sm:border-t-1 mx-2 sm:pt-2 text-sm text-left"
  }, props.reassurance.text)), buttons.length && __jsx("div", {
    className: "relative p-3 px-6 lg:px-0 w-full flex items-center justify-between mt-auto bg-white shadow"
  }, buttons));
  return __jsx("div", {
    "data-testid": props.dataTestId,
    ref: rootRef
  }, __jsx(_frameworks_form_inputs_input_button_InputButton__WEBPACK_IMPORTED_MODULE_13__[/* InputButton */ "a"], {
    className: "w-full",
    dataTestId: "criteria-trigger-button",
    iconName: props.buttonIcon,
    isActive: props.isOpen,
    isFilled: props.buttonIsFilled,
    isLoading: isDesktop && props.isLoading,
    color: criteriaContext.isJoyview ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_6__[/* COLORS */ "a"].WATER_GREEN : _utils_color_colors__WEBPACK_IMPORTED_MODULE_6__[/* COLORS */ "a"].SUCCESS,
    onClear: isDesktop ? function () {
      props.onClear && props.onClear();
    } : undefined,
    onClick: function onClick() {
      if (props.isOpen) {
        props.onClose && props.onClose();
      } else {
        props.onOpen && props.onOpen();

        if (props.trackingLabel && criteriaContext.trackingActionName) {
          track({
            actionGA: criteriaContext.trackingActionName,
            categoryGA: pageContext.pageId,
            labelGA: props.trackingLabel
          });
        }
      }
    }
  }, props.buttonLabel), props.isOpen && criteriaDropdownOrLayer);
};
CriteriaTrigger.defaultProps = {
  buttons: [],
  reassurance: {
    shouldDisplay: false,
    text: ''
  }
};

/***/ }),

/***/ "+Ugr":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("2K7v"),
    Map = __webpack_require__("McKP"),
    MapCache = __webpack_require__("pFHV");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "+dj+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productMeetingRoomInfoResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productMeetingRoomInfoResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_MEETING_ROOM_INFO */ "jb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var resortId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var query = "{\n        productMeetingRooms(".concat(productArgs, ") {\n          availableMeetingRoomShapes\n          meetingRooms {\n            label\n            area {\n              value\n              unit\n            }\n            length {\n              value\n              unit\n            }\n            width {\n              value\n              unit\n            }\n            shapes {\n              type\n              maxCapacity\n            }\n          }\n        }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_MEETING_ROOM_INFO */ "oc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "+f+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Navbar; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// CONCATENATED MODULE: ./src/client/components/frameworks/navbar/Navbar.themes.js
var themes = {
  "default": {
    thRoot: 'bg-white text-gray-light decorator-border-bottom-after',
    thScrollArea: 'max-w-site m-auto h-full',
    thList: 'flex h-full mx-auto rtl:flex-row',
    thItem: 'flex flex-shrink-0 items-center justify-center font-bold no-underline px-8 py-3 text-base text-center whitespace-no-wrap',
    thItemInactive: 'hover:bg-blue hover:text-white text-gray-darker transition-colors',
    thItemActive: 'bg-blue text-white'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/navbar/Navbar.jsx


var __jsx = react_default.a.createElement;








// We use `forwardRef` to give the parent an access to the <nav> DOM and get its height for example.
var Navbar = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var className = props.className,
      id = props.id,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      scrollBackwardLabel = props.scrollBackwardLabel,
      scrollForwardLabel = props.scrollForwardLabel,
      _props$selectedItem = props.selectedItem,
      selectedItem = _props$selectedItem === void 0 ? -1 : _props$selectedItem,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      getTrackingData = props.getTrackingData;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isRTL = _useContext.isRTL;

  if (Object(lodash["isEmpty"])(items) || !Array.isArray(items)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thList = _themes$theme.thList,
      thItem = _themes$theme.thItem,
      thItemActive = _themes$theme.thItemActive,
      thItemInactive = _themes$theme.thItemInactive,
      thRoot = _themes$theme.thRoot,
      thScrollArea = _themes$theme.thScrollArea;
  var children = items.map(function (item, index) {
    var _classnames;

    var isActive = index === selectedItem;
    return Object(lodash["isEmpty"])(item) ? null : __jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, item.link, {
      as: DynamicLink["a" /* default */],
      key: item.label,
      className: classnames_default()(thItem, (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, thItemInactive, !isActive), Object(defineProperty["a" /* default */])(_classnames, thItemActive, isActive), _classnames)),
      trackingData: getTrackingData ? getTrackingData(item.label) : null
    }), item.label);
  });
  return __jsx("nav", {
    className: classnames_default()(className, thRoot),
    "data-testid": "navbar",
    id: id || null,
    ref: ref,
    role: "navigation"
  }, __jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: scrollBackwardLabel,
    className: thScrollArea,
    forwardLabel: scrollForwardLabel,
    hasShadow: true,
    navPosition: "side"
  }, __jsx("div", {
    className: thList
  }, isRTL ? children.reverse() : children)));
});

/***/ }),

/***/ "+mhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureCity; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PFCZ");



function setDepartureCity(_ref) {
  var value = _ref.value;
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_CITY */ "b"], {
    value: value
  });
}



/***/ }),

/***/ "/0L0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productServicesResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productServicesResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_SERVICES */ "R"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_1__[/* common */ "a"](), "\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_SERVICES */ "zc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "/KRb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productRecommendationsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("KL6I");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");







var productRecommendationsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_RECOMMENDATIONS */ "nb"],
  resolve: function resolve(appContext, props) {
    if (Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_5__[/* isSeller */ "g"])(appContext)) {
      return Promise.resolve();
    }

    var _appContext$cmsConten = appContext.cmsContent,
        cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
        _appContext$cmsReleas = appContext.cmsRelease,
        cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
    var cmsArgs = "content: \"".concat(cmsContent, "\", release: \"").concat(cmsRelease, "\"");
    var resortId = props.resortId;
    var resortThumbnailQueryString = Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_4__[/* default */ "b"])({
      content: cmsContent,
      release: cmsRelease
    });
    var query = "query {\n      recommendations(productId: \"".concat(resortId, "\", limit: 3) {\n        products: resorts {\n          ").concat(resortThumbnailQueryString, "\n        }\n      },\n      config(").concat(cmsArgs, ") {\n        common {\n          next\n          previous\n          close\n          thumbnailCTA\n          thumbnailTourCTA\n          recommendedResorts\n        }\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_2__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_2__[/* resort */ "e"](appContext), "\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* LINE_PRODUCT_RECOMMENDATIONS */ "vc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    });
  }
};

/***/ }),

/***/ "/NZD":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("jbji"),
    shortOut = __webpack_require__("1iwb");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "/WwO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useScriptLoader; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var cachedScripts = [];
function useScriptLoader(scriptUrl) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(cachedScripts.includes(scriptUrl)),
      scriptLoaded = _useState[0],
      setScriptLoaded = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      scriptLoadingFailed = _useState2[0],
      setScriptLoadingFailed = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (scriptLoaded) {
      return;
    }

    var script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    new Promise(function (resolve, reject) {
      script.addEventListener('load', function () {
        return resolve(scriptUrl);
      });
      script.addEventListener('error', function (e) {
        return reject(e);
      });
    }).then(function () {
      cachedScripts.push(scriptUrl);
      setScriptLoaded(true);
    })["catch"](function () {
      script.remove();
      setScriptLoadingFailed(true);
    }); // $FlowFixMe

    document.body.appendChild(script);
  }, [scriptUrl]);
  return {
    scriptLoaded: scriptLoaded,
    scriptLoadingFailed: scriptLoadingFailed
  };
}

/***/ }),

/***/ "/nu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureDate; });
/* unused harmony export hasPriceSuggestions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSuggestionsTrackingData; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UIAR");


var getDepartureDate = function getDepartureDate(_ref) {
  var date = _ref.date,
      duration = _ref.duration,
      format = _ref.format,
      unit = _ref.unit;
  return moment__WEBPACK_IMPORTED_MODULE_0___default()(date, format).add(duration, unit).format(format);
};
var hasPriceSuggestions = function hasPriceSuggestions(proposal, appContext) {
  return proposal && proposal.price && proposal.price.gap > 0 && (proposal.price.gap < _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_1__[/* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */ "q"] || appContext.isSeller && proposal.price.gap >= _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_1__[/* PRICE_COUNTER_PROPOSAL_THRESHOLD */ "r"]);
};
var getSuggestionsTrackingData = function getSuggestionsTrackingData(_ref2) {
  var proposal = _ref2.proposal,
      suggestions = _ref2.suggestions,
      appContext = _ref2.appContext,
      disableAlternativePrice = _ref2.disableAlternativePrice;
  var hasDateSuggestion = suggestions.dates.length > 0;
  var hasResortSuggestion = suggestions.resorts.length > 0;
  var hasDurationSuggestion = suggestions.durations.length > 0;
  var hasPriceSuggestion = !disableAlternativePrice && proposal && hasPriceSuggestions(proposal, appContext);
  var labelGA = "displayCounterProposals".concat(hasPriceSuggestion ? '_rate10' : '').concat(hasDateSuggestion ? '_date' : '').concat(hasResortSuggestion ? '_resort' : '').concat(hasDurationSuggestion ? '_duration' : '');
  return {
    labelGA: labelGA
  };
};

/***/ }),

/***/ "00cE":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "05PS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getCalendar; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ getSelectedMonth; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ getCalendarLoading; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getDays; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ getPricesByDays; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ getDepartureDateBookable; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getAvailableDurations; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ getInitialDuration; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getCalendarTripPrice; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ getCalendarTripPriceLoading; });

// UNUSED EXPORTS: getBasePrice

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /home/circleci/project/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// CONCATENATED MODULE: ./src/utils/api-availability/constants.js
var API_AVAILABLE = 'available';
var API_CLOSED = 'closed';
var API_EXCLUSIVITY = 'exclusivity';
var API_FULL = 'full';
var API_NO_FLIGHT = 'noFlight';
var API_NO_DEPARTURE = 'noDeparture';
var API_UNKNOWN = 'unknown';
var API_NOT_BOOKABLE = [API_CLOSED, API_EXCLUSIVITY, API_FULL, API_NO_DEPARTURE];

// CONCATENATED MODULE: ./src/utils/api-availability/availabilityUtils.js


function isBookable(availability) {
  return !!availability && !API_NOT_BOOKABLE.includes(availability);
}


// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/store/calendar/calendar.selector.js







var INITIAL_LIST = [];
var INITIAL_CALENDAR = {};

function getMonthIndex() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var monthId = arguments.length > 1 ? arguments[1] : undefined;
  return months.findIndex(function (_ref) {
    var id = _ref.id;
    return id === monthId;
  });
}

function getMonthIndexFromDays() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dayId = arguments.length > 1 ? arguments[1] : undefined;
  /**
   * return if a day is elligible based on:
   * - dayContent.id equals dayId parameter
   * - dayContent.isCurrentMonth at true
   * @param  {Object} day  objet day from calendar.months[i]
   * @return {boolean}     this day is elligible
   */

  var matchBasedOnDay = function matchBasedOnDay(_ref2) {
    var dayContent = _ref2.dayContent;
    return dayContent.id === dayId && dayContent.isCurrentMonth;
  };

  return months.findIndex(function (_ref3) {
    var days = _ref3.days;
    return days.some(matchBasedOnDay);
  });
}

function getCurrentMonth() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedDay = arguments.length > 1 ? arguments[1] : undefined;
  var selectedDayMonthIndex = arguments.length > 2 ? arguments[2] : undefined;
  var firstMonthIndex = arguments.length > 3 ? arguments[3] : undefined;
  return selectedDay && selectedDayMonthIndex > -1 ? months[selectedDayMonthIndex] : months[firstMonthIndex];
}

function getDaysFromMonths(calendar, monthId) {
  var months = calendar.months;
  var monthIndex = getMonthIndex(months, monthId);
  return Object(lodash["get"])(months, "".concat(monthIndex, ".days"));
}

function getDaysFromDays(calendar, dayId) {
  var months = calendar.months,
      firstAvailableMonthIndex = calendar.firstAvailableMonthIndex;
  var selectedDayMonthIndex = getMonthIndexFromDays(months, dayId);
  var month = getCurrentMonth(months, dayId, selectedDayMonthIndex, firstAvailableMonthIndex);
  return Object(lodash["get"])(month, 'days', INITIAL_LIST);
}

function getDaysSelector() {
  var calendar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_CALENDAR;
  var selectedMonth = arguments.length > 1 ? arguments[1] : undefined;
  var selectedDay = arguments.length > 2 ? arguments[2] : undefined;

  if (Object(lodash["isEmpty"])(calendar)) {
    return INITIAL_LIST;
  }

  var daysFromMonths = getDaysFromMonths(calendar, selectedMonth);
  var daysFromDays = getDaysFromDays(calendar, selectedDay);
  return !daysFromMonths || daysFromMonths === daysFromDays ? daysFromDays : daysFromMonths;
}

var calendarSelector = function calendarSelector(_ref4) {
  var calendar = _ref4.calendar;
  return calendar;
};

var getCalendar = Object(lib["createSelector"])(calendarSelector, function (_ref5) {
  var calendar = _ref5.calendar;
  return calendar;
});
var getSelectedMonth = Object(lib["createSelector"])(calendarSelector, function (_ref6) {
  var selectedMonth = _ref6.selectedMonth;
  return selectedMonth;
});
var getCalendarLoading = Object(lib["createSelector"])(calendarSelector, function (_ref7) {
  var isLoading = _ref7.isLoading;
  return isLoading;
});
var getDays = Object(lib["createSelector"])(getCalendar, getSelectedMonth, tripCriteria_selector["b" /* getDepartureDate */], getDaysSelector);
var getPricesByDays = Object(lib["createSelector"])(calendarSelector, function (_ref8) {
  var byDays = _ref8.byDays;
  return byDays;
});
var getDepartureDateBookable = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], getCalendarLoading, function (_ref9, departureDate, isLoading) {
  var _byDays$dayId;

  var byDays = _ref9.byDays;

  if (!departureDate || isLoading) {
    return false;
  }

  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);
  return byDays && byDays[dayId] && isBookable((_byDays$dayId = byDays[dayId]) === null || _byDays$dayId === void 0 ? void 0 : _byDays$dayId.availability);
});
var getBasePrice = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], getDepartureDateBookable, function (_ref10, departureDate, departureDateBoobable) {
  var basePrice = _ref10.basePrice,
      byDays = _ref10.byDays;

  if (!departureDate || !departureDateBoobable) {
    return basePrice;
  }

  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);

  if (!byDays || !byDays[dayId]) {
    return null;
  }

  var _byDays$dayId2 = byDays[dayId],
      oldPrice = _byDays$dayId2.oldPrice,
      price = _byDays$dayId2.price,
      unit = _byDays$dayId2.unit;
  return {
    bestPrice: price ? {
      formattedValue: price,
      value: price
    } : null,
    initialPrice: oldPrice ? {
      formattedValue: oldPrice,
      value: oldPrice
    } : null,
    unit: unit
  };
});
var getAvailableDurations = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], function (_ref11, departureDate) {
  var _bookableDates$months, _bookableDates$months2, _bookableDates$months3;

  var bookableDates = _ref11.bookableDates,
      bookableDatesLoading = _ref11.bookableDatesLoading;

  if (bookableDatesLoading) {
    return [];
  }

  if (!departureDate || !bookableDates) {
    return null;
  }

  var monthId = moment_default()(departureDate).format(apiDate["b" /* API_MONTH_ID */]);
  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);
  return Array.isArray(bookableDates === null || bookableDates === void 0 ? void 0 : bookableDates.months) ? (bookableDates === null || bookableDates === void 0 ? void 0 : (_bookableDates$months = bookableDates.months.find(function (m) {
    return m.id.toString() === monthId;
  })) === null || _bookableDates$months === void 0 ? void 0 : (_bookableDates$months2 = _bookableDates$months.days.find(function (d) {
    return d.id.toString() === dayId;
  })) === null || _bookableDates$months2 === void 0 ? void 0 : (_bookableDates$months3 = _bookableDates$months2.availabilities.filter(function (a) {
    return a.status === 'AVAILABLE' || a.status === 'UNKNOWN';
  })) === null || _bookableDates$months3 === void 0 ? void 0 : _bookableDates$months3.reduce(function (acc, a) {
    return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(a.durations));
  }, [])) || null : null;
});
var getInitialDuration = Object(lib["createSelector"])(calendarSelector, function (_ref12) {
  var initialDuration = _ref12.initialDuration;
  return initialDuration;
});
var getCalendarTripPrice = Object(lib["createSelector"])(calendarSelector, function (_ref13) {
  var tripPrice = _ref13.tripPrice;
  return tripPrice;
});
var getCalendarTripPriceLoading = Object(lib["createSelector"])(calendarSelector, function (_ref14) {
  var tripPriceIsLoading = _ref14.tripPriceIsLoading;
  return tripPriceIsLoading;
});

/***/ }),

/***/ "07TY":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("jP+d");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "0JpG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useGQL; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ub5k");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var noop = function noop(e) {
  return e;
};

function reducer(state, action) {
  switch (action.type) {
    case 'loading':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });

    case 'data':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data,
        isLoading: false
      });

    case 'error':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.error,
        isLoading: false
      });

    default:
      throw new Error("Unknown action type! [".concat(action.type, "]"));
  }
}

function useGQL() {
  for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }

  var initialState = {
    data: null,
    error: null,
    isLoading: true
  };

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_1__["useReducer"])(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]);
  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    dispatch({
      type: 'loading'
    });
    var promises = queries.filter(function (query) {
      return !query.ignore;
    }).map(function (_ref) {
      var query = _ref.query,
          _ref$cache = _ref.cache,
          cache = _ref$cache === void 0 ? false : _ref$cache,
          _ref$map = _ref.map,
          map = _ref$map === void 0 ? noop : _ref$map,
          queryOptions = _ref.queryOptions,
          catchCallback = _ref["catch"];
      var promise = cache ? _graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, queryOptions) : _graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(query, appContext, queryOptions);

      if (catchCallback) {
        return promise.then(map)["catch"](catchCallback);
      }

      return promise.then(map);
    });
    Promise.all(promises).then(function (datas) {
      var data = queries.length === 1 ? datas[0] : datas.reduce(function (acc, item) {
        return _objectSpread(_objectSpread({}, acc), item);
      }, {});
      dispatch({
        type: 'data',
        data: data
      });
    })["catch"](function (error) {
      dispatch({
        type: 'error',
        error: error
      });
    });
  }, queries.map(function (q) {
    return q.query + (q.ignore ? 'T' : 'F');
  })); // useEffect run at each render on the react lifecycle. Here the useEffect should run only if the query OR the ignore param change!
  // $FlowFixMe

  return state;
}

/***/ }),

/***/ "0Jwk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _toArray; });
/* harmony import */ var _arrayWithHoles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Umn3");
/* harmony import */ var _iterableToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5x5+");
/* harmony import */ var _nonIterableRest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kQdG");



function _toArray(arr) {
  return Object(_arrayWithHoles__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(arr) || Object(_iterableToArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(arr) || Object(_nonIterableRest__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])();
}

/***/ }),

/***/ "0OJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PRICE_TICKET_REQUEST = 'PRICET_TICKET_REQUEST';
/* harmony default export */ __webpack_exports__["a"] = (PRICE_TICKET_REQUEST);

/***/ }),

/***/ "0ibg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setKeywords; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");


function setKeywords(keywords) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SEARCH_SET_KEYWORDS */ "s"], {
    keywords: keywords
  });
}

/***/ }),

/***/ "1I7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productSEOTitleResolver; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("psNz");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var getPriceRange = function getPriceRange(_ref) {
  var price = _ref.price,
      priceConditionLabel = _ref.priceConditionLabel;

  if (!price || !price.bestPrice && !price.initialPrice) {
    return null;
  }

  var _price$bestPrice = price.bestPrice;
  _price$bestPrice = _price$bestPrice === void 0 ? {} : _price$bestPrice;
  var bestPrice = _price$bestPrice.formattedValue,
      _price$initialPrice = price.initialPrice;
  _price$initialPrice = _price$initialPrice === void 0 ? {} : _price$initialPrice;
  var initialPrice = _price$initialPrice.formattedValue,
      _price$termsAndCondit = price.termsAndConditions,
      duration = _price$termsAndCondit.duration,
      numberOfAdults = _price$termsAndCondit.numberOfAdults,
      unit = price.unit;
  var priceToUse = bestPrice || initialPrice;
  return priceToUse ? Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["messageFormat"])(priceConditionLabel).format({
    bestPrice: priceToUse,
    duration: duration,
    numberOfAdults: numberOfAdults,
    priceUnit: unit.toLowerCase()
  }) : null;
};

var getStructuredData = function getStructuredData(props) {
  var origin = props.origin,
      _props$resort = props.resort,
      name = _props$resort.name,
      images = _props$resort.images,
      description = _props$resort.description,
      price = _props$resort.price,
      _props$resort$tripadv = _props$resort.tripadvisor,
      numReviews = _props$resort$tripadv.numReviews,
      rating = _props$resort$tripadv.rating,
      priceCondition = props.config.resort.seo.priceCondition;
  var priceRange = getPriceRange({
    price: price,
    priceConditionLabel: priceCondition
  });

  var structuredData = _objectSpread(_objectSpread({
    aggregateRating: {
      ratingValue: rating,
      reviewCount: numReviews,
      bestRating: '5',
      '@context': 'http://schema.org/',
      '@type': 'AggregateRating'
    },
    description: description,
    image: images,
    name: name
  }, priceRange ? {
    priceRange: priceRange
  } : null), {}, {
    url: origin,
    '@context': 'http://schema.org/',
    '@type': 'Hotel'
  });

  return {
    type: 'application/ld+json',
    innerHTML: JSON.stringify(structuredData)
  };
};

var getOpenGraphData = function getOpenGraphData(props) {
  return [{
    property: 'og:locale',
    content: props.locale
  }, {
    property: 'og:type',
    content: 'website'
  }, {
    property: 'og:title',
    content: props.resort.title
  }, {
    property: 'og:description',
    content: props.resort.description
  }, {
    property: 'og:url',
    content: "".concat(props.origin)
  }, {
    property: 'og:site_name',
    content: 'Club Med'
  }].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(props.resort.images.map(function (image) {
    return {
      key: "og:image".concat(image),
      property: 'og:image',
      content: image
    };
  })));
};

var productSEOTitleResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_2__[/* RESORT_SEO */ "pb"],
  props: function props() {
    return {
      title: function title(props) {
        return _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["resortAction"].generateResortTitle(props.title || '', props.resort.name);
      },
      meta: function meta(props) {
        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(props.resort.htmlHeader.meta), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(getOpenGraphData(props)));
      },
      script: function script(props) {
        return [getStructuredData(props)];
      }
    };
  },
  resolve: function resolve() {
    var appContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments.length > 1 ? arguments[1] : undefined;
    var query = "query {\n      resort(resortId: \"".concat(props.resortId, "\") {\n        name\n        htmlHeader { meta {name content} }\n        images\n        description\n        title\n        tripadvisor(resortId: \"").concat(props.resortId, "\") {\n          rating\n          numReviews\n        }\n        price(resortId: \"").concat(props.resortId, "\") {\n          bestPrice {\n            formattedValue\n          }\n          initialPrice {\n            formattedValue\n          }\n          termsAndConditions {\n            duration\n            numberOfAdults\n          }\n          unit\n        }\n      }\n      config {\n        resort {\n          seo {\n            priceCondition\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_PRODUCT_SEO_TITLE */ "yc"],
      strictErrors: false
    }).then(function (data) {
      return _objectSpread({
        origin: appContext.originalUrl,
        locale: appContext.locale
      }, data);
    });
  }
};

/***/ }),

/***/ "1KeW":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("sWQB"),
    isMasked = __webpack_require__("68C9"),
    isObject = __webpack_require__("Q7Yi"),
    toSource = __webpack_require__("AVUi");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "1MRr":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("YXT+"),
    isObjectLike = __webpack_require__("oS78");

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ "1P7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFormattedLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCursorClass; });
function getFormattedLabel() {
  var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!placeholder) return '';
  return isRequired ? "".concat(placeholder, "*") : placeholder;
}
function getCursorClass(_ref) {
  var hasPointer = _ref.hasPointer,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly;
  if (isDisabled) return 'cursor-not-allowed';
  if (isReadOnly) return 'cursor-default';
  if (isLoading) return 'cursor-wait';
  return hasPointer ? 'cursor-pointer' : '';
}

/***/ }),

/***/ "1Wgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActiveIndexes; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_10__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var ActiveIndexes = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(ActiveIndexes, _Component);

  var _super = _createSuper(ActiveIndexes);

  function ActiveIndexes() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(this, ActiveIndexes);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "state", {
      activeIndexes: _this.props.activeIndexes || [],
      isPristine: true,
      lastIndex: 0
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "clear", function () {
      _this.setState(function (prevState) {
        if (prevState.activeIndexes.length) return {
          activeIndexes: []
        };
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "update", function (index) {
      var _this$props$onUpdate = _this.props.onUpdate,
          onUpdate = _this$props$onUpdate === void 0 ? lodash__WEBPACK_IMPORTED_MODULE_9__["noop"] : _this$props$onUpdate;
      var activeIndexes = _this.state.activeIndexes;
      var newActiveIndexes = activeIndexes.includes(index) ? _this.removeIndex(activeIndexes, index) : _this.addIndex(activeIndexes, index);

      _this.setState({
        activeIndexes: newActiveIndexes,
        isPristine: false,
        lastIndex: index
      }, function () {
        onUpdate(index);
        Object(react_lazyload__WEBPACK_IMPORTED_MODULE_10__["forceCheck"])();
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(ActiveIndexes, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$activeInd = this.props.activeIndexes,
          activeIndexes = _this$props$activeInd === void 0 ? [] : _this$props$activeInd;

      if (!Object(lodash__WEBPACK_IMPORTED_MODULE_9__["isEqual"])(prevProps.activeIndexes, activeIndexes)) {
        var lastIndex = activeIndexes[activeIndexes.length - 1];
        this.setState({
          activeIndexes: activeIndexes,
          lastIndex: lastIndex >= 0 ? lastIndex : prevState.lastIndex
        });
      }
    }
  }, {
    key: "addIndex",
    value: function addIndex(activeIndexes, index) {
      var hasMultipleIndexEnabled = this.props.hasMultipleIndexEnabled;

      if (hasMultipleIndexEnabled) {
        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(activeIndexes), [index]);
      }

      return [index];
    }
  }, {
    key: "removeIndex",
    value: function removeIndex(activeIndexes, index) {
      var hasNoIndexEnabled = this.props.hasNoIndexEnabled;

      if (hasNoIndexEnabled || activeIndexes.length > 1) {
        return Object(lodash__WEBPACK_IMPORTED_MODULE_9__["pull"])(activeIndexes, index);
      }

      return activeIndexes;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        activeIndexes: this.state.activeIndexes,
        clear: this.clear,
        isPristine: this.state.isPristine,
        lastIndex: this.state.lastIndex,
        update: this.update
      });
    }
  }]);

  return ActiveIndexes;
}(react__WEBPACK_IMPORTED_MODULE_8__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(ActiveIndexes, "defaultProps", {
  activeIndexes: [],
  hasMultipleIndexEnabled: false,
  hasNoIndexEnabled: false
});

/***/ }),

/***/ "1bTl":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("Q7Yi"),
    isSymbol = __webpack_require__("vrF/");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "1bWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setKids; });
/* unused harmony export updateKid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setKidsWithoutClearProposals; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* eslint-disable flowtype/no-weak-types */



function setKids(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS */ "c"], {
    kids: kids
  });
}

function setKidsWithoutClearProposals(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */ "d"], {
    kids: kids
  });
}

function resetKids() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_RESET_KIDS */ "b"]);
}

function updateKid(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_KID */ "e"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}



/***/ }),

/***/ "1iwb":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "1qsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWinterResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isWinterMountainResort; });
/* unused harmony export resortHasBeActivities */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);


var WINTER_MOUNTAIN_RESORT = _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["constants"].WINTER_MOUNTAIN_RESORT;
function isWinterResort(resort) {
  var seasons = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'seasons', []);
  return seasons.length === 1 && seasons.includes('WINTER') && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'type', '').toUpperCase() === 'VILLAGE';
}
function isWinterMountainResort(resort) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(resort, 'category') === WINTER_MOUNTAIN_RESORT;
}
var resortHasBeActivities = function resortHasBeActivities(resort) {
  return resort.activityCategories.leisure.some(function (_ref) {
    var subCategories = _ref.subCategories;
    return subCategories.length !== 0;
  });
};

/***/ }),

/***/ "1tzK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isChineseLocale; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("qFX+");


function isChineseLocale(locale) {
  return locale === _constants__WEBPACK_IMPORTED_MODULE_0__[/* LOCALES */ "a"].EN_CN || locale === _constants__WEBPACK_IMPORTED_MODULE_0__[/* LOCALES */ "a"].ZH_CN;
}



/***/ }),

/***/ "27iJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productChildcaresResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("H0gB");




var productChildcaresResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_CHILDCARES */ "K"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var query = Object(_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__[/* productChildcaresQuery */ "d"])(productId, {
      urlParams: urlParams
    });
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_CHILDCARE */ "ec"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "2K7v":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("GSaD"),
    listCacheDelete = __webpack_require__("7jdC"),
    listCacheGet = __webpack_require__("BGmY"),
    listCacheHas = __webpack_require__("Lbah"),
    listCacheSet = __webpack_require__("2LuC");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "2LZg":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("5R7x");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "2LuC":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("3QVS");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "2N/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_ENGINE_ENTRIES; });
/* unused harmony export BOOKING_TRACKING_UPSELL_REVENUE */
var BOOKING_ENGINE_ENTRIES = {
  PRICE_CALENDAR: 'PriceCalendar',
  PRICE_REMOTE: 'PriceRemote',
  QUICK_SEARCH: 'QuickSearch',
  CRUISE_BOOKING: 'CruiseBooking'
};
var BOOKING_TRACKING_UPSELL_REVENUE = 'BOOKING_TRACKING_UPSELL_REVENUE';

/***/ }),

/***/ "2NJa":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("Q7Yi");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "2Ufl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineTitle; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var LineTitle = function LineTitle(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "isExclusiveCollection"]);

  return __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__[/* Title */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('mb-4 md:mb-6', className),
    theme: isExclusiveCollection ? 'title-serif-7' : 'title-brand-1'
  }));
};

/***/ }),

/***/ "2dUC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productTagsResolver; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QsI/");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jw1E");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("4VTZ");








var productTagsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_3__[/* PRODUCT_TAGS */ "W"],
  resolve: function () {
    var _resolve = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(appContext, props) {
      var allProductIds, productIdsAsString, _appContext$cmsConten, cmsContent, _appContext$cmsReleas, cmsRelease, resortThumbnailQueryString, query;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              allProductIds = props.tags.reduce(function (acc, tag) {
                return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(acc), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(tag.productIds));
              }, []);
              productIdsAsString = JSON.stringify(allProductIds);
              _appContext$cmsConten = appContext.cmsContent, cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten, _appContext$cmsReleas = appContext.cmsRelease, cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
              resortThumbnailQueryString = Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])({
                content: cmsContent,
                release: cmsRelease
              });
              query = "query {\n      config {\n        common {\n          close\n          next\n          previous\n          scrollBackward\n          scrollForward\n        }\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_7__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_7__[/* resort */ "e"](appContext), "\n      }\n      products: resorts(resortIds: ").concat(productIdsAsString, ") {\n        ").concat(resortThumbnailQueryString, "\n      }\n    }");
              return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runQuery(query, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_COMMON_PRODUCT_TAGS */ "Nb"]
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function resolve(_x, _x2) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }()
};

/***/ }),

/***/ "2rns":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "34at":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToHash; });
/* harmony import */ var _widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1cDg");
/* eslint-env browser */

function goToHash(hash) {
  var scrollUnderNav = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
  /* In mobile context, navBar is on top of the content of the page so hash scroll goes under the nav */

  function scrollUnderNavBar() {
    var navBar = document.getElementsByClassName(_widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__[/* NAVIGATION_OFFSET_SELECTOR */ "b"])[0];

    if (navBar) {
      document.documentElement.scrollTop -= navBar.clientHeight;
    }
  }

  if (hash) {
    var hashName = hash.split('#')[1];
    setTimeout(function () {
      var element = document.getElementById(hashName);

      if (element) {
        element.scrollIntoView({
          behavior: behavior
        });
      }

      if (scrollUnderNav) {
        scrollUnderNavBar();
      }
    }, 100);
  }
}

/***/ }),

/***/ "393O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_WHEN_EVENT; });
var OPEN_CRITERIA_WHEN_EVENT = 'openCriteriaWhen';

/***/ }),

/***/ "3FxL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productPriceTicketResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");





var productPriceTicketResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_PRICE_TICKET */ "mb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId,
        _props$durationPlaceh = props.durationPlaceholder,
        durationPlaceholder = _props$durationPlaceh === void 0 ? '' : _props$durationPlaceh,
        _props$fromToPlacehol = props.fromToPlaceholder,
        fromToPlaceholder = _props$fromToPlacehol === void 0 ? '' : _props$fromToPlacehol;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_3__[/* buildProductArgs */ "c"])(productId, urlParams);
    var cruiseArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_3__[/* buildCruiseArgs */ "b"])(urlParams);
    var query = "query {\n      config {\n        booking { form { withoutTransport } }\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_1__[/* price */ "c"](), "\n        common {\n          close\n          comparator {\n            backToSearch\n          }\n        }\n        resort {\n          ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_1__[/* resortStartingPrice */ "f"](), "\n        }\n        travelAdvisor {\n          href\n          phoneNumber\n          text\n          type\n        }\n      }\n      cruise(").concat(cruiseArgs, ") {\n        fromToDestination(message: \"").concat(fromToPlaceholder, "\")\n      }\n      product: resort(").concat(productArgs, ") {\n        badgeIcon\n        color\n        comfortLabel\n        destination {\n          country\n        }\n        duration(message:\"").concat(durationPlaceholder, "\")\n        id\n        isExplicitEC\n        name\n        rangeId\n        type\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_PRODUCT_PRICE_TICKET */ "sc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "3JOw":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF"),
    root = __webpack_require__("jP+d");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "3OB6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return editorialFoldingBlockResolver; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("psNz");
/* harmony import */ var _collapsePanel_resolver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("+BJN");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var editorialFoldingBlockResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_2__[/* EDITORIAL_FOLDING_BLOCK */ "n"],
  props: function props() {
    return _objectSpread(_objectSpread({}, Object(lodash__WEBPACK_IMPORTED_MODULE_1__["omit"])(Object(_collapsePanel_resolver__WEBPACK_IMPORTED_MODULE_3__[/* props */ "a"])(), ['children'])), {}, {
      componentId: function componentId(_ref) {
        var anchor = _ref.anchor;
        return anchor;
      }
    });
  }
};

/***/ }),

/***/ "3QVS":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("t8ah");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "3zhs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildProductsQuery */
/* unused harmony export buildOfferWithProductIdsQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchProducts; });
/* unused harmony export buildProductIdsQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productsGridResolver; });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("psNz");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("CcNa");
/* harmony import */ var _components_widgets_product_Product_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("Fe0B");






function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











function getThumbnailDatesArgs(props) {
  var today = moment__WEBPACK_IMPORTED_MODULE_6___default()();
  var start = moment__WEBPACK_IMPORTED_MODULE_6___default()(props.departureDateStart || null); // moment(undefined) === today, moment(null) === invalid date. Dat's why

  var end = moment__WEBPACK_IMPORTED_MODULE_6___default()(props.departureDateEnd || null);

  if (!start.isValid() || !end.isValid() || end.isSameOrBefore(today)) {
    return {};
  }

  return {
    duration: props.duration,
    departureCity: props.departureCity,
    dateStart: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__[/* momentToApiDate */ "j"])(start.isBefore(today) ? today : start),
    dateEnd: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__[/* momentToApiDate */ "j"])(end)
  };
} // Exported for test purpose only


function buildProductsQuery(_ref) {
  var appContext = _ref.appContext,
      productIds = _ref.productIds,
      offerId = _ref.offerId,
      props = _ref.props;
  var _appContext$cmsConten = appContext.cmsContent,
      content = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
      _appContext$cmsReleas = appContext.cmsRelease,
      release = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;

  var thumbnailArgs = _objectSpread({
    content: content,
    release: release,
    offerId: offerId,
    tourDurationPlaceholder: props.tourDurationPlaceholder,
    cruiseTimingPlaceholder: props.cruiseTimingPlaceholder,
    cruiseDurationPlaceholder: props.cruiseDurationPlaceholder,
    dateFormat: props.dateFormat
  }, getThumbnailDatesArgs(props));

  return "query {\n    products : resorts(resortIds : ".concat(JSON.stringify(productIds), ") {\n      ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_11__[/* default */ "b"])(thumbnailArgs), "\n    }\n    config(content : \"").concat(content, "\" release : \"").concat(release, "\") {\n      ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_8__[/* resort */ "e"](appContext), "\n      ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_8__[/* price */ "c"](), "\n      common { close thumbnailCTA thumbnailTourCTA openingSoon closed }\n    }\n  }");
}
function buildOfferWithProductIdsQuery(productIds, offerId) {
  return "query {\n    offer(offerId : \"".concat(offerId, "\") {\n      id\n      name\n      seoName\n      color\n      resortIds(resortIds: ").concat(JSON.stringify(productIds), ")\n    }\n  }");
}
function fetchProducts(_ref2) {
  var appContext = _ref2.appContext,
      productIds = _ref2.productIds,
      offerId = _ref2.offerId,
      props = _ref2.props;
  var query = buildProductsQuery({
    appContext: appContext,
    productIds: productIds,
    offerId: offerId,
    props: props
  });
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_12__[/* LINE_COMMON_PRODUCT_GRID_PRODUCTS */ "Lb"],
    strictErrors: false
  });
}
function buildProductIdsQuery(productIds) {
  return "query {\n    products : resorts(resortIds : ".concat(JSON.stringify(productIds), ") {\n      id\n    }\n  }");
}

function getThumbnailCMSTrads(appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {\n      config {\n        thumbnails {\n          cruiseDurationPlaceholder\n          tourDurationPlaceholder\n          cruiseTimingPlaceholder\n        }\n      }\n    }", appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_12__[/* LINE_COMMON_PRODUCT_GRID_THUMBNAIL_TRADS */ "Mb"]
  });
}

function fetchOfferWithProductIds(_x, _x2, _x3) {
  return _fetchOfferWithProductIds.apply(this, arguments);
}

function _fetchOfferWithProductIds() {
  _fetchOfferWithProductIds = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee2(appContext, productIds, offerId) {
    var query, _ref6, _ref6$offer, resortIds, rest;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = buildOfferWithProductIdsQuery(productIds, offerId);
            _context2.next = 3;
            return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_12__[/* LINE_COMMON_PRODUCT_GRID_IDS_WITH_OFFER */ "Kb"],
              strictErrors: false
            });

          case 3:
            _ref6 = _context2.sent;
            _ref6$offer = _ref6.offer;
            resortIds = _ref6$offer.resortIds;
            rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref6$offer, ["resortIds"]);
            return _context2.abrupt("return", {
              resortIds: resortIds,
              offer: rest
            });

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchOfferWithProductIds.apply(this, arguments);
}

function fetchProductIds(_x4, _x5) {
  return _fetchProductIds.apply(this, arguments);
}

function _fetchProductIds() {
  _fetchProductIds = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee3(appContext, productIds) {
    var query, _ref7, products;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            query = buildProductIdsQuery(productIds);
            _context3.next = 3;
            return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_12__[/* LINE_COMMON_PRODUCT_GRID_IDS */ "Jb"],
              strictErrors: false
            });

          case 3:
            _ref7 = _context3.sent;
            products = _ref7.products;
            return _context3.abrupt("return", {
              resortIds: products.map(function (_ref8) {
                var id = _ref8.id;
                return id;
              })
            });

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchProductIds.apply(this, arguments);
}

var productsGridResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_7__[/* RESORT_GRID */ "hb"],
  resolve: function resolve(appContext, props) {
    return Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee() {
      var _props$resortIds, productIds, offerId, fetchOfferAndProductIds, _fetchOfferAndProduct, offer, _fetchOfferAndProduct2, resortIds, sortedExistingProductIds, subsetProductIds, _ref3, thumbnailCMSTrads, _ref4, _ref4$products, products, config;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _props$resortIds = props.resortIds, productIds = _props$resortIds === void 0 ? [] : _props$resortIds, offerId = props.offerId;
              _context.next = 3;
              return offerId ? fetchOfferWithProductIds(appContext, productIds, offerId)["catch"](function () {
                return fetchProductIds(appContext, productIds);
              }) : fetchProductIds(appContext, productIds);

            case 3:
              fetchOfferAndProductIds = _context.sent;
              _fetchOfferAndProduct = fetchOfferAndProductIds.offer, offer = _fetchOfferAndProduct === void 0 ? {} : _fetchOfferAndProduct, _fetchOfferAndProduct2 = fetchOfferAndProductIds.resortIds, resortIds = _fetchOfferAndProduct2 === void 0 ? [] : _fetchOfferAndProduct2;
              sortedExistingProductIds = productIds.filter(function (id) {
                return resortIds.indexOf(id) !== -1;
              });
              subsetProductIds = props.unfoldList ? sortedExistingProductIds : sortedExistingProductIds.slice(0, _components_widgets_product_Product_utils__WEBPACK_IMPORTED_MODULE_13__[/* grid */ "d"].desktop);

              if (!(!subsetProductIds || subsetProductIds.length === 0)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", null);

            case 9:
              _context.next = 11;
              return getThumbnailCMSTrads(appContext);

            case 11:
              _ref3 = _context.sent;
              thumbnailCMSTrads = _ref3.config;
              _context.next = 15;
              return fetchProducts({
                appContext: appContext,
                productIds: subsetProductIds,
                offerId: offer.id,
                props: _objectSpread(_objectSpread({}, props), thumbnailCMSTrads.thumbnails)
              });

            case 15:
              _ref4 = _context.sent;
              _ref4$products = _ref4.products;
              products = _ref4$products === void 0 ? [] : _ref4$products;
              config = _ref4.config;
              return _context.abrupt("return", {
                productIds: sortedExistingProductIds,
                products: sortedExistingProductIds.reduce(function (acc, next) {
                  var product = products.find(function (_ref5) {
                    var id = _ref5.id;
                    return id === next;
                  });

                  if (product) {
                    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(acc), [product]);
                  }

                  return acc;
                }, []),
                config: config,
                offer: offer
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};

/***/ }),

/***/ "4+vj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPertimmDateFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatPertimmDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadOffsetSell; });
/* unused harmony export loadProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadProductsWithIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return searchWithFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadChildcareAvailabilities; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("y316");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("L73y");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("KL6I");




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











var PERTIMM_ENGLISH_SPEAKING_LOCALE = 'en';
function getPertimmDateFormat(locale) {
  return (locale === null || locale === void 0 ? void 0 : locale.slice(0, 2)) === PERTIMM_ENGLISH_SPEAKING_LOCALE ? 'YYYY/MM/DD' : 'DD/MM/YYYY';
}
function formatPertimmDate(departureDate, locale) {
  var format = getPertimmDateFormat(locale);
  return departureDate.isValid() ? departureDate.format(format) : '';
}

function getResortThumbnailArgsConfig(appContext) {
  var query = "query {\n    config {\n      thumbnails {\n        tourDurationPlaceholder\n        cruiseTimingPlaceholder\n        cruiseDurationPlaceholder\n        dateFormat\n      }\n    }\n  }";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_CONFIG */ "Id"]
  });
}

function getAllProductsInfo(_ref) {
  var appContext = _ref.appContext,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      _ref$ids = _ref.ids,
      ids = _ref$ids === void 0 ? [] : _ref$ids;
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease;
  var _options$offerId = options.offerId,
      offerId = _options$offerId === void 0 ? '' : _options$offerId,
      _options$offerName = options.offerName,
      offerName = _options$offerName === void 0 ? '' : _options$offerName,
      _options$productIds = options.productIds,
      productIds = _options$productIds === void 0 ? [] : _options$productIds;
  return getResortThumbnailArgsConfig(appContext).then(function (data) {
    var resortThumbnailQueryArgs = _objectSpread({
      content: cmsContent,
      release: cmsRelease,
      offerName: offerName,
      offerId: offerId
    }, data.config.thumbnails);

    var allProductsId = productIds.length ? ids.filter(function (id) {
      return productIds.includes(id);
    }) : ids;
    var query = "query {\n      resorts(resortIds : [\"".concat(allProductsId.join('","'), "\"]) {\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(resortThumbnailQueryArgs, {
      withoutPrice: true
    }), "\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCTS */ "Gd"]
    });
  });
}

function loadOffsetSell(_ref2) {
  var appContext = _ref2.appContext;
  var query = "\n    query {\n      locale {\n        joyviewOffsetSell\n        resortOffsetSell\n      }\n    }\n  ";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_OFFSET_SELL */ "Fd"]
  });
}
function loadProducts(_ref3) {
  var appContext = _ref3.appContext,
      options = _ref3.options;
  return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__[/* getIdsFromProducts */ "a"])(appContext).then(function (ids) {
    return getAllProductsInfo({
      appContext: appContext,
      options: options,
      ids: ids
    });
  });
}
function loadProductsWithIds(_ref4) {
  var appContext = _ref4.appContext,
      productIds = _ref4.productIds;
  return getAllProductsInfo({
    appContext: appContext,
    options: {},
    ids: productIds
  });
}
function searchWithFacets(_ref5) {
  var criteria = _ref5.criteria,
      options = _ref5.options,
      appContext = _ref5.appContext;
  var productsPromise = loadProducts({
    appContext: appContext,
    options: options
  });
  var userIsSeller = Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_12__[/* isSeller */ "g"])(appContext); // $FlowFixMe

  var searchPromise = Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_5__[/* searchWithFacets */ "c"])({
    criteria: _objectSpread(_objectSpread({}, criteria), {}, {
      tripDuration: userIsSeller ? null : criteria.tripDuration
    }),
    appContext: appContext
  });
  return Promise.all([productsPromise, searchPromise]).then(function (_ref6) {
    var _ref7 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref6, 2),
        productsInfo = _ref7[0],
        pertimmResults = _ref7[1];

    var filteredProducts = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(pertimmResults, 'answers', []).reduce(function (acc, result) {
      var resultProductId = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(result, 'meta.product_id[0]');
      var resort = productsInfo.resorts.find(function (_ref8) {
        var id = _ref8.id;
        return id === resultProductId;
      });
      var isAllAttendeeAllowed = !!resort && (!criteria.kids || criteria.kids.every(function (_ref9) {
        var birthdate = _ref9.birthdate;
        return Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_9__[/* getKidAgeInMonths */ "e"])({
          birthdate: birthdate,
          departureDate: criteria.departureDate
        }) >= resort.minAuthorizedAge.value;
      }));
      return resort && isAllAttendeeAllowed ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [resort]) : acc;
    }, []);
    var sortedFilteredProducts = criteria.productIds && criteria.productIds.length > 0 ? criteria.productIds.map(function (id) {
      return filteredProducts.find(function (product) {
        return product.id === id;
      });
    }) : filteredProducts;
    return _objectSpread(_objectSpread({}, pertimmResults), {}, {
      query: criteria.query || '',
      search: {
        products: sortedFilteredProducts.filter(Boolean)
      }
    });
  });
}

function getTransportArgs(criteria) {
  var departureCityFilter = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(criteria, 'filters', []).find(function (filter) {
    return filter.id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DEPARTURE_CITY_FACET_ID */ "j"];
  });
  var selectedDepartureCity = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(departureCityFilter, 'name');

  switch (selectedDepartureCity) {
    case 'NO':
      return {
        forceWithoutTransport: true,
        departureCity: ''
      };

    case undefined:
      return {
        forceWithoutTransport: false,
        departureCity: ''
      };

    default:
      return {
        forceWithoutTransport: false,
        departureCity: selectedDepartureCity
      };
  }
}

function loadPrices(_ref10) {
  var appContext = _ref10.appContext,
      _ref10$criteria = _ref10.criteria,
      criteria = _ref10$criteria === void 0 ? {} : _ref10$criteria,
      withFlexibility = _ref10.withFlexibility;
  var _criteria$offerName = criteria.offerName,
      offerName = _criteria$offerName === void 0 ? '' : _criteria$offerName,
      _criteria$offerId = criteria.offerId,
      offerId = _criteria$offerId === void 0 ? '' : _criteria$offerId,
      _criteria$productIds = criteria.productIds,
      productIds = _criteria$productIds === void 0 ? [] : _criteria$productIds,
      duration = criteria.duration;

  var _getTransportArgs = getTransportArgs(criteria),
      departureCity = _getTransportArgs.departureCity,
      forceWithoutTransport = _getTransportArgs.forceWithoutTransport;

  var date = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(criteria.departureDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "g"]) || '';
  var dateStart = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(criteria.minDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "g"]) || '';
  var dateEnd = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(criteria.maxDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_10__[/* DATE_FORMAT */ "g"]) || '';
  var hasDateRange = dateStart && dateEnd && (!date || withFlexibility);
  var query = "\n    query {\n      resorts(\n        optimizedPriceCalls: true,\n        ".concat(date ? "date: \"".concat(date, "\",") : '', "\n        ").concat(hasDateRange ? "dateStart: \"".concat(dateStart, "\",") : '', "\n        ").concat(hasDateRange ? "dateEnd: \"".concat(dateEnd, "\",") : '', "\n        resortIds: [\"").concat(productIds.join('","'), "\"],\n        departureCity: \"").concat(departureCity, "\",\n        duration: ").concat(String(duration || null), ",\n        offerName: \"").concat(offerName, "\",\n        offerId: \"").concat(offerId, "\",\n        forceWithoutTransport: ").concat(String(forceWithoutTransport), ",\n      ) {\n        id\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* getPriceFields */ "c"])(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* cleanupArgs */ "a"])({
    optimizedPriceCalls: true,
    resortIds: productIds,
    departureCity: departureCity,
    duration: duration || undefined,
    // for flow: criteria duration can be null, but cleanupArgs doesn't accept null as parameter.
    offerName: offerName,
    offerId: offerId,
    forceWithoutTransport: forceWithoutTransport,
    content: appContext.cmsContent,
    release: appContext.cmsRelease,
    date: date,
    dateStart: dateStart,
    dateEnd: dateEnd
  })), "\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_PRICE */ "Jd"]
  });
}
function loadChildcareAvailabilities(_ref11) {
  var appContext = _ref11.appContext,
      _ref11$criteria = _ref11.criteria,
      criteria = _ref11$criteria === void 0 ? {} : _ref11$criteria;
  var _criteria$productIds2 = criteria.productIds,
      productIds = _criteria$productIds2 === void 0 ? [] : _criteria$productIds2,
      arrivalDate = criteria.departureDate,
      duration = criteria.duration,
      kids = criteria.kids;

  if (!kids || kids.length === 0) {
    return Promise.resolve();
  }

  var query = "\n    query {\n      childcareSearch(\n        arrival_date: \"".concat(Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(arrivalDate, 'YYYYMMDD') || '', "\",\n        product_ids: [\"").concat(productIds.join('","'), "\"],\n        concerned_attendees_birthdates: [\"").concat(kids.map(function (_ref12) {
    var birthdate = _ref12.birthdate;
    return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "c"])(birthdate, 'YYYYMMDD');
  }).join('","'), "\"],\n        duration: ").concat(String(duration || null), ",\n      ) {\n        id\n        productId,\n        availability,\n        isIncluded,\n        ageMin,\n        ageMax\n        remainingStock\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* STATE_SEARCH_PRODUCT_CHILDCARE */ "Hd"]
  });
}

/***/ }),

/***/ "4/4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tabs; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.util.js
var tabs_util = __webpack_require__("GzVq");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.hoc.jsx
var tabs_hoc = __webpack_require__("lW4u");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/active-indexes/ActiveIndexes.jsx
var ActiveIndexes = __webpack_require__("1Wgj");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx + 1 modules
var TabHeader = __webpack_require__("ZKlR");

// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.themes.js

var Tabs_themes_themes = function themes(_ref) {
  var isScrollable = _ref.isScrollable;
  return {
    "default": {
      thHeader: '',
      thList: 'pb-2',
      thListItem: classnames_default()({
        'flex-grow': !isScrollable
      }),
      thSlot: 'pb-2',
      thBody: '-mt-2 pt-5'
    },
    clean: {
      thHeader: 'border-b-1 items-stretch',
      thList: 'whitespace-no-wrap',
      thListItem: 'decorator-separator-left',
      thSlot: 'flex items-center rtl:border-r-1',
      thBody: '-m-px py-5'
    },
    rounded: {
      thHeader: '',
      thScrollable: 'flex-1',
      thList: '',
      thListItem: 'flex-1',
      thSlot: '',
      thBody: 'bg-white border-1 border-t-0 rounded-tiny'
    },
    simple: {
      thHeader: '',
      thList: 'pb-3',
      thListItem: classnames_default()('mx-1', {
        'flex-grow': !isScrollable
      }),
      thSlot: 'pb-3',
      thBody: ''
    },
    lite: {
      thHeader: 'mb-5',
      thList: '-mx-1 flex-grow',
      thListItem: classnames_default()('mx-1', {
        'flex-none': isScrollable
      }),
      thSlot: ''
    },
    flat: {
      thBody: 'bg-white border-1 border-gray-light p-5 rounded-tiny relative -mt-px shadow-diffuse',
      thHeader: 'items-center',
      thList: '',
      thListItem: '',
      thSlot: 'flex-shrink-0'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx



var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var Tabs_Tabs = function _Tabs(_ref) {
  var areAllCollapsable = _ref.areAllCollapsable,
      bgColor = _ref.bgColor,
      className = _ref.className,
      collapseIconName = _ref.collapseIconName,
      containerSize = _ref.containerSize,
      expandIconName = _ref.expandIconName,
      hasBackground = _ref.hasBackground,
      isContainerWide = _ref.isContainerWide,
      isContentUnmountedOnCollapse = _ref.isContentUnmountedOnCollapse,
      _ref$initialSelectedI = _ref.initialSelectedItem,
      initialSelectedItem = _ref$initialSelectedI === void 0 ? 0 : _ref$initialSelectedI,
      id = _ref.id,
      isScrollable = _ref.isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      onSelect = _ref.onSelect,
      onTabClick = _ref.onTabClick,
      scrollForwardLabel = _ref.scrollForwardLabel,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      slotLeft = _ref.slotLeft,
      slotRight = _ref.slotRight,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  if (!items.length) {
    return null;
  }

  var refsArray = [];
  var _themes$theme = Tabs_themes_themes({
    isScrollable: isScrollable
  })[theme],
      thBody = _themes$theme.thBody,
      thHeader = _themes$theme.thHeader,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thScrollable = _themes$theme.thScrollable,
      thSlot = _themes$theme.thSlot;

  var tabUpdate = function tabUpdate(idx, update) {
    update(idx);
    refsArray[idx] && refsArray[idx].focus();
  };

  var _onKeyDown = function onKeyDown(_ref2) {
    var e = _ref2.e,
        index = _ref2.index,
        update = _ref2.update;

    if (items.length > 1) {
      var lastItem = items.length - 1;

      switch (e.which) {
        case keyCodes["c" /* ARROW_RIGHT */]:
        case keyCodes["a" /* ARROW_DOWN */]:
          e.preventDefault();
          tabUpdate(index === lastItem ? 0 : index + 1, update);
          break;

        case keyCodes["b" /* ARROW_LEFT */]:
        case keyCodes["d" /* ARROW_UP */]:
          e.preventDefault();
          tabUpdate(index === 0 ? lastItem : index - 1, update);
          break;

        case keyCodes["h" /* HOME */]:
          e.preventDefault();
          tabUpdate(0, update);
          break;

        case keyCodes["e" /* END */]:
          e.preventDefault();
          tabUpdate(lastItem, update);
          break;

        default:
      }
    }
  };

  var tabsCount = items.filter(Boolean).length;
  return __jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    activeIndexes: [initialSelectedItem],
    hasNoIndexEnabled: areAllCollapsable,
    onUpdate: onSelect
  }, function (_ref3) {
    var update = _ref3.update,
        activeIndexes = _ref3.activeIndexes,
        lastIndex = _ref3.lastIndex;
    var els = items.filter(Boolean).map(function (_ref4, index) {
      var customHeader = _ref4.customHeader,
          _ref4$header = _ref4.header,
          header = _ref4$header === void 0 ? {} : _ref4$header,
          headerId = _ref4.headerId,
          panelId = _ref4.panelId;

      var onClick = function onClick() {
        tabUpdate(index, update);
        onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(headerId, index);
      };

      var isActive = activeIndexes.includes(index);

      var setRef = function setRef(ref) {
        refsArray[index] = ref;
      };

      var title = header.title,
          rest = Object(objectWithoutProperties["a" /* default */])(header, ["title"]);

      var headerProps = _objectSpread(_objectSpread({}, rest), {}, {
        controlsId: panelId,
        id: headerId,
        isActive: isActive,
        isDisabled: tabsCount <= 1,
        onClick: onClick,
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown({
            e: e,
            index: index,
            update: update
          });
        },
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        tabIndex: isActive || index === lastIndex ? 0 : -1
      });

      if (Object(lodash["isFunction"])(customHeader)) {
        return customHeader(headerProps, setRef);
      }

      return __jsx(TabHeader["a" /* TabHeader */], Object(esm_extends["a" /* default */])({}, headerProps, {
        className: thListItem,
        collapseIconName: collapseIconName,
        expandIconName: expandIconName,
        key: headerId,
        ref: setRef,
        role: "tab",
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        theme: theme
      }), title);
    });

    var tabsList = __jsx("div", {
      className: classnames_default()('reset-list flex w-full', thList),
      role: "tablist"
    }, els);

    return __jsx("section", {
      className: className,
      id: id,
      "data-cs-override-id": "Tabs" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
      ,
      "data-testid": "tabs"
    }, __jsx(SiteContainer["a" /* SiteContainer */], {
      isWide: isContainerWide,
      size: containerSize
    }, __jsx("div", {
      className: classnames_default()('flex', thHeader)
    }, slotLeft && __jsx("div", {
      className: thSlot
    }, slotLeft), isScrollable ? __jsx(Scrollable["a" /* Scrollable */], {
      backwardLabel: scrollBackwardLabel,
      className: thScrollable,
      forwardLabel: scrollForwardLabel,
      hasShadow: true,
      navPosition: "side"
    }, tabsList) : tabsList, slotRight && __jsx("div", {
      className: thSlot
    }, slotRight))), __jsx("div", {
      "data-testid": "tabs-items-container",
      className: classnames_default()(Object(defineProperty["a" /* default */])({}, Object(tabs_util["a" /* getTabsBackgroundClasses */])(hasBackground, bgColor), activeIndexes.length > 0 && !activeIndexes.includes(-1)), thBody)
    }, items.filter(Boolean).map(function (_ref5, index) {
      var content = _ref5.content,
          headerId = _ref5.headerId,
          panelId = _ref5.panelId;
      var isActive = activeIndexes.includes(index);
      return (!isContentUnmountedOnCollapse || isActive) && __jsx("div", {
        "aria-hidden": !isActive,
        "aria-labelledby": headerId,
        className: classnames_default()({
          'h-0 invisible overflow-hidden pointer-events-none': !isActive,
          fadeIn: isActive
        }),
        "data-cs-override-id": "Tabs-panel" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
        ,
        id: panelId,
        key: panelId,
        role: "tabpanel",
        "data-testid": "tabs-item-".concat(index, "-content")
      }, __jsx(SiteContainer["a" /* SiteContainer */], {
        isWide: isContainerWide,
        size: containerSize
      }, react["Children"].map(content, function (el, i) {
        return el ? /*#__PURE__*/Object(react["cloneElement"])(el, {
          key: "".concat(panelId, "-").concat(i)
        }) : null;
      })));
    })));
  });
};

var Tabs = Object(tabs_hoc["a" /* withOpenAndScrollToHash */])(Tabs_Tabs);

/***/ }),

/***/ "45Yg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRIP_INFORMATION_SET_FLEXIBILITY; });
var TRIP_INFORMATION_SET_FLEXIBILITY = 'TRIP_INFORMATION_SET_FLEXIBILITY';

/***/ }),

/***/ "47Eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shouldHideServicesPage */
/* unused harmony export shouldHideTransportPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStepIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilteredBreadcrumbPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return navigateInBookingEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllProposalsIdWithAlternative; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z8xc");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("aWOT");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("1qsz");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("nv//");



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var JOYVIEW_ROOM_ONLY = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].PACKAGES.JOYVIEW_ROOM_ONLY;
var BASE_PATH = '/booking/';
var shouldHideServicesPage = function shouldHideServicesPage(selectedProposal, resort) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_8__[/* hasChildcare */ "p"])(selectedProposal) && !resort.isJoyview && selectedProposal.additionalServices.childcares.length === 0 || resort.isJoyview && !selectedProposal.alternativePackages && selectedProposal.packageId === JOYVIEW_ROOM_ONLY;
};
var shouldHideTransportPage = function shouldHideTransportPage(selectedProposal) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_8__[/* hasTransfer */ "s"])(selectedProposal) && !Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports');
};
var getStepIndex = function getStepIndex(steps, bookingStep) {
  return steps.findIndex(function (step) {
    return step.name === bookingStep;
  });
}; // eslint-disable-next-line max-params

var getFilteredBreadcrumbPages = function getFilteredBreadcrumbPages(_ref) {
  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      i18n = _ref.i18n,
      isActivitiesViewFeatureFlipped = _ref.isActivitiesViewFeatureFlipped,
      isOptionHoldOnlyFeatureFlipped = _ref.isOptionHoldOnlyFeatureFlipped,
      _ref$isSeller = _ref.isSeller,
      isSeller = _ref$isSeller === void 0 ? false : _ref$isSeller,
      _ref$isCmta = _ref.isCmta,
      isCmta = _ref$isCmta === void 0 ? false : _ref$isCmta,
      _ref$isDelCredere = _ref.isDelCredere,
      isDelCredere = _ref$isDelCredere === void 0 ? false : _ref$isDelCredere;
  var isRecommendedTransportSelected = selectedProposal.transports && Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_8__[/* isRecommendedTransport */ "x"])(selectedProposal.transports, selectedProposal.id);
  var activitiesView = isActivitiesViewFeatureFlipped && (selectedProposal.additionalServices.activities.some(function (activity) {
    return activity.productInfo.isIncluded === false;
  }) || selectedProposal.additionalServices.rentals.length > 0) ? {
    name: 'activities',
    path: "".concat(BASE_PATH, "activities"),
    actionGA: 'activities',
    labelGA: 'validateActivities',
    basePriceGALabel: 'basePriceActivities',
    icon: Object(_utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_9__[/* isWinterMountainResort */ "a"])(resort) ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].SKI : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].GOLF,
    showIcon: true,
    title: i18n.booking.activities.pageTitle,
    seoTitle: i18n.booking.activities.seo.title,
    gridSize: 'large'
  } : null;
  var isJoyview = Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(resort, 'isJoyview');
  var breadcrumbPages = [{
    name: 'accommodation',
    path: "".concat(BASE_PATH, "accommodation"),
    eventPageName: 'accommodations',
    actionGA: 'accommodation',
    labelGA: 'validateAccommodation',
    basePriceGALabel: 'basePriceAccommodation',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ACCOMODATIONS,
    showIcon: true,
    title: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_7__[/* tAlt */ "b"])({
      resortKeyPath: 'booking.accommodation.pageTitle',
      cruiseKeyPath: 'booking.accommodation.pageTitleCruise',
      resort: resort
    }),
    seoTitle: i18n.booking.accommodation.seo.title,
    gridSize: 'large'
  }, _objectSpread(_objectSpread({
    name: 'transport',
    path: "".concat(BASE_PATH, "transport"),
    actionGA: 'transport',
    labelGA: 'validateTransport'
  }, Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports') ? {
    icon: Object(_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_6__[/* getTransportIcon */ "k"])(Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports.inbound'), Object(lodash__WEBPACK_IMPORTED_MODULE_2__["get"])(selectedProposal, 'transports.outbound')),
    title: isRecommendedTransportSelected ? i18n.booking.transport.transportPageTitle : i18n.booking.transport.additionalTransports.transportSelection,
    seoTitle: i18n.booking.transport.seo.title,
    basePriceGALabel: 'basePriceTransport'
  } : {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRANSFER,
    title: i18n.booking.transport.transferPageTitle,
    seoTitle: i18n.booking.transport.transfer.seo.title,
    basePriceGALabel: 'basePriceTransfer'
  }), {}, {
    showIcon: true,
    isToBeHidden: shouldHideTransportPage(selectedProposal),
    gridSize: 'large'
  }), {
    name: 'services',
    path: "".concat(BASE_PATH, "services"),
    actionGA: isJoyview ? 'allInclusive' : 'service',
    labelGA: isJoyview ? 'validateAllInclusive' : 'validateServices',
    basePriceGALabel: 'basePriceServices',
    icon: isJoyview ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].DATE_PLUS : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CHILDREN,
    showIcon: true,
    title: isJoyview ? i18n.booking.services.pageTitleJoyview : i18n.booking.services.pageTitleChildcare,
    seoTitle: i18n.booking.services.seo.title,
    isToBeHidden: shouldHideServicesPage(selectedProposal, resort),
    gridSize: isJoyview ? 'small' : 'large'
  }, {
    name: 'participants',
    path: "".concat(BASE_PATH, "participants"),
    actionGA: 'participant',
    labelGA: 'validateParticipants',
    basePriceGALabel: 'basePricePaymentParticipants',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CONTACT,
    showIcon: true,
    title: i18n.booking.participants.pageTitle,
    seoTitle: i18n.booking.participants.seo.title,
    gridSize: 'mini'
  }, {
    name: 'summary',
    path: "".concat(BASE_PATH, "summary"),
    actionGA: 'summary',
    labelGA: 'validateSummary',
    basePriceGALabel: 'basePriceSummary',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].SUMMARY,
    showIcon: true,
    title: i18n.booking.summary.pageTitle,
    seoTitle: i18n.booking.summary.seo.title,
    gridSize: 'large'
  }];
  if (activitiesView) breadcrumbPages.splice(3, 0, activitiesView); // adds the banking step if the optionHoldOnly featureFlip is disabled

  if (!isOptionHoldOnlyFeatureFlipped) breadcrumbPages.push({
    name: 'banking',
    eventPageName: isSeller && isDelCredere ? 'banking_Ducroire' : 'banking',
    path: "".concat(BASE_PATH, "banking"),
    actionGA: isSeller && isDelCredere ? 'bankingDucroire' : 'banking',
    labelGA: 'validateBanking',
    basePriceGALabel: 'basePricePaymentBanking',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CREDIT_CARD,
    showIcon: !isSeller || isCmta,
    title: i18n.booking.banking.pageTitle,
    seoTitle: i18n.booking.banking.seo.title
  }); // $FlowFixMe Absolutely no clue of why

  return Object(lodash__WEBPACK_IMPORTED_MODULE_2__["reject"])(breadcrumbPages, 'isToBeHidden');
};
var navigateInBookingEngine = function navigateInBookingEngine(_ref2) {
  var location = _ref2.location,
      history = _ref2.history,
      _ref2$replace = _ref2.replace,
      replace = _ref2$replace === void 0 ? false : _ref2$replace;
  var nextUri = location instanceof urijs__WEBPACK_IMPORTED_MODULE_3___default.a ? location : Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_10__[/* convertLocationToURI */ "c"])(location);
  var fileName = nextUri.filename();
  var shownUri = nextUri.clone();
  nextUri.pathname('/booking').setQuery('bookingStep', fileName);
  var nextUrl = nextUri.resource().toString();
  var shownUrl = shownUri.resource().toString();

  if (replace) {
    history.replace(nextUrl, shownUrl);
  } else {
    history.push(nextUrl, shownUrl);
  }
};
var getAllProposalsIdWithAlternative = function getAllProposalsIdWithAlternative(proposal) {
  return [proposal.id].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(proposal.alternativePackages ? proposal.alternativePackages.map(function (alternativePackage) {
    return alternativePackage.proposalId;
  }) : []));
};

/***/ }),

/***/ "47go":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    var STATE_OUTPUT       = 0,
        STATE_HTML         = 1,
        STATE_PRE_COMMENT  = 2,
        STATE_COMMENT      = 3,
        WHITESPACE         = /\s/,
        ALLOWED_TAGS_REGEX = /<(\w*)>/g;

    function striptags(html, allowableTags) {
        var html = html || '',
            state = STATE_OUTPUT,
            depth = 0,
            output = '',
            tagBuffer = '',
            inQuote = false,
            i, length, c;

        if (typeof allowableTags === 'string') {
            // Parse the string into an array of tags
            allowableTags = parseAllowableTags(allowableTags);
        } else if (!Array.isArray(allowableTags)) {
            // If it is not an array, explicitly set to null
            allowableTags = null;
        }

        for (i = 0, length = html.length; i < length; i++) {
            c = html[i];

            switch (c) {
                case '<': {
                    // ignore '<' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // '<' followed by a space is not a valid tag, continue
                    if (html[i + 1] == ' ') {
                        consumeCharacter(c);
                        break;
                    }

                    // change to STATE_HTML
                    if (state == STATE_OUTPUT) {
                        state = STATE_HTML;

                        consumeCharacter(c);
                        break;
                    }

                    // ignore additional '<' characters when inside a tag
                    if (state == STATE_HTML) {
                        depth++;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '>': {
                    // something like this is happening: '<<>>'
                    if (depth) {
                        depth--;
                        break;
                    }

                    // ignore '>' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // an HTML tag was closed
                    if (state == STATE_HTML) {
                        inQuote = state = 0;

                        if (allowableTags) {
                            tagBuffer += '>';
                            flushTagBuffer();
                        }

                        break;
                    }

                    // '<!' met its ending '>'
                    if (state == STATE_PRE_COMMENT) {
                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    // if last two characters were '--', then end comment
                    if (state == STATE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '-') {

                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                // catch both single and double quotes
                case '"':
                case '\'': {
                    if (state == STATE_HTML) {
                        if (inQuote == c) {
                            // end quote found
                            inQuote = false;
                        } else if (!inQuote) {
                            // start quote only if not already in one
                            inQuote = c;
                        }
                    }

                    consumeCharacter(c);
                    break;
                }

                case '!': {
                    if (state == STATE_HTML &&
                        html[i - 1] == '<') {

                        // looks like we might be starting a comment
                        state = STATE_PRE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '-': {
                    // if the previous two characters were '!-', this is a comment
                    if (state == STATE_PRE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '!') {

                        state = STATE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case 'E':
                case 'e': {
                    // check for DOCTYPE, because it looks like a comment and isn't
                    if (state == STATE_PRE_COMMENT &&
                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {

                        state = STATE_HTML;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                default: {
                    consumeCharacter(c);
                }
            }
        }

        function consumeCharacter(c) {
            if (state == STATE_OUTPUT) {
                output += c;
            } else if (allowableTags && state == STATE_HTML) {
                tagBuffer += c;
            }
        }

        function flushTagBuffer() {
            var normalized = '',
                nonWhitespaceSeen = false,
                i, length, c;

            normalizeTagBuffer:
            for (i = 0, length = tagBuffer.length; i < length; i++) {
                c = tagBuffer[i].toLowerCase();

                switch (c) {
                    case '<': {
                        break;
                    }

                    case '>': {
                        break normalizeTagBuffer;
                    }

                    case '/': {
                        nonWhitespaceSeen = true;
                        break;
                    }

                    default: {
                        if (!c.match(WHITESPACE)) {
                            nonWhitespaceSeen = true;
                            normalized += c;
                        } else if (nonWhitespaceSeen) {
                            break normalizeTagBuffer;
                        }
                    }
                }
            }

            if (allowableTags.indexOf(normalized) !== -1) {
                output += tagBuffer;
            }

            tagBuffer = '';
        }

        return output;
    }

    /**
     * Return an array containing tags that are allowed to pass through the
     * algorithm.
     *
     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
     * @return array|null An array of allowed tags or null if none.
     */
    function parseAllowableTags(allowableTags) {
        var tagsArray = [],
            match;

        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
            tagsArray.push(match[1]);
        }

        return tagsArray.length !== 0 ? tagsArray : null;
    }

    return striptags;
}));


/***/ }),

/***/ "4A3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AsyncLoader_AsyncLoader; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/label/SpinnerLabel.jsx
var SpinnerLabel = __webpack_require__("4SQ0");

// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.themes.js
var themes = {
  "default": {
    thRoot: 'flex justify-center h-full items-center'
  },
  labeled: {
    thRoot: 'flex flex-col justify-center items-center my-0 mx-auto text-center',
    thRootStyle: {
      width: '20rem'
    },
    thLabel: 'inline'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var AsyncLoader_AsyncLoader = function AsyncLoader(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].TRIDENT1 : _ref$icon,
      iconSize = _ref.iconSize,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot,
      thRootStyle = _themes$theme.thRootStyle;
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    style: _objectSpread(_objectSpread({}, thRootStyle), style)
  }, __jsx(Spinner["a" /* Spinner */], {
    iconName: icon,
    iconSize: iconSize
  }), __jsx(SpinnerLabel["a" /* SpinnerLabel */], {
    className: thLabel,
    label: label
  }));
};

/***/ }),

/***/ "4Db7":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "4HxW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productRelatedProductsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");






var productRelatedProductsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RELATED_PRODUCTS */ "Z"],
  resolve: function resolve(appContext, props) {
    var _appContext$cmsConten = appContext.cmsContent,
        cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
        _appContext$cmsReleas = appContext.cmsRelease,
        cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
    var _props$resortId = props.resortId,
        resortId = _props$resortId === void 0 ? '' : _props$resortId,
        tourDurationPlaceholder = props.tourDurationPlaceholder,
        cruiseTimingPlaceholder = props.cruiseTimingPlaceholder,
        cruiseDurationPlaceholder = props.cruiseDurationPlaceholder,
        dateFormat = props.dateFormat;
    var cmsArgs = "content: \"".concat(cmsContent, "\", release: \"").concat(cmsRelease, "\"");
    var query = "query {\n      product: resort(productId: \"".concat(resortId, "\") {\n        relatedProducts {\n          id\n          ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])({
      content: cmsContent,
      release: cmsRelease,
      tourDurationPlaceholder: tourDurationPlaceholder,
      cruiseTimingPlaceholder: cruiseTimingPlaceholder,
      cruiseDurationPlaceholder: cruiseDurationPlaceholder,
      dateFormat: dateFormat
    }), "\n        }\n      }\n      config(").concat(cmsArgs, ") {\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_2__[/* resort */ "e"](appContext), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_2__[/* price */ "c"](), "\n        common {\n          next\n          previous\n          close\n          thumbnailCTA\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_PRODUCT_RELATED_PRODUCTS */ "wc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    });
  }
};

/***/ }),

/***/ "4NBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productBookingBEResolver; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");





var productBookingBEResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* RESORT_BOOKING_BE */ "eb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var offerName = location.queryParams.offer ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["url"].decodePath(location.queryParams.offer) : '';
    var resortId = props.resortId;
    var resortArgs = "resortId: \"".concat(resortId, "\"");
    var offerArgs = "offerName: \"".concat(offerName, "\"");
    var cmsArgs = "content: \"".concat(appContext.cmsContent, "\" release: \"").concat(appContext.cmsRelease, "\"");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery('', appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_PRODUCT_BOOKING */ "cc"],
      queryId: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_PRODUCT_BOOKING */ "cc"],
      prebuiltArgs: {
        resortArgs: resortArgs,
        resortId: resortId,
        cmsArgs: cmsArgs,
        offerArgs: offerArgs,
        minAgeInformation: props.minAgeInformation,
        minAgeErrorMessage: props.minAgeErrorMessage,
        resortStartingPrice: _views_configQueries__WEBPACK_IMPORTED_MODULE_3__[/* resortStartingPrice */ "f"]()
      }
    });
  }
};

/***/ }),

/***/ "4SQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerLabel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


function SpinnerLabel(props) {
  var className = props.className,
      label = props.label;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'text-center font-brand leading-normal max-w-4/5 sm:max-w-3/5 mt-4 text-blue text-xl', {
      'sr-only': !label
    }),
    "aria-live": "polite"
  }, label ? label : 'Loading');
}

/***/ }),

/***/ "4VTZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return searchRemote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resortStartingPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return price; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return faceting; });
/* unused harmony export birthdatePopin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return common; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return priceRemote; });
function searchRemote() {
  return "\n    remote {\n      date\n      placeholder\n      searchAction\n      title\n    }\n  ";
}
function resortStartingPrice() {
  return "\n    startingPrice {\n      allInclusive\n      bookingButtonLabel\n      dateFormat\n      departureCityLabel\n      departureDateLabel\n      durationUnit\n      endDateLabel\n      roomOnly\n      seeDetails\n      stayDeparture\n    }\n  ";
}
function resort(appContext) {
  var _appContext$cmsConten = appContext.cmsContent,
      cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
      _appContext$cmsReleas = appContext.cmsRelease,
      cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
  var cmsArgs = "content : \"".concat(cmsContent, "\", release : \"").concat(cmsRelease, "\"");
  return "\n    resort {\n      season(".concat(cmsArgs, ") {\n        winter\n        summer\n        button\n      }\n      ").concat(resortStartingPrice(), "\n      pricePopin {\n        buttonLabel\n        buttonCruiseLabel\n        buttonTourLabel\n        priceIsLabel\n        roomAvailability\n        startingPriceDescriptionWithoutTransport\n        startingPriceDescriptionWithTransport\n        taxeAndFees\n      }\n      tripadvisor {\n        menubar {\n          reviews\n        }\n      }\n      moreResultsLabels {\n        label\n        buttonLabel\n      }\n    }\n  ");
}
function price() {
  return "\n    price {\n      format{\n        from\n        instead\n        flightIncluded\n        unitPerTrip\n        unitPerNight\n        viewRates\n      }\n    }\n  ";
}
function faceting() {
  return "\n    common {\n      dateFormatPlaceholder\n      loadLess\n      loadMore\n      selectedCriteriasLabel {\n        _1\n        n\n      }\n    }\n    booking {\n      form {\n        dateFormat\n        dayPlaceholder\n        monthPlaceholder\n        yearPlaceholder\n        departureDateTitle\n        selectAdultsLabels {\n          _1\n          n\n        }\n        selectChildrenLabels {\n          _1\n          n\n        }\n      }\n      editCriteria {\n        validateCriteria\n      }\n    }\n    faceting {\n      intro\n      facetClear\n      oneResortThatMatchYourCriteria\n      nbResortsThatMatchYourCriteria\n      viewResorts\n      searchTitle\n      searchLinkLabel\n      suggestedRequests {\n        title\n        items {\n          label\n          url\n        }\n      }\n      reset\n      validate\n      when {\n        title\n        subTitle\n        durations\n        duration\n        from\n        bestPrice\n        lastAvailability\n        notAvailable\n        departureDateTitle\n        arrivalDateTitle\n        durationSingular\n        durationPlural\n        reinsurance\n        pricesBasedOn\n      }\n      where {\n        title\n        destinationTitle\n        countriesTitle\n      }\n      who {\n        addChildcare\n        adults\n        ageComment\n        ageSectionChildcareSubtitle\n        ageSectionSubtitle\n        birthdatePlaceholder\n        kids\n        kidsAgeLimit\n        kidsBirthdate\n        subTitle\n        title\n        withKidsFacetLabel\n        withChildcareFacetLabel\n      }\n      activities {\n        title\n        sportTitle\n        relaxTitle\n        otherActivitiesTitle\n      }\n      compare {\n        selectResort\n        selected\n        dateAndTransportMandatory\n        unavailableThumbnail\n        warningMessage\n        title\n        buttonLabel\n        cancelLabel\n        collapseLabel\n        expandLabel\n        dropzoneLabel\n      }\n      transport {\n        selectPlaceholder\n        titleFrom\n        subTitle\n        comment\n        departingFrom\n        defaultDepartureCityOnlyForDefaultTransportation\n      }\n      availabilities {\n        childcare\n        enterBirthdate\n        years\n        year\n        months\n        noChildcare\n        noChildcareFrom0\n        available\n        unavailable\n        unknown\n        urgentizationSingular\n        urgentizationPlural\n      }\n      showFilterCTA\n      hideFilterCTA\n      typesOfStay {\n        title\n        label_village\n        label_cruise\n        label_tour\n        label_villa\n      }\n      comfort {\n        title\n      }\n    }";
}
function birthdatePopin() {
  return "birthdatePopin {\n    title\n    subtitle\n    confirm\n    child\n    skip\n  }";
}
function common() {
  return "common {\n    close\n    continue\n    included\n    allInclusive\n  }";
}
function priceRemote() {
  return "".concat(faceting(), "\n  ").concat(common(), "\n  booking {\n    form {\n      selectAdultsLabels {\n        _1\n        n\n      }\n      selectChildrenLabels {\n        _1\n        n\n      }\n      selectDates\n      selectParticipants\n      selectTransports\n      proposalsLoaderLabel\n      errors {\n        birthdayFormat\n      }\n    }\n    priceCalendar {\n      offers {\n        bestPrice { label }\n        urgentisation { label rateToDisplay }\n      }\n    }\n  }\n  price {\n    format{\n      from\n      instead\n      viewRates\n      unitTotalPerTrip\n    }\n  }\n  priceRemote {\n    openAllInclusiveDetails\n    closeAllInclusiveDetails\n    notAvailable\n    notAvailableCTA\n    notAvailableCTATransportation\n    notAvailableTransportation\n    priceForAll\n    priceRemoteButton\n    linkToCalendar\n    errors {\n      noAvailabilities\n      notOnSale\n      technicalError\n      invalidCriteria\n      noTransport\n    }\n  }\n  resort {\n    startingPrice {\n      allInclusive\n    }\n  }\n  ");
}

/***/ }),

/***/ "4oK2":
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__("BRr/"),
    decode = __webpack_require__("oW49");

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),

/***/ "4qke":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("tU/q"),
    getSymbols = __webpack_require__("WwbQ"),
    keys = __webpack_require__("DWlz");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "5FP0":
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__("ubIY");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "5R7x":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "5q4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttendeesSummary; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("taV1");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("WGoB");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;








var AttendeesSummary = function AttendeesSummary(_ref) {
  var adults = _ref.adults,
      _ref$extendedDataset = _ref.extendedDataset,
      extendedDataset = _ref$extendedDataset === void 0 ? false : _ref$extendedDataset,
      kids = _ref.kids;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('PackagePriceSummary-section', {
      'PackagePriceSummary-section--extended': extendedDataset
    }),
    "data-testid": _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__[/* CRITERIA_SELECTORS */ "m"].ATTENDEES
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "PackagePriceSummary-icon",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    hasRtl: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].USERS,
    width: "1.875rem"
  }), __jsx("span", null, __jsx("div", {
    className: "PackagePriceSummary-guestsItem",
    key: "adults"
  }, __jsx("span", {
    className: "PackagePriceSummary-guestsNumber"
  }, adults), " ".concat(Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_5__[/* pluralizeLabel */ "d"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "f"])('booking.common.adult'), Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "f"])('booking.common.adults'), adults))), kids > 0 ? __jsx("div", {
    className: "PackagePriceSummary-guestsItem",
    key: "children"
  }, __jsx("span", {
    className: "PackagePriceSummary-guestsNumber"
  }, kids), " ".concat(Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_5__[/* pluralizeLabel */ "d"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "f"])('booking.common.child'), Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "f"])('booking.common.children'), kids))) : null));
};

/***/ }),

/***/ "5siB":
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {}

}());


/***/ }),

/***/ "66Hx":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "68C9":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("07TY");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "6MnY":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("lxRQ"),
    isIterateeCall = __webpack_require__("FHsl");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "6TMq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sectionsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var sectionsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* SECTIONS */ "wb"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common { next previous scrollBackward scrollForward }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_COMMON_I18N */ "c"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "6X2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryInfosResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");



var countryInfosResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* COUNTRY_INFOS */ "f"],
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var countryId = props.countryId,
        isForFamily = props.isForFamily;
    var countryArgs = "countryId:\"".concat(countryId, "\" isForFamily:").concat(isForFamily.toString());
    var query = "query {\n      config {\n        common { close }\n      }\n      countryInfos(".concat(countryArgs, ") {\n        texts {\n          title\n          description\n          media {\n            mediaUrl\n            mediaAlt\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* LINE_COMMON_COUNTRY_INFOS */ "Bb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "6wD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateTripDateCriteria; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function updateTripDateCriteria(options) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* UPDATE_TRIP_DATE_CRITERIA */ "w"], options);
}



/***/ }),

/***/ "786X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Card_Card; });

// NAMESPACE OBJECT: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_namespaceObject = {};
__webpack_require__.r(Card_layouts_namespaceObject);
__webpack_require__.d(Card_layouts_namespaceObject, "Inline1", function() { return Card_layouts_Inline1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Inline2", function() { return Card_layouts_Inline2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column1", function() { return Card_layouts_Column1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column2", function() { return Column2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Composite1", function() { return Card_layouts_Composite1; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.constants.js
var Card_constants = __webpack_require__("syQ6");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.themes.js

var defaultTheme = {
  thCtaDefaultColor: colors["a" /* COLORS */].GRAY_DARKER
};
var cardBodyThemes = {
  "default": defaultTheme,
  thumbnail: defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.jsx

var __jsx = react_default.a.createElement;






var CardBody_CardBody = function CardBody(_ref) {
  var color = _ref.color,
      ctaLabel = _ref.ctaLabel,
      isTablet = _ref.isTablet,
      layout = _ref.layout,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? {} : _ref$text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var thCtaDefaultColor = cardBodyThemes[theme].thCtaDefaultColor;
  var isCollapsable = !isTablet || [Card_constants["a" /* COLUMN_1 */], Card_constants["b" /* COLUMN_2 */]].includes(layout);
  return __jsx(react["Fragment"], null, __jsx(TextSeeMore["a" /* TextSeeMore */], Object(esm_extends["a" /* default */])({}, text, {
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: isCollapsable,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel
  })), __jsx(TextLink["a" /* TextLink */], Object(esm_extends["a" /* default */])({}, link, {
    className: classnames_default()({
      'mt-5': text === null || text === void 0 ? void 0 : text.text
    }),
    color: color || thCtaDefaultColor,
    label: ctaLabel
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.themes.js
var cardHeadingThemes = {
  "default": {
    thTitleTheme: 'title-brand-11',
    thSmall: 'font-normal text-small ml-1',
    thSubtitleTheme: 'title-sans-11'
  },
  thumbnail: {
    thTitleTheme: 'title-brand-7',
    thSmall: 'font-normal text-small ml-1',
    thSubtitleTheme: 'title-sans-12'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.jsx

var CardHeading_jsx = react_default.a.createElement;




var CardHeading_CardHeading = function CardHeading(_ref) {
  var className = _ref.className,
      color = _ref.color,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 2 : _ref$hLevel,
      iconName = _ref.iconName,
      link = _ref.link,
      small = _ref.small,
      subtitle = _ref.subtitle,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;

  if (!title) {
    return null;
  }

  var _cardHeadingThemes$th = cardHeadingThemes[theme],
      thSmall = _cardHeadingThemes$th.thSmall,
      thSubtitleTheme = _cardHeadingThemes$th.thSubtitleTheme,
      thTitleTheme = _cardHeadingThemes$th.thTitleTheme; // eslint-disable-next-line clubmed/no-fake-component

  var withLink = function withLink(node) {
    return (link === null || link === void 0 ? void 0 : link.url) ? CardHeading_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return withLink(CardHeading_jsx("div", {
    className: className
  }, CardHeading_jsx(Title["a" /* Title */], {
    color: color,
    hLevel: hLevel,
    iconName: iconName,
    theme: thTitleTheme
  }, title, !!small && CardHeading_jsx("small", {
    className: thSmall
  }, small)), !!subtitle && CardHeading_jsx(Title["a" /* Title */], {
    hLevel: hLevel < 6 ? hLevel + 1 : 6,
    color: color,
    theme: thSubtitleTheme
  }, subtitle)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.themes.js
var CardHeader_themes_defaultTheme = {
  thIntro: 'mt-5'
};
var cardHeaderThemes = {
  "default": CardHeader_themes_defaultTheme,
  thumbnail: CardHeader_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.jsx

var CardHeader_jsx = react_default.a.createElement;




var CardHeader_CardHeader = function CardHeader(_ref) {
  var color = _ref.color,
      heading = _ref.heading,
      introduction = _ref.introduction,
      link = _ref.link,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var thIntro = cardHeaderThemes[theme].thIntro;
  return CardHeader_jsx("header", null, CardHeader_jsx(CardHeading_CardHeading, Object(esm_extends["a" /* default */])({}, heading, {
    color: color,
    link: link,
    theme: theme
  })), !!introduction && CardHeader_jsx(Text["a" /* Text */], Object(esm_extends["a" /* default */])({
    className: thIntro
  }, introduction)));
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/is-image/index.js
var is_image = __webpack_require__("JFtY");
var is_image_default = /*#__PURE__*/__webpack_require__.n(is_image);

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.utils.js
var Video_utils = __webpack_require__("JhHq");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.themes.js
var themes = {
  "default": {
    thThumbnailButton: 'hover:opacity-75 relative reset-button transition-opacity w-full',
    thThumbnailButtonLabel: 'sr-only',
    thThumbnailIcon: 'absolute bg-overlay-black-60 leading-none m-2 top-0 p-3 right-0 text-white',
    thThumbnailIconSize: '1.5625rem',
    thVideo: 'w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.jsx
var VideoWithFullScreen_jsx = react_default.a.createElement;









function VideoWithFullScreen(props) {
  var buttonLabel = props.buttonLabel,
      className = props.className,
      closeLabel = props.closeLabel,
      ratioKey = props.ratioKey,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      thumbnail = props.thumbnail,
      title = props.title,
      url = props.url;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  if (!Object(Video_utils["b" /* isVideoUrl */])(url)) return null;
  if (!thumbnail) return VideoWithFullScreen_jsx(Video["a" /* Video */], {
    className: className,
    ratioKey: ratioKey,
    url: url
  });
  var _themes$theme = themes[theme],
      thIframe = _themes$theme.thIframe,
      thThumbnailButton = _themes$theme.thThumbnailButton,
      thThumbnailIcon = _themes$theme.thThumbnailIcon,
      thThumbnailIconSize = _themes$theme.thThumbnailIconSize,
      thThumbnailButtonLabel = _themes$theme.thThumbnailButtonLabel,
      thVideo = _themes$theme.thVideo;
  return VideoWithFullScreen_jsx(react["Fragment"], null, VideoWithFullScreen_jsx("button", {
    className: classnames_default()(className, thThumbnailButton),
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    },
    type: "button"
  }, VideoWithFullScreen_jsx("span", {
    classnames: thThumbnailButtonLabel
  }, buttonLabel), VideoWithFullScreen_jsx(Image["a" /* default */], {
    forceImage: true,
    imageUrl: thumbnail,
    ratioKey: ratioKey
  }), VideoWithFullScreen_jsx("div", {
    className: thThumbnailIcon
  }, VideoWithFullScreen_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].VIDEOS,
    width: thThumbnailIconSize
  }))), isExpanded && VideoWithFullScreen_jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: title,
    closeLabel: closeLabel,
    hasCloseButton: true,
    onClose: function onClose() {
      return setExpanded(!isExpanded);
    }
  }, VideoWithFullScreen_jsx(Video["a" /* Video */], {
    className: thVideo,
    iFrameClassName: thIframe,
    ratioKey: ratioKey,
    url: url
  })));
}
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.themes.js

var CardMedia_themes_defaultTheme = {
  thImageRatio: ratios_utils["a" /* default */].M,
  thVideo: 'bg-black'
};
var cardMediaThemes = {
  "default": CardMedia_themes_defaultTheme,
  thumbnail: CardMedia_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.jsx

var CardMedia_jsx = react_default.a.createElement;






var CardMedia_CardMedia = function CardMedia(_ref) {
  var children = _ref.children,
      closeLabel = _ref.closeLabel,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? {} : _ref$media,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _cardMediaThemes$them = cardMediaThemes[theme],
      thVideo = _cardMediaThemes$them.thVideo,
      thImageRatio = _cardMediaThemes$them.thImageRatio; // eslint-disable-next-line clubmed/no-fake-component

  var withLink = function withLink(node) {
    return node && link && link.url ? CardMedia_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return CardMedia_jsx(react["Fragment"], null, is_image_default()(media.url || '') ? withLink(CardMedia_jsx("div", {
    className: "image-responsive-cell overflow-hidden rounded-tiny"
  }, CardMedia_jsx(Image["a" /* default */], {
    altMsg: media.alt,
    imageUrl: media.url,
    ratioKey: media.ratioKey || thImageRatio
  }))) : CardMedia_jsx(VideoWithFullScreen, {
    buttonLabel: media.thumbnailLabel,
    className: thVideo,
    closeLabel: closeLabel,
    thumbnail: media.thumbnail || '',
    title: media.title,
    url: media.url
  }), withLink(children));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_jsx = react_default.a.createElement;


var Card_layouts_Inline1 = function Inline1(header, body, media) {
  return Card_layouts_jsx("div", {
    className: "sm:flex sm:justify-between -mx-px10"
  }, media && Card_layouts_jsx("div", {
    className: "mb-5 sm:mb-0 sm:w-1/2 px-px10"
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: classnames_default()('px-px10', {
      'sm:w-1/2': media
    })
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-5'
  }, body)));
};
var Card_layouts_Inline2 = function Inline2(header, body, media) {
  return Card_layouts_jsx("div", {
    className: "sm:flex sm:flex-row-reverse sm:justify-between -mx-px10"
  }, media && Card_layouts_jsx("div", {
    className: "mb-5 sm:mb-0 sm:w-1/2 px-px10"
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: classnames_default()('px-px10', {
      'sm:w-1/2': media
    })
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-5'
  }, body)));
};
var Card_layouts_Column1 = function Column1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media, header && Card_layouts_jsx("div", {
    className: media && 'mt-5'
  }, header), body && Card_layouts_jsx("div", {
    className: (media || header) && 'mt-5'
  }, body));
};
var Column2 = function Column2(header, body, media) {
  return Card_layouts_jsx("div", {
    className: "border-1 border-gray-light h-full rounded-tiny shadow-diffuse"
  }, media && Card_layouts_jsx("div", {
    className: "-mx-px -mt-px"
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: "p-5"
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-5'
  }, body)));
};
var Card_layouts_Composite1 = function Composite1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media, (header || body) && Card_layouts_jsx("div", {
    className: classnames_default()('sm:flex sm:-mx-px10', {
      'mt-5': media
    })
  }, header && Card_layouts_jsx("div", {
    className: "sm:flex-1 sm:px-px10"
  }, header), body && Card_layouts_jsx("div", {
    className: classnames_default()('sm:flex-1 sm:px-px10', {
      'mt-5': header
    })
  }, body)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.jsx
var Card_jsx = react_default.a.createElement;







var Card_Card = function Card(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      color = _ref.color,
      ctaLabel = _ref.ctaLabel,
      customMedia = _ref.customMedia,
      heading = _ref.heading,
      id = _ref.id,
      introduction = _ref.introduction,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? Card_constants["d" /* INLINE_1 */] : _ref$layout,
      link = _ref.link,
      media = _ref.media,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var hasTitle = Boolean(heading === null || heading === void 0 ? void 0 : heading.title);
  var hasCta = Boolean(ctaLabel);
  var header = !(introduction === null || introduction === void 0 ? void 0 : introduction.text) && !hasTitle ? null : Card_jsx(CardHeader_CardHeader, {
    color: color,
    heading: heading,
    introduction: introduction,
    link: hasCta ? null : link,
    theme: theme
  });
  var body = !(text === null || text === void 0 ? void 0 : text.text) && !hasCta ? null : Card_jsx(CardBody_CardBody, {
    ctaLabel: ctaLabel,
    color: color,
    isTablet: isTablet,
    layout: layout,
    link: link,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    text: text,
    theme: theme
  });
  var picture = !(media === null || media === void 0 ? void 0 : media.url) && !customMedia ? null : Card_jsx(CardMedia_CardMedia, {
    closeLabel: closeLabel,
    link: hasCta || hasTitle ? null : link,
    media: media,
    theme: theme
  }, customMedia);
  return body || header || picture ? Card_jsx("article", {
    className: className,
    id: id
  }, Card_layouts_namespaceObject[layout](header, body, picture)) : null;
};

/***/ }),

/***/ "7CPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toggler; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }


var Toggler = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(Toggler, _Component);

  var _super = _createSuper(Toggler);

  function Toggler() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, Toggler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "state", {
      isActive: _this.props.isActive || false
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "toggle", function () {
      var onToggle = _this.props.onToggle;

      _this.setState(function (prevState) {
        return {
          isActive: !prevState.isActive
        };
      }, function () {
        if (onToggle) {
          onToggle(_this.state.isActive);
        }
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(Toggler, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isActive = this.props.isActive;

      if (isActive !== prevProps.isActive) {
        this.setState({
          isActive: isActive
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var isActive = this.state.isActive;
      return children(this.toggle, isActive);
    }
  }]);

  return Toggler;
}(react__WEBPACK_IMPORTED_MODULE_7__["Component"]);

/***/ }),

/***/ "7jdC":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("3QVS");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "8Jk/":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("ojcf"),
    keysIn = __webpack_require__("FQR9");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ "8PLQ":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Abreve\":\"Ă\",\"abreve\":\"ă\",\"ac\":\"∾\",\"acd\":\"∿\",\"acE\":\"∾̳\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"Acy\":\"А\",\"acy\":\"а\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"af\":\"⁡\",\"Afr\":\"𝔄\",\"afr\":\"𝔞\",\"Agrave\":\"À\",\"agrave\":\"à\",\"alefsym\":\"ℵ\",\"aleph\":\"ℵ\",\"Alpha\":\"Α\",\"alpha\":\"α\",\"Amacr\":\"Ā\",\"amacr\":\"ā\",\"amalg\":\"⨿\",\"amp\":\"&\",\"AMP\":\"&\",\"andand\":\"⩕\",\"And\":\"⩓\",\"and\":\"∧\",\"andd\":\"⩜\",\"andslope\":\"⩘\",\"andv\":\"⩚\",\"ang\":\"∠\",\"ange\":\"⦤\",\"angle\":\"∠\",\"angmsdaa\":\"⦨\",\"angmsdab\":\"⦩\",\"angmsdac\":\"⦪\",\"angmsdad\":\"⦫\",\"angmsdae\":\"⦬\",\"angmsdaf\":\"⦭\",\"angmsdag\":\"⦮\",\"angmsdah\":\"⦯\",\"angmsd\":\"∡\",\"angrt\":\"∟\",\"angrtvb\":\"⊾\",\"angrtvbd\":\"⦝\",\"angsph\":\"∢\",\"angst\":\"Å\",\"angzarr\":\"⍼\",\"Aogon\":\"Ą\",\"aogon\":\"ą\",\"Aopf\":\"𝔸\",\"aopf\":\"𝕒\",\"apacir\":\"⩯\",\"ap\":\"≈\",\"apE\":\"⩰\",\"ape\":\"≊\",\"apid\":\"≋\",\"apos\":\"'\",\"ApplyFunction\":\"⁡\",\"approx\":\"≈\",\"approxeq\":\"≊\",\"Aring\":\"Å\",\"aring\":\"å\",\"Ascr\":\"𝒜\",\"ascr\":\"𝒶\",\"Assign\":\"≔\",\"ast\":\"*\",\"asymp\":\"≈\",\"asympeq\":\"≍\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"awconint\":\"∳\",\"awint\":\"⨑\",\"backcong\":\"≌\",\"backepsilon\":\"϶\",\"backprime\":\"‵\",\"backsim\":\"∽\",\"backsimeq\":\"⋍\",\"Backslash\":\"∖\",\"Barv\":\"⫧\",\"barvee\":\"⊽\",\"barwed\":\"⌅\",\"Barwed\":\"⌆\",\"barwedge\":\"⌅\",\"bbrk\":\"⎵\",\"bbrktbrk\":\"⎶\",\"bcong\":\"≌\",\"Bcy\":\"Б\",\"bcy\":\"б\",\"bdquo\":\"„\",\"becaus\":\"∵\",\"because\":\"∵\",\"Because\":\"∵\",\"bemptyv\":\"⦰\",\"bepsi\":\"϶\",\"bernou\":\"ℬ\",\"Bernoullis\":\"ℬ\",\"Beta\":\"Β\",\"beta\":\"β\",\"beth\":\"ℶ\",\"between\":\"≬\",\"Bfr\":\"𝔅\",\"bfr\":\"𝔟\",\"bigcap\":\"⋂\",\"bigcirc\":\"◯\",\"bigcup\":\"⋃\",\"bigodot\":\"⨀\",\"bigoplus\":\"⨁\",\"bigotimes\":\"⨂\",\"bigsqcup\":\"⨆\",\"bigstar\":\"★\",\"bigtriangledown\":\"▽\",\"bigtriangleup\":\"△\",\"biguplus\":\"⨄\",\"bigvee\":\"⋁\",\"bigwedge\":\"⋀\",\"bkarow\":\"⤍\",\"blacklozenge\":\"⧫\",\"blacksquare\":\"▪\",\"blacktriangle\":\"▴\",\"blacktriangledown\":\"▾\",\"blacktriangleleft\":\"◂\",\"blacktriangleright\":\"▸\",\"blank\":\"␣\",\"blk12\":\"▒\",\"blk14\":\"░\",\"blk34\":\"▓\",\"block\":\"█\",\"bne\":\"=⃥\",\"bnequiv\":\"≡⃥\",\"bNot\":\"⫭\",\"bnot\":\"⌐\",\"Bopf\":\"𝔹\",\"bopf\":\"𝕓\",\"bot\":\"⊥\",\"bottom\":\"⊥\",\"bowtie\":\"⋈\",\"boxbox\":\"⧉\",\"boxdl\":\"┐\",\"boxdL\":\"╕\",\"boxDl\":\"╖\",\"boxDL\":\"╗\",\"boxdr\":\"┌\",\"boxdR\":\"╒\",\"boxDr\":\"╓\",\"boxDR\":\"╔\",\"boxh\":\"─\",\"boxH\":\"═\",\"boxhd\":\"┬\",\"boxHd\":\"╤\",\"boxhD\":\"╥\",\"boxHD\":\"╦\",\"boxhu\":\"┴\",\"boxHu\":\"╧\",\"boxhU\":\"╨\",\"boxHU\":\"╩\",\"boxminus\":\"⊟\",\"boxplus\":\"⊞\",\"boxtimes\":\"⊠\",\"boxul\":\"┘\",\"boxuL\":\"╛\",\"boxUl\":\"╜\",\"boxUL\":\"╝\",\"boxur\":\"└\",\"boxuR\":\"╘\",\"boxUr\":\"╙\",\"boxUR\":\"╚\",\"boxv\":\"│\",\"boxV\":\"║\",\"boxvh\":\"┼\",\"boxvH\":\"╪\",\"boxVh\":\"╫\",\"boxVH\":\"╬\",\"boxvl\":\"┤\",\"boxvL\":\"╡\",\"boxVl\":\"╢\",\"boxVL\":\"╣\",\"boxvr\":\"├\",\"boxvR\":\"╞\",\"boxVr\":\"╟\",\"boxVR\":\"╠\",\"bprime\":\"‵\",\"breve\":\"˘\",\"Breve\":\"˘\",\"brvbar\":\"¦\",\"bscr\":\"𝒷\",\"Bscr\":\"ℬ\",\"bsemi\":\"⁏\",\"bsim\":\"∽\",\"bsime\":\"⋍\",\"bsolb\":\"⧅\",\"bsol\":\"\\\\\",\"bsolhsub\":\"⟈\",\"bull\":\"•\",\"bullet\":\"•\",\"bump\":\"≎\",\"bumpE\":\"⪮\",\"bumpe\":\"≏\",\"Bumpeq\":\"≎\",\"bumpeq\":\"≏\",\"Cacute\":\"Ć\",\"cacute\":\"ć\",\"capand\":\"⩄\",\"capbrcup\":\"⩉\",\"capcap\":\"⩋\",\"cap\":\"∩\",\"Cap\":\"⋒\",\"capcup\":\"⩇\",\"capdot\":\"⩀\",\"CapitalDifferentialD\":\"ⅅ\",\"caps\":\"∩︀\",\"caret\":\"⁁\",\"caron\":\"ˇ\",\"Cayleys\":\"ℭ\",\"ccaps\":\"⩍\",\"Ccaron\":\"Č\",\"ccaron\":\"č\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"Ccirc\":\"Ĉ\",\"ccirc\":\"ĉ\",\"Cconint\":\"∰\",\"ccups\":\"⩌\",\"ccupssm\":\"⩐\",\"Cdot\":\"Ċ\",\"cdot\":\"ċ\",\"cedil\":\"¸\",\"Cedilla\":\"¸\",\"cemptyv\":\"⦲\",\"cent\":\"¢\",\"centerdot\":\"·\",\"CenterDot\":\"·\",\"cfr\":\"𝔠\",\"Cfr\":\"ℭ\",\"CHcy\":\"Ч\",\"chcy\":\"ч\",\"check\":\"✓\",\"checkmark\":\"✓\",\"Chi\":\"Χ\",\"chi\":\"χ\",\"circ\":\"ˆ\",\"circeq\":\"≗\",\"circlearrowleft\":\"↺\",\"circlearrowright\":\"↻\",\"circledast\":\"⊛\",\"circledcirc\":\"⊚\",\"circleddash\":\"⊝\",\"CircleDot\":\"⊙\",\"circledR\":\"®\",\"circledS\":\"Ⓢ\",\"CircleMinus\":\"⊖\",\"CirclePlus\":\"⊕\",\"CircleTimes\":\"⊗\",\"cir\":\"○\",\"cirE\":\"⧃\",\"cire\":\"≗\",\"cirfnint\":\"⨐\",\"cirmid\":\"⫯\",\"cirscir\":\"⧂\",\"ClockwiseContourIntegral\":\"∲\",\"CloseCurlyDoubleQuote\":\"”\",\"CloseCurlyQuote\":\"’\",\"clubs\":\"♣\",\"clubsuit\":\"♣\",\"colon\":\":\",\"Colon\":\"∷\",\"Colone\":\"⩴\",\"colone\":\"≔\",\"coloneq\":\"≔\",\"comma\":\",\",\"commat\":\"@\",\"comp\":\"∁\",\"compfn\":\"∘\",\"complement\":\"∁\",\"complexes\":\"ℂ\",\"cong\":\"≅\",\"congdot\":\"⩭\",\"Congruent\":\"≡\",\"conint\":\"∮\",\"Conint\":\"∯\",\"ContourIntegral\":\"∮\",\"copf\":\"𝕔\",\"Copf\":\"ℂ\",\"coprod\":\"∐\",\"Coproduct\":\"∐\",\"copy\":\"©\",\"COPY\":\"©\",\"copysr\":\"℗\",\"CounterClockwiseContourIntegral\":\"∳\",\"crarr\":\"↵\",\"cross\":\"✗\",\"Cross\":\"⨯\",\"Cscr\":\"𝒞\",\"cscr\":\"𝒸\",\"csub\":\"⫏\",\"csube\":\"⫑\",\"csup\":\"⫐\",\"csupe\":\"⫒\",\"ctdot\":\"⋯\",\"cudarrl\":\"⤸\",\"cudarrr\":\"⤵\",\"cuepr\":\"⋞\",\"cuesc\":\"⋟\",\"cularr\":\"↶\",\"cularrp\":\"⤽\",\"cupbrcap\":\"⩈\",\"cupcap\":\"⩆\",\"CupCap\":\"≍\",\"cup\":\"∪\",\"Cup\":\"⋓\",\"cupcup\":\"⩊\",\"cupdot\":\"⊍\",\"cupor\":\"⩅\",\"cups\":\"∪︀\",\"curarr\":\"↷\",\"curarrm\":\"⤼\",\"curlyeqprec\":\"⋞\",\"curlyeqsucc\":\"⋟\",\"curlyvee\":\"⋎\",\"curlywedge\":\"⋏\",\"curren\":\"¤\",\"curvearrowleft\":\"↶\",\"curvearrowright\":\"↷\",\"cuvee\":\"⋎\",\"cuwed\":\"⋏\",\"cwconint\":\"∲\",\"cwint\":\"∱\",\"cylcty\":\"⌭\",\"dagger\":\"†\",\"Dagger\":\"‡\",\"daleth\":\"ℸ\",\"darr\":\"↓\",\"Darr\":\"↡\",\"dArr\":\"⇓\",\"dash\":\"‐\",\"Dashv\":\"⫤\",\"dashv\":\"⊣\",\"dbkarow\":\"⤏\",\"dblac\":\"˝\",\"Dcaron\":\"Ď\",\"dcaron\":\"ď\",\"Dcy\":\"Д\",\"dcy\":\"д\",\"ddagger\":\"‡\",\"ddarr\":\"⇊\",\"DD\":\"ⅅ\",\"dd\":\"ⅆ\",\"DDotrahd\":\"⤑\",\"ddotseq\":\"⩷\",\"deg\":\"°\",\"Del\":\"∇\",\"Delta\":\"Δ\",\"delta\":\"δ\",\"demptyv\":\"⦱\",\"dfisht\":\"⥿\",\"Dfr\":\"𝔇\",\"dfr\":\"𝔡\",\"dHar\":\"⥥\",\"dharl\":\"⇃\",\"dharr\":\"⇂\",\"DiacriticalAcute\":\"´\",\"DiacriticalDot\":\"˙\",\"DiacriticalDoubleAcute\":\"˝\",\"DiacriticalGrave\":\"`\",\"DiacriticalTilde\":\"˜\",\"diam\":\"⋄\",\"diamond\":\"⋄\",\"Diamond\":\"⋄\",\"diamondsuit\":\"♦\",\"diams\":\"♦\",\"die\":\"¨\",\"DifferentialD\":\"ⅆ\",\"digamma\":\"ϝ\",\"disin\":\"⋲\",\"div\":\"÷\",\"divide\":\"÷\",\"divideontimes\":\"⋇\",\"divonx\":\"⋇\",\"DJcy\":\"Ђ\",\"djcy\":\"ђ\",\"dlcorn\":\"⌞\",\"dlcrop\":\"⌍\",\"dollar\":\"$\",\"Dopf\":\"𝔻\",\"dopf\":\"𝕕\",\"Dot\":\"¨\",\"dot\":\"˙\",\"DotDot\":\"⃜\",\"doteq\":\"≐\",\"doteqdot\":\"≑\",\"DotEqual\":\"≐\",\"dotminus\":\"∸\",\"dotplus\":\"∔\",\"dotsquare\":\"⊡\",\"doublebarwedge\":\"⌆\",\"DoubleContourIntegral\":\"∯\",\"DoubleDot\":\"¨\",\"DoubleDownArrow\":\"⇓\",\"DoubleLeftArrow\":\"⇐\",\"DoubleLeftRightArrow\":\"⇔\",\"DoubleLeftTee\":\"⫤\",\"DoubleLongLeftArrow\":\"⟸\",\"DoubleLongLeftRightArrow\":\"⟺\",\"DoubleLongRightArrow\":\"⟹\",\"DoubleRightArrow\":\"⇒\",\"DoubleRightTee\":\"⊨\",\"DoubleUpArrow\":\"⇑\",\"DoubleUpDownArrow\":\"⇕\",\"DoubleVerticalBar\":\"∥\",\"DownArrowBar\":\"⤓\",\"downarrow\":\"↓\",\"DownArrow\":\"↓\",\"Downarrow\":\"⇓\",\"DownArrowUpArrow\":\"⇵\",\"DownBreve\":\"̑\",\"downdownarrows\":\"⇊\",\"downharpoonleft\":\"⇃\",\"downharpoonright\":\"⇂\",\"DownLeftRightVector\":\"⥐\",\"DownLeftTeeVector\":\"⥞\",\"DownLeftVectorBar\":\"⥖\",\"DownLeftVector\":\"↽\",\"DownRightTeeVector\":\"⥟\",\"DownRightVectorBar\":\"⥗\",\"DownRightVector\":\"⇁\",\"DownTeeArrow\":\"↧\",\"DownTee\":\"⊤\",\"drbkarow\":\"⤐\",\"drcorn\":\"⌟\",\"drcrop\":\"⌌\",\"Dscr\":\"𝒟\",\"dscr\":\"𝒹\",\"DScy\":\"Ѕ\",\"dscy\":\"ѕ\",\"dsol\":\"⧶\",\"Dstrok\":\"Đ\",\"dstrok\":\"đ\",\"dtdot\":\"⋱\",\"dtri\":\"▿\",\"dtrif\":\"▾\",\"duarr\":\"⇵\",\"duhar\":\"⥯\",\"dwangle\":\"⦦\",\"DZcy\":\"Џ\",\"dzcy\":\"џ\",\"dzigrarr\":\"⟿\",\"Eacute\":\"É\",\"eacute\":\"é\",\"easter\":\"⩮\",\"Ecaron\":\"Ě\",\"ecaron\":\"ě\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"ecir\":\"≖\",\"ecolon\":\"≕\",\"Ecy\":\"Э\",\"ecy\":\"э\",\"eDDot\":\"⩷\",\"Edot\":\"Ė\",\"edot\":\"ė\",\"eDot\":\"≑\",\"ee\":\"ⅇ\",\"efDot\":\"≒\",\"Efr\":\"𝔈\",\"efr\":\"𝔢\",\"eg\":\"⪚\",\"Egrave\":\"È\",\"egrave\":\"è\",\"egs\":\"⪖\",\"egsdot\":\"⪘\",\"el\":\"⪙\",\"Element\":\"∈\",\"elinters\":\"⏧\",\"ell\":\"ℓ\",\"els\":\"⪕\",\"elsdot\":\"⪗\",\"Emacr\":\"Ē\",\"emacr\":\"ē\",\"empty\":\"∅\",\"emptyset\":\"∅\",\"EmptySmallSquare\":\"◻\",\"emptyv\":\"∅\",\"EmptyVerySmallSquare\":\"▫\",\"emsp13\":\" \",\"emsp14\":\" \",\"emsp\":\" \",\"ENG\":\"Ŋ\",\"eng\":\"ŋ\",\"ensp\":\" \",\"Eogon\":\"Ę\",\"eogon\":\"ę\",\"Eopf\":\"𝔼\",\"eopf\":\"𝕖\",\"epar\":\"⋕\",\"eparsl\":\"⧣\",\"eplus\":\"⩱\",\"epsi\":\"ε\",\"Epsilon\":\"Ε\",\"epsilon\":\"ε\",\"epsiv\":\"ϵ\",\"eqcirc\":\"≖\",\"eqcolon\":\"≕\",\"eqsim\":\"≂\",\"eqslantgtr\":\"⪖\",\"eqslantless\":\"⪕\",\"Equal\":\"⩵\",\"equals\":\"=\",\"EqualTilde\":\"≂\",\"equest\":\"≟\",\"Equilibrium\":\"⇌\",\"equiv\":\"≡\",\"equivDD\":\"⩸\",\"eqvparsl\":\"⧥\",\"erarr\":\"⥱\",\"erDot\":\"≓\",\"escr\":\"ℯ\",\"Escr\":\"ℰ\",\"esdot\":\"≐\",\"Esim\":\"⩳\",\"esim\":\"≂\",\"Eta\":\"Η\",\"eta\":\"η\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"euro\":\"€\",\"excl\":\"!\",\"exist\":\"∃\",\"Exists\":\"∃\",\"expectation\":\"ℰ\",\"exponentiale\":\"ⅇ\",\"ExponentialE\":\"ⅇ\",\"fallingdotseq\":\"≒\",\"Fcy\":\"Ф\",\"fcy\":\"ф\",\"female\":\"♀\",\"ffilig\":\"ﬃ\",\"fflig\":\"ﬀ\",\"ffllig\":\"ﬄ\",\"Ffr\":\"𝔉\",\"ffr\":\"𝔣\",\"filig\":\"ﬁ\",\"FilledSmallSquare\":\"◼\",\"FilledVerySmallSquare\":\"▪\",\"fjlig\":\"fj\",\"flat\":\"♭\",\"fllig\":\"ﬂ\",\"fltns\":\"▱\",\"fnof\":\"ƒ\",\"Fopf\":\"𝔽\",\"fopf\":\"𝕗\",\"forall\":\"∀\",\"ForAll\":\"∀\",\"fork\":\"⋔\",\"forkv\":\"⫙\",\"Fouriertrf\":\"ℱ\",\"fpartint\":\"⨍\",\"frac12\":\"½\",\"frac13\":\"⅓\",\"frac14\":\"¼\",\"frac15\":\"⅕\",\"frac16\":\"⅙\",\"frac18\":\"⅛\",\"frac23\":\"⅔\",\"frac25\":\"⅖\",\"frac34\":\"¾\",\"frac35\":\"⅗\",\"frac38\":\"⅜\",\"frac45\":\"⅘\",\"frac56\":\"⅚\",\"frac58\":\"⅝\",\"frac78\":\"⅞\",\"frasl\":\"⁄\",\"frown\":\"⌢\",\"fscr\":\"𝒻\",\"Fscr\":\"ℱ\",\"gacute\":\"ǵ\",\"Gamma\":\"Γ\",\"gamma\":\"γ\",\"Gammad\":\"Ϝ\",\"gammad\":\"ϝ\",\"gap\":\"⪆\",\"Gbreve\":\"Ğ\",\"gbreve\":\"ğ\",\"Gcedil\":\"Ģ\",\"Gcirc\":\"Ĝ\",\"gcirc\":\"ĝ\",\"Gcy\":\"Г\",\"gcy\":\"г\",\"Gdot\":\"Ġ\",\"gdot\":\"ġ\",\"ge\":\"≥\",\"gE\":\"≧\",\"gEl\":\"⪌\",\"gel\":\"⋛\",\"geq\":\"≥\",\"geqq\":\"≧\",\"geqslant\":\"⩾\",\"gescc\":\"⪩\",\"ges\":\"⩾\",\"gesdot\":\"⪀\",\"gesdoto\":\"⪂\",\"gesdotol\":\"⪄\",\"gesl\":\"⋛︀\",\"gesles\":\"⪔\",\"Gfr\":\"𝔊\",\"gfr\":\"𝔤\",\"gg\":\"≫\",\"Gg\":\"⋙\",\"ggg\":\"⋙\",\"gimel\":\"ℷ\",\"GJcy\":\"Ѓ\",\"gjcy\":\"ѓ\",\"gla\":\"⪥\",\"gl\":\"≷\",\"glE\":\"⪒\",\"glj\":\"⪤\",\"gnap\":\"⪊\",\"gnapprox\":\"⪊\",\"gne\":\"⪈\",\"gnE\":\"≩\",\"gneq\":\"⪈\",\"gneqq\":\"≩\",\"gnsim\":\"⋧\",\"Gopf\":\"𝔾\",\"gopf\":\"𝕘\",\"grave\":\"`\",\"GreaterEqual\":\"≥\",\"GreaterEqualLess\":\"⋛\",\"GreaterFullEqual\":\"≧\",\"GreaterGreater\":\"⪢\",\"GreaterLess\":\"≷\",\"GreaterSlantEqual\":\"⩾\",\"GreaterTilde\":\"≳\",\"Gscr\":\"𝒢\",\"gscr\":\"ℊ\",\"gsim\":\"≳\",\"gsime\":\"⪎\",\"gsiml\":\"⪐\",\"gtcc\":\"⪧\",\"gtcir\":\"⩺\",\"gt\":\">\",\"GT\":\">\",\"Gt\":\"≫\",\"gtdot\":\"⋗\",\"gtlPar\":\"⦕\",\"gtquest\":\"⩼\",\"gtrapprox\":\"⪆\",\"gtrarr\":\"⥸\",\"gtrdot\":\"⋗\",\"gtreqless\":\"⋛\",\"gtreqqless\":\"⪌\",\"gtrless\":\"≷\",\"gtrsim\":\"≳\",\"gvertneqq\":\"≩︀\",\"gvnE\":\"≩︀\",\"Hacek\":\"ˇ\",\"hairsp\":\" \",\"half\":\"½\",\"hamilt\":\"ℋ\",\"HARDcy\":\"Ъ\",\"hardcy\":\"ъ\",\"harrcir\":\"⥈\",\"harr\":\"↔\",\"hArr\":\"⇔\",\"harrw\":\"↭\",\"Hat\":\"^\",\"hbar\":\"ℏ\",\"Hcirc\":\"Ĥ\",\"hcirc\":\"ĥ\",\"hearts\":\"♥\",\"heartsuit\":\"♥\",\"hellip\":\"…\",\"hercon\":\"⊹\",\"hfr\":\"𝔥\",\"Hfr\":\"ℌ\",\"HilbertSpace\":\"ℋ\",\"hksearow\":\"⤥\",\"hkswarow\":\"⤦\",\"hoarr\":\"⇿\",\"homtht\":\"∻\",\"hookleftarrow\":\"↩\",\"hookrightarrow\":\"↪\",\"hopf\":\"𝕙\",\"Hopf\":\"ℍ\",\"horbar\":\"―\",\"HorizontalLine\":\"─\",\"hscr\":\"𝒽\",\"Hscr\":\"ℋ\",\"hslash\":\"ℏ\",\"Hstrok\":\"Ħ\",\"hstrok\":\"ħ\",\"HumpDownHump\":\"≎\",\"HumpEqual\":\"≏\",\"hybull\":\"⁃\",\"hyphen\":\"‐\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"ic\":\"⁣\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"Icy\":\"И\",\"icy\":\"и\",\"Idot\":\"İ\",\"IEcy\":\"Е\",\"iecy\":\"е\",\"iexcl\":\"¡\",\"iff\":\"⇔\",\"ifr\":\"𝔦\",\"Ifr\":\"ℑ\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"ii\":\"ⅈ\",\"iiiint\":\"⨌\",\"iiint\":\"∭\",\"iinfin\":\"⧜\",\"iiota\":\"℩\",\"IJlig\":\"Ĳ\",\"ijlig\":\"ĳ\",\"Imacr\":\"Ī\",\"imacr\":\"ī\",\"image\":\"ℑ\",\"ImaginaryI\":\"ⅈ\",\"imagline\":\"ℐ\",\"imagpart\":\"ℑ\",\"imath\":\"ı\",\"Im\":\"ℑ\",\"imof\":\"⊷\",\"imped\":\"Ƶ\",\"Implies\":\"⇒\",\"incare\":\"℅\",\"in\":\"∈\",\"infin\":\"∞\",\"infintie\":\"⧝\",\"inodot\":\"ı\",\"intcal\":\"⊺\",\"int\":\"∫\",\"Int\":\"∬\",\"integers\":\"ℤ\",\"Integral\":\"∫\",\"intercal\":\"⊺\",\"Intersection\":\"⋂\",\"intlarhk\":\"⨗\",\"intprod\":\"⨼\",\"InvisibleComma\":\"⁣\",\"InvisibleTimes\":\"⁢\",\"IOcy\":\"Ё\",\"iocy\":\"ё\",\"Iogon\":\"Į\",\"iogon\":\"į\",\"Iopf\":\"𝕀\",\"iopf\":\"𝕚\",\"Iota\":\"Ι\",\"iota\":\"ι\",\"iprod\":\"⨼\",\"iquest\":\"¿\",\"iscr\":\"𝒾\",\"Iscr\":\"ℐ\",\"isin\":\"∈\",\"isindot\":\"⋵\",\"isinE\":\"⋹\",\"isins\":\"⋴\",\"isinsv\":\"⋳\",\"isinv\":\"∈\",\"it\":\"⁢\",\"Itilde\":\"Ĩ\",\"itilde\":\"ĩ\",\"Iukcy\":\"І\",\"iukcy\":\"і\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"Jcirc\":\"Ĵ\",\"jcirc\":\"ĵ\",\"Jcy\":\"Й\",\"jcy\":\"й\",\"Jfr\":\"𝔍\",\"jfr\":\"𝔧\",\"jmath\":\"ȷ\",\"Jopf\":\"𝕁\",\"jopf\":\"𝕛\",\"Jscr\":\"𝒥\",\"jscr\":\"𝒿\",\"Jsercy\":\"Ј\",\"jsercy\":\"ј\",\"Jukcy\":\"Є\",\"jukcy\":\"є\",\"Kappa\":\"Κ\",\"kappa\":\"κ\",\"kappav\":\"ϰ\",\"Kcedil\":\"Ķ\",\"kcedil\":\"ķ\",\"Kcy\":\"К\",\"kcy\":\"к\",\"Kfr\":\"𝔎\",\"kfr\":\"𝔨\",\"kgreen\":\"ĸ\",\"KHcy\":\"Х\",\"khcy\":\"х\",\"KJcy\":\"Ќ\",\"kjcy\":\"ќ\",\"Kopf\":\"𝕂\",\"kopf\":\"𝕜\",\"Kscr\":\"𝒦\",\"kscr\":\"𝓀\",\"lAarr\":\"⇚\",\"Lacute\":\"Ĺ\",\"lacute\":\"ĺ\",\"laemptyv\":\"⦴\",\"lagran\":\"ℒ\",\"Lambda\":\"Λ\",\"lambda\":\"λ\",\"lang\":\"⟨\",\"Lang\":\"⟪\",\"langd\":\"⦑\",\"langle\":\"⟨\",\"lap\":\"⪅\",\"Laplacetrf\":\"ℒ\",\"laquo\":\"«\",\"larrb\":\"⇤\",\"larrbfs\":\"⤟\",\"larr\":\"←\",\"Larr\":\"↞\",\"lArr\":\"⇐\",\"larrfs\":\"⤝\",\"larrhk\":\"↩\",\"larrlp\":\"↫\",\"larrpl\":\"⤹\",\"larrsim\":\"⥳\",\"larrtl\":\"↢\",\"latail\":\"⤙\",\"lAtail\":\"⤛\",\"lat\":\"⪫\",\"late\":\"⪭\",\"lates\":\"⪭︀\",\"lbarr\":\"⤌\",\"lBarr\":\"⤎\",\"lbbrk\":\"❲\",\"lbrace\":\"{\",\"lbrack\":\"[\",\"lbrke\":\"⦋\",\"lbrksld\":\"⦏\",\"lbrkslu\":\"⦍\",\"Lcaron\":\"Ľ\",\"lcaron\":\"ľ\",\"Lcedil\":\"Ļ\",\"lcedil\":\"ļ\",\"lceil\":\"⌈\",\"lcub\":\"{\",\"Lcy\":\"Л\",\"lcy\":\"л\",\"ldca\":\"⤶\",\"ldquo\":\"“\",\"ldquor\":\"„\",\"ldrdhar\":\"⥧\",\"ldrushar\":\"⥋\",\"ldsh\":\"↲\",\"le\":\"≤\",\"lE\":\"≦\",\"LeftAngleBracket\":\"⟨\",\"LeftArrowBar\":\"⇤\",\"leftarrow\":\"←\",\"LeftArrow\":\"←\",\"Leftarrow\":\"⇐\",\"LeftArrowRightArrow\":\"⇆\",\"leftarrowtail\":\"↢\",\"LeftCeiling\":\"⌈\",\"LeftDoubleBracket\":\"⟦\",\"LeftDownTeeVector\":\"⥡\",\"LeftDownVectorBar\":\"⥙\",\"LeftDownVector\":\"⇃\",\"LeftFloor\":\"⌊\",\"leftharpoondown\":\"↽\",\"leftharpoonup\":\"↼\",\"leftleftarrows\":\"⇇\",\"leftrightarrow\":\"↔\",\"LeftRightArrow\":\"↔\",\"Leftrightarrow\":\"⇔\",\"leftrightarrows\":\"⇆\",\"leftrightharpoons\":\"⇋\",\"leftrightsquigarrow\":\"↭\",\"LeftRightVector\":\"⥎\",\"LeftTeeArrow\":\"↤\",\"LeftTee\":\"⊣\",\"LeftTeeVector\":\"⥚\",\"leftthreetimes\":\"⋋\",\"LeftTriangleBar\":\"⧏\",\"LeftTriangle\":\"⊲\",\"LeftTriangleEqual\":\"⊴\",\"LeftUpDownVector\":\"⥑\",\"LeftUpTeeVector\":\"⥠\",\"LeftUpVectorBar\":\"⥘\",\"LeftUpVector\":\"↿\",\"LeftVectorBar\":\"⥒\",\"LeftVector\":\"↼\",\"lEg\":\"⪋\",\"leg\":\"⋚\",\"leq\":\"≤\",\"leqq\":\"≦\",\"leqslant\":\"⩽\",\"lescc\":\"⪨\",\"les\":\"⩽\",\"lesdot\":\"⩿\",\"lesdoto\":\"⪁\",\"lesdotor\":\"⪃\",\"lesg\":\"⋚︀\",\"lesges\":\"⪓\",\"lessapprox\":\"⪅\",\"lessdot\":\"⋖\",\"lesseqgtr\":\"⋚\",\"lesseqqgtr\":\"⪋\",\"LessEqualGreater\":\"⋚\",\"LessFullEqual\":\"≦\",\"LessGreater\":\"≶\",\"lessgtr\":\"≶\",\"LessLess\":\"⪡\",\"lesssim\":\"≲\",\"LessSlantEqual\":\"⩽\",\"LessTilde\":\"≲\",\"lfisht\":\"⥼\",\"lfloor\":\"⌊\",\"Lfr\":\"𝔏\",\"lfr\":\"𝔩\",\"lg\":\"≶\",\"lgE\":\"⪑\",\"lHar\":\"⥢\",\"lhard\":\"↽\",\"lharu\":\"↼\",\"lharul\":\"⥪\",\"lhblk\":\"▄\",\"LJcy\":\"Љ\",\"ljcy\":\"љ\",\"llarr\":\"⇇\",\"ll\":\"≪\",\"Ll\":\"⋘\",\"llcorner\":\"⌞\",\"Lleftarrow\":\"⇚\",\"llhard\":\"⥫\",\"lltri\":\"◺\",\"Lmidot\":\"Ŀ\",\"lmidot\":\"ŀ\",\"lmoustache\":\"⎰\",\"lmoust\":\"⎰\",\"lnap\":\"⪉\",\"lnapprox\":\"⪉\",\"lne\":\"⪇\",\"lnE\":\"≨\",\"lneq\":\"⪇\",\"lneqq\":\"≨\",\"lnsim\":\"⋦\",\"loang\":\"⟬\",\"loarr\":\"⇽\",\"lobrk\":\"⟦\",\"longleftarrow\":\"⟵\",\"LongLeftArrow\":\"⟵\",\"Longleftarrow\":\"⟸\",\"longleftrightarrow\":\"⟷\",\"LongLeftRightArrow\":\"⟷\",\"Longleftrightarrow\":\"⟺\",\"longmapsto\":\"⟼\",\"longrightarrow\":\"⟶\",\"LongRightArrow\":\"⟶\",\"Longrightarrow\":\"⟹\",\"looparrowleft\":\"↫\",\"looparrowright\":\"↬\",\"lopar\":\"⦅\",\"Lopf\":\"𝕃\",\"lopf\":\"𝕝\",\"loplus\":\"⨭\",\"lotimes\":\"⨴\",\"lowast\":\"∗\",\"lowbar\":\"_\",\"LowerLeftArrow\":\"↙\",\"LowerRightArrow\":\"↘\",\"loz\":\"◊\",\"lozenge\":\"◊\",\"lozf\":\"⧫\",\"lpar\":\"(\",\"lparlt\":\"⦓\",\"lrarr\":\"⇆\",\"lrcorner\":\"⌟\",\"lrhar\":\"⇋\",\"lrhard\":\"⥭\",\"lrm\":\"‎\",\"lrtri\":\"⊿\",\"lsaquo\":\"‹\",\"lscr\":\"𝓁\",\"Lscr\":\"ℒ\",\"lsh\":\"↰\",\"Lsh\":\"↰\",\"lsim\":\"≲\",\"lsime\":\"⪍\",\"lsimg\":\"⪏\",\"lsqb\":\"[\",\"lsquo\":\"‘\",\"lsquor\":\"‚\",\"Lstrok\":\"Ł\",\"lstrok\":\"ł\",\"ltcc\":\"⪦\",\"ltcir\":\"⩹\",\"lt\":\"<\",\"LT\":\"<\",\"Lt\":\"≪\",\"ltdot\":\"⋖\",\"lthree\":\"⋋\",\"ltimes\":\"⋉\",\"ltlarr\":\"⥶\",\"ltquest\":\"⩻\",\"ltri\":\"◃\",\"ltrie\":\"⊴\",\"ltrif\":\"◂\",\"ltrPar\":\"⦖\",\"lurdshar\":\"⥊\",\"luruhar\":\"⥦\",\"lvertneqq\":\"≨︀\",\"lvnE\":\"≨︀\",\"macr\":\"¯\",\"male\":\"♂\",\"malt\":\"✠\",\"maltese\":\"✠\",\"Map\":\"⤅\",\"map\":\"↦\",\"mapsto\":\"↦\",\"mapstodown\":\"↧\",\"mapstoleft\":\"↤\",\"mapstoup\":\"↥\",\"marker\":\"▮\",\"mcomma\":\"⨩\",\"Mcy\":\"М\",\"mcy\":\"м\",\"mdash\":\"—\",\"mDDot\":\"∺\",\"measuredangle\":\"∡\",\"MediumSpace\":\" \",\"Mellintrf\":\"ℳ\",\"Mfr\":\"𝔐\",\"mfr\":\"𝔪\",\"mho\":\"℧\",\"micro\":\"µ\",\"midast\":\"*\",\"midcir\":\"⫰\",\"mid\":\"∣\",\"middot\":\"·\",\"minusb\":\"⊟\",\"minus\":\"−\",\"minusd\":\"∸\",\"minusdu\":\"⨪\",\"MinusPlus\":\"∓\",\"mlcp\":\"⫛\",\"mldr\":\"…\",\"mnplus\":\"∓\",\"models\":\"⊧\",\"Mopf\":\"𝕄\",\"mopf\":\"𝕞\",\"mp\":\"∓\",\"mscr\":\"𝓂\",\"Mscr\":\"ℳ\",\"mstpos\":\"∾\",\"Mu\":\"Μ\",\"mu\":\"μ\",\"multimap\":\"⊸\",\"mumap\":\"⊸\",\"nabla\":\"∇\",\"Nacute\":\"Ń\",\"nacute\":\"ń\",\"nang\":\"∠⃒\",\"nap\":\"≉\",\"napE\":\"⩰̸\",\"napid\":\"≋̸\",\"napos\":\"ŉ\",\"napprox\":\"≉\",\"natural\":\"♮\",\"naturals\":\"ℕ\",\"natur\":\"♮\",\"nbsp\":\" \",\"nbump\":\"≎̸\",\"nbumpe\":\"≏̸\",\"ncap\":\"⩃\",\"Ncaron\":\"Ň\",\"ncaron\":\"ň\",\"Ncedil\":\"Ņ\",\"ncedil\":\"ņ\",\"ncong\":\"≇\",\"ncongdot\":\"⩭̸\",\"ncup\":\"⩂\",\"Ncy\":\"Н\",\"ncy\":\"н\",\"ndash\":\"–\",\"nearhk\":\"⤤\",\"nearr\":\"↗\",\"neArr\":\"⇗\",\"nearrow\":\"↗\",\"ne\":\"≠\",\"nedot\":\"≐̸\",\"NegativeMediumSpace\":\"​\",\"NegativeThickSpace\":\"​\",\"NegativeThinSpace\":\"​\",\"NegativeVeryThinSpace\":\"​\",\"nequiv\":\"≢\",\"nesear\":\"⤨\",\"nesim\":\"≂̸\",\"NestedGreaterGreater\":\"≫\",\"NestedLessLess\":\"≪\",\"NewLine\":\"\\n\",\"nexist\":\"∄\",\"nexists\":\"∄\",\"Nfr\":\"𝔑\",\"nfr\":\"𝔫\",\"ngE\":\"≧̸\",\"nge\":\"≱\",\"ngeq\":\"≱\",\"ngeqq\":\"≧̸\",\"ngeqslant\":\"⩾̸\",\"nges\":\"⩾̸\",\"nGg\":\"⋙̸\",\"ngsim\":\"≵\",\"nGt\":\"≫⃒\",\"ngt\":\"≯\",\"ngtr\":\"≯\",\"nGtv\":\"≫̸\",\"nharr\":\"↮\",\"nhArr\":\"⇎\",\"nhpar\":\"⫲\",\"ni\":\"∋\",\"nis\":\"⋼\",\"nisd\":\"⋺\",\"niv\":\"∋\",\"NJcy\":\"Њ\",\"njcy\":\"њ\",\"nlarr\":\"↚\",\"nlArr\":\"⇍\",\"nldr\":\"‥\",\"nlE\":\"≦̸\",\"nle\":\"≰\",\"nleftarrow\":\"↚\",\"nLeftarrow\":\"⇍\",\"nleftrightarrow\":\"↮\",\"nLeftrightarrow\":\"⇎\",\"nleq\":\"≰\",\"nleqq\":\"≦̸\",\"nleqslant\":\"⩽̸\",\"nles\":\"⩽̸\",\"nless\":\"≮\",\"nLl\":\"⋘̸\",\"nlsim\":\"≴\",\"nLt\":\"≪⃒\",\"nlt\":\"≮\",\"nltri\":\"⋪\",\"nltrie\":\"⋬\",\"nLtv\":\"≪̸\",\"nmid\":\"∤\",\"NoBreak\":\"⁠\",\"NonBreakingSpace\":\" \",\"nopf\":\"𝕟\",\"Nopf\":\"ℕ\",\"Not\":\"⫬\",\"not\":\"¬\",\"NotCongruent\":\"≢\",\"NotCupCap\":\"≭\",\"NotDoubleVerticalBar\":\"∦\",\"NotElement\":\"∉\",\"NotEqual\":\"≠\",\"NotEqualTilde\":\"≂̸\",\"NotExists\":\"∄\",\"NotGreater\":\"≯\",\"NotGreaterEqual\":\"≱\",\"NotGreaterFullEqual\":\"≧̸\",\"NotGreaterGreater\":\"≫̸\",\"NotGreaterLess\":\"≹\",\"NotGreaterSlantEqual\":\"⩾̸\",\"NotGreaterTilde\":\"≵\",\"NotHumpDownHump\":\"≎̸\",\"NotHumpEqual\":\"≏̸\",\"notin\":\"∉\",\"notindot\":\"⋵̸\",\"notinE\":\"⋹̸\",\"notinva\":\"∉\",\"notinvb\":\"⋷\",\"notinvc\":\"⋶\",\"NotLeftTriangleBar\":\"⧏̸\",\"NotLeftTriangle\":\"⋪\",\"NotLeftTriangleEqual\":\"⋬\",\"NotLess\":\"≮\",\"NotLessEqual\":\"≰\",\"NotLessGreater\":\"≸\",\"NotLessLess\":\"≪̸\",\"NotLessSlantEqual\":\"⩽̸\",\"NotLessTilde\":\"≴\",\"NotNestedGreaterGreater\":\"⪢̸\",\"NotNestedLessLess\":\"⪡̸\",\"notni\":\"∌\",\"notniva\":\"∌\",\"notnivb\":\"⋾\",\"notnivc\":\"⋽\",\"NotPrecedes\":\"⊀\",\"NotPrecedesEqual\":\"⪯̸\",\"NotPrecedesSlantEqual\":\"⋠\",\"NotReverseElement\":\"∌\",\"NotRightTriangleBar\":\"⧐̸\",\"NotRightTriangle\":\"⋫\",\"NotRightTriangleEqual\":\"⋭\",\"NotSquareSubset\":\"⊏̸\",\"NotSquareSubsetEqual\":\"⋢\",\"NotSquareSuperset\":\"⊐̸\",\"NotSquareSupersetEqual\":\"⋣\",\"NotSubset\":\"⊂⃒\",\"NotSubsetEqual\":\"⊈\",\"NotSucceeds\":\"⊁\",\"NotSucceedsEqual\":\"⪰̸\",\"NotSucceedsSlantEqual\":\"⋡\",\"NotSucceedsTilde\":\"≿̸\",\"NotSuperset\":\"⊃⃒\",\"NotSupersetEqual\":\"⊉\",\"NotTilde\":\"≁\",\"NotTildeEqual\":\"≄\",\"NotTildeFullEqual\":\"≇\",\"NotTildeTilde\":\"≉\",\"NotVerticalBar\":\"∤\",\"nparallel\":\"∦\",\"npar\":\"∦\",\"nparsl\":\"⫽⃥\",\"npart\":\"∂̸\",\"npolint\":\"⨔\",\"npr\":\"⊀\",\"nprcue\":\"⋠\",\"nprec\":\"⊀\",\"npreceq\":\"⪯̸\",\"npre\":\"⪯̸\",\"nrarrc\":\"⤳̸\",\"nrarr\":\"↛\",\"nrArr\":\"⇏\",\"nrarrw\":\"↝̸\",\"nrightarrow\":\"↛\",\"nRightarrow\":\"⇏\",\"nrtri\":\"⋫\",\"nrtrie\":\"⋭\",\"nsc\":\"⊁\",\"nsccue\":\"⋡\",\"nsce\":\"⪰̸\",\"Nscr\":\"𝒩\",\"nscr\":\"𝓃\",\"nshortmid\":\"∤\",\"nshortparallel\":\"∦\",\"nsim\":\"≁\",\"nsime\":\"≄\",\"nsimeq\":\"≄\",\"nsmid\":\"∤\",\"nspar\":\"∦\",\"nsqsube\":\"⋢\",\"nsqsupe\":\"⋣\",\"nsub\":\"⊄\",\"nsubE\":\"⫅̸\",\"nsube\":\"⊈\",\"nsubset\":\"⊂⃒\",\"nsubseteq\":\"⊈\",\"nsubseteqq\":\"⫅̸\",\"nsucc\":\"⊁\",\"nsucceq\":\"⪰̸\",\"nsup\":\"⊅\",\"nsupE\":\"⫆̸\",\"nsupe\":\"⊉\",\"nsupset\":\"⊃⃒\",\"nsupseteq\":\"⊉\",\"nsupseteqq\":\"⫆̸\",\"ntgl\":\"≹\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"ntlg\":\"≸\",\"ntriangleleft\":\"⋪\",\"ntrianglelefteq\":\"⋬\",\"ntriangleright\":\"⋫\",\"ntrianglerighteq\":\"⋭\",\"Nu\":\"Ν\",\"nu\":\"ν\",\"num\":\"#\",\"numero\":\"№\",\"numsp\":\" \",\"nvap\":\"≍⃒\",\"nvdash\":\"⊬\",\"nvDash\":\"⊭\",\"nVdash\":\"⊮\",\"nVDash\":\"⊯\",\"nvge\":\"≥⃒\",\"nvgt\":\">⃒\",\"nvHarr\":\"⤄\",\"nvinfin\":\"⧞\",\"nvlArr\":\"⤂\",\"nvle\":\"≤⃒\",\"nvlt\":\"<⃒\",\"nvltrie\":\"⊴⃒\",\"nvrArr\":\"⤃\",\"nvrtrie\":\"⊵⃒\",\"nvsim\":\"∼⃒\",\"nwarhk\":\"⤣\",\"nwarr\":\"↖\",\"nwArr\":\"⇖\",\"nwarrow\":\"↖\",\"nwnear\":\"⤧\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"oast\":\"⊛\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"ocir\":\"⊚\",\"Ocy\":\"О\",\"ocy\":\"о\",\"odash\":\"⊝\",\"Odblac\":\"Ő\",\"odblac\":\"ő\",\"odiv\":\"⨸\",\"odot\":\"⊙\",\"odsold\":\"⦼\",\"OElig\":\"Œ\",\"oelig\":\"œ\",\"ofcir\":\"⦿\",\"Ofr\":\"𝔒\",\"ofr\":\"𝔬\",\"ogon\":\"˛\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ogt\":\"⧁\",\"ohbar\":\"⦵\",\"ohm\":\"Ω\",\"oint\":\"∮\",\"olarr\":\"↺\",\"olcir\":\"⦾\",\"olcross\":\"⦻\",\"oline\":\"‾\",\"olt\":\"⧀\",\"Omacr\":\"Ō\",\"omacr\":\"ō\",\"Omega\":\"Ω\",\"omega\":\"ω\",\"Omicron\":\"Ο\",\"omicron\":\"ο\",\"omid\":\"⦶\",\"ominus\":\"⊖\",\"Oopf\":\"𝕆\",\"oopf\":\"𝕠\",\"opar\":\"⦷\",\"OpenCurlyDoubleQuote\":\"“\",\"OpenCurlyQuote\":\"‘\",\"operp\":\"⦹\",\"oplus\":\"⊕\",\"orarr\":\"↻\",\"Or\":\"⩔\",\"or\":\"∨\",\"ord\":\"⩝\",\"order\":\"ℴ\",\"orderof\":\"ℴ\",\"ordf\":\"ª\",\"ordm\":\"º\",\"origof\":\"⊶\",\"oror\":\"⩖\",\"orslope\":\"⩗\",\"orv\":\"⩛\",\"oS\":\"Ⓢ\",\"Oscr\":\"𝒪\",\"oscr\":\"ℴ\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"osol\":\"⊘\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"otimesas\":\"⨶\",\"Otimes\":\"⨷\",\"otimes\":\"⊗\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"ovbar\":\"⌽\",\"OverBar\":\"‾\",\"OverBrace\":\"⏞\",\"OverBracket\":\"⎴\",\"OverParenthesis\":\"⏜\",\"para\":\"¶\",\"parallel\":\"∥\",\"par\":\"∥\",\"parsim\":\"⫳\",\"parsl\":\"⫽\",\"part\":\"∂\",\"PartialD\":\"∂\",\"Pcy\":\"П\",\"pcy\":\"п\",\"percnt\":\"%\",\"period\":\".\",\"permil\":\"‰\",\"perp\":\"⊥\",\"pertenk\":\"‱\",\"Pfr\":\"𝔓\",\"pfr\":\"𝔭\",\"Phi\":\"Φ\",\"phi\":\"φ\",\"phiv\":\"ϕ\",\"phmmat\":\"ℳ\",\"phone\":\"☎\",\"Pi\":\"Π\",\"pi\":\"π\",\"pitchfork\":\"⋔\",\"piv\":\"ϖ\",\"planck\":\"ℏ\",\"planckh\":\"ℎ\",\"plankv\":\"ℏ\",\"plusacir\":\"⨣\",\"plusb\":\"⊞\",\"pluscir\":\"⨢\",\"plus\":\"+\",\"plusdo\":\"∔\",\"plusdu\":\"⨥\",\"pluse\":\"⩲\",\"PlusMinus\":\"±\",\"plusmn\":\"±\",\"plussim\":\"⨦\",\"plustwo\":\"⨧\",\"pm\":\"±\",\"Poincareplane\":\"ℌ\",\"pointint\":\"⨕\",\"popf\":\"𝕡\",\"Popf\":\"ℙ\",\"pound\":\"£\",\"prap\":\"⪷\",\"Pr\":\"⪻\",\"pr\":\"≺\",\"prcue\":\"≼\",\"precapprox\":\"⪷\",\"prec\":\"≺\",\"preccurlyeq\":\"≼\",\"Precedes\":\"≺\",\"PrecedesEqual\":\"⪯\",\"PrecedesSlantEqual\":\"≼\",\"PrecedesTilde\":\"≾\",\"preceq\":\"⪯\",\"precnapprox\":\"⪹\",\"precneqq\":\"⪵\",\"precnsim\":\"⋨\",\"pre\":\"⪯\",\"prE\":\"⪳\",\"precsim\":\"≾\",\"prime\":\"′\",\"Prime\":\"″\",\"primes\":\"ℙ\",\"prnap\":\"⪹\",\"prnE\":\"⪵\",\"prnsim\":\"⋨\",\"prod\":\"∏\",\"Product\":\"∏\",\"profalar\":\"⌮\",\"profline\":\"⌒\",\"profsurf\":\"⌓\",\"prop\":\"∝\",\"Proportional\":\"∝\",\"Proportion\":\"∷\",\"propto\":\"∝\",\"prsim\":\"≾\",\"prurel\":\"⊰\",\"Pscr\":\"𝒫\",\"pscr\":\"𝓅\",\"Psi\":\"Ψ\",\"psi\":\"ψ\",\"puncsp\":\" \",\"Qfr\":\"𝔔\",\"qfr\":\"𝔮\",\"qint\":\"⨌\",\"qopf\":\"𝕢\",\"Qopf\":\"ℚ\",\"qprime\":\"⁗\",\"Qscr\":\"𝒬\",\"qscr\":\"𝓆\",\"quaternions\":\"ℍ\",\"quatint\":\"⨖\",\"quest\":\"?\",\"questeq\":\"≟\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"rAarr\":\"⇛\",\"race\":\"∽̱\",\"Racute\":\"Ŕ\",\"racute\":\"ŕ\",\"radic\":\"√\",\"raemptyv\":\"⦳\",\"rang\":\"⟩\",\"Rang\":\"⟫\",\"rangd\":\"⦒\",\"range\":\"⦥\",\"rangle\":\"⟩\",\"raquo\":\"»\",\"rarrap\":\"⥵\",\"rarrb\":\"⇥\",\"rarrbfs\":\"⤠\",\"rarrc\":\"⤳\",\"rarr\":\"→\",\"Rarr\":\"↠\",\"rArr\":\"⇒\",\"rarrfs\":\"⤞\",\"rarrhk\":\"↪\",\"rarrlp\":\"↬\",\"rarrpl\":\"⥅\",\"rarrsim\":\"⥴\",\"Rarrtl\":\"⤖\",\"rarrtl\":\"↣\",\"rarrw\":\"↝\",\"ratail\":\"⤚\",\"rAtail\":\"⤜\",\"ratio\":\"∶\",\"rationals\":\"ℚ\",\"rbarr\":\"⤍\",\"rBarr\":\"⤏\",\"RBarr\":\"⤐\",\"rbbrk\":\"❳\",\"rbrace\":\"}\",\"rbrack\":\"]\",\"rbrke\":\"⦌\",\"rbrksld\":\"⦎\",\"rbrkslu\":\"⦐\",\"Rcaron\":\"Ř\",\"rcaron\":\"ř\",\"Rcedil\":\"Ŗ\",\"rcedil\":\"ŗ\",\"rceil\":\"⌉\",\"rcub\":\"}\",\"Rcy\":\"Р\",\"rcy\":\"р\",\"rdca\":\"⤷\",\"rdldhar\":\"⥩\",\"rdquo\":\"”\",\"rdquor\":\"”\",\"rdsh\":\"↳\",\"real\":\"ℜ\",\"realine\":\"ℛ\",\"realpart\":\"ℜ\",\"reals\":\"ℝ\",\"Re\":\"ℜ\",\"rect\":\"▭\",\"reg\":\"®\",\"REG\":\"®\",\"ReverseElement\":\"∋\",\"ReverseEquilibrium\":\"⇋\",\"ReverseUpEquilibrium\":\"⥯\",\"rfisht\":\"⥽\",\"rfloor\":\"⌋\",\"rfr\":\"𝔯\",\"Rfr\":\"ℜ\",\"rHar\":\"⥤\",\"rhard\":\"⇁\",\"rharu\":\"⇀\",\"rharul\":\"⥬\",\"Rho\":\"Ρ\",\"rho\":\"ρ\",\"rhov\":\"ϱ\",\"RightAngleBracket\":\"⟩\",\"RightArrowBar\":\"⇥\",\"rightarrow\":\"→\",\"RightArrow\":\"→\",\"Rightarrow\":\"⇒\",\"RightArrowLeftArrow\":\"⇄\",\"rightarrowtail\":\"↣\",\"RightCeiling\":\"⌉\",\"RightDoubleBracket\":\"⟧\",\"RightDownTeeVector\":\"⥝\",\"RightDownVectorBar\":\"⥕\",\"RightDownVector\":\"⇂\",\"RightFloor\":\"⌋\",\"rightharpoondown\":\"⇁\",\"rightharpoonup\":\"⇀\",\"rightleftarrows\":\"⇄\",\"rightleftharpoons\":\"⇌\",\"rightrightarrows\":\"⇉\",\"rightsquigarrow\":\"↝\",\"RightTeeArrow\":\"↦\",\"RightTee\":\"⊢\",\"RightTeeVector\":\"⥛\",\"rightthreetimes\":\"⋌\",\"RightTriangleBar\":\"⧐\",\"RightTriangle\":\"⊳\",\"RightTriangleEqual\":\"⊵\",\"RightUpDownVector\":\"⥏\",\"RightUpTeeVector\":\"⥜\",\"RightUpVectorBar\":\"⥔\",\"RightUpVector\":\"↾\",\"RightVectorBar\":\"⥓\",\"RightVector\":\"⇀\",\"ring\":\"˚\",\"risingdotseq\":\"≓\",\"rlarr\":\"⇄\",\"rlhar\":\"⇌\",\"rlm\":\"‏\",\"rmoustache\":\"⎱\",\"rmoust\":\"⎱\",\"rnmid\":\"⫮\",\"roang\":\"⟭\",\"roarr\":\"⇾\",\"robrk\":\"⟧\",\"ropar\":\"⦆\",\"ropf\":\"𝕣\",\"Ropf\":\"ℝ\",\"roplus\":\"⨮\",\"rotimes\":\"⨵\",\"RoundImplies\":\"⥰\",\"rpar\":\")\",\"rpargt\":\"⦔\",\"rppolint\":\"⨒\",\"rrarr\":\"⇉\",\"Rrightarrow\":\"⇛\",\"rsaquo\":\"›\",\"rscr\":\"𝓇\",\"Rscr\":\"ℛ\",\"rsh\":\"↱\",\"Rsh\":\"↱\",\"rsqb\":\"]\",\"rsquo\":\"’\",\"rsquor\":\"’\",\"rthree\":\"⋌\",\"rtimes\":\"⋊\",\"rtri\":\"▹\",\"rtrie\":\"⊵\",\"rtrif\":\"▸\",\"rtriltri\":\"⧎\",\"RuleDelayed\":\"⧴\",\"ruluhar\":\"⥨\",\"rx\":\"℞\",\"Sacute\":\"Ś\",\"sacute\":\"ś\",\"sbquo\":\"‚\",\"scap\":\"⪸\",\"Scaron\":\"Š\",\"scaron\":\"š\",\"Sc\":\"⪼\",\"sc\":\"≻\",\"sccue\":\"≽\",\"sce\":\"⪰\",\"scE\":\"⪴\",\"Scedil\":\"Ş\",\"scedil\":\"ş\",\"Scirc\":\"Ŝ\",\"scirc\":\"ŝ\",\"scnap\":\"⪺\",\"scnE\":\"⪶\",\"scnsim\":\"⋩\",\"scpolint\":\"⨓\",\"scsim\":\"≿\",\"Scy\":\"С\",\"scy\":\"с\",\"sdotb\":\"⊡\",\"sdot\":\"⋅\",\"sdote\":\"⩦\",\"searhk\":\"⤥\",\"searr\":\"↘\",\"seArr\":\"⇘\",\"searrow\":\"↘\",\"sect\":\"§\",\"semi\":\";\",\"seswar\":\"⤩\",\"setminus\":\"∖\",\"setmn\":\"∖\",\"sext\":\"✶\",\"Sfr\":\"𝔖\",\"sfr\":\"𝔰\",\"sfrown\":\"⌢\",\"sharp\":\"♯\",\"SHCHcy\":\"Щ\",\"shchcy\":\"щ\",\"SHcy\":\"Ш\",\"shcy\":\"ш\",\"ShortDownArrow\":\"↓\",\"ShortLeftArrow\":\"←\",\"shortmid\":\"∣\",\"shortparallel\":\"∥\",\"ShortRightArrow\":\"→\",\"ShortUpArrow\":\"↑\",\"shy\":\"­\",\"Sigma\":\"Σ\",\"sigma\":\"σ\",\"sigmaf\":\"ς\",\"sigmav\":\"ς\",\"sim\":\"∼\",\"simdot\":\"⩪\",\"sime\":\"≃\",\"simeq\":\"≃\",\"simg\":\"⪞\",\"simgE\":\"⪠\",\"siml\":\"⪝\",\"simlE\":\"⪟\",\"simne\":\"≆\",\"simplus\":\"⨤\",\"simrarr\":\"⥲\",\"slarr\":\"←\",\"SmallCircle\":\"∘\",\"smallsetminus\":\"∖\",\"smashp\":\"⨳\",\"smeparsl\":\"⧤\",\"smid\":\"∣\",\"smile\":\"⌣\",\"smt\":\"⪪\",\"smte\":\"⪬\",\"smtes\":\"⪬︀\",\"SOFTcy\":\"Ь\",\"softcy\":\"ь\",\"solbar\":\"⌿\",\"solb\":\"⧄\",\"sol\":\"/\",\"Sopf\":\"𝕊\",\"sopf\":\"𝕤\",\"spades\":\"♠\",\"spadesuit\":\"♠\",\"spar\":\"∥\",\"sqcap\":\"⊓\",\"sqcaps\":\"⊓︀\",\"sqcup\":\"⊔\",\"sqcups\":\"⊔︀\",\"Sqrt\":\"√\",\"sqsub\":\"⊏\",\"sqsube\":\"⊑\",\"sqsubset\":\"⊏\",\"sqsubseteq\":\"⊑\",\"sqsup\":\"⊐\",\"sqsupe\":\"⊒\",\"sqsupset\":\"⊐\",\"sqsupseteq\":\"⊒\",\"square\":\"□\",\"Square\":\"□\",\"SquareIntersection\":\"⊓\",\"SquareSubset\":\"⊏\",\"SquareSubsetEqual\":\"⊑\",\"SquareSuperset\":\"⊐\",\"SquareSupersetEqual\":\"⊒\",\"SquareUnion\":\"⊔\",\"squarf\":\"▪\",\"squ\":\"□\",\"squf\":\"▪\",\"srarr\":\"→\",\"Sscr\":\"𝒮\",\"sscr\":\"𝓈\",\"ssetmn\":\"∖\",\"ssmile\":\"⌣\",\"sstarf\":\"⋆\",\"Star\":\"⋆\",\"star\":\"☆\",\"starf\":\"★\",\"straightepsilon\":\"ϵ\",\"straightphi\":\"ϕ\",\"strns\":\"¯\",\"sub\":\"⊂\",\"Sub\":\"⋐\",\"subdot\":\"⪽\",\"subE\":\"⫅\",\"sube\":\"⊆\",\"subedot\":\"⫃\",\"submult\":\"⫁\",\"subnE\":\"⫋\",\"subne\":\"⊊\",\"subplus\":\"⪿\",\"subrarr\":\"⥹\",\"subset\":\"⊂\",\"Subset\":\"⋐\",\"subseteq\":\"⊆\",\"subseteqq\":\"⫅\",\"SubsetEqual\":\"⊆\",\"subsetneq\":\"⊊\",\"subsetneqq\":\"⫋\",\"subsim\":\"⫇\",\"subsub\":\"⫕\",\"subsup\":\"⫓\",\"succapprox\":\"⪸\",\"succ\":\"≻\",\"succcurlyeq\":\"≽\",\"Succeeds\":\"≻\",\"SucceedsEqual\":\"⪰\",\"SucceedsSlantEqual\":\"≽\",\"SucceedsTilde\":\"≿\",\"succeq\":\"⪰\",\"succnapprox\":\"⪺\",\"succneqq\":\"⪶\",\"succnsim\":\"⋩\",\"succsim\":\"≿\",\"SuchThat\":\"∋\",\"sum\":\"∑\",\"Sum\":\"∑\",\"sung\":\"♪\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"sup\":\"⊃\",\"Sup\":\"⋑\",\"supdot\":\"⪾\",\"supdsub\":\"⫘\",\"supE\":\"⫆\",\"supe\":\"⊇\",\"supedot\":\"⫄\",\"Superset\":\"⊃\",\"SupersetEqual\":\"⊇\",\"suphsol\":\"⟉\",\"suphsub\":\"⫗\",\"suplarr\":\"⥻\",\"supmult\":\"⫂\",\"supnE\":\"⫌\",\"supne\":\"⊋\",\"supplus\":\"⫀\",\"supset\":\"⊃\",\"Supset\":\"⋑\",\"supseteq\":\"⊇\",\"supseteqq\":\"⫆\",\"supsetneq\":\"⊋\",\"supsetneqq\":\"⫌\",\"supsim\":\"⫈\",\"supsub\":\"⫔\",\"supsup\":\"⫖\",\"swarhk\":\"⤦\",\"swarr\":\"↙\",\"swArr\":\"⇙\",\"swarrow\":\"↙\",\"swnwar\":\"⤪\",\"szlig\":\"ß\",\"Tab\":\"\\t\",\"target\":\"⌖\",\"Tau\":\"Τ\",\"tau\":\"τ\",\"tbrk\":\"⎴\",\"Tcaron\":\"Ť\",\"tcaron\":\"ť\",\"Tcedil\":\"Ţ\",\"tcedil\":\"ţ\",\"Tcy\":\"Т\",\"tcy\":\"т\",\"tdot\":\"⃛\",\"telrec\":\"⌕\",\"Tfr\":\"𝔗\",\"tfr\":\"𝔱\",\"there4\":\"∴\",\"therefore\":\"∴\",\"Therefore\":\"∴\",\"Theta\":\"Θ\",\"theta\":\"θ\",\"thetasym\":\"ϑ\",\"thetav\":\"ϑ\",\"thickapprox\":\"≈\",\"thicksim\":\"∼\",\"ThickSpace\":\"  \",\"ThinSpace\":\" \",\"thinsp\":\" \",\"thkap\":\"≈\",\"thksim\":\"∼\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"tilde\":\"˜\",\"Tilde\":\"∼\",\"TildeEqual\":\"≃\",\"TildeFullEqual\":\"≅\",\"TildeTilde\":\"≈\",\"timesbar\":\"⨱\",\"timesb\":\"⊠\",\"times\":\"×\",\"timesd\":\"⨰\",\"tint\":\"∭\",\"toea\":\"⤨\",\"topbot\":\"⌶\",\"topcir\":\"⫱\",\"top\":\"⊤\",\"Topf\":\"𝕋\",\"topf\":\"𝕥\",\"topfork\":\"⫚\",\"tosa\":\"⤩\",\"tprime\":\"‴\",\"trade\":\"™\",\"TRADE\":\"™\",\"triangle\":\"▵\",\"triangledown\":\"▿\",\"triangleleft\":\"◃\",\"trianglelefteq\":\"⊴\",\"triangleq\":\"≜\",\"triangleright\":\"▹\",\"trianglerighteq\":\"⊵\",\"tridot\":\"◬\",\"trie\":\"≜\",\"triminus\":\"⨺\",\"TripleDot\":\"⃛\",\"triplus\":\"⨹\",\"trisb\":\"⧍\",\"tritime\":\"⨻\",\"trpezium\":\"⏢\",\"Tscr\":\"𝒯\",\"tscr\":\"𝓉\",\"TScy\":\"Ц\",\"tscy\":\"ц\",\"TSHcy\":\"Ћ\",\"tshcy\":\"ћ\",\"Tstrok\":\"Ŧ\",\"tstrok\":\"ŧ\",\"twixt\":\"≬\",\"twoheadleftarrow\":\"↞\",\"twoheadrightarrow\":\"↠\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"uarr\":\"↑\",\"Uarr\":\"↟\",\"uArr\":\"⇑\",\"Uarrocir\":\"⥉\",\"Ubrcy\":\"Ў\",\"ubrcy\":\"ў\",\"Ubreve\":\"Ŭ\",\"ubreve\":\"ŭ\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ucy\":\"У\",\"ucy\":\"у\",\"udarr\":\"⇅\",\"Udblac\":\"Ű\",\"udblac\":\"ű\",\"udhar\":\"⥮\",\"ufisht\":\"⥾\",\"Ufr\":\"𝔘\",\"ufr\":\"𝔲\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uHar\":\"⥣\",\"uharl\":\"↿\",\"uharr\":\"↾\",\"uhblk\":\"▀\",\"ulcorn\":\"⌜\",\"ulcorner\":\"⌜\",\"ulcrop\":\"⌏\",\"ultri\":\"◸\",\"Umacr\":\"Ū\",\"umacr\":\"ū\",\"uml\":\"¨\",\"UnderBar\":\"_\",\"UnderBrace\":\"⏟\",\"UnderBracket\":\"⎵\",\"UnderParenthesis\":\"⏝\",\"Union\":\"⋃\",\"UnionPlus\":\"⊎\",\"Uogon\":\"Ų\",\"uogon\":\"ų\",\"Uopf\":\"𝕌\",\"uopf\":\"𝕦\",\"UpArrowBar\":\"⤒\",\"uparrow\":\"↑\",\"UpArrow\":\"↑\",\"Uparrow\":\"⇑\",\"UpArrowDownArrow\":\"⇅\",\"updownarrow\":\"↕\",\"UpDownArrow\":\"↕\",\"Updownarrow\":\"⇕\",\"UpEquilibrium\":\"⥮\",\"upharpoonleft\":\"↿\",\"upharpoonright\":\"↾\",\"uplus\":\"⊎\",\"UpperLeftArrow\":\"↖\",\"UpperRightArrow\":\"↗\",\"upsi\":\"υ\",\"Upsi\":\"ϒ\",\"upsih\":\"ϒ\",\"Upsilon\":\"Υ\",\"upsilon\":\"υ\",\"UpTeeArrow\":\"↥\",\"UpTee\":\"⊥\",\"upuparrows\":\"⇈\",\"urcorn\":\"⌝\",\"urcorner\":\"⌝\",\"urcrop\":\"⌎\",\"Uring\":\"Ů\",\"uring\":\"ů\",\"urtri\":\"◹\",\"Uscr\":\"𝒰\",\"uscr\":\"𝓊\",\"utdot\":\"⋰\",\"Utilde\":\"Ũ\",\"utilde\":\"ũ\",\"utri\":\"▵\",\"utrif\":\"▴\",\"uuarr\":\"⇈\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"uwangle\":\"⦧\",\"vangrt\":\"⦜\",\"varepsilon\":\"ϵ\",\"varkappa\":\"ϰ\",\"varnothing\":\"∅\",\"varphi\":\"ϕ\",\"varpi\":\"ϖ\",\"varpropto\":\"∝\",\"varr\":\"↕\",\"vArr\":\"⇕\",\"varrho\":\"ϱ\",\"varsigma\":\"ς\",\"varsubsetneq\":\"⊊︀\",\"varsubsetneqq\":\"⫋︀\",\"varsupsetneq\":\"⊋︀\",\"varsupsetneqq\":\"⫌︀\",\"vartheta\":\"ϑ\",\"vartriangleleft\":\"⊲\",\"vartriangleright\":\"⊳\",\"vBar\":\"⫨\",\"Vbar\":\"⫫\",\"vBarv\":\"⫩\",\"Vcy\":\"В\",\"vcy\":\"в\",\"vdash\":\"⊢\",\"vDash\":\"⊨\",\"Vdash\":\"⊩\",\"VDash\":\"⊫\",\"Vdashl\":\"⫦\",\"veebar\":\"⊻\",\"vee\":\"∨\",\"Vee\":\"⋁\",\"veeeq\":\"≚\",\"vellip\":\"⋮\",\"verbar\":\"|\",\"Verbar\":\"‖\",\"vert\":\"|\",\"Vert\":\"‖\",\"VerticalBar\":\"∣\",\"VerticalLine\":\"|\",\"VerticalSeparator\":\"❘\",\"VerticalTilde\":\"≀\",\"VeryThinSpace\":\" \",\"Vfr\":\"𝔙\",\"vfr\":\"𝔳\",\"vltri\":\"⊲\",\"vnsub\":\"⊂⃒\",\"vnsup\":\"⊃⃒\",\"Vopf\":\"𝕍\",\"vopf\":\"𝕧\",\"vprop\":\"∝\",\"vrtri\":\"⊳\",\"Vscr\":\"𝒱\",\"vscr\":\"𝓋\",\"vsubnE\":\"⫋︀\",\"vsubne\":\"⊊︀\",\"vsupnE\":\"⫌︀\",\"vsupne\":\"⊋︀\",\"Vvdash\":\"⊪\",\"vzigzag\":\"⦚\",\"Wcirc\":\"Ŵ\",\"wcirc\":\"ŵ\",\"wedbar\":\"⩟\",\"wedge\":\"∧\",\"Wedge\":\"⋀\",\"wedgeq\":\"≙\",\"weierp\":\"℘\",\"Wfr\":\"𝔚\",\"wfr\":\"𝔴\",\"Wopf\":\"𝕎\",\"wopf\":\"𝕨\",\"wp\":\"℘\",\"wr\":\"≀\",\"wreath\":\"≀\",\"Wscr\":\"𝒲\",\"wscr\":\"𝓌\",\"xcap\":\"⋂\",\"xcirc\":\"◯\",\"xcup\":\"⋃\",\"xdtri\":\"▽\",\"Xfr\":\"𝔛\",\"xfr\":\"𝔵\",\"xharr\":\"⟷\",\"xhArr\":\"⟺\",\"Xi\":\"Ξ\",\"xi\":\"ξ\",\"xlarr\":\"⟵\",\"xlArr\":\"⟸\",\"xmap\":\"⟼\",\"xnis\":\"⋻\",\"xodot\":\"⨀\",\"Xopf\":\"𝕏\",\"xopf\":\"𝕩\",\"xoplus\":\"⨁\",\"xotime\":\"⨂\",\"xrarr\":\"⟶\",\"xrArr\":\"⟹\",\"Xscr\":\"𝒳\",\"xscr\":\"𝓍\",\"xsqcup\":\"⨆\",\"xuplus\":\"⨄\",\"xutri\":\"△\",\"xvee\":\"⋁\",\"xwedge\":\"⋀\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"YAcy\":\"Я\",\"yacy\":\"я\",\"Ycirc\":\"Ŷ\",\"ycirc\":\"ŷ\",\"Ycy\":\"Ы\",\"ycy\":\"ы\",\"yen\":\"¥\",\"Yfr\":\"𝔜\",\"yfr\":\"𝔶\",\"YIcy\":\"Ї\",\"yicy\":\"ї\",\"Yopf\":\"𝕐\",\"yopf\":\"𝕪\",\"Yscr\":\"𝒴\",\"yscr\":\"𝓎\",\"YUcy\":\"Ю\",\"yucy\":\"ю\",\"yuml\":\"ÿ\",\"Yuml\":\"Ÿ\",\"Zacute\":\"Ź\",\"zacute\":\"ź\",\"Zcaron\":\"Ž\",\"zcaron\":\"ž\",\"Zcy\":\"З\",\"zcy\":\"з\",\"Zdot\":\"Ż\",\"zdot\":\"ż\",\"zeetrf\":\"ℨ\",\"ZeroWidthSpace\":\"​\",\"Zeta\":\"Ζ\",\"zeta\":\"ζ\",\"zfr\":\"𝔷\",\"Zfr\":\"ℨ\",\"ZHcy\":\"Ж\",\"zhcy\":\"ж\",\"zigrarr\":\"⇝\",\"zopf\":\"𝕫\",\"Zopf\":\"ℤ\",\"Zscr\":\"𝒵\",\"zscr\":\"𝓏\",\"zwj\":\"‍\",\"zwnj\":\"‌\"}");

/***/ }),

/***/ "8zGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Flipper; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;

var Flipper = function Flipper(_ref) {
  var description = _ref.description,
      value = _ref.value;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(value),
      oldValue = _useState[0],
      setOldValue = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(value),
      latestValue = _useState2[0],
      setLatestValue = _useState2[1];

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(''),
      transition = _useState3[0],
      setTransition = _useState3[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    setOldValue(latestValue);
    setLatestValue(value);

    if (value !== latestValue) {
      setTransition('flipperLeave');
    }
  }, [value]);
  return __jsx("span", {
    "data-testid": value,
    className: "relative"
  }, !!description && __jsx("span", {
    className: "sr-only",
    "data-testid": "srOnly"
  }, description), __jsx("span", {
    className: "text-center ".concat(transition),
    "data-testid": "Flipper-value",
    key: transition,
    onAnimationEnd: function onAnimationEnd(event) {
      switch (event.animationName) {
        case 'flipperLeave':
          setTransition('flipperEnter');
          break;

        case 'flipperEnter':
          setTransition('flipperEnter');
          break;

        default:
          break;
      }
    }
  }, transition === 'flipperLeave' ? oldValue : latestValue));
};

/***/ }),

/***/ "9BC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isPhoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emailRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPhoneRegex; });
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0__);
 // WARNING: iF this file is growing too much, think of replacing it with a library like Validator.js

function isPhoneNumber(stringToTest) {
  return /^[\d\s()+-.]+$/.test(stringToTest.trim());
}

var emailRegex = new RegExp(/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/);

var getPhoneRegex = function getPhoneRegex(locale) {
  var _domainsService$getDo, _domainsService$getDo2;

  return new RegExp(((_domainsService$getDo = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_0___default.a.getDomain(locale)) === null || _domainsService$getDo === void 0 ? void 0 : (_domainsService$getDo2 = _domainsService$getDo.fields) === null || _domainsService$getDo2 === void 0 ? void 0 : _domainsService$getDo2.phoneNumber) || /^ *\+? *(?:[ \-()]*[0-9][ \-()]*){6,12}$/);
};



/***/ }),

/***/ "9Kh7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return offerLegalInformationResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var offerLegalInformationResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* OFFER_LEGAL_INFORMATION */ "D"],
  resolve: function resolve(appContext, props) {
    var offerId = props.offerId;
    var query = "\n    {\n      offer(offerId: \"".concat(offerId, "\") {\n        legalInformation\n      },\n      config {\n        common {\n          loadLess\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_OFFER_LEGAL_INFORMATION */ "Vb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "9OZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductService; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("gA51");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var ProductService = function ProductService(_ref) {
  var className = _ref.className,
      service = _ref.service;
  var description = service.description,
      icon = service.icon,
      label = service.label;
  return description ? __jsx(_frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_5__[/* CollapsePanel */ "a"], {
    className: className,
    collapseIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].BOLDER_ARROW_FORTH_DOWN,
    collapseLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('common.included'),
    expandIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].BOLDER_ARROW_FORTH_DOWN,
    expandLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('common.included'),
    hasEllipsis: false,
    hasKeepCollapsedContent: false,
    iconName: icon,
    id: icon,
    isExpanded: false,
    key: icon,
    theme: "remote",
    title: label
  }, __jsx("p", {
    className: "reset-paragraph mb-5 text-base"
  }, description)) : __jsx("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'fadeIn border-b-1 flex items-center py-5 text-base')
  }, __jsx("span", {
    className: "flex items-center flex-1 max-w-full overflow-hidden text-gray-darker"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "rtl:mr-4 flex-shrink-0",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    name: icon,
    width: "1.375rem"
  }), label), __jsx("span", {
    className: "flex-shrink-0 font-bold rtl:ml-auto text-blue"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])('common.included')));
};

/***/ }),

/***/ "9QcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACETING_CHILDCARE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FACETING_CLEAR_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FACETING_PRICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FACETING_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FACETING_LOAD_PRODUCTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FACETING_LOAD_OFFSET_SELL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FACETING_SET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FACETING_SET_INITIAL_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FACETING_SET_IS_DATE_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FACETING_SET_IS_SEARCH_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FACETING_SET_KIDS_VALIDATION_STATE; });
/* unused harmony export FACETING_SET_SCROLL_TO_RESULTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FACETING_SET_SEARCH_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FACETING_RESET_REDIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FACETING_RESET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FACETING_TOGGLE_FACET_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FACETING_UPDATE_FILTERS; });
var FACETING_CHILDCARE_REQUEST = 'FACETING_CHILDCARE_REQUEST';
var FACETING_CLEAR_FACETS = 'FACETING_CLEAR_FACETS';
var FACETING_PRICES_REQUEST = 'FACETING_PRICES_REQUEST';
var FACETING_SEARCH_REQUEST = 'FACETING_SEARCH_REQUEST';
var FACETING_LOAD_PRODUCTS_REQUEST = 'FACETING_LOAD_PRODUCTS_REQUEST';
var FACETING_LOAD_OFFSET_SELL_REQUEST = 'FACETING_LOAD_OFFSET_SELL_REQUEST';
var FACETING_SET_FILTERS = 'FACETING_SET_FILTERS';
var FACETING_SET_INITIAL_PRICES = 'FACETING_SET_INITIAL_PRICES';
var FACETING_SET_IS_DATE_REQUIRED = 'FACETING_SET_IS_DATE_REQUIRED';
var FACETING_SET_IS_SEARCH_ENABLED = 'FACETING_SET_IS_SEARCH_ENABLED';
var FACETING_SET_KIDS_VALIDATION_STATE = 'FACETING_SET_KIDS_VALIDATION_STATE';
var FACETING_SET_SCROLL_TO_RESULTS = 'FACETING_SCROLL_TO_RESULTS';
var FACETING_SET_SEARCH_QUERY = 'FACETING_SET_SEARCH_QUERY';
var FACETING_RESET_REDIRECTION = 'FACETING_RESET_REDIRECTION';
var FACETING_RESET_SEARCH = 'FACETING_RESET_SEARCH';
var FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_FACET_SELECTED = 'FACETING_TOGGLE_FACET_SELECTED';
var FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON = 'FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON';
var FACETING_UPDATE_FILTERS = 'FACETING_UPDATE_FILTERS';

/***/ }),

/***/ "9Ts2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productBarsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productBarsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_BARS */ "db"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var productId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      resort(".concat(productArgs, ") {\n        adultOnly\n      },\n      bars(").concat(productArgs, ") {\n        introduction { included withSupplement }\n        barsList { name images description }\n      }\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_BARS */ "bc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "9XrK":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__("1MRr"),
    baseUnary = __webpack_require__("id+h"),
    nodeUtil = __webpack_require__("2LZg");

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ "9smd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productBreadcrumbResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var productBreadcrumbResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_BREADCRUMB */ "J"],
  props: function props(appContext) {
    return {
      originalUrl: function originalUrl() {
        return appContext.originalUrl;
      }
    };
  },
  resolve: function resolve(appContext, cmsProps, pageContext) {
    var productCountryPageUrl = pageContext.productCountryPageUrl,
        productRegionPageUrl = pageContext.productRegionPageUrl;
    var pageCountryQuery = productCountryPageUrl ? "\n      countryPage: pageByUrl(pageUrl: \"".concat(productCountryPageUrl, "\") {\n        pageCountry { breadcrumbLabel }\n        url\n      }") : '';
    var pageRegionQuery = productRegionPageUrl ? "\n      regionPage: pageByUrl(pageUrl: \"".concat(productRegionPageUrl, "\") {\n        pageRegion { breadcrumbLabel }\n        url\n      }") : '';
    var query = "query {\n      resort(productId: \"".concat(cmsProps.resortId, "\"){\n        name\n      }\n      ").concat(pageCountryQuery, "\n      ").concat(pageRegionQuery, "\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_BREADCRUMB */ "dc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "9wHB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ pageTrackingResolver; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/cms/toolkit/constants.js
var constants = __webpack_require__("psNz");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__("0Jwk");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// CONCATENATED MODULE: ./node_modules/path-to-regexp/dist.es2015/index.js
/**
 * Tokenize input string.
 */
function lexer(str) {
    var tokens = [];
    var i = 0;
    while (i < str.length) {
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({ type: "MODIFIER", index: i, value: str[i++] });
            continue;
        }
        if (char === "\\") {
            tokens.push({ type: "ESCAPED_CHAR", index: i++, value: str[i++] });
            continue;
        }
        if (char === "{") {
            tokens.push({ type: "OPEN", index: i, value: str[i++] });
            continue;
        }
        if (char === "}") {
            tokens.push({ type: "CLOSE", index: i, value: str[i++] });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while (j < str.length) {
                var code = str.charCodeAt(j);
                if (
                // `0-9`
                (code >= 48 && code <= 57) ||
                    // `A-Z`
                    (code >= 65 && code <= 90) ||
                    // `a-z`
                    (code >= 97 && code <= 122) ||
                    // `_`
                    code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name)
                throw new TypeError("Missing parameter name at " + i);
            tokens.push({ type: "NAME", index: i, value: name });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") {
                throw new TypeError("Pattern cannot start with \"?\" at " + j);
            }
            while (j < str.length) {
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                }
                else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") {
                        throw new TypeError("Capturing groups are not allowed at " + j);
                    }
                }
                pattern += str[j++];
            }
            if (count)
                throw new TypeError("Unbalanced pattern at " + i);
            if (!pattern)
                throw new TypeError("Missing pattern at " + i);
            tokens.push({ type: "PATTERN", index: i, value: pattern });
            i = j;
            continue;
        }
        tokens.push({ type: "CHAR", index: i, value: str[i++] });
    }
    tokens.push({ type: "END", index: i, value: "" });
    return tokens;
}
/**
 * Parse a string for the raw tokens.
 */
function parse(str, options) {
    if (options === void 0) { options = {}; }
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^" + escapeString(options.delimiter || "/#?") + "]+?";
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function (type) {
        if (i < tokens.length && tokens[i].type === type)
            return tokens[i++].value;
    };
    var mustConsume = function (type) {
        var value = tryConsume(type);
        if (value !== undefined)
            return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected " + nextType + " at " + index + ", expected " + type);
    };
    var consumeText = function () {
        var result = "";
        var value;
        // tslint:disable-next-line
        while ((value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))) {
            result += value;
        }
        return result;
    };
    while (i < tokens.length) {
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
/**
 * Compile a string to a template function for the path.
 */
function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens, options) {
    if (options === void 0) { options = {}; }
    var reFlags = flags(options);
    var _a = options.encode, encode = _a === void 0 ? function (x) { return x; } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function (token) {
        if (typeof token === "object") {
            return new RegExp("^(?:" + token.pattern + ")$", reFlags);
        }
    });
    return function (data) {
        var path = "";
        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) {
                    throw new TypeError("Expected \"" + token.name + "\" to not repeat, but got an array");
                }
                if (value.length === 0) {
                    if (optional)
                        continue;
                    throw new TypeError("Expected \"" + token.name + "\" to not be empty");
                }
                for (var j = 0; j < value.length; j++) {
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) {
                        throw new TypeError("Expected all \"" + token.name + "\" to match \"" + token.pattern + "\", but got \"" + segment + "\"");
                    }
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) {
                    throw new TypeError("Expected \"" + token.name + "\" to match \"" + token.pattern + "\", but got \"" + segment + "\"");
                }
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional)
                continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"" + token.name + "\" to be " + typeOfMessage);
        }
        return path;
    };
}
/**
 * Create path match function from `path-to-regexp` spec.
 */
function dist_es2015_match(str, options) {
    var keys = [];
    var re = pathToRegexp(str, keys, options);
    return regexpToFunction(re, keys, options);
}
/**
 * Create a path match function from `path-to-regexp` output.
 */
function regexpToFunction(re, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.decode, decode = _a === void 0 ? function (x) { return x; } : _a;
    return function (pathname) {
        var m = re.exec(pathname);
        if (!m)
            return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function (i) {
            // tslint:disable-next-line
            if (m[i] === undefined)
                return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") {
                params[key.name] = m[i].split(key.prefix + key.suffix).map(function (value) {
                    return decode(value, key);
                });
            }
            else {
                params[key.name] = decode(m[i], key);
            }
        };
        for (var i = 1; i < m.length; i++) {
            _loop_1(i);
        }
        return { path: path, index: index, params: params };
    };
}
/**
 * Escape a regular expression string.
 */
function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */
function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */
function regexpToRegexp(path, keys) {
    if (!keys)
        return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) {
        for (var i = 0; i < groups.length; i++) {
            keys.push({
                name: i,
                prefix: "",
                suffix: "",
                modifier: "",
                pattern: ""
            });
        }
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */
function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function (path) { return pathToRegexp(path, keys, options).source; });
    return new RegExp("(?:" + parts.join("|") + ")", flags(options));
}
/**
 * Create a path regexp from string input.
 */
function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 */
function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function (x) { return x; } : _d;
    var endsWith = "[" + escapeString(options.endsWith || "") + "]|$";
    var delimiter = "[" + escapeString(options.delimiter || "/#?") + "]";
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        if (typeof token === "string") {
            route += escapeString(encode(token));
        }
        else {
            var prefix = escapeString(encode(token.prefix));
            var suffix = escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys)
                    keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:" + prefix + "((?:" + token.pattern + ")(?:" + suffix + prefix + "(?:" + token.pattern + "))*)" + suffix + ")" + mod;
                    }
                    else {
                        route += "(?:" + prefix + "(" + token.pattern + ")" + suffix + ")" + token.modifier;
                    }
                }
                else {
                    route += "(" + token.pattern + ")" + token.modifier;
                }
            }
            else {
                route += "(?:" + prefix + suffix + ")" + token.modifier;
            }
        }
    }
    if (end) {
        if (!strict)
            route += delimiter + "?";
        route += !options.endsWith ? "$" : "(?=" + endsWith + ")";
    }
    else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string"
            ? delimiter.indexOf(endToken[endToken.length - 1]) > -1
            : // tslint:disable-next-line
                endToken === undefined;
        if (!strict) {
            route += "(?:" + delimiter + "(?=" + endsWith + "))?";
        }
        if (!isEndDelimited) {
            route += "(?=" + delimiter + "|" + endsWith + ")";
        }
    }
    return new RegExp(route, flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 */
function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp)
        return regexpToRegexp(path, keys);
    if (Array.isArray(path))
        return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/utils/tracking/resort.js
var tracking_resort = __webpack_require__("zCbR");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tracking/pageTracking.utils.js



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var PAGE_TYPES = dist["b2cPagesService"].PAGE_TYPES;

function matchPath(path, pathSchema) {
  var keys = [];
  var regexp = pathToRegexp(pathSchema, keys);
  var match = regexp.exec(path);

  if (match) {
    var _match = Object(toArray["a" /* default */])(match),
        url = _match[0],
        paramValues = _match.slice(1);

    return {
      matched: true,
      url: url,
      params: keys.reduce(function (memo, key, index) {
        return _objectSpread(_objectSpread({}, memo), {}, Object(defineProperty["a" /* default */])({}, key.name, paramValues[index]));
      }, {})
    };
  }

  return {
    matched: false
  };
}

function getDefaultTrackingProps(_ref) {
  var pageId = _ref.pageId,
      pageType = _ref.pageType;
  var siteSection = Object(utils["d" /* getSiteSection */])({
    pageType: pageType
  });
  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageId)
  };
}
function getDestinationTrackingProps(_ref2) {
  var pageType = _ref2.pageType,
      _ref2$pageRegion = _ref2.pageRegion;
  _ref2$pageRegion = _ref2$pageRegion === void 0 ? {
    name: null
  } : _ref2$pageRegion;
  var destinationRegion = _ref2$pageRegion.name,
      _ref2$pageCountry = _ref2.pageCountry;
  _ref2$pageCountry = _ref2$pageCountry === void 0 ? {
    name: null
  } : _ref2$pageCountry;
  var destinationCountry = _ref2$pageCountry.name;
  var siteSection = Object(utils["d" /* getSiteSection */])({
    pageType: pageType
  }); // The default productType for 'destination' && 'destination-mice' pages is 'resort',
  // Otherwise it is specified after the hyphen, e.g. 'destination-tour' or 'destination-cruise'.

  var productType = pageType === PAGE_TYPES.DESTINATION || pageType === PAGE_TYPES.DESTINATION_MICE ? PAGE_TYPES.RESORT : pageType.split('-')[1];
  var productTypes = Object.keys(PRODUCT_TYPES).map(lodash["toLower"]);
  var isIndexPage = !destinationRegion && !destinationCountry;
  var pageName = siteSection;

  if (!isIndexPage) {
    var pageIdentifier = [destinationRegion, destinationCountry].filter(function (item) {
      return !!item;
    }).join('_');
    pageName = "".concat(siteSection, "_").concat(pageIdentifier);
  }

  return _objectSpread({
    siteSection: siteSection,
    pageName: pageName,
    destinationRegion: destinationRegion,
    destinationCountry: destinationCountry
  }, productTypes.includes(productType) ? {
    productType: Object(lodash["toUpper"])(productType)
  } : null);
}
function getDestinationTravelTrackingProps(_ref3) {
  var pageId = _ref3.pageId,
      pageMeta = _ref3.pageMeta,
      _ref3$pageRegion = _ref3.pageRegion;
  _ref3$pageRegion = _ref3$pageRegion === void 0 ? {
    name: null
  } : _ref3$pageRegion;
  var destinationRegion = _ref3$pageRegion.name,
      _ref3$pageCountry = _ref3.pageCountry;
  _ref3$pageCountry = _ref3$pageCountry === void 0 ? {
    name: null
  } : _ref3$pageCountry;
  var destinationCountry = _ref3$pageCountry.name; // 'Travel' section != 'DestinationTravel' pageType to preserve historical tracking consistency

  var siteSection = 'Shopping_Travel';
  var _pageMeta$name = pageMeta.name,
      name = _pageMeta$name === void 0 ? null : _pageMeta$name;
  var pageIdentifier = name ? name : pageId;
  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageIdentifier),
    destinationRegion: destinationRegion,
    destinationCountry: destinationCountry
  };
}
function getLandingTrackingProps(_ref4, resort) {
  var pageId = _ref4.pageId,
      pageType = _ref4.pageType,
      pageMeta = _ref4.pageMeta;
  var isSummerCamp = (resort === null || resort === void 0 ? void 0 : resort.type) === PRODUCT_TYPES.SUMMER_CAMP;
  var siteSection = Object(utils["d" /* getSiteSection */])({
    pageType: pageType
  });
  var _pageMeta$name2 = pageMeta.name,
      name = _pageMeta$name2 === void 0 ? null : _pageMeta$name2;
  var pageIdentifier = name ? name : pageId;

  if (isSummerCamp && resort) {
    return {
      siteSection: siteSection,
      pageName: "".concat(siteSection, "_SummerCamp_").concat(resort.id),
      categoryGA: pageIdentifier
    };
  }

  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageIdentifier)
  };
}
function getOfferTrackingProps(_ref5) {
  var pagePath = _ref5.pagePath; // 'Offers' section != 'Offer' pageType to preserve historical tracking consistency

  var siteSection = 'Shopping_Offers';

  var _matchPath = matchPath(pagePath, '/o/:offerSlug?'),
      _matchPath$params = _matchPath.params;

  _matchPath$params = _matchPath$params === void 0 ? {} : _matchPath$params;
  var offerSlug = _matchPath$params.offerSlug;
  var pageName = offerSlug ? "".concat(siteSection, "_").concat(Object(utils["e" /* noCase */])(offerSlug)) : siteSection;
  return {
    siteSection: siteSection,
    pageName: pageName,
    channel: 'Offers'
  };
}
function getPrebookingTrackingProps(_ref6) {
  var pageId = _ref6.pageId,
      pageType = _ref6.pageType;
  var siteSection = Object(utils["d" /* getSiteSection */])({
    pageType: pageType
  });
  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageId)
  };
}
function getHomepageTrackingProps(_ref7) {
  var pageId = _ref7.pageId;
  var siteSection = 'Shopping_Home';
  var categoryGA = pageId.toLowerCase();
  return {
    categoryGA: categoryGA,
    siteSection: siteSection,
    pageName: "".concat(siteSection)
  };
}
function getResortTrackingProps(_ref8) {
  var pageType = _ref8.pageType,
      _ref8$pageData = _ref8.pageData,
      pageData = _ref8$pageData === void 0 ? {} : _ref8$pageData;
  var siteSection = Object(utils["d" /* getSiteSection */])({
    pageType: pageType
  });
  var _pageData$resort = pageData.resort,
      resort = _pageData$resort === void 0 ? {} : _pageData$resort,
      _pageData$price = pageData.price,
      price = _pageData$price === void 0 ? {} : _pageData$price,
      _pageData$bookingCrit = pageData.bookingCriteria,
      bookingCriteria = _pageData$bookingCrit === void 0 ? null : _pageData$bookingCrit;
  var resortId = Object(lodash["get"])(resort, 'id'); // '_Main' is appended to resort pageNames to preserve historical tracking consistency

  var pageName = Object(lodash["get"])(resort, 'type', '') === PRODUCT_TYPES.RESORT ? "".concat(siteSection, "_").concat(resortId, "_Main") : "".concat(siteSection, "_").concat(resortId);
  var departureCityCode = Object(lodash["get"])(price, 'termsAndConditions.departureCity.value');
  var departureCityName = Object(lodash["get"])(price, 'termsAndConditions.departureCity.name');
  return {
    isProductPage: true,
    categoryGA: "".concat(pageType, "-").concat(resortId),
    siteSection: siteSection,
    pageName: pageName,
    resortCode: Object(lodash["get"])(resort, 'id', null),
    resortCountry: Object(lodash["toUpper"])(Object(lodash["get"])(resort, 'destination.country', '')),
    resortDefaultPrice: Object(lodash["get"])(price, 'bestPrice.value', null),
    resortDepartureCityCode: Object(lodash["toUpper"])(Object(tracking_resort["b" /* getDepartureCityCode */])(departureCityCode)),
    resortDepartureCityName: Object(lodash["toUpper"])(Object(tracking_resort["c" /* getDepartureCityName */])(departureCityCode, departureCityName)),
    resortDepartureDate: Object(lodash["get"])(price, 'termsAndConditions.departureDate', null),
    resortName: Object(lodash["toUpper"])(Object(lodash["get"])(resort, 'name', '')),
    resortOldPrice: Object(lodash["get"])(price, 'initialPrice.value', null),
    resortRegion: Object(lodash["toUpper"])(Object(lodash["get"])(resort, 'destination.area', '')),
    resortSeasonType: Object(lodash["get"])(resort, 'seasonName', null),
    resortTransport: Object(lodash["toUpper"])(Object(tracking_resort["d" /* getTrackingTransport */])(departureCityCode)),
    resortTrident: Object(lodash["get"])(resort, 'comfort', null),
    resortUrlImage: Object(lodash["get"])(resort, 'image'),
    bookingCriteria: bookingCriteria
  };
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/tracking/pageTracking.resolver.js


function pageTracking_resolver_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function pageTracking_resolver_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      pageTracking_resolver_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      pageTracking_resolver_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var pageTracking_resolver_PAGE_TYPES = dist["b2cPagesService"].PAGE_TYPES;
var DESTINATION = pageTracking_resolver_PAGE_TYPES.DESTINATION,
    DESTINATION_TOUR = pageTracking_resolver_PAGE_TYPES.DESTINATION_TOUR,
    DESTINATION_MICE = pageTracking_resolver_PAGE_TYPES.DESTINATION_MICE,
    DESTINATION_TRAVEL = pageTracking_resolver_PAGE_TYPES.DESTINATION_TRAVEL,
    RESORT = pageTracking_resolver_PAGE_TYPES.RESORT,
    TOUR = pageTracking_resolver_PAGE_TYPES.TOUR,
    CRUISE = pageTracking_resolver_PAGE_TYPES.CRUISE,
    LANDING = pageTracking_resolver_PAGE_TYPES.LANDING,
    LANDING_MICE = pageTracking_resolver_PAGE_TYPES.LANDING_MICE,
    OFFER = pageTracking_resolver_PAGE_TYPES.OFFER,
    PREBOOKING = pageTracking_resolver_PAGE_TYPES.PREBOOKING,
    RESORT_MICE = pageTracking_resolver_PAGE_TYPES.RESORT_MICE,
    HOMEPAGE = pageTracking_resolver_PAGE_TYPES.HOMEPAGE,
    HOME = pageTracking_resolver_PAGE_TYPES.HOME;
var pageTrackingResolver = {
  name: constants["F" /* PAGE_TRACKING */],
  props: function props(appContext, pageContext, location) {
    var pagePath = location.pathname;

    var pageProps = pageTracking_resolver_objectSpread(pageTracking_resolver_objectSpread({}, pageContext), {}, {
      pagePath: pagePath
    });

    return {
      trackingData: function trackingData(props) {
        var resort = props.resort,
            price = props.price,
            bookingCriteria = props.bookingCriteria;
        var pageData = {
          resort: resort,
          price: price,
          bookingCriteria: bookingCriteria
        };

        switch (pageContext.pageType) {
          case OFFER:
            return getOfferTrackingProps(pageProps);

          case DESTINATION:
          case DESTINATION_TOUR:
          case DESTINATION_MICE:
            return getDestinationTrackingProps(pageProps);

          case DESTINATION_TRAVEL:
            return getDestinationTravelTrackingProps(pageProps);

          case RESORT:
          case TOUR:
          case CRUISE:
          case RESORT_MICE:
            return getResortTrackingProps(pageTracking_resolver_objectSpread(pageTracking_resolver_objectSpread({}, pageProps), {}, {
              pageData: pageData
            }));

          case LANDING:
          case LANDING_MICE:
            return getLandingTrackingProps(pageProps, resort);

          case PREBOOKING:
            return getPrebookingTrackingProps(pageProps);

          case HOME:
          case HOMEPAGE:
            return getHomepageTrackingProps(pageProps);

          default:
            return getDefaultTrackingProps(pageProps);
        }
      }
    };
  },
  resolve: function resolve(appContext, props, pageContext, location) {
    var pageType = pageContext.pageType,
        _pageContext$pageMeta = pageContext.pageMeta;
    _pageContext$pageMeta = _pageContext$pageMeta === void 0 ? {} : _pageContext$pageMeta;
    var resortId = _pageContext$pageMeta.resortId;
    var urlParams = location.urlParams,
        queryParams = location.queryParams; // Fetch data for resort, resort_mice, tour and cruise pages only

    if (![RESORT, TOUR, CRUISE, RESORT_MICE, LANDING].includes(pageType) || !resortId) {
      return Promise.resolve({});
    }

    var productArgs = Object(graphql["c" /* buildProductArgs */])(resortId, urlParams);
    var query;

    if (pageType === LANDING) {
      query = "query {\n        resort(".concat(productArgs, ") {\n          id\n          type\n        }\n      }");
    } else {
      var offerName = queryParams.offer ? dist["url"].decodePath(queryParams.offer) : '';
      var productArgsWithOffer = Object(graphql["c" /* buildProductArgs */])(resortId, urlParams, {
        offerName: offerName
      });
      query = "query {\n        resort(".concat(productArgs, ") {\n          id type name comfort seasonName image destination {country area} adultOnly\n        }\n        price(").concat(productArgsWithOffer, ") {\n          termsAndConditions {\n            departureDate departureCity {value name}\n          }\n          bestPrice {value}\n          initialPrice {value}\n        }\n        bookingCriteria(").concat(productArgs, ") {\n          initialDuration(").concat(productArgsWithOffer, ")\n          initialNumberOfAdults(").concat(productArgsWithOffer, ")\n          initialNumberOfChildren\n        }\n      }");
    }

    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["Qb" /* LINE_COMMON_TRACKING */],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "A7XF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryPoiResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var countryPoiResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* COUNTRY_POI */ "h"],
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var countryId = props.countryId,
        isForFamily = props.isForFamily;
    var countryArgs = "countryId:\"".concat(countryId, "\" isForFamily:").concat(isForFamily.toString());
    var query = "query {\n      config {\n        common { close }\n      }\n      countryPoi(".concat(countryArgs, ") {\n        title\n        description\n        media {\n          mediaUrl\n          mediaAlt\n        }\n        associatedProducts {\n          name\n          href\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_COMMON_COUNTRY_POI */ "Db"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "AVUi":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "AaDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productImmersiveResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");





var productImmersiveResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_IMMERSIVE */ "O"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var productId = props.resortId,
        _props$tourDurationPl = props.tourDurationPlaceholder,
        tourDurationPlaceholder = _props$tourDurationPl === void 0 ? '' : _props$tourDurationPl,
        _props$cruiseDatesPla = props.cruiseDatesPlaceholder,
        cruiseDatesPlaceholder = _props$cruiseDatesPla === void 0 ? '' : _props$cruiseDatesPla,
        _props$fromToPlacehol = props.fromToPlaceholder,
        fromToPlaceholder = _props$fromToPlacehol === void 0 ? '' : _props$fromToPlacehol,
        _props$dateFormat = props.dateFormat,
        dateFormat = _props$dateFormat === void 0 ? '' : _props$dateFormat;
    var urlParams = location.urlParams;
    var resortArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
    var cruiseArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildCruiseArgs */ "b"])(urlParams);
    var query = "query {\n      config {\n        common {\n          close\n          galleries {\n            gallery\n            openSlideShowGallery\n            productGallery\n            productPictureItem\n            productNextPicture\n            productPreviousPicture\n          }\n          next\n          photoTitle\n          previous\n          socialPicturesTitle\n          videoTitle\n          video360Title\n        }\n      }\n      cruise(".concat(cruiseArgs, ") {\n        fromToDestination(message: \"").concat(fromToPlaceholder, "\")\n      }\n      media(").concat(resortArgs, ") {\n        photos {url}\n        videos {url thumbnailUrl}\n        videos360 {url thumbnailUrl}\n      }\n      resort(").concat(resortArgs, ") {\n        badgeIcon\n        color\n        comfortLabel\n        dateRange(message: \"").concat(cruiseDatesPlaceholder, "\", dateFormat: \"").concat(dateFormat, "\")\n        destination {\n          country\n          area\n        }\n        duration(message: \"").concat(tourDurationPlaceholder, "\")\n        images\n        isExclusiveCollection\n        isExplicitEC\n        name\n        type\n      }\n      socialPictures(").concat(resortArgs, ") {\n        imageLarge\n        imageSmall\n        userName\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_IMMERSIVE */ "kc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    });
  }
};

/***/ }),

/***/ "AnR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ setPromoCode; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ addAccommodation; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ addTransport; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ proposals_action_addAdditionalService; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ proposals_action_deleteAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ updateAttendees; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ clearProposals; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ fetchProposalsAndRedirect; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ fetchProposalsById; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ proposals_action_fetchSelectedProposalPayment; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ proposals_action_saveCustomerProposalsHandler; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ updateInsurances; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ deleteInsurances; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ setNoInsurances; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ proposals_action_prepareBe; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ displayToastOnContextShare; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ editCriteriaFetchProposals; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ simpleFetchProposals; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ proposals_action_saveDonationToProposals; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ proposals_action_addOrReplaceAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ proposals_action_switchProposalsOffers; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/proposal/proposalQuery.js
var proposalQuery = __webpack_require__("70jX");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/attendees/attendeesQuery.js
var attendeesQuery = __webpack_require__("Bujb");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/utils/graphql-query-helper/booking/insurances/insurancesQuery.js






function updateInsurancesMutation(proposalId, insuranceId, attendees, appContext) {
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    mutation {\n      modifyInsurances (\n      proposalId: \"".concat(proposalId, "\",\n      insuranceId: \"").concat(insuranceId, "\",\n      attendees:   ").concat(Object(graphql["d" /* graphqlify */])(attendees), "\n     ) {\n        proposal {\n          id\n          ").concat(Object(proposalQuery["m" /* proposalPriceQuery */])(), "\n          ").concat(Object(proposalQuery["i" /* insurancesQuery */])(), "\n          ").concat(Object(proposalQuery["g" /* getPaymentScheduleRequest */])(appContext), "\n        }\n        errors {\n          errorKey\n          errorValue\n          errorCode\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(Object(lodash["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: requestDictionary["xd" /* PROPOSAL_UPDATE_INSURANCES */]
  });
}

function deleteInsurancesMutation(proposalId, insuranceId, appContext) {
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    mutation {\n      deleteInsurances (\n      proposalId: \"".concat(proposalId, "\",\n      insuranceId: \"").concat(insuranceId, "\",\n     ) {\n        proposal {\n          id\n          ").concat(Object(proposalQuery["m" /* proposalPriceQuery */])(), "\n          ").concat(Object(proposalQuery["i" /* insurancesQuery */])(), "\n          ").concat(Object(proposalQuery["g" /* getPaymentScheduleRequest */])(appContext), "\n        }\n        errors {\n          errorKey\n          errorValue\n          errorCode\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(Object(lodash["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: requestDictionary["md" /* PROPOSAL_DELETE_INSURANCES */]
  });
}


// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/storeHelper.js
var storeHelper = __webpack_require__("Mn1B");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var trip_information_storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.action.js



var _BOOKING_ENGINE_ENTRY;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

























var BOOKING_ENGINE_ENTRY_TRACKING_LABELS = (_BOOKING_ENGINE_ENTRY = {}, Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR, 'calendarPrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE, 'remotePrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].QUICK_SEARCH, 'quickSearch'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].CRUISE_BOOKING, 'cruiseBooking'), _BOOKING_ENGINE_ENTRY);

function setPromoCode(proposalId, params, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["v" /* SET_PROMO_CODE */], {}, {
    optimist: true,
    promise: Object(proposalQuery["k" /* promoCodeProposalMutation */])(_objectSpread({
      proposalId: proposalId
    }, params), appContext)
  });
}

function fetchProposalsById(_ref) {
  var proposalsId = _ref.proposalsId,
      appContext = _ref.appContext,
      shouldRequestPayment = _ref.shouldRequestPayment,
      adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */], {}, {
      optimist: true,
      promise: Object(BookingEngine_query["c" /* proposalsByIdQuery */])({
        proposalsId: proposalsId,
        shouldRequestPayment: shouldRequestPayment,
        adultsAttendeesIds: adultsAttendeesIds,
        kidsAttendeesIds: kidsAttendeesIds,
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
      }, appContext)
    }));
  };
}
/*
  ATTENTION:
  Les valeurs par défaut de departureCity et duration sont mises dans le CMS,
  on ne peut donc pas récupérer les valeurs du store
 */


function fetchProposalsAndRedirect(params, additionalTrackingParams, appContext, location) {
  return function (dispatch, getState) {
    var state = getState();
    var kids = Object(trip_information_storeHelper["c" /* getKids */])(state) || [];
    var adults = Object(trip_information_storeHelper["a" /* getAdults */])(state) || [];
    var nbAdults = Object(trip_information_storeHelper["b" /* getAdultsNumber */])(state) || adults_constants["a" /* DEFAULT_ADULTS_NB */];
    var numberAttendees = nbAdults + kids.length;
    var intArrivalDate = params.newArrivalDate ? params.newArrivalDate : Object(storeHelper["a" /* getArrivalDate */])(state) || Object(apiDate["l" /* timestampToApiDate */])(state.tripCriteria.departureDate);
    var redirectUri = Object(sellerUtils["e" /* getSigninURIWithRedirection */])({
      locale: appContext.locale,
      proposalId: null,
      step: null,
      isCmta: appContext.isCmta
    });
    if (!intArrivalDate) return;
    var arrivalDate = intArrivalDate.toString();

    var proposalParams = _objectSpread(_objectSpread({
      arrivalDate: arrivalDate,
      kids: kids,
      adults: adults,
      numberAttendees: numberAttendees,
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }, Object(sellerUtils["g" /* isSeller */])(appContext) ? {
      salesNetworkId: location.queryParams.cxo_sales_network_id
    } : null), params);

    var payload = {
      globalLoaderLabel: params.globalLoaderLabel,
      bookingEngineEntry: params.bookingEngineEntry
    };
    var promise = Promise.all([Object(proposalQuery["n" /* proposalsQuery */])(proposalParams, appContext), dispatch(Object(cms_actions["c" /* getBookingEngineI18n */])(appContext))]).then(function (_ref2) {
      var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 1),
          response = _ref3[0];

      var proposals = response.proposals;
      var isFetchProposalsFailed = Object(proposalUtils["r" /* hasFetchProposalsFailed */])(proposals);

      if (!isFetchProposalsFailed) {
        setTimeout(function () {
          var bookingUrl = Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals.proposals || [], proposals.resort, undefined, location.queryParams); // $FlowFixMe

          redirectUtils["a" /* default */].redirectTo()(bookingUrl);
        }, 0);
      }

      tracking_api["b" /* setDataLayer */]({
        categoryGA: 'resort',
        actionGA: BOOKING_ENGINE_ENTRY_TRACKING_LABELS[params.bookingEngineEntry],
        labelGA: isFetchProposalsFailed ? 'errorCheckPrices' : 'checkPrices'
      }, appContext);
      return response;
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["j" /* FETCH_PROPOSALS */], payload, {
      optimist: true,
      promise: promise,
      redirect_uri: redirectUri
    }));
  };
}

function editCriteriaFetchProposals(criteria, proposalsLoderLabel, appContext, location) {
  return function (dispatch, getState) {
    var search = criteria.search,
        departure = criteria.departure,
        attendees = criteria.attendees,
        departureCity = criteria.departureCity;
    var payload = {
      globalLoaderLabel: proposalsLoderLabel
    };
    var state = getState();
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */], payload, {
      optimist: true,
      promise: Object(proposalQuery["n" /* proposalsQuery */])(_objectSpread({
        productId: search.value,
        arrivalDate: moment_default()(departure.date).format('YYYYMMDD'),
        duration: departure.duration,
        departureCity: departureCity.value,
        numberAttendees: attendees.adults + attendees.kids.length,
        adults: new Array(attendees.adults).fill({}),
        // $FlowFixMe
        kids: attendees.kids,
        isJoyView: criteria.isJoyView,
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities'),
        adultsAttendeesIds: state.tripInformation.adults.map(function (_ref4) {
          var neolid = _ref4.neolid;
          return neolid;
        }).filter(Boolean),
        kidsAttendeesIds: state.tripInformation.kids.map(function (_ref5) {
          var neolid = _ref5.neolid;
          return neolid;
        }).filter(Boolean)
      }, Object(sellerUtils["g" /* isSeller */])(appContext) ? {
        salesNetworkId: location.queryParams.cxo_sales_network_id
      } : null), appContext)
    }));
  };
}

function simpleFetchProposals(criterias, proposalsLoaderLabel, appContext, location) {
  var productId = criterias.productId,
      arrivalDate = criterias.arrivalDate,
      duration = criterias.duration,
      attendees = criterias.attendees,
      departureCity = criterias.departureCity,
      bookingEngineEntry = criterias.bookingEngineEntry;
  var payload = {
    globalLoaderLabel: proposalsLoaderLabel,
    bookingEngineEntry: bookingEngineEntry
  };
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["j" /* FETCH_PROPOSALS */], payload, {
    optimist: true,
    promise: Object(proposalQuery["n" /* proposalsQuery */])(_objectSpread({
      productId: productId,
      arrivalDate: arrivalDate,
      duration: duration,
      departureCity: departureCity,
      numberAttendees: attendees.adults + attendees.kids.length,
      adults: new Array(attendees.adults).fill({}),
      // $FlowFixMe
      kids: attendees.kids,
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }, Object(sellerUtils["g" /* isSeller */])(appContext) ? {
      salesNetworkId: location.queryParams.cxo_sales_network_id
    } : null), appContext)
  });
}

function addTransport(transportId, proposalsId, isJoyview, appContext, globalLoaderLabel, toastLabel) {
  return function (dispatch) {
    // TODO show a toast if error
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["e" /* ADD_TRANSPORT */], {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel,
      transportId: transportId
    }, {
      optimist: true,
      promise: Object(proposalQuery["c" /* addTransportMutation */])(transportId, proposalsId, isJoyview, appContext)
    }));
  };
}

function displayToastOnContextShare(toastLabel) {
  return {
    type: proposals_constants["i" /* DISPLAY_TOAST_ON_CONTEXT_SHARE */],
    payload: {
      toastLabel: toastLabel
    }
  };
}

function addAccommodation(_ref6) {
  var arrangement = _ref6.arrangement,
      proposalsId = _ref6.proposalsId,
      isJoyview = _ref6.isJoyview,
      appContext = _ref6.appContext,
      globalLoaderLabel = _ref6.globalLoaderLabel,
      toastLabel = _ref6.toastLabel;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["a" /* ADD_ACCOMMODATION */], {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel
    }, {
      optimist: true,
      promise: Object(proposalQuery["a" /* addAccommodationMutation */])(arrangement, proposalsId, isJoyview, appContext)
    }));
  };
}

function updateAttendees(_ref7) {
  var proposalId = _ref7.proposalId,
      attendees = _ref7.attendees,
      appContext = _ref7.appContext;
  return function (dispatch) {
    return Object(attendeesQuery["b" /* updateAttendeesMutation */])({
      proposalId: proposalId,
      attendees: attendees,
      appContext: appContext
    }).then(function (data) {
      // $FlowFixMe it can be modifyAttendeesSellerMultipleFamilies or modifyAttendees
      var payload = Object.values(data)[0];
      var errors = payload.errors;

      if (errors) {
        // We don't do anything specific with the errors, but this will let us display per field errors
        logger["default"].error(errors[0]);
        throw new Error('Unhandled field form error');
      }

      var neolaneId = Object(lodash["get"])(payload, 'proposal.attendees.list[0].customerId');

      var cookieToSet = _objectSpread(_objectSpread({}, tracking_storage_api["a" /* get */](constants["d" /* BE_TRACKING */])), {}, {
        neolaneId: neolaneId,
        BE_customerStatus: payload.customerStatus
      });

      tracking_storage_api["b" /* set */](cookieToSet);
      dispatch(Object(createAction["b" /* default */])(proposals_constants["y" /* UPDATE_ATTENDEES */], payload));
    });
  };
}

function updateInsurances(proposalId, insuranceId, attendees, app) {
  return function (dispatch) {
    return updateInsurancesMutation(proposalId, insuranceId, attendees, app).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["z" /* UPDATE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["n" /* INSURANCE_ADDED */]));
    });
  };
}

function deleteInsurances(proposalId, insuranceId, app) {
  return function (dispatch) {
    return deleteInsurancesMutation(proposalId, insuranceId, app).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["g" /* DELETE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["o" /* INSURANCE_DELETED */]));
    });
  };
}

function setNoInsurances() {
  return function (dispatch) {
    dispatch(Object(createAction["b" /* default */])(proposals_constants["o" /* INSURANCE_DELETED */]));
  };
}

function clearProposals() {
  return Object(createAction["b" /* default */])(proposals_constants["f" /* CLEAR_PROPOSALS */]);
}

var proposals_action_fetchSelectedProposalPayment = function fetchSelectedProposalPayment(selectedProposal, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */], {
    selectedProposalId: selectedProposal.id
  }, {
    optimist: true,
    promise: Object(proposalQuery["f" /* fetchPayment */])(selectedProposal.id, appContext)
  });
};

var proposals_action_saveCustomerProposalsHandler = function saveCustomerProposalsHandler(proposalId, appContext, customerId) {
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["t" /* SAVE_CUSTOMER_PROPOSAL */], {}, {
      optimist: true,
      promise: Object(sellerUtils["j" /* saveCustomerProposal */])(proposalId, appContext, customerId)
    }));
  };
};

var proposals_action_addOrReplaceAdditionalServices = function addOrReplaceAdditionalServices(_ref8) {
  var proposalIds = _ref8.proposalIds,
      services = _ref8.services,
      _ref8$showNotificatio = _ref8.showNotification,
      showNotification = _ref8$showNotificatio === void 0 ? false : _ref8$showNotificatio,
      appContext = _ref8.appContext;
  return function (dispatch, getState) {
    var proposal = Object(booking_selector["k" /* getCurrentProposal */])(getState());
    var servicesIds = Array.isArray(services) ? services.map(function (_ref9) {
      var id = _ref9.id;
      return id;
    }) : services.id;
    var additionalServicesValues = Object.values(proposal.additionalServices);
    var isUpdatingAlreadyReservedService = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref10) {
          var pricingInfo = _ref10.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.isPartiallyRented;
        })
      );
    });
    var newReservedServiceToastLabel = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref11) {
          var pricingInfo = _ref11.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.type === 'RENTAL';
        })
      );
    }) ? 'booking.activities.skiEquipment.newEquipmentSelection' : 'booking.activities.newActivitySelection';
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["A" /* UPDATE_SERVICES */], showNotification ? {
      toastLabel: isUpdatingAlreadyReservedService ? 'booking.activities.activityUpdate' : newReservedServiceToastLabel
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["o" /* putServicesMutation */])(proposalIds, services, appContext)
    }));
  };
};

var proposals_action_deleteAdditionalServices = function deleteAdditionalServices(_ref12) {
  var proposalIds = _ref12.proposalIds,
      serviceIds = _ref12.serviceIds,
      attendeeIds = _ref12.attendeeIds,
      _ref12$showNotificati = _ref12.showNotification,
      showNotification = _ref12$showNotificati === void 0 ? false : _ref12$showNotificati,
      overloadForSpecificProposalIds = _ref12.overloadForSpecificProposalIds,
      appContext = _ref12.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["h" /* DELETE_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["e" /* deleteServicesMutation */])({
        proposalIds: proposalIds,
        serviceIds: serviceIds,
        attendeeIds: attendeeIds,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};

var proposals_action_addAdditionalService = function addAdditionalService(_ref13) {
  var proposalIds = _ref13.proposalIds,
      serviceId = _ref13.serviceId,
      attendeeIds = _ref13.attendeeIds,
      schedules = _ref13.schedules,
      _ref13$showNotificati = _ref13.showNotification,
      showNotification = _ref13$showNotificati === void 0 ? false : _ref13$showNotificati,
      overloadForSpecificProposalIds = _ref13.overloadForSpecificProposalIds,
      appContext = _ref13.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["c" /* ADD_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["b" /* addServiceMutation */])({
        proposalIds: proposalIds,
        serviceId: serviceId,
        attendeeIds: attendeeIds,
        schedules: schedules,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};

var proposals_action_prepareBe = function prepareBe(payload) {
  return Object(createAction["b" /* default */])(proposals_constants["p" /* PREPARE_BE */], payload);
};

var proposals_action_saveDonationToProposals = function saveDonationToProposals(donation) {
  return function (dispatch) {
    dispatch({
      type: proposals_constants["u" /* SAVE_DONATION_TO_PROPOSALS */],
      payload: donation
    });
  };
};

var proposals_action_switchProposalsOffers = function switchProposalsOffers(offers, appContext) {
  return function (dispatch, getState) {
    var state = getState();
    var proposals = Object(booking_selector["A" /* proposalsSelector */])(state); // TODO : remove filter when proposals array in store is fixed and does not include a random object

    var proposalsIds = proposals.map(function (_ref14) {
      var id = _ref14.id;
      return id;
    }).filter(function (id) {
      return !!id;
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["x" /* SWITCH_PROPOSALS_OFFERS */], {}, {
      optimist: true,
      promise: Object(proposalQuery["p" /* switchProposalsOffers */])(proposalsIds, offers, appContext)
    }));
  };
};



/***/ }),

/***/ "AzLH":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "B3yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keywordsSelector; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var searchSelector = function searchSelector(_ref) {
  var search = _ref.search;
  return search || {};
};

var querySelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(searchSelector, function (_ref2) {
  var query = _ref2.query;
  return query || {};
});
var keywordsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(querySelector, function (_ref3) {
  var keywords = _ref3.keywords;
  return keywords;
});


/***/ }),

/***/ "BFzD":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dynamicPage",
      function () {
        return __webpack_require__("ENTv");
      }
    ]);
  

/***/ }),

/***/ "BGmY":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("3QVS");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "BKF0":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("jP+d");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "BRr/":
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__("ZLJe")),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__("8PLQ")),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),

/***/ "BXQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return titleAndTextResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var titleAndTextResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* TITLE_AND_TEXT */ "Fb"],
  resolve: function resolve() {
    var appContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var query = "query {\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_COMMON_I18N */ "c"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "BhBy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlternativeProposalsModal; });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sRdV");
/* harmony import */ var _alternative_proposals_AlternativeProposals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("YRNe");
/* harmony import */ var _frameworks_side_panel_SidePanel_jsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("p7XS");
/* harmony import */ var _alternative_proposals_AlternativeProposalsUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("/nu6");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ub5k");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;







function AlternativeProposalsModal(_ref) {
  var trackingDefaultPayload = _ref.trackingDefaultPayload,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, ["trackingDefaultPayload"]);

  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"]);
  var modal = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])();
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__[/* useTracking */ "a"])(trackingDefaultPayload);
  var proposal = props.proposals[0];
  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    var trackingData = Object(_alternative_proposals_AlternativeProposalsUtils__WEBPACK_IMPORTED_MODULE_6__[/* getSuggestionsTrackingData */ "b"])({
      proposal: proposal,
      suggestions: props.suggestions,
      appContext: appContext,
      disableAlternativePrice: props.disableAlternativePrice
    });
    track(trackingData);
  }, [proposal]);
  return __jsx(_frameworks_side_panel_SidePanel_jsx__WEBPACK_IMPORTED_MODULE_5__[/* SidePanel */ "a"], {
    ariaLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('booking.counterProposalPopIn.rateCounterProposalTitle'),
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "f"])('common.close'),
    isExpanded: true,
    onClose: function onClose(event) {
      if (modal.current && !modal.current.contains(event.target)) {
        props.onClose();
        track({
          labelGA: 'exit'
        });
      }
    }
  }, __jsx("div", {
    ref: modal
  }, __jsx(_alternative_proposals_AlternativeProposals__WEBPACK_IMPORTED_MODULE_4__[/* AlternativeProposals */ "a"], props)));
}

/***/ }),

/***/ "Bio+":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("j++8");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "BlK1":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("ojcf"),
    getSymbolsIn = __webpack_require__("UR9l");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ "BthO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productMustTryExperiencesResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");





var productMustTryExperiencesResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* MUST_TRY_EXPERIENCES */ "x"],
  props: function props(appContext) {
    return {
      isFrench: appContext.locale.startsWith('fr')
    };
  },
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      config {\n        common { next previous scrollBackward scrollForward }\n      }\n      mustTryExperiences(".concat(productArgs, ") {\n        description\n        id\n        image\n        title\n      }\n      resort(resortId: \"").concat(productId, "\") {\n        color\n        icon\n        name\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_MUST_TRY_EXPERIENCES */ "qc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    })["catch"](function () {
      return {
        mustTryExperiences: []
      };
    });
  }
};

/***/ }),

/***/ "Bujb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateAttendeesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queryBookingAttendees; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NLwV");
/* harmony import */ var _proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("70jX");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ldK3");
/* harmony import */ var _seller_sellerUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KL6I");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var ATTENDEE_SCHEMA_PROPERTIES = ['id', 'gmNumber', 'lastName', 'firstName', 'unicodeLastName', 'unicodeFirstName', 'birthdate', 'email', 'mobile', 'optinSms', 'optinMail', 'optinFosun', 'optinEmail', 'optinPhone', 'optinClubmedPlus', 'civility', 'identityNumber', 'passport', 'customerId', 'address', 'mainContactId', 'isChild'];
/**
 * Remove all properties that don't match GQL Schema Otherwise the mutation fails
 */

var removeUselessProperties = function removeUselessProperties(attendee) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["pick"])(attendee, ATTENDEE_SCHEMA_PROPERTIES);
};
/**
 * Connected customer experience : Put attendees
 */


function updateAttendeesMutation(_ref) {
  var proposalId = _ref.proposalId,
      attendees = _ref.attendees,
      appContext = _ref.appContext;
  var formatedAttendees = attendees.map(function (attendee) {
    return removeUselessProperties(_objectSpread(_objectSpread({}, attendee), {}, {
      customerId: attendee.neolid,
      birthdate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_6__[/* timestampToApiDate */ "l"])(attendee.birthdate),
      passport: !Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(attendee.passport) ? _objectSpread(_objectSpread({}, attendee.passport), {}, {
        expirationDate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_6__[/* timestampToApiDate */ "l"])(attendee.passport.expirationDate),
        issuingDate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_6__[/* timestampToApiDate */ "l"])(attendee.passport.issuingDate)
      }) : undefined
    }));
  });
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      ".concat(Object(_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_7__[/* isSellerAndInMultiplesFamiliesContext */ "h"])(appContext, attendees) ? 'modifyAttendeesSellerMultipleFamilies' : 'modifyAttendees', " (\n      proposalId: \"").concat(proposalId, "\",\n      attendees: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_3__[/* graphqlify */ "d"])(formatedAttendees), "\n     ) {\n        proposal {\n          id\n          attendees {\n            list {\n              id\n              customerId\n            }\n          }\n          ").concat(Object(_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_4__[/* proposalPriceQuery */ "m"])(), "\n          ").concat(Object(_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_4__[/* getPaymentScheduleRequest */ "g"])(appContext), "\n        }\n        ").concat(appContext.isDirectCxo || appContext.isIndirectCxo ? '' : 'customerStatus', "\n        errors {\n          errorKey\n          errorValue\n          errorCode\n        }\n        ").concat(appContext.isDirectCxo || appContext.isIndirectCxo ? "attendees {\n                id\n                gmNumber\n                customerId\n              }" : '', "\n      }\n    }\n    ").concat(Object(_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_4__[/* getPriceDetailFragment */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* PROPOSAL_UPDATE_ATTENDEES */ "wd"]
  });
}

var queryBookingAttendees = function queryBookingAttendees(bookingId) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery("query {\n    bookingAttendees(bookingId: ".concat(bookingId, ") {\n      civility\n      gmNumber\n      customerId\n      identityNumber\n      mainContact\n      lastName\n      unicodeLastName\n      firstName\n      unicodeFirstName\n      email\n      birthdate\n    }\n  }"));
};



/***/ }),

/***/ "C2l2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productInformationSummaryResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productInformationSummaryResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_INFORMATION_SUMMARY */ "P"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var productId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {resort(".concat(productArgs, ") {factSheetUrl}}");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_INFORMATION_SUMMARY */ "lc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "C5R2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDuration; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _duration_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("RBvG");


function setDuration(value) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_duration_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DURATION */ "c"], {
    value: value
  });
}

/***/ }),

/***/ "C8zB":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("j++8");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "CATK":
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__("YXT+"),
    isObjectLike = __webpack_require__("oS78");

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ "CGZ2":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("j++8");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "CP21":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("jP+d");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "Cgsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ createPropsForProduct; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TripOverview; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/ple-utils/bookingUtils.js
var bookingUtils = __webpack_require__("vakO");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 6 modules
var Product = __webpack_require__("XTOr");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: ./src/client/components/widgets/booking-payment-status/BookingPaymentStatus.jsx
var BookingPaymentStatus = __webpack_require__("FpW3");

// EXTERNAL MODULE: ./src/client/components/widgets/travel-details/TravelDetails.jsx + 4 modules
var TravelDetails = __webpack_require__("zgAg");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-summary/empty-trip-overview/EmptyTripOverview.jsx
var __jsx = react["createElement"];




function EmptyTripOverview(props) {
  var className = props.className,
      text = props.text,
      link = props.link,
      linkLabel = props.linkLabel;
  return text ? __jsx("div", {
    className: classnames_default()('TripOverview', 'flex flex-col justify-center items-center p-4 text-center border-1 border-dotted rounded', className)
  }, __jsx(Text["a" /* Text */], {
    text: text
  }), link ? __jsx(Button["a" /* Button */], {
    className: "w-full mt-4",
    url: link
  }, linkLabel) : null) : null;
}
// EXTERNAL MODULE: ./src/client/components/widgets/trip-summary/TripSummary.tracking.js
var TripSummary_tracking = __webpack_require__("2ejy");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-summary/trip-overview/TripOverview.jsx

var TripOverview_jsx = react["createElement"];

/* eslint-disable flowtype/no-weak-types,no-duplicate-imports */













function createPropsForPictures(images) {
  if (!Array.isArray(images)) {
    return [];
  }

  return images.map(function (link) {
    return {
      src: link
    };
  });
}

function createPropsForProduct(resort, tracking, appContext) {
  return {
    id: resort.id,
    header: {
      className: 'border-r-1',
      badgeIcon: Object(product_utils["d" /* getProductBadgeIcon */])(resort),
      hasECLogo: resort.isExplicitEC,
      heading: {
        subtitle: Object(lodash["get"])(resort, 'destination.country'),
        title: resort.name || ''
      },
      link: {
        url: resort.href,
        onClick: function onClick() {
          return Object(TripSummary_tracking["a" /* track */])(tracking, appContext);
        }
      },
      productId: resort.id,
      productType: resort.type
    },
    thumbnail: {
      link: {
        url: resort.href
      },
      pictures: createPropsForPictures(resort.images),
      productId: resort.id,
      productType: resort.type
    },
    url: resort.href,
    type: resort.type || ''
  };
}
function TripOverview(_ref) {
  var className = _ref.className,
      i18n = _ref.i18n,
      stay = _ref.stay,
      emptyTripOverview = _ref.emptyTripOverview,
      children = _ref.children,
      _ref$trackingData = _ref.trackingData,
      trackingData = _ref$trackingData === void 0 ? {} : _ref$trackingData;
  var appContext = react["useContext"](ReactAppContext["a" /* default */]);

  if (Object(lodash["isEmpty"])(stay)) {
    return TripOverview_jsx(EmptyTripOverview, {
      className: className,
      text: emptyTripOverview.text,
      link: emptyTripOverview.link,
      linkLabel: emptyTripOverview.linkLabel
    });
  }

  if (!stay.resort) return null;
  return TripOverview_jsx("div", {
    className: classnames_default()('TripOverview', 'flex flex-col justify-between border-1', className)
  }, TripOverview_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({}, createPropsForProduct(stay.resort, trackingData.destinationLink, appContext), {
    className: "-m-px"
  })), TripOverview_jsx("div", {
    className: "flex flex-col justify-between flex-grow p-4"
  }, !bookingUtils["a" /* default */].isPastTrip(stay.returnDate) ? TripOverview_jsx(BookingPaymentStatus["a" /* default */], {
    className: "w-full",
    dataSelector: "TripOverview-BookingPaymentStatus",
    isBookingPaid: stay.isPaid,
    shouldProposeOnlinePayment: stay.shouldProposeOnlinePayment,
    status: stay.bookingStatus,
    bookingPaidLabel: Object(lodash["get"])(i18n, 'memberSpace.trips.price.stayPaidLabel'),
    bookingStatusLink: {
      label: Object(lodash["get"])(i18n, 'memberSpace.trips.completePaymentLabel'),
      url: "".concat(routeBuilder["a" /* buildUrl */]('bookings', {
        bookingId: stay.bookingId,
        stayId: stay.id
      }), "#price-and-payment")
    }
  }) : null, TripOverview_jsx(TravelDetails["a" /* default */], {
    className: "w-full mt-4",
    config: i18n,
    bookingStatus: stay.bookingStatus,
    stay: stay,
    isVertical: true
  }), children));
}

/***/ }),

/***/ "DWlz":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("HUtr"),
    baseKeys = __webpack_require__("e/g/"),
    isArrayLike = __webpack_require__("gvfs");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "ELg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductFlag_ProductFlag; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 10 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx + 4 modules
var ProductPriceModal = __webpack_require__("yfdt");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.themes.js
var themes = {
  thumbnail: {
    thPriceFrom: 'font-sans text-sm sm:text-base text-gray-darker px-1',
    thPriceTheme: 'thumbnail'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx

var __jsx = react_default.a.createElement;






var ProductFlag_ProductFlag = function ProductFlag(_ref) {
  var _ref$isLinkDisabled = _ref.isLinkDisabled,
      isLinkDisabled = _ref$isLinkDisabled === void 0 ? false : _ref$isLinkDisabled,
      _ref$isPriceLoading = _ref.isPriceLoading,
      isPriceLoading = _ref$isPriceLoading === void 0 ? false : _ref$isPriceLoading,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? lodash["noop"] : _ref$onClick,
      _ref$onCtaClick = _ref.onCtaClick,
      onCtaClick = _ref$onCtaClick === void 0 ? lodash["noop"] : _ref$onCtaClick,
      _ref$onEmptyPriceClic = _ref.onEmptyPriceClick,
      onEmptyPriceClick = _ref$onEmptyPriceClic === void 0 ? lodash["noop"] : _ref$onEmptyPriceClic,
      _ref$onPriceClick = _ref.onPriceClick,
      onPriceClick = _ref$onPriceClick === void 0 ? lodash["noop"] : _ref$onPriceClick,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? {} : _ref$price,
      _ref$priceInfo = _ref.priceInfo,
      priceInfo = _ref$priceInfo === void 0 ? {} : _ref$priceInfo,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'thumbnail' : _ref$theme;

  if (Object(lodash["isEmpty"])(price)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thPriceFrom = _themes$theme.thPriceFrom,
      thPriceTheme = _themes$theme.thPriceTheme;
  var hasPrice = !isPriceLoading && (!!price.initialPrice || !!price.bestPrice);

  var handleEmptyPriceClick = function handleEmptyPriceClick() {
    onEmptyPriceClick && onEmptyPriceClick();

    if (!isLinkDisabled) {
      onClick && onClick();
    }
  };

  var handlePriceClick = function handlePriceClick() {
    onPriceClick && onPriceClick();
  };

  var handleProductPriceModalOnClickButton = function handleProductPriceModalOnClickButton() {
    onCtaClick && onCtaClick();
    onClick && onClick();
  };

  var priceNode = __jsx("span", {
    className: "flex items-center justify-end w-full"
  }, Object(price_util["d" /* hasAtLeastOnePrice */])(price) && __jsx("span", {
    className: thPriceFrom
  }, price.from), __jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({}, price, {
    className: "flex items-center h-full rounded-tiny",
    "data-testid": "ProductFlag-price",
    from: null,
    isLoading: isPriceLoading,
    onClick: hasPrice ? handlePriceClick : handleEmptyPriceClick,
    theme: thPriceTheme
  })));

  return hasPrice ? __jsx(ProductPriceModal["a" /* ProductPriceModal */], Object(esm_extends["a" /* default */])({
    className: "m-1 z-2"
  }, priceInfo, {
    onClickButton: handleProductPriceModalOnClickButton
  }), priceNode) : priceNode;
};

/***/ }),

/***/ "ENTv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lz-string/libs/lz-string.js
var lz_string = __webpack_require__("O2W8");
var lz_string_default = /*#__PURE__*/__webpack_require__.n(lz_string);

// EXTERNAL MODULE: /home/circleci/project/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: /home/circleci/project/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./src/client/components/third-party/BaiduSeoScript.jsx + 2 modules
var BaiduSeoScript = __webpack_require__("XL2j");

// EXTERNAL MODULE: ./src/client/components/frameworks/line/Line.jsx + 369 modules
var Line = __webpack_require__("ybtA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var pageContext = __webpack_require__("RPju");

// CONCATENATED MODULE: ./src/client/views/dynamic-page/DynamicPage.jsx
var __jsx = react["createElement"];










function getClientSideInitialProps(_ref) {
  var appContext = _ref.appContext,
      location = _ref.location;
  var params = {
    location: lz_string_default.a.compressToEncodedURIComponent(JSON.stringify(location)),
    commonContent: appContext.cmsContent,
    commonRelease: appContext.cmsRelease,
    pagesContent: appContext.pagesContent,
    pagesRelease: appContext.pagesRelease
  }; // don't add the locale is not needed since it would be redirected without it

  if (location.queryParams.locale) {
    params.locale = appContext.locale;
  }

  var requestOptions = {
    url: new URI_default.a(location.origin).query('').pathname('/api/dynamic-page').toString(),
    method: 'GET',
    params: params,
    headers: {
      accept: 'application/json'
    }
  };
  return Object(axios["request"])(requestOptions).then(function (response) {
    return response.data;
  }).catch(function (err) {
    return Promise.resolve(err.response.data);
  });
}

function createDynamicPage() {
  var DynamicPage = function DynamicPage(_ref2) {
    var page = _ref2.page;

    var _React$useContext = react["useContext"](ReactAppContext["a" /* default */]),
        userAgent = _React$useContext.userAgent,
        originalUrl = _React$useContext.originalUrl,
        locale = _React$useContext.locale;

    var _React$useContext2 = react["useContext"](pageContext["a" /* ReactPageContext */]),
        pageTitle = _React$useContext2.pageTitle,
        pageType = _React$useContext2.pageType,
        pageDescription = _React$useContext2.pageDescription;

    return __jsx(react["Fragment"], null, __jsx(head_default.a, null, __jsx(BaiduSeoScript["a" /* BaiduSeoScript */], {
      lines: page.lines,
      locale: locale,
      userAgent: userAgent,
      originalUrl: originalUrl,
      pageTitle: pageTitle,
      pageType: pageType,
      pageDescription: pageDescription
    })), __jsx("main", {
      role: "main"
    }, __jsx(Line["a" /* Line */], {
      props: {
        lines: page.lines
      }
    })));
  }; // Avoid to inject server side code into client chunks


  if (true) {
    DynamicPage.getInitialProps = getClientSideInitialProps;
  } else {}

  return DynamicPage;
}
var DynamicPage_DynamicPage = createDynamicPage();
// CONCATENATED MODULE: ./pages/dynamicPage.js

/* harmony default export */ var dynamicPage = __webpack_exports__["default"] = (DynamicPage_DynamicPage);

/***/ }),

/***/ "EVz8":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("jP+d"),
    stubFalse = __webpack_require__("Khoy");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "Ey+l":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("Q7Yi"),
    isPrototype = __webpack_require__("RVBP"),
    nativeKeysIn = __webpack_require__("66Hx");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ "EzIG":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dZwK");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "FHsl":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("t8ah"),
    isArrayLike = __webpack_require__("gvfs"),
    isIndex = __webpack_require__("hIZU"),
    isObject = __webpack_require__("Q7Yi");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "FQR9":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("HUtr"),
    baseKeysIn = __webpack_require__("Ey+l"),
    isArrayLike = __webpack_require__("gvfs");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ "Fe0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return grid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateProductLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateCmtaLinkProp; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("igjW");



var grid = {
  mobile: 1,
  phablet: 2,
  tablet: 3,
  desktop: 3
};
var generateProductLink = function generateProductLink(url, offer) {
  var newLink = offer && offer.seoName ? new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(url).addSearch(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["appQueryParameters"].shopping.offer, _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["url"].normalizeSlug(offer.seoName)).toString() : url;
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["url"].normalizeUrl(newLink);
};
var generateLinkProp = function generateLinkProp(url, offer) {
  return url ? {
    url: generateProductLink(url, offer),
    queryParamsToIgnore: offer ? [] : ['offer']
  } : undefined;
};

var formatResortName = function formatResortName(resortName) {
  if (resortName.match(/.*winter$/) || resortName.match(/.*summer$/)) {
    return resortName;
  }

  return "".concat(resortName, "-2");
};

var generateCmtaLinkProp = function generateCmtaLinkProp(url, originalUrl) {
  var resortName = '';
  var domain = 'clubmed.com';
  var subDomain = 'travelagents';
  var resortMatch = url && url.match(/\/r\/(.*)\//);

  if (resortMatch) {
    resortName = resortMatch[1];
  }

  var domainMatcher = originalUrl && originalUrl.match(/(clubmed\.[\.\w]+)\//);

  if (domainMatcher) {
    domain = domainMatcher[1];
  }

  var cmtaUrl = "https://".concat(subDomain, ".").concat(domain);

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__[/* isStrictlyIntegrationEnv */ "e"])()) {
    cmtaUrl = "https://".concat(subDomain, ".integ.").concat(domain);
  }

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_2__[/* isStrictlyStagingEnv */ "g"])()) {
    cmtaUrl = "https://".concat(subDomain, ".staging.").concat(domain);
  }

  var cmtaFullUrl = new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(cmtaUrl).path("/resort/".concat(formatResortName(resortName), "/"));
  return {
    url: cmtaFullUrl.toString(),
    isExternalLink: true
  };
};

/***/ }),

/***/ "Fmrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Confirmation; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("jD8k");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;









var getDefaultIcon = function getDefaultIcon(status) {
  return status === 'success' ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CONFIRMATION : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].WARNING;
};

var Confirmation = function Confirmation(_ref) {
  var _ref$button = _ref.button,
      button = _ref$button === void 0 ? {} : _ref$button,
      className = _ref.className,
      icon = _ref.icon,
      link = _ref.link,
      status = _ref.status,
      text = _ref.text,
      title = _ref.title;

  if (!status || !title) {
    return null;
  }

  var colors = {
    error: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].RED,
    neutral: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLUE,
    success: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].EMERALD
  };
  var iconName = icon ? icon : getDefaultIcon(status);
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'flex items-start sm:items-center sm:px-5 py-5'),
    "data-testid": "Confirmation"
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('leading-none rtl:mr-5 text-sm sm:text-xl', "text-".concat(colors[status]))
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    name: iconName,
    width: "4em"
  })), __jsx("div", {
    className: "flex-auto"
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('font-bold text-md sm:text-xl', "text-".concat(colors[status]))
  }, title), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_7__[/* Text */ "a"], {
    text: text
  }), __jsx("div", {
    className: "flex flex-col-reverse\tsm:flex-row sm:items-start"
  }, __jsx(_frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_8__[/* TextLink */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, link, {
    className: "mt-px10 sm:rtl:mr-auto"
  })), button && button.children && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, button, {
    className: "my-px10"
  }), button.children))));
};

/***/ }),

/***/ "G8Os":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ "GJxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "listen", function() { return /* binding */ index_es_listen; });
__webpack_require__.d(__webpack_exports__, "subscribe", function() { return /* binding */ index_es_subscribe; });
__webpack_require__.d(__webpack_exports__, "unsubscribe", function() { return /* binding */ index_es_unsubscribe; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/subscribe-ui-event/node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("KiAj");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: /home/circleci/project/node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("Gpi5");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/lib/supportPassiveEvent.js
/* global window */

var passiveSupported = false; // eslint-disable-line import/no-mutable-exports

if (typeof window !== 'undefined') {
  try {
    var supportPassiveEvent_options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', null, supportPassiveEvent_options);
  } catch (err) {} // eslint-disable-line no-empty
}

/* harmony default export */ var supportPassiveEvent = (passiveSupported);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/globalVars.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




/* harmony default export */ var globalVars = ({
  connections: {},
  EE: new eventemitter3_default.a(),
  enableResizeInfo: false,
  enableScrollInfo: false,
  listeners: {},
  removers: [],
  supportPassiveEvent: supportPassiveEvent
});

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/lib/listen.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




var listen_supportPassiveEvent = globalVars.supportPassiveEvent;


var defaultEventOption = {
  capture: false,
  passive: false
};

/**
 * Cross-browser addEventListener.
 * @method listen
 * @param {Object} target - The target to add event listener.
 * @param {String} eventType - The event type.
 * @param {Function} handler - The event handler.
 * @param {Object} handler - The options object that specifies
 * characteristics about the event listener.
 * @return {Object} The object to be able to remove the handler.
 */
function listen(target, eventType, handler, options) {
  var add = 'addEventListener';
  var _remove = 'removeEventListener';
  var type = eventType;

  var eventOptions = listen_supportPassiveEvent ? assign_default()({}, defaultEventOption, options) : false;

  if (!target.addEventListener && target.attachEvent) {
    add = 'attachEvent';
    _remove = 'detachEvent';
    type = 'on' + eventType;
  }
  target[add](type, handler, eventOptions);

  return {
    remove: function remove() {
      target[_remove](eventType, handler);
    }
  };
}

/* harmony default export */ var lib_listen = (listen);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/lib/leIE8.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global navigator, parseFloat */

// less then or equal to IE8
var leIE8 = false; // eslint-disable-line import/no-mutable-exports

if (typeof navigator !== 'undefined') {
  var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
  if (matches) {
    leIE8 = parseFloat(matches[1], 10) < 9;
  }
}

/* harmony default export */ var lib_leIE8 = (leIE8);

// EXTERNAL MODULE: /home/circleci/project/node_modules/subscribe-ui-event/node_modules/lodash/clone.js
var clone = __webpack_require__("Zq1u");
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);

// EXTERNAL MODULE: /home/circleci/project/node_modules/subscribe-ui-event/node_modules/lodash/throttle.js
var lodash_throttle = __webpack_require__("olhj");
var throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// EXTERNAL MODULE: /home/circleci/project/node_modules/subscribe-ui-event/node_modules/lodash/noop.js
var noop = __webpack_require__("VNuc");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/AugmentedEvent.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var resize = { // eslint-disable-line prefer-const
  width: 0,
  height: 0
};
var AugmentedEvent_scroll = { // eslint-disable-line prefer-const
  delta: 0,
  top: 0
};
var touch = { // eslint-disable-line prefer-const
  axisIntention: '',
  startX: 0,
  startY: 0,
  deltaX: 0,
  deltaY: 0
};

var INTENTION_THRESHOLD = 5;

var getXY = function getXY(pos) {
  var t = { x: 0, y: 0 }; // eslint-disable-line prefer-const
  var docBody = document.body;
  var docEl = document.documentElement;

  if (pos.pageX || pos.pageY) {
    t.x = pos.pageX;
    t.y = pos.pageY;
  } else {
    t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
    t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
  }

  return t;
};

/**
 * ArgmentedEvent will hold some global information, such like window scroll postion,
 * so that those information is only calculated once.
 * @param {Object} option - The option for SyntheticEvent
 */

var AugmentedEvent_AugmentedEvent = function () {
  function AugmentedEvent() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AugmentedEvent);

    var mainType = (option.mainType || '').toLowerCase();
    var subType = (option.subType || '').toLowerCase();

    this.mainType = mainType;
    this.subType = subType;
    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
    this.scroll = AugmentedEvent_scroll;
    this.resize = resize;
    this.touch = touch;
  }

  _createClass(AugmentedEvent, [{
    key: 'update',
    value: function update(e) {
      var mainType = this.mainType,
          subType = this.subType;

      var docEl = document.documentElement;

      if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
        var top = docEl.scrollTop + document.body.scrollTop;
        // Prevent delta from being 0
        if (top !== this.scroll.top) {
          this.scroll.delta = top - this.scroll.top;
          this.scroll.top = top;
        }
      }
      if (globalVars.enableResizeInfo && mainType === 'resize') {
        this.resize.width = window.innerWidth || docEl.clientWidth;
        this.resize.height = window.innerHeight || docEl.clientHeight;
      }
      if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
        var pos = void 0;
        var absX = void 0;
        var absY = void 0;
        if (mainType === 'touchstart' || subType === 'start') {
          pos = getXY(e.touches[0]);
          this.touch.axisIntention = '';
          this.touch.startX = pos.x;
          this.touch.startY = pos.y;
          this.touch.deltaX = 0;
          this.touch.deltaY = 0;
        } else if (mainType === 'touchmove') {
          pos = getXY(e.touches[0]);
          this.touch.deltaX = pos.x - this.touch.startX;
          this.touch.deltaY = pos.y - this.touch.startY;
          if (this.touch.axisIntention === '') {
            absX = Math.abs(this.touch.deltaX);
            absY = Math.abs(this.touch.deltaY);
            if (absX > INTENTION_THRESHOLD && absX >= absY) {
              this.touch.axisIntention = 'x';
            } else if (absY > INTENTION_THRESHOLD && absY > absX) {
              this.touch.axisIntention = 'y';
            }
          }
        }
      }
    }
  }]);

  return AugmentedEvent;
}();

/* harmony default export */ var dist_es_AugmentedEvent = (AugmentedEvent_AugmentedEvent);

// EXTERNAL MODULE: /home/circleci/project/node_modules/raf/index.js
var raf = __webpack_require__("0xii");
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/lib/rAFThrottle.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var getTime = Date.now ||
/* istanbul ignore next */function () {
  return new Date().getTime();
};

function rAFThrottle(func) {
  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

  var context = void 0;
  var args = void 0;
  var last = 0;
  var requestId = 0;

  var later = function later() {
    var now = getTime();
    var remaining = throttle - (now - last);

    if (remaining <= 0) {
      last = now;
      requestId = 0;
      func.apply(context, args);
    } else {
      requestId = raf_default()(later);
    }
  };

  return function throttledFunc() {
    context = this;
    args = arguments; // eslint-disable-line prefer-rest-params

    if (!requestId) {
      requestId = raf_default()(later);
    }
  };
}

/* harmony default export */ var lib_rAFThrottle = (rAFThrottle);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/constants.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var EVENT_END_DELAY = 100;
var DEFAULT_THROTTLE_RATE = 50;

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/mainEventConnectors.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document, setTimeout */











// constants


var connections = globalVars.connections,
    EE = globalVars.EE,
    listeners = globalVars.listeners,
    removers = globalVars.removers;

// global variables

var doc = void 0;
var win = void 0;
var body = void 0;
var hashId = 0;

if (typeof window !== 'undefined') {
  win = window;
  doc = win.document || document;
  body = doc.body;
}

function getHash(domNode) {
  return domNode.id || 'target-id-' + hashId++; // eslint-disable-line
}

/**
 * Connect a throttled event to a throttled main event, and return an event remover.
 * The number of connections to a throttled main event will be kept. If all throttled events
 * are removed, then remove throttled main event.
 * @method connectThrottle
 * @param {String} throttledEvent - A throttled event
 * @param {Function} cb - Callback function
 * @param {Object} ctx - The "this"
 * @param {String} throttledMainEvent - A throttled main event
 * @return {Object} An event remover
 */
function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
  EE.on(throttledEvent, cb || noop_default.a, ctx);
  throttledMainEvent = throttledMainEvent || throttledEvent;
  connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
  return {
    _type: throttledEvent,
    _cb: cb,
    _ctx: ctx,
    unsubscribe: function unsubscribe() {
      if (!this._type) {
        return;
      }

      EE.removeListener(throttledEvent, cb, ctx);
      connections[throttledMainEvent]--;
      if (connections[throttledMainEvent] === 0) {
        listeners[throttledMainEvent].remove();
        listeners[throttledMainEvent] = undefined;
      }

      this._type = undefined;
      this._cb = undefined;
      this._ctx = undefined;

      // remove the remover from removers array
      for (var i = removers.length - 1; i >= 0; i--) {
        var remover = removers[i];
        if (remover === this) {
          removers.splice(i, 1);
          break;
        }
      }
    }
  };
}

/**
 * Connect to event, event start and event end.
 * @method connectContinuousEvent
 * @param {Object} target - The target of a main event, window or document.
 * @param {String} mainEvent - A browser event, like scroll or resize.
 * @param {String} event - A subscribe event.
 * @param {Object} eventOptions - An options pass to event listener
 */
function connectContinuousEvent(target, mainEvent, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);
    var targetPart = domId ? ':' + domId : '';

    var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
    var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
    var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
    var throttledEvent = event + ':' + throttleRate + targetPart;

    var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
    removers.push(remover);

    if (listeners[throttledMainEvent]) {
      return remover;
    }

    var ae = {
      start: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'start' }), // start
      main: new dist_es_AugmentedEvent({ mainType: mainEvent }), // main
      end: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'end' })
    };

    // No throttle for throttleRate = 0
    // end
    if (throttleRate === 'raf') {
      throttleRate = 16; // Set as a number for setTimeout later.
      handler = lib_rAFThrottle(handler);
    } else if (throttleRate > 0) {
      handler = throttle_default()(handler, throttleRate);
    }

    var timer = void 0;
    function endCallback(e) {
      ae.end.update(e);
      EE.emit(throttledEndEvent, e, ae.end);
      timer = null;
    }
    function handler(e) {
      if (!timer) {
        ae.start.update(e);
        EE.emit(throttledStartEvent, e, ae.start);
      }
      clearTimeout(timer);

      ae.main.update(e);
      EE.emit(throttledMainEvent, e, ae.main);
      if (!lib_leIE8) {
        timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
      } else {
        // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
        timer = setTimeout(function () {
          endCallback(clone_default()(e));
        }, throttleRate + EVENT_END_DELAY);
      }
    }

    listeners[throttledMainEvent] = lib_listen(domTarget || target, mainEvent, handler, eventOptions);
    return remover;
  };
}

function connectDiscreteEvent(target, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);

    // no throttling for discrete event
    var throttledEvent = event + ':0' + (domId ? ':' + domId : '');

    var remover = connectThrottle(throttledEvent, cb, context);
    removers.push(remover);

    if (listeners[throttledEvent]) {
      return remover;
    }

    var ae = new dist_es_AugmentedEvent({ mainType: event });

    function handler(e) {
      ae.update(e);
      EE.emit(throttledEvent, e, ae);
    }

    listeners[throttledEvent] = lib_listen(domTarget || target, event, handler, eventOptions);
    return remover;
  };
}

/* harmony default export */ var mainEventConnectors = ({
  scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
  scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
  scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
  resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
  resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
  resize: connectContinuousEvent(win, 'resize', 'resize'),
  visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
  touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
  touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
  touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
  touchstart: connectDiscreteEvent(body, 'touchstart'),
  touchend: connectDiscreteEvent(body, 'touchend')
});

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/subscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


 // less then or equal to IE8


// constants


/**
 * Subscribe to UI events.
 * @method subscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 * @param {Object} options.context - The caller.
 * @param {Number} options.throttleRate - The amount of time for throttling.
 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
 * @param {Object} options.eventOptions - Option to pass to event listener
 * @return {Object} The object with unsubscribe function.
 */
function subscribe(type, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var useRAF = options.useRAF || false;
  var throttleRate = parseInt(options.throttleRate, 10);
  var eventOptions = options.eventOptions;

  if (isNaN(throttleRate)) {
    throttleRate = DEFAULT_THROTTLE_RATE;
  }

  if (useRAF) {
    throttleRate = 'raf';
  }

  // turn off throttle if the browser is IE8 or less, because window.event will be reset
  // when using any delayed function, i.g., setTimeout, or rAF.
  if (lib_leIE8) {
    throttleRate = 0;
  }

  // once those variables enabled, then never disabled.
  globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
  globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
  globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;

  return mainEventConnectors[type](throttleRate, cb, options, eventOptions);
}

/* harmony default export */ var dist_es_subscribe = (subscribe);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/dist-es/unsubscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var unsubscribe_removers = globalVars.removers;

/**
 * Unsubscribe to UI events.
 * @method unsubscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 */

function unsubscribe(type, cb) {
  var remover = void 0;
  for (var i = unsubscribe_removers.length - 1; i >= 0; i -= 1) {
    remover = unsubscribe_removers[i];
    if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
      remover.unsubscribe();
      unsubscribe_removers.splice(i, 1);
    }
  }
}

/* harmony default export */ var dist_es_unsubscribe = (unsubscribe);

// CONCATENATED MODULE: /home/circleci/project/node_modules/subscribe-ui-event/index.es.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */





var IS_CLIENT = typeof window !== 'undefined';

function warn() {
  if (false) {}
}

var index_es_listen = IS_CLIENT ? lib_listen : warn;
var index_es_subscribe = IS_CLIENT ? dist_es_subscribe : warn;
var index_es_unsubscribe = IS_CLIENT ? dist_es_unsubscribe : warn;


/***/ }),

/***/ "GMiS":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("ojcf"),
    keys = __webpack_require__("DWlz");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ "GSaD":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "GZgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_OF_STAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_PRICE_OF_STAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_SERVICES_REQUEST; });
var PRICE_OF_STAY_REQUEST = 'PRICE_OF_STAY_REQUEST';
var RESET_PRICE_OF_STAY = 'RESET_PRICE_OF_STAY';
var ALL_INCLUSIVE_SERVICES_REQUEST = 'ALL_INCLUSIVE_SERVICES_REQUEST';

/***/ }),

/***/ "Go22":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaWhen; });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zygG");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("uDfI");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("393O");
/* harmony import */ var _filter_when_FilterWhen__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qLhN");
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("XiOS");
/* harmony import */ var _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("TYzI");
/* harmony import */ var _CriteriaTrigger__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+Rc+");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("Ub5k");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("kiXb");
/* harmony import */ var _store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("05PS");
/* harmony import */ var _store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("loSl");
/* harmony import */ var _store_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("fflk");
/* harmony import */ var _store_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("RBvG");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("RBO1");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("KL6I");

var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;





















var selector = function selector(state) {
  return {
    departureDate: state.tripCriteria.departureDate,
    duration: state.tripCriteria.duration
  };
};

var CriteriaWhen = function CriteriaWhen(props) {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"]);

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_9__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(_CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__[/* useCriteriaDisplayContext */ "c"])(),
      _useCriteriaDisplayCo2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_useCriteriaDisplayCo, 2),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0],
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_4__[/* useSelector */ "e"])(selector),
      departureDate = _useSelector.departureDate,
      duration = _useSelector.duration;

  var intialDuration = Object(react_redux__WEBPACK_IMPORTED_MODULE_4__[/* useSelector */ "e"])(_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_14__[/* getInitialDuration */ "h"]);
  var productId = props.productId,
      withFlexibility = props.withFlexibility;
  var departureDateIsBookable = Object(react_redux__WEBPACK_IMPORTED_MODULE_4__[/* useSelector */ "e"])(_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_14__[/* getDepartureDateBookable */ "g"]);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(Boolean(productId)),
      blockInputDepartureDate = _useState[0],
      setBlockInputDepartureDate = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(!blockInputDepartureDate ? departureDate : null),
      inputDepartureDate = _useState2[0],
      setInputDepartureDate = _useState2[1];

  var flexibility = Object(react_redux__WEBPACK_IMPORTED_MODULE_4__[/* useSelector */ "e"])(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_18__[/* getTripFlexibility */ "d"]);

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(duration),
      inputDuration = _useState3[0],
      setInputDuration = _useState3[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_4__[/* useDispatch */ "d"])();
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__[/* useTracking */ "a"])({
    actionGA: criteriaContext.trackingActionName
  });
  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    if (productId) {
      setBlockInputDepartureDate(true);
      setInputDepartureDate(null);
    }
  }, [productId]);
  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    if (blockInputDepartureDate && departureDateIsBookable) {
      setBlockInputDepartureDate(false);
      setInputDepartureDate(departureDate);
    }
  }, [departureDateIsBookable]);
  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    var formattedDepartureDate = departureDate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).format('DDMM') : departureDate;
    var formattedInputDepartureDate = inputDepartureDate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(inputDepartureDate).format('DDMM') : inputDepartureDate;

    if (formattedDepartureDate !== formattedInputDepartureDate && !blockInputDepartureDate) {
      setInputDepartureDate(departureDate);
    }
  }, [departureDate]);
  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    if (duration !== inputDuration) {
      setInputDuration(duration);
    }
  }, [duration]);
  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    setCriteriaContext({
      criteriaWhenIsSet: Boolean(departureDate && duration && !blockInputDepartureDate)
    });
  }, [departureDate, duration, blockInputDepartureDate]);

  var openCriteriaEventHandler = function openCriteriaEventHandler() {
    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__[/* ACTIONS */ "a"].OPEN_CRITERIA,
      payload: 'criteriaWhen'
    });
  };

  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_7__[/* OPEN_CRITERIA_WHEN_EVENT */ "a"], openCriteriaEventHandler);
    return function () {
      return document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_7__[/* OPEN_CRITERIA_WHEN_EVENT */ "a"], openCriteriaEventHandler);
    };
  }, []);

  var saveDateAndDuration = function saveDateAndDuration() {
    if (!inputDepartureDate) {
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_15__[/* clearDepartureDate */ "e"])());
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_15__[/* clearTripDuration */ "g"])());
    } else if (departureDate) {
      var currentDuration = inputDuration || props.defaultDuration || _store_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_17__[/* DEFAULT_TRIP_DURATION */ "b"];

      if (currentDuration !== duration) {
        dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_15__[/* changeTripDuration */ "d"])(currentDuration));
      }
    }

    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__[/* ACTIONS */ "a"].CLOSE_CRITERIA,
      payload: 'criteriaWhen'
    });
  };

  var labelPartsMobile = [];

  if (departureDate && duration && !blockInputDepartureDate) {
    labelPartsMobile.push(moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).format('DD/MM'));
    var arrival = moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).add({
      days: duration
    });
    labelPartsMobile.push(arrival.format('DD/MM'));
  }

  var labelParts = [Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "f"])('faceting.when.arrivalDateTitle'), Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "f"])('faceting.when.departureDateTitle')];

  if (departureDate && (!duration || !blockInputDepartureDate)) {
    labelParts[0] = moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).format('DD MMM');
  }

  if (departureDate && duration && !blockInputDepartureDate) {
    labelParts[1] = moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).add({
      days: duration
    }).format('DD MMM');

    if (flexibility && withFlexibility) {
      labelParts[1] = "".concat(labelParts[1], " (").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "f"])("faceting.flexibility.duration_".concat(flexibility, "short")), ")");
    }
  }

  var durationOptions = Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_20__[/* isSeller */ "g"])(appContext) ? Object(lodash__WEBPACK_IMPORTED_MODULE_1__["range"])(1, 31) : props.durationOptions;
  var hasPrices = !Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(props.prices);

  var buttonLabel = __jsx(react__WEBPACK_IMPORTED_MODULE_3__["Fragment"], null, __jsx("span", {
    className: "hidden lg:flex flex-row py-0 flex-1 overflow-hidden items-center whitespace-no-wrap button-default",
    style: {
      height: '1px'
    }
  }, labelParts.join(' - ')), __jsx("span", {
    className: "lg:hidden overflow-hidden button-default flex justify-center items-center",
    style: {
      height: '1px'
    }
  }, labelPartsMobile.length > 1 && __jsx(react__WEBPACK_IMPORTED_MODULE_3__["Fragment"], null, __jsx("div", {
    className: "rtl:ml-2 flex flex-col justify-around button-default py-1"
  }, labelPartsMobile.map(function (labelSplited, key) {
    return __jsx("span", {
      key: "".concat(labelSplited, "_").concat(key)
    }, labelSplited);
  })), !!flexibility && withFlexibility && __jsx("span", null, " ", Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "f"])("faceting.flexibility.duration_".concat(flexibility, "short"))))));

  var trackDepartureDateChange = function trackDepartureDateChange(value) {
    if (criteriaContext.trackingActionName) {
      track({
        labelGA: "when_".concat(value.format('DD/MM/YYYY'))
      });
    }
  };

  var trackDurationChange = function trackDurationChange(value) {
    if (criteriaContext.trackingActionName) {
      var labelGA = "duration_".concat(value);
      track({
        labelGA: labelGA
      });
    }
  };

  return __jsx(_CriteriaTrigger__WEBPACK_IMPORTED_MODULE_11__[/* CriteriaTrigger */ "a"], {
    buttonLabel: buttonLabel,
    buttonIcon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].DATE,
    buttonIsFilled: criteriaContext.criteriaWhenIsSet,
    isOpen: criteriaDisplayContext.criteriaWhenIsOpen,
    isJoyview: props.isJoyview,
    trackingLabel: "when",
    onOpen: function onOpen() {
      dispatchCriteriaDisplayContext({
        type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__[/* ACTIONS */ "a"].OPEN_CRITERIA,
        payload: 'criteriaWhen'
      });
    },
    onClose: saveDateAndDuration,
    onClear: function onClear() {
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_15__[/* clearTripDuration */ "g"])());
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_15__[/* clearDepartureDate */ "e"])());
    },
    buttons: [{
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "f"])('faceting.reset'),
      theme: 'link',
      onClick: function onClick() {
        setInputDuration();
        setInputDepartureDate();
      },
      className: 'text-sm cursor-pointer',
      dataTestId: 'criteria-when-reset'
    }, {
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "f"])('faceting.validate'),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].WHITE,
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].TURQUOISE,
      dataTestId: 'criteria-when-validate',
      onClick: function onClick() {
        saveDateAndDuration();
        dispatchCriteriaDisplayContext({
          type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__[/* ACTIONS */ "a"].OPEN_NEXT_CRITERIA,
          payload: {
            currentCriteria: 'criteriaWhen',
            criteriaContext: criteriaContext
          }
        });
      }
    }],
    reassurance: {
      text: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "f"])('faceting.when.reinsurance'),
      shouldDisplay: hasPrices
    }
  }, __jsx(_filter_when_FilterWhen__WEBPACK_IMPORTED_MODULE_8__[/* FilterWhen */ "a"], {
    defaultDuration: intialDuration || props.defaultDuration,
    optionsDuration: durationOptions,
    prices: props.prices,
    changeTripDuration: function changeTripDuration(time) {
      if (time) {
        setInputDuration(time);
        trackDurationChange(time);
      }
    },
    changeDepartureDate: function changeDepartureDate(value) {
      if (!value) {
        setInputDepartureDate();
        setInputDuration();
        return;
      }

      var newDepartureDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(value);
      var timestamp = newDepartureDate.valueOf();

      if (inputDepartureDate !== timestamp) {
        if (blockInputDepartureDate) {
          setBlockInputDepartureDate(false);
        }

        dispatch(Object(_store_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_16__[/* setDepartureDate */ "a"])(timestamp));
        dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_15__[/* clearTripDuration */ "g"])());
        setInputDepartureDate(timestamp);
        setInputDuration();
        setCriteriaContext({
          defaultValueForCalendar: newDepartureDate
        });
        trackDepartureDateChange(newDepartureDate);
      }
    },
    duration: inputDuration,
    departureDate: inputDepartureDate,
    openCalendarToDate: criteriaContext.defaultValueForCalendar,
    offsetCalendar: props.offsetSell,
    dateFormat: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "f"])('booking.form.dateFormat'),
    withFlexibility: withFlexibility
  }));
};

/***/ }),

/***/ "Gpi5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "Gqxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _responsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/Mt0");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7__["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




function Responsiveness(WrappedComponent) {
  var Responsive = /*#__PURE__*/function (_React$Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Responsive, _React$Component);

    var _super = _createSuper(Responsive);

    function Responsive() {
      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(this, Responsive);

      return _super.apply(this, arguments);
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(Responsive, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            forwardRef = _this$props.forwardRef,
            rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_this$props, ["forwardRef"]);

        return __jsx(_responsiveContext__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].Consumer, null, function (responsive) {
          return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
            ref: forwardRef
          }, rest, {
            responsive: responsive
          }));
        });
      }
    }]);

    return Responsive;
  }(react__WEBPACK_IMPORTED_MODULE_7__["Component"]); //$FlowFixMe


  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7__["forwardRef"](function (props, ref) {
    return __jsx(Responsive, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, props, {
      forwardRef: ref
    }));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (Responsiveness);

/***/ }),

/***/ "GzVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTabsBackgroundClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTabsMainId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTabsItemIds; });
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("m1JM");
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");


var getTabsBackgroundClasses = function getTabsBackgroundClasses() {
  var hasBackground = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].GRAY_LIGHTER;
  return hasBackground ? "bg-".concat(color, " border-b-1 border-t-1 border-gray-light") : '';
};
var getTabsMainId = function getTabsMainId() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var list = items.filter(Boolean).map(function (_ref) {
    var header = _ref.header,
        title = _ref.title;
    return header && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* cleanupId */ "a"])(header.title) || title && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* cleanupId */ "a"])(title);
  }).filter(Boolean);
  return Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* generateUniqueId */ "b"])(list, 'tabs-');
};
var getTabsItemIds = function getTabsItemIds(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      index = _ref2.index,
      mainId = _ref2.mainId;
  var headerId = id || Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* cleanupId */ "a"])(title), "".concat(index)], 'tabs-header-');
  var panelId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_0__[/* cleanupId */ "a"])(title), id && "".concat(id), "".concat(index)], 'tabs-panel-');
  return [headerId, panelId];
};

/***/ }),

/***/ "H0gB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return productWellnessDetailQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productActivityDetailQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return productChildcareDetailQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productActivitiesQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return productChildcaresQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return productWellnessQuery; });
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("NLwV");


function productFeatureServiceQuery(lineProps) {
  var ageInformation = lineProps.ageInformation,
      groupMin = lineProps.groupMin,
      groupMax = lineProps.groupMax,
      groupRange = lineProps.groupRange;
  return "\n    hasBookingOnline\n    hasBookingOnsite\n    id\n    isIdealForFamily\n    label\n    description\n    detailedDescription\n    durationDescription\n    ageRestriction(message: \"".concat(ageInformation, "\")\n    level\n    note\n    group(min: \"").concat(groupMin, "\" max: \"").concat(groupMax, "\" range: \"").concat(groupRange, "\")\n    specificConditions\n    equipments {\n      label\n      included\n    }\n    utilities {\n      label\n      included\n    }\n    targetPrice {\n      price\n      currency\n    }\n  ");
}

var productFeatureFacilityQuery = "\n    id\n    description\n    distance\n    label\n    nightLighting\n    onSite\n    openingHours {\n      opening\n      closing\n    }\n    outdoor\n    quantity\n    specificInformation {\n      type\n      value\n    }\n    technicalSpecificities {\n      typeDescription\n      length\n      width\n      minDepth\n      maxDepth\n      unit\n    }\n    localisation\n  ";
function productWellnessDetailQuery(productId, activityId, _ref) {
  var lineProps = _ref.lineProps,
      urlParams = _ref.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_0__[/* buildProductArgs */ "c"])(productId, urlParams);
  var activityArgs = "categoryId: \"".concat(activityId, "\"");
  return "query {\n      config {\n        common { \n          previous\n          next\n          scrollBackward\n          scrollForward\n        }\n      }\n      includedServices: activities(".concat(productArgs, ", ").concat(activityArgs, ", onlyIncluded: true) {\n        ").concat(productFeatureServiceQuery(lineProps), "\n      }\n      onDemandServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyNotIncluded: true) {\n        ").concat(productFeatureServiceQuery(lineProps), "\n      }\n      productActivities(").concat(productArgs, ") {\n        facilities(activityId : \"").concat(activityId, "\") {\n          ").concat(productFeatureFacilityQuery, "\n        }\n      }\n    }");
}
var productActivityExcursionQuery = "\n    seasonality\n    transportation\n    whatToBring\n  ";
function productActivityDetailQuery(productId, activityId, _ref2) {
  var lineProps = _ref2.lineProps,
      urlParams = _ref2.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_0__[/* buildProductArgs */ "c"])(productId, urlParams);
  var activityArgs = "categoryId: \"".concat(activityId, "\"");
  return "query {\n    config {\n      common { previous next }\n    }\n    includedServices: activities(".concat(productArgs, ", ").concat(activityArgs, ", onlyIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n    onDemandServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyNotIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n      ").concat(productActivityExcursionQuery, "\n    }\n    productActivities(").concat(productArgs, ") {\n      facilities(activityId : \"").concat(activityId, "\") {\n        ").concat(productFeatureFacilityQuery, "\n      }\n    }\n  }");
}
function productChildcareDetailQuery(productId, activityId, _ref3) {
  var lineProps = _ref3.lineProps,
      urlParams = _ref3.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_0__[/* buildProductArgs */ "c"])(productId, urlParams);
  var productActivitiesArgs = "activityId : \"".concat(activityId, "\"");
  var activityArgs = "categoryId: \"".concat(activityId, "\"");
  var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
  return "query {\n    config {\n      common { previous next }\n    }\n    resort(".concat(productArgs, ") {\n      facilities(types: [\"CHILDREN\"], withEquipments: true) {\n        subtitle\n        label\n        equipments {\n          id\n          label\n        }\n      }\n      productActivities(idFilter: \"").concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n        subtitle\n        label\n        equipments {\n          id\n          label\n        }\n      }\n    }\n    productActivities(").concat(productArgs, ") {\n      childcare(").concat(productActivitiesArgs, ") {\n        closingWeekdays\n        description\n        duration\n        furtherInformation\n        id\n        label\n        openingDates {\n          opening\n          closing\n        }\n        openingHours {\n          start\n          end\n        }\n        philosophy\n        targetPrice {\n          currency\n          price\n        }\n      }\n      facilities(").concat(productActivitiesArgs, ") {\n        ").concat(productFeatureFacilityQuery, "\n      }\n    }\n    includedServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n    onDemandServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyNotIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n  }");
}
/* lists of features */

var productFeaturesConfigQuery = "\n    config {\n      common {\n        allInclusive\n        backNavigation\n        bookOnlineOnly\n        bookOnlineOrOnsite\n        bookOnsiteOnly    \n        childcarealacarte\n        downloadLeafletLabel\n        extraCost\n        howToBookLabel\n        idealForFamilyLabel\n        included\n        loadLess\n        onDemandService\n        philosophyLabel\n        price {\n          priceFrom\n        }\n        scrollBackward\n        scrollForward\n        treatmentsLabel\n        viewMore\n      }\n    }\n  ";

function productFeaturesCategoriesFields(defaultLabel) {
  var activityLabel = defaultLabel ? "label(defaultLabel: \"".concat(defaultLabel, "\")") : 'label';
  return "\n    activities: subCategories {\n      bookingDescription\n      bookletUrl\n      brandLogoUrl\n      description\n      equipmentRentalDescription\n      id\n      image: imageUrl\n      isChildrenClub\n      isIncluded\n      keywords\n      ".concat(activityLabel, "\n      name\n      numberOfIncludedActivities\n      numberOfOnDemandActivities\n      philosophy\n      ranking\n      supervisionDescription\n      termsAndConditionsDescription\n    }\n    id\n    label\n    ranking\n  ");
}

function productActivitiesQuery(_ref4) {
  var productId = _ref4.productId,
      defaultLabel = _ref4.defaultLabel,
      urlParams = _ref4.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_0__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    ".concat(productFeaturesConfigQuery, "\n    resort(").concat(productArgs, ") {\n      categories: activityCategories {\n        leisure {\n          ").concat(productFeaturesCategoriesFields(defaultLabel), "\n        }\n      }\n    }\n  }");
}
function productChildcaresQuery(productId, _ref5) {
  var urlParams = _ref5.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_0__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    ".concat(productFeaturesConfigQuery, "\n    resort(").concat(productArgs, ") {\n      kidsActivitiesIntroduction {\n        description\n        shortDescription\n      }\n      categories: activityCategories {\n        children {\n          ").concat(productFeaturesCategoriesFields(), "\n        }\n      }\n    }\n  }");
}
function productWellnessQuery(productId, _ref6) {
  var urlParams = _ref6.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_0__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    ".concat(productFeaturesConfigQuery, "\n    resort(").concat(productArgs, ") {\n      wellnessActivitiesIntroduction {\n        bookletUrl\n        description\n        shortDescription\n      }\n      categories: activityCategories {\n        wellness {\n          ").concat(productFeaturesCategoriesFields(), "\n        }\n      }\n    }\n  }");
}

/***/ }),

/***/ "H4OD":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("4Db7");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "HUtr":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("Z1ta"),
    isArguments = __webpack_require__("lZQm"),
    isArray = __webpack_require__("tEYP"),
    isBuffer = __webpack_require__("EVz8"),
    isIndex = __webpack_require__("hIZU"),
    isTypedArray = __webpack_require__("sarX");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "HcXJ":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "HvnH":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("Q7Yi"),
    now = __webpack_require__("BKF0"),
    toNumber = __webpack_require__("1bTl");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "IpDy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productDestinationResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productDestinationResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_DESTINATION */ "fb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var productId = props.resortId;
    var urlParams = location.urlParams,
        queryParams = location.queryParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      resort(".concat(productArgs, ") {\n        title\n        name\n        description\n        productVideo\n        destination { country image description }\n        practicalInformation { healthFormalities passportAndVisas }\n        comfort\n        href(offerName : \"").concat(queryParams.offer || '', "\")\n        strengths\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_DESTINATIONS */ "gc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "IuYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Price_Price; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// CONCATENATED MODULE: ./src/client/components/frameworks/price-item/PriceItem.themes.js

var PriceItem_themes_themes = function themes(_ref) {
  var hasAction = _ref.hasAction;
  return {
    best: {
      "package": {
        thRoot: 'font-bold leading-one text-center',
        thLabel: 'block font-sans text-gray-darker text-base uppercase',
        thValue: 'block text-turquoise text-5xl',
        thLongValue: 'block text-turquoise text-3xl'
      },
      thumbnail: {
        thRoot: 'text-base flex items-center',
        thLabel: 'font-sans text-gray-darker',
        thValue: 'leading-tight text-2xl underline px-1',
        thLongValue: 'leading-tight text-2xl underline'
      },
      instagram: {
        thRoot: 'text-sm sm:text-base',
        thLabel: 'font-sans',
        thValue: 'leading-tight text-md underline font-bold',
        thLongValue: 'leading-tight text-2xl underline'
      },
      remote: {
        thRoot: 'leading-one font-bold px-1 flex items-center',
        thLabel: 'align-top font-sans inline-block text-sm pr-1 rtl:pr-1',
        thValue: classnames_default()('font-sans inline-block text-3xl', {
          underline: hasAction
        }),
        thLongValue: classnames_default()('font-sans inline-block text-3xl', {
          underline: hasAction
        })
      }
    },
    initial: {
      "package": {
        thRoot: 'block font-bold leading-tight text-center',
        thLabel: 'inline-block font-sans text-gray-darker text-base',
        thValue: 'inline-block line-through text-gray-darker text-base',
        thLongValue: 'block line-through text-gray-darker text-base'
      },
      thumbnail: {
        thRoot: 'inline-block lowercase text-md',
        thLabel: 'hidden',
        thValue: 'line-through uppercase',
        thLongValue: 'line-through uppercase'
      },
      instagram: {
        thRoot: 'text-sm sm:text-base',
        thLabel: 'font-sans',
        thValue: 'font-sans line-through',
        thLongValue: 'font-sans line-through'
      },
      remote: {
        thRoot: 'font-bold text-md text-grenadine',
        thLabel: 'font-sans',
        thValue: 'font-sans line-through',
        thLongValue: 'font-sans line-through'
      }
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price-item/PriceItem.jsx
var __jsx = react_default.a.createElement;




var PriceItem_PriceItem = function PriceItem(_ref) {
  var className = _ref.className,
      formattedValue = _ref.formattedValue,
      hasAction = _ref.hasAction,
      label = _ref.label,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'package' : _ref$theme,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'best' : _ref$type,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value;

  if (!value || !formattedValue) {
    return null;
  }

  var _themes$type$theme = PriceItem_themes_themes({
    hasAction: hasAction
  })[type][theme],
      thLabel = _themes$type$theme.thLabel,
      thLongValue = _themes$type$theme.thLongValue,
      thRoot = _themes$type$theme.thRoot,
      thValue = _themes$type$theme.thValue;
  var valueClasses = Object(price_util["g" /* isLongFormat */])(value) ? thLongValue : thValue;
  return __jsx("span", {
    className: classnames_default()(className, thRoot)
  }, !!label && __jsx("span", {
    className: thLabel,
    "data-testid": "PriceItem-label"
  }, label), !!label && !!formattedValue && __jsx("span", null, " "), __jsx("span", {
    className: valueClasses,
    "data-testid": "PriceItem-value"
  }, formattedValue));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/unit/PriceUnit.themes.js
var PriceUnit_themes_themes = {
  "package": {
    thRoot: 'block font-sans font-bold text-center text-sm uppercase'
  },
  thumbnail: {
    thRoot: 'inline-block font-sans text-sm md:text-base text-gray-darker'
  },
  instagram: {
    thRoot: 'inline-block font-sans text-sm sm:text-base'
  },
  remote: {
    thRoot: 'font-bold font-sans inline-block text-sm'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/unit/PriceUnit.jsx
var PriceUnit_jsx = react_default.a.createElement;


var PriceUnit_PriceUnit = function PriceUnit(_ref) {
  var hasAsterisk = _ref.hasAsterisk,
      theme = _ref.theme,
      unit = _ref.unit;
  return unit ? PriceUnit_jsx("span", {
    className: PriceUnit_themes_themes[theme].thRoot,
    "data-testid": "Price-unit"
  }, unit, hasAsterisk && PriceUnit_jsx("sup", null, "*")) : null;
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.themes.js
var PriceDiscount_themes_themes = {
  "package": {},
  thumbnail: {
    thInitialPrice: 'text-grenadine -order-1 -mb-1'
  },
  instagram: {
    thInitialPrice: 'text-grenadine'
  },
  remote: {
    thInitialPrice: '-order-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.jsx

var PriceDiscount_jsx = react_default.a.createElement;








var PriceDiscount_PriceDiscount = function PriceDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      from = _ref.from,
      hasAction = _ref.hasAction,
      hasAsterisk = _ref.hasAsterisk,
      hasInitialPrice = _ref.hasInitialPrice,
      hasInstalment = _ref.hasInstalment,
      initialPrice = _ref.initialPrice,
      _ref$instalmentLocale = _ref.instalmentLocales,
      instalmentLocales = _ref$instalmentLocale === void 0 ? [] : _ref$instalmentLocale,
      instead = _ref.instead,
      theme = _ref.theme,
      unit = _ref.unit;
  var context = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var thInitialPrice = PriceDiscount_themes_themes[theme].thInitialPrice;
  var displayInstalment = hasInstalment && Object(i18n["c" /* getKeyValue */])('common.price.displayInstalmentsPrice');
  var locale = context.locale;
  return PriceDiscount_jsx(react["Fragment"], null, PriceDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    hasAction: hasAction,
    label: from,
    theme: theme,
    type: "best"
  }, bestPrice, {
    formattedValue: hasInstalment ? Object(price_util["b" /* getInstalmentPrice */])(bestPrice, locale) : bestPrice && bestPrice.formattedValue
  })), PriceDiscount_jsx("span", null, " "), hasInitialPrice && PriceDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    hasAction: hasAction,
    label: instead,
    theme: theme,
    type: "initial"
  }, initialPrice, {
    className: thInitialPrice,
    formattedValue: displayInstalment && initialPrice && instalmentLocales.includes(locale) ? Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Math.trunc(initialPrice.value), locale, initialPrice.currency, {
      precision: 0
    }) : initialPrice && initialPrice.formattedValue
  })), PriceDiscount_jsx("span", null, " "), PriceDiscount_jsx(PriceUnit_PriceUnit, {
    hasAsterisk: hasAsterisk,
    theme: theme,
    unit: unit
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/no-discount/PriceNoDiscount.jsx

var PriceNoDiscount_jsx = react_default.a.createElement;





var PriceNoDiscount_PriceNoDiscount = function PriceNoDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      from = _ref.from,
      hasAsterisk = _ref.hasAsterisk,
      hasInstalment = _ref.hasInstalment,
      initialPrice = _ref.initialPrice,
      theme = _ref.theme,
      unit = _ref.unit;
  var context = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var price;

  if (Object(price_util["f" /* hasPrice */])(initialPrice)) {
    price = initialPrice;
  } else if (Object(price_util["f" /* hasPrice */])(bestPrice)) {
    price = bestPrice;
  }

  return PriceNoDiscount_jsx(react["Fragment"], null, PriceNoDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    label: from,
    theme: theme,
    type: "best"
  }, price, {
    formattedValue: hasInstalment ? Object(price_util["b" /* getInstalmentPrice */])(price, context.locale) : price && price.formattedValue
  })), PriceNoDiscount_jsx("span", null, " "), PriceNoDiscount_jsx(PriceUnit_PriceUnit, {
    hasAsterisk: hasAsterisk,
    theme: theme,
    unit: unit
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.themes.js
var PriceViewRate_themes_themes = {
  "package": {
    thRoot: 'flex font-bold font-sans justify-center leading-tight text-center text-md',
    thLabel: 'rtl:ml-2'
  },
  thumbnail: {
    thRoot: 'flex items-center underline font-sans leading-one text-sm md:text-base',
    thIcon: 'hidden',
    thLabel: 'rtl:ml-1'
  },
  instagram: {
    thRoot: 'flex items-center underline font-sans leading-one text-sm sm:text-base',
    thIcon: 'hidden',
    thLabel: 'rtl:ml-1'
  },
  remote: {
    thRoot: 'flex items-center font-bold font-sans leading-one text-xl',
    thLabel: 'rtl:ml-2'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.jsx
var PriceViewRate_jsx = react_default.a.createElement;




var PriceViewRate_PriceViewRate = function PriceViewRate(_ref) {
  var label = _ref.label,
      theme = _ref.theme;
  var _themes$theme = PriceViewRate_themes_themes[theme],
      thIcon = _themes$theme.thIcon,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  if (!label) {
    return null;
  }

  return PriceViewRate_jsx("div", {
    className: thRoot
  }, PriceViewRate_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].DATE,
    width: "1em"
  }), PriceViewRate_jsx("span", {
    className: thLabel,
    "data-testid": "Price-viewRate"
  }, label));
};
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.themes.js

var Price_themes_themes = function themes(_ref) {
  var color = _ref.color;
  return {
    "package": {
      thRoot: 'overflow-hidden'
    },
    thumbnail: {
      thRoot: 'flex items-center leading-half overflow-hidden pt-1 pb-2 text-gray-darker',
      thPriceRoot: 'font-brand flex items-center'
    },
    instagram: {
      thRoot: 'w-full flex items-center leading-half truncate text-white',
      thPriceRoot: 'font-brand text-inherit'
    },
    remote: {
      thRoot: "inline-flex overflow-hidden text-".concat(color || colors["a" /* COLORS */].BLUE),
      thPriceRoot: 'flex items-center'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.jsx
var Price_jsx = react_default.a.createElement;







var HEIGHT = '2.5rem';
var Price_Price = function Price(_ref) {
  var bestPrice = _ref.bestPrice,
      className = _ref.className,
      color = _ref.color,
      _ref$containerStyle = _ref.containerStyle,
      containerStyle = _ref$containerStyle === void 0 ? {
    minHeight: HEIGHT
  } : _ref$containerStyle,
      from = _ref.from,
      _ref$hasAsterisk = _ref.hasAsterisk,
      hasAsterisk = _ref$hasAsterisk === void 0 ? true : _ref$hasAsterisk,
      _ref$hasInitialPrice = _ref.hasInitialPrice,
      hasInitialPrice = _ref$hasInitialPrice === void 0 ? true : _ref$hasInitialPrice,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? true : _ref$hasInstalment,
      initialPrice = _ref.initialPrice,
      _ref$instalmentLocale = _ref.instalmentLocales,
      instalmentLocales = _ref$instalmentLocale === void 0 ? ['pt-BR', 'es-AR'] : _ref$instalmentLocale,
      instead = _ref.instead,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      onClick = _ref.onClick,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'package' : _ref$theme,
      unit = _ref.unit,
      viewRates = _ref.viewRates;
  var displayPrice = Object(price_util["d" /* hasAtLeastOnePrice */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  });

  if (!displayPrice && !viewRates) {
    return null;
  }

  var _themes$theme = Price_themes_themes({
    color: color
  })[theme],
      thPriceRoot = _themes$theme.thPriceRoot,
      thRoot = _themes$theme.thRoot;
  var hasAction = !!onClick;
  var TagName = hasAction ? 'button' : 'div';
  return Price_jsx(TagName, {
    "data-testid": "Price-wrapper",
    className: classnames_default()(className, thRoot, {
      'reset-button': hasAction
    }),
    onClick: onClick,
    style: containerStyle
  }, Price_jsx("div", {
    className: thPriceRoot,
    style: style
  }, isLoading ? Price_jsx("div", {
    className: "loadingDots",
    "data-testid": "Price-loader"
  }) : Price_jsx(react["Fragment"], null, displayPrice ? Price_jsx(react["Fragment"], null, Object(price_util["e" /* hasDiscount */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  }) ? Price_jsx(PriceDiscount_PriceDiscount, {
    bestPrice: bestPrice,
    from: from,
    hasAction: hasAction,
    hasAsterisk: hasAsterisk,
    hasInitialPrice: hasInitialPrice,
    hasInstalment: hasInstalment,
    initialPrice: initialPrice,
    instalmentLocales: instalmentLocales,
    instead: instead,
    theme: theme,
    unit: unit
  }) : Price_jsx(PriceNoDiscount_PriceNoDiscount, {
    bestPrice: bestPrice,
    from: from,
    hasAsterisk: hasAsterisk,
    hasInstalment: hasInstalment,
    initialPrice: initialPrice,
    theme: theme,
    unit: unit
  })) : Price_jsx(PriceViewRate_PriceViewRate, {
    label: viewRates,
    theme: theme
  }))));
};

/***/ }),

/***/ "J77r":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF"),
    root = __webpack_require__("jP+d");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "JEY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productAccommodationsResolver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productAccommodationsExclusiveCollectionResolver; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var getQuery = function getQuery(productArgs) {
  return "query {\n    config {\n      common {\n        backNavigation\n        viewMore\n        loadLess\n        next\n        previous\n        scrollBackward\n        scrollForward\n      }\n    }\n    accommodationCategory(".concat(productArgs, ") {\n      rankedCategories: accommodations {\n        id\n        ranking\n      }\n    }\n    resort(").concat(productArgs, ") {\n      accommodationsIntroduction {\n        description\n        shortDescription\n      }\n      accommodations {\n        bathroomEquipments {\n          id\n          label\n        }\n        category\n        categoryId\n        comfortId\n        comfortType\n        description\n        equipments {\n          id\n          label\n        }\n        exclusiveCollection\n        id\n        label\n        maxCapacity\n        media {\n          photos {\n            url\n          }\n        }\n        ranking\n        roomType\n        services {\n          id\n          label\n        }\n        outsideFacilities {\n          id\n          label\n        }\n        strengths {\n          id\n          label\n        }\n        surface\n        view {\n          id\n          label\n        }\n      }\n      comfort\n      type\n    }\n  }");
};

var commonAccommodationsResolver = function commonAccommodationsResolver(_ref) {
  var isLineExclusiveCollection = _ref.isLineExclusiveCollection;
  return function (appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_3__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = getQuery(productArgs);
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_PRODUCT_ACCOMMODATIONS */ "Zb"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* addTranslationKeys */ "a"])(data.config);
      return _objectSpread(_objectSpread({}, data), {}, {
        isLineExclusiveCollection: isLineExclusiveCollection
      });
    });
  };
};

var productAccommodationsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* RESORT_ACCOMMODATION_TYPES */ "cb"],
  resolve: commonAccommodationsResolver({
    isLineExclusiveCollection: false
  })
};
var productAccommodationsExclusiveCollectionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION */ "bb"],
  resolve: commonAccommodationsResolver({
    isLineExclusiveCollection: true
  })
};

/***/ }),

/***/ "JG32":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dZwK");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "JPie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aWzz");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("R6jJ");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("s5tn");






var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className;
  return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, Object(_util__WEBPACK_IMPORTED_MODULE_4__[/* inlineProp */ "b"])(focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__[/* FOCUS_AUTO */ "b"], !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes =  false ? undefined : {};
AutoFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (AutoFocusInside);

/***/ }),

/***/ "JU27":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("N8jz"),
    ListCache = __webpack_require__("2K7v"),
    Map = __webpack_require__("McKP");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "JYyW":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("VAV/");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "Jcrg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FormControl_FormControl; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/dedupe.js
var dedupe = __webpack_require__("MoqE");
var dedupe_default = /*#__PURE__*/__webpack_require__.n(dedupe);

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.themes.js



var DEFAULT_SIZES = {
  small: 32,
  medium: 42,
  large: 52
};
var themes = {
  "default": function _default(props) {
    var bgTransparent = props.bgTransparent,
        hasValidationIcon = props.hasValidationIcon,
        isActive = props.isActive,
        isDisabled = props.isDisabled,
        isFilled = props.isFilled,
        isReadOnly = props.isReadOnly,
        _props$size = props.size,
        size = _props$size === void 0 ? 'medium' : _props$size,
        _props$validationStat = props.validationState,
        validationState = _props$validationStat === void 0 ? 'NOT_VALIDATED' : _props$validationStat;
    var hasDefaultStyle = validationState === 'NOT_VALIDATED' && !isActive && !isFilled && !isDisabled;
    var hasActiveStyle = validationState === 'NOT_VALIDATED' && isActive && !isDisabled && !isFilled;
    var hasValidStyle = validationState === 'IS_VALID' && !isFilled && !isDisabled;
    var hasInvalidStyle = validationState === 'IS_INVALID' && !isFilled && !isDisabled;
    var hasFilledStyle = isFilled && !isDisabled;
    var iconTheme = dedupe_default()('flex items-center justify-center', {
      'text-current': !hasFilledStyle,
      'text-gray-medium': isDisabled
    });
    var validationIconName = null;

    if (hasValidationIcon && (hasValidStyle || hasInvalidStyle)) {
      validationIconName = hasValidStyle ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS;
    }

    return {
      thLabel: 'block font-bold pb-1 text-gray-darker text-sm transition-color',
      thField: dedupe_default()('border-1 flex outline-custom px-3 relative rounded-tiny transition-colors', Object(form_util["a" /* getCursorClass */])(props), {
        'button-medium': size === 'medium',
        'button-default': size === 'large',
        'bg-gray-lighter border-gray-lighter': isDisabled,
        'bg-white border-gray-medium': hasDefaultStyle && !bgTransparent,
        'bg-transparent border-gray-medium': hasDefaultStyle && !!bgTransparent,
        'focus-within:border-blue text-gray-darker focus-within:text-blue': hasDefaultStyle && !isReadOnly,
        'bg-white border-blue text-blue': hasActiveStyle,
        'bg-white border-success': hasValidStyle,
        'bg-white border-danger': hasInvalidStyle,
        'bg-blue border-blue text-white': hasFilledStyle
      }),
      thFieldStyle: {
        height: DEFAULT_SIZES[size]
      },
      thIconLeft: dedupe_default()(iconTheme, 'rtl:pr-3'),
      thIconRight: dedupe_default()(iconTheme, 'rtl:pl-3'),
      thInput: 'flex flex-1 relative',
      thLoader: 'flex items-center justify-center leading-none rtl:pl-3',
      thSpinnerColor: hasFilledStyle ? 'current' : 'blue',
      thClearButton: dedupe_default()('reset-button leading-none rtl:pl-3 transition-color', {
        'text-gray-medium': !hasFilledStyle,
        'text-current': hasFilledStyle
      }),
      thClearIconSize: '0.625rem',
      thValidationIcon: dedupe_default()('flex items-center justify-center pl-2 text-xs transition-all', {
        'text-success': hasValidStyle,
        'text-danger': hasInvalidStyle
      }),
      thValidationIconSize: '1em',
      thValidationIconName: validationIconName,
      thNotes: 'mt-px pt-px text-sm text-gray-medium'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx
var __jsx = react_default.a.createElement;







var FormControl_FormControl = function FormControl(_ref) {
  var bgTransparent = _ref.bgTransparent,
      children = _ref.children,
      className = _ref.className,
      dir = _ref.dir,
      hasClear = _ref.hasClear,
      _ref$hasValidationIco = _ref.hasValidationIcon,
      hasValidationIcon = _ref$hasValidationIco === void 0 ? true : _ref$hasValidationIco,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      id = _ref.id,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly,
      isRequired = _ref.isRequired,
      label = _ref.label,
      notes = _ref.notes,
      onClear = _ref.onClear,
      size = _ref.size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      validationState = _ref.validationState;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme]({
    bgTransparent: bgTransparent,
    hasValidationIcon: hasValidationIcon,
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isReadOnly: isReadOnly,
    size: size,
    validationState: validationState
  }),
      thClearButton = _themes$theme.thClearButton,
      thClearIconSize = _themes$theme.thClearIconSize,
      thField = _themes$theme.thField,
      thFieldStyle = _themes$theme.thFieldStyle,
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thInput = _themes$theme.thInput,
      thLabel = _themes$theme.thLabel,
      thLoader = _themes$theme.thLoader,
      thNotes = _themes$theme.thNotes,
      thSpinnerColor = _themes$theme.thSpinnerColor,
      thValidationIcon = _themes$theme.thValidationIcon,
      thValidationIconName = _themes$theme.thValidationIconName,
      thValidationIconSize = _themes$theme.thValidationIconSize;

  return __jsx("div", {
    className: className,
    dir: dir
  }, !!label && __jsx("label", {
    className: thLabel,
    htmlFor: id
  }, Object(lodash["isString"])(label) ? Object(form_util["b" /* getFormattedLabel */])(label, isRequired) : label), __jsx("div", {
    className: thField,
    style: thFieldStyle
  }, !!iconLeft && __jsx("div", {
    className: thIconLeft
  }, __jsx(Icon["a" /* Icon */], {
    name: iconLeft,
    width: "0.875rem"
  })), __jsx("div", {
    className: thInput
  }, children, isLoading && !isDisabled && !isReadOnly && __jsx("div", {
    className: thLoader
  }, __jsx(Spinner["a" /* Spinner */], {
    color: thSpinnerColor,
    size: "small"
  })), hasClear && !isDisabled && !isLoading && !isReadOnly && __jsx("button", {
    className: thClearButton,
    "data-testid": "FormControlClear",
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearIconSize
  }))), !!iconRight && __jsx("div", {
    className: thIconRight
  }, __jsx(Icon["a" /* Icon */], {
    name: iconRight
  })), thValidationIconName && __jsx("span", {
    className: thValidationIcon
  }, __jsx(Icon["a" /* Icon */], {
    name: thValidationIconName,
    width: thValidationIconSize
  }))), !!notes && __jsx("div", {
    className: thNotes,
    "data-testid": "FormControlNotes"
  }, notes));
};

/***/ }),

/***/ "JhHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isVideoUrl; });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_0__);

var youtubeRegEx = new RegExp('https://(?:youtu.be/|www.youtube.com/(?:watch\\?v=|embed/))([a-zA-Z0-9_-]+)');
var youkuRegEx = new RegExp('https?://(?:player.youku.com/embed/|player.youku.com/player.php/sid/)([a-zA-Z0-9]+)');

function getYoutubeVideoUrl(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://www.youtube.com/embed/".concat(urlId[1]) : null;
}

function getYoukuVideoUrl(url) {
  var urlId = youkuRegEx.exec(url);
  var clientId = _config__WEBPACK_IMPORTED_MODULE_0___default.a.get('youku.clientId');
  return urlId ? "https://player.youku.com/embed/".concat(urlId[1], "?client_id=").concat(clientId) : null;
}

function getVideoUrl(url) {
  return getYoutubeVideoUrl(url) || getYoukuVideoUrl(url);
}

function isVideoUrl(url) {
  return youtubeRegEx.test(url) || youkuRegEx.test(url);
}



/***/ }),

/***/ "Jsmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tripInformationSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdultsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getKids; });
/* unused harmony export getMainContactOptins */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);

var tripInformationSelector = function tripInformationSelector(_ref) {
  var tripInformation = _ref.tripInformation;
  return tripInformation || {};
};

var tripCriteriaSelector = function tripCriteriaSelector(_ref2) {
  var tripCriteria = _ref2.tripCriteria;
  return tripCriteria || {};
};

var getAdults = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref3) {
  var adults = _ref3.adults;
  return adults || [];
});
var getAdultsNumber = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref4) {
  var adults = _ref4.adults;
  return (adults || []).length;
});
var getKids = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref5) {
  var kids = _ref5.kids;
  return kids || [];
});
var getMainContactOptins = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref6) {
  var mainContact = _ref6.mainContact;
  return mainContact;
});


/***/ }),

/***/ "Khoy":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "KiAj":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("pfIK"),
    copyObject = __webpack_require__("ojcf"),
    createAssigner = __webpack_require__("6MnY"),
    isArrayLike = __webpack_require__("gvfs"),
    isPrototype = __webpack_require__("RVBP"),
    keys = __webpack_require__("DWlz");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ "KicR":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("5FP0");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ "Ky/o":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("2rns");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "LNcM":
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function(window, document) {
'use strict';


// Exits early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }
  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}(window, document));


/***/ }),

/***/ "LR4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ LabeledIconsList_LabeledIconsList; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.themes.js
var themes = {
  "default": {
    thRoot: 'reset-list flex flex-row py-3',
    thItem: 'flex-1 font-bold font-sans leading-normal text-center text-current text-sm',
    thItemNth: 'border-l-1',
    thIcon: 'flex items-center justify-center leading-none',
    thIconWidth: '2.625rem',
    thLabels: 'mb-0 mt-2 mx-2'
  },
  list: {
    thRoot: 'reset-list flex flex-wrap -mx-2',
    thItem: 'flex items-start p-2 w-1/2',
    thIcon: 'flex flex-shrink-0 items-center justify-center leading-none',
    thIconWidth: '1.375rem',
    thLabels: 'font-sans leading-normal px-2 text-base text-gray-darker'
  },
  listCondensed: {
    thRoot: 'reset-list flex flex-wrap -mx-px10',
    thItem: 'flex items-start p-px10 w-1/2',
    thIcon: 'flex flex-shrink-0 items-center justify-center leading-none',
    thIconWidth: '1.375rem',
    thLabels: 'font-sans leading-normal px-px10 text-base text-gray-darker'
  },
  roomColumn: {
    thRoot: 'Room-icons--column w-full md:w-1/2 grid grid-flow-col grid-rows-1 md:grid-rows-2 md:grid-cols-2 gap-2 md:gap-3 reset-list py-3 md:py-0 md:pb-3 md:rtl:pl-2',
    thItem: 'py-2 md:px-2 flex flex-col items-center justify-center bg-gray-lighter font-bold font-sans leading-normal text-center text-current text-xs',
    thIcon: 'leading-none text-xl md:text-3xl',
    thIconWidth: '0.95em',
    thLabels: 'mb-0 mt-2 mx-2 w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx

var __jsx = react_default.a.createElement;





var LabeledIconsList_LabeledIconsList = function LabeledIconsList(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!items.length) {
    return null;
  }

  var _themes$theme = themes[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thItem = _themes$theme.thItem,
      thItemNth = _themes$theme.thItemNth,
      thLabels = _themes$theme.thLabels,
      thRoot = _themes$theme.thRoot;
  return __jsx("ul", {
    className: classnames_default()(className, "text-".concat(color), thRoot)
  }, items.map(function (_ref2, idx) {
    var icon = _ref2.icon,
        labels = _ref2.labels;
    return __jsx("li", {
      className: classnames_default()(thItem, Object(defineProperty["a" /* default */])({}, thItemNth, idx > 0)),
      key: icon
    }, __jsx("div", {
      className: thIcon
    }, __jsx(Icon["a" /* Icon */], {
      name: icon,
      width: thIconWidth,
      alt: (labels || []).join('/')
    })), !!labels.length && __jsx("div", {
      className: thLabels
    }, labels.map(function (label) {
      return __jsx("div", {
        "data-testid": "LabeledIconsList-label",
        key: label
      }, label);
    })));
  }));
};

/***/ }),

/***/ "Lbah":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("3QVS");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "M3jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterTransport; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _frameworks_form_inputs_input_select_InputSelect_jsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("oWz2");
/* harmony import */ var _frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("SPKZ");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Ub5k");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var FilterTransport = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(FilterTransport, _Component);

  var _super = _createSuper(FilterTransport);

  function FilterTransport() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, FilterTransport);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "handleDepartureCityChange", function (name, departureCity) {
      var changeDepartureCity = _this.props.changeDepartureCity;
      changeDepartureCity(departureCity);
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(FilterTransport, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          departureCity = _this$props.departureCity,
          informationLabel = _this$props.informationLabel,
          isDisabled = _this$props.isDisabled,
          isLoading = _this$props.isLoading,
          label = _this$props.label,
          optionsDepartureCities = _this$props.optionsDepartureCities;
      var value = departureCity ? departureCity : '';
      var inputTransportId = 'TransportSelectFilter';
      return __jsx("div", {
        className: "px-4 py-6",
        "data-testid": "FilterTransport"
      }, __jsx("label", {
        className: "text-lg font-bold lg:text-center mb-6 block",
        htmlFor: inputTransportId
      }, label), __jsx(_frameworks_form_inputs_input_select_InputSelect_jsx__WEBPACK_IMPORTED_MODULE_8__[/* InputSelect */ "a"], {
        className: "mb-3",
        dataTestId: "search-form-select-transport",
        inputId: inputTransportId,
        isDisabled: isDisabled,
        isLoading: isLoading || optionsDepartureCities.length === 0,
        mediumText: true,
        onChange: this.handleDepartureCityChange,
        options: optionsDepartureCities,
        value: value
      }), __jsx("div", {
        className: "text-sm text-blue font-bold flex"
      }, __jsx(_frameworks_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
        className: "rtl:mr-2 flex-shrink-0",
        width: "1.75rem",
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_10__[/* ICONS */ "a"].ALL_INCLUSIVE
      }), informationLabel));
    }
  }]);

  return FilterTransport;
}(react__WEBPACK_IMPORTED_MODULE_7__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(FilterTransport, "contextType", _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"]);

/***/ }),

/***/ "MX/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_TRANSPORT_EVENT; });
var OPEN_CRITERIA_TRANSPORT_EVENT = 'openCriteriaTransport';

/***/ }),

/***/ "McKP":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF"),
    root = __webpack_require__("jP+d");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "Mn1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripDateCriteriaSelector = function tripDateCriteriaSelector(_ref) {
  var tripDateCriteria = _ref.tripDateCriteria;
  return tripDateCriteria || {};
};

var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref2) {
  var arrivalDate = _ref2.arrivalDate;
  return arrivalDate;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref3) {
  var departureDate = _ref3.departureDate;
  return departureDate;
});


/***/ }),

/***/ "MoqE":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var classNames = (function () {
		// don't inherit from Object so we can skip hasOwnProperty check later
		// http://stackoverflow.com/questions/15518328/creating-js-object-with-object-createnull#answer-21079232
		function StorageObject() {}
		StorageObject.prototype = Object.create(null);

		function _parseArray (resultSet, array) {
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				_parse(resultSet, array[i]);
			}
		}

		var hasOwn = {}.hasOwnProperty;

		function _parseNumber (resultSet, num) {
			resultSet[num] = true;
		}

		function _parseObject (resultSet, object) {
			for (var k in object) {
				if (hasOwn.call(object, k)) {
					// set value to false instead of deleting it to avoid changing object structure
					// https://www.smashingmagazine.com/2012/11/writing-fast-memory-efficient-javascript/#de-referencing-misconceptions
					resultSet[k] = !!object[k];
				}
			}
		}

		var SPACE = /\s+/;
		function _parseString (resultSet, str) {
			var array = str.split(SPACE);
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				resultSet[array[i]] = true;
			}
		}

		function _parse (resultSet, arg) {
			if (!arg) return;
			var argType = typeof arg;

			// 'foo bar'
			if (argType === 'string') {
				_parseString(resultSet, arg);

			// ['foo', 'bar', ...]
			} else if (Array.isArray(arg)) {
				_parseArray(resultSet, arg);

			// { 'foo': true, ... }
			} else if (argType === 'object') {
				_parseObject(resultSet, arg);

			// '130'
			} else if (argType === 'number') {
				_parseNumber(resultSet, arg);
			}
		}

		function _classNames () {
			// don't leak arguments
			// https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
			var len = arguments.length;
			var args = Array(len);
			for (var i = 0; i < len; i++) {
				args[i] = arguments[i];
			}

			var classSet = new StorageObject();
			_parseArray(classSet, args);

			var list = [];

			for (var k in classSet) {
				if (classSet[k]) {
					list.push(k)
				}
			}

			return list.join(' ');
		}

		return _classNames;
	})();

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "N5WC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tag; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.themes.js

var themes = {
  "default": function _default(_ref) {
    var onClick = _ref.onClick;
    return {
      thRoot: 'bg-current inline-flex items-stretch rounded-tiny text-base',
      thBody: classnames_default()('flex items-center font-bold leading-one m-1 text-current', {
        'reset-button': onClick
      }),
      thBadgeStyle: {
        width: '1.5em',
        height: '1.5em'
      },
      thBadge: 'bg-white flex items-center justify-center leading-one m-1 overflow-hidden rounded-full text-center',
      thBadgeLabel: 'text-sm',
      thIconSize: '1em',
      thIconLeft: 'm-1 text-white',
      thIconRight: 'm-1 text-white',
      thLabel: 'inline-flex m-1 text-white',
      thClose: 'p-2 reset-button text-white',
      thCloseSize: '0.625em'
    };
  },
  outlined: function outlined(_ref2) {
    var onClick = _ref2.onClick;
    return {
      thRoot: 'border-2 border-current inline-flex items-stretch text-sm',
      thBody: classnames_default()('flex items-center font-bold leading-one px-2 py-1 text-current uppercase', {
        'reset-button': onClick
      }),
      thBadgeStyle: {
        width: '2em',
        height: '2em'
      },
      thBadge: 'bg-white border-1 border-current flex items-center justify-center leading-one m-1 overflow-hidden rounded-full text-center',
      thBadgeLabel: '',
      thIconSize: '1em',
      thIconLeft: 'm-1',
      thIconRight: 'm-1',
      thLabel: 'inline-flex m-1',
      thClose: 'm-2 reset-button text-current',
      thCloseSize: '0.625em'
    };
  },
  outlinedThin: function outlinedThin(_ref3) {
    var onClick = _ref3.onClick,
        active = _ref3.active;
    return {
      thRoot: classnames_default()('border border-current items-stretch rounded-tiny text-sm', {
        'bg-current': active
      }),
      thBody: classnames_default()('flex items-center leading-one px-2 py-1 text-base text-current', {
        'reset-button': onClick
      }),
      thBadgeStyle: {
        width: '2em',
        height: '2em'
      },
      thBadge: 'bg-white border-1 border-current flex items-center justify-center leading-one m-1 overflow-hidden rounded-full text-center',
      thBadgeLabel: '',
      thIconSize: '1em',
      thIconLeft: classnames_default()('m-1', {
        'text-white': active
      }),
      thIconRight: classnames_default()('m-1', {
        'text-white': active
      }),
      thLabel: classnames_default()('inline-flex m-1 whitespace-no-wrap', {
        'text-white': active
      }),
      thClose: classnames_default()('m-2 reset-button text-current', {
        'text-white': active
      }),
      thCloseSize: '0.625em'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.jsx


var __jsx = react_default.a.createElement;








var Tag = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var active = props.active,
      badge = props.badge,
      borderColor = props.borderColor,
      className = props.className,
      closeLabel = props.closeLabel,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].BLUE : _props$color,
      _props$dataTestId = props.dataTestId,
      dataTestId = _props$dataTestId === void 0 ? 'Tag' : _props$dataTestId,
      iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      label = props.label,
      _onClick = props.onClick,
      onClose = props.onClose,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      _props$trackingData = props.trackingData,
      trackingData = _props$trackingData === void 0 ? {} : _props$trackingData,
      rest = Object(objectWithoutProperties["a" /* default */])(props, ["active", "badge", "borderColor", "className", "closeLabel", "color", "dataTestId", "iconLeft", "iconRight", "label", "onClick", "onClose", "tabIndex", "theme", "trackingData"]);

  var track = !Object(lodash["isEmpty"])(trackingData) && _onClick ? Object(useTracking["a" /* useTracking */])(trackingData) : lodash["noop"];

  if (!label) {
    return null;
  }

  var TagName = _onClick ? 'button' : 'div';

  var _themes$theme = themes[theme](props),
      thRoot = _themes$theme.thRoot,
      thBody = _themes$theme.thBody,
      thBadge = _themes$theme.thBadge,
      thBadgeStyle = _themes$theme.thBadgeStyle,
      thBadgeLabel = _themes$theme.thBadgeLabel,
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thIconSize = _themes$theme.thIconSize,
      thLabel = _themes$theme.thLabel,
      thClose = _themes$theme.thClose,
      thCloseSize = _themes$theme.thCloseSize;

  return __jsx("div", {
    className: classnames_default()(className, "text-".concat(color, " border-").concat(borderColor || color), thRoot)
  }, __jsx(TagName, Object(esm_extends["a" /* default */])({}, rest, {
    className: thBody,
    "data-testid": dataTestId,
    onClick: function onClick(e) {
      _onClick && _onClick(e);
      track({});
    },
    ref: ref,
    title: label
  }, _onClick ? {
    tabIndex: tabIndex,
    type: 'button'
  } : null), !!badge && __jsx("span", {
    key: "badge",
    className: thBadge,
    style: thBadgeStyle,
    "data-testid": "Tag-badge"
  }, typeof badge === 'string' ? __jsx("span", {
    className: thBadgeLabel
  }, badge) : badge), !!iconLeft && __jsx(Icon["a" /* Icon */], {
    key: "icon-left",
    className: thIconLeft,
    name: iconLeft,
    width: thIconSize
  }), __jsx("span", {
    key: "label",
    className: thLabel
  }, label), !!iconRight && __jsx(Icon["a" /* Icon */], {
    key: "icon-right",
    className: thIconRight,
    name: iconRight,
    width: thIconSize
  })), !!onClose && __jsx("button", {
    className: thClose,
    onClick: onClose,
    tabIndex: tabIndex,
    type: "button",
    "data-testid": "Tag-Close"
  }, !!closeLabel && __jsx("span", {
    className: "sr-only"
  }, closeLabel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseSize
  })));
});

/***/ }),

/***/ "N8jz":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("zjgX"),
    hashDelete = __webpack_require__("SHsq"),
    hashGet = __webpack_require__("EzIG"),
    hashHas = __webpack_require__("JG32"),
    hashSet = __webpack_require__("qmjq");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "N9he":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("rnJz"),
    isObjectLike = __webpack_require__("oS78");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "NPTU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SeeMore_SeeMore; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/see-more/SeeMore.themes.js
var COLLAPSED_OVERLAY_HEIGHT = 50;
var themes = {
  "default": {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #ffffff 100%)'
    },
    thButton: 'reset-button mt-2 text-base text-gray-darker focus:text-blue hover:text-blue transition-color underline'
  },
  gray: {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #f7f7f7 100%)'
    },
    thButton: 'reset-button mt-2 text-base text-gray-darker focus:text-blue hover:text-blue transition-color underline'
  },
  deepBlue: {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, hsla(216, 100%, 18%, 1) 100%)'
    },
    thButton: 'reset-button mt-2 text-base text-white transition-color underline'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx
var __jsx = react_default.a.createElement;








var SeeMore_SeeMore = function SeeMore(_ref) {
  var children = _ref.children,
      className = _ref.className,
      classNameButton = _ref.classNameButton,
      _ref$hasNoScrollOnCol = _ref.hasNoScrollOnCollapse,
      hasNoScrollOnCollapse = _ref$hasNoScrollOnCol === void 0 ? false : _ref$hasNoScrollOnCol,
      _ref$isCollapseEnable = _ref.isCollapseEnabled,
      isCollapseEnabled = _ref$isCollapseEnable === void 0 ? true : _ref$isCollapseEnable,
      _ref$offsetScrollSele = _ref.offsetScrollSelector,
      offsetScrollSelector = _ref$offsetScrollSele === void 0 ? Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */] : _ref$offsetScrollSele,
      _onClick = _ref.onClick,
      _ref$seeLessLabel = _ref.seeLessLabel,
      seeLessLabel = _ref$seeLessLabel === void 0 ? Object(i18n["f" /* t */])('common.loadLess') : _ref$seeLessLabel,
      _ref$seeMoreLabel = _ref.seeMoreLabel,
      seeMoreLabel = _ref$seeMoreLabel === void 0 ? Object(i18n["f" /* t */])('common.loadMore') : _ref$seeMoreLabel,
      _ref$seeMoreSize = _ref.seeMoreSize,
      seeMoreSize = _ref$seeMoreSize === void 0 ? 120 : _ref$seeMoreSize,
      _ref$seeMoreSizeToler = _ref.seeMoreSizeTolerance,
      seeMoreSizeTolerance = _ref$seeMoreSizeToler === void 0 ? 30 : _ref$seeMoreSizeToler,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useState = Object(react["useState"])(0),
      height = _useState[0],
      setHeight = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isCollapsable = _useState2[0],
      setIsCollapsable = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isExpanded = _useState3[0],
      setIsExpanded = _useState3[1];

  var ref = Object(react["useRef"])(null);
  var seeMoreSizeTolerated = seeMoreSize + seeMoreSizeTolerance;
  Object(react["useEffect"])(function () {
    var _ref$current;

    if (children && (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientHeight) && ref.current.clientHeight > seeMoreSizeTolerated) {
      setHeight(ref.current.clientHeight);
    }
  }, [children, ref]);
  Object(react["useEffect"])(function () {
    if (height > seeMoreSizeTolerated) {
      setIsCollapsable(true);
    }
  }, [height]);

  if (!react["Children"].count(children)) {
    return null;
  }

  if (!isCollapseEnabled) {
    return children;
  }

  var _themes$theme = themes[theme],
      thBlurStyle = _themes$theme.thBlurStyle,
      thButton = _themes$theme.thButton;
  return __jsx("div", {
    className: className
  }, __jsx("div", {
    className: "overflow-hidden relative transition-heights",
    ref: ref,
    style: isCollapsable ? {
      height: isExpanded ? height : seeMoreSize
    } : null
  }, children, isCollapsable && __jsx("div", {
    className: classnames_default()('absolute bottom-0 w-full', {
      'opacity-0': isExpanded,
      'opacity-100': !isExpanded
    }),
    style: thBlurStyle
  })), isCollapsable && __jsx("div", {
    className: classNameButton
  }, __jsx("button", {
    className: thButton,
    onClick: function onClick(e) {
      setIsExpanded(!isExpanded);
      _onClick && _onClick(e);

      if (isExpanded && !hasNoScrollOnCollapse) {
        Object(scrollToElement["a" /* scrollToElement */])(ref.current, 300, ".".concat(offsetScrollSelector));
      }
    },
    type: "button"
  }, isExpanded ? seeLessLabel : seeMoreLabel, __jsx(Icon["a" /* Icon */], {
    className: "mx-1",
    name: isExpanded ? icons["a" /* ICONS */].MINUS : icons["a" /* ICONS */].PLUS,
    width: "0.7em"
  }))));
};

/***/ }),

/***/ "NWzG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaTransport; });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zygG");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("uDfI");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _filter_transport_FilterTransport_jsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("M3jp");
/* harmony import */ var _CriteriaTrigger_jsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+Rc+");
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("XiOS");
/* harmony import */ var _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("TYzI");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("kiXb");
/* harmony import */ var _store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("loSl");
/* harmony import */ var _store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("vIa8");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("RBO1");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("UCZK");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("MX/n");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("sW3P");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;















var CriteriaTransport = function CriteriaTransport(_ref) {
  var departureCitiesOptions = _ref.departureCitiesOptions,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_6__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(_CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_7__[/* useCriteriaDisplayContext */ "c"])(),
      _useCriteriaDisplayCo2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_useCriteriaDisplayCo, 2),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0],
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useDispatch */ "d"])();
  var departureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureCity */ "a"]);
  var facetingFilters = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_10__[/* filtersSelector */ "h"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_12__[/* useTracking */ "a"])({
    actionGA: criteriaContext.trackingActionName
  });

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(departureCity),
      inputDepartureCity = _useState[0],
      setInputDepartureCity = _useState[1];

  var noDepartureCitiesOptions = [{
    isDisabled: true,
    isSelected: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "f"])('booking.priceCalendar.priceStatus.noFlight'),
    value: ''
  }]; // Store update effect

  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    // 1. Sync local state with store updates
    if (inputDepartureCity !== departureCity) {
      setInputDepartureCity(departureCity);
    } // 2. Sync criteria validation with store updates


    setCriteriaContext({
      criteriaTransportIsSet: Boolean(departureCity)
    });
  }, [departureCity]);

  var openCriteriaEventHandler = function openCriteriaEventHandler() {
    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_7__[/* ACTIONS */ "a"].OPEN_CRITERIA,
      payload: 'criteriaTransport'
    });
  }; // Open/Close effect


  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_14__[/* OPEN_CRITERIA_TRANSPORT_EVENT */ "a"], openCriteriaEventHandler);
    return function () {
      return document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_14__[/* OPEN_CRITERIA_TRANSPORT_EVENT */ "a"], openCriteriaEventHandler);
    };
  }, []);

  var saveTransport = function saveTransport() {
    if (inputDepartureCity !== departureCity) {
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_9__[/* changeDepartureCity */ "a"])(inputDepartureCity));
    }

    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_7__[/* ACTIONS */ "a"].CLOSE_CRITERIA,
      payload: 'criteriaTransport'
    });
  };

  var getIcon = function getIcon() {
    if (departureCity === 'NO') {
      return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].NO_TRANSPORT;
    }

    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].TRANSPORT;
  };

  var getLabel = function getLabel() {
    if (!criteriaContext.criteriaTransportIsSet) {
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "f"])('faceting.transport.departingFrom');
    }

    var selectedOption = departureCitiesOptions.find(function (item) {
      return item.value === departureCity;
    });

    if (!selectedOption) {
      var departureCityFilter = facetingFilters.find(function (_ref2) {
        var id = _ref2.id;
        return id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_CITY_FACET_ID */ "j"];
      });
      return departureCityFilter ? departureCityFilter.label : '';
    }

    if (departureCity === 'NO') {
      return selectedOption.label;
    }

    return Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "f"])('faceting.transport.titleFrom', {
      location: selectedOption.label
    });
  };

  var buttonIsLoading = !departureCitiesOptions.length && isLoading && criteriaContext.criteriaTransportIsSet;

  var buttonLabel = __jsx("span", {
    className: "hidden lg:flex flex-row py-0 flex-1 overflow-hidden items-center whitespace-no-wrap button-default",
    style: {
      height: '1px'
    }
  }, getLabel());

  var trackDepartureCityChange = function trackDepartureCityChange(newDepartureCity) {
    if (newDepartureCity) {
      var labelGA = "departureCity_".concat(newDepartureCity);

      if (criteriaContext.trackingActionName) {
        track({
          labelGA: labelGA
        });
      }
    }
  };

  return __jsx(_CriteriaTrigger_jsx__WEBPACK_IMPORTED_MODULE_5__[/* CriteriaTrigger */ "a"], {
    buttonLabel: buttonLabel,
    buttonIcon: getIcon(),
    buttonIsFilled: criteriaContext.criteriaTransportIsSet,
    trackingLabel: "departureCity",
    isOpen: criteriaDisplayContext.criteriaTransportIsOpen,
    isJoyview: isJoyview,
    isLoading: buttonIsLoading,
    onClear: function onClear() {
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_9__[/* changeDepartureCity */ "a"])(''));
    },
    onOpen: function onOpen() {
      dispatchCriteriaDisplayContext({
        type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_7__[/* ACTIONS */ "a"].OPEN_CRITERIA,
        payload: 'criteriaTransport'
      });
    },
    onClose: saveTransport,
    buttons: [{
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "f"])('faceting.reset'),
      theme: 'link',
      onClick: function onClick() {
        setInputDepartureCity('');
      },
      className: 'text-sm cursor-pointer'
    }, {
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "f"])('faceting.validate'),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__[/* COLORS */ "a"].WHITE,
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_13__[/* COLORS */ "a"].TURQUOISE,
      onClick: saveTransport
    }]
  }, __jsx(_filter_transport_FilterTransport_jsx__WEBPACK_IMPORTED_MODULE_4__[/* FilterTransport */ "a"], {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "f"])('faceting.transport.subTitle'),
    optionsDepartureCities: !isLoading && !departureCitiesOptions.length ? noDepartureCitiesOptions : departureCitiesOptions,
    isDisabled: !isLoading && !departureCitiesOptions.length,
    isLoading: isLoading,
    informationLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "f"])('faceting.transport.comment'),
    changeDepartureCity: function changeDepartureCity(newDepartureCity) {
      setInputDepartureCity(newDepartureCity);
      trackDepartureCityChange(newDepartureCity);
    },
    departureCity: !departureCitiesOptions.length ? '' : inputDepartureCity,
    labelDepartingFrom: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "f"])('faceting.transport.departingFrom'),
    selectPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "f"])('faceting.transport.selectPlaceholder'),
    placeholderFrom: Object(_i18n__WEBPACK_IMPORTED_MODULE_8__[/* t */ "f"])('faceting.transport.titleFrom')
  }));
};

/***/ }),

/***/ "NrqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackSearchResults; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("uDfI");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hPQF");
/* harmony import */ var _store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("vIa8");
/* harmony import */ var _store_search_search_selector__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("B3yO");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("RBO1");
/* harmony import */ var _store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Jsmy");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_tracking_resort__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zCbR");
/* harmony import */ var _store_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("apzf");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}














var useTrackSearchResults = function useTrackSearchResults() {
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__[/* useTracking */ "a"])();
  var adults = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_8__[/* getAdults */ "a"])(state) || [];
  });
  var departureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__[/* getDepartureCity */ "a"])(state);
  });
  var departureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__[/* getDepartureDate */ "b"])(state);
  });
  var duration = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_7__[/* getTripDuration */ "c"])(state);
  });

  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__[/* facetingCriteriaSelector */ "c"])(state);
  }),
      _useSelector$filters = _useSelector.filters,
      filters = _useSelector$filters === void 0 ? [] : _useSelector$filters;

  var keywords = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_search_search_selector__WEBPACK_IMPORTED_MODULE_6__[/* keywordsSelector */ "a"])(state);
  });
  var kids = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_8__[/* getKids */ "c"])(state) || [];
  });
  var products = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__[/* filteredProductsSelector */ "g"])(state) || [];
  });
  var productsCount = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_5__[/* filteredProductsCountSelector */ "e"])(state) || 0;
  });
  var query = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (_ref) {
    var faceting = _ref.faceting;
    return faceting.query || {};
  });
  var redirection = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(function (_ref2) {
    var faceting = _ref2.faceting;
    return faceting.redirection;
  });
  var profile = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useSelector */ "e"])(_store_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_13__[/* userInfoSelector */ "a"]);
  var isFromAutoComplete = Boolean(query.type);
  var nbAdults = adults.length;
  var nbKids = kids.length;
  var nbParticipants = nbAdults + nbKids;
  var searchTerms = isFromAutoComplete || query.label ? query.label : keywords;
  var withFilter = Boolean(nbKids > 0 || duration || departureDate || departureCity || filters.length > 0);

  var executeTracking = function executeTracking(payload) {
    var _profile$loyaltyProgr;

    var searchResorts = products.map(function (product) {
      return {
        resortCode: product.id,
        resortName: product.name,
        resortTrident: product.comfort,
        resortCountry: product.destination ? product.destination.country : null,
        resortRegion: product.destination ? product.destination.area : null,
        resortAdult: nbAdults,
        resortChildren: nbKids,
        resortDepartureCityCode: departureCity,
        resortSeasonType: product.seasonName || 'Summer',
        resortUrlImage: product.image,
        versionBooking: 'responsive',
        resortSeason: departureDate && Object(_utils_tracking_resort__WEBPACK_IMPORTED_MODULE_12__[/* isSummer */ "e"])(new Date(departureDate)) ? 'Summer' : 'Winter',
        resortYearSeason: moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate).format('YYYY')
      };
    }); // $FlowFixMe

    track(_objectSpread({
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_9__[/* VIRTUAL_PAGE_LOAD */ "y"],
      internalSearchEngineNbResults: redirection ? 'redirection' : productsCount,
      pageName: 'shopping_home_search',
      resortAdult: nbAdults,
      resortChildren: nbKids,
      resortDepartureCityCode: departureCity,
      resortNightNumber: duration,
      resortTotalParticipant: nbParticipants,
      resortTransport: departureCity ? 'with Transport' : null,
      searchDate: moment__WEBPACK_IMPORTED_MODULE_3___default()().format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* DATE_FORMAT */ "g"]),
      searchDepartureDate: departureDate ? moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate).format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* DATE_FORMAT */ "g"]) : null,
      searchDestinationArea: Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* DESTINATIONS_FACET_ID */ "o"]),
      searchDestinationCountry: Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_4__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_11__[/* COUNTRIES_FACET_ID */ "f"]),
      searchFilter: withFilter ? 'withFilter' : 'withoutFilter',
      searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
      searchTerms: searchTerms || '',
      // $FlowFixMe - Could not get around an issue with Array<TrackingSearchResort>
      searchResorts: searchResorts,
      fidelityStatus: (profile === null || profile === void 0 ? void 0 : (_profile$loyaltyProgr = profile.loyaltyProgram) === null || _profile$loyaltyProgr === void 0 ? void 0 : _profile$loyaltyProgr.status) || ''
    }, payload)); // Reset searchReferrer after each pageView is sent.
    // If searchReferrer === "null", GTM will set it to "search"

    track({
      event: 'PUSH',
      searchReferrer: 'null'
    });
  };

  return executeTracking;
};

/***/ }),

/***/ "ODPy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productTripadvisorResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");




var productTripadvisorResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_TRIPADVISOR */ "tb"],
  resolve: function resolve() {
    var appContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments.length > 1 ? arguments[1] : undefined;
    var cmsContent = appContext.cmsContent,
        cmsRelease = appContext.cmsRelease;
    var cmsArgs = "content: \"".concat(cmsContent, "\", release:\"").concat(cmsRelease, "\"");
    var query = "query {\n      config {\n        common { next previous }\n      }\n      tripadvisor(resortId:\"".concat(props.resortId, "\") {\n        awards {\n          displayName\n          images {\n            large\n          }\n        }\n        numReviews\n        rating\n        ratingImageUrl\n        reviews {\n          title\n          text\n          url\n          rating\n          ratingImageUrl\n          reviewAuthor(").concat(cmsArgs, ")\n          publishedDate\n          reviewDate(").concat(cmsArgs, ")\n        }\n        subratings {\n          localizedName\n          ratingImageUrl\n          value\n        }\n        tripAdvisorUrl\n      },\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_TRIPADVISOR */ "Ec"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    })["catch"](function () {
      return {};
    });
  }
};

/***/ }),

/***/ "ORYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_SET_ADULTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIP_INFORMATION_UPDATE_ADULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ADULTS_NB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ADULT_VALUE; });
var TRIP_INFORMATION_SET_ADULTS_NUMBER = 'TRIP_INFORMATION_SET_ADULTS_NUMBER';
var TRIP_INFORMATION_UPDATE_ADULT = 'TRIP_INFORMATION_UPDATE_ADULT';
var SET_ATTENDEES = 'SET_ATTENDEES';
var SET_ADULTS = 'SET_ADULTS';
var DEFAULT_ADULTS_NB = 2;
var DEFAULT_ADULT_VALUE = {
  birthdate: undefined,
  civility: undefined,
  firstName: undefined,
  lastName: undefined,
  unicodeFirstName: undefined,
  unicodeLastName: undefined,
  neolid: undefined
};

/***/ }),

/***/ "Ohju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TemplateString; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;

var TEMPLATE_REGEXP = /{\w+}/g;

function escapeCurlyBrackets(string) {
  return (string.match(/\w+/) || [''])[0];
}

function generateTemplateNodes(_ref) {
  var staticClassName = _ref.staticClassName,
      _ref$template = _ref.template,
      template = _ref$template === void 0 ? '' : _ref$template,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? {} : _ref$values,
      _ref$valuesClassName = _ref.valuesClassName,
      valuesClassName = _ref$valuesClassName === void 0 ? {} : _ref$valuesClassName;
  var templateWithoutVariables = template.split(TEMPLATE_REGEXP) || [];
  var templateVariables = template.match(TEMPLATE_REGEXP) || [];
  return templateWithoutVariables.reduce(function (templateNodes, staticValue, index, array) {
    if (index === array.length - 1) {
      return templateNodes.concat([staticClassName && staticValue ? __jsx("span", {
        className: staticClassName,
        key: staticValue
      }, staticValue) : staticValue]);
    }

    var variableName = escapeCurlyBrackets(templateVariables[index]);
    return templateNodes.concat([staticClassName && staticValue ? __jsx("span", {
      className: staticClassName,
      key: staticValue
    }, staticValue) : staticValue, encapsulateWithClassName(values[variableName], variableName, valuesClassName[variableName])]);
  }, []);
}

function encapsulateWithClassName() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var keyName = arguments.length > 1 ? arguments[1] : undefined;
  var className = arguments.length > 2 ? arguments[2] : undefined;
  var v = value ? value.toString() : '';
  return className && v ? __jsx("span", {
    key: keyName,
    className: className
  }, v) : v;
}

var TemplateString = function TemplateString(_ref2) {
  var className = _ref2.className,
      dataTestId = _ref2.dataTestId,
      staticClassName = _ref2.staticClassName,
      _ref2$template = _ref2.template,
      template = _ref2$template === void 0 ? '' : _ref2$template,
      _ref2$values = _ref2.values,
      values = _ref2$values === void 0 ? {} : _ref2$values,
      valuesClassName = _ref2.valuesClassName;
  return template ? __jsx("span", {
    "data-testid": dataTestId,
    className: className
  }, generateTemplateNodes({
    staticClassName: staticClassName,
    template: template,
    values: values,
    valuesClassName: valuesClassName
  })) : null;
};

/***/ }),

/***/ "Onl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockLink; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("NJJ8");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qBqs");
/* harmony import */ var _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uRnh");





var __jsx = react__WEBPACK_IMPORTED_MODULE_5___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var BlockLink = /*#__PURE__*/function (_PureComponent) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(BlockLink, _PureComponent);

  var _super = _createSuper(BlockLink);

  function BlockLink() {
    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, BlockLink);

    return _super.apply(this, arguments);
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(BlockLink, [{
    key: "renderTexts",
    value: function renderTexts() {
      var texts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _this$props$theme = this.props.theme,
          theme = _this$props$theme === void 0 ? 'default' : _this$props$theme;
      return texts.filter(function (text) {
        return !Object(lodash__WEBPACK_IMPORTED_MODULE_6__["isEmpty"])(text);
      }).map(function (text, idx) {
        return __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(classes, _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__[/* themes */ "a"][theme]["thCustomText".concat(idx)]),
          "data-testid": "BlockLink-text",
          key: idx
        }, text);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          icon = _this$props.icon,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === void 0 ? function () {} : _this$props$onClick,
          _this$props$secondary = _this$props.secondaryTexts,
          secondaryTexts = _this$props$secondary === void 0 ? [] : _this$props$secondary,
          _this$props$target = _this$props.target,
          target = _this$props$target === void 0 ? '_blank' : _this$props$target,
          _this$props$texts = _this$props.texts,
          texts = _this$props$texts === void 0 ? [] : _this$props$texts,
          _this$props$theme2 = _this$props.theme,
          theme = _this$props$theme2 === void 0 ? 'default' : _this$props$theme2,
          trackingData = _this$props.trackingData,
          _this$props$url = _this$props.url,
          url = _this$props$url === void 0 ? '' : _this$props$url;
      var title = (texts || []).filter(function (t) {
        return typeof t === 'string';
      }).join(' ');
      var linkTarget = url.startsWith('tel:') ? '' : target;
      var _themes$theme = _BlockLink_themes__WEBPACK_IMPORTED_MODULE_10__[/* themes */ "a"][theme],
          thIcon = _themes$theme.thIcon,
          thIconWidth = _themes$theme.thIconWidth,
          thRoot = _themes$theme.thRoot,
          thTexts = _themes$theme.thTexts,
          thSText = _themes$theme.thSText;
      return !!texts.length || icon ? __jsx(_tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_8__[/* TrackClick */ "a"], {
        as: "a",
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(className, thRoot),
        href: url,
        onClick: onClick,
        rel: "noopener noreferrer",
        target: linkTarget,
        title: title,
        trackingData: trackingData
      }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('flex-shrink-0', thIcon),
        name: icon,
        width: thIconWidth
      }), !!texts.length && __jsx("span", {
        className: thTexts
      }, this.renderTexts(texts), this.renderTexts(secondaryTexts, thSText))) : null;
    }
  }]);

  return BlockLink;
}(react__WEBPACK_IMPORTED_MODULE_5__["PureComponent"]);

/***/ }),

/***/ "PCgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridCell; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("I6kL");






var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function getClass(prop, key, css) {
  // $FlowFixMe
  return prop.hasOwnProperty(key) && Object(lodash__WEBPACK_IMPORTED_MODULE_8__["isInteger"])(prop[key]) && prop[key] > 0 ? " ".concat(key).concat(css).concat(prop[key]) : '';
}

function getResponsiveClasses(_ref) {
  var _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_CELL_COLS */ "b"] : _ref$cols,
      _ref$offsets = _ref.offsets,
      offsets = _ref$offsets === void 0 ? {} : _ref$offsets;

  var cellCols = _objectSpread(_objectSpread({}, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_CELL_COLS */ "b"]), cols);

  return Object.keys(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"]).map(function (key) {
    return getClass(cellCols, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"][key], '-GridCell--') + getClass(offsets, _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_9__[/* BREAKPOINTS */ "a"][key], '-GridCell--offset-');
  }).join('');
}

var GridCell = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(GridCell, _React$Component);

  var _super = _createSuper(GridCell);

  function GridCell() {
    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, GridCell);

    return _super.apply(this, arguments);
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(GridCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          id = _this$props.id;
      if (!react__WEBPACK_IMPORTED_MODULE_6__["Children"].count(children)) return null;
      return __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(className, 'flex-1 max-w-full', "GridCell".concat(getResponsiveClasses(this.props))),
        id: id
      }, children);
    }
  }]);

  return GridCell;
}(react__WEBPACK_IMPORTED_MODULE_6___default.a.Component);

/***/ }),

/***/ "PFCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_DEPARTURE_CITY; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cvSI");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _constants__WEBPACK_IMPORTED_MODULE_0__["u"]; });


var DEFAULT_DEPARTURE_CITY = 'NO';

/***/ }),

/***/ "PFSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_WHO_EVENT; });
var OPEN_CRITERIA_WHO_EVENT = 'openCriteriaWho';

/***/ }),

/***/ "PSHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATUS_CODE_200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_CODE_400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STATUS_CODE_401; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATUS_CODE_404; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STATUS_CODE_409; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STATUS_CODE_500; });
var STATUS_CODE_200 = 200;
var STATUS_CODE_400 = 400;
var STATUS_CODE_401 = 401;
var STATUS_CODE_404 = 404;
var STATUS_CODE_409 = 409;
var STATUS_CODE_500 = 500;

/***/ }),

/***/ "PT2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediaTextHorizontalResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var mediaTextHorizontalResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* MEDIA_TEXT_HORIZONTAL */ "u"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common {\n          close\n          seeMore\n          loadLess\n        }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_COMMON_I18N */ "c"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "PZXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ WebCallbackTrigger; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx + 1 modules
var SidePanel = __webpack_require__("p7XS");

// EXTERNAL MODULE: ./src/client/components/frameworks/block-link/BlockLink.themes.js
var BlockLink_themes = __webpack_require__("uRnh");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /home/circleci/project/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackFields.jsx

var __jsx = react_default.a.createElement;





function GroupedSelect(_ref) {
  var fieldName = _ref.fieldName,
      position = _ref.position,
      width = _ref.width,
      options = _ref.options,
      onChange = _ref.onChange;
  return __jsx(formik_esm["b" /* Field */], {
    name: fieldName
  }, function (_ref2) {
    var field = _ref2.field,
        errors = _ref2.form.errors;
    return __jsx("div", {
      className: classnames_default()("relative inline-block w-".concat(width, " border-1 overflow-hidden"), {
        'border-r-0': position === 'left',
        'rounded-l-small': position === 'left',
        'rounded-r-small': position === 'right',
        'border-success': !errors[field.name],
        'border-danger': errors[field.name]
      })
    }, __jsx("select", Object(esm_extends["a" /* default */])({
      autoComplete: "off",
      className: "reset-input reset-select relative text-current w-full bg-white px-3 py-2"
    }, field, onChange ? {
      onChange: onChange
    } : null), options.map(function (_ref3) {
      var value = _ref3.value,
          name = _ref3.name;
      return __jsx("option", {
        key: name,
        value: value
      }, name);
    })), __jsx("div", {
      className: "absolute flex h-full items-center top-0 rtl:right-0 pointer-events-none px-2 text-current"
    }, __jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].SELECT,
      width: "0.75rem"
    })));
  });
}
function GroupedInput(_ref4) {
  var fieldName = _ref4.fieldName,
      position = _ref4.position,
      width = _ref4.width,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? 'text' : _ref4$type,
      _ref4$required = _ref4.required,
      required = _ref4$required === void 0 ? false : _ref4$required;
  return __jsx(formik_esm["b" /* Field */], {
    name: fieldName
  }, function (_ref5) {
    var field = _ref5.field,
        _ref5$form = _ref5.form,
        touched = _ref5$form.touched,
        errors = _ref5$form.errors;
    return __jsx("input", Object(esm_extends["a" /* default */])({
      type: type,
      required: required
    }, field, {
      className: classnames_default()("outline-none shadows-none inline-block w-".concat(width, " px-3 py-2 align-top text-current bg-white border-1"), {
        'border-r-0': position === 'left',
        'rounded-l-small': position === 'left',
        'rounded-r-small': position === 'right',
        'border-gray-medium': !touched[field.name],
        'border-success': touched[field.name] && !errors[field.name],
        'border-danger': touched[field.name] && errors[field.name]
      })
    }));
  });
}
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackForm.utils.js




/* eslint-disable space-before-function-paren */






var ACCOUNT_ID = config_default.a.get('freespee.accountId');
var AGENT_NUMBER = config_default.a.get('freespee.agentNumber');
var AGENT_NUMBER_ID = config_default.a.get('freespee.agentNumberId');
var CALLER_ID = config_default.a.get('freespee.callerId') || '';
var CUSTOMER_ID = config_default.a.get('freespee.customerId');
var FREESPEE_DATE_FORMAT = 'YYYY-MM-DD';
var FREESPEE_TIME_FORMAT = 'HH:mm:ss';
var FREESPEE_DATETIME_FORMAT = "".concat(FREESPEE_DATE_FORMAT, " ").concat(FREESPEE_TIME_FORMAT);
var DISPLAY_TIME_FORMAT = 'HH:mm';
var RETRIES = '2';
var RETRY_INTERVAL = '120';
var ASAP_TIME = 'ASAP';
var CALLBACK_STATUS = {
  UNSCHEDULED: 'unscheduled',
  SCHEDULED: 'scheduled',
  ERROR: 'error'
};
var PHONE_PREFIXES = [{
  countryCode: 'AL',
  value: 355,
  name: '+355 (AL)'
}, {
  countryCode: 'AR',
  value: 54,
  name: '+54 (AR)'
}, {
  countryCode: 'AT',
  value: 43,
  name: '+43 (AT)'
}, {
  countryCode: 'AU',
  value: 61,
  name: '+61 (AU)'
}, {
  countryCode: 'BA',
  value: 387,
  name: '+387 (BA)'
}, {
  countryCode: 'BE',
  value: 32,
  name: '+32 (BE)'
}, {
  countryCode: 'BG',
  value: 359,
  name: '+359 (BG)'
}, {
  countryCode: 'BR',
  value: 55,
  name: '+55 (BR)'
}, {
  countryCode: 'CA',
  value: 1,
  name: '+1 (CA)'
}, {
  countryCode: 'CH',
  value: 41,
  name: '+41 (CH)'
}, {
  countryCode: 'CL',
  value: 56,
  name: '+56 (CL)'
}, {
  countryCode: 'CN',
  value: 86,
  name: '+86 (CN)'
}, {
  countryCode: 'CY',
  value: 357,
  name: '+357 (CY)'
}, {
  countryCode: 'CZ',
  value: 420,
  name: '+420 (CZ)'
}, {
  countryCode: 'DE',
  value: 49,
  name: '+49 (DE)'
}, {
  countryCode: 'DK',
  value: 45,
  name: '+45 (DK)'
}, {
  countryCode: 'EE',
  value: 372,
  name: '+372 (EE)'
}, {
  countryCode: 'EG',
  value: 20,
  name: '+20 (EG)'
}, {
  countryCode: 'ES',
  value: 34,
  name: '+34 (ES)'
}, {
  countryCode: 'FI',
  value: 358,
  name: '+358 (FI)'
}, {
  countryCode: 'FR',
  value: 33,
  name: '+33 (FR)'
}, {
  countryCode: 'GB',
  value: 44,
  name: '+44 (GB)'
}, {
  countryCode: 'GI',
  value: 350,
  name: '+350 (GI)'
}, {
  countryCode: 'GR',
  value: 30,
  name: '+30 (GR)'
}, {
  countryCode: 'HK',
  value: 852,
  name: '+852 (HK)'
}, {
  countryCode: 'HR',
  value: 385,
  name: '+385 (HR)'
}, {
  countryCode: 'HU',
  value: 36,
  name: '+36 (HU)'
}, {
  countryCode: 'IE',
  value: 353,
  name: '+353 (IE)'
}, {
  countryCode: 'IL',
  value: 972,
  name: '+972 (IL)'
}, {
  countryCode: 'IN',
  value: 91,
  name: '+91 (IN)'
}, {
  countryCode: 'IR',
  value: 98,
  name: '+98 (IR)'
}, {
  countryCode: 'IS',
  value: 354,
  name: '+354 (IS)'
}, {
  countryCode: 'IT',
  value: 39,
  name: '+39 (IT)'
}, {
  countryCode: 'JP',
  value: 81,
  name: '+81 (JP)'
}, {
  countryCode: 'LB',
  value: 961,
  name: '+961 (LB)'
}, {
  countryCode: 'LT',
  value: 370,
  name: '+370 (LT)'
}, {
  countryCode: 'LU',
  value: 352,
  name: '+352 (LU)'
}, {
  countryCode: 'LV',
  value: 371,
  name: '+371 (LV)'
}, {
  countryCode: 'MC',
  value: 377,
  name: '+377 (MC)'
}, {
  countryCode: 'MD',
  value: 373,
  name: '+373 (MD)'
}, {
  countryCode: 'MT',
  value: 356,
  name: '+356 (MT)'
}, {
  countryCode: 'MX',
  value: 52,
  name: '+52 (MX)'
}, {
  countryCode: 'NL',
  value: 31,
  name: '+31 (NL)'
}, {
  countryCode: 'NO',
  value: 47,
  name: '+47 (NO)'
}, {
  countryCode: 'NZ',
  value: 64,
  name: '+64 (NZ)'
}, {
  countryCode: 'PA',
  value: 507,
  name: '+507 (PA)'
}, {
  countryCode: 'PE',
  value: 51,
  name: '+51 (PE)'
}, {
  countryCode: 'PK',
  value: 92,
  name: '+92 (PK)'
}, {
  countryCode: 'PL',
  value: 48,
  name: '+48 (PL)'
}, {
  countryCode: 'PT',
  value: 351,
  name: '+351 (PT)'
}, {
  countryCode: 'RO',
  value: 40,
  name: '+40 (RO)'
}, {
  countryCode: 'RS',
  value: 381,
  name: '+381 (RS)'
}, {
  countryCode: 'RU',
  value: 7,
  name: '+7 (RU)'
}, {
  countryCode: 'SE',
  value: 46,
  name: '+46 (SE)'
}, {
  countryCode: 'SG',
  value: 65,
  name: '+65 (SG)'
}, {
  countryCode: 'SI',
  value: 386,
  name: '+386 (SI)'
}, {
  countryCode: 'SK',
  value: 421,
  name: '+421 (SK)'
}, {
  countryCode: 'TH',
  value: 66,
  name: '+66 (TH)'
}, {
  countryCode: 'TR',
  value: 90,
  name: '+90 (TR)'
}, {
  countryCode: 'US',
  value: 1,
  name: '+1 (US)'
}, {
  countryCode: 'ZA',
  value: 27,
  name: '+27 (ZA)'
}];

function hasNameInSlots(slots, name) {
  return slots.some(function (slot) {
    return slot.name === name;
  });
}

var WebCallbackForm_utils_getTimeSlots = function getTimeSlots(_ref) {
  var openingTimesPerDay = _ref.openingTimesPerDay,
      i18n = _ref.i18n;
  if (!openingTimesPerDay) return [];
  var openDays = Object.keys(openingTimesPerDay);
  var asap = i18n.asap,
      today = i18n.today,
      tomorrow = i18n.tomorrow;
  var maxDaysInTheFuture = 7;

  var daysOfWeek = Object(toConsumableArray["a" /* default */])(Array(maxDaysInTheFuture).keys()).map(function (day) {
    return moment_default()().utc().add(day, 'd').locale('en').format('ddd').toLowerCase();
  });

  return Object(toConsumableArray["a" /* default */])(Array(maxDaysInTheFuture).keys()).filter(function (day) {
    var dayOfWeek = moment_default()().utc().add(day, 'd').locale('en').format('ddd');
    return openDays.includes(dayOfWeek.toLowerCase());
  }).map(function (day, idx) {
    var slots = [];
    var dayLabel = daysOfWeek[day];
    var openingTimes = openingTimesPerDay[dayLabel];
    var now = moment_default.a.utc().add(day, 'd');
    var dayOfWeek = now.calendar(null, {
      sameDay: "[".concat(Object(lodash["upperFirst"])(today), "]"),
      nextDay: "[".concat(Object(lodash["upperFirst"])(tomorrow), "]"),
      nextWeek: 'dddd',
      sameElse: 'dddd'
    });
    openingTimes === null || openingTimes === void 0 ? void 0 : openingTimes.forEach(function (openingTime) {
      var _openingTime$from$spl = openingTime.from.split(':'),
          _openingTime$from$spl2 = Object(slicedToArray["a" /* default */])(_openingTime$from$spl, 2),
          beginHour = _openingTime$from$spl2[0],
          beginMinute = _openingTime$from$spl2[1];

      var begin = moment_default.a.utc().startOf('day').hour(parseInt(beginHour, 10)).minute(parseInt(beginMinute, 10));

      var _openingTime$to$split = openingTime.to.split(':'),
          _openingTime$to$split2 = Object(slicedToArray["a" /* default */])(_openingTime$to$split, 2),
          endHour = _openingTime$to$split2[0],
          endMinute = _openingTime$to$split2[1];

      var end = moment_default.a.utc().startOf('day').hour(parseInt(endHour, 10)).minute(parseInt(endMinute, 10));
      var current = begin;

      if (idx === 0) {
        current = moment_default.a.max(now, begin).add(1, 'h').startOf('h');

        if (!hasNameInSlots(slots, Object(lodash["upperFirst"])(asap))) {
          slots.push({
            value: ASAP_TIME,
            name: Object(lodash["upperFirst"])(asap)
          });
        }
      }

      while (current.isBefore(end)) {
        var value = current.format(FREESPEE_DATETIME_FORMAT);
        var slotStart = current.format(DISPLAY_TIME_FORMAT);
        current.add(30, 'm');
        var slotEnd = current.format(DISPLAY_TIME_FORMAT);
        var name = "".concat(slotStart, " - ").concat(slotEnd);

        if (!hasNameInSlots(slots, name)) {
          slots.push({
            value: value,
            name: name
          });
        }
      }
    });
    return {
      value: now.format(FREESPEE_DATE_FORMAT),
      name: Object(lodash["upperFirst"])(dayOfWeek),
      slots: slots
    };
  });
};

function concatIntervalsPerDay(openingTimesPerDay, weekday) {
  var _weekday$intervals;

  if (!(weekday === null || weekday === void 0 ? void 0 : weekday.intervals)) return openingTimesPerDay;
  var openingTimeInterval = weekday === null || weekday === void 0 ? void 0 : (_weekday$intervals = weekday.intervals) === null || _weekday$intervals === void 0 ? void 0 : _weekday$intervals.map(function (interval) {
    return {
      from: interval === null || interval === void 0 ? void 0 : interval.openingTime,
      to: interval === null || interval === void 0 ? void 0 : interval.closingTime
    };
  });

  if (openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day]) {
    openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day] = openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day].concat(openingTimeInterval);
  } else {
    openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day] = openingTimeInterval;
  }

  return openingTimesPerDay;
}

var fetchOpeningHours = /*#__PURE__*/function () {
  var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2, appContext) {
    var setOpeningTimesPerDay, query, data, _openingTimesPerDay;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setOpeningTimesPerDay = _ref2.setOpeningTimesPerDay;
            query = "query {\n    webCallbackHours(customerId: \"".concat(CUSTOMER_ID, "\") {\n      weekdays {\n        day\n        intervals {\n          openingTime\n          closingTime\n        }\n      }\n    }\n  }");
            _context.prev = 2;
            _context.next = 5;
            return graphqlClient["a" /* default */].runQuery(query, appContext, {
              requestName: requestDictionary["Od" /* WIDGET_WEBCALLBACK_OPENING_HOURS */]
            });

          case 5:
            data = _context.sent;
            _openingTimesPerDay = data.webCallbackHours.weekdays.reduce(concatIntervalsPerDay, {});
            if (_openingTimesPerDay && !Object(lodash["isEmpty"])(_openingTimesPerDay)) setOpeningTimesPerDay(_openingTimesPerDay);
            _context.next = 12;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));

  return function fetchOpeningHours(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
var submitCallback = /*#__PURE__*/function () {
  var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref4, appContext) {
    var scheduled, requesterNumber, setCallbackStatus, setSubmitting, schedule, query, _ref6, webCallback;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            scheduled = _ref4.scheduled, requesterNumber = _ref4.requesterNumber, setCallbackStatus = _ref4.setCallbackStatus, setSubmitting = _ref4.setSubmitting;
            schedule = scheduled ? "\"".concat(scheduled, "\"") : 'null';
            query = "mutation {\n    webCallback(\n      agentNumber: \"".concat(AGENT_NUMBER, "\",\n      callerId: \"").concat(CALLER_ID, "\",\n      customerId: \"").concat(CUSTOMER_ID, "\",\n      webCallbackInput: {\n        requesterNumber: \"").concat(requesterNumber, "\",\n        scheduled: ").concat(schedule, ",\n        retries: ").concat(RETRIES, ",\n        retryInterval: ").concat(RETRY_INTERVAL, "\n      }) {\n      ... on WebCallback {\n        id\n        type\n        agentNumber\n        callerId\n        requesterNumber\n        retries\n        retryInterval\n      }\n      ... on WebCallbackError {\n        errorCode\n        errorDescription\n        errorKey\n        errorValue        \n      }\n    }\n  }");
            _context2.prev = 3;
            _context2.next = 6;
            return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
              requestName: requestDictionary["Pd" /* WIDGET_WEBCALLBACK_SCHEDULE_CALL */]
            });

          case 6:
            _ref6 = _context2.sent;
            webCallback = _ref6.webCallback;

            if (webCallback.errorCode) {
              setCallbackStatus(CALLBACK_STATUS.ERROR);
            } else {
              setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
            }

            _context2.next = 14;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](3);
            setCallbackStatus(CALLBACK_STATUS.ERROR);

          case 14:
            _context2.prev = 14;
            setSubmitting(false);
            return _context2.finish(14);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 11, 14, 17]]);
  }));

  return function submitCallback(_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();
var requestCallback = function requestCallback(_ref7) {
  var scheduled = _ref7.scheduled,
      requesterNumber = _ref7.requesterNumber,
      requesterNumberPrefix = _ref7.requesterNumberPrefix,
      setCallbackStatus = _ref7.setCallbackStatus,
      setSubmitting = _ref7.setSubmitting;

  try {
    window.__fs_dncs_instance.requestCallback(ACCOUNT_ID, // AVD_ID
    AGENT_NUMBER_ID, // Answering_number_id
    requesterNumberPrefix, // Country_code
    requesterNumber, // customer_phonenr
    CALLER_ID, // caller_id
    {}, // custom_*
    scheduled ? scheduled : null, // call_time,
    function (ref, data) {
      var status = data.status,
          callId = data.call_uuid;

      if (status === 'ok' && callId) {
        setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
      } else {
        setCallbackStatus(CALLBACK_STATUS.ERROR);
      }

      setSubmitting(false);
    }, null, RETRIES // retries
    );
  } catch (error) {
    setCallbackStatus(CALLBACK_STATUS.ERROR);
    setSubmitting(false);
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackForm.jsx


var WebCallbackForm_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var DEFAULT_OPENING_TIME = '10:00:00';
var DEFAULT_CLOSING_TIME = '18:00:00';
var DEFAULT_OPENING_TIMES_PER_DAY = {
  mon: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  tue: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  wed: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  thu: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  fri: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  sat: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  sun: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }]
};
function WebCallbackForm(_ref) {
  var _currentDay$slots, _currentDay$slots$;

  var callbackStatus = _ref.callbackStatus,
      setCallbackStatus = _ref.setCallbackStatus,
      trackingData = _ref.trackingData;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var track = Object(useTracking["a" /* useTracking */])(); // These are UTC times, like what Freespee returns in from_time, to_time.

  var _useState = Object(react["useState"])(DEFAULT_OPENING_TIMES_PER_DAY),
      openingTimesPerDay = _useState[0],
      setOpeningTimesPerDay = _useState[1];

  var timeSlots = Object(react["useMemo"])(function () {
    return WebCallbackForm_utils_getTimeSlots({
      openingTimesPerDay: openingTimesPerDay,
      i18n: {
        asap: Object(src_i18n["f" /* t */])('common.dateTime.asap'),
        today: Object(src_i18n["f" /* t */])('common.dateTime.today'),
        tomorrow: Object(src_i18n["f" /* t */])('common.dateTime.tomorrow')
      }
    });
  }, [openingTimesPerDay]);

  var _timeSlots = Object(slicedToArray["a" /* default */])(timeSlots, 1),
      initialDay = _timeSlots[0];

  var _useState2 = Object(react["useState"])(initialDay),
      currentDay = _useState2[0],
      setCurrentDay = _useState2[1];

  Object(react["useEffect"])(function () {
    fetchOpeningHours({
      setOpeningTimesPerDay: setOpeningTimesPerDay
    }, appContext);
  }, []);
  Object(react["useEffect"])(function () {
    var _timeSlots2 = Object(slicedToArray["a" /* default */])(timeSlots, 1),
        newDay = _timeSlots2[0];

    setCurrentDay(newDay);
  }, [timeSlots]);
  if (!currentDay) return null;
  var localPhonePrefix = PHONE_PREFIXES.find(function (prefix) {
    var country = appContext.locale.split('-')[1];
    return country === prefix.countryCode;
  });
  var initialPhonePrefix = localPhonePrefix || PHONE_PREFIXES.find(function (prefix) {
    return prefix.countryCode === 'FR';
  }) || {};

  var changeDay = function changeDay(event, setFieldValue) {
    var dayValue = event.target.value;
    var newDay = timeSlots.find(function (slot) {
      return slot.value === dayValue;
    });

    if (newDay) {
      setCurrentDay(newDay);
      setFieldValue('slotDay', newDay.value, false);
    }
  };

  return WebCallbackForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      slotDay: currentDay.value,
      slotTime: currentDay === null || currentDay === void 0 ? void 0 : (_currentDay$slots = currentDay.slots) === null || _currentDay$slots === void 0 ? void 0 : (_currentDay$slots$ = _currentDay$slots[0]) === null || _currentDay$slots$ === void 0 ? void 0 : _currentDay$slots$.value,
      phonePrefix: initialPhonePrefix.value,
      phoneNumber: ''
    },
    validate: function validate(_ref2) {
      var phoneNumber = _ref2.phoneNumber;
      var errors = {};

      if (!phoneNumber) {
        errors.phoneNumber = 'Phone number is required';
      } // https://www.twilio.com/docs/glossary/what-e164


      if (!/^[1-9]\d{1,14}$/.test(phoneNumber)) {
        errors.phoneNumber = 'Phone number is not valid';
      }

      return errors;
    },
    onSubmit: function onSubmit(formValues, _ref3) {
      var setSubmitting = _ref3.setSubmitting;
      var slotTime = formValues.slotTime,
          phonePrefix = formValues.phonePrefix,
          phoneNumber = formValues.phoneNumber;
      requestCallback({
        scheduled: slotTime === ASAP_TIME ? null : slotTime,
        requesterNumber: "+".concat(phonePrefix).concat(phoneNumber),
        requesterNumberPrefix: phonePrefix,
        setCallbackStatus: setCallbackStatus,
        setSubmitting: setSubmitting
      });
      track(_objectSpread({
        categoryGA: pageContext.pageId,
        labelGA: tracking_constants["A" /* WEB_CALLBACK_SUBMIT */]
      }, trackingData));
    }
  }, function (_ref4) {
    var isValid = _ref4.isValid,
        isSubmitting = _ref4.isSubmitting,
        setFieldValue = _ref4.setFieldValue;
    var isDisabled = callbackStatus !== CALLBACK_STATUS.UNSCHEDULED || !isValid;
    return WebCallbackForm_jsx(formik_esm["c" /* Form */], {
      "data-testid": "web-callback-form",
      className: "h-full"
    }, WebCallbackForm_jsx("div", {
      className: "flex flex-col justify-between h-full w-full bg-gray-200"
    }, WebCallbackForm_jsx("div", {
      className: "w-full bg-ardoise",
      style: {
        backgroundImage: "url(\"".concat(Object(src_i18n["f" /* t */])('webCallback.picture'), "\")"),
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '150px'
      }
    }), WebCallbackForm_jsx("div", {
      className: "flex-auto px-6 py-5"
    }, WebCallbackForm_jsx("h3", {
      className: "my-0",
      id: constants["y" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */]
    }, Object(src_i18n["f" /* t */])('webCallback.title')), WebCallbackForm_jsx("p", null, Object(src_i18n["f" /* t */])('webCallback.subtitle')), callbackStatus !== CALLBACK_STATUS.UNSCHEDULED ? WebCallbackForm_jsx(Notification["a" /* Notification */], {
      color: callbackStatus === CALLBACK_STATUS.SCHEDULED ? colors["a" /* COLORS */].SUCCESS : colors["a" /* COLORS */].WARNING,
      hasBorder: true,
      icon: callbackStatus === CALLBACK_STATUS.SCHEDULED ? icons["a" /* ICONS */].SMALL_CIRCLE_CHECK : icons["a" /* ICONS */].CIRCLED_CROSS,
      iconWidth: "1rem"
    }, WebCallbackForm_jsx("p", {
      className: "m-0 text-base text-".concat(callbackStatus === CALLBACK_STATUS.SCHEDULED ? colors["a" /* COLORS */].SUCCESS : colors["a" /* COLORS */].WARNING)
    }, callbackStatus === CALLBACK_STATUS.SCHEDULED ? Object(src_i18n["f" /* t */])('webCallback.successMessage') : Object(src_i18n["f" /* t */])('webCallback.errorMessage'))) : WebCallbackForm_jsx(react["Fragment"], null, WebCallbackForm_jsx("div", {
      className: "inline-block w-full md:w-3/5 mb-3 md:pr-2"
    }, WebCallbackForm_jsx("label", {
      className: "block w-full p-1 text-sm"
    }, Object(src_i18n["f" /* t */])('webCallback.timeLabel')), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "slotDay",
      position: "left",
      width: "2/5" // $FlowFixMe
      ,
      options: timeSlots,
      onChange: function onChange(e) {
        return changeDay(e, setFieldValue);
      }
    }), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "slotTime",
      position: "right",
      width: "3/5" // $FlowFixMe
      ,
      options: currentDay.slots
    })), WebCallbackForm_jsx("div", {
      className: "inline-block w-full md:w-2/5 mb-3"
    }, WebCallbackForm_jsx("label", {
      className: "block w-full p-1 text-sm"
    }, Object(src_i18n["f" /* t */])('webCallback.phoneLabel')), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "phonePrefix",
      position: "left",
      width: "1/2",
      options: PHONE_PREFIXES
    }), WebCallbackForm_jsx(GroupedInput, {
      fieldName: "phoneNumber",
      position: "right",
      width: "1/2",
      type: "tel",
      required: true
    })))), WebCallbackForm_jsx("div", {
      className: "flex justify-end px-6 w-full",
      style: {
        minHeight: '3.75rem'
      }
    }, callbackStatus === CALLBACK_STATUS.UNSCHEDULED ? WebCallbackForm_jsx(Button["a" /* Button */], {
      className: "self-center w-full md:w-1/2 text-center",
      type: "submit",
      isLoading: isSubmitting,
      isDisabled: isDisabled
    }, Object(src_i18n["f" /* t */])('webCallback.callToAction')) : null)));
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackTrigger.jsx

var WebCallbackTrigger_jsx = react_default.a.createElement;

function WebCallbackTrigger_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function WebCallbackTrigger_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WebCallbackTrigger_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WebCallbackTrigger_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function WebCallbackTrigger(_ref) {
  var trackingData = _ref.trackingData,
      children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet,
      isAppMounted = _useContext.isAppMounted;

  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var track = Object(useTracking["a" /* useTracking */])();

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = Object(react["useState"])(CALLBACK_STATUS.UNSCHEDULED),
      callbackStatus = _useState2[0],
      setCallbackStatus = _useState2[1];

  var webCallbackModal = isOpen ? WebCallbackTrigger_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["f" /* t */])('webCallback.title'),
    ariaLabelledby: constants["y" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */],
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, WebCallbackTrigger_jsx(WebCallbackForm, {
    callbackStatus: callbackStatus,
    setCallbackStatus: setCallbackStatus,
    trackingData: trackingData
  })) : null;

  var webCallbackDrawer = WebCallbackTrigger_jsx(SidePanel["a" /* SidePanel */], {
    ariaLabel: Object(src_i18n["f" /* t */])('webCallback.title'),
    ariaLabelledby: constants["y" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */],
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    isExpanded: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, WebCallbackTrigger_jsx("div", {
    className: "h-full w-full fadeIn"
  }, WebCallbackTrigger_jsx(WebCallbackForm, {
    callbackStatus: callbackStatus,
    setCallbackStatus: setCallbackStatus,
    trackingData: trackingData
  })));

  var webCallbackPopin = isTablet ? webCallbackModal : webCallbackDrawer;
  return WebCallbackTrigger_jsx(react["Fragment"], null, isAppMounted ? webCallbackPopin : null, WebCallbackTrigger_jsx("button", {
    type: "button",
    className: classnames_default()(BlockLink_themes["a" /* themes */][theme].thRoot, 'bg-transparent'),
    onClick: function onClick() {
      setCallbackStatus(CALLBACK_STATUS.UNSCHEDULED);
      setIsOpen(true);

      if (isOpen === false && trackingData) {
        track(WebCallbackTrigger_objectSpread({
          categoryGA: pageContext.pageId,
          labelGA: tracking_constants["z" /* WEB_CALLBACK_OPEN */]
        }, trackingData));
      }
    }
  }, children));
}

/***/ }),

/***/ "Phb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__("ERkP");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("aWzz");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _subscribeUiEvent = __webpack_require__("GJxp");

var _classnames = __webpack_require__("O94r");

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__("Pu0A");

var _shallowequal2 = _interopRequireDefault(_shallowequal);

// constants
var STATUS_ORIGINAL = 0; // The default status, locating at the original position.
var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.
var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.

var TRANSFORM_PROP = 'transform';

// global variable for all instances
var doc;
var docBody;
var docEl;
var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr
var M;
var scrollDelta = 0;
var win;
var winHeight = -1;

var Sticky = (function (_Component) {
    _inherits(Sticky, _Component);

    function Sticky(props, context) {
        _classCallCheck(this, Sticky);

        _get(Object.getPrototypeOf(Sticky.prototype), 'constructor', this).call(this, props, context);
        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleScrollStart = this.handleScrollStart.bind(this);
        this.delta = 0;
        this.stickyTop = 0;
        this.stickyBottom = 0;
        this.frozen = false;
        this.skipNextScrollEvent = false;
        this.scrollTop = -1;

        this.bottomBoundaryTarget;
        this.topTarget;
        this.subscribers;

        this.state = {
            top: 0, // A top offset from viewport top where Sticky sticks to when scrolling up
            bottom: 0, // A bottom offset from viewport top where Sticky sticks to when scrolling down
            width: 0, // Sticky width
            height: 0, // Sticky height
            x: 0, // The original x of Sticky
            y: 0, // The original y of Sticky
            topBoundary: 0, // The top boundary on document
            bottomBoundary: Infinity, // The bottom boundary on document
            status: STATUS_ORIGINAL, // The Sticky status
            pos: 0, // Real y-axis offset for rendering position-fixed and position-relative
            activated: false // once browser info is available after mounted, it becomes true to avoid checksum error
        };
    }

    _createClass(Sticky, [{
        key: 'getTargetHeight',
        value: function getTargetHeight(target) {
            return target && target.offsetHeight || 0;
        }
    }, {
        key: 'getTopPosition',
        value: function getTopPosition(top) {
            // a top argument can be provided to override reading from the props
            top = top || this.props.top || 0;
            if (typeof top === 'string') {
                if (!this.topTarget) {
                    this.topTarget = doc.querySelector(top);
                }
                top = this.getTargetHeight(this.topTarget);
            }
            return top;
        }
    }, {
        key: 'getTargetBottom',
        value: function getTargetBottom(target) {
            if (!target) {
                return -1;
            }
            var rect = target.getBoundingClientRect();
            return this.scrollTop + rect.bottom;
        }
    }, {
        key: 'getBottomBoundary',
        value: function getBottomBoundary(bottomBoundary) {
            // a bottomBoundary can be provided to avoid reading from the props
            var boundary = bottomBoundary || this.props.bottomBoundary;

            // TODO, bottomBoundary was an object, depricate it later.
            if (typeof boundary === 'object') {
                boundary = boundary.value || boundary.target || 0;
            }

            if (typeof boundary === 'string') {
                if (!this.bottomBoundaryTarget) {
                    this.bottomBoundaryTarget = doc.querySelector(boundary);
                }
                boundary = this.getTargetBottom(this.bottomBoundaryTarget);
            }
            return boundary && boundary > 0 ? boundary : Infinity;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.setState({
                status: STATUS_ORIGINAL,
                pos: 0
            });
        }
    }, {
        key: 'release',
        value: function release(pos) {
            this.setState({
                status: STATUS_RELEASED,
                pos: pos - this.state.y
            });
        }
    }, {
        key: 'fix',
        value: function fix(pos) {
            this.setState({
                status: STATUS_FIXED,
                pos: pos
            });
        }

        /**
         * Update the initial position, width, and height. It should update whenever children change.
         * @param {Object} options optional top and bottomBoundary new values
         */
    }, {
        key: 'updateInitialDimension',
        value: function updateInitialDimension(options) {
            options = options || {};

            var outerRect = this.outerElement.getBoundingClientRect();
            var innerRect = this.innerElement.getBoundingClientRect();

            var width = outerRect.width || outerRect.right - outerRect.left;
            var height = innerRect.height || innerRect.bottom - innerRect.top;;
            var outerY = outerRect.top + this.scrollTop;

            this.setState({
                top: this.getTopPosition(options.top),
                bottom: Math.min(this.state.top + height, winHeight),
                width: width,
                height: height,
                x: outerRect.left,
                y: outerY,
                bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
                topBoundary: outerY
            });
        }
    }, {
        key: 'handleResize',
        value: function handleResize(e, ae) {
            if (this.props.shouldFreeze()) {
                return;
            }

            winHeight = ae.resize.height;
            this.updateInitialDimension();
            this.update();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart(e, ae) {
            this.frozen = this.props.shouldFreeze();

            if (this.frozen) {
                return;
            }

            if (this.scrollTop === ae.scroll.top) {
                // Scroll position hasn't changed,
                // do nothing
                this.skipNextScrollEvent = true;
            } else {
                this.scrollTop = ae.scroll.top;
                this.updateInitialDimension();
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e, ae) {
            // Scroll doesn't need to be handled
            if (this.skipNextScrollEvent) {
                this.skipNextScrollEvent = false;
                return;
            }

            scrollDelta = ae.scroll.delta;
            this.scrollTop = ae.scroll.top;
            this.update();
        }

        /**
         * Update Sticky position.
         */
    }, {
        key: 'update',
        value: function update() {
            var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;

            if (disabled) {
                if (this.state.status !== STATUS_ORIGINAL) {
                    this.reset();
                }
                return;
            }

            var delta = scrollDelta;
            // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
            // on document from viewport.
            var top = this.scrollTop + this.state.top;
            var bottom = this.scrollTop + this.state.bottom;

            // There are 2 principles to make sure Sticky won't get wrong so much:
            // 1. Reset Sticky to the original postion when "top" <= topBoundary
            // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary
            if (top <= this.state.topBoundary) {
                // #1
                this.reset();
            } else if (bottom >= this.state.bottomBoundary) {
                // #2
                this.stickyBottom = this.state.bottomBoundary;
                this.stickyTop = this.stickyBottom - this.state.height;
                this.release(this.stickyTop);
            } else {
                if (this.state.height > winHeight - this.state.top) {
                    // In this case, Sticky is higher then viewport minus top offset
                    switch (this.state.status) {
                        case STATUS_ORIGINAL:
                            this.release(this.state.y);
                            this.stickyTop = this.state.y;
                            this.stickyBottom = this.stickyTop + this.state.height;
                        // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
                        // from ORIGINAL when calling window.scrollTo().
                        // break;
                        case STATUS_RELEASED:
                            // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
                            // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
                            // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
                            this.stickyBottom = this.stickyTop + this.state.height;
                            if (delta > 0 && bottom > this.stickyBottom) {
                                this.fix(this.state.bottom - this.state.height);
                            } else if (delta < 0 && top < this.stickyTop) {
                                this.fix(this.state.top);
                            }
                            break;
                        case STATUS_FIXED:
                            var toRelease = true;
                            var pos = this.state.pos;
                            var height = this.state.height;
                            // In regular cases, when Sticky is in FIXED status,
                            // 1. it's top will stick to the screen top,
                            // 2. it's bottom will stick to the screen bottom,
                            // 3. if not the cases above, then it's height gets changed
                            if (delta > 0 && pos === this.state.top) {
                                // case 1, and scrolling down
                                this.stickyTop = top - delta;
                                this.stickyBottom = this.stickyTop + height;
                            } else if (delta < 0 && pos === this.state.bottom - height) {
                                // case 2, and scrolling up
                                this.stickyBottom = bottom - delta;
                                this.stickyTop = this.stickyBottom - height;
                            } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
                                // case 3
                                // This case only happens when Sticky's bottom sticks to the screen bottom and
                                // its height gets changed. Sticky should be in RELEASE status and update its
                                // sticky bottom by calculating how much height it changed.
                                var deltaHeight = pos + height - this.state.bottom;
                                this.stickyBottom = bottom - delta + deltaHeight;
                                this.stickyTop = this.stickyBottom - height;
                            } else {
                                toRelease = false;
                            }

                            if (toRelease) {
                                this.release(this.stickyTop);
                            }
                            break;
                    }
                } else {
                    // In this case, Sticky is shorter then viewport minus top offset
                    // and will always fix to the top offset of viewport
                    this.fix(this.state.top);
                }
            }
            this.delta = delta;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this = this;

            if (prevState.status !== this.state.status && this.props.onStateChange) {
                this.props.onStateChange({ status: this.state.status });
            }
            var arePropsChanged = !(0, _shallowequal2['default'])(this.props, prevProps);
            if (arePropsChanged) {
                // if the props for enabling are toggled, then trigger the update or reset depending on the current props
                if (prevProps.enabled !== this.props.enabled) {
                    if (this.props.enabled) {
                        this.setState({ activated: true }, function () {
                            _this.updateInitialDimension();
                            _this.update();
                        });
                    } else {
                        this.setState({ activated: false }, function () {
                            _this.reset();
                        });
                    }
                }
                // if the top or bottomBoundary props were changed, then trigger the update
                else if (prevProps.top !== this.props.top || prevProps.bottomBoundary !== this.props.bottomBoundary) {
                        this.updateInitialDimension();
                        this.update();
                    }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var subscribers = this.subscribers || [];
            for (var i = subscribers.length - 1; i >= 0; i--) {
                this.subscribers[i].unsubscribe();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Only initialize the globals if this is the first
            // time this component type has been mounted
            if (!win) {
                win = window;
                doc = document;
                docEl = doc.documentElement;
                docBody = doc.body;
                winHeight = win.innerHeight || docEl.clientHeight;
                M = window.Modernizr;
                // No Sticky on lower-end browser when no Modernizr
                if (M && M.prefixed) {
                    canEnableTransforms = M.csstransforms3d;
                    TRANSFORM_PROP = M.prefixed('transform');
                }
            }

            // when mount, the scrollTop is not necessary on the top
            this.scrollTop = docBody.scrollTop + docEl.scrollTop;

            if (this.props.enabled) {
                this.setState({ activated: true });
                this.updateInitialDimension();
                this.update();
            }
            // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality
            this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), { useRAF: true }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), { useRAF: true, enableScrollInfo: true }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), { enableResizeInfo: true })];
        }
    }, {
        key: 'translate',
        value: function translate(style, pos) {
            var enableTransforms = canEnableTransforms && this.props.enableTransforms;
            if (enableTransforms && this.state.activated) {
                style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
            } else {
                style.top = pos + 'px';
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !this.props.shouldFreeze() && !((0, _shallowequal2['default'])(this.props, nextProps) && (0, _shallowequal2['default'])(this.state, nextState));
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            // TODO, "overflow: auto" prevents collapse, need a good way to get children height
            var innerStyle = {
                position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
                top: this.state.status === STATUS_FIXED ? '0px' : '',
                zIndex: this.props.innerZ
            };
            var outerStyle = {};

            // always use translate3d to enhance the performance
            this.translate(innerStyle, this.state.pos);
            if (this.state.status !== STATUS_ORIGINAL) {
                innerStyle.width = this.state.width + 'px';
                outerStyle.height = this.state.height + 'px';
            }

            var outerClasses = (0, _classnames2['default'])('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));

            var children = this.props.children;

            return _react2['default'].createElement(
                'div',
                { ref: function (outer) {
                        _this2.outerElement = outer;
                    }, className: outerClasses, style: outerStyle },
                _react2['default'].createElement(
                    'div',
                    { ref: function (inner) {
                            _this2.innerElement = inner;
                        }, className: ['sticky-inner-wrapper', this.props.innerClass].join(' '), style: innerStyle },
                    typeof children === 'function' ? children({ status: this.state.status }) : children
                )
            );
        }
    }]);

    return Sticky;
})(_react.Component);

Sticky.displayName = 'Sticky';

Sticky.defaultProps = {
    shouldFreeze: function shouldFreeze() {
        return false;
    },
    enabled: true,
    top: 0,
    bottomBoundary: 0,
    enableTransforms: true,
    activeClass: 'active',
    releasedClass: 'released',
    onStateChange: null,
    innerClass: ''
};

/**
 * @param {Bool} enabled A switch to enable or disable Sticky.
 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
 *        whose height should serve as the top offset.
 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
 */
Sticky.propTypes = {
    enabled: _propTypes2['default'].bool,
    top: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
    bottomBoundary: _propTypes2['default'].oneOfType([_propTypes2['default'].object, // TODO, may remove
    _propTypes2['default'].string, _propTypes2['default'].number]),
    enableTransforms: _propTypes2['default'].bool,
    activeClass: _propTypes2['default'].string,
    releasedClass: _propTypes2['default'].string,
    innerClass: _propTypes2['default'].string,
    onStateChange: _propTypes2['default'].func,
    shouldFreeze: _propTypes2['default'].func,
    innerZ: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
};

Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
Sticky.STATUS_RELEASED = STATUS_RELEASED;
Sticky.STATUS_FIXED = STATUS_FIXED;

module.exports = Sticky;


/***/ }),

/***/ "Pu0A":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ "Q7Yi":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "QPCF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ResponsiveTabs_ResponsiveTabs; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.hoc.jsx
var tabs_hoc = __webpack_require__("lW4u");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.util.js
var tabs_util = __webpack_require__("GzVq");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/frameworks/active-indexes/ActiveIndexes.jsx
var ActiveIndexes = __webpack_require__("1Wgj");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx + 1 modules
var TabHeader = __webpack_require__("ZKlR");

// CONCATENATED MODULE: ./src/client/components/frameworks/accordion/Accordion.jsx


var __jsx = react_default.a.createElement;













var Accordion_scrollToId = function scrollToId(id, offsetSelector) {
  return Object(scrollToElement["a" /* scrollToElement */])("#".concat(id), 100, ".".concat(offsetSelector));
};

var Accordion_Accordion = function _Accordion(_ref) {
  var areAllCollapsable = _ref.areAllCollapsable,
      areMultiExpandable = _ref.areMultiExpandable,
      className = _ref.className,
      collapseIconName = _ref.collapseIconName,
      containerSize = _ref.containerSize,
      expandIconName = _ref.expandIconName,
      hasBackground = _ref.hasBackground,
      hasNoAutoScroll = _ref.hasNoAutoScroll,
      _ref$headerLevel = _ref.headerLevel,
      headerLevel = _ref$headerLevel === void 0 ? 3 : _ref$headerLevel,
      _ref$initialSelectedI = _ref.initialSelectedItems,
      initialSelectedItems = _ref$initialSelectedI === void 0 ? [] : _ref$initialSelectedI,
      id = _ref.id,
      isContentUnmountedOnCollapse = _ref.isContentUnmountedOnCollapse,
      items = _ref.items,
      onSelect = _ref.onSelect,
      _ref$scrollOffsetSele = _ref.scrollOffsetSelector,
      scrollOffsetSelector = _ref$scrollOffsetSele === void 0 ? Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */] : _ref$scrollOffsetSele,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!items.length) {
    return null;
  }

  var refsArray = [];

  var _onKeyDown = function onKeyDown(_ref2) {
    var e = _ref2.e,
        index = _ref2.index;

    if (items.length > 1) {
      var lastItem = items.length - 1;
      var idx = -1;

      switch (e.which) {
        case keyCodes["a" /* ARROW_DOWN */]:
          e.preventDefault();
          idx = index === lastItem ? 0 : index + 1;
          break;

        case keyCodes["d" /* ARROW_UP */]:
          e.preventDefault();
          idx = index === 0 ? lastItem : index - 1;
          break;

        case keyCodes["h" /* HOME */]:
          e.preventDefault();
          idx = 0;
          break;

        case keyCodes["e" /* END */]:
          e.preventDefault();
          idx = lastItem;
          break;

        default:
      }

      refsArray[idx] && refsArray[idx].focus();
    }
  };

  var CollapsedTag = isContentUnmountedOnCollapse ? lib["UnmountClosed"] : lib["Collapse"];
  var accordionsCount = items.filter(Boolean).length;
  return __jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    activeIndexes: initialSelectedItems,
    hasMultipleIndexEnabled: areMultiExpandable,
    hasNoIndexEnabled: areAllCollapsable,
    onUpdate: onSelect
  }, function (_ref3) {
    var update = _ref3.update,
        activeIndexes = _ref3.activeIndexes,
        isPristine = _ref3.isPristine;
    return __jsx("section", {
      className: className,
      id: id,
      "data-cs-override-id": "Accordion" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id

    }, items.filter(Boolean).map(function (_ref4, index) {
      var content = _ref4.content,
          _ref4$header = _ref4.header,
          header = _ref4$header === void 0 ? {} : _ref4$header,
          headerId = _ref4.headerId,
          panelId = _ref4.panelId;

      var title = header.title,
          rest = Object(objectWithoutProperties["a" /* default */])(header, ["title"]);

      var isExpanded = activeIndexes.includes(index);

      var onRest = function onRest() {
        if (!hasNoAutoScroll && isExpanded && !isPristine) Accordion_scrollToId(headerId, scrollOffsetSelector);
      };

      var Heading = "h".concat(headerLevel);
      return __jsx("article", {
        key: headerId
      }, __jsx(SiteContainer["a" /* SiteContainer */], {
        size: containerSize
      }, __jsx(Heading, {
        className: "reset-heading"
      }, __jsx(TabHeader["a" /* TabHeader */], Object(esm_extends["a" /* default */])({}, rest, {
        collapseIconName: collapseIconName,
        controlsId: panelId,
        expandIconName: expandIconName,
        id: headerId,
        isAccordion: true,
        isActive: isExpanded,
        isDisabled: accordionsCount <= 1 && isTablet,
        onClick: function onClick() {
          update(index);
          refsArray[index] && refsArray[index].focus();
        },
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown({
            e: e,
            index: index
          });
        },
        ref: function ref(_ref5) {
          refsArray[index] = _ref5;
        },
        theme: theme
      }), title))), __jsx(CollapsedTag, {
        isOpened: isExpanded,
        onRest: onRest
      }, __jsx("div", {
        "aria-hidden": !isExpanded,
        "aria-labelledby": headerId,
        className: classnames_default()(Object(tabs_util["a" /* getTabsBackgroundClasses */])(hasBackground), 'pt-5 sm:pt-10', {
          'invisible pointer-events-none': !isExpanded
        }),
        "data-cs-override-id": "Accordion-panel" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
        ,
        id: panelId,
        role: "region"
      }, __jsx(SiteContainer["a" /* SiteContainer */], {
        size: containerSize
      }, react["Children"].map(content, function (el, i) {
        return el ? /*#__PURE__*/Object(react["cloneElement"])(el, {
          key: "".concat(panelId, "-").concat(i)
        }) : null;
      })))));
    }));
  });
};

var Accordion = Object(tabs_hoc["a" /* withOpenAndScrollToHash */])(Accordion_Accordion);
// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// CONCATENATED MODULE: ./src/client/components/frameworks/responsive-tabs/ResponsiveTabs.jsx


var ResponsiveTabs_jsx = react_default.a.createElement;




var ResponsiveTabs_ResponsiveTabs = function ResponsiveTabs(_ref) {
  var areAllCollapsable = _ref.areAllCollapsable,
      areMultiExpandable = _ref.areMultiExpandable,
      _ref$initialSelectedI = _ref.initialSelectedItems,
      initialSelectedItems = _ref$initialSelectedI === void 0 ? [] : _ref$initialSelectedI,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["areAllCollapsable", "areMultiExpandable", "initialSelectedItems"]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return isTablet ? ResponsiveTabs_jsx(Tabs["a" /* Tabs */], rest) : ResponsiveTabs_jsx(Accordion, Object(esm_extends["a" /* default */])({}, rest, {
    areAllCollapsable: areAllCollapsable,
    areMultiExpandable: areMultiExpandable,
    initialSelectedItems: initialSelectedItems
  }));
};

/***/ }),

/***/ "QPdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("m1JM");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("SPKZ");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qBqs");
/* harmony import */ var _spinner_Spinner__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("7amT");








var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* DEPRECATED */

/* eslint-disable clubmed/no-fake-component */






var defaultProps = {
  hasNoField: false,
  isActive: false,
  isLoading: false,
  isReadOnly: false,
  isRequired: false,
  validationState: 'NOT_VALIDATED',
  generateUniqueId: true,
  scrollSelector: ''
};

function formField(Component) {
  var FormField = /*#__PURE__*/function (_React$Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(FormField, _React$Component);

    var _super = _createSuper(FormField);

    function FormField() {
      var _this;

      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(this, FormField);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "state", {
        isActive: false,
        hasValue: !!(_this.props.defaultValue || _this.props.value)
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "setActive", function () {
        _this.setState({
          isActive: true
        });
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "unsetActive", function () {
        _this.setState({
          isActive: false
        });
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "onClear", function () {
        _this.unsetActive();

        if (_this.props.onClear) {
          _this.props.onClear();
        }
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "onChange", function (value) {
        _this.setState({
          hasValue: value !== ''
        });

        if (_this.props.onChange) {
          _this.props.onChange(value);
        }
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_this), "getValidationState", function () {
        var validationState = _this.props.validationState;
        var hasValue = _this.state.hasValue;
        return validationState === 'IS_VALID' && !hasValue ? 'NOT_VALIDATED' : validationState;
      });

      return _this;
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(FormField, [{
      key: "renderInput",
      value: function renderInput(id) {
        var _this$props = this.props,
            icon = _this$props.icon,
            isDisabled = _this$props.isDisabled,
            isLoading = _this$props.isLoading,
            isReadOnly = _this$props.isReadOnly;
        var isActive = this.state.isActive;
        var validationState = this.getValidationState();
        var active = isActive || this.props.isActive;
        var isValid = validationState === 'IS_VALID' && !isDisabled;
        var isInvalid = validationState === 'IS_INVALID' && !isDisabled;
        return __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()('flex overflow-hidden outline-custom rounded-tiny transition-all', {
            'border-1': !isReadOnly,
            'bg-white': !isReadOnly && !isDisabled,
            'bg-gray-light': isDisabled && !isReadOnly,
            'border-blue': isActive && !isDisabled && validationState === 'NOT_VALIDATED',
            'border-success': isValid,
            'border-danger': isInvalid
          }),
          onBlur: this.unsetActive,
          onFocus: this.setActive
        }, __jsx(Component, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, this.props, id ? {
          id: id
        } : null, {
          onClear: this.onClear,
          onChange: this.onChange,
          height: "2.6875rem"
        })), isLoading && !isDisabled && !isReadOnly && __jsx("div", {
          className: "flex items-center justify-center leading-none rtl:pr-3"
        }, __jsx(_spinner_Spinner__WEBPACK_IMPORTED_MODULE_13__[/* Spinner */ "a"], {
          size: "small"
        })), !!icon && __jsx("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()('flex items-center justify-center -order-1 px-1 transition-all', {
            'bg-gray-light text-gray-dark': !active,
            'bg-blue text-white': active,
            'bg-success text-white': isValid,
            'bg-danger text-white': isInvalid
          }),
          style: {
            width: '2.6875rem',
            minWidth: '2.6875rem',
            height: '2.6875rem'
          }
        }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_12__[/* Icon */ "a"], {
          name: icon,
          width: "1em"
        })), (isValid || isInvalid) && __jsx("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()('flex items-center justify-center px-2 text-xs transition-all', {
            'text-success': isValid,
            'text-danger': isInvalid
          })
        }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_12__[/* Icon */ "a"], {
          name: isValid ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].CHECK : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_11__[/* ICONS */ "a"].CROSS,
          width: "1em"
        })));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            className = _this$props2.className,
            hasNoField = _this$props2.hasNoField,
            isRequired = _this$props2.isRequired,
            label = _this$props2.label,
            notes = _this$props2.notes,
            scrollSelector = _this$props2.scrollSelector;
        var id = this.props.generateUniqueId ? Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_10__[/* generateUniqueId */ "b"])([this.props.id, this.props.dataSelector]) : this.props.id;
        return !hasNoField ? __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()(className, scrollSelector, 'flex flex-col')
        }, !!label && __jsx("label", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()('flex font-bold items-center mb-2 text-sm text-gray-darker transition-all'),
          htmlFor: id
        }, "".concat(label).concat(isRequired ? '*' : '')), this.renderInput(id), !!notes && __jsx("span", {
          className: "mt-2 text-gray-darker text-sm"
        }, notes)) : this.renderInput(id);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props) {
        return {
          hasValue: !!(props.defaultValue || props.value)
        };
      }
    }]);

    return FormField;
  }(react__WEBPACK_IMPORTED_MODULE_8___default.a.Component);

  Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(FormField, "displayName", 'FormField');

  Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(FormField, "defaultProps", defaultProps);

  return FormField;
}

/* harmony default export */ __webpack_exports__["a"] = (formField);

/***/ }),

/***/ "Qabk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cruiseBookingResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var cruiseBookingResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* CRUISE_BOOKING */ "j"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var resortId = props.resortId,
        _props$criteria = props.criteria,
        criteria = _props$criteria === void 0 ? {} : _props$criteria,
        _props$dateFormat = props.dateFormat,
        dateFormat = _props$dateFormat === void 0 ? '' : _props$dateFormat,
        _props$pax = props.pax,
        pax = _props$pax === void 0 ? {
      minAgeErrorMessage: '',
      minAgeInformation: ''
    } : _props$pax;
    var minAgeErrorMessage = pax.minAgeErrorMessage,
        minAgeInformation = pax.minAgeInformation;
    var _appContext$cmsConten = appContext.cmsContent,
        cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
        _appContext$cmsReleas = appContext.cmsRelease,
        cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
    var urlParams = location.urlParams;
    var durationValuePlaceholder = criteria.durationValuePlaceholder,
        dateValuePlaceholder = criteria.dateValuePlaceholder,
        fromToValuePlaceholder = criteria.fromToValuePlaceholder;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var cruiseArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildCruiseArgs */ "b"])(urlParams);
    var cmsArgs = "content : \"".concat(cmsContent, "\" release : \"").concat(cmsRelease, "\"");
    var query = "{\n      product: resort(".concat(productArgs, ") {\n        id\n        adultOnly\n        duration(message : \"").concat(durationValuePlaceholder, "\")\n        dateRange(message : \"").concat(dateValuePlaceholder, "\" dateFormat : \"").concat(dateFormat, "\")\n        minAuthorizedAge {\n          formattedValue (message : \"").concat(minAgeInformation, "\" ").concat(cmsArgs, ")\n          value\n        }\n        minAgeErrorMessage : minAuthorizedAge {\n          formattedValue(message : \"").concat(minAgeErrorMessage, "\" ").concat(cmsArgs, ")\n        }\n      }\n      cruise(").concat(cruiseArgs, ") {\n        fromToDestination(message : \"").concat(fromToValuePlaceholder, "\")\n        departureDate\n      }\n      bookingCriteria(").concat(productArgs, ") {\n        departureCities {\n          value\n          label : name\n        },\n        initialNumberOfAdults(").concat(productArgs, ")\n        initialNumberOfChildren\n      }\n      config {\n        common {\n          participants {\n            kidsLabel\n            adultsLabel\n            kidsAgeLimit\n          }\n        }\n        booking {\n          accommodation {\n            errorMessages {\n              noProposalAvailable\n              noTransport\n            }\n          }\n          form {\n            dayPlaceholder\n            monthPlaceholder\n            yearPlaceholder\n            childrenBirthdayDateFormatPlaceholder\n            errorMaxGuestsLabel\n            departureDateErrorMessage\n            adultAge\n            proposalsLoaderLabel\n            errors {\n              adultChild\n              birthdayFormat\n            }\n          }\n        }\n        price {\n          format {\n            from\n            instead\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_CRUISE_BOOKING */ "Rb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "Qmkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESORT_PRODUCT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResultItem; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("47go");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var COMFORT_EXCLUSIVE = 5;
var REGEXP_DYNAMIC_CRUISE = /^CM2C_\d{8}_\d{8}$/;
var RESORT_PRODUCT_TYPE = 'resort';

function getType(item) {
  return item.product_id ? RESORT_PRODUCT_TYPE : item.type || '';
}

function isItemResort(item) {
  return getType(item) === RESORT_PRODUCT_TYPE;
}

function getLabel(item) {
  var label = striptags__WEBPACK_IMPORTED_MODULE_1___default()(item.value || '', '<span>');
  return isItemResort(item) && item.sibling_id ? "".concat(label, " - ").concat(item.season || '') : label;
}

function isCruise(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.CRUISE;
}

function isDynamicCruise(item) {
  return isCruise(item) && REGEXP_DYNAMIC_CRUISE.test(item.product_id || '');
}

function isJoyview(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.JOYVIEW;
}

function isTour(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.TOUR;
}

function isVilla(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.VILLA;
}

function isExclusiveComfort(item) {
  return Number(item.comfort_level) >= COMFORT_EXCLUSIVE;
}

function isExclusiveCollection(item) {
  return isVilla(item) || isCruise(item) || isExclusiveComfort(item);
}

function getProductId(item) {
  return isItemResort(item) ? item.product_id : null;
}

function getProductSeason(item) {
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["resortAction"].getSeasonInfos(item.sibling_id ? item.season_id : _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].ALL_YEAR);
}

function getProductUrl(item) {
  var productUrl = new urijs__WEBPACK_IMPORTED_MODULE_2___default.a('/');

  if (isDynamicCruise(item)) {
    productUrl.segment('c').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizePath((item.product_id || '').split('_').join('/')));
  } else if (isTour(item)) {
    productUrl.segment('i').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeSlug(item.title)).segment(getProductSeason(item));
  } else {
    productUrl.segment('r').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeSlug(item.title)).segment(getProductSeason(item));
  }

  return productUrl.toString();
}

function getLink(item) {
  return isItemResort(item) ? getProductUrl(item) : undefined;
}

function getHeadlines(item) {
  return isItemResort(item) ? {
    subLabel1: Array.isArray(item.destination_country) ? item.destination_country.join(', ') : item.destination_country,
    subLabel2: item.destination_area,
    image: item.immersive_image,
    productId: item.product_id,
    productType: item.type,
    comfortLevel: item.comfort_level,
    season: Array.isArray(item.season) ? '' : item.season
  } : {};
}

function getIcon(item) {
  var comfortLevel = item.comfort_level || 1;

  switch (item.type) {
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.CRUISE:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CRUISE;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.JOYVIEW:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TRIDENT_JOYVIEW;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.TOUR:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].TOUR;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.RESORT:
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES.VILLA:
      return comfortLevel === String(COMFORT_EXCLUSIVE) ? null : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"]["TRIDENT".concat(comfortLevel)];

    default:
      return item.type === 'activity' ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ACTIVITIES : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ADDRESS;
  }
}

function getColor(item) {
  if (isExclusiveCollection(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].DEEP_BLUE;
  }

  if (isJoyview(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WATER_GREEN;
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE;
}

var getTagsColor = function getTagsColor(item) {
  var seasonName = Array.isArray(item.seasons_id) ? '' : item.seasons_id;

  if (seasonName === _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].SEASONS.SUMMER) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].ORANGE;
  }

  if (isTour(item) || isCruise(item)) {
    return getColor(item);
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE;
};

function getResultItem(item) {
  return _objectSpread({
    icon: getIcon(item),
    id: getProductId(item) || getLabel(item),
    isExclusiveCollection: isExclusiveCollection(item),
    label: getLabel(item),
    link: getLink(item),
    productColor: getColor(item),
    product_id: getProductId(item),
    tagsColor: getTagsColor(item),
    type: getType(item)
  }, getHeadlines(item));
}

/***/ }),

/***/ "R2jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endLoading; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var START_LOADING = 'START_LOADING';
var END_LOADING = 'END_LOADING';

function endLoading() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(END_LOADING, {});
}

function startLoading(globalLoaderLabel, isNavigation) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(START_LOADING, {
    globalLoaderLabel: globalLoaderLabel,
    isNavigation: isNavigation
  });
}



/***/ }),

/***/ "RBO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* unused harmony export getMainContactOptinEmail */
/* unused harmony export getMainContactOptinSms */
/* unused harmony export getMainContactOptinFosun */
/* unused harmony export getMainContactOptinMail */
/* unused harmony export getMainContactOptinPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTripFlexibility; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var mainContactSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref2) {
  var mainContact = _ref2.mainContact;
  return mainContact || {};
});
var getDepartureCity = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref3) {
  var departureCity = _ref3.departureCity;
  return departureCity;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref4) {
  var departureDate = _ref4.departureDate;
  return departureDate;
});
var getMainContactOptinEmail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref5) {
  var optinEmail = _ref5.optinEmail;
  return optinEmail;
});
var getMainContactOptinSms = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref6) {
  var optinSms = _ref6.optinSms;
  return optinSms;
});
var getMainContactOptinMail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref7) {
  var optinMail = _ref7.optinMail;
  return optinMail;
});
var getMainContactOptinPhone = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref8) {
  var optinPhone = _ref8.optinPhone;
  return optinPhone;
});
var getMainContactOptinFosun = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref9) {
  var optinFosun = _ref9.optinFosun;
  return optinFosun;
});
var getTripDuration = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref10) {
  var duration = _ref10.duration;
  return duration;
});
var getTripFlexibility = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref11) {
  var flexibility = _ref11.flexibility;
  return flexibility;
});


/***/ }),

/***/ "RBvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TRIP_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_NO_DURATION; });
var TRIP_INFORMATION_SET_DURATION = 'TRIP_INFORMATION_SET_DURATION';
var DEFAULT_TRIP_DURATION = 7;
var DEFAULT_NO_DURATION = null;

/***/ }),

/***/ "RVBP":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "RgK2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {}

module.exports = emptyObject;

/***/ }),

/***/ "RlE+":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("ojcf"),
    getSymbols = __webpack_require__("WwbQ");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ "RqHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mixedToMoment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dateDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return maxDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return minDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closedDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDisabledDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bestPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return lastRoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return flattenPrices; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("sW3P");



var mixedToMoment = function mixedToMoment(mixedDate) {
  return moment__WEBPACK_IMPORTED_MODULE_1___default()(mixedDate);
};
var dateToInt = function dateToInt(d) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYYMMDD';
  return parseInt(mixedToMoment(d).format(format), 10);
};
var dateDiff = function dateDiff(day1, day2) {
  return Math.abs(moment__WEBPACK_IMPORTED_MODULE_1___default()(day2).diff(moment__WEBPACK_IMPORTED_MODULE_1___default()(day1), 'days'));
};
var maxDatepickerDate = function maxDatepickerDate() {
  return moment__WEBPACK_IMPORTED_MODULE_1___default()().add(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_2__[/* DEPARTURE_DATE_MAX_DATE */ "l"]).toDate();
};
var minDatepickerDate = function minDatepickerDate() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return moment__WEBPACK_IMPORTED_MODULE_1___default()().add({
    days: offset
  }).toDate();
};

function daysWithoutDepartureFactory(resolver, fromDate, toDate) {
  return function (day) {
    var _resolver = resolver(dateToInt(day)),
        _resolver$exclusivity = _resolver.exclusivity,
        exclusivity = _resolver$exclusivity === void 0 ? false : _resolver$exclusivity,
        _resolver$noFlight = _resolver.noFlight,
        noFlight = _resolver$noFlight === void 0 ? false : _resolver$noFlight,
        _resolver$full = _resolver.full,
        full = _resolver$full === void 0 ? false : _resolver$full;

    var available = !exclusivity && !noFlight && !full;

    if (!fromDate && !toDate) {
      return !available;
    }

    if (fromDate && !toDate) {
      return false;
    }

    if (fromDate && toDate) {
      var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
      return !dayIsSelected && !available;
    }
  };
}

var daysWithNoAvailabilityFactory = function daysWithNoAvailabilityFactory(resolver) {
  return function (day) {
    var data = resolver(dateToInt(day));
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(data) || data.noAvailability;
  };
};

var closedDaysFactory = function closedDaysFactory(resolver, fromDate, toDate) {
  return function (day) {
    var _resolver2 = resolver(dateToInt(day)),
        _resolver2$closed = _resolver2.closed,
        closed = _resolver2$closed === void 0 ? false : _resolver2$closed;

    if (!fromDate && !toDate) {
      return closed;
    }

    if (fromDate && !toDate) {
      return false;
    }

    if (fromDate && toDate) {
      var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
      return !dayIsSelected && closed;
    }
  };
};

var unavailableReturnDaysFactory = function unavailableReturnDaysFactory(fromDate) {
  var durations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (day) {
    if (day < fromDate) return false;
    var duration = dateDiff(day, fromDate); // rule of max 30 days of reservation

    if (duration > 30) return true;
    return !!duration && !durations.includes(duration);
  };
};

function getDisabledDays(_ref) {
  var from = _ref.from,
      isSeller = _ref.isSeller,
      optionsDuration = _ref.optionsDuration,
      prices = _ref.prices,
      resolvePrice = _ref.resolvePrice,
      to = _ref.to;
  var disabledDays = [];
  var pricesIds = Object.keys(prices || {});
  var hasPrices = pricesIds.length > 0;
  var allClosedDays = pricesIds.filter(function (priceKey) {
    return prices && prices[priceKey].closed;
  }).map(function (priceKey) {
    return parseInt(priceKey, 10);
  });

  if (hasPrices) {
    var dayIsWithoutDeparture = daysWithoutDepartureFactory(resolvePrice, from, to);
    var dayIsClosed = closedDaysFactory(resolvePrice, from, to);
    var dayIsWithoutData = daysWithNoAvailabilityFactory(resolvePrice);
    disabledDays.push(dayIsWithoutDeparture);
    disabledDays.push(dayIsClosed);
    disabledDays.push(dayIsWithoutData);
  }

  if (from && !to) {
    var fromDay = dateToInt(from);
    var closedDaysAfterFromDay = allClosedDays.filter(function (closedDay) {
      return closedDay > fromDay;
    });
    var firstClosedDay = hasPrices && closedDaysAfterFromDay.length > 0 && Math.min.apply(null, closedDaysAfterFromDay);
    disabledDays.push({
      before: moment__WEBPACK_IMPORTED_MODULE_1___default()(from).toDate(),
      after: firstClosedDay ? moment__WEBPACK_IMPORTED_MODULE_1___default()(firstClosedDay.toString()).toDate() : moment__WEBPACK_IMPORTED_MODULE_1___default()(from).add(30, 'days').toDate()
    });
  }

  if (from && !to && !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(optionsDuration) && !isSeller) {
    disabledDays.push(unavailableReturnDaysFactory(from, optionsDuration));
  }

  return disabledDays;
}
function bestPrice(resolver) {
  return function (day) {
    var id = dateToInt(day);

    var _ref2 = resolver && resolver(id) || {
      isBestPrice: false
    },
        isBestPrice = _ref2.isBestPrice;

    return isBestPrice;
  };
}
var lastRoom = function lastRoom(resolver) {
  return function (day) {
    var id = dateToInt(day);

    var _ref3 = resolver && resolver(id) || {
      lastAvailability: false
    },
        lastAvailability = _ref3.lastAvailability;

    return lastAvailability;
  };
};
function flattenPrices(prices) {
  var pricesIds = Object.keys(prices);
  return pricesIds.map(function (priceId) {
    return prices[priceId].oldPrice;
  }).join();
}

/***/ }),

/***/ "SHsq":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "SIwd":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("5FP0");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "SUcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductBanner; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_product_product_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("C9cF");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("VHif");
/* harmony import */ var _exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Itgl");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MWZw");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;






var ICONS_HEIGHT = 50;
var ProductBanner = function ProductBanner(_ref) {
  var product = _ref.product;
  return __jsx("div", {
    className: "items-start hidden lg:flex"
  }, __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__[/* Badge */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, Object(_utils_product_product_utils__WEBPACK_IMPORTED_MODULE_2__[/* getProductBadgeIcon */ "d"])(product), {
    className: "flex-shrink-0 rounded-tiny",
    size: ICONS_HEIGHT
  })), product.isExplicitEC && product.badgeIcon && __jsx("span", {
    className: "font-brand mx-1 text-base self-center"
  }, "&"), product.isExplicitEC && __jsx(_exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_5__[/* ECBadge */ "a"], {
    height: ICONS_HEIGHT,
    iconWidth: "80%"
  }), __jsx("div", {
    className: "flex-auto mx-3"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_6__[/* Title */ "a"], {
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].GRAY_DARKER,
    hLevel: 1,
    theme: "none"
  }, __jsx("div", {
    className: "font-brand font-normal leading-tight text-xl"
  }, product.name), __jsx("div", {
    className: "font-sans font-bold leading-tight uppercase text-md"
  }, product.destination.country))));
};

/***/ }),

/***/ "T26A":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("2K7v");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "TVUe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TrackingPageLoad_TrackingPageLoad; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/last-visited-tracking-api/index.js
var last_visited_tracking_api = __webpack_require__("evRn");

// EXTERNAL MODULE: ./src/client/store/lead-info/leadInfo.selector.js
var leadInfo_selector = __webpack_require__("8fx4");

// CONCATENATED MODULE: ./src/client/tracking/tracking-component/index.jsx


var __jsx = react["createElement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var tracking_component_TrackingComponent = function TrackingComponent(_ref) {
  var children = _ref.children,
      track = _ref.track,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "track"]);

  var appContext = react["useContext"](ReactAppContext["a" /* default */]);
  var pageContext = react["useContext"](context_pageContext["a" /* ReactPageContext */]);
  var leadScoring = Object(es["e" /* useSelector */])(leadInfo_selector["a" /* getLeadScore */]); // in some cases (like the NotFoundView) the siteSection's value cannot be dynamically built
  // from the pageType and attached to the pageContext,
  // so we need to declare it in the props directly but this should be avoided

  var siteSection = props.siteSection || pageContext.siteSection;
  react["useEffect"](function () {
    // $FlowFixMe
    Object(last_visited_tracking_api["b" /* trackLastVisitedProducts */])(pageContext, props.resortCode);
  }, [props.pageName]);
  react["useEffect"](function () {
    // pageId is not actually needed here, since the categoryGA is only used for events
    // not for page loading (the analytics team doesn't care), but it makes our API more
    // consistent
    tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread(_objectSpread({}, props), {}, {
      // $FlowFixMe
      siteSection: siteSection
    }, siteSection && siteSection.includes(constants["l" /* PLE */]) ? {
      BE_customerStatus: appContext.customerType
    } : undefined), leadScoring ? {
      leadScoring: leadScoring
    } : null), appContext, pageContext.pageId);

    if (track) {
      track();
    }
  }, [props.pageName]);
  return __jsx("div", null, children);
};

/* harmony default export */ var tracking_component = (tracking_component_TrackingComponent);
// CONCATENATED MODULE: ./src/client/tracking/tracking-component/index.js

/* harmony default export */ var tracking_tracking_component = (tracking_component);
// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// CONCATENATED MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx


var TrackingPageLoad_jsx = react_default.a.createElement;

function TrackingPageLoad_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function TrackingPageLoad_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TrackingPageLoad_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TrackingPageLoad_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var TrackingPageLoad_TrackingPageLoad = function TrackingPageLoad(props) {
  var _profile$loyaltyProgr;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var trackingPageLoadAppendSuffix = location.queryParams.trackingPageLoadAppendSuffix;
  var profile = Object(es["e" /* useSelector */])(userInfo_selectors["a" /* userInfoSelector */]);

  var trackingProps = TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread({}, props.trackingKey ?
  /**
   * We need to omit ski data because in case of 2 bookings from the same session,
   * when the first one has ski equipments and second one has none,
   * the second one get wrong ski data from locale storage
   * In case of new ski data exist, it will be added from props anyway
   */
  Object(lodash["omit"])(tracking_storage_api["a" /* get */](props.trackingKey), 'skiEquipment', 'skiingEquipment', 'snowboardingEquipment', 'hikingEquipment') : {}), {
    event: constants["y" /* VIRTUAL_PAGE_LOAD */]
  }), {
    fidelityStatus: (profile === null || profile === void 0 ? void 0 : (_profile$loyaltyProgr = profile.loyaltyProgram) === null || _profile$loyaltyProgr === void 0 ? void 0 : _profile$loyaltyProgr.status) || ''
  }), Object(lodash["omit"])(props, 'children', 'location', 'history', 'match', 'trackingKey'));

  if (trackingPageLoadAppendSuffix) {
    trackingProps.pageName = "".concat(trackingProps.pageName, "_").concat(trackingPageLoadAppendSuffix);
  }

  react_default.a.useEffect(function () {
    if (props.event) {
      tracking_storage_api["b" /* set */](trackingProps);
    }
  }, [props.event]);
  return TrackingPageLoad_jsx(tracking_tracking_component, Object(esm_extends["a" /* default */])({}, trackingProps, {
    track: props.track
  }));
};

/***/ }),

/***/ "TYzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* unused harmony export CriteriaDisplayContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useCriteriaDisplayContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaDisplayProvider; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var ACTIONS = Object.freeze({
  CLOSE_CRITERIA: 'CLOSE_CRITERIA',
  OPEN_CRITERIA: 'OPEN_CRITERIA',
  OPEN_NEXT_CRITERIA: 'OPEN_NEXT_CRITERIA'
});
var initialState = {
  criteriaWhenIsOpen: false,
  criteriaWhoIsOpen: false,
  criteriaTransportIsOpen: false
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  switch (action.type) {
    case ACTIONS.OPEN_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), true));

    case ACTIONS.CLOSE_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), false));

    case ACTIONS.OPEN_NEXT_CRITERIA:
      var _action$payload = action.payload,
          currentCriteria = _action$payload.currentCriteria,
          criteriaContext = _action$payload.criteriaContext;

      if (currentCriteria === 'criteriaTransport') {
        return state;
      }

      if (currentCriteria === 'criteriaWho' && !criteriaContext.criteriaTransportIsSet) {
        return _objectSpread(_objectSpread({}, state), {}, {
          criteriaTransportIsOpen: true
        });
      }

      if (currentCriteria === 'criteriaWhen') {
        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      return state;

    default:
      return state;
  }
};

var CriteriaDisplayContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["createContext"])([initialState, function () {}]);
var useCriteriaDisplayContext = function useCriteriaDisplayContext() {
  return Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(CriteriaDisplayContext);
};
var CriteriaDisplayProvider = function CriteriaDisplayProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_1__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return __jsx(CriteriaDisplayContext.Provider, {
    value: [state, dispatch]
  }, children);
};

/***/ }),

/***/ "U6GL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ DropDown_DropDown; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// CONCATENATED MODULE: ./src/client/components/frameworks/drop-down/DropDown.themes.js
var themes = {
  "default": {
    thBody: 'arrow-up arrow-white arrow-bg arrow-bg-gray-light bg-white border-1 border-light-gray mt-4 p-4 shadow-lg'
  },
  hollow: {
    thBody: 'arrow-up arrow-large arrow-white arrow-bg arrow-bg-gray-light bg-white border-1 border-gray-light mt-5 rounded-small shadow-lg'
  },
  solid: {
    thBody: 'bg-white'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/drop-down/DropDown.jsx







var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var DropDown_DropDown = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(DropDown, _Component);

  var _super = _createSuper(DropDown);

  function DropDown(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, DropDown);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "rootRef", /*#__PURE__*/Object(react["createRef"])());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "contentRef", /*#__PURE__*/Object(react["createRef"])());

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "expand", function () {
      _this.setState({
        isExpanded: true
      }, _this.toggleEventListeners);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "collapse", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      _this.setState({
        isExpanded: false
      }, _this.toggleEventListeners);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (e) {
      if (e.keyCode === keyCodes["g" /* ESCAPE */]) {
        _this.collapse();
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickOutside", function (e) {
      if (!_this.contentRef || // $FlowFixMe
      _this.contentRef.current.contains(e.target) || // $FlowFixMe
      _this.rootRef.current.contains(e.target) || // $FlowFixMe
      Object(lodash["get"])(_this.props, 'rootRef.current') && _this.props.rootRef.current.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      _this.collapse();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggle", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      }, _this.toggleEventListeners);
    });

    _this.state = {
      isExpanded: props.isExpanded || false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isExpanded) {
        this.removeEventListeners();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isExpanded !== this.props.isExpanded) {
        this.setState({
          isExpanded: nextProps.isExpanded
        }, this.toggleEventListeners);
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      if (true) {
        document.addEventListener('mouseup', this.onClickOutside, false);
        document.addEventListener('touchstart', this.onClickOutside, false);
        document.addEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      if (true) {
        document.removeEventListener('mouseup', this.onClickOutside, false);
        document.removeEventListener('touchstart', this.onClickOutside, false);
        document.removeEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "toggleEventListeners",
    value: function toggleEventListeners() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      } else {
        this.removeEventListeners();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          contentStyle = _this$props.contentStyle,
          hasCloseOnClick = _this$props.hasCloseOnClick,
          renderTrigger = _this$props.renderTrigger,
          theme = _this$props.theme;
      var thBody = themes[theme].thBody;
      return __jsx("div", {
        className: classnames_default()(className, 'inline-block relative'),
        ref: this.rootRef
      }, renderTrigger && renderTrigger(this.toggle, this.state.isExpanded), this.state.isExpanded && __jsx("div", {
        className: classnames_default()('absolute left-1/2 min-w-full w-full -translate-x-50 z-4', thBody),
        "data-testid": "DropDown-body",
        onClick: hasCloseOnClick ? this.collapse : null,
        ref: this.contentRef,
        style: contentStyle
      }, children(this.toggle, this.state.isExpanded)));
    }
  }]);

  return DropDown;
}(react["Component"]);

Object(defineProperty["a" /* default */])(DropDown_DropDown, "defaultProps", {
  isExpanded: false,
  theme: 'default'
});

/***/ }),

/***/ "UIAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_ACCOMMODATION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_TRANSFER_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UPDATE_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_PROPOSALS; });
/* unused harmony export LOAD_PROPOSAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_PROPOSALS_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_SELECTED_PROPOSAL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return REMOVE_TRANSFER_FROM_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SAVE_CUSTOMER_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return UPDATE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PREPARE_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISPLAY_TOAST_ON_CONTEXT_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_PROPOSALS_FROM_EDIT_CRITERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SAVE_DONATION_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_PROMO_CODE; });
/* unused harmony export SET_PROMO_CODE_FAILURE_STATUS */
/* unused harmony export SET_PROMO_CODE_SUCCESS_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UPDATE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SWITCH_PROPOSALS_OFFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return INSURANCE_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return INSURANCE_DELETED; });
var ADD_ACCOMMODATION = 'ADD_ACCOMMODATION';
var ADD_ACCOMMODATION_ERROR = 'ADD_ACCOMMODATION_ERROR';
var ADD_TRANSFER_TO_PROPOSALS = 'ADD_TRANSFER_TO_PROPOSALS';
var ADD_TRANSPORT = 'ADD_TRANSPORT';
var UPDATE_ATTENDEES = 'UPDATE_ATTENDEES';
var CLEAR_PROPOSALS = 'CLEAR_PROPOSALS';
var LOAD_PROPOSAL = 'LOAD_PROPOSAL';
var FETCH_PROPOSALS = 'FETCH_PROPOSALS';
var FETCH_PROPOSALS_BY_ID = 'FETCH_PROPOSALS_BY_ID';
var FETCH_SELECTED_PROPOSAL_PAYMENT = 'FETCH_SELECTED_PROPOSAL_PAYMENT';
var REMOVE_TRANSFER_FROM_PROPOSALS = 'REMOVE_TRANSFER_FROM_PROPOSALS';
var SET_PROPOSALS = 'SET_PROPOSALS';
var SAVE_CUSTOMER_PROPOSAL = 'SAVE_CUSTOMER_PROPOSAL';
var UPDATE_INSURANCES = 'UPDATE_INSURANCES';
var DELETE_INSURANCES = 'DELETE_INSURANCES';
var PREPARE_BE = 'PREPARE_BE';
var DISPLAY_TOAST_ON_CONTEXT_SHARE = 'DISPLAY_TOAST_ON_CONTEXT_SHARE';
var FETCH_PROPOSALS_FROM_EDIT_CRITERIA = 'FETCH_PROPOSALS_FROM_EDIT_CRITERIA';
var SAVE_DONATION_TO_PROPOSALS = 'SAVE_DONATION_TO_PROPOSALS';
var SET_PROMO_CODE = 'SET_PROMO_CODE';
var SET_PROMO_CODE_FAILURE_STATUS = 'failure';
var SET_PROMO_CODE_SUCCESS_STATUS = 'success';
var UPDATE_SERVICES = 'UPDATE_SERVICES';
var ADD_SERVICE = 'ADD_SERVICE';
var DELETE_SERVICE = 'DELETE_SERVICE';
var SWITCH_PROPOSALS_OFFERS = 'SWITCH_PROPOSALS_OFFERS';
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD = 30;
var INSURANCE_ADDED = 'INSURANCE_DELETED';
var INSURANCE_DELETED = 'INSURANCE_ADDED';

/***/ }),

/***/ "UR9l":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("rL40"),
    getPrototype = __webpack_require__("lBGg"),
    getSymbols = __webpack_require__("WwbQ"),
    stubArray = __webpack_require__("HcXJ");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ "UszP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediaTextVerticalResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var mediaTextVerticalResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* MEDIA_TEXT_VERTICAL */ "v"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common {\n          close\n          seeMore\n          loadLess\n        }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_COMMON_I18N */ "c"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "VAV/":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "VBBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextSeeMore; });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _see_more_SeeMore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NPTU");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qqKu");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var TextSeeMore = function TextSeeMore(_ref) {
  var className = _ref.className,
      hasNoScrollOnCollapse = _ref.hasNoScrollOnCollapse,
      isCollapseEnabled = _ref.isCollapseEnabled,
      offsetScrollSelector = _ref.offsetScrollSelector,
      onClick = _ref.onClick,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreSize = _ref.seeMoreSize,
      seeMoreTheme = _ref.seeMoreTheme,
      textProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, ["className", "hasNoScrollOnCollapse", "isCollapseEnabled", "offsetScrollSelector", "onClick", "seeLessLabel", "seeMoreLabel", "seeMoreSize", "seeMoreTheme"]);

  return __jsx(_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_2__[/* SeeMore */ "a"], {
    className: className,
    hasNoScrollOnCollapse: hasNoScrollOnCollapse,
    isCollapseEnabled: isCollapseEnabled,
    offsetScrollSelector: offsetScrollSelector,
    onClick: onClick,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize,
    theme: seeMoreTheme
  }, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_3__[/* Text */ "a"], textProps));
};

/***/ }),

/***/ "VGTs":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "VGY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryIntroductionResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var countryIntroductionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* COUNTRY_INTRODUCTION */ "g"],
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var countryId = props.countryId,
        isForFamily = props.isForFamily;
    var countryArgs = "countryId:\"".concat(countryId, "\" isForFamily:").concat(isForFamily.toString());
    var query = "query {\n      countryInfos(".concat(countryArgs, ") {\n        title\n        description\n      }\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_COMMON_COUNTRY_INTRODUCTION */ "Cb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "VNuc":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "VO7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setAdultsNumber; });
/* unused harmony export updateAdult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setAdults; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ORYz");



function setAdultsNumber(adultsNumber) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_ADULTS_NUMBER */ "e"], {
    adultsNumber: adultsNumber
  });
}

function updateAdult(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_ADULT */ "f"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}

function setAttendees(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ATTENDEES */ "d"], payload);
}

function setAdults(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ADULTS */ "c"], payload);
}



/***/ }),

/***/ "VUEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productMultimediaResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");





var productMultimediaResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_MULTIMEDIA */ "kb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var resortId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_3__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var query = "{\n      config {\n        common {\n          close\n          galleries {\n            gallery\n            openProductSlideShowGalleryAt\n            openSlideShowGallery\n            productGallery\n            productPictureItem\n            productNextPicture\n            productPreviousPicture\n          }\n          next\n          photoTitle\n          previous\n          socialPicturesTitle\n          videoTitle\n          video360Title\n        }\n      }\n      media(".concat(productArgs, ") {\n        photos {url}\n        videos {url thumbnailUrl}\n        videos360 {url thumbnailUrl}\n      }\n      resort(").concat(productArgs, "){\n        name\n      }\n      socialPictures(").concat(productArgs, ") {\n        userName\n        imageSmall\n        imageLarge\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_PRODUCT_MULTIMEDIA */ "pc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    })["catch"](function () {
      return {};
    });
  }
};

/***/ }),

/***/ "VqO2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prebookingFormResolver; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");






function getPrebookingQuery(resortIds, appContext, props) {
  var productIdsAsString = JSON.stringify(resortIds);
  var message = props.stay.minAgeInformation;
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease,
      country = appContext.country;
  return "{\n    config {\n      memberSpace {\n        accessButtonLoggedin\n      }\n    }\n    success: pageByPageId(pageId: \"prebooking-form-success\") { url }\n    error: pageByPageId(pageId: \"prebooking-form-error\") { url }\n    civilities {\n      adult {\n        name: label\n        value: code\n      }\n    }\n    travelAgencies(countryCode: \"".concat(country, "\" agencyTypes: [CLUBMED, FRANCHISE]) {\n      id\n      name\n      address {\n        city\n      }\n    }\n    bookingsCriteria(resortIds: ").concat(productIdsAsString, ") {\n      durations\n      departureCities {\n        value\n        name\n      }\n    }\n    resorts(resortIds: ").concat(productIdsAsString, ") {\n      id\n      name\n      destination {\n        country\n      }\n      accommodations {\n        id\n        label\n        categories {\n          id\n          label\n        }\n      }\n      openingDates {\n        opening\n        closing\n      }\n      adultOnly\n      minAuthorizedAge {\n        formattedValue(message: \"").concat(message, "\" content: \"").concat(cmsContent, "\" release: \"").concat(cmsRelease, "\")\n        value\n      }\n    }\n    accommodationCategories(productIds: ").concat(productIdsAsString, ") {\n      productId\n      accommodations {\n        id\n        label\n        ranking\n      }\n    }\n    legalInformations {\n      newsletterOptins {\n        id\n        title\n        description\n      }\n    }\n  }");
}

var prebookingFormResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_2__[/* PREBOOKING_FORM */ "G"],
  resolve: function () {
    var _resolve = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(appContext, props) {
      var resortsQuery, products, _ref, resorts, productIds, prebookingProductIds, prebookingQuery;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              resortsQuery = "{\n      resorts {\n        id\n      }\n    }";
              products = props.products;
              _context.next = 4;
              return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(resortsQuery, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_RESORTS */ "fb"],
                strictErrors: false
              });

            case 4:
              _ref = _context.sent;
              resorts = _ref.resorts;
              productIds = products.map(function (_ref2) {
                var productId = _ref2.productId;
                return productId;
              });
              prebookingProductIds = resorts.filter(function (_ref3) {
                var id = _ref3.id;
                return productIds.includes(id);
              }).map(function (_ref4) {
                var id = _ref4.id;
                return id;
              });
              prebookingQuery = getPrebookingQuery(prebookingProductIds, appContext, props);
              return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(prebookingQuery, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_DATA */ "eb"],
                strictErrors: false
              }));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function resolve(_x, _x2) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }()
};

/***/ }),

/***/ "VtPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MONTH; });
/* unused harmony export calendarQuery */
/* unused harmony export bookableDatesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return queryFetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return queryFetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDefaultSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPricesByDays; });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nv//");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ldK3");






var NO_TRANSPORT_VALUE = 'NO';
var DATE_FORMAT = 'YYYYMM';
var INITIAL_MONTH = 0;
function calendarQuery(args) {
  var resortId = args.resortId,
      duration = args.duration,
      departureCity = args.departureCity,
      urgentisationRate = args.urgentisationRate;
  return "\n      calendar(resortId: \"".concat(resortId, "\", duration: \"").concat(duration, "\", departureCity: \"").concat(departureCity, "\") {\n        basePrice {\n          currency\n          bestPrice {\n            value\n            currency\n            formattedValue\n          }\n          initialPrice {\n            value\n            currency\n            formattedValue\n          }\n          unit\n        }\n        blocks {\n          hasPrice\n          id\n          name\n          price {\n            value\n            currency\n            formattedValue\n          }\n          shortName\n          year\n        }\n        firstAvailableMonthIndex\n        months {\n          id\n          days {\n            dayContent {\n              arrivalDate\n              availability\n              canGoToBooking\n              id\n              isCurrentMonth\n              name\n              number\n              offer(urgentisationRate: ").concat(urgentisationRate, ")\n              shortName\n            }\n            priceConfig {\n              bestPrice(forceAdultPerTrip: true) { value formattedValue }\n              currency\n              initialPrice(forceAdultPerTrip: true) { value formattedValue }\n              isBestPriceMonth\n              termsAndConditions {\n                accommodationComfortLabel\n                departureCity {\n                  value\n                  name\n                }\n                departureDate\n                duration\n                numberOfAdults\n              }\n              rawUnit\n              unit\n            }\n          }\n        }\n        weekDays\n      }\n    ");
}
function bookableDatesQuery(_ref) {
  var departureCity = _ref.departureCity,
      departureDate = _ref.departureDate,
      lastDate = _ref.lastDate,
      productId = _ref.productId;
  return "\n    bookableDates(productId: \"".concat(productId, "\", departureDate: \"").concat(departureDate, "\", lastDate: \"").concat(lastDate, "\", departureCity: \"").concat(departureCity, "\") {\n      months {\n        id\n        days {\n          id\n          availabilities {\n            status\n            durations\n          }\n        }\n      }\n    }\n  ");
}
function queryFetchCalendar(appContext, options) {
  var locale = appContext.locale;
  var _options$resortId = options.resortId,
      resortId = _options$resortId === void 0 ? '' : _options$resortId,
      _options$transport = options.transport,
      transport = _options$transport === void 0 ? '' : _options$transport,
      duration = options.duration,
      urgentisationRate = options.urgentisationRate;
  var calendarQueryArgs = {
    locale: locale,
    resortId: resortId,
    departureCity: transport || NO_TRANSPORT_VALUE,
    duration: duration,
    urgentisationRate: urgentisationRate
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery("query {".concat(calendarQuery(calendarQueryArgs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* STATE_PRODUCT_CALENDAR */ "Cd"]
  }).then(function (_ref2) {
    var calendar = _ref2.calendar;
    return {
      calendar: calendar
    };
  });
}
function queryFetchBookableDates(appContext, options) {
  var _options$productId = options.productId,
      productId = _options$productId === void 0 ? '' : _options$productId,
      _options$departureDat = options.departureDate,
      departureDate = _options$departureDat === void 0 ? '' : _options$departureDat,
      _options$departureCit = options.departureCity,
      departureCity = _options$departureCit === void 0 ? '' : _options$departureCit,
      _options$lastDate = options.lastDate,
      lastDate = _options$lastDate === void 0 ? '' : _options$lastDate;
  var bookableDatesQueryArs = {
    productId: productId,
    departureDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* timestampToApiDate */ "l"])(departureDate || '') || '',
    lastDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* timestampToApiDate */ "l"])(lastDate || '') || '',
    departureCity: departureCity
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery("query {".concat(bookableDatesQuery(bookableDatesQueryArs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* STATE_PRODUCT_BOOKABLE_DATES */ "Bd"]
  }).then(function (_ref3) {
    var bookableDates = _ref3.bookableDates;
    return {
      bookableDates: bookableDates
    };
  });
}
function getDefaultSelectedMonth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var momentDate = value ? moment__WEBPACK_IMPORTED_MODULE_0___default()(value, format) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
  return parseInt(momentDate.format(DATE_FORMAT), 10);
}
function getSelectedMonth(calendar, previousSelectedMonth) {
  var _calendar$months; // The query date param prevails


  var dateQueryParam = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_4__[/* getSpecificQueryParam */ "j"])(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_DEPARTURE_DATE */ "f"]);

  if (dateQueryParam) {
    return getDefaultSelectedMonth(dateQueryParam);
  }

  var firstCalendarMonth = ((_calendar$months = calendar.months) === null || _calendar$months === void 0 ? void 0 : _calendar$months[0].id) || getDefaultSelectedMonth();
  var firstAvailableMonthIndex = calendar.firstAvailableMonthIndex || INITIAL_MONTH;
  var firstAvailableMonth = parseInt(moment__WEBPACK_IMPORTED_MODULE_0___default()(firstCalendarMonth, DATE_FORMAT).add(firstAvailableMonthIndex, 'months').format(DATE_FORMAT), 10); // The previously selected month remains selected unless the first available dates are later

  if (previousSelectedMonth > firstAvailableMonth) {
    return previousSelectedMonth;
  }

  return firstAvailableMonth;
}
function getPricesByDays(calendar) {
  var prices = {};

  if (calendar.months) {
    calendar.months.forEach(function (_ref4) {
      var days = _ref4.days;

      if (days) {
        days.forEach(function (_ref5) {
          var _priceConfig$termsAnd, _priceConfig$termsAnd2;

          var dayContent = _ref5.dayContent,
              priceConfig = _ref5.priceConfig;

          var _ref6 = dayContent || {},
              availability = _ref6.availability,
              id = _ref6.id,
              offer = _ref6.offer;

          var isBestPrice = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.isBestPriceMonth;
          var unit = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.unit;
          var departureCityValue = (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd === void 0 ? void 0 : (_priceConfig$termsAnd2 = _priceConfig$termsAnd.departureCity) === null || _priceConfig$termsAnd2 === void 0 ? void 0 : _priceConfig$termsAnd2.value) || NO_TRANSPORT_VALUE;

          if (id) {
            var _priceConfig$termsAnd3, _priceConfig$termsAnd4, _priceConfig$initialP, _priceConfig$bestPric, _priceConfig$bestPric2;

            var closed = availability === 'closed';
            var exclusivity = availability === 'exclusivity';
            var noDeparture = availability === 'noDeparture';
            var noFlight = availability === 'noFlight';
            var full = availability === 'full';
            var noAvailability = availability === '';
            var available = availability === 'available' || availability === 'unknown';
            var lastAvailability = offer === 'urgentisation';
            prices[id] = {
              availability: availability,
              available: available,
              closed: closed,
              currency: priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.currency,
              departureCity: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd3 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd3 === void 0 ? void 0 : (_priceConfig$termsAnd4 = _priceConfig$termsAnd3.departureCity) === null || _priceConfig$termsAnd4 === void 0 ? void 0 : _priceConfig$termsAnd4.name) || '',
              exclusivity: exclusivity,
              full: full,
              hasTransport: departureCityValue !== NO_TRANSPORT_VALUE,
              isBestPrice: isBestPrice,
              lastAvailability: lastAvailability,
              noAvailability: noAvailability,
              noDeparture: noDeparture,
              noFlight: noFlight,
              oldPrice: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$initialP = priceConfig.initialPrice) === null || _priceConfig$initialP === void 0 ? void 0 : _priceConfig$initialP.formattedValue) || null,
              price: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric = priceConfig.bestPrice) === null || _priceConfig$bestPric === void 0 ? void 0 : _priceConfig$bestPric.formattedValue) || null,
              priceValue: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric2 = priceConfig.bestPrice) === null || _priceConfig$bestPric2 === void 0 ? void 0 : _priceConfig$bestPric2.value) || null,
              unit: unit
            };
          }
        });
      }
    });
  }

  return prices;
}

/***/ }),

/***/ "W+NJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputButton_InputButton; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.themes.js



var InputButton_themes_themes = function themes(_ref) {
  var _classnames, _classnames3;

  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SUCCESS : _ref$color,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading;
  return {
    "default": {
      thRoot: classnames_default()('border-1 flex items-stretch leading-none rounded-tiny text-base transition-colors', (_classnames = {
        'bg-white border-gray-light text-gray-darker focus-within:border-blue hover:border-blue focus-within:text-blue hover:text-blue': !isActive && !isFilled && !isDisabled,
        'bg-white border-blue text-blue': isActive && !isFilled && !isDisabled
      }, Object(defineProperty["a" /* default */])(_classnames, "bg-white border-".concat(color, " text-gray-darker"), isFilled && !isDisabled), Object(defineProperty["a" /* default */])(_classnames, 'bg-gray-lighter border-gray-light text-gray-medium', isDisabled), _classnames)),
      thHeightStyle: {
        minHeight: '3.125rem',
        // IE11 needs a height in addition to minHeight to center vertically.
        height: '1px'
      },
      thButton: classnames_default()('reset-button flex items-center flex-1 text-current text-initial justify-center', {
        'lg:justify-between': !isLoading
      }),
      thClear: 'reset-button px-3 flex-shrink-0 text-current',
      thClearSize: '0.625rem',
      thIcon: classnames_default()('flex-shrink-0 md:mx-2', Object(defineProperty["a" /* default */])({
        'text-blue': isActive && !isFilled && !isDisabled
      }, "text-".concat(color), isFilled && !isDisabled)),
      thIconSize: '1.125rem',
      thIconSelect: "hidden lg:inline-block md:flex-shrink-0 mx-2 transition-transform ".concat(isActive ? 'rotate-180' : ''),
      thLoader: 'flex items-center justify-center leading-none',
      thSpinnerColor: isFilled ? 'current' : 'blue'
    },
    select: {
      thRoot: classnames_default()('border-1 flex items-stretch leading-none rounded-tiny text-base transition-colors', (_classnames3 = {}, Object(defineProperty["a" /* default */])(_classnames3, "bg-white border-gray-medium text-gray-darker focus-within:border-".concat(color, " hover:border-").concat(color, " focus-within:text-").concat(color, " hover:text-").concat(color), !isActive && !isFilled && !isDisabled), Object(defineProperty["a" /* default */])(_classnames3, "bg-white border-".concat(color, " text-").concat(color), isActive && !isFilled && !isDisabled), Object(defineProperty["a" /* default */])(_classnames3, "bg-".concat(color, " border-").concat(color, " text-white"), isFilled && !isDisabled), Object(defineProperty["a" /* default */])(_classnames3, 'bg-gray-lighter border-gray-light text-gray-medium', isDisabled), _classnames3)),
      thHeightStyle: {
        height: '1px'
      },
      thButton: 'reset-button flex items-center flex-1 text-current text-initial button-default lg:justify-between justify-center',
      thClear: 'reset-button px-3 flex-shrink-0 text-current',
      thClearSize: '0.625rem',
      thIcon: 'flex-shrink-0 lg:mx-3',
      thIconSelect: classnames_default()('inline-block lg:flex-shrink-0 mx-3 transition-transform', {
        'rotate-180': isActive
      }),
      thLoader: 'flex items-center justify-center leading-none',
      thSpinnerColor: isFilled ? 'current' : 'blue'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.jsx
var __jsx = react_default.a.createElement;






var InputButton_InputButton = function InputButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      dataTestId = _ref.dataTestId,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = InputButton_themes_themes({
    color: color,
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isLoading: isLoading
  })[theme],
      thButton = _themes$theme.thButton,
      thClear = _themes$theme.thClear,
      thClearSize = _themes$theme.thClearSize,
      thHeightStyle = _themes$theme.thHeightStyle,
      thIcon = _themes$theme.thIcon,
      thIconSelect = _themes$theme.thIconSelect,
      thIconSize = _themes$theme.thIconSize,
      thLoader = _themes$theme.thLoader,
      thRoot = _themes$theme.thRoot,
      thSpinnerColor = _themes$theme.thSpinnerColor;

  if (!iconName && !children) {
    return null;
  }

  var hasClear = onClear && !isDisabled && isFilled;
  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, __jsx("button", {
    className: thButton,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: onClick,
    style: thHeightStyle,
    type: "button"
  }, !!iconName && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    color: "none",
    name: iconName,
    width: thIconSize
  }), isLoading ? __jsx("div", {
    className: thLoader
  }, __jsx(Spinner["a" /* Spinner */], {
    color: thSpinnerColor,
    size: "small"
  })) : children, !hasClear && !!children && __jsx(Icon["a" /* Icon */], {
    className: thIconSelect,
    name: icons["a" /* ICONS */].SELECT,
    width: ".625rem"
  })), hasClear && __jsx("button", {
    "data-testid": "InputButtonClear",
    className: thClear,
    disabled: isDisabled,
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearSize
  })));
};

/***/ }),

/***/ "WRD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Fieldset; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/frameworks/fieldset/Fieldset.themes.js
var themes = {
  "default": {
    thRoot: 'border-0 m-0 p-0 relative',
    thLegends: 'font-bold mb-5 text-2xl text-blue w-full',
    thHead: 'flex items-center leading-tight',
    thIcon: 'rtl:mr-4 flex-shrink-0',
    thIconSize: '1.9rem',
    thLegendsInner: 'flex-1',
    thLegend: 'after-decorator-line flex items-baseline',
    thSmall: 'block font-normal leading-one text-sm text-gray-darker',
    thDescription: 'mb-5'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/fieldset/Fieldset.jsx
var __jsx = react_default.a.createElement;





function Fieldset(props) {
  var children = props.children,
      className = props.className,
      description = props.description,
      iconName = props.iconName,
      legend = props.legend,
      subLegend = props.subLegend,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  if (!react["Children"].count(children)) return null;
  var hasLegend = !!iconName || !!legend || !!subLegend;
  var _themes$theme = themes[theme],
      thDescription = _themes$theme.thDescription,
      thHead = _themes$theme.thHead,
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thLegend = _themes$theme.thLegend,
      thLegends = _themes$theme.thLegends,
      thLegendsInner = _themes$theme.thLegendsInner,
      thRoot = _themes$theme.thRoot,
      thSmall = _themes$theme.thSmall;
  return __jsx("fieldset", {
    className: classnames_default()(className, thRoot)
  }, hasLegend && __jsx("legend", {
    className: thLegends
  }, __jsx("div", {
    className: thHead
  }, __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: iconName,
    width: thIconSize
  }), (legend || subLegend) && __jsx("div", {
    className: thLegendsInner
  }, __jsx("div", {
    className: thLegend,
    "data-testid": "Fieldset-legend"
  }, legend), subLegend && __jsx("small", {
    className: thSmall
  }, subLegend)))), __jsx(Text["a" /* Text */], {
    className: thDescription,
    text: description
  }), children);
}

/***/ }),

/***/ "WUtx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productRestaurantsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productRestaurantsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_RESTAURANTS */ "ob"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      restaurants(".concat(productArgs, "){\n        introduction { description }\n        restaurantsList { name images description }\n      }\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_RESTAURANTS */ "xc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "Wb8K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return offerSEOResolver; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");






function generateOfferTitle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var offerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["messageFormat"])(title).format({
    offerName: offerName
  });
}

var offerSEOResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_2__[/* OFFER_SEO */ "E"],
  props: function props() {
    return {
      title: function title(props) {
        return generateOfferTitle(props.title || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(props, 'config.offer.seo.title'), Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(props, 'offer.name'));
      },
      meta: function meta(props) {
        return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(props, 'offer.htmlHeader.meta', []);
      }
    };
  },
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var offerId = props.offerId;
    var query = "{\n      config {\n        offer {\n          seo {\n            title\n          }\n        }\n      }\n      offer(offerId: \"".concat(offerId, "\") {\n        name\n        htmlHeader {\n          meta {\n            name\n            content\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_OFFER_SEO */ "Xb"]
    })["catch"](function () {
      return {
        offer: null
      };
    });
  }
};

/***/ }),

/***/ "WwbQ":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("AzLH"),
    stubArray = __webpack_require__("HcXJ");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "WzQP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridRow; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("I6kL");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




function getResponsiveClasses(grid) {
  return Object.keys(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"]).map(function (key) {
    if (grid.hasOwnProperty(key)) {
      return " ".concat(_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"][key], "-GridRow--").concat(grid[_utils_responsive_Responsive_constants__WEBPACK_IMPORTED_MODULE_2__[/* BREAKPOINTS */ "a"][key]]); // fit, full, 1of2, 1of3
    }
  }).join('');
}

function GridRow(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$grid = _ref.grid,
      grid = _ref$grid === void 0 ? {} : _ref$grid,
      _ref$hasLeftGutters = _ref.hasLeftGutters,
      hasLeftGutters = _ref$hasLeftGutters === void 0 ? true : _ref$hasLeftGutters,
      _ref$hasTopGutters = _ref.hasTopGutters,
      hasTopGutters = _ref$hasTopGutters === void 0 ? true : _ref$hasTopGutters;
  if (!react__WEBPACK_IMPORTED_MODULE_0__["Children"].count(children)) return null;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'flex flex-wrap', {
      'GridRow--leftGutters': hasLeftGutters,
      'GridRow--topGutters': hasTopGutters
    }, getResponsiveClasses(grid))
  }, children);
}

/***/ }),

/***/ "XL2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BaiduSeoScript_BaiduSeoScript; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/utils/media-server/index.js
var media_server = __webpack_require__("FLQK");

// CONCATENATED MODULE: ./src/seo/json-ld/index.js


function getBaiduStructuredPageData(title, description, imageUrls, pageUrl) {
  return {
    '@context': 'https://zhanzhang.baidu.com/contexts/cambrian.jsonld',
    '@id': pageUrl,
    title: title,
    description: description,
    images: imageUrls.map(function (url) {
      return media_server["a" /* getUrl */]({
        format: '_AUTOFORMAT_',
        url: url,
        width: 2000,
        height: 'auto',
        transform: 'resize',
        quality: 70
      });
    }),
    pubDate: moment_default()() // Set to the beginning of the current quarter,
    // 1st day of months, 12:00 am
    .startOf('quarter').format('YYYY-MM-DDThh:mm:ss')
  };
}
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /home/circleci/project/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// CONCATENATED MODULE: ./src/seo/sitemap/sitemap.utils.js




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var SITEMAP_URL_CHANGE_FREQUENCY = 'weekly';
var SITEMAP_URL_PRIORITY = 0.5;
var XML_NAMESPACES = ['xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"', 'xmlns:xhtml="http://www.w3.org/1999/xhtml"'];
function isBaiduBot() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''; // Detects Baidu’s web crawler via the user agent string.
  // e.g. "Mozilla/5.0 (compatible; Baiduspider/2.0; +http://www.baidu.com/search/spider.html)"

  return new RegExp('Baiduspider', 'ig').test(userAgent);
}
function getXmlNamespaces(userAgent) {
  var xmlNamespaces = isBaiduBot(userAgent) ? [].concat(XML_NAMESPACES, ['xmlns:mobile="http://www.baidu.com/schemas/sitemap-mobile/1/"']) : XML_NAMESPACES;
  return xmlNamespaces.join(' ');
}
function getPageUrls(_x, _x2) {
  return _getPageUrls.apply(this, arguments);
}

function _getPageUrls() {
  _getPageUrls = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(pageTypes, _ref) {
    var appContext, pageTypesString, pagesQuery, _ref3, pages;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            appContext = _ref.appContext;
            pageTypesString = pageTypes.map(function (pageType) {
              return "\"".concat(pageType, "\"");
            }).join(',');
            pagesQuery = "{\n    pages: pagesByTypes(pageTypes: [".concat(pageTypesString, "]) {\n      href: url\n      hrefLang {\n        locale\n        url\n      }\n    }\n  }");
            _context.prev = 3;
            _context.next = 6;
            return graphqlClient["a" /* default */].runQuery(pagesQuery, appContext, {
              requestName: requestDictionary["Sc" /* PAGE_SITEMAP */]
            });

          case 6:
            _ref3 = _context.sent;
            pages = _ref3.pages;
            return _context.abrupt("return", pages);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            logger_default.a.error(_context.t0);
            return _context.abrupt("return", []);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 11]]);
  }));
  return _getPageUrls.apply(this, arguments);
}

function getPageEntries(dataEntries, _ref2) {
  var appContext = _ref2.appContext,
      userAgent = _ref2.userAgent;
  var locale = appContext.locale,
      originalUrl = appContext.originalUrl;
  var uri = new URI_default.a(originalUrl);
  var hostname = uri.hostname();
  var tld = uri.tld();
  var isDomainDefaultLocale = dist_default.a.getLocaleFromHostname(tld) === locale;
  return dataEntries.map(function (entry) {
    var href = entry.href,
        hrefLang = entry.hrefLang; // Build full entry url

    var entryUri = new URI_default.a(href).protocol('https').hostname(hostname).tld(tld);
    if (!isDomainDefaultLocale) entryUri.addQuery({
      locale: locale
    });
    var url = entryUri.toString(); // Build localized links

    var links = hrefLang.map(function (link) {
      return {
        lang: link.locale,
        url: link.url
      };
    }); // Build complete entry

    return _objectSpread(_objectSpread({
      url: url,
      changefreq: SITEMAP_URL_CHANGE_FREQUENCY,
      priority: SITEMAP_URL_PRIORITY
    }, links.length > 0 && {
      links: links
    }), isBaiduBot(userAgent) && {
      mobile: 'pc mobile'
    });
  });
}
// EXTERNAL MODULE: ./src/utils/locale/localeUtils.js
var localeUtils = __webpack_require__("1tzK");

// CONCATENATED MODULE: ./src/client/components/third-party/BaiduSeoScript.jsx

var __jsx = react_default.a.createElement;




var BaiduSeoScript_BaiduSeoScript = function BaiduSeoScript(_ref) {
  var lines = _ref.lines,
      locale = _ref.locale,
      userAgent = _ref.userAgent,
      originalUrl = _ref.originalUrl,
      pageTitle = _ref.pageTitle,
      pageDescription = _ref.pageDescription;

  var getImmersives = function getImmersives(allLines) {
    var immersives = [];

    var collectFn = function collectFn(line) {
      var _line$props$media;

      immersives = line.name === 'immersive' ? [].concat(Object(toConsumableArray["a" /* default */])(immersives), [line.props.backgroundURL]) : immersives;
      immersives = line.name === 'product-immersive' ? [].concat(Object(toConsumableArray["a" /* default */])(immersives), Object(toConsumableArray["a" /* default */])((_line$props$media = line.props.media) === null || _line$props$media === void 0 ? void 0 : _line$props$media.photos.map(function (p) {
        return p.url;
      }))) : immersives;
      (line.props.lines || []).forEach(collectFn);
    };

    allLines.forEach(collectFn);
    return immersives;
  };

  return isBaiduBot(userAgent) && Object(localeUtils["a" /* isChineseLocale */])(locale) && __jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(getBaiduStructuredPageData(pageTitle, pageDescription, getImmersives(lines), originalUrl))
    }
  });
};

/***/ }),

/***/ "XSvm":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "XTOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_Product; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// CONCATENATED MODULE: ./src/client/components/widgets/offer-discount/OfferDiscount.jsx

var __jsx = react_default.a.createElement;



function OfferDiscount(props) {
  var className = props.className,
      _props$discount = props.discount,
      discount = _props$discount === void 0 ? {} : _props$discount,
      _props$i18n = props.i18n,
      i18n = _props$i18n === void 0 ? {} : _props$i18n;
  var offerName = discount && discount.offerName || i18n.defaultLabel || '';
  var color = discount && discount.offerColor || i18n.defaultColor || '';
  return Object(lodash["get"])(discount, 'amount.value') ? __jsx("div", {
    className: classnames_default()(className, 'bg-current font-bold p-1 text-center text-sm uppercase', Object(defineProperty["a" /* default */])({}, "text-".concat(color), color)),
    style: {
      backgroundColor: color
    }
  }, __jsx("span", {
    className: "text-white"
  }, offerName)) : null;
}
// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/Availability.jsx
var Availability_jsx = react_default.a.createElement;




var computeAvailabilityStatus = function computeAvailabilityStatus(_ref) {
  var availability = _ref.availability,
      remainingStock = _ref.remainingStock;

  switch (true) {
    case availability === 'UNAVAILABLE':
    case availability === 'AVAILABLE' && remainingStock === 0:
      return 'unavailable';

    case availability === 'AVAILABLE' && remainingStock !== null && +remainingStock < 10:
    case availability === 'PARTIAL':
      return 'remaining';

    case availability === 'AVAILABLE':
      return 'available';

    default:
      return 'unknown';
  }
};

var Availability_Availability = function Availability(_ref2) {
  var availability = _ref2.availability,
      config = _ref2.config,
      remainingStock = _ref2.remainingStock;
  var availabilityStatus = computeAvailabilityStatus({
    availability: availability,
    remainingStock: remainingStock
  });

  var _ref3 = config[availabilityStatus] || {},
      color = _ref3.color,
      icon = _ref3.icon,
      label = _ref3.label;

  return label ? Availability_jsx("span", {
    className: "flex flex-none flex-shrink items-center text-".concat(color, " rtl:text-right")
  }, icon && Availability_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-1",
    name: icon,
    width: "0.8rem"
  }), Object(dist["messageFormat"])(label).format({
    count: remainingStock
  })) : null;
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/AvailabilityAge.jsx
var AvailabilityAge_jsx = react_default.a.createElement;



var shouldShowAgeInMonth = function shouldShowAgeInMonth(ageInNumberOfMonths) {
  return ageInNumberOfMonths <= 23;
};

var shouldShowAgeInYearsRange = function shouldShowAgeInYearsRange(ageMin, ageMax) {
  return !(Math.floor(ageMin / 12) === Math.floor(ageMax / 12));
};

var AvailabilityAge_AvailabilityAge = function AvailabilityAge(_ref) {
  var ageMax = _ref.ageMax,
      ageMin = _ref.ageMin,
      childcareLabel = _ref.childcareLabel,
      monthsLabel = _ref.monthsLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var message = '';

  if (shouldShowAgeInMonth(ageMax)) {
    message = Object(dist["messageFormat"])(monthsLabel).format({
      min: ageMin,
      max: ageMax
    });
  } else if (shouldShowAgeInYearsRange(ageMin, ageMax)) {
    message = Object(dist["messageFormat"])(yearsLabel).format({
      min: Math.floor(ageMin / 12),
      max: Math.floor(ageMax / 12)
    });
  } else {
    // Shows a single year age
    message = Object(dist["messageFormat"])(yearLabel).format({
      fixed: Math.floor(ageMin / 12)
    });
  }

  return AvailabilityAge_jsx(react["Fragment"], null, "".concat(childcareLabel, " "), AvailabilityAge_jsx("span", {
    className: "font-normal whitespace-no-wrap"
  }, "(", message, ")"));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/productChildcareAvailabilities.jsx
var productChildcareAvailabilities_jsx = react_default.a.createElement;







var productChildcareAvailabilities_ProductChildcareAvailabilities = function ProductChildcareAvailabilities(_ref) {
  var availableLabel = _ref.availableLabel,
      childcareLabel = _ref.childcareLabel,
      items = _ref.items,
      monthsLabel = _ref.monthsLabel,
      remainingLabel = _ref.remainingLabel,
      unavailableLabel = _ref.unavailableLabel,
      unknownLabel = _ref.unknownLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var renderConfig = {
    available: {
      color: colors["a" /* COLORS */].EMERALD,
      icon: icons["a" /* ICONS */].SMALL_CHECK,
      label: availableLabel
    },
    remaining: {
      color: colors["a" /* COLORS */].ORANGE,
      icon: icons["a" /* ICONS */].WARNING,
      label: remainingLabel
    },
    unavailable: {
      color: colors["a" /* COLORS */].RED,
      icon: icons["a" /* ICONS */].SMALL_CROSS,
      label: unavailableLabel
    },
    unknown: {
      color: colors["a" /* COLORS */].GRAY_MEDIUM,
      label: unknownLabel
    }
  };
  return productChildcareAvailabilities_jsx(react["Fragment"], null, items.map(function (_ref2) {
    var id = _ref2.id,
        ageMin = _ref2.ageMin,
        ageMax = _ref2.ageMax,
        availability = _ref2.availability,
        isIncluded = _ref2.isIncluded,
        remainingStock = _ref2.remainingStock;
    return productChildcareAvailabilities_jsx("p", {
      key: id,
      className: "flex font-bold items-start justify-between mt-3 reset-paragraph text-base text-gray-darker"
    }, productChildcareAvailabilities_jsx("span", {
      className: "flex-1"
    }, productChildcareAvailabilities_jsx(AvailabilityAge_AvailabilityAge, {
      ageMax: ageMax,
      ageMin: ageMin,
      childcareLabel: childcareLabel,
      monthsLabel: monthsLabel,
      yearLabel: yearLabel,
      yearsLabel: yearsLabel
    }), productChildcareAvailabilities_jsx("span", {
      className: classnames_default()('font-brand font-normal ml-1 text-sm', {
        'text-blue': isIncluded,
        'text-red': !isIncluded
      })
    }, isIncluded ? Object(src_i18n["f" /* t */])('common.included') : Object(src_i18n["f" /* t */])('common.onDemand'))), productChildcareAvailabilities_jsx(Availability_Availability, {
      availability: availability,
      config: renderConfig,
      remainingStock: remainingStock
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-comparison/ProductComparison.jsx

var ProductComparison_jsx = react_default.a.createElement;





var ProductComparison_ProductComparison = function ProductComparison(_ref) {
  var children = _ref.children,
      className = _ref.className,
      eligibilityLabel = _ref.eligibilityLabel,
      isEligible = _ref.isEligible,
      label = _ref.label,
      onComparisonClick = _ref.onComparisonClick,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? product_utils["b" /* IS_ENABLED */] : _ref$status;

  if (!react["Children"].count(children)) {
    return null;
  }

  if (!isEligible) return ProductComparison_jsx("div", {
    className: "relative"
  }, children, ProductComparison_jsx("div", {
    className: "absolute bg-overlay-white-60 flex font-bold items-center justify-center inset-0 p-5 text-base text-center z-1"
  }, eligibilityLabel));
  var isSelectable = status !== product_utils["a" /* IS_DISABLED */];
  var isSelected = status === product_utils["c" /* IS_SELECTED */];
  var buttonProps = isSelectable ? {
    onClick: onComparisonClick,
    type: 'button',
    title: label
  } : null;
  var TagName = isSelectable ? 'button' : 'div';
  return ProductComparison_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, 'relative', 'reset-button')
  }, buttonProps), children, ProductComparison_jsx("div", {
    className: classnames_default()('absolute', 'bg-overlay-gray-darker-40', 'flex items-center', 'justify-center', 'p-4', 'inset-0', 'text-white', 'z-1', 'rounded-tiny', {
      'cursor-pointer': isSelectable
    })
  }, isSelectable && ProductComparison_jsx("div", {
    className: classnames_default()('flex flex-col', 'items-center', 'opacity-100', 'p-2', 'rounded-full', 'border-2', 'transition-colors', {
      'bg-transparent border-white': !isSelected
    }, {
      'bg-emerald border-emerald': isSelected
    })
  }, ProductComparison_jsx(Icon["a" /* Icon */], {
    name: isSelected ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].PLUS,
    width: "1.25rem"
  }))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx + 1 modules
var ProductFlag = __webpack_require__("ELg1");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-header/ProductHeader.jsx
var ProductHeader = __webpack_require__("hgS3");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-thumbnail/ProductThumbnail.jsx

var ProductThumbnail_jsx = react_default.a.createElement;










var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var ProductThumbnail_ProductThumbnail = /*#__PURE__*/Object(react["memo"])(function ProductThumbnail(_ref) {
  var closedLabel = _ref.closedLabel,
      className = _ref.className,
      hasBorder = _ref.hasBorder,
      hasTransport = _ref.hasTransport,
      isLinkDisabled = _ref.isLinkDisabled,
      link = _ref.link,
      nextLabel = _ref.nextLabel,
      openingStatus = _ref.openingStatus,
      openingSoonLabel = _ref.openingSoonLabel,
      _ref$pictures = _ref.pictures,
      pictures = _ref$pictures === void 0 ? [] : _ref$pictures,
      previousLabel = _ref.previousLabel,
      productTags = _ref.productTags,
      _ref$tagsColor = _ref.tagsColor,
      tagsColor = _ref$tagsColor === void 0 ? colors["a" /* COLORS */].BLUE : _ref$tagsColor,
      transportLabel = _ref.transportLabel,
      isSliderDisabled = _ref.isSliderDisabled,
      hasLazyLoading = _ref.hasLazyLoading;
  var TagName = isLinkDisabled ? 'div' : DynamicLink["a" /* default */];
  var defaultPicture = pictures[0] || {};
  return ProductThumbnail_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()('block', 'image-responsive-cell', 'relative', className)
  }, isLinkDisabled ? null : link), !isSliderDisabled && pictures.length > 1 && openingStatus !== OPENING_STATUS.CLOSED ? ProductThumbnail_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    hasInsetBorder: hasBorder,
    hasLazyLoading: true,
    media: pictures,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratios_utils["a" /* default */].XL
  }) : ProductThumbnail_jsx(Image["a" /* default */], {
    altMsg: defaultPicture.alt,
    className: classnames_default()({
      'inset-border-after': hasBorder
    }),
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    groupKey: "thumbnails",
    ratioKey: ratios_utils["a" /* default */].XL,
    hasLazyLoading: hasLazyLoading
  }), hasTransport && ProductThumbnail_jsx("div", {
    className: "bg-blue inline-flex items-center overflow-hidden p-2 text-xs text-white uppercase absolute top-0 rtl:right-0 mt-5 rtl:mr-5 rounded-tiny font-brand uppercase",
    "data-testid": "ProductThumbnail-transport"
  }, ProductThumbnail_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 rtl:mr-1",
    name: icons["a" /* ICONS */].TRANSPORT,
    width: "calc(10rem / 16)"
  }), ProductThumbnail_jsx("div", {
    className: "leading-tight text-xxs",
    "data-testid": "ProductThumbnail-transportLabel"
  }, transportLabel)), openingStatus === OPENING_STATUS.OPENING_SOON && ProductThumbnail_jsx("div", {
    className: "bg-orange inline-flex items-center overflow-hidden p-2 text-xs text-white uppercase absolute top-0 rtl:right-0 mt-5 rtl:mr-5 rounded-tiny font-bold",
    "data-testid": "ProductThumbnail-openingSoon"
  }, ProductThumbnail_jsx("div", {
    className: "leading-tight text-xxs",
    "data-testid": "ProductThumbnail-openingSoonlabel"
  }, openingSoonLabel)), openingStatus === OPENING_STATUS.CLOSED && ProductThumbnail_jsx("div", {
    className: "absolute bg-overlay-black-60 font-bold inline-flex items-center justify-center overflow-hidden inset-0 rounded-tiny text-white text-xl uppercase",
    "data-testid": "ProductThumbnail-closed"
  }, ProductThumbnail_jsx("div", {
    "data-testid": "ProductThumbnail-closedLabel"
  }, closedLabel)), !!productTags && ProductThumbnail_jsx("div", {
    "data-testid": "ProductThumbnail-bottomTags",
    className: classnames_default()("bg-".concat(tagsColor), 'absolute leading-one font-brand uppercase left-1/2 bottom-0 p-2 mb-5 rounded-tiny text-center text-white text-xs -translate-x-50 whitespace-no-wrap max-w-9/10 truncate z-1')
  }, productTags));
});
// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.jsx



var Product_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

























var Product_Product = function Product(_ref) {
  var _flag$price, _flag$price$bestPrice;

  var _ref$callToAction = _ref.callToAction,
      callToAction = _ref$callToAction === void 0 ? {} : _ref$callToAction,
      childcare = _ref.childcare,
      childcareIncluded = _ref.childcareIncluded,
      className = _ref.className,
      comfort = _ref.comfort,
      comparison = _ref.comparison,
      departureDateOn = _ref.departureDateOn,
      _ref$flag = _ref.flag,
      flag = _ref$flag === void 0 ? {} : _ref$flag,
      hasComparison = _ref.hasComparison,
      hasDiscount = _ref.hasDiscount,
      _ref$hasFadeIn = _ref.hasFadeIn,
      hasFadeIn = _ref$hasFadeIn === void 0 ? true : _ref$hasFadeIn,
      hasLazyLoading = _ref.hasLazyLoading,
      header = _ref.header,
      id = _ref.id,
      index = _ref.index,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids,
      lineName = _ref.lineName,
      _ref$minAuthorizedAge = _ref.minAuthorizedAge,
      minAuthorizedAge = _ref$minAuthorizedAge === void 0 ? {} : _ref$minAuthorizedAge,
      offer = _ref.offer,
      offerDiscount = _ref.offerDiscount,
      onClick = _ref.onClick,
      onComparisonClick = _ref.onComparisonClick,
      thumbnail = _ref.thumbnail,
      url = _ref.url;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var track = Object(useTracking["a" /* useTracking */])({});
  var pageContext = react_default.a.useContext(context_pageContext["a" /* ReactPageContext */]);
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';
  var clickThumbnailTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: id,
    resortCode: id,
    resortTrident: typeof comfort === 'number' ? comfort : '',
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price = flag.price) === null || _flag$price === void 0 ? void 0 : (_flag$price$bestPrice = _flag$price.bestPrice) === null || _flag$price$bestPrice === void 0 ? void 0 : _flag$price$bestPrice.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(Object(lodash["camelCase"])(lineName)) : siteSection,
    thumbnailPosition: index + 1
  } : null;
  var ProductHeaderWrapper = hasComparison ? ProductComparison_ProductComparison : react["Fragment"];
  var linkShouldBeDisabled = isLinkDisabled || hasComparison;

  var goOnResort = function goOnResort() {
    var newHistoryState = new DynamicLinkUtil["a" /* default */](dist["windowWrapper"].getLocation(), url ? Object(Product_utils["c" /* generateProductLink */])(url, offer) : '');
    history.pushRoute(newHistoryState.toString());
  };

  var productHeader = Product_jsx(ProductHeader["a" /* ProductHeader */], Object(esm_extends["a" /* default */])({}, header, {
    className: "pt-5",
    isLinkDisabled: linkShouldBeDisabled,
    link: appContext.isCmta ? Object(Product_utils["a" /* generateCmtaLinkProp */])(url, appContext.originalUrl) : Object(Product_utils["b" /* generateLinkProp */])(url, offer),
    onClick: function onClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    }
  }));

  var minAuthorizedAgeMessage = (minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) === 0 ? Object(src_i18n["f" /* t */])('faceting.availabilities.noChildcareFrom0') : Object(dist["messageFormat"])(Object(src_i18n["f" /* t */])('faceting.availabilities.noChildcare')).format({
    min_authorized_age_in_months: Math.floor((minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) / 12)
  });

  var childcareBirthdateAlert = (kids === null || kids === void 0 ? void 0 : kids.length) > 0 && childcare && Object(lodash["isEmpty"])(childcare.items) && !childcareIncluded && Product_jsx("div", {
    className: "border-1 flex p-2 rounded-tiny text-sm"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-1",
    color: colors["a" /* COLORS */].BLACK,
    name: icons["a" /* ICONS */].SMALL_WARNING,
    width: "1rem"
  }), minAuthorizedAgeMessage);

  var noChildcareAlert = kids && kids.length > 0 && kids.some(function (kid) {
    return !kid.birthdate;
  }) && childcareIncluded && Product_jsx("button", {
    className: "bg-turquoise focus:bg-turquoise-active hover:bg-turquoise-active cursor-pointer font-bold leading-one p-2 flex rounded-tiny text-initial text-sm text-white transition-colors",
    onClick: function onClick() {
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
      Object(scrollToElement["a" /* scrollToElement */])('[data-testid="CriteriaWho"]', 600);
    },
    type: "button"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-1",
    name: icons["a" /* ICONS */].KIDS,
    width: "1rem"
  }), Object(src_i18n["f" /* t */])('faceting.availabilities.enterBirthdate'));

  return Product_jsx("article", {
    className: classnames_default()(className, 'fadeInLong flex flex-col relative', {
      fadeInLong: hasFadeIn
    }),
    onClick: onClick
  }, Product_jsx(ProductHeaderWrapper, hasComparison ? _objectSpread(_objectSpread({}, comparison), {}, {
    onComparisonClick: onComparisonClick
  }) : {}, Product_jsx("div", {
    className: "relative",
    "data-testid": "Product-Header-Wrapper"
  }, !!departureDateOn && Product_jsx("div", {
    className: "bg-white p-2 z-2 absolute rtl:left-0 -mt-5 rtl:ml-2 rounded-tiny font-brand border-1 border-turquoise shadow-xs",
    "data-testid": "Product-departure"
  }, Product_jsx("div", {
    className: "leading-tight text-base text-black",
    "data-testid": "Product-departureLabel"
  }, departureDateOn)), hasDiscount && // $FlowFixMe
  Product_jsx(OfferDiscount, Object(esm_extends["a" /* default */])({}, offerDiscount, {
    className: "absolute opacity-75 inset-x-0 z-1"
  })), Product_jsx(ProductThumbnail_ProductThumbnail, Object(esm_extends["a" /* default */])({
    className: classnames_default()('rounded-tiny', 'overflow-hidden')
  }, thumbnail, {
    hasLazyLoading: hasLazyLoading,
    isLinkDisabled: true,
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous')
  })), !hasComparison ? productHeader : null)), hasComparison ? productHeader : null, Product_jsx(ProductFlag["a" /* ProductFlag */], Object(esm_extends["a" /* default */])({}, flag, {
    isLinkDisabled: linkShouldBeDisabled,
    onClick: goOnResort,
    onCtaClick: function onCtaClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_discoverResort")
        }));
      }
    },
    onEmptyPriceClick: function onEmptyPriceClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    },
    onPriceClick: function onPriceClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_bestPrice")
        }));
      }
    },
    price: flag.price
  })), childcareBirthdateAlert, noChildcareAlert, !!callToAction.label && Product_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, callToAction, {
    className: "mt-2 w-full",
    colorBg: linkShouldBeDisabled ? colors["a" /* COLORS */].INFO : colors["a" /* COLORS */].BLUE,
    colorBorder: linkShouldBeDisabled ? colors["a" /* COLORS */].INFO : colors["a" /* COLORS */].BLUE,
    iconRight: {
      name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH
    },
    isDisabled: linkShouldBeDisabled,
    onClick: goOnResort
  }), callToAction.label), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('faceting.childcare') && childcare && !Object(lodash["isEmpty"])(childcare.items) && Product_jsx(productChildcareAvailabilities_ProductChildcareAvailabilities, childcare));
};

/***/ }),

/***/ "XiOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaContextProvider; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var initialState = {
  criteriaWhenIsSet: false,
  criteriaWhoIsSet: false,
  criteriaTransportIsSet: false,
  defaultValueForCalendar: null,
  isJoyview: false,
  layerButtonLabel: '',
  layerHeader: '',
  trackingActionName: ''
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  return _objectSpread(_objectSpread({}, state), action);
};

var CriteriaContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["createContext"])([initialState, function () {}]);
var CriteriaContextProvider = function CriteriaContextProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_1__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return __jsx(CriteriaContext.Provider, {
    value: [state, dispatch]
  }, children);
};

/***/ }),

/***/ "Y3fD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__("ERkP");
var factory = __webpack_require__("ttFy");

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),

/***/ "YKA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransportSummary; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("taV1");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var TransportSummary = function TransportSummary(_ref) {
  var departure = _ref.departure,
      _ref$extendedDataset = _ref.extendedDataset,
      extendedDataset = _ref$extendedDataset === void 0 ? false : _ref$extendedDataset,
      transportIcon = _ref.transportIcon;
  var noTransportIcon = _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].NO_TRANSPORT;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('PackagePriceSummary-section', {
      'PackagePriceSummary-section--extended': extendedDataset
    }),
    "data-testid": _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__[/* CRITERIA_SELECTORS */ "m"].TRANSPORT
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "PackagePriceSummary-icon",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    hasRtl: true,
    name: departure ? transportIcon : noTransportIcon,
    width: "1.875rem"
  }), departure ? __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "f"])('common.transport.from'), ' ', __jsx("span", {
    className: "PackagePriceSummary-departure"
  }, departure)) : Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "f"])('booking.priceDetails.packagePrice.noTransport'));
};

/***/ }),

/***/ "YRNe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AlternativeProposals; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/AlternativePrice.themes.js
var themes = {
  "default": {
    thRoot: 'w-full bg-white border-1 rounded-small shadow-sm relative',
    thHeightStyle: {
      minHeight: '3.125rem',
      // IE11 needs a height in addition to minHeight to center vertically.
      height: '1px'
    },
    thButton: 'flex flex-1 border-1 leading-none overflow-hidden rounded-small text-base bg-blue border-blue text-white items-center text-current text-initial lg:rtl:mr-3 justify-center md:justify-between',
    thClear: 'reset-button px-3 flex-shrink-0 text-current',
    thClearSize: '0.625rem',
    thIcon: 'flex-shrink-0 mx-2',
    thLabel: 'flex-1 mx-2 overflow-hidden flex items-center whitespace-no-wrap',
    thSubmitButton: 'reset-button bg-success cursor-pointer font-bold flex justify-center items-center leading-none rounded-small text-base text-white mt-4 lg:mt-0 lg:flex-1 w-full lg:w-auto'
  }
};
// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 10 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/widgets/product-banner/ProductBanner.jsx
var ProductBanner = __webpack_require__("SUcU");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// EXTERNAL MODULE: ./src/client/components/widgets/product-services/product-service/ProductService.jsx
var ProductService = __webpack_require__("9OZL");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price-criteria-button/AlternativePriceCriteriaButton.jsx
var __jsx = react_default.a.createElement;




var AlternativePriceCriteriaButton_AlternativePriceCriteriaButton = function AlternativePriceCriteriaButton(_ref) {
  var children = _ref.children,
      iconName = _ref.iconName,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thButton = _themes$theme.thButton,
      thHeightStyle = _themes$theme.thHeightStyle,
      thIcon = _themes$theme.thIcon,
      thLabel = _themes$theme.thLabel;
  return __jsx("button", {
    className: thButton,
    style: thHeightStyle,
    onClick: onClick
  }, __jsx(Icon["a" /* Icon */], {
    name: iconName,
    className: thIcon,
    width: "1em"
  }), __jsx("span", {
    className: classnames_default()('alternative-price-criteria-label', thLabel),
    style: thHeightStyle
  }, children));
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/constants.js
var constants = __webpack_require__("393O");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/constants.js
var criteria_who_constants = __webpack_require__("PFSw");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/constants.js
var criteria_transport_constants = __webpack_require__("MX/n");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/constants.js
var departure_city_constants = __webpack_require__("PFCZ");

// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/constants.js
var ALL_INCLUSIVE_SERVICE_LIST_DESKTOP_OVERFLOW_THRESHOLD = 4;
var ALL_INCLUSIVE_SERVICE_LIST_MOBILE_OVERFLOW_THRESHOLD = 2;
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/AlternativePrice.jsx

var AlternativePrice_jsx = react_default.a.createElement;























var AlternativePrice_AlternativePrice = function AlternativePrice(_ref) {
  var proposals = _ref.proposals,
      resort = _ref.resort,
      _ref$searchCriteria = _ref.searchCriteria,
      arrivalDate = _ref$searchCriteria.arrivalDate,
      duration = _ref$searchCriteria.duration,
      adultsCount = _ref$searchCriteria.adultsCount,
      kidsCount = _ref$searchCriteria.kidsCount,
      departureCity = _ref$searchCriteria.departureCity,
      departureCities = _ref.departureCities,
      seeOtherProposalsCallback = _ref.seeOtherProposalsCallback,
      onModify = _ref.onModify,
      bookingEngineEntryPoint = _ref.bookingEngineEntryPoint,
      continueToBookingEngine = _ref.continueToBookingEngine,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      hasOtherProposals = _ref.hasOtherProposals;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var _useState = Object(react["useState"])(false),
      isDetailOpened = _useState[0],
      setIsDetailOpened = _useState[1];

  var _proposals$ = proposals[0],
      price = _proposals$.price,
      allInclusiveServices = _proposals$.allInclusiveServices;

  if (!price) {
    return null;
  }

  var _themes$theme = themes[theme],
      thRoot = _themes$theme.thRoot,
      thSubmitButton = _themes$theme.thSubmitButton;
  var noTransport = departureCity === departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */];
  var openCriteriaWhenEvent = document.createEvent('Event');
  openCriteriaWhenEvent.initEvent(constants["a" /* OPEN_CRITERIA_WHEN_EVENT */], true, true);
  var openCriteriaWhoEvent = document.createEvent('Event');
  openCriteriaWhoEvent.initEvent(criteria_who_constants["a" /* OPEN_CRITERIA_WHO_EVENT */], true, true);
  var openCriteriaTransportEvent = document.createEvent('Event');
  openCriteriaTransportEvent.initEvent(criteria_transport_constants["a" /* OPEN_CRITERIA_TRANSPORT_EVENT */], true, true);

  var criteriaClickHandlerFactory = function criteriaClickHandlerFactory(event) {
    return function () {
      if (onModify) {
        onModify();
      }

      if (bookingEngineEntryPoint === booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE) {
        setTimeout(function () {
          document.dispatchEvent(event);
        }, 200);
      }
    };
  };

  var firstDay = moment_default()(arrivalDate);
  var city = departureCities.find(function (d) {
    return departureCity === d.value;
  });
  var bestPrice = price.bestPrice,
      total = price.total,
      currency = price.currency;
  var overflowThreshold = isDesktop ? ALL_INCLUSIVE_SERVICE_LIST_DESKTOP_OVERFLOW_THRESHOLD : ALL_INCLUSIVE_SERVICE_LIST_MOBILE_OVERFLOW_THRESHOLD;
  return AlternativePrice_jsx(react["Fragment"], null, hasOtherProposals ? AlternativePrice_jsx(Button["a" /* Button */], {
    color: isDesktop ? colors["a" /* COLORS */].WHITE : colors["a" /* COLORS */].TURQUOISE,
    colorBg: isDesktop ? colors["a" /* COLORS */].TURQUOISE : colors["a" /* COLORS */].GRAY_LIGHTER,
    colorBorder: isDesktop ? colors["a" /* COLORS */].TURQUOISE : colors["a" /* COLORS */].GRAY_LIGHTER,
    className: "lg:mt-8 alternative-price-other-proposals-btn",
    onClick: seeOtherProposalsCallback,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'checkPriceKO',
      labelGA: 'seeOtherProposals'
    }
  }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.seeOtherProposalsButton')) : null, AlternativePrice_jsx("div", {
    className: classnames_default()('alternative-price-fake-remote-container', thRoot)
  }, AlternativePrice_jsx("div", {
    className: "p-3  flex flex-col items-center"
  }, AlternativePrice_jsx("div", {
    className: "flex justify-between w-full"
  }, AlternativePrice_jsx(ProductBanner["a" /* ProductBanner */], {
    product: resort
  }), AlternativePrice_jsx("div", {
    className: "text-center w-full lg:w-auto lg:text-right lg:flex lg:items-center"
  }, AlternativePrice_jsx("div", {
    className: "hidden lg:flex lg:items-center"
  }, AlternativePrice_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].ALL_INCLUSIVE,
    width: "1.5rem"
  }), AlternativePrice_jsx("div", {
    className: "font-brand text-blue text-md ml-2 rtl:ml-2"
  }, Object(src_i18n["f" /* t */])('booking.priceDetails.packagePrice.allInclusive'))), AlternativePrice_jsx(Price["a" /* Price */], {
    bestPrice: bestPrice,
    className: "inline-flex",
    currency: currency,
    hasInstalment: false,
    initialPrice: total,
    theme: "remote",
    unit: Object(src_i18n["f" /* t */])('booking.priceDetails.packagePrice.totalPrice')
  }))), AlternativePrice_jsx("div", {
    className: "search-criteria-container flex mt-2 lg:mt-3 w-full flex-between flex-wrap lg:flex-no-wrap"
  }, AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: icons["a" /* ICONS */].DATE,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaWhenEvent) : undefined
  }, "".concat(firstDay.format('DD MMM'), " - ").concat(firstDay.add(duration, 'd').format('DD MMM'))), AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: icons["a" /* ICONS */].USERS,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaWhoEvent) : undefined
  }, Object(labelUtils["b" /* getAttendeesSummary */])({
    adultsCount: adultsCount,
    kidsCount: kidsCount
  })), AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: noTransport ? icons["a" /* ICONS */].NO_TRANSPORT : icons["a" /* ICONS */].TRANSPORT,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaTransportEvent) : undefined
  }, city ? city.name : ''), AlternativePrice_jsx(Button["a" /* Button */], {
    style: {
      minWidth: 80,
      width: isDesktop ? 250 : '100%'
    },
    className: thSubmitButton,
    type: "submit",
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'checkPriceKO',
      labelGA: 'rate_check'
    },
    colorBg: colors["a" /* COLORS */].SUCCESS,
    colorBorder: colors["a" /* COLORS */].SUCCESS,
    onClick: function onClick() {
      continueToBookingEngine();
    }
  }, Object(src_i18n["f" /* t */])('common.continue'))), onModify && AlternativePrice_jsx(Button["a" /* Button */], {
    iconLeft: {
      name: icons["a" /* ICONS */].PEN
    },
    color: colors["a" /* COLORS */].TURQUOISE,
    colorBg: colors["a" /* COLORS */].WHITE,
    className: "text-md underline",
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'checkPriceKO',
      labelGA: 'rate_modify'
    },
    onClick: function onClick() {
      onModify();
    }
  }, Object(src_i18n["f" /* t */])('common.modify')), AlternativePrice_jsx("div", {
    className: "w-full px-6"
  }, AlternativePrice_jsx("div", {
    className: "flex flex-wrap proposal-services-container"
  }, allInclusiveServices.slice(0, overflowThreshold).map(function (service) {
    return AlternativePrice_jsx(ProductService["a" /* ProductService */], {
      service: service,
      className: "w-full lg:w-1/2",
      key: service.label
    });
  })), allInclusiveServices.length > overflowThreshold && AlternativePrice_jsx(react["Fragment"], null, AlternativePrice_jsx(lib["Collapse"], {
    isOpened: isDetailOpened
  }, AlternativePrice_jsx("div", {
    className: "flex flex-wrap proposal-services-container"
  }, allInclusiveServices.slice(overflowThreshold, allInclusiveServices.length).map(function (service) {
    return AlternativePrice_jsx(ProductService["a" /* ProductService */], {
      service: service,
      className: "w-full lg:w-1/2",
      key: service.label
    });
  }))), !isDetailOpened ? AlternativePrice_jsx("div", {
    className: "proposal-services-container__overlay w-full"
  }) : null))), allInclusiveServices.length > overflowThreshold && AlternativePrice_jsx("div", {
    className: "flex items-center justify-center absolute left-1/2 -translate-x-50"
  }, AlternativePrice_jsx(StripButton["a" /* StripButton */], {
    className: "font-bold text-center text-blue text-sm underline",
    height: 30,
    onClick: function onClick() {
      return setIsDetailOpened(!isDetailOpened);
    },
    orientation: "bottom"
  }, AlternativePrice_jsx("div", {
    className: "flex items-center text-base"
  }, !isDetailOpened ? Object(src_i18n["f" /* t */])('priceRemote.openAllInclusiveDetails') : Object(src_i18n["f" /* t */])('priceRemote.closeAllInclusiveDetails'), AlternativePrice_jsx(Icon["a" /* Icon */], {
    className: classnames_default()('text-blue rtl:ml-2 transition-transform', Object(defineProperty["a" /* default */])({}, 'rotate-180', isDetailOpened)),
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    width: "0.625rem"
  }))))));
};
// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposalsUtils.js
var AlternativeProposalsUtils = __webpack_require__("/nu6");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestionHeader.jsx
var AlternativeDateSuggestionHeader_jsx = react_default.a.createElement;









var AlternativeDateSuggestionHeader_AlternativeDateSuggestionHeader = function AlternativeDateSuggestionHeader(props) {
  var arrivalDate = props.arrivalDate,
      duration = props.duration,
      resort = props.resort;
  var getFormattedDateTitle = Object(dateUtils["b" /* formatDate */])('DD/MM');
  var departureDate = Object(AlternativeProposalsUtils["a" /* getDepartureDate */])({
    date: arrivalDate,
    duration: duration,
    format: apiDate["a" /* API_DATE_FORMAT */],
    unit: 'days'
  });
  return AlternativeDateSuggestionHeader_jsx("div", {
    className: "bg-white rounded-small md:flex md:justify-center md:w-full",
    "data-testid": "AlternativeDate"
  }, AlternativeDateSuggestionHeader_jsx("div", {
    className: "AlternativeProposalsModal-header flex py-4 px-6 md:py-8 md:items-center md:w-full lg:mx-6 lg:px-0"
  }, AlternativeDateSuggestionHeader_jsx(Icon["a" /* Icon */], {
    className: "AternativeProposalsModal-icon flex-shrink self-start",
    color: colors["a" /* COLORS */].ORANGE,
    name: icons["a" /* ICONS */].WARNING,
    width: "3rem",
    hasRtl: true
  }), AlternativeDateSuggestionHeader_jsx("div", {
    className: "AlternativeProposalsModal-title ml-2 rtl:ml-2 rtl:mr-0 md:ml-6 md:rtl:ml-6"
  }, AlternativeDateSuggestionHeader_jsx("div", {
    className: "text-blue"
  }, AlternativeDateSuggestionHeader_jsx(TemplateString["a" /* TemplateString */], {
    template: Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.noAvailabilityOnCriterionLabel') // $FlowFixMe
    ,
    values: {
      resortName: resort.name
    }
  })), AlternativeDateSuggestionHeader_jsx("div", {
    className: "text-orange"
  }, AlternativeDateSuggestionHeader_jsx(TemplateString["a" /* TemplateString */], {
    template: Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.notAvailableDates') // $FlowFixMe
    ,
    values: {
      arrivalDate: getFormattedDateTitle(arrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDateTitle(departureDate, 'YYYYMMDD') || ''
    }
  })))));
};
// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price-title/AlternativePriceTitle.jsx
var AlternativePriceTitle_jsx = react_default.a.createElement;







var AlternativePriceTitle_AlternativePriceTitle = function AlternativePriceTitle(_ref) {
  var title = _ref.title,
      price = _ref.proposal.price;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  if (!price) {
    return null;
  }

  return AlternativePriceTitle_jsx("div", {
    className: "flex alternative-price-title-container"
  }, Object(sellerUtils["g" /* isSeller */])(appContext) && price.gap >= 30 || price.gap < 30 ? AlternativePriceTitle_jsx("div", {
    className: "flex"
  }, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    className: "alternative-price-title-icon alternative-price-title-icon--full",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "6rem",
    hasRtl: true
  }), AlternativePriceTitle_jsx("span", {
    className: "alternative-price-title ml-2 rtl:ml-2 rtl:mr-0 md:ml-6 md:rtl:ml-6 text-blue"
  }, title)) : AlternativePriceTitle_jsx(react["Fragment"], null, AlternativePriceTitle_jsx("div", {
    className: "inline-flex items-center alternative-price-title-call-center-advise"
  }, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    className: "alternative-price-title-icon",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "4rem",
    hasRtl: true
  }), AlternativePriceTitle_jsx("span", {
    className: "alternative-price-title ml-2 rtl:ml-2 rtl:mr-0 md:ml-6 md:rtl:ml-6 text-blue"
  }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.callCenterAdvise'))), AlternativePriceTitle_jsx("div", {
    className: "flex alternative-price-title-please-call items-center"
  }, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    className: "alternative-price-title-icon",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "4rem",
    hasRtl: true
  }), AlternativePriceTitle_jsx("div", {
    className: "ml-4"
  }, AlternativePriceTitle_jsx("span", {
    className: "inline-block w-full text-blue text-lg"
  }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.pleaseCallLabel')), AlternativePriceTitle_jsx("span", {
    className: "text-emerald font-bold text-lg"
  }, Object(src_i18n["f" /* t */])('travelAdvisor.phoneNumber')), AlternativePriceTitle_jsx("span", {
    className: "text-gray text-md alternative-price-title-call-cost"
  }, ' ', Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.callCost'))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-proposal-header/AlternativeProposalHeader.jsx
var AlternativeProposalHeader_jsx = react_default.a.createElement;





var AlternativeProposalHeader_AlternativeProposalHeader = function AlternativeProposalHeader(_ref) {
  var title = _ref.title,
      proposal = _ref.proposal,
      _ref$iconWidth = _ref.iconWidth,
      iconWidth = _ref$iconWidth === void 0 ? '6rem' : _ref$iconWidth;
  return AlternativeProposalHeader_jsx("div", {
    className: "bg-white rounded-small md:flex md:justify-center md:w-full"
  }, AlternativeProposalHeader_jsx("div", {
    className: "AlternativeProposalsModal-header flex py-2 px-6 md:py-4 md:items-center md:w-full lg:mx-6 lg:px-0"
  }, proposal ? AlternativeProposalHeader_jsx(AlternativePriceTitle_AlternativePriceTitle, {
    proposal: proposal,
    title: title
  }) : AlternativeProposalHeader_jsx("div", {
    className: "flex"
  }, AlternativeProposalHeader_jsx(Icon["a" /* Icon */], {
    className: "alternative-price-title-icon alternative-price-title-icon--full",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: iconWidth,
    hasRtl: true
  }), AlternativeProposalHeader_jsx("span", {
    className: "alternative-proposal-title font-brand ml-2 rtl:ml-2 rtl:mr-0 md:ml-6 md:rtl:ml-6 text-blue"
  }, title))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/flipper/Flipper.jsx
var Flipper = __webpack_require__("8zGh");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/DateSummary.jsx
var DateSummary = __webpack_require__("tF/N");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeSuggestionCriteria.jsx
var AlternativeSuggestionCriteria_jsx = react_default.a.createElement;








function AlternativeSuggestionCriteria(_ref) {
  var title = _ref.title,
      suggestion = _ref.suggestion,
      onSubmit = _ref.onSubmit,
      buttonLabel = _ref.buttonLabel,
      _ref$categoryGA = _ref.categoryGA,
      categoryGA = _ref$categoryGA === void 0 ? 'resort' : _ref$categoryGA;
  var getFormattedDate = Object(dateUtils["b" /* formatDate */])('D MMMM YYYY');
  return AlternativeSuggestionCriteria_jsx("div", {
    "data-testid": "AlternativeDateSuggestionCriteria",
    className: "AlternativeProposalsModal-criteria rtl:mr-4 mt-8"
  }, title, AlternativeSuggestionCriteria_jsx(Capsule["a" /* Capsule */], {
    additionalStyle: {
      content: {
        padding: '20px',
        fontSize: '14px'
      }
    }
  }, AlternativeSuggestionCriteria_jsx(DateSummary["a" /* DateSummary */], {
    template: Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.fromTo'),
    values: {
      arrivalDate: getFormattedDate(suggestion.resortArrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDate(suggestion.resortDepartureDate, 'YYYYMMDD') || ''
    }
  }), AlternativeSuggestionCriteria_jsx("div", {
    className: "AlternativeProposalsModal-criteriaPrice flex font-bold font-bold items-center ml-10 justify-center text-blue"
  }, AlternativeSuggestionCriteria_jsx(Flipper["a" /* Flipper */], {
    value: suggestion.price.total
  }), AlternativeSuggestionCriteria_jsx(react["Fragment"], null, AlternativeSuggestionCriteria_jsx("span", {
    className: "AlternativeProposalsModal-criteriaLabelPrice ml-2 rtl:ml-2"
  }, "\xA0", AlternativeSuggestionCriteria_jsx(Flipper["a" /* Flipper */], {
    value: Object(src_i18n["f" /* t */])('booking.priceDetails.packagePrice.totalPrice')
  }), "\xA0"), AlternativeSuggestionCriteria_jsx("span", null, "\xA0"))), AlternativeSuggestionCriteria_jsx(Button["a" /* Button */], {
    dataTestId: "AlternativeProposalsModalButton",
    className: "w-full mt-2",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    trackingData: {
      actionGA: 'checkPricesKO',
      labelGA: 'date_check',
      categoryGA: categoryGA
    },
    onClick: function onClick() {
      return onSubmit(suggestion.resortArrivalDate);
    }
  }, buttonLabel)));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestionImmersive.jsx
var AlternativeDateSuggestionImmersive_jsx = react_default.a.createElement;






var AlternativeDateSuggestionImmersive_AlternativeDateSuggestionImmersive = function AlternativeDateSuggestionImmersive(props) {
  var onClose = props.onClose,
      resort = props.resort;
  var trackClick = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'resort',
    actionGA: 'checkPricesKO'
  });
  return AlternativeDateSuggestionImmersive_jsx("div", {
    className: "AlternativeProposalsModal-image pb-6 w-full md:pt-8 md:pb-0 md:pr-6 md:rtl:pr-6 lg:pr-0 lg:rtl:pr-0 lg:mr-6 lg:rtl:mr-6 lg:rtl:ml-0"
  }, AlternativeDateSuggestionImmersive_jsx(Image["a" /* default */], {
    imageUrl: resort.image,
    altMsg: resort.name,
    forceImage: true,
    hasLazyLoading: false,
    mandatoryWidthAndHeight: {
      w: 734,
      h: 408
    }
  }), onClose ? AlternativeDateSuggestionImmersive_jsx("div", {
    className: "flex justify-end font-bold mt-4"
  }, AlternativeDateSuggestionImmersive_jsx("button", {
    type: "button",
    className: "AlternativeProposalsModal-doNotCheckPrice reset-button TextLink TextLink--default text-blue cursor flex items-center p-0 pr-2 rtl:pr-2 md:pr-0 md:rtl:pr-0",
    onClick: function onClick() {
      onClose && onClose();
      trackClick({
        labelGA: 'backResortPage'
      });
    }
  }, AlternativeDateSuggestionImmersive_jsx("span", {
    className: "font-sans md:ml-1 md:rtl:ml-1"
  }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.doNotCheckPriceLabel')), AlternativeDateSuggestionImmersive_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    className: "TextLink-iconRight"
  }))) : null);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-suggestions/AlternativeSuggestions.jsx
var AlternativeSuggestions_jsx = react_default.a.createElement;





var AlternativeSuggestions_AlternativeSuggestions = function AlternativeSuggestions(_ref) {
  var title = _ref.title,
      children = _ref.children,
      onClose = _ref.onClose,
      immersiveResort = _ref.immersiveResort;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isBrowserGreaterThan = _useResponsive.isBrowserGreaterThan;

  return AlternativeSuggestions_jsx("div", {
    className: "AlternativeProposalsModal-content-wrapper w-full flex flex-col md:flex-row justify-center mt-4"
  }, AlternativeSuggestions_jsx("div", {
    className: "AlternativeProposalsModal-date-suggestion flex flex-col sm:flex-row w-full"
  }, AlternativeSuggestions_jsx("div", {
    className: "AlternativeProposalsModal-contentCriterias mb-10 md:mb-0 md:mt-8 lg:ml-6"
  }, AlternativeSuggestions_jsx("div", {
    className: "AlternativeProposalsModal-titleSuggest text-blue text-xl font-bold px-6 lg:pl-0"
  }, title), isBrowserGreaterThan.S ? AlternativeSuggestions_jsx("div", {
    className: "AlternativeProposalsModal-Criterias md:flex md:flex-wrap"
  }, children) : AlternativeSuggestions_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["f" /* t */])('common.scrollBackward'),
    childrenWrapperClassNames: "flex px-6",
    forwardLabel: Object(src_i18n["f" /* t */])('common.scrollForward')
  }, children)), immersiveResort && AlternativeSuggestions_jsx(AlternativeDateSuggestionImmersive_AlternativeDateSuggestionImmersive, {
    onClose: onClose,
    resort: immersiveResort
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeDurationSuggestions.jsx

var AlternativeDurationSuggestions_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var AlternativeDurationSuggestions_AlternativeDurationSuggestions = function AlternativeDurationSuggestions(_ref) {
  var durations = _ref.durations,
      onSelectNewDuration = _ref.onSelectNewDuration,
      categoryGA = _ref.categoryGA;
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'resort',
    actionGA: 'checkPriceKO'
  });
  return AlternativeDurationSuggestions_jsx(AlternativeSuggestions_AlternativeSuggestions, {
    title: Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.durationsLabel')
  }, durations.map(function (suggestion) {
    var duration = suggestion.data.duration;
    return AlternativeDurationSuggestions_jsx(AlternativeSuggestionCriteria, {
      key: duration,
      title: AlternativeDurationSuggestions_jsx("div", {
        className: "text-md mb-1"
      }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.durationLabel'), ' ', AlternativeDurationSuggestions_jsx("span", {
        className: "font-bold text-blue text-lg"
      }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.durationsSuggestions', {
        duration: duration
      }))),
      buttonLabel: Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.checkPriceLabelDuration'),
      suggestion: _objectSpread(_objectSpread({}, suggestion.data), {}, {
        price: {
          total: suggestion.data.price.total.formattedValue
        }
      }),
      onSubmit: function onSubmit() {
        onSelectNewDuration({
          proposalIds: suggestion.ids,
          duration: duration
        });
        track({
          labelGA: 'duration_check'
        });
      },
      categoryGA: categoryGA
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestion.jsx
var AlternativeDateSuggestion_jsx = react_default.a.createElement;




var AlternativeDateSuggestion_AlternativeDateSuggestion = function AlternativeDateSuggestion(props) {
  var onSubmit = props.onSubmit,
      onClose = props.onClose,
      resort = props.resort,
      dates = props.dates,
      _props$categoryGA = props.categoryGA,
      categoryGA = _props$categoryGA === void 0 ? 'resort' : _props$categoryGA;
  return AlternativeDateSuggestion_jsx(AlternativeSuggestions_AlternativeSuggestions, {
    title: Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.weSuggestLabel', {
      resortName: resort.name
    }),
    onClose: onClose,
    immersiveResort: resort
  }, dates.map(function (suggestion) {
    return AlternativeDateSuggestion_jsx(AlternativeSuggestionCriteria, {
      key: suggestion.dateOffset,
      suggestion: suggestion,
      onSubmit: onSubmit,
      categoryGA: categoryGA,
      buttonLabel: Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.checkPriceLabel')
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposalsSeparatorDashed.jsx
var AlternativeProposalsSeparatorDashed_jsx = react_default.a.createElement;

 // $FlowFixMe

var AlternativeProposalsSeparatorDashed = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  return AlternativeProposalsSeparatorDashed_jsx("div", {
    "data-testid": "AlternativeProposalsSeparatorDashed",
    ref: ref,
    className: "flex mt-4 w-full"
  }, AlternativeProposalsSeparatorDashed_jsx("div", {
    className: "self-center border-t border-dashed flex-1"
  }), AlternativeProposalsSeparatorDashed_jsx("div", {
    className: "font-bold mx-6 text-2xl text-blue"
  }, Object(src_i18n["f" /* t */])('booking.common.or')), AlternativeProposalsSeparatorDashed_jsx("div", {
    className: "self-center border-t border-dashed flex-1"
  }));
});
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 6 modules
var Product = __webpack_require__("XTOr");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-summary/trip-overview/TripOverview.jsx + 1 modules
var TripOverview = __webpack_require__("Cgsf");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResortThumbnail.jsx

var AlternativeResortThumbnail_jsx = react_default.a.createElement;










var AlternativeResortThumbnail_AlternativeResortThumbnail = function AlternativeResortThumbnail(props) {
  var suggestion = props.suggestion,
      className = props.className,
      onClick = props.onClick,
      _props$categoryGA = props.categoryGA,
      categoryGA = _props$categoryGA === void 0 ? 'resort' : _props$categoryGA,
      scrollToBookingEngineEntryPoint = props.scrollToBookingEngineEntryPoint;
  var appContext = react_default.a.useContext(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var trackClick = Object(useTracking["a" /* useTracking */])({
    categoryGA: categoryGA,
    actionGA: 'checkPricesKO'
  });

  var handleClick = function handleClick() {
    var _suggestion$resort = suggestion.resort,
        id = _suggestion$resort.id,
        name = _suggestion$resort.name,
        href = _suggestion$resort.href;
    onClick ? onClick(id, name) : history.pushRoute(href).then(function () {
      if (scrollToBookingEngineEntryPoint) {
        scrollToBookingEngineEntryPoint();
      }
    });
  };

  return AlternativeResortThumbnail_jsx("div", {
    "data-testid": "AlternativeResortThumbnail",
    className: classnames_default()('AlternativeResortThumbnail flex flex-col mr-4', className)
  }, AlternativeResortThumbnail_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
    className: "AlternativeProposalsModal-thumbnail"
  }, Object(TripOverview["b" /* createPropsForProduct */])(suggestion.resort, undefined, appContext), {
    hasLazyLoading: false // Allows to avoid to launch the tracking on the arrows of the slider
    ,
    onClick: function onClick(e) {
      if (e.target instanceof HTMLImageElement) {
        handleClick();
        trackClick({
          labelGA: 'resort_checkThumbnail'
        });
      }
    }
  })), AlternativeResortThumbnail_jsx(Button["a" /* Button */], {
    dataTestId: "AlernativeResortThumbnailButton",
    className: "px-6 my-6 self-center",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    trackingData: {
      actionGA: 'checkPricesKO',
      labelGA: 'resort_check',
      categoryGA: 'resort'
    },
    onClick: handleClick
  }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.checkPriceLabelResort')));
};
// EXTERNAL MODULE: ./src/client/components/widgets/package/price/AttendeesSummary.jsx
var AttendeesSummary = __webpack_require__("5q4R");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/TransportSummary.jsx
var TransportSummary = __webpack_require__("YKA5");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResortCriteria.jsx
var AlternativeResortCriteria_jsx = react_default.a.createElement;












var AlternativeResortCriteria_AlternativeResortCriteria = function AlternativeResortCriteria(props) {
  var adultsNumber = props.adultsNumber,
      arrivalDate = props.arrivalDate,
      departureCity = props.departureCity,
      duration = props.duration,
      kidsNumber = props.kidsNumber;
  var getFormattedDate = Object(dateUtils["b" /* formatDate */])('D MMMM YYYY');
  var departureDate = Object(AlternativeProposalsUtils["a" /* getDepartureDate */])({
    date: arrivalDate,
    duration: duration,
    format: apiDate["a" /* API_DATE_FORMAT */],
    unit: 'days'
  });
  return AlternativeResortCriteria_jsx("div", {
    "data-testid": "AlternativeResortCriteria",
    className: "AlternativeResort-criteria flex flex-col mt-3 mb-8 md:mt-0 md:mb-0 md:mr-4 md:rtl:mr-4 md:rtl:ml-0"
  }, AlternativeResortCriteria_jsx(Capsule["a" /* Capsule */], {
    additionalStyle: {
      content: {
        padding: '20px',
        fontSize: '14px'
      }
    }
  }, AlternativeResortCriteria_jsx("div", null, AlternativeResortCriteria_jsx(DateSummary["a" /* DateSummary */], {
    template: Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.fromTo'),
    values: {
      arrivalDate: getFormattedDate(arrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDate(departureDate, 'YYYYMMDD') || ''
    }
  })), AlternativeResortCriteria_jsx("div", {
    className: "mt-4"
  }, AlternativeResortCriteria_jsx(AttendeesSummary["a" /* AttendeesSummary */], {
    adults: adultsNumber,
    kids: kidsNumber
  })), AlternativeResortCriteria_jsx("div", {
    className: "mt-4"
  }, AlternativeResortCriteria_jsx(TransportSummary["a" /* TransportSummary */], {
    departure: departureCity !== 'NO' ? departureCity : null,
    transportIcon: icons["a" /* ICONS */].TRANSPORT
  })), AlternativeResortCriteria_jsx("div", {
    className: "flex mt-4"
  }, AlternativeResortCriteria_jsx(Icon["a" /* Icon */], {
    className: "AlternativeResortCriteria-icon flex-shrink",
    color: colors["a" /* COLORS */].ORANGE,
    name: icons["a" /* ICONS */].WARNING,
    width: "2rem",
    hasRtl: true
  }), AlternativeResortCriteria_jsx("div", {
    className: "AlternativeResortCriteria-textWarning font-bold ml-2 text-orange rtl:ml-2 rtl:mr-0"
  }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.resortCounterProposalTransportReassurance')))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResort.jsx
var AlternativeResort_jsx = react_default.a.createElement;






var AlternativeResort_AlternativeResort = function AlternativeResort(props) {
  var adultsNumber = props.adultsNumber,
      arrivalDate = props.arrivalDate,
      departureCity = props.departureCity,
      duration = props.duration,
      i18n = props.i18n,
      kidsNumber = props.kidsNumber,
      suggestions = props.suggestions,
      selectResortHandler = props.selectResortHandler,
      scrollToBookingEngineEntryPoint = props.scrollToBookingEngineEntryPoint,
      _props$categoryGA = props.categoryGA,
      categoryGA = _props$categoryGA === void 0 ? 'resort' : _props$categoryGA;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isBrowserGreaterThan = _useResponsive.isBrowserGreaterThan;

  return AlternativeResort_jsx("div", {
    className: "flex justify-center w-full mt-10",
    "data-testid": "AlternativeResort"
  }, AlternativeResort_jsx("div", {
    className: "AlternativeResort-wrapper px-6 w-full"
  }, AlternativeResort_jsx("div", {
    className: "AlternativeResort-title font-bold text-blue text-xl"
  }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.resortCounterProposalTitle')), AlternativeResort_jsx("div", {
    className: "AlternativeResort-content md:flex md:mt-4 md:flex-wrap"
  }, AlternativeResort_jsx(AlternativeResortCriteria_AlternativeResortCriteria, {
    adultsNumber: adultsNumber,
    arrivalDate: arrivalDate,
    departureCity: departureCity,
    duration: duration,
    i18n: i18n,
    kidsNumber: kidsNumber
  }), isBrowserGreaterThan.S ? AlternativeResort_jsx(react["Fragment"], null, suggestions.map(function (suggestion, index) {
    return AlternativeResort_jsx(AlternativeResortThumbnail_AlternativeResortThumbnail, {
      key: suggestion.resort.id,
      suggestion: suggestion,
      className: index < suggestions.length - 1 ? 'mr-4 rtl:mr-4' : '',
      onClick: selectResortHandler,
      categoryGA: categoryGA,
      scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint
    });
  })) : AlternativeResort_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["f" /* t */])('common.scrollBackward'),
    forwardLabel: Object(src_i18n["f" /* t */])('common.scrollForward'),
    hasArrows: false,
    childrenWrapperClassNames: "flex px-6"
  }, suggestions.map(function (suggestion, index) {
    return AlternativeResort_jsx(AlternativeResortThumbnail_AlternativeResortThumbnail, {
      key: suggestion.resort.id,
      suggestion: suggestion,
      className: index < suggestions.length - 1 ? 'rtl:mr-4' : undefined,
      onClick: selectResortHandler,
      categoryGA: categoryGA,
      scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint
    });
  })))), AlternativeResort_jsx("div", {
    className: "md:border-t md:border-dotted md:mb-6"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposals.jsx
var AlternativeProposals_jsx = react_default.a.createElement;














function AlternativeProposals(_ref) {
  var _ref$searchCriteria = _ref.searchCriteria,
      arrivalDate = _ref$searchCriteria.arrivalDate,
      duration = _ref$searchCriteria.duration,
      adultsCount = _ref$searchCriteria.adultsCount,
      departureCity = _ref$searchCriteria.departureCity,
      kidsCount = _ref$searchCriteria.kidsCount,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      i18n = _ref.i18n,
      proposals = _ref.proposals,
      resort = _ref.resort,
      scrollToBookingEngineEntryPoint = _ref.scrollToBookingEngineEntryPoint,
      bookingEngineEntryPoint = _ref.bookingEngineEntryPoint,
      goToBookingEngine = _ref.goToBookingEngine,
      _ref$suggestions = _ref.suggestions,
      dates = _ref$suggestions.dates,
      resorts = _ref$suggestions.resorts,
      durations = _ref$suggestions.durations,
      searchCriteria = _ref.searchCriteria,
      selectResortHandler = _ref.selectResortHandler,
      onSelectNewDuration = _ref.onSelectNewDuration,
      _ref$disableAlternati = _ref.disableAlternativePrice,
      disableAlternativePrice = _ref$disableAlternati === void 0 ? false : _ref$disableAlternati;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var separatorComponent = Object(react["useRef"])(null);
  var proposal = proposals[0];
  var shouldDisplayAlternativePriceCriteria = !disableAlternativePrice && proposal && proposal.price && proposal.price.gap && proposal.price.gap > proposals_constants["r" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */] && (appContext.isSeller || proposal.price.gap < proposals_constants["q" /* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */]);
  var shouldDisplayAlternativePriceTitle = !disableAlternativePrice && proposal && proposal.price && proposal.price.gap && proposal.price.gap > proposals_constants["r" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];

  var seeOtherProposalsCallback = function seeOtherProposalsCallback() {
    if (separatorComponent.current) {
      separatorComponent.current.scrollIntoView();
    }
  };

  var atLeastOneDateCounterProposal = dates.length > 0;
  var atLeastOneResortCounterProposal = resorts.length > 0;
  var atLeastOneDurationCounterProposal = durations.length > 0;
  var hasSuggestions = atLeastOneDateCounterProposal || atLeastOneResortCounterProposal || atLeastOneDurationCounterProposal;
  return AlternativeProposals_jsx("div", {
    "data-testid": "AlternativeProposalsModal",
    className: "AlternativeProposalsModal rounded-small md:flex md:flex-col md:items-center"
  }, shouldDisplayAlternativePriceTitle ? AlternativeProposals_jsx(AlternativeProposalHeader_AlternativeProposalHeader, {
    title: Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.rateCounterProposalTitle'),
    proposal: proposal
  }) : null, shouldDisplayAlternativePriceCriteria && AlternativeProposals_jsx(react["Fragment"], null, AlternativeProposals_jsx("div", {
    className: "AlternativeProposalsModal-content flex flex-col items-center px-8 w-full max-w-site"
  }, AlternativeProposals_jsx(AlternativePrice_AlternativePrice, {
    proposals: proposals,
    resort: resort,
    searchCriteria: searchCriteria,
    departureCities: i18n.bookingCriteria.departureCities,
    seeOtherProposalsCallback: seeOtherProposalsCallback,
    hasOtherProposals: hasSuggestions,
    onModify: onClose ? function () {
      onClose();

      if (scrollToBookingEngineEntryPoint) {
        scrollToBookingEngineEntryPoint();
      }
    } : undefined,
    bookingEngineEntryPoint: bookingEngineEntryPoint // $FlowFixMe
    ,
    continueToBookingEngine: goToBookingEngine
  })), hasSuggestions && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, {
    ref: separatorComponent
  })), hasSuggestions && !shouldDisplayAlternativePriceTitle && !disableAlternativePrice ? AlternativeProposals_jsx(AlternativeDateSuggestionHeader_AlternativeDateSuggestionHeader, {
    arrivalDate: arrivalDate,
    duration: duration,
    resort: resort
  }) : AlternativeProposals_jsx(AlternativeProposalHeader_AlternativeProposalHeader, {
    title: Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.otherProposals'),
    iconWidth: "3rem"
  }), atLeastOneDateCounterProposal && AlternativeProposals_jsx(AlternativeDateSuggestion_AlternativeDateSuggestion, {
    arrivalDate: arrivalDate,
    duration: duration,
    dates: dates,
    onSubmit: onSubmit,
    onClose: onClose,
    resort: resort
  }), atLeastOneDateCounterProposal && (atLeastOneDurationCounterProposal || atLeastOneResortCounterProposal) && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, null), atLeastOneDurationCounterProposal && AlternativeProposals_jsx(AlternativeDurationSuggestions_AlternativeDurationSuggestions, {
    onSelectNewDuration: onSelectNewDuration,
    durations: durations
  }), atLeastOneDurationCounterProposal && atLeastOneResortCounterProposal && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, null), atLeastOneResortCounterProposal && AlternativeProposals_jsx(react["Fragment"], null, AlternativeProposals_jsx(AlternativeResort_AlternativeResort, {
    adultsNumber: adultsCount,
    arrivalDate: arrivalDate,
    departureCity: departureCity,
    duration: duration,
    i18n: i18n,
    kidsNumber: kidsCount,
    suggestions: resorts,
    scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint,
    selectResortHandler: selectResortHandler
  })), !appContext.isCmta && AlternativeProposals_jsx(react["Fragment"], null, AlternativeProposals_jsx("div", {
    className: "border-t border-solid mt-4 mb-2 md:mt-12 md:mb-8 w-full"
  }), AlternativeProposals_jsx("div", {
    className: "flex items-center mb-8 px-6"
  }, AlternativeProposals_jsx(Icon["a" /* Icon */], {
    className: "mr-3 lg:mr-2 flex",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "4rem",
    hasRtl: true
  }), AlternativeProposals_jsx("p", {
    className: "font-bold text-lg text-blue"
  }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.contactCallCenter'), ' ', AlternativeProposals_jsx("span", {
    className: "AlternativeProposalsModal-callText"
  }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.callCenterNumber')), ' ', AlternativeProposals_jsx("span", {
    className: "font-normal text-gray text-sm"
  }, Object(src_i18n["f" /* t */])('booking.counterProposalPopIn.callCost'))))));
}

/***/ }),

/***/ "YXT+":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("J77r"),
    Map = __webpack_require__("McKP"),
    Promise = __webpack_require__("3JOw"),
    Set = __webpack_require__("weY2"),
    WeakMap = __webpack_require__("tJ/X"),
    baseGetTag = __webpack_require__("rnJz"),
    toSource = __webpack_require__("AVUi");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "YYl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productsFiltersResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");





var productsFiltersResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCTS_FILTERS */ "H"],
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _props$offerId = props.offerId,
        offerId = _props$offerId === void 0 ? '' : _props$offerId;
    var query = "{\n      config {\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_1__[/* resort */ "e"](appContext), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_1__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_1__[/* faceting */ "b"](), "\n        common { close thumbnailCTA next previous scrollBackward scrollForward }\n        remote {\n          date\n          searchAction\n          noResult {\n            zeroResult\n            explanation\n          }\n        }\n      }\n      offer(offerId: \"").concat(offerId, "\") {\n        id\n        name\n        seoName\n        color\n        products {\n          id\n          price {\n            bestPrice {\n              value\n              formattedValue\n            }\n            initialPrice {\n              value\n              formattedValue\n            }\n            unit\n            currency\n            termsAndConditions {\n              departureDate\n              duration\n              durationFormatted\n              numberOfAdults\n              accommodationComfortLabel\n            }\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_OFFER_PRODUCT_FILTER */ "Wb"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    });
  }
};

/***/ }),

/***/ "YZTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS_DESKTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ID_LAYER_HEADER__BE__CATEGORY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ID_LAYER_HEADER__BE__CHOOSE_EQUIPEMENT; });
/* unused harmony export ID_LAYER_HEADER__BE__MOBILE_FILTERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ID_LAYER_HEADER__BE__SELLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE; });
/* unused harmony export ID_LAYER_HEADER__PLE__PYR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ID_LAYER_HEADER__PLE__PYR_AGENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ID_LAYER_HEADER__PLE__PYR_RESORT_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ID_LAYER_HEADER__PLE__PYR_ROOM_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS; });
/* unused harmony export ID_MODAL_HEADER__BE__BUSINESS_CLASS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ID_MODAL_HEADER__BE__OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ID_MODAL_HEADER__BE__PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ID_MODAL_HEADER__BE__SHARE_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ID_MODAL_HEADER__BE__MISMATCH_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ID_MODAL_HEADER__PLE__LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ID_MODAL_HEADER__BE__CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ID_MODAL_HEADER__PLE__NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ID_SIDEPANEL_HEADER__SHOPPING__WIBILONG_NARROW; });
// Layers header IDs
var ID_LAYER_HEADER__BE__ACCOMMODATIONS_DESKTOP = 'AccommodationsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__ACCOMMODATIONS_MOBILE = 'AccommodationsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__CATEGORY_LIST = 'CategoryListLayerHeaderId';
var ID_LAYER_HEADER__BE__CHOOSE_EQUIPEMENT = 'ChooseEquipmentLayerHeaderId';
var ID_LAYER_HEADER__BE__MOBILE_FILTERS = 'MobileFiltersLayerHeaderId';
var ID_LAYER_HEADER__BE__SELLER = 'SellerLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP = 'TransportsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE = 'TransportsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE = 'OtherProposalsMobileLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR = 'PickYourRoomLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_AGENCY = 'PickYourRoomAgencyLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_RESORT_ONLY = 'PYRResortOnlyLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_ROOM_RESORT = 'PickYourRoomResortLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES = 'CookiePreferencesLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL = 'CriteriaModalLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER = 'CriteriaTriggerLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS = 'PriceRemoteDetailsLayerHeaderId'; // Modals header IDs

var ID_MODAL_HEADER__BE__BUSINESS_CLASS = 'BusinessClassModalHeaderId';
var ID_MODAL_HEADER__BE__OPTION = 'OptionModalHeaderId';
var ID_MODAL_HEADER__BE__PROMO_CODE = 'PromoCodeModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION = 'SaveCriteriaConfirmationModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN = 'SaveCriteriaLoginModalHeaderId';
var ID_MODAL_HEADER__BE__SHARE_CONTEXT = 'ShareContextModalHeaderId';
var ID_MODAL_HEADER__BE__MISMATCH_COUNTRY = 'MismatchCountryModalHeaderId';
var ID_MODAL_HEADER__PLE__LOGIN = 'ParticipantsLoginToPleModalHeaderId';
var ID_MODAL_HEADER__BE__CUSTOMER = 'ParticipantsCustomerModalHeaderId';
var ID_MODAL_HEADER__PLE__NEWSLETTER = 'NewsletterModalHeaderId';
var ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER = 'WebCallBackTriggerModalHeaderId'; // SidePanel header IDs

var ID_SIDEPANEL_HEADER__SHOPPING__WIBILONG_NARROW = 'WibilongNarrowSidePanelHeaderId';

/***/ }),

/***/ "YbGu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productFlashInfoResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productFlashInfoResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_FLASH_INFO */ "gb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var resortId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var query = "query {\n      config {\n        common { close }\n      }\n      editorialZone(".concat(productArgs, ") {\n        texts\n        image\n        link\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_FLASH_INFO */ "ic"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "YfuU":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("2NJa"),
    getPrototype = __webpack_require__("lBGg"),
    isPrototype = __webpack_require__("RVBP");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "YjXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputSwitch_InputSwitch; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.themes.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var DEFAULT_SIZES = {
  small: 15,
  medium: 23,
  large: 23
};
var themes = {
  "default": function _default(props) {
    var color = props.color,
        isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        size = props.size,
        validationState = props.validationState;
    return {
      thRoot: 'flex items-center',
      thLabel: classnames_default()('flex items-center text-base px-3', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'font-bold text-blue text-lg': size === 'large',
        'text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled
      }),
      thChecked: classnames_default()('leading-none bg-white border-1 border-solid border-gray-medium flex-shrink-0 p-px rounded-tiny', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'text-blue': isChecked,
        'bg-gray-light opacity-25': isDisabled
      }),
      thCheckedStyle: {
        width: DEFAULT_SIZES[size],
        height: DEFAULT_SIZES[size]
      },
      thLoading: 'rtl:ml-2 flex items-center leading-none',
      thSwitch: classnames_default()('reset-button border-2 flex items-center transition-all', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), Object(defineProperty["a" /* default */])({
        'bg-gray-light border-gray-light': isDisabled,
        'bg-gray-darker border-gray-darker': !isChecked && !isDisabled
      }, "bg-".concat(color, " border-").concat(color), isChecked && !isDisabled)),
      thSwitchStyle: {
        width: 58,
        padding: '0 1px',
        height: 30,
        borderRadius: 30
      },
      thSwitchToggler: classnames_default()('bg-white block leading-none flex items-center justify-center rounded-half transition-all', Object(defineProperty["a" /* default */])({
        'rtl:translate-x-100': isChecked
      }, "text-".concat(color), isChecked && !isDisabled)),
      thSwitchTogglerStyle: {
        width: 28,
        height: 28
      }
    };
  },
  bubble: function bubble(props) {
    var isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        validationState = props.validationState;
    return {
      thRoot: 'relative',
      thLabel: classnames_default()('flex items-center justify-center shadow border-1 rounded py-3 px-5 text-base text-center transition-colors', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'bg-white': !isDisabled,
        'bg-gray-light border-gray-light opacity-50': isDisabled,
        'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
        'border-current text-blue': isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'border-current text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'border-current text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled
      }),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50'
    };
  },
  bubble2: function bubble2(props) {
    var isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        validationState = props.validationState;
    return {
      thRoot: 'relative',
      thLabel: classnames_default()('flex items-center justify-center border-1 rounded py-1 px-1 text-base text-center transition-colors', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'bg-white': !isChecked,
        'border-gray-light opacity-50': isDisabled && !isChecked,
        'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
        'border-blue text-white bg-blue': isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'border-current text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'border-current text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled,
        'border-blue text-white bg-blue opacity-50': isDisabled && isChecked
      }),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx







var __jsx = react_default.a.createElement;

function InputSwitch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InputSwitch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InputSwitch_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InputSwitch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }











var InputSwitch_InputSwitch = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputSwitch, _Component);

  var _super = _createSuper(InputSwitch);

  function InputSwitch(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputSwitch);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function () {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? '' : _this$props$value;

      if (!isReadOnly && !isDisabled && !isLoading) {
        var isChecked = !_this.state.isChecked;

        _this.setState({
          isChecked: isChecked
        }, function () {
          return onChange(name, isChecked, value);
        });
      }
    });

    _this.state = {
      isChecked: props.isChecked || false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputSwitch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isChecked !== this.props.isChecked) {
        this.setState({
          isChecked: this.props.isChecked
        });
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props2 = this.props,
          _this$props2$iconChec = _this$props2.iconChecked,
          iconChecked = _this$props2$iconChec === void 0 ? null : _this$props2$iconChec,
          _this$props2$iconUnCh = _this$props2.iconUnChecked,
          iconUnChecked = _this$props2$iconUnCh === void 0 ? null : _this$props2$iconUnCh;
      return this.state.isChecked ? iconChecked : iconUnChecked;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          ariaDescribedby = _this$props3.ariaDescribedby,
          ariaLabelledby = _this$props3.ariaLabelledby,
          className = _this$props3.className,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? "InputSwitch_".concat(shortid_default.a.generate()) : _this$props3$id,
          inputTestId = _this$props3.inputTestId,
          isDisabled = _this$props3.isDisabled,
          isLoading = _this$props3.isLoading,
          isReadOnly = _this$props3.isReadOnly,
          isRequired = _this$props3.isRequired,
          isSwitch = _this$props3.isSwitch,
          label = _this$props3.label,
          labelClassName = _this$props3.labelClassName,
          name = _this$props3.name,
          onClick = _this$props3.onClick,
          theme = _this$props3.theme,
          value = _this$props3.value,
          dataTestId = _this$props3.dataTestId;
      var isChecked = this.state.isChecked;

      var _themes$theme = themes[theme](InputSwitch_objectSpread({
        isChecked: isChecked
      }, this.props)),
          thChecked = _themes$theme.thChecked,
          thCheckedStyle = _themes$theme.thCheckedStyle,
          thLabel = _themes$theme.thLabel,
          thLoading = _themes$theme.thLoading,
          thRoot = _themes$theme.thRoot,
          thSwitch = _themes$theme.thSwitch,
          thSwitchStyle = _themes$theme.thSwitchStyle,
          thSwitchToggler = _themes$theme.thSwitchToggler,
          thSwitchTogglerStyle = _themes$theme.thSwitchTogglerStyle;

      return __jsx("div", {
        "data-testid": dataTestId,
        className: classnames_default()(className, thRoot)
      }, isSwitch ? __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: thSwitch,
        "data-testid": id,
        onClick: this.onChange,
        role: "checkbox",
        style: thSwitchStyle,
        type: "button"
      }, __jsx("span", {
        className: thSwitchToggler,
        style: thSwitchTogglerStyle
      }, isChecked ? __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CHECK
      }) : __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CROSS,
        width: "0.7rem"
      }))) : __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: classnames_default()('reset-button', thChecked),
        "data-testid": id,
        disabled: isDisabled,
        onClick: this.onChange,
        role: "checkbox",
        style: thCheckedStyle,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: this.getIcon(),
        width: "100%"
      })), __jsx("input", {
        checked: isChecked,
        className: "hidden",
        disabled: isDisabled,
        id: id,
        "data-testid": inputTestId,
        label: label,
        name: name,
        onChange: this.onChange,
        onClick: onClick,
        required: isRequired,
        type: "checkbox",
        value: value
      }), isLoading && !isDisabled && !isReadOnly && __jsx("div", {
        className: thLoading
      }, __jsx(Spinner["a" /* Spinner */], {
        size: "small"
      })), !!label && __jsx("label", {
        className: classnames_default()(labelClassName, thLabel),
        htmlFor: id
      }, Object(lodash["isString"])(label) ? Object(form_util["b" /* getFormattedLabel */])(label, isRequired) : label));
    }
  }]);

  return InputSwitch;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputSwitch_InputSwitch, "defaultProps", {
  color: colors["a" /* COLORS */].BLUE,
  iconChecked: icons["a" /* ICONS */].CHECK,
  iconUnChecked: null,
  isDisabled: false,
  isLoading: false,
  size: 'medium',
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "Z1ta":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "ZHrn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ ContactInfoUtils_getOptinsInfos; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ ContactInfoUtils_getInitialAttendeesList; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ ContactInfoUtils_getInitialFormValues; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getAddressValidators; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ ContactInfoUtils_getValidators; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ addressSchemaSort; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ ContactInfoUtils_getAdultCivilities; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ ContactInfoUtils_getHeaderContactInfoTitle; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ cleanUselessAttendeesValues; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ ContactInfoUtils_getGmNumbersOptions; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ ContactInfoUtils_findDuplicateAttendees; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ submitOption; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ submitOptionFromProposal; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getLegalInputInformation; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ renderErrorUpdatingAttendees; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getAllAttendeesIds; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ ContactInfoUtils_shouldHideField; });

// UNUSED EXPORTS: isChild, getCNILLegalMessage, getLegalInformation, shouldDisplayLegalInformation

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /home/circleci/project/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");

// CONCATENATED MODULE: ./src/client/components/widgets/participants/utils.js
var STRICT_REGEX = /[.-]/g;
var NON_STRICT_REGEX = /[^\d]/g;
var REJECT_CPF_LIST = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];
function digitsVerifier(numbers) {
  var numberList = numbers.split('').map(function (number) {
    return parseInt(number, 10);
  });
  var modulo = numberList.length + 1;
  var multiplied = numberList.map(function (number, index) {
    return number * (modulo - index);
  });
  var mod = multiplied.reduce(function (buffer, number) {
    return buffer + number;
  }) % 11;
  return mod < 2 ? 0 : 11 - mod;
}
function isValidCPF(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var stripped = strip(cpf, isStrict); // CPF must be defined

  if (!stripped) {
    return false;
  } // CPF must have 11 chars


  if (stripped.length !== 11) {
    return false;
  }

  if (REJECT_CPF_LIST.includes(stripped)) {
    return false;
  }

  var numbers = stripped.substr(0, 9);
  numbers += digitsVerifier(numbers);
  numbers += digitsVerifier(numbers);
  return numbers.substr(-2) === stripped.substr(-2);
}
function strip(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var regex = isStrict ? STRICT_REGEX : NON_STRICT_REGEX;
  return (cpf || '').toString().replace(regex, '');
}
// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/legal-information/legalInformationIds.constants.js
var legalInformationIds_constants = __webpack_require__("y5Lu");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/regex/RegexHelper.js
var RegexHelper = __webpack_require__("9BC+");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var constants = __webpack_require__("ZOp8");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js



var _this = undefined;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
















function getCNILLegalMessage() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cnilLegalMessage = legalMessages.find(function (legalMessage) {
    return legalMessage.id === constants["a" /* CNIL_LEGAL_MESSAGE_ID */];
  });
  return cnilLegalMessage && Object(lodash["pick"])(cnilLegalMessage, ['label', 'description', 'required']);
}

function getLegalInputInformation() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments.length > 1 ? arguments[1] : undefined;
  return legalMessages.find(function (legalMessage) {
    return legalMessage.id === id;
  });
}

function getLegalInformation(beLegalInfos) {
  return function (id) {
    return (beLegalInfos || []).find(function (legalInfo) {
      return legalInfo.id === id;
    });
  };
}

var ContactInfoUtils_getOptinsInfos = function getOptinsInfos(bookingProcess) {
  var getLegalInfo = getLegalInformation(bookingProcess);
  return {
    email: getLegalInfo(legalInformationIds_constants["b" /* EMAIL_OPTIN */]),
    sms: getLegalInfo(legalInformationIds_constants["l" /* SMS_OPTIN */]),
    mail: getLegalInfo(legalInformationIds_constants["e" /* MAIL_OPTIN */]),
    fosun: getLegalInfo(legalInformationIds_constants["c" /* FOSUN_PARTNERS */]),
    phone: getLegalInfo(legalInformationIds_constants["j" /* PHONE_OPTIN */]),
    clubmedPlus: getLegalInfo(legalInformationIds_constants["a" /* CLUBMED_PLUS */]),
    theo: getLegalInfo(legalInformationIds_constants["m" /* THEO */])
  };
};

function shouldDisplayLegalInformation(beLegalInfos) {
  var getLegalInfo = getLegalInformation(beLegalInfos);
  return function (id) {
    return !!getLegalInfo(id);
  };
}

function _getOptionSubmissionRequest(appContext, params) {
  return "\n    mutation {\n      bookings(\n        proposalId: \"".concat(params.proposalId, "\"\n        bookingStatus: OPTION\n        ").concat(params.sellerEmail ? "sellerEmail: \"".concat(params.sellerEmail, "\"") : '', "\n      ) {\n        bookingId\n      }\n    }");
}

function submitOptionFromProposal(appContext, sellerEmail, selectedProposalId, productId) {
  var redirectTo = redirectUtils["a" /* default */].redirectToUri();
  return function (proposal) {
    var params = {
      proposalId: (proposal === null || proposal === void 0 ? void 0 : proposal.id) || '',
      sellerEmail: sellerEmail
    };

    var query = _getOptionSubmissionRequest(appContext, params);

    return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
      requestName: requestDictionary["vd" /* PROPOSAL_UPDATE */]
    }).then(function (response) {
      redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmation', {
        status: statusCode_constants["a" /* STATUS_CODE_200 */]
      }, {
        bi: Object(lodash["get"])(response, 'bookings.bookingId', ''),
        selectedProposalId: selectedProposalId,
        productId: productId
      }))();
    })["catch"](function (error) {
      var status = Object(lodash["get"])(error, 'errors[0].responseBody.status_code', statusCode_constants["b" /* STATUS_CODE_400 */]);
      var error_code = Object(lodash["get"])(error, 'errors[0].responseBody.errors[0].error_code', 'BOOKING_UNAVAILABLE');
      var error_description = Object(lodash["get"])(error, 'errors[0].responseBody.errors[0].error_description');
      redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmationError', {
        status: status,
        error_code: error_code,
        error_description: error_description
      }, {
        selectedProposalId: selectedProposalId,
        productId: productId
      }))();
    });
  };
}

function submitOption(appContext, location, sellerEmail) {
  var _location$queryParams = location.queryParams,
      selectedProposalId = _location$queryParams.selectedProposalId,
      productId = _location$queryParams.product;
  return submitOptionFromProposal(appContext, sellerEmail, selectedProposalId, productId);
}

function renderErrorUpdatingAttendees(statusCode, i18n) {
  var message = '';

  switch (statusCode) {
    case statusCode_constants["f" /* STATUS_CODE_500 */]:
    case statusCode_constants["c" /* STATUS_CODE_401 */]:
      message = Object(lodash["get"])(i18n, 'booking.form.errors.technicalErrorParticipants');
      break;

    default:
      message = Object(lodash["get"])(i18n, 'booking.form.errorLabel');
      break;
  }

  return message;
}

var getAttendeeId = function getAttendeeId(_ref) {
  var neolid = _ref.neolid;
  return neolid;
};

var getAllAttendeesIds = function getAllAttendeesIds(_ref2) {
  var adults = _ref2.adults,
      kids = _ref2.kids;
  var allAttendeesIds = {};

  if (adults.length > 0) {
    allAttendeesIds.adultsAttendeesIds = adults.map(getAttendeeId).filter(Boolean);
  }

  if (kids.length > 0) {
    allAttendeesIds.kidsAttendeesIds = kids.map(getAttendeeId).filter(Boolean);
  }

  return allAttendeesIds;
};

var ContactInfoUtils_getInitialAttendeesList = function getInitialAttendeesList(_ref3) {
  var attendees = _ref3.attendees,
      connectedUserInfo = _ref3.connectedUserInfo; // defined the default lastName to that of connectedUser

  var adults = attendees.adults.map(function (adult, index) {
    return _objectSpread(_objectSpread({}, adult), {}, {
      lastName: connectedUserInfo && !adult.lastName ? connectedUserInfo.lastName : adult.lastName,
      isMain: index === 0 || !!adult.gmNumber && index === attendees.adults.findIndex(function (_ref4) {
        var gmNumber = _ref4.gmNumber;
        return gmNumber === adult.gmNumber;
      })
    });
  }); // defined the default lastName to this of connectedUser

  var children = attendees.children.map(function (child) {
    return _objectSpread(_objectSpread({}, child), {}, {
      lastName: connectedUserInfo && !child.lastName ? connectedUserInfo.lastName : child.lastName
    });
  });
  return {
    adults: adults,
    children: children,
    all: [].concat(Object(toConsumableArray["a" /* default */])(adults.map(function (adult, index) {
      return _objectSpread(_objectSpread({}, adult), {}, {
        attendeeIndex: index
      });
    })), Object(toConsumableArray["a" /* default */])(children.map(function (child, index) {
      return _objectSpread(_objectSpread({}, child), {}, {
        attendeeIndex: index,
        isChild: true
      });
    })))
  };
};
var ContactInfoUtils_getInitialFormValues = function getInitialFormValues(_ref5) {
  var i18n = _ref5.i18n,
      initialAttendeesList = _ref5.initialAttendeesList,
      connectedUserInfo = _ref5.connectedUserInfo,
      hasAddress = _ref5.hasAddress,
      nationalityFieldRules = _ref5.nationalityFieldRules,
      locale = _ref5.locale,
      sellerEmail = _ref5.sellerEmail;
  var showOnlyCountryCode = i18n.booking.participants.postalAddress.displayCountryFieldOnly;
  var optins = ContactInfoUtils_getOptinsInfos(i18n.bookingProcess); // The opt-ins show are configurable from the CMS, but we also don't show them for identified
  // users who already checked them

  var getOptinValue = function getOptinValue(optin, optinName, userInfo) {
    if (!optin) {
      return;
    } // in case of a connected user return undefined to not show it if already checked


    if (connectedUserInfo[optinName] === true) {
      return undefined;
    }

    if (userInfo[optinName] !== undefined) {
      return userInfo[optinName];
    }

    return optin.preChecked;
  };

  return {
    seller: {
      email: sellerEmail
    },
    // $FlowFixMe temporarily disabled: waiting for clic evolv
    adults: initialAttendeesList.adults.map(function (adult) {
      return _objectSpread(_objectSpread(_objectSpread({}, adult), {}, {
        passport: _objectSpread(_objectSpread({}, adult.passport), nationalityFieldRules && (nationalityFieldRules.concernedAttendees === 'all' || adult.isMain) && (!adult.passport || !adult.passport.nationality) ? {
          nationality: 'RU'
        } : {}),
        birthdate: typeof adult.birthdate === 'number' ? adult.birthdate : Object(apiDate["d" /* apiDateToTimestamp */])(adult.birthdate),
        address: adult.isMain && hasAddress ? _objectSpread(_objectSpread({}, showOnlyCountryCode ? null : adult.address), {}, {
          countryCode: Object(lodash["get"])(adult.address, 'countryCode', locale.split('-')[1])
        }) : undefined
      }, adult.isMain ? {
        optinEmail: getOptinValue(optins.email, 'optinEmail', adult),
        optinSms: getOptinValue(optins.sms, 'optinSms', adult),
        optinMail: getOptinValue(optins.mail, 'optinMail', adult),
        optinFosun: getOptinValue(optins.fosun, 'optinFosun', adult),
        optinPhone: getOptinValue(optins.phone, 'optinPhone', adult),
        optinClubmedPlus: getOptinValue(optins.clubmedPlus, 'optinClubmedPlus', adult),
        legalAgreement: false,
        checkAll: false
      } : null), {}, {
        // clear user info we don't want to store in the form state and in the store
        isMain: undefined,
        mainContactId: !adult.gmNumber && initialAttendeesList.adults[0].neolid ? initialAttendeesList.adults[0].neolid : '-1' // temporarily disabled: waiting for clic evolv

      });
    }),
    // $FlowFixMe temporarily disabled: waiting for clic evolv
    children: initialAttendeesList.children.map(function (child) {
      return _objectSpread(_objectSpread({}, child), {}, {
        passport: _objectSpread(_objectSpread({}, child.passport), nationalityFieldRules && nationalityFieldRules.concernedAttendees === 'all' && (!child.passport || !child.passport.nationality) ? {
          nationality: 'RU'
        } : {}),
        birthdate: typeof child.birthdate === 'number' ? child.birthdate : Object(apiDate["d" /* apiDateToTimestamp */])(child.birthdate),
        mainContactId: !child.gmNumber && initialAttendeesList.adults[0].neolid ? initialAttendeesList.adults[0].neolid : '-1' // temporarily disabled: waiting for clic evolv

      });
    })
  };
};
function getAddressValidators(addressSchema) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref6$withRequired = _ref6.withRequired,
      withRequired = _ref6$withRequired === void 0 ? true : _ref6$withRequired,
      message = _ref6.message;

  return addressSchema.reduce(function (addressValidators, fieldValidation) {
    var rule = lib["string"]();
    fieldValidation.validators.forEach(function (validator) {
      switch (validator.name) {
        case 'pattern':
          rule = rule.matches(validator.value, message);
          break;

        case 'minLength':
          rule = rule.transform(function (value) {
            return value === '' ? undefined : value;
          }, message).min(validator.value, message);
          break;

        case 'maxLength':
          rule = rule.max(validator.value, message);
          break;

        default:
          // eslint-disable-next-line no-console
          console.error("Cannot handle rule ".concat(validator.name));
      }
    });

    if (withRequired) {
      if (fieldValidation.required) {
        rule = rule.required();
      }
    }

    return _objectSpread(_objectSpread({}, addressValidators), {}, Object(defineProperty["a" /* default */])({}, fieldValidation.name, rule));
  }, {});
}
var ContactInfoUtils_getValidators = function getValidators(_ref7) {
  var nationality = _ref7.nationality,
      identityNumberInformation = _ref7.identityNumberInformation,
      addressSchema = _ref7.addressSchema,
      passportInformation = _ref7.passportInformation,
      expirationDate = _ref7.expirationDate,
      issuingDate = _ref7.issuingDate,
      locale = _ref7.locale,
      departureDate = _ref7.departureDate,
      arrivalDate = _ref7.arrivalDate,
      adultCivilities = _ref7.adultCivilities,
      childCivilities = _ref7.childCivilities,
      userIsSeller = _ref7.userIsSeller;
  var BRAZIL_LOCALE = 'pt-BR';
  var strictNameValidator = lib["string"]().matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/);
  var baseWordValidator = strictNameValidator.matches(/^[\x20-\xFF]+$/); // ASCII

  var phoneRegex = Object(RegexHelper["b" /* getPhoneRegex */])(locale);
  var rawValidators = {
    adultCivilities: lib["string"]().oneOf(adultCivilities).required(),
    childCivilities: lib["string"]().oneOf(childCivilities).required(),
    firstName: baseWordValidator.max(20).required(),
    lastName: baseWordValidator.max(30).required(),
    unicodeFirstName: strictNameValidator.max(100).required(),
    unicodeLastName: strictNameValidator.max(100).required(),
    adultBirthDate: lib["date"]().transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()().subtract(constants["h" /* YEAR_OF_MAJORITY */], 'y')).min(moment_default()().subtract(constants["c" /* MAX_AGE */], 'y')).required(),
    childBirthDate: lib["date"]().transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()()).min(moment_default()().subtract(constants["h" /* YEAR_OF_MAJORITY */], 'y')).required(),
    email: lib["string"]().matches(RegexHelper["a" /* emailRegex */]).required(),
    mobile: lib["string"]().matches(phoneRegex).required(),
    emailNotRequired: lib["string"]().email(),
    mobileNotRequired: lib["string"]().transform(function (v) {
      return !v ? undefined : v;
    }) // transform to undefined when empty string to pass the regex
    .matches(phoneRegex),
    documentNumber: function () {
      if (!passportInformation) {
        return;
      }

      var rule = lib["string"]().transform(function (value, initialValue) {
        return initialValue ? initialValue.replace(/ /g, '') : initialValue;
      }).matches(/[a-zA-Z0-9]{6,30}/, {
        excludeEmptyString: true
      });
      return passportInformation.required && !userIsSeller ? rule.required() : rule;
    }(),
    expirationDate: function () {
      if (!expirationDate) {
        return;
      }

      var rule = lib["mixed"]().transform(function (value, initialValue) {
        return initialValue ? new Date(initialValue) : initialValue;
      }).test('', '', function (value) {
        //<< optionnal for seller >> && << cms .required - expirationDate at least one day after departure for user >>
        if (expirationDate.required && !userIsSeller && !value || (!expirationDate.required || userIsSeller) && value && value <= moment_default()(departureDate).add(1, 'd') || expirationDate.required && !userIsSeller && !value) {
          return false;
        }

        return true;
      });
      return rule;
    }(),
    issuingDate: function () {
      if (!issuingDate) {
        return;
      }

      var rule = lib["mixed"]().transform(function (value, initialValue) {
        return initialValue ? new Date(initialValue) : initialValue;
      }).test('', '', function (value) {
        //<< optionnal for seller >> && << cms .required - issuingDate at least one day before arrival for user >>
        if (issuingDate.required && !userIsSeller && !value || (!issuingDate.required || userIsSeller) && value && value >= moment_default()(arrivalDate).subtract(1, 'd')) {
          return false;
        }

        return true;
      });
      return rule;
    }(),
    nationality: function () {
      if (!nationality) {
        return;
      }

      var rule = lib["string"]();
      return nationality.required && !userIsSeller ? rule.required() : rule;
    }(),
    identityNumber: function () {
      if (!identityNumberInformation) {
        return;
      }

      var brazilCpfRule = lib["string"]().test('', '', function (value) {
        value && value.replace(/ /g, '');

        if (value.length < 11 || value.length > 14 || !isValidCPF(value)) {
          // $FlowFixMe should use the function syntax instead of the arrow, but it only works this way
          return _this.createError();
        }
      });
      var rule = lib["string"]().transform(function (value, initialValue) {
        return initialValue ? initialValue.replace(/ /g, '') : initialValue;
      }).min(6).max(30);
      var finalRule = locale === BRAZIL_LOCALE ? brazilCpfRule : rule;
      return identityNumberInformation.required ? finalRule.required() : finalRule;
    }(),
    legalAgreement: lib["mixed"]().oneOf([true]).required(),
    gmNumber: lib["string"]().required()
  }; // $FlowFixMe

  return _objectSpread(_objectSpread({}, rawValidators), {}, {
    address: getAddressValidators(addressSchema)
  });
};
var addressSchemaOrder = ['additionalInformation1', 'additionalInformation2', 'streetNumber', 'streetName', 'addOn', 'zipCode', 'town', 'stateOrDistrict', 'city', 'countryCode'];
var addressSchemaSort = function addressSchemaSort(schema1, schema2) {
  return addressSchemaOrder.indexOf(schema1.name) - addressSchemaOrder.indexOf(schema2.name);
};
var ContactInfoUtils_getAdultCivilities = function getAdultCivilities(defaultCivilities, locale) {
  var adultCivilities = Object(dist["getAdultsCivilities"])(locale);
  return Object(lodash["isEmpty"])(adultCivilities) ? defaultCivilities : adultCivilities;
};
var ContactInfoUtils_getHeaderContactInfoTitle = function getHeaderContactInfoTitle(_ref8) {
  var i18n = _ref8.i18n,
      isValid = _ref8.isValid,
      isMain = _ref8.isMain,
      isChild = _ref8.isChild,
      displayUnicodeFields = _ref8.displayUnicodeFields,
      formValues = _ref8.formValues,
      attendeeIdentifier = _ref8.attendeeIdentifier,
      attendeeIndex = _ref8.attendeeIndex;

  if (isValid) {
    if (displayUnicodeFields) {
      return "".concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".unicodeFirstName")), " ").concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".unicodeLastName")));
    }

    return "".concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".firstName")), " ").concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".lastName")));
  }

  if (isMain) {
    return i18n.booking.participants.personnalInfosHeader.title;
  }

  if (isChild) {
    return "".concat(i18n.booking.participants.otherKidsInfosHeader.title, " ").concat(attendeeIndex + 1);
  }

  return "".concat(i18n.booking.participants.otherAdultsInfosHeader.title, " ").concat(attendeeIndex);
};
var cleanUselessAttendeesValues = function cleanUselessAttendeesValues(_ref9) {
  var adults = _ref9.adults,
      children = _ref9.children;
  return {
    children: children,
    // clear legalAgreement, it's not need in the store it's just to block the form
    adults: adults.map(function (adult) {
      return _objectSpread(_objectSpread({}, adult), {}, {
        legalAgreement: undefined
      });
    })
  };
};
var ContactInfoUtils_isChild = function isChild(attendeeIdentifier) {
  return attendeeIdentifier.includes('children');
};
var ContactInfoUtils_getGmNumbersOptions = function getGmNumbersOptions(_ref10) {
  var formik = _ref10.formik,
      i18n = _ref10.i18n,
      previousGmNumberOptions = _ref10.previousGmNumberOptions; // we use a negative gmNumber to know that it's a new gm

  var newGmNumber = -1;
  return [].concat(Object(toConsumableArray["a" /* default */])([].concat(Object(toConsumableArray["a" /* default */])(formik.values.adults), Object(toConsumableArray["a" /* default */])(formik.values.children)).reduce(function (accGmNumbersOptions, attendee, index) {
    if (!attendee.gmNumber && !attendee.mainContactId) {
      return accGmNumbersOptions;
    }

    var _attendee$firstName = attendee.firstName,
        firstName = _attendee$firstName === void 0 ? '' : _attendee$firstName,
        _attendee$lastName = attendee.lastName,
        lastName = _attendee$lastName === void 0 ? '' : _attendee$lastName;
    var gmNumbersOptionsIndex = accGmNumbersOptions.findIndex(function (_ref11) {
      var gmNumber = _ref11.gmNumber,
          value = _ref11.value;
      return gmNumber === attendee.gmNumber || value === attendee.mainContactId;
    });

    if (gmNumbersOptionsIndex > -1) {
      accGmNumbersOptions[gmNumbersOptionsIndex].name += ", ".concat(firstName, " ").concat(lastName);
      return accGmNumbersOptions;
    }

    if (!attendee.gmNumber && attendee.mainContactId < 0) {
      var previousNewHouseholdOption = previousGmNumberOptions.find(function (_ref12) {
        var gmNumber = _ref12.gmNumber;
        return gmNumber === attendee.mainContactId;
      });
      /**
       * if the main contact of a previously created new household is deleted (=> the user change his household)
       * and there is other attendees on this household, we prevent this household to be in the options
       * and we will reset them later in the provider
       */

      if (previousNewHouseholdOption && previousNewHouseholdOption.mainContactIndex !== index) {
        return accGmNumbersOptions;
      } // when a new household is created update the id for a potential next-one


      newGmNumber--;
      return [].concat(Object(toConsumableArray["a" /* default */])(accGmNumbersOptions), [{
        mainContactIndex: index,
        gmNumber: attendee.mainContactId,
        value: attendee.mainContactId,
        name: "".concat(i18n.booking.participants.labels.gmNumber, " ").concat(lastName, " - ").concat(firstName, " ").concat(lastName)
      }]);
    }

    return [].concat(Object(toConsumableArray["a" /* default */])(accGmNumbersOptions), [{
      gmNumber: attendee.gmNumber,
      value: attendee.neolid,
      name: "".concat(attendee.gmNumber, " - ").concat(firstName, " ").concat(lastName)
    }]);
  }, [// select placeholder
  {
    name: i18n.booking.participants.labels.selectGmNumber,
    value: '',
    gmNumber: null
  }])), [{
    // select new household action option
    name: i18n.booking.participants.labels.createGmNumber,
    value: newGmNumber
  }]);
};

var ContactInfoUtils_shouldHideField = function shouldHideField(_ref13) {
  var connectedUserInfo = _ref13.connectedUserInfo,
      userIsSeller = _ref13.userIsSeller,
      formInitialValues = _ref13.formInitialValues,
      fieldName = _ref13.fieldName,
      attendeeIdentifier = _ref13.attendeeIdentifier,
      fieldNameConnectedUserOverride = _ref13.fieldNameConnectedUserOverride;

  if (connectedUserInfo && (fieldNameConnectedUserOverride && connectedUserInfo[fieldNameConnectedUserOverride] || connectedUserInfo[fieldName])) {
    return true;
  } // if the attendee has a gmNumber he is identified and if he has a value for the field
  // we don't want to permit the seller to modified the field #11741


  return !!(userIsSeller && Object(lodash["get"])(formInitialValues, "".concat(attendeeIdentifier, ".neolid")) && Object(lodash["get"])(formInitialValues, "".concat(attendeeIdentifier, ".").concat(fieldName)));
};

var ContactInfoUtils_findDuplicateAttendees = function findDuplicateAttendees(attendees) {
  var duplicates = attendees.reduce(function (acc, _ref14, index) {
    var birthdate = _ref14.birthdate,
        lastName = _ref14.lastName,
        firstName = _ref14.firstName;

    if (birthdate && lastName && firstName) {
      var key = "".concat(birthdate).concat(lastName).concat(firstName).toLocaleLowerCase();

      if (acc[key]) {
        acc[key].push(index);
      } else {
        acc[key] = [index];
      }
    }

    return acc;
  }, {});
  Object.keys(duplicates).forEach(function (key) {
    if (duplicates[key].length < 2) {
      delete duplicates[key];
    }
  }); // $FlowFixMe return indexes of duplicate attendees

  return Object(lodash["flatten"])(Object.values(duplicates));
};


/***/ }),

/***/ "ZKlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TabHeader; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.themes.js


var themes = {
  clean: function clean(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].TURQUOISE;
    return {
      thBody: 'flex h-full items-center',
      thChildren: 'flex-auto flex font-bold items-center justify-center leading-one text-sm md:text-md',
      thIcon: 'flex-shrink-0 rtl:mr-2',
      thIconWidth: '1em',
      thRoot: "".concat(isActive ? "text-".concat(currentColor) : "text-gray-darker focus:text-".concat(currentColor, " hover:text-").concat(currentColor), " px-4 py-3 transition-color"),
      thToggleIcon: "flex-shrink-0 leading-none text-gray-dark rtl:ml-2 ".concat(isActive ? 'rotate-360' : 'rotate-0'),
      thToggleIconWidth: '0.75rem'
    };
  },
  "default": function _default(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].BLUE;
    return {
      thBody: 'flex h-full items-center py-4 px-2',
      thChildren: 'flex-grow flex items-center justify-center leading-one px-2 text-white',
      thIcon: 'flex-shrink-0 rtl:mr-2',
      thIconWidth: '1em',
      thRoot: "bg-current ".concat(isActive ? "text-".concat(currentColor, "-active arrow-down arrow-").concat(currentColor, "-active") : "text-".concat(currentColor, " focus:text-").concat(currentColor, "-active hover:text-").concat(currentColor, "-active"), " text-base text-center transition-color w-full"),
      thToggleIcon: "flex-shrink-0 leading-none text-white rtl:ml-2 ".concat(isActive ? 'rotate-360' : 'rotate-0'),
      thToggleIconWidth: '0.625rem'
    };
  },
  rounded: function rounded(_ref) {
    var isActive = _ref.isActive;
    return {
      thRoot: classnames_default()('border-1 border-gray-light border-solid rounded-t-tiny', {
        'bg-gray-lighter': !isActive,
        'bg-white border-b-0 arrow-down-top arrow-turquoise': isActive
      }),
      thBody: 'flex items-center justify-between',
      thChildren: 'flex-1 flex items-center justify-center',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thToggleIcon: 'flex-shrink-0 text-blue',
      thToggleIconWidth: '0.75rem'
    };
  },
  flat: function flat(_ref2) {
    var isActive = _ref2.isActive;
    return {
      thBody: classnames_default()('border-t-1 border-l-1 border-r-1 flex h-full items-center p-3 md:px-5 md:py-2 transition-colors', {
        'bg-white border-b-white': isActive,
        'bg-gray-lighter border-b-1': !isActive
      }),
      thChildren: classnames_default()('justify-center flex-grow flex font-brand items-center leading-tight text-blue text-sm md:text-lg', {
        'opacity-50': !isActive
      }),
      thIcon: '',
      thIconWidth: '',
      thRoot: classnames_default()('overflow-hidden rounded-tiny', {
        'z-2': isActive
      }),
      thToggleIcon: '',
      thToggleIconWidth: ''
    };
  },
  simple: function simple(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].TURQUOISE;
    return {
      thRoot: "".concat(isActive ? "text-".concat(currentColor, " border-").concat(currentColor, " arrow-down arrow-").concat(currentColor) : "text-white hover:text-".concat(currentColor, " border-gray-light hover:border-").concat(currentColor), " bg-current border-1 flex-initial font-bold rounded text-sm text-center transition-colors uppercase"),
      thBody: "flex h-full items-center p-2 ".concat(isActive ? 'text-white' : 'text-gray-darker focus:text-white hover:text-white transition-color'),
      thChildren: 'flex-grow flex items-center justify-center p-2',
      thIcon: 'flex-shrink-0 rtl:mr-2',
      thIconWidth: '1em',
      thToggleIcon: 'flex-shrink-0 leading-none m-2',
      thToggleIconWidth: '0.625rem'
    };
  },
  lite: function lite(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].GRAY_DARKER;
    return {
      thBody: 'flex items-center',
      thIcon: 'flex-shrink-0 rtl:mr-2',
      thIconWidth: '1em',
      thRoot: classnames_default()("py-1 px-3 rounded-tiny text-".concat(currentColor, " text-md transition-bg-color"), {
        'bg-white': !isActive,
        'bg-overlay-blue-10 font-bold': isActive
      }),
      thToggleIcon: 'flex-shrink-0 leading-none m-2',
      thToggleIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx


var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







// $FlowFixMe
var TabHeader = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var children = props.children,
      className = props.className,
      collapseIconName = props.collapseIconName,
      controlsId = props.controlsId,
      _props$dataTestId = props.dataTestId,
      dataTestId = _props$dataTestId === void 0 ? 'tab-header' : _props$dataTestId,
      expandIconName = props.expandIconName,
      iconName = props.iconName,
      id = props.id,
      isAccordion = props.isAccordion,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      _onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      role = props.role,
      style = props.style,
      tabIndex = props.tabIndex,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      trackingData = props.trackingData;
  var track = !isActive && trackingData ? Object(useTracking["a" /* useTracking */])(trackingData) : lodash["noop"];

  var _themes$theme = themes[theme](props),
      thBody = _themes$theme.thBody,
      thChildren = _themes$theme.thChildren,
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot,
      thToggleIcon = _themes$theme.thToggleIcon,
      thToggleIconWidth = _themes$theme.thToggleIconWidth;

  var toggleIcon = isActive ? collapseIconName : expandIconName;

  var aria = _objectSpread(_objectSpread({}, controlsId ? {
    'aria-controls': controlsId
  } : null), isAccordion ? {
    'aria-expanded': isActive
  } : {
    'aria-selected': isActive
  });

  return __jsx("button", Object(esm_extends["a" /* default */])({}, aria, {
    className: classnames_default()(className, 'reset-button', thRoot),
    "data-cs-override-id": "TabHeader" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
    ,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: function onClick() {
      _onClick && _onClick();
      track({});
    },
    onKeyDown: onKeyDown,
    id: id,
    ref: ref,
    role: role,
    style: style,
    tabIndex: tabIndex,
    type: "button"
  }), __jsx("div", {
    className: thBody
  }, __jsx("div", {
    className: thChildren
  }, !!iconName && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: iconName,
    width: thIconWidth
  }), children), !!toggleIcon && __jsx(Icon["a" /* Icon */], {
    className: thToggleIcon,
    name: toggleIcon,
    width: thToggleIconWidth
  })));
});

/***/ }),

/***/ "ZLJe":
/***/ (function(module) {

module.exports = JSON.parse("{\"amp\":\"&\",\"apos\":\"'\",\"gt\":\">\",\"lt\":\"<\",\"quot\":\"\\\"\"}");

/***/ }),

/***/ "ZOp8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCROLL_ANCHOR */
/* unused harmony export MAIN */
/* unused harmony export ADULTS */
/* unused harmony export KIDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return YEAR_OF_MAJORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CNIL_LEGAL_MESSAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GENERAL_PERSONAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UNIQUE_IDENTIFICATION_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return THIRD_PARTY_PROVISION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OVERSEAS_PROVISION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OVERSEAS_PROVISION_INSURANCE; });
var SCROLL_ANCHOR = 'scrollAnchor';
var MAIN = 'main';
var ADULTS = 'adults';
var KIDS = 'kids';
var YEAR_OF_MAJORITY = 18;
var MAX_AGE = 100; //CGUs IDs

var CNIL_LEGAL_MESSAGE_ID = 'CNIL';
var GENERAL_PERSONAL_INFORMATION = 'GENERAL_PERSONAL_INFORMATION';
var UNIQUE_IDENTIFICATION_INFORMATION = 'UNIQUE_IDENTIFICATION_INFORMATION';
var THIRD_PARTY_PROVISION = 'THIRD_PARTY_PROVISION';
var OVERSEAS_PROVISION = 'OVERSEAS_PROVISION';
var OVERSEAS_PROVISION_INSURANCE = 'OVERSEAS_PROVISION_INSURANCE';

/***/ }),

/***/ "ZP80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FETCH_PREBOOKING_TRAVELERS; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ fetchPrebookingTravelers; });

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/BookingAttendeesProfile.fragment.js
var BookingAttendeesProfile_fragment = __webpack_require__("SQLw");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.queries.js


function travelerProfilesQuery(_ref) {
  var adults = _ref.adults,
      kids = _ref.kids;
  return "\n    {\n      ".concat(Object(BookingEngine_query["a" /* getCxoAttendeesData */])({
    adultsAttendeesIds: adults,
    kidsAttendeesIds: kids
  }), "\n    }\n    ").concat(adults && adults[0] || kids && kids[0] ? BookingAttendeesProfile_fragment["a" /* default */] : '', "\n  ");
}
// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.action.js





var FETCH_PREBOOKING_TRAVELERS = 'FETCH_PREBOOKING_TRAVELERS';
function fetchPrebookingTravelers(params, appContext) {
  return function (dispatch) {
    if (!params.adults || params.adults.length === 0) {
      return Promise.reject();
    }

    var query = travelerProfilesQuery(params);
    var promise = graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
      requestName: requestDictionary["gb" /* CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_TRAVELERS */]
    })["catch"](function (error) {
      if (error.errors && error.errors.some(function (e) {
        return e.statusCode === 401;
      })) {
        Object(sellerUtils["f" /* handle401GraphqlErrorSeller */])(error, appContext);
      }

      return {};
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(FETCH_PREBOOKING_TRAVELERS, params, {
      optimist: true,
      promise: promise
    }));
  };
}

/***/ }),

/***/ "ZS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductPriceInfo; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qqKu");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var ProductPriceInfo = function ProductPriceInfo(_ref) {
  var city = _ref.city,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      onClick = _ref.onClick,
      startDate = _ref.startDate,
      unit = _ref.unit;
  var isAllInclusive = !isJoyview && !isTour; // eslint-disable-next-line no-nested-ternary

  var buttonLabel = isTour ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.buttonTourLabel') : isCruise ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.buttonCruiseLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.buttonLabel');
  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "a"], {
    className: "p-5",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].GRAY_DARKER,
    text: [hasTransport ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.startingPriceDescriptionWithTransport', {
      unit: unit,
      city: city,
      endDate: endDate,
      startDate: startDate
    }) : Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.startingPriceDescriptionWithoutTransport', {
      endDate: endDate,
      startDate: startDate,
      unit: unit
    }), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.roomAvailability')].join(' '),
    theme: "text-sans-2"
  }), (isAllInclusive || onClick) && __jsx("div", {
    className: "flex flex-col items-center border-t-1 border-gray-light p-5"
  }, isAllInclusive && __jsx("p", {
    className: "flex flex-col sm:flex-row sm:flex-wrap sm:justify-center max-w-full reset-paragraph text-center text-gray-darker text-sm"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.pricePopin.priceIsLabel'), ' ', __jsx("span", {
    className: "font-brand rtl:ml-1 text-blue text-md"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    className: "-mt-1 rtl:mr-1",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLUE,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].ALL_INCLUSIVE,
    width: "1.2rem"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "f"])('resort.startingPrice.allInclusive'))), onClick && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_4__[/* Button */ "a"], {
    className: "mt-px10",
    colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BOOKING,
    colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BOOKING,
    dataTestId: "ProductPriceInfo-button",
    onClick: onClick
  }, buttonLabel)));
};

/***/ }),

/***/ "ZpYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ StripButton; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.themes.js
var themes = {
  "default": function _default(_ref) {
    var color = _ref.color,
        colorBorder = _ref.colorBorder,
        orientation = _ref.orientation;
    return {
      thRoot: 'reset-button flex relative justify-center',
      thInner: "bg-".concat(color, " border-").concat(orientation === 'top' ? 't' : 'b', "-1 border-").concat(colorBorder, " -m").concat(orientation === 'top' ? 'x' : '', "-px overflow-hidden px-1 stripButton-text p").concat(orientation === 'top' ? 't' : 'b', "-2 whitespace-no-wrap")
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx

var __jsx = react_default.a.createElement;





function StripButtonSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      colorBorder = _ref.colorBorder,
      height = _ref.height,
      hasBottomOrientation = _ref.hasBottomOrientation;
  return __jsx("svg", {
    className: classnames_default()(className, 'fill-current', "text-".concat(color)),
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 30",
    height: height,
    width: 30,
    style: {
      flexBasis: '15px'
    }
  }, __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    d: "M10,21H-5L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))), __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    style: {
      strokeWidth: '1px'
    },
    className: "fill-transparent stroke-current text-".concat(colorBorder),
    d: "M-5,21L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))));
}

function StripButton(props) {
  var children = props.children,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].WHITE : _props$color,
      _props$colorBorder = props.colorBorder,
      colorBorder = _props$colorBorder === void 0 ? colors["a" /* COLORS */].GRAY_LIGHT : _props$colorBorder,
      _props$dataTestId = props.dataTestId,
      dataTestId = _props$dataTestId === void 0 ? 'strip-button' : _props$dataTestId,
      _props$height = props.height,
      height = _props$height === void 0 ? 30 : _props$height,
      onClick = props.onClick,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'top' : _props$orientation,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  if (!react["Children"].count(children)) return null;

  var _themes$theme = themes[theme]({
    color: color,
    colorBorder: colorBorder,
    orientation: orientation
  }),
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;

  var hasBottomOrientation = orientation === 'bottom';
  var svgProps = {
    color: color,
    colorBorder: colorBorder,
    height: height,
    hasBottomOrientation: hasBottomOrientation
  };
  return __jsx("button", {
    className: classnames_default()(className, thRoot),
    onClick: onClick,
    type: "button",
    "data-testid": dataTestId
  }, __jsx(StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: hasBottomOrientation ? '-scale-y-1 rtl:-scale-y-1' : 'rtl:-scale-x-1'
  }, svgProps)), __jsx("span", {
    className: thInner,
    style: {
      height: height
    }
  }, children), __jsx(StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: hasBottomOrientation ? '-scale-1 rtl:-scale-1' : '-scale-x-1 rtl:translate-x-0'
  }, svgProps)));
}

/***/ }),

/***/ "Zq1u":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("rhE9");

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ "aFmo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productQuotationFormResolver; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productQuotationFormResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* QUOTATION_FORM */ "Y"],
  resolve: function resolve(appContext, _ref, _ref2) {
    var resortId = _ref.resortId,
        dateFormat = _ref.criteria.dateFormat;
    var pageType = _ref2.pageType;
    var isLandingPage = pageType === _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["b2cPagesService"].PAGE_TYPES.LANDING;
    var productQuotationFormQuery = "{\n      product: resort(productId: \"".concat(resortId, "\") {\n        image,\n        productId: id\n        productLabel: name\n        productRangeLabel: rangeLabel\n        rangeId\n        seasonName\n        type\n      }\n      ").concat(isLandingPage ? '' : "price(productId: \"".concat(resortId, "\") {\n        initialPrice { value }\n      }"), "\n      bookingCriteria(resortId: \"").concat(resortId, "\") {\n        departureCities { value name }\n      }\n      ").concat(isLandingPage ? '' : "stopover(productId: \"".concat(resortId, "\") {\n        tour {\n          duration(message: \"{durationInNights}\")\n        }\n        extension {\n          duration(message: \"{durationInNights}\")\n          title(message: \"\")\n        }\n      }"), "\n      tour(productId: \"").concat(resortId, "\") {\n        availableDates {\n          value\n          name: formattedValue(dateFormat: \"").concat(dateFormat, "\")\n        }\n      }\n      civilities { adult { value: code name: label } }\n      newsletter(id: CLUBMED) { id description }\n      legalInformations { newsletterOptins { id title description } }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(productQuotationFormQuery, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_QUOTATION_FORM */ "uc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "aUQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAutocomplete; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zygG");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ub5k");
/* harmony import */ var _use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ngAq");
/* harmony import */ var _client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Qmkj");
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("y316");








function useAutocomplete() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(keywords),
      autocompleteQuery = _useState[0],
      setAutocompleteQuery = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])([]),
      autocompleteResults = _useState2[0],
      setAutocompleteResults = _useState2[1];

  var _useDebounce = Object(_use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_5__[/* useDebounce */ "a"])([autocompleteQuery], 300),
      _useDebounce2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_useDebounce, 1),
      debouncedAutocompleteQuery = _useDebounce2[0]; // This effect is used to fetch autocomplete suggestions when the query changes (with a 300ms debounce)


  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee() {
        var _ref2, _ref2$answers, answers, results;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_7__[/* suggest */ "d"])({
                  criteria: {
                    keywords: debouncedAutocompleteQuery
                  },
                  appContext: appContext
                });

              case 3:
                _ref2 = _context.sent;
                _ref2$answers = _ref2.answers;
                answers = _ref2$answers === void 0 ? [] : _ref2$answers;
                results = answers.map(_client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_6__[/* getResultItem */ "b"]);
                setAutocompleteResults(results);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                setAutocompleteResults([]);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    if (debouncedAutocompleteQuery) {
      fetchData();
    } else {
      setAutocompleteResults([]);
    }
  }, [debouncedAutocompleteQuery]);
  return {
    autocompleteQuery: autocompleteQuery,
    setAutocompleteQuery: setAutocompleteQuery,
    autocompleteResults: autocompleteResults,
    setAutocompleteResults: setAutocompleteResults
  };
}

/***/ }),

/***/ "aZXx":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "afpJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productAccessAndMapResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var productAccessAndMapResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_ACCESS_AND_MAP */ "ab"],
  resolve: function resolve(appContext, _ref) {
    var resortId = _ref.resortId;
    var query = "query {\n      config {\n        common {\n          close\n          loadLess\n          maps {\n            productBaiduMap\n            productGoogleMap\n            productGoogleStreetView\n          }\n          viewMore\n        }\n      }\n      resort(resortId: \"".concat(resortId, "\") {\n        name\n        address {\n          streetNumber\n          streetName\n          additionalInformation1\n          additionalInformation2\n          addOn\n          city\n          town\n          zipCode\n          stateOrDistrict\n          country\n        }\n        coordinates {\n          latitude\n          longitude\n        }\n        accesses {\n          id\n          type\n          name\n          transfertDurationMin\n        }\n        streetView {\n          latitude\n          longitude\n          heading\n          pitch\n          fov\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_ACCESS_AND_MAP */ "Yb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "akds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Video; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("u/u4");
/* harmony import */ var _image_placeholder_ImagePlaceholder_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("D0nZ");
/* harmony import */ var _Video_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("JhHq");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





function Video(props) {
  var className = props.className,
      iFrameClassName = props.iFrameClassName,
      _props$ratioKey = props.ratioKey,
      ratioKey = _props$ratioKey === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].L : _props$ratioKey,
      url = props.url;
  if (!Object(_Video_utils__WEBPACK_IMPORTED_MODULE_4__[/* isVideoUrl */ "b"])(url)) return null;
  return __jsx(_image_placeholder_ImagePlaceholder_jsx__WEBPACK_IMPORTED_MODULE_3__[/* ImagePlaceholder */ "a"], {
    aspectRatio: 100 * _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].values[ratioKey],
    className: className
  }, __jsx("div", {
    className: "leading-none flex h-full items-center justify-center overflow-hidden"
  }, __jsx("iframe", {
    title: "Video iframe",
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(iFrameClassName, 'border-0 fadeIn format-16/9 max-h-full'),
    src: Object(_Video_utils__WEBPACK_IMPORTED_MODULE_4__[/* getVideoUrl */ "a"])(url)
  })));
}

/***/ }),

/***/ "bEXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return destinationsResolver; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QsI/");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("jw1E");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("4VTZ");




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var PRODUCT_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PRODUCT_TYPES;
var destinationsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_4__[/* DESTINATIONS */ "l"],
  resolve: function () {
    var _resolve = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(appContext) {
      var query;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              query = "query {\n      config {\n        common {\n          close\n          next\n          previous\n          scrollBackward\n          scrollForward\n        }\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_8__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_8__[/* resort */ "e"](appContext), "\n      }\n      destinations(productType: \"").concat(PRODUCT_TYPES.RESORT, "\") {\n        countries {\n          id\n          label\n          products {\n            comfort\n            href\n            id\n            type\n            ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_7__[/* getPriceFields */ "c"])(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_7__[/* cleanupArgs */ "a"])({})), "\n          }\n        }\n        id\n        isCruise\n        isJoyview\n        isTour\n        label\n      }\n    }");
              return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].runQuery(query, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* LINE_COMMON_DESTINATIONS */ "Eb"]
              }).then(function (data) {
                return _objectSpread(_objectSpread({}, data), {}, {
                  productType: PRODUCT_TYPES.RESORT
                });
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function resolve(_x) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }()
};

/***/ }),

/***/ "bGCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ getProductProps; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Product_mapper_getProductPriceInfoProps; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ setProductHref; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ Product_mapper_updateProductUrl; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_mapper_createProductUrlWithParams; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ updateProduct; });

// UNUSED EXPORTS: getTagsAndBadgeColor, getProductTags, getProductOfferDiscountProps, getProductCallToActionProps, getProductChildcareAvailabilitiesProps, getProductComparisonProps, getProductFlagProps, getProductHeaderProps, getProductPriceProps, getProductThumbnailProps

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /home/circleci/project/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// CONCATENATED MODULE: ./src/client/components/widgets/products-comparison/ProductsComparisonUtils.js


function getAggregateDiscount(product) {
  var proposals = Object(lodash["get"])(product, 'proposals.proposals', []);
  var selectedProposal = proposals.find(function (proposal) {
    return Object(lodash["get"])(proposal, 'selected', true);
  });
  return Object(lodash["get"])(selectedProposal, 'price.aggregateDiscount', null);
}


// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.mapper.js




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var DEFAULT_COMPARISON = {
  isDisabled: false,
  isSelected: false
};

var getSubTitle = function getSubTitle(product) {
  var _product$destination;

  if (product.isCruise) {
    return product.timingDescription;
  }

  return ((_product$destination = product.destination) === null || _product$destination === void 0 ? void 0 : _product$destination.country) || '';
};

var Product_mapper_getProductUrl = function getProductUrl(props) {
  var _props$product, _props$product$price, _props$product$price$, _props$product$price2, _props$product$price3, _props$product$price4, _props$product$price5, _props$product$price6;

  if (!props.contextualizeUrl) {
    return props.product.href;
  }

  var departureDate = "".concat(((_props$product = props.product) === null || _props$product === void 0 ? void 0 : (_props$product$price = _props$product.price) === null || _props$product$price === void 0 ? void 0 : (_props$product$price$ = _props$product$price.termsAndConditions) === null || _props$product$price$ === void 0 ? void 0 : _props$product$price$.departureDate) || '');
  var url = new URI_default.a(props.product.href).setQuery({
    departure_city: (_props$product$price2 = props.product.price) === null || _props$product$price2 === void 0 ? void 0 : (_props$product$price3 = _props$product$price2.termsAndConditions) === null || _props$product$price3 === void 0 ? void 0 : (_props$product$price4 = _props$product$price3.departureCity) === null || _props$product$price4 === void 0 ? void 0 : _props$product$price4.value,
    duration: (_props$product$price5 = props.product.price) === null || _props$product$price5 === void 0 ? void 0 : (_props$product$price6 = _props$product$price5.termsAndConditions) === null || _props$product$price6 === void 0 ? void 0 : _props$product$price6.duration,
    date: departureDate !== 'null' && departureDate ? Object(apiDate["e" /* formatApiDate */])(departureDate, constants["e" /* QUERY_DATE_FORMAT */]) : undefined
  });
  return url.toString();
};

var Product_mapper_getTagsAndBadgeColor = function getTagsAndBadgeColor(product) {
  if (product.isTour || product.isCruise) {
    return product.color;
  }

  if (product.isSummer) {
    return colors["a" /* COLORS */].ORANGE;
  }

  return colors["a" /* COLORS */].BLUE;
};

var Product_mapper_getProductHeaderProps = function getProductHeaderProps(props) {
  var product = props.product;
  var badge = product.seasonTrad;
  var badgeColor = Product_mapper_getTagsAndBadgeColor(product); // $FlowFixMe

  var badgeIcon = Object(product_utils["d" /* getProductBadgeIcon */])(product);
  var link = {
    url: Product_mapper_getProductUrl(props)
  };
  var heading = {
    title: product.name,
    subtitle: getSubTitle(product)
  };
  return {
    badge: badge,
    badgeColor: badgeColor,
    badgeIcon: badgeIcon,
    hasECLogo: product.isExplicitEC,
    heading: heading,
    link: link
  };
};

var Product_mapper_getProductComparisonProps = function getProductComparisonProps(_ref) {
  var _config$faceting;

  var _ref$comparison = _ref.comparison,
      comparison = _ref$comparison === void 0 ? DEFAULT_COMPARISON : _ref$comparison,
      config = _ref.config,
      product = _ref.product;

  var _ref2 = (config === null || config === void 0 ? void 0 : (_config$faceting = config.faceting) === null || _config$faceting === void 0 ? void 0 : _config$faceting.compare) || {},
      selected = _ref2.selected,
      selectResort = _ref2.selectResort,
      unavailableThumbnail = _ref2.unavailableThumbnail;

  var status = product_utils["b" /* IS_ENABLED */];

  if (comparison.isDisabled) {
    status = product_utils["a" /* IS_DISABLED */];
  } else if (comparison.isSelected) {
    status = product_utils["c" /* IS_SELECTED */];
  }

  var label = comparison.isSelected ? selected : selectResort;

  var _ref3 = product || {},
      isCruise = _ref3.isCruise,
      isTour = _ref3.isTour;

  return {
    status: status,
    label: label,
    isEligible: !isTour && !isCruise,
    eligibilityLabel: unavailableThumbnail
  };
};

var getProductCallToActionProps = function getProductCallToActionProps(_ref4) {
  var config = _ref4.config,
      product = _ref4.product;

  var _ref5 = product || {},
      isTour = _ref5.isTour;

  var _ref6 = (config === null || config === void 0 ? void 0 : config.common) || {},
      thumbnailCTA = _ref6.thumbnailCTA,
      thumbnailTourCTA = _ref6.thumbnailTourCTA;

  return {
    label: isTour ? thumbnailTourCTA : thumbnailCTA
  };
};

var Product_mapper_getProductPriceProps = function getProductPriceProps(_ref7) {
  var _config$price;

  var config = _ref7.config,
      product = _ref7.product,
      offerColor = _ref7.offerColor;
  var color = product.isJoyview ? colors["a" /* COLORS */].WATER_GREEN : '';
  return _objectSpread(_objectSpread({
    style: {
      color: offerColor
    },
    color: offerColor || color
  }, (config === null || config === void 0 ? void 0 : (_config$price = config.price) === null || _config$price === void 0 ? void 0 : _config$price.format) || {}), product.price || {});
};

var Product_mapper_getProductChildcareAvailabilitiesProps = function getProductChildcareAvailabilitiesProps(_ref8) {
  var _config$faceting2;

  var config = _ref8.config,
      product = _ref8.product;

  var _ref9 = (config === null || config === void 0 ? void 0 : (_config$faceting2 = config.faceting) === null || _config$faceting2 === void 0 ? void 0 : _config$faceting2.availabilities) || {},
      monthsLabel = _ref9.months,
      yearsLabel = _ref9.years,
      yearLabel = _ref9.year,
      availableLabel = _ref9.available,
      unknownLabel = _ref9.unknown,
      unavailableLabel = _ref9.unavailable,
      urgentizationSingular = _ref9.urgentizationSingular,
      urgentizationPlural = _ref9.urgentizationPlural,
      childcareLabel = _ref9.childcare;

  var sortedChildcareAvailabilities = (product.childcareAvailabilities || []).sort(function (a, b) {
    return a.ageMin - b.ageMin;
  });

  var _sortedChildcareAvail = sortedChildcareAvailabilities,
      _sortedChildcareAvail2 = Object(slicedToArray["a" /* default */])(_sortedChildcareAvail, 2),
      _sortedChildcareAvail3 = _sortedChildcareAvail2[0],
      first = _sortedChildcareAvail3 === void 0 ? {} : _sortedChildcareAvail3,
      _sortedChildcareAvail4 = _sortedChildcareAvail2[1],
      second = _sortedChildcareAvail4 === void 0 ? {} : _sortedChildcareAvail4;

  var hasChildBetween4And23Months = first.ageMin === 4 || first.ageMax === 23;
  var hasOnlyBetween4And13Months = first.ageMin === 4 && second.ageMax !== 23;
  var hasOnlyBetween14And23Months = first.ageMax === 23;
  if (hasOnlyBetween4And13Months) first.ageMax = 23;else if (hasOnlyBetween14And23Months) first.ageMin = 4;else if (hasChildBetween4And23Months) {
    var stock = first.remainingStock === null && second.remainingStock === null ? null : (first.remainingStock || 0) + (second.remainingStock || 0);
    var availability = 'UNKNOWN';
    if (stock === 0) availability = 'UNAVAILABLE';else if (stock) availability = stock <= 10 ? 'PARTIAL' : 'AVAILABLE';
    sortedChildcareAvailabilities = [_objectSpread(_objectSpread({}, second), {}, {
      remainingStock: stock,
      ageMin: 4,
      ageMax: 23,
      availability: availability
    })].concat(Object(toConsumableArray["a" /* default */])(sortedChildcareAvailabilities.slice(2)));
  }
  return {
    items: sortedChildcareAvailabilities,
    monthsLabel: monthsLabel,
    yearsLabel: yearsLabel,
    yearLabel: yearLabel,
    availableLabel: availableLabel,
    unavailableLabel: unavailableLabel,
    unknownLabel: unknownLabel,
    remainingLabel: {
      n: urgentizationPlural,
      _1: urgentizationSingular
    },
    childcareLabel: childcareLabel
  };
};

var Product_mapper_getProductPriceInfoProps = function getProductPriceInfoProps(_ref10) {
  var _config$resort, _config$resort$starti, _product$price, _product$price$termsA, _product$price2, _product$price2$terms, _product$price3, _product$price3$terms, _product$price4, _product$price4$terms, _product$price4$terms2, _product$price5, _product$price5$terms, _product$price5$terms2, _product$price6;

  var config = _ref10.config,
      product = _ref10.product;
  var startDate = '';
  var endDate = '';
  var dateFormat = (config === null || config === void 0 ? void 0 : (_config$resort = config.resort) === null || _config$resort === void 0 ? void 0 : (_config$resort$starti = _config$resort.startingPrice) === null || _config$resort$starti === void 0 ? void 0 : _config$resort$starti.dateFormat) || Object(i18n["f" /* t */])('resort.startingPrice.dateFormat');
  startDate = moment_default()(product === null || product === void 0 ? void 0 : (_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$termsA = _product$price.termsAndConditions) === null || _product$price$termsA === void 0 ? void 0 : _product$price$termsA.departureDate, apiDate["a" /* API_DATE_FORMAT */]).format(dateFormat);
  endDate = moment_default()(product === null || product === void 0 ? void 0 : (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : (_product$price2$terms = _product$price2.termsAndConditions) === null || _product$price2$terms === void 0 ? void 0 : _product$price2$terms.departureDate, apiDate["a" /* API_DATE_FORMAT */]).add({
    days: ((_product$price3 = product.price) === null || _product$price3 === void 0 ? void 0 : (_product$price3$terms = _product$price3.termsAndConditions) === null || _product$price3$terms === void 0 ? void 0 : _product$price3$terms.duration) || 0
  }).format(dateFormat);
  return {
    city: (product === null || product === void 0 ? void 0 : (_product$price4 = product.price) === null || _product$price4 === void 0 ? void 0 : (_product$price4$terms = _product$price4.termsAndConditions) === null || _product$price4$terms === void 0 ? void 0 : (_product$price4$terms2 = _product$price4$terms.departureCity) === null || _product$price4$terms2 === void 0 ? void 0 : _product$price4$terms2.name) || '',
    endDate: endDate,
    hasTransport: !!(product === null || product === void 0 ? void 0 : (_product$price5 = product.price) === null || _product$price5 === void 0 ? void 0 : (_product$price5$terms = _product$price5.termsAndConditions) === null || _product$price5$terms === void 0 ? void 0 : (_product$price5$terms2 = _product$price5$terms.departureCity) === null || _product$price5$terms2 === void 0 ? void 0 : _product$price5$terms2.value),
    isCruise: product.isCruise,
    isJoyview: product.isJoyview,
    isTour: product.isTour,
    startDate: startDate,
    unit: ((_product$price6 = product.price) === null || _product$price6 === void 0 ? void 0 : _product$price6.unit) || ''
  };
};

var getProductTags = function getProductTags(product) {
  if (product.isTour) {
    var rangeLabel = product.rangeLabel.toUpperCase();
    return product.duration ? "".concat(rangeLabel, " : ").concat(product.duration) : rangeLabel;
  }

  if (product.isCruise) {
    var _product$thematics, _product$thematics$;

    return "".concat((_product$thematics = product.thematics) === null || _product$thematics === void 0 ? void 0 : (_product$thematics$ = _product$thematics[0]) === null || _product$thematics$ === void 0 ? void 0 : _product$thematics$.label, " - ").concat(product.duration);
  }
};

var Product_mapper_getProductThumbnailProps = function getProductThumbnailProps(props) {
  var _product$price7, _product$price7$terms, _product$price7$terms2;

  var product = props.product,
      _props$isSliderDisabl = props.isSliderDisabled,
      isSliderDisabled = _props$isSliderDisabl === void 0 ? false : _props$isSliderDisabl;
  var openingStatus = product.openingStatus;
  return {
    closedLabel: Object(i18n["f" /* t */])('common.closed'),
    hasBorder: product.isExclusiveCollection,
    hasTransport: !!(product === null || product === void 0 ? void 0 : (_product$price7 = product.price) === null || _product$price7 === void 0 ? void 0 : (_product$price7$terms = _product$price7.termsAndConditions) === null || _product$price7$terms === void 0 ? void 0 : (_product$price7$terms2 = _product$price7$terms.departureCity) === null || _product$price7$terms2 === void 0 ? void 0 : _product$price7$terms2.value),
    link: {
      url: Product_mapper_getProductUrl(props)
    },
    openingSoonLabel: Object(i18n["f" /* t */])('common.openingSoon'),
    pictures: (product.images || []).map(function (image) {
      return {
        alt: product.name,
        src: image || ''
      };
    }),
    productTags: getProductTags(product),
    tagsColor: Product_mapper_getTagsAndBadgeColor(product),
    transportLabel: Object(i18n["f" /* t */])('price.format.flightIncluded'),
    isSliderDisabled: isSliderDisabled,
    openingStatus: openingStatus
  };
};

var getProductFlagProps = function getProductFlagProps(props) {
  var _props$isPriceLoading = props.isPriceLoading,
      isPriceLoading = _props$isPriceLoading === void 0 ? false : _props$isPriceLoading,
      product = props.product;
  var _product$openingStatu = product.openingStatus,
      openingStatus = _product$openingStatu === void 0 ? OPENING_STATUS.OPEN : _product$openingStatu;
  var price = openingStatus === OPENING_STATUS.OPEN ? Product_mapper_getProductPriceProps(props) : {};
  return {
    price: price,
    priceInfo: Product_mapper_getProductPriceInfoProps(props),
    isPriceLoading: isPriceLoading
  };
};

var Product_mapper_getProductOfferDiscountProps = function getProductOfferDiscountProps(_ref11) {
  var product = _ref11.product,
      config = _ref11.config;
  return {
    discount: getAggregateDiscount(product),
    i18n: config.offerDiscount
  };
};

var Product_mapper_createProductUrlWithParams = function createProductUrlWithParams(href, product) {
  var currentLocation = dist["windowWrapper"].getLocation();
  var possibleQueries = [constants["f" /* QUERY_DEPARTURE_DATE */], constants["g" /* QUERY_DURATION */], constants["k" /* QUERY_TRANSPORT */]];

  if (product.isCruise) {
    possibleQueries = [constants["k" /* QUERY_TRANSPORT */]];
  } else if (product.isTour) {
    possibleQueries = [constants["f" /* QUERY_DEPARTURE_DATE */], constants["k" /* QUERY_TRANSPORT */]];
  }

  var getDepartureDate = function getDepartureDate() {
    var _product$flag, _product$flag$price, _product$flag$price$t; // $FlowFixMe


    if (product.departureDateOn && (product === null || product === void 0 ? void 0 : (_product$flag = product.flag) === null || _product$flag === void 0 ? void 0 : (_product$flag$price = _product$flag.price) === null || _product$flag$price === void 0 ? void 0 : (_product$flag$price$t = _product$flag$price.termsAndConditions) === null || _product$flag$price$t === void 0 ? void 0 : _product$flag$price$t.departureDate)) {
      return Object(apiDate["h" /* momentFromApiDate */])(product.flag.price.termsAndConditions.departureDate).format(constants["e" /* QUERY_DATE_FORMAT */]);
    }

    return Object(uriUtils["i" /* getQueryParameters */])(currentLocation)[constants["f" /* QUERY_DEPARTURE_DATE */]] || '';
  };

  return Object(uriUtils["f" /* generateUrlWithParams */])(href, {
    queryParams: possibleQueries.reduce(function (acc, curr) {
      return _objectSpread(_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, curr, curr === constants["f" /* QUERY_DEPARTURE_DATE */] ? getDepartureDate() : Object(uriUtils["i" /* getQueryParameters */])(currentLocation)[curr] || ''));
    }, {})
  });
};

var setProductHref = function setProductHref(props) {
  var _props$product2 = props.product,
      product = _props$product2 === void 0 ? {} : _props$product2;
  var href = product.href;

  if (href && true) {
    return _objectSpread(_objectSpread({}, props), {}, {
      // $FlowFixMe
      product: _objectSpread(_objectSpread({}, product), {}, {
        href: Product_mapper_createProductUrlWithParams(href, product)
      })
    });
  }

  return props;
};

var getProductProps = function getProductProps(props) {
  var _props$product4, _props$product4$child;

  var _props$product3 = props.product,
      product = _props$product3 === void 0 ? {} : _props$product3,
      _props$kids = props.kids,
      kids = _props$kids === void 0 ? [] : _props$kids,
      _props$hasComparison = props.hasComparison,
      hasComparison = _props$hasComparison === void 0 ? false : _props$hasComparison;
  return {
    callToAction: getProductCallToActionProps(props),
    childcare: Product_mapper_getProductChildcareAvailabilitiesProps(props),
    childcareIncluded: (_props$product4 = props.product) === null || _props$product4 === void 0 ? void 0 : (_props$product4$child = _props$product4.childcareDetails) === null || _props$product4$child === void 0 ? void 0 : _props$product4$child.some(function (childcare) {
      return childcare.included;
    }),
    comfort: product.comfort,
    comparison: Product_mapper_getProductComparisonProps(props),
    departureDateOn: product.departureDateOn,
    flag: getProductFlagProps(props),
    hasComparison: hasComparison,
    header: Product_mapper_getProductHeaderProps(props),
    id: product.id,
    kids: kids,
    minAuthorizedAge: props.product.minAuthorizedAge,
    thumbnail: Product_mapper_getProductThumbnailProps(props),
    type: product.type,
    url: Product_mapper_getProductUrl(props)
  };
};

var updateProduct = function updateProduct(product, props) {
  return _objectSpread(_objectSpread({}, product), {}, {
    hasComparison: props.hasComparison,
    childcare: Product_mapper_getProductChildcareAvailabilitiesProps(props),
    comparison: Product_mapper_getProductComparisonProps(props),
    flag: getProductFlagProps(props)
  });
};

var Product_mapper_updateProductUrl = function updateProductUrl(product) {
  var newProductUrl = Product_mapper_createProductUrlWithParams(new URI_default.a(product.url).pathname(), product);
  return _objectSpread(_objectSpread({}, product), {}, {
    url: newProductUrl,
    header: _objectSpread(_objectSpread({}, product.header), {}, {
      link: {
        url: newProductUrl
      }
    }),
    // $FlowFixMe
    thumbnail: _objectSpread(_objectSpread({}, product.thumbnail), {}, {
      link: {
        url: newProductUrl
      }
    })
  });
};



/***/ }),

/***/ "bLh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productSpaceIntroductionResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var productSpaceIntroductionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_SPACE_INTRODUCTION */ "qb"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_SPACE_INTRODUCTION */ "Ac"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "bNYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productCommunityQuestionsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productCommunityQuestionsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_COMMUNITY_QUESTIONS */ "L"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      config {\n        common { close next previous scrollBackward scrollForward }\n      }\n      productCommunity(".concat(productArgs, ") {\n        linkAllQuestionsUrl\n        questions {\n          id\n          likesCount\n          authorName\n          date\n          title\n          text\n          answersCount\n          answers {\n            id\n            likesCount\n            authorName\n            date\n            text\n          }\n        }\n      }\n      resort(").concat(productArgs, ") {\n        icon\n      }\n     }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_COMMUNITY_QUESTIONS */ "fc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "c/N2":
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ "c18e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChoiceList; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qBqs");
/* harmony import */ var _form_inputs_input_switch_InputSwitch_jsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("YjXp");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





function ChoiceList(props) {
  var _props$choices = props.choices,
      choices = _props$choices === void 0 ? [] : _props$choices,
      className = props.className,
      listClassName = props.listClassName,
      name = props.name,
      onChange = props.onChange,
      showToggleAll = props.showToggleAll,
      title = props.title,
      toggleAllValue = props.toggleAllValue,
      dataTestId = props.dataTestId;

  var onToggle = function onToggle(_, isSelected, value) {
    props.onChange(props.name, isSelected, value);
  };

  return __jsx("fieldset", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('p-0 m-0 border-0', className),
    "data-testid": dataTestId
  }, title && __jsx("legend", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('p-none mb-1', {
      'text-xl text-blue font-bold': !showToggleAll
    })
  }, showToggleAll ? __jsx(_form_inputs_input_switch_InputSwitch_jsx__WEBPACK_IMPORTED_MODULE_4__[/* InputSwitch */ "a"], {
    label: title,
    isChecked: choices.every(function (choice) {
      return choice.isSelected;
    }),
    onChange: onChange,
    name: name,
    size: "large",
    value: toggleAllValue
  }) : title), choices.length > 0 && __jsx("ul", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('list-none p-0', listClassName)
  }, choices.map(function (choice) {
    return __jsx("li", {
      className: "flex items-center mb-2",
      key: choice.value
    }, choice.icon && __jsx(_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"], {
      className: "mr-3",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
      name: choice.icon,
      width: "1.5rem"
    }), __jsx(_form_inputs_input_switch_InputSwitch_jsx__WEBPACK_IMPORTED_MODULE_4__[/* InputSwitch */ "a"], {
      name: "".concat(name, "[]"),
      label: choice.label,
      value: choice.value,
      isChecked: !!choice.isSelected,
      onChange: onToggle
    }));
  })));
}

/***/ }),

/***/ "cGFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidationStateFromKid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidationStateFromKids; });
/* unused harmony export updateValidationStateForKid */
/* unused harmony export addOrRemoveKidFromValidationState */
/* unused harmony export addOrRemoveKidFromKidsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasKidWithoutAValidBirthdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasOnlyValidKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return invalidateNotValidatedKids; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* harmony import */ var _facetingUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kNiU");
/* harmony import */ var _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("45yR");




var getValidationStateFromKid = function getValidationStateFromKid(kid, isKidBirthdateRequired) {
  if (typeof kid !== 'object') {
    return _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
  }

  if (!kid.birthdate) {
    return isKidBirthdateRequired ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"];
  }

  return typeof kid === 'object' && Object(_facetingUtils__WEBPACK_IMPORTED_MODULE_2__[/* isKidMinor */ "g"])(kid.birthdate) ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_VALID */ "b"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
};
var getValidationStateFromKids = function getValidationStateFromKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return kids.map(function (kid) {
    return getValidationStateFromKid(kid);
  });
};
var updateValidationStateForKid = function updateValidationStateForKid(_ref) {
  var index = _ref.index,
      kid = _ref.kid,
      _ref$kidsValidationSt = _ref.kidsValidationState,
      kidsValidationState = _ref$kidsValidationSt === void 0 ? [] : _ref$kidsValidationSt;
  var validationState = getValidationStateFromKid(kid);
  return kidsValidationState.map(function (kidValidation, indexKid) {
    var isNewKid = kidValidation === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"];
    var kidNeedsValidation = !!kid.birthdate || !isNewKid;
    return indexKid === index && kidNeedsValidation ? validationState : kidValidation;
  });
};
var addOrRemoveKidFromValidationState = function addOrRemoveKidFromValidationState(_ref2) {
  var _ref2$currentState = _ref2.currentState,
      currentState = _ref2$currentState === void 0 ? [] : _ref2$currentState,
      kidsNumber = _ref2.kidsNumber;

  if (kidsNumber > currentState.length) {
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(currentState), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Array(kidsNumber - currentState.length).fill(_client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__[/* VALIDATION_STATE_ENUM */ "f"].notvalidated)));
  }

  if (kidsNumber < currentState.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(currentState.slice(0, kidsNumber));
  }

  return currentState;
};
var addOrRemoveKidFromKidsList = function addOrRemoveKidFromKidsList(args) {
  var _args$kids = args.kids,
      kids = _args$kids === void 0 ? [] : _args$kids,
      kidsNumber = args.kidsNumber;

  if (kidsNumber > kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(kids).concat(Array(kidsNumber - kids.length).fill().map(function () {
      return _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_1__[/* DEFAULT_KID_VALUE */ "a"];
    }));
  }

  if (kidsNumber < kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(kids.slice(0, kidsNumber));
  }

  return kids;
};
var hasKidWithoutAValidBirthdate = function hasKidWithoutAValidBirthdate(kidsValidationState) {
  return Boolean(kidsValidationState && kidsValidationState.find(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"];
  }));
};
var hasOnlyValidKids = function hasOnlyValidKids(kidsValidationState) {
  return kidsValidationState.every(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_VALID */ "b"];
  });
};
var invalidateNotValidatedKids = function invalidateNotValidatedKids(kidsValidationState) {
  return kidsValidationState.reduce(function (acc, current) {
    if (current === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* NOT_VALIDATED */ "c"]) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [_client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_3__[/* IS_INVALID */ "a"]]);
    }

    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(acc), [current]);
  }, []);
};

/***/ }),

/***/ "cHMM":
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__("tRRp");

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),

/***/ "cdYD":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("tU/q"),
    getSymbolsIn = __webpack_require__("UR9l"),
    keysIn = __webpack_require__("FQR9");

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ "ceQO":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("5FP0"),
    cloneDataView = __webpack_require__("KicR"),
    cloneRegExp = __webpack_require__("c/N2"),
    cloneSymbol = __webpack_require__("kE5G"),
    cloneTypedArray = __webpack_require__("SIwd");

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ "cjjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EMAIL_PATTERN", function() { return EMAIL_PATTERN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GM_NUMBER_PATTERN", function() { return GM_NUMBER_PATTERN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_NUMBER_PATTERN", function() { return PHONE_NUMBER_PATTERN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "email", function() { return email; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firstName", function() { return firstName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lastName", function() { return lastName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unicodeFirstName", function() { return unicodeFirstName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unicodeLastName", function() { return unicodeLastName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notContainsUnicode", function() { return notContainsUnicode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "strictName", function() { return strictName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ASCII", function() { return ASCII; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minLength", function() { return minLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "haveLength", function() { return haveLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxLength", function() { return maxLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "regexp", function() { return regexp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enum", function() { return enum1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "phoneNumber", function() { return phoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mandatory", function() { return mandatory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "date", function() { return date; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minAge", function() { return minAge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxAge", function() { return maxAge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gmNumber", function() { return gmNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inRange", function() { return inRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "legalAgreement", function() { return legalAgreement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "optionalBirthdate", function() { return optionalBirthdate; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__);



var EMAIL_PATTERN = /^(?!.*@.*\.{2})[^\s@]+@[^\s@]+\.[^\s@.]+$/;
var GM_NUMBER_PATTERN = /^[0-9]{0,9}$/;
var PHONE_NUMBER_PATTERN = /^ *\+? *(?:[ \-()]*[0-9][ \-()]*){6,12}$/;
var UNICODE_CHAR_REGEXP = /[^\u0000-\u00ff]/;

function _regexp(reg) {
  return function (value) {
    return reg.test(value);
  };
}

function _minLength(length) {
  return function (value) {
    return value.length >= length;
  };
}

function _maxLength(length) {
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return value.length <= length;
  };
}

function _haveLength(length) {
  return function (value) {
    return value.length === length;
  };
}

function _enum(values) {
  return function (value) {
    return values.indexOf(value) !== -1;
  };
}

function _mandatory() {
  return function (value) {
    return !!value;
  };
}

function _checkDate(format) {
  return function (dateToCheck) {
    return !!(dateToCheck && format && moment__WEBPACK_IMPORTED_MODULE_1___default()(dateToCheck, format, true).isValid());
  };
}

function _getAge(birthday, birthdayFormat, onDate, onDateFormat) {
  var fromDate = onDate && onDateFormat ? moment__WEBPACK_IMPORTED_MODULE_1___default()(onDate, onDateFormat) : moment__WEBPACK_IMPORTED_MODULE_1___default()();
  return fromDate.diff(moment__WEBPACK_IMPORTED_MODULE_1___default()(birthday, birthdayFormat), 'years', true);
}

function _notContainsUnicode(str) {
  return !UNICODE_CHAR_REGEXP.test(str);
}

function _inRange(min, max) {
  return function (value) {
    return value >= min && value <= max;
  };
}
/* Validators */


var email = {
  name: 'email',
  isValid: _regexp(EMAIL_PATTERN)
};
var firstName = {
  name: 'firstName',
  isValid: function isValid(value) {
    return _maxLength(20)(value) && _notContainsUnicode(value);
  }
};
var lastName = {
  name: 'lastName',
  isValid: function isValid(value) {
    return _maxLength(30)(value) && _notContainsUnicode(value);
  }
};
var notContainsUnicode = {
  name: 'notContainsUnicode',
  isValid: function isValid(value) {
    return _notContainsUnicode(value);
  }
};
var unicodeFirstName = {
  name: 'unicodeFirstName',
  isValid: _maxLength(100)
};
var unicodeLastName = {
  name: 'unicodeLastName',
  isValid: _maxLength(100)
};
var strictName = {
  name: 'strictName',
  isValid: function isValid(value) {
    return _mandatory()(value) && _regexp(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/)(value);
  }
};
var ASCII = {
  name: 'ASCII',
  isValid: _regexp(/^[\x20-\xFF]+$/)
};

function minLength(length) {
  return {
    name: 'minLength',
    isValid: _minLength(length)
  };
}

function haveLength(length) {
  return {
    name: 'haveLength',
    isValid: _haveLength(length)
  };
}

function maxLength(length) {
  return {
    name: 'maxLength',
    isValid: _maxLength(length)
  };
}

function regexp(exp) {
  return {
    name: 'regexp',
    isValid: _regexp(exp)
  };
}

function enum1() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return {
    name: 'enum',
    isValid: _enum(values)
  };
}

function phoneNumber(locale) {
  var phoneRegexp = new RegExp(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2___default.a.getDomain(locale), 'fields.phoneNumber', PHONE_NUMBER_PATTERN));
  return {
    name: 'phoneNumber',
    isValid: _regexp(phoneRegexp)
  };
}

function mandatory() {
  return {
    name: 'mandatory',
    isValid: _mandatory()
  };
}

function date(format) {
  return {
    name: 'date',
    isValid: _checkDate(format)
  };
}

var optionalBirthdate = function optionalBirthdate(_ref) {
  var ageRequired = _ref.ageRequired,
      birthdayFormat = _ref.birthdayFormat,
      onDate = _ref.onDate,
      onDateFormat = _ref.onDateFormat;
  return {
    name: 'optionalBirthdate',
    isValid: function isValid(birthdate) {
      return !birthdate || birthdayFormat && moment__WEBPACK_IMPORTED_MODULE_1___default()(birthdate, birthdayFormat, true).isValid() && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isNumber"])(ageRequired) && _checkDate(birthdayFormat)(birthdate) && _getAge(birthdate, birthdayFormat, onDate, onDateFormat) >= ageRequired;
    }
  };
};

function minAge(_ref2) {
  var ageRequired = _ref2.ageRequired,
      birthdayFormat = _ref2.birthdayFormat,
      onDate = _ref2.onDate,
      onDateFormat = _ref2.onDateFormat;
  return {
    name: 'minAge',
    isValid: function isValid(birthday) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isNumber"])(ageRequired) && _checkDate(birthdayFormat)(birthday) && _getAge(birthday, birthdayFormat, onDate, onDateFormat) >= ageRequired;
    }
  };
}

function maxAge() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      ageRequired = _ref3.ageRequired,
      birthdayFormat = _ref3.birthdayFormat,
      onDate = _ref3.onDate,
      onDateFormat = _ref3.onDateFormat;

  return {
    name: 'maxAge',
    isValid: function isValid(birthday) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isNumber"])(ageRequired) && _checkDate(birthdayFormat)(birthday) && _getAge(birthday, birthdayFormat, onDate, onDateFormat) < ageRequired;
    }
  };
}

function inRange(min, max) {
  return {
    name: 'inRange',
    isValid: _inRange(min, max)
  };
}

var gmNumber = {
  name: 'gmNumber',
  isValid: function isValid(value) {
    return _regexp(GM_NUMBER_PATTERN)(value);
  }
};

function legalAgreement(required) {
  return {
    name: 'legalAgreement',
    // if legalAgreement is not required, return true to bypass validation
    isValid: function isValid(value) {
      return required ? value === true : true;
    }
  };
}



/***/ }),

/***/ "cvSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SYNC_WITH_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SEARCH_SET_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TRIP_INFORMATION_SET_DEPARTURE_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TRIP_INFORMATION_SET_DEPARTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_USER_PAST_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RESET_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_USER_FUTURE_TRIPS_FETCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_USER_FUTURE_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RESET_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_USER_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_USER_SEARCHES_RESOLVED; });
/* unused harmony export SET_PARTICIPANTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_CALENDAR_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_CALENDAR_TRIP_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_CALENDAR_TRIP_PRICE_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_BOOKABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_BOOKABLE_DATES_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALENDAR_CHANGE_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALENDAR_SET_INITIAL_DURATION; });
/* unused harmony export QUOTATION_FORM_UPDATE */
/* unused harmony export QUOTATION_FORM_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPDATE_TRIP_DATE_CRITERIA; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);

var SYNC_WITH_LOCATION = 'SYNC_WITH_LOCATION';
var SEARCH_SET_KEYWORDS = 'SEARCH_SET_KEYWORDS';
var TRIP_INFORMATION_SET_DEPARTURE_CITY = 'TRIP_INFORMATION_SET_DEPARTURE_CITY';
var TRIP_INFORMATION_SET_DEPARTURE_DATE = 'TRIP_INFORMATION_SET_DEPARTURE_DATE';
var FETCH_USER_PAST_TRIPS = 'FETCH_USER_PAST_TRIPS';
var FETCH_USER_PAST_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_PAST_TRIPS);
var RESET_USER_PAST_TRIPS = 'RESET_USER_PAST_TRIPS';
var FETCH_USER_FUTURE_TRIPS = 'FETCH_USER_FUTURE_TRIPS';
var FETCH_USER_FUTURE_TRIPS_FETCHED = 'FETCH_USER_FUTURE_TRIPS_FETCHED';
var FETCH_USER_FUTURE_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_FUTURE_TRIPS);
var RESET_USER_FUTURE_TRIPS = 'RESET_USER_FUTURE_TRIPS';
var FETCH_USER_SEARCHES = 'FETCH_USER_SEARCHES';
var FETCH_USER_SEARCHES_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_SEARCHES);
var SET_PARTICIPANTS = 'SET_PARTICIPANTS';
var FETCH_CALENDAR = 'FETCH_CALENDAR';
var FETCH_CALENDAR_ABORT = 'FETCH_CALENDAR_ABORT';
var FETCH_CALENDAR_TRIP_PRICE = 'FETCH_CALENDAR_TRIP_PRICE';
var FETCH_CALENDAR_TRIP_PRICE_ABORT = 'FETCH_CALENDAR_TRIP_PRICE_ABORT';
var FETCH_BOOKABLE_DATES = 'FETCH_BOOKABLE_DATES';
var FETCH_BOOKABLE_DATES_ABORT = 'FETCH_BOOKABLE_DATES_ABORT';
var CALENDAR_CHANGE_MONTH = 'CALENDAR_CHANGE_MONTH';
var CLEAR_CALENDAR = 'CLEAR_CALENDAR';
var CALENDAR_SET_INITIAL_DURATION = 'CALENDAR_SET_INITIAL_DURATION';
var QUOTATION_FORM_UPDATE = 'QUOTATION_FORM_UPDATE';
var QUOTATION_FORM_REQUEST = 'QUOTATION_FORM_REQUEST';
var UPDATE_TRIP_DATE_CRITERIA = 'UPDATE_TRIP_DATE_CRITERIA';

/***/ }),

/***/ "d4In":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CapsuleCollapseLists_CapsuleCollapseLists; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx + 1 modules
var CollapsePanel = __webpack_require__("gA51");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.themes.js

var themes = {
  "default": {
    thMessage: 'decorator-border-bottom-list font-bold p-5 text-base',
    thCollapse: 'decorator-border-bottom-list border-gray-light',
    thCollapseTheme: 'limpidSmall',
    thCollapseIconCollapse: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    thCollapseIconExpand: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    thItems: 'reset-list pb-5 text-base',
    thItem: 'flex items-center px-5 py-1',
    thItemIcon: 'flex-shrink-0 rtl:mr-4 text-blue',
    thItemIconWidth: '1.5rem',
    thItemLabel: 'flex-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.jsx
var __jsx = react_default.a.createElement;





var CapsuleCollapseLists_CapsuleCollapseLists = function CapsuleCollapseLists(_ref) {
  var className = _ref.className,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? {} : _ref$header,
      _ref$lists = _ref.lists,
      lists = _ref$lists === void 0 ? [] : _ref$lists,
      message = _ref.message,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!lists || !lists.length) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCollapse = _themes$theme.thCollapse,
      thCollapseIconCollapse = _themes$theme.thCollapseIconCollapse,
      thCollapseIconExpand = _themes$theme.thCollapseIconExpand,
      thCollapseTheme = _themes$theme.thCollapseTheme,
      thItems = _themes$theme.thItems,
      thItem = _themes$theme.thItem,
      thItemIcon = _themes$theme.thItemIcon,
      thItemIconWidth = _themes$theme.thItemIconWidth,
      thItemLabel = _themes$theme.thItemLabel,
      thMessage = _themes$theme.thMessage;
  return __jsx(Capsule["a" /* Capsule */], {
    additionalStyle: {
      root: style
    },
    className: className,
    color: header.color,
    header: "large",
    icon: header.iconName,
    label: header.title
  }, !!message && __jsx("div", {
    className: thMessage
  }, message), lists.map(function (el, index) {
    var _el$items;

    return !!((_el$items = el.items) === null || _el$items === void 0 ? void 0 : _el$items.length) && __jsx(CollapsePanel["a" /* CollapsePanel */], {
      className: thCollapse,
      collapseIconName: thCollapseIconCollapse,
      expandIconName: thCollapseIconExpand,
      isExpanded: index === 0,
      key: el.title,
      theme: thCollapseTheme,
      title: el.title
    }, __jsx("ul", {
      className: thItems
    }, el.items.map(function (_ref2) {
      var iconName = _ref2.iconName,
          label = _ref2.label;
      return __jsx("li", {
        className: thItem,
        key: label
      }, __jsx(Icon["a" /* Icon */], {
        className: thItemIcon,
        name: iconName,
        width: thItemIconWidth
      }), __jsx("span", {
        className: thItemLabel
      }, label));
    })));
  }));
};

/***/ }),

/***/ "d9/u":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "dZwK":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "e/g/":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("RVBP"),
    nativeKeys = __webpack_require__("H4OD");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "e4lk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Address; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



function toLine() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.filter(Boolean).join(' ');
}

function AddressLine(_ref) {
  var children = _ref.children;
  return children ? __jsx("li", {
    className: "leading-normal text-base text-gray-darker"
  }, children) : null;
}

function Address(props) {
  var additionalInformation1 = props.additionalInformation1,
      additionalInformation2 = props.additionalInformation2,
      addOn = props.addOn,
      city = props.city,
      className = props.className,
      country = props.country,
      stateOrDistrict = props.stateOrDistrict,
      streetNumber = props.streetNumber,
      streetName = props.streetName,
      town = props.town,
      zipCode = props.zipCode;
  return __jsx("ul", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'reset-list')
  }, __jsx(AddressLine, null, toLine(streetNumber, streetName)), __jsx(AddressLine, null, toLine(additionalInformation1)), __jsx(AddressLine, null, toLine(additionalInformation2)), __jsx(AddressLine, null, toLine(addOn, city)), __jsx(AddressLine, null, toLine(town, zipCode)), __jsx(AddressLine, null, toLine(stateOrDistrict, country)));
}

/***/ }),

/***/ "eVJY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cruiseProgramResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var cruiseProgramResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* CRUISE_PROGRAM */ "k"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var titlePlaceholder = props.titlePlaceholder,
        subtitlePlaceholder = props.subtitlePlaceholder,
        dateFormat = props.dateFormat,
        dayPlaceholder = props.dayPlaceholder,
        departureTimePlaceholder = props.departureTimePlaceholder,
        arrivalTimePlaceholder = props.arrivalTimePlaceholder;
    var urlParams = location.urlParams;
    var cruiseArgs = "cruiseDepartureDate: \"".concat(urlParams.departureDate, "\" cruiseArrivalDate: \"").concat(urlParams.arrivalDate, "\"");
    var query = "{\n      cruise(".concat(cruiseArgs, ") {\n        stopover {\n          title(message : \"").concat(titlePlaceholder, "\")\n          subtitle(message : \"").concat(subtitlePlaceholder, "\" dateFormat : \"").concat(dateFormat, "\")\n          stops {\n            day(message : \"").concat(dayPlaceholder, "\")\n            title\n            description\n            departureTime(message : \"").concat(departureTimePlaceholder, "\")\n            arrivalTime(message : \"").concat(arrivalTimePlaceholder, "\")\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_CRUISE_PROGRAM */ "Sb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "eaHo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productInstagramResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productInstagramResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* INSTAGRAM_GRID */ "s"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var resortId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var query = "query {\n      socialPictures(".concat(productArgs, ") {\n        imageLarge,\n        imageSmall,\n        userName,\n        canonicalUrl,\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_INSTAGRAM_GRID */ "mc"],
      strictErrors: false
    })["catch"](function () {
      return [];
    });
  }
};

/***/ }),

/***/ "evRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLastVisitedProductIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackLastVisitedProducts; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _local_storage_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1RIK");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("829J");





var _b2cPagesService$PAGE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["b2cPagesService"].PAGE_TYPES,
    RESORT = _b2cPagesService$PAGE.RESORT,
    TOUR = _b2cPagesService$PAGE.TOUR,
    CRUISE = _b2cPagesService$PAGE.CRUISE,
    RESORT_MICE = _b2cPagesService$PAGE.RESORT_MICE;
function getLastVisitedProductIds() {
  var trackingShopping = Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_3__[/* getFromLocalStorage */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_TRACKING */ "u"]);
  return trackingShopping ? trackingShopping[_constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "s"]] : [];
}
function trackLastVisitedProducts(pageContext, productId) {
  if ([RESORT, TOUR, CRUISE, RESORT_MICE].includes(pageContext.pageType) && productId) {
    var seenProductIds = getLastVisitedProductIds().filter(function (seenResortId) {
      return seenResortId !== productId;
    }).slice(0, _constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_LAST_VISITED_PRODUCTS_NUMBER */ "t"] - 1);
    Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_3__[/* setInLocalStorage */ "d"])(_constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_TRACKING */ "u"], Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, _constants__WEBPACK_IMPORTED_MODULE_4__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "s"], [productId].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(seenProductIds))));
  }
}

/***/ }),

/***/ "f4mQ":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "fBdL":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("2K7v"),
    stackClear = __webpack_require__("T26A"),
    stackDelete = __webpack_require__("nkaD"),
    stackGet = __webpack_require__("d9/u"),
    stackHas = __webpack_require__("VGTs"),
    stackSet = __webpack_require__("+Ugr");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "fGxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryEventsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var countryEventsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* COUNTRY_EVENTS */ "e"],
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var countryId = props.countryId,
        isForFamily = props.isForFamily;
    var countryArgs = "countryId:\"".concat(countryId, "\" isForFamily:").concat(isForFamily.toString());
    var query = "query {\n      config {\n        common { close }\n      }\n      countryEvents(".concat(countryArgs, ") {\n        title\n        description\n        media {\n          mediaUrl\n          mediaAlt\n        }\n        startDate\n        endDate\n        associatedProducts {\n          name\n          href\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_COMMON_COUNTRY_EVENTS */ "Ab"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "fflk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureDate; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function setDepartureDate(departureDate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_DATE */ "v"], {
    departureDate: departureDate
  });
}



/***/ }),

/***/ "g3/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productActivitiesResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("H0gB");




var productActivitiesResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_ACTIVITIES */ "I"],
  resolve: function resolve(appContext, props, pageContext, _ref) {
    var urlParams = _ref.urlParams;
    var productId = props.resortId,
        defaultLabel = props.otherSports.label;
    var query = Object(_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__[/* productActivitiesQuery */ "a"])({
      productId: productId,
      defaultLabel: defaultLabel,
      urlParams: urlParams
    });
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_ACTIVITIES */ "ac"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "g73z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productIntroductionResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NLwV");




var productIntroductionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_INTRODUCTION */ "ib"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_3__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      config {\n        common {\n          loadLess\n          viewMore\n        }\n        resort {\n          resortIntroduction {\n            communityLabel\n            toSummerLabel\n            toWinterLabel\n          }\n        }\n      }\n      productCommunity(".concat(productArgs, ") {\n        questions {\n          id\n        }\n      }\n      resort(resortId:\"").concat(productId, "\"){\n        descriptionTitle\n        description\n        destination {\n          country\n        }\n        icon\n        images\n        isDoubleSeason\n        isExclusiveCollection\n        isWinter\n        linkedResort{\n          href\n        }\n        name\n        tripadvisor(resortId:\"").concat(productId, "\") {\n          rating\n          ratingImageUrl\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_INTRODUCTION */ "nc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "gA51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CollapsePanel_CollapsePanel; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/toggler/Toggler.jsx
var Toggler = __webpack_require__("7CPK");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.themes.js

var themes = {
  "default": {
    thRoot: 'fadeIn',
    thHeader: 'border-b-1 flex relative',
    thHeaderDecorator: 'absolute arrow-down arrow-large arrow-white arrow-bg arrow-bg-large arrow-bg-turquoise border-b-2 border-turquoise -mb-px opacity-0 bottom-0 rtl:left-0 w-full sm:w-1/5 sm:rtl:ml-6 transition-opacity z-1',
    thHeaderDecoratorActive: 'opacity-100',
    thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden py-5 text-initial text-gray-darker hover:text-turquoise transition-color',
    thTitle: 'flex-1 flex items-center font-bold font-sans leading-tight max-w-full text-current text-xl',
    thTitleHasEllipsis: true,
    thTitleIconColor: colors["a" /* COLORS */].BLUE,
    thLabels: 'flex-shrink-0 font-bold flex items-center text-base text-blue uppercase whitespace-no-wrap',
    thLabel: 'hidden sm:inline-block',
    thLabelIcon: 'text-gray-darker transition-transform rtl:ml-2',
    thLabelIconActive: 'rotate-180',
    thLabelIconWidth: '0.8125rem',
    thBody: 'overflow-hidden',
    thContent: 'overflow-hidden shadow-inner-bottom shadow-inner-top',
    thContentInner: 'py-10'
  },
  lite: {
    thRoot: 'fadeIn',
    thHeader: 'flex relative',
    thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden pt-4 pb-0 text-initial text-gray-darker hover:text-blue transition-color',
    thTitle: 'flex-1 max-w-full',
    thTitleHasEllipsis: true,
    thLabels: 'flex-shrink-0 flex items-center font-bold rtl:ml-auto text-blue text-base whitespace-no-wrap',
    thLabel: 'underline',
    thLabelIcon: 'rtl:ml-2',
    thLabelIconWidth: '0.625rem',
    thContent: ' arrow-up arrow-large arrow-bg arrow-white arrow-bg-gray-light border-1 p-5 mt-5 shadow-md'
  },
  liteFlexible: {
    thRoot: 'fadeIn',
    thHeader: 'flex relative',
    thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden pt-4 pb-0 text-initial text-gray-darker hover:text-blue transition-color',
    thTitle: 'flex-1 max-w-full',
    thTitleHasEllipsis: true,
    thLabels: 'w-full border-t-1 py-4 flex items-center justify-center text-base text-gray-600',
    thLabel: 'underline',
    thLabelIcon: 'rtl:ml-2',
    thLabelIconWidth: '0.625rem',
    thContent: 'flex',
    thContentInner: 'w-full'
  },
  limpid: {
    thRoot: 'fadeIn',
    thHeader: 'flex relative',
    thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden text-initial text-gray-darker',
    thTitle: 'flex-1 max-w-full',
    thTitleHasEllipsis: true,
    thLabels: 'flex-shrink-0 font-bold flex items-center rtl:ml-auto text-base text-blue uppercase whitespace-no-wrap',
    thLabel: 'underline',
    thLabelIcon: 'text-gray-darker rtl:ml-2',
    thLabelIconWidth: '0.625rem',
    thBody: 'overflow-hidden',
    thContent: 'overflow-hidden'
  },
  limpidSmall: {
    thRoot: 'fadeIn',
    thHeader: 'flex relative text-base',
    thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden p-5 text-initial text-gray-darker',
    thTitle: 'flex-1 font-bold max-w-full',
    thTitleHasEllipsis: false,
    thLabels: 'flex-shrink-0 font-bold flex items-center rtl:ml-auto text-blue uppercase whitespace-no-wrap',
    thLabel: 'underline',
    thLabelIcon: 'text-gray-darker rtl:ml-2',
    thLabelIconActive: 'rotate-180',
    thLabelIconWidth: '0.625rem',
    thBody: 'overflow-hidden',
    thContent: 'overflow-hidden'
  },
  remote: {
    thRoot: 'fadeIn border-b-1',
    thHeader: 'py-5 flex relative',
    thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden text-initial text-gray-darker',
    thTitle: 'flex-1 flex items-center max-w-full',
    thTitleIcon: 'rtl:mr-4',
    thTitleIconColor: colors["a" /* COLORS */].BLUE,
    thTitleIconSize: '1.375rem',
    thLabels: 'flex-shrink-0 font-bold flex items-center rtl:ml-auto text-base text-blue whitespace-no-wrap',
    thLabelIcon: 'text-gray-darker rtl:ml-2',
    thLabelIconActive: 'rotate-180',
    thLabelIconWidth: '0.625rem',
    thBody: 'overflow-hidden',
    thContent: 'overflow-hidden',
    thInner: 'w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx



var __jsx = react_default.a.createElement;









var POSITIONS = {
  BOTTOM: 'bottom',
  TOP: 'top'
};

var hasLabels = function hasLabels(_ref, isActive) {
  var collapseIconName = _ref.collapseIconName,
      collapseLabel = _ref.collapseLabel,
      expandIconName = _ref.expandIconName,
      expandLabel = _ref.expandLabel;
  return isActive ? collapseIconName || collapseLabel : expandIconName || expandLabel;
};

var CollapsePanel_LoadMoreButton = function LoadMoreButton(_ref2) {
  var ariaId = _ref2.ariaId,
      isActive = _ref2.isActive,
      toggle = _ref2.toggle,
      collapsePanelProps = Object(objectWithoutProperties["a" /* default */])(_ref2, ["ariaId", "isActive", "toggle"]);

  var _collapsePanelProps$a = collapsePanelProps.as,
      HeaderTag = _collapsePanelProps$a === void 0 ? 'div' : _collapsePanelProps$a,
      collapseLabel = collapsePanelProps.collapseLabel,
      _collapsePanelProps$c = collapsePanelProps.collapseIconName,
      collapseIconName = _collapsePanelProps$c === void 0 ? icons["a" /* ICONS */].CROSS : _collapsePanelProps$c,
      expandLabel = collapsePanelProps.expandLabel,
      _collapsePanelProps$e = collapsePanelProps.expandIconName,
      expandIconName = _collapsePanelProps$e === void 0 ? icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN : _collapsePanelProps$e,
      iconName = collapsePanelProps.iconName,
      isExpanded = collapsePanelProps.isExpanded,
      _collapsePanelProps$t = collapsePanelProps.theme,
      theme = _collapsePanelProps$t === void 0 ? 'default' : _collapsePanelProps$t,
      title = collapsePanelProps.title,
      trackingData = collapsePanelProps.trackingData;
  var _themes$theme = themes[theme],
      thButton = _themes$theme.thButton,
      thHeader = _themes$theme.thHeader,
      thHeaderDecorator = _themes$theme.thHeaderDecorator,
      thHeaderDecoratorActive = _themes$theme.thHeaderDecoratorActive,
      thLabels = _themes$theme.thLabels,
      thLabel = _themes$theme.thLabel,
      thLabelIcon = _themes$theme.thLabelIcon,
      thLabelIconActive = _themes$theme.thLabelIconActive,
      thLabelIconWidth = _themes$theme.thLabelIconWidth,
      thTitle = _themes$theme.thTitle,
      thTitleHasEllipsis = _themes$theme.thTitleHasEllipsis,
      thTitleIcon = _themes$theme.thTitleIcon,
      thTitleIconColor = _themes$theme.thTitleIconColor,
      thTitleIconSize = _themes$theme.thTitleIconSize;
  return __jsx(HeaderTag, {
    className: classnames_default()('reset-heading', thHeader)
  }, __jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    "aria-controls": ariaId,
    "aria-expanded": isActive,
    className: thButton,
    onClick: toggle,
    type: "button",
    trackingData: isExpanded ? null : trackingData
  }, !!title && __jsx("div", {
    className: thTitle
  }, __jsx(Icon["a" /* Icon */], {
    className: classnames_default()('rtl:mr-2 flex-shrink-0', thTitleIcon),
    color: thTitleIconColor,
    name: iconName,
    width: thTitleIconSize || '1em'
  }), thTitleHasEllipsis ? __jsx("span", {
    className: "truncate w-full"
  }, title) : title), hasLabels(collapsePanelProps, isActive) && __jsx("div", {
    className: thLabels
  }, __jsx("span", {
    className: thLabel,
    "data-testid": "CollapsePanel-label"
  }, isActive ? collapseLabel : expandLabel), __jsx(Icon["a" /* Icon */], {
    className: classnames_default()(thLabelIcon, Object(defineProperty["a" /* default */])({}, thLabelIconActive, isActive)),
    name: isActive ? collapseIconName : expandIconName,
    width: thLabelIconWidth
  }))), (thHeaderDecorator || thHeaderDecoratorActive) && __jsx("div", {
    className: classnames_default()(thHeaderDecorator, Object(defineProperty["a" /* default */])({}, thHeaderDecoratorActive, isActive))
  }));
};

var CollapsePanel_CollapsePanel = function CollapsePanel(props) {
  var _useState = Object(react["useState"])(props.isExpanded),
      isVisible = _useState[0],
      setVisible = _useState[1];

  if (!react["Children"].count(props.children)) {
    return null;
  }

  var children = props.children,
      className = props.className,
      _props$hasKeepCollaps = props.hasKeepCollapsedContent,
      hasKeepCollapsedContent = _props$hasKeepCollaps === void 0 ? true : _props$hasKeepCollaps,
      id = props.id,
      isExpanded = props.isExpanded,
      _props$loadMoreButton = props.loadMoreButtonPosition,
      loadMoreButtonPosition = _props$loadMoreButton === void 0 ? POSITIONS.TOP : _props$loadMoreButton,
      onClick = props.onClick,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title;
  var _themes$theme2 = themes[theme],
      thBody = _themes$theme2.thBody,
      thContent = _themes$theme2.thContent,
      thContentInner = _themes$theme2.thContentInner,
      thRoot = _themes$theme2.thRoot;
  var ariaId = Object(uniqueId["b" /* generateUniqueId */])([id || title || ''], 'CollapsePanel_');
  var CollapsedTag = hasKeepCollapsedContent ? lib["Collapse"] : lib["UnmountClosed"];
  return __jsx(Toggler["a" /* Toggler */], {
    isActive: isExpanded,
    onToggle: onClick
  }, function (toggle, isActive) {
    return __jsx("section", {
      className: classnames_default()(className, thRoot),
      id: id
    }, loadMoreButtonPosition === POSITIONS.TOP && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      toggle: toggle
    })), __jsx("div", {
      "aria-hidden": !isActive,
      className: classnames_default()(thBody, {
        invisible: !isVisible
      }),
      id: ariaId
    }, __jsx(CollapsedTag, {
      isOpened: isActive,
      onWork: function onWork() {
        setVisible(true);
      },
      onRest: function onRest(_ref3) {
        var isFullyClosed = _ref3.isFullyClosed;
        setVisible(!isFullyClosed);
      }
    }, __jsx("div", {
      className: thContent
    }, __jsx("div", {
      className: thContentInner
    }, children)))), loadMoreButtonPosition === POSITIONS.BOTTOM && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      toggle: toggle
    })));
  });
};

/***/ }),

/***/ "gvfs":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("sWQB"),
    isLength = __webpack_require__("XSvm");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "gyFy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("Phb7");


/***/ }),

/***/ "h9IM":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if ( true && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else {}
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),

/***/ "hIZU":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "hPQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACET_QUERY_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return navigateToSearchPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return navigateToResortPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentUrlContainsSearchQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return currentUrlHasNoQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFacetsAsString; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("U2CP");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("k9PE");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("nv//");








var FACET_QUERY_PARAMS = [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]];

var computeQueryParamsForUrl = function computeQueryParamsForUrl(args) {
  var _ref;

  var criteriaKeysToPersist = args.criteriaKeysToPersist,
      searchCriteria = args.searchCriteria;
  var formattedDate = searchCriteria.departureDate && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* getDepartureDateDisplayValue */ "d"])(Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* formatDepartureDateForStore */ "a"])(searchCriteria.departureDate, ''));
  var searchQuery = searchCriteria.query ? searchCriteria.query.label : '';
  return _ref = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"]) && formattedDate || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"]) && searchCriteria.duration || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]) && searchCriteria.departureCity || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"], criteriaKeysToPersist.includes(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"]) && (searchCriteria.keywords || searchQuery) || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_KIDS */ "h"]) && searchCriteria.kids.length > 0 && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* serializeKidsToQueryParam */ "h"])({
    kids: searchCriteria.kids,
    kidsValidationState: searchCriteria.kidsValidationState
  }) || undefined), _ref;
};

var navigateToSearchPage = function navigateToSearchPage(args) {
  var criteriaKeysToPersist = args.criteriaKeysToPersist,
      location = args.location,
      searchCriteria = args.searchCriteria,
      searchPageRouteName = args.searchPageRouteName;
  var queryParams = computeQueryParamsForUrl({
    criteriaKeysToPersist: criteriaKeysToPersist,
    searchCriteria: searchCriteria
  }); // NOTE: URI.setQuery() does not remove existing queries

  var searchPageUrl = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__[/* convertLocationToURI */ "c"])(location).setQuery(queryParams);
  var previousPathname = searchPageUrl.pathname();
  var pathname = searchPageRouteName ? _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_2__[/* urlPattern */ "b"](searchPageRouteName) : null;

  if (pathname) {
    searchPageUrl.pathname(pathname);
  }

  var isShallow = searchPageUrl.pathname() === previousPathname;
  _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].redirectTo()(searchPageUrl, {
    shallow: isShallow
  });
};
var navigateToResortPage = function navigateToResortPage(args) {
  var location = args.location,
      query = args.query,
      searchCriteria = args.searchCriteria;
  var queryParams = computeQueryParamsForUrl({
    criteriaKeysToPersist: [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DEPARTURE_DATE */ "f"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_DURATION */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_5__[/* QUERY_TRANSPORT */ "k"]],
    searchCriteria: searchCriteria
  });
  var resortPageUrl = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_7__[/* convertLocationToURI */ "c"])(location).pathname(query.link).setQuery(queryParams);
  _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].redirectTo()(resortPageUrl);
};
var currentUrlContainsSearchQueryParam = function currentUrlContainsSearchQueryParam(location) {
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(location.queryParams[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* QUERY_QUERY_PARAM */ "A"]]);
};
var currentUrlHasNoQueryParams = function currentUrlHasNoQueryParams(location) {
  return FACET_QUERY_PARAMS.every(function (queryKey) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(location.queryParams[queryKey]);
  });
};
var getFacetsAsString = function getFacetsAsString(filters, facetCategoryId) {
  var facetsInCategory = filters.filter(function (filter) {
    return filter.id === facetCategoryId;
  });

  if (facetsInCategory.length === 0) {
    return null;
  }

  return facetsInCategory.map(function (filter) {
    return filter.name;
  }).join('|');
};

/***/ }),

/***/ "hUtE":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("j++8");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "hfZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABTestContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ABTestContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "hgS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductHeader; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("VHif");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("i5Mr");
/* harmony import */ var _exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Itgl");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("MWZw");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;







var ICONS_HEIGHT = 32;
var ProductHeader = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_1__["memo"])(function ProductHeader(_ref) {
  var badge = _ref.badge,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLUE : _ref$badgeColor,
      _ref$badgeIcon = _ref.badgeIcon,
      badgeIcon = _ref$badgeIcon === void 0 ? {} : _ref$badgeIcon,
      className = _ref.className,
      hasECLogo = _ref.hasECLogo,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? {} : _ref$heading,
      isLinkDisabled = _ref.isLinkDisabled,
      link = _ref.link,
      onClick = _ref.onClick;
  var _heading$title = heading.title,
      title = _heading$title === void 0 ? '' : _heading$title,
      _heading$subtitle = heading.subtitle,
      subtitle = _heading$subtitle === void 0 ? '' : _heading$subtitle;
  var TagName = isLinkDisabled ? 'div' : _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"];
  return __jsx("header", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'flex'),
    onClick: onClick,
    "data-testid": "Product-Header"
  }, __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: "reset-anchor flex flex-1 z-1 min-w-0",
    "data-testid": "ProductHeader-link"
  }, isLinkDisabled ? null : link), !isLinkDisabled && __jsx("div", {
    className: "absolute inset-0",
    "data-testid": "ProductHeader-link-overlay"
  }), __jsx("div", {
    className: "relative flex-1 flex flex-col-reverse justify-center -mb-px overflow-hidden rtl:pr-1"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__[/* Title */ "a"], {
    className: "flex items-center font-brand leading-one text-lg",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].GRAY_DARKER,
    hasEllipsis: true,
    hLevel: 2,
    role: "presentation",
    theme: "none"
  }, title), __jsx("div", {
    className: "flex"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__[/* Title */ "a"], {
    className: "flex min-w-0 items-center font-bold font-sans text-sm uppercase tracking-tight",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].GRAY_MEDIUM,
    hasEllipsis: true,
    hLevel: 3,
    role: "presentation",
    theme: "none"
  }, subtitle), !!badge && __jsx("div", {
    "data-testid": "ProductHeader-seasonBadge",
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("bg-".concat(badgeColor), 'leading-one p-1 font-bold uppercase rounded-tiny text-center text-white text-xs whitespace-no-wrap rtl:ml-2')
  }, __jsx("div", {
    className: "-mb-px"
  }, badge))))), __jsx("div", {
    className: "flex -mx-1"
  }, __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__[/* Badge */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, badgeIcon, {
    className: "mx-1 rounded-tiny",
    size: ICONS_HEIGHT
  })), hasECLogo && (badgeIcon === null || badgeIcon === void 0 ? void 0 : badgeIcon.iconName) && __jsx("span", {
    className: "font-brand leading-none text-sm self-center"
  }, "&"), hasECLogo && __jsx(_exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_6__[/* ECBadge */ "a"], {
    className: "flex-none mx-1",
    height: ICONS_HEIGHT,
    iconWidth: "95%"
  })));
});

/***/ }),

/***/ "hqKg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ "i0/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productWellnessResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("H0gB");




var productWellnessResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_WELLNESS */ "X"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var query = Object(_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__[/* productWellnessQuery */ "f"])(productId, {
      urlParams: urlParams
    });
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_WELLNESS */ "Fc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "id+h":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "igjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStrictlyProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isStrictlyStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStrictlyIntegrationEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isStrictlyTestEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStrictlyDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLocale; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);



function getCurrentUri(req) {
  return new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}
function isProduction() {
  return _config__WEBPACK_IMPORTED_MODULE_2___default.a.get('DEPLOYMENT_ENV') === 'production';
}
function isStrictlyProductionEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod');
}
function isStrictlyStagingEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}
function isStrictlyIntegrationEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}
function isStrictlyTestEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'test';
}
function isStrictlyDevelopmentEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}
function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }

  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default.a.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}

/***/ }),

/***/ "ih3X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return offerDescriptionResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var offerDescriptionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* OFFER_DESCRIPTION */ "C"],
  resolve: function resolve(appContext, props) {
    var offerId = props.offerId;
    var query = "{\n      offer(offerId: \"".concat(offerId, "\") {color timingArgument description}\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_OFFER_DESCRIPTION */ "Tb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "iiKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CheckedList; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/checked-list/CheckedList.themes.js

var themes = {
  "default": {
    thTitle: 'mb-5',
    thList: 'reset-list sm:colum-count-2 -m-1',
    thListItem: 'flex p-1',
    thIcon: 'bg-emerald flex-shrink-0 p-1 rounded-full rtl:mr-2',
    thIconColor: colors["a" /* COLORS */].WHITE,
    thIconWidth: '1em'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/checked-list/CheckedList.jsx
var __jsx = react_default.a.createElement;






function CheckedList(props) {
  var children = props.children,
      className = props.className,
      itemClassName = props.itemClassName,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title;
  if (!react["Children"].count(children)) return null;
  var _themes$theme = themes[theme],
      thTitle = _themes$theme.thTitle,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thIcon = _themes$theme.thIcon,
      thIconColor = _themes$theme.thIconColor,
      thIconWidth = _themes$theme.thIconWidth;
  return __jsx(react["Fragment"], null, title && __jsx(Title["a" /* Title */], {
    className: thTitle,
    theme: "title-sans-3"
  }, title), __jsx("ul", {
    className: classnames_default()(className, thList)
  }, react["Children"].map(children, function (child, idx) {
    return __jsx("li", {
      className: classnames_default()(itemClassName, thListItem),
      key: idx
    }, __jsx(Icon["a" /* Icon */], {
      color: thIconColor,
      className: thIcon,
      name: icons["a" /* ICONS */].CHECK,
      width: thIconWidth
    }), child);
  })));
}

/***/ }),

/***/ "imxd":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "j++8":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("aZXx");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "jD8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TextLink; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.themes.js

var themes = {
  "default": function _default(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color;
    return {
      thIconWidth: '.7em',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-base focus:underline hover:underline"),
      thLabel: '',
      thIconLeft: 'rtl:mr-2',
      thIconRight: 'rtl:ml-2'
    };
  },
  fancy: function fancy(_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color;
    return {
      thIconWidth: '0.4375rem',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-sm"),
      thLabel: '',
      thIconLeft: 'rtl:mr-2',
      thIconRight: 'rtl:ml-2'
    };
  },
  solid: function solid(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref3$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " bg-current font-bold font-sans leading-one p-3 rounded-tiny text-base uppercase"),
      thLabel: 'text-white',
      thIconLeft: 'text-white rtl:mr-2',
      thIconRight: 'text-white rtl:ml-2'
    };
  },
  simple: function simple(_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref4$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " font-sans leading-loose self-start rtl:ml-auto text-base underline"),
      thLabel: '',
      thIconLeft: 'rtl:mr-2',
      thIconRight: 'rtl:ml-2'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx

var __jsx = react_default.a.createElement;







function TextLink(props) {
  var ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      className = props.className,
      color = props.color,
      iconLeftName = props.iconLeftName,
      _props$iconRightName = props.iconRightName,
      iconRightName = _props$iconRightName === void 0 ? icons["a" /* ICONS */].BOLDER_ARROW_FORTH : _props$iconRightName,
      isExternalLink = props.isExternalLink,
      label = props.label,
      onClick = props.onClick,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      target = props.target,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      trackingData = props.trackingData,
      url = props.url;
  if (!label) return null;

  var _themes$theme = themes[theme]({
    color: color
  }),
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  return __jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    as: url ? DynamicLink["a" /* default */] : 'button',
    className: classnames_default()(className, 'reset-button inline-flex items-center', thRoot),
    onClick: onClick,
    tabIndex: tabIndex,
    target: target,
    trackingData: trackingData
  }, url ? {
    url: url,
    isExternalLink: isExternalLink
  } : {
    type: 'button'
  }), !!iconLeftName && __jsx(Icon["a" /* Icon */], {
    className: thIconLeft,
    hasRtl: true,
    name: iconLeftName,
    width: thIconWidth
  }), __jsx("span", {
    className: thLabel
  }, label), !!iconRightName && __jsx(Icon["a" /* Icon */], {
    className: thIconRight,
    hasRtl: true,
    name: iconRightName,
    width: thIconWidth
  }));
}

/***/ }),

/***/ "jP+d":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("5R7x");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "jVcT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productStrengthsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var productStrengthsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_STRENGTHS */ "V"],
  resolve: function resolve(appContext, _ref) {
    var resortId = _ref.resortId;
    var query = "query {\n      config {\n        common {\n          loadLess\n          loadMore\n        }\n      }\n      resort(resortId:\"".concat(resortId, "\"){\n        comfort\n        isExclusiveCollection\n        isJoyview\n        type\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_STRENGTHS */ "Cc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "jbji":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("w5oF"),
    defineProperty = __webpack_require__("2rns"),
    identity = __webpack_require__("00cE");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "jldR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Capsule; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/capsule/Capsule.styles.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var style = {
  capsule: {
    width: '100%',
    position: 'relative'
  },
  upsideCapsule: {
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  header: {
    borderRadius: '5px 5px 0 0',
    backgroundColor: '#0480a9',
    height: '4px',
    position: 'static',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1
  },
  upsideHeader: {
    borderRadius: '0 0 5px 5px'
  },
  headerLarge: {
    backgroundColor: '#005589',
    height: '48px',
    position: 'relative'
  },
  headerAuto: {
    backgroundColor: '#005589',
    position: 'relative',
    padding: '10px',
    height: 'auto'
  },
  content: {
    position: 'relative',
    borderRadius: '0 0 5px 5px',
    backgroundColor: '#fff',
    overflow: 'hidden',
    boxShadow: '0 10px 20px 0 rgba(0,0,0,0.05)',
    border: 'solid 1px #d4d1d1'
  },
  upsideContent: {
    marginTop: '-1px',
    borderRadius: '5px 5px 0 0'
  },
  contentNoHeader: {
    marginTop: '-1px',
    borderRadius: '5px'
  },
  contentLargeHeader: {
    paddingTop: '34px',
    marginTop: '-35px'
  },
  upsideContentLargeHeader: {
    paddingTop: '0',
    marginTop: '0',
    paddingBottom: '34px',
    marginBottom: '-35px'
  },
  label: {
    fontFamily: 'Trident, HappinessBeta, HappinessBeta-New, HappinessBeta wf, Verdana, Arial, sans-serif',
    verticalAlign: '-3px'
  },
  checkIcon: {
    position: 'absolute',
    display: 'flex',
    top: '-12px',
    right: '-9px',
    left: '-9px',
    justifyContent: 'flex-end'
  }
};
var styles = function styles(_ref) {
  var _ref$additionalStyle = _ref.additionalStyle,
      additionalStyle = _ref$additionalStyle === void 0 ? {
    header: {},
    content: {},
    icon: {},
    label: {}
  } : _ref$additionalStyle,
      color = _ref.color,
      isHeaderNone = _ref.isHeaderNone,
      isLargeHeader = _ref.isLargeHeader,
      isHeaderAuto = _ref.isHeaderAuto,
      upside = _ref.upside;
  return {
    computedCapsuleStyle: _objectSpread(_objectSpread(_objectSpread({}, style.capsule), upside ? style.upsideCapsule : null), additionalStyle.root),
    computedHeaderStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.header), isLargeHeader ? style.headerLarge : null), isHeaderAuto ? style.headerAuto : null), upside ? style.upsideHeader : null), color ? {
      backgroundColor: color
    } : null), additionalStyle.header),
    computedContentStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.content), upside ? style.upsideContent : null), isLargeHeader ? style.contentLargeHeader : null), isLargeHeader && upside ? style.upsideContentLargeHeader : null), isHeaderNone ? style.contentNoHeader : null), additionalStyle.content),
    computedIconWrapperStyle: _objectSpread({}, additionalStyle.icon),
    computedLabelStyle: _objectSpread(_objectSpread({}, style.label), additionalStyle.label),
    computedCheckIconStyle: _objectSpread({}, style.checkIcon)
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx
var __jsx = react_default.a.createElement;






var SMALL = 'small';
var LARGE = 'large';
var AUTO = 'auto';
var NONE = 'none';
function Capsule(props) {
  var additionalStyle = props.additionalStyle,
      children = props.children,
      className = props.className,
      color = props.color,
      _props$header = props.header,
      header = _props$header === void 0 ? SMALL : _props$header,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? icons["a" /* ICONS */].ALL_INCLUSIVE : _props$icon,
      label = props.label,
      upside = props.upside,
      validated = props.validated;
  var isLargeHeader = header === LARGE;
  var isHeaderNone = header === NONE;
  var isHeaderAuto = header === AUTO;

  var _styles = styles({
    additionalStyle: additionalStyle,
    color: color,
    isHeaderNone: isHeaderNone,
    isLargeHeader: isLargeHeader,
    isHeaderAuto: isHeaderAuto,
    upside: upside
  }),
      computedCapsuleStyle = _styles.computedCapsuleStyle,
      computedCheckIconStyle = _styles.computedCheckIconStyle,
      computedContentStyle = _styles.computedContentStyle,
      computedHeaderStyle = _styles.computedHeaderStyle,
      computedIconWrapperStyle = _styles.computedIconWrapperStyle,
      computedLabelStyle = _styles.computedLabelStyle;

  if (!react["Children"].count(children)) {
    return null;
  }

  return __jsx("section", {
    className: classnames_default()(className, 'Capsule'),
    style: computedCapsuleStyle
  }, header !== 'none' && __jsx("div", {
    style: computedHeaderStyle
  }, (isLargeHeader || isHeaderAuto) && __jsx(react["Fragment"], null, __jsx("div", {
    style: computedIconWrapperStyle
  }, __jsx(Icon["a" /* Icon */], {
    name: icon,
    width: computedIconWrapperStyle.width || '1.25rem'
  })), __jsx("span", null, "\xA0"), __jsx("span", {
    style: computedLabelStyle
  }, label))), __jsx("div", {
    style: computedContentStyle
  }, validated && __jsx("div", {
    style: {
      position: 'relative'
    }
  }, __jsx("div", {
    style: computedCheckIconStyle
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].SUCCESS,
    name: icons["a" /* ICONS */].SMALL_CIRCLE_CHECK,
    width: "3rem"
  }))), children));
}

/***/ }),

/***/ "jw1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPriceFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanupArgs; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);


var generateCmsArgs = function generateCmsArgs(content, release) {
  return "content : \"".concat(content, "\" release : \"").concat(release, "\"");
};

var getPriceArgs = function getPriceArgs(args) {
  return ['offerId', 'offerName', 'date', 'dateStart', 'dateEnd', 'duration', 'departureCity', 'forceWithoutTransport', 'optimizedPriceCalls'].filter(function (key) {
    return args[key];
  }).map(function (key) {
    var value = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isString"])(args[key]) ? "\"".concat(args[key], "\"") : args[key];
    return [key, value];
  });
};

var buildPriceGraphqlArgs = function buildPriceGraphqlArgs(args) {
  return args.length ? "(".concat(args.map(function (priceArg) {
    return priceArg.join(' : ');
  }).join(' '), ")") : '';
};

function getPriceFields(args) {
  var content = args.content,
      release = args.release;
  var cmsArgs = generateCmsArgs(content, release);
  var priceArgs = buildPriceGraphqlArgs(getPriceArgs(args));
  return "\n    price ".concat(priceArgs, " {\n      bestPrice {\n        value\n        formattedValue\n      }\n      initialPrice {\n        value\n        formattedValue\n      }\n      unit(").concat(cmsArgs, ")\n      currency\n      termsAndConditions {\n        departureDate\n        duration\n        durationFormatted(").concat(cmsArgs, ")\n        numberOfAdults\n        departureCity {\n          value\n          name\n        }\n        accommodationComfortLabel\n      }\n    }");
}

function getThumbnailBaseFields(args) {
  var offerName = args.offerName,
      tourDurationPlaceholder = args.tourDurationPlaceholder,
      cruiseTimingPlaceholder = args.cruiseTimingPlaceholder,
      cruiseDurationPlaceholder = args.cruiseDurationPlaceholder,
      dateFormat = args.dateFormat,
      content = args.content,
      release = args.release; // use typeof string since we cannot be sure that there are no empty strings on the CMS

  var durationArgs = typeof tourDurationPlaceholder === 'string' && typeof cruiseDurationPlaceholder === 'string' ? "(message : \"".concat(tourDurationPlaceholder, "\", cruiseMessage : \"").concat(cruiseDurationPlaceholder, "\")") : '';
  var timingDescriptionArgs = typeof cruiseTimingPlaceholder === 'string' && typeof dateFormat === 'string' ? "(message : \"".concat(cruiseTimingPlaceholder, "\" dateFormat : \"").concat(dateFormat, "\")") : '';
  return "\n    badgeIcon\n    childcareDetails {\n      id\n      included\n    }\n    color\n    comfort\n    comfortLabel\n    destination {\n      area\n      country\n    }\n    duration".concat(durationArgs, "\n    href(offerName : \"").concat(offerName, "\")\n    id\n    images\n    isCruise\n    isDoubleSeason\n    isExclusiveCollection\n    isExplicitEC\n    isJoyview\n    isResort\n    isSummer\n    isTour\n    isVilla\n    isWinter\n    minAuthorizedAge {\n      value\n    }\n    name\n    openingStatus\n    rangeId\n    rangeLabel\n    resortId\n    seasonName\n    seasonTrad(").concat(generateCmsArgs(content, release), ")\n    thematics {\n      label\n    }\n    timingDescription").concat(timingDescriptionArgs, "\n    title\n    type");
}

function cleanupArgs(args) {
  return {
    content: args.content || '',
    release: args.release || '',
    cruiseTimingPlaceholder: args.cruiseTimingPlaceholder,
    cruiseDurationPlaceholder: args.cruiseDurationPlaceholder,
    date: args.date || '',
    dateFormat: args.dateFormat,
    departureCity: args.departureCity || '',
    duration: args.duration || null,
    dateStart: args.dateStart || '',
    dateEnd: args.dateEnd || '',
    forceWithoutTransport: !!args.forceWithoutTransport,
    offerId: args.offerId || '',
    offerName: args.offerName || '',
    optimizedPriceCalls: args.optimizedPriceCalls || false,
    tourDurationPlaceholder: args.tourDurationPlaceholder
  };
}

function makeResortThumbnailQuery(args, options) {
  var _ref = options || {},
      _ref$withoutPrice = _ref.withoutPrice,
      withoutPrice = _ref$withoutPrice === void 0 ? false : _ref$withoutPrice;

  var priceFields = !withoutPrice ? getPriceFields(cleanupArgs(args)) : '';
  return "".concat(getThumbnailBaseFields(cleanupArgs(args))).concat(priceFields);
}

/* harmony default export */ __webpack_exports__["b"] = (makeResortThumbnailQuery);

/***/ }),

/***/ "k9PE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("qm5D");
/* harmony import */ var _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Mkub");



 // TODO This was a curried function. It should be just redirectTo(uri: string): void

function redirectTo(currentUrl) {
  return function (uri, options) {
    if (true) {
      var dynamicLinkHelper = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](currentUrl || window.location.href, uri);

      if (dynamicLinkHelper.isExternalUrl()) {
        _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].setLocation(uri);
      } else {
        var objectUri = new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(uri); // next/router is not happy if you only pass him the query parameters. So get the pathname
        // when not provided

        if (objectUri.pathname() === '') {
          objectUri.pathname(window.location.pathname);
        }

        var currentUri = new urijs__WEBPACK_IMPORTED_MODULE_1___default.a(window.location.href);

        if (currentUri.resource() !== objectUri.resource()) {
          // URI().resource() prevent domain name to be passed to the history
          // http://domain/foo -> /foo
          // /foo -> /foo
          if (options && options.shallow) {
            _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].shallowPushRoute(objectUri.resource());
          } else if (options === null || options === void 0 ? void 0 : options.replace) {
            _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].replaceRoute(objectUri.resource());
          } else {
            _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_0__["Router"].pushRoute(objectUri.resource(), undefined, options);
          }
        }
      }
    }
  };
}

function redirectToUri() {
  return function (uri) {
    return function () {
      var redirectUri = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"](_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["windowWrapper"].getLocation(), uri).toString();
      redirectTo()(redirectUri);
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  redirectTo: redirectTo,
  redirectToUri: redirectToUri
});

/***/ }),

/***/ "kE5G":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("CP21");

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ "kHWL":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("rnJz"),
    isLength = __webpack_require__("XSvm"),
    isObjectLike = __webpack_require__("oS78");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "kNiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return serializeKidsToQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getKidAgeInMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDepartureDateDisplayValue; });
/* unused harmony export findFacetCategoryById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDepartureDateForStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getChildcareFacets; });
/* unused harmony export getChildren */
/* unused harmony export getFormattedDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCities; });
/* unused harmony export getSelectedDepartureCity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isDateInThePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isKidMinor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return unserializeKidsFromQueryParam; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wQ38");
/* harmony import */ var _uri_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Sj1w");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sW3P");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







function findFacetCategoryById(facets, facetCategoryId) {
  return facets.find(function (facetCategory) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(facetCategory, 'id') === facetCategoryId;
  });
}

function _getFacetValues(facets, categoryId) {
  var category = findFacetCategoryById(facets, categoryId);
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(category, 'list', []);
}

function getChildcareFacets(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_5__[/* CHILDCARE_FACET_ID */ "e"]);
}

function getDepartureCities(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "j"]);
}

function getSelectedDepartureCity(facets) {
  var selectedCity = getDepartureCities(facets).find(function (facet) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(facet, 'selected');
  });
  return selectedCity ? Object(lodash__WEBPACK_IMPORTED_MODULE_1__["get"])(selectedCity, 'name') : null;
}

function formatDepartureDateForStore(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_5__[/* DATE_FORMAT */ "g"];
  return date !== null ? moment__WEBPACK_IMPORTED_MODULE_2___default()(date, format).valueOf() : null;
}

function getDepartureDateDisplayValue() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(date);
  return momentDate.isValid() ? momentDate.format(_constants__WEBPACK_IMPORTED_MODULE_5__[/* DATE_FORMAT */ "g"]) : '';
}

function isDateInThePast(timestampDate) {
  return timestampDate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(timestampDate).isBefore() : false;
}

function getFormattedDepartureDate(date, dateFormat) {
  return date ? moment__WEBPACK_IMPORTED_MODULE_2___default()(date).format(dateFormat) : '';
}

function isKidMinor(birthdate) {
  if (!birthdate) {
    return false;
  }

  var minBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()().subtract(18, 'years');
  var momentBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate);
  return momentBirthdate.isValid() && momentBirthdate.isBetween(minBirthdate, moment__WEBPACK_IMPORTED_MODULE_2___default()());
}

function getChildren(numberOfChildren, childrenBirthdates) {
  if (Number.isInteger(numberOfChildren) && numberOfChildren >= 0 && numberOfChildren <= _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "u"]) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["times"])(numberOfChildren, function (idx) {
      return childrenBirthdates && childrenBirthdates.length > idx ? {
        birthdate: moment__WEBPACK_IMPORTED_MODULE_2___default()(childrenBirthdates[idx], 'YYYYMMDD', true).valueOf(),
        childcareIncluded: false
      } : {
        childcareIncluded: false
      };
    });
  }

  return null;
}

function unserializeKidsFromQueryParam(value) {
  if (!value) return [];
  var kidsNumber = Number(value); // NOTE: DO NOT USE parseInt() !!! parseInt('2010-12-10c') will return 2010 ...

  if (kidsNumber > _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "u"]) {
    return [];
  }

  if (Number.isInteger(kidsNumber)) return new Array(kidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"]));
  var kids = value.split(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_KIDS_DELIMITER */ "i"]).map(function (serializedKidString) {
    var hasChildcareFlag = serializedKidString.substr(-1) === _uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"];
    var strBirthdate = serializedKidString.replace(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"], '');
    var birthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(strBirthdate, _uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DATE_FORMAT */ "e"], true);
    var childcareIncluded = birthdate.isValid() ? hasChildcareFlag : _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"].childcareIncluded;
    return _objectSpread(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* DEFAULT_KID_VALUE */ "a"]), {}, {
      childcareIncluded: childcareIncluded,
      birthdate: birthdate.isValid() ? birthdate.valueOf() : undefined
    });
  });
  return kids.length > _constants__WEBPACK_IMPORTED_MODULE_5__[/* KIDS_NUMBER_MAX */ "u"] ? [] : kids;
}
/**
 * Helper to serialize kids array as a URI query parameter.
 *
 * Example of returns:
 *
 * - `kids=1` (1 kid, no birthdate)
 * - `kids=2010-10-30` (1 kid, with birthdate)
 * - `kids=_` (2 kids)
 * - `kids=2010-10-30=_` (2 kids, 1 birthdate)
 * - `kids=2010-10-30c=___`
 * - `kids=2010-10-30c_2009-04-01!`
 */


var serializeKidsToQueryParam = function serializeKidsToQueryParam(params) {
  var kids = params.kids,
      kidsValidationState = params.kidsValidationState;
  var serializedKids = kids.map(function (_ref, index) {
    var birthdate = _ref.birthdate;

    if (!birthdate || !kidsValidationState || kidsValidationState[index] !== _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_3__[/* VALIDATION_STATE_ENUM */ "f"].valid) {
      return '';
    }

    var formattedBirthdate = moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate).format(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DATE_FORMAT */ "e"]);
    return formattedBirthdate;
  }).filter(function (birthdate) {
    return birthdate !== '';
  }); // Special case when there is only one kid, as we can't make a join('_') with only one item

  var serializedOutput = '';

  if (serializedKids.length === 1) {
    if (serializedKids.filter(Boolean).length === 0) {
      serializedOutput = '1';
    } // Return kid's birthdate


    if (serializedOutput !== '1') {
      serializedOutput = serializedKids.shift();
    }

    var childcareIncluded = kids.some(function (kid) {
      return kid.childcareIncluded;
    });

    if (childcareIncluded) {
      serializedOutput = "".concat(serializedOutput).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_CHILDCARE_FLAG */ "c"]);
    }

    return serializedOutput;
  }

  return serializedKids.join(_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_KIDS_DELIMITER */ "i"]);
};
var getKidAgeInMonths = function getKidAgeInMonths(_ref2) {
  var birthdate = _ref2.birthdate,
      departureDate = _ref2.departureDate;
  var defaultDepartureDate = moment__WEBPACK_IMPORTED_MODULE_2___default()().add(_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH */ "k"], 'months').valueOf();
  var b = birthdate ? moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate) : moment__WEBPACK_IMPORTED_MODULE_2___default()().subtract(8, 'y');
  return moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate || defaultDepartureDate).diff(b, 'months');
};


/***/ }),

/***/ "kWb8":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"Agrave\":\"À\",\"agrave\":\"à\",\"amp\":\"&\",\"AMP\":\"&\",\"Aring\":\"Å\",\"aring\":\"å\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"brvbar\":\"¦\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"cedil\":\"¸\",\"cent\":\"¢\",\"copy\":\"©\",\"COPY\":\"©\",\"curren\":\"¤\",\"deg\":\"°\",\"divide\":\"÷\",\"Eacute\":\"É\",\"eacute\":\"é\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"Egrave\":\"È\",\"egrave\":\"è\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"frac12\":\"½\",\"frac14\":\"¼\",\"frac34\":\"¾\",\"gt\":\">\",\"GT\":\">\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"iexcl\":\"¡\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"iquest\":\"¿\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"laquo\":\"«\",\"lt\":\"<\",\"LT\":\"<\",\"macr\":\"¯\",\"micro\":\"µ\",\"middot\":\"·\",\"nbsp\":\" \",\"not\":\"¬\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ordf\":\"ª\",\"ordm\":\"º\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"para\":\"¶\",\"plusmn\":\"±\",\"pound\":\"£\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"raquo\":\"»\",\"reg\":\"®\",\"REG\":\"®\",\"sect\":\"§\",\"shy\":\"­\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"szlig\":\"ß\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"times\":\"×\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uml\":\"¨\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"yen\":\"¥\",\"yuml\":\"ÿ\"}");

/***/ }),

/***/ "kWbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackQueryChange; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("RPju");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sRdV");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zwLB");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var useTrackQueryChange = function useTrackQueryChange() {
  var pageContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_2__[/* ReactPageContext */ "a"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__[/* useTracking */ "a"])();

  var executeTracking = function executeTracking(query, payload) {
    if (query) {
      var isFromAutoComplete = Boolean(query.type);
      track(_objectSpread({
        categoryGA: pageContext.pageId,
        actionGA: 'search',
        labelGA: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_4__[/* getSearchMappedTypeForLabelGA */ "c"])(query.type),
        internalSearchEngineNbResults: '',
        searchReferrer: pageContext.pageId,
        searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
        searchTerms: query.label || null
      }, payload));
    }
  };

  return executeTracking;
};

/***/ }),

/***/ "kawP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productSummaryResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");






var productSummaryResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_SUMMARY */ "rb"],
  resolve: function resolve(appContext, props) {
    var _appContext$cmsConten = appContext.cmsContent,
        cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
        _appContext$cmsReleas = appContext.cmsRelease,
        cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
    var cmsArgs = "content : \"".concat(cmsContent, "\", release : \"").concat(cmsRelease, "\"");
    var resortId = props.resortId,
        tourDurationPlaceholder = props.tourDurationPlaceholder,
        cruiseTimingPlaceholder = props.cruiseTimingPlaceholder,
        cruiseDurationPlaceholder = props.cruiseDurationPlaceholder,
        dateFormat = props.dateFormat;
    var resortThumbnailQueryString = Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_4__[/* default */ "b"])({
      content: cmsContent,
      release: cmsRelease,
      tourDurationPlaceholder: tourDurationPlaceholder,
      cruiseTimingPlaceholder: cruiseTimingPlaceholder,
      cruiseDurationPlaceholder: cruiseDurationPlaceholder,
      dateFormat: dateFormat
    });
    var query = "query {\n      product : resort(productId : \"".concat(resortId, "\") {\n        description\n        ").concat(resortThumbnailQueryString, "\n      }\n      config(").concat(cmsArgs, ") {\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_1__[/* resort */ "e"](appContext), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_1__[/* price */ "c"](), "\n        common {\n          next\n          previous\n          close\n          thumbnailCTA\n          thumbnailTourCTA\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_PRODUCT_SUMMARY */ "Dc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    })["catch"](function () {});
  }
};

/***/ }),

/***/ "klIi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tourIntroductionResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var tourIntroductionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* TOUR_INTRODUCTION */ "Gb"],
  resolve: function resolve(appContext, props) {
    var resortId = props.resortId;
    var query = "query {\n      resort(resortId: \"".concat(resortId, "\") {\n        strengths\n        details\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_TOUR_INTRODUCTION */ "Gc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "lBGg":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("4Db7");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "lDSF":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("1KeW"),
    getValue = __webpack_require__("f4mQ");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "lEjn":
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__("CATK"),
    baseUnary = __webpack_require__("id+h"),
    nodeUtil = __webpack_require__("2LZg");

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ "lW4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withOpenAndScrollToHash; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zygG");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _tabs_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("GzVq");
/* harmony import */ var _scroll_scrollToHash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("34at");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function getWithIds(_ref) {
  var id = _ref.id,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  var mainId = id || Object(_tabs_util__WEBPACK_IMPORTED_MODULE_5__[/* getTabsMainId */ "c"])(items);
  var itemsWithIds = items.map(function (item, index) {
    var _getTabsItemIds = Object(_tabs_util__WEBPACK_IMPORTED_MODULE_5__[/* getTabsItemIds */ "b"])({
      id: item.id,
      index: index,
      mainId: mainId,
      title: item.header && item.header.title
    }),
        _getTabsItemIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_getTabsItemIds, 2),
        headerId = _getTabsItemIds2[0],
        panelId = _getTabsItemIds2[1];

    return _objectSpread(_objectSpread({}, item), {}, {
      headerId: headerId,
      panelId: panelId
    });
  });
  return [mainId, itemsWithIds];
}
/* scroll to Tabs or Accordion item #id and open it */


function withOpenAndScrollToHash(WrappedComponent) {
  return function OpenTabAndScrollToHash(props) {
    var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])({
      initialSelectedItem: props.initialSelectedItem,
      initialSelectedItems: props.initialSelectedItems
    }),
        _useState$ = _useState[0],
        initialSelectedItem = _useState$.initialSelectedItem,
        initialSelectedItems = _useState$.initialSelectedItems,
        setIntialItems = _useState[1];

    var _getWithIds = getWithIds({
      id: props.id,
      items: props.items
    }),
        _getWithIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_getWithIds, 2),
        mainId = _getWithIds2[0],
        itemsWithIds = _getWithIds2[1];

    Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
      var hash = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["windowWrapper"].getLocationPart('hash');

      if (hash.length < 2) {
        setIntialItems({
          initialSelectedItem: props.initialSelectedItem,
          initialSelectedItems: props.initialSelectedItems
        });
        return;
      }

      var ids = itemsWithIds.map(function (_ref2) {
        var _ref2$headerId = _ref2.headerId,
            headerId = _ref2$headerId === void 0 ? '' : _ref2$headerId;
        return "#".concat(headerId);
      });
      var index = ids.indexOf(hash);

      if (index !== -1) {
        setIntialItems({
          initialSelectedItem: index,
          initialSelectedItems: [index]
        });
        setTimeout(function () {
          Object(_scroll_scrollToHash__WEBPACK_IMPORTED_MODULE_6__[/* goToHash */ "a"])(hash);
        }, 250);
      }
    }, [props.initialSelectedItem, props.initialSelectedItems]);
    return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, props, {
      id: mainId,
      initialSelectedItems: initialSelectedItems,
      initialSelectedItem: initialSelectedItem,
      items: itemsWithIds,
      key: mainId // to reinitialize state when it is new tabs, see : https://fr.reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key

    }));
  };
}

/***/ }),

/***/ "lZQm":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("N9he"),
    isObjectLike = __webpack_require__("oS78");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "loSl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return toggleFacet; });
/* unused harmony export changeKids */
/* unused harmony export changeKidsNumberWith */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeKidsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeDepartureCity; });
/* unused harmony export changeDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setInitialProductPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setKidsValidationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetRedirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetSearch; });
/* unused harmony export setFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resetCriteria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return resetCalendarCriteria; });
/* unused harmony export setIsDateRequired */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setIsSearchEnabled; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("uDfI");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rJ95");
/* harmony import */ var _search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("0ibg");
/* harmony import */ var _search_search_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("B3yO");
/* harmony import */ var _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("wQ38");
/* harmony import */ var _trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("1bWg");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("fflk");
/* harmony import */ var _trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+mhw");
/* harmony import */ var _trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("6wD6");
/* harmony import */ var _trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("C5R2");
/* harmony import */ var _trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("RBvG");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Jsmy");
/* harmony import */ var _faceting_selector__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("vIa8");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("9QcM");





function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

















function setActiveFacet(categoryId, value, isSelected) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_TOGGLE_FACET_SELECTED */ "p"], {
    categoryId: categoryId,
    value: value,
    isSelected: isSelected
  });
}

function toggleFacet(_ref) {
  var categoryId = _ref.categoryId,
      isSelected = _ref.isSelected,
      value = _ref.value;
  return setActiveFacet(categoryId, value, isSelected);
}
function changeKids(value) {
  return function (dispatch, getState) {
    var oldKids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getKids */ "c"])(getState());
    var newKids = value.map(function (kid, index) {
      return _objectSpread(_objectSpread({}, kid), {}, {
        neolid: Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(oldKids, "[".concat(index, "].neolid"))
      });
    });
    return dispatch(Object(_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_10__[/* setKids */ "b"])(newKids));
  };
}

function _changeKidsSize(kids, newSize) {
  var emptyKids = Object(lodash__WEBPACK_IMPORTED_MODULE_4__["times"])(newSize - kids.length, function () {
    return _objectSpread({}, _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_9__[/* DEFAULT_KID_VALUE */ "a"]);
  });

  if (newSize < kids.length) {
    return kids.slice(0, newSize);
  }

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(kids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(emptyKids));
} // use this export when testing.


var changeKidsNumberWith = function changeKidsNumberWith(changeKidsFunc) {
  return function changeKidsNumber(value) {
    return function (dispatch, getState) {
      var kids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getKids */ "c"])(getState());

      var newKids = _changeKidsSize(kids, value);

      return dispatch(changeKidsFunc(newKids));
    };
  };
}; // use this export in app code.

var changeKidsNumber = changeKidsNumberWith(changeKids);
function changeDepartureCity(value) {
  return Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__[/* setDepartureCity */ "a"])({
    value: value
  });
}
function changeDepartureDate(_ref2) {
  var value = _ref2.value;
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(value);
}
var clearDepartureDate = function clearDepartureDate() {
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null);
};
var setSearchQuery = function setSearchQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    label: ''
  };
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_SEARCH_QUERY */ "o"], {
    value: query
  });
};
function clearTripDuration() {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]);
}
function changeSearchQuery(value) {
  return function (dispatch, getState) {
    var store = getState();
    var keywords = Object(_search_search_selector__WEBPACK_IMPORTED_MODULE_8__[/* keywordsSelector */ "a"])(store);
    var searchQuery = Object(_faceting_selector__WEBPACK_IMPORTED_MODULE_17__[/* searchQuerySelector */ "m"])(getState());
    Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
      if (keywords) {
        dispatch(Object(_search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_7__[/* setKeywords */ "a"])(''));
      }

      if (searchQuery.label !== value.label) {
        dispatch(setSearchQuery(value));
      }
    });
  };
}
function changeTripDuration(value) {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(value);
}
function setInitialProductPrices(initialProductPrices) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_INITIAL_PRICES */ "j"], {
    initialProductPrices: initialProductPrices
  });
}
function setKidsValidationState(kidsValidationState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_KIDS_VALIDATION_STATE */ "m"], {
    kidsValidationState: kidsValidationState
  });
}
function clearFacets(categoryId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_CLEAR_FACETS */ "b"], {
    categoryId: categoryId
  });
}
function resetRedirection() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_RESET_REDIRECTION */ "f"]);
}
function resetSearch() {
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_RESET_SEARCH */ "g"])));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function setFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_FILTERS */ "i"], {
    filters: filters
  });
}
function updateFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_UPDATE_FILTERS */ "s"], {
    filters: filters
  });
}
function resetCriteria() {
  return /*#__PURE__*/function () {
    var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_12__[/* setDepartureCity */ "a"])({
                  value: null
                }));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]));
                dispatch(updateFilters([]));
                dispatch(setSearchQuery({
                  label: ''
                }));
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
}
function resetCalendarCriteria() {
  return /*#__PURE__*/function () {
    var _ref5 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee3(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_13__[/* updateTripDateCriteria */ "a"])({
                  day: null
                }));
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_11__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_14__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEFAULT_NO_DURATION */ "a"]));
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
}
function setIsDateRequired(isDateRequired) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_IS_DATE_REQUIRED */ "k"], {
    isDateRequired: isDateRequired
  });
}
function setIsSearchEnabled(isSearchEnabled) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_18__[/* FACETING_SET_IS_SEARCH_ENABLED */ "l"], {
    isSearchEnabled: isSearchEnabled
  });
}

/***/ }),

/***/ "lxRQ":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("00cE"),
    overRest = __webpack_require__("JYyW"),
    setToString = __webpack_require__("/NZD");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "m4Zw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productPriceTicketCustomResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productPriceTicketCustomResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_PRICE_TICKET_CUSTOM */ "Q"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      config {\n        common {\n          comparator {\n            backToSearch\n          }\n        }\n      }\n      resort(".concat(productArgs, ") {\n        badgeIcon\n        color\n        comfortLabel\n        destination {\n          country\n        }\n        isExplicitEC\n        name\n        type\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_PRICE_TICKET_CUSTOM */ "tc"]
    });
  }
};

/***/ }),

/***/ "muDs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productGoogleStreetViewResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var productGoogleStreetViewResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_STREET_VIEW */ "U"],
  resolve: function resolve(appContext, props) {
    var query = "query {\n      config {\n        common { close }\n      }\n      resort(resortId: \"".concat(props.resortId, "\") {\n        name\n        streetView {\n          latitude\n          longitude\n          heading\n          pitch\n          fov\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_STREET_VIEW */ "Bc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "ngAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useDebounce; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // Our hook

function useDebounce(values, delay) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(values),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(values);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, values);
  return debouncedValue;
}

/***/ }),

/***/ "nkaD":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "nz94":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "oG87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("aPQG");






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(ErrorBoundary, [{
    key: "componentDidCatch",
    // eslint-disable-next-line class-methods-use-this
    value: function componentDidCatch(error, info) {
      Object(_errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_6__[/* handleComponentError */ "a"])(error, info);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError && !this.props.useNativeErrorHandling) {
        return null;
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_5___default.a.Component);

/***/ }),

/***/ "oS78":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "oS9k":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ "oW49":
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__("8PLQ"),
    legacyMap = __webpack_require__("kWb8"),
    xmlMap    = __webpack_require__("ZLJe"),
    decodeCodePoint = __webpack_require__("cHMM");

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),

/***/ "oWz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputSelect_InputSelect; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.themes.js


var themes = {
  "default": function _default(props) {
    return {
      thInputWrapper: 'relative w-full',
      thInput: classnames_default()("reset-input reset-select h-full relative ".concat(props.mediumText ? 'text-md' : 'text-base', " text-gray-darker w-full"), Object(form_util["a" /* getCursorClass */])(props)),
      thPlaceholder: '',
      thCaret: classnames_default()('absolute flex h-full items-center top-0 rtl:right-0 pointer-events-none rtl:pl-3', {
        'text-current': !props.isDisabled,
        'text-gray-darker': props.isDisabled
      })
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.jsx








var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var InputSelect_InputSelect = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputSelect, _Component);

  var _super = _createSuper(InputSelect);

  function InputSelect(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputSelect);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = e.target.value;

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        value: ''
      }, function () {
        return onClear(e);
      });
    });

    _this.state = {
      value: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputSelect, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = this.props.options;

      if (Object(lodash["isEmpty"])(options)) {
        return null;
      }

      return options.map(function (_ref2) {
        var isDisabled = _ref2.isDisabled,
            isSelected = _ref2.isSelected,
            label = _ref2.label,
            value = _ref2.value;
        return label ? __jsx("option", {
          disabled: isDisabled,
          key: label,
          label: label,
          selected: isSelected,
          value: value
        }, label) : null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          bgTransparent = _this$props2.bgTransparent,
          caretIcon = _this$props2.caretIcon,
          className = _this$props2.className,
          hasClear = _this$props2.hasClear,
          iconLeft = _this$props2.iconLeft,
          iconRight = _this$props2.iconRight,
          _this$props2$id = _this$props2.id,
          id = _this$props2$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputSelect_') : _this$props2$id,
          isDisabled = _this$props2.isDisabled,
          isFilled = _this$props2.isFilled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          isRequired = _this$props2.isRequired,
          label = _this$props2.label,
          name = _this$props2.name,
          notes = _this$props2.notes,
          onBlur = _this$props2.onBlur,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          placeholder = _this$props2.placeholder,
          size = _this$props2.size,
          theme = _this$props2.theme,
          validationState = _this$props2.validationState,
          dataTestId = _this$props2.dataTestId,
          inputId = _this$props2.inputId;
      var value = this.state.value;
      var hasClearEnabled = Boolean(hasClear && this.state.value);
      var hasValue = Boolean(value);
      var placeholderFormatted = Object(form_util["b" /* getFormattedLabel */])(placeholder, isRequired);

      var _themes$theme = themes[theme](this.props),
          thCaret = _themes$theme.thCaret,
          thInput = _themes$theme.thInput,
          thInputWrapper = _themes$theme.thInputWrapper,
          thPlaceholder = _themes$theme.thPlaceholder;

      return __jsx(FormControl["a" /* FormControl */], {
        bgTransparent: bgTransparent,
        className: className,
        hasClear: hasClearEnabled,
        id: id,
        iconLeft: iconLeft,
        iconRight: iconRight,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        size: size,
        theme: theme,
        validationState: validationState
      }, __jsx("div", {
        className: thInputWrapper
      }, __jsx("select", Object(esm_extends["a" /* default */])({
        className: thInput,
        disabled: Boolean(isDisabled || isLoading || isReadOnly),
        id: inputId ? inputId : id
      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        required: isRequired,
        value: value,
        "data-testid": dataTestId
      }), !!placeholderFormatted && __jsx("option", {
        className: thPlaceholder,
        label: placeholderFormatted,
        disabled: true,
        value: ""
      }, placeholderFormatted), this.getOptions()), !(isDisabled || isLoading || isReadOnly) && __jsx("div", {
        className: thCaret,
        "data-testid": "InputSelectCaret"
      }, __jsx(Icon["a" /* Icon */], {
        name: caretIcon,
        width: "0.625rem",
        dataTestid: caretIcon ? "caret-".concat(caretIcon) : ''
      }))));
    }
  }]);

  return InputSelect;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputSelect_InputSelect, "defaultProps", {
  caretIcon: icons["a" /* ICONS */].SELECT,
  options: [],
  size: 'medium',
  theme: 'default',
  mediumText: false
});

/***/ }),

/***/ "oZU8":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("CP21");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "ojcf":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("pfIK"),
    baseAssignValue = __webpack_require__("Ky/o");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "okv5":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("jP+d");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("EIeC")(module)))

/***/ }),

/***/ "olhj":
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__("HvnH"),
    isObject = __webpack_require__("Q7Yi");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ "ontP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FacetSearch_FacetSearch; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// CONCATENATED MODULE: ./src/client/router/useRouterEvents.js


function useRouterEvents() {
  var _useState = Object(react["useState"])(false),
      transitioning = _useState[0],
      setTransitioning = _useState[1];

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  Object(react["useEffect"])(function () {
    var routeChangeStartHandler = function routeChangeStartHandler() {
      setTransitioning(true);
    };

    var routeChangeCompleteHandler = function routeChangeCompleteHandler() {
      setTransitioning(false);
    };

    history.events.on('routeChangeStart', routeChangeStartHandler);
    history.events.on('routeChangeComplete', routeChangeCompleteHandler);
    return function () {
      history.events.off('routeChangeStart', routeChangeStartHandler);
      history.events.off('routeChangeComplete', routeChangeCompleteHandler);
    };
  }, []);
  return {
    transitioning: transitioning
  };
}
// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsive_responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaContext.jsx
var CriteriaContext = __webpack_require__("XiOS");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/FacetSearch.utils.js
var FacetSearch_utils = __webpack_require__("hPQF");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackQueryChange.js
var useTrackQueryChange = __webpack_require__("kWbI");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackSearchResults.js
var useTrackSearchResults = __webpack_require__("NrqW");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/faceting/constants.js
var constants = __webpack_require__("9QcM");

// CONCATENATED MODULE: ./src/client/store/faceting/productComparison.action.js



function productComparison_action_toggleProductComparisonSelectionMode() {
  return function (dispatch) {
    return dispatch(Object(createAction["b" /* default */])(constants["q" /* FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE */]));
  };
}

function setProductComparisonSelectionMode(enable) {
  return function (dispatch) {
    dispatch(Object(createAction["b" /* default */])(constants["n" /* FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE */], {
      enable: enable
    }));
  };
}

function toggleProductSelected(productId) {
  return function (dispatch) {
    return dispatch(Object(createAction["b" /* default */])(constants["r" /* FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON */], {
      productId: productId
    }));
  };
}


// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.action.js
var departureDate_action = __webpack_require__("fflk");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/utils/searchHelper.js
var searchHelper = __webpack_require__("4+vj");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/client/store/faceting/faceting.selector.js + 1 modules
var faceting_selector = __webpack_require__("vIa8");

// CONCATENATED MODULE: ./src/client/store/faceting/searchRequest.action.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








function facetingSearchRequest(_ref) {
  var appContext = _ref.appContext,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  return function (dispatch, getState) {
    var state = getState();
    var departureDate = Object(tripCriteria_selector["b" /* getDepartureDate */])(state);

    if (departureDate && Object(facetingUtils["f" /* isDateInThePast */])(departureDate)) {
      dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
    }

    var boutique = options.boutique,
        defaultDepartureCity = options.defaultDepartureCity,
        offerId = options.offerId,
        productIds = options.productIds,
        screenSize = options.screenSize;

    var _searchQuerySelector = Object(faceting_selector["m" /* searchQuerySelector */])(state),
        query = _searchQuerySelector.label;

    var facetingCriteria = Object(faceting_selector["c" /* facetingCriteriaSelector */])(state);
    var flexibility = Object(tripCriteria_selector["d" /* getTripFlexibility */])(state);

    var criteria = _objectSpread(_objectSpread({}, facetingCriteria), {}, {
      boutique: boutique,
      defaultDepartureCity: defaultDepartureCity,
      flexibility: flexibility,
      offerId: offerId,
      productIds: productIds,
      query: query,
      screenSize: screenSize
    });

    var promise = Object(searchHelper["f" /* searchWithFacets */])({
      criteria: criteria,
      options: options,
      appContext: appContext
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(constants["h" /* FACETING_SEARCH_REQUEST */], {}, {
      optimist: true,
      promise: promise
    }));
  };
}
function facetingLoadOffsetSellRequest(_ref2) {
  var appContext = _ref2.appContext;
  return function (dispatch) {
    var promise = Object(searchHelper["c" /* loadOffsetSell */])({
      appContext: appContext
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(constants["c" /* FACETING_LOAD_OFFSET_SELL_REQUEST */], {}, {
      optimist: true,
      promise: promise
    }));
  };
}
function facetingLoadProductsRequest(_ref3) {
  var appContext = _ref3.appContext,
      _ref3$productIds = _ref3.productIds,
      productIds = _ref3$productIds === void 0 ? [] : _ref3$productIds;
  return function (dispatch) {
    var promise = Object(searchHelper["e" /* loadProductsWithIds */])({
      appContext: appContext,
      productIds: productIds
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(constants["d" /* FACETING_LOAD_PRODUCTS_REQUEST */], {}, {
      optimist: true,
      promise: promise
    }));
  };
}
function pricesRequestAction(_ref4) {
  var appContext = _ref4.appContext,
      criteria = _ref4.criteria,
      withFlexibility = _ref4.withFlexibility;
  var promise = Object(searchHelper["d" /* loadPrices */])({
    appContext: appContext,
    criteria: criteria,
    withFlexibility: withFlexibility
  });
  return Object(createAction["a" /* createOptimisticAction */])(constants["e" /* FACETING_PRICES_REQUEST */], {}, {
    optimist: true,
    promise: promise
  });
}
function childcareRequestAction(_ref5) {
  var appContext = _ref5.appContext,
      _ref5$criteria = _ref5.criteria,
      criteria = _ref5$criteria === void 0 ? {} : _ref5$criteria;
  var promise = Object(searchHelper["b" /* loadChildcareAvailabilities */])({
    appContext: appContext,
    criteria: criteria
  });
  return Object(createAction["a" /* createOptimisticAction */])(constants["a" /* FACETING_CHILDCARE_REQUEST */], {}, {
    optimist: true,
    promise: promise
  });
}
// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/constants.js
var departure_city_constants = __webpack_require__("PFCZ");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: /home/circleci/project/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// CONCATENATED MODULE: ./src/utils/faceting/unpersistedFacetUtils.js








function getCriteriaFromQueryParams(url) {
  return function (criteria) {
    var facetQueryParams = url ? new URI_default.a(url).query(true) : {};
    return Object(lodash["get"])(facetQueryParams, criteria, null);
  };
}

function getUrlWithUnpersistedData(options) {
  var url = options.url,
      query = options.query,
      _options$productIdsTo = options.productIdsToCompare,
      productIdsToCompare = _options$productIdsTo === void 0 ? [] : _options$productIdsTo,
      departureCity = options.departureCity,
      departureDate = options.departureDate,
      duration = options.duration;

  var queryParams = Object(defineProperty["a" /* default */])({}, faceting_constants["y" /* PRODUCTS_TO_COMPARE_QUERY_PARAM */], productIdsToCompare);

  if (!Object(lodash["isEmpty"])(query)) {
    queryParams[faceting_constants["A" /* QUERY_QUERY_PARAM */]] = query.label;
  }

  if (!Object(lodash["isEmpty"])(departureCity)) {
    queryParams[uri_constants["k" /* QUERY_TRANSPORT */]] = departureCity;
  }

  var departureDateTimestamp = departureDate;

  if (moment_default.a.isMoment(departureDate) && departureDate.isValid()) {
    departureDateTimestamp = departureDate.valueOf();
  }

  if (Object(lodash["isInteger"])(departureDateTimestamp)) {
    queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]] = Object(uriUtils["d" /* formatDateForHashParams */])(departureDateTimestamp);
  }

  if (Object(lodash["isInteger"])(duration) && duration > 0) {
    queryParams[uri_constants["g" /* QUERY_DURATION */]] = "".concat(duration);
  }

  return Object(uriUtils["f" /* generateUrlWithParams */])(url, {
    queryParams: queryParams
  });
}


// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: /home/circleci/project/node_modules/redux/es/redux.js
var redux = __webpack_require__("9OUN");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx + 1 modules
var SeeMore = __webpack_require__("NPTU");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-banners/SearchBanners.themes.js
var themes = {
  "default": function _default() {
    return {
      thRoot: 'flex max-w-full flex-col',
      thBannerRoot: 'max-w-full',
      thBannerHtml: '',
      thBannerImg: 'max-w-full',
      thBannerText: ''
    };
  },
  top: function top() {
    return {
      thRoot: 'flex max-w-full flex-col justify-center items-center',
      thBannerRoot: 'max-w-full',
      thBannerHtml: '',
      thBannerImg: 'max-w-full',
      thBannerText: ''
    };
  },
  terms: function terms() {
    return {
      thRoot: 'flex max-w-full flex-col text-grey',
      thBannerRoot: 'max-w-full',
      thBannerHtml: 'leading-normal text-sm text-gray-medium',
      thBannerImg: 'max-w-full',
      thBannerText: 'leading-normal text-sm text-gray-medium'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-banners/SearchBanners.jsx


var __jsx = react_default.a.createElement;















var getResponsiveClasses = function getResponsiveClasses(screenSizes) {
  var classes = [];

  if (screenSizes.length === 0) {
    return classes;
  }

  if (!screenSizes.includes('xs')) {
    classes.push('hidden');
  }

  classes.push(screenSizes.includes('sm') ? 'sm:flex' : 'sm:hidden');
  classes.push(screenSizes.includes('md') ? 'md:flex' : 'md:hidden');
  classes.push(screenSizes.includes('lg') ? 'lg:flex' : 'lg:hidden');
  classes.push(screenSizes.includes('xl') ? 'xl:flex' : 'xl:hidden');
  return classes;
};

var filterByPosition = function filterByPosition(_ref, position) {
  var _ref$position = _ref.position,
      type = _ref$position.type,
      value = _ref$position.value;
  return type === position || value === position;
};

var filterBySeason = function filterBySeason(_ref2, seasons) {
  var _ref2$content$filters = _ref2.content.filters,
      filters = _ref2$content$filters === void 0 ? [] : _ref2$content$filters;
  var productsHaveSeasons = seasons && seasons.length > 0;
  var bannerHasSeasonFilter = filters && filters.seasons && filters.seasons.length > 0;

  if (!productsHaveSeasons || !bannerHasSeasonFilter) {
    return true;
  }

  return filters.seasons.some(function (filterSeasons) {
    return seasons.sort().join() === filterSeasons.sort().join();
  });
};

var SearchBanners_filterByKidsAge = function filterByKidsAge(_ref3, kids, departureDate) {
  var _ref3$content$filters = _ref3.content.filters,
      filters = _ref3$content$filters === void 0 ? [] : _ref3$content$filters;
  var searchHasKids = kids && kids.length > 0 && kids.some(function (kid) {
    return !!kid.birthdate;
  });
  var bannerHasKidsAgeFilter = filters && filters.kidsAgeInMonths && filters.kidsAgeInMonths.length > 0;

  if (!bannerHasKidsAgeFilter) {
    return true;
  }

  if ((!searchHasKids || !departureDate) && bannerHasKidsAgeFilter) {
    return false;
  }

  return kids.some(function (kid) {
    var ageInMonths = moment_default()(departureDate).diff(moment_default()(kid.birthdate), 'months');
    return filters.kidsAgeInMonths.some(function (ageFilter) {
      var _ageFilter$split = ageFilter.split('-'),
          _ageFilter$split2 = Object(slicedToArray["a" /* default */])(_ageFilter$split, 2),
          min = _ageFilter$split2[0],
          max = _ageFilter$split2[1];

      return Object(lodash["inRange"])(ageInMonths, parseInt(min, 10), parseInt(max, 10));
    });
  });
};

var SearchBanners_filterByProductIds = function filterByProductIds(_ref4, productIds) {
  var _ref4$content$filters = _ref4.content.filters,
      filters = _ref4$content$filters === void 0 ? [] : _ref4$content$filters;
  var searchHasProductIds = productIds && productIds.length > 0;
  var bannerHasProductIdsFilter = filters && filters.products && filters.products.length > 0;

  if (!bannerHasProductIdsFilter) {
    return true;
  }

  if (!searchHasProductIds && bannerHasProductIdsFilter) {
    return false;
  }

  return lodash["without"].apply(void 0, [productIds].concat(Object(toConsumableArray["a" /* default */])(filters.products))).length === 0;
};

var SearchBanners_SearchBanners = function SearchBanners(_ref5) {
  var position = _ref5.position,
      className = _ref5.className;

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var bannerContents = Object(es["e" /* useSelector */])(function (state) {
    var seasons = Object(faceting_selector["f" /* filteredProductsSeasonsSelector */])(state);
    var kids = Object(storeHelper["c" /* getKids */])(state);
    var departureDate = Object(tripCriteria_selector["b" /* getDepartureDate */])(state);
    var banners = Object(faceting_selector["b" /* bannersSelector */])(state);
    var productIds = Object(faceting_selector["i" /* getFacetingProductIds */])(state);

    if (!position) {
      return banners;
    }

    return banners.filter(function (banner) {
      return filterByPosition(banner, position);
    }).filter(function (banner) {
      return SearchBanners_filterByProductIds(banner, productIds);
    }).filter(function (banner) {
      return SearchBanners_filterByKidsAge(banner, kids, departureDate);
    }).filter(function (banner) {
      return filterBySeason(banner, seasons);
    });
  });

  if (!bannerContents || bannerContents.length === 0) {
    return null;
  }

  var _themes = themes[position || 'default'](),
      thRoot = _themes.thRoot,
      thBannerRoot = _themes.thBannerRoot,
      thBannerHtml = _themes.thBannerHtml,
      thBannerImg = _themes.thBannerImg,
      thBannerText = _themes.thBannerText;

  var WithSeeMore = function WithSeeMore(_ref6) {
    var children = _ref6.children,
        seeMoreClassName = _ref6.className;
    return __jsx(SeeMore["a" /* SeeMore */], {
      className: seeMoreClassName,
      isCollapseEnabled: !isDesktop,
      seeLessLabel: Object(src_i18n["f" /* t */])('common.loadLess'),
      seeMoreLabel: Object(src_i18n["f" /* t */])('common.loadMore')
    }, children);
  };

  return __jsx(SiteContainer["a" /* SiteContainer */], null, __jsx("div", {
    className: classnames_default()(thRoot, className)
  }, bannerContents.map(function (_ref7) {
    var content = _ref7.content;
    return __jsx("div", {
      className: classnames_default()(thBannerRoot, content.screenSizes ? getResponsiveClasses(content.screenSizes) : ''),
      key: content.text
    }, content.type === 'img' && __jsx("img", {
      className: thBannerImg,
      src: content.imgUrl,
      alt: content.text
    }), content.type === 'text' && __jsx("div", null, __jsx(WithSeeMore, {
      className: thBannerText
    }, __jsx(Text["a" /* Text */], {
      text: content.text
    }))), content.type === 'html' && __jsx("div", null, __jsx(WithSeeMore, {
      className: thBannerHtml
    }, __jsx("div", {
      dangerouslySetInnerHTML: {
        __html: content.text
      }
    }))));
  })));
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/react-stickynode/index.js
var react_stickynode = __webpack_require__("gyFy");
var react_stickynode_default = /*#__PURE__*/__webpack_require__.n(react_stickynode);

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/drop-zone/DropZone.themes.js
var DropZone_themes_themes = {
  "default": {
    thRoot: 'border-1 border-dashed border-gray-light flex items-center justify-center px-5 text-gray-light relative rounded',
    thNumber: 'absolute rtl:left-0 flex inset-y-0 italic items-center leading-one mx-5 text-15xl',
    thLabel: 'flex-1 font-bold text-center text-md text-gray-darker px-2',
    thRootFilled: 'flex shadow',
    thChildren: 'flex-1 p-2 w-9/10',
    thClear: 'reset-button border-0 border-l-1 rtl:border-l-1 border-solid border-gray-light leading-none p-2',
    thClearIconSize: '0.625rem'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/drop-zone/DropZone.jsx
var DropZone_jsx = react_default.a.createElement;





var DropZone_DropZone = function DropZone(_ref) {
  var children = _ref.children,
      className = _ref.className,
      label = _ref.label,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? '5.625rem' : _ref$minHeight,
      number = _ref.number,
      onClear = _ref.onClear,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = DropZone_themes_themes[theme],
      thChildren = _themes$theme.thChildren,
      thClear = _themes$theme.thClear,
      thClearIconSize = _themes$theme.thClearIconSize,
      thLabel = _themes$theme.thLabel,
      thNumber = _themes$theme.thNumber,
      thRoot = _themes$theme.thRoot,
      thRootFilled = _themes$theme.thRootFilled;
  return children ? DropZone_jsx("div", {
    className: classnames_default()(className, thRootFilled),
    style: {
      minHeight: minHeight
    }
  }, DropZone_jsx("div", {
    className: thChildren
  }, children), DropZone_jsx("button", {
    className: thClear,
    onClick: onClear,
    type: "button"
  }, DropZone_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearIconSize
  }))) : DropZone_jsx("div", {
    className: classnames_default()(className, thRoot),
    style: {
      minHeight: minHeight
    }
  }, !!number && DropZone_jsx("span", {
    className: thNumber
  }, number), !!label && DropZone_jsx("span", {
    className: thLabel
  }, label));
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-header/ProductHeader.jsx
var ProductHeader = __webpack_require__("hgS3");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx + 1 modules
var ProductFlag = __webpack_require__("ELg1");

// CONCATENATED MODULE: ./src/client/components/widgets/product-condensed/ProductCondensed.jsx

var ProductCondensed_jsx = react_default.a.createElement;








var ProductCondensed_ProductCondensed = function ProductCondensed(_ref) {
  var className = _ref.className,
      header = _ref.header,
      offer = _ref.offer,
      price = _ref.price,
      priceInfo = _ref.priceInfo,
      url = _ref.url;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var goOnResort = function goOnResort() {
    var newHistoryState = new DynamicLinkUtil["a" /* default */](dist["windowWrapper"].getLocation(), url ? Object(Product_utils["c" /* generateProductLink */])(url, offer) : '');
    history.pushRoute(newHistoryState.toString());
  };

  return ProductCondensed_jsx("article", {
    className: classnames_default()(className, 'flex flex-col')
  }, ProductCondensed_jsx(ProductHeader["a" /* ProductHeader */], Object(esm_extends["a" /* default */])({}, header, {
    isLinkDisabled: true
  })), ProductCondensed_jsx(ProductFlag["a" /* ProductFlag */], {
    isLinkDisabled: true,
    onClick: goOnResort,
    price: price,
    priceInfo: priceInfo,
    theme: "thumbnail"
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-compare-button/SearchCompareButton.jsx

var SearchCompareButton_jsx = react_default.a.createElement;





function SearchCompareButton(props) {
  var className = props.className,
      comparisonClick = props.comparisonClick,
      comparisonToggle = props.comparisonToggle,
      comparisonUrl = props.comparisonUrl,
      isComparisonActive = props.isComparisonActive,
      isComparisonSubmitable = props.isComparisonSubmitable,
      label = props.label,
      mandatoryMessage = props.mandatoryMessage,
      selectedItemsCount = props.selectedItemsCount,
      selectedItemsMax = props.selectedItemsMax,
      style = props.style;
  var isDisabled = isComparisonActive && !isComparisonSubmitable;

  var getToggleOrComparisonOnClick = function getToggleOrComparisonOnClick() {
    if (isComparisonSubmitable) return comparisonClick;
    return isComparisonActive ? lodash["noop"] : comparisonToggle;
  };

  var trackingData = isComparisonSubmitable ? {
    actionGA: 'overlayCTA',
    labelGA: 'compareMySelection'
  } : {
    actionGA: 'overlayCTA',
    labelGA: 'compareAndBook'
  };
  return SearchCompareButton_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    "aria-disabled": isDisabled,
    as: isComparisonSubmitable ? DynamicLink["a" /* default */] : 'button',
    trackingData: trackingData,
    className: classnames_default()(className, 'reset-anchor reset-button flex items-stretch font-bold overflow-hidden rounded-small text-md text-white', {
      'bg-gray-light cursor-default': isDisabled,
      'bg-turquoise': !isComparisonActive && !isComparisonSubmitable,
      'bg-emerald': isComparisonSubmitable
    }),
    onClick: getToggleOrComparisonOnClick(),
    style: style,
    title: !isComparisonSubmitable ? mandatoryMessage : ''
  }, isComparisonSubmitable ? {
    url: comparisonUrl
  } : {
    type: 'button'
  }, {
    "data-testid": "search-compare-button"
  }), SearchCompareButton_jsx("span", {
    className: "flex-1 p-2 text-center"
  }, label), !!selectedItemsCount && SearchCompareButton_jsx("span", {
    className: "bg-overlay-black-15 p-2"
  }, selectedItemsCount, "/", selectedItemsMax));
}
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-compare/large/SearchCompareLarge.jsx
var SearchCompareLarge_jsx = react_default.a.createElement;








var SearchCompareLarge_SearchCompareLarge = function SearchCompareLarge(_ref) {
  var buttonLabel = _ref.buttonLabel,
      cancelLabel = _ref.cancelLabel,
      children = _ref.children,
      className = _ref.className,
      comparisonClick = _ref.comparisonClick,
      comparisonToggle = _ref.comparisonToggle,
      comparisonUrl = _ref.comparisonUrl,
      dropzoneLabel = _ref.dropzoneLabel,
      isComparisonActive = _ref.isComparisonActive,
      isComparisonSubmitable = _ref.isComparisonSubmitable,
      mandatoryMessage = _ref.mandatoryMessage,
      resultsCount = _ref.resultsCount,
      _ref$selectedItems = _ref.selectedItems,
      selectedItems = _ref$selectedItems === void 0 ? [] : _ref$selectedItems,
      _ref$selectedItemsMax = _ref.selectedItemsMax,
      selectedItemsMax = _ref$selectedItemsMax === void 0 ? 3 : _ref$selectedItemsMax,
      toggleProductSelectedForComparison = _ref.toggleProductSelectedForComparison;

  var _useState = Object(react["useState"])(false),
      isSticky = _useState[0],
      setSticky = _useState[1];

  var onStateChange = function onStateChange(status) {
    setSticky(status.status !== react_stickynode_default.a.STATUS_ORIGINAL);
  };

  return SearchCompareLarge_jsx(react_stickynode_default.a, {
    bottomBoundary: "#SearchCompareBeacon",
    innerZ: 3,
    onStateChange: onStateChange
  }, SearchCompareLarge_jsx("section", {
    className: classnames_default()(className, 'bg-white py-2', {
      'border-b-1 border-gray-light shadow-bottom': isSticky
    })
  }, SearchCompareLarge_jsx(SiteContainer["a" /* SiteContainer */], null, SearchCompareLarge_jsx("div", {
    className: "flex items-center justify-between"
  }, SearchCompareLarge_jsx("div", {
    className: "flex-1"
  }, children), isComparisonActive && SearchCompareLarge_jsx("button", {
    className: "reset-button font-bold text-base mx-5",
    onClick: comparisonToggle,
    type: "button"
  }, cancelLabel), resultsCount && resultsCount > 0 && SearchCompareLarge_jsx(SearchCompareButton, {
    comparisonToggle: comparisonToggle,
    comparisonClick: comparisonClick,
    comparisonUrl: comparisonUrl,
    isComparisonActive: isComparisonActive,
    isComparisonSubmitable: isComparisonSubmitable,
    label: buttonLabel,
    mandatoryMessage: mandatoryMessage,
    selectedItemsCount: selectedItems.length,
    selectedItemsMax: selectedItemsMax,
    style: {
      minWidth: 280,
      minHeight: 40
    }
  }))), SearchCompareLarge_jsx(lib["UnmountClosed"], {
    isOpened: isComparisonActive
  }, SearchCompareLarge_jsx(SiteContainer["a" /* SiteContainer */], null, SearchCompareLarge_jsx("div", {
    className: "flex -mx-2 pt-3"
  }, Array(selectedItemsMax).fill().map(function (_, idx) {
    var product = selectedItems[idx];
    var productId = product && product.id;
    return SearchCompareLarge_jsx("div", {
      className: "p-2 w-1/3",
      key: productId || idx
    }, SearchCompareLarge_jsx(DropZone_DropZone, {
      className: "h-full",
      label: dropzoneLabel,
      number: idx + 1,
      onClear: productId && toggleProductSelectedForComparison ? function () {
        return toggleProductSelectedForComparison(productId);
      } : undefined
    }, product && SearchCompareLarge_jsx(ProductCondensed_ProductCondensed, product)));
  }))))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-compare/narrow/SearchCompareNarrow.jsx
var SearchCompareNarrow_jsx = react_default.a.createElement;










var SearchCompareNarrow_SearchCompareNarrow = function SearchCompareNarrow(_ref) {
  var buttonLabel = _ref.buttonLabel,
      cancelLabel = _ref.cancelLabel,
      collapseLabel = _ref.collapseLabel,
      expandLabel = _ref.expandLabel,
      children = _ref.children,
      className = _ref.className,
      comparisonClick = _ref.comparisonClick,
      comparisonToggle = _ref.comparisonToggle,
      comparisonUrl = _ref.comparisonUrl,
      dropzoneLabel = _ref.dropzoneLabel,
      isComparisonActive = _ref.isComparisonActive,
      isComparisonSubmitable = _ref.isComparisonSubmitable,
      isProductsTopInViewport = _ref.isProductsTopInViewport,
      isProductsBottomInViewport = _ref.isProductsBottomInViewport,
      mandatoryMessage = _ref.mandatoryMessage,
      resultsCount = _ref.resultsCount,
      _ref$selectedItems = _ref.selectedItems,
      selectedItems = _ref$selectedItems === void 0 ? [] : _ref$selectedItems,
      _ref$selectedItemsMax = _ref.selectedItemsMax,
      selectedItemsMax = _ref$selectedItemsMax === void 0 ? 3 : _ref$selectedItemsMax,
      toggleProductSelectedForComparison = _ref.toggleProductSelectedForComparison;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  var selectedItemsCount = selectedItems.length;
  return SearchCompareNarrow_jsx(react["Fragment"], null, SearchCompareNarrow_jsx(SiteContainer["a" /* SiteContainer */], {
    className: className
  }, children), resultsCount && resultsCount > 0 && SearchCompareNarrow_jsx("section", {
    className: classnames_default()('bg-white border-t-1 border-gray-light bottom-0 w-full z-3', {
      fixed: isProductsTopInViewport,
      absolute: isProductsBottomInViewport
    })
  }, !!selectedItemsCount && SearchCompareNarrow_jsx("div", {
    className: "absolute bottom-full flex justify-center w-full"
  }, SearchCompareNarrow_jsx(StripButton["a" /* StripButton */], {
    className: "font-bold text-center text-blue text-sm underline",
    height: 30,
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    }
  }, isExpanded ? collapseLabel : expandLabel, SearchCompareNarrow_jsx(Icon["a" /* Icon */], {
    className: "rtl:ml-2 flex-shrink-0",
    name: isExpanded ? icons["a" /* ICONS */].SELECT : icons["a" /* ICONS */].SELECT_UP,
    width: "0.625rem"
  }))), SearchCompareNarrow_jsx(lib["UnmountClosed"], {
    isOpened: isExpanded
  }, SearchCompareNarrow_jsx(SiteContainer["a" /* SiteContainer */], null, SearchCompareNarrow_jsx("div", {
    className: "pt-5 pb-1"
  }, Array(selectedItemsMax).fill().map(function (_, idx) {
    var product = selectedItems[idx];
    var productId = product && product.id;
    return SearchCompareNarrow_jsx("div", {
      className: "mb-5",
      key: productId || idx
    }, SearchCompareNarrow_jsx(DropZone_DropZone, {
      label: dropzoneLabel,
      number: idx + 1,
      onClear: productId && toggleProductSelectedForComparison ? function () {
        toggleProductSelectedForComparison(productId);
        if (selectedItemsCount - 1 === 0) setExpanded(!isExpanded);
      } : undefined
    }, product && SearchCompareNarrow_jsx(ProductCondensed_ProductCondensed, product)));
  })))), SearchCompareNarrow_jsx(SiteContainer["a" /* SiteContainer */], null, SearchCompareNarrow_jsx("div", {
    className: "flex items-center justify-between py-3"
  }, isComparisonActive && SearchCompareNarrow_jsx("button", {
    className: "reset-button font-bold text-base rtl:mr-5",
    onClick: function onClick() {
      comparisonToggle();
      setExpanded(false);
    },
    type: "button"
  }, cancelLabel), SearchCompareNarrow_jsx(SearchCompareButton, {
    className: "flex-1",
    comparisonToggle: comparisonToggle,
    comparisonClick: comparisonClick,
    comparisonUrl: comparisonUrl,
    isComparisonActive: isComparisonActive,
    isComparisonSubmitable: isComparisonSubmitable,
    label: buttonLabel,
    mandatoryMessage: mandatoryMessage,
    selectedItemsCount: selectedItemsCount,
    selectedItemsMax: selectedItemsMax,
    style: {
      minHeight: 40
    }
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-compare/SearchCompare.jsx
var SearchCompare_jsx = react_default.a.createElement;




var SearchCompare_SearchCompare = function SearchCompare(props) {
  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  return isDesktop ? SearchCompare_jsx(SearchCompareLarge_SearchCompareLarge, props) : SearchCompare_jsx(SearchCompareNarrow_SearchCompareNarrow, props);
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.mapper.js + 1 modules
var Product_mapper = __webpack_require__("bGCG");

// EXTERNAL MODULE: ./src/client/components/widgets/products-grid/ProductsGrid.jsx
var ProductsGrid = __webpack_require__("w04c");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-results/SearchResults.jsx







var SearchResults_jsx = react_default.a.createElement;

function SearchResults_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function SearchResults_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SearchResults_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SearchResults_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }














var ProductsGridVirtualized = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(41), __webpack_require__.e(93)]).then(__webpack_require__.bind(null, "GbXy")).then(function (c) {
    return c.ProductsGridVirtualized;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("GbXy")];
    },
    modules: ["../../products-grid-virtualized/ProductsGridVirtualized"]
  }
});
var defaultProps = {
  config: {},
  resorts: [],
  displayValidationButton: true,
  isProductComparisonSelectionModeEnabled: false,
  productsSelectedForComparison: [],
  maxSelectableItems: 3,
  filteredProductsId: [],
  kids: [],
  toggleProductSelectedForComparison: lodash["noop"],
  isPriceLoading: false,
  prices: [],
  childcareAvailabilities: [],
  isSynchronousGrid: false
};
var SearchResults_SearchResults = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(SearchResults, _Component);

  var _super = _createSuper(SearchResults);

  function SearchResults() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, SearchResults);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "flattenResort", function (product) {
      var _price$termsAndCondit;

      var _this$props = _this.props,
          productsSelectedForComparison = _this$props.productsSelectedForComparison,
          maxSelectableItems = _this$props.maxSelectableItems,
          isProductComparisonSelectionModeEnabled = _this$props.isProductComparisonSelectionModeEnabled,
          displayValidationButton = _this$props.displayValidationButton,
          config = _this$props.config,
          isPriceLoading = _this$props.isPriceLoading,
          kids = _this$props.kids,
          departureDate = _this$props.departureDate;
      var productId = product.id;
      var isSelectedForComparison = productsSelectedForComparison.includes(productId);
      var maxSelectableItemsReached = productsSelectedForComparison.length === maxSelectableItems;

      var price = _this.getPriceForProduct(productId);

      var priceDepartureDate = price === null || price === void 0 ? void 0 : (_price$termsAndCondit = price.termsAndConditions) === null || _price$termsAndCondit === void 0 ? void 0 : _price$termsAndCondit.departureDate;
      var departureDateOn;

      if (departureDate && priceDepartureDate && moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]) !== String(priceDepartureDate)) {
        departureDateOn = Object(src_i18n["f" /* t */])('faceting.flexibility.resultIndication', {
          departure_date: moment_default()(priceDepartureDate, apiDate["a" /* API_DATE_FORMAT */]).format('DD/MM')
        });
      }

      return {
        hasComparison: isProductComparisonSelectionModeEnabled,
        isSliderDisabled: isProductComparisonSelectionModeEnabled,
        comparison: {
          isDisabled: isProductComparisonSelectionModeEnabled && !isSelectedForComparison && maxSelectableItemsReached,
          isSelectable: isProductComparisonSelectionModeEnabled && (isSelectedForComparison || !maxSelectableItemsReached),
          isSelected: isSelectedForComparison
        },
        displayValidationButton: displayValidationButton,
        config: config,
        offerColor: Object(lodash["get"])(_this.props, ['offer', 'color']),
        isPriceLoading: isPriceLoading,
        kids: kids,
        product: SearchResults_objectSpread(SearchResults_objectSpread({}, product), {}, {
          childcareAvailabilities: _this.getChildcareAvailabilitiesForProduct(productId),
          departureDateOn: departureDateOn,
          price: price
        })
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getProducts", Object(lodash["memoize"])(function (_ref) {
      var products = _ref.products;
      return products.map(function (product) {
        return Object(redux["d" /* compose */])(Product_mapper["f" /* updateProductUrl */], Product_mapper["c" /* getProductProps */], Product_mapper["d" /* setProductHref */], _this.flattenResort)(product);
      });
    }));

    return _this;
  }

  Object(createClass["a" /* default */])(SearchResults, [{
    key: "getPriceForProduct",
    value: function getPriceForProduct(productId) {
      var product = this.props.prices.find(function (p) {
        return p.id === productId;
      });
      return Object(lodash["get"])(product, 'price', {});
    }
  }, {
    key: "getChildcareAvailabilitiesForProduct",
    value: function getChildcareAvailabilitiesForProduct(productId) {
      return this.props.childcareAvailabilities.filter(function (childcareAvailability) {
        return childcareAvailability.productId === productId;
      });
    }
  }, {
    key: "getProductWithModifier",

    /**
     * Mutate the products to set the price or the comparison mode
     * We mutate the product to re-render only the subcomponents which needed it
     */
    value: function getProductWithModifier() {
      var _this2 = this;

      return this.getProducts({
        products: this.props.resorts,
        prices: this.props.prices
      }).map(function (product, index) {
        return Object(Product_mapper["e" /* updateProduct */])(product, _this2.flattenResort(_this2.props.resorts[index]));
      });
    }
  }, {
    key: "withCallToAction",
    value: function withCallToAction() {
      var _this$props$config, _this$props$config$co, _this$props$config$co2, _this$props$config$co3;

      var _get = Object(lodash["get"])(this.props, 'config.common', {}),
          thumbnailCTA = _get.thumbnailCTA,
          thumbnailTourCTA = _get.thumbnailTourCTA;

      var seeMoreText = !!((_this$props$config = this.props.config) === null || _this$props$config === void 0 ? void 0 : (_this$props$config$co = _this$props$config.common) === null || _this$props$config$co === void 0 ? void 0 : (_this$props$config$co2 = _this$props$config$co.editorial) === null || _this$props$config$co2 === void 0 ? void 0 : (_this$props$config$co3 = _this$props$config$co2.search) === null || _this$props$config$co3 === void 0 ? void 0 : _this$props$config$co3.seeMoreText);
      return Boolean(thumbnailCTA || thumbnailTourCTA || seeMoreText);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          comparisonUrl = _this$props2.comparisonUrl,
          config = _this$props2.config,
          flexibility = _this$props2.flexibility,
          isProductComparisonModeAuthorized = _this$props2.isProductComparisonModeAuthorized,
          isProductComparisonSelectionModeEnabled = _this$props2.isProductComparisonSelectionModeEnabled,
          isProductsBottomInViewport = _this$props2.isProductsBottomInViewport,
          isProductsTopInViewport = _this$props2.isProductsTopInViewport,
          onClickCompareButton = _this$props2.onClickCompareButton,
          productsSelectedForComparison = _this$props2.productsSelectedForComparison,
          toggleProductComparisonSelectionMode = _this$props2.toggleProductComparisonSelectionMode,
          toggleProductSelectedForComparison = _this$props2.toggleProductSelectedForComparison,
          hasDepartureDate = _this$props2.hasDepartureDate,
          hasDepartureCity = _this$props2.hasDepartureCity,
          offer = _this$props2.offer,
          isSynchronousGrid = _this$props2.isSynchronousGrid;
      var display = this.props.hasSeeMore ? {
        mobile: 2,
        phablet: 4,
        tablet: 6,
        desktop: 6
      } : undefined;
      var products = this.props.prices.length === 0 && this.props.childcareAvailabilities.length === 0 ? this.getProducts({
        products: this.props.resorts,
        prices: this.props.prices
      }) : this.getProductWithModifier();
      var hasChildcareIncluded = this.props.childcareAvailabilities.length > 0;
      var childrenClassName = flexibility ? 'pt-5' : '';
      return SearchResults_jsx(react["Fragment"], null, isProductComparisonModeAuthorized ? SearchResults_jsx(SearchCompare_SearchCompare, {
        className: "mb-6",
        buttonLabel: Object(lodash["get"])(config, 'faceting.compare.buttonLabel'),
        cancelLabel: Object(lodash["get"])(config, 'faceting.compare.cancelLabel'),
        comparisonToggle: toggleProductComparisonSelectionMode,
        comparisonClick: onClickCompareButton,
        comparisonUrl: comparisonUrl,
        collapseLabel: Object(lodash["get"])(config, 'faceting.compare.collapseLabel'),
        dropzoneLabel: Object(lodash["get"])(config, 'faceting.compare.dropzoneLabel'),
        expandLabel: Object(lodash["get"])(config, 'faceting.compare.expandLabel'),
        isComparisonActive: isProductComparisonSelectionModeEnabled,
        isComparisonSubmitable: productsSelectedForComparison.length > 0 && hasDepartureDate && hasDepartureCity,
        isProductsBottomInViewport: isProductsBottomInViewport,
        isProductsTopInViewport: isProductsTopInViewport,
        mandatoryMessage: !hasDepartureDate || !hasDepartureCity ? Object(lodash["get"])(config, 'faceting.compare.dateAndTransportMandatory') : '',
        resultsCount: products.length,
        selectedItems: products.filter(function (product) {
          return productsSelectedForComparison.includes(product.id);
        }).map(function (product) {
          var _product$flag;

          return {
            header: product.header,
            id: product.id,
            order: productsSelectedForComparison.findIndex(function (p) {
              return p === product.id;
            }),
            picture: Object(lodash["get"])(product, 'thumbnail.pictures[0]'),
            price: Object(lodash["get"])(product, 'flag.price'),
            priceInfo: product === null || product === void 0 ? void 0 : (_product$flag = product.flag) === null || _product$flag === void 0 ? void 0 : _product$flag.priceInfo,
            url: product.url,
            offer: offer
          };
        }).sort(function (a, b) {
          return a.order - b.order;
        }),
        selectedItemsMax: faceting_constants["w" /* MAX_NUMBER_OF_SELECTED_PRODUCTS */],
        toggleProductSelectedForComparison: toggleProductSelectedForComparison
      }, this.props.title) : SearchResults_jsx(SiteContainer["a" /* SiteContainer */], null, this.props.title), SearchResults_jsx(SearchBanners_SearchBanners, {
        position: "top"
      }), SearchResults_jsx(SiteContainer["a" /* SiteContainer */], null, this.props.virtualizedGrid && !hasChildcareIncluded && !this.withCallToAction() ? SearchResults_jsx(ProductsGridVirtualized, {
        childrenClassName: childrenClassName,
        className: this.props.className,
        products: products,
        onComparisonClick: toggleProductSelectedForComparison
      }) : SearchResults_jsx(ProductsGrid["a" /* ProductsGrid */], {
        childrenClassName: childrenClassName,
        className: this.props.className,
        products: products,
        totalNumberToDisplay: this.props.resorts.length,
        seeMore: this.props.seeMore,
        onComparisonClick: toggleProductSelectedForComparison,
        hasSeeMore: this.props.hasSeeMore,
        display: display,
        offer: offer,
        isSynchronousGrid: isSynchronousGrid
      }), SearchResults_jsx("div", {
        id: "SearchCompareBeacon"
      })), SearchResults_jsx(SearchBanners_SearchBanners, {
        position: "terms"
      }));
    }
  }]);

  return SearchResults;
}(react["Component"]);

Object(defineProperty["a" /* default */])(SearchResults_SearchResults, "defaultProps", defaultProps);
// EXTERNAL MODULE: ./src/client/components/frameworks/grid-cell/Grid.cell.jsx
var Grid_cell = __webpack_require__("PCgT");

// EXTERNAL MODULE: ./src/client/components/frameworks/grid-row/Grid.row.jsx
var Grid_row = __webpack_require__("WzQP");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/store/search/query/searchQuery.action.js
var searchQuery_action = __webpack_require__("0ibg");

// EXTERNAL MODULE: ./src/client/store/search/search.selector.js
var search_selector = __webpack_require__("B3yO");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/departureCity.action.js
var departureCity_action = __webpack_require__("+mhw");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/adults.action.js
var adults_action = __webpack_require__("VO7D");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/kids.action.js
var kids_action = __webpack_require__("1bWg");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-no-results/CriteriaControl.jsx
var CriteriaControl_jsx = react_default.a.createElement;



function CriteriaControl(props) {
  var children = props.children,
      iconLeft = props.iconLeft,
      onClear = props.onClear,
      id = props.id;
  if (!react["Children"].count(children)) return null;
  return CriteriaControl_jsx("div", {
    className: "inline-block rtl:mr-3 mb-3"
  }, CriteriaControl_jsx("div", {
    className: "border-1 rounded-sm flex outline-custom px-3 relative rounded-tiny transition-colors bg-white border-gray-medium text-gray-darker",
    style: {
      height: 41
    }
  }, !!iconLeft && CriteriaControl_jsx("div", {
    className: "flex items-center justify-center rtl:pr-3"
  }, CriteriaControl_jsx(Icon["a" /* Icon */], {
    name: iconLeft,
    width: "0.875rem"
  })), CriteriaControl_jsx("div", {
    className: "flex relative"
  }, CriteriaControl_jsx("span", {
    className: "flex items-center justify-center rtl:pr-3 font-sans text-base leading-4 capitalize"
  }, children), CriteriaControl_jsx("button", {
    className: "reset-button leading-none rtl:pl-3 transition-color text-gray-darker",
    "data-testid": id,
    onClick: onClear,
    type: "button"
  }, CriteriaControl_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-no-results/CriteriaControls.jsx



var CriteriaControls_jsx = react_default.a.createElement;





















var CriteriaControls_CriteriaControls = function CriteriaControls() {
  var searchQuery = Object(es["e" /* useSelector */])(faceting_selector["m" /* searchQuerySelector */]);
  var keywords = Object(es["e" /* useSelector */])(search_selector["a" /* keywordsSelector */]);
  var facettesFilters = Object(es["e" /* useSelector */])(faceting_selector["h" /* filtersSelector */]);

  var _useState = Object(react["useState"])(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.label),
      searchQueryLabel = _useState[0],
      setSearchQueryLabel = _useState[1];

  var _useState2 = Object(react["useState"])(facettesFilters),
      facettes = _useState2[0],
      setFacettes = _useState2[1];

  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);

  var _useState3 = Object(react["useState"])(departureDate),
      departureDateCriteria = _useState3[0],
      setDepartureDateCriteria = _useState3[1];

  var tripDuration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var adultsNumber = Object(es["e" /* useSelector */])(storeHelper["b" /* getAdultsNumber */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);

  var _useState4 = Object(react["useState"])(adultsNumber),
      adultsNumberState = _useState4[0],
      setAdultsNumberState = _useState4[1];

  var departureCityCode = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  Object(react["useEffect"])(function () {
    setFacettes(facettesFilters);
    setAdultsNumberState(adultsNumber);
  }, [JSON.stringify(facettesFilters), adultsNumber]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var labelParts = '';

  if (adultsNumberState > 0) {
    var labelPartsTmp = [];
    var lengthPeople = adultsNumber + kids.length;

    if (lengthPeople) {
      if (adultsNumber >= 1) {
        labelPartsTmp.push(Object(src_i18n["f" /* t */])('booking.form.selectAdultsLabels', {
          count: adultsNumber
        }));
      }

      if (kids.length >= 1) {
        labelPartsTmp.push(Object(src_i18n["f" /* t */])('booking.form.selectChildrenLabels', {
          count: kids.length
        }));
      }

      labelParts = labelPartsTmp.join(' - ');
    }
  }

  var isFromAutoComplete = Boolean(searchQuery.type);
  var searchTerms = isFromAutoComplete || searchQuery.label ? searchQuery.label : keywords;
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'search',
    actionGA: 'search',
    searchReferrer: 'search',
    searchTerms: searchTerms || ''
  });

  var removeDepartureDateCriteria = function removeDepartureDateCriteria() {
    return setDepartureDateCriteria(null);
  };

  var removeFacetCriteria = function removeFacetCriteria(_ref) {
    var id = _ref.id,
        name = _ref.name;
    return setFacettes(Object(toConsumableArray["a" /* default */])(facettes).filter(function (_ref2) {
      var facetteId = _ref2.id,
          facetteName = _ref2.name;
      return id !== facetteId || name !== facetteName;
    }));
  };

  var clearSearchQuery = function clearSearchQuery() {
    return setSearchQueryLabel('');
  };

  var submitFilters = function submitFilters() {
    track({
      labelGA: 'noResult_applyCriterias'
    });
    Object(es["b" /* batch */])(function () {
      dispatch(Object(facetingSearch_action["q" /* updateFilters */])(facettes));

      if (!departureDateCriteria) {
        dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
      }

      if (searchQueryLabel !== (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.label)) {
        if (keywords) {
          dispatch(Object(searchQuery_action["a" /* setKeywords */])(''));
        }

        dispatch(Object(facetingSearch_action["o" /* setSearchQuery */])({
          label: ''
        }));
      }

      var previousDepartureCity = facettesFilters.find(function (_ref3) {
        var id = _ref3.id;
        return id === faceting_constants["j" /* DEPARTURE_CITY_FACET_ID */];
      });
      var departureCity = facettes.find(function (_ref4) {
        var id = _ref4.id;
        return id === faceting_constants["j" /* DEPARTURE_CITY_FACET_ID */];
      });

      if (!departureCity && previousDepartureCity) {
        dispatch(Object(departureCity_action["a" /* setDepartureCity */])({
          value: null
        }));
      }

      if (!adultsNumberState && adultsNumber) {
        dispatch(Object(adults_action["b" /* setAdultsNumber */])(0));
        dispatch(Object(kids_action["b" /* setKids */])([]));
        dispatch(Object(facetingSearch_action["b" /* changeKidsNumber */])(0));
        dispatch(Object(facetingSearch_action["n" /* setKidsValidationState */])([]));
      }
    });
  };

  var cleanCriteria = /*#__PURE__*/function () {
    var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              track({
                labelGA: 'noResult_resetCriterias'
              });
              Object(es["b" /* batch */])(function () {
                if (adultsNumberState) {
                  dispatch(Object(adults_action["b" /* setAdultsNumber */])(0));
                  dispatch(Object(kids_action["b" /* setKids */])([]));
                  dispatch(Object(facetingSearch_action["b" /* changeKidsNumber */])(0));
                  dispatch(Object(facetingSearch_action["n" /* setKidsValidationState */])([]));
                }

                if (keywords) {
                  dispatch(Object(searchQuery_action["a" /* setKeywords */])(''));
                }
              });
              return _context.abrupt("return", dispatch(Object(facetingSearch_action["i" /* resetCriteria */])()));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function cleanCriteria() {
      return _ref5.apply(this, arguments);
    };
  }();

  var clearParticipants = function clearParticipants() {
    return setAdultsNumberState(0);
  };

  var noTransport = departureCityCode === 'NO';
  return CriteriaControls_jsx(react["Fragment"], null, searchQueryLabel && CriteriaControls_jsx(CriteriaControl, {
    onClear: clearSearchQuery,
    iconLeft: icons["a" /* ICONS */].SEARCH_GLASS
  }, searchQueryLabel), departureDateCriteria && CriteriaControls_jsx(CriteriaControl, {
    onClear: removeDepartureDateCriteria,
    iconLeft: icons["a" /* ICONS */].DATE,
    id: "departure_date"
  }, "".concat(moment_default()(departureDateCriteria).format('DD MMM'), " - ").concat(moment_default()(departureDateCriteria).add({
    days: tripDuration || duration_constants["b" /* DEFAULT_TRIP_DURATION */]
  }).format('DD MMM'))), !!labelParts && CriteriaControls_jsx(CriteriaControl, {
    onClear: clearParticipants,
    iconLeft: icons["a" /* ICONS */].USERS,
    key: "participants",
    id: "participants"
  }, labelParts), facettes.filter(function (_ref6) {
    var id = _ref6.id;
    return id === faceting_constants["j" /* DEPARTURE_CITY_FACET_ID */];
  }).map(function (_ref7) {
    var id = _ref7.id,
        name = _ref7.name,
        label = _ref7.label;
    return CriteriaControls_jsx(CriteriaControl, {
      onClear: function onClear() {
        return removeFacetCriteria({
          id: id,
          name: name
        });
      },
      iconLeft: noTransport ? icons["a" /* ICONS */].NO_TRANSPORT : icons["a" /* ICONS */].TRANSPORT,
      key: name,
      id: name
    }, noTransport ? label : "".concat(Object(src_i18n["f" /* t */])('common.transport.from'), " ").concat(label));
  }), facettes.filter(function (_ref8) {
    var id = _ref8.id;
    return id === faceting_constants["o" /* DESTINATIONS_FACET_ID */] || id === faceting_constants["f" /* COUNTRIES_FACET_ID */];
  }).map(function (_ref9) {
    var id = _ref9.id,
        name = _ref9.name;
    return CriteriaControls_jsx(CriteriaControl, {
      iconLeft: icons["a" /* ICONS */].EARTH_PLANE,
      onClear: function onClear() {
        return removeFacetCriteria({
          id: id,
          name: name
        });
      },
      key: name,
      id: name
    }, name);
  }), facettes.filter(function (_ref10) {
    var id = _ref10.id;
    return id === faceting_constants["a" /* ACTIVITIES_FACET_ID */];
  }).map(function (_ref11) {
    var id = _ref11.id,
        name = _ref11.name;
    return CriteriaControls_jsx(CriteriaControl, {
      iconLeft: icons["a" /* ICONS */].ACTIVITIES,
      onClear: function onClear() {
        return removeFacetCriteria({
          id: id,
          name: name
        });
      },
      key: name,
      id: name
    }, name.split('|')[1]);
  }), facettes.filter(function (_ref12) {
    var id = _ref12.id;
    return id === faceting_constants["B" /* TYPES_OF_STAY_FACET_ID */];
  }).map(function (_ref13) {
    var id = _ref13.id,
        name = _ref13.name;
    return CriteriaControls_jsx(CriteriaControl, {
      key: name,
      id: name,
      iconLeft: icons["a" /* ICONS */].BEACH,
      onClear: function onClear() {
        return removeFacetCriteria({
          id: id,
          name: name
        });
      }
    }, Object(src_i18n["f" /* t */])("faceting.typesOfStay.label_".concat(name.toLowerCase())));
  }), facettes.filter(function (_ref14) {
    var id = _ref14.id;
    return id === faceting_constants["q" /* FACET_COMFORT_ID */];
  }).map(function (_ref15) {
    var id = _ref15.id,
        name = _ref15.name;
    return CriteriaControls_jsx(CriteriaControl, {
      key: name,
      id: name,
      iconLeft: icons["a" /* ICONS */].TRIDENT1,
      onClear: function onClear() {
        return removeFacetCriteria({
          id: id,
          name: name
        });
      }
    }, name);
  }), CriteriaControls_jsx("div", null, CriteriaControls_jsx("div", {
    className: "inline-flex flex-col-reverse md:flex md:flex-row mt-4 justify-between"
  }, CriteriaControls_jsx("button", {
    className: "cursor-pointer text-gray-darker inline-flex flex items-center bg-transparent mt-4 md:mt-0",
    type: "button",
    "data-testid": "reset-filters",
    onClick: cleanCriteria
  }, CriteriaControls_jsx("span", {
    className: "text-base underline"
  }, Object(src_i18n["f" /* t */])('common.comparator.resetCriteria'))), CriteriaControls_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    onClick: submitFilters,
    dataTestId: "apply-filters",
    size: "medium"
  }, Object(src_i18n["f" /* t */])('common.apply')))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/webcallback/WebCallbackTrigger.jsx + 3 modules
var WebCallbackTrigger = __webpack_require__("PZXw");

// EXTERNAL MODULE: ./config/index.js
var config_0 = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config_0);

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-no-results/CallCenterBlock.jsx

var CallCenterBlock_jsx = react_default.a.createElement;









var CallCenterBlock_Contact = function Contact(_ref) {
  var text = _ref.text,
      textLtr = _ref.textLtr,
      secondaryText = _ref.secondaryText,
      iconName = _ref.iconName,
      className = _ref.className,
      url = _ref.url;
  var Comp = url ? 'a' : 'div';
  var link = url ? {
    href: url
  } : undefined;
  return CallCenterBlock_jsx(Comp, Object(esm_extends["a" /* default */])({
    className: className
  }, link), CallCenterBlock_jsx(Icon["a" /* Icon */], {
    name: iconName,
    color: colors["a" /* COLORS */].BLUE,
    width: "1.875rem"
  }), CallCenterBlock_jsx("div", {
    className: "text-blue"
  }, CallCenterBlock_jsx("p", {
    className: "text-xl font-bold m-0",
    dir: textLtr ? 'ltr' : ''
  }, text), CallCenterBlock_jsx("p", {
    className: classnames_default()('text-sm m-0', {
      underline: !url
    })
  }, secondaryText)));
};

function CallCenterBlock() {
  var isWebCallbackEnabled = config_default.a.get('freespee.enabled');
  return CallCenterBlock_jsx("div", {
    style: {
      background: 'rgba(0,85,137,0.05)'
    }
  }, CallCenterBlock_jsx("div", {
    className: "text-center p-4"
  }, CallCenterBlock_jsx("p", {
    className: "text-2xl text-blue font-brand m-0 mt-4"
  }, Object(src_i18n["f" /* t */])('navigationBar.contact.title')), CallCenterBlock_jsx("p", {
    className: "text-md text-sans"
  }, Object(src_i18n["f" /* t */])('remote.noResult.contactAdvisors')), CallCenterBlock_jsx("div", {
    className: "lg:flex justify-around"
  }, CallCenterBlock_jsx(CallCenterBlock_Contact, {
    text: Object(src_i18n["f" /* t */])('navigationBar.contact.phoneNumber'),
    textLtr: true,
    secondaryText: Object(src_i18n["f" /* t */])('navigationBar.contact.toll'),
    url: "tel:".concat(Object(src_i18n["f" /* t */])('navigationBar.contact.phoneNumber')),
    iconName: icons["a" /* ICONS */].PHONE_BUBBLE
  }), isWebCallbackEnabled && CallCenterBlock_jsx(WebCallbackTrigger["a" /* WebCallbackTrigger */], {
    trackingData: {
      actionGA: 'search'
    },
    theme: "search"
  }, CallCenterBlock_jsx(CallCenterBlock_Contact, {
    text: Object(src_i18n["f" /* t */])('remote.noResult.callBackLabel'),
    secondaryText: Object(src_i18n["f" /* t */])('remote.noResult.callBackSchedule'),
    className: "mt-4 lg:mt-0",
    iconName: icons["a" /* ICONS */].CALLMEBACK
  })))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-no-results/SearchNoResults.jsx
var SearchNoResults_jsx = react_default.a.createElement;





var SearchNoResults = /*#__PURE__*/Object(react["memo"])(function (_ref) {
  var explanation = _ref.explanation,
      title = _ref.title,
      isSeller = _ref.isSeller;
  return SearchNoResults_jsx(Grid_row["a" /* GridRow */], {
    className: "text-center md:text-initial"
  }, SearchNoResults_jsx(Grid_cell["a" /* GridCell */], {
    cols: {
      M: 7,
      XS: 12
    }
  }, SearchNoResults_jsx("div", {
    className: "my-4 lg:my-6"
  }, SearchNoResults_jsx("p", {
    className: "my-4 font-brand text-md md:text-xl lg:text-2xl"
  }, title), SearchNoResults_jsx("p", null, explanation), SearchNoResults_jsx(CriteriaControls_CriteriaControls, null))), !isSeller ? SearchNoResults_jsx(Grid_cell["a" /* GridCell */], {
    cols: {
      M: 5,
      XS: 12
    }
  }, SearchNoResults_jsx("div", {
    className: "my-4 lg:my-6"
  }, SearchNoResults_jsx(CallCenterBlock, null))) : SearchNoResults_jsx("div", null));
});
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/grid/Grid.jsx + 2 modules
var Grid = __webpack_require__("uLWw");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-results-placeholder/SearchResultsPlaceholder.jsx
var SearchResultsPlaceholder_jsx = react_default.a.createElement;




var ratio = ratios_utils["a" /* default */].values.XL;
var SearchResultsPlaceholder_SearchResultsPlaceholder = function SearchResultsPlaceholder(_ref) {
  var nbItems = _ref.nbItems;
  return SearchResultsPlaceholder_jsx(Grid["a" /* default */], null, Object(lodash["fill"])(Array(nbItems)).map(function (a, i) {
    return SearchResultsPlaceholder_jsx("article", {
      className: "relative flex flex-col bg-white",
      "data-testid": "search-results-placeholder-item",
      key: i
    }, SearchResultsPlaceholder_jsx("div", {
      className: "bg-gray-lighter",
      style: {
        paddingBottom: "".concat(100 * ratio, "%")
      }
    }), SearchResultsPlaceholder_jsx("div", {
      className: "relative bg-white"
    }, SearchResultsPlaceholder_jsx("div", {
      className: "flex items-stretch w-full no-underline text-inherit"
    }, SearchResultsPlaceholder_jsx("div", {
      className: "flex-col flex-1 overflow-hidden py-1"
    }, SearchResultsPlaceholder_jsx("div", {
      className: "bg-gray-lighter mb-1 flex w-3/5 mt-1 mb-2 w-4/5",
      style: {
        height: '0.6rem'
      }
    }), SearchResultsPlaceholder_jsx("div", {
      className: "bg-gray-lighter mb-1 flex w-3/5",
      style: {
        height: '0.6rem'
      }
    })))));
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: /home/circleci/project/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./src/utils/pertimm-client/filters.js
var pertimm_client_filters = __webpack_require__("y0S3");

// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-results-title/SearchResultsTitle.jsx
var SearchResultsTitle_jsx = react_default.a.createElement;
// $FlowFixMe (see https://github.com/facebook/flow/pull/7111)



function SearchResultsTitle(props) {
  var singularLabel = props.singularLabel,
      pluralLabel = props.pluralLabel,
      resultsCount = props.resultsCount;

  if (!resultsCount || !singularLabel || !pluralLabel) {
    return null;
  }

  return SearchResultsTitle_jsx("h2", {
    className: "reset-heading font-brand font-bold leading-tight text-xl md:text-3xl"
  }, SearchResultsTitle_jsx("span", {
    className: "font-normal",
    dangerouslySetInnerHTML: {
      __html: Object(dist["messageFormat"])(Object(labelUtils["d" /* pluralizeLabel */])(singularLabel, pluralLabel, resultsCount)).format({
        nbResults: "<strong class=\"text-blue\">".concat(resultsCount, "</strong>")
      })
    }
  }));
}
/* harmony default export */ var search_results_title_SearchResultsTitle = (/*#__PURE__*/Object(react["memo"])(SearchResultsTitle));
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/FacetSearchResults.jsx
var FacetSearchResults_jsx = react_default.a.createElement;





























function mapStateToProps(state) {
  var _state$faceting = state.faceting,
      _state$faceting$child = _state$faceting.childcareAvailabilities,
      childcareAvailabilities = _state$faceting$child === void 0 ? [] : _state$faceting$child,
      isDateRequired = _state$faceting.isDateRequired,
      isLoading = _state$faceting.isLoading,
      _state$faceting$isPri = _state$faceting.isPriceLoading,
      isPriceLoading = _state$faceting$isPri === void 0 ? false : _state$faceting$isPri,
      isSelectionModeEnabled = _state$faceting.isSelectionModeEnabled,
      _state$faceting$noRes = _state$faceting.noResults,
      noResults = _state$faceting$noRes === void 0 ? false : _state$faceting$noRes,
      pertimmInterpretations = _state$faceting.pertimmInterpretations,
      _state$faceting$price = _state$faceting.prices,
      prices = _state$faceting$price === void 0 ? [] : _state$faceting$price,
      productsSelectedForComparison = _state$faceting.productsSelectedForComparison,
      query = _state$faceting.query,
      _state$tripInformatio = state.tripInformation,
      _state$tripInformatio2 = _state$tripInformatio.adults,
      adults = _state$tripInformatio2 === void 0 ? [] : _state$tripInformatio2,
      kids = _state$tripInformatio.kids;
  return {
    activeFacets: Object(faceting_selector["a" /* activeFacetsSelector */])(state),
    adultsNumber: adults.length || adults_constants["a" /* DEFAULT_ADULTS_NB */],
    childcareAvailabilities: childcareAvailabilities,
    departureCity: Object(tripCriteria_selector["a" /* getDepartureCity */])(state),
    departureDate: Object(tripCriteria_selector["b" /* getDepartureDate */])(state),
    duration: Object(tripCriteria_selector["c" /* getTripDuration */])(state),
    filteredProducts: Object(faceting_selector["g" /* filteredProductsSelector */])(state),
    filters: Object(faceting_selector["j" /* getFiltersSelector */])(state),
    flexibility: Object(tripCriteria_selector["d" /* getTripFlexibility */])(state),
    isDateRequired: isDateRequired,
    isLoading: isLoading,
    isPriceLoading: isPriceLoading,
    isProductComparisonSelectionModeEnabled: isSelectionModeEnabled,
    kids: kids,
    noResults: noResults,
    pertimmInterpretations: pertimmInterpretations,
    prices: prices,
    productsSelectedForComparison: productsSelectedForComparison,
    query: query,
    recommandedProducts: Object(faceting_selector["l" /* recommandedProductsSelector */])(state)
  };
}

var FacetSearchResults_FacetSearchResults = function FacetSearchResults(_ref) {
  var i18n = _ref.i18n,
      initialProducts = _ref.initialProducts,
      _ref$isProductCompari = _ref.isProductComparisonModeAuthorized,
      isProductComparisonModeAuthorized = _ref$isProductCompari === void 0 ? false : _ref$isProductCompari,
      _ref$isSynchronousGri = _ref.isSynchronousGrid,
      isSynchronousGrid = _ref$isSynchronousGri === void 0 ? false : _ref$isSynchronousGri,
      resultsHasSeeMore = _ref.resultsHasSeeMore,
      resultsSeeMore = _ref.resultsSeeMore,
      _ref$searchOptions = _ref.searchOptions,
      searchOptions = _ref$searchOptions === void 0 ? {} : _ref$searchOptions,
      _ref$shouldSetDefault = _ref.shouldSetDefaultDepartureCityOnCompare,
      shouldSetDefaultDepartureCityOnCompare = _ref$shouldSetDefault === void 0 ? false : _ref$shouldSetDefault,
      virtualizedGrid = _ref.virtualizedGrid,
      _ref$offer = _ref.offer,
      offer = _ref$offer === void 0 ? {} : _ref$offer;

  var _useSelector = Object(es["e" /* useSelector */])(mapStateToProps),
      activeFacets = _useSelector.activeFacets,
      adultsNumber = _useSelector.adultsNumber,
      childcareAvailabilities = _useSelector.childcareAvailabilities,
      departureCity = _useSelector.departureCity,
      departureDate = _useSelector.departureDate,
      duration = _useSelector.duration,
      filteredProducts = _useSelector.filteredProducts,
      filters = _useSelector.filters,
      flexibility = _useSelector.flexibility,
      isDateRequired = _useSelector.isDateRequired,
      isLoading = _useSelector.isLoading,
      isPriceLoading = _useSelector.isPriceLoading,
      isProductComparisonSelectionModeEnabled = _useSelector.isProductComparisonSelectionModeEnabled,
      kids = _useSelector.kids,
      noResults = _useSelector.noResults,
      pertimmInterpretations = _useSelector.pertimmInterpretations,
      prices = _useSelector.prices,
      productsSelectedForComparison = _useSelector.productsSelectedForComparison,
      query = _useSelector.query,
      recommandedProducts = _useSelector.recommandedProducts;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var filteredProductsRef = Object(react["useRef"])(null);
  var dispatch = Object(es["d" /* useDispatch */])(); // This state, the updateCompareButtonStickyStatus function and the first effect should be moved to SearchCompare

  var _useState = Object(react["useState"])(true),
      isProductsTopInViewport = _useState[0],
      setProductsTopInViewport = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isProductsBottomInViewport = _useState2[0],
      setProductsBottomInViewport = _useState2[1];

  var updateCompareButtonStickyStatus = Object(lodash["throttle"])(function () {
    if (filteredProducts.length > 0 && filteredProductsRef.current) {
      var searchResultsWrapperClientRect = filteredProductsRef.current.getBoundingClientRect();
      var clientHeight = dist["windowWrapper"].getClientHeight();
      setProductsTopInViewport(searchResultsWrapperClientRect.top <= clientHeight);
      setProductsBottomInViewport(searchResultsWrapperClientRect.bottom <= clientHeight);
    }
  }, 200);
  Object(react["useEffect"])(function () {
    if (isProductComparisonModeAuthorized) {
      document.removeEventListener('scroll', updateCompareButtonStickyStatus, false);
      document.addEventListener('scroll', updateCompareButtonStickyStatus, false);
    }

    if (initialProducts && initialProducts.length > 0) {
      dispatch(Object(facetingSearch_action["l" /* setInitialProductPrices */])(initialProducts));
    }
  }, []);
  var productIds = [];
  productIds = Object(react["useMemo"])(function () {
    return (filteredProducts.length !== 0 ? filteredProducts : recommandedProducts).map(function (product) {
      return product.id;
    });
  }, [filteredProducts.length !== 0 ? filteredProducts : recommandedProducts]);
  Object(react["useEffect"])(function () {
    if (productIds && productIds.length > 0 && !isLoading) {
      var _ref2 = pertimmInterpretations || {},
          minDate = _ref2.minDate,
          maxDate = _ref2.maxDate;

      var boutique = searchOptions.boutique,
          defaultDepartureCity = searchOptions.defaultDepartureCity,
          offerId = searchOptions.offerId,
          offerName = searchOptions.offerName;

      var _getFlexibilityDates = Object(pertimm_client_filters["f" /* getFlexibilityDates */])({
        departureDate: departureDate,
        flexibility: flexibility
      }),
          minDepartureDate = _getFlexibilityDates.minDepartureDate,
          maxDepartureDate = _getFlexibilityDates.maxDepartureDate;

      var withFlexibility = flexibility && departureDate;
      dispatch(pricesRequestAction({
        appContext: appContext,
        criteria: {
          boutique: boutique,
          defaultDepartureCity: defaultDepartureCity,
          departureDate: departureDate,
          duration: duration,
          filters: filters,
          maxDate: withFlexibility ? Number(maxDepartureDate) : maxDate,
          minDate: withFlexibility ? Number(minDepartureDate) : minDate,
          offerId: offerId,
          offerName: offerName,
          productIds: productIds,
          query: query ? query.label : ''
        },
        withFlexibility: withFlexibility
      }));
    }
    /**
     * Component should fetch childcare availabilities
     * if availabilities don't exist yet
     * and if there are eligeable kids
     */


    var childcareProductIds = childcareAvailabilities.map(function (childcareAvailability) {
      return childcareAvailability.productId;
    });
    var productsWithoutChildcareAvailabilities = productIds.filter(function (id) {
      return !childcareProductIds.includes(id);
    });
    var kidsWithChildcare = kids.filter(function (kid) {
      return kid.birthdate;
    });

    if (productsWithoutChildcareAvailabilities.length > 0 && kidsWithChildcare.length > 0 && departureDate) {
      dispatch(childcareRequestAction({
        appContext: appContext,
        criteria: {
          departureDate: departureDate,
          duration: duration || duration_constants["b" /* DEFAULT_TRIP_DURATION */],
          kids: kidsWithChildcare,
          productIds: productIds
        }
      }));
    }
  }, [departureCity, productIds, kids, flexibility, isLoading]);
  Object(react["useEffect"])(function () {
    if (!isDateRequired && !departureDate) {
      dispatch(setProductComparisonSelectionMode(false));
    }
  }, [isDateRequired]);

  var computeFacetsToCXOParams = function computeFacetsToCXOParams() {
    var destinations = filteredProducts.filter(function (product) {
      return productsSelectedForComparison.indexOf(Object(lodash["get"])(product, 'id')) !== -1;
    }).map(function (destination) {
      return Object(lodash["get"])(destination, 'name');
    });
    var activities = activeFacets[faceting_constants["a" /* ACTIVITIES_FACET_ID */]] ? Object.keys(activeFacets[faceting_constants["a" /* ACTIVITIES_FACET_ID */]]) : null;
    return [Object(facetingUtils["d" /* getDepartureDateDisplayValue */])(departureDate), departureCity, destinations && destinations.length > 0 ? destinations.join(' / ') : null, adultsNumber, kids.length, activities && activities.length > 0 ? activities.join(' / ') : null, // activities
    adultsNumber + kids.length, // participants
    kids.some(function (kid) {
      return kid.childcareIncluded;
    })];
  };

  var onClickCompareButton = function onClickCompareButton() {
    dispatch(Object(globalLoader_action["d" /* startLoading */])());

    if (Object(sellerUtils["g" /* isSeller */])(appContext)) {
      Object(sellerUtils["l" /* sendFacetsToCxO */])(computeFacetsToCXOParams());
    }
  };

  var toggleProductComparisonSelectionMode = function toggleProductComparisonSelectionMode() {
    dispatch(setProductComparisonSelectionMode(!isProductComparisonSelectionModeEnabled));

    if (shouldSetDefaultDepartureCityOnCompare && !departureCity && !isProductComparisonSelectionModeEnabled) {
      dispatch(Object(facetingSearch_action["a" /* changeDepartureCity */])(departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */]));
    }
  };

  var getCompareUrl = function getCompareUrl() {
    var url = routeBuilder["b" /* urlPattern */]('comparator');
    return getUrlWithUnpersistedData({
      url: url,
      query: query,
      productIdsToCompare: productsSelectedForComparison,
      departureCity: departureCity,
      departureDate: departureDate,
      duration: duration
    });
  };

  var toggleProductSelectedForComparison = function toggleProductSelectedForComparison() {
    if (isProductComparisonSelectionModeEnabled) {
      return function (productId) {
        return dispatch(toggleProductSelected(productId));
      };
    }
  };

  var hasDepartureDate = !!departureDate;
  var hasDepartureCity = !!departureCity;
  var resultsCount = filteredProducts.length;
  var shouldDisplayResults = resultsCount > 0 && !isLoading && !noResults;
  var comparisonUrl = getCompareUrl();

  if (noResults && !isLoading) {
    var _i18n$remote, _i18n$remote$noResult;

    var _title = FacetSearchResults_jsx(Title["a" /* Title */], {
      theme: "title-brand-9"
    }, Object(src_i18n["f" /* t */])('remote.noResult.recommendation.title'));

    return FacetSearchResults_jsx(react["Fragment"], null, FacetSearchResults_jsx(head_default.a, null, FacetSearchResults_jsx("title", null, i18n === null || i18n === void 0 ? void 0 : (_i18n$remote = i18n.remote) === null || _i18n$remote === void 0 ? void 0 : (_i18n$remote$noResult = _i18n$remote.noResult) === null || _i18n$remote$noResult === void 0 ? void 0 : _i18n$remote$noResult.zeroResult)), FacetSearchResults_jsx(SiteContainer["a" /* SiteContainer */], null, FacetSearchResults_jsx("div", {
      "data-testid": "facet-search-no-results"
    }, FacetSearchResults_jsx(SearchNoResults, {
      title: Object(src_i18n["f" /* t */])('remote.noResult.explanation'),
      explanation: Object(src_i18n["f" /* t */])('remote.noResult.updateCriteria'),
      isSeller: Object(sellerUtils["g" /* isSeller */])(appContext)
    })), recommandedProducts.length !== 0 ? FacetSearchResults_jsx("div", {
      "data-testid": "facet-search-recommanded-results"
    }, FacetSearchResults_jsx(SearchResults_SearchResults, {
      childcareAvailabilities: childcareAvailabilities,
      className: "pb-24 lg:pb-10",
      comparisonUrl: comparisonUrl,
      config: i18n,
      displayValidationButton: !Object(sellerUtils["g" /* isSeller */])(appContext),
      hasSeeMore: false,
      isPriceLoading: isPriceLoading,
      isProductsBottomInViewport: isProductsBottomInViewport,
      isProductComparisonSelectionModeEnabled: false,
      isProductComparisonModeAuthorized: false,
      isProductsTopInViewport: isProductsTopInViewport,
      isSynchronousGrid: isSynchronousGrid,
      offer: offer,
      onClickCompareButton: onClickCompareButton,
      prices: prices,
      resorts: recommandedProducts,
      title: _title,
      toggleProductComparisonSelectionMode: toggleProductComparisonSelectionMode,
      virtualizedGrid: virtualizedGrid
    })) : FacetSearchResults_jsx("div", null)));
  }

  if (isLoading || !resultsCount) {
    return FacetSearchResults_jsx("div", {
      "data-testid": "facet-search-results"
    }, FacetSearchResults_jsx(SiteContainer["a" /* SiteContainer */], null, FacetSearchResults_jsx(SearchResultsPlaceholder_SearchResultsPlaceholder, {
      nbItems: 8
    })), ")");
  }

  var title = FacetSearchResults_jsx(SearchResultsTitle, {
    pluralLabel: Object(src_i18n["f" /* t */])('faceting.nbResortsThatMatchYourCriteria'),
    resultsCount: filteredProducts.length,
    singularLabel: Object(src_i18n["f" /* t */])('faceting.oneResortThatMatchYourCriteria')
  });

  return FacetSearchResults_jsx("div", {
    ref: filteredProductsRef,
    "data-testid": "facet-search-results"
  }, shouldDisplayResults && FacetSearchResults_jsx(SearchResults_SearchResults, {
    className: "pb-24 lg:pb-10",
    departureDate: departureDate,
    flexibility: flexibility,
    title: title,
    config: i18n,
    offer: offer,
    resorts: filteredProducts,
    prices: prices,
    isPriceLoading: isPriceLoading,
    childcareAvailabilities: childcareAvailabilities,
    isProductComparisonSelectionModeEnabled: isProductComparisonSelectionModeEnabled && resultsCount > 0,
    productsSelectedForComparison: productsSelectedForComparison,
    maxSelectableItems: faceting_constants["w" /* MAX_NUMBER_OF_SELECTED_PRODUCTS */],
    toggleProductSelectedForComparison: toggleProductSelectedForComparison(),
    toggleProductComparisonSelectionMode: toggleProductComparisonSelectionMode,
    displayValidationButton: !Object(sellerUtils["g" /* isSeller */])(appContext),
    hasSeeMore: resultsHasSeeMore,
    seeMore: resultsSeeMore,
    isSynchronousGrid: isSynchronousGrid,
    kids: kids,
    virtualizedGrid: virtualizedGrid,
    isProductComparisonModeAuthorized: isProductComparisonModeAuthorized,
    onClickCompareButton: onClickCompareButton,
    comparisonUrl: comparisonUrl,
    isProductsBottomInViewport: isProductsBottomInViewport,
    isProductsTopInViewport: isProductsTopInViewport,
    hasDepartureDate: hasDepartureDate,
    hasDepartureCity: hasDepartureCity
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/choice-list/ChoiceList.jsx
var ChoiceList = __webpack_require__("c18e");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetLabel.jsx
var FacetLabel_jsx = react_default.a.createElement;

function FacetLabel(_ref) {
  var children = _ref.children,
      count = _ref.count;

  if (!children) {
    // Safeguard: API can return facets with null names, that must be ignored.
    return null;
  }

  return FacetLabel_jsx(react["Fragment"], null, FacetLabel_jsx("span", {
    className: "capitalize"
  }, children.toLowerCase()), FacetLabel_jsx("span", {
    className: "mx-2 font-bold text-gray-medium"
  }, "(", count, ")"));
}
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetList.jsx
var FacetList_jsx = react_default.a.createElement;




var FacetList_defaultProps = {
  listClassName: ''
};

var FacetList_getChoices = function getChoices(_ref) {
  var facets = _ref.facets,
      activeFacets = _ref.activeFacets;
  // Safeguard: API can return facets with null names, that must be ignored.
  return facets.filter(function (_ref2) {
    var label = _ref2.label;
    return !!label;
  }).map(function (_ref3) {
    var label = _ref3.label,
        count = _ref3.count,
        value = _ref3.value;
    return {
      label: FacetList_jsx(FacetLabel, {
        count: count
      }, label),
      value: value,
      isSelected: activeFacets && activeFacets[value]
    };
  });
};

var FacetList_FacetList = function FacetList(props) {
  return FacetList_jsx(ChoiceList["a" /* ChoiceList */], {
    choices: FacetList_getChoices(props),
    className: classnames_default()('FacetList', props.className),
    listClassName: props.listClassName,
    name: props.name,
    onChange: props.onChange,
    title: props.title
  });
};
FacetList_FacetList.defaultProps = FacetList_defaultProps;
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetCategory.jsx

var FacetCategory_jsx = react_default.a.createElement;

function FacetCategory_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FacetCategory_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FacetCategory_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FacetCategory_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var FacetCategory_FacetCategory = function FacetCategory(_ref) {
  var facetsFromSearch = _ref.facetsFromSearch,
      onChange = _ref.onChange,
      templateConfig = _ref.templateConfig,
      activeFacets = _ref.activeFacets;
  var facetId = templateConfig.id,
      _templateConfig$facet = templateConfig.facetLists,
      facetListsConfig = _templateConfig$facet === void 0 ? [] : _templateConfig$facet;

  var localizeFacetLabel = function localizeFacetLabel(facet, facetLabelsFolder) {
    if (!facetLabelsFolder) {
      return facet;
    }

    var localizedLabel = Object(src_i18n["f" /* t */])("".concat(facetLabelsFolder, ".label_").concat(facet.value.toLowerCase()));

    if (!localizedLabel) {
      return facet;
    }

    return FacetCategory_objectSpread(FacetCategory_objectSpread({}, facet), {}, {
      label: localizedLabel
    });
  };

  return FacetCategory_jsx("div", {
    className: classnames_default()('lg:flex', 'FacetCategory', "FacetCategory-".concat(facetId)),
    key: facetId
  }, facetListsConfig.map(function (_ref2) {
    var deep = _ref2.deep,
        subFacetId = _ref2.id,
        facetLabels = _ref2.facetLabels,
        titleLabel = _ref2.titleLabel;
    var facetFromSearch = facetsFromSearch.find(function (_ref3) {
      var id = _ref3.id;
      return id === subFacetId;
    });

    if (!facetFromSearch || !facetFromSearch.list) {
      return;
    }

    if (!deep) {
      return FacetCategory_jsx(FacetList_FacetList, {
        activeFacets: activeFacets[subFacetId],
        className: "FacetList-".concat(subFacetId),
        facets: facetFromSearch.list.map(function (facet) {
          return localizeFacetLabel(facet, facetLabels);
        }),
        key: subFacetId,
        name: subFacetId,
        onChange: onChange,
        title: Object(src_i18n["f" /* t */])(titleLabel)
      });
    }

    return facetFromSearch.list.map(function (_ref4) {
      var label = _ref4.label,
          _ref4$list = _ref4.list,
          list = _ref4$list === void 0 ? [] : _ref4$list,
          value = _ref4.value;
      return FacetCategory_jsx(FacetList_FacetList, {
        activeFacets: activeFacets[subFacetId],
        className: classnames_default()('lg:flex-1', "FacetList-".concat(subFacetId)),
        facets: list.map(function (facet) {
          return localizeFacetLabel(facet, facetLabels);
        }) || [],
        key: value,
        name: subFacetId,
        onChange: onChange,
        title: label || Object(src_i18n["f" /* t */])(titleLabel)
      });
    });
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/SearchFacets.utils.js
function getLabelGA(facetId) {
  switch (facetId) {
    case '':
      return null;

    case 'activities':
      return 'whichActivities';

    case 'destinations':
      return 'whichDestinations';

    default:
      // 'when', 'who', 'where'
      return facetId;
  }
}

var getActiveFacetTabTrackingData = function getActiveFacetTabTrackingData(_ref) {
  var facetId = _ref.facetId;
  return {
    actionGA: 'smartCriterias',
    labelGA: getLabelGA(facetId)
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/SearchFacets.jsx
var SearchFacets_jsx = react_default.a.createElement;











var SearchFacets_SearchFacets = function SearchFacets(props) {
  var activeFacets = props.activeFacets,
      facets = props.facets,
      _props$facetTemplateC = props.facetTemplateConfig,
      facetTemplateConfig = _props$facetTemplateC === void 0 ? [] : _props$facetTemplateC,
      facetTrackingConfig = props.facetTrackingConfig;

  var _useState = Object(react["useState"])(-1),
      selectedFacetTab = _useState[0],
      setSelectedFacetTab = _useState[1];

  var track = Object(useTracking["a" /* useTracking */])();

  if (facets.length <= 0) {
    return null;
  }

  var onClearFacets = function onClearFacets(id) {
    var templateConfig = facetTemplateConfig.find(function (_ref) {
      var facetId = _ref.id;
      return id === facetId;
    });

    if (!templateConfig) {
      return;
    }

    props.clearFacets(id);
    templateConfig.facetLists.forEach(function (_ref2) {
      var facetListId = _ref2.id;
      props.clearFacets(facetListId);
    });
  };

  var trackFacetChange = function trackFacetChange(name, checked, value) {
    if (!checked) {
      return;
    }

    var labelSuffix = value.toString().replace(/[|\s]/g, '_').toLowerCase();
    var trackingConfig = facetTrackingConfig.find(function (_ref3) {
      var id = _ref3.id;
      return id === name.replace('[]', '');
    });

    if (!trackingConfig) {
      return;
    }

    var labelGA = "".concat(trackingConfig.trackingPrefixLabel, "_").concat(labelSuffix);

    if (labelGA) {
      track({
        actionGA: 'smartCriterias',
        labelGA: labelGA
      });
    }
  };

  var changeFacet = function changeFacet(name, checked, value) {
    setSelectedFacetTab(-1);
    trackFacetChange(name, checked, value);
    props.toggleFacet({
      categoryId: name,
      isSelected: checked,
      value: value
    });
  };

  var getTabItems = function getTabItems() {
    return facetTemplateConfig.map(function (templateConfig) {
      var id = templateConfig.id,
          dataLabel = templateConfig.dataLabel,
          iconName = templateConfig.iconName,
          titleLabel = templateConfig.titleLabel,
          facetLists = templateConfig.facetLists;
      var count = facetLists.map(function (_ref4) {
        var facetId = _ref4.id;
        return activeFacets[facetId] ? Object.keys(activeFacets[facetId]).length : 0;
      }).reduce(function (acc, facetCount) {
        return acc + facetCount;
      }, 0);
      var title = Object(src_i18n["f" /* t */])(titleLabel);
      return {
        id: id,
        header: {
          iconName: iconName,
          title: title,
          trackingData: getActiveFacetTabTrackingData({
            facetId: dataLabel
          })
        },
        customHeader: count > 0 ? function (_ref5, setRef) {
          var controlsId = _ref5.controlsId,
              itemId = _ref5.id,
              onClick = _ref5.onClick,
              onKeyDown = _ref5.onKeyDown,
              isActive = _ref5.isActive,
              style = _ref5.style,
              tabIndex = _ref5.tabIndex;
          return SearchFacets_jsx("div", {
            className: "px-3 py-2 decorator-separator-left",
            key: title,
            style: style
          }, SearchFacets_jsx(Tag["a" /* Tag */], {
            "aria-controls": controlsId,
            "area-selected": String(isActive),
            badge: SearchFacets_jsx(TemplateString["a" /* TemplateString */], {
              staticClassName: "sr-only",
              template: count > 1 ? Object(src_i18n["f" /* t */])('common.selectedCriteriasLabel.n') : Object(src_i18n["f" /* t */])('common.selectedCriteriasLabel._1'),
              values: {
                count: count.toString()
              }
            }),
            closeLabel: "".concat(Object(src_i18n["f" /* t */])('faceting.reset'), " ").concat(title),
            id: itemId,
            label: title,
            onClick: onClick,
            onClose: function onClose() {
              return onClearFacets(id);
            },
            onKeyDown: onKeyDown,
            ref: setRef,
            role: "tab",
            tabIndex: tabIndex,
            trackingData: !isActive ? getActiveFacetTabTrackingData({
              facetId: dataLabel,
              isActive: isActive
            }) : null
          }));
        } : null,
        content: [SearchFacets_jsx(FacetCategory_FacetCategory, {
          templateConfig: templateConfig,
          facetsFromSearch: facets,
          onChange: changeFacet,
          activeFacets: activeFacets,
          key: id,
          name: id
        })]
      };
    });
  };

  var onClickIconFilters = function onClickIconFilters() {
    // Set the first tab as active or close it if already active
    setSelectedFacetTab(selectedFacetTab === 0 ? -1 : 0);
  };

  var onActiveFacetTabChanged = function onActiveFacetTabChanged(index) {
    setSelectedFacetTab(selectedFacetTab === index ? -1 : index);
  };

  return SearchFacets_jsx(Tabs["a" /* Tabs */], {
    areAllCollapsable: true,
    className: "mb-6",
    collapseIconName: icons["a" /* ICONS */].SELECT_UP,
    expandIconName: icons["a" /* ICONS */].SELECT,
    hasBackground: true,
    initialSelectedItem: selectedFacetTab,
    isContentUnmountedOnCollapse: true,
    isScrollable: true,
    items: getTabItems(),
    onSelect: onActiveFacetTabChanged,
    scrollBackwardLabel: Object(src_i18n["f" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(src_i18n["f" /* t */])('common.scrollForward'),
    slotLeft: SearchFacets_jsx("button", {
      className: "bg-transparent leading-none p-2",
      onClick: onClickIconFilters,
      type: "button",
      "data-testid": "search-facets-toggle-button"
    }, SearchFacets_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].SETTINGS
    })),
    theme: "clean"
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/CriteriaFacets.jsx
var CriteriaFacets_jsx = react_default.a.createElement;






var CriteriaFacets_CriteriaFacets = function CriteriaFacets() {
  var dispatch = Object(es["d" /* useDispatch */])();
  var activeFacets = Object(es["e" /* useSelector */])(faceting_selector["a" /* activeFacetsSelector */]);
  var facets = Object(es["e" /* useSelector */])(faceting_selector["d" /* facetsSelector */]);
  return CriteriaFacets_jsx(SearchFacets_SearchFacets, {
    facets: facets,
    activeFacets: activeFacets,
    toggleFacet: function toggleFacet(_ref) {
      var categoryId = _ref.categoryId,
          isSelected = _ref.isSelected,
          value = _ref.value;
      dispatch(Object(facetingSearch_action["p" /* toggleFacet */])({
        categoryId: categoryId,
        isSelected: isSelected,
        value: value
      }));
    },
    clearFacets: function clearFacets(categoryId) {
      dispatch(Object(facetingSearch_action["f" /* clearFacets */])(categoryId));
    },
    facetLabels: true,
    facetTemplateConfig: faceting_constants["s" /* FILTERABLE_FACETS_TEMPLATE_CONFIG */],
    facetTrackingConfig: faceting_constants["t" /* FILTERABLE_FACETS_TRACKING_CONFIG */]
  });
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/FilterWhen.jsx + 1 modules
var FilterWhen = __webpack_require__("qLhN");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria-modal/CriteriaModal.jsx
var CriteriaModal_jsx = react_default.a.createElement;










var CriteriaModal_CriteriaModal = function CriteriaModal(_ref) {
  var children = _ref.children,
      _onClose = _ref.onClose,
      onReset = _ref.onReset,
      onValidate = _ref.onValidate;

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var _useContext2 = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext2[0];

  var buttons = CriteriaModal_jsx("div", {
    className: "relative p-3 px-6 lg:px-0 w-full flex items-center justify-between mt-auto bg-white".concat(isDesktop ? '' : ' shadow')
  }, CriteriaModal_jsx(Button["a" /* Button */], {
    theme: "link",
    onClick: function onClick() {
      onReset && onReset();
    },
    className: "text-sm cursor-pointer"
  }, Object(src_i18n["f" /* t */])('faceting.reset')), CriteriaModal_jsx(Button["a" /* Button */], {
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    onClick: function onClick() {
      onValidate && onValidate();
    },
    className: "text-sm cursor-pointer"
  }, Object(src_i18n["f" /* t */])('faceting.validate')));

  var ariaLabel = Object(src_i18n["f" /* t */])('faceting.when.duration');
  var closeLabel = Object(src_i18n["f" /* t */])('common.close');

  var onCloseModal = function onCloseModal() {
    _onClose && _onClose();
  };

  return isDesktop ? CriteriaModal_jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    className: "text-center px-10 py-5",
    closeLabel: closeLabel,
    onClose: function onClose() {
      _onClose && _onClose();
    },
    size: "small"
  }, children, buttons) : CriteriaModal_jsx(Layer["b" /* Layer */], {
    ariaLabel: ariaLabel,
    ariaLabelledby: identifiers_constants["m" /* ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL */],
    buttonLeft: {
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      label: Object(src_i18n["f" /* t */])('common.backNavigation'),
      onClick: onCloseModal
    },
    closeLabel: closeLabel,
    hasAnimateEnter: true,
    header: CriteriaModal_jsx("div", {
      className: "text-center font-normal text-xl text-gray-darker",
      dangerouslySetInnerHTML: {
        __html: criteriaContext.layerHeader
      },
      id: identifiers_constants["m" /* ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL */]
    }),
    onClose: onCloseModal
  }, CriteriaModal_jsx("div", {
    className: "scroll-y",
    style: {
      height: 'calc(100% - 70px)'
    }
  }, children), buttons);
};
// CONCATENATED MODULE: ./src/client/components/widgets/criteria-modal/criteria-modal-when/CriteriaModalWhen.jsx
var CriteriaModalWhen_jsx = react_default.a.createElement;












var CriteriaModalWhen_CriteriaModalWhen = function CriteriaModalWhen(_ref) {
  var durationOptions = _ref.durationOptions,
      _onClose = _ref.onClose;

  var _useContext = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);

  var _useState = Object(react["useState"])(departureDate),
      inputDepartureDate = _useState[0],
      setInputDepartureDate = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      inputDuration = _useState2[0],
      setInputDuration = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      validated = _useState3[0],
      setValidated = _useState3[1];

  var dispatch = Object(es["d" /* useDispatch */])();
  var track = Object(useTracking["a" /* useTracking */])();

  var persistDepartureDate = function persistDepartureDate() {
    var invalid = !(departureDate || moment_default.a.isMoment(inputDepartureDate) || moment_default()(inputDepartureDate).isValid());

    if (invalid) {
      return dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
    }

    dispatch(Object(departureDate_action["a" /* setDepartureDate */])(moment_default()(inputDepartureDate).valueOf()));
    setCriteriaContext({
      defaultValueForCalendar: departureDate
    });

    if (criteriaContext.trackingActionName) {
      track({
        actionGA: criteriaContext.trackingActionName,
        labelGA: "when_".concat(moment_default()(inputDepartureDate).format('DD/MM/YYYY'))
      });
    }
  };

  var persistDuration = function persistDuration() {
    var durationToPersist = inputDuration;

    if (!inputDuration && inputDepartureDate) {
      durationToPersist = duration_constants["b" /* DEFAULT_TRIP_DURATION */];
    }

    if (durationToPersist) {
      dispatch(Object(facetingSearch_action["d" /* changeTripDuration */])(durationToPersist));

      if (criteriaContext.trackingActionName) {
        var labelGA = "duration_".concat(durationToPersist);
        track({
          actionGA: criteriaContext.trackingActionName,
          labelGA: labelGA
        });
      }
    }
  };

  Object(react["useEffect"])(function () {
    if (validated) {
      _onClose();
    }
  }, [validated]);
  return CriteriaModalWhen_jsx(CriteriaModal_CriteriaModal, {
    onValidate: function onValidate() {
      if (inputDepartureDate && inputDuration) {
        persistDepartureDate();
        persistDuration();
        setValidated(true);
      }
    },
    onClose: function onClose() {
      _onClose();
    },
    onReset: function onReset() {
      setInputDuration(0);
      setInputDepartureDate(null);
    }
  }, CriteriaModalWhen_jsx(FilterWhen["a" /* FilterWhen */], {
    optionsDuration: durationOptions,
    changeTripDuration: function changeTripDuration(time) {
      setInputDuration(time);
    },
    changeDepartureDate: function changeDepartureDate(value) {
      setInputDepartureDate(moment_default()(value, moment_default.a.defaultFormat));
    },
    clearDepartureDate: function clearDepartureDate() {
      setInputDepartureDate(null);
    },
    clearTripDuration: function clearTripDuration() {
      setInputDuration(0);
    },
    duration: inputDuration,
    departureDate: inputDepartureDate,
    openCalendarToDate: criteriaContext.defaultValueForCalendar,
    dateFormat: Object(src_i18n["f" /* t */])('booking.form.dateFormat'),
    label: Object(src_i18n["f" /* t */])('faceting.compare.warningMessage'),
    isSubmittable: true
  }));
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/striptags/striptags.js
var striptags = __webpack_require__("47go");
var striptags_default = /*#__PURE__*/__webpack_require__.n(striptags);

// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// EXTERNAL MODULE: ./src/hooks/use-autocomplete/useAutocomplete.js
var useAutocomplete = __webpack_require__("aUQU");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.jsx + 4 modules
var InputDatalist = __webpack_require__("wRBU");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-query/CriteriaQuery.jsx

var CriteriaQuery_jsx = react_default.a.createElement;

function CriteriaQuery_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CriteriaQuery_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CriteriaQuery_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CriteriaQuery_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var ItemLayout = function ItemLayout(_ref) {
  var label = _ref.label;

  if (!label) {
    return null;
  }

  return CriteriaQuery_jsx("div", {
    className: "focus:bg-turquoise hover:bg-turquoise cursor-pointer flex items-center overflow-hidden py-4 focus:text-white hover:text-white transition-colors p-px10"
  }, CriteriaQuery_jsx("span", {
    className: "decorator-match font-sans text-sm truncate"
  }, label));
};

var ItemTitle = function ItemTitle(_ref2) {
  var title = _ref2.title;
  return CriteriaQuery_jsx("div", {
    className: "text-blue text-xs font-sans font-bold py-2"
  }, title);
};

var CriteriaQuery_redirection = 'redirection_suggestedRequest';
var CriteriaQuery_CriteriaQuery = function CriteriaQuery(props) {
  var _props$suggestedReque, _props$suggestedReque2, _props$suggestedReque3, _props$suggestedReque4;

  var _useContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageId = _useContext.pageId;

  var _useContext2 = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      isSeller = _useContext2.isSeller;

  var keywords = Object(es["e" /* useSelector */])(search_selector["a" /* keywordsSelector */]);
  var query = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.query;
  });
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'search'
  });

  var _useAutocomplete = Object(useAutocomplete["a" /* useAutocomplete */])(keywords),
      setAutocompleteQuery = _useAutocomplete.setAutocompleteQuery,
      autocompleteResults = _useAutocomplete.autocompleteResults,
      setAutocompleteResults = _useAutocomplete.setAutocompleteResults;

  var value = query && query.label ? query.label : keywords;
  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var hasSuggestedRequests = !!((_props$suggestedReque = props.suggestedRequests) === null || _props$suggestedReque === void 0 ? void 0 : (_props$suggestedReque2 = _props$suggestedReque.items) === null || _props$suggestedReque2 === void 0 ? void 0 : _props$suggestedReque2.length);
  return CriteriaQuery_jsx(InputDatalist["a" /* InputDatalist */], {
    dataList: value || isSeller ? autocompleteResults : (((_props$suggestedReque3 = props.suggestedRequests) === null || _props$suggestedReque3 === void 0 ? void 0 : _props$suggestedReque3.items) || []).map(function (_ref3) {
      var label = _ref3.label,
          link = _ref3.url;
      return {
        id: label,
        label: label,
        link: link
      };
    }),
    hasClear: true,
    hasValidationIcon: false,
    iconLeft: icons["a" /* ICONS */].SEARCH_GLASS,
    isAnimated: true,
    itemLayout: !value ? ItemLayout : undefined,
    itemTitle: !value && hasSuggestedRequests ? CriteriaQuery_jsx(ItemTitle, {
      title: (_props$suggestedReque4 = props.suggestedRequests) === null || _props$suggestedReque4 === void 0 ? void 0 : _props$suggestedReque4.title
    }) : undefined,
    onChange: function onChange(_, v) {
      var cleanKeywords = striptags_default()(v);
      dispatch(Object(searchQuery_action["a" /* setKeywords */])(cleanKeywords));
      setAutocompleteQuery(cleanKeywords);
      props.onQueryChange({
        label: cleanKeywords
      });
    },
    onClear: function onClear() {
      setAutocompleteResults([]);
      var emptyQuery = {
        label: ''
      };

      if (!keywords) {
        // User is clearing the search query
        dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(emptyQuery));
      }

      props.onQueryChange(emptyQuery);
      dispatch(Object(searchQuery_action["a" /* setKeywords */])(''));
      setAutocompleteQuery('');
    },
    onFocus: function onFocus() {
      if (!isSeller && !value && hasSuggestedRequests) {
        track({
          labelGA: 'requestsDisplay'
        });
      }
    },
    onSelect: function onSelect(_ref4) {
      var label = _ref4.label,
          _ref4$item = _ref4.item,
          type = _ref4$item.type,
          productType = _ref4$item.productType,
          link = _ref4$item.link;

      if (value) {
        var searchQuery = {
          label: label,
          link: link,
          productType: productType,
          type: type
        };
        dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(searchQuery));
        props.onQueryChange(searchQuery);
      } else if (link) {
        var isSearchUrl = link.startsWith('/s');
        track({
          internalSearchEngineNbResults: isSearchUrl ? '' : CriteriaQuery_redirection,
          labelGA: 'suggestedRequest',
          searchReferrer: pageId,
          searchRequestType: 'Autocomplete',
          searchTerms: label
        });
        history.pushRoute(link);
        var internalSearchEngineNbResults = !isSearchUrl ? {
          internalSearchEngineNbResults: CriteriaQuery_redirection,
          searchResorts: []
        } : undefined;
        trackSearchResults(CriteriaQuery_objectSpread({
          searchRequestType: 'Autocomplete',
          searchTerms: label
        }, internalSearchEngineNbResults));
      }
    },
    placeholder: Object(src_i18n["f" /* t */])('faceting.searchTitle'),
    size: "large",
    value: value,
    validationState: value ? validationStates["b" /* IS_VALID */] : validationStates["c" /* NOT_VALIDATED */]
  });
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/CriteriaTransport.jsx
var CriteriaTransport = __webpack_require__("NWzG");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/CriteriaWhen.jsx
var CriteriaWhen = __webpack_require__("Go22");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/CriteriaWho.jsx
var CriteriaWho = __webpack_require__("wKzQ");

// EXTERNAL MODULE: ./src/utils/locale/localeUtils.js
var localeUtils = __webpack_require__("1tzK");

// EXTERNAL MODULE: ./node_modules/entities/index.js
var entities = __webpack_require__("4oK2");

// CONCATENATED MODULE: ./src/client/components/widgets/search-form/SearchForm.utils.js




var SearchForm_utils_getDepartureCitiesFromFacets = function getDepartureCitiesFromFacets(facets, placeholderLabel) {
  var departureCities = Object(facetingUtils["c" /* getDepartureCities */])(facets);

  if (departureCities.length === 0) {
    return [];
  }

  var options = [{
    value: '',
    label: placeholderLabel
  }];
  var noTransportOption = departureCities.find(function (city) {
    return city.value === departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */];
  });

  if (noTransportOption) {
    var value = noTransportOption.value,
        label = noTransportOption.label;
    options.push({
      value: value,
      label: Object(entities["decodeHTML"])(label)
    });
  }

  var citiesOptions = departureCities.filter(function (city) {
    return city.value !== departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */];
  }).map(function (_ref) {
    var label = _ref.label,
        value = _ref.value;
    return {
      value: value,
      label: Object(entities["decodeHTML"])(label)
    };
  }).sort(function (a, b) {
    return a.value.localeCompare(b.value);
  });
  return [].concat(options, Object(toConsumableArray["a" /* default */])(citiesOptions));
};
// CONCATENATED MODULE: ./src/client/components/widgets/search-form/SearchForm.jsx

var SearchForm_jsx = react_default.a.createElement;



























var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;

var SearchForm_SubmitButton = function SubmitButton(props) {
  return SearchForm_jsx("div", {
    className: classnames_default()(props.className, 'rtl:ml-2 flex-none lg:justify-center lg:leading-none lg:mx-2')
  }, SearchForm_jsx(Button["a" /* Button */], {
    className: "lg:rtl:ml-2 flex-none lg:mx-2 w-full",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].BLUE,
    colorBorder: colors["a" /* COLORS */].BLUE,
    minWidth: "initial",
    size: "large",
    type: "submit"
  }, SearchForm_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS
  })));
};

var SearchForm_SearchForm = function SearchForm(props) {
  var _props$i18n, _props$i18n$faceting;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useContext = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 1),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0];

  var _useState = Object(react["useState"])(false),
      criteriaQueryIsJoyviewProduct = _useState[0],
      setCriteriaQueryIsJoyviewProduct = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      criteriaModalWhenIsOpen = _useState2[0],
      setCriteriaModalWhenIsOpen = _useState2[1];

  var trackQueryChange = Object(useTrackQueryChange["a" /* useTrackQueryChange */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var departureDate = Object(es["e" /* useSelector */])(function (state) {
    return Object(lodash["get"])(state, 'tripCriteria.departureDate');
  });
  var duration = Object(es["e" /* useSelector */])(function (state) {
    return Object(lodash["get"])(state, 'tripCriteria.duration', 0);
  });
  var facets = Object(es["e" /* useSelector */])(function (state) {
    return Object(faceting_selector["d" /* facetsSelector */])(state);
  });
  var resultsCount = Object(es["e" /* useSelector */])(function (state) {
    return Object(faceting_selector["e" /* filteredProductsCountSelector */])(state);
  });
  var isLoading = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.isLoading;
  });
  var joyviewOffsetSell = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.joyviewOffsetSell;
  });
  var resortOffsetSell = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.resortOffsetSell;
  });
  var offsetSell = Object(localeUtils["a" /* isChineseLocale */])(appContext.locale) && criteriaQueryIsJoyviewProduct && joyviewOffsetSell > -1 ? joyviewOffsetSell : resortOffsetSell;
  var isProductComparisonSelectionModeEnabled = Object(es["e" /* useSelector */])(function (state) {
    return Object(lodash["get"])(state, 'faceting.isSelectionModeEnabled');
  });

  var getOptionsDuration = function getOptionsDuration() {
    var results = (facets.find(function (f) {
      return f.id === faceting_constants["p" /* DURATION_FACET */];
    }) || {
      list: []
    }).list;
    return results.map(function (opt) {
      return parseInt(opt.value, 10);
    }).sort(function (a, b) {
      return a < b ? -1 : 1;
    });
  };

  Object(react["useEffect"])(function () {
    setCriteriaContext({
      layerButtonLabel: props.layerButtonLabel,
      layerHeader: props.showNbResultsInLayer ? Object(src_i18n["f" /* t */])('faceting.viewResorts', {
        n: "<span class=\"font-bold text-blue\">".concat(resultsCount || 0, "</span>")
      }) : ''
    });
  }, [props.showNbResultsInLayer, resultsCount, props.layerButtonLabel]);
  Object(react["useEffect"])(function () {
    if (criteriaDisplayContext.criteriaWhenIsOpen || criteriaDisplayContext.criteriaTransportIsOpen) {
      dispatch(Object(facetingSearch_action["m" /* setIsSearchEnabled */])(true));
    }
  }, [criteriaDisplayContext.criteriaTransportIsOpen, criteriaDisplayContext.criteriaWhenIsOpen]);

  var updateTranslationKeys = function updateTranslationKeys() {
    Object(src_i18n["a" /* addTranslationKeys */])({
      common: Object(lodash["get"])(props, 'i18n.common'),
      booking: Object(lodash["get"])(props, 'i18n.booking'),
      faceting: Object(lodash["get"])(props, 'i18n.faceting')
    });
  };

  updateTranslationKeys();
  Object(react["useEffect"])(function () {
    updateTranslationKeys();
  }, [props.i18n]);
  Object(react["useEffect"])(function () {
    var dateIsMissing = !departureDate || !duration;

    if (isProductComparisonSelectionModeEnabled && dateIsMissing && !criteriaDisplayContext.criteriaWhenIsOpen && !criteriaModalWhenIsOpen) {
      setCriteriaModalWhenIsOpen(true);
    }
  }, [criteriaDisplayContext.criteriaWhenIsOpen, isProductComparisonSelectionModeEnabled, departureDate]);
  var departureCitiesOptions = SearchForm_utils_getDepartureCitiesFromFacets(facets, Object(src_i18n["f" /* t */])('faceting.transport.selectPlaceholder'));

  var onSubmit = function onSubmit(event) {
    if (event) {
      event.preventDefault();
    }

    if (Object(lodash["isFunction"])(props.onSubmit)) {
      props.onSubmit(event);
    }
  };

  var onQueryChange = function onQueryChange(query) {
    setCriteriaQueryIsJoyviewProduct(query && query.productType === PRODUCT_TYPES.JOYVIEW);

    if (query && query.label && query.type) {
      return props.doTrackQueryChange && trackQueryChange(query);
    }
  };

  var onClose = function onClose() {
    setCriteriaModalWhenIsOpen(false);

    if (!departureDate && !duration) {
      dispatch(setProductComparisonSelectionMode(false));
    }
  };

  var durations = getOptionsDuration();
  return SearchForm_jsx("form", {
    className: "relative",
    onSubmit: onSubmit
  }, SearchForm_jsx(SiteContainer["a" /* SiteContainer */], null, SearchForm_jsx("div", {
    className: "mx-auto p-2 lg:flex mb-4 bg-white shadow-lg border-1 border-gray-light rounded-small lg:py-3 lg:px-1"
  }, props.withQuery && SearchForm_jsx("div", {
    className: "flex mb-2 lg:flex-1 lg:mb-0 lg:mx-2 lg:block"
  }, SearchForm_jsx("div", {
    className: "flex-1",
    "data-testid": "search-form-criteria-query"
  }, SearchForm_jsx(CriteriaQuery_CriteriaQuery, {
    onQueryChange: onQueryChange,
    suggestedRequests: (_props$i18n = props.i18n) === null || _props$i18n === void 0 ? void 0 : (_props$i18n$faceting = _props$i18n.faceting) === null || _props$i18n$faceting === void 0 ? void 0 : _props$i18n$faceting.suggestedRequests
  })), SearchForm_jsx(SearchForm_SubmitButton, {
    className: "lg:hidden"
  })), SearchForm_jsx("div", {
    className: "flex -mx-1 lg:mx-0 lg:flex-2"
  }, SearchForm_jsx("div", {
    className: "flex-1 lg:mx-2 px-1 lg:px-0",
    "data-testid": "search-form-criteria-when"
  }, SearchForm_jsx(CriteriaWhen["a" /* CriteriaWhen */], {
    durationOptions: durations,
    offsetSell: offsetSell > -1 ? offsetSell : null,
    withFlexibility: true
  })), SearchForm_jsx("div", {
    className: "flex-1 lg:mx-2 px-1 lg:px-0",
    "data-testid": "search-form-criteria-who"
  }, SearchForm_jsx(CriteriaWho["a" /* CriteriaWho */], null)), SearchForm_jsx("div", {
    className: "flex-1 lg:mx-2 px-1 lg:px-0",
    "data-testid": "search-form-criteria-transport"
  }, SearchForm_jsx(CriteriaTransport["a" /* CriteriaTransport */], {
    departureCitiesOptions: departureCitiesOptions,
    isLoading: isLoading
  }))), SearchForm_jsx(SearchForm_SubmitButton, {
    className: "hidden lg:flex"
  }))), props.withFacets && SearchForm_jsx(CriteriaFacets_CriteriaFacets, {
    i18n: props.i18n
  }), criteriaModalWhenIsOpen && SearchForm_jsx(CriteriaModalWhen_CriteriaModalWhen, {
    durationOptions: durations,
    onClose: onClose
  }));
};
// EXTERNAL MODULE: ./src/routes/constants.js
var routes_constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/client/store/utils/autocompleteItemHelper.js
var autocompleteItemHelper = __webpack_require__("Qmkj");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search/FacetSearch.jsx


var FacetSearch_jsx = react_default.a.createElement;


























var FacetSearch_FacetSearch = function FacetSearch(props) {
  var _props$shouldRedirect = props.shouldRedirectToResortPage,
      shouldRedirectToResortPage = _props$shouldRedirect === void 0 ? false : _props$shouldRedirect,
      _props$withSearchResu = props.withSearchResults,
      withSearchResults = _props$withSearchResu === void 0 ? false : _props$withSearchResu,
      _props$isSynchronousG = props.isSynchronousGrid,
      isSynchronousGrid = _props$isSynchronousG === void 0 ? false : _props$isSynchronousG;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var routerEvents = useRouterEvents();
  var responsiveContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]);

  var _useState = Object(react["useState"])(false),
      searchDone = _useState[0],
      setSearchDone = _useState[1];

  var dispatch = Object(es["d" /* useDispatch */])();
  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var facetingCriteria = Object(es["e" /* useSelector */])(faceting_selector["c" /* facetingCriteriaSelector */]);
  var isLoading = Object(es["e" /* useSelector */])(function (_ref) {
    var faceting = _ref.faceting;
    return faceting.isLoading;
  });
  var noResults = Object(es["e" /* useSelector */])(function (_ref2) {
    var faceting = _ref2.faceting;
    return faceting.noResults;
  });
  var isSearchEnabled = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.isSearchEnabled;
  });
  var keywords = Object(es["e" /* useSelector */])(search_selector["a" /* keywordsSelector */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var kidsValidationState = Object(es["e" /* useSelector */])(faceting_selector["k" /* getKidsValidationState */]);
  var products = Object(es["e" /* useSelector */])(function (state) {
    return Object(faceting_selector["g" /* filteredProductsSelector */])(state) || [];
  });
  var productIds = products.map(function (_ref3) {
    var resortId = _ref3.resortId;
    return resortId;
  }).join('|');
  var query = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.query || {};
  });
  var redirection = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.redirection;
  });
  var flexibility = Object(es["e" /* useSelector */])(tripCriteria_selector["d" /* getTripFlexibility */]);
  var trackQueryChange = Object(useTrackQueryChange["a" /* useTrackQueryChange */])();
  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var searchCriteria = {
    departureCity: departureCity,
    departureDate: departureDate,
    duration: duration,
    keywords: keywords,
    kids: kids,
    kidsValidationState: kidsValidationState,
    query: query
  };
  var searchOptions = Object(react["useMemo"])(function () {
    var _props$offer, _props$offer2;

    return {
      boutique: props.boutique,
      offerId: (_props$offer = props.offer) === null || _props$offer === void 0 ? void 0 : _props$offer.id,
      offerName: (_props$offer2 = props.offer) === null || _props$offer2 === void 0 ? void 0 : _props$offer2.seoName,
      productIds: (props.initialProducts || []).map(function (product) {
        return product.id;
      }),
      query: query.label || '',
      screenSize: responsiveContext.currentBreakpoint
    };
  }, [props.boutique, props.initialProducts, props.offer, props.i18n, query, responsiveContext.currentBreakpoint]);

  var search = function search() {
    // We check routerReady to ensure that we do not update URL
    // or results while the router is transitioning between routes.
    if (isSearchEnabled) {
      if (props.shouldPersistCriteriaInUrl && !routerEvents.transitioning) {
        Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
          criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
          location: location,
          searchCriteria: searchCriteria,
          searchPageRouteName: props.searchPageRouteName
        });
      }

      dispatch(facetingSearchRequest({
        appContext: appContext,
        options: searchOptions
      }));
      setSearchDone(true);
    }
  };

  Object(react["useEffect"])(function () {
    dispatch(facetingLoadOffsetSellRequest({
      appContext: appContext
    }));
  }, []);
  Object(react["useEffect"])(function () {
    if (typeof products !== 'undefined' && pageContext.pageId === routes_constants["C" /* SEARCH_PAGE_ID */] && withSearchResults && isLoading === false && searchDone) {
      trackSearchResults();
    }
  }, [productIds, isLoading]);
  Object(react["useEffect"])(function () {
    var _props$i18n$remote, _props$i18n$remote$no, _props$i18n$remote$no2, _props$i18n$remote$no3;

    if (!isLoading && noResults && ((_props$i18n$remote = props.i18n.remote) === null || _props$i18n$remote === void 0 ? void 0 : (_props$i18n$remote$no = _props$i18n$remote.noResult) === null || _props$i18n$remote$no === void 0 ? void 0 : (_props$i18n$remote$no2 = _props$i18n$remote$no.recommendation) === null || _props$i18n$remote$no2 === void 0 ? void 0 : (_props$i18n$remote$no3 = _props$i18n$remote$no2.resortIds) === null || _props$i18n$remote$no3 === void 0 ? void 0 : _props$i18n$remote$no3.length) > 0) {
      dispatch(facetingLoadProductsRequest({
        appContext: appContext,
        productIds: props.i18n.remote.noResult.recommendation.resortIds
      }));
    }
  }, [products]);

  var cleanSearch = /*#__PURE__*/function () {
    var _ref4 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(Object(facetingSearch_action["k" /* resetSearch */])()));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function cleanSearch() {
      return _ref4.apply(this, arguments);
    };
  }();

  var cleanCriteria = /*#__PURE__*/function () {
    var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", dispatch(Object(facetingSearch_action["i" /* resetCriteria */])()));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function cleanCriteria() {
      return _ref5.apply(this, arguments);
    };
  }();

  Object(react["useEffect"])(function () {
    dispatch(setProductComparisonSelectionMode(false));
    var _props$initialIsSearc = props.initialIsSearchEnabled,
        initialIsSearchEnabled = _props$initialIsSearc === void 0 ? false : _props$initialIsSearc;

    if (!Object(FacetSearch_utils["b" /* currentUrlContainsSearchQueryParam */])(location)) {
      // We always want to reset the search query, unless it's in the URL.
      dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])({
        label: ''
      }));
    } // useEffect cannot be async because it's supposed to return a cleaning callback.
    // This immediatly invoked function is a workaround to this.


    Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(Object(FacetSearch_utils["c" /* currentUrlHasNoQueryParams */])(location) && props.resetSearchAtMount)) {
                _context3.next = 5;
                break;
              }

              _context3.next = 3;
              return cleanSearch();

            case 3:
              _context3.next = 5;
              return cleanCriteria();

            case 5:
              if (departureCity) {
                // If transport is set in store, we need to trigger
                // the search request to get the departureCities facet from Pertimm.
                dispatch(Object(facetingSearch_action["m" /* setIsSearchEnabled */])(true));
              } else {
                dispatch(Object(facetingSearch_action["m" /* setIsSearchEnabled */])(initialIsSearchEnabled));
              }

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();

    return function () {
      cleanSearch();
    };
  }, []);
  Object(react["useEffect"])(function () {
    // In case PERTIMM response indicates a redirection, go to this page...
    if (redirection) {
      dispatch(Object(globalLoader_action["d" /* startLoading */])());
      redirectUtils["a" /* default */].redirectTo()(redirection, {
        replace: true,
        shallow: false
      });
      return function () {
        // clear search query to avoid infinite loop on back #14970
        dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])({
          label: ''
        }));
        dispatch(Object(facetingSearch_action["j" /* resetRedirection */])());
      };
    }
  }, [redirection]);
  var filtersKeysToIgnore = [faceting_constants["m" /* DEPARTURE_DATE_MAX_FACET_ID */], faceting_constants["n" /* DEPARTURE_DATE_MIN_FACET_ID */], faceting_constants["p" /* DURATION_FACET */], faceting_constants["z" /* PRODUCT_FACET_ID */]];
  Object(react["useEffect"])(function () {
    search();
  }, [JSON.stringify(kids), JSON.stringify(query), isSearchEnabled, departureDate, duration, JSON.stringify((facetingCriteria.filters || []).filter(function (facet) {
    return !filtersKeysToIgnore.includes(facet.id);
  })), props.offer, flexibility]);

  var onSubmit = function onSubmit(event) {
    var searchPageRouteName = props.searchPageRouteName;

    if (event) {
      event.preventDefault();
    }

    var searchQuery = keywords ? {
      label: keywords
    } : query;

    if (keywords) {
      dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(searchQuery));
    }

    if (!keywords && shouldRedirectToResortPage && searchQuery.type === autocompleteItemHelper["a" /* RESORT_PRODUCT_TYPE */]) {
      trackQueryChange(searchQuery, {
        internalSearchEngineNbResults: 'redirection'
      });
      trackSearchResults({
        internalSearchEngineNbResults: 'redirection',
        searchResorts: []
      });
      Object(FacetSearch_utils["e" /* navigateToResortPage */])({
        location: location,
        query: searchQuery,
        searchCriteria: searchCriteria
      });
    } else {
      if (!withSearchResults) {
        trackQueryChange(searchQuery);
        cleanSearch();
      }

      Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
        criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
        location: location,
        searchCriteria: searchCriteria,
        searchPageRouteName: searchPageRouteName
      });
    }
  };

  return FacetSearch_jsx("div", {
    "data-testid": "facetSearch",
    className: "relative z-3"
  }, FacetSearch_jsx(CriteriaContext["b" /* CriteriaContextProvider */], {
    value: {
      trackingActionName: 'smartCriterias'
    }
  }, FacetSearch_jsx(CriteriaDisplayContext["b" /* CriteriaDisplayProvider */], null, props.withSearchForm && FacetSearch_jsx(SearchForm_SearchForm, {
    doTrackQueryChange: withSearchResults,
    i18n: props.i18n,
    onSubmit: onSubmit,
    withFacets: props.withSearchFacets,
    withQuery: !props.hideSearchInput,
    showNbResultsInLayer: props.withSearchResults,
    layerButtonLabel: props.withSearchResults ? props.i18n.remote && props.i18n.remote.searchAction || 'search' : props.i18n.booking.editCriteria.validateCriteria
  }), props.withSearchResults && FacetSearch_jsx(FacetSearchResults_FacetSearchResults, {
    i18n: props.i18n,
    initialProducts: props.initialProducts,
    isProductComparisonModeAuthorized: props.isProductComparisonModeAuthorized,
    offer: props.offer,
    resultsHasSeeMore: props.resultsHasSeeMore,
    resultsSeeMore: props.resultsSeeMore,
    isSynchronousGrid: isSynchronousGrid,
    searchOptions: searchOptions,
    shouldSetDefaultDepartureCityOnCompare: props.shouldSetDefaultDepartureCityOnCompare,
    virtualizedGrid: props.virtualizedGrid
  }))));
};

/***/ }),

/***/ "p7XS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SidePanel_SidePanel; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-focus-lock/dist/es2015/AutoFocusInside.js
var AutoFocusInside = __webpack_require__("JPie");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.themes.js
var themes = {
  "default": {
    thRoot: 'bg-white',
    thCloseButton: 'reset-button bg-white cursor-pointer leading-none m-5 p-4 rounded-full text-gray-darker text-md',
    thCloseButtonLabel: 'sr-only'
  }
};
var POSITIONS_CLASSES = {
  top: {
    pin: 'inset-x-0 top-0',
    transform: '-translate-y-100',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'bottom-0 rtl:right-0 rtl:slideInRight'
  },
  bottom: {
    pin: 'inset-x-0 bottom-0',
    transform: 'translate-y-100',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'top-0 rtl:right-0 rtl:slideInRight'
  },
  left: {
    pin: 'inset-y-0 left-0',
    transform: '-translate-x-100',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 right-0'
  },
  right: {
    pin: 'inset-y-0 right-0',
    transform: 'translate-x-100',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 left-0'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var SidePanel_SidePanel = function SidePanel(_ref) {
  var _classnames;

  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$backdropColor = _ref.backdropColor,
      backdropColor = _ref$backdropColor === void 0 ? '#000' : _ref$backdropColor,
      _ref$backdropOpacity = _ref.backdropOpacity,
      backdropOpacity = _ref$backdropOpacity === void 0 ? 0.8 : _ref$backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      height = _ref.height,
      isExpanded = _ref.isExpanded,
      onClose = _ref.onClose,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? Portal_constants["d" /* OVER_BOT */] : _ref$portalName,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom' : _ref$position,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var sidePanelBodyref = Object(react["useRef"])();
  var onScroll = Object(lodash["throttle"])(function () {
    Object(lib["forceCheck"])();
  }, 250);
  Object(react["useEffect"])(function () {
    // $FlowFixMe
    sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.addEventListener('scroll', onScroll);
    return function () {
      // $FlowFixMe
      sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.removeEventListener('scroll', onScroll);
    };
  }, []);
  Object(react["useEffect"])(function () {
    if (isExpanded) {
      Object(lib["forceCheck"])();
    }
  }, [isExpanded]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thRoot = _themes$theme.thRoot;
  var positionClasses = POSITIONS_CLASSES[position];
  var closeBtnSidePanel = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  return __jsx(Portal["a" /* default */], {
    name: portalName
  }, __jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: isExpanded
  }, isExpanded && __jsx("div", {
    className: "fadeIn fixed h-screen inset-0",
    "data-testid": "SidePanel-backdrop",
    style: {
      backgroundColor: backdropColor,
      opacity: backdropOpacity
    }
  }), __jsx("div", {
    "aria-hidden": !isExpanded,
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, __jsx("div", {
    role: "document"
  }, __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: isExpanded,
    onClickOutside: onClose,
    onEscapeKey: onClose
  }, isExpanded && __jsx(AutoFocusInside["a" /* default */], null, __jsx("button", {
    className: classnames_default()('fixed z-2', thCloseButton, positionClasses.button),
    onClick: onClose,
    type: "button"
  }, closeBtnSidePanel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnSidePanel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  }))), __jsx("aside", {
    className: classnames_default()(className, thRoot, positionClasses.pin, 'fixed h-full overflow-y-scroll transition-all w-full z-1', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, positionClasses.transform, !isExpanded), Object(defineProperty["a" /* default */])(_classnames, 'translate-0', isExpanded), _classnames)),
    ref: sidePanelBodyref,
    style: _objectSpread({
      height: height
    }, positionClasses.style)
  }, isExpanded && children))))));
};

/***/ }),

/***/ "pFHV":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("JU27"),
    mapCacheDelete = __webpack_require__("CGZ2"),
    mapCacheGet = __webpack_require__("Bio+"),
    mapCacheHas = __webpack_require__("hUtE"),
    mapCacheSet = __webpack_require__("C8zB");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "pIL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return immersiveResolver; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QsI/");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("4VTZ");




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var immersiveResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_3__[/* IMMERSIVE */ "q"],
  resolve: function () {
    var _resolve = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(appContext, props) {
      var displaySearch, query;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              displaySearch = props.displaySearch;
              query = "query {\n      config {\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_6__[/* searchRemote */ "g"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_6__[/* resort */ "e"](appContext), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_6__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_6__[/* faceting */ "b"](), "\n      }\n    }");

              if (!displaySearch) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runQuery(query, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_COMMON_IMMERSIVE */ "Gb"]
              }).then(function (data) {
                return _objectSpread({}, data);
              }));

            case 4:
              return _context.abrupt("return", Promise.resolve({}));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function resolve(_x, _x2) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }()
};

/***/ }),

/***/ "pNXd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Introduction_Introduction; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/introduction/Introduction.themes.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var defaultTheme = {
  thRoot: 'overflow-hidden sm:flex -mx-px10',
  thLeft: 'flex-1 px-px10',
  thRight: 'flex-1 mt-5 sm:mt-0 px-px10',
  thTitleTheme: 'title-brand-10',
  thSmall: 'lowercase text-base rtl:ml-1',
  thSubtitle: 'mt-2',
  thSubtitleTheme: 'title-sans-11'
};
var themes = {
  "default": defaultTheme,
  fancy: _objectSpread(_objectSpread({}, defaultTheme), {}, {
    thTitleTheme: 'title-serif-5'
  })
};
// CONCATENATED MODULE: ./src/client/components/frameworks/introduction/Introduction.jsx
var __jsx = react_default.a.createElement;





var Introduction_Introduction = function Introduction(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      iconName = _ref.iconName,
      isTextSeeMoreCollapseEnabled = _ref.isTextSeeMoreCollapseEnabled,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      small = _ref.small,
      subtitle = _ref.subtitle,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;
  var hasHeading = !!title || !!subtitle;
  var hasText = !!text;

  if (!hasHeading && !hasText) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLeft = _themes$theme.thLeft,
      thRight = _themes$theme.thRight,
      thRoot = _themes$theme.thRoot,
      thSmall = _themes$theme.thSmall,
      thSubtitle = _themes$theme.thSubtitle,
      thSubtitleTheme = _themes$theme.thSubtitleTheme,
      thTitleTheme = _themes$theme.thTitleTheme;
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    "data-testid": dataTestId
  }, hasHeading && __jsx("div", {
    className: thLeft
  }, __jsx(Title["a" /* Title */], {
    hLevel: 2,
    iconName: iconName,
    theme: thTitleTheme
  }, title, !!small && __jsx("small", {
    className: thSmall
  }, small)), __jsx(Title["a" /* Title */], {
    className: thSubtitle,
    hLevel: 3,
    theme: thSubtitleTheme
  }, subtitle)), hasText && __jsx("div", {
    className: thRight
  }, __jsx(TextSeeMore["a" /* TextSeeMore */], {
    isCollapseEnabled: isTextSeeMoreCollapseEnabled,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    text: text
  })));
};

/***/ }),

/***/ "pP7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setCms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_BOOKING_ENGINE_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBookingEngineI18n; });
/* harmony import */ var _views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9LZ4");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");


var SET_CMS = 'SET_CMS';
var setCms = function setCms(config, legalInformations) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SET_CMS, {
    config: config,
    legalInformations: legalInformations
  });
};
var GET_BOOKING_ENGINE_I18N = 'GET_BOOKING_ENGINE_I18N';
var getBookingEngineI18n = function getBookingEngineI18n(appContext) {
  return function (dispatch) {
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(GET_BOOKING_ENGINE_I18N, {}, {
      promise: Object(_views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__[/* fetchBookingEngineI18nQuery */ "a"])(appContext)
    }));
  };
};

/***/ }),

/***/ "pUua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tourProgramResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var tourProgramResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* TOUR_PROGRAM */ "Ib"],
  resolve: function resolve(appContext, props) {
    var productId = props.resortId,
        yourItinerary = props.yourItinerary,
        tourDurationPlaceholder = props.tourDurationPlaceholder,
        tourDayPlaceholder = props.tourDayPlaceholder,
        yourExtension = props.yourExtension,
        extensionDurationPlaceholder = props.extensionDurationPlaceholder,
        extensionDayPlaceholder = props.extensionDayPlaceholder;
    var query = "query {\n      stopover(productId:\"".concat(productId, "\"){\n        tour{\n          title(message:\"").concat(yourItinerary, "\")\n          duration(message:\"").concat(tourDurationPlaceholder, "\")\n          stops{\n            day(message:\"").concat(tourDayPlaceholder, "\")\n            title\n            description\n          }\n        }\n        extension{\n          title(message:\"").concat(yourExtension, "\")\n          duration(message:\"").concat(extensionDurationPlaceholder, "\")\n          stops{\n            day(message:\"").concat(extensionDayPlaceholder, "\")\n            title\n            description\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_TOUR_PROGRAM */ "Ic"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "pfIK":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("Ky/o"),
    eq = __webpack_require__("t8ah");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "psNz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BRAND_PROMISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHECKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COUNTRY_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COUNTRY_INFOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COUNTRY_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COUNTRY_POI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CRISIS_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CRUISE_BOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CRUISE_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DOWNLOAD_LINKS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EDITORIAL_FOLDING_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EVENT_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUTTON_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return HIGHLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return IMMERSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return INSTAGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return INSTAGRAM_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return LAST_SEEN_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return MEDIA_TEXT_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MEDIA_TEXT_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MEDIA_THUMBNAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MUST_TRY_EXPERIENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return NAVIGATION_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return NAVIGATION_TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return OFFER_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return OFFER_LEGAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return OFFER_SEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return OFFERS_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return OFFERS_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PAGE_TRACKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return PREBOOKING_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return PRODUCT_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return PRODUCT_BREADCRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return PRODUCT_CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return PRODUCT_COMMUNITY_QUESTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return PRODUCT_EXCLUSIVE_COLLECTION_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return PRODUCT_IMAGE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PRODUCT_IMMERSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return PRODUCT_INFORMATION_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PRODUCT_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return PRODUCT_SIGNATURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return PRODUCT_SPACE_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return PRODUCT_STREET_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return PRODUCT_STRENGTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return PRODUCT_WELLNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return PRODUCTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return PRODUCT_PRICE_TICKET_CUSTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return PRODUCT_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return QUOTATION_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return RELATED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return RESORT_ACCESS_AND_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return RESORT_ACCOMMODATION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return RESORT_BARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eb", function() { return RESORT_BOOKING_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fb", function() { return RESORT_DESTINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gb", function() { return RESORT_FLASH_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hb", function() { return RESORT_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ib", function() { return RESORT_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jb", function() { return RESORT_MEETING_ROOM_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kb", function() { return RESORT_MULTIMEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lb", function() { return RESORT_PRICE_REMOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mb", function() { return RESORT_PRICE_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nb", function() { return RESORT_RECOMMENDATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ob", function() { return RESORT_RESTAURANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pb", function() { return RESORT_SEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qb", function() { return RESORT_SPACE_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rb", function() { return RESORT_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sb", function() { return RESORT_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tb", function() { return RESORT_TRIPADVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ub", function() { return RESORT_WELLNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vb", function() { return SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wb", function() { return SECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "xb", function() { return SMART_FAQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yb", function() { return SUBMISSION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zb", function() { return TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ab", function() { return TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bb", function() { return TEASER_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cb", function() { return TEST_AB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Db", function() { return TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Eb", function() { return THEMATIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fb", function() { return TITLE_AND_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Gb", function() { return TOUR_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hb", function() { return TOUR_PRACTICAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ib", function() { return TOUR_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jb", function() { return TRIPADVISOR_TESTIMONY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Kb", function() { return VIDEO; });
var ALL_INCLUSIVE_PUSH = 'all-inclusive-push';
var BRAND_PROMISE = 'brand-promise';
var CHECKLIST = 'checklist';
var COUNTRY_EVENTS = 'country-events';
var COUNTRY_INFOS = 'country-infos';
var COUNTRY_INTRODUCTION = 'country-introduction';
var COUNTRY_POI = 'country-poi';
var CRISIS_ALERT = 'crisis-alert';
var CRUISE_BOOKING = 'cruise-booking';
var CRUISE_PROGRAM = 'cruise-program';
var DESTINATIONS = 'destinations';
var DOWNLOAD_LINKS_LIST = 'download-links-list';
var EDITORIAL_FOLDING_BLOCK = 'editorial-folding-block';
var EVENT_FORM = 'event-form';
var BUTTON_TICKET = 'button-ticket';
var HIGHLIGHT = 'highlight';
var IMMERSIVE = 'immersive';
var INSTAGRAM = 'instagram';
var INSTAGRAM_GRID = 'instagram-grid';
var LAST_SEEN_PRODUCTS = 'last-seen-products';
var MEDIA_TEXT_HORIZONTAL = 'media-text-horizontal';
var MEDIA_TEXT_VERTICAL = 'media-text-vertical';
var MEDIA_THUMBNAIL = 'media-thumbnail';
var MUST_TRY_EXPERIENCES = 'must-try-experiences';
var NAVIGATION_TAB = 'navigation-tab';
var NAVIGATION_TABS = 'navigation-tabs';
var OFFER_DESCRIPTION = 'offer-description';
var OFFER_LEGAL_INFORMATION = 'offer-legal-information';
var OFFER_SEO = 'offer-seo';
var OFFERS_GRID = 'offers-grid';
var OFFERS_PUSH = 'offers-push';
var PAGE_TRACKING = 'page-tracking';
var PREBOOKING_FORM = 'prebooking-form';
var PRODUCT_ACTIVITIES = 'product-activities';
var PRODUCT_BREADCRUMB = 'product-breadcrumb';
var PRODUCT_CHILDCARES = 'product-childcares';
var PRODUCT_COMMUNITY_QUESTIONS = 'product-community-questions';
var PRODUCT_EXCLUSIVE_COLLECTION_SPACE = 'product-exclusive-collection-space';
var PRODUCT_IMAGE_MAP = 'product-image-map';
var PRODUCT_IMMERSIVE = 'product-immersive';
var PRODUCT_INFORMATION_SUMMARY = 'product-information-summary';
var PRODUCT_SERVICES = 'product-services';
var PRODUCT_SIGNATURES = 'product-signatures';
var PRODUCT_SPACE_INTRODUCTION = 'product-space-introduction';
var PRODUCT_STREET_VIEW = 'product-street-view';
var PRODUCT_STRENGTHS = 'product-strengths';
var PRODUCT_WELLNESS = 'product-wellness';
var PRODUCTS_FILTERS = 'products-filters';
var PRODUCT_PRICE_TICKET_CUSTOM = 'product-price-ticket-custom';
var PRODUCT_TAGS = 'product-tags';
var QUOTATION_FORM = 'quotation-form';
var RELATED_PRODUCTS = 'related-products';
var RESORT_ACCESS_AND_MAP = 'resort-access-and-map';
var RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION = 'resort-accommodation-exclusivecollection';
var RESORT_ACCOMMODATION_TYPES = 'resort-accommodationTypes';
var RESORT_BARS = 'resort-bars';
var RESORT_BOOKING_BE = 'resort-bookingBE';
var RESORT_DESTINATION = 'resort-destination';
var RESORT_FLASH_INFO = 'resort-flash-info';
var RESORT_GRID = 'resort-grid';
var RESORT_INTRODUCTION = 'resort-introduction';
var RESORT_MEETING_ROOM_INFO = 'resort-meeting-room-info';
var RESORT_MULTIMEDIA = 'resort-multimedia';
var RESORT_PRICE_REMOTE = 'resort-price-remote';
var RESORT_PRICE_TICKET = 'resort-price-ticket';
var RESORT_RECOMMENDATIONS = 'resort-recommendations';
var RESORT_RESTAURANTS = 'resort-restaurants';
var RESORT_SEO = 'resort-seo';
var RESORT_SPACE_INTRODUCTION = 'resort-space-introduction';
var RESORT_SUMMARY = 'resort-summary';
var RESORT_TAGS = 'product-tags';
var RESORT_TRIPADVISOR = 'resort-tripadvisor';
var RESORT_WELLNESS = 'resort-wellness';
var SECTION = 'section';
var SECTIONS = 'sections';
var SMART_FAQ = 'smart-faq';
var SUBMISSION_STATUS = 'submission-status';
var TAB = 'tab';
var TABS = 'tabs';
var TEASER_CARDS = 'teaser-cards';
var TEST_AB = 'test-ab';
var TEXT = 'text';
var THEMATIC = 'thematic';
var TITLE_AND_TEXT = 'title-and-text';
var TOUR_INTRODUCTION = 'tour-introduction';
var TOUR_PRACTICAL_INFORMATION = 'tour-practical-information';
var TOUR_PROGRAM = 'tour-program';
var TRIPADVISOR_TESTIMONY = 'tripadvisor-testimony';
var VIDEO = 'video';

/***/ }),

/***/ "pteD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TripDatePicker_TripDatePicker; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-day-picker/DayPicker.js
var DayPicker = __webpack_require__("nFOY");
var DayPicker_default = /*#__PURE__*/__webpack_require__.n(DayPicker);

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.utils.js
var Datepicker_utils = __webpack_require__("szYs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/DatepickerArrow.jsx
var __jsx = react_default.a.createElement;







function DatepickerArrow(_ref) {
  var className = _ref.className,
      fromMonth = _ref.fromMonth,
      locale = _ref.locale,
      month = _ref.month,
      _ref$onPrevious = _ref.onPrevious,
      onPrevious = _ref$onPrevious === void 0 ? lodash["noop"] : _ref$onPrevious,
      _ref$onNext = _ref.onNext,
      onNext = _ref$onNext === void 0 ? lodash["noop"] : _ref$onNext,
      toMonth = _ref.toMonth;
  return __jsx("div", {
    className: className
  }, !DayPicker["DateUtils"].isSameMonth(month, fromMonth) ? __jsx("button", {
    className: "reset-button",
    "data-testid": "datepicker-arrow-prev",
    onClick: function onClick() {
      return onPrevious();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    rotation: 180,
    width: "0.625rem"
  })) : __jsx("div", {
    style: {
      width: 30,
      height: 30
    }
  }), __jsx("span", {
    className: "flex-1"
  }, Object(Datepicker_utils["formatMonthTitle"])(month, locale)), !DayPicker["DateUtils"].isSameMonth(month, toMonth) ? __jsx("button", {
    className: "reset-button",
    "data-testid": "datepicker-arrow-next",
    onClick: function onClick() {
      return onNext();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.625rem"
  })) : __jsx("div", {
    style: {
      width: 30,
      height: 30
    }
  }));
}
// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/DatepickerCaption.jsx
var DatepickerCaption_jsx = react_default.a.createElement;





function DatepickerCaption(_ref) {
  var className = _ref.className,
      _ref$date = _ref.date,
      date = _ref$date === void 0 ? new Date() : _ref$date,
      fromMonth = _ref.fromMonth,
      hasNavigationByYear = _ref.hasNavigationByYear,
      onNext = _ref.onNext,
      onPrevious = _ref.onPrevious,
      toMonth = _ref.toMonth;
  if (!hasNavigationByYear) return null;
  var currentYear = date.getFullYear();
  var fromYear = fromMonth.getFullYear();
  var toYear = toMonth.getFullYear();
  return DatepickerCaption_jsx("div", {
    className: classnames_default()(className, 'flex items-center justify-between')
  }, currentYear > fromYear && DatepickerCaption_jsx("button", {
    className: "reset-button",
    onClick: function onClick() {
      return onPrevious();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, DatepickerCaption_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    rotation: 180,
    width: "0.625rem"
  })), DatepickerCaption_jsx("span", {
    className: "flex-1"
  }, date.getFullYear(), " "), currentYear < toYear && DatepickerCaption_jsx("button", {
    className: "reset-button",
    onClick: function onClick() {
      return onNext();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, DatepickerCaption_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.625rem"
  })));
}
// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/Datepicker.themes.js
var themes = {
  "default": {
    thRoot: 'relative font-base font-bold text-center',
    thDayPicker: {
      container: 'relative sm:bg-white sm:rounded',
      // The container element
      wrapper: '',
      // The wrapper element, used for keyboard interaction
      interactionDisabled: '',
      // Added to the container when there's no interaction with the calendar
      navBar: 'flex items-center justify-between pb-2',
      // The navigation bar with the arrows to switch between months
      navButtonPrev: '',
      // Button to switch to the previous month
      navButtonNext: '',
      // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default',
      // Added to the navbuttons when disabled with fromMonth/toMonth props
      months: 'flex -m-3',
      // Container of the months table
      month: 'flex-1 p-3',
      // The month's main table
      caption: 'font-bold mb-5 text-center text-md text-gray-darker',
      // The caption element, containing the current month's name and year
      weekdays: '',
      // Table header displaying the weekdays names
      weekdaysRow: 'flex',
      // Table row displaying the weekdays names
      weekday: 'flex-1 text-base text-gray-medium uppercase',
      // Cell displaying the weekday name
      body: 'body border-l border-b border-gray-light',
      // Table's body with the weeks
      week: 'flex',
      // Table's row for each week
      day: 'cursor-pointer flex-1 flex flex-col items-center justify-center md:h-25 h-13 p-1 text-base text-center transition-all border-t border-r border-gray-light',
      // The single day cell
      footer: 'mt-3',
      // The calendar footer (only with todayButton prop)
      todayButton: 'text-blue focus:text-turquoise hover:text-turquoise text-sm reset-button',
      // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'underline',
      // Added to the day's cell for the current day
      selected: 'bg-overlay-emerald-30 opacity-100 Datepicker-selected',
      // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'cursor-default pointer-events-none text-gray-medium',
      // Added to the day's cell specified in the "disabledDays" prop
      outside: 'text-gray-light' // Added to the day's cell outside the current month

    },
    thDayStart: 'thDayStart bg-emerald-active text-white',
    thDayEnd: 'thDayEnd bg-emerald-active text-white',
    thDayMiddle: 'thDayMiddle bg-emerald text-white'
  },
  compact: {
    thRoot: 'relative font-base font-bold text-center',
    thDayPicker: {
      container: 'overflow-hidden relative sm:bg-white sm:rounded',
      // The container element
      wrapper: '',
      // The wrapper element, used for keyboard interaction
      interactionDisabled: '',
      // Added to the container when there's no interaction with the calendar
      navBar: 'flex items-center justify-between pb-2',
      // The navigation bar with the arrows to switch between months
      navButtonPrev: '',
      // Button to switch to the previous month
      navButtonNext: '',
      // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default',
      // Added to the navbuttons when disabled with fromMonth/toMonth props
      months: 'flex -m-3',
      // Container of the months table
      month: 'flex-1 p-3',
      // The month's main table
      caption: 'font-bold mb-5 text-center text-md text-gray-darker',
      // The caption element, containing the current month's name and year
      weekdays: '',
      // Table header displaying the weekdays names
      weekdaysRow: 'flex',
      // Table row displaying the weekdays names
      weekday: 'flex-1 text-base text-gray-medium uppercase',
      // Cell displaying the weekday name
      body: 'body',
      // Table's body with the weeks
      week: 'flex',
      // Table's row for each week
      day: 'cursor-pointer flex-1 flex flex-col items-center justify-center h-10 p-1 text-base text-center transition-all',
      // The single day cell
      footer: 'mt-3',
      // The calendar footer (only with todayButton prop)
      todayButton: 'text-blue focus:text-turquoise hover:text-turquoise text-sm reset-button',
      // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'underline',
      // Added to the day's cell for the current day
      selected: 'bg-overlay-emerald-40 opacity-100 Datepicker-selected',
      // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'cursor-default pointer-events-none text-gray-medium',
      // Added to the day's cell specified in the "disabledDays" prop
      outside: 'opacity-50' // Added to the day's cell outside the current month

    },
    thDayStart: 'bg-emerald rtl:rounded-l text-white',
    thDayEnd: 'bg-emerald rtl:rounded-r text-white',
    thDayMiddle: 'bg-emerald text-white'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/Datepicker.jsx


var Datepicker_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function isSelectingFirstDay(from, to, day) {
  var isBeforeFirstDay = Boolean(from && DayPicker["DateUtils"].isDayBefore(day, from));
  var isRangeSelected = Boolean(from && to);
  return !from || isBeforeFirstDay || isRangeSelected;
}

function isChangingSelection(from, to, day) {
  return Boolean(from && to && day >= from && day <= to);
}

function isSelectingSameDay(from, to, day) {
  return Boolean(from && !to && DayPicker["DateUtils"].isSameDay(from, day));
}

var Datepicker_Datepicker = function Datepicker(props) {
  var _objectSpread2;

  var className = props.className,
      maxDate = props.maxDate,
      minDate = props.minDate,
      navbarElement = props.navbarElement,
      hasNavigationByYear = props.hasNavigationByYear,
      initialMonth = props.initialMonth,
      _props$locale = props.locale,
      locale = _props$locale === void 0 ? moment_default.a.locale() : _props$locale,
      renderDay = props.renderDay,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      _props$customModifier = props.customModifiers,
      customModifiers = _props$customModifier === void 0 ? {} : _props$customModifier,
      _props$datePickerClas = props.datePickerClassNames,
      datePickerClassNames = _props$datePickerClas === void 0 ? {} : _props$datePickerClas,
      _props$disabledDays = props.disabledDays,
      disabledDays = _props$disabledDays === void 0 ? [] : _props$disabledDays,
      selectedDays = props.selectedDays,
      hasRangeMode = props.hasRangeMode,
      onSelect = props.onSelect,
      onMouseOver = props.onMouseOver,
      weekdayElement = props.weekdayElement;

  var _ref = !selectedDays || DayPicker["DateUtils"].isDate(selectedDays) ? {
    from: selectedDays,
    to: selectedDays
  } : selectedDays,
      from = _ref.from,
      to = _ref.to;

  var month = from || initialMonth || minDate || new Date();

  var _useState = Object(react["useState"])(null),
      hovered = _useState[0],
      setHovered = _useState[1];

  var _useState2 = Object(react["useState"])(month),
      activeMonth = _useState2[0],
      setActiveMonth = _useState2[1];

  Object(react["useEffect"])(function () {
    setActiveMonth(month);
  }, [moment_default()(month, moment_default.a.defaultFormat).format('YYYYMMDD')]);

  var handleDayClick = function handleDayClick(day, modifiers) {
    setHovered(null);

    if (onSelect) {
      if (!hasRangeMode) {
        onSelect({
          from: day,
          to: day,
          modifiers: modifiers
        });
      } else if (isSelectingFirstDay(from, to, day) || isChangingSelection(from, to, day)) {
        onSelect({
          from: day,
          to: null,
          modifiers: modifiers
        });
      } else if (isSelectingSameDay(from, to, day)) {
        onSelect({
          from: null,
          to: null,
          modifiers: modifiers
        });
      } else {
        onSelect({
          from: from,
          to: day,
          modifiers: modifiers
        });
      }
    }
  };

  var handleDayMouseEnter = function handleDayMouseEnter(day) {
    setHovered(day);

    if (onMouseOver) {
      onMouseOver(day);
    }
  };

  var handleDayMouseLeave = function handleDayMouseLeave() {
    setHovered(null);
  };

  var addMonthsInRange = function addMonthsInRange(date, number) {
    var targetMonth = moment_default()(date).add({
      months: number
    }).toDate();
    if (minDate && DayPicker["DateUtils"].isDayBefore(targetMonth, minDate)) return minDate;
    if (maxDate && DayPicker["DateUtils"].isDayAfter(targetMonth, maxDate)) return maxDate;
    return targetMonth;
  };

  var handleNextMonth = function handleNextMonth() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, 1));
  };

  var handlePreviousMonth = function handlePreviousMonth() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, -1));
  };

  var handleNextYear = function handleNextYear() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, 12));
  };

  var handlePreviousYear = function handlePreviousYear() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, -12));
  };

  var allDisabledDays = [].concat(Object(toConsumableArray["a" /* default */])(disabledDays), [{
    before: minDate,
    after: maxDate
  }]);
  var _themes$theme = themes[theme],
      thDayEnd = _themes$theme.thDayEnd,
      thDayStart = _themes$theme.thDayStart,
      thDayMiddle = _themes$theme.thDayMiddle,
      thDayPicker = _themes$theme.thDayPicker,
      thRoot = _themes$theme.thRoot;
  var allSelectedDays = [from, {
    from: from,
    to: to || hovered
  }, hovered];

  var modifiers = _objectSpread(_objectSpread({}, customModifiers), {}, (_objectSpread2 = {}, Object(defineProperty["a" /* default */])(_objectSpread2, thDayStart, from), Object(defineProperty["a" /* default */])(_objectSpread2, thDayEnd, to), Object(defineProperty["a" /* default */])(_objectSpread2, thDayMiddle, hovered), _objectSpread2));

  return Datepicker_jsx("div", {
    className: classnames_default()(className, thRoot)
  }, Datepicker_jsx(DayPicker_default.a, {
    canChangeMonth: true,
    firstDayOfWeek: moment_default.a.localeData().firstDayOfWeek(),
    fixedWeeks: true,
    locale: locale,
    localeUtils: Datepicker_utils,
    showOutsideDays: true,
    showWeekDays: true,
    captionElement: Datepicker_jsx(DatepickerCaption, {
      className: thDayPicker.caption,
      fromMonth: minDate,
      hasNavigationByYear: hasNavigationByYear,
      onNext: handleNextYear,
      onPrevious: handlePreviousYear,
      toMonth: maxDate
    }),
    classNames: _objectSpread(_objectSpread({}, thDayPicker), datePickerClassNames),
    disabledDays: allDisabledDays,
    fromMonth: minDate,
    initialMonth: initialMonth,
    modifiers: modifiers,
    month: activeMonth,
    navbarElement: navbarElement || Datepicker_jsx(DatepickerArrow, {
      onNext: handleNextMonth,
      onPrevious: handlePreviousMonth,
      fromMonth: minDate,
      locale: locale,
      toMonth: maxDate
    }),
    onDayClick: handleDayClick,
    onDayMouseEnter: handleDayMouseEnter,
    onDayMouseLeave: handleDayMouseLeave,
    renderDay: renderDay,
    selectedDays: allSelectedDays,
    toMonth: maxDate,
    weekdayElement: weekdayElement
  }));
};
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.themes.js
var TripDatePicker_themes_themes = function themes(isTablet) {
  return {
    "default": {
      thDay: "cursor-pointer flex-1 flex flex-col items-center justify-center ".concat(isTablet ? 'h-25' : 'h-13', " p-1 text-base text-center transition-all border-t border-r border-gray-light relative"),
      thDayNumber: 'md:absolute top-0 left-0 md:p-1 text-xs md:text-sm font-normal',
      thDayOldPrice: 'text-sm line-through hidden md:block',
      thDayPrice: 'text-sm md:text-md',
      thStatusMessage: 'hidden md:inline w-full font-normal',
      thFrom: 'hidden md:inline w-full font-normal'
    },
    compact: {
      thDay: 'cursor-pointer flex flex-1 flex-col items-center justify-start h-9 leading-tight p-1 text-base text-center',
      thDayNumber: '',
      thDayOldPrice: 'hidden',
      thDayPrice: 'mx-auto self-end block font-hairline text-xs',
      thStatusMessage: 'hidden',
      thFrom: 'hidden'
    }
  };
};
// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDetails.jsx
var DayPriceDetails_jsx = react_default.a.createElement;





var DayPriceDetails_DayPriceDetails = function DayPriceDetails(_ref) {
  var day = _ref.day,
      duration = _ref.duration,
      departureCity = _ref.departureCity,
      hasTransport = _ref.hasTransport,
      isJoyview = _ref.isJoyview,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      unit = _ref.unit;

  var _useState = Object(react["useState"])(false),
      isVisible = _useState[0],
      setIsVisibleState = _useState[1];

  var setIsVisible = Object(lodash["debounce"])(function (visible) {
    setIsVisibleState(visible);
  }, 150);

  var setVisibile = function setVisibile() {
    if (!isVisible) {
      setIsVisible(true);
    }
  };

  var seInVisible = function seInVisible() {
    return setIsVisible(false);
  };

  Object(react["useEffect"])(function () {
    setIsVisible(shouldDisplayDetails);
  }, [shouldDisplayDetails]);
  var dateFormat = Object(i18n["f" /* t */])('resort.startingPrice.dateFormat');
  var startDate = moment_default()(day).format(dateFormat);
  var endDate = moment_default()(day).add({
    days: duration
  }).format(dateFormat);
  return DayPriceDetails_jsx(react["Fragment"], null, DayPriceDetails_jsx("div", {
    className: "absolute inset-0 z-3 w-full h-full",
    onMouseOver: setVisibile,
    onMouseLeave: seInVisible
  }), isVisible && shouldDisplayDetails && DayPriceDetails_jsx("div", {
    className: "absolute left-1/2 -translate-x-50 z-2 top-0 text-initial font-normal",
    style: {
      width: '25rem'
    }
  }, DayPriceDetails_jsx("div", {
    className: "absolute bottom-full fadeIn inset-x-0"
  }, DayPriceDetails_jsx("div", {
    className: "arrow-down arrow-large arrow-white bg-white filter-drop-shadow-after rounded-tiny shadow-md"
  }, DayPriceDetails_jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
    city: departureCity,
    endDate: endDate,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    startDate: startDate,
    unit: unit
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayWithPrice.jsx
var DayWithPrice_jsx = react_default.a.createElement;








var COMPACT_MAX_CHARACTERS = 5;
var DayWithPrice_DayWithPrice = function DayWithPrice(_ref) {
  var day = _ref.day,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 7 : _ref$duration,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? false : _ref$hasInstalment,
      isJoyview = _ref.isJoyview,
      locale = _ref.locale,
      _ref$price = _ref.price,
      availability = _ref$price.availability,
      currency = _ref$price.currency,
      departureCity = _ref$price.departureCity,
      hasTransport = _ref$price.hasTransport,
      formattedPriceValue = _ref$price.price,
      oldPrice = _ref$price.oldPrice,
      unit = _ref$price.unit,
      priceValue = _ref$price.priceValue,
      shouldDisplayPrice = _ref.shouldDisplayPrice,
      shouldDisplayStatusMessage = _ref.shouldDisplayStatusMessage,
      isLoading = _ref.isLoading,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      theme = _ref.theme,
      withPriceDetails = _ref.withPriceDetails;
  var statusMessageKey = "booking.priceCalendar.priceStatus.".concat(availability);
  var _themes$theme = TripDatePicker_themes_themes()[theme],
      thDayNumber = _themes$theme.thDayNumber,
      thDayOldPrice = _themes$theme.thDayOldPrice,
      thDayPrice = _themes$theme.thDayPrice,
      thStatusMessage = _themes$theme.thStatusMessage,
      thFrom = _themes$theme.thFrom;

  var getCompactPrice = function getCompactPrice(rawPrice) {
    var compactPrice = (rawPrice === null || rawPrice === void 0 ? void 0 : rawPrice.replace(/[\s|.,]/gi, '')) || '';
    return compactPrice.length <= COMPACT_MAX_CHARACTERS ? compactPrice : '';
  };

  var price = hasInstalment ? Object(price_util["b" /* getInstalmentPrice */])({
    currency: currency,
    formattedValue: formattedPriceValue,
    value: priceValue
  }, locale) : formattedPriceValue;
  return DayWithPrice_jsx(react["Fragment"], null, withPriceDetails && DayWithPrice_jsx(DayPriceDetails_DayPriceDetails, {
    duration: duration,
    departureCity: departureCity,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    shouldDisplayDetails: !!price && shouldDisplayDetails,
    day: day,
    unit: unit
  }), DayWithPrice_jsx("span", {
    className: thDayNumber
  }, moment_default()(day).format('D')), shouldDisplayStatusMessage && Object(i18n["d" /* has */])(statusMessageKey) && !isLoading && DayWithPrice_jsx("span", {
    className: thStatusMessage
  }, Object(i18n["f" /* t */])(statusMessageKey)), isLoading && DayWithPrice_jsx(Spinner["a" /* Spinner */], {
    size: "tiny",
    color: colors["a" /* COLORS */].GRAY
  }), shouldDisplayPrice && !isLoading && DayWithPrice_jsx(react["Fragment"], null, !!price && DayWithPrice_jsx("span", {
    className: thFrom
  }, Object(i18n["f" /* t */])('price.format.from')), DayWithPrice_jsx("span", {
    "data-testid": "price",
    className: thDayPrice
  }, theme === 'compact' ? getCompactPrice(price) : price), price !== oldPrice && DayWithPrice_jsx("span", {
    className: thDayOldPrice
  }, oldPrice)));
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx



var TripDatePicker_jsx = react_default.a.createElement;














var selector = function selector(state) {
  var _state$calendar;

  return {
    isBookableDatesLoading: state === null || state === void 0 ? void 0 : (_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.bookableDatesLoading
  };
}; // $FlowFixMe


var Weekday = function Weekday(_ref) {
  var weekday = _ref.weekday,
      className = _ref.className,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale;
  var weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return TripDatePicker_jsx("div", {
    className: className,
    title: weekdayName
  }, weekdayName);
};

var TripDatePicker_TripDatePicker = function TripDatePicker(_ref2) {
  var _modifiers;

  var className = _ref2.className,
      departureDate = _ref2.departureDate,
      duration = _ref2.duration,
      hasInstalment = _ref2.hasInstalment,
      isJoyview = _ref2.isJoyview,
      navbarElement = _ref2.navbarElement,
      navigationByYear = _ref2.navigationByYear,
      offsetCalendar = _ref2.offsetCalendar,
      onDayMouseOver = _ref2.onDayMouseOver,
      onSelect = _ref2.onSelect,
      openCalendarToDate = _ref2.openCalendarToDate,
      optionsDuration = _ref2.optionsDuration,
      prices = _ref2.prices,
      _ref2$selectedDays = _ref2.selectedDays,
      from = _ref2$selectedDays.from,
      to = _ref2$selectedDays.to,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      withLongDayFormat = _ref2.withLongDayFormat,
      _ref2$withPriceDetail = _ref2.withPriceDetails,
      withPriceDetails = _ref2$withPriceDetail === void 0 ? false : _ref2$withPriceDetail,
      props = Object(objectWithoutProperties["a" /* default */])(_ref2, ["className", "departureDate", "duration", "hasInstalment", "isJoyview", "navbarElement", "navigationByYear", "offsetCalendar", "onDayMouseOver", "onSelect", "openCalendarToDate", "optionsDuration", "prices", "selectedDays", "theme", "withLongDayFormat", "withPriceDetails"]);

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var _props$displayPrices = props.displayPrices,
      displayPrices = _props$displayPrices === void 0 ? Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('datePicker.displayPrices') : _props$displayPrices;

  var _useSelector = Object(es["e" /* useSelector */])(selector),
      isBookableDatesLoading = _useSelector.isBookableDatesLoading;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var onMouseOver = function onMouseOver(day) {
    onDayMouseOver && onDayMouseOver(day);
  };

  var pricesIds = Object.keys(prices || {});
  var flattenedPrices = prices ? Object(TripDatePicker_utils["e" /* flattenPrices */])(prices) : '';
  var hasPrices = pricesIds.length > 0;
  var doDisplayPricesInDatePicker = hasPrices && displayPrices;
  var resolvePrice = Object(react["useCallback"])(function (dayId) {
    return Object(lodash["get"])(prices, "[".concat(dayId, "]"), {});
  }, [flattenedPrices]);
  var isSeller = appContext.isSeller,
      locale = appContext.locale;
  var disabledDays = Object(react["useMemo"])(function () {
    return Object(TripDatePicker_utils["f" /* getDisabledDays */])({
      from: from,
      to: to,
      prices: prices,
      isSeller: isSeller,
      optionsDuration: optionsDuration,
      resolvePrice: resolvePrice
    });
  }, [from, isSeller, optionsDuration.join(), flattenedPrices, to]);
  var dayIsClosed = Object(react["useCallback"])(Object(TripDatePicker_utils["b" /* closedDaysFactory */])(resolvePrice, from, moment_default()(to).subtract(1, 'day').toDate()), [from, to, flattenedPrices]);
  var classColorGreen = 'text-emerald';
  var classColorOrange = 'text-orange';
  var modifiers = (_modifiers = {}, Object(defineProperty["a" /* default */])(_modifiers, classColorGreen, hasPrices ? Object(TripDatePicker_utils["a" /* bestPrice */])(resolvePrice) : []), Object(defineProperty["a" /* default */])(_modifiers, classColorOrange, hasPrices ? Object(TripDatePicker_utils["g" /* lastRoom */])(resolvePrice) : []), Object(defineProperty["a" /* default */])(_modifiers, "disabledDays", disabledDays), Object(defineProperty["a" /* default */])(_modifiers, 'pointer-events-none', function pointerEventsNone(day) {
    var dayIsSelected = from && to && Object(TripDatePicker_utils["d" /* dateToInt */])(day) >= Object(TripDatePicker_utils["d" /* dateToInt */])(from) && Object(TripDatePicker_utils["d" /* dateToInt */])(day) <= Object(TripDatePicker_utils["d" /* dateToInt */])(to);

    if (hasPrices && dayIsSelected) {
      return dayIsClosed(day);
    }
  }), _modifiers);
  var firstDateWithPrices = Object(react["useMemo"])(function () {
    var today = Object(TripDatePicker_utils["d" /* dateToInt */])(new Date());
    var dayWithPrice = pricesIds.find(function (pricesKey) {
      return Object(TripDatePicker_utils["d" /* dateToInt */])(moment_default()(pricesKey, apiDate["a" /* API_DATE_FORMAT */]).toDate()) > today && prices && prices[pricesKey].available;
    });
    return dayWithPrice || '';
  }, [flattenedPrices]);
  var thDay = TripDatePicker_themes_themes(isTablet)[theme].thDay; // If bookable dates are loading only define current or selected day as range

  var datesRange = isBookableDatesLoading ? {
    min: moment_default()(from).toDate(),
    max: moment_default()(from).toDate()
  } : {
    min: Object(TripDatePicker_utils["i" /* minDatepickerDate */])(offsetCalendar),
    max: Object(TripDatePicker_utils["h" /* maxDatepickerDate */])()
  };
  return TripDatePicker_jsx(Datepicker_Datepicker, Object(esm_extends["a" /* default */])({
    hasRangeMode: true,
    className: className,
    selectedDays: {
      from: from,
      to: to
    },
    disabledDays: disabledDays,
    customModifiers: modifiers,
    hasNavigationByYear: navigationByYear,
    minDate: datesRange.min,
    maxDate: datesRange.max,
    navbarElement: navbarElement,
    initialMonth: moment_default()(from || openCalendarToDate || firstDateWithPrices || Object(TripDatePicker_utils["i" /* minDatepickerDate */])(offsetCalendar)).toDate(),
    onSelect: onSelect,
    onMouseOver: onMouseOver,
    onFocus: onMouseOver,
    theme: theme,
    weekdayElement: withLongDayFormat ? TripDatePicker_jsx(Weekday, null) : undefined
  }, doDisplayPricesInDatePicker ? {
    // eslint-disable-next-line clubmed/no-fake-component
    renderDay: function renderDay(day, dayModifiers) {
      return TripDatePicker_jsx(DayWithPrice_DayWithPrice, {
        day: day,
        duration: duration,
        hasInstalment: hasInstalment,
        isLoading: departureDate && isBookableDatesLoading && moment_default()(day).isAfter(departureDate) ? true : false,
        isJoyview: isJoyview,
        locale: locale,
        price: resolvePrice(Object(TripDatePicker_utils["d" /* dateToInt */])(day)),
        shouldDisplayPrice: hasPrices && !from,
        shouldDisplayStatusMessage: !from,
        shouldDisplayDetails: withPriceDetails && !!dayModifiers[themes[theme].thDayPicker.selected] && !from && !to,
        withPriceDetails: withPriceDetails,
        theme: theme
      });
    },
    datePickerClassNames: {
      day: thDay
    }
  } : null));
};

/***/ }),

/***/ "qFX+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCALES; });
var LOCALES = {
  EN_CN: 'en-CN',
  ZH_CN: 'zh-CN'
};


/***/ }),

/***/ "qLhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FilterWhen_FilterWhen; });

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.jsx + 1 modules
var InputSelect = __webpack_require__("oWz2");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx + 7 modules
var TripDatePicker = __webpack_require__("pteD");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.constants.js
var flexibility_constants = __webpack_require__("45Yg");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.action.js


function setFlexibility(value) {
  return Object(createAction["b" /* default */])(flexibility_constants["a" /* TRIP_INFORMATION_SET_FLEXIBILITY */], {
    value: value
  });
}
// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/FilterWhen.jsx
var __jsx = react_default.a.createElement;














var FilterWhen_PriceLegend = function PriceLegend() {
  return __jsx("div", {
    className: "content-start flex flex-wrap justify-center"
  }, __jsx("div", {
    className: "text-center text-sm pl-2 py-1 text-emerald"
  }, Object(i18n["f" /* t */])('faceting.when.bestPrice')), __jsx("div", {
    className: "text-center text-sm pl-2 py-1 text-orange"
  }, Object(i18n["f" /* t */])('faceting.when.lastAvailability')), __jsx("div", {
    className: "text-center text-sm pl-4 py-1 text-gray-light"
  }, Object(i18n["f" /* t */])('faceting.when.notAvailable')));
};

var FilterWhen_FilterWhen = function FilterWhen(_ref) {
  var changeDepartureDate = _ref.changeDepartureDate,
      changeTripDuration = _ref.changeTripDuration,
      dateFormat = _ref.dateFormat,
      _ref$defaultDuration = _ref.defaultDuration,
      defaultDuration = _ref$defaultDuration === void 0 ? 7 : _ref$defaultDuration,
      departureDate = _ref.departureDate,
      duration = _ref.duration,
      isSubmittable = _ref.isSubmittable,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      navigationByYear = _ref.navigationByYear,
      openCalendarToDate = _ref.openCalendarToDate,
      _ref$optionsDuration = _ref.optionsDuration,
      optionsDuration = _ref$optionsDuration === void 0 ? [] : _ref$optionsDuration,
      _ref$prices = _ref.prices,
      prices = _ref$prices === void 0 ? {} : _ref$prices,
      _ref$showDurationLabe = _ref.showDurationLabel,
      showDurationLabel = _ref$showDurationLabe === void 0 ? true : _ref$showDurationLabe,
      offsetCalendar = _ref.offsetCalendar,
      _ref$withFlexibility = _ref.withFlexibility,
      withFlexibility = _ref$withFlexibility === void 0 ? false : _ref$withFlexibility;
  var track = Object(useTracking["a" /* useTracking */])({});
  var dispatch = Object(es["d" /* useDispatch */])();
  var from = departureDate ? moment_default()(departureDate).toDate() : null;
  var to = from && duration ? moment_default()(from).add({
    days: duration
  }).toDate() : null;

  var _useState = Object(react["useState"])(from),
      hovered = _useState[0],
      setHovered = _useState[1];

  var computeDisplayedDuration = function computeDisplayedDuration() {
    var displayedDuration = from && (to || hovered) ? Object(TripDatePicker_utils["c" /* dateDiff */])(from, to || hovered || from) || duration || defaultDuration : 0;
    return displayedDuration || defaultDuration || 0;
  };

  var displayedDuration = computeDisplayedDuration();
  var flexibility = Object(es["e" /* useSelector */])(tripCriteria_selector["d" /* getTripFlexibility */]);
  Object(react["useEffect"])(function () {
    if (!departureDate) {
      setHovered(null);
    }
  }, [departureDate]);

  var onFlexibilityChange = function onFlexibilityChange(name, value) {
    var flexibilityValue = parseInt(value, 10);
    track({
      actionGA: 'smartCriterias',
      labelGA: "flexibility_".concat(flexibilityValue || 'none')
    });
    dispatch(setFlexibility(flexibilityValue));
  };

  var onDayMouseOver = function onDayMouseOver(day) {
    setHovered(day);
  };

  var onSelect = function onSelect(dates) {
    changeDepartureDate(dates.from);

    if (dates.from && dates.to) {
      var updatedDuration = Object(TripDatePicker_utils["c" /* dateDiff */])(dates.from, dates.to);
      changeTripDuration(updatedDuration);
    } else {
      changeTripDuration(null);
    }
  };

  var hasPrices = Object.keys(prices || {}).length > 0;
  var cls = ['p-2 mx-4 mb-3 bg-white border-1 border-gray-light rounded', 'lg:p-0 lg:m-1 md:mx-auto lg:rounded-none lg:border-0 lg:mr-1 text-center'];
  var durationLabel = Object(dist["messageFormat"])({
    n: Object(i18n["f" /* t */])('faceting.when.durationPlural'),
    _0: '-',
    _1: Object(i18n["f" /* t */])('faceting.when.durationSingular')
  }).format({
    n: displayedDuration,
    count: displayedDuration
  });
  return __jsx("div", {
    "data-testid": "FilterWhen",
    className: "block p-2 mb-10 sm:m-0"
  }, label ? __jsx(react["Fragment"], null, isSubmittable ? __jsx("div", {
    className: "text-sm font-bold text-left text-orange flex items-center"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].WARNING,
    width: "2.5em",
    className: "mr-3 flex"
  }), __jsx("span", null, label)) : __jsx("div", {
    className: "text-lg font-bold lg:text-center"
  }, label)) : null, __jsx("div", {
    className: "block p-2 mx-2 text-base sm:hidden"
  }, __jsx("div", {
    className: "flex justify-between mb-1"
  }, __jsx("span", null, Object(i18n["f" /* t */])('faceting.when.arrivalDateTitle')), __jsx("span", {
    className: "font-bold text-blue"
  }, from ? moment_default()(from).format(dateFormat) : ' -')), __jsx("div", {
    className: "flex justify-between mb-1"
  }, __jsx("span", null, Object(i18n["f" /* t */])('faceting.when.departureDateTitle')), __jsx("span", {
    className: "font-bold text-blue"
  }, to ? moment_default()(to).format(dateFormat) : ' -'))), __jsx("div", {
    className: cls.join(' ')
  }, showDurationLabel && !hasPrices ? __jsx("div", {
    className: "px-4 py-2 mb-1 lg:px-2 sm:border-b"
  }, __jsx("div", {
    className: "flex justify-between items-center mt-1 text-base"
  }, __jsx("span", null, Object(i18n["f" /* t */])('faceting.when.duration')), __jsx("span", {
    "data-testid": "duration-label"
  }, durationLabel))) : null, hasPrices ? __jsx("div", {
    className: "w-full sm:border-b border-gray-light py-1 mb-2"
  }, __jsx("div", {
    className: "text-center text-base"
  }, Object(i18n["f" /* t */])('faceting.when.pricesBasedOn'), ' ', __jsx("strong", {
    "data-testid": "prices-duration-label"
  }, durationLabel)), __jsx(FilterWhen_PriceLegend, null)) : null, __jsx(TripDatePicker["a" /* TripDatePicker */], {
    className: "pb-0",
    departureDate: departureDate,
    navigationByYear: navigationByYear,
    offsetCalendar: offsetCalendar,
    onSelect: onSelect,
    onDayMouseOver: onDayMouseOver,
    openCalendarToDate: openCalendarToDate,
    optionsDuration: optionsDuration,
    prices: prices,
    selectedDays: {
      from: from,
      to: to
    },
    theme: "compact"
  }), withFlexibility && __jsx("div", {
    className: "px-4 py-3 border-t"
  }, __jsx("span", {
    className: "flex text-base font-sans font-bold text-gray-darker mb-1"
  }, Object(i18n["f" /* t */])('faceting.flexibility.label')), __jsx(InputSelect["a" /* InputSelect */], {
    dataTestId: "flexibility-input",
    onChange: onFlexibilityChange,
    value: flexibility,
    options: [{
      label: Object(i18n["f" /* t */])('faceting.flexibility.duration_0'),
      value: 0
    }, {
      label: Object(i18n["f" /* t */])('faceting.flexibility.duration_1'),
      value: 1
    }, {
      label: Object(i18n["f" /* t */])('faceting.flexibility.duration_3'),
      value: 3
    }, {
      label: Object(i18n["f" /* t */])('faceting.flexibility.duration_7'),
      value: 7
    }]
  }))));
};

/***/ }),

/***/ "qmjq":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dZwK");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "rL40":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "rXTn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("SPKZ");
/* harmony import */ var _form_field_FormField_jsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("QPdA");
/* harmony import */ var _icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("qBqs");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* DEPRECATED */





var defaultProps = {
  dataSelector: 'FormSelect',
  isDisabled: false,
  isReadOnly: false,
  isRequired: false,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onClear: function onClear() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  options: []
};

var FormSelect = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(FormSelect, _React$Component);

  var _super = _createSuper(FormSelect);

  function FormSelect(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, FormSelect);

    _this = _super.call(this, props);

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "onChange", function (e) {
      if (!_this.props.isReadOnly) {
        e.persist();
        var value = e.target.value;

        _this.props.onChange(value);

        _this.setState({
          value: value
        });
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "onClear", function () {
      _this.props.onClear();

      _this.setState({
        value: ''
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "getOptions", function () {
      if (!_this.props.options.length) {
        return null;
      }

      return _this.props.options.map(function (_ref) {
        var label = _ref.label,
            value = _ref.value,
            isDisabled = _ref.isDisabled;
        return label.trim() ? __jsx("option", {
          disabled: isDisabled,
          key: value,
          label: label.trim(),
          value: value
        }, label) : null;
      });
    });

    _this.state = {
      value: props.value || ''
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(FormSelect, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref2) {
      var value = _ref2.value;

      if (this.props.value !== value) {
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      var _this$props = this.props,
          className = _this$props.className,
          dataSelector = _this$props.dataSelector,
          height = _this$props.height,
          iconLeft = _this$props.iconLeft,
          id = _this$props.id,
          isDisabled = _this$props.isDisabled,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          isRequired = _this$props.isRequired,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onClick = _this$props.onClick,
          onFocus = _this$props.onFocus,
          onKeyDown = _this$props.onKeyDown,
          onKeyUp = _this$props.onKeyUp,
          placeholder = _this$props.placeholder;
      return __jsx("div", {
        className: "cursor-pointer flex-1 relative"
      }, __jsx("select", {
        className: classnames__WEBPACK_IMPORTED_MODULE_8___default()('reset-input reset-select bg-transparent py-3 px-4 rtl:pr-10 text-md w-full', {
          'text-gray-darker': value,
          'text-gray-dark': !value,
          'pointer-events-none': isReadOnly,
          'cursor-not-allowed': isDisabled,
          'cursor-progress': isLoading && !isDisabled,
          'rtl:pl-9': !!iconLeft
        }, className),
        "data-selector": dataSelector,
        "data-testid": dataSelector,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        readOnly: isReadOnly,
        required: isRequired,
        style: {
          height: height
        },
        value: value
      }, !!placeholder && __jsx("option", {
        "data-testid": "FormSelectPlaceholder",
        label: placeholder.trim(),
        disabled: true,
        value: ""
      }, isRequired ? "".concat(placeholder, "*") : placeholder), this.getOptions()), !isReadOnly && __jsx("div", {
        className: "absolute flex h-full items-center top-0 pointer-events-none px-3 rtl:right-0"
      }, __jsx(_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_9__[/* ICONS */ "a"].SELECT
      })), !!iconLeft && __jsx("div", {
        className: "absolute flex h-full items-center top-0 pointer-events-none px-3 rtl:left-0"
      }, __jsx(_icon_Icon_jsx__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: iconLeft
      })));
    }
  }]);

  return FormSelect;
}(react__WEBPACK_IMPORTED_MODULE_7___default.a.Component);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(FormSelect, "displayName", 'FormSelect');

FormSelect.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(_form_field_FormField_jsx__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(FormSelect));

/***/ }),

/***/ "rcxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAGE_BE_ACCOMMODATION; });
/* unused harmony export PAGE_BE_TRANSPORT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAGE_BE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAGE_BE_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PAGE_BE_SERVICES_ALL_INCLUSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGE_BE_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAGE_BE_BANKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getBookingEngineUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getBookingCriteriaOffsetSell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return checkIsDepartureDateAvailaible; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("U2CP");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PIvV");
/* harmony import */ var _proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("oL6k");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("CcNa");




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var PAGE_BE_ACCOMMODATION = 'accommodation';
var PAGE_BE_TRANSPORT = 'transport';
var PAGE_BE_SERVICES = 'services';
var PAGE_BE_ACTIVITIES = 'activities';
var PAGE_BE_SERVICES_ALL_INCLUSIVE = 'allInclusive';
var PAGE_BE_PARTICIPANTS = 'participants';
var PAGE_BE_BANKING = 'banking';
function getBookingEngineUri() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PAGE_BE_ACCOMMODATION;
  var proposals = arguments.length > 1 ? arguments[1] : undefined;
  var resort = arguments.length > 2 ? arguments[2] : undefined;
  var selectedProposalId = arguments.length > 3 ? arguments[3] : undefined;
  var otherQueryParameters = arguments.length > 4 ? arguments[4] : undefined;
  var proposalIds = proposals.map(function (proposal) {
    return proposal.id;
  });
  var defaultProposal = Object(_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* getDefaultProposal */ "d"])(proposals, resort);

  var queryParams = _objectSpread(_objectSpread({}, otherQueryParameters), {}, {
    proposalIds: proposalIds,
    selectedProposalId: selectedProposalId || defaultProposal.id
  });

  return _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_4__[/* buildUrl */ "a"]('booking', {
    page: page
  }, queryParams);
}
var getBookingCriteriaOffsetSell = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(productId, appContext) {
    var getQuery, query;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getQuery = function getQuery() {
              return "query {\n                  bookingCriteria(productId: \"".concat(productId, "\") {\n                    offsetSell\n                  }\n            }");
            };

            query = getQuery();
            return _context.abrupt("return", _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__[/* CRITERIA_OFFSETSELL */ "f"]
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getBookingCriteriaOffsetSell(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // check if the departureDate comes after today plus the offsetSell (in days), which is defined by the API

var checkIsDepartureDateAvailaible = function checkIsDepartureDateAvailaible(departureDate, offsetSell) {
  return moment__WEBPACK_IMPORTED_MODULE_3___default()(departureDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_3___default()().add(offsetSell, 'd'), 'day');
};

/***/ }),

/***/ "rhE9":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("fBdL"),
    arrayEach = __webpack_require__("oS9k"),
    assignValue = __webpack_require__("pfIK"),
    baseAssign = __webpack_require__("GMiS"),
    baseAssignIn = __webpack_require__("8Jk/"),
    cloneBuffer = __webpack_require__("okv5"),
    copyArray = __webpack_require__("nz94"),
    copySymbols = __webpack_require__("RlE+"),
    copySymbolsIn = __webpack_require__("BlK1"),
    getAllKeys = __webpack_require__("4qke"),
    getAllKeysIn = __webpack_require__("cdYD"),
    getTag = __webpack_require__("YXT+"),
    initCloneArray = __webpack_require__("G8Os"),
    initCloneByTag = __webpack_require__("ceQO"),
    initCloneObject = __webpack_require__("YfuU"),
    isArray = __webpack_require__("tEYP"),
    isBuffer = __webpack_require__("EVz8"),
    isMap = __webpack_require__("9XrK"),
    isObject = __webpack_require__("Q7Yi"),
    isSet = __webpack_require__("lEjn"),
    keys = __webpack_require__("DWlz");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ "rnJz":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("CP21"),
    getRawTag = __webpack_require__("oZU8"),
    objectToString = __webpack_require__("imxd");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "sW3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADULTS_ONLY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADULTS_NUMBER_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTS_NUMBER_MAX; });
/* unused harmony export AREA_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHILDCARE_FACET_ID; });
/* unused harmony export COUNTRY_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEFAULT_DEPARTURE_CITY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEPARTURE_CITY_FACET_ID; });
/* unused harmony export DEPARTURE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DEPARTURE_DATE_MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DEPARTURE_DATE_MAX_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DEPARTURE_DATE_MIN_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DURATION_FACET; });
/* unused harmony export KIDS_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return KIDS_NUMBER_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LOCALE_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MAX_NUMBER_OF_SELECTED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return OFFER_ID_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PRODUCT_FACET_ID; });
/* unused harmony export WHEN_FACET_ID */
/* unused harmony export WHERE_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DESTINATIONS_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COUNTRIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return TYPES_OF_STAY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FACET_COMFORT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return QUERY_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PRODUCTS_TO_COMPARE_QUERY_PARAM; });
/* unused harmony export FACET_QUERY_PARAMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_CHILDCARE_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FILTERABLE_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FILTERABLE_FACETS_TRACKING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FILTERABLE_FACETS_TEMPLATE_CONFIG; });
/* unused harmony export FACETS */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var ADULTS_ONLY_FACET_ID = 'facette_adult_only';
var ADULTS_NUMBER_MIN = 1;
var ADULTS_NUMBER_MAX = 6;
var AREA_FACET_PREFIX_ID = 'AREA';
var CHILDCARE_FACET_ID = 'facette_childcare_age_in_month';
var COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
var DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
var DEPARTURE_DATE = 'date';
var DEPARTURE_DATE_MAX_DATE = {
  years: 2
};
var DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
var DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
var DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
var DURATION_FACET = 'facette_duration';
var KIDS_FACET_ID = 'facette_kids';
var KIDS_NUMBER_MAX = 5;
var LOCALE_FACET_ID = 'locale';
var MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
var OFFER_ID_FACET_ID = 'facette_offer_id';
var PRODUCT_FACET_ID = 'product_id';
var WHEN_FACET_ID = 'facette_when';
var WHERE_FACET_ID = 'facette_where';
var ACTIVITIES_FACET_ID = 'activities_tree';
var DESTINATIONS_FACET_ID = 'destinations_tree';
var COUNTRIES_FACET_ID = 'facette_destination_country';
var TYPES_OF_STAY_FACET_ID = 'facette_type';
var FACET_COMFORT_ID = 'facette_comfort_label';
var QUERY_QUERY_PARAM = 'search';
var PRODUCTS_TO_COMPARE_QUERY_PARAM = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].productsComparison.productIds;
var FACET_QUERY_PARAMS = [{
  id: 'destination',
  facetId: COUNTRIES_FACET_ID
}, {
  id: 'departure_city',
  facetId: DEPARTURE_CITY_FACET_ID
}];
var DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];
var FILTERABLE_FACETS_IDS = [ACTIVITIES_FACET_ID, DESTINATIONS_FACET_ID, COUNTRIES_FACET_ID, TYPES_OF_STAY_FACET_ID, FACET_COMFORT_ID];
var FILTERABLE_FACETS_TRACKING_CONFIG = [{
  id: ACTIVITIES_FACET_ID,
  trackingPrefixLabel: 'activities'
}, {
  id: DESTINATIONS_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: COUNTRIES_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  trackingPrefixLabel: 'comfort'
}];
var FILTERABLE_FACETS_TEMPLATE_CONFIG = [{
  id: DESTINATIONS_FACET_ID,
  dataLabel: 'where',
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].EARTH_PLANE,
  facetLists: [{
    deep: false,
    id: DESTINATIONS_FACET_ID,
    titleLabel: 'faceting.where.destinationTitle'
  }, {
    deep: false,
    id: COUNTRIES_FACET_ID,
    titleLabel: 'faceting.where.countriesTitle'
  }],
  titleLabel: 'faceting.where.title'
}, {
  id: ACTIVITIES_FACET_ID,
  dataLabel: 'activities',
  facetLists: [{
    deep: true,
    id: ACTIVITIES_FACET_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].ACTIVITIES,
  titleLabel: 'faceting.activities.title'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  dataLabel: 'typeofstay',
  facetLists: [{
    deep: false,
    id: TYPES_OF_STAY_FACET_ID,
    facetLabels: 'faceting.typesOfStay'
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].BEACH,
  titleLabel: 'faceting.typesOfStay.title',
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  dataLabel: 'comfort',
  facetLists: [{
    deep: false,
    id: FACET_COMFORT_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT1,
  titleLabel: 'faceting.comfort.title'
}];
var FACETS = {
  when: 'when',
  who: 'who',
  where: 'where'
};

/***/ }),

/***/ "sWQB":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("rnJz"),
    isObject = __webpack_require__("Q7Yi");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "sarX":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("kHWL"),
    baseUnary = __webpack_require__("id+h"),
    nodeUtil = __webpack_require__("2LZg");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "syQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INLINE_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INLINE_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLUMN_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLUMN_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPOSITE_1; });
var INLINE_1 = 'Inline1';
var INLINE_2 = 'Inline2';
var COLUMN_1 = 'Column1';
var COLUMN_2 = 'Column2';
var COMPOSITE_1 = 'Composite1';

/***/ }),

/***/ "t8ah":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "tCJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Sections_Sections; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-stickynode/index.js
var react_stickynode = __webpack_require__("gyFy");
var react_stickynode_default = /*#__PURE__*/__webpack_require__.n(react_stickynode);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/drop-down/DropDown.jsx + 1 modules
var DropDown = __webpack_require__("U6GL");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/drop-down-nav/DropDownNav.themes.js
var themes = {
  "default": {
    thDropDown: 'w-full',
    thDropDownTheme: 'solid',
    thTrigger: 'reset-button flex items-center justify-center bg-white hover:bg-blue border-0 border-b-1 border-gray-light hover:border-blue border-solid cursor-pointer font-bold p-4 text-base text-blue hover:text-white transition-colors w-full',
    thIcon: 'flex-shrink-0 rtl:ml-2',
    thIconWidth: '0.625rem',
    thItemsList: 'reset-list border-b-1 border-gray-light text-base',
    thItemLink: 'reset-anchor bg-white hover:bg-blue block cursor-pointer px-4 py-2 text-gray-darker hover:text-white transition-colors',
    thItemLinkSelected: 'font-bold'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/drop-down-nav/DropDownNav.jsx


var __jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/role-supports-aria-props */

/* eslint-disable jsx-a11y/aria-role */










var ariaButtonId = "DropDownNavButton_".concat(shortid_default.a.generate());
var ariaMenuId = "DropDownNavMenu_".concat(shortid_default.a.generate()); // We use `forwardRef` to give the parent an access to the <nav> DOM and get its height for example.
// $FlowFixMe

var DropDownNav = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var className = props.className,
      id = props.id,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      _props$selectedItem = props.selectedItem,
      selectedItem = _props$selectedItem === void 0 ? 0 : _props$selectedItem,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      getTrackingData = props.getTrackingData;

  if (Object(lodash["isEmpty"])(items) || !Array.isArray(items)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thDropDown = _themes$theme.thDropDown,
      thDropDownTheme = _themes$theme.thDropDownTheme,
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thItemLink = _themes$theme.thItemLink,
      thItemLinkSelected = _themes$theme.thItemLinkSelected,
      thItemsList = _themes$theme.thItemsList,
      thTrigger = _themes$theme.thTrigger;
  return __jsx("nav", {
    className: className,
    "data-testid": "dropdown-nav",
    id: id || null,
    ref: ref
  }, __jsx(DropDown["a" /* DropDown */], {
    className: thDropDown,
    hasCloseOnClick: true,
    renderTrigger: function renderTrigger(handler, isExpanded) {
      return __jsx("button", {
        "aria-controls": ariaMenuId,
        "aria-expanded": isExpanded,
        "aria-haspopup": true,
        className: thTrigger,
        id: ariaMenuId,
        onClick: handler,
        type: "button"
      }, items[selectedItem] ? items[selectedItem].label : __jsx("div", {
        className: "loadingDots"
      }), __jsx(Icon["a" /* Icon */], {
        className: thIcon,
        name: icons["a" /* ICONS */].SELECT,
        width: thIconWidth,
        rotation: isExpanded ? 180 : 0
      }));
    },
    theme: thDropDownTheme
  }, function () {
    return __jsx("ul", {
      id: ariaMenuId,
      "aria-labelledby": ariaButtonId,
      role: "menu",
      className: thItemsList
    }, items.filter(function (_ref) {
      var label = _ref.label;
      return label;
    }).map(function (_ref2, index) {
      var label = _ref2.label,
          link = _ref2.link;
      return __jsx("li", {
        key: label,
        role: "none"
      }, __jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
        as: DynamicLink["a" /* default */],
        className: classnames_default()(thItemLink, Object(defineProperty["a" /* default */])({}, thItemLinkSelected, index === selectedItem)),
        "data-testid": "DropDownNav-item-link-".concat(index)
      }, link, {
        trackingData: getTrackingData ? getTrackingData(label) : null,
        role: "menuitem"
      }), label));
    }));
  }));
});
// EXTERNAL MODULE: ./src/client/components/frameworks/navbar/Navbar.jsx + 1 modules
var Navbar = __webpack_require__("+f+f");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// CONCATENATED MODULE: ./src/client/components/frameworks/intersection-observer/createIntersectionObserver.js
if (true) {
  // Polyfills for intersection-observer
  __webpack_require__("LNcM");
}

function createIntersectionObserver(callback, options) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
  return new IntersectionObserver(callback, options);
}
// CONCATENATED MODULE: ./src/client/components/frameworks/intersection-observer/IntersectionObserver.jsx









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var IntersectionObserver_IntersectionObserver = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(IntersectionObserver, _Component);

  var _super = _createSuper(IntersectionObserver);

  function IntersectionObserver() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, IntersectionObserver);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleIntersection", function (_ref) {
      var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 1),
          entry = _ref2[0];

      _this.props.onChange(entry);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "observe", function () {
      if (_this.target && _this.observer) {
        _this.observer.observe(_this.target);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "unobserve", function () {
      if (_this.target && _this.observer) {
        _this.observer.unobserve(_this.target);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setRefTarget", function (target) {
      _this.targetChanged = _this.previousTarget && _this.previousTarget !== target;

      if (_this.targetChanged) {
        _this.unobserve();
      }

      _this.target = target;
    });

    return _this;
  }

  Object(createClass["a" /* default */])(IntersectionObserver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          rootMargin = _this$props.rootMargin,
          threshold = _this$props.threshold;
      this.observer = createIntersectionObserver(this.handleIntersection, {
        rootMargin: rootMargin,
        threshold: threshold
      });
      this.observe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unobserve();

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      // @todo remove this
      this.previousTarget = this.target;
      return /*#__PURE__*/react_default.a.cloneElement(react_default.a.Children.only(this.props.children), {
        ref: this.setRefTarget
      });
    }
  }]);

  return IntersectionObserver;
}(react["Component"]);

Object(defineProperty["a" /* default */])(IntersectionObserver_IntersectionObserver, "displayName", 'IntersectionObserver');

Object(defineProperty["a" /* default */])(IntersectionObserver_IntersectionObserver, "defaultProps", {
  rootMargin: '0px',
  threshold: 0
});
// CONCATENATED MODULE: ./src/client/components/frameworks/section/Section.jsx






var Section_jsx = react_default.a.createElement;

function Section_createSuper(Derived) { var hasNativeReflectConstruct = Section_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Section_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var Section_Section = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(Section, _PureComponent);

  var _super = Section_createSuper(Section);

  function Section(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Section);

    _this = _super.call(this, props);
    _this.intersectionObserverThreshold = [];

    for (var i = 0; i <= 1.0; i += 0.01) {
      // Get notified of every percent of visiblity change in the viewport (1% of intersection to 100%)
      _this.intersectionObserverThreshold.push(Math.round(i * 100) / 100);
    }

    return _this;
  }

  Object(createClass["a" /* default */])(Section, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          index = _this$props.index,
          name = _this$props.name;
      return Section_jsx(IntersectionObserver_IntersectionObserver, {
        onChange: this.props.onSectionIntersectViewport,
        threshold: this.intersectionObserverThreshold
      }, Section_jsx("section", {
        className: className,
        "data-cs-override-id": "Section",
        "data-index": index,
        "data-testid": "section",
        id: name ? dist["url"].normalizeSlug(name) : null
      }, children));
    }
  }]);

  return Section;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(Section_Section, "defaultProps", {
  name: ''
});
// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// CONCATENATED MODULE: ./src/client/components/frameworks/sections/Sections.jsx
var Sections_jsx = react_default.a.createElement;









var Sections_Sections = function Sections(_ref) {
  var children = _ref.children,
      navItems = _ref.navItems,
      getTrackingData = _ref.getTrackingData,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel,
      pageType = _ref.pageType;
  var navBarRef = Object(react["useRef"])(null);
  var onSectionIntersectViewport = Object(react["useRef"])(lodash["noop"]);

  var _useState = Object(react["useState"])(0),
      selectedIndex = _useState[0],
      setSelectedIndex = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isSticky = _useState2[0],
      setIsSticky = _useState2[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var navSelector = pageType || 'Sections';
  Object(react["useEffect"])(function () {
    onSectionIntersectViewport.current = function (event) {
      var visiblePercentage = Math.floor(event.intersectionRatio * 100);
      var navBarHeight = navBarRef && Object(lodash["get"])(navBarRef, 'current.offsetHeight');
      var selected = Number(event.target.dataset.index);

      if (event.isIntersecting && visiblePercentage > 10 && event.intersectionRect.top <= navBarHeight) {
        setSelectedIndex(selected);
      }
    };
  }, []);
  var onStateChange = Object(react["useCallback"])(function (status) {
    setIsSticky(status.status !== react_stickynode_default.a.STATUS_ORIGINAL);
  }, []);
  var onNavItemClick = Object(react["useCallback"])(function (anchor) {
    return function (e) {
      e.preventDefault(); // $FlowFixMe

      var selected = Number(e.target.dataset.position);
      var scrollRootOffsetSelector = "#".concat(navSelector);
      Object(scrollToElement["a" /* scrollToElement */])("#".concat(anchor), 600, scrollRootOffsetSelector).then(function () {
        setSelectedIndex(selected);
      });
    };
  }, []);
  var navbarItems = Object(react["useMemo"])(function () {
    return navItems.map(function (label, index) {
      var anchor = label ? dist["url"].normalizeSlug(label) : '';
      return {
        label: label,
        link: {
          'data-position': index,
          onClick: onNavItemClick(anchor),
          url: "#".concat(anchor)
        }
      };
    });
  }, []);
  return Sections_jsx(react["Fragment"], null, Sections_jsx(react_stickynode_default.a, {
    className: "relative z-3",
    onStateChange: onStateChange
  }, isTablet ? Sections_jsx(Navbar["a" /* Navbar */], {
    className: isSticky ? 'shadow-md' : '',
    getTrackingData: getTrackingData,
    id: navSelector,
    items: navbarItems,
    ref: navBarRef,
    scrollBackwardLabel: scrollBackwardLabel,
    scrollForwardLabel: scrollForwardLabel,
    selectedItem: selectedIndex
  }) : Sections_jsx(DropDownNav, {
    className: isSticky ? 'shadow-md slideInTop' : '',
    getTrackingData: getTrackingData,
    id: navSelector,
    items: navbarItems,
    ref: navBarRef,
    selectedItem: selectedIndex
  })), children.map(function (sectionLines, index) {
    return Sections_jsx(Section_Section, {
      index: index,
      key: navItems[index],
      name: navItems[index],
      onSectionIntersectViewport: onSectionIntersectViewport.current
    }, sectionLines);
  }));
};
Sections_Sections.defaultProps = {
  children: [],
  navItems: [],
  pageType: ''
};

/***/ }),

/***/ "tEYP":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "tF/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateSummary; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("taV1");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ohju");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var DateSummary = function DateSummary(_ref) {
  var _ref$extendedDataset = _ref.extendedDataset,
      extendedDataset = _ref$extendedDataset === void 0 ? false : _ref$extendedDataset,
      template = _ref.template,
      values = _ref.values;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('PackagePriceSummary-section', {
      'PackagePriceSummary-section--extended': extendedDataset
    }),
    "data-testid": _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__[/* CRITERIA_SELECTORS */ "m"].DEPARTURE
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].DATE,
    className: "PackagePriceSummary-icon",
    width: "1.875rem",
    hasRtl: true
  }), __jsx(_frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_6__[/* TemplateString */ "a"], {
    template: template // $FlowFixMe
    ,
    values: values,
    valuesClassName: {
      arrivalDate: 'PackagePriceSummary-arrivalDate',
      departureDate: 'PackagePriceSummary-departureDate'
    }
  }));
};

/***/ }),

/***/ "tI3i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "tJ/X":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF"),
    root = __webpack_require__("jP+d");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "tRRp":
/***/ (function(module) {

module.exports = JSON.parse("{\"0\":65533,\"128\":8364,\"130\":8218,\"131\":402,\"132\":8222,\"133\":8230,\"134\":8224,\"135\":8225,\"136\":710,\"137\":8240,\"138\":352,\"139\":8249,\"140\":338,\"142\":381,\"145\":8216,\"146\":8217,\"147\":8220,\"148\":8221,\"149\":8226,\"150\":8211,\"151\":8212,\"152\":732,\"153\":8482,\"154\":353,\"155\":8250,\"156\":339,\"158\":382,\"159\":376}");

/***/ }),

/***/ "tU/q":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("rL40"),
    isArray = __webpack_require__("tEYP");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "tUgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FilterWho_FilterWho; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/utils/faceting/kidsValidationStateUtils.js
var kidsValidationStateUtils = __webpack_require__("cGFA");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-date/InputDate.themes.js


var themes = {
  "default": function _default(props) {
    return {
      thInputWrapper: 'relative decorator-slash-separator flex-1 h-full',
      thInput: classnames_default()('reset-input h-full text-center text-current w-full', Object(form_util["a" /* getCursorClass */])(props))
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-date/InputDate.jsx








var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var DAY = 'd';
var MONTH = 'm';
var YEAR = 'y';
var DAY_LENGTH = 2;
var MONTH_LENGTH = 2;
var YEAR_LENGTH = 4;

function getInputsState(_ref) {
  var value = _ref.value;
  var date = value ? moment_default()(value) : moment_default()(null);
  return {
    dayValue: date.isValid() ? date.format('DD') : '',
    monthValue: date.isValid() ? date.format('MM') : '',
    yearValue: date.isValid() ? date.format('YYYY') : ''
  };
}

var InputDate_InputDate = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputDate, _Component);

  var _super = _createSuper(InputDate);

  function InputDate(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputDate);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (inputRef, value, maxLength, nextRef) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        _this.setState(Object(defineProperty["a" /* default */])({}, inputRef, value), function () {
          return onChange(_this.props.name || '', _this.getDate());
        });

        if (nextRef && value.length === maxLength) {
          var _this$nextRef;

          // $FlowFixMe
          (_this$nextRef = _this[nextRef]) === null || _this$nextRef === void 0 ? void 0 : _this$nextRef.focus();
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        dayValue: '',
        monthValue: '',
        yearValue: ''
      }, function () {
        return onClear(e);
      });
    });

    _this.state = _objectSpread({}, getInputsState(props));
    return _this;
  }

  Object(createClass["a" /* default */])(InputDate, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState(getInputsState(nextProps));
      }
    }
  }, {
    key: "getDate",
    value: function getDate() {
      var _this$state = this.state,
          dayValue = _this$state.dayValue,
          monthValue = _this$state.monthValue,
          yearValue = _this$state.yearValue;
      var allFields = dayValue.length === DAY_LENGTH && monthValue.length === MONTH_LENGTH && yearValue.length === YEAR_LENGTH;

      if (allFields) {
        var date = moment_default()([parseInt(yearValue, 10), parseInt(monthValue, 10) - 1, parseInt(dayValue, 10)]);
        return date.isValid() ? date.valueOf() : false;
      }

      return null;
    }
  }, {
    key: "getInputOrder",
    value: function getInputOrder(type) {
      var _this$props$dateForma = this.props.dateFormat,
          dateFormat = _this$props$dateForma === void 0 ? '' : _this$props$dateForma;
      return dateFormat.toLowerCase().indexOf(type);
    }
  }, {
    key: "getInputs",
    value: function getInputs() {
      return [{
        ref: 'dayValue',
        placeholder: this.props.placeholderDay || '',
        value: this.state.dayValue,
        order: this.getInputOrder(DAY),
        maxLength: DAY_LENGTH
      }, {
        ref: 'monthValue',
        placeholder: this.props.placeholderMonth || '',
        value: this.state.monthValue,
        order: this.getInputOrder(MONTH),
        maxLength: MONTH_LENGTH
      }, {
        ref: 'yearValue',
        placeholder: this.props.placeholderYear || '',
        value: this.state.yearValue,
        order: this.getInputOrder(YEAR),
        maxLength: YEAR_LENGTH
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          hasClear = _this$props2.hasClear,
          iconLeft = _this$props2.iconLeft,
          iconRight = _this$props2.iconRight,
          _this$props2$id = _this$props2.id,
          id = _this$props2$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputDate_') : _this$props2$id,
          isDisabled = _this$props2.isDisabled,
          isFilled = _this$props2.isFilled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          isRequired = _this$props2.isRequired,
          label = _this$props2.label,
          notes = _this$props2.notes,
          onBlur = _this$props2.onBlur,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          size = _this$props2.size,
          theme = _this$props2.theme,
          validationState = _this$props2.validationState;
      var _this$state2 = this.state,
          dayValue = _this$state2.dayValue,
          monthValue = _this$state2.monthValue,
          yearValue = _this$state2.yearValue;
      var hasValue = Boolean(dayValue) || Boolean(monthValue) || Boolean(yearValue);
      var hasClearEnabled = Boolean(hasClear && hasValue);
      var inputs = Object(lodash["sortBy"])(this.getInputs(), ['order']);

      var _themes$theme = themes[theme](this.props),
          thInput = _themes$theme.thInput,
          thInputWrapper = _themes$theme.thInputWrapper;

      return __jsx(FormControl["a" /* FormControl */], {
        className: className,
        hasClear: hasClearEnabled,
        iconLeft: iconLeft,
        iconRight: iconRight,
        id: id,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        size: size,
        theme: theme,
        validationState: validationState
      }, inputs.map(function (input, index) {
        var nextRef = index + 1 < inputs.length ? inputs[index + 1].ref : null;
        return __jsx("span", {
          key: index,
          className: thInputWrapper
        }, __jsx("input", Object(esm_extends["a" /* default */])({
          className: thInput,
          "data-testid": input.ref,
          disabled: isDisabled
        }, index === 0 ? {
          id: id
        } : null, {
          maxLength: input.maxLength,
          onBlur: onBlur,
          onChange: function onChange(e) {
            return _this2.onChange(input.ref, e.target.value, input.maxLength, nextRef);
          },
          onClick: onClick,
          onFocus: onFocus,
          onKeyDown: onKeyDown,
          onKeyUp: onKeyUp,
          placeholder: input.placeholder,
          readOnly: Boolean(isReadOnly || isLoading),
          ref: function ref(node) {
            // $FlowFixMe
            _this2[input.ref] = node;
          },
          required: isRequired,
          type: "tel",
          value: input.value
        })));
      }));
    }
  }]);

  return InputDate;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputDate_InputDate, "defaultProps", {
  dateFormat: 'DDMMYYYY',
  onChange: function onChange() {
    return Promise.resolve();
  },
  size: 'medium',
  theme: 'default'
});
// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx + 1 modules
var InputNumber = __webpack_require__("xGYs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-who/filter-who/FilterWho.jsx



var FilterWho_jsx = react_default.a.createElement;

function FilterWho_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FilterWho_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FilterWho_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FilterWho_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var FilterWho_FilterWho = function FilterWho(_ref) {
  var addChildcareLabel = _ref.addChildcareLabel,
      adultsLabel = _ref.adultsLabel,
      adultsNumber = _ref.adultsNumber,
      _ref$birthdaysErrorMe = _ref.birthdaysErrorMessage,
      birthdaysErrorMessage = _ref$birthdaysErrorMe === void 0 ? '' : _ref$birthdaysErrorMe,
      changeKidsNumber = _ref.changeKidsNumber,
      changeKid = _ref.changeKid,
      dateFormat = _ref.dateFormat,
      dayPlaceholder = _ref.dayPlaceholder,
      hasChildcareSwitch = _ref.hasChildcareSwitch,
      _ref$informationLabel = _ref.informationLabel,
      informationLabel = _ref$informationLabel === void 0 ? '' : _ref$informationLabel,
      isShrink = _ref.isShrink,
      kids = _ref.kids,
      kidsAgeLabel = _ref.kidsAgeLabel,
      kidsAgeLimitLabel = _ref.kidsAgeLimitLabel,
      kidsLabel = _ref.kidsLabel,
      kidsValidationState = _ref.kidsValidationState,
      label = _ref.label,
      _ref$minAdultsNumber = _ref.minAdultsNumber,
      minAdultsNumber = _ref$minAdultsNumber === void 0 ? 0 : _ref$minAdultsNumber,
      monthPlaceholder = _ref.monthPlaceholder,
      setAdultsNumber = _ref.setAdultsNumber,
      validateKidsBirthdate = _ref.validateKidsBirthdate,
      yearPlaceholder = _ref.yearPlaceholder;

  var _useState = Object(react["useState"])(kids.some(function (kid) {
    return kid.childcareIncluded;
  })),
      childcareIncluded = _useState[0],
      setChildcareIncluded = _useState[1];

  var handleKidsNumber = function handleKidsNumber(name, value) {
    if (changeKidsNumber) {
      changeKidsNumber(value);
    }
  };

  var handleKidAge = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(index, kid) {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!kid.birthdate) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return validateKidsBirthdate(index, kid);

            case 3:
              // $FlowFixMe
              if (Object(facetingUtils["g" /* isKidMinor */])(kid.birthdate)) {
                changeKid(index, kid);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleKidAge(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getMaxAdultsAvailable = function getMaxAdultsAvailable() {
    return constants["b" /* ADULTS_NUMBER_MAX */] - kids.length;
  };

  var getMaxKidsAvailable = function getMaxKidsAvailable() {
    return constants["b" /* ADULTS_NUMBER_MAX */] - adultsNumber;
  };

  Object(react["useEffect"])(function () {
    kids.forEach(function (kid, index) {
      return changeKid(index, FilterWho_objectSpread(FilterWho_objectSpread({}, kid), {}, {
        childcareIncluded: childcareIncluded
      }));
    });
  }, [childcareIncluded]);
  return FilterWho_jsx("div", {
    "data-testid": "FilterWho",
    className: "FilterWho"
  }, FilterWho_jsx("div", {
    className: "px-4 py-6"
  }, FilterWho_jsx("div", {
    className: "mb-6 text-lg font-bold lg:text-center"
  }, label), FilterWho_jsx("div", {
    className: "lg:flex lg:items-center text-left"
  }, FilterWho_jsx(InputNumber["a" /* InputNumber */], {
    ariaLabel: adultsLabel,
    attendeeType: "adults",
    className: "my-6 lg:flex-auto lg:mx-6 lg:my-0 lg:w-1/2",
    dataTestId: "FilterWho-Adults",
    hasColumnLayout: isShrink,
    label: adultsLabel,
    max: getMaxAdultsAvailable(),
    min: minAdultsNumber,
    onChange: function onChange(name, value) {
      setAdultsNumber(value || 0);
    },
    value: adultsNumber
  }), FilterWho_jsx(InputNumber["a" /* InputNumber */], {
    ariaLabel: kidsLabel,
    attendeeType: "kids",
    className: "my-6 lg:flex-auto lg:mx-6 my-4 lg:my-0 lg:w-1/2",
    dataTestId: "FilterWho-Children",
    hasColumnLayout: isShrink,
    label: kidsLabel,
    max: getMaxKidsAvailable(),
    notes: kidsAgeLimitLabel,
    onChange: handleKidsNumber,
    value: kids.length
  }))), kids.length > 0 && hasChildcareSwitch && FilterWho_jsx("div", {
    className: "p-4 border-gray-light border-t-1"
  }, FilterWho_jsx(InputSwitch["a" /* InputSwitch */], {
    inputTestId: "childcare-switch" // $FlowFixMe
    ,
    isChecked: childcareIncluded,
    label: addChildcareLabel,
    labelClassName: "font-bold text-blue",
    onChange: function onChange(name, isChecked) {
      return setChildcareIncluded(isChecked);
    } // $FlowFixMe
    ,
    value: childcareIncluded
  })), kids.length > 0 && FilterWho_jsx("div", {
    className: "p-4 border-gray-light border-t-1"
  }, FilterWho_jsx("div", {
    className: "mb-4"
  }, FilterWho_jsx("p", {
    className: "font-bold reset-paragraph text-base text-blue"
  }, kidsAgeLabel), informationLabel && FilterWho_jsx("p", {
    className: "reset-paragraph text-xs"
  }, informationLabel)), Object(kidsValidationStateUtils["c" /* hasKidWithoutAValidBirthdate */])(kidsValidationState) && birthdaysErrorMessage && FilterWho_jsx(FormFeedback["a" /* FormFeedback */], {
    isError: true,
    message: birthdaysErrorMessage
  }), FilterWho_jsx("div", {
    className: !isShrink ? 'lg:flex lg:flex-wrap lg:-m-2' : null
  }, kids.map(function (kid, index) {
    return FilterWho_jsx("div", {
      className: !isShrink ? 'flex-none lg:px-2 w-full lg:w-1/2' : null,
      key: String(kid.birthdate) + String(index)
    }, FilterWho_jsx(InputDate_InputDate, {
      className: "mb-4",
      dateFormat: dateFormat,
      onChange: function onChange(name, birthdate) {
        return handleKidAge(index, FilterWho_objectSpread(FilterWho_objectSpread({}, kid), {}, {
          birthdate: birthdate
        }));
      },
      placeholderDay: dayPlaceholder,
      placeholderMonth: monthPlaceholder,
      placeholderYear: yearPlaceholder,
      validationState: kidsValidationState[index],
      value: kid.birthdate
    }));
  }))));
};

/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCapitalLetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFirstWord; });
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return titleCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return snakeToCamel; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);


function getCapitalLetters(firstName, lastName) {
  return (firstName ? firstName.charAt(0).toUpperCase() : '') + (lastName ? lastName.charAt(0).toUpperCase() : '');
}

function getFirstWord(str) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isString"])(str) ? str.replace(/\s.*/, '') : '';
}

function getValidString(str) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isString"])(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function titleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}



/***/ }),

/***/ "ttFy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("Km8e");

var emptyObject = __webpack_require__("RgK2");
var _invariant = __webpack_require__("tI3i");

if (false) { var warning; }

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {}
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {}
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {}
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {}
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) { var isMixinValid, typeofSpec; }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {}
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) { var _bind, componentName; }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {}
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {}

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {}
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {}

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {}

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ "uGNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECTED_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelectedProposal; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nv//");
/* harmony import */ var _views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("47Eh");




var SELECT_PROPOSAL = 'SELECT_PROPOSAL';
var CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId, location, history) {
  var updatedUri = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__[/* convertLocationToURI */ "c"])(location).setQuery(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].booking.selectedProposalId, proposalId);
  Object(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__[/* navigateInBookingEngine */ "d"])({
    location: updatedUri,
    history: history,
    replace: true
  });
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SELECT_PROPOSAL, {
    proposalId: proposalId
  });
}



/***/ }),

/***/ "uL19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addUserInfosToAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getCustomerSearchResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterProposalBySamePackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAdditionalTransportsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getIsLoadingAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getIsLoadingAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdditionalAccommodationsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAdditionalAccommodationsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getFilteredAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getFilteredAdditionalAccommodationsSets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getSearchCriteriaTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAdditionalTransportsFilters; });
/* unused harmony export getFilteredAdditionalTransports */
/* unused harmony export getAdditionalTransportsSorters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getReservedServicesByAttendee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getSelectedProposalId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCurrentResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getPaymentProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getProposalsWithMappedAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCurrentProposal; });
/* unused harmony export getProposalHasAnyEquipmentForRent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getDetailedAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAttendeesWithInfos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getConnectedUserInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return proposalsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getInsuranceStatus; });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("oL6k");
/* harmony import */ var _user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("apzf");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Jsmy");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ldK3");




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var bookingSelector = function bookingSelector(_ref) {
  var booking = _ref.booking;
  return booking || {};
};

var additionalTransportsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref2) {
  var additionalTransports = _ref2.additionalTransports;
  return additionalTransports || {};
});
var getPaymentProviders = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref3) {
  var paymentProviders = _ref3.paymentProviders;
  return paymentProviders;
});
var getInsuranceStatus = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref4) {
  var insurance = _ref4.insurance;
  return insurance;
});
var getSearchCriteriaTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref5) {
  var searchCriteria = _ref5.searchCriteria;
  return searchCriteria;
});
var getAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref6) {
  var transports = _ref6.transports;
  return transports;
});
var getAdditionalTransportsFilters = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref7) {
  var filters = _ref7.filters;
  return filters;
});
var getFilteredAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref8) {
  var filteredTransports = _ref8.filteredTransports;
  return filteredTransports;
});
var getAdditionalTransportsSorters = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref9) {
  var sorters = _ref9.sorters;
  return sorters || [];
});
var getAdditionalTransportsError = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref10) {
  var error = _ref10.error;
  return error;
});
var getIsLoadingAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalTransportsSelector, function (_ref11) {
  var isLoading = _ref11.isLoading;
  return isLoading;
});
var additionalAccommodationsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref12) {
  var additionalAccommodations = _ref12.additionalAccommodations;
  return additionalAccommodations || {};
});
var getIsLoadingAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref13) {
  var isLoading = _ref13.isLoading;
  return isLoading;
});
var getAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref14) {
  var accommodationsSets = _ref14.accommodationsSets;
  return accommodationsSets;
});
var getAdditionalAccommodationsFilters = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref15) {
  var filters = _ref15.filters;
  return filters;
});
var getAdditionalAccommodationsError = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref16) {
  var error = _ref16.error;
  return error;
});
var getFilteredAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(additionalAccommodationsSelector, function (_ref17) {
  var filteredAccommodations = _ref17.filteredAccommodations;
  return filteredAccommodations;
});
var getFilteredAdditionalAccommodationsSets = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getFilteredAdditionalAccommodations, getAdditionalAccommodations, function (filteredAccommodations, additionalAccommodations) {
  return filteredAccommodations && filteredAccommodations.length > 0 ? filteredAccommodations : additionalAccommodations;
});
var proposalsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref18) {
  var proposals = _ref18.proposals;
  return proposals || [];
});
var getCurrentResort = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref19) {
  var resort = _ref19.resort;
  return resort;
});

var findAttendeeByNeolid = function findAttendeeByNeolid(attendees, neolid) {
  return attendees.find(function (attendee) {
    return attendee.neolid === neolid;
  });
};

var getSelectedProposalId = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref20) {
  var selectedProposalId = _ref20.selectedProposalId;
  return selectedProposalId;
});
/**
 * It should be getSelectedProposal but there is a selector getSelectedProposal
 * witch get the proposal from paymentInfoSelector
 * I do not know why...
 */

var getCurrentProposal = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref21) {
  var proposals = _ref21.proposals,
      selectedProposalId = _ref21.selectedProposalId;
  return (
    /**
     * return the selected proposal if found,
     * if not (for any reason) the default proposal for keeping the return shape value consistent
     */
    proposals.find(function (proposal) {
      return proposal.id === selectedProposalId;
    }) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_5__[/* getDefaultProposal */ "d"])(proposals)
  );
});

var filterProposalBySamePackage = function filterProposalBySamePackage(proposals, selectedProposal) {
  var errorsProposals = proposals.filter(function (proposal) {
    return proposal.errorCode;
  });

  if (errorsProposals.length) {
    return errorsProposals;
  }

  return proposals.filter(function (item) {
    var _item$accommodations = item.accommodations,
        accommodations = _item$accommodations === void 0 ? [] : _item$accommodations,
        packageId = item.packageId;
    return accommodations.length && packageId === selectedProposal.packageId;
  });
};

var getProposals = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(proposalsSelector, getCurrentProposal, filterProposalBySamePackage);
var getProposalsWithMappedAttendees = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getProposals, _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_7__[/* tripInformationSelector */ "d"], function (proposals, tripInformation) {
  if (!proposals) {
    return proposals;
  }

  return proposals.map(function (proposal) {
    return _objectSpread(_objectSpread({}, proposal), {}, {
      attendees: _objectSpread(_objectSpread({}, proposal.attendees), {}, {
        list: proposal.attendees.list.map(function (attendee) {
          // if there is a birthdate it's a children otherwise it's an adult
          var attendeeData = attendee.birthdate ? findAttendeeByNeolid(tripInformation.kids, attendee.customerId) : findAttendeeByNeolid(tripInformation.adults, attendee.customerId);

          if (!attendeeData) {
            return attendee;
          }

          return _objectSpread(_objectSpread({}, attendee), {}, {
            firstName: attendeeData.firstName,
            lastName: attendeeData.lastName
          });
        })
      })
    });
  });
});
var getProposalHasAnyEquipmentForRent = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref22) {
  var rentalEquipments = _ref22.rentalEquipments;
  return rentalEquipments.hasAnyEquipmentForRent;
});
var getAttendees = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getCurrentProposal, function (_ref23) {
  var attendees = _ref23.attendees;
  return attendees;
});
var getConnectedUserInfoSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_6__[/* userInfoSelector */ "a"], function (connectedUserInfo) {
  return connectedUserInfo.isQuickLoggedIn ? {} : Object(lodash__WEBPACK_IMPORTED_MODULE_4__["omit"])(_objectSpread(_objectSpread({}, connectedUserInfo), {}, {
    birthdate: connectedUserInfo.dateOfBirth,
    neolid: connectedUserInfo.neolaneId,
    // harmonize the neolid between user and seller
    mobile: connectedUserInfo.mobilePhoneNumber
  }), ['dateOfBirth', 'GMNumber', 'homePhoneNumber', 'isProspect', 'neolaneId', 'unicodeCivility', 'expirationDate', 'mobilePhoneNumber']);
});
var getSuggestions = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (_ref24) {
  var suggestions = _ref24.suggestions;
  return suggestions;
});
/**
 * The comparator does not put proposal in store
 * We need to use this function instead of the getAttendeesWithInfos selector
 */

var addUserInfosToAttendees = function addUserInfosToAttendees(proposalAttendees, tripAttendees, connectedUserInfo) {
  var getSortAttendeesByGmNumber = function getSortAttendeesByGmNumber(attendee1, attendee2) {
    if (!attendee1.gmNumber || !attendee2.gmNumber) {
      return 0;
    }

    return tripAttendees.adults.findIndex(function (attendee) {
      return attendee.gmNumber === attendee1.gmNumber;
    }) - tripAttendees.adults.findIndex(function (attendee) {
      return attendee.gmNumber === attendee2.gmNumber;
    });
  }; // defensive code if store is not available (ex: confirmation page)


  if (!tripAttendees || !proposalAttendees) {
    return {
      adults: [],
      children: []
    };
  }

  var sortedAdultsAttendees = tripAttendees.adults.sort(getSortAttendeesByGmNumber);
  var adultsList = proposalAttendees.adults.map(function (adult, index) {
    return _objectSpread(_objectSpread(_objectSpread({}, index === 0 ? connectedUserInfo : null), adult), Object(lodash__WEBPACK_IMPORTED_MODULE_4__["omitBy"])(sortedAdultsAttendees[index], function (value) {
      return value === undefined;
    }));
  });
  var childrenList = proposalAttendees.children.map(function (child) {
    return _objectSpread(_objectSpread({}, child), Object(lodash__WEBPACK_IMPORTED_MODULE_4__["omitBy"])(tripAttendees.kids.find(function (kid) {
      if (kid.id) {
        return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* apiDateToTimestamp */ "d"])(child.birthdate) && kid.id === child.id;
      }

      if (kid.neolid && child.customerId) {
        return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* apiDateToTimestamp */ "d"])(child.birthdate) && kid.neolid === child.customerId;
      }

      return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_8__[/* apiDateToTimestamp */ "d"])(child.birthdate);
    }), function (value, key) {
      return value === undefined || key === 'birthdate';
    }));
  }).sort(getSortAttendeesByGmNumber).sort(function (child1, child2) {
    // for seller set children with neolid (so with his fields already filled) first
    if (child1.neolid && !child2.neolid) {
      return -1;
    }

    if (!child1.neolid && child2.neolid) {
      return 1;
    }

    return 0;
  });
  return {
    adults: adultsList,
    children: childrenList
  };
};
var getCustomerSearchResult = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(bookingSelector, function (booking) {
  return booking.customerSearch;
});

var addSearchDataToAttendees = function addSearchDataToAttendees(attendeesWithInfo, attendeesFromSearch) {
  var enrichedAdults = attendeesWithInfo.adults.map(function (attendee, index) {
    var attendeeFromSearch = attendeesFromSearch.adults[index];
    return _objectSpread(_objectSpread({}, attendee), attendeeFromSearch ? _objectSpread(_objectSpread({}, attendeeFromSearch), {}, {
      /**
       * attendeeFromSearch has a "fake" id which is in reality customerId (see commonProfileFieldsFragment)
       * we want to have the proposal attendee id here because it's what the api is waiting for
       *  */
      id: attendee.id,
      customerId: attendeeFromSearch.id
    }) : null);
  });
  var enrichedChildren = attendeesWithInfo.children.map(function (attendee, index) {
    var attendeeFromSearch = attendeesFromSearch.children[index];
    return _objectSpread(_objectSpread({}, attendee), attendeeFromSearch ? _objectSpread(_objectSpread({}, attendeeFromSearch), {}, {
      /**
       * attendeeFromSearch has a "fake" id which is in reality customerId (see commonProfileFieldsFragment)
       * we want to have the proposal attendee id here because it's what the api is waiting for
       *  */
      id: attendee.id,
      customerId: attendeeFromSearch.id
    }) : null);
  });
  return {
    adults: enrichedAdults,
    children: enrichedChildren
  };
};

var enrichAttendeesWithAvailableData = function enrichAttendeesWithAvailableData(proposalAttendees, tripAttendees, connectedUserInfo, searchResult) {
  var attendeesWithInfo = addUserInfosToAttendees(proposalAttendees, tripAttendees, connectedUserInfo);
  return searchResult && searchResult.data ? addSearchDataToAttendees(attendeesWithInfo, searchResult.data) : attendeesWithInfo;
};

var getAttendeesWithInfos = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getAttendees, _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_7__[/* tripInformationSelector */ "d"], getConnectedUserInfoSelector, getCustomerSearchResult, enrichAttendeesWithAvailableData);
var getReservedServicesByAttendee = Object(reselect__WEBPACK_IMPORTED_MODULE_3__["createSelector"])(getCurrentProposal, getAttendeesWithInfos, function (_ref25, attendeesWithInfos) {
  var additionalServices = _ref25.additionalServices; // defensive code if store is not available (ex: confirmation page)

  if (!additionalServices || !attendeesWithInfos) {
    return [];
  }

  var attendeesWithServiceRented = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(additionalServices.activities), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(additionalServices.rentals)).reduce(function (acc, service) {
    var pricingInfo = service.pricingInfo,
        productInfo = service.productInfo;
    pricingInfo.schedules.forEach(function (_ref26) {
      var attendees = _ref26.attendees;
      attendees.forEach(function (attendee) {
        if (attendee.isRented) {
          if (acc[attendee.id]) {
            if (acc[attendee.id][productInfo.id]) {
              acc[attendee.id][productInfo.id].price += attendee.price.value;

              if (!acc[attendee.id][productInfo.id].services.some(function (_ref27) {
                var servicePricingInfo = _ref27.pricingInfo;
                return servicePricingInfo.id === service.pricingInfo.id;
              })) {
                acc[attendee.id][productInfo.id].services.push(service);
              }
            } else {
              acc[attendee.id][productInfo.id] = {
                price: attendee.price.value,
                services: [service]
              };
            }
          } else {
            acc[attendee.id] = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({}, productInfo.id, {
              price: attendee.price.value,
              services: [service]
            });
          }
        }
      });
    });
    return acc;
  }, {});
  return Object.entries(attendeesWithServiceRented).reduce(function (reservedServicesByAttendee, _ref28) {
    var _ref29 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref28, 2),
        id = _ref29[0],
        rentedServices = _ref29[1];

    var childIndex = attendeesWithInfos.children.findIndex(function (attendee) {
      return attendee.id === id;
    });

    if (childIndex > -1) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.children[childIndex]), {}, {
        id: id,
        index: childIndex + 1,
        isAdult: false,
        // $FlowFixMe 🤷‍️
        rentedServices: Object.values(rentedServices)
      })]);
    }

    var adultIndex = attendeesWithInfos.adults.findIndex(function (attendee) {
      return attendee.id === id;
    });
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.adults[adultIndex]), {}, {
      id: id,
      index: adultIndex + 1,
      isAdult: true,
      // $FlowFixMe 🤷‍️
      rentedServices: Object.values(rentedServices)
    })]);
  }, []).sort(function (a, b) {
    if (a.isAdult && !b.isAdult) {
      return -1;
    }

    if (!a.isAdult && b.isAdult) {
      return 1;
    }

    return a.index - b.index;
  });
});

var getDetailedAttendees = function getDetailedAttendees(_ref30) {
  var booking = _ref30.booking;
  return booking.attendees;
};



/***/ }),

/***/ "uLWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: Grid

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.themes.js
var themes = {
  "default": {
    thRoot: 'flex pt-2 w-full',
    thContent: 'bg-white flex flex-wrap relative w-full',
    thButton: 'absolute bottom-0 flex left-0 justify-center w-full',
    thPlaceholders: 'w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.jsx
var __jsx = react_default.a.createElement;







var PLACEHOLDER_URLS = ['https://ns.clubmed.com/it/2019/shop/dummy.png', 'https://ns.clubmed.com/it/2019/shop/dummy2.png', 'https://ns.clubmed.com/it/2019/shop/dummy3.png'];
var MoreResults_MoreResults = function MoreResults(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? 0 : _ref$number,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? lodash["noop"] : _ref$onClick,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      grid = _ref.grid,
      maxPlaceholders = _ref.maxPlaceholders;

  if (!number) {
    return null;
  }

  var _themes$theme = themes[theme],
      thContent = _themes$theme.thContent,
      thButton = _themes$theme.thButton,
      thPlaceholders = _themes$theme.thPlaceholders,
      thRoot = _themes$theme.thRoot;

  var renderPlaceholders = function renderPlaceholders() {
    var placeholders = [];

    for (var i = 0; i < number && i < maxPlaceholders; i++) {
      placeholders.push(__jsx(Image["a" /* default */], {
        className: classnames_default()('fadeIn px-2 align-bottom', grid),
        imageUrl: PLACEHOLDER_URLS[i],
        mandatoryWidthAndHeight: {
          w: 760,
          h: 'auto'
        },
        key: PLACEHOLDER_URLS[i]
      }));
    }

    return placeholders;
  };

  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, __jsx("div", {
    className: thContent
  }, __jsx("div", {
    className: thPlaceholders
  }, renderPlaceholders(), __jsx("div", {
    style: {
      position: 'absolute',
      bottom: '0',
      left: '0',
      right: '0',
      top: '0',
      background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%)'
    }
  })), __jsx("div", {
    className: thButton
  }, __jsx(Button["a" /* Button */], {
    onClick: onClick,
    dataTestId: "more-results-btn",
    iconRight: {
      name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH
    },
    minWidth: "220px",
    isLoading: isLoading
  }, __jsx("span", {
    "data-testid": "Moreresults-number"
  }, number), " ", text))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/grid/Grid.jsx









var Grid_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






function getWidth() {
  var fraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return fraction < 2 || fraction > 6 ? 'w-full' : "w-1/".concat(fraction);
}

function filterContext(hasOneRemaining, itemsByLine, isSeeMoreVisible) {
  return function (item, index) {
    if (isSeeMoreVisible) {
      return index < itemsByLine;
    }

    return true;
  };
}

var Grid_Grid = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Grid, _Component);

  var _super = _createSuper(Grid);

  function Grid() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Grid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      isExpanded: !_this.props.hasSeeMore
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickSeeMore", function () {
      var _this$props = _this.props,
          _this$props$totalNumb = _this$props.totalNumberToDisplay,
          totalNumberToDisplay = _this$props$totalNumb === void 0 ? 0 : _this$props$totalNumb,
          _this$props$getChildr = _this$props.getChildren,
          getChildren = _this$props$getChildr === void 0 ? function () {
        return Promise.resolve({});
      } : _this$props$getChildr,
          _this$props$isSynchro = _this$props.isSynchronousGrid,
          isSynchronousGrid = _this$props$isSynchro === void 0 ? false : _this$props$isSynchro;

      if (isSynchronousGrid || totalNumberToDisplay === _this.getItemsByLine()) {
        _this.setState({
          isExpanded: true
        });
      }

      if (totalNumberToDisplay > _this.getItemsByLine()) {
        getChildren();
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Grid, [{
    key: "getGrid",
    value: function getGrid() {
      var _this$props$grid = this.props.grid,
          grid = _this$props$grid === void 0 ? {} : _this$props$grid;
      var desktop = grid.desktop,
          tablet = grid.tablet,
          phablet = grid.phablet,
          mobile = grid.mobile;
      return "".concat(getWidth(mobile), " sm:").concat(getWidth(phablet), " md:").concat(getWidth(tablet), " lg:").concat(getWidth(desktop));
    }
  }, {
    key: "getItemsByLine",
    value: function getItemsByLine() {
      var _this$props2 = this.props,
          _this$props2$display = _this$props2.display,
          display = _this$props2$display === void 0 ? {} : _this$props2$display,
          _this$props2$responsi = _this$props2.responsive,
          responsive = _this$props2$responsi === void 0 ? {} : _this$props2$responsi;
      var _display$desktop = display.desktop,
          desktop = _display$desktop === void 0 ? 1 : _display$desktop,
          _display$tablet = display.tablet,
          tablet = _display$tablet === void 0 ? 1 : _display$tablet,
          _display$phablet = display.phablet,
          phablet = _display$phablet === void 0 ? 1 : _display$phablet,
          _display$mobile = display.mobile,
          mobile = _display$mobile === void 0 ? 1 : _display$mobile;
      var _responsive$isBrowser = responsive.isBrowserGreaterThan,
          isBrowserGreaterThan = _responsive$isBrowser === void 0 ? {} : _responsive$isBrowser;

      if (isBrowserGreaterThan.M && desktop > -1) {
        return desktop;
      }

      if (isBrowserGreaterThan.S && tablet > -1) {
        return tablet;
      }

      if (isBrowserGreaterThan.XS && phablet > -1) {
        return phablet;
      }

      return mobile;
    }
  }, {
    key: "getNumberOfItemsByLineExcludingSeeMore",
    value: function getNumberOfItemsByLineExcludingSeeMore() {
      return this.getItemsByLine();
    }
  }, {
    key: "getRest",
    value: function getRest() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          totalNumberToDisplay = _this$props3.totalNumberToDisplay;
      return totalNumberToDisplay ? totalNumberToDisplay - this.getItemsByLine() : react["Children"].count(children) - this.getItemsByLine();
    }
  }, {
    key: "getSeeMore",
    value: function getSeeMore() {
      var _this$props4 = this.props,
          hasSeeMore = _this$props4.hasSeeMore,
          isLoading = _this$props4.isLoading,
          seeMore = _this$props4.seeMore;
      return hasSeeMore && this.getRest() > 0 && !this.state.isExpanded ? Grid_jsx(MoreResults_MoreResults, Object(esm_extends["a" /* default */])({}, seeMore, {
        className: "h-full",
        isLoading: isLoading,
        number: this.getRest(),
        onClick: this.onClickSeeMore,
        grid: this.getGrid(),
        maxPlaceholders: this.getItemsByLine()
      })) : null;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this2 = this;

      var hasOneRemaining = this.getRest() === 1;
      var filterItem = filterContext(hasOneRemaining, this.getNumberOfItemsByLineExcludingSeeMore(), !this.state.isExpanded);
      return react["Children"].toArray(this.props.children).filter(filterItem).map(function (item) {
        return Grid_jsx("div", {
          className: classnames_default()('fadeIn p-px10', _this2.getGrid(), _this2.props.childrenClassName),
          "data-testid": "Grid-item",
          key: item.key
        }, item);
      });
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return [].concat(Object(toConsumableArray["a" /* default */])(this.getChildren()), [this.getSeeMore()]).filter(function (i) {
        return i;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var isLoading = _ref.isLoading;

      if (isLoading && !this.props.isLoading && !this.state.isExpanded) {
        this.setState({
          isExpanded: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var items = this.getItems();
      return items.length ? Grid_jsx("div", {
        className: classnames_default()(className, 'flex flex-wrap -m-px10'),
        "data-testid": "grid"
      }, items.map(function (item, index) {
        return (
          /* eslint-disable react/no-array-index-key */
          Grid_jsx(react["Fragment"], {
            key: index
          }, item)
        );
      })) : null;
    }
  }]);

  return Grid;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Grid_Grid, "defaultProps", {
  display: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  },
  getChildren: function getChildren() {
    return Promise.resolve({});
  },
  grid: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  }
});

/* harmony default export */ var grid_Grid = __webpack_exports__["a"] = (Object(Responsive["a" /* default */])(Grid_Grid));

/***/ }),

/***/ "uRnh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
var themes = {
  "default": {
    thRoot: 'cursor-pointer flex items-center font-bold font-sans leading-one no-underline text-sm text-white',
    thIcon: 'rtl:mr-1',
    thIconWidth: '2.5rem',
    thSText: 'text-base uppercase',
    thCustomText1: 'text-base uppercase'
  },
  black: {
    thRoot: 'flex justify-end items-center font-bold font-sans leading-tight no-underline text-initial text-gray-darker text-md',
    thIcon: 'text-gray-darker mb-1 sm:mb-0 sm:rtl:mr-3',
    thIconWidth: '2rem',
    thCustomText2: 'text-booking'
  },
  footerLite: {
    thRoot: 'flex flex-col lg:flex-row items-center text-center lg:text-initial text-blue',
    thIcon: 'lg:flex-shrink-0 mb-2 lg:mb-0 lg:rtl:mr-px10',
    thIconWidth: '1.5625rem',
    thTexts: 'lg:flex-1 text-gray-darker text-base',
    thCustomText0: 'font-bold text-blue text-md',
    thCustomText1: 'font-bold text-blue text-md'
  },
  contact: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-1 sm:mb-0 sm:rtl:mr-3',
    thIconWidth: '1.75rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-light'
  },
  contact2: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-1 sm:mb-0 sm:rtl:mr-3',
    thIconWidth: '3rem',
    thCustomText1: 'font-normal text-base text-gray-light',
    thCustomText2: 'font-normal text-base text-gray-darker'
  },
  smallFooterLite: {
    thRoot: 'cursor-pointer flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md text-blue',
    thIcon: 'text-blue mb-1 sm:mb-0 sm:rtl:mr-3',
    thIconWidth: '1.2rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-darker'
  },
  search: {
    thRoot: 'cursor-pointer items-center font-sans no-underline text-sm text-white'
  }
};

/***/ }),

/***/ "ubIY":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("jP+d");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "v78B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationTabsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var navigationTabsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* NAVIGATION_TABS */ "z"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common { next previous scrollBackward scrollForward }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_COMMON_I18N */ "c"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "v7Z5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tourPracticalInformationResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var tourPracticalInformationResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* TOUR_PRACTICAL_INFORMATION */ "Hb"],
  resolve: function resolve(appContext, props) {
    var productId = props.resortId;
    var query = "query {\n      resort(resortId:\"".concat(productId, "\"){\n        practicalInformation {\n          healthFormalities\n          passportAndVisas\n          includedInPackage\n          excludedInPackage\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_TOUR_PRACTICAL_INFO */ "Hc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "vIa8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ activeFacetsSelector; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ bannersSelector; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ facetingCriteriaSelector; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ facetsSelector; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ filteredProductsSelector; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ recommandedProductsSelector; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ filteredProductsCountSelector; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ filteredProductsSeasonsSelector; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ filtersSelector; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ getFacetingProductIds; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ getFiltersSelector; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getKidsValidationState; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ searchQuerySelector; });

// UNUSED EXPORTS: facetingSelector, facetingPricesSelector

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/utils/faceting/facetingFilters.js





var facetingFilters_FacetFilters = /*#__PURE__*/function () {
  function FacetFilters(list) {
    Object(classCallCheck["a" /* default */])(this, FacetFilters);

    this._list = list || [];
  }

  Object(createClass["a" /* default */])(FacetFilters, [{
    key: "addFilter",
    value: function addFilter(filter) {
      this._list.push({
        id: filter.id,
        name: filter.name
      });

      return this;
    }
  }, {
    key: "addFilters",
    value: function addFilters(filters) {
      if (filters) {
        filters.map(this.addFilter.bind(this));
      }

      return this;
    }
  }, {
    key: "removeFilters",
    value: function removeFilters(ids) {
      this._list = this._list.filter(function (item) {
        return !Object(lodash["includes"])(ids, item.id);
      });
      return this;
    }
  }, {
    key: "addChildcareFilters",
    value: function addChildcareFilters(args) {
      var kids = args.kids,
          _args$childcareFacets = args.childcareFacets,
          facets = _args$childcareFacets === void 0 ? [] : _args$childcareFacets,
          departureDate = args.departureDate;
      var childcareFacets = Object(lodash["isEmpty"])(facets) ? constants["h" /* DEFAULT_CHILDCARE_FACETS */].map(function (f) {
        return {
          label: f,
          value: f
        };
      }) : facets;
      var childcareRanges = childcareFacets.map(function (_ref) {
        var name = _ref.label;
        var facetRange = name.split('-');
        return {
          name: name,
          min: parseInt(facetRange[0], 10),
          max: parseInt(facetRange[1], 10)
        };
      });
      var childcareFilters = kids.filter(function (_ref2) {
        var childcareIncluded = _ref2.childcareIncluded;
        return childcareIncluded;
      }).map(function (_ref3) {
        var birthdate = _ref3.birthdate;
        var kidAgeInMonths = Object(facetingUtils["e" /* getKidAgeInMonths */])({
          birthdate: birthdate,
          departureDate: departureDate
        });
        var matchingFacet = childcareRanges.find(function (_ref4) {
          var min = _ref4.min,
              max = _ref4.max;
          return Object(lodash["inRange"])(kidAgeInMonths, min, max + 1);
        }); // lodash inRange exludes the max value

        if (!matchingFacet || !matchingFacet.name) {
          return null;
        }

        return {
          id: constants["e" /* CHILDCARE_FACET_ID */],
          name: matchingFacet.name
        };
      }).filter(Boolean);
      this._list = this._list.concat(Object(lodash["uniqWith"])(childcareFilters, lodash["isEqual"]));
      return this;
    }
  }, {
    key: "addAdultOnlyFilter",
    value: function addAdultOnlyFilter() {
      var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return Object(lodash["isEmpty"])(kids) ? this : this.addFilter({
        id: constants["d" /* ADULTS_ONLY_FACET_ID */],
        name: false
      });
    }
  }, {
    key: "value",
    value: function value() {
      return this._list.map(function (item) {
        return Object(lodash["pick"])(item, ['id', 'name']);
      });
    }
  }]);

  return FacetFilters;
}();
// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// CONCATENATED MODULE: ./src/client/store/faceting/faceting.selector.js


/* eslint-disable max-params */








var facetingSelector = function facetingSelector(_ref) {
  var faceting = _ref.faceting;
  return faceting || {};
};

var activeFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref2) {
  var activeFacets = _ref2.activeFacets;
  return activeFacets || {};
});
var searchQuerySelector = Object(lib["createSelector"])(facetingSelector, function (_ref3) {
  var query = _ref3.query;
  return query || {
    label: ''
  };
});
var facetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref4) {
  var facets = _ref4.facets;
  return facets || [];
});
var filtersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref5) {
  var filters = _ref5.filters;
  return filters || [];
});
var facetingPricesSelector = Object(lib["createSelector"])(facetingSelector, function (_ref6) {
  var prices = _ref6.prices;
  return prices;
});
var filteredProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref7) {
  var _ref7$products = _ref7.products,
      products = _ref7$products === void 0 ? [] : _ref7$products;
  return products;
});
var recommandedProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref8) {
  var _ref8$recommandedProd = _ref8.recommandedProducts,
      recommandedProducts = _ref8$recommandedProd === void 0 ? [] : _ref8$recommandedProd;
  return recommandedProducts;
});
var bannersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref9) {
  var banners = _ref9.banners;
  return banners || [];
});
var filteredProductsCountSelector = Object(lib["createSelector"])(facetingSelector, function (_ref10) {
  var _ref10$products = _ref10.products,
      products = _ref10$products === void 0 ? [] : _ref10$products;
  return products.length;
});
var filteredProductsSeasonsSelector = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.reduce(function (seasons, product) {
    return seasons.includes(product.seasonName) ? seasons : [].concat(Object(toConsumableArray["a" /* default */])(seasons), [product.seasonName]);
  }, []);
});
var getFacetingProductIds = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.map(function (_ref11) {
    var id = _ref11.id;
    return id;
  });
});
var getKidsValidationState = Object(lib["createSelector"])(facetingSelector, function (_ref12) {
  var _ref12$kidsValidation = _ref12.kidsValidationState,
      kidsValidationState = _ref12$kidsValidation === void 0 ? [] : _ref12$kidsValidation;
  return kidsValidationState;
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * representing active facets to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var activeFacetsCriteriaSelector = Object(lib["createSelector"])(activeFacetsSelector, function (activeFacets) {
  return Object.keys(activeFacets).reduce(function (acc, categoryId) {
    Object.entries(activeFacets[categoryId]).map(function (_ref13) {
      var _ref14 = Object(slicedToArray["a" /* default */])(_ref13, 2),
          filter = _ref14[0],
          isSelected = _ref14[1];

      if (isSelected) {
        acc.push({
          id: categoryId,
          name: filter
        });
      }
    });
    return acc;
  }, []);
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * containing aggregation of both facets and criterias to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'facette_adult_only', name: false },
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var getFiltersSelector = Object(lib["createSelector"])(storeHelper["c" /* getKids */], tripCriteria_selector["b" /* getDepartureDate */], activeFacetsCriteriaSelector, filtersSelector, tripCriteria_selector["a" /* getDepartureCity */], facetsSelector, function (kids, departureDate, activeFacets, filters, departureCity, facets) {
  var allFilters = new facetingFilters_FacetFilters(filters).removeFilters([constants["a" /* ACTIVITIES_FACET_ID */], constants["d" /* ADULTS_ONLY_FACET_ID */], constants["e" /* CHILDCARE_FACET_ID */], constants["j" /* DEPARTURE_CITY_FACET_ID */]].concat(Object(toConsumableArray["a" /* default */])(constants["r" /* FILTERABLE_FACETS_IDS */]))).addAdultOnlyFilter(kids).addChildcareFilters({
    kids: kids,
    childcareFacets: Object(facetingUtils["b" /* getChildcareFacets */])(facets),
    departureDate: departureDate
  }).addFilters(activeFacets);

  if (departureCity) {
    allFilters.addFilter({
      id: constants["j" /* DEPARTURE_CITY_FACET_ID */],
      name: departureCity
    });
  }

  return allFilters.value();
});
/**
 * Returns an object with an aggregation of criterias for Pertimm:
 *
 * Example:
 * ```json
 * {
 *    departureDate: '',
 *    tripDuration: '7',
 *    filters: [
 *      { id: 'facette_departure_city',  name: 'PAR' },
 *      { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 *    ]
 * }
 * ```
 */

var facetingCriteriaSelector = Object(lib["createSelector"])([tripCriteria_selector["b" /* getDepartureDate */], tripCriteria_selector["c" /* getTripDuration */], getFiltersSelector, storeHelper["c" /* getKids */]], function (departureDate, tripDuration, filters, kids) {
  return {
    departureDate: departureDate,
    tripDuration: tripDuration,
    filters: filters,
    kids: kids
  };
});


/***/ }),

/***/ "vrF/":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("rnJz"),
    isObjectLike = __webpack_require__("oS78");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "vt7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instagramResolver; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("4VTZ");







var priceQuery = function priceQuery(displayPrices) {
  if (displayPrices) {
    return "\n      price {\n        bestPrice {\n          formattedValue\n          value\n        }\n        termsAndConditions {\n          accommodationComfortLabel\n          arrivalDate\n          departureCity {\n            name\n            value\n          }\n          departureDate\n          duration\n          durationFormatted\n          numberOfAdults\n        }\n        unit\n      }";
  }

  return '';
};

var instagramResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_2__[/* INSTAGRAM */ "r"],
  resolve: function () {
    var _resolve = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(appContext, props) {
      var displayPrices, resortIds, resortIdsAsString, query;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              displayPrices = props.displayPrices, resortIds = props.resortIds;
              resortIdsAsString = JSON.stringify(resortIds);
              query = "query {\n      config {\n        common {\n          close\n          next\n          previous\n          scrollBackward\n          scrollForward\n        }\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_5__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_5__[/* resort */ "e"](appContext), "\n      }\n      products: resorts(resortIds: ").concat(resortIdsAsString, ") {\n        color\n        comfort\n        duration,\n        href\n        id\n        isCruise\n        isJoyview\n        isTour\n        name\n        ").concat(priceQuery(displayPrices), "\n        socialPictures {\n          canonicalUrl,\n          imageLarge,\n          imageSmall,\n          userName,\n        }\n      }\n    }");
              return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(query, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_COMMON_INSTAGRAM */ "Hb"]
              }));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function resolve(_x, _x2) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }()
};

/***/ }),

/***/ "w04c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductsGrid; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _frameworks_grid_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("uLWw");
/* harmony import */ var _line_title_LineTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2Ufl");
/* harmony import */ var _product_Product__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("XTOr");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;




var ProductsGrid = function ProductsGrid(_ref) {
  var childrenClassName = _ref.childrenClassName,
      className = _ref.className,
      display = _ref.display,
      fetchData = _ref.fetchData,
      grid = _ref.grid,
      hasSeeMore = _ref.hasSeeMore,
      isLoading = _ref.isLoading,
      _ref$isSynchronousGri = _ref.isSynchronousGrid,
      isSynchronousGrid = _ref$isSynchronousGri === void 0 ? false : _ref$isSynchronousGri,
      lineName = _ref.lineName,
      products = _ref.products,
      offer = _ref.offer,
      onComparisonClick = _ref.onComparisonClick,
      seeMore = _ref.seeMore,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      totalNumberToDisplay = _ref.totalNumberToDisplay;

  if (products.length === 0) {
    return null;
  }

  return __jsx("div", {
    className: className
  }, !!title && __jsx(_line_title_LineTitle__WEBPACK_IMPORTED_MODULE_3__[/* LineTitle */ "a"], null, title), __jsx(_frameworks_grid_Grid__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], {
    childrenClassName: childrenClassName,
    display: display || grid,
    getChildren: fetchData,
    grid: grid,
    hasSeeMore: hasSeeMore,
    isLoading: isLoading,
    seeMore: seeMore,
    totalNumberToDisplay: totalNumberToDisplay,
    isSynchronousGrid: isSynchronousGrid
  }, products.map(function (product, index) {
    return __jsx(_product_Product__WEBPACK_IMPORTED_MODULE_4__[/* Product */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
      index: index,
      key: product.id,
      lineName: lineName,
      offer: offer,
      onComparisonClick: onComparisonClick ? function () {
        return onComparisonClick(product.id);
      } : undefined
    }, product));
  })));
};
ProductsGrid.defaultProps = {
  hasSeeMore: false,
  products: []
};

/***/ }),

/***/ "w5oF":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "wKzQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaWho; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("uDfI");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SPKZ");
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("XiOS");
/* harmony import */ var _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("TYzI");
/* harmony import */ var _CriteriaTrigger_jsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+Rc+");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("PFSw");
/* harmony import */ var _filter_who_FilterWho_jsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("tUgU");
/* harmony import */ var _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("45yR");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("kiXb");
/* harmony import */ var _store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("loSl");
/* harmony import */ var _store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ORYz");
/* harmony import */ var _store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("VO7D");
/* harmony import */ var _store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("1bWg");
/* harmony import */ var _store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("Jsmy");
/* harmony import */ var _utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("cGFA");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("sRdV");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





















var KIDS_ACTIONS = {
  CHANGE_KID: 'CHANGE_KID',
  CHANGE_KIDS_COUNT: 'CHANGE_KIDS_COUNT',
  REMOVE_KIDS: 'REMOVE_KIDS',
  SYNC_KIDS: 'SYNC_KIDS'
};

var getKidBirthdateAndChildcare = function getKidBirthdateAndChildcare(kid) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_6__["pick"])(kid, ['birthdate', 'childcareIncluded']);
};

var getKidWithoutStatus = function getKidWithoutStatus(kid) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_6__["omit"])(kid, ['status']);
};

var getKidWithStatus = function getKidWithStatus(kid, isKidBirthdateRequired) {
  return _objectSpread(_objectSpread({}, kid), {}, {
    status: Object(_utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_21__[/* getValidationStateFromKid */ "a"])(kid, isKidBirthdateRequired)
  });
};

var CriteriaWho = function CriteriaWho(props) {
  var _props$hasChildcareSw = props.hasChildcareSwitch,
      hasChildcareSwitch = _props$hasChildcareSw === void 0 ? true : _props$hasChildcareSw,
      isKidBirthdateRequired = props.isKidBirthdateRequired,
      isJoyview = props.isJoyview;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_3__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_9__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(_CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__[/* useCriteriaDisplayContext */ "c"])(),
      _useCriteriaDisplayCo2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_useCriteriaDisplayCo, 2),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0],
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_4__[/* useDispatch */ "d"])();
  var adultsNumber = Object(react_redux__WEBPACK_IMPORTED_MODULE_4__[/* useSelector */ "e"])(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_20__[/* getAdultsNumber */ "b"]);
  var kids = Object(react_redux__WEBPACK_IMPORTED_MODULE_4__[/* useSelector */ "e"])(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_20__[/* getKids */ "c"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_22__[/* useTracking */ "a"])({
    actionGA: criteriaContext.trackingActionName
  });

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(adultsNumber || _store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_17__[/* DEFAULT_ADULTS_NB */ "a"]),
      inputAdultsNumber = _useState[0],
      setInputAdultsNumber = _useState[1];

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_3__["useReducer"])(function (state, action) {
    switch (action.type) {
      case KIDS_ACTIONS.SYNC_KIDS:
        return action.payload;

      case KIDS_ACTIONS.REMOVE_KIDS:
        return [];

      case KIDS_ACTIONS.CHANGE_KIDS_COUNT:
        return action.payload > state.length ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(state), [{
          birthdate: undefined,
          childcareIncluded: false,
          neolid: undefined,
          status: _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_14__[/* NOT_VALIDATED */ "c"]
        }]) : state.slice(0, -1);

      case KIDS_ACTIONS.CHANGE_KID:
        return state.map(function (kid, index) {
          return index === action.payload.index ? getKidWithStatus(action.payload.kid, isKidBirthdateRequired) : kid;
        });

      default:
        return state;
    }
  }, kids.map(getKidWithStatus)),
      inputKids = _useReducer[0],
      setInputKids = _useReducer[1];

  var inputKidsValidationState = inputKids.map(function (kid) {
    return kid.status;
  });
  var hasInvalidKidsStatus = inputKidsValidationState.some(function (status) {
    return status === _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_14__[/* NOT_VALIDATED */ "c"] || status === _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_14__[/* IS_INVALID */ "a"];
  });
  var inputKidsEqualKids = Object(lodash__WEBPACK_IMPORTED_MODULE_6__["isEqual"])(inputKids.map(getKidBirthdateAndChildcare), kids.map(getKidBirthdateAndChildcare));
  var inputAdultsNumberEqualsAdultsNumber = inputAdultsNumber === adultsNumber; // Store update effect

  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    var adultsAreSet = adultsNumber > 0;
    var kidsAreSet = Object(_utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_21__[/* hasOnlyValidKids */ "d"])(Object(_utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_21__[/* getValidationStateFromKids */ "b"])(kids)); // Is also true when there are no kids

    setCriteriaContext({
      criteriaWhoIsSet: adultsAreSet && kidsAreSet
    });
  }, [adultsNumber, kids]);

  var openCriteriaEventHandler = function openCriteriaEventHandler() {
    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__[/* ACTIONS */ "a"].OPEN_CRITERIA,
      payload: 'criteriaWho'
    });
  }; // Open/Close effect


  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_12__[/* OPEN_CRITERIA_WHO_EVENT */ "a"], openCriteriaEventHandler);
    return function () {
      return document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_12__[/* OPEN_CRITERIA_WHO_EVENT */ "a"], openCriteriaEventHandler);
    };
  }, []);

  var saveParticipants = function saveParticipants() {
    if (!inputKidsEqualKids) {
      dispatch(Object(_store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_19__[/* setKids */ "b"])(inputKids.map(getKidWithoutStatus)));
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_16__[/* setKidsValidationState */ "n"])(inputKidsValidationState));

      if (kids.length !== inputKids.length) {
        dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_16__[/* changeKidsNumber */ "b"])(inputKids.length));
      }
    } else {
      // Sync kids store with inputKids
      setInputKids({
        type: KIDS_ACTIONS.SYNC_KIDS,
        payload: inputKids
      });
    }

    if (inputKids.length > 0 && inputAdultsNumber === 0) {
      dispatch(Object(_store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_18__[/* setAdultsNumber */ "b"])(_store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_17__[/* DEFAULT_ADULTS_NB */ "a"]));
    } else if (!inputAdultsNumberEqualsAdultsNumber) {
      dispatch(Object(_store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_18__[/* setAdultsNumber */ "b"])(inputAdultsNumber));
    }

    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__[/* ACTIONS */ "a"].CLOSE_CRITERIA,
      payload: 'criteriaWho'
    });
  };

  var labelParts = '';
  var labelPartsMobile = '';

  if (adultsNumber > 0) {
    var labelPartsTmp = [];
    var lengthPeople = adultsNumber + kids.length;

    if (lengthPeople) {
      labelPartsMobile = lengthPeople.toString(10);

      if (adultsNumber >= 1) {
        labelPartsTmp.push(Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('booking.form.selectAdultsLabels', {
          count: adultsNumber
        }));
      }

      if (kids.length >= 1) {
        labelPartsTmp.push(Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('booking.form.selectChildrenLabels', {
          count: kids.length
        }));
      }

      labelParts = labelPartsTmp.join(' - ');
    }
  } else {
    labelParts = Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.who.title');
  }

  var buttonLabel = __jsx(react__WEBPACK_IMPORTED_MODULE_3__["Fragment"], null, __jsx("span", {
    className: "hidden lg:flex flex-row py-0 flex-1 overflow-hidden items-center whitespace-no-wrap button-default",
    style: {
      height: '1px'
    }
  }, labelParts), __jsx("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('lg:hidden flex flex-col py-1 justify-center overflow-hidden items-center whitespace-no-wrap button-default', {
      'rtl:ml-2': !!labelPartsMobile
    }),
    style: {
      height: '1px'
    }
  }, !!labelPartsMobile && __jsx("span", null, labelPartsMobile)));

  var trackKidsNumberChange = function trackKidsNumberChange(value) {
    if (criteriaContext.trackingActionName) {
      track({
        labelGA: 'who_child',
        valueGA: value
      });
    }
  };

  var trackAdultsNumberChange = function trackAdultsNumberChange(value) {
    if (criteriaContext.trackingActionName) {
      track({
        labelGA: 'who_adult',
        valueGA: value
      });
    }
  };

  return __jsx(_CriteriaTrigger_jsx__WEBPACK_IMPORTED_MODULE_11__[/* CriteriaTrigger */ "a"], {
    buttonLabel: buttonLabel,
    buttonIcon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].USERS,
    buttonIsFilled: criteriaContext.criteriaWhoIsSet,
    dataTestId: "CriteriaWho",
    dropDownMinWidth: 500,
    isOpen: criteriaDisplayContext.criteriaWhoIsOpen,
    isJoyview: isJoyview,
    trackingLabel: "who",
    onOpen: function onOpen() {
      dispatchCriteriaDisplayContext({
        type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__[/* ACTIONS */ "a"].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
    },
    onClose: saveParticipants,
    onClear: function onClear() {
      setCriteriaContext({
        criteriaWhoIsSet: false
      });
      dispatch(Object(_store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_18__[/* setAdultsNumber */ "b"])(0));
      dispatch(Object(_store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_19__[/* setKids */ "b"])([]));
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_16__[/* changeKidsNumber */ "b"])(0));
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_16__[/* setKidsValidationState */ "n"])([]));
      setInputKids({
        type: KIDS_ACTIONS.REMOVE_KIDS
      });
      setInputAdultsNumber(_store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_17__[/* DEFAULT_ADULTS_NB */ "a"]);
    },
    buttons: [{
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.reset'),
      theme: 'link',
      onClick: function onClick() {
        setInputAdultsNumber(_store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_17__[/* DEFAULT_ADULTS_NB */ "a"]);
        setInputKids({
          type: KIDS_ACTIONS.REMOVE_KIDS
        });
      },
      className: 'text-sm cursor-pointer',
      dataTestId: 'criteria-who-reset'
    }, {
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.validate'),
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_7__[/* COLORS */ "a"].TURQUOISE,
      dataTestId: 'criteria-who-validate',
      isDisabled: isKidBirthdateRequired && hasInvalidKidsStatus,
      onClick: function onClick() {
        saveParticipants();
        dispatchCriteriaDisplayContext({
          type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_10__[/* ACTIONS */ "a"].OPEN_NEXT_CRITERIA,
          payload: {
            currentCriteria: 'criteriaWho',
            criteriaContext: criteriaContext
          }
        });
      }
    }]
  }, __jsx(_filter_who_FilterWho_jsx__WEBPACK_IMPORTED_MODULE_13__[/* FilterWho */ "a"], {
    hasChildcareSwitch: hasChildcareSwitch,
    adultsNumber: inputAdultsNumber,
    kids: inputKids,
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.who.title'),
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.who.subTitle'),
    adultsLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.who.adults'),
    kidsLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.who.kids'),
    kidsAgeLabel: isKidBirthdateRequired ? Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.who.ageSectionSubtitle') : Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.who.ageSectionChildcareSubtitle'),
    kidsAgeLimitLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.who.kidsAgeLimit'),
    dateFormat: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('booking.form.dateFormat'),
    dayPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('booking.form.dayPlaceholder'),
    monthPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('booking.form.monthPlaceholder'),
    yearPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('booking.form.yearPlaceholder'),
    informationLabel: !isKidBirthdateRequired ? Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.who.ageComment') : undefined,
    addChildcareLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('faceting.who.addChildcare'),
    birthdaysErrorMessage: isKidBirthdateRequired ? Object(_i18n__WEBPACK_IMPORTED_MODULE_15__[/* t */ "f"])('booking.form.errors.birthdayFormat') : '',
    changeKidsNumber: function changeKidsNumber(value) {
      setInputKids({
        type: KIDS_ACTIONS.CHANGE_KIDS_COUNT,
        payload: value
      });
      trackKidsNumberChange(value);
    },
    changeKid: function changeKid(index, kid) {
      setInputKids({
        type: KIDS_ACTIONS.CHANGE_KID,
        payload: {
          index: index,
          kid: kid
        }
      });
    },
    kidsValidationState: inputKidsValidationState,
    validateKidsBirthdate: function validateKidsBirthdate(index, kid) {
      setInputKids({
        type: KIDS_ACTIONS.CHANGE_KID,
        payload: {
          index: index,
          kid: kid
        }
      });
    },
    setAdultsNumber: function setAdultsNumber(number) {
      setInputAdultsNumber(number);
      trackAdultsNumberChange(number);
    }
  }));
};

/***/ }),

/***/ "wQ38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_UPDATE_KID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIP_INFORMATION_RESET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_KID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATION_STATE_ENUM; });
var TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
var TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS = 'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
var TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
var TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';
var DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true
};
var VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED'
});

/***/ }),

/***/ "wRBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputDatalist_InputDatalist; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /home/circleci/project/node_modules/striptags/striptags.js
var striptags = __webpack_require__("47go");
var striptags_default = /*#__PURE__*/__webpack_require__.n(striptags);

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-text/InputText.themes.js


var themes = {
  "default": function _default(props) {
    return {
      thInput: classnames_default()('reset-input text-md sm:text-base w-full', Object(form_util["a" /* getCursorClass */])(props), {
        'text-white': props.isFilled,
        'text-darker-gray': !props.isFilled,
        'button-medium': props.size === 'medium',
        'button-default': props.size === 'large'
      }),
      thToggler: classnames_default()('reset-button leading-none px-4 text-base', Object(form_util["a" /* getCursorClass */])(props))
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-text/InputText.jsx








var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var InputText_InputText = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputText, _Component);

  var _super = _createSuper(InputText);

  function InputText(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputText);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = e.target.value;

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (e) {
      var _this$props$onKeyDown = _this.props.onKeyDown,
          onKeyDown = _this$props$onKeyDown === void 0 ? lodash["noop"] : _this$props$onKeyDown;
      e.persist();
      onKeyDown(e);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        value: ''
      }, function () {
        return onClear(e);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleType", function () {
      var _this$props2 = _this.props,
          type = _this$props2.type,
          _this$props2$typeTogg = _this$props2.typeToggler,
          typeToggler = _this$props2$typeTogg === void 0 ? {} : _this$props2$typeTogg;

      _this.setState({
        type: _this.state.type !== typeToggler.antiType ? typeToggler.antiType : type
      });
    });

    _this.state = {
      type: props.type || 'text',
      value: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputText, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value,
          type = _ref.type;
      this.setState(function (prevState) {
        if (prevState.value !== value || prevState.type !== type) {
          return {
            type: type,
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          autoComplete = _this$props3.autoComplete,
          className = _this$props3.className,
          hasClear = _this$props3.hasClear,
          hasTypeToggler = _this$props3.hasTypeToggler,
          hasValidationIcon = _this$props3.hasValidationIcon,
          iconLeft = _this$props3.iconLeft,
          iconRight = _this$props3.iconRight,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputText_') : _this$props3$id,
          isActive = _this$props3.isActive,
          isDisabled = _this$props3.isDisabled,
          isFilled = _this$props3.isFilled,
          isLoading = _this$props3.isLoading,
          isNotEditable = _this$props3.isNotEditable,
          isReadOnly = _this$props3.isReadOnly,
          isRequired = _this$props3.isRequired,
          label = _this$props3.label,
          maxLength = _this$props3.maxLength,
          minLength = _this$props3.minLength,
          name = _this$props3.name,
          notes = _this$props3.notes,
          onBlur = _this$props3.onBlur,
          onClick = _this$props3.onClick,
          onFocus = _this$props3.onFocus,
          onKeyUp = _this$props3.onKeyUp,
          pattern = _this$props3.pattern,
          placeholder = _this$props3.placeholder,
          size = _this$props3.size,
          _this$props3$theme = _this$props3.theme,
          theme = _this$props3$theme === void 0 ? 'default' : _this$props3$theme,
          _this$props3$typeTogg = _this$props3.typeToggler,
          typeToggler = _this$props3$typeTogg === void 0 ? {} : _this$props3$typeTogg,
          validationState = _this$props3.validationState,
          dataTestId = _this$props3.dataTestId;
      var _this$state = this.state,
          type = _this$state.type,
          value = _this$state.value;
      var hasClearEnabled = Boolean(hasClear && value);
      var hasValue = Boolean(value);

      var _themes$theme = themes[theme](this.props),
          thInput = _themes$theme.thInput,
          thToggler = _themes$theme.thToggler;

      return __jsx(FormControl["a" /* FormControl */], {
        className: className,
        hasClear: hasClearEnabled,
        hasValidationIcon: hasValidationIcon,
        iconLeft: iconLeft,
        iconRight: iconRight,
        id: id,
        isActive: isActive,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        size: size,
        theme: theme,
        validationState: validationState
      }, __jsx("input", Object(esm_extends["a" /* default */])({
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        "data-testid": dataTestId,
        id: id
      }, Object(lodash["isInteger"])(maxLength) ? {
        maxLength: maxLength
      } : null, Object(lodash["isInteger"])(minLength) ? {
        minLength: minLength
      } : null, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: this.onKeyDown,
        onKeyUp: onKeyUp // $FlowFixMe

      }, pattern ? {
        pattern: pattern
      } : null, placeholder ? {
        placeholder: Object(form_util["b" /* getFormattedLabel */])(placeholder, isRequired)
      } : null, {
        readOnly: Boolean(isReadOnly || isLoading || isNotEditable),
        required: isRequired,
        role: type === 'search' ? 'search' : 'textbox',
        type: type,
        value: value
      })), hasTypeToggler && __jsx("button", {
        className: thToggler,
        disabled: isDisabled,
        onClick: this.toggleType,
        type: "button",
        "data-testid": "InputTextToggler"
      }, __jsx(Icon["a" /* Icon */], {
        name: type === this.props.type ? typeToggler.icon : typeToggler.antiIcon
      })));
    }
  }]);

  return InputText;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputText_InputText, "defaultProps", {
  autoComplete: 'off',
  size: 'medium',
  theme: 'default',
  type: 'text',
  typeToggler: {
    antiIcon: icons["a" /* ICONS */].CLOSED_EYE_PASSWORD,
    antiType: 'text',
    icon: icons["a" /* ICONS */].EYE_PASSWORD
  }
});
// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/widgets/exclusive-collection-badge/ECBadge.jsx
var ECBadge = __webpack_require__("Itgl");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.layouts.jsx
var InputDatalist_layouts_jsx = react_default.a.createElement;





var InputDatalist_layouts_DefaultLayout = function DefaultLayout(_ref) {
  var icon = _ref.icon,
      isActive = _ref.isActive,
      label = _ref.label,
      subLabel1 = _ref.subLabel1,
      subLabel2 = _ref.subLabel2,
      type = _ref.type;

  var _useState = Object(react["useState"])(false),
      hover = _useState[0],
      setHover = _useState[1];

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  if (!label) {
    return null;
  }

  return InputDatalist_layouts_jsx("div", {
    className: classnames_default()('focus:bg-turquoise hover:bg-turquoise cursor-pointer flex items-center overflow-hidden px-2 py-3 focus:text-white hover:text-white transition-colors', {
      'bg-turquoise text-white': isActive
    }),
    onMouseEnter: function onMouseEnter() {
      return isDesktop && setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return isDesktop && setHover(false);
    }
  }, icon ? InputDatalist_layouts_jsx(Icon["a" /* Icon */], {
    className: classnames_default()('flex-shrink-0', {
      'text-blue': !hover && !isActive
    }),
    name: icon,
    width: "1.25rem"
  }) : InputDatalist_layouts_jsx(ECBadge["a" /* ECBadge */], {
    className: "flex-shrink-0",
    height: 30
  }), InputDatalist_layouts_jsx("div", {
    className: "decorator-match flex-1 rtl:ml-3 text-md"
  }, !!subLabel1 && !!subLabel2 && InputDatalist_layouts_jsx("div", {
    className: classnames_default()('leading-one text-sm', {
      'text-gray-medium': !isActive && !hover,
      'text-current': isActive || hover
    })
  }, !!subLabel1 && InputDatalist_layouts_jsx("span", {
    className: "font-bold uppercase"
  }, subLabel1), !!subLabel1 && !!subLabel2 && InputDatalist_layouts_jsx("span", null, " - "), !!subLabel2 && InputDatalist_layouts_jsx("span", {
    className: ""
  }, subLabel2)), InputDatalist_layouts_jsx("div", {
    className: classnames_default()({
      'font-brand text-md': type === 'resort'
    }) // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: label
    }
  })));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.themes.js
var InputDatalist_themes_themes = {
  "default": {
    thRoot: 'relative',
    thDatalist: 'reset-list absolute arrow-up arrow-large arrow-white arrow-bg arrow-bg-blue bg-white border-1 border-blue mt-5 p-2 rounded-small shadow-lg top-full w-full z-6'
  },
  pyr: {
    thRoot: 'fixed',
    thDatalist: 'reset-list absolute arrow-up arrow-large arrow-white arrow-bg arrow-bg-blue bg-white border-1 border-blue mt-5 p-2 rounded-small shadow-lg top-full w-full z-6'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.jsx








var InputDatalist_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function InputDatalist_createSuper(Derived) { var hasNativeReflectConstruct = InputDatalist_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function InputDatalist_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-env browser */








var InputDatalist_InputDatalist = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(InputDatalist, _PureComponent);

  var _super = InputDatalist_createSuper(InputDatalist);

  function InputDatalist(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputDatalist);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "dataListElementRef", null);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickOutside", function (e) {
      var isActive = _this.state.isActive;

      if (!_this.dataListElementRef || !isActive) {
        return;
      }

      var dataListNode = _this.dataListElementRef.current;

      if (!dataListNode || !dataListNode.contains(e.target)) {
        _this.setState({
          isActive: false
        });

        if (_this.props.onClickOutside) {
          _this.props.onClickOutside();
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openList", function () {
      _this.setState(function (prevState) {
        if (!prevState.isActive) {
          return {
            isActive: true
          };
        }
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (e) {
      var _this$props = _this.props,
          _this$props$dataList = _this$props.dataList,
          dataList = _this$props$dataList === void 0 ? [] : _this$props$dataList,
          onClear = _this$props.onClear,
          onKeyDown = _this$props.onKeyDown,
          onValidate = _this$props.onValidate;
      var _this$state = _this.state,
          index = _this$state.index,
          selected = _this$state.selected;

      if (e.keyCode === keyCodes["a" /* ARROW_DOWN */] && index < dataList.length - 1) {
        _this.goToIndex(1);
      } else if (e.keyCode === keyCodes["d" /* ARROW_UP */] && index > 0) {
        _this.goToIndex(-1);
      } else if (e.keyCode === keyCodes["f" /* ENTER */]) {
        var item = dataList[index];

        _this.setState({
          isActive: false
        });

        if (item) {
          _this.onSelect(item);
        } else if (selected === '' && Object(lodash["isFunction"])(onClear)) {
          onClear();
        } else if (Object(lodash["isFunction"])(onValidate)) {
          onValidate();
        }
      }

      if (Object(lodash["isFunction"])(onKeyDown)) {
        onKeyDown(e);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onFocus", function (e) {
      var onFocus = _this.props.onFocus;

      if (Object(lodash["isFunction"])(onFocus) && !_this.state.isActive) {
        onFocus(e);
      }

      _this.openList();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (name, value) {
      _this.setState({
        isActive: true,
        selected: value
      }, function () {
        if (_this.props.onChange) _this.props.onChange(name, value);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        index: -1,
        isActive: false,
        selected: ''
      }, function () {
        return onClear(e);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickItem", function (item) {
      return function () {
        return _this.onSelect(item);
      };
    });

    _this.dataListElementRef = /*#__PURE__*/Object(react["createRef"])();
    _this.state = {
      index: -1,
      isActive: false,
      selected: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputDatalist, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (true) {
        document.addEventListener('click', this.onClickOutside);
        document.addEventListener('focus', this.onClickOutside);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (true) {
        document.removeEventListener('click', this.onClickOutside);
        document.removeEventListener('focus', this.onClickOutside);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var selected = this.props.value;

      if (!Object(lodash["isUndefined"])(selected) && !prevState.isActive && prevState.selected !== selected) {
        this.setState({
          selected: selected
        });
      }
    }
  }, {
    key: "goToIndex",
    value: function goToIndex(offset) {
      this.setState(function (prevState) {
        var index = prevState.index + offset;
        return {
          index: index
        };
      });
    }
  }, {
    key: "onSelect",
    value: function onSelect(item) {
      var _this$props$onSelect = this.props.onSelect,
          onSelect = _this$props$onSelect === void 0 ? lodash["noop"] : _this$props$onSelect;
      var sanitizedItem = {
        item: item,
        label: striptags_default()(Object(lodash["get"])(item, 'label'))
      };
      this.setState({
        index: -1,
        isActive: false,
        selected: sanitizedItem.label
      });
      onSelect(sanitizedItem);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          dataList = _this$props2.dataList,
          id = _this$props2.id,
          isAnimated = _this$props2.isAnimated,
          isDisabled = _this$props2.isDisabled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          itemLayout = _this$props2.itemLayout,
          itemTitle = _this$props2.itemTitle,
          theme = _this$props2.theme;
      var _themes$theme = InputDatalist_themes_themes[theme],
          thDatalist = _themes$theme.thDatalist,
          thRoot = _themes$theme.thRoot;
      var _this$state2 = this.state,
          isActive = _this$state2.isActive,
          selected = _this$state2.selected;
      return InputDatalist_jsx("div", {
        className: thRoot,
        ref: this.dataListElementRef
      }, InputDatalist_jsx(InputText_InputText, Object(esm_extends["a" /* default */])({}, Object(lodash["pick"])(this.props, ['hasClear', 'hasValidationIcon', 'iconLeft', 'iconRight', 'isDisabled', 'isFilled', 'isLoading', 'isReadOnly', 'isRequired', 'label', 'name', 'notes', 'onBlur', 'onClick', 'onKeyUp', 'placeholder', 'size', 'theme', 'validationState']), {
        autoComplete: "off",
        dataTestId: "InputDatalistQuery",
        id: id,
        isActive: isActive && !isReadOnly,
        onChange: this.onChange,
        onClear: this.onClear,
        onFocus: this.onFocus,
        onKeyDown: this.onKeyDown,
        type: "text",
        value: selected
      })), isActive && !isReadOnly && !isDisabled && !isLoading && !!dataList.length && InputDatalist_jsx("ul", {
        className: classnames_default()(thDatalist, {
          fadeIn: isAnimated
        }),
        "data-testid": "InputDatalistList",
        role: "listbox"
      }, !!itemTitle && InputDatalist_jsx("li", {
        className: "decorator-border-bottom-list"
      }, itemTitle), dataList.map(function (item, index) {
        if (!item.label) return null;
        var indexFromState = _this2.state.index;

        var newItem = _objectSpread(_objectSpread({}, item), {}, {
          isActive: index === indexFromState
        });

        var hasCustomLayout = Object(lodash["isFunction"])(itemLayout);
        return InputDatalist_jsx("li", {
          className: "decorator-border-bottom-list",
          "data-testid": item.id,
          key: item.id ? item.id : index,
          onClick: _this2.onClickItem(item)
        }, // $FlowFixMe
        hasCustomLayout ? itemLayout(newItem) : InputDatalist_jsx(InputDatalist_layouts_DefaultLayout, newItem));
      })));
    }
  }]);

  return InputDatalist;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(InputDatalist_InputDatalist, "defaultProps", {
  dataList: [],
  size: 'medium',
  theme: 'default'
});

/***/ }),

/***/ "weY2":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("lDSF"),
    root = __webpack_require__("jP+d");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "xGYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputNumber_InputNumber; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.themes.js

var themes = {
  "default": function _default(_ref) {
    var hasColumnLayout = _ref.hasColumnLayout,
        hasValue = _ref.hasValue,
        isDisabled = _ref.isDisabled,
        isReadOnly = _ref.isReadOnly,
        validationState = _ref.validationState;
    return {
      thRoot: hasColumnLayout ? 'flex flex-col text-center' : 'flex items-center justify-between',
      thLabel: classnames_default()('text-base', {
        'rtl:mr-3': !hasColumnLayout,
        'mb-1': hasColumnLayout,
        'text-gray-darker': validationState === 'NOT_VALIDATED' && hasValue && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-danger': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thNotes: 'text-xs text-gray-medium',
      thInputs: 'flex-shrink-0',
      thInput: classnames_default()('reset-input reset-input-number mx-1 px-1 text-center text-base outline-custom', {
        'font-bold': hasValue && !isReadOnly && !isDisabled,
        'text-blue': validationState === 'NOT_VALIDATED' && hasValue && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-danger': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thButton: 'reset-button cursor-default bg-gray-light border-gray-light rounded-tiny h-full text-gray-medium transition-colors',
      thButtonEnabled: 'cursor-pointer focus:bg-turquoise hover:bg-turquoise focus:border-turquoise hover:border-turquoise focus:text-white hover:text-white',
      thButtonStyle: {
        height: '1.875rem',
        width: '1.875rem'
      },
      thButtonIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx








var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }








var InputNumber_InputNumber = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputNumber, _Component);

  var _super = _createSuper(InputNumber);

  function InputNumber(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputNumber);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = Number(e.target.value);

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "decrease", function () {
      var _this$props2 = _this.props,
          _this$props2$name = _this$props2.name,
          name = _this$props2$name === void 0 ? '' : _this$props2$name,
          _this$props2$min = _this$props2.min,
          min = _this$props2$min === void 0 ? 0 : _this$props2$min,
          _this$props2$step = _this$props2.step,
          step = _this$props2$step === void 0 ? 1 : _this$props2$step,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === void 0 ? lodash["noop"] : _this$props2$onChange;
      var currentValue = _this.state.value || min;
      var decreasedValue = currentValue - step;
      var nextValue = decreasedValue >= min ? decreasedValue : min;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "increase", function () {
      var _this$props3 = _this.props,
          _this$props3$name = _this$props3.name,
          name = _this$props3$name === void 0 ? '' : _this$props3$name,
          _this$props3$min = _this$props3.min,
          min = _this$props3$min === void 0 ? 0 : _this$props3$min,
          _this$props3$max = _this$props3.max,
          max = _this$props3$max === void 0 ? 10 : _this$props3$max,
          _this$props3$step = _this$props3.step,
          step = _this$props3$step === void 0 ? 1 : _this$props3$step,
          _this$props3$onChange = _this$props3.onChange,
          onChange = _this$props3$onChange === void 0 ? lodash["noop"] : _this$props3$onChange;
      var currentValue = _this.state.value || min;
      var increasedValue = currentValue + step;
      var nextValue = increasedValue <= max ? increasedValue : max;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    _this.state = {
      value: props.value
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputNumber, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          ariaLabel = _this$props4.ariaLabel,
          autoComplete = _this$props4.autoComplete,
          className = _this$props4.className,
          dataTestId = _this$props4.dataTestId,
          hasColumnLayout = _this$props4.hasColumnLayout,
          _this$props4$id = _this$props4.id,
          id = _this$props4$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputNumber_') : _this$props4$id,
          isDisabled = _this$props4.isDisabled,
          isLoading = _this$props4.isLoading,
          isReadOnly = _this$props4.isReadOnly,
          isRequired = _this$props4.isRequired,
          label = _this$props4.label,
          attendeeType = _this$props4.attendeeType,
          _this$props4$max = _this$props4.max,
          max = _this$props4$max === void 0 ? 10 : _this$props4$max,
          _this$props4$min = _this$props4.min,
          min = _this$props4$min === void 0 ? 1 : _this$props4$min,
          name = _this$props4.name,
          notes = _this$props4.notes,
          onBlur = _this$props4.onBlur,
          onClick = _this$props4.onClick,
          onFocus = _this$props4.onFocus,
          onKeyDown = _this$props4.onKeyDown,
          onKeyUp = _this$props4.onKeyUp,
          placeholder = _this$props4.placeholder,
          step = _this$props4.step,
          theme = _this$props4.theme,
          validationState = _this$props4.validationState;
      var value = this.state.value;
      var hasValue = Boolean(value);
      var decreaseDisabled = isDisabled || isLoading || Number(value) <= min;
      var increaseDisabled = isDisabled || isLoading || Number(value) >= max;

      var _themes$theme = themes[theme]({
        hasColumnLayout: hasColumnLayout,
        hasValue: hasValue,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        validationState: validationState
      }),
          thButton = _themes$theme.thButton,
          thButtonEnabled = _themes$theme.thButtonEnabled,
          thButtonIconWidth = _themes$theme.thButtonIconWidth,
          thButtonStyle = _themes$theme.thButtonStyle,
          thInput = _themes$theme.thInput,
          thInputs = _themes$theme.thInputs,
          thLabel = _themes$theme.thLabel,
          thNotes = _themes$theme.thNotes,
          thRoot = _themes$theme.thRoot;

      return __jsx("div", {
        className: classnames_default()(className, thRoot),
        "data-testid": dataTestId
      }, !!label && __jsx("label", {
        className: thLabel,
        htmlFor: id
      }, label, !!notes && __jsx("div", {
        className: thNotes
      }, notes)), __jsx("div", {
        className: thInputs
      }, !isReadOnly && __jsx("button", {
        className: classnames_default()(thButton, Object(defineProperty["a" /* default */])({}, thButtonEnabled, !decreaseDisabled)),
        disabled: decreaseDisabled,
        onClick: this.decrease,
        style: thButtonStyle,
        type: "button",
        "data-testid": attendeeType ? "".concat(attendeeType, "DecrementButton") : 'DecrementButton'
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].MINUS,
        width: thButtonIconWidth
      })), __jsx("input", Object(esm_extends["a" /* default */])({
        "aria-label": ariaLabel,
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        id: id,
        max: max,
        min: min // $FlowFixMe

      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
      }, placeholder ? {
        placeholder: placeholder
      } : null, {
        readOnly: true,
        required: isRequired,
        step: step,
        style: {
          width: "".concat(max.toString().length + 1, "em"),
          height: '1.875em',
          lineHeight: '1.875em'
        },
        type: "number",
        value: value
      })), !isReadOnly && __jsx("button", {
        className: classnames_default()(thButton, Object(defineProperty["a" /* default */])({}, thButtonEnabled, !increaseDisabled)),
        disabled: increaseDisabled,
        onClick: this.increase,
        style: thButtonStyle,
        type: "button",
        "data-testid": attendeeType ? "".concat(attendeeType, "IncrementButton") : 'IncrementButton'
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].PLUS,
        width: thButtonIconWidth
      }))));
    }
  }]);

  return InputNumber;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputNumber_InputNumber, "defaultProps", {
  autoComplete: 'off',
  max: 10,
  min: 0,
  step: 1,
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "xXeT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return offersGridResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var offersGridResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* OFFERS_GRID */ "A"],
  resolve: function resolve(appContext) {
    var query = "query {\n      offers {\n        id name image commercialArgument timingArgument legalInformation color description href\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_OFFER_GRID */ "Ub"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "y0S3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return composeFiltersAsPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLocaleFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFlexibilityDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureDateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDurationFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getProductIdsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getOfferFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFacetsFilters; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("4+vj");
/* harmony import */ var _faceting_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("sW3P");






var FILTER_PARAM = 'filters';
function composeFiltersAsPayload() {
  for (var _len = arguments.length, filters = new Array(_len), _key = 0; _key < _len; _key++) {
    filters[_key] = arguments[_key];
  }

  var formData = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flattenDeep"])(filters).reduce(function (acc, _ref) {
    var name = _ref.name,
        value = _ref.value,
        operation = _ref.operation;
    if (value) acc.push("".concat(FILTER_PARAM, "[").concat(name, "][values][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_3___default.a.encode(value)));

    if (value && operation) {
      acc.push("".concat(FILTER_PARAM, "[").concat(name, "][operations][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_3___default.a.encode(operation)));
    }

    return acc;
  }, []);
  return formData.join('&');
}

function buildFilters(_ref2) {
  var name = _ref2.name,
      value = _ref2.value,
      operation = _ref2.operation;
  return value ? [{
    name: name,
    value: value,
    operation: operation
  }] : [];
}

function getLocaleFilters(locale) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* LOCALE_FACET_ID */ "v"],
    value: locale,
    operation: operation
  });
}
var getFlexibilityDates = function getFlexibilityDates(_ref3) {
  var departureDate = _ref3.departureDate,
      flexibility = _ref3.flexibility;

  if (!flexibility || !departureDate) {
    return {
      minDepartureDate: departureDate,
      maxDepartureDate: departureDate
    };
  }

  var minDepartureDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).subtract(flexibility, 'days');
  return {
    minDepartureDate: minDepartureDate.isAfter(moment__WEBPACK_IMPORTED_MODULE_2___default()().add(1, 'days')) ? minDepartureDate.valueOf() : moment__WEBPACK_IMPORTED_MODULE_2___default()().add(1, 'days').valueOf(),
    maxDepartureDate: moment__WEBPACK_IMPORTED_MODULE_2___default()(departureDate).add(flexibility, 'days').valueOf()
  };
};
function getDepartureDateFilters(_ref4) {
  var departureDate = _ref4.departureDate,
      _ref4$flexibility = _ref4.flexibility,
      flexibility = _ref4$flexibility === void 0 ? 0 : _ref4$flexibility,
      locale = _ref4.locale,
      _ref4$operation = _ref4.operation,
      operation = _ref4$operation === void 0 ? 'and' : _ref4$operation;

  var _getFlexibilityDates = getFlexibilityDates({
    departureDate: departureDate,
    flexibility: flexibility
  }),
      minDepartureDate = _getFlexibilityDates.minDepartureDate,
      maxDepartureDate = _getFlexibilityDates.maxDepartureDate;

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MIN_FACET_ID */ "n"],
    value: minDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_2___default()(minDepartureDate), locale),
    operation: operation
  })), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MAX_FACET_ID */ "m"],
    value: maxDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_4__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_2___default()(maxDepartureDate), locale),
    operation: operation
  })));
}
function getDepartureCityFilters(_ref5) {
  var _ref5$facets = _ref5.facets,
      facets = _ref5$facets === void 0 ? [] : _ref5$facets,
      _ref5$defaultValue = _ref5.defaultValue,
      defaultValue = _ref5$defaultValue === void 0 ? '' : _ref5$defaultValue,
      _ref5$operation = _ref5.operation,
      operation = _ref5$operation === void 0 ? 'and' : _ref5$operation;
  var departureCityFacet = Object(lodash__WEBPACK_IMPORTED_MODULE_1__["findLast"])(facets, function (_ref6) {
    var id = _ref6.id;
    return id === _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "j"];
  }) || {};
  var value = departureCityFacet.name || defaultValue;
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "j"],
    value: value,
    operation: operation
  });
}
function getDurationFilters(duration) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DURATION_FACET */ "p"],
    value: duration,
    operation: operation
  });
}

function getProductIdFilters(id) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* PRODUCT_FACET_ID */ "z"],
    value: id,
    operation: operation
  });
}

function getProductIdsFilters() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 ? arguments[1] : undefined;
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flatten"])(ids.map(function (id) {
    return getProductIdFilters(id, operation);
  }));
}
function getOfferFilters(offerId) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* OFFER_ID_FACET_ID */ "x"],
    value: offerId,
    operation: operation
  });
}
var FACETS_TO_OMIT = [_faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MIN_FACET_ID */ "n"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_DATE_MAX_FACET_ID */ "m"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DEPARTURE_CITY_FACET_ID */ "j"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* DURATION_FACET */ "p"], _faceting_constants__WEBPACK_IMPORTED_MODULE_5__[/* OFFER_ID_FACET_ID */ "x"]];
function getFacetsFilters() {
  var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  var filters = facets.filter(function (facet) {
    return !FACETS_TO_OMIT.includes(facet.id);
  }).map(function (facet) {
    return buildFilters({
      name: facet.id,
      value: facet.name,
      operation: operation
    });
  });
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["flatten"])(filters);
}

/***/ }),

/***/ "y316":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ suggest; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ search; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ searchWithFacets; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getIdsFromProducts; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/pertimm-client/filters.js
var filters = __webpack_require__("y0S3");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");

// EXTERNAL MODULE: /home/circleci/project/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/utils/pertimm-client/request.js



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var PertimmRequestFailed = error_js_default.a.create({
  name: 'PertimmRequestFailed',
  message: 'The Pertimm request failed'
});

var request_getAxiosConfig = function getAxiosConfig() {
  var proxyConfig = config_default.a.get('pertimm.proxy');
  var httpsAgent;

  if (false) {}

  return {
    httpsAgent: httpsAgent,
    proxy: httpsAgent ? false : undefined
  };
};

var START_INDEX_PARAM = 'res_sf';

function recursivePostRequest(_ref) {
  var axiosConfig = _ref.axiosConfig,
      url = _ref.url,
      payload = _ref.payload,
      queryparams = _ref.queryparams,
      acc = _ref.acc;
  return Object(axios["request"])(_objectSpread(_objectSpread({}, axiosConfig), {}, {
    method: 'POST',
    url: url,
    data: payload,
    params: queryparams
  })).then(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref2.data;

    if (!acc) acc = _objectSpread({}, data);else acc.answers = [].concat(Object(toConsumableArray["a" /* default */])(acc.answers), Object(toConsumableArray["a" /* default */])(data.answers || []));
    var nextStart = Number(data.start_answer) + Number(data.returned_answers_count) - 1;
    var hasMoreAnswers = nextStart + 1 < Number(data.available_answers_count);
    return hasMoreAnswers ? recursivePostRequest({
      axiosConfig: axiosConfig,
      url: url,
      payload: payload,
      queryparams: _objectSpread(_objectSpread({}, queryparams), {}, Object(defineProperty["a" /* default */])({}, START_INDEX_PARAM, nextStart)),
      acc: acc
    }) : acc;
  })["catch"](function () {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _error$response = error.response;
    _error$response = _error$response === void 0 ? {} : _error$response;
    var _error$response$statu = _error$response.status,
        status = _error$response$statu === void 0 ? 500 : _error$response$statu,
        _error$response$data = _error$response.data,
        data = _error$response$data === void 0 ? '' : _error$response$data;
    throw new PertimmRequestFailed({
      statusCode: status,
      errors: data
    });
  });
}

function postSearchRequest(_ref3) {
  var _objectSpread3;

  var locale = _ref3.locale,
      _ref3$payload = _ref3.payload,
      payload = _ref3$payload === void 0 ? '' : _ref3$payload,
      _ref3$queryparams = _ref3.queryparams,
      queryparams = _ref3$queryparams === void 0 ? {} : _ref3$queryparams;
  return recursivePostRequest({
    url: config_default.a.get('pertimm.apiUrl'),
    axiosConfig: request_getAxiosConfig(),
    payload: payload,
    queryparams: _objectSpread((_objectSpread3 = {
      enable_interpretation_explanation: true
    }, Object(defineProperty["a" /* default */])(_objectSpread3, START_INDEX_PARAM, 0), Object(defineProperty["a" /* default */])(_objectSpread3, "search_locale", locale), Object(defineProperty["a" /* default */])(_objectSpread3, "user_locale", locale), _objectSpread3), queryparams),
    acc: undefined
  });
}
// CONCATENATED MODULE: ./src/utils/pertimm-client/index.js





var ACTIONS = {
  WORD_WHEEL: 'wordWheel',
  PERTIMM_SEARCH: 'pertimmSearch'
};
var pertimm_client_getApiKey = Object(lodash["memoize"])(function getApiKey(appContext) {
  return config_default.a.get( // eslint-disable-next-line no-nested-ternary
  appContext.isCmta ? 'api.cm_ta_api_key' : Object(sellerUtils["g" /* isSeller */])(appContext) ? 'api.seller.api_key' : 'api.api_key');
});

function suggest(_ref) {
  var appContext = _ref.appContext,
      _ref$criteria = _ref.criteria,
      criteria = _ref$criteria === void 0 ? {} : _ref$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords = criteria.keywords,
      keywords = _criteria$keywords === void 0 ? '' : _criteria$keywords,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.WORD_WHEEL,
      max_suggests: config_default.a.get('pertimm.max_suggests'),
      enable_interpretation_explanation: 'true',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }))
  });
}

function search(_ref2) {
  var appContext = _ref2.appContext,
      _ref2$criteria = _ref2.criteria,
      criteria = _ref2$criteria === void 0 ? {} : _ref2$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords2 = criteria.keywords,
      keywords = _criteria$keywords2 === void 0 ? '' : _criteria$keywords2,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  });
}

function searchWithFacets(_ref3) {
  var _ref3$criteria = _ref3.criteria,
      criteria = _ref3$criteria === void 0 ? {} : _ref3$criteria,
      appContext = _ref3.appContext;
  var departureDate = criteria.departureDate,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: criteria.query || '',
      'contexts[boutique]': criteria.boutique,
      'contexts[screenSize]': criteria.screenSize
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale), Object(filters["b" /* getDepartureCityFilters */])({
      facets: criteria.filters,
      defaultValue: criteria.defaultDepartureCity
    }), Object(filters["d" /* getDurationFilters */])(criteria.tripDuration), Object(filters["i" /* getProductIdsFilters */])(criteria.productIds), Object(filters["e" /* getFacetsFilters */])(criteria.filters), Object(filters["h" /* getOfferFilters */])(criteria.offerId))
  });
}

function getIdsFromProducts(appContext) {
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      disable_catalogs: 1
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  }).then(function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$answers = _ref4.answers,
        answers = _ref4$answers === void 0 ? [] : _ref4$answers;

    return answers.map(function (result) {
      return Object(lodash["get"])(result, 'meta.product_id[0]');
    });
  });
}



/***/ }),

/***/ "y5Lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CNIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EMAIL_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SMS_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MAIL_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PASSPORT_ID; });
/* unused harmony export CGV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IDENTITY_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PHONE_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PROFILING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FOSUN_PARTNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PASSPORT_EXPIRATION_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PASSPORT_ISSUING_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NATIONALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLUBMED_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return THEO; });
var CNIL = 'CNIL';
var EMAIL_OPTIN = 'EMAIL_OPTIN';
var SMS_OPTIN = 'SMS_OPTIN';
var MAIL_OPTIN = 'MAIL_OPTIN';
var PASSPORT_ID = 'PASSPORT_ID';
var CGV = 'CGV';
var IDENTITY_NUMBER = 'IDENTITY_NUMBER';
var PHONE_OPTIN = 'PHONE_OPTIN';
var PROFILING = 'PROFILING';
var FOSUN_PARTNERS = 'FOSUN_PARTNERS';
var PASSPORT_EXPIRATION_DATE = 'PASSPORT_EXPIRATION_DATE';
var PASSPORT_ISSUING_DATE = 'PASSPORT_ISSUING_DATE';
var NATIONALITY = 'NATIONALITY';
var CLUBMED_PLUS = 'CLUBMED_PLUS';
var THEO = 'WEBTHEO';

/***/ }),

/***/ "yLnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return teaserCardsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");




var teaserCardsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* TEASER_CARDS */ "Bb"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common {\n          backNavigation\n          next\n          previous\n          scrollBackward\n          scrollForward\n        }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_COMMON_TEASER_CARDS */ "Ob"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    });
  }
};

/***/ }),

/***/ "yTc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tabResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");

var tabResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* TAB */ "zb"],
  props: function props() {
    return {
      header: function header(props) {
        var data = {
          title: props.title
        };

        if (props.anchor) {
          data.id = props.anchor;
        }

        if (props.icon) {
          data.iconName = props.icon;
        }

        return data;
      }
    };
  }
};

/***/ }),

/***/ "yWy0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventFormResolver; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var eventFormResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* EVENT_FORM */ "o"],
  resolve: function resolve(appContext) {
    var PRODUCT_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["constants"].PRODUCT_TYPES;
    var query = "{\n      resorts(productType: ".concat(PRODUCT_TYPES.RESORT, ") {\n        id: resortId\n        name\n        destination {\n          area\n        }\n        openingStatus\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_COMMON_EVENT_FORM */ "Fb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "ybtA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Line; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/cms/toolkit/constants.js
var constants = __webpack_require__("psNz");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx + 2 modules
var TrackingPageLoad = __webpack_require__("TVUe");

// EXTERNAL MODULE: /home/circleci/project/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/storeHelper.js
var trip_date_criteria_storeHelper = __webpack_require__("Mn1B");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 1 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/adults.action.js
var adults_action = __webpack_require__("VO7D");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/tripDateCriteria.action.js
var tripDateCriteria_action = __webpack_require__("6wD6");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.action.js
var departureDate_action = __webpack_require__("fflk");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: /home/circleci/project/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/constants.js
var kids_constants = __webpack_require__("wQ38");

// CONCATENATED MODULE: ./src/utils/trip-information/tripInformationUtils.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable flowtype/no-weak-types */






function getAdultsWithoutMainContact(adults) {
  return (adults || []).slice(1);
}

function getKidsBirthdate(kids) {
  return (kids || []).map(function (kid) {
    return Object(lodash["get"])(kid, 'birthdate');
  }).filter(Boolean) // kids may not have a birthdate
  .map(function (birthdate) {
    return moment_default()(birthdate);
  });
}

function getFormattedKidsBirthdate(kids, dateFormat) {
  return getKidsBirthdate(kids).map(function (birthdate) {
    return moment_default()(birthdate).format(dateFormat);
  });
}

function getResortInitialKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var initialKidsNumber = arguments.length > 1 ? arguments[1] : undefined;
  var isAdultOnlyResort = arguments.length > 2 ? arguments[2] : undefined;

  if (isAdultOnlyResort) {
    return [];
  }

  return Object(lodash["isEmpty"])(kids) && initialKidsNumber > -1 ? Array(initialKidsNumber).fill(_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */])) : kids;
}


// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/constants.js
var BOOKING_ENGINE_FORM_SELECTOR = '#booking';
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/constants.js
var PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME = 'PriceRemoteStickyWrapper-initialPosition';
var PRICE_REMOTE_STICKY_WRAPPER_SELECTOR = ".".concat(PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME);
var PRICE_REMOTE_FORM_ID = 'price-remote-form';
// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/client/router/withRouter.js
var withRouter = __webpack_require__("MGbB");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/resort/resortUtils.js
var resortUtils = __webpack_require__("1qsz");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 1 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineI18n.query.js
var BookingEngineI18n_query = __webpack_require__("9LZ4");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// EXTERNAL MODULE: ./src/client/components/widgets/alternative-proposals-modal/AlternativeProposalsModal.jsx
var AlternativeProposalsModal = __webpack_require__("BhBy");

// EXTERNAL MODULE: /home/circleci/project/node_modules/redux/es/redux.js
var redux = __webpack_require__("9OUN");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/departureCity.action.js
var departureCity_action = __webpack_require__("+mhw");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.action.js
var duration_action = __webpack_require__("C5R2");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/kids.action.js
var kids_action = __webpack_require__("1bWg");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-information/participants/participants.constants.js
var DEFAULT_MIN_AGE = 0;
var DEFAULT_MAX_AGE = 18;
// EXTERNAL MODULE: ./src/client/components/utils/common-validator/CommonValidators.js
var CommonValidators = __webpack_require__("cjjV");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-booking/participants.validator.js


var maxAge = CommonValidators["maxAge"],
    minAge = CommonValidators["minAge"],
    participants_validator_date = CommonValidators["date"];
var MAX_PAX = 6;
var API_DATE_FORMAT = 'YYYYMMDD';

function hasTooManyPax(adults, children) {
  return adults + children > MAX_PAX;
}

function getBirthDayErrorMessage(params) {
  var departureDate = params.departureDate,
      birthday = params.birthday,
      dateFormat = params.dateFormat,
      adultAge = params.adultAge,
      childAge = params.childAge,
      birthdayFormatErrorMessage = params.birthdayFormatErrorMessage,
      adultAgeErrorMessage = params.adultAgeErrorMessage,
      minAgeErrorMessage = params.minAgeErrorMessage;
  var onDate = departureDate ? String(departureDate) : '';
  var nowDate = moment_default()().format(API_DATE_FORMAT);
  var adultAgeValidator = maxAge({
    ageRequired: +adultAge,
    birthdayFormat: dateFormat,
    onDate: nowDate,
    onDateFormat: API_DATE_FORMAT
  });
  var maxAgeValidator = maxAge({
    ageRequired: +adultAge,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var minAgeValidator = minAge({
    ageRequired: +childAge,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var isChildBorn = minAge({
    ageRequired: 0,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var dateValidator = participants_validator_date(dateFormat);

  if (!dateValidator.isValid(birthday) || !adultAgeValidator.isValid(birthday)) {
    return birthdayFormatErrorMessage;
  }

  if (!isChildBorn.isValid(birthday)) {
    return birthdayFormatErrorMessage;
  }

  if (!maxAgeValidator.isValid(birthday)) {
    return adultAgeErrorMessage;
  }

  if (!minAgeValidator.isValid(birthday)) {
    return minAgeErrorMessage;
  }

  return '';
}

function participants_validator_checkFormErrors(params) {
  var _params$adults = params.adults,
      adults = _params$adults === void 0 ? 2 : _params$adults,
      _params$children = params.children,
      children = _params$children === void 0 ? 0 : _params$children,
      _params$departureDate = params.departureDate,
      departureDate = _params$departureDate === void 0 ? '' : _params$departureDate,
      _params$birthdays = params.birthdays,
      birthdays = _params$birthdays === void 0 ? [] : _params$birthdays,
      dateFormat = params.dateFormat,
      adultAge = params.adultAge,
      _params$childAge = params.childAge,
      childAge = _params$childAge === void 0 ? 0 : _params$childAge,
      birthdayFormatErrorMessage = params.birthdayFormatErrorMessage,
      adultAgeErrorMessage = params.adultAgeErrorMessage,
      minAgeErrorMessage = params.minAgeErrorMessage;
  var birthdaysErrorMessage = birthdays.reduce(function (errorMessage, birthday) {
    return errorMessage || getBirthDayErrorMessage({
      dateFormat: dateFormat,
      departureDate: departureDate,
      adultAge: adultAge,
      childAge: childAge,
      birthday: birthday,
      birthdayFormatErrorMessage: birthdayFormatErrorMessage,
      adultAgeErrorMessage: adultAgeErrorMessage,
      minAgeErrorMessage: minAgeErrorMessage
    });
  }, null);
  var birthdaysNotValid = birthdays.length !== children || !!birthdaysErrorMessage;
  return {
    maxPax: hasTooManyPax(+adults, +children),
    departureDate: !departureDate,
    birthdays: birthdaysNotValid,
    birthdaysErrorMessage: birthdaysErrorMessage || birthdaysNotValid && birthdayFormatErrorMessage || ''
  };
}

/* harmony default export */ var participants_validator = ({
  checkFormErrors: participants_validator_checkFormErrors
});
// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// CONCATENATED MODULE: ./src/client/components/utils/watch-location-query-change/WatchLocationQueryChange.jsx






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var WatchLocationQueryChange_WatchLocationQueryChange = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_WatchLocationQueryChange, _Component);

  var _super = _createSuper(_WatchLocationQueryChange);

  function _WatchLocationQueryChange() {
    Object(classCallCheck["a" /* default */])(this, _WatchLocationQueryChange);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(_WatchLocationQueryChange, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          location = _this$props.location,
          queryKey = _this$props.queryKey,
          onChange = _this$props.onChange;

      if (location.queryParams[queryKey]) {
        onChange(location.queryParams[queryKey]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          location = _this$props2.location,
          queryKey = _this$props2.queryKey,
          onChange = _this$props2.onChange;

      if (prevProps.location.queryParams[queryKey] !== location.queryParams[queryKey] && prevProps.location.pathname === location.pathname) {
        onChange(location.queryParams[queryKey]);
      }
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _WatchLocationQueryChange;
}(react["Component"]);

var WatchLocationQueryChange = Object(withRouter["a" /* withRouter */])(WatchLocationQueryChange_WatchLocationQueryChange);
// CONCATENATED MODULE: ./src/client/components/widgets/booking-step-title/BookingStepTitle.jsx
var __jsx = react_default.a.createElement;

var BookingStepTitle = function BookingStepTitle(_ref) {
  var number = _ref.number,
      title = _ref.title;
  return __jsx("h3", {
    className: "font-bold font-sans leading-tight mb-5 reset-heading text-xl",
    "data-selector": "BookingCriteriaStep-title--".concat(number)
  }, __jsx("span", {
    className: "rtl:mr-2 text-3xl text-blue"
  }, number, "."), title);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /home/circleci/project/node_modules/create-react-class/index.js
var create_react_class = __webpack_require__("Y3fD");
var create_react_class_default = /*#__PURE__*/__webpack_require__.n(create_react_class);

// EXTERNAL MODULE: /home/circleci/project/node_modules/react-dom/index.js
var react_dom = __webpack_require__("7nmT");
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./src/client/components/frameworks/form-field/FormField.jsx
var FormField = __webpack_require__("QPdA");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-input-tel-date/FormInputTelDate.jsx

var FormInputTelDate_jsx = react_default.a.createElement;

function FormInputTelDate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FormInputTelDate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormInputTelDate_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormInputTelDate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* DEPRECATED */







var dayDefaultStruct = {
  ref: 'day',
  stateName: 'dayValue',
  placeholderPropName: 'dayPlaceholder',
  maxLength: 2,
  onChange: null,
  placeholder: null
};
var monthDefaultStruct = {
  ref: 'month',
  stateName: 'monthValue',
  placeholderPropName: 'monthPlaceholder',
  maxLength: 2,
  onChange: null,
  placeholder: null
};
var yearDefaultStruct = {
  ref: 'year',
  stateName: 'yearValue',
  placeholderPropName: 'yearPlaceholder',
  maxLength: 4,
  onChange: null,
  placeholder: null
};
var datePatterns = [{
  key: 'd',
  struct: dayDefaultStruct
}, {
  key: 'm',
  struct: monthDefaultStruct
}, {
  key: 'y',
  struct: yearDefaultStruct
}];
var FormInputTelDate = create_react_class_default()({
  displayName: "FormInputTelDate",
  getDefaultProps: function getDefaultProps() {
    return {
      dateFormat: 'DDMMYYYY',
      dataSelector: 'FormInputTelDate',
      isActive: false,
      isDisabled: false,
      isReadOnly: false,
      isRequired: false,
      onBlur: function onBlur() {},
      onChange: function onChange() {},
      onClear: function onClear() {},
      onClick: function onClick() {},
      onKeyDown: function onKeyDown() {},
      onKeyUp: function onKeyUp() {}
    };
  },
  getInitialState: function getInitialState() {
    var formattedDate = moment_default()(this.props.value, this.props.dateFormat);
    return this.props.value && formattedDate.isValid() ? {
      dayValue: formattedDate.format('DD'),
      monthValue: formattedDate.format('MM'),
      yearValue: formattedDate.format('YYYY')
    } : {
      dayValue: '',
      monthValue: '',
      yearValue: ''
    };
  },
  areAllInputsFilled: function areAllInputsFilled() {
    return this.state.dayValue.length === dayDefaultStruct.maxLength && this.state.monthValue.length === monthDefaultStruct.maxLength && this.state.yearValue.length === yearDefaultStruct.maxLength;
  },
  getFormattedDate: function getFormattedDate() {
    if (Object(lodash["isEmpty"])(this.state.yearValue) && Object(lodash["isEmpty"])(this.state.monthValue) && Object(lodash["isEmpty"])(this.state.dayValue)) {
      return '';
    }

    return this.areAllInputsFilled() ? moment_default()([+this.state.yearValue, +this.state.monthValue - 1, +this.state.dayValue]).format(this.props.dateFormat) : moment_default.a.invalid().toString();
  },
  handleChange: function handleChange(value, event, nextInput, maxLength) {
    var _this = this;

    this.setState(Object(defineProperty["a" /* default */])({}, value, event.target.value), function () {
      _this.props.onChange(_this.getFormattedDate());
    });

    if (nextInput && maxLength && event.target.value.length === maxLength) {
      react_dom_default.a.findDOMNode(nextInput).focus();
    }
  },
  handleBlur: function handleBlur(value, event, nextInput) {
    if (!nextInput || Object(lodash["get"])(event, 'relatedTarget.className', '').indexOf('FormInputTelDate-input') === -1) {
      this.props.onBlur(this.getFormattedDate());
    }
  },
  getHandleChangeFunction: function getHandleChangeFunction(field, nextRef, maxLength) {
    var _this2 = this;

    return function (event) {
      return _this2.handleChange(field, event, nextRef, maxLength);
    };
  },
  getHandleBlurFunction: function getHandleBlurFunction(field, nextRef) {
    var _this3 = this;

    return function (event) {
      return _this3.handleBlur(field, event, nextRef);
    };
  },
  buildFormatStructure: function buildFormatStructure(_ref, index, patterns) {
    var struct = _ref.struct,
        size = _ref.size;
    var nextRef = index + 1 < patterns.length ? Object(lodash["get"])(this.refs, patterns[index + 1].struct.ref) : null;
    return FormInputTelDate_objectSpread(FormInputTelDate_objectSpread({}, struct), {}, {
      id: "".concat(this.props.id, "-").concat(index),
      maxLength: size,
      onChange: this.getHandleChangeFunction(struct.stateName, nextRef, size),
      onBlur: this.getHandleBlurFunction(struct.stateName, nextRef),
      placeholder: Object(lodash["get"])(this.props, struct.placeholderPropName)
    });
  },
  getPatternPos: function getPatternPos(dateFormat) {
    return function (datePattern) {
      return FormInputTelDate_objectSpread(FormInputTelDate_objectSpread({}, datePattern), {}, {
        pos: dateFormat.indexOf(datePattern.key)
      });
    };
  },
  getPatternSize: function getPatternSize(dateFormat) {
    return function (datePattern) {
      return FormInputTelDate_objectSpread(FormInputTelDate_objectSpread({}, datePattern), {}, {
        size: (dateFormat.match(new RegExp(datePattern.key, 'g')) || []).length
      });
    };
  },
  getDateStructure: function getDateStructure(dateFormat) {
    return Object(lodash["sortBy"])(datePatterns.map(this.getPatternPos(dateFormat)), ['pos']).map(this.getPatternSize(dateFormat)).map(this.buildFormatStructure);
  },
  render: function render() {
    var _this4 = this;

    var structures = this.getDateStructure(this.props.dateFormat.toLowerCase());
    return FormInputTelDate_jsx("div", {
      className: "flex items-center text-base w-full",
      "data-selector": this.props.dataSelector,
      onFocus: this.props.onFocus ? this.props.onFocus : null
    }, structures.map(function (structure, index) {
      return FormInputTelDate_jsx("div", {
        className: "decorator-slash-separator flex flex-1 items-center",
        key: "".concat(_this4.state[structure.id], "-").concat(index)
      }, FormInputTelDate_jsx("input", {
        className: classnames_default()('reset-input bg-transparent text-center w-full', {
          'cursor-not-allowed': _this4.props.isDisabled,
          'cursor-progress': _this4.props.isLoading && !_this4.props.isDisabled
        }),
        disabled: _this4.props.isDisabled,
        id: _this4.state[structure.id],
        maxLength: structure.maxLength,
        onBlur: structure.onBlur,
        onChange: structure.onChange,
        placeholder: structure.placeholder,
        ref: structure.ref,
        style: {
          height: _this4.props.height
        },
        type: "tel",
        value: _this4.state[structure.stateName]
      }));
    }));
  }
});
/* harmony default export */ var form_input_tel_date_FormInputTelDate = (Object(FormField["a" /* default */])(FormInputTelDate));
// CONCATENATED MODULE: ./src/utils/immutability/immutability.js


function immutability_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function immutability_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      immutability_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      immutability_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function updateArrayIndexFp(array, index, updater) {
  // $FlowFixMe
  return Object.values(immutability_objectSpread(immutability_objectSpread({}, array), {}, Object(defineProperty["a" /* default */])({}, index, updater(array[index]))));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-validator-hoc/FormValidator.jsx








function FormValidator_createSuper(Derived) { var hasNativeReflectConstruct = FormValidator_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function FormValidator_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function FormValidator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FormValidator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormValidator_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormValidator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable flowtype/no-weak-types */





function _isFormValid(fields) {
  return fields.every(function (field) {
    return field.validationState === validationStates["b" /* IS_VALID */];
  });
}

function _isFieldValid(field) {
  var fieldValidators = Object(lodash["get"])(field, 'validators') || [];
  return !Object(lodash["isEmpty"])(fieldValidators) ? fieldValidators.every(function (validator) {
    return validator.isValid(field.value);
  }) : true;
}

function _setFieldValidationState(field) {
  if (Object(lodash["isEmpty"])(Object(lodash["get"])(field, 'validators'))) {
    return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
      validationState: validationStates["b" /* IS_VALID */]
    });
  }

  if (!field.value) {
    return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
      validationState: _isFieldValid(field) ? validationStates["b" /* IS_VALID */] : validationStates["c" /* NOT_VALIDATED */]
    });
  }

  return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
    validationState: _isFieldValid(field) ? validationStates["b" /* IS_VALID */] : validationStates["a" /* IS_INVALID */]
  });
}

var FormValidator_FormValidator = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(FormValidator, _React$Component);

  var _super = FormValidator_createSuper(FormValidator);

  function FormValidator(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, FormValidator);

    _this = _super.call(this, props);
    var formFields = _this.getFields(_this.props) || [];
    _this.state = FormValidator_objectSpread(FormValidator_objectSpread({}, _this.state), {}, {
      fields: formFields.map(function (field) {
        return _setFieldValidationState(field);
      })
    });
    Object(assertThisInitialized["a" /* default */])(_this).setFieldsInState = _this.setFieldsInState.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).isFormSubmittable = _this.isFormSubmittable.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).isFieldValid = _this.isFieldValid.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).onSubmit = _this.onSubmit.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).updateFieldValue = _this.updateFieldValue.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).validateFields = _this.validateFields.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).getFieldByName = _this.getFieldByName.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).getFieldValueByName = _this.getFieldValueByName.bind(Object(assertThisInitialized["a" /* default */])(_this));
    return _this;
  }

  Object(createClass["a" /* default */])(FormValidator, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!Object(lodash["isEqual"])(this.props, prevProps)) {
        this.setFieldsInState(this.props);
      }
    }
  }, {
    key: "setFieldsInState",
    value: function setFieldsInState(props) {
      var formFields = this.getFields(props) || [];
      this.setState({
        fields: formFields.map(function (field) {
          return _setFieldValidationState(field);
        })
      });
    }
    /**
     * getFields has to be implemented by the inherited form class
     *
     * @param props (the props used to get/calculate the form fields)
     * @returns the list of form fields
     *
     * const someValidFormField = {
     *    name : a string to eventually identify the field
     *    value : anything
     *    validators : a list of validators to validate the field
     *        -> ex: utils/common-validator/CommonValidators
     * }
     */
    // eslint-disable-next-line no-unused-vars

  }, {
    key: "getFields",
    value: function getFields(props) {
      return [];
    }
  }, {
    key: "validateFields",
    value: function validateFields(callback) {
      var fieldsWithValidation = this.state.fields.map(_setFieldValidationState);
      this.setState({
        fields: fieldsWithValidation
      }, callback);
      return fieldsWithValidation;
    }
  }, {
    key: "updateFieldValue",
    value: function updateFieldValue(fieldName, options, callback) {
      var _this2 = this;

      return function (newFieldValue) {
        var indexToUpdate = Object(lodash["findIndex"])(_this2.state.fields, {
          name: fieldName
        });
        var newFields = updateArrayIndexFp(_this2.state.fields, indexToUpdate, function (field) {
          return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
            value: newFieldValue
          });
        });

        _this2.setState({
          fields: newFields
        }, function () {
          return Object(lodash["get"])(options, 'validate') ? _this2.validateFields(callback) : callback;
        });
      };
    }
  }, {
    key: "updateFieldsValue",
    value: function updateFieldsValue(keyValues, options, callback) {
      var _this3 = this;

      var newFields = keyValues.reduce(function (updatedFields, _ref) {
        var fieldName = _ref.fieldName,
            value = _ref.value;
        var indexToUpdate = Object(lodash["findIndex"])(updatedFields, {
          name: fieldName
        });
        return updateArrayIndexFp(updatedFields, indexToUpdate, function (field) {
          return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
            name: fieldName,
            value: value
          });
        });
      }, this.state.fields);
      this.setState({
        fields: newFields
      }, function () {
        return Object(lodash["get"])(options, 'validate') ? _this3.validateFields(callback) : callback;
      });
    }
  }, {
    key: "isFormSubmittable",
    value: function isFormSubmittable(callback) {
      return Object(lodash["flow"])(this.validateFields, _isFormValid)(callback);
    }
  }, {
    key: "isFieldValid",
    value: function isFieldValid(field) {
      return _isFieldValid(field);
    }
  }, {
    key: "isFormValid",
    value: function isFormValid() {
      return _isFormValid(this.state.fields);
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      return this.isFormSubmittable() && this.props.onSubmit(this.state.fields);
    }
  }, {
    key: "getFieldByName",
    value: function getFieldByName(fieldName) {
      return Object(lodash["get"])(this.state, 'fields', []).find(function (field) {
        return field.name === fieldName;
      });
    }
  }, {
    key: "getFieldValueByName",
    value: function getFieldValueByName(fieldName) {
      var formField = Object(lodash["get"])(this.state, 'fields', []).find(function (field) {
        return field.name === fieldName;
      });
      return Object(lodash["get"])(formField, 'value');
    }
  }]);

  return FormValidator;
}(react["Component"]);

/* harmony default export */ var form_validator_hoc_FormValidator = (FormValidator_FormValidator);
// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx + 1 modules
var InputNumber = __webpack_require__("xGYs");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-information/participants/Participants.jsx







var Participants_jsx = react_default.a.createElement;

function Participants_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Participants_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Participants_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Participants_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Participants_createSuper(Derived) { var hasNativeReflectConstruct = Participants_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Participants_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }












var Participants_Participants = /*#__PURE__*/function (_FormValidator) {
  Object(inherits["a" /* default */])(Participants, _FormValidator);

  var _super = Participants_createSuper(Participants);

  function Participants() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Participants);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onAdultsNumberChange", function (_, value) {
      _this.props.setAdultsNumber(value);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKidsNumberChange", function (_, value) {
      var kids = Array(value).fill(undefined).map(function (kid, i) {
        if (_this.props.kids[i]) return _this.props.kids[i];
        return kid;
      });

      var kidsValidations = _this.state.fields.map(function (_ref) {
        var validationState = _ref.validationState;
        return validationState;
      });

      _this.props.setKids({
        kids: kids,
        kidsValidations: kidsValidations
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleKids", function (idx) {
      return function (value) {
        var kidsValidations = _this.validateFields().map(function (kidsValidation) {
          return kidsValidation.validationState;
        });

        var kids = _this.props.kids.map(function (kid, index) {
          return idx !== index ? kid : Participants_objectSpread(Participants_objectSpread({}, kid), {}, {
            birthdate: moment_default()(value, _this.props.dateFormat).valueOf()
          });
        });

        _this.props.setKids({
          kids: kids,
          kidsValidations: kidsValidations
        });
      };
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Participants, [{
    key: "getFields",
    value: function getFields(props) {
      var _this2 = this;

      var dateFormat = props.dateFormat,
          kids = props.kids,
          _props$adultAge = props.adultAge,
          adultAge = _props$adultAge === void 0 ? DEFAULT_MAX_AGE : _props$adultAge,
          _props$childAge = props.childAge,
          childAge = _props$childAge === void 0 ? DEFAULT_MIN_AGE : _props$childAge,
          departureDate = props.departureDate;
      return kids.map(function (kid, idx) {
        var birthdate = _this2.getKidBirthdate(idx);

        var adultAgeInYear = +adultAge;
        var childAgeInYear = +childAge / 12;
        var params = {
          birthdayFormat: dateFormat,
          onDate: departureDate,
          onDateFormat: 'YYYYMMDD'
        };
        return {
          name: "birthdate.".concat(idx),
          value: birthdate,
          validators: [Object(CommonValidators["maxAge"])(Participants_objectSpread(Participants_objectSpread({}, params), {}, {
            ageRequired: adultAgeInYear
          })), Object(CommonValidators["minAge"])(Participants_objectSpread(Participants_objectSpread({}, params), {}, {
            ageRequired: childAgeInYear
          }))]
        };
      });
    }
  }, {
    key: "getKidBirthdate",
    value: function getKidBirthdate(idx) {
      var birthdate = Object(lodash["get"])(this.props.kids[idx], 'birthdate');
      return Object(lodash["get"])(this.state, "fields.".concat(idx, ".value")) || (birthdate ? moment_default()(birthdate).format(this.props.dateFormat) : '');
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          adultsLabel = _this$props.adultsLabel,
          adultsNumber = _this$props.adultsNumber,
          childrenBirthdayDateFormatPlaceholder = _this$props.childrenBirthdayDateFormatPlaceholder,
          kids = _this$props.kids,
          kidsAgeLimit = _this$props.kidsAgeLimit,
          kidsLabel = _this$props.kidsLabel,
          minAgeInformation = _this$props.minAgeInformation;
      return Participants_jsx(react["Fragment"], null, Participants_jsx("div", {
        className: "flex flex-col md:flex-row md:items-start -mx-5"
      }, Participants_jsx("div", {
        className: "pb-5 px-5 md:w-1/2"
      }, Participants_jsx("div", {
        className: "bg-white flex flex-col md:flex-row justify-between px-5 py-px10 rounded-tiny"
      }, Participants_jsx(InputNumber["a" /* InputNumber */], {
        className: "my-px10 mx-3",
        dataTestId: "ParticipantsAdultsSelect",
        min: 1,
        max: 7,
        step: 1,
        value: adultsNumber,
        label: adultsLabel,
        onChange: this.onAdultsNumberChange,
        attendeeType: "adults"
      }), !this.props.adultOnly && Participants_jsx(InputNumber["a" /* InputNumber */], {
        className: "mx-3 my-3",
        dataTestId: "ParticipantsChildrenSelect",
        min: 0,
        max: 7,
        step: 1,
        value: kids.length,
        label: kidsLabel,
        notes: kidsAgeLimit,
        onChange: this.onKidsNumberChange,
        attendeeType: "kids"
      })), minAgeInformation && kids.length > 0 && Participants_jsx("div", {
        className: "flex items-center md:justify-end font-sans mt-2 text-blue text-xs",
        "data-selector": "ParticipantsKidsAgeMessage"
      }, Participants_jsx(Icon["a" /* Icon */], {
        className: "rtl:mr-2",
        name: icons["a" /* ICONS */].SMALL_WARNING,
        size: "1rem"
      }), minAgeInformation)), kids.length > 0 && Participants_jsx("div", {
        className: "pb-5 px-5 md:w-1/2"
      }, Participants_jsx("ul", {
        className: "reset-list md:flex md:flex-wrap md:-m-px10"
      }, Array.from({
        length: this.props.kids.length
      }).map(function (child, idx) {
        var label = Object(dist["messageFormat"])(childrenBirthdayDateFormatPlaceholder).format({
          childIndex: "".concat(idx + 1)
        });

        var birthdate = _this3.getKidBirthdate(idx);

        var _get = Object(lodash["get"])(_this3.state, "fields.".concat(idx), {}),
            validationState = _get.validationState;

        return Participants_jsx("li", {
          className: "mb-5 md:mb-0 last-child-mb-0 md:p-px10 md:w-1/2",
          key: idx
        }, Participants_jsx(form_input_tel_date_FormInputTelDate, {
          dateFormat: _this3.props.dateFormat,
          dayPlaceholder: _this3.props.dayPlaceholder,
          id: "birthday".concat(idx),
          label: label,
          monthPlaceholder: _this3.props.monthPlaceholder,
          yearPlaceholder: _this3.props.yearPlaceholder,
          onBlur: _this3.handleKids(idx),
          onChange: _this3.updateFieldValue("birthdate.".concat(idx)),
          value: birthdate,
          isRequired: true,
          validationState: validationState
        }));
      })))));
    }
  }]);

  return Participants;
}(form_validator_hoc_FormValidator);

Object(defineProperty["a" /* default */])(Participants_Participants, "defaultProps", {
  kids: []
});
// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-booking/participantsErrors.jsx
var participantsErrors_jsx = react_default.a.createElement;


var participantsErrors_ParticipantsErrors = function ParticipantsErrors(_ref) {
  var className = _ref.className,
      config = _ref.config,
      errors = _ref.errors,
      isSubmitted = _ref.isSubmitted;
  var maxPax = errors.maxPax,
      departureDate = errors.departureDate,
      birthdays = errors.birthdays,
      birthdaysErrorMessage = errors.birthdaysErrorMessage;

  if (maxPax) {
    return participantsErrors_jsx(FormFeedback["a" /* FormFeedback */], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: config.errorMaxGuestsLabel
    });
  }

  if (isSubmitted && departureDate) {
    return participantsErrors_jsx(FormFeedback["a" /* FormFeedback */], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: config.departureDateErrorMessage
    });
  }

  if (isSubmitted && birthdays) {
    return participantsErrors_jsx(FormFeedback["a" /* FormFeedback */], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: birthdaysErrorMessage
    });
  }

  return null;
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.jsx + 1 modules
var InputSelect = __webpack_require__("oWz2");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-information/departure-city/DepartureCities.jsx
var DepartureCities_jsx = react_default.a.createElement;




var defaultProps = {
  departureCities: [],
  departureCity: '',
  setDepartureCity: lodash["noop"],
  title: '',
  dataTestId: 'BookingOptionsDepartureCities'
};
var DepartureCities_DepartureCities = function DepartureCities(_ref) {
  var dataTestId = _ref.dataTestId,
      departureCities = _ref.departureCities,
      departureCity = _ref.departureCity,
      setDepartureCity = _ref.setDepartureCity;

  var getDepartureCitiesOptions = function getDepartureCitiesOptions() {
    return departureCities.map(function (departureCityToMap) {
      return {
        value: departureCityToMap === null || departureCityToMap === void 0 ? void 0 : departureCityToMap.value,
        label: (departureCityToMap === null || departureCityToMap === void 0 ? void 0 : departureCityToMap.name) || ''
      };
    });
  };

  var handleChange = function handleChange(name, value) {
    setDepartureCity(value);
  };

  return DepartureCities_jsx(InputSelect["a" /* InputSelect */], {
    bgTransparent: true,
    dataTestId: dataTestId,
    hasNoField: true,
    iconLeft: icons["a" /* ICONS */].TRANSPORT,
    mediumText: true,
    onChange: handleChange,
    options: getDepartureCitiesOptions(),
    size: "large",
    value: departureCity
  });
};
DepartureCities_DepartureCities.defaultProps = defaultProps;
// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/TransportCriteria.jsx

var TransportCriteria_jsx = react_default.a.createElement;







var TransportCriteria_TransportCriteria = function TransportCriteria(_ref) {
  var departureCities = _ref.departureCities,
      departureCity = _ref.departureCity;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var changeDepartureCity = function changeDepartureCity(value) {
    var uri = Object(uriUtils["c" /* convertLocationToURI */])(location);
    var searchPageUrl = uri.clone().setQuery(Object(defineProperty["a" /* default */])({}, uri_constants["k" /* QUERY_TRANSPORT */], value));
    redirectUtils["a" /* default */].redirectTo()(searchPageUrl, {
      shallow: true
    });
  };

  return TransportCriteria_jsx(DepartureCities_DepartureCities, {
    dataTestId: "BookingOptionsDepartureCities",
    departureCities: departureCities,
    departureCity: departureCity,
    setDepartureCity: changeDepartureCity,
    title: Object(src_i18n["f" /* t */])('booking.form.transportFrom')
  });
};
// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx + 1 modules
var SeeMore = __webpack_require__("NPTU");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/ReassuranceBlock.jsx
var ReassuranceBlock_jsx = react_default.a.createElement;






var ReassuranceBlock_ReassuranceBlock = function ReassuranceBlock(_ref) {
  var items = _ref.items;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var TagName = isTablet ? react["Fragment"] : SeeMore["a" /* SeeMore */];
  var seeMoreProps = isTablet ? null : {
    classNameButton: 'rtl:text-right',
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: !isTablet,
    seeLessLabel: Object(src_i18n["f" /* t */])('common.loadLess'),
    seeMoreLabel: Object(src_i18n["f" /* t */])('common.loadMore'),
    seeMoreSize: 110,
    theme: 'gray'
  };
  return ReassuranceBlock_jsx(TagName, seeMoreProps, ReassuranceBlock_jsx("div", {
    className: "border-1 border-blue font-sans rounded-tiny p-px10"
  }, ReassuranceBlock_jsx("div", {
    className: "text-sm md:text-md text-blue font-bold"
  }, Object(src_i18n["f" /* t */])('booking.form.reinsuranceTitle')), ReassuranceBlock_jsx("div", {
    className: "text-xs md:text-base"
  }, Object(src_i18n["f" /* t */])('booking.form.reinsuranceSubtitle')), items.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label;
    return ReassuranceBlock_jsx("span", {
      key: iconName,
      className: "flex items-center max-w-full overflow-hidden pt-2 text-xs md:text-base text-gray-darker"
    }, ReassuranceBlock_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-4 flex-shrink-0",
      color: colors["a" /* COLORS */].BLUE,
      name: iconName,
      width: "1.25rem"
    }), label);
  }), ReassuranceBlock_jsx("div", {
    className: "pt-2 text-xs md:text-sm text-gray-dark"
  }, Object(src_i18n["f" /* t */])('booking.form.reinsuranceLegalMentions'))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/BookingCriteria.jsx









var BookingCriteria_jsx = react_default.a.createElement;

function BookingCriteria_createSuper(Derived) { var hasNativeReflectConstruct = BookingCriteria_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function BookingCriteria_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





























var BookingCriteria_BookingCriteriaComponent = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(BookingCriteriaComponent, _React$Component);

  var _super = BookingCriteria_createSuper(BookingCriteriaComponent);

  function BookingCriteriaComponent() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, BookingCriteriaComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      departureDate: _this.props.departureDate,
      tripDurationCriteria: _this.props.tripDurationCriteria,
      isLoading: false,
      hasCheckedPrice: false
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleChange", function (action) {
      return function (payload) {
        _this.setState({
          hasCheckedPrice: false
        }, function () {
          return action(payload);
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleCheckPrice", function () {
      var haveError = Object(lodash["values"])(_this.checkFormErrors()).some(function (error) {
        return error;
      });

      if (!haveError) {
        return _this.props.getPackages(_this.props.departureDate);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSubmit", function () {
      if (_this.props.isDepartureDateAvailaible) {
        _this.setState({
          hasCheckedPrice: true
        }, _this.handleCheckPrice);
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(BookingCriteriaComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          adultOnly = _this$props.adultOnly,
          kids = _this$props.tripInformation.kids;

      if (adultOnly && kids.length) {
        this.props.resetKids();
      }
    }
  }, {
    key: "checkFormErrors",
    value: function checkFormErrors() {
      var dateFormat = Object(lodash["get"])(this.props, 'i18n.dateFormat', 'DD/MM/YYYY');
      var birthdays = getFormattedKidsBirthdate(this.props.kids, dateFormat);
      var adultAgeInYear = +Object(lodash["get"])(this.props, 'i18n.adultAge', DEFAULT_MAX_AGE);
      var childAge = typeof this.props.childAge === 'number' ? this.props.childAge : DEFAULT_MIN_AGE;
      var childAgeInYear = childAge / 12;
      var _this$props2 = this.props,
          _this$props2$adultsNu = _this$props2.adultsNumber,
          adultsNumber = _this$props2$adultsNu === void 0 ? 0 : _this$props2$adultsNu,
          kids = _this$props2.kids,
          _this$props2$departur = _this$props2.departureDate,
          departureDate = _this$props2$departur === void 0 ? '' : _this$props2$departur,
          tripDurationCriteria = _this$props2.tripDurationCriteria;
      return participants_validator.checkFormErrors({
        adults: adultsNumber,
        children: kids.length,
        departureDate: tripDurationCriteria ? departureDate : null,
        birthdays: birthdays,
        dateFormat: dateFormat,
        adultAge: adultAgeInYear,
        childAge: childAgeInYear,
        birthdayFormatErrorMessage: Object(lodash["get"])(this.props, 'i18n.birthdayFormatErrorMessage'),
        adultAgeErrorMessage: Object(lodash["get"])(this.props, 'i18n.adultAgeErrorMessage'),
        minAgeErrorMessage: Object(lodash["get"])(this.props, 'i18n.minAgeErrorMessage')
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _i18n$bookingCriteria,
          _this2 = this,
          _i18n$booking,
          _i18n$booking$form,
          _this$props$i18n,
          _this$props$i18n2,
          _this$props$bookingCo,
          _this$props$bookingCo2,
          _this$props$resort,
          _this$props$i18n3;

      var i18n = this.props.i18n;
      var departureCities = (i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingCriteria = i18n.bookingCriteria) === null || _i18n$bookingCriteria === void 0 ? void 0 : _i18n$bookingCriteria.departureCities) || [];
      var withTransport = departureCities.some(function (_ref) {
        var value = _ref.value;
        return value !== 'NO';
      });
      return BookingCriteria_jsx(react["Fragment"], null, BookingCriteria_jsx(WatchLocationQueryChange, {
        queryKey: uri_constants["g" /* QUERY_DURATION */],
        onChange: function onChange(value) {
          return value && _this2.props.setDuration(parseInt(value, 10) || duration_constants["a" /* DEFAULT_NO_DURATION */]);
        }
      }), withTransport && BookingCriteria_jsx(react["Fragment"], null, BookingCriteria_jsx(WatchLocationQueryChange, {
        queryKey: uri_constants["k" /* QUERY_TRANSPORT */],
        onChange: function onChange(value) {
          return value && _this2.props.setDepartureCity({
            value: value
          });
        }
      }), BookingCriteria_jsx(BookingStepTitle, {
        number: 1,
        title: Object(src_i18n["f" /* t */])('booking.form.transportFrom')
      }), BookingCriteria_jsx("div", {
        className: "md:flex mb-5 md:mb-8"
      }, BookingCriteria_jsx("div", {
        className: "mb-5 md:mb-0 md:flex-1"
      }, BookingCriteria_jsx(TransportCriteria_TransportCriteria, {
        departureCities: departureCities,
        departureCity: this.props.departureCity
      }), BookingCriteria_jsx(Text["a" /* Text */], {
        className: "hidden md:block md:mt-8 px-1",
        text: Object(src_i18n["f" /* t */])('bookingConfig.form.legalNotice'),
        theme: "text-sans-2"
      })), BookingCriteria_jsx("div", {
        className: "md:flex-2 md:rtl:ml-24"
      }, BookingCriteria_jsx(ReassuranceBlock_ReassuranceBlock, {
        items: (i18n === null || i18n === void 0 ? void 0 : (_i18n$booking = i18n.booking) === null || _i18n$booking === void 0 ? void 0 : (_i18n$booking$form = _i18n$booking.form) === null || _i18n$booking$form === void 0 ? void 0 : _i18n$booking$form.items) || []
      }), BookingCriteria_jsx(Text["a" /* Text */], {
        className: "md:hidden mt-5",
        text: Object(src_i18n["f" /* t */])('bookingConfig.form.legalNotice'),
        theme: "text-sans-2"
      })))), BookingCriteria_jsx(BookingStepTitle, {
        number: withTransport ? 2 : 1,
        title: Object(src_i18n["f" /* t */])('booking.form.resortCriteriaDatesSelectionTitle')
      }), react["Children"].map(this.props.children, function (child) {
        return /*#__PURE__*/Object(react["cloneElement"])(child, {
          handleChange: _this2.handleChange
        });
      }), this.props.isWinterResort && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('booking.reinsuranceSkiPass') && BookingCriteria_jsx(Notification["a" /* Notification */], {
        className: "mb-10",
        color: colors["a" /* COLORS */].GRENADINE,
        hasBorder: true,
        text: (_this$props$i18n = this.props.i18n) === null || _this$props$i18n === void 0 ? void 0 : _this$props$i18n.skiPassIncludedDescription,
        title: (_this$props$i18n2 = this.props.i18n) === null || _this$props$i18n2 === void 0 ? void 0 : _this$props$i18n2.skiPassIncludedLabel
      }), BookingCriteria_jsx(BookingStepTitle, {
        number: withTransport ? 3 : 2,
        title: (_this$props$bookingCo = this.props.bookingConfig) === null || _this$props$bookingCo === void 0 ? void 0 : (_this$props$bookingCo2 = _this$props$bookingCo.form) === null || _this$props$bookingCo2 === void 0 ? void 0 : _this$props$bookingCo2.guestCriteriaTitle
      }), BookingCriteria_jsx(Participants_Participants, {
        dateFormat: Object(lodash["get"])(this.props, 'i18n.dateFormat'),
        dayPlaceholder: Object(lodash["get"])(this.props, 'i18n.dayPlaceholder'),
        monthPlaceholder: Object(lodash["get"])(this.props, 'i18n.monthPlaceholder'),
        yearPlaceholder: Object(lodash["get"])(this.props, 'i18n.yearPlaceholder'),
        adultOnly: this.props.adultOnly,
        childrenBirthdayDateFormatPlaceholder: Object(lodash["get"])(this.props, 'i18n.childrenBirthdayDateFormatPlaceholder', ''),
        setKids: this.handleChange(function (_ref2) {
          var kids = _ref2.kids,
              kidsValidations = _ref2.kidsValidations;
          Object(es["b" /* batch */])(function () {
            _this2.props.setKids(kids);

            _this2.props.setKidsValidationState(kidsValidations);
          });
        }),
        setAdultsNumber: this.handleChange(this.props.setAdultsNumber),
        kids: this.props.kids,
        adultsNumber: this.props.adultsNumber,
        selectAdultsLabels: Object(lodash["get"])(this.props, 'i18n.selectAdultsLabels'),
        selectChildrenLabels: Object(lodash["get"])(this.props, 'i18n.selectChildrenLabels'),
        minAgeInformation: Object(lodash["get"])(this.props, 'i18n.minAgeInformation'),
        adultAge: Object(lodash["get"])(this.props, 'i18n.adultAge'),
        childAge: Object(lodash["get"])(this.props, 'childAge'),
        departureDate: Object(lodash["get"])(this.props, 'departureDate'),
        kidsLabel: Object(lodash["get"])(this.props, 'i18n.common.participants.kidsLabel'),
        adultsLabel: Object(lodash["get"])(this.props, 'i18n.common.participants.adultsLabel'),
        kidsAgeLimit: Object(lodash["get"])(this.props, 'i18n.common.participants.kidsAgeLimit')
      }), ((_this$props$resort = this.props.resort) === null || _this$props$resort === void 0 ? void 0 : _this$props$resort.isResort) && this.props.kids.length > 0 && BookingCriteria_jsx("div", {
        className: "mb-5 md:pr-5 md:w-1/2"
      }, BookingCriteria_jsx(Notification["a" /* Notification */], {
        color: colors["a" /* COLORS */].GRENADINE,
        hasBorder: true,
        text: "**".concat(this.props.i18n.didYouKnowLabel, "** ").concat(this.props.i18n.kidStayIncludedDescription),
        title: (_this$props$i18n3 = this.props.i18n) === null || _this$props$i18n3 === void 0 ? void 0 : _this$props$i18n3.kidStayIncludedLabel
      })), BookingCriteria_jsx(participantsErrors_ParticipantsErrors, {
        className: "justify-end",
        config: Object(lodash["pick"])(this.props.config.booking.form, ['errorMaxGuestsLabel', 'departureDateErrorMessage']),
        errors: this.checkFormErrors(),
        isSubmitted: this.state.hasCheckedPrice
      }), BookingCriteria_jsx("section", {
        className: "rtl:text-right"
      }, BookingCriteria_jsx(Button["a" /* Button */], {
        className: "uppercase w-full",
        colorBg: colors["a" /* COLORS */].BOOKING,
        colorBorder: colors["a" /* COLORS */].BOOKING,
        dataTestId: "BookingCriteria-checkPrice",
        iconRight: {
          name: icons["a" /* ICONS */].ARROW_FORTH
        },
        isDisabled: this.state.isLoading,
        onClick: this.onSubmit,
        size: "large",
        style: {
          maxWidth: 360
        }
      }, i18n === null || i18n === void 0 ? void 0 : i18n.checkPriceLabel)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref3, prevState) {
      var departureDate = _ref3.departureDate,
          tripDurationCriteria = _ref3.tripDurationCriteria;

      if (departureDate !== prevState.departureDate || tripDurationCriteria !== prevState.tripDurationCriteria) {
        return {
          departureDate: departureDate,
          hasCheckedPrice: false,
          tripDurationCriteria: tripDurationCriteria
        };
      }

      return null;
    }
  }]);

  return BookingCriteriaComponent;
}(react_default.a.Component); // $FlowFixMe


Object(defineProperty["a" /* default */])(BookingCriteria_BookingCriteriaComponent, "contextType", ReactAppContext["a" /* default */]);

Object(defineProperty["a" /* default */])(BookingCriteria_BookingCriteriaComponent, "defaultProps", {
  i18n: {},
  isWinterResort: false,
  adultsNumber: 2,
  childAge: 0,
  isJoyView: false,
  isTransportEnabled: false,
  kids: [],
  departureCity: '',
  duration: 7,
  productId: '',
  // $FlowFixMe
  setKids: lodash["noop"],
  // $FlowFixMe
  setKidsValidationState: lodash["noop"],
  // $FlowFixMe
  setAdultsNumber: lodash["noop"],
  setDuration: lodash["noop"],
  // $FlowFixMe
  setDepartureCity: lodash["noop"],
  dataSelector: 'BookingCriteria'
});

var BookingCriteria_BookingCriteria = function BookingCriteria(_ref4) {
  var myRef = _ref4.myRef,
      otherProps = Object(objectWithoutProperties["a" /* default */])(_ref4, ["myRef"]);

  return BookingCriteria_jsx(BookingCriteria_BookingCriteriaComponent, Object(esm_extends["a" /* default */])({
    ref: myRef
  }, otherProps));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/BookingCriteria.container.jsx













var mapDispatchToProps = {
  resetKids: kids_action["a" /* resetKids */],
  setKidsValidationState: facetingSearch_action["n" /* setKidsValidationState */],
  setAdultsNumber: adults_action["b" /* setAdultsNumber */],
  setDepartureCity: departureCity_action["a" /* setDepartureCity */],
  setDepartureDate: departureDate_action["a" /* setDepartureDate */],
  setDuration: duration_action["a" /* setDuration */],
  setKids: kids_action["b" /* setKids */],
  endLoading: globalLoader_action["c" /* endLoading */]
};

var BookingCriteria_container_mapStateToProps = function mapStateToProps(state) {
  return {
    tripInformation: Object(storeHelper["d" /* tripInformationSelector */])(state),
    tripDurationCriteria: Object(tripCriteria_selector["c" /* getTripDuration */])(state)
  };
};

var BookingCriteriaContainer = Object(redux["d" /* compose */])(Responsive["a" /* default */], Object(es["c" /* connect */])(BookingCriteria_container_mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
}))(BookingCriteria_BookingCriteria);
// CONCATENATED MODULE: ./src/client/components/widgets/booking-errors/BookingErrors.jsx
var BookingErrors_jsx = react_default.a.createElement;




var PROPOSAL_SEARCH_ERROR_MAPPING = {
  invalidBookingCriteria: 'invalidBookingCriteria',
  noAccommodation: 'noAccommodation',
  noProposalAvailable: 'noProposalAvailable',
  noProposalWithFlight: 'noProposalWithFlight',
  noTransport: 'noTransport',
  technicalError: 'technicalError',
  unableToMakeProposal: 'unableToMakeProposal',
  unavailableForBirthdates: 'ageIncorrectOrUnauthorized'
};
var BookingErrors_BookingErrors = function BookingErrors(_ref) {
  var className = _ref.className,
      errorCode = _ref.errorCode;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return BookingErrors_jsx("div", {
    id: "Package-error",
    className: classnames_default()(className, {
      'arrow-upRight arrow-large arrow-gray-lighter arrow-bg arrow-bg-gray-light md:border-t-1 relative': isTablet
    })
  }, BookingErrors_jsx("div", {
    className: "md:max-w-1/2 md:py-6 m-auto text-blue text-center text-xl"
  }, errorCode && PROPOSAL_SEARCH_ERROR_MAPPING[errorCode] ? Object(src_i18n["f" /* t */])("booking.accommodation.errorMessages.".concat(PROPOSAL_SEARCH_ERROR_MAPPING[errorCode])) : Object(src_i18n["f" /* t */])('booking.accommodation.errorMessageNoProposal')));
};
// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-months/month/BookingCalendarMonth.jsx
var BookingCalendarMonth_jsx = react_default.a.createElement;



var BookingCalendarMonth_BookingCalendarMonth = function BookingCalendarMonth(_ref) {
  var className = _ref.className,
      id = _ref.id,
      isActive = _ref.isActive,
      name = _ref.name,
      _onClick = _ref.onClick,
      price = _ref.price,
      shortName = _ref.shortName,
      style = _ref.style,
      year = _ref.year;
  return BookingCalendarMonth_jsx("button", {
    className: classnames_default()(className, 'border-1 cursor-pointer flex flex-col font-bold items-center justify-center overflow-hidden sm:p-px10 w-full', {
      'bg-white border-gray-medium': !isActive,
      'bg-turquoise border-turquoise text-white': isActive
    }),
    onClick: function onClick() {
      return _onClick(id);
    },
    style: style,
    type: "button"
  }, BookingCalendarMonth_jsx("div", {
    className: "text-center text-sm sm:text-base truncate uppercase w-full"
  }, isActive ? name : shortName, isActive && BookingCalendarMonth_jsx("span", null, " ", year)), !!price && BookingCalendarMonth_jsx(react["Fragment"], null, BookingCalendarMonth_jsx("div", {
    className: "text-xs sm:text-sm truncate uppercase w-full"
  }, Object(src_i18n["f" /* t */])('price.format.from')), BookingCalendarMonth_jsx("div", {
    className: "sm:mt-2 text-xs sm:text-base"
  }, price)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-months/BookingCalendarMonths.jsx

var BookingCalendarMonths_jsx = react_default.a.createElement;






var BookingCalendarMonths_BookingCalendarMonths = function BookingCalendarMonths(_ref) {
  var _ref$current;

  var className = _ref.className,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$months = _ref.months,
      months = _ref$months === void 0 ? [] : _ref$months,
      onClick = _ref.onClick;

  var _useState = Object(react["useState"])(null),
      hovering = _useState[0],
      setHovering = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      initialPosition = _useState2[0],
      setInitialPosition = _useState2[1];

  var ref = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
      setInitialPosition(months.findIndex(function (m) {
        return m.isActive;
      }));
    }
  }, [isLoading]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var containerWidth = (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientWidth) || 0; // eslint-disable-next-line no-nested-ternary

  var width = !isTablet ? containerWidth / 4 : isDesktop ? containerWidth / 8 : containerWidth / 5;
  var elementWidth = isTablet ? width : width * 0.95;
  return BookingCalendarMonths_jsx("div", {
    className: (className, 'relative')
  }, BookingCalendarMonths_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["f" /* t */])('booking.common.previousMonths'),
    className: "z-1",
    controlsClassName: "mb-5 pb-2 sm:pb-5",
    deltaScrollFactorClick: elementWidth * 2,
    elementWidth: elementWidth,
    forwardLabel: Object(src_i18n["f" /* t */])('booking.common.nextMonths'),
    initialPosition: elementWidth ? initialPosition : null,
    innerClassName: "md:px-10"
  }, BookingCalendarMonths_jsx("div", {
    className: "flex mb-5 mx-1 sm:mx-4 md:mx-0",
    ref: ref
  }, months.map(function (month) {
    return BookingCalendarMonths_jsx("div", {
      className: classnames_default()('flex-none px-1 sm:px-2 relative transition-width', {
        'w-1/4 sm:w-1/5 md:w-1/8': !month.isActive && hovering !== month.id,
        'w-1/2 sm:w-2/5 md:w-1/4': month.isActive,
        'w-3/10 sm:w-1/4 md:w-1/6': !month.isActive && hovering === month.id
      }),
      key: month.id,
      onMouseEnter: function onMouseEnter() {
        return setHovering(month.id);
      },
      onMouseLeave: function onMouseLeave() {
        return setHovering(null);
      },
      style: !isTablet && elementWidth ? {
        width: month.isActive ? elementWidth * 2 : elementWidth
      } : null
    }, BookingCalendarMonths_jsx(BookingCalendarMonth_BookingCalendarMonth, Object(esm_extends["a" /* default */])({}, month, {
      className: "mb-2 sm:mb-4",
      onClick: onClick,
      style: {
        height: isTablet ? 85 : 52
      }
    })), month.isActive && BookingCalendarMonths_jsx("div", {
      className: "arrow-down arrow-large arrow-gray-lighter arrow-bg arrow-bg-large arrow-bg-turquoise border-b-2 border-turquoise -mb-px bottom-0 rtl:left-0 w-full transition-opacity"
    }));
  }))), BookingCalendarMonths_jsx("hr", {
    className: "absolute block border-0 border-solid border-gray-medium border-t-1 h-px m-0 -mt-5 p-0 w-full z-0"
  }));
};
// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-resume/BookingCalendarResume.jsx
var BookingCalendarResume_jsx = react_default.a.createElement;








var BookingCalendarResume_BookingCalendarResume = function BookingCalendarResume(_ref) {
  var className = _ref.className,
      duration = _ref.duration,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      id = _ref.id,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      onClose = _ref.onClose,
      onReset = _ref.onReset,
      price = _ref.price,
      priceIsLoading = _ref.priceIsLoading,
      startDate = _ref.startDate,
      style = _ref.style;
  var track = Object(useTracking["a" /* useTracking */])();
  return BookingCalendarResume_jsx("aside", {
    className: classnames_default()(className, 'bg-white rounded-small shadow'),
    id: id,
    style: style
  }, BookingCalendarResume_jsx("div", {
    className: "relative"
  }, BookingCalendarResume_jsx("button", {
    className: "absolute leading-none reset-button rtl:right-0 text-base top-0 m-px10",
    onClick: onClose,
    type: "button"
  }, BookingCalendarResume_jsx("span", {
    className: "sr-only"
  }, Object(src_i18n["f" /* t */])('common.close')), BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  })), BookingCalendarResume_jsx("div", {
    className: "border-b-1 border-gray-medium p-5"
  }, BookingCalendarResume_jsx("p", {
    className: "flex items-start mb-8 reset-paragraph text-sm sm:text-base"
  }, BookingCalendarResume_jsx("span", {
    className: "leading-none rtl:mr-3 text-emerald text-3xl"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CONFIRMATION,
    width: "1em"
  })), ' ', BookingCalendarResume_jsx("span", null, BookingCalendarResume_jsx(TemplateString["a" /* TemplateString */], {
    className: "inline-flex",
    template: Object(src_i18n["f" /* t */])('resort.startingPrice.stayDeparture'),
    values: {
      departure_date: startDate
    },
    valuesClassName: {
      departure_date: 'rtl:ml-1 text-turquoise'
    }
  }), BookingCalendarResume_jsx("br", null), BookingCalendarResume_jsx(TemplateString["a" /* TemplateString */], {
    className: "inline-flex",
    template: Object(src_i18n["f" /* t */])('resort.startingPrice.endDateLabel'),
    values: {
      end_date: endDate
    },
    valuesClassName: {
      end_date: 'rtl:ml-1 text-turquoise'
    }
  }))), priceIsLoading && BookingCalendarResume_jsx("div", {
    className: "flex justify-center"
  }, BookingCalendarResume_jsx(Spinner["a" /* Spinner */], {
    size: "small"
  })), price && !priceIsLoading && BookingCalendarResume_jsx("p", {
    className: "mb-5 reset-paragraph text-center text-sm"
  }, BookingCalendarResume_jsx("span", {
    className: "hidden md:inline-block leading-none rtl:mr-px10 -mb-1 text-blue text-lg"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ACCOMODATIONS,
    width: "1em"
  }), hasTransport && BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    className: "rtl:ml-1",
    name: icons["a" /* ICONS */].TRANSPORT,
    width: "1em"
  })), Object(src_i18n["f" /* t */])('price.format.from'), ' ', BookingCalendarResume_jsx("span", {
    className: "font-bold text-turquoise text-xl"
  }, price), ' ', Object(src_i18n["f" /* t */])('booking.form.duration', {
    N: duration
  }, "For ".concat(duration, " nights"))), BookingCalendarResume_jsx("p", {
    className: "flex flex-col reset-paragraph text-center text-xs sm:text-sm"
  }, isJoyview ? BookingCalendarResume_jsx("span", {
    className: "leading-one text-waterGreen"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CLUBMED_JOYVIEW,
    isNotSquare: true,
    width: "10em"
  })) : BookingCalendarResume_jsx(react["Fragment"], null, price && !priceIsLoading ? Object(src_i18n["f" /* t */])('booking.form.priceIsLabel') : '', ' ', BookingCalendarResume_jsx("span", {
    className: "font-brand leading-one text-blue text-base sm:text-md"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    className: "-mb-2px",
    name: icons["a" /* ICONS */].ALL_INCLUSIVE
  }), ' ', Object(src_i18n["f" /* t */])('resort.startingPrice.allInclusive'))))), BookingCalendarResume_jsx("button", {
    className: "px-5 py-px10 reset-button text-center text-sm underline w-full",
    onClick: function onClick() {
      onReset();
      track({
        actionGA: 'calendarPrice',
        labelGA: 'resetDates'
      });
    },
    type: "button"
  }, Object(src_i18n["f" /* t */])('booking.priceCalendar.resetCalendar'))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var async_loader_AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.helper.js
var calendar_helper = __webpack_require__("VtPb");

// EXTERNAL MODULE: ./src/client/store/constants.js
var store_constants = __webpack_require__("cvSI");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/store/priceTicket/priceTicket.helper.js






function fetchPrice(_ref) {
  var appContext = _ref.appContext,
      duration = _ref.duration,
      _ref$forceAdultPerTri = _ref.forceAdultPerTrip,
      forceAdultPerTrip = _ref$forceAdultPerTri === void 0 ? false : _ref$forceAdultPerTri,
      location = _ref.location,
      productId = _ref.productId,
      transport = _ref.transport;
  var urlParams = location.urlParams,
      queryParams = location.queryParams;
  var offerName = dist["url"].decodePath(queryParams.offer) || '';
  var tripDuration = duration || queryParams[uri_constants["g" /* QUERY_DURATION */]];
  var productArgsToBuild = {};
  productArgsToBuild.offerName = offerName;
  productArgsToBuild.date = queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]] || '';
  productArgsToBuild.departureCity = transport || queryParams[uri_constants["k" /* QUERY_TRANSPORT */]] || '';

  if (tripDuration) {
    productArgsToBuild.duration = parseInt(tripDuration, 10);
  }

  var _appContext$cmsConten = appContext.cmsContent,
      cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
      _appContext$cmsReleas = appContext.cmsRelease,
      cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
  var productArgs = Object(graphql["c" /* buildProductArgs */])(productId, urlParams, productArgsToBuild);
  var cmsArgs = "content: \"".concat(cmsContent, "\", release: \"").concat(cmsRelease, "\"");
  var query = "query {\n    price(".concat(productArgs, ") {\n      offerColor( offerName : \"").concat(offerName, "\")\n      bestPrice(forceAdultPerTrip: ").concat(String(forceAdultPerTrip), ") {\n        value\n        formattedValue\n      }\n      initialPrice(forceAdultPerTrip: ").concat(String(forceAdultPerTrip), ") {\n        value\n        formattedValue\n      }\n      unit(").concat(cmsArgs, ")\n      currency\n      termsAndConditions {\n        departureDate\n        duration\n        durationFormatted(").concat(cmsArgs, ")\n        departureCity {\n          value\n          name\n        }\n        numberOfAdults\n        accommodationComfortLabel\n        accommodationId\n        productId\n      }\n    }\n  }");
  return graphqlClient["a" /* default */].runQuery(query, appContext, {
    requestName: requestDictionary["Ed" /* STATE_PRODUCT_PRICE_TICKET */]
  });
}


// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// CONCATENATED MODULE: ./src/client/store/calendar/calendar.action.js















function fetchCalendar(options, appContext) {
  return function (dispatch, getState) {
    var _state$calendar, _state$calendar2;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.isLoading) && ((_state$calendar2 = state.calendar) === null || _state$calendar2 === void 0 ? void 0 : _state$calendar2.lastRequestId) !== -1;

    if (calendarRequestInProgress) {
      return dispatch(Object(createAction["b" /* default */])(store_constants["g" /* FETCH_CALENDAR_ABORT */], {}));
    }

    return dispatch(Object(createAction["a" /* createOptimisticAction */])(store_constants["f" /* FETCH_CALENDAR */], {}, {
      optimist: true,
      promise: Object(calendar_helper["f" /* queryFetchCalendar */])(appContext, options)
    }));
  };
}
function fetchCalendarTripPrice(options) {
  return function (dispatch, getState) {
    var _state$calendar3, _state$calendar4;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar3 = state.calendar) === null || _state$calendar3 === void 0 ? void 0 : _state$calendar3.isLoading) && ((_state$calendar4 = state.calendar) === null || _state$calendar4 === void 0 ? void 0 : _state$calendar4.lastRequestId) !== -1;

    if (calendarRequestInProgress) {
      return dispatch(Object(createAction["b" /* default */])(store_constants["i" /* FETCH_CALENDAR_TRIP_PRICE_ABORT */], {}));
    }

    return dispatch(Object(createAction["a" /* createOptimisticAction */])(store_constants["h" /* FETCH_CALENDAR_TRIP_PRICE */], {}, {
      optimist: true,
      promise: fetchPrice(options)
    }));
  };
}
function fetchBookableDates(options, appContext) {
  return function (dispatch, getState) {
    var _state$calendar5, _state$calendar6;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar5 = state.calendar) === null || _state$calendar5 === void 0 ? void 0 : _state$calendar5.isLoading) && ((_state$calendar6 = state.calendar) === null || _state$calendar6 === void 0 ? void 0 : _state$calendar6.lastRequestId) !== -1;

    if (calendarRequestInProgress) {
      return dispatch(Object(createAction["b" /* default */])(store_constants["e" /* FETCH_BOOKABLE_DATES_ABORT */], {}));
    }

    return dispatch(Object(createAction["a" /* createOptimisticAction */])(store_constants["d" /* FETCH_BOOKABLE_DATES */], {}, {
      optimist: true,
      promise: Object(calendar_helper["e" /* queryFetchBookableDates */])(appContext, options)
    }));
  };
}
function selectMonth(selectedMonth) {
  // format YYYYMM (number)
  return Object(createAction["b" /* default */])(store_constants["a" /* CALENDAR_CHANGE_MONTH */], {
    selectedMonth: selectedMonth
  });
}

function determineDepartureDate(state) {
  if (!Object(trip_date_criteria_storeHelper["b" /* getDepartureDate */])(state)) {
    var departureDateFromUrl = Object(lodash["get"])(Object(uriUtils["i" /* getQueryParameters */])(dist["windowWrapper"].getLocation()), uri_constants["f" /* QUERY_DEPARTURE_DATE */]);
    return Object(dateUtils["c" /* formatTimestampDate */])(departureDateFromUrl, apiDate["a" /* API_DATE_FORMAT */]) || Object(trip_date_criteria_storeHelper["b" /* getDepartureDate */])(state);
  }

  return Object(dateUtils["c" /* formatTimestampDate */])(Object(trip_date_criteria_storeHelper["b" /* getDepartureDate */])(state), apiDate["a" /* API_DATE_FORMAT */]);
}

function setPossibleDepartureDate() {
  return function (dispatch, getState) {
    var findDayInMonths = function findDayInMonths() {
      var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var dayId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var id = parseInt(dayId, 10);
      var allDays = months.reduce(function (acc, m) {
        return [].concat(acc, m.days);
      }, []);
      return allDays.find(function (d) {
        return Object(lodash["get"])(d, 'dayContent.id') === id;
      });
    };

    var departureDate = determineDepartureDate(getState());

    if (departureDate) {
      var calendarMonth = Object(lodash["get"])(getState(), 'calendar.calendar.months');
      var day = findDayInMonths(calendarMonth, departureDate);
      var dayContent = Object(lodash["get"])(day, 'dayContent', null);

      if (dayContent) {
        if (Object(lodash["get"])(dayContent, 'canGoToBooking')) {
          var yearAndMonth = parseInt(dayContent.id / 100, 10);
          Object(es["b" /* batch */])(function () {
            dispatch(Object(tripDateCriteria_action["a" /* updateTripDateCriteria */])({
              day: dayContent
            })); // makes sure tripCriteria.departureDate in store is synchronised
            // TODO: merge tripDateCriteria into tripCriteria #12563

            dispatch(Object(departureDate_action["a" /* setDepartureDate */])(moment_default()("".concat(dayContent.id), apiDate["a" /* API_DATE_FORMAT */]).valueOf()));
            dispatch(selectMonth(yearAndMonth));
          });
        } else {
          Object(es["b" /* batch */])(function () {
            dispatch(Object(tripDateCriteria_action["a" /* updateTripDateCriteria */])({
              day: null
            }));
            dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
          });
        }
      }
    }
  };
}
var calendar_action_setInitialDuration = function setInitialDuration(duration) {
  return {
    type: store_constants["b" /* CALENDAR_SET_INITIAL_DURATION */],
    payload: {
      duration: duration
    }
  };
};
// EXTERNAL MODULE: ./src/client/store/calendar/calendar.selector.js + 2 modules
var calendar_selector = __webpack_require__("05PS");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-form/useAvailableDurations.js







var useAvailableDurations_useAvailableDurations = function useAvailableDurations(_ref) {
  var initialTransport = _ref.initialTransport,
      productId = _ref.productId;
  var availableDurations = Object(es["e" /* useSelector */])(calendar_selector["a" /* getAvailableDurations */]);
  var prices = Object(es["e" /* useSelector */])(calendar_selector["i" /* getPricesByDays */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  Object(react["useEffect"])(function () {
    if (departureDate && !availableDurations) {
      // Get 15 next and previous availability's days
      var lastDate = moment_default()(departureDate).add(15, 'days').valueOf();
      var firstDate = moment_default()(departureDate).subtract(15, 'days').valueOf();
      dispatch(fetchBookableDates({
        departureCity: departureCity || initialTransport,
        departureDate: firstDate,
        lastDate: lastDate,
        productId: productId
      }, appContext));
    }
  }, [prices, departureDate]);
  return availableDurations;
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx + 7 modules
var TripDatePicker = __webpack_require__("pteD");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-form/price-calendar/PriceLegend.jsx
var PriceLegend_jsx = react_default.a.createElement;


var PriceLegend_PriceLegend = function PriceLegend(_ref) {
  var durationLabel = _ref.durationLabel;
  return PriceLegend_jsx("div", {
    className: "w-full"
  }, PriceLegend_jsx("div", {
    className: "md:hidden pt-px10 text-center text-base"
  }, Object(src_i18n["f" /* t */])('faceting.when.pricesBasedOn'), ' ', PriceLegend_jsx("strong", {
    "data-testid": "prices-duration-label"
  }, durationLabel)), PriceLegend_jsx("div", {
    className: "flex flex-wrap font-bold justify-center pb-px10 md:py-5"
  }, PriceLegend_jsx("div", {
    className: "p-1 sm:px-5 text-center text-base md:text-md text-emerald"
  }, Object(src_i18n["f" /* t */])('faceting.when.bestPrice')), PriceLegend_jsx("div", {
    className: "p-1 sm:px-5 text-center text-base md:text-md text-orange"
  }, Object(src_i18n["f" /* t */])('faceting.when.lastAvailability')), PriceLegend_jsx("div", {
    className: "p-1 sm:px-5 text-center text-base md:text-md text-gray-light"
  }, Object(src_i18n["f" /* t */])('faceting.when.notAvailable')), PriceLegend_jsx("div", {
    className: "hidden md:block p-1 sm:px-5 text-base text-center text-md"
  }, PriceLegend_jsx("span", {
    className: "font-normal"
  }, Object(src_i18n["f" /* t */])('faceting.when.pricesBasedOn'), " "), durationLabel)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-form/price-calendar/PriceCalendar.jsx

var PriceCalendar_jsx = react_default.a.createElement;































var HASH = 'PriceCalendarResume';
var SCROLL_ANCHOR = 'PriceCalendar';
var YEAR_MONTH = 'YYYYMM';

var defaultHandleChange = function defaultHandleChange(cb) {
  return function () {
    return cb();
  };
};

var PriceCalendar_PriceCalendar = function PriceCalendar(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var queryParams = location.queryParams;
  var bookingConfig = props.bookingConfig,
      _props$handleChange = props.handleChange,
      handleChange = _props$handleChange === void 0 ? defaultHandleChange : _props$handleChange,
      cmsStartingPrice = props.cmsStartingPrice,
      didMountCallback = props.didMountCallback,
      duration = props.duration,
      isJoyview = props.isJoyview,
      resortId = props.resortId,
      transport = props.transport;
  var urgentisationRate = bookingConfig.priceCalendar.offers.urgentisation.rateToDisplay;
  var dispatch = Object(es["d" /* useDispatch */])();
  var calendar = Object(es["e" /* useSelector */])(calendar_selector["b" /* getCalendar */]);
  var days = Object(es["e" /* useSelector */])(calendar_selector["f" /* getDays */]);
  var selectedMonth = Object(es["e" /* useSelector */])(calendar_selector["j" /* getSelectedMonth */]);
  var selectedDay = Object(es["e" /* useSelector */])(trip_date_criteria_storeHelper["b" /* getDepartureDate */]);
  var isLoading = Object(es["e" /* useSelector */])(calendar_selector["c" /* getCalendarLoading */]);
  var prices = Object(es["e" /* useSelector */])(calendar_selector["i" /* getPricesByDays */]);
  var tripDuration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var departureDate = Object(es["e" /* useSelector */])(function (state) {
    return state.tripCriteria.departureDate;
  });
  var departureDateIsBookable = Object(es["e" /* useSelector */])(calendar_selector["g" /* getDepartureDateBookable */]);

  var _useState = Object(react["useState"])(!departureDateIsBookable),
      blockInputDepartureDate = _useState[0],
      setBlockInputDepartureDate = _useState[1];

  var _useState2 = Object(react["useState"])(duration),
      durationPrice = _useState2[0];

  var price = Object(es["e" /* useSelector */])(calendar_selector["d" /* getCalendarTripPrice */]);
  var priceIsLoading = Object(es["e" /* useSelector */])(calendar_selector["e" /* getCalendarTripPriceLoading */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'calendarPrice'
  });
  Object(react["useEffect"])(function () {
    if (isLoading) {
      setBlockInputDepartureDate(true);
    }
  }, [isLoading]);
  Object(react["useEffect"])(function () {
    if (blockInputDepartureDate && departureDateIsBookable && !isLoading) {
      setBlockInputDepartureDate(false);
    }
  }, [departureDateIsBookable, blockInputDepartureDate, isLoading]);

  var _useState3 = Object(react["useState"])(false),
      hasToaster = _useState3[0],
      setHasToaster = _useState3[1];

  var _useState4 = Object(react["useState"])(tripDuration),
      inputDuration = _useState4[0],
      setInputDuration = _useState4[1];

  Object(react["useEffect"])(function () {
    if (inputDuration && inputDuration !== durationPrice) dispatch(fetchCalendarTripPrice({
      appContext: appContext,
      duration: inputDuration,
      forceAdultPerTrip: true,
      location: location,
      productId: resortId,
      transport: transport
    }));
  }, [resortId, inputDuration, transport]);

  var _useState5 = Object(react["useState"])(!blockInputDepartureDate && departureDate ? moment_default()(departureDate) : moment_default()(selectedMonth, YEAR_MONTH)),
      openCalendarToDate = _useState5[0],
      setCalendarToDate = _useState5[1];

  Object(react["useEffect"])(function () {
    if (tripDuration !== inputDuration) {
      setInputDuration(tripDuration);
    }
  }, [tripDuration]);
  Object(react["useEffect"])(function () {
    if (!departureDate) {
      setCalendarToDate(moment_default()(selectedMonth, YEAR_MONTH));
    }
  }, [selectedMonth]);
  var availableDurations = useAvailableDurations_useAvailableDurations({
    productId: resortId,
    initialTransport: transport
  });

  var setUrlQueries = function setUrlQueries(queries) {
    var uri = Object(uriUtils["c" /* convertLocationToURI */])(location);
    var searchPageUrl = uri.clone().setQuery(queries);
    redirectUtils["a" /* default */].redirectTo()(searchPageUrl, {
      shallow: true
    });
  };

  var onSelect = function onSelect(dates) {
    var timestamp = dates.from && moment_default()(dates.from).valueOf();

    if (blockInputDepartureDate) {
      setBlockInputDepartureDate(false);
    }

    if (departureDate !== timestamp) {
      handleChange(function () {
        Object(es["b" /* batch */])(function () {
          dispatch(Object(departureDate_action["a" /* setDepartureDate */])(timestamp));
          dispatch(Object(facetingSearch_action["g" /* clearTripDuration */])());
        });
        setInputDuration(null);
        requestAnimationFrame(function () {
          var _setUrlQueries;

          setUrlQueries((_setUrlQueries = {}, Object(defineProperty["a" /* default */])(_setUrlQueries, uri_constants["f" /* QUERY_DEPARTURE_DATE */], (timestamp || undefined) && moment_default()(timestamp).format(uri_constants["e" /* QUERY_DATE_FORMAT */])), Object(defineProperty["a" /* default */])(_setUrlQueries, uri_constants["g" /* QUERY_DURATION */], undefined), _setUrlQueries));
        });

        if (timestamp) {
          track({
            labelGA: "when_".concat(moment_default()(timestamp).format('DD/MM/YYYY'))
          });
          setCalendarToDate(moment_default()(timestamp));
        }
      })();
    }

    if (dates.from && dates.to) {
      var updatedDuration = Object(TripDatePicker_utils["c" /* dateDiff */])(dates.from, dates.to);
      track({
        labelGA: "duration_".concat(updatedDuration)
      });
      setInputDuration(updatedDuration);
      Object(es["b" /* batch */])(function () {
        dispatch(Object(facetingSearch_action["d" /* changeTripDuration */])(updatedDuration));
        var dayId = parseInt(moment_default()(dates.from).format(apiDate["a" /* API_DATE_FORMAT */]), 10);
        var day = days.find(function (calendarDay) {
          return calendarDay.dayContent.id === dayId;
        });
        day && dispatch(Object(tripDateCriteria_action["a" /* updateTripDateCriteria */])({
          day: day.dayContent
        }));
      });
      setHasToaster(true);
      setUrlQueries(Object(defineProperty["a" /* default */])({}, uri_constants["g" /* QUERY_DURATION */], updatedDuration));
    } else {
      setInputDuration(null);
      dispatch(Object(tripDateCriteria_action["a" /* updateTripDateCriteria */])(null));
      setHasToaster(false);
    }
  };

  Object(react["useEffect"])(function () {
    dispatch(calendar_action_setInitialDuration(duration));
  }, []);
  Object(react["useEffect"])(function () {
    var hasProposalIdQueryParam = Object(lodash["has"])(queryParams, 'proposalId');

    if (hasProposalIdQueryParam || !resortId) {
      return; // because a Redux action will fetch the calendar
    }

    dispatch(fetchCalendar({
      resortId: resortId,
      transport: transport,
      duration: durationPrice,
      urgentisationRate: urgentisationRate
    }, appContext));

    if (hasToaster) {
      setHasToaster(false);
    }
  }, [resortId, transport, urgentisationRate]);
  Object(react["useEffect"])(function () {
    dispatch(setPossibleDepartureDate());
    /**
     * Should fetch proposals after state update for arrivaldate
     * see BookingEngineForm, ligne 170.
     * */

    didMountCallback && didMountCallback();
  }, [calendar.months]);

  var onSelectDate = function onSelectDate(day) {
    props.onSelectDate(day);
  };
  /**
   * make sure the selected date is up to date after a transport update
   */


  Object(react["useEffect"])(function () {
    if (selectedDay) {
      var day = days.find(function (calendarDay) {
        return calendarDay.dayContent.id === selectedDay;
      });
      day && onSelectDate(day.dayContent);
    }
  }, [calendar, transport, selectedDay]);
  Object(react["useEffect"])(function () {
    if (hasToaster) {
      requestAnimationFrame(function () {
        Object(scrollToElement["a" /* scrollToElement */])("#".concat(HASH), 500, ".".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]));
      });
    }
  }, [hasToaster]);
  var from = departureDate && !blockInputDepartureDate ? moment_default()(departureDate).toDate() : null;
  var to = from && inputDuration ? moment_default()(from).add({
    days: inputDuration
  }).toDate() : null;

  var _useState6 = Object(react["useState"])(from),
      hovered = _useState6[0],
      setHovered = _useState6[1];

  Object(react["useEffect"])(function () {
    if (!departureDate) {
      setHovered(null);
    }
  }, [departureDate]);

  var onSelectMonth = function onSelectMonth(monthId) {
    if (monthId !== selectedMonth) {
      _onReset();

      setCalendarToDate(moment_default()(selectedMonth, YEAR_MONTH));
      requestAnimationFrame(function () {
        setCalendarToDate(moment_default()(monthId, YEAR_MONTH));
        dispatch(selectMonth(monthId));
      });
    }
  };

  var _onReset = function onReset() {
    var _setUrlQueries3;

    setUrlQueries((_setUrlQueries3 = {}, Object(defineProperty["a" /* default */])(_setUrlQueries3, uri_constants["f" /* QUERY_DEPARTURE_DATE */], undefined), Object(defineProperty["a" /* default */])(_setUrlQueries3, uri_constants["g" /* QUERY_DURATION */], undefined), _setUrlQueries3));
    dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
    dispatch(Object(facetingSearch_action["g" /* clearTripDuration */])());
    setInputDuration(null);
    setHasToaster(false);
  };

  var onDayMouseOver = function onDayMouseOver(day) {
    setHovered(day);
  };

  var displayedDuration = from && (to || hovered) ? Object(TripDatePicker_utils["c" /* dateDiff */])(from, to || hovered || from) || durationPrice : durationPrice;
  var durationLabel = Object(dist["messageFormat"])({
    n: Object(src_i18n["f" /* t */])('faceting.when.durationPlural'),
    _0: '-',
    _1: Object(src_i18n["f" /* t */])('faceting.when.durationSingular')
  }).format({
    n: displayedDuration,
    count: displayedDuration
  });
  var locale = appContext.locale;
  var selectedDayPrice = selectedDay && prices && prices[selectedDay];
  var instalmentSelectedDayPrice = Object(price_util["b" /* getInstalmentPrice */])({
    currency: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.currency,
    formattedValue: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.price,
    value: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.priceValue
  }, locale);
  return PriceCalendar_jsx("div", {
    id: "calendar",
    "data-scroll-anchor": SCROLL_ANCHOR
  }, PriceCalendar_jsx("div", {
    className: "-mx-5 md:mx-0 relative",
    style: {
      minHeight: 450
    }
  }, !Object(lodash["isEmpty"])(calendar) && PriceCalendar_jsx(react["Fragment"], null, PriceCalendar_jsx(BookingCalendarMonths_BookingCalendarMonths, {
    isLoading: isLoading,
    months: calendar.blocks.map(function (b) {
      return {
        id: b.id,
        isActive: b.id === selectedMonth,
        name: b.name,
        price: Object(price_util["b" /* getInstalmentPrice */])(b.price, locale),
        shortName: b.shortName,
        year: b.year
      };
    }),
    onClick: onSelectMonth
  }), PriceCalendar_jsx(PriceLegend_PriceLegend, {
    durationLabel: durationLabel
  }), PriceCalendar_jsx(TripDatePicker["a" /* TripDatePicker */], {
    className: "mb-5 md:mb-10 -mx-px md:mx-0",
    displayPrices: true,
    duration: durationPrice,
    hasInstalment: true,
    isJoyview: isJoyview,
    navbarElement: function navbarElement(_ref) {
      var month = _ref.month;
      var datePickerMonth = Number(moment_default()(month).format(YEAR_MONTH));

      if (datePickerMonth !== selectedMonth && !isLoading && (from || to)) {
        dispatch(selectMonth(datePickerMonth));
      }

      return null;
    },
    onSelect: onSelect,
    onDayMouseOver: onDayMouseOver,
    optionsDuration: (availableDurations === null || availableDurations === void 0 ? void 0 : availableDurations.length) ? availableDurations : [],
    openCalendarToDate: openCalendarToDate,
    prices: prices,
    selectedDays: {
      from: from,
      to: to
    },
    withLongDayFormat: isTablet,
    withPriceDetails: isDesktop
  }), from && to && hasToaster && !isLoading && PriceCalendar_jsx(BookingCalendarResume_BookingCalendarResume, {
    className: "absolute bottom-0 md:bottom-auto rtl:right-0 rtl:slideInRight -mt-30 md:-mt-48 mx-5 md:mx-0 z-3",
    duration: inputDuration ? inputDuration : 0,
    hasTransport: transport !== 'NO',
    id: HASH,
    isJoyview: isJoyview,
    endDate: moment_default()(to).format((cmsStartingPrice === null || cmsStartingPrice === void 0 ? void 0 : cmsStartingPrice.dateFormat) || 'D MMMM YYYY'),
    onClose: function onClose() {
      return setHasToaster(false);
    },
    onReset: function onReset() {
      requestAnimationFrame(function () {
        Object(scrollToElement["a" /* scrollToElement */])("[data-scroll-anchor=\"".concat(SCROLL_ANCHOR, "\"]"), 500, ".".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]));
      });

      _onReset();
    },
    price: inputDuration && inputDuration !== durationPrice ? Object(price_util["b" /* getInstalmentPrice */])(price === null || price === void 0 ? void 0 : price.bestPrice, locale) : instalmentSelectedDayPrice,
    priceIsLoading: priceIsLoading,
    startDate: moment_default()(from).format((cmsStartingPrice === null || cmsStartingPrice === void 0 ? void 0 : cmsStartingPrice.dateFormat) || 'D MMMM YYYY'),
    style: isTablet ? {
      width: 380
    } : {
      width: 'calc(100% - 2.5rem)'
    }
  })), isLoading && PriceCalendar_jsx("div", {
    className: "absolute bg-gray-lighter flex items-center justify-center inset-0 w-full z-1"
  }, PriceCalendar_jsx(async_loader_AsyncLoader["a" /* AsyncLoader */], null))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/BookingEngineForm.jsx









var BookingEngineForm_jsx = react_default.a.createElement;

function BookingEngineForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingEngineForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingEngineForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingEngineForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function BookingEngineForm_createSuper(Derived) { var hasNativeReflectConstruct = BookingEngineForm_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function BookingEngineForm_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



























var BookingEngineForm_defaultProps = {
  clearProposals: lodash["noop"],
  kids: [],
  i18n: null,
  dataSelector: 'BookingEngineForm',
  fetchProposalsAndRedirect: lodash["noop"],
  suggestions: {
    dates: [],
    resorts: []
  }
};

var BookingEngineForm_BookingEngineForm = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(BookingEngineForm, _Component);

  var _super = BookingEngineForm_createSuper(BookingEngineForm);

  function BookingEngineForm(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, BookingEngineForm);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setShouldFetchProposals", function () {
      var queryParams = _this.props.location.queryParams;
      var fetch = queryParams.fetch;
      var shouldFetch = Boolean(fetch && "".concat(fetch) === '1');
      return function () {
        _this.setState({
          shouldFetchProposals: shouldFetch
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "checkLoading", function () {
      if (_this.props.suggestions.dates.length > 0 || _this.props.suggestions.durations.length > 0 || // errors are so badly handle that it's easier to check if there is no proposal rather that there is an error
      _this.props.proposals.some(function (_ref) {
        var id = _ref.id;
        return !id;
      }) || _this.props.proposals.some(function (proposal) {
        return proposal.price.gap > proposals_constants["r" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];
      })) {
        _this.props.endLoading();
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleDepartureDate", function () {
      var day = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var newDepartureDate = moment_default()(String(day === null || day === void 0 ? void 0 : day.id)).valueOf();

      if (_this.props.departureDate !== (day === null || day === void 0 ? void 0 : day.id)) {
        _this.props.setDepartureDate(newDepartureDate);
      }

      _this.props.updateTripDateCriteria({
        day: day
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onFormSubmit", function (event) {
      event.preventDefault();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getPackages", function (newArrivalDate) {
      var _this$props = _this.props,
          bookingCriteria = _this$props.bookingCriteria,
          fetchProposalsAndRedirect = _this$props.fetchProposalsAndRedirect,
          resort = _this$props.resort,
          departureCity = _this$props.departureCity,
          duration = _this$props.duration,
          i18n = _this$props.i18n,
          tripInformation = _this$props.tripInformation,
          location = _this$props.location;
      var productId = resort.id;
      var isJoyView = resort.isJoyview;
      var departureCityOption = bookingCriteria.departureCities.find(function (city) {
        return city.value === departureCity;
      });

      var fetchParams = BookingEngineForm_objectSpread(BookingEngineForm_objectSpread({
        productId: productId,
        departureCity: departureCity,
        duration: duration,
        isJoyView: isJoyView,
        // $FlowFixMe it's a recomposition
        globalLoaderLabel: i18n.booking.form.proposalsLoaderLabel
      }, Object(sellerUtils["g" /* isSeller */])(_this.context) ? Object(ContactInfoUtils["f" /* getAllAttendeesIds */])(tripInformation) : null), {}, {
        newArrivalDate: newArrivalDate,
        bookingEngineEntry: booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR
      });

      var trackingParams = {
        departureCityName: Object(lodash["get"])(departureCityOption, 'name'),
        shouldTrackTransport: Object(lodash["get"])(_this.props.package, 'transport.enableTransport', false)
      };
      return fetchProposalsAndRedirect(fetchParams, trackingParams, _this.context, location);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "redirectToBE", function (newArrivalDate) {
      _this.setState({
        showModal: false
      });

      _this.getPackages(newArrivalDate).then(function () {
        _this.setState({
          showModal: true
        });
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "shouldDisplayModal", function () {
      return _this.hasCounterProposals() && _this.canDisplayCounterProposals() && _this.state.showModal;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "goToBookingEngine", /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _this$props2, resort, proposals, attendees, setCms, setAttendees, prepareBe, history, location, _yield$fetchBookingEn, config, legalInformations, proposalId;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, resort = _this$props2.resort, proposals = _this$props2.proposals, attendees = _this$props2.attendees, setCms = _this$props2.setCms, setAttendees = _this$props2.setAttendees, prepareBe = _this$props2.prepareBe, history = _this$props2.history, location = _this$props2.location;

              _this.setState({
                showModal: false
              });

              _context.next = 4;
              return Object(BookingEngineI18n_query["a" /* fetchBookingEngineI18nQuery */])(_this.context);

            case 4:
              _yield$fetchBookingEn = _context.sent;
              config = _yield$fetchBookingEn.config;
              legalInformations = _yield$fetchBookingEn.legalInformations;

              if (config && legalInformations) {
                setCms(config, legalInformations);
                setAttendees(attendees);
              }

              proposalId = proposals[0].id;
              prepareBe({
                resort: resort,
                proposals: {
                  proposals: proposals,
                  resort: resort
                },
                proposalId: proposalId
              });
              history.pushRoute(Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals, resort, proposalId, location.queryParams));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.state = {
      showModal: true,
      shouldFetchProposals: false,
      isDepartureDateAvailaible: true
    };
    _this.bookingCriteriaNode = /*#__PURE__*/Object(react["createRef"])();
    return _this;
  }

  Object(createClass["a" /* default */])(BookingEngineForm, [{
    key: "scrollToBookingEngineEntryPoint",
    value: function scrollToBookingEngineEntryPoint() {
      var _this2 = this;

      /**
       * The setTimeout is needed to make sure the modal is closed before trying to scroll
       */
      setTimeout(function () {
        var bookingEngineEntry = _this2.props.bookingEngineEntry;
        var PRICE_CALENDAR = booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR,
            PRICE_REMOTE = booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE;
        var bookingEngineFormSelector = document.querySelector(BOOKING_ENGINE_FORM_SELECTOR);
        var priceRemoteSelector = document.querySelector(PRICE_REMOTE_STICKY_WRAPPER_SELECTOR);

        if (bookingEngineEntry === PRICE_CALENDAR && bookingEngineFormSelector) {
          // $FlowFixMe the validity of this check in the condition above
          bookingEngineFormSelector.scrollIntoView();
        } else if (bookingEngineEntry === PRICE_REMOTE && priceRemoteSelector) {
          // $FlowFixMe the validity of this check in the condition above
          priceRemoteSelector.scrollIntoView();
        }
      }, 0);
    }
  }, {
    key: "setIsDepartureDateAvailaible",
    value: function () {
      var _setIsDepartureDateAvailaible = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(departureDate) {
        var _yield$getBookingCrit, bookingCriteria;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(BookingPagesUtils["h" /* getBookingCriteriaOffsetSell */])(this.props.resort.id, this.context);

              case 2:
                _yield$getBookingCrit = _context2.sent;
                bookingCriteria = _yield$getBookingCrit.bookingCriteria;
                this.setState({
                  isDepartureDateAvailaible: !Object(BookingPagesUtils["g" /* checkIsDepartureDateAvailaible */])(String(departureDate), bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.offsetSell)
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setIsDepartureDateAvailaible(_x) {
        return _setIsDepartureDateAvailaible.apply(this, arguments);
      }

      return setIsDepartureDateAvailaible;
    }()
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _this3 = this;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // We assume that if we have proposals, it implies we come from the booking engine.
                this.props.clearSelectedProposal();
                this.props.clearProposals();
                _context3.next = 4;
                return this.setIsDepartureDateAvailaible(this.props.departureDate);

              case 4:
                /**
                 * This setTimeout is needed also (plus the one used in scrollToBookingEngineEntryPoint)
                 * because of a race condition with RouteChangeListener scroll (a bugfix for hash)
                 * See RouteChangeListener line 29
                 */
                setTimeout(function () {
                  return _this3.scrollToBookingEngineEntryPoint();
                }, 0);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
    /**
     * #10731
     * This means the user comes from a metasearch and has already selected trip criterias.
     * We force fetching proposals to avoid one more click on continue button
     * but we cannot make the query on componentDidMount hook because state is not yet hydrated from query params
     * arrivalDate is mandatory and will be set after calendar did mount.
     * See PriceCalendar & didMountCallback
     * url format: ?duration=6&date=2019-04-30&number_of_adults=2&kids=2015-03-02_2014-12-20&fetch=1&_ab2=b
     */

  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee4(prevProps, prevState) {
        var oldProposal, newProposal;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.props.departureDate !== prevProps.departureDate)) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return this.setIsDepartureDateAvailaible(this.props.departureDate);

              case 3:
                if (this.state.shouldFetchProposals && !prevState.shouldFetchProposals && this.bookingCriteriaNode.current) {
                  // $FlowFixMe
                  this.bookingCriteriaNode.current.onSubmit();
                }

                oldProposal = prevProps.proposals[0];
                newProposal = this.props.proposals[0];

                if (!Object(lodash["isEqual"])(oldProposal, newProposal) || !Object(lodash["isEqual"])(prevProps.suggestions, this.props.suggestions)) {
                  this.checkLoading(); // scroll to errors if any

                  if (Object(proposalUtils["q" /* hasErroredProposals */])(this.props.proposals) || this.hasCounterProposals() && !this.canDisplayCounterProposals()) {
                    // the setTimeout is needed to make sure the global loader is closed before trying to scroll
                    setTimeout(function () {
                      Object(scrollToElement["a" /* scrollToElement */])('#Package-error', 600, ".".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]));
                    });
                  }
                } // makes sure the counter proposal modal will be closed on resort change


                if (prevProps.resort.id !== this.props.resort.id) {
                  this.setState({
                    showModal: false
                  });
                }

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidUpdate(_x2, _x3) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
    /**
     * In case the fetch proposals return counter proposals the global loader stay so we need to end it ourself
     * IT stay because we want to keep it when we redirect to the BE for prevent any flickering
     */

  }, {
    key: "canDisplayCounterProposals",
    value: function canDisplayCounterProposals() {
      var _this4 = this;

      return !this.props.proposals.some(function (proposal) {
        return proposal.price.gap >= proposals_constants["q" /* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */] && !Object(sellerUtils["g" /* isSeller */])(_this4.context);
      }) || this.props.suggestions.dates.length > 0 || this.props.suggestions.durations.length > 0 || this.props.suggestions.resorts.length > 0;
    }
  }, {
    key: "hasCounterProposals",
    value: function hasCounterProposals() {
      var proposal = this.props.proposals[0];
      var _this$props$suggestio = this.props.suggestions,
          dates = _this$props$suggestio.dates,
          durations = _this$props$suggestio.durations;
      return dates.length > 0 || durations.length > 0 || !Object(lodash["isEmpty"])(proposal) && proposal.price && proposal.price.gap > proposals_constants["r" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$bookingCo,
          _this$props$bookingCo2,
          _this$props$bookingCo3,
          _this$props$bookingCo4,
          _this5 = this,
          _this$props$proposals;

      var failedProposals = Object(proposalUtils["q" /* hasErroredProposals */])(this.props.proposals);

      var i18n = BookingEngineForm_objectSpread(BookingEngineForm_objectSpread({}, this.props.i18n), {}, {
        adultAge: Object(lodash["get"])(this.props, 'bookingConfig.form.adultAge'),
        bookingCriteria: this.props.bookingCriteria,
        childrenBirthdayDateFormatPlaceholder: Object(lodash["get"])(this.props, 'bookingConfig.form.childrenBirthdayDateFormatPlaceholder'),
        dateFormat: Object(lodash["get"])(this.props, 'bookingConfig.form.dateFormat'),
        dayPlaceholder: Object(lodash["get"])(this.props, 'bookingConfig.form.dayPlaceholder'),
        monthPlaceholder: Object(lodash["get"])(this.props, 'bookingConfig.form.monthPlaceholder'),
        yearPlaceholder: Object(lodash["get"])(this.props, 'bookingConfig.form.yearPlaceholder'),
        dateValidate: Object(lodash["get"])(this.props, 'bookingConfig.form.dateValidate'),
        durationTitle: Object(lodash["get"])(this.props, 'bookingConfig.form.durationTitle'),
        durationOptionsFormat: Object(lodash["get"])(this.props, 'bookingConfig.form.selectDuration'),
        selectAdultsLabels: Object(lodash["get"])(this.props, 'bookingConfig.form.selectAdultsLabels'),
        selectChildrenLabels: Object(lodash["get"])(this.props, 'bookingConfig.form.selectChildrenLabels'),
        legalNotice: Object(lodash["get"])(this.props, 'bookingConfig.form.legalNotice'),
        minAgeInformation: Object(lodash["get"])(this.props, 'resort.minAuthorizedAge.formattedValue'),
        birthdayFormatErrorMessage: Object(lodash["get"])(this.props, 'bookingConfig.form.errors.birthdayFormat'),
        adultAgeErrorMessage: Object(lodash["get"])(this.props, 'bookingConfig.form.errors.adultChild'),
        skiPassIncludedLabel: Object(lodash["get"])(this.props, 'bookingConfig.form.reinsurance.skiPassIncludedLabel'),
        skiPassIncludedDescription: Object(lodash["get"])(this.props, 'bookingConfig.form.reinsurance.skiPassIncludedDescription'),
        kidStayIncludedLabel: Object(lodash["get"])(this.props, 'bookingConfig.form.reinsurance.kidStayIncludedLabel'),
        didYouKnowLabel: Object(lodash["get"])(this.props, 'bookingConfig.form.reinsurance.didYouKnowLabel'),
        kidStayIncludedDescription: Object(lodash["get"])(this.props, 'bookingConfig.form.reinsurance.kidStayIncludedDescription'),
        minAgeErrorMessage: Object(lodash["get"])(this.props, 'resort.minAgeErrorMessage.formattedValue'),
        proposalsLoaderLabel: Object(lodash["get"])(this.props, 'bookingConfig.form.proposalsLoaderLabel')
      });

      Object(src_i18n["a" /* addTranslationKeys */])({
        booking: this.props.i18n.booking,
        common: this.props.i18n.common,
        package: this.props.i18n.package,
        priceRemote: this.props.i18n.priceRemote,
        bookingConfig: {
          form: {
            legalNotice: (_this$props$bookingCo = this.props.bookingConfig) === null || _this$props$bookingCo === void 0 ? void 0 : (_this$props$bookingCo2 = _this$props$bookingCo.form) === null || _this$props$bookingCo2 === void 0 ? void 0 : _this$props$bookingCo2.legalNotice
          }
        }
      });
      return BookingEngineForm_jsx(SiteContainer["a" /* SiteContainer */], {
        bgColor: colors["a" /* COLORS */].GRAY_LIGHTER,
        hasBorders: true,
        hasBottomShadow: true,
        hasTopShadow: true
      }, BookingEngineForm_jsx("form", {
        className: "py-8",
        id: "booking",
        onSubmit: this.onFormSubmit
      }, BookingEngineForm_jsx("h2", {
        className: "border-b-1 border-gray-light font-bold leading-tight mb-5 pb-px10 reset-heading text-blue text-2xl md:text-4xl"
      }, (_this$props$bookingCo3 = this.props.bookingConfig) === null || _this$props$bookingCo3 === void 0 ? void 0 : (_this$props$bookingCo4 = _this$props$bookingCo3.form) === null || _this$props$bookingCo4 === void 0 ? void 0 : _this$props$bookingCo4.title), BookingEngineForm_jsx(BookingCriteriaContainer, {
        myRef: this.bookingCriteriaNode,
        adultOnly: Object(lodash["get"])(this.props, 'resort.adultOnly'),
        isWinterResort: Object(resortUtils["b" /* isWinterResort */])(this.props.resort),
        adultsNumber: this.props.adultsNumber,
        bookingConfig: this.props.bookingConfig,
        duration: this.props.duration,
        departureDate: this.props.departureDate,
        isDepartureDateAvailaible: this.state.isDepartureDateAvailaible,
        departureCity: this.props.departureCity,
        enableTransfer: Object(lodash["get"])(this.props, 'bookingConfig.enableTransfer'),
        kids: this.props.kids,
        getPackages: this.getPackages,
        isJoyView: Object(lodash["get"])(this.props, 'resort.isJoyview', false),
        isTransportEnabled: Object(lodash["get"])(this.props, 'package.transport.enableTransport', false),
        pushImage: this.props.pushImage,
        config: this.props.config,
        childAge: Object(lodash["get"])(this.props, 'resort.minAuthorizedAge.value'),
        resort: Object(lodash["get"])(this.props, 'resort'),
        i18n: i18n
      }, BookingEngineForm_jsx(PriceCalendar_PriceCalendar, {
        selectedDay: this.props.departureDate,
        onSelectDate: this.handleDepartureDate,
        bookingConfig: this.props.bookingConfig,
        travelAdvisorConfig: this.props.travelAdvisorConfig,
        cmsStartingPrice: this.props.cmsStartingPrice,
        cmsPrice: this.props.cmsPrice,
        duration: this.props.duration,
        transport: this.props.departureCity,
        resortId: Object(lodash["get"])(this.props, 'resort.id'),
        isJoyview: Object(lodash["get"])(this.props, 'resort.isJoyview', false),
        didMountCallback: this.setShouldFetchProposals()
      })), !this.state.isDepartureDateAvailaible || failedProposals || this.props.proposals.some(function (proposal) {
        return proposal.price && proposal.price.gap >= proposals_constants["q" /* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */] && !Object(sellerUtils["g" /* isSeller */])(_this5.context);
      }) ? BookingEngineForm_jsx(BookingErrors_BookingErrors, {
        className: "mt-5 md:mt-8",
        errorCode: (_this$props$proposals = this.props.proposals.find(function (_ref3) {
          var errorCode = _ref3.errorCode;
          return !!errorCode;
        })) === null || _this$props$proposals === void 0 ? void 0 : _this$props$proposals.errorCode
      }) : null, this.shouldDisplayModal() && BookingEngineForm_jsx(AlternativeProposalsModal["a" /* AlternativeProposalsModal */], {
        trackingDefaultPayload: {
          categoryGA: 'resort',
          actionGA: 'checkPricesKO'
        },
        searchCriteria: {
          arrivalDate: String(this.props.arrivalDate),
          duration: this.props.duration,
          adultsCount: this.props.adultsNumber,
          kidsCount: this.props.kids.length,
          departureCity: this.props.departureCity
        },
        i18n: i18n,
        onClose: this.props.clearProposals,
        onSubmit: this.redirectToBE,
        proposals: this.props.proposals,
        suggestions: this.props.suggestions,
        resort: this.props.resort,
        goToBookingEngine: this.goToBookingEngine,
        bookingEngineEntryPoint: this.props.bookingEngineEntry,
        scrollToBookingEngineEntryPoint: function scrollToBookingEngineEntryPoint() {
          return _this5.scrollToBookingEngineEntryPoint();
        },
        onSelectNewDuration: function onSelectNewDuration(_ref4) {
          var proposalIds = _ref4.proposalIds;

          var queryParams = BookingEngineForm_objectSpread(BookingEngineForm_objectSpread({}, _this5.props.location.queryParams), {}, {
            proposalIds: proposalIds,
            selectedProposalId: proposalIds[0]
          });

          _this5.props.history.pushRoute(routeBuilder["a" /* buildUrl */]('booking', {
            page: BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */]
          }, queryParams));
        }
      })));
    }
  }]);

  return BookingEngineForm;
}(react["Component"]);

Object(defineProperty["a" /* default */])(BookingEngineForm_BookingEngineForm, "defaultProps", BookingEngineForm_defaultProps);

Object(defineProperty["a" /* default */])(BookingEngineForm_BookingEngineForm, "contextType", ReactAppContext["a" /* default */]);

/* harmony default export */ var booking_engine_form_BookingEngineForm = (Object(withRouter["a" /* withRouter */])(BookingEngineForm_BookingEngineForm));
// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/BookingEngineForm.container.jsx


function BookingEngineForm_container_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingEngineForm_container_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingEngineForm_container_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingEngineForm_container_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















function getValue(value, initialValue) {
  return !value && initialValue ? initialValue : value;
}

function getQueryParamValue(name, location) {
  return Object(lodash["get"])(location.queryParams, name);
}

function getValidDepartureCity(state, props) {
  var availableTransports = Object(lodash["get"])(props, 'bookingCriteria.departureCities') || [];
  var transportIATACodes = availableTransports.map(function (t) {
    return t.value;
  });
  var departureCity = Object(tripCriteria_selector["a" /* getDepartureCity */])(state) || getQueryParamValue(uri_constants["k" /* QUERY_TRANSPORT */], props.location);
  return transportIATACodes.includes(departureCity) ? departureCity : Object(lodash["get"])(props, 'bookingCriteria.initialTransport');
}

function BookingEngineForm_container_mapStateToProps(state, props) {
  var kids = Object(storeHelper["c" /* getKids */])(state) || [];
  var adults = (Object(storeHelper["a" /* getAdults */])(state) || []).length;
  var duration = Object(tripCriteria_selector["c" /* getTripDuration */])(state);
  var departureCity = getValidDepartureCity(state, props);
  var departureDate = Object(trip_date_criteria_storeHelper["b" /* getDepartureDate */])(state);
  return {
    adultsNumber: getValue(adults, Object(lodash["get"])(props, 'bookingCriteria.initialNumberOfAdults')) || adults_constants["a" /* DEFAULT_ADULTS_NB */],
    arrivalDate: Object(trip_date_criteria_storeHelper["a" /* getArrivalDate */])(state),
    bookingEngineEntry: state.booking.bookingEngineEntry,
    departureDate: departureDate,
    departureCity: getValue(departureCity, Object(lodash["get"])(props, 'bookingCriteria.initialTransport')),
    duration: getValue(duration, Object(lodash["get"])(props, 'bookingCriteria.initialDuration')) || duration_constants["b" /* DEFAULT_TRIP_DURATION */],
    kids: getResortInitialKids(kids, Object(lodash["get"])(props, 'bookingCriteria.initialNumberOfChildren'), Object(lodash["get"])(props, 'resort.adultOnly')),
    proposals: Object(booking_selector["u" /* getProposals */])(state),
    selectedProposalId: Object(booking_selector["y" /* getSelectedProposalId */])(state),
    resort: BookingEngineForm_container_objectSpread(BookingEngineForm_container_objectSpread({}, Object(booking_selector["l" /* getCurrentResort */])(state)), props.resort),
    attendees: Object(booking_selector["n" /* getDetailedAttendees */])(state),
    tripInformation: Object(storeHelper["d" /* tripInformationSelector */])(state),
    suggestions: Object(booking_selector["z" /* getSuggestions */])(state)
  };
}
var BookingEngineForm_container_mapDispatchToProps = {
  clearProposals: proposals_action["e" /* clearProposals */],
  endLoading: globalLoader_action["c" /* endLoading */],
  startLoading: globalLoader_action["d" /* startLoading */],
  updateTripDateCriteria: tripDateCriteria_action["a" /* updateTripDateCriteria */],
  setDepartureDate: departureDate_action["a" /* setDepartureDate */],
  clearSelectedProposal: selectedProposalId_action["c" /* clearSelectedProposal */],
  selectProposal: selectedProposalId_action["d" /* selectProposal */],
  fetchProposalsAndRedirect: proposals_action["j" /* fetchProposalsAndRedirect */],
  setCms: cms_actions["d" /* setCms */],
  setAttendees: adults_action["c" /* setAttendees */],
  prepareBe: proposals_action["m" /* prepareBe */]
};
/* harmony default export */ var BookingEngineForm_container = (Object(es["c" /* connect */])(BookingEngineForm_container_mapStateToProps, BookingEngineForm_container_mapDispatchToProps)(booking_engine_form_BookingEngineForm));
// EXTERNAL MODULE: ./src/client/cms/toolkit/tracking/pageTracking.resolver.js + 2 modules
var pageTracking_resolver = __webpack_require__("9wHB");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tracking/pageTracking.descriptor.js


var pageTracking_descriptor_jsx = react_default.a.createElement;

function pageTracking_descriptor_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function pageTracking_descriptor_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      pageTracking_descriptor_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      pageTracking_descriptor_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









function DynamicPageLoadTracking(_ref) {
  var trackingData = _ref.trackingData; // $FlowFixMe

  return pageTracking_descriptor_jsx(TrackingPageLoad["a" /* TrackingPageLoad */], trackingData);
}

function pageTracking_descriptor_mapStateToProps(state, props) {
  var location = props.location,
      _props$trackingData = props.trackingData,
      trackingData = _props$trackingData === void 0 ? {} : _props$trackingData,
      _props$resort = props.resort,
      resort = _props$resort === void 0 ? {} : _props$resort;
  var _trackingData$isProdu = trackingData.isProductPage,
      isProductPage = _trackingData$isProdu === void 0 ? false : _trackingData$isProdu;
  if (!isProductPage) return {
    trackingData: trackingData
  };

  var _mapDefaultToCurrentB = BookingEngineForm_container_mapStateToProps(state, pageTracking_descriptor_objectSpread(pageTracking_descriptor_objectSpread({}, trackingData), {}, {
    location: location,
    resort: resort
  })),
      adultsNumber = _mapDefaultToCurrentB.adultsNumber,
      kids = _mapDefaultToCurrentB.kids,
      duration = _mapDefaultToCurrentB.duration;

  var kidsNumber = kids.length;
  delete trackingData.bookingCriteria;
  return {
    trackingData: pageTracking_descriptor_objectSpread(pageTracking_descriptor_objectSpread({}, trackingData), {}, {
      resortAdult: adultsNumber,
      resortChildren: kidsNumber,
      resortNightNumber: duration,
      resortTotalParticipant: adultsNumber + kidsNumber
    })
  };
}

var ConnectedDynamicPageLoadTracking = Object(es["c" /* connect */])(pageTracking_descriptor_mapStateToProps)(DynamicPageLoadTracking);

var pageTracking_descriptor_Component = function Component(props) {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  return pageTracking_descriptor_jsx(ConnectedDynamicPageLoadTracking, Object(esm_extends["a" /* default */])({}, props, {
    location: location
  }));
};

var pageTrackingDescriptor = {
  name: constants["F" /* PAGE_TRACKING */],
  component: pageTracking_descriptor_Component,
  props: pageTracking_resolver["a" /* pageTrackingResolver */].props,
  resolve: pageTracking_resolver["a" /* pageTrackingResolver */].resolve
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-placeholder/ImagePlaceholder.jsx
var ImagePlaceholder = __webpack_require__("D0nZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-icon/AdditionItemIcon.themes.js
var AdditionItemIcon_themes_themes = {
  "default": {
    thItemIcon: 'flex items-center justify-center h-full text-blue',
    thItemIconSize: '75%',
    thItemLabel: 'font-bold inline-flex items-center mt-2 text-base text-blue',
    thItemLabelIcon: 'rtl:ml-2'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-icon/AdditionItemIcon.jsx
var AdditionItemIcon_jsx = react_default.a.createElement;






function AdditionItemIcon(props) {
  var alt = props.alt,
      iconName = props.iconName,
      label = props.label,
      symbol = props.symbol,
      _props$ratioKey = props.ratioKey,
      ratioKey = _props$ratioKey === void 0 ? ratios_utils["a" /* default */].XL : _props$ratioKey,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  if (!iconName) return null;
  var _themes$theme = AdditionItemIcon_themes_themes[theme],
      thItemIcon = _themes$theme.thItemIcon,
      thItemIconSize = _themes$theme.thItemIconSize,
      thItemLabel = _themes$theme.thItemLabel,
      thItemLabelIcon = _themes$theme.thItemLabelIcon;
  return AdditionItemIcon_jsx(react["Fragment"], null, AdditionItemIcon_jsx(ImagePlaceholder["a" /* ImagePlaceholder */], {
    aspectRatio: 100 * ratios_utils["a" /* default */].values[ratioKey]
  }, AdditionItemIcon_jsx("div", {
    className: thItemIcon
  }, AdditionItemIcon_jsx(Icon["a" /* Icon */], {
    name: iconName,
    isNotSquare: true,
    width: thItemIconSize
  })), symbol), alt && AdditionItemIcon_jsx("span", {
    className: "sr-only"
  }, alt, " "), !!label && AdditionItemIcon_jsx("div", {
    className: thItemLabel,
    "data-testid": "AdditionItemIcon-label"
  }, label, AdditionItemIcon_jsx(Icon["a" /* Icon */], {
    className: thItemLabelIcon,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "1em"
  })));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-image/AdditionItemImage.themes.js
var AdditionItemImage_themes_themes = {
  "default": {
    thItemImage: 'relative',
    thItemLabel: 'flex items-baseline font-bold leading-normal mt-2 overflow-hidden text-base text-gray-darker',
    thItemLabelIcon: 'flex-shrink-0 text-blue rtl:mr-1',
    thItemLabelIconSize: '1em'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-image/AdditionItemImage.jsx
var AdditionItemImage_jsx = react_default.a.createElement;







function AdditionItemImage(props) {
  var _props$image = props.image,
      image = _props$image === void 0 ? {} : _props$image,
      label = props.label,
      symbol = props.symbol,
      _props$ratioKey = props.ratioKey,
      ratioKey = _props$ratioKey === void 0 ? ratios_utils["a" /* default */].XL : _props$ratioKey,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  if (!image.src) return null;
  var _themes$theme = AdditionItemImage_themes_themes[theme],
      thItemImage = _themes$theme.thItemImage,
      thItemLabel = _themes$theme.thItemLabel,
      thItemLabelIcon = _themes$theme.thItemLabelIcon,
      thItemLabelIconSize = _themes$theme.thItemLabelIconSize;
  return AdditionItemImage_jsx(react["Fragment"], null, AdditionItemImage_jsx("div", {
    className: classnames_default()('image-responsive-cell', thItemImage)
  }, AdditionItemImage_jsx(Image["a" /* default */], {
    altMsg: image.alt,
    imageUrl: image.src,
    ratioKey: ratioKey
  }), symbol), !!label && AdditionItemImage_jsx("div", {
    className: thItemLabel,
    "data-testid": "AdditionItemImage-label"
  }, AdditionItemImage_jsx(Icon["a" /* Icon */], {
    className: thItemLabelIcon,
    name: icons["a" /* ICONS */].CHECK,
    width: thItemLabelIconSize
  }), label));
}
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/Addition.themes.js
var Addition_themes_themes = {
  "default": {
    thRoot: '-mx-2',
    thList: 'reset-list flex max-w-full',
    thItem: 'flex-1 px-2 relative',
    thSymbol: 'absolute bg-white flex font-bold items-center justify-center leading-none -mx-2 p-2 rounded-full text-blue text-2xl top-1/2 rtl:-translate-50-x-reverse z-1',
    thSymbolStyle: {
      width: '2.8rem',
      height: '2.8rem'
    }
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/Addition.jsx

var Addition_jsx = react_default.a.createElement;

function Addition_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Addition_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Addition_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Addition_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function Addition(props) {
  var className = props.className,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      ratioKey = props.ratioKey,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  var filteredItems = items.filter(function (_ref) {
    var _ref$icon = _ref.icon,
        icon = _ref$icon === void 0 ? {} : _ref$icon,
        _ref$image = _ref.image,
        image = _ref$image === void 0 ? {} : _ref$image;
    return icon.name || image.src;
  });
  if (!filteredItems.length) return null;
  var _themes$theme = Addition_themes_themes[theme],
      thItem = _themes$theme.thItem,
      thList = _themes$theme.thList,
      thRoot = _themes$theme.thRoot,
      thSymbol = _themes$theme.thSymbol,
      thSymbolStyle = _themes$theme.thSymbolStyle;
  var width = 100 / filteredItems.length;
  return Addition_jsx("div", {
    className: classnames_default()(className, thRoot)
  }, Addition_jsx("ul", {
    className: thList
  }, filteredItems.map(function (_ref2, idx) {
    var _ref2$icon = _ref2.icon,
        icon = _ref2$icon === void 0 ? {} : _ref2$icon,
        image = _ref2.image,
        label = _ref2.label,
        _ref2$link = _ref2.link,
        link = _ref2$link === void 0 ? {} : _ref2$link;
    var isLink = !!link.url;
    var TagName = isLink ? DynamicLink["a" /* default */] : react["Fragment"];
    var tagProps = isLink ? Addition_objectSpread(Addition_objectSpread({}, link), {}, {
      className: 'block'
    }) : null;
    var symbol = idx > 0 ? Addition_jsx("div", {
      className: thSymbol,
      style: thSymbolStyle
    }, idx === filteredItems.length - 1 ? '=' : '+') : null;
    return Addition_jsx("li", {
      className: thItem,
      key: label,
      style: {
        maxWidth: "".concat(width, "%"),
        minWidth: "".concat(width, "%")
      }
    }, Addition_jsx(TagName, tagProps, icon.name ? Addition_jsx(AdditionItemIcon, {
      alt: icon.alt,
      iconName: icon.name,
      label: label,
      ratioKey: ratioKey,
      symbol: symbol,
      theme: theme
    }) : Addition_jsx(AdditionItemImage, {
      image: image,
      label: label,
      ratioKey: ratioKey,
      symbol: symbol,
      theme: theme
    })));
  })));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// CONCATENATED MODULE: ./src/client/components/widgets/all-inclusive-push/AllInclusivePush.jsx
var AllInclusivePush_jsx = react_default.a.createElement;







function AllInclusivePush(props) {
  var _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet;

  if (!items.length) {
    return null;
  }

  var filteredItems = items.filter(function (item) {
    return item.label || item.icon;
  });

  var _ref = filteredItems.pop() || {},
      _ref$icon = _ref.icon,
      lastIcon = _ref$icon === void 0 ? {} : _ref$icon,
      _ref$label = _ref.label,
      lastLabel = _ref$label === void 0 ? '' : _ref$label,
      _ref$link = _ref.link,
      lastLink = _ref$link === void 0 ? {} : _ref$link;

  return isTablet ? AllInclusivePush_jsx(Addition, {
    items: items
  }) : AllInclusivePush_jsx("ul", {
    className: "list-none p-0"
  }, filteredItems.map(function (_ref2) {
    var label = _ref2.label;
    return AllInclusivePush_jsx("li", {
      className: "flex items-center font-bold pb-2 text-base text-gray-darker",
      key: label
    }, AllInclusivePush_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-2",
      color: colors["a" /* COLORS */].BLUE,
      name: icons["a" /* ICONS */].CHECK,
      width: "1em"
    }), label);
  }), AllInclusivePush_jsx("li", {
    className: "flex flex-col mt-2"
  }, AllInclusivePush_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    isNotSquare: true,
    name: lastIcon.name,
    width: "40%"
  }), lastIcon.alt && AllInclusivePush_jsx("span", {
    className: "sr-only"
  }, lastIcon.alt, " "), AllInclusivePush_jsx(TextLink["a" /* TextLink */], {
    className: "mt-3 self-end",
    label: lastLabel,
    url: lastLink.url
  })));
}
// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// CONCATENATED MODULE: ./src/client/components/lines/all-inclusive-push-line/AllInclusivePushLine.jsx

var AllInclusivePushLine_jsx = react_default.a.createElement;




var AllInclusivePushLine_AllInclusivePushLine = function AllInclusivePushLine(_ref) {
  var id = _ref.id,
      title = _ref.title,
      _ref$lastItem = _ref.lastItem,
      lastItem = _ref$lastItem === void 0 ? {} : _ref$lastItem,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  if (!items.length) {
    return null;
  }

  return AllInclusivePushLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, AllInclusivePushLine_jsx(LineTitle["a" /* LineTitle */], null, title), AllInclusivePushLine_jsx(AllInclusivePush, {
    items: [].concat(Object(toConsumableArray["a" /* default */])(items.map(function (item) {
      return {
        image: {
          alt: '',
          src: item.mediaUrl
        },
        label: item.label,
        link: {
          url: item.link
        }
      };
    })), [{
      icon: {
        alt: lastItem.mediaAlt,
        name: lastItem.icon
      },
      label: lastItem.label,
      link: {
        url: lastItem.link
      }
    }])
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/all-inclusive-push/allInclusivePush.descriptor.js


var allInclusivePushDescriptor = {
  name: constants["a" /* ALL_INCLUSIVE_PUSH */],
  component: AllInclusivePushLine_AllInclusivePushLine
};
// EXTERNAL MODULE: ./src/client/components/frameworks/checked-list/CheckedList.jsx + 1 modules
var CheckedList = __webpack_require__("iiKe");

// CONCATENATED MODULE: ./src/client/components/lines/checklist-line/ChecklistLine.jsx

var ChecklistLine_jsx = react_default.a.createElement;



function ChecklistLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  return ChecklistLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, ChecklistLine_jsx(CheckedList["a" /* CheckedList */], props));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/checklist/checklist.descriptor.js


var checklistDescriptor = {
  name: constants["d" /* CHECKLIST */],
  component: ChecklistLine
};
// CONCATENATED MODULE: ./src/client/components/widgets/crisis-alert/CrisisAlert.jsx
var CrisisAlert_jsx = react_default.a.createElement;




var CrisisAlert_CrisisAlert = function CrisisAlert(_ref) {
  var linkLabel = _ref.linkLabel,
      linkUrl = _ref.linkUrl,
      message = _ref.message;

  if (!message) {
    return null;
  }

  return CrisisAlert_jsx(Notification["a" /* Notification */], {
    color: colors["a" /* COLORS */].WARNING,
    hasBorder: true,
    text: message
  }, CrisisAlert_jsx(TextLink["a" /* TextLink */], {
    className: "uppercase",
    label: linkLabel,
    url: linkUrl
  }));
};
// CONCATENATED MODULE: ./src/client/components/lines/crisis-alert-line/CrisisAlertLine.jsx

var CrisisAlertLine_jsx = react_default.a.createElement;



function CrisisAlertLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  if (!props.message) {
    return null;
  }

  return CrisisAlertLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, CrisisAlertLine_jsx(CrisisAlert_CrisisAlert, {
    message: props.message,
    linkLabel: props.link.label,
    linkUrl: props.link.url
  }));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/crisis-alert/crisisAlert.descriptor.js


var crisisAlertDescriptor = {
  name: constants["i" /* CRISIS_ALERT */],
  component: CrisisAlertLine
};
// EXTERNAL MODULE: ./src/client/components/utils/feature-testing/index.js
var feature_testing = __webpack_require__("qlAI");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.themes.js


function Slider_themes_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function Slider_themes_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      Slider_themes_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      Slider_themes_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var NAV_POSITION_CLASSES = {
  bottom: {
    thControls: 'flex justify-end -mx-1 mt-2',
    thControl: 'mx-1'
  },
  center: {
    thInner: 'relative',
    thControls: 'z-2 absolute flex justify-between pointer-events-none top-1/2 -translate-y-50 w-full',
    thControl: 'pointer-events-auto click-zone-lg',
    thControlLeft: '-translate-x-50',
    thControlRight: 'translate-x-50',
    thControlDisabled: 'invisible'
  },
  side: {
    thRoot: 'flex',
    thInner: 'flex-1',
    thControls: 'flex px-1',
    thControl: 'mx-1'
  },
  top: {
    thRoot: 'flex flex-col',
    thControls: 'flex justify-end -mx-1 mb-2 -order-1',
    thControl: 'mx-1'
  }
};
var Slider_themes_themes = {
  "default": function _default(_ref) {
    var navPosition = _ref.navPosition;
    return Slider_themes_objectSpread(Slider_themes_objectSpread({}, NAV_POSITION_CLASSES[navPosition]), {}, {
      thControlColor: colors["a" /* COLORS */].WHITE,
      thControlColorBg: colors["a" /* COLORS */].BLUE
    });
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.jsx


var Slider_jsx = react_default.a.createElement;








if ( true && typeof document !== 'undefined' && // $FlowFixMe
!('scrollBehavior' in document.documentElement.style)) {
  // $FlowFixMe
  __webpack_require__("5siB").polyfill();
}

function Slider(props) {
  var className = props.className,
      children = props.children,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      hasControls = props.hasControls,
      hasTabindex = props.hasTabindex,
      id = props.id,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$navPosition = props.navPosition,
      navPosition = _props$navPosition === void 0 ? 'top' : _props$navPosition,
      _props$nbItemsToScrol = props.nbItemsToScroll,
      nbItemsToScroll = _props$nbItemsToScrol === void 0 ? 1 : _props$nbItemsToScrol,
      nextLabel = props.nextLabel,
      onChangeIndex = props.onChangeIndex,
      onNext = props.onNext,
      onPrevious = props.onPrevious,
      previousLabel = props.previousLabel,
      scrollAreaClassName = props.scrollAreaClassName,
      scrollAreaContainerClassName = props.scrollAreaContainerClassName,
      scrollControlsClassName = props.scrollControlsClassName,
      scrollItemClassName = props.scrollItemClassName,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  var childrenCount = react["Children"].count(children);
  var containerRef = Object(react["useRef"])(null);
  var refsArray = Object(react["useRef"])([]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var _useState = Object(react["useState"])(initialIndex),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])({
    hasReachedLeft: false,
    hasReachedRight: false
  }),
      reachedX = _useState2[0],
      setReachedX = _useState2[1];

  var _useState3 = Object(react["useState"])(react["Children"].map(children, function () {
    return false;
  })),
      hiddenIndexes = _useState3[0],
      setHiddenIndexes = _useState3[1];

  var _useState4 = Object(react["useState"])(null),
      prevInitialIndex = _useState4[0],
      setPrevInitialIndex = _useState4[1];

  Object(react["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  var getHiddenIndexes = function getHiddenIndexes() {
    if (cols > 0) {
      return;
    }

    if (containerRef.current) {
      var _containerRef$current = containerRef.current,
          clientWidth = _containerRef$current.clientWidth,
          scrollLeft = _containerRef$current.scrollLeft,
          containerOffsetLeft = _containerRef$current.offsetLeft;
      var indexes = refsArray.current.filter(Boolean).map(function (_ref) {
        var offsetLeft = _ref.offsetLeft,
            offsetWidth = _ref.offsetWidth;
        return offsetLeft < scrollLeft + containerOffsetLeft || offsetLeft + offsetWidth > scrollLeft + containerOffsetLeft + clientWidth;
      });
      setHiddenIndexes(indexes);
    }
  };

  var getReachedX = function getReachedX() {
    if (containerRef.current) {
      var _containerRef$current2 = containerRef.current,
          clientWidth = _containerRef$current2.clientWidth,
          scrollLeft = _containerRef$current2.scrollLeft,
          scrollWidth = _containerRef$current2.scrollWidth;

      var _hasReachedLeft = scrollLeft === 0;

      var _hasReachedRight = scrollLeft + clientWidth >= scrollWidth;

      setReachedX({
        hasReachedLeft: _hasReachedLeft,
        hasReachedRight: _hasReachedRight
      });
    }
  }; // get index in possible range


  var getSafeIndex = function getSafeIndex(idx) {
    if (idx < 0) {
      return 0;
    }

    var maxIndex = cols > 0 ? childrenCount - cols : childrenCount - 1;
    return idx > maxIndex ? maxIndex : idx;
  };

  var scrollToIndex = function scrollToIndex(index, e) {
    var _containerRef$current3;

    if (e) {
      e.preventDefault();
    }

    var idx = getSafeIndex(index);
    var scrollValue = refsArray.current.slice(0, idx).reduce(function (v, ref) {
      // $FlowFixMe
      return v + ref.offsetWidth;
    }, 0);

    if ((_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.scrollTo) {
      containerRef.current.scrollTo({
        behavior: 'smooth',
        left: scrollValue
      });
    }
  };

  Object(react["useEffect"])(function () {
    getReachedX();
    getHiddenIndexes();
    scrollToIndex(initialIndex);
    setPrevInitialIndex(initialIndex);
  }, [children]);
  Object(react["useEffect"])(function () {
    if (initialIndex !== prevInitialIndex) {
      scrollToIndex(initialIndex);
      setPrevInitialIndex(initialIndex);
    }
  }, [initialIndex]);

  if (!childrenCount) {
    return null;
  }

  var onScroll = Object(lodash["throttle"])(function () {
    getReachedX();
    getHiddenIndexes(); // $FlowFixMe

    var _containerRef$current4 = containerRef.current,
        offsetLeft = _containerRef$current4.offsetLeft,
        scrollLeft = _containerRef$current4.scrollLeft;
    var positions = refsArray.current.filter(Boolean).map(function (ref) {
      return ref.offsetLeft;
    });
    var closest = positions.reduce(function (prev, curr) {
      return Math.abs(curr - scrollLeft) < Math.abs(prev - scrollLeft) ? curr : prev;
    }, offsetLeft);
    var pos = positions.indexOf(closest);

    if (activeIndex > pos) {
      onPrevious && onPrevious();
    } else if (activeIndex < pos) {
      onNext && onNext();
    }

    if (pos > -1) {
      setActiveIndex(pos);
      var el = refsArray.current[pos]; // $FlowFixMe

      var elFocused = hasTabindex ? el : el.firstChild; // $FlowFixMe

      elFocused.focus({
        preventScroll: true
      });
    }
  }, 250);

  var _themes$theme = Slider_themes_themes[theme]({
    navPosition: navPosition
  }),
      thControl = _themes$theme.thControl,
      thControlLeft = _themes$theme.thControlLeft,
      thControlRight = _themes$theme.thControlRight,
      thControlColor = _themes$theme.thControlColor,
      thControlColorBg = _themes$theme.thControlColorBg,
      thControlDisabled = _themes$theme.thControlDisabled,
      thControls = _themes$theme.thControls,
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;

  var hasReachedLeft = reachedX.hasReachedLeft,
      hasReachedRight = reachedX.hasReachedRight;
  var isSnapScrollDisabled = isRTL && Object(feature_testing["a" /* hasTouch */])();
  return Slider_jsx("div", {
    className: classnames_default()(className, thRoot, 'relative', {
      '-scale-x-1': isRTL
    }),
    dir: "ltr",
    id: id
  }, Slider_jsx("div", {
    className: classnames_default()('h-full', thInner)
  }, Slider_jsx("div", {
    className: scrollAreaClassName
  }, Slider_jsx("div", {
    className: classnames_default()('flex flex-row flex-no-wrap w-full', scrollAreaContainerClassName),
    onScroll: onScroll,
    ref: containerRef
  }, react["Children"].map(children, function (child, idx) {
    var _classnames;

    var isHidden = cols > 0 ? idx < activeIndex || idx >= activeIndex + cols : hiddenIndexes[idx];
    return Slider_jsx("div", Object(esm_extends["a" /* default */])({
      "aria-hidden": isHidden,
      className: classnames_default()(Object(lodash["isFunction"])(scrollItemClassName) ? scrollItemClassName(idx) : scrollItemClassName, 'image-responsive-cell', (_classnames = {
        'scroll-snap-align-start': !isSnapScrollDisabled
      }, Object(defineProperty["a" /* default */])(_classnames, "w-1/".concat(cols), cols > 1), Object(defineProperty["a" /* default */])(_classnames, 'w-full', cols === 1), Object(defineProperty["a" /* default */])(_classnames, '-scale-x-1', isRTL), _classnames)),
      key: idx,
      ref: function ref(_ref2) {
        refsArray.current[idx] = _ref2;
      }
    }, hasTabindex ? {
      tabIndex: -1
    } : null), /*#__PURE__*/Object(react["cloneElement"])(child, {
      dir: isRTL ? 'rtl' : 'ltr',
      isHidden: isHidden
    }));
  })))), hasControls && !(hasReachedLeft && hasReachedRight) && Slider_jsx("div", {
    className: classnames_default()(scrollControlsClassName, thControls)
  }, Slider_jsx(ArrowButton["a" /* ArrowButton */], {
    className: classnames_default()(thControl, thControlLeft, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedLeft)),
    color: thControlColor,
    colorBg: thControlColorBg,
    hasNoRtl: true,
    isDisabled: hasReachedLeft,
    label: previousLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex - nbItemsToScroll, e);
    }
  }), Slider_jsx(ArrowButton["a" /* ArrowButton */], {
    className: classnames_default()(thControl, thControlRight, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedRight)),
    color: thControlColor,
    colorBg: thControlColorBg,
    hasNoRtl: true,
    isDisabled: hasReachedRight,
    label: nextLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex + nbItemsToScroll, e);
    },
    rotation: 180
  })));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// CONCATENATED MODULE: ./src/client/components/lines/destinations-line/DestinationsLine.utils.js



function DestinationsLine_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function DestinationsLine_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      DestinationsLine_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      DestinationsLine_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var TOP_DESTINATIONS_AREA_ID = 'top-destinations';
var DestinationsLine_utils_getPricedDestinations = function getPricedDestinations(destinations) {
  var pricedAreas = [];
  var pricedCountries = [];
  destinations === null || destinations === void 0 ? void 0 : destinations.forEach(function (area) {
    var _area$countries;

    var areaPrice = {};
    var types = {
      isCruise: area.isCruise,
      isJoyview: area.isJoyview,
      isTour: area.isTour
    };
    area === null || area === void 0 ? void 0 : (_area$countries = area.countries) === null || _area$countries === void 0 ? void 0 : _area$countries.forEach(function (country) {
      if (country.products.length > 0) {
        var countryPrice = {};
        country.products.forEach(function (_ref) {
          var _areaPrice$bestPrice, _countryPrice$bestPri, _price$bestPrice;

          var id = _ref.id,
              href = _ref.href,
              price = _ref.price,
              comfort = _ref.comfort;
          var areaPriceValue = (_areaPrice$bestPrice = areaPrice.bestPrice) === null || _areaPrice$bestPrice === void 0 ? void 0 : _areaPrice$bestPrice.value;
          var countryPriceValue = (_countryPrice$bestPri = countryPrice.bestPrice) === null || _countryPrice$bestPri === void 0 ? void 0 : _countryPrice$bestPri.value;
          var productPriceValue = price === null || price === void 0 ? void 0 : (_price$bestPrice = price.bestPrice) === null || _price$bestPrice === void 0 ? void 0 : _price$bestPrice.value;

          if (!areaPriceValue || productPriceValue && areaPriceValue > productPriceValue) {
            areaPrice = DestinationsLine_utils_objectSpread(DestinationsLine_utils_objectSpread({}, price), {}, {
              productId: id,
              productComfort: comfort,
              productHref: href,
              countryId: country.id
            });
          }

          if (!countryPriceValue || productPriceValue && countryPriceValue > productPriceValue) {
            countryPrice = DestinationsLine_utils_objectSpread(DestinationsLine_utils_objectSpread({}, price), {}, {
              productId: id,
              productHref: href,
              productComfort: comfort
            });
          }
        });
        pricedCountries.push(DestinationsLine_utils_objectSpread({
          id: country.id,
          label: Object(lodash["capitalize"])(country.label),
          price: countryPrice
        }, types));
      }
    });
    var areaLabel = area.label;
    pricedAreas.push(DestinationsLine_utils_objectSpread({
      id: area.id,
      label: areaLabel.charAt(0).toUpperCase() + areaLabel.slice(1),
      price: areaPrice
    }, types));
  });
  return {
    pricedAreas: pricedAreas,
    pricedCountries: pricedCountries
  };
};
var DestinationsLine_utils_getTopDestinations = function getTopDestinations(topDestinations, _ref2) {
  var _ref3;

  var pricedAreas = _ref2.pricedAreas,
      pricedCountries = _ref2.pricedCountries;

  var areaDestinations = (_ref3 = []).concat.apply(_ref3, Object(toConsumableArray["a" /* default */])(topDestinations.destinations.map(function (destination) {
    return Object.values(destination);
  })));

  return {
    areaId: TOP_DESTINATIONS_AREA_ID,
    areaLabel: topDestinations.label,
    destinations: areaDestinations.reduce(function (destinations, destination) {
      var pricedDestination = pricedAreas.find(function (area) {
        return area.id === destination.id;
      }) || pricedCountries.find(function (country) {
        return country.id === destination.id;
      });

      if (pricedDestination) {
        destinations.push(DestinationsLine_utils_objectSpread(DestinationsLine_utils_objectSpread({}, pricedDestination), destination));
      }

      return destinations;
    }, [])
  };
};
var getOtherDestinations = function getOtherDestinations(otherDestinations, _ref4) {
  var pricedAreas = _ref4.pricedAreas,
      pricedCountries = _ref4.pricedCountries;
  return otherDestinations.reduce(function (destinations, destination) {
    var pricedArea = pricedAreas.find(function (area) {
      return area.id === destination.id;
    });

    if (pricedArea) {
      destinations.push({
        areaId: pricedArea.id,
        areaLabel: pricedArea.label,
        destinations: destination.countries.reduce(function (countries, country) {
          var pricedCountry = pricedCountries.find(function (c) {
            return c.id === country.id;
          });

          if (pricedCountry) {
            countries.push(DestinationsLine_utils_objectSpread(DestinationsLine_utils_objectSpread({}, pricedCountry), country));
          }

          return countries;
        }, [])
      });
    }

    return destinations;
  }, []);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 10 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.mapper.js + 1 modules
var Product_mapper = __webpack_require__("bGCG");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx + 4 modules
var ProductPriceModal = __webpack_require__("yfdt");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// CONCATENATED MODULE: ./src/client/components/widgets/destinations/DestinationCard.jsx

var DestinationCard_jsx = react_default.a.createElement;















var DestinationCard_DestinationCard = function DestinationCard(_ref) {
  var id = _ref.id,
      index = _ref.index,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      label = _ref.label,
      lineName = _ref.lineName,
      link = _ref.link,
      mediaUrl = _ref.mediaUrl,
      price = _ref.price,
      trackingData = _ref.trackingData;

  var _useState = Object(react["useState"])(false),
      isHover = _useState[0],
      setHover = _useState[1];

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history,
      location = _useRouter.location;

  var track = Object(useTracking["a" /* useTracking */])(trackingData);
  var pageContext = react_default.a.useContext(context_pageContext["a" /* ReactPageContext */]);
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';

  var handleProductPriceModalClick = function handleProductPriceModalClick(e) {
    e.preventDefault(); // Prevent event from propagating to card link

    track({
      labelGA: "".concat(trackingData.labelGA, "_bestPrice")
    });
  };

  var handleProductPriceModalClickButton = function handleProductPriceModalClickButton(e) {
    e.preventDefault(); // Prevent event from propagating to card link

    track({
      labelGA: "".concat(trackingData.labelGA, "_discoverResort")
    });

    if (typeof index === 'number') {
      var _price$bestPrice;

      track({
        actionGA: 'clickThumbnail',
        labelGA: (price === null || price === void 0 ? void 0 : price.productId) ? "".concat(price.productId, "_discoverResort") : '_discoverResort',
        resortCode: (price === null || price === void 0 ? void 0 : price.productId) || '',
        resortTrident: typeof (price === null || price === void 0 ? void 0 : price.productComfort) === 'number' ? price.productComfort : '',
        thumbnailPrice: (price === null || price === void 0 ? void 0 : (_price$bestPrice = price.bestPrice) === null || _price$bestPrice === void 0 ? void 0 : _price$bestPrice.value) || '',
        thumbnailList: lineName ? "".concat(siteSection, "_").concat(Object(lodash["camelCase"])(lineName)) : siteSection,
        thumbnailPosition: index + 1
      });
    }

    if (price.productHref) {
      var productUrl = Object(uriUtils["f" /* generateUrlWithParams */])(price.productHref, {
        queryParams: location.queryParams
      });
      history.pushRoute(Object(Product_mapper["a" /* createProductUrlWithParams */])(productUrl, {
        isCruise: isCruise,
        isTour: isTour
      }));
    }
  };

  var handleFocus = function handleFocus() {
    setHover(true);
  };

  var handleBlur = function handleBlur() {
    setHover(false);
  };

  return DestinationCard_jsx("article", {
    className: "bg-gray-darker image-responsive-cell overflow-hidden relative rounded-tiny",
    "data-testid": "destination-card"
  }, DestinationCard_jsx(Image["a" /* default */], {
    altMsg: label,
    className: classnames_default()('transition-transform opacity-75', {
      'scale-105': isHover
    }),
    groupKey: "destinations",
    hasLazyLoading: true,
    imageUrl: mediaUrl,
    ratioKey: ratios_utils["a" /* default */].R_38_BY_28
  }), DestinationCard_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "absolute inset-0",
    "data-testid": "destination-card-".concat(id, "-link"),
    onBlur: handleBlur,
    onFocus: handleFocus,
    onMouseEnter: handleFocus,
    onMouseLeave: handleBlur,
    trackingData: trackingData,
    url: link
  }, DestinationCard_jsx("h3", {
    className: "absolute bottom-0 capitalize font-bold leading-tight p-2 pb-16 reset-heading text-center text-white text-xl w-full"
  }, label)), DestinationCard_jsx("div", {
    className: "absolute bottom-0 mb-8 w-full"
  }, DestinationCard_jsx(ProductPriceModal["a" /* ProductPriceModal */] // $FlowFixMe
  , Object(esm_extends["a" /* default */])({}, Object(Product_mapper["b" /* getProductPriceInfoProps */])({
    product: {
      price: price
    }
  }), {
    className: "m-1",
    isCruise: isCruise,
    isJoyview: isJoyview,
    isTour: isTour,
    onClick: handleProductPriceModalClick,
    onClickButton: handleProductPriceModalClickButton
  }), DestinationCard_jsx(Price["a" /* Price */], {
    bestPrice: price.bestPrice,
    className: "capitalize justify-center",
    containerStyle: {
      minHeight: '1.5rem'
    },
    from: Object(src_i18n["f" /* t */])('price.format.from'),
    theme: "instagram",
    unit: price.unit
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/destinations/Destinations.jsx


var Destinations_jsx = react_default.a.createElement;

function Destinations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Destinations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Destinations_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Destinations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var Destinations_Destinations = function Destinations(_ref) {
  var destinations = _ref.destinations,
      header = _ref.header,
      lineName = _ref.lineName,
      productType = _ref.productType,
      trackingData = _ref.trackingData;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(0),
      selectedDestinationIndex = _useState[0],
      setSelectedDestinationIndex = _useState[1];

  var _destinations$selecte = destinations[selectedDestinationIndex],
      selectedAreaId = _destinations$selecte.areaId,
      selectedAreaLabel = _destinations$selecte.areaLabel,
      selectedAreaDestinations = _destinations$selecte.destinations;
  return Destinations_jsx("div", {
    className: "flex flex-wrap w-full max-w-site"
  }, Destinations_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["f" /* t */])('common.scrollBackward'),
    childrenWrapperClassNames: "flex",
    className: "w-screen lg:w-full -mx-5 lg:mx-0 mb-4",
    forwardLabel: Object(src_i18n["f" /* t */])('common.scrollForward'),
    header: header,
    navPosition: "top"
  }, destinations.map(function (area, index) {
    return Destinations_jsx(Tag["a" /* Tag */], {
      active: index === selectedDestinationIndex,
      borderColor: index === selectedDestinationIndex ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].GRAY_LIGHT,
      className: classnames_default()('rtl:mr-2 mb-2', {
        'rtl:ml-5 lg:rtl:ml-0': index === 0
      }),
      color: index === selectedDestinationIndex ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].GRAY_DARKER,
      key: area.areaId,
      label: area.areaLabel,
      onClick: function onClick() {
        return setSelectedDestinationIndex(index);
      },
      trackingData: Destinations_objectSpread(Destinations_objectSpread({}, trackingData), {}, {
        labelGA: area.areaId === TOP_DESTINATIONS_AREA_ID ? 'topDestinations_tab' : "".concat(area.areaLabel, "_tab")
      }),
      theme: "outlinedThin"
    });
  })), Destinations_jsx(Slider, {
    className: "w-screen lg:w-full -mx-5 lg:mx-0",
    cols: 0,
    hasControls: isDesktop && selectedAreaDestinations.length > 3,
    navPosition: "center",
    nbItemsToScroll: isTablet ? 2 : 1,
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous'),
    scrollAreaContainerClassName: "overflow-x-auto lg:overflow-hidden",
    scrollControlsClassName: "-mx-5 lg:mx-0"
  }, selectedAreaDestinations.map(function (destination, index) {
    return Destinations_jsx("div", {
      key: destination.id,
      className: classnames_default()('relative rtl:mr-5', {
        'rtl:ml-5 lg:rtl:ml-0': index === 0,
        'lg:rtl:mr-0': index === selectedAreaDestinations.length - 1
      }),
      style: {
        width: '55vw',
        maxWidth: '280px'
      }
    }, Destinations_jsx(DestinationCard_DestinationCard, Object(esm_extends["a" /* default */])({}, destination, {
      index: index,
      lineName: lineName,
      productType: productType,
      trackingData: Destinations_objectSpread(Destinations_objectSpread({}, trackingData), {}, {
        labelGA: selectedAreaId === TOP_DESTINATIONS_AREA_ID ? "topDestinations_".concat(destination.label) : "".concat(selectedAreaLabel, "_").concat(destination.label)
      })
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/destinations-line/DestinationsLine.jsx


var DestinationsLine_jsx = react_default.a.createElement;

function DestinationsLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function DestinationsLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DestinationsLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DestinationsLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var DestinationsLine_DestinationsLine = function DestinationsLine(_ref) {
  var areas = _ref.areas,
      config = _ref.config,
      destinations = _ref.destinations,
      id = _ref.id,
      productType = _ref.productType,
      _ref$seeAllDestinatio = _ref.seeAllDestinationsLink,
      seeAllDestinationsLabel = _ref$seeAllDestinatio.label,
      seeAllDestinationsUrl = _ref$seeAllDestinatio.url,
      title = _ref.title,
      topDestinations = _ref.topDestinations,
      _ref$viewMapLink = _ref.viewMapLink,
      viewMapLabel = _ref$viewMapLink.label,
      viewMapUrl = _ref$viewMapLink.url;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  Object(src_i18n["a" /* addTranslationKeys */])(config);

  var _getPricedDestination = DestinationsLine_utils_getPricedDestinations(destinations),
      pricedAreas = _getPricedDestination.pricedAreas,
      pricedCountries = _getPricedDestination.pricedCountries;

  var topAreas = DestinationsLine_utils_getTopDestinations(topDestinations, {
    pricedAreas: pricedAreas,
    pricedCountries: pricedCountries
  });
  var otherAreas = getOtherDestinations(areas, {
    pricedAreas: pricedAreas,
    pricedCountries: pricedCountries
  });
  var allAreas = [topAreas].concat(Object(toConsumableArray["a" /* default */])(otherAreas));
  var trackingData = {
    actionGA: 'push_content_destinations'
  };
  var hasAllDestinationsLink = Boolean(seeAllDestinationsLabel) && Boolean(seeAllDestinationsUrl);
  var hasViewMapLink = Boolean(viewMapLabel) && Boolean(viewMapUrl);

  var header = DestinationsLine_jsx(react["Fragment"], null, DestinationsLine_jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), DestinationsLine_jsx("div", {
    className: "m-auto md:mx-0 mt-4 md:mt-1 order-last md:order-none"
  }, hasViewMapLink && DestinationsLine_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: DestinationsLine_objectSpread(DestinationsLine_objectSpread({}, trackingData), {}, {
      labelGA: 'viewMap'
    }),
    url: viewMapUrl
  }, viewMapLabel), hasAllDestinationsLink && DestinationsLine_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: classnames_default()('text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline', {
      'rtl:ml-4': hasViewMapLink
    }),
    trackingData: DestinationsLine_objectSpread(DestinationsLine_objectSpread({}, trackingData), {}, {
      labelGA: 'seeAllDestinations'
    }),
    url: seeAllDestinationsUrl
  }, seeAllDestinationsLabel)));

  var desktopHeader = isDesktop ? DestinationsLine_jsx("div", {
    className: "flex justify-between w-full"
  }, header) : null;
  return DestinationsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, DestinationsLine_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, isDesktop ? null : header, DestinationsLine_jsx(Destinations_Destinations, {
    destinations: allAreas,
    header: desktopHeader,
    lineName: constants["l" /* DESTINATIONS */],
    productType: productType,
    trackingData: trackingData
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/destinations/destinations.resolver.js
var destinations_resolver = __webpack_require__("bEXL");

// CONCATENATED MODULE: ./src/client/cms/toolkit/destinations/destinations.descriptor.js



var destinationsDescriptor = {
  name: constants["l" /* DESTINATIONS */],
  component: DestinationsLine_DestinationsLine,
  resolver: destinations_resolver["a" /* destinationsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/frameworks/download-links-list/DownloadLinksList.themes.js
var DownloadLinksList_themes_themes = {
  "default": {
    thRoot: 'flex flex-col sm:flex-row sm:items-center',
    thLabel: 'flex flex-col sm:flex-row sm:flex-1 items-center sm:rtl:mr-5 text-center',
    thLabelIconSize: '1.25rem',
    thText: 'font-bold mt-2 sm:mt-0 sm:rtl:ml-2',
    thList: 'reset-list flex flex-col sm:flex-row flex-shrink-0 flex-start',
    thListItem: 'flex justify-center mt-4 sm:mt-0 sm:px-3',
    thListItemIcon: 'flex-shrink-0 rtl:mr-1',
    thLink: 'reset-anchor inline-flex flex-row-reverse font-bold items-center text-blue hover:text-blue-active focus:text-blue-active text-sm transition-color underline uppercase'
  },
  lite: {
    thRoot: 'flex flex-col sm:flex-row sm:items-center',
    thLabel: 'flex flex-row items-center sm:rtl:mr-5',
    thLabelIconSize: '1rem',
    thText: 'font-bold mt-2 sm:mt-0 rtl:ml-2',
    thList: 'reset-list flex flex-col sm:flex-row flex-shrink-0 sm:-mx-1',
    thListItem: 'flex items-center sm:mt-0 sm:px-1 text-blue w-full sm:w-auto',
    thListItemIcon: 'flex-shrink-0 rtl:mr-1',
    thListItemIconSize: '1.3rem',
    thLink: 'reset-anchor inline-block font-bold items-center text-blue hover:text-blue-active focus:text-blue-active text-md transition-color underline w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/download-links-list/DownloadLinksList.jsx
var DownloadLinksList_jsx = react_default.a.createElement;









function DownloadLinksList(props) {
  var className = props.className,
      _props$links = props.links,
      links = _props$links === void 0 ? [] : _props$links,
      text = props.text,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;

  if (!links.length) {
    return null;
  }

  var _themes$theme = DownloadLinksList_themes_themes[theme],
      thLabel = _themes$theme.thLabel,
      thLabelIconSize = _themes$theme.thLabelIconSize,
      thLink = _themes$theme.thLink,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thListItemIcon = _themes$theme.thListItemIcon,
      thListItemIconSize = _themes$theme.thListItemIconSize,
      thRoot = _themes$theme.thRoot,
      thText = _themes$theme.thText;
  return DownloadLinksList_jsx("section", {
    className: classnames_default()(className, thRoot)
  }, !!text && DownloadLinksList_jsx("div", {
    className: thLabel
  }, DownloadLinksList_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].DOWNLOAD,
    width: thLabelIconSize
  }), DownloadLinksList_jsx(Text["a" /* Text */], {
    className: thText,
    text: text
  })), DownloadLinksList_jsx("ul", {
    className: thList
  }, links.map(function (_ref) {
    var iconName = _ref.iconName,
        label = _ref.label,
        onClick = _ref.onClick,
        target = _ref.target,
        trackingData = _ref.trackingData,
        url = _ref.url;
    return url && label ? DownloadLinksList_jsx("li", {
      className: thListItem,
      key: label
    }, DownloadLinksList_jsx(Icon["a" /* Icon */], {
      className: thListItemIcon,
      name: iconName,
      width: thListItemIconSize
    }), DownloadLinksList_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      trackingData: trackingData,
      className: thLink,
      onClick: onClick,
      target: target,
      url: url
    }, label)) : null;
  })));
}
// CONCATENATED MODULE: ./src/client/components/lines/download-links-list-line/DownloadLinksListLine.jsx
var DownloadLinksListLine_jsx = react_default.a.createElement;



var DownloadLinksListLine_DownloadLinksListLine = function DownloadLinksListLine(_ref) {
  var id = _ref.id,
      _ref$links = _ref.links,
      links = _ref$links === void 0 ? [] : _ref$links,
      text = _ref.text;

  if (!links.length) {
    return null;
  }

  return DownloadLinksListLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-DownloadLinksList",
    id: id
  }, DownloadLinksListLine_jsx(DownloadLinksList, {
    className: "bg-white py-5 shadow-bottom",
    links: links,
    text: text
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/download-links-list/downloadLinksList.descriptor.js


var downloadLinksListDescriptor = {
  name: constants["m" /* DOWNLOAD_LINKS_LIST */],
  component: DownloadLinksListLine_DownloadLinksListLine
};
// EXTERNAL MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx + 1 modules
var CollapsePanel = __webpack_require__("gA51");

// EXTERNAL MODULE: ./src/client/cms/toolkit/editorial-folding-block/collapsePanel.resolver.js
var collapsePanel_resolver = __webpack_require__("+BJN");

// CONCATENATED MODULE: ./src/client/cms/toolkit/editorial-folding-block/collapsePanel.descriptor.js
var collapsePanel_descriptor_jsx = react_default.a.createElement;







var panelProps = collapsePanel_resolver["a" /* props */];
var collapsePanel_descriptor_Panel = function Panel(_ref) {
  var displayed = _ref.displayed,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? collapsePanel_descriptor_jsx("div", null) : _ref$children,
      componentId = _ref.componentId,
      header = _ref.header,
      icon = _ref.icon,
      _ref$collapseLabel = _ref.collapseLabel,
      collapseLabel = _ref$collapseLabel === void 0 ? '' : _ref$collapseLabel,
      _ref$expandLabel = _ref.expandLabel,
      expandLabel = _ref$expandLabel === void 0 ? '' : _ref$expandLabel;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      hash = _useRouter.location.hash;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  var cleanedHash = hash && isAppMounted ? hash.split(uri_constants["b" /* HASH_PARAMS_DELIMITER */])[0] : null;
  var defaultExpanded = cleanedHash ? cleanedHash === "#".concat(componentId) : false;

  if (!displayed) {
    return null;
  }

  return collapsePanel_descriptor_jsx("div", {
    className: "Line Line-ProductInformation"
  }, collapsePanel_descriptor_jsx(SiteContainer["a" /* SiteContainer */], null, collapsePanel_descriptor_jsx(CollapsePanel["a" /* CollapsePanel */], {
    as: "h2",
    collapseLabel: collapseLabel,
    expandLabel: expandLabel,
    iconName: icon,
    id: componentId,
    isExpanded: defaultExpanded,
    title: header,
    trackingData: {
      actionGA: 'blockInfos',
      labelGA: componentId
    }
  }, children)));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/editorial-folding-block/editorialFoldingBlock.resolver.js
var editorialFoldingBlock_resolver = __webpack_require__("3OB6");

// CONCATENATED MODULE: ./src/client/cms/toolkit/editorial-folding-block/editorialFoldingBlock.descriptor.js
var editorialFoldingBlock_descriptor_jsx = react_default.a.createElement;





var editorialFoldingBlockDescriptor = {
  name: constants["n" /* EDITORIAL_FOLDING_BLOCK */],
  component: function component(props) {
    return editorialFoldingBlock_descriptor_jsx(Line, {
      component: collapsePanel_descriptor_Panel,
      props: props
    });
  },
  props: editorialFoldingBlock_resolver["a" /* editorialFoldingBlockResolver */].props
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 17 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/widgets/confirmation/Confirmation.jsx
var Confirmation = __webpack_require__("Fmrk");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: /home/circleci/project/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// CONCATENATED MODULE: ./src/client/components/widgets/event-form/eventForm.utils.js




var EVENT_TYPES = dist["constants"].EVENT_TYPES,
    USER_SALUTATIONS = dist["constants"].USER_SALUTATIONS;
var eventForm_utils_getInitialFormValues = function getInitialFormValues() {
  return {
    type: '',
    numberOfParticipants: '',
    withMeetingRooms: false,
    withRooms: false,
    withServices: false,
    withTransport: false,
    logisticsComment: '',
    region: '',
    resort: '',
    dates: {
      from: null,
      to: null
    },
    withFlexibleDates: false,
    company: '',
    salutation: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    postcode: '',
    city: '',
    country: '',
    generalComment: '',
    optinEmail: false,
    optinSMS: false,
    optinPhone: false
  };
};
var eventForm_utils_getEventQuery = function getEventQuery(values) {
  var address = values.address,
      city = values.city,
      company = values.company,
      country = values.country,
      dates = values.dates,
      email = values.email,
      firstName = values.firstName,
      generalComment = values.generalComment,
      lastName = values.lastName,
      logisticsComment = values.logisticsComment,
      numberOfParticipants = values.numberOfParticipants,
      optinEmail = values.optinEmail,
      optinPhone = values.optinPhone,
      optinSMS = values.optinSMS,
      phone = values.phone,
      postcode = values.postcode,
      resort = values.resort,
      salutation = values.salutation,
      type = values.type,
      withFlexibleDates = values.withFlexibleDates,
      withMeetingRooms = values.withMeetingRooms,
      withTransport = values.withTransport;
  var departureDate = dates.from ? "\"".concat(moment_default()(dates.from).format('YYYY-MM-DD'), "\"") : 'null';
  var returnDate = dates.to ? "\"".concat(moment_default()(dates.to).format('YYYY-MM-DD'), "\"") : 'null';
  return "mutation {\n    event(eventInput: {\n      address: \"".concat(address, "\",\n      city: \"").concat(city, "\",\n      company: \"").concat(company, "\",\n      country: \"").concat(country, "\",\n      departureDate: ").concat(departureDate, ",\n      email: \"").concat(email, "\",\n      firstName: \"").concat(firstName, "\",\n      generalComment: \"").concat(generalComment, "\",\n      lastName: \"").concat(lastName, "\",\n\t\t\tlogisticsComment: \"").concat(logisticsComment, "\",\n      numberOfParticipants: ").concat(numberOfParticipants, ",\n      optinEmail: ").concat(optinEmail.toString(), ",\n      optinPhone: ").concat(optinPhone.toString(), ",\n      optinSMS: ").concat(optinSMS.toString(), ",\n      phone: \"").concat(phone, "\",\n      postcode: \"").concat(postcode, "\",\n      resort: \"").concat(resort, "\",\n      returnDate: ").concat(returnDate, ",\n      salutation: ").concat(salutation, ",\n      type: ").concat(type, ",\n      withFlexibleDates: ").concat(withFlexibleDates.toString(), ",\n      withMeetingRooms: ").concat(withMeetingRooms.toString(), ",\n      withTransport: ").concat(withTransport.toString(), ",\n    }) {\n      __typename\n      ...on EventError {\n        statusCode\n        statusMessage\n        errorCode\n        errorDescription\n      }\n      ...on Event {\n        id\n      }\n    }\n  }");
};
var eventForm_utils_getEventSchema = function getEventSchema(resortIds) {
  return lib["object"]().shape({
    type: lib["mixed"]().oneOf(Object.keys(EVENT_TYPES)).required(Object(src_i18n["f" /* t */])('eventForm.packageSection.eventTypePlaceholder')),
    numberOfParticipants: lib["number"]().min(1, Object(src_i18n["f" /* t */])('eventForm.packageSection.numberOfParticipantsPlaceholder')).required(Object(src_i18n["f" /* t */])('eventForm.packageSection.numberOfParticipantsPlaceholder')),
    numberOfRooms: lib["number"]().min(1),
    withFlexibleDates: lib["boolean"](),
    withMeetingRooms: lib["boolean"](),
    withRooms: lib["boolean"](),
    withServices: lib["boolean"](),
    withTransport: lib["boolean"](),
    logisticsComment: lib["string"](),
    resort: lib["mixed"]().oneOf(resortIds),
    dates: lib["object"]().shape({
      from: lib["date"]().nullable(),
      to: lib["date"]().nullable()
    }),
    company: lib["string"](),
    salutation: lib["mixed"]().oneOf(Object.keys(USER_SALUTATIONS)).required(Object(src_i18n["f" /* t */])('eventForm.userSection.salutationPlaceholder')),
    firstName: lib["string"]().required(Object(src_i18n["f" /* t */])('eventForm.userSection.firstNamePlaceholder')),
    lastName: lib["string"]().required(Object(src_i18n["f" /* t */])('eventForm.userSection.lastNamePlaceholder')),
    email: lib["string"]().email(Object(src_i18n["f" /* t */])('eventForm.userSection.emailPlaceholder')).required(Object(src_i18n["f" /* t */])('eventForm.userSection.emailPlaceholder')),
    phone: lib["string"]().required(Object(src_i18n["f" /* t */])('eventForm.userSection.phonePlaceholder')),
    address: lib["string"]().required(Object(src_i18n["f" /* t */])('eventForm.userSection.streetPlaceholder')),
    postcode: lib["string"]().required(Object(src_i18n["f" /* t */])('eventForm.userSection.postcodePlaceholder')),
    city: lib["string"]().required(Object(src_i18n["f" /* t */])('eventForm.userSection.cityPlaceholder')),
    country: lib["string"]().required(Object(src_i18n["f" /* t */])('eventForm.userSection.countryPlaceholder')),
    generalComment: lib["string"](),
    optinEmail: lib["boolean"](),
    optinSMS: lib["boolean"](),
    optinPhone: lib["boolean"]()
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/event-form/EventForm.jsx




var EventForm_jsx = react_default.a.createElement;

function EventForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function EventForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { EventForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { EventForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var FORM_ACTIONS = {
  SUBMIT_EVENT: 'SUBMIT_EVENT',
  SUBMIT_EVENT_ERROR: 'SUBMIT_EVENT_ERROR',
  SUBMIT_EVENT_SUCCESS: 'SUBMIT_EVENT_SUCCESS'
};
var FORM_STATUS = {
  NEW: 'neutral',
  SUCCESS: 'success',
  ERROR: 'error'
};
var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var EventForm_EventForm = function EventForm(_ref) {
  var formError = _ref.formError,
      formSuccess = _ref.formSuccess,
      regions = _ref.regions,
      resorts = _ref.resorts,
      eventTypeOptions = _ref.eventTypeOptions,
      userSalutationOptions = _ref.userSalutationOptions;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: tracking_constants["j" /* MEETING_EVENT */].REQUEST
  });

  var _useReducer = Object(react["useReducer"])(function (state, action) {
    switch (action.type) {
      case FORM_ACTIONS.SUBMIT_EVENT:
        return EventForm_objectSpread(EventForm_objectSpread({}, state), {}, {
          isSending: true
        });

      case FORM_ACTIONS.SUBMIT_EVENT_ERROR:
        return {
          isSending: false,
          formStatus: FORM_STATUS.ERROR,
          confirmation: formError
        };

      case FORM_ACTIONS.SUBMIT_EVENT_SUCCESS:
        return {
          isSending: false,
          formStatus: FORM_STATUS.SUCCESS,
          confirmation: formSuccess
        };

      default:
        return state;
    }
  }, {
    isSending: false,
    formStatus: FORM_STATUS.NEW,
    confirmation: {}
  }),
      _useReducer$ = _useReducer[0],
      isSending = _useReducer$.isSending,
      formStatus = _useReducer$.formStatus,
      confirmation = _useReducer$.confirmation,
      dispatch = _useReducer[1];

  var openedResorts = resorts.filter(function (_ref2) {
    var openingStatus = _ref2.openingStatus;
    return openingStatus === OPENING_STATUS.OPEN;
  });
  return EventForm_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "py-10",
    id: "event-form"
  }, EventForm_jsx(LineTitle["a" /* LineTitle */], null, Object(src_i18n["f" /* t */])('eventForm.formTitle')), EventForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: eventForm_utils_getInitialFormValues(),
    validationSchema: eventForm_utils_getEventSchema(openedResorts.map(function (resort) {
      return resort.id;
    })),
    onSubmit: /*#__PURE__*/function () {
      var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values) {
        var query, labelGA, _yield$graphQLClient$, event;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: FORM_ACTIONS.SUBMIT_EVENT
                });
                query = eventForm_utils_getEventQuery(values);
                labelGA = values.resort || null;
                _context.prev = 3;
                _context.next = 6;
                return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
                  requestName: requestDictionary["Ld" /* WIDGET_EVENT_FORM_SUBMIT */]
                });

              case 6:
                _yield$graphQLClient$ = _context.sent;
                event = _yield$graphQLClient$.event;

                if (event.errorCode) {
                  dispatch({
                    type: FORM_ACTIONS.SUBMIT_EVENT_ERROR
                  });
                  track({
                    actionGA: tracking_constants["j" /* MEETING_EVENT */].SEND_REQUEST_ERROR,
                    labelGA: labelGA
                  });
                } else {
                  dispatch({
                    type: FORM_ACTIONS.SUBMIT_EVENT_SUCCESS
                  });
                  track({
                    actionGA: tracking_constants["j" /* MEETING_EVENT */].SEND_REQUEST_SUCCESS,
                    labelGA: labelGA
                  });
                }

                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);
                dispatch({
                  type: FORM_ACTIONS.SUBMIT_EVENT_ERROR
                });
                track({
                  actionGA: tracking_constants["j" /* MEETING_EVENT */].SEND_REQUEST_ERROR,
                  labelGA: labelGA
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 11]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()
  }, function (_ref4) {
    var values = _ref4.values,
        isValid = _ref4.isValid;
    return EventForm_jsx(formik_esm["c" /* Form */], {
      "data-testid": "form"
    }, EventForm_jsx(Title["a" /* Title */], {
      className: "mt-8 mb-3 px-2",
      color: colors["a" /* COLORS */].BLUE,
      hLevel: 3,
      theme: "title-sans-4"
    }, Object(src_i18n["f" /* t */])('eventForm.packageSection.title')), EventForm_jsx("div", {
      className: "flex flex-wrap"
    }, EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-type",
      isRequired: true,
      label: Object(src_i18n["f" /* t */])('eventForm.packageSection.eventTypeLabel'),
      name: "type",
      options: eventTypeOptions,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.packageSection.eventTypePlaceholder'),
      type: "select"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-participants",
      isRequired: true,
      label: Object(src_i18n["f" /* t */])('eventForm.packageSection.numberOfParticipantsLabel'),
      min: 1,
      name: "numberOfParticipants",
      optimized: true,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.packageSection.numberOfParticipantsPlaceholder'),
      type: "number"
    })), EventForm_jsx("p", {
      className: "w-full mb-2 px-2 pt-2 text-base font-bold"
    }, Object(src_i18n["f" /* t */])('eventForm.packageSection.packageServicesSection.packageServicesLabel')), EventForm_jsx("div", {
      className: "flex flex-wrap w-full md:w-1/2"
    }, EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-3",
      label: Object(src_i18n["f" /* t */])('eventForm.packageSection.packageServicesSection.roomsCheckboxLabel'),
      name: "withRooms",
      optimized: true,
      type: "checkbox"
    }), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      hideErrorMessage: true,
      isDisabled: !values.withRooms,
      isRequired: values.withRooms,
      label: Object(src_i18n["f" /* t */])('eventForm.packageSection.packageServicesSection.roomsInputLabel'),
      min: 1,
      name: "numberOfRooms",
      placeholder: Object(src_i18n["f" /* t */])('eventForm.packageSection.packageServicesSection.roomsInputPlaceholder'),
      type: "number"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-3",
      label: Object(src_i18n["f" /* t */])('eventForm.packageSection.packageServicesSection.transportationCheckboxLabel'),
      name: "withTransport",
      optimized: true,
      type: "checkbox"
    }), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      isDisabled: !values.withTransport,
      label: Object(src_i18n["f" /* t */])('eventForm.packageSection.packageServicesSection.transportationInputLabel'),
      name: "departureCity",
      placeholder: Object(src_i18n["f" /* t */])('eventForm.packageSection.packageServicesSection.transportationInputPlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-3",
      label: Object(src_i18n["f" /* t */])('eventForm.packageSection.packageServicesSection.meetingRoomsCheckboxLabel'),
      name: "withMeetingRooms",
      optimized: true,
      type: "checkbox"
    }))), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-3",
      label: Object(src_i18n["f" /* t */])('eventForm.packageSection.packageServicesSection.otherServicesCheckboxLabel'),
      name: "withServices",
      optimized: true,
      type: "checkbox"
    }), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      isDisabled: !values.withServices,
      label: Object(src_i18n["f" /* t */])('eventForm.packageSection.packageServicesSection.otherServicesInputLabel'),
      name: "logisticsComment",
      placeholder: Object(src_i18n["f" /* t */])('eventForm.packageSection.packageServicesSection.otherServicesInputPlaceholder'),
      type: "textarea"
    }))), EventForm_jsx(Title["a" /* Title */], {
      className: "mt-8 mb-3 px-2",
      color: colors["a" /* COLORS */].BLUE,
      hLevel: 3,
      theme: "title-sans-4"
    }, Object(src_i18n["f" /* t */])('eventForm.staySection.title')), EventForm_jsx("div", {
      className: "flex flex-wrap"
    }, EventForm_jsx("div", {
      className: "w-full md:w-1/2"
    }, EventForm_jsx("div", {
      className: "w-full p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-region",
      label: Object(src_i18n["f" /* t */])('eventForm.staySection.destinationLabel'),
      name: "region",
      options: regions.map(function (region) {
        return {
          name: region,
          value: region
        };
      }).sort(),
      placeholder: Object(src_i18n["f" /* t */])('eventForm.staySection.destinationPlaceholder'),
      type: "select"
    })), EventForm_jsx("div", {
      className: "w-full p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-resort",
      label: Object(src_i18n["f" /* t */])('eventForm.staySection.resortLabel'),
      name: "resort",
      options: openedResorts.filter(function (resort) {
        return !values.region || resort.region === values.region;
      }).map(function (resort) {
        return {
          name: resort.name,
          value: resort.id
        };
      }),
      placeholder: Object(src_i18n["f" /* t */])('eventForm.staySection.resortPlaceholder'),
      type: "select"
    }))), EventForm_jsx("div", {
      className: "w-full md:w-1/4 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      isDateRange: true,
      label: Object(src_i18n["f" /* t */])('eventForm.staySection.datesLabel'),
      name: "dates",
      placeholder: Object(src_i18n["f" /* t */])('eventForm.staySection.datesPlaceholder'),
      type: "datepicker"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/4 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-3 md:mt-9",
      label: Object(src_i18n["f" /* t */])('eventForm.staySection.flexibleDatesLabel'),
      name: "withFlexibleDates",
      type: "checkbox"
    }))), EventForm_jsx(Title["a" /* Title */], {
      className: "mt-8 mb-3 px-2",
      color: colors["a" /* COLORS */].BLUE,
      hLevel: 3,
      theme: "title-sans-4"
    }, Object(src_i18n["f" /* t */])('eventForm.userSection.title')), EventForm_jsx("div", {
      className: "flex flex-wrap"
    }, EventForm_jsx("div", {
      className: "w-full"
    }, EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-company",
      label: Object(src_i18n["f" /* t */])('eventForm.userSection.companyLabel'),
      name: "company",
      optimized: true,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.userSection.companyPlaceholder'),
      type: "text"
    }))), EventForm_jsx("div", {
      className: "w-1/2 md:w-1/6 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-salutation",
      isRequired: true,
      label: Object(src_i18n["f" /* t */])('eventForm.userSection.salutationLabel'),
      name: "salutation",
      optimized: true,
      options: userSalutationOptions,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.userSection.salutationPlaceholder'),
      type: "select"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/3 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-firstName",
      isRequired: true,
      label: Object(src_i18n["f" /* t */])('eventForm.userSection.firstNameLabel'),
      name: "firstName",
      optimized: true,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.userSection.firstNamePlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-lastName",
      isRequired: true,
      label: Object(src_i18n["f" /* t */])('eventForm.userSection.lastNameLabel'),
      name: "lastName",
      optimized: true,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.userSection.lastNamePlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-email",
      isRequired: true,
      label: Object(src_i18n["f" /* t */])('eventForm.userSection.emailLabel'),
      name: "email",
      optimized: true,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.userSection.emailPlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-phone",
      isRequired: true,
      label: Object(src_i18n["f" /* t */])('eventForm.userSection.phoneLabel'),
      name: "phone",
      optimized: true,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.userSection.phonePlaceholder'),
      type: "text"
    })), EventForm_jsx("p", {
      className: "w-full mb-2 px-2 pt-2 text-base font-bold"
    }, Object(src_i18n["f" /* t */])('eventForm.userSection.addressLabel')), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-address",
      isRequired: true,
      label: Object(src_i18n["f" /* t */])('eventForm.userSection.streetLabel'),
      name: "address",
      optimized: true,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.userSection.streetPlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-1/2 md:w-1/6 p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-postcode",
      isRequired: true,
      label: Object(src_i18n["f" /* t */])('eventForm.userSection.postcodeLabel'),
      name: "postcode",
      optimized: true,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.userSection.postcodePlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/3"
    }, EventForm_jsx("div", {
      className: "w-full p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-city",
      isRequired: true,
      label: Object(src_i18n["f" /* t */])('eventForm.userSection.cityLabel'),
      name: "city",
      optimized: true,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.userSection.cityPlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-country",
      isRequired: true,
      label: Object(src_i18n["f" /* t */])('eventForm.userSection.countryLabel'),
      name: "country",
      optimized: true,
      placeholder: Object(src_i18n["f" /* t */])('eventForm.userSection.countryPlaceholder'),
      type: "text"
    })))), EventForm_jsx(Title["a" /* Title */], {
      className: "mt-8 mb-3 px-2",
      color: colors["a" /* COLORS */].BLUE,
      hLevel: 3,
      theme: "title-sans-4"
    }, Object(src_i18n["f" /* t */])('eventForm.commentSection.title')), EventForm_jsx("div", {
      className: "flex flex-wrap"
    }, EventForm_jsx("div", {
      className: "w-full p-2"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      label: Object(src_i18n["f" /* t */])('eventForm.commentSection.commentLabel'),
      name: "generalComment",
      placeholder: Object(src_i18n["f" /* t */])('eventForm.commentSection.commentPlaceholder'),
      type: "textarea"
    })), EventForm_jsx("div", {
      className: "w-full p-2"
    }, EventForm_jsx("p", null, Object(src_i18n["f" /* t */])('eventForm.commentSection.optinLabel')), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-3",
      label: Object(src_i18n["f" /* t */])('eventForm.commentSection.emailOptinLabel'),
      name: "optinEmail",
      optimized: true,
      type: "checkbox"
    }), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-3",
      label: Object(src_i18n["f" /* t */])('eventForm.commentSection.smsOptinLabel'),
      name: "optinSMS",
      optimized: true,
      type: "checkbox"
    }), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-3",
      label: Object(src_i18n["f" /* t */])('eventForm.commentSection.phoneOptinLabel'),
      name: "optinPhone",
      optimized: true,
      type: "checkbox"
    }))), EventForm_jsx("div", {
      className: classnames_default()('mt-4', {
        'text-right': formStatus === FORM_STATUS.NEW,
        'flex justify-center': formStatus !== FORM_STATUS.NEW
      })
    }, formStatus === FORM_STATUS.NEW ? EventForm_jsx(Button["a" /* Button */], {
      colorBg: colors["a" /* COLORS */].BLUE,
      colorBorder: colors["a" /* COLORS */].BLUE,
      dataTestId: "event-submit",
      isDisabled: !isValid,
      isLoading: isSending,
      type: "submit"
    }, Object(src_i18n["f" /* t */])('eventForm.formButton')) : EventForm_jsx(Confirmation["a" /* Confirmation */], Object(esm_extends["a" /* default */])({}, confirmation, {
      status: formStatus
    }))));
  }));
};
// CONCATENATED MODULE: ./src/client/components/lines/event-form-line/EventFormLine.utils.js

var EventFormLine_utils_getEventFormResorts = function getEventFormResorts(resorts) {
  return Object(lodash["sortBy"])(Object(lodash["uniqBy"])(resorts, 'id').map(function (_ref) {
    var id = _ref.id,
        name = _ref.name,
        destination = _ref.destination,
        openingStatus = _ref.openingStatus;
    return {
      id: id,
      name: name,
      openingStatus: openingStatus,
      region: destination.area
    };
  }), function (resort) {
    return Object(lodash["toUpper"])(resort.name);
  });
};
var getEventFormRegions = function getEventFormRegions(resorts) {
  return Array.from(new Set(resorts.map(function (resort) {
    return resort.region;
  }))).sort();
};
// CONCATENATED MODULE: ./src/client/components/lines/event-form-line/EventFormLine.jsx
var EventFormLine_jsx = react_default.a.createElement;




function EventFormLine(props) {
  Object(src_i18n["a" /* addTranslationKeys */])({
    eventForm: props
  });
  var formError = props.formError,
      formSuccess = props.formSuccess,
      resorts = props.resorts,
      eventTypeOptions = props.packageSection.eventTypeOptions,
      salutationOptions = props.userSection.salutationOptions;
  var formResorts = EventFormLine_utils_getEventFormResorts(resorts);
  var formRegions = getEventFormRegions(formResorts);
  return EventFormLine_jsx(EventForm_EventForm, {
    formError: formError,
    formSuccess: formSuccess,
    regions: formRegions,
    resorts: formResorts,
    eventTypeOptions: eventTypeOptions,
    userSalutationOptions: salutationOptions
  });
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/event-form/eventForm.resolver.js
var eventForm_resolver = __webpack_require__("yWy0");

// CONCATENATED MODULE: ./src/client/cms/toolkit/event-form/eventForm.descriptor.js



var eventFormDescriptor = {
  name: constants["o" /* EVENT_FORM */],
  component: EventFormLine,
  resolve: eventForm_resolver["a" /* eventFormResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/button-ticket-line/ButtonTicketLine.jsx
var ButtonTicketLine_jsx = react_default.a.createElement;






var ButtonTicketLine_ButtonTicketLine = function ButtonTicketLine(_ref) {
  var buttonLabel = _ref.buttonLabel,
      buttonLink = _ref.buttonLink,
      title = _ref.title;

  var _useContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageType = _useContext.pageType;

  var trackingData = {
    categoryGA: pageType,
    actionGA: 'priceBar',
    labelGA: 'getAQuote'
  };
  return ButtonTicketLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-ButtonTicket"
  }, ButtonTicketLine_jsx("div", {
    className: "bg-white shadow-diffuse rounded-tiny border-1 border-gray-light flex items-center p-3 flex-col md:flex-row mt-8 md:mt-0"
  }, ButtonTicketLine_jsx(Text["a" /* Text */], {
    className: "flex-1 md:rtl:ml-2 text-center md:text-initial px-3 md:px-0",
    text: title
  }), ButtonTicketLine_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BOOKING,
    url: buttonLink,
    trackingData: trackingData,
    dataTestId: "getButtonTicketLineBtn",
    className: "w-full md:w-auto mt-4 sm:mt-0"
  }, buttonLabel)));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/button-ticket/buttonTicket.descriptor.js


var buttonTicketDescriptor = {
  name: constants["c" /* BUTTON_TICKET */],
  component: ButtonTicketLine_ButtonTicketLine
};
// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/FacetSearch.jsx + 32 modules
var FacetSearch = __webpack_require__("ontP");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx + 2 modules
var Hero = __webpack_require__("2B1m");

// CONCATENATED MODULE: ./src/client/components/lines/immersive-line/ImmersiveLine.jsx


var ImmersiveLine_jsx = react_default.a.createElement;




var ImmersiveLine_ImmersiveLine = function ImmersiveLine(_ref) {
  var backgroundURL = _ref.backgroundURL,
      config = _ref.config,
      _ref$displaySearch = _ref.displaySearch,
      displaySearch = _ref$displaySearch === void 0 ? false : _ref$displaySearch,
      id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["backgroundURL", "config", "displaySearch", "id"]);

  return ImmersiveLine_jsx(react["Fragment"], null, ImmersiveLine_jsx("div", {
    className: "Line Line-Immersive",
    id: id
  }, ImmersiveLine_jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, props, {
    hasOverlap: displaySearch,
    url: backgroundURL
  }))), displaySearch && ImmersiveLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-Search"
  }, ImmersiveLine_jsx(FacetSearch["a" /* FacetSearch */], {
    i18n: config,
    searchPageRouteName: "search",
    shouldRedirectToResortPage: true,
    withSearchForm: true
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/immersive/immersive.resolver.js
var immersive_resolver = __webpack_require__("pIL7");

// CONCATENATED MODULE: ./src/client/cms/toolkit/immersive/immersive.descriptor.js



var immersiveDescriptor = {
  name: constants["q" /* IMMERSIVE */],
  component: ImmersiveLine_ImmersiveLine,
  resolver: immersive_resolver["a" /* immersiveResolver */]
};
// CONCATENATED MODULE: ./src/client/components/frameworks/social-picture/SocialPicture.themes.js

var SocialPicture_themes_themes = {
  "default": {
    thRoot: 'relative',
    thIconContainer: 'absolute bottom-0 flex gradient-linear-transparent-black-80 items-center p-2 text-white w-full',
    thText: 'truncate rtl:ml-1',
    thIcon: 'flex-shrink-0',
    thIconWidth: 'calc(20rem / 16)',
    thIconColor: colors["a" /* COLORS */].WHITE,
    thImageLazyloading: false,
    thImageSize: {
      w: 1000
    },
    changeWidthButHeightIsAuto: true
  },
  cards: {
    thRoot: 'relative rounded-tiny overflow-hidden',
    thIconContainer: 'absolute flex items-center justify-end p-3 sm:p-5 top-0 text-white w-full',
    thText: 'truncate rtl:ml-1 text-sm font-bold',
    thIcon: 'flex-shrink-0',
    thIconWidth: '1rem',
    thIconColor: colors["a" /* COLORS */].WHITE,
    thImageLazyloading: true,
    thImageSize: {
      w: 500,
      h: 500
    },
    changeWidthButHeightIsAuto: false
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/social-picture/SocialPicture.jsx
var SocialPicture_jsx = react_default.a.createElement;






var SocialPicture_SocialPicture = function SocialPicture(_ref) {
  var className = _ref.className,
      src = _ref.src,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      userName = _ref.userName;

  if (!src) {
    return null;
  }

  var _themes$theme = SocialPicture_themes_themes[theme],
      thIcon = _themes$theme.thIcon,
      thIconColor = _themes$theme.thIconColor,
      thIconContainer = _themes$theme.thIconContainer,
      thIconWidth = _themes$theme.thIconWidth,
      thImageLazyloading = _themes$theme.thImageLazyloading,
      thImageSize = _themes$theme.thImageSize,
      thRoot = _themes$theme.thRoot,
      thText = _themes$theme.thText,
      changeWidthButHeightIsAuto = _themes$theme.changeWidthButHeightIsAuto;
  return SocialPicture_jsx("div", {
    className: classnames_default()(className, thRoot),
    "data-testid": "social-picture"
  }, SocialPicture_jsx(Image["a" /* default */], {
    changeWidthButHeightIsAuto: changeWidthButHeightIsAuto,
    className: "align-bottom w-full",
    forceImage: true,
    hasLazyLoading: thImageLazyloading,
    imageUrl: src,
    mandatoryWidthAndHeight: thImageSize,
    transformation: "resize"
  }), userName && SocialPicture_jsx("div", {
    className: thIconContainer
  }, SocialPicture_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    color: thIconColor,
    name: icons["a" /* ICONS */].INSTAGRAM,
    width: thIconWidth
  }), SocialPicture_jsx("span", {
    className: thText
  }, userName)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/instagram/InstagramCard.jsx


var InstagramCard_jsx = react_default.a.createElement;

function InstagramCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InstagramCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InstagramCard_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InstagramCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var InstagramCard_InstagramCard = function InstagramCard(_ref) {
  var _price$bestPrice;

  var comfort = _ref.comfort,
      href = _ref.href,
      id = _ref.id,
      index = _ref.index,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      lineName = _ref.lineName,
      name = _ref.name,
      price = _ref.price,
      socialPicture = _ref.socialPicture;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history,
      location = _useRouter.location;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'push_content_instagram',
    labelGA: id
  });
  var pageContext = react_default.a.useContext(context_pageContext["a" /* ReactPageContext */]);
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';
  var clickThumbnailTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: id,
    resortCode: id,
    resortTrident: comfort || '',
    thumbnailPrice: (price === null || price === void 0 ? void 0 : (_price$bestPrice = price.bestPrice) === null || _price$bestPrice === void 0 ? void 0 : _price$bestPrice.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(Object(lodash["camelCase"])(lineName)) : siteSection,
    thumbnailPosition: index + 1
  } : null;
  var hasPrice = !!price && (!!(price === null || price === void 0 ? void 0 : price.initialPrice) || !!(price === null || price === void 0 ? void 0 : price.bestPrice));

  var handleDynamicLinkClick = function handleDynamicLinkClick() {
    track({});

    if (clickThumbnailTrackingData) {
      track(clickThumbnailTrackingData);
    }
  };

  var handleProductPriceModalClick = function handleProductPriceModalClick(e) {
    e.preventDefault(); // Prevent event from propagating to card link

    e.stopPropagation(); // Prevent event from bubbling to Dynamic Link

    track({});

    if (clickThumbnailTrackingData) {
      track(InstagramCard_objectSpread(InstagramCard_objectSpread({}, clickThumbnailTrackingData), {}, {
        labelGA: "".concat(id, "_bestPrice")
      }));
    }
  };

  var handleProductPriceModalClickButton = function handleProductPriceModalClickButton(e) {
    e.preventDefault(); // Prevent event from propagating to card link

    e.stopPropagation(); // Prevent event from bubbling to Dynamic Link

    track({});

    if (clickThumbnailTrackingData) {
      track(InstagramCard_objectSpread(InstagramCard_objectSpread({}, clickThumbnailTrackingData), {}, {
        labelGA: "".concat(id, "_discoverResort")
      }));
    }

    if (href) {
      var productUrl = Object(uriUtils["f" /* generateUrlWithParams */])(href, {
        queryParams: location.queryParams
      });
      history.pushRoute(Object(Product_mapper["a" /* createProductUrlWithParams */])(productUrl, {
        isCruise: isCruise,
        isTour: isTour
      }));
    }
  };

  return InstagramCard_jsx("div", {
    className: classnames_default()('flex-none lg:flex-auto', {
      'rtl:ml-5': index !== 0
    }),
    style: {
      width: '60vw',
      maxWidth: '280px'
    }
  }, InstagramCard_jsx(DynamicLink["a" /* default */], {
    className: "block relative",
    "data-testid": "instagram-card-link",
    onClick: handleDynamicLinkClick,
    url: href
  }, InstagramCard_jsx(SocialPicture_SocialPicture, {
    src: socialPicture.imageLarge,
    theme: "cards",
    userName: socialPicture.userName
  }), InstagramCard_jsx("div", {
    className: "absolute gradient-linear-transparent-black-80 inset-x-0 bottom-0 py-3 sm:py-5 rounded-tiny text-white"
  }, InstagramCard_jsx("p", {
    className: "reset-paragraph font-brand px-3 sm:px-5 text-md sm:text-lg truncate"
  }, name), hasPrice && InstagramCard_jsx(ProductPriceModal["a" /* ProductPriceModal */] // $FlowFixMe
  , Object(esm_extends["a" /* default */])({}, Object(Product_mapper["b" /* getProductPriceInfoProps */])({
    product: {
      price: price
    }
  }), {
    className: "m-1",
    isCruise: isCruise,
    isJoyview: isJoyview,
    isTour: isTour,
    onClick: handleProductPriceModalClick,
    onClickButton: handleProductPriceModalClickButton
  }), InstagramCard_jsx(Price["a" /* Price */], {
    bestPrice: price === null || price === void 0 ? void 0 : price.bestPrice,
    className: "px-3 sm:px-5",
    containerStyle: null,
    from: Object(src_i18n["f" /* t */])('price.format.from'),
    style: {
      minHeight: 'none'
    },
    theme: "instagram",
    unit: price === null || price === void 0 ? void 0 : price.unit
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/instagram/Instagram.jsx

var Instagram_jsx = react_default.a.createElement;



var Instagram_Instagram = function Instagram(_ref) {
  var cards = _ref.cards,
      lineName = _ref.lineName,
      title = _ref.title;

  if (!cards.length) {
    return null;
  }

  return Instagram_jsx(react["Fragment"], null, !!title && Instagram_jsx(LineTitle["a" /* LineTitle */], null, title), Instagram_jsx("div", {
    className: "-mx-5 overflow-x-scroll lg:overflow-x-visible",
    style: {
      maxHeight: '280px'
    }
  }, Instagram_jsx("div", {
    className: "flex flex-no-wrap px-5"
  }, cards.map(function (item, index) {
    return Instagram_jsx(InstagramCard_InstagramCard, Object(esm_extends["a" /* default */])({}, item, {
      index: index,
      key: item.href,
      lineName: lineName
    }));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/lines/instagram-line/InstagramLine.jsx


var InstagramLine_jsx = react_default.a.createElement;

function InstagramLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InstagramLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InstagramLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InstagramLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var InstagramLine_InstagramLine = function InstagramLine(_ref) {
  var config = _ref.config,
      displayPrices = _ref.displayPrices,
      id = _ref.id,
      products = _ref.products,
      title = _ref.title;

  if (!products || products.length === 0) {
    return null;
  }

  Object(src_i18n["a" /* addTranslationKeys */])(config);
  var cards = products.filter(function (_ref2) {
    var socialPictures = _ref2.socialPictures;
    return socialPictures.length > 0;
  }).map(function (_ref3) {
    var socialPictures = _ref3.socialPictures,
        rest = Object(objectWithoutProperties["a" /* default */])(_ref3, ["socialPictures"]);

    return InstagramLine_objectSpread(InstagramLine_objectSpread({}, rest), {}, {
      price: displayPrices ? rest.price : null,
      socialPicture: socialPictures[0]
    });
  });
  return cards.length > 0 ? InstagramLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, InstagramLine_jsx(Instagram_Instagram, {
    cards: cards,
    lineName: constants["r" /* INSTAGRAM */],
    title: title
  })) : null;
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/instagram/instagram.resolver.js
var instagram_resolver = __webpack_require__("vt7b");

// CONCATENATED MODULE: ./src/client/cms/toolkit/instagram/instagram.descriptor.js



var instagramDescriptor = {
  name: constants["r" /* INSTAGRAM */],
  component: InstagramLine_InstagramLine,
  resolver: instagram_resolver["a" /* instagramResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/frameworks/grid/Grid.jsx + 2 modules
var Grid = __webpack_require__("uLWw");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 6 modules
var Product = __webpack_require__("XTOr");

// EXTERNAL MODULE: ./src/client/tracking/last-visited-tracking-api/index.js
var last_visited_tracking_api = __webpack_require__("evRn");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/resort-thumbnail-query/resortThumbnailQuery.js
var resortThumbnailQuery = __webpack_require__("jw1E");

// EXTERNAL MODULE: ./src/client/views/configQueries.js
var configQueries = __webpack_require__("4VTZ");

// CONCATENATED MODULE: ./src/client/components/lines/last-seen-products-line/LastSeenProductsLine.jsx


var LastSeenProductsLine_jsx = react_default.a.createElement;






















var MAX_LAST_SEEN_PRODUCTS = 3;

function lastSeenProductsQuery(appContext, productIds) {
  var _appContext$cmsConten = appContext.cmsContent,
      cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
      _appContext$cmsReleas = appContext.cmsRelease,
      cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
  var cmsArgs = "content: \"".concat(cmsContent, "\", release: \"").concat(cmsRelease, "\"");
  var resortThumbnailQueryString = Object(resortThumbnailQuery["b" /* default */])({
    content: cmsContent,
    release: cmsRelease
  });
  var query = "query {\n      products: resorts(resortIds : ".concat(JSON.stringify(productIds), ") {\n        ").concat(resortThumbnailQueryString, "\n      },\n      config(").concat(cmsArgs, ") {\n        common {\n          next\n          previous\n          close\n          thumbnailCTA\n          thumbnailTourCTA\n        }\n        ").concat(configQueries["c" /* price */](), "\n        ").concat(configQueries["e" /* resort */](appContext), "\n      }\n    }");
  return query;
} // Placeholder styling replicates Product card image aspect ratio


var LastSeenPlaceholder = function LastSeenPlaceholder(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles;
  return LastSeenProductsLine_jsx("div", {
    className: className,
    style: styles
  }, LastSeenProductsLine_jsx("div", {
    className: "relative",
    style: {
      height: '0',
      paddingBottom: 'calc(240 / 380 * 100%)'
    }
  }, LastSeenProductsLine_jsx("div", {
    className: "absolute pin h-full w-full border-2 border-dashed"
  })));
};

var LastSeenProductsLine_LastSeenProductsLine = function LastSeenProductsLine(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      seeMoreResortsLabel = _ref2.seeMoreResortsLabel;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted,
      isDesktop = _useResponsive.isDesktop;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'lastSeenProducts'
  }); // Get last seen products from localStorage

  var productIds = Object(last_visited_tracking_api["a" /* getLastVisitedProductIds */])().slice(0, MAX_LAST_SEEN_PRODUCTS);

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: lastSeenProductsQuery(appContext, productIds),
    queryOptions: {
      requestName: requestDictionary["Ib" /* LINE_COMMON_LAST_SEEN_PRODUCTS */]
    },
    ignore: productIds.length <= 0,
    cache: true
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  if (!isAppMounted) {
    return null;
  }

  var lastSeenProducts = [];

  if (!isLoading && data && data.products) {
    lastSeenProducts = Object(lodash["sortBy"])(data.products.map(function (product) {
      return Object(redux["d" /* compose */])(Product_mapper["c" /* getProductProps */], Product_mapper["d" /* setProductHref */])({
        config: data.config,
        product: product,
        isSliderDisabled: true
      });
    }), function (product) {
      return Object(lodash["indexOf"])(productIds, product.id);
    });
  }

  var numberOfProducts = lastSeenProducts.length;
  var numberOfPlaceholders = MAX_LAST_SEEN_PRODUCTS - numberOfProducts;
  return LastSeenProductsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, numberOfProducts > 0 && title && seeMoreResortsLabel && LastSeenProductsLine_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, LastSeenProductsLine_jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), LastSeenProductsLine_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "m-auto md:mx-0 mt-4 md:mt-1 order-last md:order-none text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: {
      actionGA: 'lastSeenProducts',
      labelGA: 'seeMore'
    },
    url: "/s"
  }, seeMoreResortsLabel), LastSeenProductsLine_jsx("div", {
    className: "w-full lg:order-1"
  }, isDesktop ? LastSeenProductsLine_jsx(Grid["a" /* default */], {
    totalNumberToDisplay: MAX_LAST_SEEN_PRODUCTS
  }, lastSeenProducts.map(function (product, index) {
    return LastSeenProductsLine_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
      index: index,
      key: product.id,
      lineName: constants["t" /* LAST_SEEN_PRODUCTS */],
      offer: product.offer,
      onClick: function onClick() {
        return track({
          labelGA: product.id
        });
      }
    }, product));
  }), Object(toConsumableArray["a" /* default */])(Array(numberOfPlaceholders).keys()).map(function (pId) {
    return LastSeenProductsLine_jsx(LastSeenPlaceholder, {
      key: "lastSeenPlaceHolder-".concat(pId)
    });
  })) : LastSeenProductsLine_jsx(Slider, {
    className: "w-screen -mx-5",
    cols: 0,
    hasControls: false,
    navPosition: "center",
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous'),
    scrollAreaContainerClassName: "overflow-x-auto"
  }, [].concat(Object(toConsumableArray["a" /* default */])(lastSeenProducts.map(function (product, index) {
    return LastSeenProductsLine_jsx("div", {
      key: product.id,
      className: classnames_default()('relative pr-5', {
        'ml-5': index === 0
      }),
      style: {
        width: '85vw',
        maxWidth: '380px'
      }
    }, LastSeenProductsLine_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
      index: index,
      lineName: constants["t" /* LAST_SEEN_PRODUCTS */],
      offer: product.offer,
      onClick: function onClick() {
        return track({
          labelGA: product.id
        });
      }
    }, product)));
  })), Object(toConsumableArray["a" /* default */])(numberOfProducts < MAX_LAST_SEEN_PRODUCTS ? [LastSeenProductsLine_jsx(LastSeenPlaceholder, {
    key: "lastSeenPlaceHolder",
    className: "pr-5",
    styles: {
      width: '85vw',
      maxWidth: '380px'
    }
  })] : []))))));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/last-seen-products/lastSeenProducts.descriptor.js


var lastSeenProductsDescriptor = {
  name: constants["t" /* LAST_SEEN_PRODUCTS */],
  component: LastSeenProductsLine_LastSeenProductsLine
};
// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.constants.js
var Card_constants = __webpack_require__("syQ6");

// CONCATENATED MODULE: ./src/client/components/utils/cards/cards.utils.js

var cards_utils_mapColToCard = function mapColToCard(_ref) {
  var color = _ref.color,
      config = _ref.config,
      cta = _ref.cta,
      icon = _ref.icon,
      introduction = _ref.introduction,
      link = _ref.link,
      mediaRatio = _ref.mediaRatio,
      mediaUrl = _ref.mediaUrl,
      smallTitle = _ref.smallTitle,
      subTitle = _ref.subTitle,
      text = _ref.text,
      title = _ref.title;
  return {
    closeLabel: Object(lodash["get"])(config, 'common.close'),
    seeMoreLabel: Object(lodash["get"])(config, 'common.seeMore'),
    seeLessLabel: Object(lodash["get"])(config, 'common.loadLess'),
    color: color,
    ctaLabel: cta,
    heading: {
      iconName: icon,
      title: title,
      small: smallTitle,
      subtitle: subTitle
    },
    introduction: {
      text: introduction
    },
    link: {
      url: link
    },
    media: {
      alt: '',
      ratioKey: mediaRatio,
      url: mediaUrl
    },
    text: {
      text: text
    }
  };
};
// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.jsx + 11 modules
var Card = __webpack_require__("786X");

// CONCATENATED MODULE: ./src/client/components/lines/media-text-horizontal-line/MediaTextHorizontalLine.jsx


var MediaTextHorizontalLine_jsx = react_default.a.createElement;





var LEFT = 'left';
var MediaTextHorizontalLine_MediaTextHorizontalLine = function MediaTextHorizontalLine(_ref) {
  var id = _ref.id,
      mediaPosition = _ref.mediaPosition,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["id", "mediaPosition"]);

  return MediaTextHorizontalLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, rest.mediaUrl ? MediaTextHorizontalLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards_utils_mapColToCard(rest), {
    layout: mediaPosition === LEFT ? Card_constants["d" /* INLINE_1 */] : Card_constants["e" /* INLINE_2 */]
  })) : MediaTextHorizontalLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards_utils_mapColToCard(rest), {
    layout: Card_constants["d" /* INLINE_1 */]
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/media-text-horizontal/mediaTextHorizontal.resolver.js
var mediaTextHorizontal_resolver = __webpack_require__("PT2a");

// CONCATENATED MODULE: ./src/client/cms/toolkit/media-text-horizontal/mediaTextHorizontal.descriptor.js



var mediaTextHorizontalDescriptor = {
  name: constants["u" /* MEDIA_TEXT_HORIZONTAL */],
  component: MediaTextHorizontalLine_MediaTextHorizontalLine,
  resolve: mediaTextHorizontal_resolver["a" /* mediaTextHorizontalResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/media-text-vertical-line/MediaTextVerticalLine.jsx


var MediaTextVerticalLine_jsx = react_default.a.createElement;

function MediaTextVerticalLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MediaTextVerticalLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MediaTextVerticalLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MediaTextVerticalLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var MediaTextVerticalLine_MediaTextVerticalLine = function MediaTextVerticalLine(_ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      config = _ref.config,
      id = _ref.id;

  if (!columns.length) {
    return null;
  }

  return MediaTextVerticalLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, columns.length > 1 ? MediaTextVerticalLine_jsx("div", {
    className: "sm:flex -m-px10"
  }, columns.map(function (col) {
    return MediaTextVerticalLine_jsx("div", {
      className: "p-px10 sm:w-1/2",
      key: col.title
    }, MediaTextVerticalLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards_utils_mapColToCard(MediaTextVerticalLine_objectSpread(MediaTextVerticalLine_objectSpread({}, col), {}, {
      config: config
    })), {
      layout: Card_constants["a" /* COLUMN_1 */]
    })));
  })) : MediaTextVerticalLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards_utils_mapColToCard(MediaTextVerticalLine_objectSpread(MediaTextVerticalLine_objectSpread({}, columns[0]), {}, {
    config: config
  })), {
    layout: Card_constants["c" /* COMPOSITE_1 */]
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/media-text-vertical/mediaTextVertical.resolver.js
var mediaTextVertical_resolver = __webpack_require__("UszP");

// CONCATENATED MODULE: ./src/client/cms/toolkit/media-text-vertical/mediaTextVertical.descriptor.js



var mediaTextVerticalDescriptor = {
  name: constants["v" /* MEDIA_TEXT_VERTICAL */],
  component: MediaTextVerticalLine_MediaTextVerticalLine,
  resolve: mediaTextVertical_resolver["a" /* mediaTextVerticalResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/media-thumbnail-line/MediaThumbnailLine.jsx


var MediaThumbnailLine_jsx = react_default.a.createElement;

function MediaThumbnailLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MediaThumbnailLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MediaThumbnailLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MediaThumbnailLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var MediaThumbnailLine_MediaThumbnailLine = function MediaThumbnailLine(_ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      config = _ref.config,
      id = _ref.id,
      title = _ref.title;

  if (!columns.length) {
    return null;
  }

  return MediaThumbnailLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, MediaThumbnailLine_jsx(LineTitle["a" /* LineTitle */], null, title), MediaThumbnailLine_jsx("div", {
    className: "sm:flex -m-px10"
  }, columns.map(function (col) {
    return MediaThumbnailLine_jsx("div", {
      className: "p-px10 sm:w-1/3",
      key: col.title
    }, MediaThumbnailLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards_utils_mapColToCard(MediaThumbnailLine_objectSpread(MediaThumbnailLine_objectSpread({}, col), {}, {
      config: config
    })), {
      className: "h-full",
      layout: Card_constants["b" /* COLUMN_2 */],
      theme: "thumbnail"
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/media-thumbnail/mediaThumbnail.descriptor.js




var mediaThumbnailDescriptor = {
  name: constants["w" /* MEDIA_THUMBNAIL */],
  component: MediaThumbnailLine_MediaThumbnailLine,
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common { close }\n      }\n    }";
    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["c" /* CORE_GET_COMMON_I18N */],
      strictErrors: false
    });
  }
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/navigation-tab/navigationTab.descriptor.js
var navigationTab_descriptor_jsx = react_default.a.createElement;



var navigationTabDescriptor = {
  name: constants["y" /* NAVIGATION_TAB */],
  component: function component(props) {
    return navigationTab_descriptor_jsx(Line, {
      props: props
    });
  }
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/react-stickynode/index.js
var react_stickynode = __webpack_require__("gyFy");
var react_stickynode_default = /*#__PURE__*/__webpack_require__.n(react_stickynode);

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.hoc.jsx
var tabs_hoc = __webpack_require__("lW4u");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation-tabs/header/NavigationTabsHeader.jsx


var NavigationTabsHeader_jsx = react_default.a.createElement;




function NavigationTabsHeader(props) {
  var _classnames;

  var children = props.children,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].BLUE : _props$color,
      controlsId = props.controlsId,
      id = props.id,
      isActive = props.isActive,
      onClick = props.onClick,
      trackingData = props.trackingData;
  return NavigationTabsHeader_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    "aria-controls": controlsId,
    "aria-selected": isActive,
    as: "button",
    className: classnames_default()(className, 'cursor-pointer h-navigation-tabs px-3 py-2 text-base transition-colors', "focus:bg-".concat(color, " focus:text-white hover:bg-").concat(color, " hover:text-white"), (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(color, " text-white"), isActive), Object(defineProperty["a" /* default */])(_classnames, 'bg-white text-gray-darker', !isActive), _classnames)),
    id: id,
    onClick: onClick,
    role: "tab",
    style: {
      minWidth: '7.5rem'
    },
    tabIndex: isActive ? 0 : -1
  }, trackingData ? {
    trackingData: trackingData
  } : null), children);
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation-tabs/NavigationTabs.utils.js
function getClassNames(length) {
  switch (length) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      return 'w-auto flex-none sm:flex-1';

    case 6:
      return 'w-auto flex-none sm:w-1/5 md:w-auto md:flex-1';

    case 7:
      return 'w-auto flex-none sm:w-1/5 md:w-1/6 lg:w-auto lg:flex-1';

    default:
      return 'w-auto flex-none sm:w-1/5 md:w-1/6 lg:w-1/8';
  }
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation-tabs/NavigationTabs.jsx







var NavigationTabs_jsx = react_default.a.createElement;

function NavigationTabs_createSuper(Derived) { var hasNativeReflectConstruct = NavigationTabs_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationTabs_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }












var NavigationTabs_NavigationTabs = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_NavigationTabs, _Component);

  var _super = NavigationTabs_createSuper(_NavigationTabs);

  function _NavigationTabs(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, _NavigationTabs);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (event) {
      var items = _this.props.items;

      if (items.length > 1) {
        _this.setState(function (_ref) {
          var index = _ref.index;

          switch (event.which) {
            case keyCodes["c" /* ARROW_RIGHT */]:
            case keyCodes["a" /* ARROW_DOWN */]:
              event.preventDefault();
              return {
                index: index === items.length - 1 ? 0 : index + 1
              };

            case keyCodes["b" /* ARROW_LEFT */]:
            case keyCodes["d" /* ARROW_UP */]:
              event.preventDefault();
              return {
                index: index === 0 ? items.length - 1 : index - 1
              };

            case keyCodes["h" /* HOME */]:
              event.preventDefault();
              return {
                index: 0
              };

            case keyCodes["e" /* END */]:
              event.preventDefault();
              return {
                index: items.length - 1
              };

            default:
          }
        }, function () {
          return _this.refsArray[_this.state.index] && _this.refsArray[_this.state.index].firstChild.focus();
        });
      }
    });

    _this.refsArray = [];
    _this.state = {
      index: props.initialSelectedItem,
      initialOffsetLeft: 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(_NavigationTabs, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.initialSelectedItem !== this.props.initialSelectedItem) {
        var initialSelectedItem = this.props.initialSelectedItem || 0;
        this.setState({
          index: initialSelectedItem,
          initialOffsetLeft: this.getInitialOffsetLeft(initialSelectedItem)
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        initialOffsetLeft: this.getInitialOffsetLeft(this.props.initialSelectedItem)
      });

      if (this.refsArray.length) {
        // $FlowFixMe
        this.refsArray.forEach(function (ref) {
          return ref.addEventListener('keydown', _this2.onKeyDown, false);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (this.refsArray.length) {
        // $FlowFixMe
        this.refsArray.forEach(function (ref) {
          return ref.removeEventListener('keydown', _this3.onKeyDown, false);
        });
      }
    }
  }, {
    key: "getInitialOffsetLeft",
    value: function getInitialOffsetLeft() {
      var initialSelectedItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var ref = this.refsArray[initialSelectedItem];
      return ref ? ref.offsetLeft : 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          className = _this$props.className,
          _this$props$id = _this$props.id,
          mainId = _this$props$id === void 0 ? 'NavigationTabs' : _this$props$id,
          items = _this$props.items,
          scrollBackwardLabel = _this$props.scrollBackwardLabel,
          scrollForwardLabel = _this$props.scrollForwardLabel;

      if (!items.length) {
        return null;
      }

      var _this$state = this.state,
          index = _this$state.index,
          initialOffsetLeft = _this$state.initialOffsetLeft;
      var activeItem = items[index] || {};
      var activeColor = activeItem.color || colors["a" /* COLORS */].BLUE;
      var content = items.map(function (_ref2, idx) {
        var color = _ref2.color,
            id = _ref2.id,
            title = _ref2.title,
            trackingData = _ref2.trackingData;
        return NavigationTabs_jsx("div", {
          className: classnames_default()('border-gray-light', getClassNames(items.length), {
            'rtl:border-l-1': idx !== 0
          }),
          key: id || title,
          ref: function ref(_ref3) {
            _this4.refsArray[idx] = _ref3;
          }
        }, NavigationTabs_jsx(NavigationTabsHeader, {
          className: "w-full",
          color: color,
          controlsId: "".concat(id, "-tab"),
          id: id,
          isActive: idx === index,
          onClick: function onClick() {
            _this4.setState({
              index: idx
            }, function () {
              Object(scrollToElement["a" /* scrollToElement */])("#".concat(mainId), 100); // $FlowFixMe

              _this4.refsArray[idx].firstChild.focus();
            });
          },
          trackingData: trackingData
        }, title));
      });
      return NavigationTabs_jsx("div", {
        className: className,
        id: mainId
      }, NavigationTabs_jsx(react_stickynode_default.a, {
        bottomBoundary: "#NavigationTabsBeacon",
        innerZ: 5
      }, NavigationTabs_jsx("div", {
        className: "lg:px-5"
      }, NavigationTabs_jsx("div", {
        className: "bg-white border-b-2 border-".concat(activeColor, " lg:max-w-site lg:m-auto shadow-lg")
      }, NavigationTabs_jsx(Scrollable["a" /* Scrollable */], {
        backwardLabel: scrollBackwardLabel,
        className: "border-t-1 lg:border-l-1 lg:border-r-1 lg:-m-px border-gray-light",
        forwardLabel: scrollForwardLabel,
        hasShadow: true,
        initialScrollLeft: initialOffsetLeft,
        navPosition: "center"
      }, NavigationTabs_jsx("div", {
        className: "bg-white flex",
        role: "tablist"
      }, content))))), NavigationTabs_jsx("div", {
        "aria-labelledby": activeItem.id,
        className: "outline-none py-5",
        id: "".concat(activeItem.id, "-tab"),
        role: "tabpanel"
      }, activeItem.content), NavigationTabs_jsx("div", {
        id: "NavigationTabsBeacon"
      }));
    }
  }]);

  return _NavigationTabs;
}(react["Component"]);

Object(defineProperty["a" /* default */])(NavigationTabs_NavigationTabs, "defaultProps", {
  initialSelectedItem: 0,
  items: []
});

var NavigationTabs = Object(tabs_hoc["a" /* withOpenAndScrollToHash */])(NavigationTabs_NavigationTabs);
// CONCATENATED MODULE: ./src/client/components/lines/navigation-tabs-line/NavigationTabsLine.jsx
var NavigationTabsLine_jsx = react_default.a.createElement;





function NavigationTabsLine(_ref) {
  var _ref$config$common = _ref.config.common,
      scrollBackward = _ref$config$common.scrollBackward,
      scrollForward = _ref$config$common.scrollForward,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? [] : _ref$lines;

  var _useContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageType = _useContext.pageType;

  var items = lines.map(function (line) {
    var _line$props = line.props,
        id = _line$props.id,
        isExclusiveCollection = _line$props.isExclusiveCollection,
        title = _line$props.title,
        tabLines = _line$props.lines;
    return {
      id: id,
      color: isExclusiveCollection ? colors["a" /* COLORS */].DEEP_BLUE : colors["a" /* COLORS */].BLUE,
      title: title,
      content: tabLines.map(Line),
      trackingData: {
        categoryGA: pageType,
        actionGA: 'blockInfos',
        labelGA: id || 'productInfos'
      }
    };
  });

  if (!items.length) {
    return null;
  }

  return items.length > 1 ? NavigationTabsLine_jsx(NavigationTabs, {
    className: "Line",
    items: items,
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  }) : items[0].content;
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/navigation-tabs/navigationTabs.resolver.js
var navigationTabs_resolver = __webpack_require__("v78B");

// CONCATENATED MODULE: ./src/client/cms/toolkit/navigation-tabs/navigationTabs.descriptor.js



var navigationTabsDescriptor = {
  name: constants["z" /* NAVIGATION_TABS */],
  component: NavigationTabsLine,
  resolve: navigationTabs_resolver["a" /* navigationTabsResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// CONCATENATED MODULE: ./src/client/components/widgets/offers-grid/OffersGrid.jsx

var OffersGrid_jsx = react_default.a.createElement;








var OffersGrid_OffersGrid = function OffersGrid(_ref) {
  var _ref$offers = _ref.offers,
      offers = _ref$offers === void 0 ? [] : _ref$offers,
      _ref$textLimit = _ref.textLimit,
      textLimit = _ref$textLimit === void 0 ? 250 : _ref$textLimit;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!offers.length) {
    return null;
  }

  return OffersGrid_jsx("section", {
    className: "sm:flex flex-wrap"
  }, offers.map(function () {
    var offer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _offer$color = offer.color,
        color = _offer$color === void 0 ? 'black' : _offer$color,
        commercialArgument = offer.commercialArgument,
        _offer$description = offer.description,
        description = _offer$description === void 0 ? '' : _offer$description,
        href = offer.href,
        id = offer.id,
        image = offer.image,
        _offer$name = offer.name,
        name = _offer$name === void 0 ? '' : _offer$name;
    var truncatedText = textLimit > 0 ? Object(string_util["f" /* truncate */])(description, textLimit) : description;
    var classNames = isTablet ? 'decorator-border-grid pt-8 px-3 pb-12 w-1/2' : 'decorator-border-bottom-list py-5';
    return OffersGrid_jsx("div", {
      className: classNames,
      key: id
    }, OffersGrid_jsx("div", {
      className: "m-auto",
      style: {
        maxWidth: '23.75rem'
      }
    }, OffersGrid_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({
      ctaLabel: name,
      customMedia: image ? OffersGrid_jsx(DynamicLink["a" /* default */], {
        className: "block flex leading-none m-0 no-underline",
        "data-testid": "OffersGrid-captionLink",
        url: href
      }, OffersGrid_jsx(Image["a" /* default */], {
        className: "w-7/10",
        imageUrl: image,
        mandatoryWidthAndHeight: {
          w: 250,
          h: 250 * ratios_utils["a" /* default */].values[ratios_utils["a" /* default */].S]
        }
      }), OffersGrid_jsx("span", {
        className: "flex font-bold items-center leading-one no-underline p-1 text-center text-lg text-white uppercase w-3/10",
        "data-testid": "OffersGrid-captionLink-caption",
        style: {
          backgroundColor: color,
          wordWrap: 'break-word'
        }
      }, commercialArgument)) : null,
      heading: {
        title: name
      }
    }, id ? {
      id: id
    } : null, {
      layout: Card_constants["a" /* COLUMN_1 */],
      link: {
        url: href
      },
      text: {
        text: truncatedText
      }
    }))));
  }));
};
// CONCATENATED MODULE: ./src/client/components/lines/offers-grid-line/OffersGridLine.jsx
var OffersGridLine_jsx = react_default.a.createElement;




var OffersGridLine_OffersGridLine = function OffersGridLine(_ref) {
  var id = _ref.id,
      offers = _ref.offers,
      title = _ref.title;

  if (!offers.length) {
    return null;
  }

  return OffersGridLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, OffersGridLine_jsx(LineTitle["a" /* LineTitle */], null, title), OffersGridLine_jsx(OffersGrid_OffersGrid, {
    offers: offers
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/offers-grid/offersGrid.resolver.js
var offersGrid_resolver = __webpack_require__("xXeT");

// CONCATENATED MODULE: ./src/client/cms/toolkit/offers-grid/offersGrid.descriptor.js



var offersGridDescriptor = {
  name: constants["A" /* OFFERS_GRID */],
  component: OffersGridLine_OffersGridLine,
  resolve: offersGrid_resolver["a" /* offersGridResolver */].resolve
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/react-collapse/lib/index.js
var react_collapse_lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// CONCATENATED MODULE: ./src/client/components/widgets/offers-push/OfferPush.themes.js



var OfferPush_themes_themes = {
  "default": function _default(_ref) {
    var titleColor = _ref.titleColor,
        subtitleColor = _ref.subtitleColor,
        isHover = _ref.isHover;
    return {
      thRoot: 'bg-gray-darker image-responsive-cell overflow-hidden relative rounded-tiny',
      thImage: classnames_default()('opacity-75 transition-transform-opacity', {
        'scale-105': isHover
      }),
      thHeader: 'absolute flex justify-center mt-5 text-center top-0 w-full',
      thHeaderItem: function thHeaderItem(_ref2) {
        var _classnames;

        var _ref2$textColor = _ref2.textColor,
            textColor = _ref2$textColor === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$textColor,
            _ref2$backgroundColor = _ref2.backgroundColor,
            backgroundColor = _ref2$backgroundColor === void 0 ? colors["a" /* COLORS */].BLACK : _ref2$backgroundColor;
        return classnames_default()('font-brand font-normal leading-one max-w-1/2 m-0 mx-1 p-2 rounded-tiny text-xs', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "text-".concat(textColor), true), Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(backgroundColor), true), _classnames));
      },
      thTitle: classnames_default()('font-bold leading-tight mb-3 reset-heading text-2xl text-center', Object(defineProperty["a" /* default */])({}, "text-".concat(titleColor || colors["a" /* COLORS */].WHITE), true)),
      thSubTitle: classnames_default()('m-0 pb-4 text-center text-md', Object(defineProperty["a" /* default */])({}, "text-".concat(subtitleColor || colors["a" /* COLORS */].WHITE), true)),
      thFooter: 'absolute bottom-0 p-2 pb-6 transition-transform w-full'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/offers-push/OfferPush.jsx

var OfferPush_jsx = react_default.a.createElement;

function OfferPush_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function OfferPush_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { OfferPush_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { OfferPush_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var OfferPush_OfferPush = function OfferPush(_ref) {
  var _tag$, _tag$2;

  var countdown = _ref.countdown,
      id = _ref.id,
      link = _ref.link,
      mediaUrl = _ref.mediaUrl,
      subTitle = _ref.subTitle,
      tag = _ref.tag,
      _ref$theming = _ref.theming,
      titleColor = _ref$theming.titleColor,
      subtitleColor = _ref$theming.subtitleColor,
      title = _ref.title;

  var _useState = Object(react["useState"])(false),
      isHover = _useState[0],
      setHover = _useState[1];

  var _themes$default = OfferPush_themes_themes.default({
    titleColor: titleColor,
    subtitleColor: subtitleColor,
    isHover: isHover
  }),
      thRoot = _themes$default.thRoot,
      thImage = _themes$default.thImage,
      thHeader = _themes$default.thHeader,
      thHeaderItem = _themes$default.thHeaderItem,
      thTitle = _themes$default.thTitle,
      thFooter = _themes$default.thFooter,
      thSubTitle = _themes$default.thSubTitle;

  var trackingData = OfferPush_objectSpread(OfferPush_objectSpread({}, tracking_constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: tracking_constants["k" /* OFFER_PUSH */].ACTION,
    labelGA: "".concat(title, "-").concat(id)
  });

  var shouldDisplayOffer = !countdown.dateTimeEnd && ((_tag$ = tag[1]) === null || _tag$ === void 0 ? void 0 : _tag$.text);
  var shouldDisplayCountdown = countdown.dateTimeEnd;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  return OfferPush_jsx("article", {
    className: thRoot,
    "data-testid": "offer-push-container",
    dir: isRTL ? 'rtl' : 'ltr'
  }, OfferPush_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "block overflow-hidden relative",
    "data-testid": "offer-push-".concat(id, "-link"),
    onBlur: function onBlur() {
      return setHover(false);
    },
    onFocus: function onFocus() {
      return setHover(true);
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    trackingData: trackingData,
    url: link
  }, OfferPush_jsx(Image["a" /* default */], {
    altMsg: title,
    className: thImage,
    groupKey: "offers-push",
    hasLazyLoading: true,
    imageUrl: mediaUrl,
    ratioKey: ratios_utils["a" /* default */].XL
  }), OfferPush_jsx("div", {
    className: thHeader
  }, ((_tag$2 = tag[0]) === null || _tag$2 === void 0 ? void 0 : _tag$2.text) && OfferPush_jsx("p", {
    className: thHeaderItem(tag[0].theming, true),
    "data-testid": "offer-push-".concat(id, "-tag-first")
  }, OfferPush_jsx("span", {
    className: "block -mb-px truncate"
  }, tag[0].text.toUpperCase())), shouldDisplayCountdown && OfferPush_jsx(Countdown["a" /* Countdown */], {
    bgColor: countdown.backgroundColor,
    className: "leading-one mx-1 py-1",
    color: countdown.textColor,
    dataTestId: "offer-push-".concat(id, "-countdown"),
    dateTimeEnd: countdown.dateTimeEnd,
    days: countdown.days,
    hours: countdown.hours,
    minutes: countdown.minutes,
    seconds: countdown.seconds,
    theme: "offerPush"
  }), shouldDisplayOffer && OfferPush_jsx("p", {
    className: thHeaderItem(tag[1].theming, false),
    "data-testid": "offer-push-".concat(id, "-tag-second")
  }, OfferPush_jsx("span", {
    className: "block -mb-px truncate"
  }, tag[1].text.toUpperCase()))), OfferPush_jsx("div", {
    className: thFooter
  }, title && OfferPush_jsx("h3", {
    className: thTitle,
    "data-testid": "offer-push-".concat(id, "-title")
  }, title), subTitle && OfferPush_jsx(react_collapse_lib["Collapse"], {
    isOpened: isHover
  }, OfferPush_jsx("p", {
    className: thSubTitle,
    "data-testid": "offer-push-".concat(id, "-subtitle")
  }, Object(string_util["f" /* truncate */])(subTitle, 115))))));
};
// CONCATENATED MODULE: ./src/client/components/lines/offers-push-line/OffersPushLineNarrow.jsx

var OffersPushLineNarrow_jsx = react_default.a.createElement;








var OffersPushLineNarrow_OffersPushLineNarrow = function OffersPushLineNarrow(_ref) {
  var title = _ref.title,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreLink = _ref.seeMoreLink,
      columns = _ref.columns;
  return OffersPushLineNarrow_jsx(react["Fragment"], null, !!title && OffersPushLineNarrow_jsx(LineTitle["a" /* LineTitle */], null, title), OffersPushLineNarrow_jsx("div", {
    className: "-mx-5 lg:mx-0 w-screen lg:w-full"
  }, OffersPushLineNarrow_jsx(Slider, {
    cols: 0,
    hasControls: false,
    navPosition: "center",
    nbItemsToScroll: 1,
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous'),
    scrollAreaClassName: "overflow-hidden",
    scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory"
  }, columns.map(function (columnProps, index) {
    return OffersPushLineNarrow_jsx("div", {
      className: classnames_default()('flex-1 sm:w-1/3 rtl:ml-5', {
        'lg:rtl:ml-0': index === 0
      }),
      style: {
        width: '85vw',
        maxWidth: '380px'
      },
      key: index
    }, OffersPushLineNarrow_jsx(OfferPush_OfferPush, Object(esm_extends["a" /* default */])({}, columnProps, {
      id: index + 1
    })));
  }), OffersPushLineNarrow_jsx("div", {
    style: {
      width: '20px',
      height: '1px',
      flexShrink: '0'
    },
    className: "lg:hidden rtl:-order-1"
  }))), seeMoreLabel && seeMoreLink && OffersPushLineNarrow_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    url: seeMoreLink,
    className: "block mx-auto mt-4 text-center text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: {
      actionGA: 'main_push_offers',
      labelGA: 'seeMore'
    }
  }, seeMoreLabel));
};
// CONCATENATED MODULE: ./src/client/components/lines/offers-push-line/OffersPushLineLarge.jsx

var OffersPushLineLarge_jsx = react_default.a.createElement;









var OffersPushLineLarge_OffersPushLineLarge = function OffersPushLineLarge(_ref) {
  var title = _ref.title,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreLink = _ref.seeMoreLink,
      columns = _ref.columns;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  return OffersPushLineLarge_jsx(react["Fragment"], null, OffersPushLineLarge_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, title && OffersPushLineLarge_jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), seeMoreLabel && seeMoreLink && OffersPushLineLarge_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "m-auto md:mx-0 mt-4 md:mt-1 order-last md:order-none text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: {
      actionGA: 'main_push_offers',
      labelGA: 'seeMore'
    },
    url: seeMoreLink
  }, seeMoreLabel)), OffersPushLineLarge_jsx("div", {
    className: "-mx-5 lg:mx-0 w-screen lg:w-full"
  }, OffersPushLineLarge_jsx(Slider, {
    cols: 0,
    hasControls: isDesktop,
    navPosition: "center",
    nbItemsToScroll: 2,
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous'),
    scrollAreaContainerClassName: "overflow-x-auto lg:overflow-hidden",
    scrollControlsClassName: "-mx-5 lg:mx-0"
  }, columns.map(function (column, index) {
    return OffersPushLineLarge_jsx("div", {
      className: classnames_default()('flex-1 sm:w-1/3 rtl:ml-5', {
        'lg:rtl:ml-0': index === 0
      }),
      style: {
        width: '85vw',
        maxWidth: '380px'
      },
      key: index
    }, OffersPushLineLarge_jsx(OfferPush_OfferPush, Object(esm_extends["a" /* default */])({}, column, {
      id: index + 1
    })));
  }), OffersPushLineLarge_jsx("div", {
    style: {
      width: '20px',
      height: '1px',
      flexShrink: '0'
    },
    className: "lg:hidden rtl:-order-1"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/lines/offers-push-line/OffersPushLine.jsx
var OffersPushLine_jsx = react_default.a.createElement;





var OffersPushLine_OffersPushLine = function OffersPushLine(props) {
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return OffersPushLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: props.id
  }, isTablet ? OffersPushLine_jsx(OffersPushLineLarge_OffersPushLineLarge, props) : OffersPushLine_jsx(OffersPushLineNarrow_OffersPushLineNarrow, props));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/offers-push/offersPush.descriptor.js


var offersPushDescriptor = {
  name: constants["B" /* OFFERS_PUSH */],
  component: OffersPushLine_OffersPushLine
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingFormLogin.jsx
var PrebookingFormLogin_jsx = react_default.a.createElement;








var PrebookingFormLogin_PrebookingFormLogin = function PrebookingFormLogin(props) {
  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  if (!props.hasLoginButton || props.hasSeller || props.hasUser) {
    return null;
  }

  return PrebookingFormLogin_jsx("div", {
    className: "flex flex-wrap lg:w-4/5 lg:mx-auto"
  }, PrebookingFormLogin_jsx("div", {
    className: "my-3 px-3 w-full md:w-2/3"
  }, PrebookingFormLogin_jsx("p", {
    className: "w-full my-0 text-base"
  }, Object(src_i18n["f" /* t */])('prebookingForm.login.memberSpace'))), PrebookingFormLogin_jsx("div", {
    className: "flex items-center justify-center my-3 px-3 w-full md:w-1/3"
  }, PrebookingFormLogin_jsx(Button["a" /* Button */], {
    dataTestId: "prebooking-form-login",
    iconLeft: {
      name: icons["a" /* ICONS */].USER
    },
    trackingData: {
      categoryGA: 'prebooking-form',
      actionGA: 'logIn',
      labelGA: 'logIn'
    },
    url: ple_utils["f" /* buildSigninUrl */]({
      locale: locale,
      redirectUri: Object(uriUtils["c" /* convertLocationToURI */])(location).toString()
    }),
    isExternalLink: true
  }, Object(src_i18n["f" /* t */])('prebookingForm.login.labelCTA'))), PrebookingFormLogin_jsx("hr", {
    className: "block border-0 border-solid border-gray-light border-t-1 h-px my-4 mx-0 p-0"
  }));
};
// EXTERNAL MODULE: ./src/client/store/prebooking-form/prebookingform.action.js + 1 modules
var prebookingform_action = __webpack_require__("ZP80");

// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingForm.constants.js
var ADULTS = 'adults';
var KIDS = 'kids';
var COMPANION_GROUPS = {
  ADULTS: ADULTS,
  KIDS: KIDS
};
var MAX_FORM_ADULTS = 10;
var MAX_FORM_KIDS = 10;
var MIN_FORM_ADULTS = 1;
var MIN_FORM_KIDS = 0;
var MAX_COMPANIONS = 7;
// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");

// EXTERNAL MODULE: /home/circleci/project/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingForm.utils.js




function PrebookingForm_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function PrebookingForm_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      PrebookingForm_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      PrebookingForm_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}













 // Map Traveler in User Context

var PrebookingForm_utils_getDateTimestamp = function getDateTimestamp(birthdate) {
  return moment_default()(birthdate).valueOf();
};

var getFormUser = function getFormUser(user) {
  var _user$civility = user.civility,
      civility = _user$civility === void 0 ? '' : _user$civility,
      dateOfBirth = user.dateOfBirth,
      _user$email = user.email,
      email = _user$email === void 0 ? '' : _user$email,
      _user$firstName = user.firstName,
      firstName = _user$firstName === void 0 ? '' : _user$firstName,
      _user$GMNumber = user.GMNumber,
      GMNumber = _user$GMNumber === void 0 ? '' : _user$GMNumber,
      _user$lastName = user.lastName,
      lastName = _user$lastName === void 0 ? '' : _user$lastName,
      _user$mobilePhoneNumb = user.mobilePhoneNumber,
      mobilePhoneNumber = _user$mobilePhoneNumb === void 0 ? '' : _user$mobilePhoneNumb,
      unicodeFirstName = user.unicodeFirstName,
      unicodeLastName = user.unicodeLastName;
  return {
    civility: civility,
    birthdate: dateOfBirth ? PrebookingForm_utils_getDateTimestamp(dateOfBirth) : null,
    email: email,
    firstName: firstName,
    firstNameUnicode: unicodeFirstName,
    memberNumber: GMNumber,
    lastName: lastName,
    lastNameUnicode: unicodeLastName,
    phone: mobilePhoneNumber
  };
};
var getFormOptins = function getFormOptins(optins) {
  var _ref = optins || {},
      _ref$optinEmail = _ref.optinEmail,
      optinEmail = _ref$optinEmail === void 0 ? false : _ref$optinEmail,
      _ref$optinPhone = _ref.optinPhone,
      optinPhone = _ref$optinPhone === void 0 ? false : _ref$optinPhone,
      _ref$optinSms = _ref.optinSms,
      optinSms = _ref$optinSms === void 0 ? false : _ref$optinSms;

  return {
    optinEmail: optinEmail,
    optinPhone: optinPhone,
    optinSms: optinSms
  };
}; // Map Traveler and Companions in CXO/Seller Context

var getFormTraveler = function getFormTraveler(traveler) {
  var _ref2 = traveler || {},
      birthdate = _ref2.birthdate,
      civility = _ref2.civility,
      email = _ref2.email,
      firstName = _ref2.firstName,
      lastName = _ref2.lastName,
      gmNumber = _ref2.gmNumber,
      mobile = _ref2.mobile,
      unicodeFirstName = _ref2.unicodeFirstName,
      unicodeLastName = _ref2.unicodeLastName;

  return {
    birthdate: birthdate || null,
    civility: civility || '',
    email: email || '',
    firstName: firstName || '',
    firstNameUnicode: unicodeFirstName || '',
    lastName: lastName || '',
    lastNameUnicode: unicodeLastName || '',
    memberNumber: gmNumber || '',
    phone: mobile || ''
  };
};

var getFormCompanion = function getFormCompanion(companion) {
  return {
    birthdate: companion.birthdate || null,
    civility: typeof companion.civility !== 'string' ? '' : companion.civility,
    firstName: companion.firstName || '',
    lastName: companion.lastName || ''
  };
};

var PrebookingForm_utils_getFormTravelerAndCompanions = function getFormTravelerAndCompanions(_ref3) {
  var adults = _ref3.adults,
      kids = _ref3.kids;
  var formTraveler = adults.length > 0 ? getFormTraveler(adults[0]) : getFormTraveler(null);
  var adultCompanions = adults.slice(1);
  var formKids = kids.map(getFormCompanion);
  var formAdults = adultCompanions.map(getFormCompanion);
  return PrebookingForm_utils_objectSpread({
    traveler: formTraveler,
    adultsNumber: (formAdults.length + MIN_FORM_ADULTS).toString(),
    kidsNumber: formKids.length.toString(),
    adults: formAdults,
    kids: formKids
  }, adults.length > 0 ? getFormOptins(adults[0]) : getFormOptins(null));
}; // Initialize Form

var PrebookingForm_utils_getInitialFormValues = function getInitialFormValues(agency) {
  return {
    accommodation: '',
    accommodationCategory: '',
    adults: [],
    adultsNumber: MIN_FORM_ADULTS.toString(),
    agency: agency || '',
    departureCity: '',
    departureDate: {
      from: null,
      to: null
    },
    duration: '',
    kids: [],
    kidsNumber: MIN_FORM_KIDS.toString(),
    optinEmail: false,
    optinPhone: false,
    optinSms: false,
    productId: '',
    traveler: {
      birthdate: null,
      civility: '',
      email: '',
      firstName: '',
      lastName: '',
      memberNumber: '',
      phone: ''
    }
  };
}; // Set Form Schema
// Birthdate from 1920

var minBirthdateTimestamp = moment_default()('1920-01-01').valueOf(); // Birthdate less than 18 years old

var kidBirthdateTimestamp = moment_default()().subtract(18, 'years').valueOf();
var adultBirthdateSchema = lib["number"]().min(minBirthdateTimestamp).max(kidBirthdateTimestamp).nullable();
var getAdultBirthdateValidator = function getAdultBirthdateValidator() {
  return adultBirthdateSchema;
};
var PrebookingForm_utils_getKidFutureBithdateValidator = function getKidFutureBithdateValidator() {
  return lib["number"]().test('', '', function (value) {
    var context = this.options.context;

    if (value && (context === null || context === void 0 ? void 0 : context.values.departureDate.from)) {
      var departureDate = moment_default()(context === null || context === void 0 ? void 0 : context.values.departureDate.from).startOf('day');
      var kidBirthdate = moment_default()(value).startOf('day');
      return kidBirthdate.isBefore(departureDate);
    }

    return false;
  });
};
var PrebookingForm_utils_getFormSchema = function getFormSchema(t, _ref4) {
  var _getDomain, _getDomain$fields;

  var agencies = _ref4.agencies,
      civilities = _ref4.civilities,
      locale = _ref4.locale,
      productIds = _ref4.productIds;
  var agencySchema = lib["mixed"]().oneOf(agencies).required();
  var fistNameSchema = lib["string"]().required(t('prebookingForm.mainTraveler.firstNamePlaceholder')).max(20, t('prebookingForm.mainTraveler.firstNamePlaceholder'));
  var lastNameSchema = lib["string"]().required(t('prebookingForm.mainTraveler.firstNamePlaceholder')).max(30, t('prebookingForm.mainTraveler.firstNamePlaceholder'));
  var adultCivilities = civilities.adults.map(function (civility) {
    return civility.value;
  });
  var kidCivilities = civilities.kids.map(function (civility) {
    return civility.value;
  });
  var adultCompanionSchema = lib["object"]().shape({
    civility: lib["mixed"]().oneOf(adultCivilities).required(),
    birthdate: adultBirthdateSchema,
    firstName: fistNameSchema,
    lastName: lastNameSchema
  });
  var kidCompanionSchema = lib["object"]().shape({
    civility: lib["mixed"]().oneOf(kidCivilities),
    birthdate: lib["number"]().min(kidBirthdateTimestamp).nullable().required(),
    firstName: fistNameSchema,
    lastName: lastNameSchema
  });
  var travelerSchema = lib["object"]().shape({
    birthdate: adultBirthdateSchema,
    civility: lib["mixed"]().oneOf(adultCivilities).required(),
    email: lib["string"]().email(t('prebookingForm.mainTraveler.emailPlaceholder')).required(t('prebookingForm.mainTraveler.emailPlaceholder')),
    firstName: fistNameSchema,
    lastName: lastNameSchema,
    memberNumber: lib["string"]().matches(CommonValidators["GM_NUMBER_PATTERN"]),
    phone: lib["string"]().required(t('prebookingForm.mainTraveler.phonePlaceholder')).matches(((_getDomain = Object(domains_service_dist["getDomain"])(locale)) === null || _getDomain === void 0 ? void 0 : (_getDomain$fields = _getDomain.fields) === null || _getDomain$fields === void 0 ? void 0 : _getDomain$fields.phoneNumber) || CommonValidators["PHONE_NUMBER_PATTERN"], {
      excludeEmptyString: true,
      message: t('prebookingForm.mainTraveler.phonePlaceholder')
    })
  });
  return lib["object"]().shape(PrebookingForm_utils_objectSpread(PrebookingForm_utils_objectSpread({
    accommodation: lib["string"](),
    accommodationCategory: lib["string"]().required(),
    adults: lib["array"]().min(MIN_FORM_ADULTS - 1).max(MAX_FORM_ADULTS - 1).of(adultCompanionSchema),
    adultsNumber: lib["string"]().required()
  }, agencies.length ? {
    agency: agencySchema
  } : null), {}, {
    departureCity: lib["string"]().required(),
    departureDate: lib["object"]().shape({
      from: lib["date"](),
      to: lib["date"]().nullable()
    }).required(),
    duration: lib["string"]().required().matches(/^[0-9]{1,2}$/),
    // 1 or 2 digits
    kids: lib["array"]().min(MIN_FORM_KIDS).max(MAX_FORM_KIDS).of(kidCompanionSchema),
    kidsNumber: lib["string"]().required(),
    optinEmail: lib["boolean"](),
    optinPhone: lib["boolean"](),
    optinSms: lib["boolean"](),
    productId: lib["mixed"]().oneOf(productIds).required(),
    traveler: travelerSchema
  }));
}; // Submit prebooking form

var PrebookingForm_utils_formatDate = function formatDate(date) {
  return Object(apiDate["j" /* momentToApiDate */])(moment_default()(date));
};

var getCompanionQuery = function getCompanionQuery(companion) {
  var birthdate = companion.birthdate,
      civility = companion.civility,
      firstName = companion.firstName,
      _companion$firstNameU = companion.firstNameUnicode,
      firstNameUnicode = _companion$firstNameU === void 0 ? '' : _companion$firstNameU,
      lastName = companion.lastName,
      _companion$lastNameUn = companion.lastNameUnicode,
      lastNameUnicode = _companion$lastNameUn === void 0 ? '' : _companion$lastNameUn;
  return "{\n    ".concat(birthdate ? "birthdate: \"".concat(PrebookingForm_utils_formatDate(birthdate), "\"") : '', "\n    civility: \"").concat(civility, "\"\n    lastName: \"").concat(lastName, "\"\n    unicodeLastName: \"").concat(lastNameUnicode, "\"\n    firstName: \"").concat(firstName, "\"\n    unicodeFirstName: \"").concat(firstNameUnicode, "\"\n  }");
};

var getCompanionsQuery = function getCompanionsQuery(companions) {
  return companions.reduce(function (acc, companion) {
    return "".concat(acc).concat(getCompanionQuery(companion));
  }, '');
};

var PrebookingForm_utils_getPrebookingFormQuery = function getPrebookingFormQuery(values, cxoId, appContext) {
  var accommodation = values.accommodation,
      accommodationCategory = values.accommodationCategory,
      adults = values.adults,
      agency = values.agency,
      departureCity = values.departureCity,
      departureDate = values.departureDate,
      duration = values.duration,
      kids = values.kids,
      optinEmail = values.optinEmail,
      optinPhone = values.optinPhone,
      optinSms = values.optinSms,
      productId = values.productId,
      traveler = values.traveler;
  var birthdate = traveler.birthdate,
      civility = traveler.civility,
      email = traveler.email,
      firstName = traveler.firstName,
      _traveler$firstNameUn = traveler.firstNameUnicode,
      firstNameUnicode = _traveler$firstNameUn === void 0 ? '' : _traveler$firstNameUn,
      lastName = traveler.lastName,
      _traveler$lastNameUni = traveler.lastNameUnicode,
      lastNameUnicode = _traveler$lastNameUni === void 0 ? '' : _traveler$lastNameUni,
      _traveler$memberNumbe = traveler.memberNumber,
      memberNumber = _traveler$memberNumbe === void 0 ? '' : _traveler$memberNumbe,
      phone = traveler.phone;
  return "mutation {\n    prebooking(\n      productId: \"".concat(productId, "\"\n      departureCity: \"").concat(departureCity, "\"\n      departureDate: \"").concat(PrebookingForm_utils_formatDate(departureDate.from || Date.now()), "\"\n      duration: ").concat(parseInt(duration, 10), "\n      accommodation: ").concat(accommodation ? "\"".concat(accommodation, "\"") : 'null', "\n      accommodationCategory: \"").concat(accommodationCategory, "\"\n      agency: ").concat(agency ? "\"".concat(agency, "\"") : 'null', "\n      ").concat(Object(sellerUtils["g" /* isSeller */])(appContext) && cxoId ? "agentId : \"".concat(Object(sellerUtils["a" /* decryptHeptaSeller */])(cxoId), "\"") : '', "\n      mainContact: {\n        gmNumber: \"").concat(memberNumber, "\"\n        civility: \"").concat(civility, "\"\n        lastName: \"").concat(lastName, "\"\n        unicodeLastName: \"").concat(lastNameUnicode, "\"\n        firstName: \"").concat(firstName, "\"\n        unicodeFirstName: \"").concat(firstNameUnicode, "\"\n        ").concat(birthdate ? "birthdate: \"".concat(PrebookingForm_utils_formatDate(birthdate), "\"") : '', "\n        email: \"").concat(email, "\"\n        mobile: \"").concat(phone, "\"\n        ").concat(typeof optinSms !== 'undefined' ? "optinSms: ".concat(optinSms.toString()) : '', "\n        ").concat(typeof optinPhone !== 'undefined' ? "optinPhone: ".concat(optinPhone.toString()) : '', "\n        ").concat(typeof optinEmail !== 'undefined' ? "optinEmail: ".concat(optinEmail.toString()) : '', "\n      }\n      adults: [").concat(getCompanionsQuery(adults), "]\n      children: [").concat(getCompanionsQuery(kids), "]\n    ) {\n      errors {\n        errorKey\n        errorCode\n      }\n      neolaneID\n    }\n  }");
};
var handleSubmit = /*#__PURE__*/function () {
  var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values, params) {
    var actions, appContext, cxoId, history, location, redirects, errorUrl, successUrl, prebookingFormQuery, _ref6, prebooking, neolaneId, requestHasSucceeded, redirectUri;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            actions = params.actions, appContext = params.appContext, cxoId = params.cxoId, history = params.history, location = params.location, redirects = params.redirects;
            errorUrl = redirects.errorUrl, successUrl = redirects.successUrl;
            prebookingFormQuery = PrebookingForm_utils_getPrebookingFormQuery(values, cxoId, appContext);
            _context.prev = 3;
            _context.next = 6;
            return graphqlClient["a" /* default */].runNoCacheQuery(prebookingFormQuery, appContext, {
              requestName: requestDictionary["hb" /* CUSTOMER_BOOKING_PREBOOKING_FORM_SUBMIT */]
            });

          case 6:
            _ref6 = _context.sent;
            prebooking = _ref6.prebooking; // Set isLoading to false

            actions.setSubmitting(false); // Track

            neolaneId = prebooking.neolaneID;

            if (neolaneId) {
              tracking_api["b" /* setDataLayer */]({
                categoryGA: 'prebooking-form',
                actionGA: 'CTASendRequest',
                labelGA: values.productId,
                user: {
                  neolaneID: neolaneId
                }
              }, appContext);
            } // Redirect


            requestHasSucceeded = prebooking.errors.length === 0;
            redirectUri = requestHasSucceeded ? successUrl : errorUrl;

            if (Object(sellerUtils["g" /* isSeller */])(appContext) && requestHasSucceeded) {
              redirectUri = routeBuilder["a" /* buildUrl */]('prebookingformSuccessSeller');
            }

            history.push(new URI_default.a(redirectUri).query(PrebookingForm_utils_objectSpread(PrebookingForm_utils_objectSpread({}, location.queryParams), {}, {
              trackingPageLoadAppendSuffix: values.productId
            })).toString());
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](3);

            if (ple_utils["l" /* hasAuthResponseError */](_context.t0)) {
              ple_utils["o" /* redirectOnLoginPage */]({
                locale: appContext.locale,
                redirectPath: location.pathname // state: values,

              });
            } else {
              history.push(new URI_default.a(errorUrl).query(PrebookingForm_utils_objectSpread(PrebookingForm_utils_objectSpread({}, location.queryParams), {}, {
                trackingPageLoadAppendSuffix: values.productId
              })).toString());
            }

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 17]]);
  }));

  return function handleSubmit(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();
var PrebookingForm_utils_getClosingDatesRanges = function getClosingDatesRanges(openingDatesRanges) {
  return (// $FlowFixMe
    openingDatesRanges.sort(function (date1, date2) {
      return Number(date1.opening) - Number(date2.opening);
    }) // $FlowFixMe
    .map(function (openingDate, index, openingDates) {
      var _openingDates;

      return {
        after: Object(apiDate["h" /* momentFromApiDate */])(openingDate.closing).toDate(),
        before: Object(apiDate["h" /* momentFromApiDate */])(((_openingDates = openingDates[index + 1]) === null || _openingDates === void 0 ? void 0 : _openingDates.opening) || openingDates[0].opening).toDate()
      };
    })
  );
};
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingFormCompanion.jsx
var PrebookingFormCompanion_jsx = react_default.a.createElement;





var PrebookingFormCompanion_PrebookingFormCompanion = function PrebookingFormCompanion(props) {
  var companionGroup = props.companionGroup,
      dateFormat = props.dateFormat,
      hasUnicodeFields = props.hasUnicodeFields,
      index = props.index,
      civilities = props.civilities;
  var formHeader = companionGroup === COMPANION_GROUPS.ADULTS ? "".concat(Object(src_i18n["f" /* t */])('prebookingForm.pax.adultCompanionLabel'), " ").concat(index + 1) : "".concat(Object(src_i18n["f" /* t */])('prebookingForm.pax.childCompanionLabel'), " ").concat(index + 1);
  var isRequiredForAdults = companionGroup === COMPANION_GROUPS.ADULTS;
  var isRequiredForKids = companionGroup === COMPANION_GROUPS.KIDS;
  return PrebookingFormCompanion_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingFormCompanion_jsx("p", {
    className: "w-full mb-2 px-2 text-base font-bold"
  }, formHeader), PrebookingFormCompanion_jsx("div", {
    className: "w-full"
  }, PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-civility-field"),
    isRequired: isRequiredForAdults,
    name: "".concat(companionGroup, ".").concat(index, ".civility"),
    options: civilities,
    placeholder: "".concat(Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.civilityPlaceholder')).concat(isRequiredForAdults ? '*' : ''),
    type: "select"
  }))), PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-firstName-field"),
    isRequired: true,
    name: "".concat(companionGroup, ".").concat(index, ".firstName"),
    optimized: true,
    placeholder: "".concat(Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.firstNamePlaceholder'), "*"),
    type: "text"
  })), PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-lastName-field"),
    isRequired: true,
    name: "".concat(companionGroup, ".").concat(index, ".lastName"),
    optimized: true,
    placeholder: "".concat(Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.lastNamePlaceholder'), "*"),
    type: "text"
  })), hasUnicodeFields && PrebookingFormCompanion_jsx(react["Fragment"], null, PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-firstNameUnicode-field"),
    name: "".concat(companionGroup, ".").concat(index, ".firstNameUnicode"),
    optimized: true,
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    type: "text"
  })), PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-lastNameUnicode-field"),
    isRequired: true,
    name: "".concat(companionGroup, ".").concat(index, ".lastNameUnicode"),
    optimized: true,
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    type: "text"
  }))), PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-birthdate-field"),
    isRequired: isRequiredForKids,
    label: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.birthDateInformation'),
    name: "".concat(companionGroup, ".").concat(index, ".birthdate"),
    placeholder: "".concat(Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.birthDateInformation')).concat(isRequiredForKids ? '*' : '', "}"),
    type: "birthdate",
    dayPlaceholder: "DD",
    monthPlaceholder: "MM",
    yearPlaceholder: "YYYY",
    dateFormat: dateFormat,
    validate: isRequiredForKids ? PrebookingForm_utils_getKidFutureBithdateValidator() : getAdultBirthdateValidator()
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingForm.jsx


var PrebookingForm_jsx = react_default.a.createElement;

function PrebookingForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PrebookingForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PrebookingForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PrebookingForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var DEFAULT_COMPANION = {
  birthdate: null,
  civility: '',
  firstName: '',
  lastName: ''
};
function PrebookingForm(_ref) {
  var _sortedOpeningDates$, _sortedOpeningDates;

  var adultsOptions = _ref.adultsOptions,
      agencies = _ref.agencies,
      civilities = _ref.civilities,
      dateFormat = _ref.dateFormat,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      hasSeller = _ref.hasSeller,
      hasUnicodeFields = _ref.hasUnicodeFields,
      hasUser = _ref.hasUser,
      initialFormData = _ref.initialFormData,
      kidsOptions = _ref.kidsOptions,
      newsletterOptins = _ref.newsletterOptins,
      productOptions = _ref.productOptions,
      products = _ref.products;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      isValid = _useFormikContext.isValid,
      values = _useFormikContext.values,
      setValues = _useFormikContext.setValues,
      isSubmitting = _useFormikContext.isSubmitting; // CXO/Auth: update traveler information


  Object(react["useEffect"])(function () {
    setValues(PrebookingForm_objectSpread(PrebookingForm_objectSpread({}, values), initialFormData));
  }, [initialFormData]);
  Object(react["useEffect"])(function () {
    var _products$values$prod;

    var departureDate = values.departureDate.from;

    if (values.productId && departureDate && !((_products$values$prod = products[values.productId]) === null || _products$values$prod === void 0 ? void 0 : _products$values$prod.openingDates.some(function (_ref2) {
      var opening = _ref2.opening,
          closing = _ref2.closing;
      return moment_default()(departureDate).isBetween(Object(apiDate["h" /* momentFromApiDate */])(opening), Object(apiDate["h" /* momentFromApiDate */])(closing));
    }))) {
      setValues(PrebookingForm_objectSpread(PrebookingForm_objectSpread({}, values), {}, {
        departureDate: {
          from: null,
          to: null
        }
      }));
    }
  }, [values.productId]);
  var optinEmail = newsletterOptins.optinEmail,
      optinPhone = newsletterOptins.optinPhone,
      optinSms = newsletterOptins.optinSms,
      optinProfile = newsletterOptins.optinProfile;
  var productId = values.productId,
      accommodationCategory = values.accommodationCategory,
      adults = values.adults,
      adultsNumber = values.adultsNumber,
      kids = values.kids,
      kidsNumber = values.kidsNumber;
  var product = productId ? products[productId] : null;
  var minAuthorizedAge = product ? product.minAuthorizedAge : null;
  var durationOptions = product ? product.durations : [];
  var transportOptions = product ? product.transports : [];
  var accommodationCategoryOptions = product ? product.accommodations : [];

  var _ref3 = product && accommodationCategory ? product.accommodations.find(function (a) {
    return a.value === accommodationCategory;
  }) || {} : {},
      _ref3$types = _ref3.types,
      accommodationOptions = _ref3$types === void 0 ? [] : _ref3$types;

  var adultsInt = parseInt(adultsNumber, 10);
  var kidsInt = parseInt(kidsNumber, 10);
  var hasAddtionnalTravelers = adultsInt > MIN_FORM_ADULTS || kidsInt > MIN_FORM_KIDS;

  var handleAdultsNumber = function handleAdultsNumber(e) {
    var updatedAdultsNumber = e.target.value;
    var updatedAdultsInt = parseInt(updatedAdultsNumber, 10);
    var newAdults = updatedAdultsInt - adultsInt;
    var updatedAdults = newAdults > 0 ? [].concat(Object(toConsumableArray["a" /* default */])(adults), Object(toConsumableArray["a" /* default */])(Array(newAdults).fill(null).map(function () {
      return DEFAULT_COMPANION;
    }))) : adults.slice(0, updatedAdultsInt - MIN_FORM_ADULTS);
    setValues(PrebookingForm_objectSpread(PrebookingForm_objectSpread({}, values), {}, {
      adultsNumber: updatedAdultsNumber,
      adults: updatedAdults
    }));
  };

  var handleKidsNumber = function handleKidsNumber(e) {
    var updatedKidsNumber = e.target.value;
    var updatedKidsInt = parseInt(updatedKidsNumber, 10);
    var newKids = updatedKidsInt - kidsInt;
    var updatedKids = newKids > 0 ? [].concat(Object(toConsumableArray["a" /* default */])(kids), Object(toConsumableArray["a" /* default */])(Array(newKids).fill(null).map(function () {
      return DEFAULT_COMPANION;
    }))) : kids.slice(0, updatedKidsInt);
    setValues(PrebookingForm_objectSpread(PrebookingForm_objectSpread({}, values), {}, {
      kidsNumber: updatedKidsNumber,
      kids: updatedKids
    }));
  };

  var sortedOpeningDates = Object(toConsumableArray["a" /* default */])((product === null || product === void 0 ? void 0 : product.openingDates) || []).sort(function (date1, date2) {
    return Number(date1.opening) - Number(date2.opening);
  });

  var disabledDays = PrebookingForm_utils_getClosingDatesRanges(sortedOpeningDates);
  var firstOpeningDate = (_sortedOpeningDates$ = sortedOpeningDates[0]) === null || _sortedOpeningDates$ === void 0 ? void 0 : _sortedOpeningDates$.opening;
  var minDate = firstOpeningDate && Object(apiDate["h" /* momentFromApiDate */])(firstOpeningDate).isAfter(moment_default()(departureDateStart)) ? Object(apiDate["h" /* momentFromApiDate */])(firstOpeningDate).toDate() : departureDateStart;
  var lastClosingDate = (_sortedOpeningDates = sortedOpeningDates[sortedOpeningDates.length - 1]) === null || _sortedOpeningDates === void 0 ? void 0 : _sortedOpeningDates.closing;
  var maxDate = lastClosingDate && moment_default()(departureDateEnd).isAfter(Object(apiDate["h" /* momentFromApiDate */])(lastClosingDate)) ? Object(apiDate["h" /* momentFromApiDate */])(lastClosingDate).toDate() : departureDateEnd;

  var MandatoryFieldsNote = function MandatoryFieldsNote() {
    return PrebookingForm_jsx("p", {
      className: "m-0 mb-3 px-2 text-small"
    }, Object(src_i18n["f" /* t */])('prebookingForm.mandatoryFieldsInformation'));
  };

  return PrebookingForm_jsx(formik_esm["c" /* Form */], {
    id: "prebooking-form-form",
    "data-testid": "prebooking-form-form"
  }, PrebookingForm_jsx(Title["a" /* Title */], {
    className: "mt-8 mb-1 px-2",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["f" /* t */])('prebookingForm.stay.title')), PrebookingForm_jsx(MandatoryFieldsNote, null), PrebookingForm_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "product-id-field",
    hideErrorMessage: true,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('prebookingForm.stay.productLabel'),
    name: "productId",
    options: productOptions,
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.stay.productPlaceholder'),
    type: "select"
  }), minAuthorizedAge ? PrebookingForm_jsx(Notification["a" /* Notification */], {
    className: "px-0 py-0",
    text: minAuthorizedAge
  }) : null), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-city-field",
    hideErrorMessage: true,
    isDisabled: !productId,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('prebookingForm.stay.departureCityLabel'),
    name: "departureCity",
    options: transportOptions,
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.stay.departureCityPlaceholder'),
    type: "select"
  }))), PrebookingForm_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-date-field",
    dateFormat: dateFormat,
    hideErrorMessage: true,
    isDisabled: !productId,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('prebookingForm.stay.departureDateLabel'),
    maxDate: maxDate,
    minDate: minDate,
    disabledDays: disabledDays,
    name: "departureDate",
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.stay.departureDatePlaceholder'),
    type: "datepicker"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "duration-field",
    hideErrorMessage: true,
    isDisabled: !productId,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('prebookingForm.stay.durationLabel'),
    name: "duration",
    options: durationOptions,
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.stay.durationPlaceholder'),
    type: "select"
  }))), PrebookingForm_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingForm_jsx("p", {
    className: classnames_default()('w-full mt-2 mb-0 px-2 text-base font-bold', {
      'text-gray-darker': !!productId,
      'text-gray-light': !productId
    })
  }, Object(src_i18n["f" /* t */])('prebookingForm.stay.accommodationsLabel'), '*'), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "accommodation-category-field",
    hideErrorMessage: true,
    isDisabled: !productId,
    isRequired: true,
    name: "accommodationCategory",
    options: accommodationCategoryOptions,
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.stay.accommodationsCategoryPlaceholder'),
    type: "select"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "accommodation-field",
    hideErrorMessage: true,
    isDisabled: !productId,
    name: "accommodation",
    options: accommodationOptions,
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.stay.accommodationsTypePlaceholder'),
    type: "select"
  }))), PrebookingForm_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingForm_jsx("p", {
    className: "w-full mt-2 mb-0 px-2 text-base font-bold"
  }, Object(src_i18n["f" /* t */])('prebookingForm.stay.numberOfParticipantsLabel'), '*'), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "adults-number-field",
    hideErrorMessage: true,
    name: "adultsNumber",
    options: adultsOptions,
    onChange: handleAdultsNumber,
    type: "select"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "kids-number-field",
    hideErrorMessage: true,
    name: "kidsNumber",
    options: kidsOptions,
    onChange: handleKidsNumber,
    type: "select"
  }))), PrebookingForm_jsx(Title["a" /* Title */], {
    className: "mt-8 mb-1 px-2",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.title')), PrebookingForm_jsx(MandatoryFieldsNote, null), PrebookingForm_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingForm_jsx("div", {
    className: "w-full"
  }, PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-civility-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.civilityPlaceholder'),
    name: "traveler.civility",
    options: civilities.adults,
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.civilityPlaceholder'),
    type: "select"
  }))), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-firstName-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.firstNamePlaceholder'),
    name: "traveler.firstName",
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.firstNamePlaceholder'),
    type: "text"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-lastName-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.lastNamePlaceholder'),
    name: "traveler.lastName",
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.lastNamePlaceholder'),
    type: "text"
  })), hasUnicodeFields && PrebookingForm_jsx(react["Fragment"], null, PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-firstNameUnicode-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    name: "traveler.firstNameUnicode",
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    type: "text"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-lastNameUnicode-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    name: "traveler.lastNameUnicode",
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    type: "text"
  }))), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-birthdate-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    label: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.birthDateInformation'),
    name: "traveler.birthdate",
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.birthDateInformation'),
    type: "birthdate",
    dayPlaceholder: "DD",
    monthPlaceholder: "MM",
    yearPlaceholder: "YYYY",
    dateFormat: dateFormat
  })), !hasSeller && PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-gm-number-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    label: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.gmNumberPlaceholder'),
    name: "traveler.memberNumber",
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.gmNumberPlaceholder'),
    type: "text"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-email-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.emailPlaceholder'),
    name: "traveler.email",
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.emailPlaceholder'),
    type: "text"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-phone-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.phoneNumberPlaceholder'),
    name: "traveler.phone",
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.phoneNumberPlaceholder'),
    type: "text"
  })), agencies.length > 0 && PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-agency-field",
    hideErrorMessage: true,
    isDisabled: hasSeller,
    label: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.favoriteTravelAgencyLabel'),
    name: "agency",
    options: agencies,
    placeholder: Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.favoriteTravelAgencyPlaceholder'),
    type: "select"
  })), hasAddtionnalTravelers && PrebookingForm_jsx("div", {
    className: "w-full p-2"
  }, PrebookingForm_jsx(Title["a" /* Title */], {
    className: "mt-8 mb-1 px-2",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["f" /* t */])('prebookingForm.pax.title')), PrebookingForm_jsx(MandatoryFieldsNote, null), adults.map(function (adult, index) {
    return PrebookingForm_jsx(PrebookingFormCompanion_PrebookingFormCompanion, {
      key: "adult-".concat(index),
      companionGroup: ADULTS,
      dateFormat: dateFormat,
      civilities: civilities.adults,
      hasUnicodeFields: hasUnicodeFields,
      index: index
    });
  }), kids.map(function (kid, index) {
    return PrebookingForm_jsx(PrebookingFormCompanion_PrebookingFormCompanion, {
      key: "kid-".concat(index),
      companionGroup: KIDS,
      dateFormat: dateFormat,
      civilities: civilities.kids,
      hasUnicodeFields: hasUnicodeFields,
      index: index
    });
  })), !hasSeller && PrebookingForm_jsx("div", {
    className: "w-full p-2"
  }, PrebookingForm_jsx("p", {
    className: "w-full mb-2 text-base font-bold"
  }, Object(src_i18n["f" /* t */])('prebookingForm.mainTraveler.optinCommunicationsInformation')), optinEmail && PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-3",
    dataTestId: "optin-email-field",
    label: optinEmail.title,
    name: "optinEmail",
    optimized: true,
    type: "checkbox"
  }), optinPhone && PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-3",
    dataTestId: "optin-phone-field",
    label: optinPhone.title,
    name: "optinPhone",
    optimized: true,
    type: "checkbox"
  }), optinSms && PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-3",
    dataTestId: "optin-sms-field",
    label: optinSms.title,
    name: "optinSms",
    optimized: true,
    type: "checkbox"
  }), optinEmail && optinEmail.description && PrebookingForm_jsx(Text["a" /* Text */], {
    className: "mt-4",
    theme: "text-sans-2",
    text: optinEmail.description
  }), optinProfile && optinProfile.description && PrebookingForm_jsx(Text["a" /* Text */], {
    className: "mt-4",
    theme: "text-sans-2",
    text: optinProfile.description
  }))), PrebookingForm_jsx("div", {
    className: "mt-4 px-2 text-right"
  }, PrebookingForm_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BLUE,
    colorBorder: colors["a" /* COLORS */].BLUE,
    dataTestId: "prebooking-submit",
    isDisabled: !isValid,
    isLoading: isSubmitting,
    type: "submit"
  }, Object(src_i18n["f" /* t */])('prebookingForm.sendRequest'))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingFormContainer.jsx




var PrebookingFormContainer_jsx = react_default.a.createElement;

function PrebookingFormContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PrebookingFormContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PrebookingFormContainer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PrebookingFormContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function PrebookingFormContainer(_ref) {
  var adultsOptions = _ref.adultsOptions,
      agencies = _ref.agencies,
      civilities = _ref.civilities,
      cxoAgency = _ref.cxoAgency,
      cxoId = _ref.cxoId,
      dateFormat = _ref.dateFormat,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      hasSeller = _ref.hasSeller,
      hasUnicodeFields = _ref.hasUnicodeFields,
      hasUser = _ref.hasUser,
      kidsOptions = _ref.kidsOptions,
      newsletterOptins = _ref.newsletterOptins,
      productOptions = _ref.productOptions,
      products = _ref.products,
      redirectUris = _ref.redirectUris;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history,
      location = _useRouter.location;

  var redirects = {
    errorUrl: redirectUris.error || '/',
    successUrl: redirectUris.success || '/'
  };
  var productIds = productOptions.map(function (productOption) {
    return productOption.value;
  }).filter(Boolean);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useSelector = Object(es["e" /* useSelector */])(function (state) {
    var userInfo = state.userInfo,
        _state$seller = state.seller,
        seller = _state$seller === void 0 ? {
      neolids: []
    } : _state$seller,
        _state$tripInformatio = state.tripInformation;
    _state$tripInformatio = _state$tripInformatio === void 0 ? {
      adults: [],
      kids: []
    } : _state$tripInformatio;
    var adults = _state$tripInformatio.adults,
        kids = _state$tripInformatio.kids;

    if (seller.neolids.length > 0) {
      return {
        initialFormData: PrebookingForm_utils_getFormTravelerAndCompanions({
          adults: adults,
          kids: kids
        }),
        travelers: {
          adults: adults.map(function (adult) {
            return adult.neolid;
          }).filter(Boolean),
          kids: kids.map(function (kid) {
            return kid.neolid;
          }).filter(Boolean)
        }
      };
    }

    return {
      initialFormData: PrebookingFormContainer_objectSpread({
        traveler: getFormUser(userInfo)
      }, getFormOptins(userInfo)),
      travelers: null
    };
  }),
      initialFormData = _useSelector.initialFormData,
      travelers = _useSelector.travelers;

  var travelerIds = travelers ? [].concat(Object(toConsumableArray["a" /* default */])(travelers.adults), Object(toConsumableArray["a" /* default */])(travelers.kids)).join() : ''; // CXO: fetch complete traveler information

  Object(react["useEffect"])(function () {
    if (hasSeller && travelerIds.length > 0) {
      dispatch(Object(prebookingform_action["b" /* fetchPrebookingTravelers */])(travelers, appContext));
    }
  }, [travelerIds]);
  return PrebookingFormContainer_jsx(formik_esm["d" /* Formik */], {
    initialValues: PrebookingForm_utils_getInitialFormValues(cxoAgency),
    validationSchema: PrebookingForm_utils_getFormSchema(src_i18n["f" /* t */], {
      agencies: agencies.map(function (agency) {
        return agency.value;
      }),
      civilities: civilities,
      locale: appContext.locale,
      productIds: productIds
    }),
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values, actions) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return handleSubmit(values, {
                  actions: actions,
                  appContext: appContext,
                  cxoId: cxoId,
                  dateFormat: dateFormat,
                  history: history,
                  location: location,
                  redirects: redirects
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, PrebookingFormContainer_jsx(PrebookingForm, {
    adultsOptions: adultsOptions,
    agencies: agencies,
    civilities: civilities,
    dateFormat: dateFormat,
    departureDateEnd: departureDateEnd,
    departureDateStart: departureDateStart,
    hasUnicodeFields: hasUnicodeFields,
    initialFormData: initialFormData,
    hasUser: hasUser,
    hasSeller: hasSeller,
    kidsOptions: kidsOptions,
    newsletterOptins: newsletterOptins,
    productOptions: productOptions,
    products: products
  }));
}
// EXTERNAL MODULE: ./src/utils/legal-information/legalInformationIds.constants.js
var legalInformationIds_constants = __webpack_require__("y5Lu");

// CONCATENATED MODULE: ./src/client/store/utils/selectOptionsBuilders.js


function getCountOptions(labels, initial, limit) {
  var options = [];
  var messageFormat = Object(dist["messageFormat"])(labels);

  for (var count = initial; count <= limit + 1; count++) {
    options.push({
      label: messageFormat.format({
        count: count
      }),
      value: count
    });
  }

  return options;
}
function getAdultsOptions(selectAdultsLabels) {
  var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
  return getCountOptions(selectAdultsLabels, initial, limit);
}
function getChildrenOptions(selectChildrenLabels) {
  var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
  return getCountOptions(selectChildrenLabels, initial, limit);
}
function getDurationOptions(messageFormat, durations) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'duration';
  var durationMessage = Object(dist["messageFormat"])(messageFormat);
  return durations.map(function (duration) {
    return {
      name: durationMessage.format(Object(defineProperty["a" /* default */])({}, key, duration)),
      label: durationMessage.format(Object(defineProperty["a" /* default */])({}, key, duration)),
      value: duration.toString()
    };
  });
}
// CONCATENATED MODULE: ./src/client/components/lines/prebooking-form-line/PrebookingFormLine.utils.js






 // Line props
// CIVILITIES

var PrebookingFormLine_utils_getCivilities = function getCivilities(adultCivilities, locale) {
  return {
    adults: adultCivilities,
    kids: Object(domains_service_dist["getKidsCivilities"])(locale).map(function (_ref) {
      var value = _ref.value,
          label = _ref.label;
      return {
        value: value,
        name: label
      };
    })
  };
}; // TRAVEL AGENCY OPTIONS

var getAgencyName = function getAgencyName(travelAgency) {
  var _travelAgency$address;

  return "".concat(((_travelAgency$address = travelAgency.address) === null || _travelAgency$address === void 0 ? void 0 : _travelAgency$address.city) || '', " - ").concat(travelAgency.name);
};

var getFilteredAgencyName = function getFilteredAgencyName(travelAgency) {
  /**
   * ^[.+?\s]*            Match 0 or more chars or white space at the beginning
   * (?:<T1>|<T2>)?       Do not capture group of 1st or 2nd potential terms
   * \s*                  Match 0 or more white spaces
   * (.+?)$               Capture group of any chars up to the end
   * /i                   Case insensitive Flags
   */
  var agencyNameFilter = /^[.+?\s]*(?:CLUB MED VOYAGES|APPARTEMENT BOUTIQUE)?\s*(.+?)$/i;
  var trimmedName = agencyNameFilter.exec(travelAgency.name);
  return trimmedName && trimmedName[1] ? trimmedName[1] : getAgencyName(travelAgency);
};

var getTravelAgencyOptions = function getTravelAgencyOptions(travelAgencies, locale) {
  if (!travelAgencies) {
    return [];
  }

  return travelAgencies.map(function (travelAgency) {
    return {
      name: locale === 'fr-FR' ? getFilteredAgencyName(travelAgency) : getAgencyName(travelAgency),
      value: travelAgency.id
    };
  }).sort(function (travelAgencyA, travelAgencyB) {
    return travelAgencyA.name.localeCompare(travelAgencyB.name) > 0 ? 1 : -1;
  });
}; // ADULTS/KIDS NUMBER OPTIONS

var PrebookingFormLine_utils_getAdultsNumberOptions = function getAdultsNumberOptions(adultsAge) {
  return getAdultsOptions(adultsAge, MIN_FORM_ADULTS, MAX_FORM_ADULTS).map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return {
      name: label,
      value: value.toString()
    };
  });
};
var PrebookingFormLine_utils_getKidsNumberOptions = function getKidsNumberOptions(kidsAge) {
  return getChildrenOptions(kidsAge, MIN_FORM_KIDS, MAX_FORM_KIDS).map(function (_ref3) {
    var label = _ref3.label,
        value = _ref3.value;
    return {
      name: label,
      value: value.toString()
    };
  });
}; // NEWSLETTER OPTINS

var getNewsletterOptin = function getNewsletterOptin(optin) {
  return optin ? {
    title: optin.title,
    description: optin.description
  } : null;
};

var PrebookingFormLine_utils_getNewsletterOptins = function getNewsletterOptins(newsletterOptins) {
  var optinEmail = newsletterOptins.find(function (optin) {
    return optin.id === legalInformationIds_constants["b" /* EMAIL_OPTIN */];
  });
  var optinPhone = newsletterOptins.find(function (optin) {
    return optin.id === legalInformationIds_constants["j" /* PHONE_OPTIN */];
  });
  var optinSms = newsletterOptins.find(function (optin) {
    return optin.id === legalInformationIds_constants["l" /* SMS_OPTIN */];
  });
  var optinProfile = newsletterOptins.find(function (optin) {
    return optin.id === legalInformationIds_constants["k" /* PROFILING */];
  });
  return {
    optinEmail: getNewsletterOptin(optinEmail),
    optinPhone: getNewsletterOptin(optinPhone),
    optinSms: getNewsletterOptin(optinSms),
    optinProfile: getNewsletterOptin(optinProfile)
  };
}; // PRODUCT OPTIONS

var PrebookingFormLine_utils_getProductOption = function getProductOption(isTopProduct) {
  return function (product) {
    return {
      key: "".concat(product.productId, "-").concat(isTopProduct ? 'top' : 'regular'),
      name: "".concat(product.name, ", ").concat(Object(string_util["e" /* titleCase */])(product.destination.country)),
      value: product.productId
    };
  };
};

function getProductOptions(lineProducts, products) {
  var topProducts = lineProducts.filter(function (lineProduct) {
    return lineProduct.sortedFirst;
  }).map(function (_ref4) {
    var productId = _ref4.productId;
    return products[productId];
  }).filter(Boolean).map(PrebookingFormLine_utils_getProductOption(true));
  return [].concat(Object(toConsumableArray["a" /* default */])(topProducts), Object(toConsumableArray["a" /* default */])(topProducts.length ? [{
    key: 'separator',
    name: '──────────',
    value: null,
    isDisabled: true
  }] : []), Object(toConsumableArray["a" /* default */])(Object.values(products).map(PrebookingFormLine_utils_getProductOption(false)).sort(function (productOptionA, productOptionB) {
    if (!productOptionA.name) return 1;
    if (!productOptionB.name) return -1;
    return productOptionA.name.localeCompare(productOptionB.name);
  })));
} // PRODUCT DATA

function getAccommodationsOptions() {
  var accommodations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var accommodationCategories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return accommodationCategories.map(function (accommodationCategory) {
    var categoryId = accommodationCategory.id,
        categoryLabel = accommodationCategory.label,
        categoryRanking = accommodationCategory.ranking;
    var types = accommodations.filter(function (accommodation) {
      return accommodation.categories.map(function (_ref5) {
        var id = _ref5.id;
        return id;
      }).includes(categoryId);
    }).map(function (_ref6) {
      var id = _ref6.id,
          label = _ref6.label;
      return {
        name: label,
        value: id
      };
    });
    return {
      value: categoryId,
      name: categoryLabel,
      rankingIndex: Object.values(dist["constants"].RANKINGS).findIndex(function (ranking) {
        return ranking === categoryRanking;
      }),
      types: types
    };
  }).sort(function (accommodationsOptionA, accommodationsOptionB) {
    return accommodationsOptionB.rankingIndex - accommodationsOptionA.rankingIndex;
  });
}

function getFormProducts(_ref7) {
  var resorts = _ref7.resorts,
      bookingsCriteria = _ref7.bookingsCriteria,
      accommodationCategories = _ref7.accommodationCategories,
      durationLabels = _ref7.durationLabels;
  return resorts.reduce(function (products, product, productIndex) {
    var _bookingsCriteria$pro, _bookingsCriteria$pro2;

    var name = product.name,
        destination = product.destination,
        adultOnly = product.adultOnly,
        openingDates = product.openingDates,
        accommodations = product.accommodations,
        minAuthorizedAge = product.minAuthorizedAge;
    var durations = ((_bookingsCriteria$pro = bookingsCriteria[productIndex]) === null || _bookingsCriteria$pro === void 0 ? void 0 : _bookingsCriteria$pro.durations) || [];
    var transports = ((_bookingsCriteria$pro2 = bookingsCriteria[productIndex]) === null || _bookingsCriteria$pro2 === void 0 ? void 0 : _bookingsCriteria$pro2.departureCities) || [];
    var productAccommodationCategories = accommodationCategories.find(function (category) {
      return category.productId === product.id;
    });
    var categories = (productAccommodationCategories === null || productAccommodationCategories === void 0 ? void 0 : productAccommodationCategories.accommodations) || [];
    products[product.id] = {
      productId: product.id,
      name: name,
      destination: destination,
      openingDates: openingDates,
      minAuthorizedAge: minAuthorizedAge.formattedValue || '',
      minAuthorizedAgeInMonths: minAuthorizedAge.value || '',
      durations: getDurationOptions(durationLabels, durations, 'count'),
      transports: transports,
      accommodations: getAccommodationsOptions(accommodations, categories),
      adultOnly: adultOnly
    };
    return products;
  }, {});
}
// CONCATENATED MODULE: ./src/client/components/lines/prebooking-form-line/PrebookingFormLine.jsx


var PrebookingFormLine_jsx = react_default.a.createElement;

function PrebookingFormLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PrebookingFormLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PrebookingFormLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PrebookingFormLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function PrebookingFormLine(props) {
  var accommodationCategories = props.accommodationCategories,
      bookingsCriteria = props.bookingsCriteria,
      adultCivilities = props.civilities,
      config = props.config,
      dateFormat = props.dateFormat,
      error = props.error,
      legalInformations = props.legalInformations,
      login = props.login,
      mainTraveler = props.mainTraveler,
      mandatoryFieldsInformation = props.mandatoryFieldsInformation,
      pax = props.pax,
      products = props.products,
      resorts = props.resorts,
      sendRequest = props.sendRequest,
      stay = props.stay,
      success = props.success,
      travelAgencies = props.travelAgencies;
  Object(src_i18n["a" /* addTranslationKeys */])({
    prebookingForm: {
      login: login,
      mainTraveler: mainTraveler,
      mandatoryFieldsInformation: mandatoryFieldsInformation,
      pax: pax,
      sendRequest: sendRequest,
      stay: stay
    }
  });
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var hasUnicodeFields = appContext.displayUnicodeFields,
      locale = appContext.locale,
      hasSeller = appContext.isDirectCxo,
      hasUser = appContext.isUserLogged;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location; // CXO: set seller agency and id


  var agencies = getTravelAgencyOptions(travelAgencies, locale);

  var _useMemo = Object(react["useMemo"])(function () {
    var salesIds = {
      cxoAgency: null,
      cxoId: location.queryParams.cxo_id || null
    };
    var salesNetworkId = location.queryParams.cxo_sales_network_id;

    if (salesNetworkId) {
      var _salesNetworkId$split = salesNetworkId.split('_'),
          _salesNetworkId$split2 = Object(slicedToArray["a" /* default */])(_salesNetworkId$split, 1),
          sellerAgency = _salesNetworkId$split2[0];

      salesIds = PrebookingFormLine_objectSpread(PrebookingFormLine_objectSpread({}, salesIds), {}, {
        cxoAgency: agencies.map(function (a) {
          return a.value;
        }).find(function (travelAgencyId) {
          return travelAgencyId === sellerAgency;
        }) || null
      });
    }

    return salesIds;
  }, [location.queryParams]),
      cxoAgency = _useMemo.cxoAgency,
      cxoId = _useMemo.cxoId;

  var civilities = PrebookingFormLine_utils_getCivilities(adultCivilities.adult, locale);
  var hasLoginButton = !!config.memberSpace.accessButtonLoggedin;
  var formProducts = getFormProducts({
    accommodationCategories: accommodationCategories,
    bookingsCriteria: bookingsCriteria,
    resorts: resorts,
    durationLabels: props.stay.durationValue
  });
  var productOptions = getProductOptions(products, formProducts);
  var departureDateStart = new Date(props.departureDateStart);
  var departureDateEnd = new Date(props.departureDateEnd);
  var redirectUris = {
    error: error ? error.url : null,
    success: success ? success.url : null
  };
  var adultsOptions = PrebookingFormLine_utils_getAdultsNumberOptions(props.stay.adultsAge);
  var kidsOptions = PrebookingFormLine_utils_getKidsNumberOptions(props.stay.childrenAge);
  var newsletterOptins = PrebookingFormLine_utils_getNewsletterOptins(legalInformations.newsletterOptins || []);
  return PrebookingFormLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: "prebookingform",
    dataTestId: "prebooking-form-section",
    className: "Line"
  }, PrebookingFormLine_jsx(PrebookingFormLogin_PrebookingFormLogin, {
    hasLoginButton: hasLoginButton,
    hasUser: hasUser,
    hasSeller: hasSeller
  }), PrebookingFormLine_jsx(PrebookingFormContainer, {
    adultsOptions: adultsOptions,
    agencies: agencies,
    civilities: civilities,
    cxoAgency: cxoAgency,
    cxoId: cxoId,
    dateFormat: dateFormat,
    departureDateEnd: departureDateEnd,
    departureDateStart: departureDateStart,
    hasSeller: hasSeller,
    hasUnicodeFields: hasUnicodeFields,
    hasUser: hasUser,
    kidsOptions: kidsOptions,
    locale: locale,
    newsletterOptins: newsletterOptins,
    productOptions: productOptions,
    products: formProducts,
    redirectUris: redirectUris
  }));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/prebooking-form/prebookingForm.resolver.js
var prebookingForm_resolver = __webpack_require__("VqO2");

// CONCATENATED MODULE: ./src/client/cms/toolkit/prebooking-form/prebookingForm.descriptor.js



var prebookingFormDescriptor = {
  name: constants["G" /* PREBOOKING_FORM */],
  component: PrebookingFormLine,
  resolve: prebookingForm_resolver["a" /* prebookingFormResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-tags/ProductTags.jsx


var ProductTags_jsx = react_default.a.createElement;

function ProductTags_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductTags_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductTags_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductTags_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var ProductTags_ProductTags = function ProductTags(_ref) {
  var lineName = _ref.lineName,
      tags = _ref.tags,
      trackingData = _ref.trackingData;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(0),
      selectedTagIndex = _useState[0],
      setSelectedTagIndex = _useState[1];

  var track = Object(useTracking["a" /* useTracking */])(trackingData);
  var _tags$selectedTagInde = tags[selectedTagIndex],
      selectedProducts = _tags$selectedTagInde.products,
      selectedTagLabel = _tags$selectedTagInde.label;
  return ProductTags_jsx("div", {
    className: "flex flex-wrap w-full max-w-site"
  }, ProductTags_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["f" /* t */])('common.scrollBackward'),
    childrenWrapperClassNames: "flex",
    className: "w-screen lg:w-full -mx-5 lg:mx-0 mb-4",
    forwardLabel: Object(src_i18n["f" /* t */])('common.scrollForward')
  }, tags.map(function (tag, index) {
    return ProductTags_jsx(Tag["a" /* Tag */], {
      active: index === selectedTagIndex,
      borderColor: index === selectedTagIndex ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].GRAY_LIGHT,
      className: classnames_default()('rtl:mr-2 mb-2', {
        'rtl:ml-5 lg:rtl:ml-0': index === 0
      }),
      color: index === selectedTagIndex ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].GRAY_DARKER,
      key: tag.label,
      label: tag.label,
      onClick: function onClick() {
        return setSelectedTagIndex(index);
      },
      trackingData: ProductTags_objectSpread(ProductTags_objectSpread({}, trackingData), {}, {
        labelGA: "tag_".concat(tag.label)
      }),
      theme: "outlinedThin"
    });
  })), ProductTags_jsx(Slider, {
    className: "-mx-5 lg:mx-0 w-screen lg:w-full",
    cols: 0,
    hasControls: isDesktop && selectedProducts.length > 3,
    navPosition: "center",
    nbItemsToScroll: isTablet ? 2 : 1,
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous'),
    scrollAreaContainerClassName: "overflow-x-auto lg:overflow-hidden",
    scrollControlsClassName: "-mx-5 lg:mx-0"
  }, selectedProducts.map(function (product, index) {
    return ProductTags_jsx("div", {
      key: product.id,
      className: classnames_default()('relative rtl:pr-5', {
        'rtl:ml-5 lg:rtl:ml-0': index === 0
      }),
      style: {
        width: '85vw',
        maxWidth: '380px'
      }
    }, ProductTags_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({}, product, {
      index: index,
      lineName: lineName,
      onClick: function onClick() {
        return track({
          labelGA: "".concat(selectedTagLabel, "_").concat(product.id)
        });
      }
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-tags-line/ProductTagsLine.jsx

var ProductTagsLine_jsx = react_default.a.createElement;

function ProductTagsLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductTagsLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductTagsLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductTagsLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var ProductTagsLine_ProductTagsLine = function ProductTagsLine(_ref) {
  var config = _ref.config,
      id = _ref.id,
      products = _ref.products,
      seeAllProductsLink = _ref.seeAllProductsLink,
      tags = _ref.tags,
      title = _ref.title;

  if (!tags || tags.length === 0 || !products || products.length === 0) {
    return null;
  }

  Object(src_i18n["a" /* addTranslationKeys */])(config);
  var formattedProducts = products.map(function (product) {
    return Object(redux["d" /* compose */])(Product_mapper["c" /* getProductProps */], Product_mapper["d" /* setProductHref */])({
      config: config,
      product: product,
      isSliderDisabled: true
    });
  });
  var tagsWithProducts = tags.map(function (tag) {
    var productsInTag = tag.productIds.map(function (productId) {
      return formattedProducts.find(function (p) {
        return p.id === productId;
      });
    }).filter(Boolean);
    return productsInTag.length > 0 ? ProductTagsLine_objectSpread(ProductTagsLine_objectSpread({}, tag), {}, {
      products: productsInTag
    }) : null;
  }).filter(Boolean);
  var trackingData = {
    actionGA: 'push_content_IdealResort'
  };
  return tagsWithProducts.length > 0 && ProductTagsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    dataTestId: "Line-ProductTags",
    id: id
  }, ProductTagsLine_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, ProductTagsLine_jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), ProductTagsLine_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "m-auto md:mx-0 mt-4 md:mt-1 order-last md:order-none text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: ProductTagsLine_objectSpread(ProductTagsLine_objectSpread({}, trackingData), {}, {
      labelGA: 'seeAllResorts'
    }),
    url: seeAllProductsLink.url
  }, seeAllProductsLink.label), ProductTagsLine_jsx(ProductTags_ProductTags, {
    lineName: constants["sb" /* RESORT_TAGS */],
    tags: tagsWithProducts,
    trackingData: trackingData
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-tags/productTags.resolver.js
var productTags_resolver = __webpack_require__("2dUC");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-tags/productTags.descriptor.js



var productTagsDescriptor = {
  name: constants["W" /* PRODUCT_TAGS */],
  component: ProductTagsLine_ProductTagsLine,
  resolver: productTags_resolver["a" /* productTagsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/products-filters-line/ProductsFiltersLine.jsx
var ProductsFiltersLine_jsx = react_default.a.createElement;




var ProductsFiltersLine_ProductsFiltersLine = function ProductsFiltersLine(_ref) {
  var config = _ref.config,
      id = _ref.id,
      offer = _ref.offer;
  var appContext = react_default.a.useContext(ReactAppContext["a" /* default */]);

  if (!offer) {
    return null;
  }

  var isProductComparisonModeAuthorized = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('search.productComparison');
  return ProductsFiltersLine_jsx("div", {
    className: "Line Line-ProductsFilters",
    id: id
  }, ProductsFiltersLine_jsx(FacetSearch["a" /* FacetSearch */], {
    hideSearchInput: true,
    i18n: config,
    initialIsSearchEnabled: true,
    initialProducts: offer.products || [],
    isProductComparisonModeAuthorized: isProductComparisonModeAuthorized,
    offer: offer,
    resetSearchAtMount: true,
    shouldPersistCriteriaInUrl: true,
    withSearchFacets: true,
    withSearchForm: true,
    withSearchResults: true
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/products-filters/productsFilters.resolver.js
var productsFilters_resolver = __webpack_require__("YYl6");

// CONCATENATED MODULE: ./src/client/cms/toolkit/products-filters/productsFilters.descriptor.js



var productsFiltersDescriptor = {
  name: constants["H" /* PRODUCTS_FILTERS */],
  component: ProductsFiltersLine_ProductsFiltersLine,
  resolve: productsFilters_resolver["a" /* productsFiltersResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/products-grid/productsGrid.resolver.js
var productsGrid_resolver = __webpack_require__("3zhs");

// CONCATENATED MODULE: ./src/client/components/frameworks/async-loader/AsyncLoader.jsx








function AsyncLoader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AsyncLoader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AsyncLoader_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AsyncLoader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function AsyncLoader_createSuper(Derived) { var hasNativeReflectConstruct = AsyncLoader_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function AsyncLoader_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }


var AsyncLoader_AsyncLoader = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(AsyncLoader, _React$Component);

  var _super = AsyncLoader_createSuper(AsyncLoader);

  function AsyncLoader(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, AsyncLoader);

    _this = _super.call(this, props);
    _this.state = {
      data: null
    };
    _this.handleDataFetch = _this.handleDataFetch.bind(Object(assertThisInitialized["a" /* default */])(_this));
    return _this;
  }

  Object(createClass["a" /* default */])(AsyncLoader, [{
    key: "handleDataFetch",
    value: function handleDataFetch() {
      var _this2 = this;

      var fetchData = this.props.fetchData;
      return fetchData.apply(void 0, arguments).then(function (data) {
        _this2.setState({
          data: data
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var props = this.state.data ? this.props.asyncPropsMapper(children.props, this.state.data) : children.props;
      return /*#__PURE__*/react_default.a.cloneElement(children, AsyncLoader_objectSpread(AsyncLoader_objectSpread({}, props), {}, {
        fetchData: this.handleDataFetch
      }));
    }
  }]);

  return AsyncLoader;
}(react_default.a.Component);
// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/components/widgets/products-grid/ProductsGrid.jsx
var ProductsGrid = __webpack_require__("w04c");

// CONCATENATED MODULE: ./src/client/components/widgets/product/AsyncProductsGrid.jsx




var AsyncProductsGrid_jsx = react_default.a.createElement;

function AsyncProductsGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AsyncProductsGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AsyncProductsGrid_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AsyncProductsGrid_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var AsyncProductsGrid_AsyncProductsGrid = function AsyncProductsGrid(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useState = Object(react["useState"])(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _props$productIds = props.productIds,
      productIds = _props$productIds === void 0 ? [] : _props$productIds,
      offer = props.offer,
      productsMapper = props.productsMapper,
      asyncPropsMapper = props.asyncPropsMapper,
      fetchProducts = props.fetchProducts;

  var fetchMore = /*#__PURE__*/function () {
    var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var remainingProductIds, _yield$fetchProducts, products;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              remainingProductIds = productIds.slice(Product_utils["d" /* grid */].desktop);
              setIsLoading(true);
              _context.next = 4;
              return fetchProducts({
                appContext: appContext,
                productIds: remainingProductIds,
                offerId: offer ? offer.id : undefined,
                props: props
              });

            case 4:
              _yield$fetchProducts = _context.sent;
              products = _yield$fetchProducts.products;
              setIsLoading(false); // $FlowFixMe soz, i'm just refactoring, before me flow didn't understand the typings

              return _context.abrupt("return", productsMapper(AsyncProductsGrid_objectSpread(AsyncProductsGrid_objectSpread({}, props), {}, {
                products: products
              })));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchMore() {
      return _ref.apply(this, arguments);
    };
  }();

  return AsyncProductsGrid_jsx(AsyncLoader_AsyncLoader, {
    asyncPropsMapper: asyncPropsMapper,
    fetchData: fetchMore
  }, AsyncProductsGrid_jsx(ProductsGrid["a" /* ProductsGrid */], Object(esm_extends["a" /* default */])({}, props, {
    isLoading: isLoading,
    offer: offer
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/products-grid-line/ProductsGridLine.utils.js


var ProductsGridLine_utils_productsMapper = function productsMapper(props) {
  var _props$products = props.products,
      products = _props$products === void 0 ? [] : _props$products,
      _props$productIds = props.productIds,
      productIds = _props$productIds === void 0 ? [] : _props$productIds,
      config = props.config,
      _props$offer = props.offer,
      offer = _props$offer === void 0 ? {} : _props$offer;
  return productIds.reduce(function (prev, next) {
    var product = products.find(function (_ref) {
      var id = _ref.id;
      return next === id;
    });

    if (product) {
      prev.push(product);
    }

    return prev;
  }, []).map(function (product) {
    return Object(Product_mapper["c" /* getProductProps */])({
      config: config,
      product: product,
      contextualizeUrl: !!(props.departureDateStart && props.departureDateEnd),
      offerColor: offer.color
    });
  });
};
var ProductsGridLine_utils_asyncPropsMapper = function asyncPropsMapper(initialProps, moreProducts) {
  var _initialProps$product = initialProps.products,
      products = _initialProps$product === void 0 ? [] : _initialProps$product;
  return {
    products: [].concat(Object(toConsumableArray["a" /* default */])(products), Object(toConsumableArray["a" /* default */])(moreProducts))
  };
};
// CONCATENATED MODULE: ./src/client/components/lines/products-grid-line/ProductsGridLine.jsx


var ProductsGridLine_jsx = react_default.a.createElement;







var ProductsGridLine_ProductsGridLine = function ProductsGridLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  var moreResultsColor = props.moreResultsColor,
      moreResultsLabel = props.moreResultsLabel,
      moreResultsButtonLabel = props.moreResultsButtonLabel,
      unfoldList = props.unfoldList,
      _props$productIds = props.productIds,
      productIds = _props$productIds === void 0 ? [] : _props$productIds;
  return ProductsGridLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-ProductsGrid",
    id: id
  }, ProductsGridLine_jsx(AsyncProductsGrid_AsyncProductsGrid, Object(esm_extends["a" /* default */])({}, props, {
    asyncPropsMapper: ProductsGridLine_utils_asyncPropsMapper,
    fetchProducts: productsGrid_resolver["a" /* fetchProducts */],
    grid: Product_utils["d" /* grid */],
    hasSeeMore: !unfoldList,
    lineName: constants["hb" /* RESORT_GRID */],
    products: ProductsGridLine_utils_productsMapper(props),
    productsMapper: ProductsGridLine_utils_productsMapper,
    seeMore: {
      color: moreResultsColor,
      text: moreResultsLabel,
      label: moreResultsButtonLabel
    },
    totalNumberToDisplay: productIds.length
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/products-grid/productsGrid.descriptor.js



var productsGridDescriptor = {
  name: constants["hb" /* RESORT_GRID */],
  component: ProductsGridLine_ProductsGridLine,
  resolve: productsGrid_resolver["b" /* productsGridResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/section/section.descriptor.js
var section_descriptor_jsx = react_default.a.createElement;



var sectionDescriptor = {
  name: constants["vb" /* SECTION */],
  component: function component(props) {
    return section_descriptor_jsx(Line, {
      props: props
    });
  }
};
// EXTERNAL MODULE: ./src/client/components/frameworks/sections/Sections.jsx + 5 modules
var Sections = __webpack_require__("tCJK");

// CONCATENATED MODULE: ./src/client/components/lines/sections-line/SectionsLine.jsx
var SectionsLine_jsx = react_default.a.createElement;


var SectionsLine_SectionsLine = function SectionsLine(_ref) {
  var children = _ref.children,
      _ref$config$common = _ref.config.common,
      scrollBackward = _ref$config$common.scrollBackward,
      scrollForward = _ref$config$common.scrollForward,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? [] : _ref$lines;
  return SectionsLine_jsx(Sections["a" /* Sections */], {
    navItems: lines.map(function (l) {
      return l.props.name;
    }),
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  }, children);
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/sections/sections.resolver.js
var sections_resolver = __webpack_require__("6TMq");

// CONCATENATED MODULE: ./src/client/cms/toolkit/sections/sections.descriptor.js



var sectionsDescriptor = {
  name: constants["wb" /* SECTIONS */],
  component: SectionsLine_SectionsLine,
  resolve: sections_resolver["a" /* sectionsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/smart-faq-line/SmartFaqLine.jsx
var SmartFaqLine_jsx = react_default.a.createElement;

function SmartFaqLine() {
  return SmartFaqLine_jsx("div", {
    id: "st-faq"
  });
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/smart-faq/smartFaq.descriptor.js


var smartFaqDescriptor = {
  name: constants["xb" /* SMART_FAQ */],
  component: SmartFaqLine
};
// CONCATENATED MODULE: ./src/client/components/lines/submission-status-line/SubmissionStatusLine.jsx

var SubmissionStatusLine_jsx = react_default.a.createElement;



function SubmissionStatusLine(_ref) {
  var id = _ref.id,
      hasShadow = _ref.hasShadow,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id", "hasShadow"]);

  return SubmissionStatusLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    hasBorders: hasShadow,
    hasShadowOutset: hasShadow,
    size: "small",
    className: "Line Line-SubmissionStatus"
  }, SubmissionStatusLine_jsx(Confirmation["a" /* Confirmation */], props));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/submission-status/submissionStatus.descriptor.js


var submissionStatusDescriptor = {
  name: constants["yb" /* SUBMISSION_STATUS */],
  component: SubmissionStatusLine
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/tab/tab.resolver.js
var tab_resolver = __webpack_require__("yTc0");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tab/tab.descriptor.js
var tab_descriptor_jsx = react_default.a.createElement;




var tabDescriptor = {
  name: constants["zb" /* TAB */],
  component: function component(props) {
    return tab_descriptor_jsx(Line, {
      props: props
    });
  },
  props: tab_resolver["a" /* tabResolver */].props
};
// EXTERNAL MODULE: ./src/client/components/frameworks/responsive-tabs/ResponsiveTabs.jsx + 1 modules
var ResponsiveTabs = __webpack_require__("QPCF");

// CONCATENATED MODULE: ./src/client/components/lines/tabs-line/TabsLine.jsx


var TabsLine_jsx = react_default.a.createElement;





function TabsLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  var items = props.lines.map(function (line) {
    var TabContent = descriptorsLibrary[line.name].component;
    return {
      header: {
        color: line.props.color,
        iconName: line.props.header.icon,
        title: line.props.header.title
      },
      id: line.props.anchor || null,
      content: [TabsLine_jsx(TabContent, Object(esm_extends["a" /* default */])({}, line.props, {
        key: "1"
      }))]
    };
  });
  var initialSelectedItems = props.lines.map(function (line, index) {
    return line.props.isExpanded ? index : -1;
  }).filter(function (i) {
    return i > -1;
  });
  return TabsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, TabsLine_jsx(ResponsiveTabs["a" /* ResponsiveTabs */], {
    areAllCollapsable: true,
    collapseIconName: icons["a" /* ICONS */].MINUS,
    expandIconName: icons["a" /* ICONS */].PLUS,
    initialSelectedItems: initialSelectedItems,
    items: items
  }));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/tabs/tabs.descriptor.js


var tabsDescriptor = {
  name: constants["Ab" /* TABS */],
  component: TabsLine
};
// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.jsx







var ProductInformationSlider_jsx = react_default.a.createElement;

function ProductInformationSlider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductInformationSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductInformationSlider_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductInformationSlider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ProductInformationSlider_createSuper(Derived) { var hasNativeReflectConstruct = ProductInformationSlider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ProductInformationSlider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var ProductInformationSlider_ProductInformationSlider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ProductInformationSlider, _Component);

  var _super = ProductInformationSlider_createSuper(ProductInformationSlider);

  function ProductInformationSlider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ProductInformationSlider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openLayer", function (activeItem) {
      return _this.props.toggleLayer(activeItem, true);
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ProductInformationSlider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          isLarge = _this$props.isLarge,
          queryLayer = _this$props.queryLayer,
          scrollBackwardLabel = _this$props.scrollBackwardLabel,
          scrollForwardLabel = _this$props.scrollForwardLabel;

      if (!react["Children"].count(children)) {
        return null;
      }

      var _this$context = this.context,
          isDesktop = _this$context.isDesktop,
          isTablet = _this$context.isTablet;

      var renderItem = function renderItem(element, index) {
        var _element$props$link = element.props.link,
            link = _element$props$link === void 0 ? {} : _element$props$link;

        if (!link.url) {
          link = ProductInformationSlider_objectSpread(ProductInformationSlider_objectSpread({}, link), {}, {
            onClick: function onClick() {
              return _this2.openLayer(index);
            }
          });
        }

        return /*#__PURE__*/react_default.a.createElement('div', {
          style: {
            width: !isTablet ? 280 : null
          }
        }, /*#__PURE__*/react_default.a.cloneElement(element, {
          link: link,
          isLarge: isLarge
        }));
      };

      var getCols = function getCols() {
        if (isTablet) {
          if (isLarge) return 2;
          if (isDesktop) return 4;
          return 3;
        }

        return 0;
      };

      var clonedChildren = react["Children"].map(children, renderItem);
      return ProductInformationSlider_jsx("section", null, ProductInformationSlider_jsx(Slider, {
        cols: getCols(),
        hasControls: isTablet,
        id: queryLayer,
        navPosition: isTablet ? 'top' : 'center',
        nbItemsToScroll: isTablet ? 2 : 1,
        nextLabel: scrollForwardLabel,
        previousLabel: scrollBackwardLabel,
        scrollAreaClassName: "overflow-hidden -mx-2",
        scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory",
        scrollItemClassName: "overflow-hidden px-2 flex-none max-w-full"
      }, clonedChildren));
    }
  }]);

  return ProductInformationSlider;
}(react["Component"]);

Object(defineProperty["a" /* default */])(ProductInformationSlider_ProductInformationSlider, "contextType", responsiveContext["a" /* default */]);
// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationLayer.jsx

var ProductInformationLayer_jsx = react_default.a.createElement;

function ProductInformationLayer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductInformationLayer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductInformationLayer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductInformationLayer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ProductInformationLayer_ProductInformationLayer = function ProductInformationLayer(_ref) {
  var activeItem = _ref.activeItem,
      backNavigationLabel = _ref.backNavigationLabel,
      children = _ref.children,
      errorMessage = _ref.errorMessage,
      renderDetail = _ref.renderDetail,
      toggleLayer = _ref.toggleLayer;

  var _useState = Object(react["useState"])({
    activeItem: activeItem,
    isLoading: false,
    isOpen: false
  }),
      state = _useState[0],
      setState = _useState[1];

  Object(react["useEffect"])(function () {
    loadDetails();
  }, [activeItem]);

  var closeLayer = function closeLayer() {
    setState(ProductInformationLayer_objectSpread(ProductInformationLayer_objectSpread({}, state), {}, {
      isLoading: false,
      isOpen: false
    })); // -1 to indicate that no product has been selected

    toggleLayer(-1, false);
  };

  var updateDetail = function updateDetail(active, detailInfo) {
    setState({
      activeItem: active,
      detail: detailInfo,
      isLoading: false,
      isOpen: true
    });
  };

  var getItem = function getItem(index) {
    return react["Children"].toArray(children)[index];
  };

  var loadDetails = function loadDetails() {
    var item = getItem(activeItem) || {};
    var props = item.props;

    if (props && props.fetchDetail) {
      setState(ProductInformationLayer_objectSpread(ProductInformationLayer_objectSpread({}, state), {}, {
        isLoading: true
      }));
      props.fetchDetail().then(function (data) {
        updateDetail(activeItem, data);
      }).catch(function () {
        updateDetail(activeItem, null);
      });
    }
  };

  var renderActiveDetail = function renderActiveDetail() {
    var item = getItem(activeItem);

    if (!item) {
      return null;
    }

    var leftButton = {
      iconClassName: 'rtl:-scale-x-1',
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      onClick: closeLayer,
      label: backNavigationLabel
    };
    var ariaLabel = state.detail ? state.detail.label || state.detail.title : '';
    return ProductInformationLayer_jsx(Layer["b" /* Layer */], {
      ariaLabel: ariaLabel,
      bgColor: colors["a" /* COLORS */].WHITE,
      buttonLeft: leftButton,
      closeLabel: Object(src_i18n["f" /* t */])('common.close'),
      hasAnimateEnter: true,
      hasContainerHeader: true,
      onClose: closeLayer
    }, state.detail ? renderDetail(state.detail) : ProductInformationLayer_jsx("div", {
      "data-testid": "error",
      className: "p-5"
    }, ProductInformationLayer_jsx("div", {
      className: "max-w-site mx-auto flex justify-center"
    }, ProductInformationLayer_jsx(Confirmation["a" /* Confirmation */], {
      status: "error",
      title: errorMessage
    }))));
  };

  return state.isOpen && !state.isLoading ? renderActiveDetail() : state.isLoading && ProductInformationLayer_jsx("div", {
    id: "loading",
    className: "relative z-4"
  }, ProductInformationLayer_jsx(Backdrop["a" /* Backdrop */], {
    bgColor: "#fff",
    opacity: 0.95
  }, ProductInformationLayer_jsx("div", {
    "aria-live": "polite",
    className: "absolute text-center top-1/2 left-1/2 -translate-50",
    style: {
      width: '13rem'
    }
  }, ProductInformationLayer_jsx("span", {
    className: "sr-only"
  }, "Loading"), ProductInformationLayer_jsx(Spinner["a" /* Spinner */], {
    "data-testid": "Spinner",
    iconName: icons["a" /* ICONS */].TRIDENT1
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.container.jsx



var ProductInformationSlider_container_jsx = react_default.a.createElement;








var ProductInformationSlider_container_ProductInformationSliderContainer = function _ProductInformationSliderContainer(props) {
  // -1 to init activeItem (it means no item has been selected yet), 0 is the index of first element
  var _useState = Object(react["useState"])(-1),
      activeItem = _useState[0],
      setActiveItem = _useState[1];

  var queryLayer = props.queryLayer,
      sliderIndex = props.sliderIndex,
      location = props.location;
  var uri = Object(uriUtils["c" /* convertLocationToURI */])(location); // -1_-1 is the default value of queryparam to initialise sliderIndex and activeItem (-1)

  var active = Object(lodash["get"])(uri.query(true), queryLayer, '-1_-1');

  var _active$split = active.split('_'),
      _active$split2 = Object(slicedToArray["a" /* default */])(_active$split, 2),
      uriSliderIndex = _active$split2[0],
      uriActiveItem = _active$split2[1];

  Object(react["useEffect"])(function () {
    if (uri.hasQuery(queryLayer, /^[0-9]_[0-9]*$/) && Number(uriSliderIndex) === sliderIndex) {
      setActiveItem(uriActiveItem);
    }
  }, [location]);

  var toggleLayer = function toggleLayer(item, layer) {
    var newUrl = uri.clone();

    if (layer) {
      newUrl = newUrl.addQuery(Object(defineProperty["a" /* default */])({}, queryLayer, "".concat(sliderIndex, "_").concat(item)));
    } else {
      newUrl = newUrl.removeQuery(Object(defineProperty["a" /* default */])({}, queryLayer, "".concat(sliderIndex, "_").concat(uriActiveItem)));
    } // using window.history replaceState to add or remove queryParam in silent mode (without triggering component rerender)


    window.history.pushState(null, null, Object(DynamicLinkUtil["b" /* getSpaUrl */])(newUrl));
    setActiveItem(item);
  };

  return ProductInformationSlider_container_jsx(react["Fragment"], null, ProductInformationSlider_container_jsx(ProductInformationSlider_ProductInformationSlider, Object(esm_extends["a" /* default */])({}, props, {
    toggleLayer: toggleLayer
  })), ProductInformationSlider_container_jsx(ProductInformationLayer_ProductInformationLayer, Object(esm_extends["a" /* default */])({}, props, {
    activeItem: activeItem,
    toggleLayer: toggleLayer
  })));
};

var ProductInformationSliderContainer = Object(withRouter["a" /* withRouter */])(ProductInformationSlider_container_ProductInformationSliderContainer);
// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.jsx
var TeaserCard_jsx = react_default.a.createElement;





var TeaserCard_TeaserCard = function TeaserCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasInsetBorder = _ref.hasInsetBorder,
      isActive = _ref.isActive,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? ratios_utils["a" /* default */].R_38_BY_28 : _ref$ratio,
      width = _ref.width;
  var defaultPicture = media[0] || {};
  return TeaserCard_jsx("div", {
    className: classnames_default()(className, 'flex flex-col'),
    style: {
      width: width
    }
  }, children, TeaserCard_jsx("div", {
    className: classnames_default()('bg-gray-darker rounded-tiny -order-1 overflow-hidden transition-all image-responsive-cell', {
      'opacity-75 scale-095': isActive
    })
  }, media.length > 1 ? TeaserCard_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    hasControlsOnHover: true,
    hasInsetBorder: hasInsetBorder,
    hasLazyLoading: true,
    media: media,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratio
  }) : TeaserCard_jsx(Image["a" /* default */], {
    altMsg: defaultPicture.alt,
    className: hasInsetBorder ? 'inset-border-after' : '',
    groupKey: "thumbnails",
    hasLazyLoading: true,
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    ratioKey: ratio
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/teaser-cards/teaser-cards-card/TeaserCardsCard.jsx

var TeaserCardsCard_jsx = react_default.a.createElement;






var TeaserCardsCard_TeaserCardsCard = function TeaserCardsCard(_ref) {
  var card = _ref.card,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      trackingData = _ref.trackingData;
  var image = card.image,
      title = card.title,
      subtitle = card.subtitle,
      seeMoreLabel = card.seeMoreLabel;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  return TeaserCardsCard_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    as: link.onClick ? 'button' : DynamicLink["a" /* default */],
    className: "reset-button block relative text-initial w-full",
    "data-testid": "TeaserCard",
    onMouseEnter: isDesktop ? function () {
      return setHovering(true);
    } : null,
    onMouseLeave: isDesktop ? function () {
      return setHovering(false);
    } : null,
    trackingData: trackingData
  }), TeaserCardsCard_jsx(TeaserCard_TeaserCard, {
    className: "w-full",
    isActive: isHovering,
    media: [{
      src: image
    }]
  }, !!title && TeaserCardsCard_jsx("p", {
    className: "reset-paragraph my-4 text-center text-md"
  }, Object(string_util["f" /* truncate */])(title, 35, true)), !!subtitle && TeaserCardsCard_jsx("p", {
    className: "reset-paragraph font-normal font-sans leading-normal my-4 text-base text-gray-darker"
  }, Object(string_util["f" /* truncate */])(subtitle, 65, true)), !!seeMoreLabel && TeaserCardsCard_jsx("p", {
    className: "reset-paragraph my-4 text-center text-sm underline"
  }, seeMoreLabel)));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// CONCATENATED MODULE: ./src/client/components/frameworks/sheet/Sheet.themes.js
var Sheet_themes_themes = {
  "default": function _default(_ref) {
    var _ref$diamond = _ref.diamond,
        diamond = _ref$diamond === void 0 ? {} : _ref$diamond,
        hasSlideshow = _ref.hasSlideshow,
        isDesktop = _ref.isDesktop;
    var thTopStyles = isDesktop ? {
      marginBottom: '3.4375rem'
    } : {
      marginBottom: '2.1875rem'
    };
    return {
      thRoot: 'bg-white',
      thTop: 'relative',
      thTopStyles: diamond ? thTopStyles : {},
      thHero: hasSlideshow ? 'absolute overflow-hidden inset-0' : '',
      thHeroStyles: hasSlideshow ? {
        minHeight: '102%',
        filter: 'blur(10px)',
        opacity: '0.25'
      } : {},
      thSlideshow: 'my-0 mx-auto w-full',
      thSlideshowStyles: {
        maxWidth: '45rem'
      },
      thDiamond: 'absolute bottom-0 left-1/2 -translate-x-50 translate-y-50 -mb-2px',
      thDiamondClassName: 'font-bold uppercase text-xs sm:text-sm',
      thDiamondSize: isDesktop ? 75 : 60,
      thBody: 'px-5 py-5 lg:py-4',
      thContent: 'max-w-site mx-auto w-full',
      thFooter: 'bg-gray-lighter overflow-hidden px-5'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/sheet/Sheet.jsx

var Sheet_jsx = react_default.a.createElement;









function Sheet(props) {
  var children = props.children,
      className = props.className,
      diamond = props.diamond,
      immersive = props.immersive,
      footer = props.footer,
      _props$slideshow = props.slideshow,
      slideshow = _props$slideshow === void 0 ? {} : _props$slideshow,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  if (!react["Children"].count(children)) return null;
  var hasSlideshow = !Object(lodash["isEmpty"])(slideshow.media);

  var _themes$theme = Sheet_themes_themes[theme]({
    diamond: diamond,
    hasSlideshow: hasSlideshow,
    isDesktop: isDesktop
  }),
      thBody = _themes$theme.thBody,
      thContent = _themes$theme.thContent,
      thDiamond = _themes$theme.thDiamond,
      thDiamondClassName = _themes$theme.thDiamondClassName,
      thDiamondSize = _themes$theme.thDiamondSize,
      thFooter = _themes$theme.thFooter,
      thHero = _themes$theme.thHero,
      thHeroStyles = _themes$theme.thHeroStyles,
      thRoot = _themes$theme.thRoot,
      thSlideshow = _themes$theme.thSlideshow,
      thSlideshowStyles = _themes$theme.thSlideshowStyles,
      thTop = _themes$theme.thTop,
      thTopStyles = _themes$theme.thTopStyles;

  return Sheet_jsx("section", {
    className: classnames_default()(thRoot, className)
  }, (!Object(lodash["isEmpty"])(immersive) || hasSlideshow) && Sheet_jsx("div", {
    className: thTop,
    style: thTopStyles
  }, !Object(lodash["isEmpty"])(immersive) && Sheet_jsx("div", {
    className: thHero
  }, Sheet_jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, immersive, {
    size: hasSlideshow ? 'full' : 'medium',
    style: thHeroStyles
  }))), hasSlideshow && Sheet_jsx("div", {
    className: thSlideshow,
    style: thSlideshowStyles
  }, Sheet_jsx(ImageSlideShow["a" /* ImageSlideShow */], Object(esm_extends["a" /* default */])({
    media: slideshow.media,
    ratio: ratios_utils["a" /* default */].XL
  }, slideshow))), !Object(lodash["isEmpty"])(diamond) && Sheet_jsx("div", {
    className: thDiamond
  }, Sheet_jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({
    className: thDiamondClassName,
    size: thDiamondSize
  }, diamond, {
    variant: "diamond"
  })))), Sheet_jsx("div", {
    className: thBody,
    "data-testid": "Sheet-body"
  }, Sheet_jsx("div", {
    className: thContent
  }, children)), !!footer && Sheet_jsx("footer", {
    className: thFooter
  }, Sheet_jsx("div", {
    className: thContent
  }, footer)));
}
// CONCATENATED MODULE: ./src/client/components/widgets/teaser-cards/teaser-cards-layer/TeaserCardsLayer.jsx
var TeaserCardsLayer_jsx = react_default.a.createElement;







var TeaserCardsLayer_TeaserCardsLayer = function TeaserCardsLayer(_ref) {
  var image = _ref.image,
      title = _ref.title,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? '' : _ref$description,
      _ref$blocks = _ref.blocks,
      blocks = _ref$blocks === void 0 ? [] : _ref$blocks;
  return TeaserCardsLayer_jsx(Sheet, {
    immersive: {
      url: image
    }
  }, !!title && TeaserCardsLayer_jsx(Title["a" /* Title */], {
    className: "mb-8",
    theme: "title-sans-8"
  }, title), !!description && TeaserCardsLayer_jsx(Text["a" /* Text */], {
    className: "mb-8",
    text: description
  }), !Object(lodash["isEmpty"])(blocks) && TeaserCardsLayer_jsx("div", {
    className: "flex flex-wrap -mx-2 -my-5"
  }, blocks.map(function (_ref2, index) {
    var blockTitle = _ref2.title,
        blockText = _ref2.text;
    return blockTitle && blockText ? TeaserCardsLayer_jsx("div", {
      className: "px-2 py-5 w-full sm:w-1/2",
      key: index
    }, TeaserCardsLayer_jsx(Card["a" /* Card */], {
      heading: {
        hLevel: 3,
        title: blockTitle
      },
      layout: Card_constants["a" /* COLUMN_1 */],
      text: {
        text: blockText
      }
    })) : null;
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/teaser-cards/TeaserCards.jsx
var TeaserCards_jsx = react_default.a.createElement;




function resolveLayerData(cardData) {
  var image = cardData.image,
      title = cardData.layerTitle,
      description = cardData.layerDescription,
      blocks = cardData.layerBlocks;
  return Promise.resolve({
    image: image,
    title: title,
    description: description,
    blocks: blocks
  });
}
var TeaserCards_TeaserCards = function TeaserCards(props) {
  var _props$cards = props.cards,
      cards = _props$cards === void 0 ? [] : _props$cards,
      backNavigationLabel = props.backNavigationLabel,
      scrollBackwardLabel = props.scrollBackwardLabel,
      scrollForwardLabel = props.scrollForwardLabel,
      sliderQueryName = props.sliderQueryName;
  return TeaserCards_jsx(ProductInformationSliderContainer, {
    backNavigationLabel: backNavigationLabel,
    isExpanded: true,
    queryLayer: sliderQueryName,
    renderDetail: function renderDetail(layerData) {
      return TeaserCards_jsx(TeaserCardsLayer_TeaserCardsLayer, layerData);
    },
    scrollBackwardLabel: scrollBackwardLabel,
    scrollForwardLabel: scrollForwardLabel,
    sliderIndex: 1
  }, cards.map(function (card, index) {
    return TeaserCards_jsx(TeaserCardsCard_TeaserCardsCard, {
      card: card,
      fetchDetail: function fetchDetail() {
        return resolveLayerData(card);
      },
      key: index,
      link: card.link // Component takes card link as separate prop so it can be cloned with a slider link
      ,
      trackingData: card.trackingData
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/lines/teaser-cards-line/TeaserCardsLine.jsx


var TeaserCardsLine_jsx = react_default.a.createElement;

function TeaserCardsLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function TeaserCardsLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TeaserCardsLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TeaserCardsLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var TeaserCardsLine_TeaserCardsLine = function TeaserCardsLine(_ref) {
  var cards = _ref.cards,
      _ref$config$common = _ref.config.common,
      backNavigation = _ref$config$common.backNavigation,
      scrollBackward = _ref$config$common.scrollBackward,
      scrollForward = _ref$config$common.scrollForward,
      header = _ref.header,
      id = _ref.id,
      title = _ref.title;
  var teaserCards = (cards || []).map(function (card) {
    var seeMoreUrl = card.seeMoreUrl,
        cardtitle = card.title,
        rest = Object(objectWithoutProperties["a" /* default */])(card, ["seeMoreUrl", "title"]);

    var link = {};

    if (seeMoreUrl) {
      link.url = seeMoreUrl;
    }

    return TeaserCardsLine_objectSpread(TeaserCardsLine_objectSpread({}, rest), {}, {
      title: cardtitle,
      link: link,
      trackingData: {
        actionGA: title,
        labelGA: title
      }
    });
  });
  return TeaserCardsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, TeaserCardsLine_jsx(LineTitle["a" /* LineTitle */], null, title), TeaserCardsLine_jsx(TeaserCards_TeaserCards, {
    backNavigationLabel: backNavigation,
    cards: teaserCards,
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward,
    sliderQueryName: Object(string_util["a" /* camelCasify */])(header)
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/teaser-cards/teaserCards.resolver.js
var teaserCards_resolver = __webpack_require__("yLnO");

// CONCATENATED MODULE: ./src/client/cms/toolkit/teaser-cards/teaserCards.descriptor.js



var teaserCardsDescriptor = {
  name: constants["Bb" /* TEASER_CARDS */],
  component: TeaserCardsLine_TeaserCardsLine,
  resolve: teaserCards_resolver["a" /* teaserCardsResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/context/ABTestContext.js
var ABTestContext = __webpack_require__("hfZn");

// CONCATENATED MODULE: ./src/client/cms/toolkit/test-ab/TestAB.jsx
var TestAB_jsx = react_default.a.createElement;




var TestAB_TestAB = function TestAB(props) {
  var tests = Object(react["useContext"])(ABTestContext["a" /* ABTestContext */]);

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isAppMounted = _useContext.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var idx = tests[props.name] ? Number(tests[props.name]) : 0;
  var variation = props.lines[!Number.isNaN(idx) ? idx : 0];
  var VariationComponent = descriptorsLibrary[variation.name].component;
  return TestAB_jsx(react["Fragment"], null, TestAB_jsx(VariationComponent, variation.props));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/test-ab/testAB.descriptor.js


var testABDescriptor = {
  name: constants["Cb" /* TEST_AB */],
  component: TestAB_TestAB
};
// CONCATENATED MODULE: ./src/client/components/lines/text-line/TextLine.jsx

var TextLine_jsx = react_default.a.createElement;



function TextLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  return TextLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, TextLine_jsx(Text["a" /* Text */], props));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/text/text.descriptor.js


var textDescriptor = {
  name: constants["Db" /* TEXT */],
  component: TextLine
};
// CONCATENATED MODULE: ./src/client/components/lines/thematic-line/ThematicCard.jsx

var ThematicCard_jsx = react_default.a.createElement;

function ThematicCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ThematicCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ThematicCard_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ThematicCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var ThematicCard_ThematicCard = function ThematicCard(_ref) {
  var _ref2;

  var isExclusiveCollection = _ref.isExclusiveCollection,
      mediaUrl = _ref.mediaUrl,
      itemTitle = _ref.itemTitle,
      link = _ref.link,
      isFirst = _ref.isFirst;

  var _useState = Object(react["useState"])(false),
      isHover = _useState[0],
      setHover = _useState[1];

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet;

  var blockDimensions = isTablet ? {
    height: '235px',
    width: '180px'
  } : {
    height: '313px',
    width: '240px'
  };

  var handleFocus = function handleFocus() {
    setHover(true);
  };

  var handleBlur = function handleBlur() {
    setHover(false);
  };

  var TagName = link ? TrackClick["a" /* TrackClick */] : react["Fragment"];
  var thematicTitle = itemTitle ? itemTitle : '';
  var trackingData = {
    actionGA: 'push_content_thematic',
    labelGA: "".concat(thematicTitle).trim()
  };
  var conditionalTagNameProps = link ? {
    as: DynamicLink["a" /* default */],
    url: link,
    trackingData: trackingData,
    className: 'z-1'
  } : {};
  return ThematicCard_jsx("div", {
    style: ThematicCard_objectSpread(ThematicCard_objectSpread({}, blockDimensions), {}, {
      flexShrink: '0'
    }),
    onMouseEnter: handleFocus,
    onMouseLeave: handleBlur,
    onFocus: handleFocus,
    onBlur: handleBlur,
    "data-testid": "ThematicLine-item",
    className: classnames_default()('rounded-tiny overflow-hidden p-3 py-6 rtl:ml-5 text-center flex items-end justify-center relative', {
      'inset-border-after font-serif': isExclusiveCollection
    }, {
      'lg:rtl:ml-0': isFirst
    })
  }, ThematicCard_jsx(Image["a" /* default */], {
    className: classnames_default()('absolute inset-0 transition-transform', {
      'scale-105': isHover && link
    }),
    altMsg: "",
    imageUrl: mediaUrl,
    mandatoryWidthAndHeight: {
      h: 313,
      w: 240
    }
  }), ThematicCard_jsx("div", {
    style: (_ref2 = {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,

      /* eslint-disable no-dupe-keys */
      background: '-moz-linear-gradient(top, rgba(0,0,0,0) 50%, rgba(0,0,0,0.4) 100%)'
    }, Object(defineProperty["a" /* default */])(_ref2, "background", '-webkit-linear-gradient(top, rgba(0,0,0,0) 50%,rgba(0,0,0,0.4) 100%)'), Object(defineProperty["a" /* default */])(_ref2, "background", 'linear-gradient(to bottom, rgba(0,0,0,0) 50%,rgba(0,0,0,0.4) 100%)'), _ref2)
  }), ThematicCard_jsx(TagName, conditionalTagNameProps, ThematicCard_jsx("div", {
    className: classnames_default()('absolute inset-0', {
      'z-1': !!link
    })
  }), ThematicCard_jsx("div", {
    className: "relative text-white text-xl leading-tight font-bold"
  }, itemTitle)));
};
// CONCATENATED MODULE: ./src/client/components/lines/thematic-line/ThematicLine.jsx
var ThematicLine_jsx = react_default.a.createElement;







var ThematicLine_ThematicLine = function ThematicLine(_ref) {
  var title = _ref.title,
      items = _ref.items;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  return ThematicLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: "thematic"
  }, ThematicLine_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, !!title && ThematicLine_jsx(LineTitle["a" /* LineTitle */], null, title), ThematicLine_jsx("div", {
    className: "-mx-5 lg:m-0 w-screen lg:w-full"
  }, ThematicLine_jsx(Slider, {
    cols: 0,
    hasControls: isDesktop,
    navPosition: "center",
    nbItemsToScroll: isTablet ? 2 : 1,
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous'),
    scrollAreaClassName: "overflow-hidden",
    scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory",
    scrollControlsClassName: "-mx-5 lg:mx-0",
    scrollItemClassName: "overflow-hidden flex-none max-w-full"
  }, items.map(function (_ref2, index) {
    var isExclusiveCollection = _ref2.isExclusiveCollection,
        itemTitle = _ref2.itemTitle,
        link = _ref2.link,
        mediaUrl = _ref2.mediaUrl;
    return ThematicLine_jsx(ThematicCard_ThematicCard, {
      isExclusiveCollection: isExclusiveCollection,
      isFirst: index === 0,
      itemTitle: itemTitle,
      link: link,
      key: itemTitle,
      mediaUrl: mediaUrl
    });
  })))));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/thematic/thematic.resolver.js




var thematicResolver = {
  name: constants["Eb" /* THEMATIC */],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common { next previous scrollBackward scrollForward }\n      }\n    }";
    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["Pb" /* LINE_COMMON_THEMATIC */]
    }).then(function (data) {
      Object(src_i18n["a" /* addTranslationKeys */])(data.config);
      return data;
    });
  }
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/thematic/thematic.descriptor.js



var thematicDescriptor = {
  name: constants["Eb" /* THEMATIC */],
  component: ThematicLine_ThematicLine,
  resolve: thematicResolver.resolve
};
// EXTERNAL MODULE: ./src/client/components/frameworks/introduction/Introduction.jsx + 1 modules
var Introduction = __webpack_require__("pNXd");

// CONCATENATED MODULE: ./src/client/components/lines/title-and-text-line/TitleAndTextLine.jsx
var TitleAndTextLine_jsx = react_default.a.createElement;




var TitleAndTextLine_TitleAndTextLine = function TitleAndTextLine(_ref) {
  var config = _ref.config,
      hasShadow = _ref.hasShadow,
      icon = _ref.icon,
      id = _ref.id,
      smallTitle = _ref.smallTitle,
      subTitle = _ref.subTitle,
      text = _ref.text,
      theme = _ref.theme,
      title = _ref.title;
  return TitleAndTextLine_jsx(SiteContainer["a" /* SiteContainer */], {
    hasBorders: hasShadow,
    hasShadowOutset: hasShadow,
    id: id,
    className: classnames_default()('Line', {
      'Line-Introduction': hasShadow,
      'Line-TitleAndText': !hasShadow
    })
  }, TitleAndTextLine_jsx(Introduction["a" /* Introduction */], {
    className: hasShadow ? 'py-5' : '',
    iconName: icon,
    isTextSeeMoreCollapseEnabled: true,
    small: smallTitle,
    seeMoreLabel: config.common.viewMore,
    seeLessLabel: config.common.loadLess,
    subtitle: subTitle,
    text: text,
    theme: theme,
    title: title
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/title-and-text/titleAndText.resolver.js
var titleAndText_resolver = __webpack_require__("BXQg");

// CONCATENATED MODULE: ./src/client/cms/toolkit/title-and-text/titleAndText.descriptor.js



var titleAndTextDescriptor = {
  name: constants["Fb" /* TITLE_AND_TEXT */],
  component: TitleAndTextLine_TitleAndTextLine,
  resolve: titleAndText_resolver["a" /* titleAndTextResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-testimony/TripadvisorTestimony.jsx
var TripadvisorTestimony_jsx = react_default.a.createElement;









var TRIPADVISOR_RATINGS_SVG = {
  '4': 'https://www.tripadvisor.fr/img/cdsi/img2/ratings/traveler/4.0-24206-5.svg',
  '5': 'https://www.tripadvisor.fr/img/cdsi/img2/ratings/traveler/5.0-24206-5.svg'
};
var QUOTATION_MARK_COLOR = '#E6EEF3';
var TripadvisorTestimony_TripadvisorTestimony = function TripadvisorTestimony(_ref) {
  var author = _ref.author,
      className = _ref.className,
      date = _ref.date,
      fullCommentLink = _ref.fullCommentLink,
      link = _ref.link,
      onBy = _ref.onBy,
      stars = _ref.stars,
      style = _ref.style,
      text = _ref.text;
  return TripadvisorTestimony_jsx("blockquote", {
    cite: fullCommentLink,
    className: classnames_default()(className, 'flex flex-col items-center m-0 py-4'),
    style: style
  }, TripadvisorTestimony_jsx("div", {
    className: "flex flex-col md:rtl:flex-row items-center justify-center w-full"
  }, TripadvisorTestimony_jsx(Icon["a" /* Icon */], {
    className: "md:self-start mb-4 md:rtl:mr-6",
    hasRtl: true,
    name: icons["a" /* ICONS */].QUOTATION_MARK,
    style: {
      color: QUOTATION_MARK_COLOR
    },
    width: "2rem"
  }), TripadvisorTestimony_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    rel: "nofollow",
    trackingData: {
      actionGA: 'push_content_testimony',
      labelGA: 'seeFullComment'
    },
    url: fullCommentLink
  }, TripadvisorTestimony_jsx(Text["a" /* Text */], {
    theme: "text-brand-1",
    text: text,
    color: colors["a" /* COLORS */].BLUE,
    className: "text-center max-w-site-small"
  })), TripadvisorTestimony_jsx(Icon["a" /* Icon */], {
    className: "hidden md:inline-block self-end rtl:ml-6",
    hasRtl: true,
    name: icons["a" /* ICONS */].QUOTATION_MARK,
    rotation: 180,
    style: {
      color: QUOTATION_MARK_COLOR
    },
    width: "2rem"
  })), TripadvisorTestimony_jsx("p", {
    className: "flex flex-col md:rtl:flex-row items-center justify-center"
  }, TripadvisorTestimony_jsx("img", {
    alt: "",
    className: "md:rtl:mr-2 my-2 md:my-0",
    src: TRIPADVISOR_RATINGS_SVG[stars]
  }), TripadvisorTestimony_jsx(TemplateString["a" /* TemplateString */], {
    className: "text-center mt-1",
    dataTestId: "tripadvisor-testimony-onby",
    template: onBy,
    values: {
      author: author,
      date: date
    },
    valuesClassName: {
      author: 'font-bold',
      date: 'font-bold'
    }
  }), (link === null || link === void 0 ? void 0 : link.url) && TripadvisorTestimony_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "mt-1 md:rtl:ml-2 text-gray-darker underline",
    "data-testid": "tripadvisor-testimony-seemore",
    rel: "nofollow",
    trackingData: {
      actionGA: 'push_content_testimony',
      labelGA: 'seeMore'
    },
    url: link.url
  }, link.label)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-testimonies/TripadvisorTestimonies.jsx

var TripadvisorTestimonies_jsx = react_default.a.createElement;






var TripadvisorTestimonies_TripadvisorTestimonies = function TripadvisorTestimonies(_ref) {
  var className = _ref.className,
      items = _ref.items;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!(items === null || items === void 0 ? void 0 : items.length)) {
    return null;
  }

  if (items.length === 1) {
    return TripadvisorTestimonies_jsx(TripadvisorTestimony_TripadvisorTestimony, Object(esm_extends["a" /* default */])({}, items[0], {
      className: className
    }));
  }

  return TripadvisorTestimonies_jsx(Slider, {
    className: className,
    cols: isTablet ? 1 : 0,
    hasControls: isTablet,
    navPosition: "center",
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous'),
    scrollAreaClassName: "overflow-hidden",
    scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory",
    scrollItemClassName: function scrollItemClassName(i) {
      return classnames_default()('overflow-hidden pl-5 md:pl-0 flex-none max-w-full', {
        'pr-5 md:pr-0': i === items.length - 1
      });
    }
  }, items.map(function (_ref2) {
    var author = _ref2.author,
        date = _ref2.date,
        fullCommentLink = _ref2.fullCommentLink,
        link = _ref2.link,
        onBy = _ref2.onBy,
        stars = _ref2.stars,
        text = _ref2.text;
    return TripadvisorTestimonies_jsx(TripadvisorTestimony_TripadvisorTestimony, {
      author: author,
      date: date,
      fullCommentLink: fullCommentLink,
      key: link.url,
      link: link,
      onBy: onBy,
      stars: stars,
      text: text,
      style: isTablet ? null : {
        width: '80vw'
      }
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/lines/tripadvisor-testimony-line/TripadvisorTestimonyLine.jsx
var TripadvisorTestimonyLine_jsx = react_default.a.createElement;




var TripadvisorTestimonyLine_TripadvisorTestimonyLine = function TripadvisorTestimonyLine(_ref) {
  var id = _ref.id,
      reviews = _ref.reviews;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return TripadvisorTestimonyLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    dataTestId: "Line-TripadvisorTestimony",
    id: id,
    isWide: !isTablet
  }, TripadvisorTestimonyLine_jsx(TripadvisorTestimonies_TripadvisorTestimonies, {
    items: reviews
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/tripadvisor-testimony/tripadvisorTestimony.descriptor.js


var tripadvisorTestimonyDescriptor = {
  name: constants["Jb" /* TRIPADVISOR_TESTIMONY */],
  component: TripadvisorTestimonyLine_TripadvisorTestimonyLine
};
// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// CONCATENATED MODULE: ./src/client/components/lines/video-line/VideoLine.jsx

var VideoLine_jsx = react_default.a.createElement;



function VideoLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  return VideoLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, VideoLine_jsx(Video["a" /* Video */], props));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/video/video.descriptor.js


var videoDescriptor = {
  name: constants["Kb" /* VIDEO */],
  component: VideoLine
};
// CONCATENATED MODULE: ./src/client/components/lines/highlight-line/HighlightLine.jsx


var HighlightLine_jsx = react_default.a.createElement;


var HighlightLine_HighlightLine = function HighlightLine(_ref) {
  var backgroundURL = _ref.backgroundURL,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["backgroundURL"]);

  return HighlightLine_jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, props, {
    className: "Line Line-Highlight",
    hLevel: 2,
    size: props.size === 'small' ? 'highlightSmall' : 'highlight',
    trackingData: {
      actionGA: 'highlight'
    },
    url: backgroundURL
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/highlight/highlight.descriptor.js


var highlightDescriptor = {
  name: constants["p" /* HIGHLIGHT */],
  component: HighlightLine_HighlightLine
};
// CONCATENATED MODULE: ./src/client/components/lines/brand-promise-line/BrandPromiseLine.jsx
var BrandPromiseLine_jsx = react_default.a.createElement;














function getBadgeStylesFromIcon(isExclusiveCollectionIcon) {
  if (isExclusiveCollectionIcon) {
    return {
      iconContainer: '',
      iconContainerWidth: '122',
      iconContainerHeight: '72',
      icon: 'border-5 border-current p-2',
      iconWidth: 'calc(100rem / 16)',
      isNotSquare: true
    };
  }

  return {
    iconContainer: 'rounded-full',
    iconContainerWidth: '84',
    iconContainerHeight: '84',
    icon: '',
    iconWidth: 'calc(31rem / 16)',
    isNotSquare: false
  };
}

function getTextStyles(isExclusiveCollection) {
  if (isExclusiveCollection) {
    return 'text-deepBlue font-serif';
  }

  return 'text-blue';
}

function getItemsToRender(items, hoveredItem, setHoveredItem) {
  var shouldShowPictures = items.every(function (item) {
    return !!item.mediaUrl;
  });
  return items.map(function (_ref, index) {
    var text = _ref.text,
        iconName = _ref.iconName,
        isExclusiveCollection = _ref.isExclusiveCollection,
        mediaUrl = _ref.mediaUrl,
        mediaAlt = _ref.mediaAlt,
        link = _ref.link;
    var TagName = link ? TrackClick["a" /* TrackClick */] : react["Fragment"];
    var iconTitle = iconName || '';
    var trackingData = {
      actionGA: 'push_content_brandPromise',
      labelGA: "".concat(iconTitle).trim()
    };
    var conditionalTagNameProps = link ? {
      as: DynamicLink["a" /* default */],
      url: link,
      trackingData: trackingData
    } : {};
    var isXCIcon = iconName === icons["a" /* ICONS */].EXCLUSIVE_COLLECTION;
    var isXC = isExclusiveCollection || isXCIcon;
    var textStyles = getTextStyles(isXC);
    var badgeStyles = getBadgeStylesFromIcon(isXCIcon);
    /* I know how tedious this looks but we're concentrating the complexity
    in those four lines, the rest should be smooth sailing. I hope. */

    return BrandPromiseLine_jsx("div", {
      key: text,
      onMouseEnter: function onMouseEnter() {
        setHoveredItem(index);
      },
      onMouseLeave: function onMouseLeave() {
        setHoveredItem(null);
      },
      "data-testid": "BrandPromiseLine-item",
      className: classnames_default()('relative rtl:ml-5', {
        'lg:rtl:ml-0': index === 0
      })
    }, shouldShowPictures ? BrandPromiseLine_jsx("div", {
      style: {
        height: '235px',
        width: '180px',
        flexShrink: '0'
      },
      className: classnames_default()('rounded-tiny p-3 overflow-hidden text-center flex items-end justify-center relative', {
        'inset-border-after': isXC
      })
    }, BrandPromiseLine_jsx(Image["a" /* default */], {
      className: classnames_default()('absolute inset-0 transition-transform', {
        'scale-105': hoveredItem === index && link
      }),
      altMsg: mediaAlt,
      imageUrl: mediaUrl,
      mandatoryWidthAndHeight: {
        h: 235,
        w: 180
      }
    })) : null, BrandPromiseLine_jsx(TagName, conditionalTagNameProps, shouldShowPictures ? BrandPromiseLine_jsx("div", {
      className: "relative",
      style: {
        height: '235px',
        marginTop: '-235px'
      }
    }) : null, BrandPromiseLine_jsx("div", {
      style: {
        width: '180px'
      },
      className: textStyles
    }, BrandPromiseLine_jsx("div", {
      style: {
        width: '126px',
        height: '72px',
        marginTop: shouldShowPictures ? '-42px' : ''
      },
      className: "relative m-auto overflow-hidden will-change-transform"
    }, BrandPromiseLine_jsx("div", {
      className: classnames_default()('bg-white m-auto flex items-center justify-center', badgeStyles.iconContainer),
      style: {
        width: "calc(".concat(badgeStyles.iconContainerWidth, "rem / 16)"),
        height: "calc(".concat(badgeStyles.iconContainerHeight, "rem / 16)")
      }
    }, BrandPromiseLine_jsx(Icon["a" /* Icon */], {
      name: iconName,
      className: badgeStyles.icon,
      width: badgeStyles.iconWidth,
      isNotSquare: badgeStyles.isNotSquare
    }))), BrandPromiseLine_jsx(Text["a" /* Text */], {
      className: "text-base text-center",
      color: "current",
      text: text
    }))));
  });
}

var BrandPromiseLine_BrandPromiseLine = function BrandPromiseLine(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      items = _ref2.items,
      learnMoreLink = _ref2.learnMoreLink,
      learnMoreLabel = _ref2.learnMoreLabel;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(null),
      hoveredItem = _useState[0],
      setHoveredItem = _useState[1];

  return BrandPromiseLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, BrandPromiseLine_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, !!title && BrandPromiseLine_jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), learnMoreLabel && learnMoreLink && BrandPromiseLine_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "m-auto md:mx-0 mt-4 md:mt-1 order-last md:order-none text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: {
      actionGA: 'push_content_brandPromise',
      labelGA: 'learnMore'
    },
    url: learnMoreLink
  }, learnMoreLabel), BrandPromiseLine_jsx("div", {
    className: "-mx-5 lg:mx-0 w-screen lg:w-full"
  }, BrandPromiseLine_jsx(Slider, {
    cols: 0,
    hasControls: isDesktop,
    navPosition: "center",
    nbItemsToScroll: isTablet ? 2 : 1,
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous'),
    scrollAreaClassName: "overflow-hidden",
    scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory",
    scrollControlsClassName: "-mx-5 lg:mx-0",
    scrollItemClassName: "overflow-hidden flex-none max-w-full"
  }, getItemsToRender(items, hoveredItem, setHoveredItem), BrandPromiseLine_jsx("div", {
    style: {
      width: '20px',
      height: '1px',
      flexShrink: '0'
    },
    className: "lg:hidden rtl:-order-1"
  })))));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/brand-promise/brandPromise.descriptor.js


var brandPromiseDescriptor = {
  name: constants["b" /* BRAND_PROMISE */],
  component: BrandPromiseLine_BrandPromiseLine
};
// CONCATENATED MODULE: ./src/client/components/lines/country-events-line/CountryEventsLine.jsx

var CountryEventsLine_jsx = react_default.a.createElement;





var ORIGINAL_DATE_FORMAT = 'DD/MM/YYYY';
var TARGET_DATE_FORMAT = 'DD MMMM YYYY';

function CountryEventsLine_formatDate(startDate, endDate) {
  return [startDate, endDate].filter(Boolean).map(function (date) {
    return moment_default()(date, ORIGINAL_DATE_FORMAT).format(TARGET_DATE_FORMAT);
  }).join(' - ');
}

function getCtaLabel(associatedProductLabel, productName) {
  return productName ? "".concat(associatedProductLabel, " ").concat(productName).trim() : '';
}

function CountryEventsLine(_ref) {
  var associatedProductLabel = _ref.associatedProductLabel,
      close = _ref.config.common.close,
      _ref$countryEvents = _ref.countryEvents,
      countryEvents = _ref$countryEvents === void 0 ? [] : _ref$countryEvents,
      id = _ref.id,
      seeMoreLabel = _ref.seeMoreLabel;
  var countryEventsCards = countryEvents.map(function (_ref2) {
    var _ref2$associatedProdu = _ref2.associatedProducts,
        associatedProducts = _ref2$associatedProdu === void 0 ? [] : _ref2$associatedProdu,
        description = _ref2.description,
        endDate = _ref2.endDate,
        media = _ref2.media,
        startDate = _ref2.startDate,
        title = _ref2.title;
    var associatedProduct = associatedProducts.length > 0 ? associatedProducts[0] : {};
    return {
      closeLabel: close,
      ctaLabel: getCtaLabel(associatedProductLabel, associatedProduct.name),
      heading: {
        title: title,
        hLevel: 3
      },
      introduction: {
        text: CountryEventsLine_formatDate(startDate, endDate)
      },
      link: {
        url: associatedProduct.url
      },
      media: {
        alt: media ? media.mediaAlt : '',
        url: media ? media.mediaUrl : ''
      },
      text: {
        text: description,
        seeMoreLabel: seeMoreLabel
      }
    };
  });

  if (countryEventsCards.length === 0) {
    return null;
  }

  return CountryEventsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, countryEventsCards.length > 1 ? CountryEventsLine_jsx("div", {
    className: "sm:flex sm:flex-wrap -m-2"
  }, countryEventsCards.map(function (countryEventCard) {
    return CountryEventsLine_jsx("div", {
      className: "sm:w-1/2 p-2",
      key: countryEventCard.heading.title
    }, CountryEventsLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, countryEventCard, {
      layout: Card_constants["a" /* COLUMN_1 */]
    })));
  })) : CountryEventsLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, countryEventsCards[0], {
    layout: Card_constants["c" /* COMPOSITE_1 */]
  })));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/country-events/countryEvents.resolver.js
var countryEvents_resolver = __webpack_require__("fGxS");

// CONCATENATED MODULE: ./src/client/cms/toolkit/country-events/countryEvents.descriptor.js



var countryEventsDescriptor = {
  name: constants["e" /* COUNTRY_EVENTS */],
  component: CountryEventsLine,
  resolve: countryEvents_resolver["a" /* countryEventsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/country-infos-line/CountryInfosLine.jsx

var CountryInfosLine_jsx = react_default.a.createElement;




var CountryInfosLine_CountryInfosLine = function CountryInfosLine(_ref) {
  var close = _ref.config.common.close,
      _ref$countryInfos$tex = _ref.countryInfos.texts,
      texts = _ref$countryInfos$tex === void 0 ? [] : _ref$countryInfos$tex,
      _ref$cta = _ref.cta,
      cta = _ref$cta === void 0 ? [] : _ref$cta,
      id = _ref.id;
  var cards = texts.map(function (_ref2, index) {
    var _ref2$description = _ref2.description,
        description = _ref2$description === void 0 ? '' : _ref2$description,
        _ref2$media = _ref2.media;
    _ref2$media = _ref2$media === void 0 ? {} : _ref2$media;
    var _ref2$media$mediaAlt = _ref2$media.mediaAlt,
        mediaAlt = _ref2$media$mediaAlt === void 0 ? '' : _ref2$media$mediaAlt,
        _ref2$media$mediaUrl = _ref2$media.mediaUrl,
        mediaUrl = _ref2$media$mediaUrl === void 0 ? '' : _ref2$media$mediaUrl,
        _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title;
    return {
      closeLabel: close,
      ctaLabel: cta[index] && cta[index].label,
      heading: {
        title: title,
        hLevel: 3
      },
      link: {
        url: cta[index] && cta[index].link
      },
      media: {
        url: mediaUrl,
        alt: mediaAlt
      },
      text: {
        text: description
      }
    };
  });

  if (!cards.length) {
    return null;
  }

  return CountryInfosLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, cards.map(function (card, index) {
    return CountryInfosLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, card, {
      key: card.heading.title,
      className: index ? 'mt-5' : '',
      layout: index % 2 === 0 ? Card_constants["d" /* INLINE_1 */] : Card_constants["e" /* INLINE_2 */]
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/country-infos/countryInfos.resolver.js
var countryInfos_resolver = __webpack_require__("6X2a");

// CONCATENATED MODULE: ./src/client/cms/toolkit/country-infos/countryInfos.descriptor.js



var countryInfosDescriptor = {
  name: constants["f" /* COUNTRY_INFOS */],
  component: CountryInfosLine_CountryInfosLine,
  resolve: countryInfos_resolver["a" /* countryInfosResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/country-introduction-line/CountryIntroductionLine.jsx
var CountryIntroductionLine_jsx = react_default.a.createElement;



function CountryIntroductionLine(_ref) {
  var _ref$countryInfos = _ref.countryInfos,
      _ref$countryInfos$des = _ref$countryInfos.description,
      description = _ref$countryInfos$des === void 0 ? '' : _ref$countryInfos$des,
      _ref$countryInfos$tit = _ref$countryInfos.title,
      title = _ref$countryInfos$tit === void 0 ? '' : _ref$countryInfos$tit,
      _ref$config$common = _ref.config.common,
      viewMore = _ref$config$common.viewMore,
      loadLess = _ref$config$common.loadLess,
      id = _ref.id;
  return CountryIntroductionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, CountryIntroductionLine_jsx(Introduction["a" /* Introduction */], {
    text: description,
    title: title,
    seeMoreLabel: viewMore,
    seeLessLabel: loadLess
  }));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/country-introduction/countryIntroduction.resolver.js
var countryIntroduction_resolver = __webpack_require__("VGY0");

// CONCATENATED MODULE: ./src/client/cms/toolkit/country-introduction/countryIntroduction.descriptor.js



var countryIntroductionDescriptor = {
  name: constants["g" /* COUNTRY_INTRODUCTION */],
  component: CountryIntroductionLine,
  resolve: countryIntroduction_resolver["a" /* countryIntroductionResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/country-poi-line/CountryPoiLine.jsx

var CountryPoiLine_jsx = react_default.a.createElement;





function CountryPoiLine_getCtaLabel(associatedProductLabel, productName) {
  return productName ? "".concat(associatedProductLabel, " ").concat(productName).trim() : '';
}

function CountryPoiLine(_ref) {
  var _ref$associatedProduc = _ref.associatedProductLabel,
      associatedProductLabel = _ref$associatedProduc === void 0 ? '' : _ref$associatedProduc,
      close = _ref.config.common.close,
      _ref$countryPoi = _ref.countryPoi,
      countryPoi = _ref$countryPoi === void 0 ? [] : _ref$countryPoi,
      id = _ref.id;
  var cards = countryPoi.map(function (_ref2) {
    var _ref2$associatedProdu = _ref2.associatedProducts,
        associatedProducts = _ref2$associatedProdu === void 0 ? [] : _ref2$associatedProdu,
        _ref2$description = _ref2.description,
        description = _ref2$description === void 0 ? '' : _ref2$description,
        media = _ref2.media,
        _ref2$seeMoreLabel = _ref2.seeMoreLabel,
        seeMoreLabel = _ref2$seeMoreLabel === void 0 ? '' : _ref2$seeMoreLabel,
        _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title;
    return {
      closeLabel: close,
      ctaLabel: CountryPoiLine_getCtaLabel(associatedProductLabel, associatedProducts && associatedProducts[0] ? associatedProducts[0].name : ''),
      heading: {
        title: title,
        hLevel: 3
      },
      link: {
        url: associatedProducts && associatedProducts[0] ? associatedProducts[0].href : ''
      },
      media: {
        url: media ? media.mediaUrl : '',
        alt: media ? media.mediaAlt : ''
      },
      text: {
        text: description,
        seeMoreLabel: seeMoreLabel
      }
    };
  });

  if (!cards.length) {
    return null;
  }

  return CountryPoiLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, cards.length > 1 ? CountryPoiLine_jsx("div", {
    className: "sm:flex sm:flex-wrap -m-2"
  }, cards.map(function (card) {
    return CountryPoiLine_jsx("div", {
      className: "sm:w-1/2 p-2",
      key: card.heading.title
    }, CountryPoiLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, card, {
      layout: Card_constants["a" /* COLUMN_1 */]
    })));
  })) : CountryPoiLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards[0], {
    layout: Card_constants["c" /* COMPOSITE_1 */]
  })));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/country-poi/countryPoi.resolver.js
var countryPoi_resolver = __webpack_require__("A7XF");

// CONCATENATED MODULE: ./src/client/cms/toolkit/country-poi/countryPoi.descriptor.js



var countryPoiDescriptor = {
  name: constants["h" /* COUNTRY_POI */],
  component: CountryPoiLine,
  resolve: countryPoi_resolver["a" /* countryPoiResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/offer-description-line/OfferDescriptionLine.jsx
var OfferDescriptionLine_jsx = react_default.a.createElement;




var OfferDescriptionLine_OfferDescriptionLine = function OfferDescriptionLine(_ref) {
  var config = _ref.config,
      _ref$offer = _ref.offer,
      offer = _ref$offer === void 0 ? {} : _ref$offer;

  if (Object(lodash["isEmpty"])(offer)) {
    return null;
  }

  return OfferDescriptionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, OfferDescriptionLine_jsx(Introduction["a" /* Introduction */], {
    color: offer.color,
    text: offer.description,
    title: offer.timingArgument,
    seeLessLabel: config.common.loadLess,
    seeMoreLabel: config.common.viewMore
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/offer-description/offerDescription.resolver.js
var offerDescription_resolver = __webpack_require__("ih3X");

// CONCATENATED MODULE: ./src/client/cms/toolkit/offer-description/offerDescription.descriptor.js



var offerDescriptionDescriptor = {
  name: constants["C" /* OFFER_DESCRIPTION */],
  component: OfferDescriptionLine_OfferDescriptionLine,
  resolve: offerDescription_resolver["a" /* offerDescriptionResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// CONCATENATED MODULE: ./src/client/components/lines/offer-legal-information-line/OfferLegalInformationLine.jsx
var OfferLegalInformationLine_jsx = react_default.a.createElement;




var OfferLegalInformationLine_OfferLegalInformationLine = function OfferLegalInformationLine(_ref) {
  var config = _ref.config,
      offer = _ref.offer,
      seeMore = _ref.seeMore;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  if (!offer || !offer.legalInformation) {
    return null;
  }

  return OfferLegalInformationLine_jsx("div", {
    className: "Line Line-Offer-Legal-Information"
  }, OfferLegalInformationLine_jsx(SiteContainer["a" /* SiteContainer */], null, OfferLegalInformationLine_jsx(TextSeeMore["a" /* TextSeeMore */], {
    text: offer.legalInformation,
    theme: "text-sans-2",
    seeMoreLabel: seeMore,
    seeLessLabel: config.common.loadLess,
    isCollapseEnabled: !isDesktop
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/offer-legal-information/offerLegalInformation.resolver.js
var offerLegalInformation_resolver = __webpack_require__("9Kh7");

// CONCATENATED MODULE: ./src/client/cms/toolkit/offer-legal-information/offerLegalInformation.descriptor.js



var offerLegalInformationDescriptor = {
  name: constants["D" /* OFFER_LEGAL_INFORMATION */],
  component: OfferLegalInformationLine_OfferLegalInformationLine,
  resolve: offerLegalInformation_resolver["a" /* offerLegalInformationResolver */].resolve
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./src/client/cms/toolkit/offer-seo/offerSeo.resolver.js
var offerSeo_resolver = __webpack_require__("Wb8K");

// CONCATENATED MODULE: ./src/client/cms/toolkit/offer-seo/offerSeo.descriptor.js
var offerSeo_descriptor_jsx = react["createElement"];





var offerSeo_descriptor_SeoComponent = function SeoComponent(_ref) {
  var title = _ref.title,
      meta = _ref.meta;
  return offerSeo_descriptor_jsx(head_default.a, null, offerSeo_descriptor_jsx("title", {
    key: "title"
  }, title), meta.map(function (_ref2) {
    var name = _ref2.name,
        content = _ref2.content;
    return offerSeo_descriptor_jsx("meta", {
      key: name,
      content: content,
      name: name
    });
  }));
};

var offerSEODescriptor = {
  name: constants["E" /* OFFER_SEO */],
  component: offerSeo_descriptor_SeoComponent,
  props: offerSeo_resolver["a" /* offerSEOResolver */].props,
  resolve: offerSeo_resolver["a" /* offerSEOResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/frameworks/fieldset/Fieldset.jsx + 1 modules
var Fieldset = __webpack_require__("WRD1");

// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseFooter.jsx

var CruiseFooter_jsx = react_default.a.createElement;








var CruiseFooter_CruiseFooter = function CruiseFooter(_ref) {
  var config = _ref.config,
      loading = _ref.loading,
      price = _ref.price,
      onClick = _ref.onClick;

  if (loading) {
    return true ? CruiseFooter_jsx("div", {
      className: "flex flex-col items-center justify-center",
      "data-testid": "cruiseBooking-loader"
    }, CruiseFooter_jsx("p", null, Object(src_i18n["f" /* t */])('booking.loadingPrice')), CruiseFooter_jsx(Spinner["a" /* Spinner */], {
      size: "small",
      color: colors["a" /* COLORS */].GRAY
    })) : undefined;
  }

  return CruiseFooter_jsx("div", {
    className: "flex flex-col items-center justify-center"
  }, CruiseFooter_jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({
    hasInitialPrice: false
  }, Object(lodash["get"])(config, 'price.format', {}), price, {
    theme: "remote"
  })), CruiseFooter_jsx(Button["a" /* Button */], {
    className: "mt-6",
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    iconRight: {
      name: icons["a" /* ICONS */].ARROW_FORTH
    },
    onClick: onClick,
    size: "large",
    theme: "formSubmit",
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'cruiseForm',
      labelGA: 'checkPrices'
    },
    type: "button"
  }, Object(src_i18n["f" /* t */])('booking.labelCTA')), CruiseFooter_jsx("div", {
    className: "leading-normal max-w-full mt-6 text-base text-center text-gray-darker",
    "data-testid": "cruiseBookingForm-disclaimer"
  }, Object(src_i18n["f" /* t */])('booking.disclaimer')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseParticipants.jsx
var CruiseParticipants_jsx = react_default.a.createElement;





var CruiseParticipants_CruiseParticipants = function CruiseParticipants(_ref) {
  var adultsNumber = _ref.adultsNumber,
      _ref$cruise = _ref.cruise,
      cruise = _ref$cruise === void 0 ? {} : _ref$cruise,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? DEFAULT_DATE_FORMAT : _ref$dateFormat,
      kids = _ref.kids,
      product = _ref.product,
      setAdultsNumber = _ref.setAdultsNumber,
      _setKids = _ref.setKids,
      setKidsValidationState = _ref.setKidsValidationState;
  return CruiseParticipants_jsx(Participants_Participants, {
    dateFormat: dateFormat,
    dayPlaceholder: Object(src_i18n["f" /* t */])('config.booking.form.dayPlaceholder'),
    monthPlaceholder: Object(src_i18n["f" /* t */])('config.booking.form.monthPlaceholder'),
    yearPlaceholder: Object(src_i18n["f" /* t */])('config.booking.form.yearPlaceholder'),
    adultOnly: product.adultOnly,
    childrenBirthdayDateFormatPlaceholder: Object(src_i18n["f" /* t */])('config.booking.form.childrenBirthdayDateFormatPlaceholder'),
    setKids: function setKids(_ref2) {
      var allKids = _ref2.kids,
          kidsValidations = _ref2.kidsValidations;
      Object(es["b" /* batch */])(function () {
        _setKids(allKids);

        setKidsValidationState(kidsValidations);
      });
    },
    setAdultsNumber: setAdultsNumber,
    kids: kids,
    adultsNumber: adultsNumber,
    departureDate: cruise.departureDate,
    minAgeInformation: product.minAuthorizedAge.formattedValue || '',
    adultAge: Object(src_i18n["f" /* t */])('config.booking.form.adultAge'),
    childAge: product.minAuthorizedAge.value,
    kidsLabel: Object(src_i18n["f" /* t */])('config.common.participants.kidsLabel'),
    adultsLabel: Object(src_i18n["f" /* t */])('config.common.participants.adultsLabel'),
    kidsAgeLimit: Object(src_i18n["f" /* t */])('config.common.participants.kidsAgeLimit')
  });
};
// EXTERNAL MODULE: ./src/client/components/frameworks/form-select/FormSelect.jsx
var FormSelect = __webpack_require__("rXTn");

// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseCriteriaFieldset.jsx
var CruiseCriteriaFieldset_jsx = react_default.a.createElement;






var CruiseCriteriaFieldset_CruiseCriteriaFieldset = function CruiseCriteriaFieldset(_ref) {
  var bookingCriteria = _ref.bookingCriteria,
      cruise = _ref.cruise,
      product = _ref.product,
      transport = _ref.transport,
      onChange = _ref.onChange;
  var transports = bookingCriteria.departureCities || [];
  return CruiseCriteriaFieldset_jsx(react["Fragment"], null, CruiseCriteriaFieldset_jsx("div", {
    className: "w-full sm:w-1/3 p-2",
    "data-testid": "cruiseBookingForm-cruiseDates"
  }, CruiseCriteriaFieldset_jsx(Title["a" /* Title */], {
    className: "my-2",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 3,
    iconName: icons["a" /* ICONS */].DATE,
    theme: "title-sans-3"
  }, Object(src_i18n["f" /* t */])('criteria.dateLabel')), CruiseCriteriaFieldset_jsx("p", {
    className: "py-3 px-4 text-md text-gray-dark"
  }, product.dateRange || '')), CruiseCriteriaFieldset_jsx("div", {
    className: "w-full sm:w-1/3 p-2",
    "data-testid": "cruiseBookingForm-cruiseLocation"
  }, CruiseCriteriaFieldset_jsx(Title["a" /* Title */], {
    className: "my-2",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 3,
    iconName: icons["a" /* ICONS */].ADDRESS,
    theme: "title-sans-3"
  }, Object(src_i18n["f" /* t */])('criteria.fromToLabel')), CruiseCriteriaFieldset_jsx("p", {
    className: "py-3 px-4 text-md text-gray-dark"
  }, cruise.fromToDestination || '')), CruiseCriteriaFieldset_jsx("div", {
    className: "w-full sm:w-1/3 p-2",
    "data-testid": "cruiseBookingForm-cruiseDuration"
  }, CruiseCriteriaFieldset_jsx(Title["a" /* Title */], {
    className: "my-2",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 3,
    iconName: icons["a" /* ICONS */].DURATION,
    theme: "title-sans-3"
  }, Object(src_i18n["f" /* t */])('criteria.durationLabel')), CruiseCriteriaFieldset_jsx("p", {
    className: "py-3 px-4 text-md text-gray-dark"
  }, product.duration || '')), transports.length && CruiseCriteriaFieldset_jsx("div", {
    className: "w-full sm:w-1/3 p-2",
    "data-testid": "cruiseBookingForm-transports"
  }, CruiseCriteriaFieldset_jsx(Title["a" /* Title */], {
    className: "my-2",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 3,
    iconName: icons["a" /* ICONS */].TRANSPORT,
    theme: "title-sans-3"
  }, Object(src_i18n["f" /* t */])('criteria.transportationLabel')), CruiseCriteriaFieldset_jsx(FormSelect["a" /* default */], {
    options: transports,
    dataSelector: "cruiseBookingForm-transports-formSelect",
    value: transport,
    onChange: onChange
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseBooking.utils.js




var CruiseBooking_utils_callPrice = function callPrice(_ref) {
  var appContext = _ref.appContext,
      _ref$departureCity = _ref.departureCity,
      departureCity = _ref$departureCity === void 0 ? '' : _ref$departureCity,
      offer = _ref.location.queryParams.offer,
      productId = _ref.productId;
  var offerName = offer ? dist["url"].decodePath(offer) : '';
  var productArgs = Object(graphql["c" /* buildProductArgs */])(productId, {}, {
    offerName: offerName,
    departureCity: departureCity
  });
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease;
  var cmsArgs = "content : \"".concat(cmsContent, "\" release : \"").concat(cmsRelease, "\"");
  var query = "{\n          price(".concat(productArgs, ") {\n            bestPrice {\n              value\n              formattedValue\n            }\n            termsAndConditions {\n              departureDate\n              arrivalDate\n              duration\n            }\n            unit(").concat(cmsArgs, ")\n          }\n        }");
  return graphqlClient["a" /* default */].runQuery(query, appContext, {
    requestName: requestDictionary["Kd" /* WIDGET_CRUISE_BOOKING_CALL_PRICE */]
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseBooking.jsx










var CruiseBooking_jsx = react_default.a.createElement;

function CruiseBooking_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CruiseBooking_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CruiseBooking_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CruiseBooking_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function CruiseBooking_createSuper(Derived) { var hasNativeReflectConstruct = CruiseBooking_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function CruiseBooking_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }


























var DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
var CruiseBooking_CruiseBooking = /*#__PURE__*/function (_FormValidator) {
  Object(inherits["a" /* default */])(_CruiseBooking, _FormValidator);

  var _super = CruiseBooking_createSuper(_CruiseBooking);

  function _CruiseBooking(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, _CruiseBooking);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleTransport", function (value) {
      var redirectUri = new URI_default.a(dist["windowWrapper"].getLocation()).setSearch(uri_constants["k" /* QUERY_TRANSPORT */], value).toString();
      redirectUtils["a" /* default */].redirectTo()(redirectUri);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "redirectToBookingEngine", /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _this$props, cruise, product, adultsNumber, kids, simpleFetchProposals, location, getBookingEngineI18n, arrivalDate, criterias, _yield$Promise$all, _yield$Promise$all2, proposals, failedProposals;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, cruise = _this$props.cruise, product = _this$props.product, adultsNumber = _this$props.adultsNumber, kids = _this$props.kids, simpleFetchProposals = _this$props.simpleFetchProposals, location = _this$props.location, getBookingEngineI18n = _this$props.getBookingEngineI18n;
              arrivalDate = Object(lodash["get"])(_this.state.price, 'termsAndConditions.arrivalDate');

              if (!arrivalDate) {
                // If the `/v0/search_price` API do not send back a price (e.g. when there is a transport added), the `termsAndConditions.arrivalDate` is empty. In that case, we fallback to the `departureDate` of the cruise - as the parameter `arrivalDate` means "arrival on the site" and _not_ the end of the cruise (#8962).
                arrivalDate = cruise.departureDate;
              }

              criterias = {
                productId: product.id,
                arrivalDate: arrivalDate,
                duration: Object(lodash["get"])(_this.state.price, 'termsAndConditions.duration'),
                attendees: {
                  adults: adultsNumber,
                  kids: kids
                },
                departureCity: Object(uriUtils["j" /* getSpecificQueryParam */])(uri_constants["k" /* QUERY_TRANSPORT */]) || 'NO',
                bookingEngineEntry: booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].CRUISE_BOOKING
              };
              _context.next = 6;
              return Promise.all([simpleFetchProposals(criterias, Object(lodash["get"])(_this.props, 'config.booking.form.proposalsLoaderLabel', 'loading'), _this.context, location), getBookingEngineI18n(_this.context)]);

            case 6:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = Object(slicedToArray["a" /* default */])(_yield$Promise$all, 1);
              proposals = _yield$Promise$all2[0].proposals;
              failedProposals = Object(proposalUtils["r" /* hasFetchProposalsFailed */])(proposals);

              if (!failedProposals) {
                _this.props.history.pushRoute(Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals.proposals, proposals.resort, proposals.proposals[0].id, location.queryParams));
              } else {
                _this.setState({
                  proposalError: proposals.errors
                });
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleSubmit", function (e) {
      e.preventDefault();

      _this.setState({
        hasBeenSubmitted: true,
        proposalError: ''
      }, function () {
        var haveError = Object.values(_this.checkFormErrors()).some(function (error) {
          return error;
        });
        if (haveError) return;
        return _this.redirectToBookingEngine();
      });
    });

    _this.state = {
      loading: true,
      price: {},
      fields: [],
      hasBeenSubmitted: false,
      transport: '',
      proposalError: ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(_CruiseBooking, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updatePrice();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState && prevState.transport !== this.state.transport) {
        this.updatePrice();
      }
    }
  }, {
    key: "updatePrice",
    value: function updatePrice() {
      var _this2 = this;

      CruiseBooking_utils_callPrice({
        departureCity: this.state.transport,
        appContext: this.context,
        location: this.props.location,
        productId: this.props.product.id
      }).then(function (_ref2) {
        var price = _ref2.price;

        _this2.setState({
          loading: false,
          price: price
        });
      });
    }
  }, {
    key: "getFieldByName",
    value: function getFieldByName(name) {
      return Object(lodash["find"])(this.state.fields, {
        name: name
      });
    }
  }, {
    key: "checkFormErrors",
    value: function checkFormErrors() {
      var _this$props$dateForma = this.props.dateFormat,
          dateFormat = _this$props$dateForma === void 0 ? DEFAULT_DATE_FORMAT : _this$props$dateForma;
      var birthdays = getFormattedKidsBirthdate(this.props.kids, dateFormat);
      var adultAgeInYear = +Object(lodash["get"])(this.props, 'config.booking.form.adultAge', DEFAULT_MAX_AGE);
      var childAgeInYear = +Object(lodash["get"])(this.props, 'product.minAuthorizedAge.value', DEFAULT_MIN_AGE) / 12;
      var minAgeErrorMessage = Object(lodash["get"])(this.props, 'product.minAgeErrorMessage.formattedValue');
      var _this$props2 = this.props,
          _this$props2$adultsNu = _this$props2.adultsNumber,
          adultsNumber = _this$props2$adultsNu === void 0 ? 0 : _this$props2$adultsNu,
          kids = _this$props2.kids,
          _this$props2$cruise = _this$props2.cruise,
          cruise = _this$props2$cruise === void 0 ? {} : _this$props2$cruise;
      return participants_validator.checkFormErrors({
        adults: adultsNumber,
        children: kids.length,
        departureDate: cruise.departureDate,
        birthdays: birthdays,
        dateFormat: dateFormat,
        adultAge: adultAgeInYear,
        childAge: childAgeInYear,
        birthdayFormatErrorMessage: Object(lodash["get"])(this.props, 'config.booking.form.errors.birthdayFormat'),
        adultAgeErrorMessage: Object(lodash["get"])(this.props, 'config.booking.form.errors.adultChild'),
        minAgeErrorMessage: minAgeErrorMessage
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$proposalE;

      var _this$state = this.state,
          loading = _this$state.loading,
          price = _this$state.price,
          transport = _this$state.transport;
      var _this$props3 = this.props,
          adultsNumber = _this$props3.adultsNumber,
          bookingCriteria = _this$props3.bookingCriteria,
          config = _this$props3.config,
          criteria = _this$props3.criteria,
          cruise = _this$props3.cruise,
          dateFormat = _this$props3.dateFormat,
          kids = _this$props3.kids,
          _this$props3$pax = _this$props3.pax,
          pax = _this$props3$pax === void 0 ? {} : _this$props3$pax,
          product = _this$props3.product,
          setAdultsNumber = _this$props3.setAdultsNumber,
          setKids = _this$props3.setKids,
          setKidsValidationState = _this$props3.setKidsValidationState,
          title = _this$props3.title;
      return CruiseBooking_jsx(react_default.a.Fragment, null, CruiseBooking_jsx("div", {
        className: "PriceTicket-sticky-beacon"
      }), CruiseBooking_jsx("section", {
        id: "booking",
        className: "py-10"
      }, CruiseBooking_jsx("form", {
        "data-testid": "CruiseBookingForm-form",
        onSubmit: this.handleSubmit
      }, CruiseBooking_jsx(Title["a" /* Title */], {
        "data-testid": "CruiseBookingForm-title",
        color: colors["a" /* COLORS */].GRAY_DARKER,
        className: "mb-8",
        theme: "title-sans-4"
      }, title), CruiseBooking_jsx(Fieldset["a" /* Fieldset */], {
        className: "mb-12",
        legend: criteria.title,
        "data-testid": "CruiseBookingForm-criteriaFieldset"
      }, CruiseBooking_jsx("div", {
        className: "sm:flex sm:flex-wrap -m-2"
      }, CruiseBooking_jsx(CruiseCriteriaFieldset_CruiseCriteriaFieldset, {
        bookingCriteria: bookingCriteria,
        cruise: cruise,
        product: product,
        transport: transport,
        onChange: this.handleTransport
      }))), CruiseBooking_jsx(Fieldset["a" /* Fieldset */], {
        className: "mb-12",
        legend: pax.title,
        "data-testid": "CruiseBookingForm-paxFieldset"
      }, CruiseBooking_jsx(CruiseParticipants_CruiseParticipants, {
        adultsNumber: adultsNumber,
        cruise: cruise,
        dateFormat: dateFormat,
        kids: kids,
        setKidsValidationState: setKidsValidationState,
        product: product,
        setAdultsNumber: setAdultsNumber,
        setKids: setKids
      }), this.state.proposalError && CruiseBooking_jsx(BookingErrors_BookingErrors, {
        errorCode: (_this$state$proposalE = this.state.proposalError[0]) === null || _this$state$proposalE === void 0 ? void 0 : _this$state$proposalE.errorCode
      }), CruiseBooking_jsx(participantsErrors_ParticipantsErrors, {
        config: Object(lodash["pick"])(config.booking.form, ['errorMaxGuestsLabel', 'departureDateErrorMessage']),
        errors: this.checkFormErrors(),
        isSubmitted: this.state.hasBeenSubmitted
      })), CruiseBooking_jsx(CruiseFooter_CruiseFooter, {
        config: config,
        loading: loading,
        price: price,
        onClick: this.handleSubmit
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (Object(uriUtils["j" /* getSpecificQueryParam */])(uri_constants["k" /* QUERY_TRANSPORT */]) !== state.transport) {
        return CruiseBooking_objectSpread(CruiseBooking_objectSpread({}, state), {}, {
          loading: true,
          transport: Object(uriUtils["j" /* getSpecificQueryParam */])(uri_constants["k" /* QUERY_TRANSPORT */])
        });
      }

      return null;
    }
  }]);

  return _CruiseBooking;
}(form_validator_hoc_FormValidator);

Object(defineProperty["a" /* default */])(CruiseBooking_CruiseBooking, "contextType", ReactAppContext["a" /* default */]);

Object(defineProperty["a" /* default */])(CruiseBooking_CruiseBooking, "defaultProps", {
  adultsNumber: 2,
  kids: [],
  resortId: ''
});

var CruiseBooking = Object(withRouter["a" /* withRouter */])(CruiseBooking_CruiseBooking);
// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseBooking.container.js












function CruiseBooking_container_getValue(value, cmsDefaultValue) {
  return !value && cmsDefaultValue ? cmsDefaultValue : value;
}

function CruiseBooking_container_mapStateToProps(state, props) {
  var bookingCriteria = props.bookingCriteria,
      resort = props.resort;
  var kids = Object(storeHelper["c" /* getKids */])(state);
  var adultsNumber = (Object(storeHelper["a" /* getAdults */])(state) || []).length;
  return {
    adultsNumber: CruiseBooking_container_getValue(adultsNumber, Object(lodash["get"])(bookingCriteria, 'initialNumberOfAdults')) || adults_constants["a" /* DEFAULT_ADULTS_NB */],
    kids: getResortInitialKids(kids, Object(lodash["get"])(bookingCriteria, 'initialNumberOfChildren'), Object(lodash["get"])(resort, 'adultOnly')),
    i18n: state.cms
  };
}
var CruiseBooking_container_mapDispatchToProps = {
  setKids: kids_action["b" /* setKids */],
  setKidsValidationState: facetingSearch_action["n" /* setKidsValidationState */],
  setAdultsNumber: adults_action["b" /* setAdultsNumber */],
  simpleFetchProposals: proposals_action["r" /* simpleFetchProposals */],
  getBookingEngineI18n: cms_actions["c" /* getBookingEngineI18n */]
};
var CruiseBookingContainer = Object(es["c" /* connect */])(CruiseBooking_container_mapStateToProps, CruiseBooking_container_mapDispatchToProps)(CruiseBooking);
// CONCATENATED MODULE: ./src/client/components/lines/cruise-booking-line/CruiseBookingLine.jsx

var CruiseBookingLine_jsx = react_default.a.createElement;




var CruiseBookingLine_CruiseBookingLine = function CruiseBookingLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  Object(src_i18n["a" /* addTranslationKeys */])({
    booking: props.booking,
    criteria: props.criteria,
    config: props.config
  });
  return CruiseBookingLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, CruiseBookingLine_jsx(CruiseBookingContainer, props));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/cruise-booking/cruiseBooking.resolver.js
var cruiseBooking_resolver = __webpack_require__("Qabk");

// CONCATENATED MODULE: ./src/client/cms/toolkit/cruise-booking/cruiseBooking.descriptor.js



var cruiseBookingDescriptor = {
  name: constants["j" /* CRUISE_BOOKING */],
  component: CruiseBookingLine_CruiseBookingLine,
  resolve: cruiseBooking_resolver["a" /* cruiseBookingResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-program/ProductProgram.jsx
var ProductProgram_jsx = react_default.a.createElement;






function ProductProgramSectionTitles(_ref) {
  var className = _ref.className,
      subtitle = _ref.subtitle,
      title = _ref.title;
  return ProductProgram_jsx("div", {
    className: className
  }, ProductProgram_jsx(Title["a" /* Title */], {
    hLevel: 2,
    theme: "title-brand-11"
  }, title), ProductProgram_jsx(Title["a" /* Title */], {
    hLevel: 3,
    theme: "title-sans-11"
  }, subtitle));
}

function ProductProgramFull(_ref2) {
  var className = _ref2.className,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      stops = _ref2.stops;
  return Object(lodash["isEmpty"])(stops) ? null : ProductProgram_jsx(react["Fragment"], null, ProductProgram_jsx(ProductProgramSectionTitles, {
    className: classnames_default()(className, 'mb-8'),
    subtitle: subtitle,
    title: title
  }), ProductProgram_jsx("div", {
    className: "flex flex-wrap -m-3"
  }, stops.map(function (_ref3) {
    var day = _ref3.day,
        description = _ref3.description,
        stopTitle = _ref3.title,
        departureTime = _ref3.departureTime,
        arrivalTime = _ref3.arrivalTime;
    var departureArrivalTime = [arrivalTime, departureTime].filter(Boolean).join('\n');
    return day || description || stopTitle ? ProductProgram_jsx("div", {
      className: "w-full sm:w-1/2 p-3"
    }, ProductProgram_jsx(Title["a" /* Title */], {
      className: "mb-1",
      hLevel: 3,
      theme: "title-sans-3"
    }, "".concat(day, " - ").concat(stopTitle)), ProductProgram_jsx(Text["a" /* Text */], {
      text: description
    }), !!departureArrivalTime && ProductProgram_jsx(Text["a" /* Text */], {
      text: departureArrivalTime
    })) : null;
  })));
}

function ProductProgramLite(_ref4) {
  var className = _ref4.className,
      title = _ref4.title,
      subtitle = _ref4.subtitle,
      stops = _ref4.stops;
  return Object(lodash["isEmpty"])(stops) ? null : ProductProgram_jsx("section", {
    className: classnames_default()(className, 'flex flex-wrap -m-3')
  }, ProductProgram_jsx(ProductProgramSectionTitles, {
    className: "w-full sm:w-1/2 p-3",
    subtitle: subtitle,
    title: title
  }), ProductProgram_jsx("div", {
    className: "w-full sm:w-1/2 p-3"
  }, ProductProgram_jsx("ul", {
    className: "reset-list leading-normal text-base text-gray-darker"
  }, stops.map(function (_ref5) {
    var day = _ref5.day,
        stopTitle = _ref5.title;
    return day || stopTitle ? ProductProgram_jsx("li", {
      className: "list-disc py-1",
      key: day
    }, ProductProgram_jsx("strong", null, day), " - ", stopTitle) : null;
  }))));
}

function ProductProgram(props) {
  var _props$extension = props.extension,
      extension = _props$extension === void 0 ? {} : _props$extension,
      isDetailed = props.isDetailed,
      _props$program = props.program,
      program = _props$program === void 0 ? {} : _props$program;
  if (Object(lodash["isEmpty"])(program.stops)) return null;
  return isDetailed ? ProductProgram_jsx(react["Fragment"], null, ProductProgram_jsx(ProductProgramFull, {
    stops: program.stops,
    subtitle: program.subtitle,
    title: program.title
  }), ProductProgram_jsx(ProductProgramFull, {
    className: "mt-10",
    stops: extension.stops,
    subtitle: extension.subtitle,
    title: extension.title
  })) : ProductProgram_jsx(react["Fragment"], null, ProductProgram_jsx(ProductProgramLite, {
    stops: program.stops,
    subtitle: program.subtitle,
    title: program.title
  }), ProductProgram_jsx(ProductProgramLite, {
    className: "mt-10",
    stops: extension.stops,
    subtitle: extension.subtitle,
    title: extension.title
  }));
}
// CONCATENATED MODULE: ./src/client/components/lines/cruise-program-line/CruiseProgramLine.jsx
var CruiseProgramLine_jsx = react_default.a.createElement;



var CruiseProgramLine_CruiseProgramLine = function CruiseProgramLine(_ref) {
  var id = _ref.id,
      isDetailed = _ref.isDetailed,
      _ref$cruise = _ref.cruise;
  _ref$cruise = _ref$cruise === void 0 ? {} : _ref$cruise;
  var _ref$cruise$stopover = _ref$cruise.stopover,
      stopover = _ref$cruise$stopover === void 0 ? {} : _ref$cruise$stopover;
  return CruiseProgramLine_jsx("div", {
    className: "Line Line-Cruise-Program",
    id: id
  }, CruiseProgramLine_jsx(SiteContainer["a" /* SiteContainer */], null, CruiseProgramLine_jsx(ProductProgram, {
    isDetailed: isDetailed,
    program: stopover
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/cruise-program/cruiseProgram.resolver.js
var cruiseProgram_resolver = __webpack_require__("eVJY");

// CONCATENATED MODULE: ./src/client/cms/toolkit/cruise-program/cruiseProgram.descriptor.js



var cruiseProgramDescriptor = {
  name: constants["k" /* CRUISE_PROGRAM */],
  component: CruiseProgramLine_CruiseProgramLine,
  resolve: cruiseProgram_resolver["a" /* cruiseProgramResolver */].resolve
};
// EXTERNAL MODULE: ./config/index.js
var config_0 = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config_0);

// CONCATENATED MODULE: ./src/client/components/utils/google/google.constants.js
var GOOGLE_API_DOMAIN = 'googlemap.api.domain';
var GOOGLE_API_KEY = 'googlemap.api.key';
var GOOGLE_API_STREET_VIEW_PATH = 'googlemap.api.streetViewPath';
var GOOGLE_API_JS_PATH = 'googlemap.api.jsPath';
var GOOGLE_API_STATIC_PATH = 'googlemap.api.staticPath';
var GOOGLE_PLACE_URL = 'http://www.google.com/maps/place';

// CONCATENATED MODULE: ./src/client/components/utils/google/google.utils.js



function getGoogleBaseUrl() {
  var googleDomain = config_default.a.get(GOOGLE_API_DOMAIN);
  var googleKey = config_default.a.get(GOOGLE_API_KEY);
  return new URI_default.a(googleDomain).query({
    key: googleKey
  });
}
function getGoogleScriptUrl() {
  return getGoogleBaseUrl().path(config_default.a.get(GOOGLE_API_JS_PATH)).toString();
}
function google_utils_getStaticMapURL(path, query) {
  var baseUrl = getGoogleBaseUrl();
  baseUrl.path(config_default.a.get(path));
  baseUrl.addQuery(query);
  return baseUrl.toString();
}
function getGoogleMapURL(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude;
  return "".concat(GOOGLE_PLACE_URL, "/").concat(latitude, ",").concat(longitude);
}
// CONCATENATED MODULE: ./src/client/components/utils/baidu/baidu.constants.js
var API_VERSION = '2.0';
var BAIDU_CALLBACK = 'baiduloadedcallback';
var BAIDU_MARKER_URL = 'http://api.map.baidu.com/marker';

// CONCATENATED MODULE: ./src/client/components/utils/baidu/baidu.utils.js

function getBaiduMapURL(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude;
  return "".concat(BAIDU_MARKER_URL, "?location=").concat(longitude, ",").concat(latitude, "&output=html");
}
// EXTERNAL MODULE: ./src/client/components/frameworks/address/Address.jsx
var Address = __webpack_require__("e4lk");

// CONCATENATED MODULE: ./src/client/components/utils/async-script-loader/AsyncScriptLoader.jsx
/* eslint-disable react/no-did-mount-set-state */



var LOADING_STATE_NOT_LOADED = 'NOT_LOADED';
var LOADING_STATE_STARTED = 'STARTED';
var LOADING_STATE_LOADED = 'LOADED';
/* harmony default export */ var AsyncScriptLoader = (create_react_class_default()({
  displayName: 'AsyncScriptLoader',
  getInitialState: function getInitialState() {
    return {
      loadingState: LOADING_STATE_NOT_LOADED
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      preload: lodash["noop"],
      callback: lodash["noop"],
      loader: function loader() {
        return lodash["noop"];
      }
    };
  },
  isUnmounted: false,
  handleLoaded: function handleLoaded() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      loadingState: LOADING_STATE_LOADED
    });
  },
  componentDidMount: function componentDidMount() {
    if (this.state.loadingState !== LOADING_STATE_NOT_LOADED) {
      return;
    }

    this.props.preload();
    this.setState({
      loadingState: LOADING_STATE_STARTED
    });
    var loader = this.props.loader();
    loader(this.props.scriptURL, this.handleLoaded);
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.state.loadingState === LOADING_STATE_LOADED) {
      this.props.callback();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.isUnmounted = true;
  },
  render: function render() {
    return this.state.loadingState === LOADING_STATE_LOADED ? this.props.children : null;
  }
}));
// CONCATENATED MODULE: ./src/client/components/frameworks/map/Map.jsx
var Map_jsx = react_default.a.createElement;





function Map(props) {
  var children = props.children,
      className = props.className,
      closeLabel = props.closeLabel,
      dataTestId = props.dataTestId,
      imageSrc = props.imageSrc,
      _props$ratio = props.ratio,
      ratio = _props$ratio === void 0 ? {
    w: 29,
    h: 32
  } : _props$ratio,
      title = props.title,
      trackingData = props.trackingData;

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  if (!imageSrc) return null;
  return Map_jsx(react["Fragment"], null, Map_jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    className: classnames_default()(className, 'reset-button block cursor-pointer overflow-hidden relative w-full image-responsive-cell'),
    onClick: function onClick() {
      return setOpen(true);
    },
    trackingData: !isOpen ? trackingData : null,
    type: "button",
    "data-testid": dataTestId
  }, Map_jsx(Image["a" /* default */], {
    forceImage: true,
    imageUrl: imageSrc,
    mandatoryWidthAndHeight: ratio
  })), isOpen && Map_jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: title,
    closeLabel: closeLabel,
    hasCloseButton: true,
    onClose: function onClose() {
      return setOpen(false);
    }
  }, Map_jsx("div", {
    className: "flex-1 h-full"
  }, children)));
}
// CONCATENATED MODULE: ./src/client/components/frameworks/map/BaiduMap.jsx
var BaiduMap_jsx = react["createElement"];









var SQUARE_MARKER = '/markers/squareMarker.png';
var MARKER = '/markers/marker.png';
var BaiduMap_BaiduMap = function BaiduMap(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      latitude = _ref.latitude,
      longitude = _ref.longitude,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 780 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 420 : _ref$height,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 2 : _ref$scale,
      title = _ref.title,
      _ref$zoom = _ref.zoom,
      zoom = _ref$zoom === void 0 ? 7 : _ref$zoom,
      _ref$loader = _ref.loader,
      loader = _ref$loader === void 0 ? function () {
    return __webpack_require__("h9IM");
  } : _ref$loader;
  var responsive = react["useContext"](responsiveContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var mapRef = react["useRef"]();

  var getBaiduBaseUrl = function getBaiduBaseUrl() {
    var apiConfig = config_default.a.get('baidumap.api');
    return new URI_default.a(apiConfig.domain).addQuery({
      ak: apiConfig.key,
      v: API_VERSION
    });
  };

  var getMarkerUrl = function getMarkerUrl(marker) {
    return "".concat(location.origin).concat(marker);
  };

  var initInteractiveMap = function initInteractiveMap(isLarge) {
    var BMap = dist["windowWrapper"].get('BMap');
    var centerPt = new BMap.Point(longitude, latitude);
    var markerPt = new BMap.Point(longitude, latitude);
    var icon = new BMap.Icon(getMarkerUrl(MARKER), new BMap.Size(58, 70), {
      anchor: new BMap.Size(29, 70),
      infoWindowAnchor: new BMap.Size(29, 0)
    });
    var marker = new BMap.Marker(markerPt, {
      icon: icon
    });
    var map = new BMap.Map(mapRef.current); // Workaround a BaiduMap bug for pinchzoom on mobile

    if (isLarge) {
      // $FlowFixMe
      Object.defineProperty(mapRef.current, 'offsetParent', {
        get: function get() {
          return dist["windowWrapper"].get('document.body');
        }
      });
    }

    map.enableScrollWheelZoom();
    map.centerAndZoom(centerPt, zoom + 1);
    map.addOverlay(marker);
  };

  var isBaiduMapLoaded = function isBaiduMapLoaded() {
    var BMap = dist["windowWrapper"].get('BMap');
    return BMap && BMap.version;
  };

  var getStaticMapOptions = function getStaticMapOptions() {
    return {
      width: width,
      height: height,
      scale: scale,
      zoom: zoom,
      center: "".concat(longitude, ",").concat(latitude),
      markers: "".concat(longitude, ",").concat(latitude),
      markerStyles: "-1,".concat(getMarkerUrl(SQUARE_MARKER))
    };
  };

  var getStaticMapURL = function getStaticMapURL() {
    var baseUrl = getBaiduBaseUrl();
    baseUrl.path(config_default.a.get('baidumap.api.staticPath'));
    baseUrl.addQuery(getStaticMapOptions());
    return baseUrl.toString();
  };

  var getBaiduScriptUrl = function getBaiduScriptUrl() {
    var baseUrl = getBaiduBaseUrl();
    baseUrl.path(config_default.a.get('baidumap.api.jsPath'));
    baseUrl.addQuery('callback', BAIDU_CALLBACK);
    return baseUrl.toString();
  };

  return BaiduMap_jsx(Map, {
    className: className,
    closeLabel: closeLabel,
    imageSrc: getStaticMapURL(),
    isLarge: responsive.isTablet,
    ratio: {
      w: width,
      h: height
    },
    title: title,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'mapClick',
      labelGA: 'BaiduMap'
    }
  }, BaiduMap_jsx(AsyncScriptLoader, {
    scriptURL: getBaiduScriptUrl(),
    loader: loader,
    preload: function preload() {
      dist["windowWrapper"].set(BAIDU_CALLBACK, function () {
        initInteractiveMap(responsive.isTablet);
      });
    },
    callback: function callback() {
      isBaiduMapLoaded() ? dist["windowWrapper"].get(BAIDU_CALLBACK)() : function () {};
    }
  }, BaiduMap_jsx("div", {
    className: "h-full",
    "data-testid": "BaiduMapContainer",
    ref: mapRef
  })));
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// CONCATENATED MODULE: ./src/client/components/frameworks/map/GoogleMap.jsx
var GoogleMap_jsx = react["createElement"];








var GoogleMapReact = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 43).then(__webpack_require__.t.bind(null, "h6Ot", 7));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("h6Ot")];
    },
    modules: ['google-map-react']
  }
});

var createMapOptions = function createMapOptions() {
  return {
    fullscreenControl: false
  };
};

var addMarker = function addMarker(_ref) {
  var map = _ref.map,
      maps = _ref.maps,
      position = _ref.position,
      icon = _ref.icon;
  // eslint-disable-next-line no-new
  new maps.Marker({
    icon: icon,
    map: map,
    position: position
  });
};

var GoogleMap_GoogleMap = function GoogleMap(props) {
  var className = props.className,
      closeLabel = props.closeLabel,
      _props$format = props.format,
      format = _props$format === void 0 ? 'jpeg' : _props$format,
      _props$height = props.height,
      height = _props$height === void 0 ? 420 : _props$height,
      _props$latitude = props.latitude,
      latitude = _props$latitude === void 0 ? 0 : _props$latitude,
      _props$longitude = props.longitude,
      longitude = _props$longitude === void 0 ? 0 : _props$longitude,
      _props$maptype = props.maptype,
      maptype = _props$maptype === void 0 ? 'roadmap' : _props$maptype,
      _props$scale = props.scale,
      scale = _props$scale === void 0 ? 2 : _props$scale,
      title = props.title,
      _props$width = props.width,
      width = _props$width === void 0 ? 780 : _props$width,
      _props$zoom = props.zoom,
      zoom = _props$zoom === void 0 ? 8 : _props$zoom;
  var coordinates = {
    lat: latitude,
    lng: longitude
  };
  var appContext = react["useContext"](ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var iconUrl = "".concat(location.origin, "/markers/marker.png");
  var staticMapOptions = {
    center: "".concat(latitude, ",").concat(longitude),
    zoom: zoom,
    size: "".concat(width, "x").concat(height),
    scale: scale,
    maptype: maptype,
    language: appContext.locale,
    format: format,
    markers: "icon:".concat(iconUrl, "|scale:").concat(scale, "|").concat(latitude, ",").concat(longitude)
  };
  return GoogleMap_jsx(Map, {
    className: className,
    closeLabel: closeLabel,
    dataTestId: "map-preview",
    imageSrc: google_utils_getStaticMapURL(GOOGLE_API_STATIC_PATH, staticMapOptions),
    ratio: {
      w: width,
      h: height
    },
    title: title,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'mapClick',
      labelGA: 'GoogleMap'
    }
  }, GoogleMap_jsx("div", {
    className: "h-full"
  }, GoogleMap_jsx(GoogleMapReact, {
    bootstrapURLKeys: {
      key: config_default.a.get(GOOGLE_API_KEY)
    },
    defaultCenter: coordinates,
    defaultZoom: zoom,
    onGoogleApiLoaded: function onGoogleApiLoaded(_ref2) {
      var map = _ref2.map,
          maps = _ref2.maps;
      return addMarker({
        map: map,
        maps: maps,
        position: coordinates,
        icon: iconUrl
      });
    },
    options: createMapOptions,
    yesIWantToUseGoogleMapApiInternals: true
  })));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/map/GoogleStreetView.jsx
var GoogleStreetView_jsx = react_default.a.createElement;






var GoogleStreetView_GoogleMapReact = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 43).then(__webpack_require__.t.bind(null, "h6Ot", 7));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("h6Ot")];
    },
    modules: ['google-map-react']
  }
});

var addStreetView = function addStreetView(_ref) {
  var map = _ref.map,
      maps = _ref.maps,
      position = _ref.position,
      pov = _ref.pov,
      ref = _ref.ref;
  var panorama = new maps.StreetViewPanorama(ref, {
    fullscreenControl: false,
    position: position,
    pov: pov,
    linksControl: true,
    panControl: true
  });
  map.setStreetView(panorama);
};

function GoogleStreetView(props) {
  var className = props.className,
      closeLabel = props.closeLabel,
      _props$fov = props.fov,
      fov = _props$fov === void 0 ? 2 : _props$fov,
      _props$heading = props.heading,
      heading = _props$heading === void 0 ? 2 : _props$heading,
      _props$height = props.height,
      height = _props$height === void 0 ? 120 : _props$height,
      latitude = props.latitude,
      longitude = props.longitude,
      title = props.title,
      _props$width = props.width,
      width = _props$width === void 0 ? 640 : _props$width;
  var coordinates = {
    lat: latitude,
    lng: longitude
  };
  var staticMapOptions = {
    size: "".concat(width, "x").concat(height),
    location: "".concat(latitude, ",").concat(longitude),
    fov: fov,
    heading: heading,
    pitch: 0 // guess what, the pitch that gets returned from the API is all kinds of wrong
    // because it really likes looking at ceilings; people don't want to look at
    // ceilings, so we hardcode the pitch to 0 until the API gets its act together
    // and returns 0; tbh we shouldn't even need the API to provide this to us.

  };

  var _map = Object(react["useRef"])();

  return GoogleStreetView_jsx(Map, {
    className: className,
    closeLabel: closeLabel,
    dataTestId: "streetview-preview",
    imageSrc: google_utils_getStaticMapURL(GOOGLE_API_STREET_VIEW_PATH, staticMapOptions),
    ratio: {
      w: width,
      h: height
    },
    title: title,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'mapClick',
      labelGA: 'GoogleStreetView'
    }
  }, GoogleStreetView_jsx("div", {
    className: "h-full",
    ref: _map
  }, GoogleStreetView_jsx(GoogleStreetView_GoogleMapReact, {
    bootstrapURLKeys: {
      key: config_default.a.get(GOOGLE_API_KEY)
    },
    defaultCenter: coordinates,
    defaultZoom: fov,
    onGoogleApiLoaded: function onGoogleApiLoaded(_ref2) {
      var map = _ref2.map,
          maps = _ref2.maps;
      return addStreetView({
        map: map,
        maps: maps,
        position: coordinates,
        pov: {
          heading: heading,
          pitch: 0
        },
        // same here, for now
        ref: _map.current
      });
    },
    yesIWantToUseGoogleMapApiInternals: true
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/access-and-map/AccessAndMap.jsx


var AccessAndMap_jsx = react_default.a.createElement;

function AccessAndMap_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AccessAndMap_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccessAndMap_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccessAndMap_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var AccessAndMap_AccessAndMap = function AccessAndMap(_ref) {
  var _ref$access = _ref.access,
      access = _ref$access === void 0 ? [] : _ref$access,
      accessTitle = _ref.accessTitle,
      address = _ref.address,
      className = _ref.className,
      isBaidu = _ref.isBaidu,
      map = _ref.map,
      productName = _ref.productName,
      _ref$streetView = _ref.streetView,
      streetView = _ref$streetView === void 0 ? {} : _ref$streetView;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!map) {
    return null;
  }

  var ratio = isTablet ? {
    w: 780,
    h: 420
  } : {
    w: 290,
    h: 320
  };

  var mapProps = AccessAndMap_objectSpread(AccessAndMap_objectSpread({}, map), {}, {
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    width: ratio.w,
    height: ratio.h
  });

  var coords = {
    latitude: mapProps.latitude,
    longitude: mapProps.longitude
  };
  var streetViewRatio = {
    w: 170,
    h: 90
  };
  var mapUrl = isBaidu ? getBaiduMapURL(coords) : getGoogleMapURL(coords);
  var hasStreetView = !!streetView.latitude && !!streetView.longitude;
  return AccessAndMap_jsx("div", {
    className: classnames_default()(className, 'flex flex-col sm:flex-row')
  }, AccessAndMap_jsx("div", {
    className: "relative mb-5 sm:mb-0 sm:w-2/3"
  }, isBaidu ? AccessAndMap_jsx(BaiduMap_BaiduMap, Object(esm_extends["a" /* default */])({}, mapProps, {
    className: "rounded-tiny",
    title: Object(dist["messageFormat"])(Object(src_i18n["f" /* t */])('common.maps.productBaiduMap')).format({
      productName: productName
    })
  })) : AccessAndMap_jsx("div", {
    className: "relative"
  }, AccessAndMap_jsx(GoogleMap_GoogleMap, Object(esm_extends["a" /* default */])({}, mapProps, {
    className: "rounded-tiny",
    title: Object(dist["messageFormat"])(Object(src_i18n["f" /* t */])('common.maps.productGoogleMap')).format({
      productName: productName
    })
  })), hasStreetView && AccessAndMap_jsx("div", {
    style: {
      height: streetViewRatio.h,
      width: streetViewRatio.w
    },
    className: "absolute bottom-0 right-0 m-5"
  }, AccessAndMap_jsx(GoogleStreetView, Object(esm_extends["a" /* default */])({}, streetView, {
    className: "border-5 border-solid border-white rounded-tiny shadow z-1",
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    height: streetViewRatio.h,
    title: Object(dist["messageFormat"])(Object(src_i18n["f" /* t */])('common.maps.productGoogleStreetView')).format({
      productName: productName
    }),
    width: streetViewRatio.w
  }))))), AccessAndMap_jsx("div", {
    className: "sm:rtl:ml-5 sm:w-1/3"
  }, address && AccessAndMap_jsx("div", {
    className: "bg-white border-1 flex items-center last-child-mb-0 mb-5 py-3 px-5 rounded-tiny"
  }, AccessAndMap_jsx(Address["a" /* Address */], Object(esm_extends["a" /* default */])({}, address, {
    className: "flex-1"
  })), mapUrl && AccessAndMap_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "leading-none p-4 rtl:-mr-4 text-gray-darker",
    "data-testid": "address-link",
    url: mapUrl,
    target: "_blank",
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'mapClick',
      labelGA: 'GoogleMapPage'
    }
  }, AccessAndMap_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_FORTH,
    hasRtl: true,
    width: "0.625rem"
  }))), !Object(lodash["isEmpty"])(access) && accessTitle && AccessAndMap_jsx("h3", {
    className: "reset-heading text-base mb-4"
  }, accessTitle), AccessAndMap_jsx(SeeMore["a" /* SeeMore */], {
    seeMoreLabel: Object(src_i18n["f" /* t */])('common.viewMore'),
    seeLessLabel: Object(src_i18n["f" /* t */])('common.loadLess'),
    seeMoreSize: 250,
    isCollapseEnabled: access.length > 3,
    classNameButton: "rtl:text-right"
  }, access.map(function (_ref2, i) {
    var iconName = _ref2.iconName,
        _ref2$texts = _ref2.texts,
        texts = _ref2$texts === void 0 ? [] : _ref2$texts;
    return AccessAndMap_jsx("div", {
      className: "bg-white border-1 flex items-center justify-between last-child-mb-0 mb-4 py-3 px-5 rounded-tiny",
      "data-testid": "AccessAndMap-access",
      key: i
    }, AccessAndMap_jsx("div", null, texts.map(function (accessTextLine, j) {
      return AccessAndMap_jsx("p", {
        className: classnames_default()('reset-paragraph leading-normal text-gray-darker', {
          'text-sm': j,
          'text-base': !j
        }),
        key: j
      }, j ? accessTextLine : AccessAndMap_jsx("strong", {
        className: "font-bold"
      }, accessTextLine));
    })), AccessAndMap_jsx(Icon["a" /* Icon */], {
      className: "rtl:ml-5 flex-shrink-0",
      color: colors["a" /* COLORS */].GRAY_DARKER,
      name: iconName,
      width: "1rem"
    }));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-access-and-map-line/ProductAccessAndMapLine.jsx
var ProductAccessAndMapLine_jsx = react_default.a.createElement;






var ICON_MAPPING = {
  TRAIN_STATION: icons["a" /* ICONS */].TRAIN,
  AIRPORT: icons["a" /* ICONS */].TRANSPORT,
  PORT: icons["a" /* ICONS */].BOAT
};

function buildAccess(minutes) {
  return function (_ref) {
    var name = _ref.name,
        transfertDurationMin = _ref.transfertDurationMin,
        type = _ref.type;
    return type ? {
      iconName: ICON_MAPPING[type.toUpperCase()],
      texts: [name, transfertDurationMin ? "".concat(transfertDurationMin, " ").concat(minutes) : null].filter(Boolean)
    } : null;
  };
}

var ProductAccessAndMapLine_ProductAccessAndMapLine = function ProductAccessAndMapLine(props) {
  var accessTitle = props.accessTitle,
      config = props.config,
      mapType = props.mapType,
      minutes = props.minutes,
      _props$resort = props.resort,
      resort = _props$resort === void 0 ? {} : _props$resort,
      title = props.title;
  var accessesFiltered = resort.accesses.filter(function (access) {
    return access.id && !access.id.includes('MICE');
  });
  Object(src_i18n["a" /* addTranslationKeys */])(config);
  return ProductAccessAndMapLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, ProductAccessAndMapLine_jsx(LineTitle["a" /* LineTitle */], null, title), ProductAccessAndMapLine_jsx(AccessAndMap_AccessAndMap, {
    accessTitle: accessTitle,
    access: [].concat(accessesFiltered || []).map(buildAccess(minutes)).filter(Boolean),
    address: resort.address,
    isBaidu: mapType === 'BAIDU',
    map: resort.coordinates,
    productName: resort.name,
    streetView: resort.streetView
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-access-and-map/productAccessAndMap.resolver.js
var productAccessAndMap_resolver = __webpack_require__("afpJ");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-access-and-map/productAccessAndMap.descriptor.js



var productAccessAndMapDescriptor = {
  name: constants["ab" /* RESORT_ACCESS_AND_MAP */],
  component: ProductAccessAndMapLine_ProductAccessAndMapLine,
  resolve: productAccessAndMap_resolver["a" /* productAccessAndMapResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/utils/markup/markup.js


function markup_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function markup_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      markup_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      markup_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var markup_getLinkTagName = function getLinkTagName(link) {
  if (Object(lodash["isEmpty"])(link)) {
    return 'div';
  }

  return link.onClick ? 'button' : DynamicLink["a" /* default */];
};
var getLinkProps = function getLinkProps(link) {
  return (link === null || link === void 0 ? void 0 : link.onClick) ? markup_objectSpread(markup_objectSpread({}, link), {}, {
    type: 'button'
  }) : link;
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-room-card/ProductRoomCard.jsx

var ProductRoomCard_jsx = react_default.a.createElement;










function ProductRoomCard(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      isHidden = _ref.isHidden,
      isLarge = _ref.isLarge,
      _ref$labeledIconsList = _ref.labeledIconsList,
      labeledIconsList = _ref$labeledIconsList === void 0 ? [] : _ref$labeledIconsList,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      seeMoreLabel = _ref.seeMoreLabel,
      title = _ref.title,
      trackingData = _ref.trackingData,
      width = _ref.width;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop,
      isTablet = _useContext.isTablet;

  var tagName = markup_getLinkTagName(link);
  var linkProps = getLinkProps(link);

  var content = ProductRoomCard_jsx(react["Fragment"], null, ProductRoomCard_jsx(Title["a" /* Title */], {
    className: "my-4",
    hasEllipsis: true,
    theme: isExclusiveCollection ? 'title-serif-3' : 'title-sans-3'
  }, title), ProductRoomCard_jsx("ul", {
    className: classnames_default()('reset-list my-4', {
      'lg:-mx-1 lg:flex lg:flex-wrap': isLarge
    })
  }, labeledIconsList.map(function (_ref2, index) {
    var icon = _ref2.icon,
        labels = _ref2.labels;
    return ProductRoomCard_jsx("li", {
      className: classnames_default()('flex justify-between mt-1 overflow-hidden text-base', {
        'lg:flex-none lg:w-1/2 px-1': isLarge
      }),
      key: index,
      style: {
        height: '1.25rem'
      }
    }, !!labels && ProductRoomCard_jsx("span", {
      className: "inline-flex items-center max-w-4/5"
    }, ProductRoomCard_jsx(Icon["a" /* Icon */], {
      className: "flex-shrink-0 rtl:mr-2",
      name: icon,
      width: "1em"
    }), ProductRoomCard_jsx("span", {
      className: "truncate"
    }, labels.map(function (label) {
      return ProductRoomCard_jsx("span", {
        key: label
      }, label, "\xA0");
    }))));
  })), !!seeMoreLabel && ProductRoomCard_jsx("p", {
    className: "reset-paragraph my-4 text-center text-sm underline"
  }, seeMoreLabel));

  var ratio = isLarge && isTablet ? ratios_utils["a" /* default */].R_38_BY_58 : ratios_utils["a" /* default */].R_38_BY_28;
  return isDesktop ? ProductRoomCard_jsx(TeaserCard_TeaserCard, {
    "aria-hidden": isHidden,
    className: classnames_default()(className, 'transition-transform w-full'),
    hasInsetBorder: isExclusiveCollection,
    isActive: isHovering,
    media: media,
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous'),
    ratio: ratio,
    width: width
  }, ProductRoomCard_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, linkProps, {
    as: tagName,
    className: "reset-button text-initial w-full",
    onMouseEnter: function onMouseEnter() {
      return setHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovering(false);
    },
    tabIndex: isHidden ? -1 : 0,
    trackingData: trackingData
  }), content)) : ProductRoomCard_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, linkProps, {
    "aria-hidden": isHidden,
    as: tagName,
    className: classnames_default()(className, 'reset-button block text-initial w-full'),
    style: {
      width: width
    },
    tabIndex: isHidden ? -1 : 0,
    trackingData: trackingData
  }), ProductRoomCard_jsx(TeaserCard_TeaserCard, {
    hasInsetBorder: isExclusiveCollection,
    media: media.slice(0, 1),
    ratio: ratio
  }, content));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx + 1 modules
var LabeledIconsList = __webpack_require__("LR4h");

// CONCATENATED MODULE: ./src/client/components/widgets/product-room-detail/ProductRoomDetail.jsx

var ProductRoomDetail_jsx = react_default.a.createElement;

function ProductRoomDetail_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductRoomDetail_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductRoomDetail_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductRoomDetail_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ProductRoomDetail_ProductRoomDetail = function ProductRoomDetail(_ref) {
  var description = _ref.description,
      _ref$diamond = _ref.diamond,
      diamond = _ref$diamond === void 0 ? {} : _ref$diamond,
      immersive = _ref.immersive,
      isExclusiveCollection = _ref.isExclusiveCollection,
      _ref$overview = _ref.overview,
      overview = _ref$overview === void 0 ? [] : _ref$overview,
      _ref$services = _ref.services,
      services = _ref$services === void 0 ? [] : _ref$services,
      _ref$slideshow = _ref.slideshow,
      slideshow = _ref$slideshow === void 0 ? {} : _ref$slideshow,
      title = _ref.title;
  var diamondProps = isExclusiveCollection ? ProductRoomDetail_objectSpread(ProductRoomDetail_objectSpread({}, diamond), {}, {
    color: colors["a" /* COLORS */].DEEP_BLUE,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].DEEP_BLUE
  }) : ProductRoomDetail_objectSpread(ProductRoomDetail_objectSpread({}, diamond), {}, {
    color: colors["a" /* COLORS */].WHITE,
    colorBg: diamond.color,
    colorBorder: diamond.color
  });

  var slideshowProps = ProductRoomDetail_objectSpread(ProductRoomDetail_objectSpread({}, slideshow), {}, {
    groupKey: 'roomDetail',
    hasInsetBorder: isExclusiveCollection,
    media: slideshow.media,
    nextLabel: Object(src_i18n["f" /* t */])('common.next'),
    previousLabel: Object(src_i18n["f" /* t */])('common.previous')
  });

  var color = isExclusiveCollection ? colors["a" /* COLORS */].DEEP_BLUE : colors["a" /* COLORS */].BLUE;
  var textColor = isExclusiveCollection ? colors["a" /* COLORS */].DEEP_BLUE : colors["a" /* COLORS */].GRAY_DARKER;
  return ProductRoomDetail_jsx(Sheet, {
    diamond: diamondProps,
    immersive: immersive,
    slideshow: slideshowProps
  }, !!overview.length && ProductRoomDetail_jsx("section", {
    className: "border-b-1 pb-5"
  }, ProductRoomDetail_jsx("div", {
    className: "mx-auto",
    style: {
      maxWidth: '33rem'
    }
  }, ProductRoomDetail_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
    color: color,
    items: overview
  }))), ProductRoomDetail_jsx("section", {
    className: classnames_default()('py-5', {
      'border-b-1': services.length
    })
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "sm:text-5xl",
    color: textColor,
    theme: isExclusiveCollection ? 'title-serif-4' : 'title-sans-4'
  }, title), ProductRoomDetail_jsx(Text["a" /* Text */], {
    className: "mt-5 sm:text-md",
    text: description,
    theme: "text-sans-1"
  })), services.map(function (_ref2, idx) {
    var label = _ref2.label,
        items = _ref2.items;
    return ProductRoomDetail_jsx("section", {
      className: classnames_default()('py-5', {
        'border-b-1': idx !== services.length - 1
      }),
      key: label
    }, ProductRoomDetail_jsx(Title["a" /* Title */], {
      className: "mb-3",
      hLevel: 3,
      theme: "title-sans-3"
    }, label), ProductRoomDetail_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
      items: items,
      theme: "list",
      color: color
    }));
  }));
};
// EXTERNAL MODULE: ./src/utils/proposal/constants.js
var proposal_constants = __webpack_require__("tI+f");

// CONCATENATED MODULE: ./src/client/components/lines/product-accommodations-line/productAccommodations.utils.js

var productAccommodations_utils_jsx = react_default.a.createElement;









var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES,
    RANKINGS = dist["constants"].RANKINGS;
var DEFAULT_RANKING = RANKINGS.LOW;
function getSurfaceIconItem(i18n, surface, roomType) {
  return {
    icon: icons["a" /* ICONS */][roomType] || null,
    labels: [Object(lodash["get"])(i18n, Object(lodash["camelCase"])(roomType)), surface || roomType && ' ' || '']
  };
}
function getCapacityIconItem(i18n, capacity) {
  var peopleLabel = Object(lodash["get"])(i18n, 'numberOfPeopleLabel');

  if (!capacity || !peopleLabel) {
    return null;
  }

  return {
    icon: icons["a" /* ICONS */].PEOPLE,
    labels: [Object(lodash["get"])(i18n, 'capacityOfPeopleLabel'), Object(dist["messageFormat"])(peopleLabel).format({
      count: capacity
    })]
  };
}
function getViewIconItem(view) {
  return view ? {
    icon: icons["a" /* ICONS */][Object(lodash["get"])(view, 'id')] || icons["a" /* ICONS */].TRIDENT1,
    labels: [view.label]
  } : null;
}
function getOutsideFacilitiesIconItems(outsideFacilities) {
  if (Object(lodash["isEmpty"])(outsideFacilities)) {
    return null;
  }

  return outsideFacilities.map(function (item) {
    return {
      icon: icons["a" /* ICONS */][Object(lodash["get"])(item, 'id')],
      labels: [item.label]
    };
  });
}

function getServiceIconItem(service) {
  return service ? {
    icon: icons["a" /* ICONS */][Object(lodash["get"])(service, 'id')] || icons["a" /* ICONS */].TRIDENT1,
    labels: [service.label]
  } : null;
}

function aggregateIconList(_ref) {
  var surfaceItem = _ref.surfaceItem,
      capacityItem = _ref.capacityItem,
      outsideFacilitiesItems = _ref.outsideFacilitiesItems,
      strengths = _ref.strengths,
      viewItem = _ref.viewItem;
  var maxAccomodationsToDisplay = 4;
  var accomodationsWithoutStrengthsCount = [surfaceItem, capacityItem].concat(Object(toConsumableArray["a" /* default */])(outsideFacilitiesItems || []), [viewItem]).filter(function (item) {
    return Object(lodash["get"])(item, 'labels.0');
  }).length;
  var availableSpacesForStrengths = maxAccomodationsToDisplay - accomodationsWithoutStrengthsCount;
  var strengthsItems = (strengths || []).slice(0, availableSpacesForStrengths).map(function (strength) {
    return {
      icon: icons["a" /* ICONS */][Object(lodash["get"])(strength, 'id')] || icons["a" /* ICONS */].TRIDENT1,
      labels: [Object(lodash["get"])(strength, 'label') || '']
    };
  }); // $FlowFixMe

  return Object(lodash["compact"])([surfaceItem, capacityItem].concat(Object(toConsumableArray["a" /* default */])(outsideFacilitiesItems || []), Object(toConsumableArray["a" /* default */])(strengthsItems), [viewItem])).filter(function (_ref2) {
    var _ref2$labels = _ref2.labels,
        labels = _ref2$labels === void 0 ? [] : _ref2$labels;
    return labels.length && labels[0];
  }).slice(0, 4);
}

function mapAccommodationStrengths(i18n, accommodation) {
  var maxCapacity = accommodation.maxCapacity,
      roomType = accommodation.roomType,
      strengths = accommodation.strengths,
      surface = accommodation.surface,
      view = accommodation.view,
      outsideFacilities = accommodation.outsideFacilities;
  var surfaceItem = getSurfaceIconItem(i18n, surface, roomType);
  var capacityItem = getCapacityIconItem(i18n, maxCapacity);
  var viewItem = getViewIconItem(view);
  var outsideFacilitiesItems = getOutsideFacilitiesIconItems(outsideFacilities);
  return aggregateIconList({
    surfaceItem: surfaceItem,
    capacityItem: capacityItem,
    outsideFacilitiesItems: outsideFacilitiesItems,
    strengths: strengths,
    viewItem: viewItem
  });
}

function mapAccommodationServices(i18n, accommodation, isExclusiveCollection) {
  var _accommodation$bathro = accommodation.bathroomEquipments,
      bathroomEquipments = _accommodation$bathro === void 0 ? [] : _accommodation$bathro,
      _accommodation$equipm = accommodation.equipments,
      equipments = _accommodation$equipm === void 0 ? [] : _accommodation$equipm,
      _accommodation$servic = accommodation.services,
      services = _accommodation$servic === void 0 ? [] : _accommodation$servic;
  var isSuiteAccommodation = (accommodation === null || accommodation === void 0 ? void 0 : accommodation.comfortId) === proposal_constants["c" /* COMFORT_TYPE_SUITE */];
  return [{
    label: isExclusiveCollection || isSuiteAccommodation ? Object(lodash["get"])(i18n, 'servicesLabel', '') : null,
    items: Array.isArray(services) && services.map(function (service) {
      return getServiceIconItem(service);
    })
  }, {
    label: Object(lodash["get"])(i18n, 'equipmentLabel', ''),
    items: equipments.map(function (equipment) {
      return getServiceIconItem(equipment);
    })
  }, {
    label: Object(lodash["get"])(i18n, 'bathroomLabel', ''),
    items: bathroomEquipments.map(function (equipment) {
      return getServiceIconItem(equipment);
    })
  }, {
    label: !(isExclusiveCollection || isSuiteAccommodation) ? Object(lodash["get"])(i18n, 'servicesLabel', '') : null,
    items: Array.isArray(services) && services.map(function (service) {
      return getServiceIconItem(service);
    })
  }].filter(function (service) {
    return service.label;
  });
}

function getRankingIndex(ranking) {
  return Object.values(RANKINGS).findIndex(function (r) {
    return r === ranking;
  });
}

function productAccommodations_utils_isProductExclusiveCollection(comfort) {
  return comfort > 4;
} // eslint-disable-next-line clubmed/no-fake-component


function getAccommodation(_ref3) {
  var accommodation = _ref3.accommodation,
      categoryLabel = _ref3.categoryLabel,
      resortComfort = _ref3.resortComfort,
      i18n = _ref3.i18n;
  var categoryId = accommodation.categoryId,
      comfortId = accommodation.comfortId,
      comfortType = accommodation.comfortType,
      description = accommodation.description,
      id = accommodation.id,
      label = accommodation.label,
      photos = accommodation.media.photos;
  var strengths = mapAccommodationStrengths(i18n, accommodation);
  var isDisplayable = [strengths.length, comfortType, label, description].every(function (item) {
    return !!item;
  });
  var isExclusiveCollection = productAccommodations_utils_isProductExclusiveCollection(resortComfort) || accommodation.exclusiveCollection;
  var details = {
    categoryId: categoryId,
    comfort: resortComfort,
    comfortType: comfortType,
    comfortId: comfortId,
    description: description,
    immersive: {
      url: Object(lodash["get"])(photos, '[0].url')
    },
    label: label,
    overview: strengths,
    services: mapAccommodationServices(i18n, accommodation, isExclusiveCollection),
    slideshow: {
      groupeKey: 'roomCard',
      media: photos.map(function (_ref4) {
        var url = _ref4.url;
        return {
          src: url
        };
      })
    }
  };
  return isDisplayable && productAccommodations_utils_jsx(ProductRoomCard, {
    fetchDetail: function fetchDetail() {
      return Promise.resolve(details);
    },
    isExclusiveCollection: isExclusiveCollection,
    key: id,
    labeledIconsList: strengths,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'blockInfos',
      labelGA: "accommodation_".concat(categoryLabel, "_seeMore")
    },
    media: photos.map(function (_ref5) {
      var url = _ref5.url;
      return {
        src: url
      };
    }),
    seeMoreLabel: i18n.seeMore,
    title: label
  });
}

function productAccommodations_utils_renderDetail() {
  return function (_ref6) {
    var comfort = _ref6.comfort,
        comfortType = _ref6.comfortType,
        description = _ref6.description,
        exclusiveCollection = _ref6.exclusiveCollection,
        immersive = _ref6.immersive,
        label = _ref6.label,
        overview = _ref6.overview,
        services = _ref6.services,
        slideshow = _ref6.slideshow;
    var customProps = {
      description: description,
      title: label,
      diamond: {
        color: colors["a" /* COLORS */].LILAS,
        label: comfortType
      },
      immersive: immersive,
      isExclusiveCollection: productAccommodations_utils_isProductExclusiveCollection(comfort) || exclusiveCollection,
      overview: overview,
      services: services,
      slideshow: slideshow
    };
    return productAccommodations_utils_jsx(ProductRoomDetail_ProductRoomDetail, customProps);
  };
}

function mapItemForTabs(props) {
  var _props$accommodationC = props.accommodationCategory;
  _props$accommodationC = _props$accommodationC === void 0 ? {} : _props$accommodationC;
  var _props$accommodationC2 = _props$accommodationC.rankedCategories,
      rankedCategories = _props$accommodationC2 === void 0 ? [] : _props$accommodationC2,
      bathroomLabel = props.bathroomLabel,
      capacityOfPeopleLabel = props.capacityOfPeopleLabel,
      _props$config = props.config;
  _props$config = _props$config === void 0 ? {} : _props$config;
  var _props$config$common = _props$config.common;
  _props$config$common = _props$config$common === void 0 ? {} : _props$config$common;
  var backNavigation = _props$config$common.backNavigation,
      scrollBackward = _props$config$common.scrollBackward,
      scrollForward = _props$config$common.scrollForward,
      equipmentLabel = props.equipmentLabel,
      isLineExclusiveCollection = props.isLineExclusiveCollection,
      numberOfPeopleLabel = props.numberOfPeopleLabel,
      _props$resort = props.resort,
      _props$resort$accommo = _props$resort.accommodations,
      accommodations = _props$resort$accommo === void 0 ? [] : _props$resort$accommo,
      _props$resort$comfort = _props$resort.comfort,
      resortComfort = _props$resort$comfort === void 0 ? 3 : _props$resort$comfort,
      type = _props$resort.type,
      _props$roomConfigurat = props.roomConfiguration;
  _props$roomConfigurat = _props$roomConfigurat === void 0 ? {} : _props$roomConfigurat;
  var singleRoom = _props$roomConfigurat.singleRoom,
      connectingRooms = _props$roomConfigurat.connectingRooms,
      separatedRooms = _props$roomConfigurat.separatedRooms,
      seeMore = props.seeMore,
      servicesLabel = props.servicesLabel;
  var i18n = {
    bathroomLabel: bathroomLabel,
    capacityOfPeopleLabel: capacityOfPeopleLabel,
    connectingRooms: connectingRooms,
    equipmentLabel: equipmentLabel,
    numberOfPeopleLabel: numberOfPeopleLabel,
    seeMore: seeMore,
    separatedRooms: separatedRooms,
    servicesLabel: servicesLabel,
    singleRoom: singleRoom
  };
  var accommodationCategories = accommodations.reduce(function (categories, accommodation) {
    // Ranking index to sort categories and accommodations within a category
    var rankedCategory = rankedCategories.find(function (c) {
      return c.id === accommodation.categoryId;
    });
    var categoryRanking = rankedCategory ? rankedCategory.ranking : DEFAULT_RANKING;
    var categoryIndex = getRankingIndex(categoryRanking); // Accommodation tabs are now based on accommodation comfort, not category...

    var categoryId = accommodation.comfortId;
    var categoryLabel = accommodation.comfortType; // ...except for VILLA products

    if (type === PRODUCT_TYPES.VILLA) {
      // eslint-disable-next-line prefer-destructuring
      categoryId = accommodation.categoryId;
      categoryLabel = accommodation.category;
    }

    if (!categoryId) return categories; // Ranking index to sort accommodations within a category

    var accommodationIndex = getRankingIndex(accommodation.ranking);
    var accommodationProps = {
      accommodation: accommodation,
      accommodationIndex: accommodationIndex,
      categoryLabel: categoryLabel,
      categoryIndex: categoryIndex,
      colorId: accommodation.categoryId,
      resortComfort: resortComfort,
      i18n: i18n
    };

    if (categories[categoryId]) {
      // Add accommodation to category if it exists
      categories[categoryId].categoryAccommodations.push(accommodationProps);
    } else {
      // Create category if it doesn't exist
      categories[categoryId] = {
        categoryAccommodations: [accommodationProps],
        categoryId: categoryId,
        categoryIndex: categoryIndex,
        categoryLabel: categoryLabel
      };
    }

    return categories;
  }, {});
  return (// I have no idea what's going on there and to be honest I don't care enough
    // sorry to the person who'll be reading that in the future but I give up
    // $FlowFixMe
    Object.values(accommodationCategories) // $FlowFixMe
    .sort(function (a, b) {
      return b.categoryIndex - a.categoryIndex;
    }).map(function (accommodationCategory, index) {
      // $FlowFixMe
      var categoryAccommodations = accommodationCategory.categoryAccommodations,
          categoryLabel = accommodationCategory.categoryLabel; // We need to sort with the upper index first. Since Array.sort is broken client side (why??),
      // we use the lodash function which only sorts from the lower to the upper. We knows that the
      // accomodations are already sorted by accomodationIdex so we have to sort by categoryIndex.
      // The tricky part is here: we cannot reverse the output of lodash.sortBy, so we sort with a
      // negative categoryIndex.

      var categoryAccommodationsProps = Object(lodash["sortBy"])(Object(toConsumableArray["a" /* default */])(categoryAccommodations), function (_ref7) {
        var categoryIndex = _ref7.categoryIndex;
        return -1 * categoryIndex;
      });
      var content = categoryAccommodationsProps.map(getAccommodation).filter(Boolean);
      var isLarge = content.every(function (item) {
        return item.props.isExclusiveCollection;
      });
      return isLineExclusiveCollection && isLarge || !isLineExclusiveCollection ? {
        header: {
          title: categoryLabel,
          trackingData: {
            categoryGA: 'resort',
            actionGA: 'blockInfos',
            labelGA: "accommodations_".concat(categoryLabel)
          }
        },
        content: [productAccommodations_utils_jsx(ProductInformationSliderContainer, {
          backNavigationLabel: backNavigation,
          errorMessage: "error",
          isLarge: isLarge,
          key: "ProductAccommodationsSlider_".concat(categoryLabel),
          queryLayer: "acommodationLayer",
          renderDetail: productAccommodations_utils_renderDetail(),
          scrollBackwardLabel: scrollBackward,
          scrollForwardLabel: scrollForward,
          sliderIndex: index
        }, content)]
      } : null;
    }).filter(function (item) {
      return item !== null;
    })
  );
}
// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// CONCATENATED MODULE: ./src/client/components/lines/product-accommodations-line/ProductAccommodationsLine.jsx
var ProductAccommodationsLine_jsx = react_default.a.createElement;






var ProductAccommodationsLine_ProductAccommodationsLine = function ProductAccommodationsLine(props) {
  var items = mapItemForTabs(props);
  var _props$config = props.config;
  _props$config = _props$config === void 0 ? {} : _props$config;
  var _props$config$common = _props$config.common;
  _props$config$common = _props$config$common === void 0 ? {} : _props$config$common;
  var loadLess = _props$config$common.loadLess,
      scrollBackward = _props$config$common.scrollBackward,
      scrollForward = _props$config$common.scrollForward,
      viewMore = _props$config$common.viewMore,
      id = props.id,
      accommodationsIntroduction = props.resort.accommodationsIntroduction;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var content = ProductAccommodationsLine_jsx(react["Fragment"], null, accommodationsIntroduction && ProductAccommodationsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: isTablet
  }, ProductAccommodationsLine_jsx(Introduction["a" /* Introduction */], {
    className: "mb-4",
    dataTestId: "Line-Product-Accommodations__Introduction",
    isTextSeeMoreCollapseEnabled: true,
    title: accommodationsIntroduction.shortDescription,
    text: accommodationsIntroduction.description,
    seeMoreLabel: viewMore,
    seeLessLabel: loadLess
  })), ProductAccommodationsLine_jsx(Tabs["a" /* Tabs */], {
    isScrollable: true,
    items: items,
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward,
    theme: "lite"
  }));

  return isTablet ? ProductAccommodationsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, content) : ProductAccommodationsLine_jsx("div", {
    className: "Line",
    id: id
  }, content);
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-accommodations/productAccommodations.resolver.js
var productAccommodations_resolver = __webpack_require__("JEY5");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-accommodations/productAccommodations.descriptor.js



var productAccommodationsDescriptor = {
  name: constants["cb" /* RESORT_ACCOMMODATION_TYPES */],
  component: ProductAccommodationsLine_ProductAccommodationsLine,
  resolve: productAccommodations_resolver["b" /* productAccommodationsResolver */].resolve
};
var productAccommodationsExclusiveCollectionDescriptor = {
  name: constants["bb" /* RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION */],
  component: ProductAccommodationsLine_ProductAccommodationsLine,
  resolve: productAccommodations_resolver["a" /* productAccommodationsExclusiveCollectionResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-utils/productFeatures.icons.js


var featuresIcons = {
  /* activities */
  activity_search_criterion_archery: {
    icon: icons["a" /* ICONS */].ARCHERY
  },
  activity_search_criterion_climbing: {
    icon: icons["a" /* ICONS */].CLIMBING
  },
  activity_search_criterion_creactive: {
    icon: icons["a" /* ICONS */].CREACTIVE
  },
  activity_search_criterion_cycling_mountain_biking: {
    icon: icons["a" /* ICONS */].VTT
  },
  activity_search_criterion_dance: {
    icon: icons["a" /* ICONS */].DANCE
  },
  activity_search_criterion_entertainment: {
    icon: icons["a" /* ICONS */].ENTERTAINMENT
  },
  activity_search_criterion_fitness: {
    icon: icons["a" /* ICONS */].FITNESS
  },
  activity_search_criterion_flying_trapeze_circus: {
    icon: icons["a" /* ICONS */].TRAPEZE
  },
  activity_search_criterion_football: {
    icon: icons["a" /* ICONS */].SPORT
  },
  activity_search_criterion_golf: {
    icon: icons["a" /* ICONS */].GOLF
  },
  activity_search_criterion_horseriding: {
    icon: icons["a" /* ICONS */].RIDING
  },
  activity_search_criterion_kayak: {
    icon: icons["a" /* ICONS */].KAYAK
  },
  activity_search_criterion_kitesurfing: {
    icon: icons["a" /* ICONS */].KITESURF
  },
  activity_search_criterion_nordic_walking: {
    icon: icons["a" /* ICONS */].NORDIC_WALKING
  },
  activity_search_criterion_sailing: {
    icon: icons["a" /* ICONS */].SAILING
  },
  activity_search_criterion_scuba_diving: {
    icon: icons["a" /* ICONS */].DIVING
  },
  activity_search_criterion_skiing_snowboarding: {
    icon: icons["a" /* ICONS */].SKI
  },
  activity_search_criterion_snorkelling: {
    icon: icons["a" /* ICONS */].SNORKELLING
  },
  activity_search_criterion_snowboard: {
    icon: icons["a" /* ICONS */].SNOWBOARD
  },
  activity_search_criterion_snow_shoe_walks: {
    icon: icons["a" /* ICONS */].SKI_IN_OUT
  },
  activity_search_criterion_stand_up_paddle: {
    icon: icons["a" /* ICONS */].STAND_UP_PADDLE
  },
  activity_search_criterion_volleyball: {
    icon: icons["a" /* ICONS */].SPORT_SCHOOL
  },
  activity_search_criterion_surfing: {
    icon: icons["a" /* ICONS */].TRIDENT1
  },
  activity_search_criterion_swimming: {
    icon: icons["a" /* ICONS */].SWIM
  },
  activity_search_criterion_tai_chi: {
    icon: icons["a" /* ICONS */].TRIDENT1
  },
  activity_search_criterion_tennis: {
    icon: icons["a" /* ICONS */].TENNIS
  },
  activity_search_criterion_treeetop_adventure: {
    icon: icons["a" /* ICONS */].TREETOP_ADVENTURE
  },
  activity_search_criterion_walking_hiking: {
    icon: icons["a" /* ICONS */].WALKING
  },
  activity_search_criterion_waterskiing_wakeboarding: {
    icon: icons["a" /* ICONS */].WATERSKI
  },
  activity_search_criterion_whitewater_sports: {
    icon: icons["a" /* ICONS */].TRIDENT1
  },
  activity_search_criterion_windsurfing: {
    icon: icons["a" /* ICONS */].SURF
  },
  activity_search_criterion_yoga: {
    icon: icons["a" /* ICONS */].YOGA
  },

  /* childcare */
  activity_search_criterion_petit_club: {
    color: colors["a" /* COLORS */].ORANGE,
    icon: icons["a" /* ICONS */].PETIT_CLUB
  },
  activity_search_criterion_mini_club: {
    color: colors["a" /* COLORS */].EMERALD,
    icon: icons["a" /* ICONS */].MINI_CLUB
  },
  activity_search_criterion_baby_club: {
    color: colors["a" /* COLORS */].GRENADINE,
    icon: icons["a" /* ICONS */].BABY_CLUB
  },
  activity_search_criterion_passworld: {
    color: colors["a" /* COLORS */].BLACK,
    icon: icons["a" /* ICONS */].PASSWORLD
  },
  activity_search_criterion_junior: {
    color: colors["a" /* COLORS */].BLACK,
    icon: icons["a" /* ICONS */].JUNIOR
  }
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-utils/productFeatures.utils.js



function productFeatures_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function productFeatures_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      productFeatures_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      productFeatures_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










function mapOpeningHours(openingHours) {
  return openingHours.reduce(function (acc, openingHour) {
    if (!openingHour.start || !openingHour.end) return acc;
    var label = Object(src_i18n["f" /* t */])('productChildcaresInformation.openingHours', {
      ' opening_hours - start ': Object(apiDate["f" /* formatApiTime */])(openingHour.start, 'LT').toLowerCase(),
      ' opening_hours - end ': Object(apiDate["f" /* formatApiTime */])(openingHour.end, 'LT').toLowerCase()
    });
    return acc.length ? "".concat(acc, " ").concat(label) : label;
  }, '');
}

function mapClosingDays(closingWeekdays) {
  if (!closingWeekdays.length) {
    return '';
  }

  var weekdays = closingWeekdays.map(function (closingWeekday) {
    return Object(lodash["capitalize"])(moment_default()().day(closingWeekday).format('dddd'));
  }).join(', ');
  return Object(src_i18n["f" /* t */])('productChildcaresInformation.closingDays', {
    closing_weekdays: weekdays
  });
}

function getRank(item) {
  return Object.values(dist["constants"].RANKINGS).findIndex(function (ranking) {
    return ranking === item.ranking;
  });
}

function sortActivities(a, b) {
  return getRank(b) - getRank(a);
}

function getHowToBookDesc(_ref) {
  var hasBookingOnline = _ref.hasBookingOnline,
      hasBookingOnsite = _ref.hasBookingOnsite,
      config = _ref.config;

  if (!hasBookingOnline && !hasBookingOnsite) {
    return '';
  }

  if (hasBookingOnline && hasBookingOnsite) {
    return config.common.bookOnlineOrOnsite;
  }

  return hasBookingOnline ? config.common.bookOnlineOnly : config.common.bookOnsiteOnly;
}

function mapServices() {
  var services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
      included = _ref2.included,
      onDemand = _ref2.onDemand,
      age = _ref2.age,
      group = _ref2.group,
      equipmentsLabel = _ref2.equipmentsLabel,
      utilitiesLabel = _ref2.utilitiesLabel,
      durationLabel = _ref2.durationLabel,
      config = _ref2.config,
      _ref2$excursionPackin = _ref2.excursionPackingLabel,
      excursionPackingLabel = _ref2$excursionPackin === void 0 ? '' : _ref2$excursionPackin,
      _ref2$excursionSeason = _ref2.excursionSeasonalityLabel,
      excursionSeasonalityLabel = _ref2$excursionSeason === void 0 ? '' : _ref2$excursionSeason,
      _ref2$excursionTransp = _ref2.excursionTransportationLabel,
      excursionTransportationLabel = _ref2$excursionTransp === void 0 ? '' : _ref2$excursionTransp;

  return services.map(function (_ref3) {
    var hasBookingOnline = _ref3.hasBookingOnline,
        hasBookingOnsite = _ref3.hasBookingOnsite,
        id = _ref3.id,
        isIdealForFamily = _ref3.isIdealForFamily,
        description = _ref3.description,
        detailedDescription = _ref3.detailedDescription,
        ageRestriction = _ref3.ageRestriction,
        durationDescription = _ref3.durationDescription,
        label = _ref3.label,
        level = _ref3.level,
        note = _ref3.note,
        groupDescription = _ref3.group,
        specificConditions = _ref3.specificConditions,
        equipments = _ref3.equipments,
        utilities = _ref3.utilities,
        seasonality = _ref3.seasonality,
        transportation = _ref3.transportation,
        whatToBring = _ref3.whatToBring,
        targetPrice = _ref3.targetPrice;
    var items = [{
      description: description
    }, {
      label: config.common.treatmentsLabel,
      description: detailedDescription
    }, {
      label: group,
      description: groupDescription
    }, productFeatures_utils_objectSpread({
      label: age,
      description: ageRestriction
    }, specificConditions ? {
      note: specificConditions
    } : {}), {
      label: excursionSeasonalityLabel,
      description: seasonality
    }, {
      label: excursionTransportationLabel,
      description: transportation
    }, {
      label: excursionPackingLabel,
      description: whatToBring
    }, {
      label: equipmentsLabel,
      items: (equipments || []).map(function (equipment) {
        return {
          description: equipment.label,
          tag: equipment.included ? {
            color: colors["a" /* COLORS */].BLUE,
            label: included
          } : {
            color: colors["a" /* COLORS */].AMBER,
            label: onDemand
          }
        };
      })
    }, {
      label: utilitiesLabel,
      items: (utilities || []).map(function (utility) {
        return {
          description: utility.label,
          tag: utility.included ? {
            color: colors["a" /* COLORS */].BLUE,
            label: included
          } : {
            color: colors["a" /* COLORS */].AMBER,
            label: onDemand
          }
        };
      })
    }, {
      label: config.common.howToBookLabel,
      description: getHowToBookDesc({
        hasBookingOnline: hasBookingOnline,
        hasBookingOnsite: hasBookingOnsite,
        config: config
      })
    }].filter(function (item) {
      return item.description || item.items && !Object(lodash["isEmpty"])(item.items);
    });
    var price = targetPrice && targetPrice.price ? productFeatures_utils_objectSpread(productFeatures_utils_objectSpread({}, targetPrice), {}, {
      label: Object(lodash["get"])(config, 'common.price.priceFrom', '+{price}{currency}')
    }) : null;
    var badges = isIdealForFamily ? [{
      label: config.common.idealForFamilyLabel,
      iconName: icons["a" /* ICONS */].IDEAL_FOR_FAMILY
    }] : null;
    return productFeatures_utils_objectSpread(productFeatures_utils_objectSpread(productFeatures_utils_objectSpread(productFeatures_utils_objectSpread(productFeatures_utils_objectSpread({}, badges ? {
      badges: badges
    } : {}), {}, {
      id: id,
      items: items
    }, level ? {
      level: level
    } : {}), durationDescription ? {
      duration: {
        label: durationLabel,
        description: durationDescription
      }
    } : {}), {}, {
      title: label
    }, note ? {
      note: note
    } : {}), price ? {
      targetPrice: price
    } : {});
  });
}

function mapFacilities() {
  var facilities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var props = arguments.length > 1 ? arguments[1] : undefined;
  var inside = arguments.length > 2 ? arguments[2] : undefined;
  var distanceLabel = props.distance,
      indoorLabel = props.indoor,
      nightLightingLabel = props.nightLighting,
      openingHoursLabel = props.openingHours,
      outdoorLabel = props.outdoor,
      typeDescriptionLabel = props.typeDescription,
      locationLabel = props.location;
  return facilities.filter(function (_ref4) {
    var onSite = _ref4.onSite;
    return onSite === inside;
  }).map(function (_ref5) {
    var id = _ref5.id,
        description = _ref5.description,
        distance = _ref5.distance,
        label = _ref5.label,
        nightLighting = _ref5.nightLighting,
        openingHours = _ref5.openingHours,
        outdoor = _ref5.outdoor,
        quantity = _ref5.quantity,
        _ref5$specificInforma = _ref5.specificInformation,
        specificInformation = _ref5$specificInforma === void 0 ? [] : _ref5$specificInforma,
        _ref5$technicalSpecif = _ref5.technicalSpecificities,
        technicalSpecificities = _ref5$technicalSpecif === void 0 ? {} : _ref5$technicalSpecif,
        localisation = _ref5.localisation;
    var basicInformation = [{
      label: distanceLabel,
      description: distance.toString()
    }, {
      description: nightLighting ? nightLightingLabel : ''
    }, {
      description: outdoor ? outdoorLabel : indoorLabel
    }, {
      label: locationLabel,
      description: localisation
    }, {
      label: openingHoursLabel,
      description: "".concat(Object(lodash["get"])(openingHours, 'opening', ''), " ").concat(Object(lodash["get"])(openingHours, 'closing', '')).trim()
    }];
    var mapSpecificInformation = specificInformation.map(function (information) {
      return {
        label: Object(lodash["get"])(props, Object(lodash["get"])(information, 'type'), ''),
        description: Object(lodash["get"])(information, 'value', '')
      };
    });
    var mapTechnicalSpecificities = Object.keys(technicalSpecificities).filter(function (key) {
      return key !== 'unit' && technicalSpecificities[key] && !Object(lodash["isEmpty"])(technicalSpecificities[key].toString());
    }).map(function (key) {
      if (key === 'typeDescription') {
        return {
          label: typeDescriptionLabel,
          description: technicalSpecificities.typeDescription
        };
      }

      return {
        label: Object(lodash["get"])(props, key, ''),
        description: "".concat(technicalSpecificities[key], " ").concat(Object(lodash["get"])(technicalSpecificities, 'unit', 'm'))
      };
    });
    var items = [].concat(basicInformation, Object(toConsumableArray["a" /* default */])(mapTechnicalSpecificities), Object(toConsumableArray["a" /* default */])(mapSpecificInformation)).filter(function (item) {
      return item && item.description;
    });
    return {
      id: id,
      description: description,
      items: items,
      title: label,
      quantity: quantity
    };
  });
}

function mapGeneralInformation(activityId, props, activities) {
  var activity = activities.find(function (_ref6) {
    var id = _ref6.id;
    return id === activityId;
  });
  if (!activity) return [];
  var bookingLabel = props.bookingLabel,
      termsAndConditionsLabel = props.termsAndConditionsLabel,
      supervisionLabel = props.supervisionLabel,
      equipmentRentalLabel = props.equipmentRentalLabel;
  var bookingDescription = activity.bookingDescription,
      termsAndConditionsDescription = activity.termsAndConditionsDescription,
      supervisionDescription = activity.supervisionDescription,
      equipmentRentalDescription = activity.equipmentRentalDescription;
  return [{
    label: bookingLabel,
    description: bookingDescription || ''
  }, {
    label: termsAndConditionsLabel,
    description: termsAndConditionsDescription || ''
  }, {
    label: supervisionLabel,
    description: supervisionDescription || ''
  }, {
    label: equipmentRentalLabel,
    description: equipmentRentalDescription || ''
  }].filter(function (info) {
    return info.description && info.description.trim();
  });
}

function mapChildcareInformation(_ref7) {
  var _childcare$openingHou, _childcare$closingWee;

  var opening = _ref7.opening,
      philosophy = _ref7.philosophy;
  var childcare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (Object(lodash["isEmpty"])(childcare)) return {};
  var items = [{
    label: philosophy,
    description: childcare.philosophy
  }].filter(function (item) {
    return Object(lodash["has"])(item, 'description') || Object(lodash["has"])(item, 'note');
  });
  var openingHoursLabel = (childcare === null || childcare === void 0 ? void 0 : (_childcare$openingHou = childcare.openingHours) === null || _childcare$openingHou === void 0 ? void 0 : _childcare$openingHou.length) ? mapOpeningHours(childcare.openingHours) : null;
  var closingDaysLabel = (childcare === null || childcare === void 0 ? void 0 : (_childcare$closingWee = childcare.closingWeekdays) === null || _childcare$closingWee === void 0 ? void 0 : _childcare$closingWee.length) ? mapClosingDays(childcare.closingWeekdays) : null;
  var description = openingHoursLabel ? "".concat(openingHoursLabel) : '';

  if (closingDaysLabel) {
    description += description.length ? " ".concat(closingDaysLabel) : closingDaysLabel;
  }

  return {
    duration: {
      label: opening,
      description: description
    },
    items: items,
    note: childcare.furtherInformation
  };
}

function mapActivityData(_ref8) {
  var _productFeaturesLineD;

  var _ref8$activityDetail = _ref8.activityDetail,
      _ref8$activityDetail$ = _ref8$activityDetail.childcare,
      childcare = _ref8$activityDetail$ === void 0 ? {} : _ref8$activityDetail$,
      _ref8$activityDetail$2 = _ref8$activityDetail.facilities,
      facilities = _ref8$activityDetail$2 === void 0 ? [] : _ref8$activityDetail$2,
      _ref8$activityDetail$3 = _ref8$activityDetail.includedServices,
      includedServices = _ref8$activityDetail$3 === void 0 ? [] : _ref8$activityDetail$3,
      _ref8$activityDetail$4 = _ref8$activityDetail.onDemandServices,
      onDemandServices = _ref8$activityDetail$4 === void 0 ? [] : _ref8$activityDetail$4,
      _ref8$activityDetail$5 = _ref8$activityDetail.resort,
      resort = _ref8$activityDetail$5 === void 0 ? {} : _ref8$activityDetail$5,
      _ref8$activityId = _ref8.activityId,
      activityId = _ref8$activityId === void 0 ? '' : _ref8$activityId,
      _ref8$color = _ref8.color,
      color = _ref8$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref8$color,
      description = _ref8.description,
      _ref8$icon = _ref8.icon,
      icon = _ref8$icon === void 0 ? icons["a" /* ICONS */].TRIDENT1 : _ref8$icon,
      image = _ref8.image,
      isIncluded = _ref8.isIncluded,
      title = _ref8.title,
      notIncludedMessage = _ref8.notIncludedMessage,
      productFeaturesLineData = _ref8.productFeaturesLineData,
      activities = _ref8.activities,
      philosophy = _ref8.philosophy,
      brandLogoUrl = _ref8.brandLogoUrl,
      bookletUrl = _ref8.bookletUrl;
  var isFacilityActivity = ['services_and_facilities_0_2', 'services_and_facilities_2_3', 'services_and_facilities_4_10'].some(function (id) {
    return activityId.includes(id);
  });
  var config = productFeaturesLineData.config,
      facilitiesTitle = productFeaturesLineData.facilitiesTitle,
      generalInformationTitle = productFeaturesLineData.generalInformationTitle,
      includedTitle = productFeaturesLineData.includedTitle,
      onDemandTitle = productFeaturesLineData.onDemandTitle,
      outsideFacilitiesTitle = productFeaturesLineData.outsideFacilitiesTitle,
      resortFacilitiesTitle = productFeaturesLineData.resortFacilitiesTitle;
  return productFeatures_utils_objectSpread(productFeatures_utils_objectSpread({}, description ? {
    description: description
  } : null), {}, {
    diamond: {
      colorBg: color,
      colorBorder: color,
      iconName: icon
    },
    downloadLinksList: [{
      iconName: icons["a" /* ICONS */].DOWNLOAD,
      label: config.common.downloadLeafletLabel,
      // $FlowFixMe
      url: bookletUrl
    }].filter(function (i) {
      return i.url;
    }),
    equipmentsTitle: Object(lodash["get"])(config, 'common.allInclusive', ''),
    equipments: isFacilityActivity ? [].concat(Object(toConsumableArray["a" /* default */])(resort.facilities || []), Object(toConsumableArray["a" /* default */])(resort.productActivities || [])).map(function (e) {
      return {
        items: e.equipments.map(function (i) {
          return {
            iconName: icons["a" /* ICONS */][i.id],
            label: i.label
          };
        }),
        title: e.subtitle || e.label
      };
    }) : null,
    immersive: {
      url: image
    },
    brandInformation: Object(lodash["isEmpty"])(childcare) ? {
      title: config.common.philosophyLabel,
      description: philosophy,
      imageSrc: brandLogoUrl
    } : null,
    mainInformationTitle: Object(lodash["get"])(childcare, 'label', ''),
    // $FlowFixMe
    mainInformation: mapChildcareInformation(productFeaturesLineData, childcare),
    isIncluded: isIncluded,
    notIncludedMessage: notIncludedMessage || '',
    includedMessage: '',
    // $FlowFixMe
    includedServices: mapServices(includedServices, productFeaturesLineData),
    includedTitle: includedTitle,
    // $FlowFixMe
    onDemandServices: mapServices(onDemandServices, productFeaturesLineData),
    onDemandTitle: onDemandTitle,
    // $FlowFixMe
    insideFacilities: mapFacilities(facilities, productFeaturesLineData, true),
    // $FlowFixMe
    outsideFacilities: mapFacilities(facilities, productFeaturesLineData, false),
    facilitiesTitle: facilitiesTitle,
    insideFacilitiesTitle: resortFacilitiesTitle,
    outsideFacilitiesTitle: outsideFacilitiesTitle,
    targetPrice: productFeatures_utils_objectSpread(productFeatures_utils_objectSpread({}, Object(lodash["get"])(childcare, 'targetPrice', {})), {}, {
      label: (productFeaturesLineData === null || productFeaturesLineData === void 0 ? void 0 : (_productFeaturesLineD = productFeaturesLineData.config.common.price) === null || _productFeaturesLineD === void 0 ? void 0 : _productFeaturesLineD.priceFrom) || ''
    }),
    generalInformation: mapGeneralInformation(activityId, productFeaturesLineData, activities),
    generalInformationTitle: generalInformationTitle,
    generalInformationExtraCost: productFeaturesLineData.config.common.extraCost,
    title: title,
    titleColor: color
  });
}

function resolveActivityServices(_ref9) {
  var activityId = _ref9.activityId,
      color = _ref9.color,
      description = _ref9.description,
      hasBanner = _ref9.hasBanner,
      icon = _ref9.icon,
      image = _ref9.image,
      isIncluded = _ref9.isIncluded,
      title = _ref9.title,
      notIncludedMessage = _ref9.notIncludedMessage,
      productFeaturesLineData = _ref9.productFeaturesLineData,
      activities = _ref9.activities,
      philosophy = _ref9.philosophy,
      brandLogoUrl = _ref9.brandLogoUrl,
      bookletUrl = _ref9.bookletUrl;
  return function (_ref10) {
    var productActivities = _ref10.productActivities;
    return mapActivityData({
      activityId: activityId,
      color: color,
      description: description,
      hasBanner: hasBanner,
      icon: icon,
      image: image,
      isIncluded: isIncluded,
      title: title,
      activityDetail: productActivities,
      notIncludedMessage: notIncludedMessage,
      productFeaturesLineData: productFeaturesLineData,
      activities: activities,
      philosophy: philosophy,
      brandLogoUrl: brandLogoUrl,
      bookletUrl: bookletUrl
    });
  };
}

function getActivityKeyword() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyword = keywords.find(function (k) {
    return featuresIcons.hasOwnProperty(k);
  });
  return keyword ? featuresIcons[keyword] : {
    icon: icons["a" /* ICONS */].TRIDENT1,
    color: undefined
  };
}

function mapActivitiesPerCategory(_ref11) {
  var _ref11$activities = _ref11.activities,
      activities = _ref11$activities === void 0 ? [] : _ref11$activities,
      _ref11$categoryId = _ref11.categoryId,
      categoryId = _ref11$categoryId === void 0 ? '' : _ref11$categoryId,
      fetchActivityServices = _ref11.fetchActivityServices,
      _ref11$hasBanner = _ref11.hasBanner,
      hasBanner = _ref11$hasBanner === void 0 ? false : _ref11$hasBanner,
      notIncludedMessage = _ref11.notIncludedMessage,
      productFeaturesLineData = _ref11.productFeaturesLineData,
      labelGAPrefix = _ref11.labelGAPrefix;
  var config = productFeaturesLineData.config,
      includedTitle = productFeaturesLineData.includedTitle,
      onDemandTitle = productFeaturesLineData.onDemandTitle,
      resortId = productFeaturesLineData.resortId,
      seeMore = productFeaturesLineData.seeMore;
  return activities.sort(sortActivities).map(function (_ref12) {
    var activityId = _ref12.id,
        isChildrenClub = _ref12.isChildrenClub,
        isIncluded = _ref12.isIncluded,
        label = _ref12.label,
        name = _ref12.name,
        description = _ref12.description,
        keywords = _ref12.keywords,
        image = _ref12.image,
        numberOfIncludedActivities = _ref12.numberOfIncludedActivities,
        numberOfOnDemandActivities = _ref12.numberOfOnDemandActivities,
        philosophy = _ref12.philosophy,
        brandLogoUrl = _ref12.brandLogoUrl,
        bookletUrl = _ref12.bookletUrl;

    if (!image) {
      image = 'invalid';
    }

    if (!activityId || !name || !label) {
      return null;
    }

    var _getActivityKeyword = getActivityKeyword(keywords || []),
        icon = _getActivityKeyword.icon,
        color = _getActivityKeyword.color;

    var hasOnDemandBanner = hasBanner && !isIncluded;
    var hasIncludedBanner = hasBanner && isChildrenClub && isIncluded; // $FlowFixMe

    return productFeatures_utils_objectSpread(productFeatures_utils_objectSpread({}, hasOnDemandBanner || hasIncludedBanner ? {
      banner: {
        color: isIncluded ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].AMBER,
        iconName: isIncluded ? icons["a" /* ICONS */].ALL_INCLUSIVE : icons["a" /* ICONS */].ON_DEMAND,
        label: isIncluded ? config.common.included : config.common.childcarealacarte
      }
    } : {}), {}, {
      counters: [{
        color: colors["a" /* COLORS */].BLUE,
        count: numberOfIncludedActivities || 0,
        icon: icons["a" /* ICONS */].ALL_INCLUSIVE,
        label: includedTitle
      }, {
        color: colors["a" /* COLORS */].AMBER,
        count: numberOfOnDemandActivities || 0,
        icon: icons["a" /* ICONS */].ON_DEMAND,
        label: onDemandTitle
      }],
      fetchDetail: function fetchDetail() {
        return fetchActivityServices && fetchActivityServices({
          productId: resortId,
          activityId: activityId
        }).then(resolveActivityServices({
          activityId: activityId,
          color: color,
          description: description,
          hasBanner: hasBanner,
          icon: icon,
          image: image,
          isIncluded: isIncluded,
          notIncludedMessage: notIncludedMessage,
          philosophy: philosophy,
          brandLogoUrl: brandLogoUrl,
          title: label,
          productFeaturesLineData: productFeaturesLineData,
          activities: activities,
          bookletUrl: bookletUrl
        }));
      },
      imageSrc: image,
      trackingData: {
        actionGA: 'blockInfos',
        labelGA: "".concat(labelGAPrefix, "_").concat(categoryId, "_").concat(name)
      },
      seeMoreLabel: seeMore,
      title: label,
      titleColor: color ? color : colors["a" /* COLORS */].GRAY_DARKER
    });
  }).filter(Boolean);
}
function mapCategories(_ref13) {
  var fetchActivityServices = _ref13.fetchActivityServices,
      hasBanner = _ref13.hasBanner,
      labelGAPrefix = _ref13.labelGAPrefix,
      notIncludedMessage = _ref13.notIncludedMessage,
      productActivitiesCategories = _ref13.productActivitiesCategories,
      productFeaturesLineData = _ref13.productFeaturesLineData;
  return productActivitiesCategories.sort(sortActivities).map(function () {
    var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref14.id,
        activities = _ref14.activities,
        label = _ref14.label;

    if (!id || !label) {
      return null;
    }

    var activitiesItems = mapActivitiesPerCategory({
      activities: activities,
      categoryId: id,
      fetchActivityServices: fetchActivityServices,
      hasBanner: hasBanner,
      labelGAPrefix: labelGAPrefix,
      notIncludedMessage: notIncludedMessage,
      productActivitiesCategories: productActivitiesCategories,
      productFeaturesLineData: productFeaturesLineData
    });
    return {
      backNavigationLabel: productFeaturesLineData.config.common.backNavigation,
      errorMessage: productFeaturesLineData.noDetailsErrorMessage,
      id: id,
      title: label,
      activities: activitiesItems
    };
  }).filter(Boolean);
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-utils/productFeatures.queries.js
var productFeatures_queries = __webpack_require__("H0gB");

// EXTERNAL MODULE: ./src/utils/tracking/resort.js
var tracking_resort = __webpack_require__("zCbR");

// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-card/ProductFeatureCard.jsx

var ProductFeatureCard_jsx = react_default.a.createElement;










var ProductFeatureCard_ProductFeatureCard = function ProductFeatureCard(_ref) {
  var _ref$banner = _ref.banner,
      banner = _ref$banner === void 0 ? {} : _ref$banner,
      className = _ref.className,
      _ref$counters = _ref.counters,
      counters = _ref$counters === void 0 ? [] : _ref$counters,
      imageSrc = _ref.imageSrc,
      isHidden = _ref.isHidden,
      link = _ref.link,
      seeMoreLabel = _ref.seeMoreLabel,
      title = _ref.title,
      titleColor = _ref.titleColor,
      trackingData = _ref.trackingData,
      width = _ref.width;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var media = [{
    src: imageSrc
  }];
  var tagName = markup_getLinkTagName(link);
  var linkProps = getLinkProps(link);
  return ProductFeatureCard_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, linkProps, {
    "aria-hidden": isHidden,
    as: tagName,
    className: classnames_default()(className, 'reset-button block relative text-initial w-full'),
    onMouseEnter: isDesktop ? function () {
      return setHovering(true);
    } : null,
    onMouseLeave: isDesktop ? function () {
      return setHovering(false);
    } : null,
    style: {
      width: width
    },
    tabIndex: isHidden ? -1 : 0,
    trackingData: trackingData
  }), !!banner.label && ProductFeatureCard_jsx("div", {
    className: classnames_default()("bg-".concat(banner.color || colors["a" /* COLORS */].BLUE, " absolute flex font-brand items-center justify-center p-3 round-t-tiny text-base sm:text-sm lg:text-base text-center text-white w-full z-1 transition-transform"), {
      'scale-095': isHovering
    })
  }, ProductFeatureCard_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-2",
    name: banner.iconName,
    width: "0.625rem"
  }), banner.label), ProductFeatureCard_jsx(TeaserCard_TeaserCard, {
    isActive: isHovering,
    media: media
  }, ProductFeatureCard_jsx(Title["a" /* Title */], {
    className: "my-4",
    color: titleColor,
    hasEllipsis: true,
    theme: "title-sans-3"
  }, title), !Object(lodash["isEmpty"])(counters) && ProductFeatureCard_jsx("ul", {
    className: "reset-list my-4",
    style: {
      height: '2.5rem'
    }
  }, counters.map(function (_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref2$color,
        icon = _ref2.icon,
        label = _ref2.label,
        count = _ref2.count;
    return count ? ProductFeatureCard_jsx("li", {
      className: "flex font-brand justify-between my-1 overflow-hidden text-base text-".concat(color),
      key: label
    }, !!label && !!count && ProductFeatureCard_jsx(react["Fragment"], null, ProductFeatureCard_jsx("span", {
      className: "inline-flex items-center max-w-4/5"
    }, ProductFeatureCard_jsx(Icon["a" /* Icon */], {
      className: "flex-shrink-0 rtl:mr-2",
      name: icon,
      width: "1em"
    }), ProductFeatureCard_jsx("span", {
      className: "truncate"
    }, label)), count)) : null;
  })), !!seeMoreLabel && ProductFeatureCard_jsx("p", {
    className: "reset-paragraph my-4 text-center text-sm underline"
  }, seeMoreLabel)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-features-slider/ProductFeaturesSlider.jsx


var ProductFeaturesSlider_jsx = react_default.a.createElement;



var ProductFeaturesSlider_ProductFeaturesSlider = function ProductFeaturesSlider(_ref) {
  var items = _ref.items,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["items"]);

  return ProductFeaturesSlider_jsx(ProductInformationSliderContainer, rest, items.map(function (item) {
    return ProductFeaturesSlider_jsx(ProductFeatureCard_ProductFeatureCard, Object(esm_extends["a" /* default */])({
      key: item.title
    }, item));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-information/ProductInformation.jsx

var ProductInformation_jsx = react_default.a.createElement;




var ProductInformation_ProductInformation = function ProductInformation(_ref) {
  var introduction = _ref.introduction,
      items = _ref.items,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel;
  return ProductInformation_jsx(react["Fragment"], null, !Object(lodash["isEmpty"])(introduction) && ProductInformation_jsx(Introduction["a" /* Introduction */], Object(esm_extends["a" /* default */])({
    className: "mb-4"
  }, introduction, {
    isTextSeeMoreCollapseEnabled: true
  })), ProductInformation_jsx(Tabs["a" /* Tabs */], {
    isContentUnmountedOnCollapse: true,
    isScrollable: true,
    items: items,
    scrollBackwardLabel: scrollBackwardLabel,
    scrollForwardLabel: scrollForwardLabel,
    theme: "lite"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-features/ProductFeatures.jsx
var ProductFeatures_jsx = react_default.a.createElement;




var ProductFeatures_getItems = function getItems(_ref) {
  var categories = _ref.categories,
      labelGAPrefix = _ref.labelGAPrefix,
      queryLayer = _ref.queryLayer,
      renderDetail = _ref.renderDetail,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel;
  return (categories || []).map(function (category, index) {
    return {
      header: {
        title: category.title,
        trackingData: {
          categoryGA: 'resort',
          actionGA: 'blockInfos',
          labelGA: "".concat(labelGAPrefix, "_").concat(category.id)
        }
      },
      content: [ProductFeatures_jsx(ProductFeaturesSlider_ProductFeaturesSlider, {
        backNavigationLabel: category.backNavigationLabel,
        errorMessage: category.errorMessage,
        items: category.activities,
        key: category.id,
        queryLayer: queryLayer,
        renderDetail: renderDetail,
        scrollBackwardLabel: scrollBackwardLabel,
        scrollForwardLabel: scrollForwardLabel,
        sliderIndex: index
      })]
    };
  });
};

var ProductFeatures_ProductFeatures = function ProductFeatures(_ref2) {
  var categories = _ref2.categories,
      introduction = _ref2.introduction,
      labelGAPrefix = _ref2.labelGAPrefix,
      _ref2$queryLayer = _ref2.queryLayer,
      queryLayer = _ref2$queryLayer === void 0 ? 'productActivitiesLayer' : _ref2$queryLayer,
      renderDetail = _ref2.renderDetail,
      scrollBackwardLabel = _ref2.scrollBackwardLabel,
      scrollForwardLabel = _ref2.scrollForwardLabel;
  return ProductFeatures_jsx(ProductInformation_ProductInformation, {
    introduction: introduction,
    items: ProductFeatures_getItems({
      categories: categories,
      labelGAPrefix: labelGAPrefix,
      queryLayer: queryLayer,
      renderDetail: renderDetail,
      scrollBackwardLabel: scrollBackwardLabel,
      scrollForwardLabel: scrollForwardLabel
    }),
    scrollBackwardLabel: scrollBackwardLabel,
    scrollForwardLabel: scrollForwardLabel
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-brand-information/ProductFeatureDetailBrandInformation.jsx
var ProductFeatureDetailBrandInformation_jsx = react_default.a.createElement;





function ProductFeatureDetailBrandInformation(_ref) {
  var className = _ref.className,
      description = _ref.description,
      imageSrc = _ref.imageSrc,
      title = _ref.title;

  if (!description) {
    return null;
  }

  var hasImage = !!imageSrc;

  var desc = ProductFeatureDetailBrandInformation_jsx(Text["a" /* Text */], {
    text: description
  });

  return ProductFeatureDetailBrandInformation_jsx("section", {
    className: className
  }, ProductFeatureDetailBrandInformation_jsx(Title["a" /* Title */], {
    className: "mb-8",
    hLevel: 3,
    theme: "title-brand-6"
  }, title), hasImage ? ProductFeatureDetailBrandInformation_jsx("div", {
    className: "flex flex-col sm:flex-row -mx-5"
  }, ProductFeatureDetailBrandInformation_jsx("div", {
    className: "flex-none px-5 sm:w-1/2"
  }, desc), ProductFeatureDetailBrandInformation_jsx("div", {
    className: "flex-none px-5 mt-5 sm:mt-0 sm:w-1/2"
  }, ProductFeatureDetailBrandInformation_jsx(Image["a" /* default */], {
    imageUrl: imageSrc,
    ratioKey: ratios_utils["a" /* default */].XL
  }))) : desc);
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-facilities/ProductFeatureDetailFacility.jsx
var ProductFeatureDetailFacility_jsx = react_default.a.createElement;





function ProductFeatureDetailFacility(props) {
  var className = props.className,
      id = props.id,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      description = props.description,
      quantity = props.quantity,
      title = props.title;

  if (!title) {
    return null;
  }

  return ProductFeatureDetailFacility_jsx("article", {
    className: className,
    id: id
  }, ProductFeatureDetailFacility_jsx(Title["a" /* Title */], {
    className: "mb-0",
    hLevel: 5,
    theme: "title-sans-1"
  }, title, !!quantity && ": ".concat(quantity)), ProductFeatureDetailFacility_jsx(Text["a" /* Text */], {
    className: "m-0",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    text: description,
    theme: "text-sans-2"
  }), !Object(lodash["isEmpty"])(items) && ProductFeatureDetailFacility_jsx("ul", {
    className: "font-sans list-none p-0 mt-2 text-gray-darker text-sm"
  }, items.map(function (item) {
    return !!item.description && ProductFeatureDetailFacility_jsx("li", {
      className: "list-disc",
      key: item.description
    }, item.label && ProductFeatureDetailFacility_jsx("span", {
      className: "font-bold"
    }, item.label, ": "), item.description);
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-facilities/ProductFeatureDetailFacilities.jsx
var ProductFeatureDetailFacilities_jsx = react_default.a.createElement;





function ProductFeatureDetailFacilities(props) {
  var className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].BLUE : _props$color,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title;

  if (!items.length) {
    return null;
  }

  return ProductFeatureDetailFacilities_jsx("section", {
    className: className
  }, ProductFeatureDetailFacilities_jsx(Title["a" /* Title */], {
    color: color,
    hLevel: 4,
    theme: "title-brand-3"
  }, title), ProductFeatureDetailFacilities_jsx("ul", {
    className: "sm:colum-count-2 list-none p-0 my-3"
  }, items.map(function (item, idx) {
    return !Object(lodash["isEmpty"])(item) && ProductFeatureDetailFacilities_jsx("li", {
      className: "break-inside-avoid-column my-3".concat(idx === 0 ? ' mt-0' : ''),
      key: item.id
    }, ProductFeatureDetailFacilities_jsx(ProductFeatureDetailFacility, item));
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-informations/ProductFeatureDetailInformation.jsx
var ProductFeatureDetailInformation_jsx = react_default.a.createElement;



function ProductFeatureDetailInformation(props) {
  var className = props.className,
      description = props.description,
      label = props.label;

  if (!description) {
    return null;
  }

  return ProductFeatureDetailInformation_jsx("article", {
    className: className
  }, !!label && ProductFeatureDetailInformation_jsx("div", {
    className: "font-sans font-bold text-gray-darker text-sm"
  }, label, ": "), ProductFeatureDetailInformation_jsx(Text["a" /* Text */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    text: description,
    theme: "text-sans-2"
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-informations/ProductFeatureDetailInformations.jsx
var ProductFeatureDetailInformations_jsx = react_default.a.createElement;





function ProductFeatureDetailInformations(props) {
  var className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _props$color,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      notes = props.notes,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title;

  if (!items.length) {
    return null;
  }

  return ProductFeatureDetailInformations_jsx("section", {
    className: className
  }, ProductFeatureDetailInformations_jsx(Title["a" /* Title */], {
    className: "mb-5",
    color: color,
    hLevel: 3,
    theme: "title-brand-4"
  }, title), ProductFeatureDetailInformations_jsx("ul", {
    className: "sm:colum-count-2 list-none p-0 m-0"
  }, items.map(function (item, idx) {
    return item && item.description ? ProductFeatureDetailInformations_jsx("li", {
      className: "break-inside-avoid-column list-disc my-3".concat(idx === 0 ? ' mt-0' : ''),
      key: item.description
    }, ProductFeatureDetailInformations_jsx(ProductFeatureDetailInformation, item)) : null;
  })), !!notes && ProductFeatureDetailInformations_jsx(Text["a" /* Text */], {
    className: "mt-3",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    text: notes,
    theme: "text-sans-2"
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-main-information/ProductFeatureDetailMainInformation.jsx
var ProductFeatureDetailMainInformation_jsx = react_default.a.createElement;




function ProductFeatureDetailMainInformation(props) {
  var className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _props$color,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? {} : _props$duration,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      note = props.note,
      smallTitle = props.smallTitle,
      title = props.title;

  if (!duration.description && !items.length) {
    return null;
  }

  return ProductFeatureDetailMainInformation_jsx("section", {
    className: className
  }, ProductFeatureDetailMainInformation_jsx(Title["a" /* Title */], {
    className: "mb-5 sm:mb-4",
    color: color,
    hLevel: 3,
    theme: "title-brand-5"
  }, smallTitle ? ProductFeatureDetailMainInformation_jsx("span", {
    className: "flex flex-col sm:flex-row sm:justify-between w-full"
  }, title, " ", smallTitle) : title), ProductFeatureDetailMainInformation_jsx("div", {
    className: "rtl:pr-2 w-full sm:w-1/2"
  }, !!duration.description && ProductFeatureDetailMainInformation_jsx("div", {
    className: "text-1 mt-3 mb-3"
  }, !!duration.label && ProductFeatureDetailMainInformation_jsx("span", {
    className: "font-bold"
  }, "".concat(duration.label, ": ")), duration.description), !!items.length && ProductFeatureDetailMainInformation_jsx("ul", {
    className: "list-none p-0 leading-normal text-base text-gray-darker"
  }, items.map(function (item) {
    return (item.description || item.note) && ProductFeatureDetailMainInformation_jsx("li", {
      className: "my-1 py-2 list-disc",
      key: item.label
    }, !!item.label && ProductFeatureDetailMainInformation_jsx("div", {
      className: "font-bold"
    }, item.label), !!item.description && ProductFeatureDetailMainInformation_jsx(Text["a" /* Text */], {
      className: "inline-block mb-1",
      text: item.description
    }), !!item.note && ProductFeatureDetailMainInformation_jsx("small", {
      className: "block"
    }, item.note));
  })), !!note && ProductFeatureDetailMainInformation_jsx("div", {
    className: "italic mt-4 text-sm"
  }, note)));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.jsx + 1 modules
var CapsuleCollapseLists = __webpack_require__("d4In");

// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-services/ProductFeatureDetailServiceItem.jsx
var ProductFeatureDetailServiceItem_jsx = react_default.a.createElement;



function ProductFeatureDetailServiceItem(props) {
  var className = props.className,
      description = props.description,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      label = props.label,
      note = props.note,
      _props$tag = props.tag,
      tag = _props$tag === void 0 ? {} : _props$tag;
  return ProductFeatureDetailServiceItem_jsx("li", {
    className: className
  }, !!label && ProductFeatureDetailServiceItem_jsx("div", {
    className: "font-bold"
  }, label), !!description && ProductFeatureDetailServiceItem_jsx(Text["a" /* Text */], {
    className: "inline-block mb-1",
    text: description
  }), !!(tag === null || tag === void 0 ? void 0 : tag.label) && ProductFeatureDetailServiceItem_jsx("span", {
    className: "font-bold text-".concat(tag.color || colors["a" /* COLORS */].GRAY_DARKER, " mb-1")
  }, " ".concat(tag.label)), !!note && ProductFeatureDetailServiceItem_jsx("small", {
    className: "block"
  }, note), !!items.length && ProductFeatureDetailServiceItem_jsx("ul", {
    className: "list-none p-0 leading-normal text-base text-gray-darker"
  }, items.map(function (item, i) {
    return ProductFeatureDetailServiceItem_jsx(ProductFeatureDetailServiceItem, {
      className: "list-hyphen",
      description: item.description,
      index: i,
      items: item.items,
      key: item.description,
      label: item.label,
      note: item.note,
      tag: item.tag
    });
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-services/ProductFeatureDetailService.jsx
var ProductFeatureDetailService_jsx = react_default.a.createElement;









var ProductFeatureDetailService_ProductFeatureDetailService = function ProductFeatureDetailService(props) {
  var _props$badges = props.badges,
      badges = _props$badges === void 0 ? [] : _props$badges,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _props$color,
      duration = props.duration,
      id = props.id,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      level = props.level,
      note = props.note,
      _props$targetPrice = props.targetPrice,
      targetPrice = _props$targetPrice === void 0 ? {} : _props$targetPrice,
      title = props.title;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  if (!title) {
    return null;
  }

  var instalmentValue = Object(src_i18n["c" /* getKeyValue */])('common.price.instalmentValue');
  return ProductFeatureDetailService_jsx("article", {
    className: className,
    "data-id": id
  }, ProductFeatureDetailService_jsx(Title["a" /* Title */], {
    className: "sm:text-lg justify-between items-baseline",
    color: color,
    hLevel: 2,
    theme: "title-sans-3"
  }, title), ProductFeatureDetailService_jsx(Title["a" /* Title */], {
    className: "sm:text-md",
    hLevel: 3,
    theme: "title-sans-1"
  }, level), (targetPrice === null || targetPrice === void 0 ? void 0 : targetPrice.price) && ProductFeatureDetailService_jsx(TemplateString["a" /* TemplateString */], {
    className: "block text-base py-2",
    template: targetPrice.label,
    values: {
      currency: targetPrice.currency ? Object(price_util["a" /* getCurrencySymbol */])(locale, targetPrice.currency) : '',
      price: Object(src_i18n["c" /* getKeyValue */])('common.price.displayInstalmentsPrice') ? Object(src_i18n["f" /* t */])('common.price.instalmentPrice', {
        instalmentValue: instalmentValue,
        dividedPrice: Math.trunc(targetPrice.price / instalmentValue)
      }) : Math.trunc(targetPrice.price) || ''
    },
    valuesClassName: {
      currency: "text-xl text-".concat(color, " font-bold"),
      price: "text-xl text-".concat(color, " font-bold")
    }
  }), (duration === null || duration === void 0 ? void 0 : duration.description) && ProductFeatureDetailService_jsx("div", {
    className: "text-1 my-3"
  }, duration.label ? ProductFeatureDetailService_jsx("span", {
    className: "font-bold"
  }, "".concat(duration.label, ": ")) : null, duration.description), badges.map(function (_ref) {
    var iconName = _ref.iconName,
        label = _ref.label;
    return ProductFeatureDetailService_jsx("div", {
      className: "flex items-center my-3",
      key: iconName
    }, ProductFeatureDetailService_jsx(Badge["a" /* Badge */], {
      className: "rtl:mr-2",
      color: colors["a" /* COLORS */].WHITE,
      colorBg: colors["a" /* COLORS */].BLUE,
      colorBorder: colors["a" /* COLORS */].BLUE,
      iconName: iconName,
      iconSize: "2.375rem",
      size: 50,
      variant: "pill"
    }), ProductFeatureDetailService_jsx("span", {
      className: "font-brand text-blue text-md"
    }, label));
  }), !!items.length && ProductFeatureDetailService_jsx("ul", {
    className: "list-none p-0 leading-normal text-base text-gray-darker"
  }, items.map(function (item) {
    return ProductFeatureDetailService_jsx(ProductFeatureDetailServiceItem, {
      className: "my-1 py-2 list-disc",
      description: item.description,
      items: item.items,
      key: item.description,
      label: item.label,
      note: item.note,
      tag: item.tag
    });
  })), !!note && ProductFeatureDetailService_jsx("div", {
    className: "italic mt-4 text-sm"
  }, note));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-services/ProductFeatureDetailServices.jsx
var ProductFeatureDetailServices_jsx = react_default.a.createElement;







function ProductFeatureDetailServices(props) {
  var className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _props$color,
      _props$equipmentsTitl = props.equipmentsTitle,
      equipmentsTitle = _props$equipmentsTitl === void 0 ? '' : _props$equipmentsTitl,
      _props$equipments = props.equipments,
      equipments = _props$equipments === void 0 ? [] : _props$equipments,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      titleIcon = props.titleIcon;

  if (!items.length) {
    return null;
  }

  var hasEquipements = !!(equipments === null || equipments === void 0 ? void 0 : equipments.length);
  return ProductFeatureDetailServices_jsx("section", {
    className: className
  }, ProductFeatureDetailServices_jsx(Title["a" /* Title */], {
    className: "mb-5 sm:mb-4",
    color: color,
    hLevel: 3,
    iconName: titleIcon,
    theme: "title-brand-5"
  }, title), ProductFeatureDetailServices_jsx("div", {
    className: classnames_default()({
      'sm:flex -m-2': hasEquipements
    })
  }, ProductFeatureDetailServices_jsx("div", {
    className: hasEquipements ? 'sm:w-1/2' : 'sm:flex flex-wrap -m-2'
  }, items.map(function (item) {
    return !!(item === null || item === void 0 ? void 0 : item.title) && ProductFeatureDetailServices_jsx("div", {
      className: classnames_default()('p-2', {
        'sm:w-1/2': !hasEquipements
      }),
      key: item.id
    }, ProductFeatureDetailServices_jsx(ProductFeatureDetailService_ProductFeatureDetailService, {
      badges: item.badges,
      color: color,
      duration: item.duration,
      id: item.id,
      items: item.items,
      level: item.level,
      note: item.note,
      targetPrice: item.targetPrice,
      title: item.title
    }));
  })), hasEquipements && ProductFeatureDetailServices_jsx("div", {
    className: "sm:w-1/2 p-2"
  }, ProductFeatureDetailServices_jsx(CapsuleCollapseLists["a" /* CapsuleCollapseLists */], {
    header: {
      iconName: icons["a" /* ICONS */].ALL_INCLUSIVE,
      title: equipmentsTitle
    },
    lists: equipments,
    style: {
      maxWidth: 380
    }
  }))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/ProductFeatureDetail.jsx

var ProductFeatureDetail_jsx = react_default.a.createElement;



















function ProductFeatureDetail(_ref) {
  var brandInformation = _ref.brandInformation,
      description = _ref.description,
      diamond = _ref.diamond,
      _ref$downloadLinksLis = _ref.downloadLinksList,
      downloadLinksList = _ref$downloadLinksLis === void 0 ? [] : _ref$downloadLinksLis,
      _ref$facilitiesTitle = _ref.facilitiesTitle,
      facilitiesTitle = _ref$facilitiesTitle === void 0 ? '' : _ref$facilitiesTitle,
      mainInformationTitle = _ref.mainInformationTitle,
      mainInformation = _ref.mainInformation,
      equipments = _ref.equipments,
      equipmentsTitle = _ref.equipmentsTitle,
      generalInformationTitle = _ref.generalInformationTitle,
      _ref$generalInformati = _ref.generalInformation,
      generalInformation = _ref$generalInformati === void 0 ? [] : _ref$generalInformati,
      generalInformationExtraCost = _ref.generalInformationExtraCost,
      immersive = _ref.immersive,
      isIncluded = _ref.isIncluded,
      includedMessage = _ref.includedMessage,
      notIncludedMessage = _ref.notIncludedMessage,
      _ref$includedServices = _ref.includedServices,
      includedServices = _ref$includedServices === void 0 ? [] : _ref$includedServices,
      includedTitle = _ref.includedTitle,
      _ref$insideFacilities = _ref.insideFacilities,
      insideFacilities = _ref$insideFacilities === void 0 ? [] : _ref$insideFacilities,
      insideFacilitiesTitle = _ref.insideFacilitiesTitle,
      _ref$onDemandServices = _ref.onDemandServices,
      onDemandServices = _ref$onDemandServices === void 0 ? [] : _ref$onDemandServices,
      onDemandTitle = _ref.onDemandTitle,
      _ref$outsideFacilitie = _ref.outsideFacilities,
      outsideFacilities = _ref$outsideFacilitie === void 0 ? [] : _ref$outsideFacilitie,
      outsideFacilitiesTitle = _ref.outsideFacilitiesTitle,
      _ref$targetPrice = _ref.targetPrice,
      targetPrice = _ref$targetPrice === void 0 ? {} : _ref$targetPrice,
      title = _ref.title,
      _ref$titleColor = _ref.titleColor,
      titleColor = _ref$titleColor === void 0 ? colors["a" /* COLORS */].BLUE : _ref$titleColor;

  var _useContext = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext.locale;

  var footer = ProductFeatureDetail_jsx(ProductFeatureDetailInformations, {
    className: "my-3",
    items: generalInformation,
    notes: generalInformationExtraCost,
    title: generalInformationTitle
  });

  var message = isIncluded ? includedMessage : notIncludedMessage;
  var instalmentValue = Object(src_i18n["c" /* getKeyValue */])('common.price.instalmentValue');
  return ProductFeatureDetail_jsx(Sheet, {
    diamond: diamond,
    footer: footer,
    immersive: immersive
  }, !!title && ProductFeatureDetail_jsx(Title["a" /* Title */], {
    className: message ? 'mb-2' : 'mb-8',
    theme: "title-sans-8",
    color: titleColor
  }, title), !!message && ProductFeatureDetail_jsx("p", {
    className: classnames_default()('reset-paragraph flex items-center justify-center font-brand mb-8 text-center text-lg sm:text-3xl', {
      'text-blue': isIncluded,
      'text-amber': !isIncluded
    })
  }, ProductFeatureDetail_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-2",
    name: isIncluded ? icons["a" /* ICONS */].ALL_INCLUSIVE : icons["a" /* ICONS */].ON_DEMAND,
    width: "1em"
  }), message), ProductFeatureDetail_jsx(Text["a" /* Text */], {
    className: "mb-8",
    text: description
  }), ProductFeatureDetail_jsx(DownloadLinksList, {
    className: "mb-8",
    links: downloadLinksList,
    theme: "lite"
  }), ProductFeatureDetail_jsx(ProductFeatureDetailMainInformation, Object(esm_extends["a" /* default */])({
    className: "my-5",
    smallTitle: targetPrice.price ? ProductFeatureDetail_jsx(TemplateString["a" /* TemplateString */], {
      className: "text-base font-sans",
      template: targetPrice.label,
      values: {
        currency: Object(price_util["a" /* getCurrencySymbol */])(locale, targetPrice.currency),
        price: Object(src_i18n["c" /* getKeyValue */])('common.price.displayInstalmentsPrice') ? Object(src_i18n["f" /* t */])('common.price.instalmentPrice', {
          instalmentValue: instalmentValue,
          dividedPrice: Math.trunc(targetPrice.price / instalmentValue)
        }) : Math.trunc(targetPrice.price)
      },
      valuesClassName: {
        currency: 'text-amber text-xl font-bold',
        price: 'text-amber text-xl font-bold'
      }
    }) : null,
    title: mainInformationTitle
  }, mainInformation)), ProductFeatureDetail_jsx(ProductFeatureDetailBrandInformation, {
    className: "mt-5 mb-10 sm:mb-20",
    description: brandInformation === null || brandInformation === void 0 ? void 0 : brandInformation.description,
    imageSrc: brandInformation === null || brandInformation === void 0 ? void 0 : brandInformation.imageSrc,
    title: brandInformation === null || brandInformation === void 0 ? void 0 : brandInformation.title
  }), !!includedServices.length && ProductFeatureDetail_jsx(ProductFeatureDetailServices, {
    className: "my-5",
    color: colors["a" /* COLORS */].BLUE,
    equipments: equipments,
    equipmentsTitle: equipmentsTitle,
    items: includedServices,
    title: includedTitle,
    titleIcon: icons["a" /* ICONS */].ALL_INCLUSIVE
  }), !!onDemandServices.length && ProductFeatureDetail_jsx(ProductFeatureDetailServices, {
    className: "my-5",
    color: colors["a" /* COLORS */].AMBER,
    items: onDemandServices,
    title: onDemandTitle,
    titleIcon: icons["a" /* ICONS */].ON_DEMAND
  }), (!Object(lodash["isEmpty"])(insideFacilities) || !Object(lodash["isEmpty"])(outsideFacilities)) && ProductFeatureDetail_jsx("section", null, ProductFeatureDetail_jsx(Title["a" /* Title */], {
    className: "my-5",
    hLevel: 3,
    theme: "title-brand-6"
  }, facilitiesTitle), insideFacilities.length && ProductFeatureDetail_jsx(ProductFeatureDetailFacilities, {
    className: "my-5",
    items: insideFacilities,
    title: insideFacilitiesTitle
  }), outsideFacilities && ProductFeatureDetail_jsx(ProductFeatureDetailFacilities, {
    className: "my-5",
    items: outsideFacilities,
    title: outsideFacilitiesTitle
  })));
}
// CONCATENATED MODULE: ./src/client/components/lines/product-activities-line/ProductActivitiesLine.jsx

var ProductActivitiesLine_jsx = react_default.a.createElement;

function ProductActivitiesLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductActivitiesLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductActivitiesLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductActivitiesLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var ProductActivitiesLine_ProductActivitiesLine = function ProductActivitiesLine(props) {
  var _props$config$common = props.config.common,
      scrollBackward = _props$config$common.scrollBackward,
      scrollForward = _props$config$common.scrollForward,
      id = props.id,
      resort = props.resort;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  if (!resort) {
    return null;
  }

  var fetchActivityServices = function fetchActivityServices(_ref) {
    var productId = _ref.productId,
        activityId = _ref.activityId;
    var query = Object(productFeatures_queries["b" /* productActivityDetailQuery */])(productId, activityId, {
      lineProps: props,
      urlParams: location.urlParams
    });
    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["Md" /* WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES */]
    }).then(function (data) {
      Object(src_i18n["a" /* addTranslationKeys */])(data.config);
      return {
        productActivities: ProductActivitiesLine_objectSpread(ProductActivitiesLine_objectSpread({}, data.productActivities), {}, {
          includedServices: data.includedServices,
          onDemandServices: data.onDemandServices
        })
      };
    });
  };

  var productActivitiesCategories = resort.categories && resort.categories.leisure ? resort.categories.leisure.filter(function (_ref2) {
    var activities = _ref2.activities;
    return activities && activities.length !== 0;
  }) : [];
  var productCategories = mapCategories({
    fetchActivityServices: fetchActivityServices,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].ACTIVITIES,
    productActivitiesCategories: productActivitiesCategories,
    productFeaturesLineData: props
  });
  return ProductActivitiesLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductActivitiesLine_jsx(ProductFeatures_ProductFeatures, {
    categories: productCategories,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].ACTIVITIES,
    queryLayer: "productActivitiesLayer",
    renderDetail: function renderDetail(data) {
      return ProductActivitiesLine_jsx(ProductFeatureDetail, data);
    },
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-activities/productActivities.resolver.js
var productActivities_resolver = __webpack_require__("g3/4");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-activities/productActivities.descriptor.js



var productActivitiesDescriptor = {
  name: constants["I" /* PRODUCT_ACTIVITIES */],
  component: ProductActivitiesLine_ProductActivitiesLine,
  resolve: productActivities_resolver["a" /* productActivitiesResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-catering/ProductCatering.jsx
var ProductCatering_jsx = react_default.a.createElement;




var ProductCatering_ProductCatering = function ProductCatering(_ref) {
  var _ref$intros = _ref.intros,
      intros = _ref$intros === void 0 ? [] : _ref$intros,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel;
  var hasIntros = !!intros.length;
  var hasList = !!list.length;

  if (!hasIntros && !hasList) {
    return null;
  }

  return ProductCatering_jsx("div", {
    className: "pb-8"
  }, hasIntros && ProductCatering_jsx("div", {
    className: "flex"
  }, intros.map(function (_ref2) {
    var description = _ref2.description,
        _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title;
    return ProductCatering_jsx(Card["a" /* Card */], {
      className: "w-full md:w-1/2",
      key: title,
      heading: {
        title: title
      },
      text: {
        text: description
      }
    });
  })), hasIntros && hasList && ProductCatering_jsx("hr", {
    className: "block border-0 border-solid border-gray-light border-t-1 h-px my-5 mx-0 p-0"
  }), hasList && list.map(function (_ref3, index) {
    var description = _ref3.description,
        _ref3$image = _ref3.image,
        image = _ref3$image === void 0 ? '' : _ref3$image,
        _ref3$name = _ref3.name,
        name = _ref3$name === void 0 ? '' : _ref3$name;
    return (description || name) && ProductCatering_jsx(react["Fragment"], {
      key: name
    }, index > 0 && ProductCatering_jsx("hr", {
      className: "block border-0 border-solid border-gray-light border-t-1 h-px my-5 mx-0 p-0"
    }), ProductCatering_jsx(Card["a" /* Card */], {
      heading: {
        title: name
      },
      layout: Card_constants["d" /* INLINE_1 */],
      media: {
        url: image,
        ratioKey: ratios_utils["a" /* default */].M
      },
      seeLessLabel: seeLessLabel,
      seeMoreLabel: seeMoreLabel,
      text: {
        text: description
      }
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-bars/productBars.resolver.js
var productBars_resolver = __webpack_require__("9Ts2");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-bars/productBars.descriptor.js


var productBars_descriptor_jsx = react_default.a.createElement;

function productBars_descriptor_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function productBars_descriptor_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      productBars_descriptor_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      productBars_descriptor_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var productBars_descriptor_ProductBarsLine = function ProductBarsLine(_ref) {
  var bars = _ref.bars,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      priceInclude = _ref.priceInclude,
      title = _ref.title,
      withSupplement = _ref.withSupplement;
  var intros = bars.introduction ? [{
    title: priceInclude,
    description: bars.introduction.included
  }, {
    title: withSupplement,
    description: bars.introduction.withSupplement
  }] : [];
  var list = bars.barsList.map(function (bar) {
    var _bar$images = Object(slicedToArray["a" /* default */])(bar.images, 1),
        image = _bar$images[0];

    return productBars_descriptor_objectSpread(productBars_descriptor_objectSpread({}, bar), {}, {
      image: image
    });
  });
  return productBars_descriptor_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, productBars_descriptor_jsx(LineTitle["a" /* LineTitle */], null, title), productBars_descriptor_jsx(ProductCatering_ProductCatering, {
    intros: intros,
    list: list,
    seeLessLabel: config.common.loadLess,
    seeMoreLabel: config.common.viewMore
  }));
};

var productBarsDescriptor = {
  name: constants["db" /* RESORT_BARS */],
  component: productBars_descriptor_ProductBarsLine,
  resolve: productBars_resolver["a" /* productBarsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-booking-line/ProductBookingLine.utils.js


function ProductBookingLine_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function ProductBookingLine_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ProductBookingLine_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ProductBookingLine_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var NO_TRANSPORT_VALUE = 'NO';
var ProductBookingLine_utils_getBookingConfig = function getBookingConfig(props) {
  var checkPriceLabel = props.checkPriceLabel,
      config = props.config,
      enableTransfer = props.enableTransfer,
      minAgeErrorMessage = props.minAgeErrorMessage,
      minAgeInformation = props.minAgeInformation,
      bookingPackage = props["package"],
      resortId = props.resortId;
  return ProductBookingLine_utils_objectSpread(ProductBookingLine_utils_objectSpread({}, config), {}, {
    booking: Object(lodash["merge"])(config.booking, {
      checkPriceLabel: checkPriceLabel,
      departureCity: NO_TRANSPORT_VALUE,
      enableTransfer: enableTransfer,
      minAgeErrorMessage: minAgeErrorMessage,
      minAgeInformation: minAgeInformation,
      "package": bookingPackage,
      resortId: resortId
    })
  });
};
// CONCATENATED MODULE: ./src/client/components/lines/product-booking-line/ProductBookingLine.jsx

var ProductBookingLine_jsx = react["createElement"];

function ProductBookingLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductBookingLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductBookingLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductBookingLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ProductBookingLine_ProductBookingLine = function ProductBookingLine(props) {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  if (!props.resort) {
    return null;
  }

  var bookingConfig = ProductBookingLine_utils_getBookingConfig(props);
  return ProductBookingLine_jsx("div", {
    className: "Line Line-BookingEngine"
  }, ProductBookingLine_jsx("div", {
    className: "PriceTicket-sticky-beacon"
  }), ProductBookingLine_jsx(BookingEngineForm_container, {
    bookingConfig: bookingConfig.booking,
    bookingCriteria: props.bookingCriteria,
    checkPriceLabel: props.checkPriceLabel,
    config: bookingConfig,
    cmsPrice: bookingConfig.price,
    cmsStartingPrice: bookingConfig.resort.startingPrice,
    enableTransfer: props.enableTransfer,
    i18n: ProductBookingLine_objectSpread(ProductBookingLine_objectSpread({}, bookingConfig), {}, {
      package: props.package,
      checkPriceLabel: props.checkPriceLabel,
      errorMessageNoProposal: props.package.errorMessageNoProposal,
      errorMessageNoMorePackages: props.package.errorMessageNoMorePackages,
      legalInformations: props.legalInformations
    }),
    legalInformations: props.legalInformations,
    location: location,
    package: props.package,
    pushImage: bookingConfig.booking.form.pushImage ? bookingConfig.booking.form.pushImage : null,
    resort: props.resort,
    resortId: props.resortId,
    travelAdvisorConfig: bookingConfig.travelAdvisor
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-booking/productBookingBE.resolver.js
var productBookingBE_resolver = __webpack_require__("4NBB");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-booking/productBookingBE.descriptor.js



var productBookingBEDescriptor = {
  name: constants["eb" /* RESORT_BOOKING_BE */],
  component: ProductBookingLine_ProductBookingLine,
  resolve: productBookingBE_resolver["a" /* productBookingBEResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-breadcrumb-line/ProductBreadcrumbLine.jsx


var ProductBreadcrumbLine_jsx = react_default.a.createElement;

function ProductBreadcrumbLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductBreadcrumbLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductBreadcrumbLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductBreadcrumbLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var ProductBreadcrumbLine_BreadcrumbCell = function BreadcrumbCell(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      url = _ref.url,
      numberOfItems = _ref.numberOfItems;
  var maxWidthClass = numberOfItems < 5 ? "max-w-1/".concat(numberOfItems) : 'max-w-1/4';
  var baseClasses = "border-1 border-gray-light font-bold inline-flex items-center justify-center leading-one mx-1 p-2 rounded-tiny text-sm whitespace-no-wrap flex-grow sm:flex-grow-0 ".concat(maxWidthClass);
  return url ? ProductBreadcrumbLine_jsx(DynamicLink["a" /* default */], {
    className: classnames_default()(baseClasses, 'text-gray-darker'),
    url: url
  }, ProductBreadcrumbLine_jsx("span", {
    className: "max-w-full truncate"
  }, icon && ProductBreadcrumbLine_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-2 overflow-visible",
    name: icon,
    width: "calc(12rem / 16)"
  }), label)) : ProductBreadcrumbLine_jsx("div", {
    className: classnames_default()(baseClasses, 'text-black')
  }, ProductBreadcrumbLine_jsx("span", {
    className: "max-w-full truncate"
  }, label));
};

var ProductBreadcrumbLine_ProductBreadcrumbLine = function ProductBreadcrumbLine(_ref2) {
  var countryPage = _ref2.countryPage,
      originalUrl = _ref2.originalUrl,
      regionPage = _ref2.regionPage,
      resort = _ref2.resort;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var origin = new URI_default.a(originalUrl).origin().toString();
  var breadcrumbItems = [{
    label: dist["constants"].WEBSITE_NAME,
    url: '/',
    icon: icons["a" /* ICONS */].HOME
  }, regionPage ? {
    label: regionPage.pageRegion.breadcrumbLabel,
    url: regionPage.url
  } : null, countryPage ? {
    label: countryPage.pageCountry.breadcrumbLabel,
    url: countryPage.url
  } : null, {
    label: resort.name,
    url: ''
  }].filter(Boolean);
  return ProductBreadcrumbLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, [{
    type: 'application/ld+json',
    innerHTML: JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems.map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@id': item.url ? origin + item.url : Object(uriUtils["c" /* convertLocationToURI */])(ProductBreadcrumbLine_objectSpread(ProductBreadcrumbLine_objectSpread({}, location), {}, {
              origin: origin
            })),
            name: item.label
          }
        };
      })
    })
  }].map(function (script, idx) {
    return ProductBreadcrumbLine_jsx("script", {
      key: idx,
      type: script.type,
      dangerouslySetInnerHTML: {
        __html: script.innerHTML
      }
    });
  }), ProductBreadcrumbLine_jsx("div", {
    className: "flex -mx-1 justify-center md:justify-start"
  }, breadcrumbItems.map(function (item) {
    return ProductBreadcrumbLine_jsx(ProductBreadcrumbLine_BreadcrumbCell, Object(esm_extends["a" /* default */])({}, item, {
      numberOfItems: breadcrumbItems.length,
      key: item.label
    }));
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-breadcrumb/productBreadcrumb.resolver.js
var productBreadcrumb_resolver = __webpack_require__("9smd");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-breadcrumb/productBreadcrumb.descriptor.js



var productBreadcrumbDescriptor = {
  name: constants["J" /* PRODUCT_BREADCRUMB */],
  component: ProductBreadcrumbLine_ProductBreadcrumbLine,
  props: productBreadcrumb_resolver["a" /* productBreadcrumbResolver */].props,
  resolve: productBreadcrumb_resolver["a" /* productBreadcrumbResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-childcares-line/ProductChildcaresLine.jsx

var ProductChildcaresLine_jsx = react_default.a.createElement;

function ProductChildcaresLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductChildcaresLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductChildcaresLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductChildcaresLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var ProductChildcaresLine_ProductChildcaresLine = function ProductChildcaresLine(props) {
  var closingDays = props.closingDays,
      openingHours = props.openingHours,
      _props$config$common = props.config.common,
      childcarealacarte = _props$config$common.childcarealacarte,
      loadLess = _props$config$common.loadLess,
      scrollBackward = _props$config$common.scrollBackward,
      scrollForward = _props$config$common.scrollForward,
      viewMore = _props$config$common.viewMore,
      id = props.id,
      resort = props.resort;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  Object(src_i18n["a" /* addTranslationKeys */])({
    'productChildcaresInformation.closingDays': closingDays,
    'productChildcaresInformation.openingHours': openingHours
  });

  if (!resort) {
    return null;
  }

  var fetchActivityServices = function fetchActivityServices(_ref) {
    var productId = _ref.productId,
        activityId = _ref.activityId;
    var query = Object(productFeatures_queries["c" /* productChildcareDetailQuery */])(productId, activityId, {
      lineProps: props,
      urlParams: location.urlParams
    });
    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["Md" /* WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES */]
    }).then(function (data) {
      Object(src_i18n["a" /* addTranslationKeys */])(data.config);
      return {
        productActivities: ProductChildcaresLine_objectSpread(ProductChildcaresLine_objectSpread({}, data.productActivities), {}, {
          resort: data.resort,
          includedServices: data.includedServices,
          onDemandServices: data.onDemandServices
        })
      };
    });
  };

  var introduction = {
    seeLessLabel: loadLess,
    seeMoreLabel: viewMore,
    text: resort.kidsActivitiesIntroduction && resort.kidsActivitiesIntroduction.description || '',
    title: resort.kidsActivitiesIntroduction && resort.kidsActivitiesIntroduction.shortDescription || ''
  };
  var productActivitiesCategories = resort.categories && resort.categories.children ? resort.categories.children.filter(function (_ref2) {
    var activities = _ref2.activities;
    return activities && activities.length !== 0;
  }) : [];
  var productCategories = mapCategories({
    fetchActivityServices: fetchActivityServices,
    hasBanner: true,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].CHILDCARE,
    notIncludedMessage: childcarealacarte,
    productActivitiesCategories: productActivitiesCategories,
    productFeaturesLineData: props
  });
  return ProductChildcaresLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductChildcaresLine_jsx(ProductFeatures_ProductFeatures, {
    categories: productCategories,
    introduction: introduction,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].CHILDCARE,
    queryLayer: "productChildcaresLayer",
    renderDetail: function renderDetail(data) {
      return ProductChildcaresLine_jsx(ProductFeatureDetail, data);
    },
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-childcares/productChildcares.resolver.js
var productChildcares_resolver = __webpack_require__("27iJ");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-childcares/productChildcares.descriptor.js



var productChildcaresDescriptor = {
  name: constants["K" /* PRODUCT_CHILDCARES */],
  component: ProductChildcaresLine_ProductChildcaresLine,
  resolve: productChildcares_resolver["a" /* productChildcaresResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/frameworks/active-indexes/ActiveIndexes.jsx
var ActiveIndexes = __webpack_require__("1Wgj");

// CONCATENATED MODULE: ./src/client/components/frameworks/post-answer/PostAnswer.themes.js
var PostAnswer_themes_themes = {
  "default": {
    thTag: 'mb-5',
    thTextTheme: 'text-sans-3',
    thBottom: 'flex items-center justify-between mt-5',
    thAuthor: 'font-bold',
    thDate: 'text-gray-medium',
    thLikesLabel: 'font-bold text-gray-darker rtl:mr-2',
    thLikes: 'inline-flex items-center text-red rtl:mr-3',
    thIcon: 'rtl:mr-2',
    thIconSize: '1.25rem'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/post-answer/PostAnswer.jsx

var PostAnswer_jsx = react_default.a.createElement;






function PostAnswer(props) {
  var author = props.author,
      className = props.className,
      date = props.date,
      hasLabel = props.hasLabel,
      id = props.id,
      _props$likesCount = props.likesCount,
      likesCount = _props$likesCount === void 0 ? 0 : _props$likesCount,
      likesLabel = props.likesLabel,
      tag = props.tag,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      text = props.text;
  if (!text) return null;
  var _themes$theme = PostAnswer_themes_themes[theme],
      thAuthor = _themes$theme.thAuthor,
      thBottom = _themes$theme.thBottom,
      thDate = _themes$theme.thDate,
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thLikes = _themes$theme.thLikes,
      thLikesLabel = _themes$theme.thLikesLabel,
      thTag = _themes$theme.thTag,
      thTextTheme = _themes$theme.thTextTheme;
  return PostAnswer_jsx("article", {
    id: id,
    className: className
  }, PostAnswer_jsx(Tag["a" /* Tag */], Object(esm_extends["a" /* default */])({
    className: thTag
  }, tag)), PostAnswer_jsx(Text["a" /* Text */], {
    text: text,
    theme: thTextTheme
  }), (!!author || !!date || !!likesCount) && PostAnswer_jsx("div", {
    className: thBottom
  }, PostAnswer_jsx("div", null, !!author && PostAnswer_jsx("span", {
    className: thAuthor
  }, author), !!author && !!date && ' - ', !!date && PostAnswer_jsx("span", {
    className: thDate
  }, date)), PostAnswer_jsx("div", {
    className: thLikes
  }, hasLabel && !!likesLabel && PostAnswer_jsx("span", {
    className: thLikesLabel
  }, likesLabel), PostAnswer_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].HEART_FILLED,
    width: thIconSize
  }), likesCount)));
}
// CONCATENATED MODULE: ./src/client/components/frameworks/post-question/PostQuestion.themes.js
var PostQuestion_themes_themes = {
  "default": function _default(_ref) {
    var _ref$author = _ref.author,
        author = _ref$author === void 0 ? {} : _ref$author;
    return {
      thRoot: 'flex flex-col',
      thTop: 'flex items-center mb-3',
      thBadge: 'rtl:mr-2 flex-shrink-0',
      thBadgeIconSize: '1rem',
      thBadgeSize: 40,
      thBadgeVariant: 'pill',
      thAuthor: "text-".concat(author.color ? author.color : 'gray-dark', " text-base"),
      thDate: 'text-base text-gray-light rtl:ml-5',
      thTitle: '',
      thTitleTheme: 'title-sans-3',
      thText: 'mt-2',
      thBottom: 'flex items-center mt-auto pt-3 text-md',
      thIcon: 'rtl:mr-1',
      thIconSize: '1.25rem',
      thLikes: 'inline-flex items-center text-red rtl:mr-3',
      thAnswers: 'inline-flex items-center text-turquoise',
      thSeeMore: 'font-bold text-turquoise text-md underline rtl:ml-auto'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/post-question/PostQuestion.jsx

var PostQuestion_jsx = react_default.a.createElement;









function PostQuestion(props) {
  var _props$answersCount = props.answersCount,
      answersCount = _props$answersCount === void 0 ? 0 : _props$answersCount,
      _props$author = props.author,
      author = _props$author === void 0 ? {} : _props$author,
      className = props.className,
      date = props.date,
      id = props.id,
      _props$likesCount = props.likesCount,
      likesCount = _props$likesCount === void 0 ? 0 : _props$likesCount,
      seeMoreLabel = props.seeMoreLabel,
      text = props.text,
      _props$textLimit = props.textLimit,
      textLimit = _props$textLimit === void 0 ? 130 : _props$textLimit,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title,
      titleId = props.titleId,
      _props$titleLimit = props.titleLimit,
      titleLimit = _props$titleLimit === void 0 ? -1 : _props$titleLimit;
  if (!title) return null;

  var _themes$theme = PostQuestion_themes_themes[theme](props),
      thAnswers = _themes$theme.thAnswers,
      thAuthor = _themes$theme.thAuthor,
      thBadge = _themes$theme.thBadge,
      thBadgeIconSize = _themes$theme.thBadgeIconSize,
      thBadgeSize = _themes$theme.thBadgeSize,
      thBadgeVariant = _themes$theme.thBadgeVariant,
      thBottom = _themes$theme.thBottom,
      thDate = _themes$theme.thDate,
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thLikes = _themes$theme.thLikes,
      thRoot = _themes$theme.thRoot,
      thSeeMore = _themes$theme.thSeeMore,
      thText = _themes$theme.thText,
      thTitle = _themes$theme.thTitle,
      thTitleTheme = _themes$theme.thTitleTheme,
      thTop = _themes$theme.thTop;

  return PostQuestion_jsx("article", {
    id: id,
    className: classnames_default()(thRoot, className)
  }, PostQuestion_jsx("div", {
    className: thTop
  }, PostQuestion_jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({
    alt: author.avatarImg && author.name,
    className: thBadge,
    colorBg: author.color,
    colorBorder: author.color,
    iconSize: thBadgeIconSize,
    size: thBadgeSize,
    variant: thBadgeVariant
  }, author.avatarImg ? {
    imageSrc: author.avatarImg
  } : {
    iconName: icons["a" /* ICONS */].USER
  })), !!author.name && PostQuestion_jsx("span", {
    className: thAuthor
  }, author.name), !!date && PostQuestion_jsx("span", {
    className: thDate
  }, date)), PostQuestion_jsx(Title["a" /* Title */], {
    id: titleId,
    className: thTitle,
    theme: thTitleTheme
  }, titleLimit > 0 ? Object(string_util["f" /* truncate */])(title, titleLimit) : title), !!text && PostQuestion_jsx(Text["a" /* Text */], {
    className: thText,
    text: textLimit > 0 ? Object(string_util["f" /* truncate */])(text, textLimit) : text
  }), PostQuestion_jsx("div", {
    className: thBottom
  }, PostQuestion_jsx("span", {
    className: thLikes
  }, PostQuestion_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].HEART_FILLED,
    width: thIconSize
  }), likesCount), PostQuestion_jsx("span", {
    className: thAnswers
  }, PostQuestion_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].ANSWERS,
    width: thIconSize
  }), answersCount), !!seeMoreLabel && PostQuestion_jsx("span", {
    className: thSeeMore
  }, seeMoreLabel)));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// CONCATENATED MODULE: ./src/client/components/widgets/wibilong/large/WibilongLarge.jsx

var WibilongLarge_jsx = react_default.a.createElement;
















var clearAndScroll = function clearAndScroll(_ref) {
  var clear = _ref.clear,
      scrollTo = _ref.scrollTo;
  return function () {
    clear();
    scrollTo();
  };
};

function WibilongLarge(props) {
  var noAnswerstext = props.noAnswerstext,
      _props$questions = props.questions,
      questions = _props$questions === void 0 ? [] : _props$questions,
      _props$scrollTo = props.scrollTo,
      scrollTo = _props$scrollTo === void 0 ? lodash["noop"] : _props$scrollTo,
      seeMoreLabel = props.seeMoreLabel;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  if (Object(lodash["isEmpty"])(questions)) return null;
  return WibilongLarge_jsx(SiteContainer["a" /* SiteContainer */], null, WibilongLarge_jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    hasNoIndexEnabled: true
  }, function (_ref2) {
    var activeIndexes = _ref2.activeIndexes,
        clear = _ref2.clear,
        update = _ref2.update;
    var answers = questions[activeIndexes[0]] && questions[activeIndexes[0]].answers ? questions[activeIndexes[0]].answers : [];
    var onClear = clearAndScroll({
      clear: clear,
      scrollTo: scrollTo
    });
    var items = questions.map(function (q, i) {
      var isActive = activeIndexes.includes(i);
      var hasSomeSelected = !!activeIndexes.length;
      return WibilongLarge_jsx("div", {
        className: "p-2",
        key: q.id
      }, WibilongLarge_jsx(TrackClick["a" /* TrackClick */], {
        as: "div",
        className: classnames_default()('bg-white cursor-pointer flex overflow-hidden p-5 rounded shadow-md transition-all', {
          'opacity-50': hasSomeSelected && !isActive,
          'hover:scale-1025': !hasSomeSelected,
          'scale-1025': isActive
        }),
        "data-testid": "Wibilong-question",
        onClick: function onClick() {
          update(i);
          scrollTo();
        },
        role: "button",
        style: {
          minHeight: 250
        },
        tabIndex: 0,
        trackingData: !hasSomeSelected ? q.trackingData : null
      }, WibilongLarge_jsx(PostQuestion, Object(esm_extends["a" /* default */])({}, q, {
        className: "w-full",
        textLimit: isActive ? -1 : 100,
        titleLimit: isActive ? -1 : 60,
        seeMoreLabel: !Object(lodash["isEmpty"])(q.answers) ? seeMoreLabel : ''
      }))));
    });
    return WibilongLarge_jsx(react["Fragment"], null, WibilongLarge_jsx(SliderHandler["a" /* SliderHandler */], {
      className: "flex-1",
      items: items,
      onNext: onClear,
      onPrevious: onClear,
      hasKeyboardSupport: true,
      hasLazyload: true,
      hasSwipeSupport: true,
      nbItemsToScroll: 1,
      nbItemsToShow: isDesktop ? 3 : 2
    }, function (_ref3) {
      var hasControls = _ref3.hasControls,
          isNextControlDisabled = _ref3.isNextControlDisabled,
          isPreviousControlDisabled = _ref3.isPreviousControlDisabled,
          itemsNode = _ref3.itemsNode,
          onNext = _ref3.onNext,
          onPrevious = _ref3.onPrevious;
      return WibilongLarge_jsx("div", {
        className: "flex"
      }, hasControls && WibilongLarge_jsx("div", {
        className: classnames_default()('flex-none rtl:mr-3', {
          invisible: isPreviousControlDisabled
        }),
        style: {
          marginTop: '118px'
        }
      }, WibilongLarge_jsx(ArrowButton["a" /* ArrowButton */], {
        className: "shadow-sm",
        isDisabled: isPreviousControlDisabled,
        label: Object(src_i18n["f" /* t */])('common.previous'),
        onClick: onPrevious
      })), itemsNode, hasControls && WibilongLarge_jsx("div", {
        className: classnames_default()('flex-none rtl:ml-3', {
          invisible: isNextControlDisabled
        }),
        style: {
          marginTop: '118px'
        }
      }, WibilongLarge_jsx(ArrowButton["a" /* ArrowButton */], {
        className: "shadow-sm",
        isDisabled: isNextControlDisabled,
        label: Object(src_i18n["f" /* t */])('common.next'),
        onClick: onNext,
        rotation: 180
      })));
    }), !Object(lodash["isEmpty"])(activeIndexes) && WibilongLarge_jsx("div", {
      className: "fadeIn flex flex-col items-center mt-10 relative"
    }, !Object(lodash["isEmpty"])(answers) && WibilongLarge_jsx("button", {
      "data-testid": "Wibilong-clear",
      className: "reset-button absolute bg-white leading-none mt-3 p-3 rtl:right-0 rtl:mr-10 rounded-full shadow-md text-gray-medium",
      onClick: onClear,
      type: "button"
    }, WibilongLarge_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].CROSS,
      width: "1.25rem"
    })), WibilongLarge_jsx("div", {
      className: "border-t-1 max-w-site-small w-full"
    }, !Object(lodash["isEmpty"])(answers) ? answers.map(function (answer) {
      return WibilongLarge_jsx(PostAnswer, Object(esm_extends["a" /* default */])({}, answer, {
        className: "py-8 border-b-1",
        key: answer.id
      }));
    }) : WibilongLarge_jsx(Notification["a" /* Notification */], {
      className: "mt-8",
      hasBorder: true,
      hasClose: true,
      onClose: onClear,
      text: noAnswerstext
    }))));
  }));
}
// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx + 1 modules
var SidePanel = __webpack_require__("p7XS");

// EXTERNAL MODULE: ./src/hooks/use-script-loader/useScriptLoader.js
var useScriptLoader = __webpack_require__("/WwO");

// CONCATENATED MODULE: ./src/client/components/widgets/wibilong/popin-button/WibilongPopinButton.jsx
var WibilongPopinButton_jsx = react_default.a.createElement;







var WibilongPopinButton_WibilongPopinButton = function WibilongPopinButton(props) {
  var dataUrl = config_default.a.get('social.wibilong.appUrl');
  var isEnabled = config_default.a.get('social.wibilong.enabled');
  var scriptUrl = config_default.a.get('social.wibilong.scriptUrl');

  var _useScriptLoader = Object(useScriptLoader["a" /* useScriptLoader */])(scriptUrl),
      scriptLoaded = _useScriptLoader.scriptLoaded;

  Object(react["useEffect"])(function () {
    if (isEnabled) {
      var wibilongPopin = dist["windowWrapper"].get('wibilongPopin');

      if (wibilongPopin && Object(lodash["isFunction"])(wibilongPopin.init)) {
        wibilongPopin.init();
      }
    }
  }, [scriptLoaded]);
  var className = props.className,
      country = props.country,
      language = props.language,
      productId = props.productId,
      trackingData = props.trackingData;
  return WibilongPopinButton_jsx(react["Fragment"], null, !isEnabled ? null : WibilongPopinButton_jsx(TrackClick["a" /* TrackClick */], {
    as: "div",
    className: classnames_default()(className, 'WibilongPopinButton'),
    trackingData: trackingData
  }, WibilongPopinButton_jsx("div", {
    id: "PopinDiv",
    "data-url": dataUrl,
    "data-product": "".concat(productId).concat(country).concat(language)
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/wibilong/catchblock/WibilongCatchBlock.jsx

var WibilongCatchBlock_jsx = react_default.a.createElement;






function WibilongCatchBlock(props) {
  var button = props.button,
      text = props.text,
      className = props.className,
      _props$link = props.link,
      link = _props$link === void 0 ? {} : _props$link;
  return WibilongCatchBlock_jsx("div", {
    className: classnames_default()(className, 'text-center flex flex-col justify-center')
  }, WibilongCatchBlock_jsx(Text["a" /* Text */], {
    theme: "text-sans-4",
    text: text
  }), WibilongCatchBlock_jsx(WibilongPopinButton_WibilongPopinButton, Object(esm_extends["a" /* default */])({}, button, {
    className: "mt-3"
  })), !!link.url && WibilongCatchBlock_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "font-bold mt-3 text-md text-blue focus:text-turquoise hover:text-turquoise underline transition-color",
    target: link.target,
    trackingData: link.trackingData,
    url: link.url
  }, link.label));
}
// CONCATENATED MODULE: ./src/client/components/widgets/wibilong/narrow/WibilongNarrow.jsx

var WibilongNarrow_jsx = react_default.a.createElement;












function WibilongNarrow(props) {
  var button = props.button,
      hasLinkAllQuestions = props.hasLinkAllQuestions,
      _props$linkAllQuestio = props.linkAllQuestions,
      linkAllQuestions = _props$linkAllQuestio === void 0 ? {} : _props$linkAllQuestio,
      noAnswerstext = props.noAnswerstext,
      _props$questions = props.questions,
      questions = _props$questions === void 0 ? [] : _props$questions,
      scrollBackwardLabel = props.scrollBackwardLabel,
      scrollForwardLabel = props.scrollForwardLabel,
      seeMoreLabel = props.seeMoreLabel,
      text = props.text;
  if (Object(lodash["isEmpty"])(questions)) return null;
  var boxStyles = {
    minHeight: 230,
    width: '80vw'
  };
  return WibilongNarrow_jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    hasNoIndexEnabled: true
  }, function (_ref) {
    var update = _ref.update,
        activeIndexes = _ref.activeIndexes,
        clear = _ref.clear;
    var activeQuestion = questions[activeIndexes[0]] || {};
    var answers = activeQuestion.answers ? activeQuestion.answers : [];
    var ariaLabel = activeQuestion.title;
    var ariaLabelledby = activeQuestion.id && "".concat(identifiers_constants["z" /* ID_SIDEPANEL_HEADER__SHOPPING__WIBILONG_NARROW */], "-").concat(activeQuestion.id);
    return WibilongNarrow_jsx("div", {
      className: "mt-6"
    }, WibilongNarrow_jsx(Scrollable["a" /* Scrollable */], {
      backwardLabel: scrollBackwardLabel,
      forwardLabel: scrollForwardLabel,
      navPosition: "center"
    }, WibilongNarrow_jsx("div", {
      className: "flex px-4"
    }, questions.map(function (q, i) {
      return WibilongNarrow_jsx("div", {
        className: "flex-none p-2",
        key: q.id,
        style: boxStyles
      }, WibilongNarrow_jsx(TrackClick["a" /* TrackClick */], {
        as: "div",
        className: "bg-white cursor-pointer h-full p-5 rounded shadow-md",
        "data-testid": "Wibilong-question",
        onClick: function onClick() {
          return update(i);
        },
        role: "button",
        tabIndex: 0,
        trackingData: q.trackingData
      }, WibilongNarrow_jsx(PostQuestion, Object(esm_extends["a" /* default */])({}, q, {
        className: "h-full",
        seeMoreLabel: !Object(lodash["isEmpty"])(q.answers) ? seeMoreLabel : ''
      }))));
    }), WibilongNarrow_jsx("div", {
      className: "pr-4 pointer-events-none"
    }))), WibilongNarrow_jsx(SidePanel["a" /* SidePanel */], {
      ariaLabel: ariaLabel,
      ariaLabelledby: ariaLabelledby,
      className: "px-4 py-5",
      closeLabel: Object(src_i18n["f" /* t */])('common.close'),
      isExpanded: !Object(lodash["isEmpty"])(activeIndexes),
      onClose: clear
    }, !Object(lodash["isEmpty"])(activeIndexes) && WibilongNarrow_jsx("div", {
      className: "fadeIn"
    }, WibilongNarrow_jsx(PostQuestion, Object(esm_extends["a" /* default */])({}, questions[activeIndexes[0]], {
      className: "bg-white cursor-pointer flex-none m-2 p-5 rounded shadow-md",
      textLimit: -1,
      titleId: ariaLabelledby
    })), WibilongNarrow_jsx("div", {
      className: "border-t-1 mt-8"
    }, !Object(lodash["isEmpty"])(answers) ? answers.map(function (answer) {
      return WibilongNarrow_jsx(PostAnswer, Object(esm_extends["a" /* default */])({}, answer, {
        className: "py-8 border-b-1",
        key: answer.id
      }));
    }) : WibilongNarrow_jsx(Notification["a" /* Notification */], {
      className: "mt-8",
      closeLabel: ariaLabel ? [Object(src_i18n["f" /* t */])('common.close'), ariaLabel].join(' - ') : '',
      hasBorder: true,
      hasClose: true,
      onClose: clear,
      text: noAnswerstext
    }), hasLinkAllQuestions && WibilongNarrow_jsx(WibilongCatchBlock, {
      className: "mt-8",
      button: button,
      link: linkAllQuestions,
      text: text
    })))));
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/wibilong/Wibilong.jsx

var Wibilong_jsx = react_default.a.createElement;

















var Wibilong_scrollToQuestions = function scrollToQuestions(id) {
  return function () {
    Object(scrollToElement["a" /* scrollToElement */])("#".concat(id), 300, '.Line-PriceTicket');
  };
};

function Wibilong(props) {
  var button = props.button,
      className = props.className,
      hasLinkAllQuestions = props.hasLinkAllQuestions,
      icon = props.icon,
      _props$linkAllQuestio = props.linkAllQuestions,
      linkAllQuestions = _props$linkAllQuestio === void 0 ? {} : _props$linkAllQuestio,
      _props$questions = props.questions,
      questions = _props$questions === void 0 ? [] : _props$questions,
      text = props.text,
      title = props.title;
  if (Object(lodash["isEmpty"])(questions)) return null;
  var id = 'wibilong';
  var scrollTo = Wibilong_scrollToQuestions(id);
  return Wibilong_jsx("section", {
    className: classnames_default()(className, 'bg-white relative shadow-inner-top shadow-inner-bottom'),
    id: id
  }, Wibilong_jsx("div", {
    className: "absolute inset-0",
    style: {
      opacity: '0.05'
    }
  }, Wibilong_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].TURQUOISE,
    name: icon,
    width: "40rem"
  })), Wibilong_jsx("div", {
    className: "py-9"
  }, Wibilong_jsx(responsiveContext["a" /* default */].Consumer, null, function (_ref) {
    var isTablet = _ref.isTablet,
        isDesktop = _ref.isDesktop;
    return Wibilong_jsx(react["Fragment"], null, (!!text || !!title) && Wibilong_jsx(SiteContainer["a" /* SiteContainer */], null, Wibilong_jsx("header", {
      className: "flex flex-col sm:flex-row items-center justify-end sm:px-16 text-center sm:text-initial"
    }, !!text && Wibilong_jsx("div", {
      className: "flex flex-col sm:flex-row items-center sm:rtl:mr-auto w-full"
    }, Wibilong_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-5",
      color: colors["a" /* COLORS */].BLUE,
      name: icons["a" /* ICONS */].COMMUNITY,
      width: isTablet ? '3.2rem' : '4rem'
    }), Wibilong_jsx(Text["a" /* Text */], {
      className: "mt-4 sm:mt-0",
      theme: "text-sans-4",
      text: text
    })), !!title && Wibilong_jsx(Title["a" /* Title */], {
      className: "mt-4 sm:mt-0 w-full",
      theme: isDesktop ? 'title-sans-9' : 'title-sans-4'
    }, title))), isTablet ? Wibilong_jsx(WibilongLarge, Object(esm_extends["a" /* default */])({}, props, {
      scrollTo: scrollTo
    })) : Wibilong_jsx(WibilongNarrow, props));
  }), Wibilong_jsx(SiteContainer["a" /* SiteContainer */], null, Wibilong_jsx("footer", {
    className: "flex flex-col items-center mt-4"
  }, Wibilong_jsx(WibilongPopinButton_WibilongPopinButton, Object(esm_extends["a" /* default */])({
    className: "inline-block"
  }, button)), hasLinkAllQuestions && linkAllQuestions && linkAllQuestions.url && Wibilong_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, linkAllQuestions, {
    as: DynamicLink["a" /* default */],
    className: "font-bold mt-4 mx-8 text-md text-blue focus:text-turquoise hover:text-turquoise underline transition-color"
  }), linkAllQuestions.label)))));
}
// CONCATENATED MODULE: ./src/client/components/lines/product-community-questions-line/productCommunityQuestionsLine.utils.js


function productCommunityQuestionsLine_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function productCommunityQuestionsLine_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      productCommunityQuestionsLine_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      productCommunityQuestionsLine_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var DATE_FORMAT = 'D MMM YYYY';

function getTag(_ref) {
  var idx = _ref.idx,
      lastAnswerLabel = _ref.lastAnswerLabel;
  return idx === 0 ? {
    color: colors["a" /* COLORS */].WATER_GREEN,
    label: lastAnswerLabel
  } : null;
}

function mapAnswer(answers) {
  var labels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var lastAnswerLabel = labels.lastAnswerLabel,
      usefullLabel = labels.usefullLabel;
  return answers.map(function (a, idx) {
    var tag = getTag({
      idx: idx,
      lastAnswerLabel: lastAnswerLabel
    });
    return productCommunityQuestionsLine_utils_objectSpread(productCommunityQuestionsLine_utils_objectSpread({
      id: a.id,
      author: a.authorName,
      date: Object(apiDate["e" /* formatApiDate */])(a.date, DATE_FORMAT),
      likesCount: a.likesCount,
      likesLabel: usefullLabel
    }, tag ? {
      tag: tag
    } : null), {}, {
      text: a.text
    });
  });
}

function mapQuestionsAndAnswers(props) {
  var bestAnswerLabel = props.bestAnswerLabel,
      lastAnswerLabel = props.lastAnswerLabel,
      usefullLabel = props.usefullLabel,
      _props$productCommuni = props.productCommunity.questions,
      questions = _props$productCommuni === void 0 ? [] : _props$productCommuni;
  var avatarsColors = [colors["a" /* COLORS */].AMBER, colors["a" /* COLORS */].OCHER, colors["a" /* COLORS */].PINE];
  return questions.sort(function (a, b) {
    return moment_default()(b.date, apiDate["a" /* API_DATE_FORMAT */]).toDate().getTime() - moment_default()(a.date, apiDate["a" /* API_DATE_FORMAT */]).toDate().getTime() || a.likesCount - b.likesCount;
  }).map(function (q, idx) {
    return {
      id: q.id,
      answers: mapAnswer(q.answers, {
        bestAnswerLabel: bestAnswerLabel,
        lastAnswerLabel: lastAnswerLabel,
        usefullLabel: usefullLabel
      }),
      answersCount: q.answersCount,
      author: {
        color: avatarsColors[idx % avatarsColors.length],
        name: q.authorName
      },
      date: Object(apiDate["e" /* formatApiDate */])(q.date, DATE_FORMAT),
      likesCount: q.likesCount,
      text: q.text,
      title: q.title,
      trackingData: {
        event: 'eventGA',
        categoryGA: 'resort',
        actionGA: 'wibilong',
        labelGA: 'seeAnswers',
        valueGA: '0',
        nonInteraction: '0'
      }
    };
  });
}

function mapCommunityQuestions(props) {
  var buttonLabel = props.buttonLabel,
      config = props.config,
      noAnswersLabel = props.noAnswersLabel,
      popinButton = props.popinButton,
      linkAllQuestionsUrl = props.productCommunity.linkAllQuestionsUrl,
      icon = props.resort.icon,
      seeAllQuestionsLabel = props.seeAllQuestionsLabel,
      seeMoreLabel = props.seeMoreLabel,
      text = props.text;
  return {
    button: productCommunityQuestionsLine_utils_objectSpread(productCommunityQuestionsLine_utils_objectSpread({
      label: buttonLabel
    }, popinButton), {}, {
      trackingData: {
        event: 'eventGA',
        categoryGA: 'resort',
        actionGA: 'wibilong',
        labelGA: 'askQuestion',
        valueGA: '0',
        nonInteraction: '0'
      }
    }),
    icon: icon,
    linkAllQuestions: linkAllQuestionsUrl ? {
      label: seeAllQuestionsLabel,
      target: '_blank',
      url: linkAllQuestionsUrl,
      trackingData: {
        event: 'eventGA',
        categoryGA: 'resort',
        actionGA: 'wibilong',
        labelGA: 'seeQuestion',
        valueGA: '0',
        nonInteraction: '0'
      }
    } : {},
    noAnswerstext: noAnswersLabel,
    questions: mapQuestionsAndAnswers(props),
    scrollBackwardLabel: Object(lodash["get"])(config, 'common.scrollBackward'),
    scrollForwardLabel: Object(lodash["get"])(config, 'common.scrollForward'),
    seeMoreLabel: seeMoreLabel,
    text: text
  };
}
// CONCATENATED MODULE: ./src/client/components/lines/product-community-questions-line/ProductCommunityQuestionsLine.jsx

var ProductCommunityQuestionsLine_jsx = react_default.a.createElement;

function ProductCommunityQuestionsLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductCommunityQuestionsLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductCommunityQuestionsLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductCommunityQuestionsLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var WIBILONG_ENABLED = config_default.a.get('social.wibilong.enabled');
var ProductCommunityQuestionsLine_ProductCommunityQuestionsLine = function ProductCommunityQuestionsLine(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  Object(src_i18n["a" /* addTranslationKeys */])(props.config);
  var hasCommunityQuestions = Boolean(props.productCommunity.questions.length);
  var isDisplayed = WIBILONG_ENABLED && isAppMounted && hasCommunityQuestions;

  if (!isDisplayed) {
    return null;
  }

  var popinButton = {
    country: appContext.country.toUpperCase(),
    language: appContext.language.toUpperCase(),
    productId: props.resortId
  };
  var communityQuestionsProps = mapCommunityQuestions(ProductCommunityQuestionsLine_objectSpread(ProductCommunityQuestionsLine_objectSpread({}, props), {}, {
    popinButton: popinButton
  }));
  return ProductCommunityQuestionsLine_jsx("div", {
    className: "Line"
  }, ProductCommunityQuestionsLine_jsx(Wibilong, communityQuestionsProps));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-community-questions/productCommunityQuestions.resolver.js
var productCommunityQuestions_resolver = __webpack_require__("bNYI");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-community-questions/productCommunityQuestions.descriptor.js



var productCommunityQuestionsDescriptor = {
  name: constants["L" /* PRODUCT_COMMUNITY_QUESTIONS */],
  component: ProductCommunityQuestionsLine_ProductCommunityQuestionsLine,
  resolve: productCommunityQuestions_resolver["a" /* productCommunityQuestionsResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-destination/productDestination.resolver.js
var productDestination_resolver = __webpack_require__("IpDy");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-destination/productDestination.descriptor.js
var productDestination_descriptor_jsx = react_default.a.createElement;












function renderArea(props) {
  var _props$resort = props.resort,
      _props$resort$name = _props$resort.name,
      title = _props$resort$name === void 0 ? '' : _props$resort$name,
      _props$resort$descrip = _props$resort.description,
      description = _props$resort$descrip === void 0 ? '' : _props$resort$descrip,
      productVideo = _props$resort.productVideo,
      _props$resort$strengt = _props$resort.strengths,
      strengths = _props$resort$strengt === void 0 ? [] : _props$resort$strengt;
  return productDestination_descriptor_jsx("div", {
    className: "sm:flex"
  }, productDestination_descriptor_jsx(Title["a" /* Title */], {
    className: "sm:w-1/4",
    theme: "title-sans-2"
  }, title), productDestination_descriptor_jsx("div", {
    className: "sm:w-3/4"
  }, productDestination_descriptor_jsx(Text["a" /* Text */], {
    text: description
  }), description ? productDestination_descriptor_jsx("hr", {
    className: "block border-0 border-solid border-gray-light border-t-1 h-px my-4 mx-0 p-0"
  }) : null, productDestination_descriptor_jsx("div", {
    className: "sm:flex"
  }, productDestination_descriptor_jsx("div", {
    className: "mb-5 sm:rtl:mr-5 sm:mb-0 sm:w-1/3 image-responsive-cell"
  }, productDestination_descriptor_jsx(Image["a" /* default */], {
    imageUrl: productVideo,
    ratioKey: ratios_utils["a" /* default */].XL
  })), !Object(lodash["isEmpty"])(strengths) ? productDestination_descriptor_jsx("ul", {
    "data-testid": "Destination-strengths",
    className: "reset-list text-base sm:w-2/3"
  }, strengths.map(function (strength, index) {
    return productDestination_descriptor_jsx("li", {
      className: "list-disc",
      key: index
    }, strength);
  })) : null)));
}

function renderResponsiveTabsContent(content, id) {
  return content ? productDestination_descriptor_jsx(Text["a" /* Text */], {
    key: id,
    text: content
  }) : null;
}

function getResponsiveTabsItems(titles, practicalInformation) {
  var _titles$healthFormali = titles.healthFormalities,
      healthFormalities = _titles$healthFormali === void 0 ? '' : _titles$healthFormali,
      _titles$passportAndVi = titles.passportAndVisas,
      passportAndVisas = _titles$passportAndVi === void 0 ? '' : _titles$passportAndVi;
  return [{
    header: {
      iconName: icons["a" /* ICONS */].HEALTH,
      title: healthFormalities
    },
    content: [renderResponsiveTabsContent(practicalInformation.healthFormalities, 'health')]
  }, {
    header: {
      iconName: icons["a" /* ICONS */].PASSPORT,
      title: passportAndVisas
    },
    content: [renderResponsiveTabsContent(practicalInformation.passportAndVisas, 'passport')]
  }];
}

function hasResponsiveTabs(props) {
  return Object(lodash["get"])(props, 'resort.practicalInformation.healthFormalities', null) || Object(lodash["get"])(props, 'resort.practicalInformation.passportAndVisas', null);
}

var productDestination_descriptor_ProductDestinationsLine = function ProductDestinationsLine(props) {
  var healthFormalities = props.healthFormalities,
      passportAndVisas = props.passportAndVisas,
      resort = props.resort;
  var _resort$strengths = resort.strengths,
      strengths = _resort$strengths === void 0 ? [] : _resort$strengths;
  var shouldRenderArea = strengths.length > 0 || !!resort.productVideo;
  var description = Object(lodash["get"])(resort, 'destination.description', '');
  return productDestination_descriptor_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, productDestination_descriptor_jsx("div", {
    className: "pt-5",
    "data-testid": "ProductInformationDestination"
  }, productDestination_descriptor_jsx("div", {
    className: "sm:flex"
  }, productDestination_descriptor_jsx(Title["a" /* Title */], {
    className: "sm:w-1/4 mb-5",
    theme: "title-sans-2"
  }, Object(lodash["get"])(props, 'resort.destination.country', '')), productDestination_descriptor_jsx("div", {
    className: "sm:w-3/4"
  }, productDestination_descriptor_jsx(Text["a" /* Text */], {
    text: description
  }), hasResponsiveTabs(props) ? productDestination_descriptor_jsx(react["Fragment"], null, productDestination_descriptor_jsx(ResponsiveTabs["a" /* ResponsiveTabs */], {
    areAllCollapsable: true,
    className: "mt-5",
    expandIconName: icons["a" /* ICONS */].PLUS,
    items: getResponsiveTabsItems({
      healthFormalities: healthFormalities,
      passportAndVisas: passportAndVisas
    }, Object(lodash["get"])(props, 'resort.practicalInformation'))
  }), productDestination_descriptor_jsx("hr", {
    className: "block border-0 border-solid border-gray-light border-t-1 h-px my-4 mx-0 p-0"
  })) : null)), shouldRenderArea ? renderArea(props) : null));
};

var productDestinationDescriptor = {
  name: constants["fb" /* RESORT_DESTINATION */],
  component: productDestination_descriptor_ProductDestinationsLine,
  resolve: productDestination_resolver["a" /* productDestinationResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-exclusive-collection-space/ProductExclusiveCollectionSpace.jsx
var ProductExclusiveCollectionSpace_jsx = react_default.a.createElement;











function ProductExclusiveCollectionSpace(props) {
  var mediaUrl = props.mediaUrl,
      text = props.text,
      title = props.title;
  return ProductExclusiveCollectionSpace_jsx("article", {
    className: "flex"
  }, ProductExclusiveCollectionSpace_jsx("div", {
    className: "text-center md:text-initial md:w-1/2 md:rtl:pr-8 pt-5 md:pt-16"
  }, ProductExclusiveCollectionSpace_jsx("div", {
    style: {
      width: '10rem'
    },
    className: "m-auto md:m-0"
  }, ProductExclusiveCollectionSpace_jsx(ImagePlaceholder["a" /* ImagePlaceholder */], {
    aspectRatio: 100 * ratios_utils["a" /* default */].values[ratios_utils["a" /* default */].XL]
  }, ProductExclusiveCollectionSpace_jsx("div", {
    className: "flex items-center justify-center h-full text-blue"
  }, ProductExclusiveCollectionSpace_jsx(Icon["a" /* Icon */], {
    className: "mb-5",
    color: colors["a" /* COLORS */].DEEP_BLUE,
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED_EXCLUSIVE,
    width: "10rem"
  })))), ProductExclusiveCollectionSpace_jsx(Title["a" /* Title */], {
    theme: "title-serif-1",
    className: "md:max-w-4/5 pt-4"
  }, Object(string_util["f" /* truncate */])(title, 60)), ProductExclusiveCollectionSpace_jsx(TextSeeMore["a" /* TextSeeMore */], {
    className: "mt-5 max-w-9/10",
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: true,
    seeLessLabel: Object(src_i18n["f" /* t */])('common.loadLess'),
    seeMoreLabel: Object(src_i18n["f" /* t */])('common.viewMore'),
    seeMoreSize: 110,
    text: text,
    theme: "text-sans-3"
  })), ProductExclusiveCollectionSpace_jsx("div", {
    className: "hidden md:block h-full image-responsive-cell inset-border-after mb-15 sm:mb-0 w-1/2"
  }, ProductExclusiveCollectionSpace_jsx(Image["a" /* default */], {
    imageUrl: mediaUrl,
    ratioKey: ratios_utils["a" /* default */].R_13_BY_12
  })));
}
// CONCATENATED MODULE: ./src/client/components/lines/product-exclusive-collection-space-line/ProductExclusiveCollectionSpaceLine.jsx
var ProductExclusiveCollectionSpaceLine_jsx = react_default.a.createElement;




function ProductExclusiveCollectionSpaceLine(_ref) {
  var config = _ref.config,
      id = _ref.id,
      mediaUrl = _ref.mediaUrl,
      text = _ref.text,
      title = _ref.title;
  Object(src_i18n["a" /* addTranslationKeys */])(config);
  return ProductExclusiveCollectionSpaceLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line",
    size: "medium"
  }, ProductExclusiveCollectionSpaceLine_jsx(ProductExclusiveCollectionSpace, {
    mediaUrl: mediaUrl,
    text: text,
    title: title
  }));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-exclusive-collection-space/productExclusiveCollectionSpace.resolver.js



var productExclusiveCollectionSpaceResolver = {
  name: constants["M" /* PRODUCT_EXCLUSIVE_COLLECTION_SPACE */],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }";
    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["hc" /* LINE_PRODUCT_EXCLUSIVE_COLLECTION_SPACE */],
      strictErrors: false
    });
  }
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-exclusive-collection-space/productExclusiveCollectionSpace.descriptor.js



var productExclusiveCollectionSpaceDescriptor = {
  name: constants["M" /* PRODUCT_EXCLUSIVE_COLLECTION_SPACE */],
  component: ProductExclusiveCollectionSpaceLine,
  resolver: productExclusiveCollectionSpaceResolver.resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-flash-info-line/ProductFlashInfoLine.jsx

var ProductFlashInfoLine_jsx = react_default.a.createElement;





var ProductFlashInfoLine_ProductFlashInfoLine = function ProductFlashInfoLine(_ref) {
  var close = _ref.config.common.close,
      editorialZone = _ref.editorialZone,
      id = _ref.id,
      seeMore = _ref.seeMore,
      title = _ref.title;

  if (!editorialZone) {
    return null;
  }

  var image = editorialZone.image,
      link = editorialZone.link,
      texts = editorialZone.texts;

  var _texts = Object(slicedToArray["a" /* default */])(texts, 3),
      _texts$ = _texts[0],
      headingTitle = _texts$ === void 0 ? '' : _texts$,
      _texts$2 = _texts[1],
      headingSubtitle = _texts$2 === void 0 ? '' : _texts$2,
      _texts$3 = _texts[2],
      text = _texts$3 === void 0 ? '' : _texts$3;

  return ProductFlashInfoLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductFlashInfoLine_jsx(LineTitle["a" /* LineTitle */], null, title), ProductFlashInfoLine_jsx(Card["a" /* Card */], {
    closeLabel: close,
    ctaLabel: seeMore,
    heading: {
      title: headingTitle,
      subtitle: headingSubtitle
    },
    link: {
      url: link
    },
    media: {
      alt: headingTitle,
      ratioKey: ratios_utils["a" /* default */].XS,
      url: image
    },
    text: {
      seeMoreLabel: seeMore,
      text: text
    }
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-flash-info/productFlashInfo.resolver.js
var productFlashInfo_resolver = __webpack_require__("YbGu");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-flash-info/productFlashInfo.descriptor.js



var productFlashInfoDescriptor = {
  name: constants["gb" /* RESORT_FLASH_INFO */],
  component: ProductFlashInfoLine_ProductFlashInfoLine,
  resolve: productFlashInfo_resolver["a" /* productFlashInfoResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-google-street-view-line/ProductGoogleStreetViewLine.jsx

var ProductGoogleStreetViewLine_jsx = react_default.a.createElement;





var ProductGoogleStreetViewLine_ProductGoogleStreetViewLine = function ProductGoogleStreetViewLine(_ref) {
  var _ref$config$common = _ref.config.common,
      close = _ref$config$common.close,
      productGoogleStreetView = _ref$config$common.maps.productGoogleStreetView,
      id = _ref.id,
      _ref$resort = _ref.resort,
      name = _ref$resort.name,
      streetView = _ref$resort.streetView;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var ratio = isTablet ? {
    w: 1280,
    h: 240
  } : {
    w: 852,
    h: 340
  };
  return ProductGoogleStreetViewLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, ProductGoogleStreetViewLine_jsx(GoogleStreetView, Object(esm_extends["a" /* default */])({}, streetView, {
    closeLabel: close,
    height: ratio.h,
    title: Object(dist["messageFormat"])(productGoogleStreetView).format({
      name: name
    }),
    width: ratio.w
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-google-street-view/productGoogleStreetView.resolver.js
var productGoogleStreetView_resolver = __webpack_require__("muDs");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-google-street-view/productGoogleStreetView.descriptor.js




var productGoogleStreetViewDescriptor = {
  name: constants["U" /* PRODUCT_STREET_VIEW */],
  component: ProductGoogleStreetViewLine_ProductGoogleStreetViewLine,
  resolve: productGoogleStreetView_resolver["a" /* productGoogleStreetViewResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-image-map-line/ProductImageMapLine.jsx

var ProductImageMapLine_jsx = react_default.a.createElement;






var ProductImageMapLine_ProductImageMapLine = function ProductImageMapLine(_ref) {
  var _ref$mapMobileDimensi = _ref.mapMobileDimensions,
      mapMobileDimensions = _ref$mapMobileDimensi === void 0 ? {
    w: 600,
    h: 500
  } : _ref$mapMobileDimensi,
      _ref$mapTabletRatio = _ref.mapTabletRatio,
      mapTabletRatio = _ref$mapTabletRatio === void 0 ? ratios_utils["a" /* default */].S : _ref$mapTabletRatio,
      _ref$resort = _ref.resort,
      resort = _ref$resort === void 0 ? {} : _ref$resort,
      title = _ref.title;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var altMsg = resort.name,
      imageUrl = resort.mapUrl;
  if (!imageUrl) return null;
  var map = {
    altMsg: altMsg,
    imageUrl: imageUrl
  };
  var mapConf = isTablet ? {
    ratioKey: mapTabletRatio,
    transformation: 'resize'
  } : {
    mandatoryWidthAndHeight: mapMobileDimensions
  };
  return ProductImageMapLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-ProductImageMap"
  }, ProductImageMapLine_jsx(Title["a" /* Title */], {
    className: "mb-8",
    theme: "title-sans-4"
  }, title), ProductImageMapLine_jsx(Image["a" /* default */], Object(esm_extends["a" /* default */])({}, map, mapConf)));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-image-map/productImageMap.resolver.js
var productImageMap_resolver = __webpack_require__("+MSq");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-image-map/productImageMap.descriptor.js



var productImageMapDescriptor = {
  name: constants["N" /* PRODUCT_IMAGE_MAP */],
  component: ProductImageMapLine_ProductImageMapLine,
  resolve: productImageMap_resolver["a" /* productImageMapResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/item/ImmersiveSlideShowItem.jsx
var ImmersiveSlideShowItem_jsx = react_default.a.createElement;



var ImmersiveSlideShowItem_ImmersiveSlideShowItem = function ImmersiveSlideShowItem(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      hasInsetBorder = _ref.hasInsetBorder,
      _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$insetBorderOffse = _ref.insetBorderOffset,
      insetBorderOffset = _ref$insetBorderOffse === void 0 ? 0 : _ref$insetBorderOffse,
      src = _ref.src;
  return ImmersiveSlideShowItem_jsx("div", {
    className: classnames_default()(className, 'relative'),
    key: src
  }, ImmersiveSlideShowItem_jsx(Hero["a" /* Hero */], {
    alt: alt,
    size: immersiveSize,
    url: src
  }), hasInsetBorder && ImmersiveSlideShowItem_jsx("div", {
    className: "absolute bottom-0 fadeIn h-full inset-border inset-x-0 pointer-events-none",
    style: {
      height: "calc(100% - ".concat(insetBorderOffset, "px)")
    }
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/hero/heroUtils.js
var heroUtils = __webpack_require__("5xkM");

// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/controls/ImmersiveSlideShowControls.jsx
var ImmersiveSlideShowControls_jsx = react_default.a.createElement;



var ImmersiveSlideShowControls_ImmersiveSlideShowControls = function ImmersiveSlideShowControls(_ref) {
  var className = _ref.className,
      style = _ref.style,
      isNextDisabled = _ref.isNextDisabled,
      isPrevDisabled = _ref.isPrevDisabled,
      nextLabel = _ref.nextLabel,
      onNext = _ref.onNext,
      onPrev = _ref.onPrev,
      previousLabel = _ref.previousLabel;
  return ImmersiveSlideShowControls_jsx("div", {
    className: classnames_default()(className, 'absolute flex items-center justify-between max-w-site m-auto inset-0 pointer-events-none w-full'),
    style: style
  }, !isPrevDisabled && ImmersiveSlideShowControls_jsx(ArrowButton["a" /* ArrowButton */], {
    className: "rtl:ml-5 lg:rtl:ml-0 rtl:mr-auto pointer-events-auto shadow-sm z-1",
    label: previousLabel,
    onClick: onPrev
  }), !isNextDisabled && ImmersiveSlideShowControls_jsx(ArrowButton["a" /* ArrowButton */], {
    className: "rtl:mr-5 lg:rtl:mr-0 rtl:ml-auto pointer-events-auto shadow-sm z-1",
    label: nextLabel,
    onClick: onNext,
    rotation: 180
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/large/ImmersiveSlideShowLarge.jsx
var ImmersiveSlideShowLarge_jsx = react_default.a.createElement;





var getInitialDisplayedIndex = function getInitialDisplayedIndex(length) {
  return Array(length).fill(false).map(function (_, idx) {
    return idx === length - 1 || idx < 2;
  });
};

var ImmersiveSlideShowLarge_ImmersiveSlideShowLarge = function ImmersiveSlideShowLarge(_ref) {
  var className = _ref.className,
      _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel;

  var _useState = Object(react["useState"])(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])(getInitialDisplayedIndex(items.length)),
      displayedIndex = _useState2[0],
      setDisplayedIndex = _useState2[1];

  Object(react["useEffect"])(function () {
    if (displayedIndex.every(Boolean)) return;
    var newDisplayedIndex = displayedIndex.map(function (isDisplayed, idx) {
      return isDisplayed || idx === activeIndex + 1 || idx === activeIndex - 1;
    });
    setDisplayedIndex(newDisplayedIndex);
  }, [activeIndex]);

  if (!items.length) {
    return null;
  }

  var increase = function increase() {
    activeIndex === items.length - 1 ? setActiveIndex(0) : setActiveIndex(activeIndex + 1);
  };

  var decrease = function decrease() {
    activeIndex === 0 ? setActiveIndex(items.length - 1) : setActiveIndex(activeIndex - 1);
  };

  var _getHeroDimensions = Object(heroUtils["e" /* getHeroDimensions */])(immersiveSize, true),
      height = _getHeroDimensions.height;

  return ImmersiveSlideShowLarge_jsx("div", {
    className: classnames_default()(className, 'overflow-hidden relative'),
    style: {
      height: height
    }
  }, items.map(function (item, idx) {
    return ImmersiveSlideShowLarge_jsx("div", {
      "aria-hidden": idx !== activeIndex,
      className: classnames_default()('absolute inset-0 transition-opacity-long', {
        'opacity-100': idx === activeIndex,
        'opacity-0': idx !== activeIndex
      }),
      key: idx,
      tabIndex: -1
    }, displayedIndex[idx] ? item : null);
  }), items.length > 1 && ImmersiveSlideShowLarge_jsx(ImmersiveSlideShowControls_ImmersiveSlideShowControls, {
    nextLabel: nextLabel,
    onNext: increase,
    onPrev: decrease,
    previousLabel: previousLabel
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/narrow/ImmersiveSlideShowNarrow.jsx
var ImmersiveSlideShowNarrow_jsx = react_default.a.createElement;





var PRELOADED_ITEMS_NB = 3;

var ImmersiveSlideShowNarrow_getInitialDisplayedIndex = function getInitialDisplayedIndex(length) {
  return Array(length).fill(false).fill(true, 0, PRELOADED_ITEMS_NB);
};

var ImmersiveSlideShowNarrow_ImmersiveSlideShowNarrow = function ImmersiveSlideShowNarrow(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel;

  var _useState = Object(react["useState"])(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])(ImmersiveSlideShowNarrow_getInitialDisplayedIndex(items.length)),
      displayedIndex = _useState2[0],
      setDisplayedIndex = _useState2[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var coef = isRTL ? -1 : 1;
  var containerRef = Object(react["useRef"])(null);

  var scroll = function scroll(index, e) {
    if (e) {
      e.preventDefault();
    }

    if (containerRef && containerRef.current) {
      containerRef.current.scrollTo({
        behavior: 'smooth',
        left: coef * containerRef.current.scrollWidth * (index / items.length)
      });
    }

    setActiveIndex(index);
  };

  var onScroll = Object(lodash["debounce"])(function () {
    if (containerRef && containerRef.current) {
      var pos = Math.round(coef * containerRef.current.scrollLeft / containerRef.current.scrollWidth * items.length);
      setActiveIndex(pos);
    }
  }, 150);
  Object(react["useEffect"])(function () {
    // $FlowFixMe
    containerRef.current.addEventListener('scroll', onScroll);
    return function () {
      // $FlowFixMe
      containerRef.current.removeEventListener('scroll', onScroll);
    };
  }, [coef]);
  Object(react["useEffect"])(function () {
    if (displayedIndex.every(Boolean)) return;
    var newDisplayedIndex = displayedIndex.map(function (_, idx) {
      return idx < activeIndex + PRELOADED_ITEMS_NB;
    });
    setDisplayedIndex(newDisplayedIndex);
  }, [activeIndex]);

  if (!items.length) {
    return null;
  }

  return ImmersiveSlideShowNarrow_jsx("div", {
    className: classnames_default()(className, 'overflow-hidden relative')
  }, ImmersiveSlideShowNarrow_jsx("div", {
    className: classnames_default()(className, 'flex flex-row flex-no-wrap overflow-auto scroll-snap-type-x-mandatory w-full'),
    dir: isRTL ? 'rtl' : 'ltr',
    ref: containerRef
  }, items.map(function (item, idx) {
    return ImmersiveSlideShowNarrow_jsx("div", {
      className: "flex-none overflow-visible scroll-snap-align-center w-full",
      key: idx,
      tabIndex: -1
    }, displayedIndex[idx] ? item : null);
  })), items.length > 1 && ImmersiveSlideShowNarrow_jsx(ImmersiveSlideShowControls_ImmersiveSlideShowControls, {
    className: isRTL ? 'rotate-180' : '',
    isNextDisabled: isRTL ? activeIndex === 0 : activeIndex === items.length - 1,
    isPrevDisabled: isRTL ? activeIndex === items.length - 1 : activeIndex === 0,
    nextLabel: nextLabel,
    onNext: function onNext(e) {
      return scroll(activeIndex + coef, e);
    },
    onPrev: function onPrev(e) {
      return scroll(activeIndex - coef, e);
    },
    previousLabel: previousLabel,
    style: {
      bottom: '50px'
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/ImmersiveSlideShow.jsx


var ImmersiveSlideShow_jsx = react_default.a.createElement;






var ImmersiveSlideShow_ImmersiveSlideShow = function ImmersiveSlideShow(_ref) {
  var _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      _ref$pictureAltLabel = _ref.pictureAltLabel,
      pictureAltLabel = _ref$pictureAltLabel === void 0 ? '' : _ref$pictureAltLabel,
      previousLabel = _ref.previousLabel,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["immersiveSize", "media", "nextLabel", "pictureAltLabel", "previousLabel"]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!media.length) {
    return null;
  }

  var items = media.map(function (src, idx) {
    return ImmersiveSlideShow_jsx(ImmersiveSlideShowItem_ImmersiveSlideShowItem, Object(esm_extends["a" /* default */])({}, rest, {
      alt: Object(dist["messageFormat"])(pictureAltLabel).format({
        nb: idx + 1
      }),
      immersiveSize: immersiveSize,
      key: src,
      src: src
    }));
  });
  return isDesktop ? ImmersiveSlideShow_jsx(ImmersiveSlideShowLarge_ImmersiveSlideShowLarge, {
    items: items,
    immersiveSize: immersiveSize,
    nextLabel: nextLabel,
    previousLabel: previousLabel
  }) : ImmersiveSlideShow_jsx(ImmersiveSlideShowNarrow_ImmersiveSlideShowNarrow, {
    items: items,
    nextLabel: nextLabel,
    previousLabel: previousLabel
  });
};
// CONCATENATED MODULE: ./src/client/components/utils/medias/medias.js


var _ICONS;


var MEDIA_TYPES = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
  VIDEOS360: 'videos360',
  SOCIALPICTURES: 'socialPictures'
};
var ORDERED_MEDIAS = [MEDIA_TYPES.PHOTOS, MEDIA_TYPES.VIDEOS, MEDIA_TYPES.VIDEOS360, MEDIA_TYPES.SOCIALPICTURES];
var ORDERED_MEDIAS_THUMBNAILS = [MEDIA_TYPES.VIDEOS360, MEDIA_TYPES.VIDEOS, MEDIA_TYPES.PHOTOS, MEDIA_TYPES.SOCIALPICTURES];
var ICONS = (_ICONS = {}, Object(defineProperty["a" /* default */])(_ICONS, MEDIA_TYPES.PHOTOS, icons["a" /* ICONS */].PHOTO_ALBUM), Object(defineProperty["a" /* default */])(_ICONS, MEDIA_TYPES.VIDEOS, icons["a" /* ICONS */].VIDEOS), Object(defineProperty["a" /* default */])(_ICONS, MEDIA_TYPES.VIDEOS360, icons["a" /* ICONS */].VIDEOS_360), Object(defineProperty["a" /* default */])(_ICONS, MEDIA_TYPES.SOCIALPICTURES, icons["a" /* ICONS */].INSTAGRAM), _ICONS);

// CONCATENATED MODULE: ./src/client/components/frameworks/action-buttons-group/ActionButtonsGroup.themes.js

var ActionButtonsGroup_themes_themes = function themes(_ref) {
  var isScrollable = _ref.isScrollable;
  return {
    "default": {
      thRoot: 'flex flex-wrap -m-px',
      thButton: 'cursor-pointer bg-blue focus:bg-turquoise hover:bg-turquoise capitalize flex flex-1 font-bold items-center justify-center m-px px-4 py-3 text-base text-white transition-bg-color w-full',
      thButtonActive: 'cursor-default bg-turquoise focus:bg-turquoise hover:bg-turquoise capitalize flex flex-1 font-bold items-center justify-center m-px pointer-events-none px-4 py-3 text-base text-white transition-bg-color w-full',
      thIcon: 'rtl:mr-2',
      thIconSize: '1.625rem',
      thText: 'text-initial',
      thNumber: 'block leading-one'
    },
    overlay: {
      thRoot: classnames_default()({
        'flex flex-wrap justify-center -m-px': !isScrollable,
        'flex overflow-x-scroll sm:overflow-hidden': isScrollable
      }),
      thButton: 'cursor-pointer bg-white focus:bg-overlay-black-60 hover:bg-overlay-black-60 capitalize flex font-bold items-center justify-between m-1 p-2 rounded-tiny text-sm text-gray focus:text-white hover:text-white transition-all',
      thButtonActive: 'cursor-default bg-overlay-black-60 focus:bg-overlay-black-60 hover:bg-overlay-black-60 capitalize flex font-bold items-center justify-between mx-1 p-2 pointer-events-none rounded-tiny text-sm text-white transition-all',
      thIcon: 'flex-shrink-0 rtl:mr-1 overflow-visible',
      thIconSize: '1rem',
      thText: 'flex flex-row-reverse font-bold justify-between w-full text-initial',
      thNumber: 'rtl:pl-1'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/action-buttons-group/ActionButtonsGroup.jsx
var ActionButtonsGroup_jsx = react_default.a.createElement;





var ActionButtonsGroup_ActionButtonsGroup = function ActionButtonsGroup(_ref) {
  var className = _ref.className,
      isScrollable = _ref.isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 'initial' : _ref$minWidth,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!items.length) {
    return null;
  }

  var _themes$theme = ActionButtonsGroup_themes_themes({
    isScrollable: isScrollable
  })[theme],
      thRoot = _themes$theme.thRoot,
      thButton = _themes$theme.thButton,
      thButtonActive = _themes$theme.thButtonActive,
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thText = _themes$theme.thText,
      thNumber = _themes$theme.thNumber;
  return ActionButtonsGroup_jsx("div", {
    className: classnames_default()(className, thRoot)
  }, items.map(function (_ref2) {
    var ariaLabel = _ref2.ariaLabel,
        iconName = _ref2.iconName,
        id = _ref2.id,
        isActive = _ref2.isActive,
        label = _ref2.label,
        number = _ref2.number,
        onClick = _ref2.onClick,
        trackingData = _ref2.trackingData;
    return ActionButtonsGroup_jsx(TrackClick["a" /* TrackClick */], {
      "aria-disabled": isActive,
      "aria-label": ariaLabel,
      as: "button",
      className: isActive ? thButtonActive : thButton,
      key: id,
      onClick: onClick,
      style: {
        minWidth: minWidth
      },
      trackingData: trackingData,
      type: "button"
    }, ActionButtonsGroup_jsx(Icon["a" /* Icon */], {
      className: thIcon,
      name: iconName,
      width: thIconSize
    }), ActionButtonsGroup_jsx("span", {
      className: thText
    }, ActionButtonsGroup_jsx("span", {
      className: thNumber
    }, number, ActionButtonsGroup_jsx("span", null, " ")), label));
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/avatar/Avatar.themes.js
var Avatar_themes_themes = {
  "default": {
    thRoot: 'flex items-center justify-center leading-normal max-w-full',
    thPicture: 'bg-gray-light flex-shrink-0 overflow-hidden rounded-full',
    thTexts: 'rtl:ml-2',
    thName: 'text-base truncate text-inherit',
    thTextTheme: 'text-sans2',
    thDescription: ''
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/avatar/Avatar.jsx
var Avatar_jsx = react_default.a.createElement;





function Avatar(props) {
  var className = props.className,
      _props$size = props.size,
      size = _props$size === void 0 ? 35 : _props$size,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      userDescription = props.userDescription,
      userName = props.userName,
      userPictureUrl = props.userPictureUrl;
  if (!userPictureUrl && !userName) return null;
  var styles = {
    width: size,
    height: size
  };
  var imageSize = {
    w: size,
    h: size
  };
  var _themes$theme = Avatar_themes_themes[theme],
      thDescription = _themes$theme.thDescription,
      thName = _themes$theme.thName,
      thPicture = _themes$theme.thPicture,
      thRoot = _themes$theme.thRoot,
      thTexts = _themes$theme.thTexts,
      thTextTheme = _themes$theme.thTextTheme;
  return Avatar_jsx("div", {
    className: classnames_default()(className, thRoot)
  }, userPictureUrl && Avatar_jsx("div", {
    className: thPicture,
    "data-testid": "Avatar-picture",
    style: styles
  }, Avatar_jsx(Image["a" /* default */], {
    altMsg: userName,
    forceImage: true,
    imageUrl: userPictureUrl,
    mandatoryWidthAndHeight: imageSize
  })), (!!userName || !!userDescription) && Avatar_jsx("div", {
    className: thTexts
  }, !!userName && Avatar_jsx("div", {
    className: thName,
    "data-testid": "Avatar-name"
  }, userName), !!userDescription && Avatar_jsx(Text["a" /* Text */], {
    className: thDescription,
    text: userDescription,
    theme: thTextTheme
  })));
}
// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.themes.js
var ProgressBar_themes_themes = {
  "default": {
    thSize: '0.125rem',
    thRoot: 'bg-gray-darker leading-none overflow-hidden relative',
    thBar: 'transition-width'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx
var ProgressBar_jsx = react_default.a.createElement;





var ProgressBar_ProgressBar = function ProgressBar(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 10 : _ref$max,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      value = _ref.value;

  if (!Object(lodash["isInteger"])(value) || value < 0) {
    return null;
  }

  var stepPercent = 100 / max;
  var currentPercent = stepPercent * value;
  var _themes$theme = ProgressBar_themes_themes[theme],
      thBar = _themes$theme.thBar,
      thRoot = _themes$theme.thRoot,
      thSize = _themes$theme.thSize;
  return ProgressBar_jsx("div", {
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value,
    className: classnames_default()(className, thRoot),
    role: "progressbar"
  }, ProgressBar_jsx("div", {
    className: classnames_default()(thBar, "bg-".concat(color)),
    "data-testid": "progress-bar",
    style: {
      width: "".concat(currentPercent, "%"),
      height: thSize
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/carousel/Carousel.jsx
var Carousel_jsx = react_default.a.createElement;






function Carousel(props) {
  var children = props.children,
      className = props.className,
      hasInfiniteScroll = props.hasInfiniteScroll,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      nextLabel = props.nextLabel,
      previousLabel = props.previousLabel;
  var childrenCount = react["Children"].toArray(children).filter(Boolean).length;
  if (!childrenCount) return null;
  return Carousel_jsx("div", {
    className: classnames_default()(className, 'overflow-hidden relative')
  }, Carousel_jsx(SliderHandler["a" /* SliderHandler */], {
    className: "h-full w-full",
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasSwipeSupport: true,
    initialIndex: initialIndex,
    items: children
  }, function (_ref) {
    var hasControls = _ref.hasControls,
        index = _ref.index,
        isNextControlDisabled = _ref.isNextControlDisabled,
        isPreviousControlDisabled = _ref.isPreviousControlDisabled,
        itemsNode = _ref.itemsNode,
        onNext = _ref.onNext,
        onPrevious = _ref.onPrevious;
    return Carousel_jsx("div", {
      className: "flex-1 flex pb-5 relative"
    }, itemsNode, hasControls && Carousel_jsx("div", {
      className: "absolute flex items-center justify-between m-auto inset-0 pointer-events-none px-5 w-full"
    }, !isPreviousControlDisabled && Carousel_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "rtl:mr-auto pointer-events-auto shadow-sm z-1",
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && Carousel_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "rtl:ml-auto pointer-events-auto shadow-sm z-1",
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasControls && Carousel_jsx("div", {
      className: "absolute bottom-0 left-0 w-full"
    }, Carousel_jsx(ProgressBar_ProgressBar, {
      color: colors["a" /* COLORS */].WHITE,
      max: childrenCount,
      min: 1,
      value: index + 1
    })));
  }));
}
// CONCATENATED MODULE: ./src/client/components/frameworks/media-thumbnail/MediaThumbnail.jsx
var MediaThumbnail_jsx = react_default.a.createElement;







function MediaThumbnail(props) {
  var alt = props.alt,
      children = props.children,
      className = props.className,
      hasForcedImage = props.hasForcedImage,
      hasLazyLoading = props.hasLazyLoading,
      iconName = props.iconName,
      onClick = props.onClick,
      _props$ratio = props.ratio,
      ratio = _props$ratio === void 0 ? ratios_utils["a" /* default */].M : _props$ratio,
      src = props.src,
      trackingData = props.trackingData;
  var hasChildren = !!react["Children"].count(children);
  if (!hasChildren && Object(lodash["isEmpty"])(src)) return null;
  return MediaThumbnail_jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    className: classnames_default()(className, 'bg-white reset-button block image-responsive-cell overflow-hidden relative w-full hover:opacity-75 transition-opacity'),
    onClick: onClick,
    trackingData: trackingData,
    type: "button"
  }, hasChildren ? children : MediaThumbnail_jsx(Image["a" /* default */], {
    altMsg: alt,
    forceImage: hasForcedImage,
    hasLazyLoading: hasLazyLoading,
    imageUrl: src,
    ratioKey: ratio
  }), !!iconName && MediaThumbnail_jsx("div", {
    className: "absolute bg-overlay-black-60 leading-none m-1 p-3 top-0 rtl:right-0 text-white",
    style: {
      width: '3.125rem',
      height: '3.125rem'
    }
  }, MediaThumbnail_jsx(Icon["a" /* Icon */], {
    name: iconName,
    width: "100%"
  })));
}
// EXTERNAL MODULE: /home/circleci/project/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/errors/errors.js + 3 modules
var errors_errors = __webpack_require__("wNDy");

// CONCATENATED MODULE: ./src/client/components/utils/youku-api/index.js



function getVideoThumbnailUrl(videoId) {
  var clientId = config_default.a.get('youku.clientId');

  if (!clientId) {
    return Promise.reject(new errors_errors["b" /* BadRequest */]('Missing Youku client Id'));
  }

  if (!videoId) {
    return Promise.reject(new errors_errors["b" /* BadRequest */]('Missing Youku video Id'));
  }

  return axios_default.a.get("https://api.youku.com/videos/show.json?client_id=".concat(clientId, "&video_id=").concat(videoId)).then(function (response) {
    return response.data.bigThumbnail || response.data.thumbnail || new errors_errors["d" /* NotFoundError */]('Youku video not found');
  })["catch"](function () {
    return null;
  });
}
// CONCATENATED MODULE: ./src/client/components/frameworks/image/YoukuThumbnail.jsx






var YoukuThumbnail_jsx = react_default.a.createElement;

function YoukuThumbnail_createSuper(Derived) { var hasNativeReflectConstruct = YoukuThumbnail_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function YoukuThumbnail_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var YoukuThumbnail_YoukuThumbnail = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(YoukuThumbnail, _Component);

  var _super = YoukuThumbnail_createSuper(YoukuThumbnail);

  function YoukuThumbnail(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, YoukuThumbnail);

    _this = _super.call(this, props);
    _this.state = {
      thumbnailUrl: null
    };
    return _this;
  }

  Object(createClass["a" /* default */])(YoukuThumbnail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var youkuRegEx = new RegExp('https://vthumb.ykimg.com/([a-zA-Z0-9]+)');
      var urlMatch = youkuRegEx.exec(this.props.imageUrl);

      if (urlMatch && urlMatch[1]) {
        getVideoThumbnailUrl(urlMatch[1]).then(function (youkuThumbnail) {
          _this2.setState({
            thumbnailUrl: youkuThumbnail
          });
        }).catch(function () {
          return null;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var thumbnailUrl = this.state.thumbnailUrl;
      return YoukuThumbnail_jsx(Image["a" /* default */], Object(esm_extends["a" /* default */])({}, this.props, {
        imageUrl: thumbnailUrl,
        forceImage: thumbnailUrl ? true : false
      }));
    }
  }]);

  return YoukuThumbnail;
}(react["Component"]);
// CONCATENATED MODULE: ./src/client/components/widgets/multimedia-launcher/MultimediaLauncher.jsx

var MultimediaLauncher_jsx = react_default.a.createElement;






var YOUKU_SRC = 'vthumb.ykimg.com';

function MultimediaLauncherThumbnail(props) {
  return props.src ? MultimediaLauncher_jsx(MediaThumbnail, Object(esm_extends["a" /* default */])({}, props, {
    hasLazyLoading: props.hasLazyLoading
  }), props.src.includes(YOUKU_SRC) ? MultimediaLauncher_jsx(YoukuThumbnail_YoukuThumbnail, {
    imageUrl: props.src,
    ratioKey: props.ratio
  }) : null) : null;
}

function MultimediaLauncher(props) {
  var className = props.className,
      hasLazyLoading = props.hasLazyLoading,
      isOverlay = props.isOverlay,
      items = props.items,
      _props$thumbnails = props.thumbnails,
      thumbnails = _props$thumbnails === void 0 ? [] : _props$thumbnails;
  var thumbs = thumbnails.filter(function (t) {
    return t.src;
  });

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet;

  return MultimediaLauncher_jsx("div", {
    className: classnames_default()(className, 'overflow-hidden')
  }, !isOverlay && MultimediaLauncher_jsx(react["Fragment"], null, isTablet ? MultimediaLauncher_jsx("div", {
    className: "fadeIn flex -m-px border-b-1 border-transparent"
  }, MultimediaLauncher_jsx("div", {
    className: "p-px w-1/2"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, thumbs[0], {
    hasLazyLoading: hasLazyLoading
  }))), MultimediaLauncher_jsx("div", {
    className: "flex flex-wrap w-1/2"
  }, MultimediaLauncher_jsx("div", {
    className: "w-1/2 p-px"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, thumbs[1], {
    hasLazyLoading: hasLazyLoading
  }))), MultimediaLauncher_jsx("div", {
    className: "w-1/2 p-px"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, thumbs[2], {
    hasLazyLoading: hasLazyLoading
  }))), MultimediaLauncher_jsx("div", {
    className: "w-1/2 p-px"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, thumbs[3], {
    hasLazyLoading: hasLazyLoading
  }))), MultimediaLauncher_jsx("div", {
    className: "w-1/2 p-px"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, thumbs[4], {
    hasLazyLoading: hasLazyLoading
  }))))) : MultimediaLauncher_jsx("div", {
    className: "fadeIn border-b-2 border-transparent"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, thumbs[0], {
    hasLazyLoading: hasLazyLoading
  })))), MultimediaLauncher_jsx(ActionButtonsGroup_ActionButtonsGroup, {
    className: "fadeIn",
    items: items,
    minWidth: isOverlay ? '6.25rem' : '8.4375rem',
    theme: isOverlay ? 'overlay' : 'default'
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/multimedia/Multimedia.jsx







var Multimedia_jsx = react_default.a.createElement;

function Multimedia_createSuper(Derived) { var hasNativeReflectConstruct = Multimedia_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Multimedia_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }














var Multimedia_Multimedia = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Multimedia, _Component);

  var _super = Multimedia_createSuper(Multimedia);

  function Multimedia(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Multimedia);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeCarousel", function () {
      _this.setState({
        activeMedias: '',
        carouselIndex: 0
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "showCarousel", function (type) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _this.setState({
        activeMedias: type,
        carouselIndex: index
      });
    });

    _this.state = {
      activeMedias: '',
      carouselIndex: 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(Multimedia, [{
    key: "getCarouselItems",

    /* Carousel */
    value: function getCarouselItems(type) {
      var _this$props = this.props,
          medias = _this$props.medias,
          _this$props$pictureAl = _this$props.pictureAltLabel,
          pictureAltLabel = _this$props$pictureAl === void 0 ? '' : _this$props$pictureAl;
      return (medias[type] || []).map(function (_ref, idx) {
        var alt = _ref.alt,
            imageLarge = _ref.imageLarge,
            url = _ref.url,
            userName = _ref.userName;
        var altMsg = alt || Object(dist["messageFormat"])(pictureAltLabel).format({
          nb: idx + 1,
          total: medias[type].length
        });

        if (type === MEDIA_TYPES.PHOTOS) {
          return Multimedia_jsx("div", {
            "data-testid": "MultimediaPhoto",
            key: url,
            className: "flex flex-1 h-full items-center justify-center max-w-full w-full overflow-hidden relative"
          }, Multimedia_jsx(Image["a" /* default */], {
            altMsg: altMsg,
            changeWidthButHeightIsAuto: true,
            className: "absolute top-1/2 left-1/2 max-w-full max-h-full -translate-50",
            hasLazyLoading: false,
            imageUrl: url
          }));
        }

        if (type === MEDIA_TYPES.SOCIALPICTURES) {
          return Multimedia_jsx("div", {
            "data-testid": "MultimediaSocialPicture",
            key: imageLarge,
            className: "flex flex-1 h-full items-center justify-center max-w-full w-full overflow-hidden relative"
          }, Multimedia_jsx(Image["a" /* default */], {
            altMsg: altMsg,
            changeWidthButHeightIsAuto: true,
            className: "absolute top-1/2 left-1/2 max-w-full max-h-full -translate-50",
            forceImage: true,
            hasLazyLoading: false,
            imageUrl: imageLarge
          }), Multimedia_jsx("div", {
            className: "absolute inset-x-0 bottom-0 p-4 text-center text-white w-full gradient-linear-transparent-black-80"
          }, Multimedia_jsx(Avatar, {
            userName: userName
          })));
        }

        return Multimedia_jsx(Video["a" /* Video */], {
          className: "flex flex-1 h-full items-center justify-center m-auto md:max-w-4/5 overflow-hidden static md:w-4/5",
          key: url,
          url: url
        });
      });
    }
    /* Medias */

  }, {
    key: "hasMedias",
    value: function hasMedias(isDesktop) {
      var _this2 = this;

      return Object.keys(this.props.medias).reduce(function (has, type) {
        return has || _this2.hasTypeMedias(type, isDesktop);
      }, false);
    }
  }, {
    key: "hasTypeMedias",
    value: function hasTypeMedias(type, isDesktop) {
      var hasTypeMedias = Array.isArray(Object(lodash["get"])(this.props, ['medias', type])) && Object(lodash["get"])(this.props, ['medias', type]).length > 0;

      if (type === MEDIA_TYPES.VIDEOS360) {
        return hasTypeMedias && isDesktop;
      }

      return hasTypeMedias;
    }
  }, {
    key: "mapThumbnails",
    value: function mapThumbnails(type, isDesktop) {
      var _this3 = this;

      var medias = this.hasTypeMedias(type, isDesktop) ? this.props.medias[type] : [];
      return medias.map(function (media, index) {
        return {
          alt: Object(dist["messageFormat"])(_this3.props.launcherPictureAltLabel || '').format({
            nb: index + 1,
            mediaType: _this3.props.labels && _this3.props.labels[type]
          }),
          hasForcedImage: !!media.thumbnailUrl,
          iconName: type === MEDIA_TYPES.PHOTOS ? '' : ICONS[type],
          onClick: function onClick() {
            return _this3.showCarousel(type, index);
          },
          ratio: _this3.props.ratioKey,
          src: media.thumbnailUrl || media.url || media.imageLarge || '',
          trackingData: {
            actionGA: 'media',
            labelGA: type
          }
        };
      });
    }
  }, {
    key: "getLauncherThumbnails",
    value: function getLauncherThumbnails(isDesktop) {
      var _this4 = this;

      return Object(lodash["flattenDeep"])(ORDERED_MEDIAS_THUMBNAILS.map(function (type) {
        return _this4.mapThumbnails(type, isDesktop);
      })).filter(function (i) {
        return !!i.src;
      });
    }
  }, {
    key: "getLauncherProps",
    value: function getLauncherProps(isDesktop) {
      var _this5 = this;

      var _this$props2 = this.props,
          _this$props2$labels = _this$props2.labels,
          labels = _this$props2$labels === void 0 ? {} : _this$props2$labels,
          _this$props2$medias = _this$props2.medias,
          medias = _this$props2$medias === void 0 ? {} : _this$props2$medias,
          openGalleryLabel = _this$props2.openGalleryLabel;
      return {
        items: ORDERED_MEDIAS.map(function (type) {
          return _this5.hasTypeMedias(type, isDesktop) ? {
            ariaLabel: openGalleryLabel ? "".concat(labels[type], " (").concat(Object(lodash["get"])(medias, [type], []).length, ") - ").concat(openGalleryLabel) : null,
            iconName: ICONS[type],
            id: type,
            isActive: type === _this5.state.activeMedias,
            label: labels[type],
            number: Object(lodash["get"])(medias, [type], []).length,
            onClick: function onClick() {
              return _this5.showCarousel(type);
            },
            trackingData: {
              actionGA: 'media',
              labelGA: type
            }
          } : null;
        }).filter(Boolean),
        // $FlowFixMe
        thumbnails: this.getLauncherThumbnails(isDesktop).slice(0, 5)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      return Multimedia_jsx(responsiveContext["a" /* default */].Consumer, null, function (_ref2) {
        var isDesktop = _ref2.isDesktop;
        if (!_this6.hasMedias(isDesktop)) return null;
        var _this6$state = _this6.state,
            activeMedias = _this6$state.activeMedias,
            carouselIndex = _this6$state.carouselIndex;
        var _this6$props = _this6.props,
            closeLabel = _this6$props.closeLabel,
            galleryLabel = _this6$props.galleryLabel,
            isOverlay = _this6$props.isOverlay,
            nextLabel = _this6$props.nextLabel,
            previousLabel = _this6$props.previousLabel;

        var items = _this6.getCarouselItems(activeMedias);

        var launcherProps = _this6.getLauncherProps(isDesktop);

        return Multimedia_jsx(react["Fragment"], null, Multimedia_jsx(MultimediaLauncher, {
          hasLazyLoading: true,
          isOverlay: isOverlay,
          items: launcherProps.items,
          thumbnails: launcherProps.thumbnails
        }), !!activeMedias && Multimedia_jsx(Backdrop["a" /* Backdrop */], {
          ariaLabel: galleryLabel,
          className: "frosted-glass-desaturated",
          closeLabel: closeLabel,
          hasCloseButton: true,
          onClose: _this6.closeCarousel
        }, Multimedia_jsx("div", {
          className: "h-full w-full flex flex-col"
        }, Multimedia_jsx(Carousel, {
          className: "flex-1 flex",
          hasInfiniteScroll: true,
          initialIndex: carouselIndex,
          key: Math.random(),
          nextLabel: nextLabel,
          previousLabel: previousLabel
        }, items), Multimedia_jsx("div", {
          className: "flex items-center justify-center px-2",
          style: {
            height: '72px'
          }
        }, Multimedia_jsx(ActionButtonsGroup_ActionButtonsGroup, {
          isScrollable: true,
          items: launcherProps.items,
          minWidth: "6.25rem",
          theme: "overlay"
        })))));
      });
    }
  }]);

  return Multimedia;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Multimedia_Multimedia, "defaultProps", {
  medias: {},
  ratioKey: ratios_utils["a" /* default */].L
});
// EXTERNAL MODULE: ./src/client/components/widgets/exclusive-collection-badge/ECBadge.jsx
var ECBadge = __webpack_require__("Itgl");

// CONCATENATED MODULE: ./src/client/components/widgets/product-immersive/product-immersive-narrow/ProductImmersiveNarrow.jsx

var ProductImmersiveNarrow_jsx = react_default.a.createElement;







var ICONS_HEIGHT = 27;
var ProductImmersiveNarrow_ProductImmersiveNarrow = function ProductImmersiveNarrow(_ref) {
  var _ref$badgeIcon = _ref.badgeIcon,
      badgeIcon = _ref$badgeIcon === void 0 ? {} : _ref$badgeIcon,
      hasInsetBorder = _ref.hasInsetBorder,
      hasECLogo = _ref.hasECLogo,
      infos = _ref.infos,
      media = _ref.media,
      nextLabel = _ref.nextLabel,
      pictureAltLabel = _ref.pictureAltLabel,
      previousLabel = _ref.previousLabel,
      size = _ref.size,
      title = _ref.title;
  return ProductImmersiveNarrow_jsx(react["Fragment"], null, ProductImmersiveNarrow_jsx("div", {
    className: "fadeInLong bg-white flex items-start p-1 py-2 w-full z-2",
    style: {
      marginTop: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT
    }
  }, ProductImmersiveNarrow_jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({}, badgeIcon, {
    className: "mx-1 rounded-tiny",
    size: ICONS_HEIGHT
  })), hasECLogo && (badgeIcon === null || badgeIcon === void 0 ? void 0 : badgeIcon.iconName) && ProductImmersiveNarrow_jsx("span", {
    className: "font-brand leading-none self-center text-sm"
  }, "&"), hasECLogo && ProductImmersiveNarrow_jsx(ECBadge["a" /* ECBadge */], {
    className: "mx-1",
    height: ICONS_HEIGHT
  }), ProductImmersiveNarrow_jsx("div", {
    className: "mx-1 flex-1"
  }, ProductImmersiveNarrow_jsx(Title["a" /* Title */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    className: "font-brand leading-one text-md w-full",
    hLevel: 1,
    theme: "none"
  }, ProductImmersiveNarrow_jsx("div", {
    "data-testid": "ProductImmersiveNarrow-title"
  }, title), !!(infos === null || infos === void 0 ? void 0 : infos.length) && ProductImmersiveNarrow_jsx("div", {
    className: "flex"
  }, ProductImmersiveNarrow_jsx("div", {
    className: "rtl:mr-1 font-brand leading-one text-sm text-gray-dark uppercase",
    "data-testid": "ProductImmersiveNarrow-info"
  }, infos[0]))))), ProductImmersiveNarrow_jsx("div", {
    className: "relative"
  }, ProductImmersiveNarrow_jsx(ImmersiveSlideShow_ImmersiveSlideShow, {
    hasInsetBorder: hasInsetBorder,
    immersiveSize: size,
    media: media,
    nextLabel: nextLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-immersive/ProductImmersive.jsx

var ProductImmersive_jsx = react_default.a.createElement;







var ProductImmersive_ProductImmersive = function ProductImmersive(_ref) {
  var badgeIcon = _ref.badgeIcon,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      galleryLabel = _ref.galleryLabel,
      hasInsetBorder = _ref.hasInsetBorder,
      hasECLogo = _ref.hasECLogo,
      id = _ref.id,
      _ref$infos = _ref.infos,
      infos = _ref$infos === void 0 ? [] : _ref$infos,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      multimedia = _ref.multimedia,
      multimediaLabels = _ref.multimediaLabels,
      nextLabel = _ref.nextLabel,
      openGalleryLabel = _ref.openGalleryLabel,
      pictureAltLabel = _ref.pictureAltLabel,
      previousLabel = _ref.previousLabel,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      title = _ref.title;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!media.length) {
    return null;
  }

  var multimediaStyle = isDesktop ? {
    bottom: '45px'
  } : {
    bottom: '80px'
  };
  return ProductImmersive_jsx("div", Object(esm_extends["a" /* default */])({
    className: classnames_default()('relative', className)
  }, id ? {
    id: id
  } : null), isDesktop ? ProductImmersive_jsx(ImmersiveSlideShow_ImmersiveSlideShow, {
    hasInsetBorder: hasInsetBorder,
    immersiveSize: size,
    insetBorderOffset: Navigation_constants["e" /* heights */].NAVIGATION_LARGE_HEIGHT,
    media: media,
    nextLabel: nextLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel
  }) : ProductImmersive_jsx(ProductImmersiveNarrow_ProductImmersiveNarrow, {
    badgeIcon: badgeIcon,
    hasECLogo: hasECLogo,
    hasInsetBorder: hasInsetBorder,
    infos: infos,
    media: media,
    nextLabel: nextLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel,
    size: size,
    title: title
  }), ProductImmersive_jsx("div", {
    className: "absolute w-full",
    style: multimediaStyle
  }, ProductImmersive_jsx(Multimedia_Multimedia, {
    closeLabel: closeLabel,
    galleryLabel: galleryLabel,
    isOverlay: true,
    labels: multimediaLabels,
    medias: multimedia,
    nextLabel: nextLabel,
    openGalleryLabel: openGalleryLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-immersive-line/ProductImmersiveLine.jsx

var ProductImmersiveLine_jsx = react_default.a.createElement;

function ProductImmersiveLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductImmersiveLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductImmersiveLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductImmersiveLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ProductImmersiveLine_PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;

var getProductInfos = function getProductInfos(_ref) {
  var dateRange = _ref.dateRange,
      duration = _ref.duration,
      _ref$destination = _ref.destination,
      destination = _ref$destination === void 0 ? {} : _ref$destination,
      fromToDestination = _ref.fromToDestination,
      type = _ref.type;
  var country = destination.country,
      area = destination.area;

  switch (type) {
    case ProductImmersiveLine_PRODUCT_TYPES.TOUR:
      return [duration].filter(Boolean);

    case ProductImmersiveLine_PRODUCT_TYPES.CRUISE:
      return [fromToDestination, dateRange].filter(Boolean);

    default:
      return [country, area].filter(Boolean);
  }
};

var ProductImmersiveLine_ProductImmersiveLine = function ProductImmersiveLine(_ref2) {
  var config = _ref2.config,
      cruise = _ref2.cruise,
      id = _ref2.id,
      media = _ref2.media,
      _ref2$resort = _ref2.resort,
      resort = _ref2$resort === void 0 ? {} : _ref2$resort,
      socialPictures = _ref2.socialPictures;
  var _resort$images = resort.images,
      images = _resort$images === void 0 ? [] : _resort$images,
      isExclusiveCollection = resort.isExclusiveCollection,
      isExplicitEC = resort.isExplicitEC,
      name = resort.name;
  Object(src_i18n["a" /* addTranslationKeys */])(config);
  var galleryLabel = name ? Object(src_i18n["f" /* t */])('common.galleries.productGallery', {
    productName: name
  }) : Object(src_i18n["f" /* t */])('common.galleries.gallery');
  var nextLabel = name ? Object(src_i18n["f" /* t */])('common.galleries.productNextPicture', {
    productName: name
  }) : Object(src_i18n["f" /* t */])('common.next');
  var previousLabel = name ? Object(src_i18n["f" /* t */])('common.galleries.productPreviousPicture', {
    productName: name
  }) : Object(src_i18n["f" /* t */])('common.previous');
  var pictureAltLabel = Object(src_i18n["f" /* t */])('common.galleries.productPictureItem', {
    total: images.length,
    productName: name
  });
  return ProductImmersiveLine_jsx(ProductImmersive_ProductImmersive, {
    badgeIcon: Object(product_utils["d" /* getProductBadgeIcon */])(resort),
    className: "Line Line-Immersive",
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    galleryLabel: galleryLabel,
    hasECLogo: isExplicitEC,
    hasInsetBorder: isExclusiveCollection,
    id: id,
    infos: getProductInfos(ProductImmersiveLine_objectSpread(ProductImmersiveLine_objectSpread({}, resort), cruise)),
    media: images,
    multimedia: ProductImmersiveLine_objectSpread(ProductImmersiveLine_objectSpread({}, media), {}, {
      socialPictures: socialPictures
    }),
    multimediaLabels: {
      photos: Object(src_i18n["f" /* t */])('common.photoTitle'),
      socialPictures: Object(src_i18n["f" /* t */])('common.socialPicturesTitle'),
      videos: Object(src_i18n["f" /* t */])('common.videoTitle'),
      videos360: Object(src_i18n["f" /* t */])('common.video360Title')
    },
    nextLabel: nextLabel,
    openGalleryLabel: Object(src_i18n["f" /* t */])('common.galleries.openSlideShowGallery'),
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel,
    title: name
  });
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-immersive/productImmersive.resolver.js
var productImmersive_resolver = __webpack_require__("AaDX");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-immersive/productImmersive.descriptor.js



var productImmersiveDescriptor = {
  name: constants["O" /* PRODUCT_IMMERSIVE */],
  component: ProductImmersiveLine_ProductImmersiveLine,
  resolve: productImmersive_resolver["a" /* productImmersiveResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-information-summary-line/ProductInformationSummaryLine.jsx
var ProductInformationSummaryLine_jsx = react_default.a.createElement;



function ProductInformationSummaryLine(_ref) {
  var downloadLabel = _ref.downloadLabel,
      id = _ref.id,
      factSheetUrl = _ref.resort.factSheetUrl,
      resortId = _ref.resortId,
      text = _ref.text;

  if (!factSheetUrl) {
    return null;
  }

  var links = [{
    label: downloadLabel,
    target: '_blank',
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'CTA_download_factsheet',
      labelGA: resortId
    },
    url: factSheetUrl
  }];
  return ProductInformationSummaryLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line Line-DownloadLinksList"
  }, ProductInformationSummaryLine_jsx(DownloadLinksList, {
    className: "bg-white py-5 shadow-bottom",
    links: links,
    text: text
  }));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-information-summary/productInformationSummary.resolver.js
var productInformationSummary_resolver = __webpack_require__("C2l2");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-information-summary/productInformationSummary.descriptor.js



var productInformationSummaryDescriptor = {
  name: constants["P" /* PRODUCT_INFORMATION_SUMMARY */],
  component: ProductInformationSummaryLine,
  resolve: productInformationSummary_resolver["a" /* productInformationSummaryResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/social-pictures-grid/SocialPicturesGrid.utils.js


function SocialPicturesGrid_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function SocialPicturesGrid_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      SocialPicturesGrid_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      SocialPicturesGrid_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var smallPictureStyle = {
  width: 'calc(50% - 8px)',
  display: 'inline-flex',
  flexGrow: '0'
};

var smallPictureOnTopStyle = SocialPicturesGrid_utils_objectSpread(SocialPicturesGrid_utils_objectSpread({}, smallPictureStyle), {}, {
  marginBottom: '16px',
  alignSelf: 'flex-end'
});

var smallPictureOnBottomStyle = SocialPicturesGrid_utils_objectSpread(SocialPicturesGrid_utils_objectSpread({}, smallPictureStyle), {}, {
  marginTop: '16px',
  alignSelf: 'flex-start'
});

function getSocialPictureGridLayout(length) {
  var styles = [];

  if (length < 9) {
    styles.push([{}, smallPictureOnBottomStyle, smallPictureOnBottomStyle]);
    styles.push([{}, smallPictureOnBottomStyle, smallPictureOnBottomStyle]);
    styles.push([smallPictureOnTopStyle, smallPictureOnTopStyle, {}]); // see, I wrote a nifty lil' thang back in the day (below), but now we've got
    // to make our component be pretty with less than the ideal number of pictures
    // so we ain't relying on anything random unless we're at 9 pictures because,
    // well, there aren't that many ways to make 5 pictures look great on 3 columns,
    // so for every other case, we're hardcoding these styles
  }

  for (var i = 0; i < 3; i++) {
    if (Math.random() > 0.5) {
      // just to spice it up a little, either we're returning styles for
      // picture(small, small, big) or picture(big, small, small) because
      // predictibility is overrated and truth is only hearsay
      styles.push([smallPictureOnTopStyle, smallPictureOnTopStyle, {}]);
    }

    styles.push([{}, smallPictureOnBottomStyle, smallPictureOnBottomStyle]);
  }

  return styles;
}
// CONCATENATED MODULE: ./src/client/components/widgets/social-pictures-grid/SocialPicturesGrid.jsx

var SocialPicturesGrid_jsx = react_default.a.createElement;

function SocialPicturesGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function SocialPicturesGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SocialPicturesGrid_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SocialPicturesGrid_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var fillUpScheme = {
  // hardcoding how we're filling the grid depending on how many pictures we have
  // is this the best way to do it? idk but It Works™
  // note: if we had the precise dimensions of the pictures beforehand we actually
  // could build a much more powerful layout engine but maybe that'd be overkill?
  '5': [1, 0, 1, 1, 0, 0, 1, 0, 1],
  '6': [1, 0, 1, 1, 1, 0, 1, 0, 1],
  '7': [1, 0, 1, 1, 1, 1, 1, 0, 1],
  '8': [1, 1, 1, 1, 1, 1, 1, 0, 1],
  '9': [1, 1, 1, 1, 1, 1, 1, 1, 1]
};
var SocialPicturesGrid_SocialPicturesGrid = function SocialPicturesGrid(props) {
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _props$pictures = props.pictures,
      pictures = _props$pictures === void 0 ? [] : _props$pictures;
  var numberOfPictures = pictures.length;
  var imageStyles = getSocialPictureGridLayout(numberOfPictures);

  if (Object(lodash["isEmpty"])(pictures)) {
    return null;
  }

  var paddedPictures = pictures.slice(0);
  var currentFillUpScheme = fillUpScheme[numberOfPictures];

  for (var i = 0; i < currentFillUpScheme.length; i++) {
    if (currentFillUpScheme[i] === 0) {
      paddedPictures.splice(i, 0, {});
    }
  }

  var MAX_NUMBER_OF_COLUMNS = isTablet ? 3 : 1;
  var formattedArray = [];

  for (var column = 0; column < MAX_NUMBER_OF_COLUMNS; column++) {
    var subArray = [];

    for (var item = 0; item < 3; item++) {
      if (isTablet) {
        subArray.push(paddedPictures[item + column * 3]);
      } else {
        subArray.push(pictures[item + column * 3]);
      }
    }

    formattedArray.push(subArray);
  }

  return SocialPicturesGrid_jsx(react["Fragment"], null, SocialPicturesGrid_jsx("div", {
    className: "flex justify-center -mx-2"
  }, formattedArray.map(function (array, primaryArrayIndex) {
    var currentImageStyles = imageStyles[primaryArrayIndex];
    return SocialPicturesGrid_jsx("div", {
      className: "flex flex-wrap self-center justify-between px-2 sm:w-1/3",
      key: primaryArrayIndex
    }, array.map(function (picture, secondaryArrayIndex) {
      return Object(lodash["isEmpty"])(picture) ? SocialPicturesGrid_jsx("div", {
        style: SocialPicturesGrid_objectSpread({
          borderRadius: '2px',
          width: '100%'
        }, currentImageStyles[secondaryArrayIndex])
      }) : SocialPicturesGrid_jsx("div", {
        className: "overflow-hidden",
        "data-testid": "SocialPicturesGrid-thumbnail",
        key: picture.src,
        style: SocialPicturesGrid_objectSpread({
          borderRadius: '2px',
          width: '100%'
        }, currentImageStyles[secondaryArrayIndex])
      }, SocialPicturesGrid_jsx(SocialPicture_SocialPicture, {
        src: picture.src,
        userName: picture.userName
      }));
    }));
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-instagram-line/ProductInstagramLine.jsx
var ProductInstagramLine_jsx = react_default.a.createElement;





var MIN_PICTURES_TO_SHOW = 5;
var MAX_PICTURES_TO_SHOW = 9;
var ProductInstagramLine_ProductInstagramLine = function ProductInstagramLine(_ref) {
  var _ref$socialPictures = _ref.socialPictures,
      socialPictures = _ref$socialPictures === void 0 ? [] : _ref$socialPictures,
      title = _ref.title;

  if (socialPictures.length < MIN_PICTURES_TO_SHOW) {
    return null;
  }

  var pictures = Object(lodash["slice"])(socialPictures, 0, MAX_PICTURES_TO_SHOW).map(function (_ref2) {
    var imageLarge = _ref2.imageLarge,
        imageSmall = _ref2.imageSmall,
        userName = _ref2.userName,
        canonicalUrl = _ref2.canonicalUrl;
    return {
      src: imageLarge,
      thumbnailSrc: imageSmall,
      canonicalUrl: canonicalUrl,
      userName: userName
    };
  });
  return ProductInstagramLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    size: "medium"
  }, ProductInstagramLine_jsx(LineTitle["a" /* LineTitle */], null, title), ProductInstagramLine_jsx(SocialPicturesGrid_SocialPicturesGrid, {
    pictures: pictures
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-instagram/productInstagram.resolver.js
var productInstagram_resolver = __webpack_require__("eaHo");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-instagram/productInstagram.descriptor.js



var productInstagramDescriptor = {
  name: constants["s" /* INSTAGRAM_GRID */],
  component: ProductInstagramLine_ProductInstagramLine,
  resolve: productInstagram_resolver["a" /* productInstagramResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-introduction-actions/ProductIntroductionActions.jsx
var ProductIntroductionActions_jsx = react_default.a.createElement;







var ProductIntroductionActions_ProductIntroductionActions = function ProductIntroductionActions(_ref) {
  var className = _ref.className,
      communityLabel = _ref.communityLabel,
      _ref$ratingImage = _ref.ratingImage,
      ratingImage = _ref$ratingImage === void 0 ? {} : _ref$ratingImage,
      _ref$seasonLink = _ref.seasonLink,
      seasonLink = _ref$seasonLink === void 0 ? {} : _ref$seasonLink;
  return ProductIntroductionActions_jsx("div", {
    className: classnames_default()(className, 'flex flex-col sm:flex-row items-center sm:items-stretch sm:-mx-2')
  }, ratingImage && ratingImage.src && ProductIntroductionActions_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'practicalInfos',
      labelGA: 'tripAdvisorAnchor'
    },
    className: "reset-anchor mx-2 border-1 border-solid leading-none p-2 rounded-tiny",
    url: "#tripadvisor"
  }, ProductIntroductionActions_jsx(Image["a" /* default */], {
    altMsg: ratingImage.alt,
    className: "",
    dontChangeAnything: true,
    imageUrl: ratingImage.src
  })), communityLabel && ProductIntroductionActions_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'wibilong',
      labelGA: 'seeQuestionsAndAnswers'
    },
    className: "bg-turquoise border-1 border-turquoise inline-flex items-center justify-center leading-one mx-2 mt-5 sm:mt-0 px-4 py-3 sm:py-2 rounded-tiny text-base text-white",
    url: "#wibilong"
  }, ProductIntroductionActions_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-1",
    name: icons["a" /* ICONS */].COMMUNITY
  }), communityLabel), seasonLink && seasonLink.url && ProductIntroductionActions_jsx(DynamicLink["a" /* default */], {
    className: "border-1 border-gray-light hover:border-turquoise font-bold inline-flex items-center justify-center leading-one mx-2 mt-5 sm:mt-0 px-4 py-3 sm:py-2 rounded-tiny text-base text-gray-darker hover:text-turquoise transition-colors",
    url: seasonLink.url
  }, ProductIntroductionActions_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-1",
    name: seasonLink.iconName
  }), seasonLink.label));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-introduction/ProductIntroduction.jsx
var ProductIntroduction_jsx = react_default.a.createElement;









var ProductIntroduction_ProductIntroduction = function ProductIntroduction(_ref) {
  var className = _ref.className,
      communityLabel = _ref.communityLabel,
      iconName = _ref.iconName,
      imageSrc = _ref.imageSrc,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      ratingImage = _ref.ratingImage,
      reduceLabel = _ref.reduceLabel,
      seasonLink = _ref.seasonLink,
      seeMoreLabel = _ref.seeMoreLabel,
      text = _ref.text,
      title = _ref.title;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop,
      isTablet = _useContext.isTablet;

  if (!title) {
    return null;
  }

  var seeMoreSize = isDesktop ? 120 : 90;

  var top = ProductIntroduction_jsx(ProductIntroductionActions_ProductIntroductionActions, {
    className: "mb-5",
    communityLabel: communityLabel,
    ratingImage: ratingImage,
    seasonLink: seasonLink
  });

  var logo = ProductIntroduction_jsx("div", {
    className: "sm:inline-block mb-8 sm:mb-5 text-blue text-center"
  }, ProductIntroduction_jsx(Icon["a" /* Icon */], {
    alt: productName,
    isNotSquare: true,
    name: iconName,
    width: isDesktop ? '7rem' : '5rem'
  }), productName && ProductIntroduction_jsx("p", {
    className: "reset-paragraph"
  }, productName), productCountry && ProductIntroduction_jsx("p", {
    className: "reset-paragraph"
  }, productCountry));

  var content = ProductIntroduction_jsx(react["Fragment"], null, ProductIntroduction_jsx(Title["a" /* Title */], {
    className: "mb-5",
    theme: "title-brand-2"
  }, Object(string_util["f" /* truncate */])(title, 50)), ProductIntroduction_jsx(TextSeeMore["a" /* TextSeeMore */], {
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: true,
    seeLessLabel: reduceLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize,
    text: text,
    theme: "text-sans-3"
  }));

  return isTablet ? ProductIntroduction_jsx("article", {
    className: className
  }, top, ProductIntroduction_jsx("div", {
    className: "flex"
  }, ProductIntroduction_jsx("div", {
    className: "h-full relative rtl:pr-3 w-1/2 image-responsive-cell z-0"
  }, ProductIntroduction_jsx(Image["a" /* default */], {
    imageUrl: imageSrc,
    className: "rounded-tiny overflow-hidden",
    ratioKey: ratios_utils["a" /* default */].R_63_BY_58
  }), ProductIntroduction_jsx("div", {
    className: "absolute bg-white rtl:right-0 z-1 rounded-tiny",
    style: {
      width: '11%',
      height: '80%',
      top: '10%'
    }
  })), ProductIntroduction_jsx("div", {
    className: "w-1/2 px-3 lg:pt-5 lg:rtl:pr-24"
  }, logo, content))) : ProductIntroduction_jsx("article", {
    className: className
  }, logo, top, content);
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-introduction-exclusive-collection/ProductIntroductionExclusiveCollection.jsx
var ProductIntroductionExclusiveCollection_jsx = react_default.a.createElement;










var ProductIntroductionExclusiveCollection_ProductIntroductionExclusiveCollection = function ProductIntroductionExclusiveCollection(_ref) {
  var className = _ref.className,
      communityLabel = _ref.communityLabel,
      iconName = _ref.iconName,
      imageSrc = _ref.imageSrc,
      ratingImage = _ref.ratingImage,
      reduceLabel = _ref.reduceLabel,
      seasonLink = _ref.seasonLink,
      seeMoreLabel = _ref.seeMoreLabel,
      text = _ref.text,
      title = _ref.title;

  if (!title) {
    return null;
  }

  return ProductIntroductionExclusiveCollection_jsx("article", {
    className: classnames_default()(className)
  }, ProductIntroductionExclusiveCollection_jsx(ProductIntroductionActions_ProductIntroductionActions, {
    className: "my-5",
    communityLabel: communityLabel,
    ratingImage: ratingImage,
    seasonLink: seasonLink
  }), ProductIntroductionExclusiveCollection_jsx("div", {
    className: "flex"
  }, ProductIntroductionExclusiveCollection_jsx("div", {
    className: "hidden md:block h-full image-responsive-cell inset-border-after mb-15 sm:mb-0 sm:rtl:mr-5 sm:w-2/5"
  }, ProductIntroductionExclusiveCollection_jsx(Image["a" /* default */], {
    imageUrl: imageSrc,
    ratioKey: ratios_utils["a" /* default */].R_65_BY_48
  })), ProductIntroductionExclusiveCollection_jsx("div", {
    className: "text-center md:w-3/5 lg:px-24 lg:pt-16"
  }, ProductIntroductionExclusiveCollection_jsx(Icon["a" /* Icon */], {
    className: "border-5 border-deepBlue p-2 mb-9 lg:mb-15",
    color: colors["a" /* COLORS */].DEEP_BLUE,
    isNotSquare: true,
    name: iconName,
    width: "8.875rem"
  }), ProductIntroductionExclusiveCollection_jsx(Title["a" /* Title */], {
    theme: "title-serif-1"
  }, Object(string_util["f" /* truncate */])(title, 50)), ProductIntroductionExclusiveCollection_jsx(TextSeeMore["a" /* TextSeeMore */], {
    className: "mt-9 lg:mt-15",
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: true,
    seeLessLabel: reduceLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: 110,
    text: text,
    theme: "text-sans-3"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-introduction-line/ProductIntroductionLine.jsx
var ProductIntroductionLine_jsx = react_default.a.createElement;






var ProductIntroductionLine_ProductIntroductionLine = function ProductIntroductionLine(_ref) {
  var _ref$config = _ref.config,
      _ref$config$common = _ref$config.common,
      loadLess = _ref$config$common.loadLess,
      viewMore = _ref$config$common.viewMore,
      _ref$config$resort$re = _ref$config.resort.resortIntroduction,
      communityLabel = _ref$config$resort$re.communityLabel,
      toSummerLabel = _ref$config$resort$re.toSummerLabel,
      toWinterLabel = _ref$config$resort$re.toWinterLabel,
      hasCommunityButton = _ref.hasCommunityButton,
      hasSeasonButton = _ref.hasSeasonButton,
      hasTripadvisorButton = _ref.hasTripadvisorButton,
      id = _ref.id,
      imageSrc = _ref.imageSrc,
      questions = _ref.productCommunity.questions,
      _ref$resort = _ref.resort,
      descriptionTitle = _ref$resort.descriptionTitle,
      description = _ref$resort.description,
      country = _ref$resort.destination.country,
      icon = _ref$resort.icon,
      _ref$resort$images = _ref$resort.images,
      images = _ref$resort$images === void 0 ? [] : _ref$resort$images,
      isDoubleSeason = _ref$resort.isDoubleSeason,
      isExclusiveCollection = _ref$resort.isExclusiveCollection,
      isWinter = _ref$resort.isWinter,
      linkedResort = _ref$resort.linkedResort,
      name = _ref$resort.name,
      _ref$resort$tripadvis = _ref$resort.tripadvisor,
      _ref$resort$tripadvis2 = _ref$resort$tripadvis.rating,
      rating = _ref$resort$tripadvis2 === void 0 ? '' : _ref$resort$tripadvis2,
      _ref$resort$tripadvis3 = _ref$resort$tripadvis.ratingImageUrl,
      ratingImageUrl = _ref$resort$tripadvis3 === void 0 ? '' : _ref$resort$tripadvis3;
  var props = {
    communityLabel: config_default.a.get('social.wibilong.enabled') && questions.length && hasCommunityButton ? communityLabel : '',
    iconName: icon,
    imageSrc: imageSrc || images[2] || images[1] || images[0],
    productCountry: country,
    productName: name,
    ratingImage: hasTripadvisorButton ? {
      alt: "Tripadvisor: ".concat(rating),
      src: ratingImageUrl
    } : null,
    reduceLabel: loadLess,
    seasonLink: isDoubleSeason || !hasSeasonButton ? null : {
      iconName: isWinter ? icons["a" /* ICONS */].SUN : icons["a" /* ICONS */].MOUNTAIN,
      label: isWinter ? toSummerLabel : toWinterLabel,
      url: linkedResort && linkedResort.href
    },
    seeMoreLabel: viewMore,
    title: descriptionTitle,
    text: description
  };
  return ProductIntroductionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line",
    size: isExclusiveCollection ? 'large' : 'medium'
  }, isExclusiveCollection ? ProductIntroductionLine_jsx(ProductIntroductionExclusiveCollection_ProductIntroductionExclusiveCollection, props) : ProductIntroductionLine_jsx(ProductIntroduction_ProductIntroduction, props));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-introduction/productIntroduction.resolver.js
var productIntroduction_resolver = __webpack_require__("g73z");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-introduction/productIntroduction.descriptor.js



var productIntroductionDescriptor = {
  name: constants["ib" /* RESORT_INTRODUCTION */],
  component: ProductIntroductionLine_ProductIntroductionLine,
  resolve: productIntroduction_resolver["a" /* productIntroductionResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-meeting-room-info-line/ProductMeetingRoomInfoLine.jsx


var ProductMeetingRoomInfoLine_jsx = react_default.a.createElement;

function ProductMeetingRoomInfoLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductMeetingRoomInfoLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductMeetingRoomInfoLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductMeetingRoomInfoLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var MEETING_ROOM_SHAPES = dist["constants"].MEETING_ROOM_SHAPES;
var SHAPE_NOT_AVAILABLE = '-';

var ProductMeetingRoomInfoLine_getMeetingRoomCapacityByShape = function getMeetingRoomCapacityByShape(_ref) {
  var meetingRoom = _ref.meetingRoom,
      shape = _ref.shape;
  var meetingRoomShape = meetingRoom.shapes.find(function (_ref2) {
    var type = _ref2.type;
    return type === shape;
  });
  return meetingRoomShape && meetingRoomShape.maxCapacity ? Object(src_i18n["f" /* t */])('productMeetingRoomInfoLine.people', {
    max_capacity: meetingRoomShape.maxCapacity
  }) : SHAPE_NOT_AVAILABLE;
};

var ProductMeetingRoomInfoLine_ProductMeetingRoomInfoLine = function ProductMeetingRoomInfoLine(_ref3) {
  var _shapeLabels;

  var productMeetingRooms = _ref3.productMeetingRooms,
      translationKeys = Object(objectWithoutProperties["a" /* default */])(_ref3, ["productMeetingRooms"]);

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet,
      isRTL = _useContext.isRTL;

  Object(src_i18n["a" /* addTranslationKeys */])({
    productMeetingRoomInfoLine: translationKeys
  });

  if (productMeetingRooms.meetingRooms.length === 0 || productMeetingRooms.availableMeetingRoomShapes.length === 0) {
    return null;
  }

  var availableMeetingRoomShapes = productMeetingRooms.availableMeetingRoomShapes,
      meetingRooms = productMeetingRooms.meetingRooms;
  var shapeLabels = (_shapeLabels = {}, Object(defineProperty["a" /* default */])(_shapeLabels, MEETING_ROOM_SHAPES.USHAPE, Object(src_i18n["f" /* t */])('productMeetingRoomInfoLine.ushape')), Object(defineProperty["a" /* default */])(_shapeLabels, MEETING_ROOM_SHAPES.BOARDROOM, Object(src_i18n["f" /* t */])('productMeetingRoomInfoLine.boardroom')), Object(defineProperty["a" /* default */])(_shapeLabels, MEETING_ROOM_SHAPES.CLASSROOM, Object(src_i18n["f" /* t */])('productMeetingRoomInfoLine.classroom')), Object(defineProperty["a" /* default */])(_shapeLabels, MEETING_ROOM_SHAPES.THEATRE, Object(src_i18n["f" /* t */])('productMeetingRoomInfoLine.theatre')), _shapeLabels);
  var headerCellStyle = 'bg-blue text-white h-16 font-brand text-md text-center font-normal leading-tight';
  var firstColStickyStyle = 'border-none px-6 absolute md:static rtl:left-0 md:inset-auto break-words';
  var contentRowClasses = 'text-center h-16 text-base font-sans leading-one';
  var stickyWrapperStyle = isRTL ? {
    marginRight: !isTablet ? '12.1rem' : undefined
  } : {
    marginLeft: !isTablet ? '12.1rem' : undefined
  };
  var colBorderStyle = !isTablet ? '2px solid white' : undefined;
  var colBorder = isRTL ? {
    borderLeft: colBorderStyle
  } : {
    borderRight: colBorderStyle
  };
  var firstColWidth = !isTablet ? '12rem' : undefined;

  var contentToRender = ProductMeetingRoomInfoLine_jsx("div", {
    className: classnames_default()('mt-3 mb-5 md:my-16 md:w-full overflow-x-scroll md:overflow-x-hidden', {
      Line: !isTablet
    }),
    style: stickyWrapperStyle
  }, ProductMeetingRoomInfoLine_jsx("table", {
    className: "w-full",
    style: {
      borderSpacing: isTablet ? '2px' : '0px'
    }
  }, ProductMeetingRoomInfoLine_jsx("thead", null, ProductMeetingRoomInfoLine_jsx("tr", null, ProductMeetingRoomInfoLine_jsx("th", {
    className: "".concat(firstColStickyStyle, " ").concat(headerCellStyle, " flex justify-center items-center"),
    style: {
      width: firstColWidth
    }
  }, Object(src_i18n["f" /* t */])('productMeetingRoomInfoLine.meetingRoomsTitle')), availableMeetingRoomShapes.map(function (shape) {
    return ProductMeetingRoomInfoLine_jsx("th", {
      key: shape,
      className: headerCellStyle,
      style: ProductMeetingRoomInfoLine_objectSpread({
        minWidth: '8rem'
      }, colBorder)
    }, shapeLabels[shape]);
  }))), ProductMeetingRoomInfoLine_jsx("tbody", null, meetingRooms.map(function (meetingRoom, index) {
    var _meetingRoom$length, _meetingRoom$width, _meetingRoom$length2, _meetingRoom$width2, _meetingRoom$area, _meetingRoom$area2;

    return ProductMeetingRoomInfoLine_jsx("tr", {
      key: meetingRoom.label,
      className: "".concat(contentRowClasses)
    }, ProductMeetingRoomInfoLine_jsx("td", {
      className: classnames_default()(firstColStickyStyle, {
        'bg-gray-lighter': index % 2 === 0
      }),
      style: {
        width: firstColWidth,
        lineHeight: !meetingRoom.length && !meetingRoom.width && !meetingRoom.area ? 3 : undefined
      }
    }, ProductMeetingRoomInfoLine_jsx("p", {
      className: "font-bold break-words truncate"
    }, meetingRoom.label), ProductMeetingRoomInfoLine_jsx("p", null, meetingRoom.length && meetingRoom.width ? Object(src_i18n["f" /* t */])('productMeetingRoomInfoLine.lengthWidth', {
      length_value: ((_meetingRoom$length = meetingRoom.length) === null || _meetingRoom$length === void 0 ? void 0 : _meetingRoom$length.value) || '',
      width_value: ((_meetingRoom$width = meetingRoom.width) === null || _meetingRoom$width === void 0 ? void 0 : _meetingRoom$width.value) || '',
      length_width_unit: ((_meetingRoom$length2 = meetingRoom.length) === null || _meetingRoom$length2 === void 0 ? void 0 : _meetingRoom$length2.unit) || ((_meetingRoom$width2 = meetingRoom.width) === null || _meetingRoom$width2 === void 0 ? void 0 : _meetingRoom$width2.unit) || ''
    }) : null, meetingRoom.length && meetingRoom.width && meetingRoom.area ? " ".concat(Object(src_i18n["f" /* t */])('productMeetingRoomInfoLine.lengthWidthAreaSeparator'), " ") : null, meetingRoom.area ? Object(src_i18n["f" /* t */])('productMeetingRoomInfoLine.area', {
      area_value: ((_meetingRoom$area = meetingRoom.area) === null || _meetingRoom$area === void 0 ? void 0 : _meetingRoom$area.value) || '',
      area_unit: ((_meetingRoom$area2 = meetingRoom.area) === null || _meetingRoom$area2 === void 0 ? void 0 : _meetingRoom$area2.unit) || ''
    }) : null)), availableMeetingRoomShapes.map(function (shape) {
      var meetingRoomCapacity = ProductMeetingRoomInfoLine_getMeetingRoomCapacityByShape({
        meetingRoom: meetingRoom,
        shape: shape
      });
      return ProductMeetingRoomInfoLine_jsx("td", {
        key: shape,
        className: classnames_default()('leading-tight', {
          'bg-gray-lighter': index % 2 === 0
        }),
        style: ProductMeetingRoomInfoLine_objectSpread({
          minWidth: '8rem',
          lineHeight: '5'
        }, colBorder),
        "aria-hidden": meetingRoomCapacity === SHAPE_NOT_AVAILABLE
      }, meetingRoomCapacity);
    }));
  }))));

  return isTablet ? ProductMeetingRoomInfoLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, contentToRender) : contentToRender;
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-meeting-room-info/productMeetingRoomInfo.resolver.js
var productMeetingRoomInfo_resolver = __webpack_require__("+dj+");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-meeting-room-info/productMeetingRoomInfo.descriptor.js



var productMeetingRoomInfoDescriptor = {
  name: constants["jb" /* RESORT_MEETING_ROOM_INFO */],
  component: ProductMeetingRoomInfoLine_ProductMeetingRoomInfoLine,
  resolve: productMeetingRoomInfo_resolver["a" /* productMeetingRoomInfoResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-multimedia-line/ProductMultimediaLine.jsx

var ProductMultimediaLine_jsx = react_default.a.createElement;

function ProductMultimediaLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductMultimediaLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductMultimediaLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductMultimediaLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ProductMultimediaLine_ProductMultimediaLine = function ProductMultimediaLine(_ref) {
  var config = _ref.config,
      id = _ref.id,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? {} : _ref$media,
      name = _ref.resort.name,
      socialPictures = _ref.socialPictures,
      title = _ref.title;
  var photos = media.photos,
      videos = media.videos,
      videos360 = media.videos360;
  Object(src_i18n["a" /* addTranslationKeys */])(config);

  if (!(photos === null || photos === void 0 ? void 0 : photos.length) && !(videos === null || videos === void 0 ? void 0 : videos.length) && !(videos360 === null || videos360 === void 0 ? void 0 : videos360.length) && !(socialPictures === null || socialPictures === void 0 ? void 0 : socialPictures.length)) {
    return null;
  }

  var galleryLabel = name ? Object(src_i18n["f" /* t */])('common.galleries.productGallery', {
    productName: name
  }) : Object(src_i18n["f" /* t */])('common.galleries.gallery');
  var nextLabel = name ? Object(src_i18n["f" /* t */])('common.galleries.productNextPicture', {
    productName: name
  }) : Object(src_i18n["f" /* t */])('common.next');
  var previousLabel = name ? Object(src_i18n["f" /* t */])('common.galleries.productPreviousPicture', {
    productName: name
  }) : Object(src_i18n["f" /* t */])('common.previous');
  return ProductMultimediaLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductMultimediaLine_jsx(LineTitle["a" /* LineTitle */], null, title), ProductMultimediaLine_jsx(Multimedia_Multimedia, {
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    galleryLabel: galleryLabel,
    labels: {
      photos: Object(src_i18n["f" /* t */])('common.photoTitle'),
      socialPictures: Object(src_i18n["f" /* t */])('common.socialPicturesTitle'),
      videos: Object(src_i18n["f" /* t */])('common.videoTitle'),
      videos360: Object(src_i18n["f" /* t */])('common.video360Title')
    },
    launcherPictureAltLabel: Object(src_i18n["f" /* t */])('common.galleries.openProductSlideShowGalleryAt', {
      productName: name
    }),
    medias: ProductMultimediaLine_objectSpread(ProductMultimediaLine_objectSpread({}, media), {}, {
      socialPictures: socialPictures
    }),
    nextLabel: nextLabel,
    openGalleryLabel: Object(src_i18n["f" /* t */])('common.galleries.openSlideShowGallery'),
    pictureAltLabel: Object(src_i18n["f" /* t */])('common.galleries.productPictureItem', {
      productName: name
    }),
    previousLabel: previousLabel
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-multimedia/productMultimedia.resolver.js
var productMultimedia_resolver = __webpack_require__("VUEF");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-multimedia/productMultimedia.descriptor.js



var productMultimediaDescriptor = {
  name: constants["kb" /* RESORT_MULTIMEDIA */],
  component: ProductMultimediaLine_ProductMultimediaLine,
  resolve: productMultimedia_resolver["a" /* productMultimediaResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-must-try-card/ProductMustTryCard.jsx
var ProductMustTryCard_jsx = react_default.a.createElement;





function ProductMustTryCard(props) {
  var className = props.className,
      description = props.description,
      imageSrc = props.imageSrc,
      seeMoreLabel = props.seeMoreLabel,
      title = props.title,
      trackingData = props.trackingData;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  return ProductMustTryCard_jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    className: classnames_default()(className, 'reset-button overflow-hidden relative text-initial w-full h-full'),
    "data-testid": "ProductMustTryCard",
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    },
    trackingData: trackingData
  }, ProductMustTryCard_jsx("div", {
    className: "relative h-full pb-12"
  }, ProductMustTryCard_jsx("div", {
    className: "bg-gray-darker rounded-tiny overflow-hidden image-responsive-cell"
  }, ProductMustTryCard_jsx(Image["a" /* default */], {
    altMsg: "",
    groupKey: "thumbnails",
    hasLazyLoading: true,
    imageUrl: imageSrc,
    ratioKey: ratios_utils["a" /* default */].R_38_BY_28
  })), ProductMustTryCard_jsx("p", {
    className: "reset-paragraph px-4 pt-4 text-center text-md leading-tight overflow-hidden",
    style: {
      maxHeight: '55px'
    }
  }, title), !!seeMoreLabel && ProductMustTryCard_jsx("p", {
    className: "reset-paragraph my-4 text-center text-sm underline absolute bottom-0 inset-x-0"
  }, seeMoreLabel), ProductMustTryCard_jsx("div", {
    className: classnames_default()('absolute top-full bg-white max-h-full overflow-y-auto mt-1 mx-1 pt-5 px-5 pb-1 rounded-tiny text-center transition-transform', {
      '-translate-y-100': isExpanded,
      'translate-y-0': !isExpanded
    })
  }, ProductMustTryCard_jsx("p", {
    className: "reset-paragraph mb-5 text-lg"
  }, title), ProductMustTryCard_jsx("p", {
    className: "reset-paragraph text-base"
  }, description))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-must-try/ProductMustTryLarge.jsx
var ProductMustTryLarge_jsx = react_default.a.createElement;










function ProductMustTryLarge(props) {
  var className = props.className,
      isFrench = props.isFrench,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      productColor = props.productColor,
      productIconName = props.productIconName;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  return ProductMustTryLarge_jsx("div", {
    className: classnames_default()(className, 'relative -mx-5 overflow-hidden')
  }, ProductMustTryLarge_jsx("div", {
    className: "absolute bg-".concat(productColor, " flex justify-center overflow-hidden p-5 top-0 rounded-tiny w-full"),
    style: {
      height: '24.375rem'
    }
  }, ProductMustTryLarge_jsx("div", {
    className: classnames_default()('relative px-15', {
      'pt-3': isFrench
    })
  }, ProductMustTryLarge_jsx("div", {
    className: "absolute opacity-25 top-0 rtl:left-0"
  }, ProductMustTryLarge_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLACK,
    isNotSquare: true,
    name: productIconName,
    width: "8.75rem"
  })), ProductMustTryLarge_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].WHITE,
    name: isFrench ? icons["a" /* ICONS */].MUST_TRY_EXPERIENCES_FR : icons["a" /* ICONS */].MUST_TRY_EXPERIENCES,
    width: isFrench ? '11rem' : '10rem'
  }))), ProductMustTryLarge_jsx(SliderHandler["a" /* SliderHandler */], {
    className: "-mx-2",
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items.map(function (item) {
      return ProductMustTryLarge_jsx("div", {
        className: "px-2 relative h-full",
        key: item.title
      }, ProductMustTryLarge_jsx(ProductMustTryCard, item));
    }),
    nbItemsToScroll: 1,
    nbItemsToShow: isDesktop ? 4 : 3
  }, function (_ref) {
    var hasControls = _ref.hasControls,
        isNextControlDisabled = _ref.isNextControlDisabled,
        isPreviousControlDisabled = _ref.isPreviousControlDisabled,
        itemsNode = _ref.itemsNode,
        onNext = _ref.onNext,
        onPrevious = _ref.onPrevious;
    return ProductMustTryLarge_jsx("div", {
      className: "relative mt-24 mx-5"
    }, itemsNode, hasControls && ProductMustTryLarge_jsx("div", {
      className: "absolute flex items-center justify-between inset-0 pointer-events-none w-full"
    }, !isPreviousControlDisabled && ProductMustTryLarge_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto rtl:-ml-2",
      colorBg: colors["a" /* COLORS */].WHITE,
      color: colors["a" /* COLORS */].GRAY_DARKER,
      label: Object(src_i18n["f" /* t */])('common.previous'),
      onClick: onPrevious
    }), !isNextControlDisabled && ProductMustTryLarge_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto rtl:-mr-2 rtl:ml-auto",
      colorBg: colors["a" /* COLORS */].WHITE,
      color: colors["a" /* COLORS */].GRAY_DARKER,
      label: Object(src_i18n["f" /* t */])('common.next'),
      onClick: onNext,
      rotation: 180
    })));
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-must-try/ProductMustTryNarrow.jsx
var ProductMustTryNarrow_jsx = react_default.a.createElement;







function ProductMustTryNarrow(props) {
  var className = props.className,
      isFrench = props.isFrench,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      productColor = props.productColor,
      productIconName = props.productIconName,
      scrollBackwardLabel = props.scrollBackwardLabel,
      scrollForwardLabel = props.scrollForwardLabel;
  return ProductMustTryNarrow_jsx("div", {
    className: classnames_default()(className, 'relative')
  }, ProductMustTryNarrow_jsx("div", {
    className: "absolute bg-".concat(productColor, " p-5 inset-0 text-center"),
    style: {
      height: '24.375rem'
    }
  }, ProductMustTryNarrow_jsx("div", {
    className: "absolute opacity-25 top-0 rtl:left-0 pt-3"
  }, ProductMustTryNarrow_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLACK,
    isNotSquare: true,
    name: productIconName,
    width: "8.75rem"
  })), ProductMustTryNarrow_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].WHITE,
    name: isFrench ? icons["a" /* ICONS */].MUST_TRY_EXPERIENCES_FR : icons["a" /* ICONS */].MUST_TRY_EXPERIENCES,
    width: isFrench ? '12.5rem' : '10rem'
  })), ProductMustTryNarrow_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: scrollBackwardLabel,
    className: "pt-24",
    forwardLabel: scrollForwardLabel,
    navPosition: "center"
  }, ProductMustTryNarrow_jsx("div", {
    className: "flex px-3"
  }, items.map(function (_ref) {
    var description = _ref.description,
        id = _ref.id,
        imageSrc = _ref.imageSrc,
        seeMoreLabel = _ref.seeMoreLabel,
        title = _ref.title,
        trackingData = _ref.trackingData;
    return ProductMustTryNarrow_jsx("div", {
      key: id,
      className: "flex-none m-2",
      style: {
        width: '280px'
      }
    }, ProductMustTryNarrow_jsx(ProductMustTryCard, {
      description: description,
      imageSrc: imageSrc,
      seeMoreLabel: seeMoreLabel,
      title: title,
      trackingData: trackingData
    }));
  }), ProductMustTryNarrow_jsx("div", {
    className: "pr-3"
  }))));
}
// CONCATENATED MODULE: ./src/client/components/lines/product-must-try-line/ProductMustTryLine.jsx

var ProductMustTryLine_jsx = react_default.a.createElement;







var ProductMustTryLine_ProductMustTryLine = function ProductMustTryLine(_ref) {
  var _ref$config$common = _ref.config.common,
      scrollBackward = _ref$config$common.scrollBackward,
      scrollForward = _ref$config$common.scrollForward,
      id = _ref.id,
      isFrench = _ref.isFrench,
      mustTryExperiences = _ref.mustTryExperiences,
      _ref$resort = _ref.resort,
      productColor = _ref$resort.color,
      productName = _ref$resort.name,
      productIconName = _ref$resort.icon,
      seeMore = _ref.seeMore,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;
  var items = (mustTryExperiences || []).map(function (_ref2) {
    var itemId = _ref2.id,
        itemTitle = _ref2.title,
        image = _ref2.image,
        description = _ref2.description;
    return {
      description: description,
      id: itemId,
      imageSrc: image,
      seeMoreLabel: seeMore,
      title: itemTitle,
      trackingData: {
        categoryGA: 'cards',
        actionGA: 'must_try',
        labelGA: itemTitle || null
      }
    };
  });

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!items.length) {
    return null;
  }

  var props = {
    isFrench: isFrench,
    items: items,
    productColor: productColor,
    productIconName: productIconName
  };

  var titleNode = ProductMustTryLine_jsx(LineTitle["a" /* LineTitle */], null, Object(dist["messageFormat"])(title).format({
    productName: productName
  }));

  return isTablet ? ProductMustTryLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, titleNode, ProductMustTryLine_jsx(ProductMustTryLarge, props)) : ProductMustTryLine_jsx("div", Object(esm_extends["a" /* default */])({}, id ? {
    id: id
  } : null, {
    className: "Line"
  }), titleNode, ProductMustTryLine_jsx(ProductMustTryNarrow, Object(esm_extends["a" /* default */])({}, props, {
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-must-try-experiences/productMustTryExperiences.resolver.js
var productMustTryExperiences_resolver = __webpack_require__("BthO");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-must-try-experiences/productMustTryExperiences.descriptor.js



var productMustTryExperiencesDescriptor = {
  name: constants["x" /* MUST_TRY_EXPERIENCES */],
  component: ProductMustTryLine_ProductMustTryLine,
  props: productMustTryExperiences_resolver["a" /* productMustTryExperiencesResolver */].props,
  resolve: productMustTryExperiences_resolver["a" /* productMustTryExperiencesResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaContext.jsx
var CriteriaContext = __webpack_require__("XiOS");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/PriceRemoteContext.js

var PriceRemoteContext_jsx = react_default.a.createElement;

function PriceRemoteContext_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function PriceRemoteContext_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      PriceRemoteContext_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      PriceRemoteContext_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var initialState = {
  isCompact: false,
  isDetailOpened: false,
  isInLayer: false,
  isJoyview: false,
  isOverrideSticky: true,
  isTotalPrice: false,
  submitPriceRemoteForm: function submitPriceRemoteForm() {}
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  return PriceRemoteContext_objectSpread(PriceRemoteContext_objectSpread({}, state), action);
};

var PriceRemoteContext = /*#__PURE__*/Object(react["createContext"])([initialState, function () {}]);
var PriceRemoteContext_PriceRemoteContextProvider = function PriceRemoteContextProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react["useReducer"])(criteriaContextReducer, PriceRemoteContext_objectSpread(PriceRemoteContext_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return PriceRemoteContext_jsx(PriceRemoteContext.Provider, {
    value: [state, dispatch]
  }, children);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/CriteriaTransport.jsx
var CriteriaTransport = __webpack_require__("NWzG");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/CriteriaWhen.jsx
var CriteriaWhen = __webpack_require__("Go22");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/CriteriaWho.jsx
var CriteriaWho = __webpack_require__("wKzQ");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/hooks/use-set-url-with-facetings/useSetUrlWithFacetings.js






var FACET_QUERY_PARAMS = [uri_constants["f" /* QUERY_DEPARTURE_DATE */], uri_constants["g" /* QUERY_DURATION */], uri_constants["h" /* QUERY_KIDS */], uri_constants["k" /* QUERY_TRANSPORT */]];
var useSetUrlWithFacetings_useSetUrlWithFacetings = function useSetUrlWithFacetings(props) {
  var currentUrlHasNoQueryParams = function currentUrlHasNoQueryParams() {
    var currentQuery = props.uri.query(true);
    return FACET_QUERY_PARAMS.every(function (queryKey) {
      return Object(lodash["isEmpty"])(currentQuery[queryKey]);
    });
  };

  var computeQueryParamsForUrl = function computeQueryParamsForUrl(_ref) {
    var _ref2;

    var criteriaKeysToPersist = _ref.criteriaKeysToPersist;
    var departureCity = props.departureCity,
        departureDate = props.departureDate,
        duration = props.duration,
        kids = props.kids,
        kidsValidationState = props.kidsValidationState;
    var formattedDate = departureDate && Object(facetingUtils["d" /* getDepartureDateDisplayValue */])(Object(facetingUtils["a" /* formatDepartureDateForStore */])(departureDate, ''));
    return _ref2 = {}, Object(defineProperty["a" /* default */])(_ref2, uri_constants["f" /* QUERY_DEPARTURE_DATE */], criteriaKeysToPersist.includes(uri_constants["f" /* QUERY_DEPARTURE_DATE */]) && formattedDate || undefined), Object(defineProperty["a" /* default */])(_ref2, uri_constants["g" /* QUERY_DURATION */], criteriaKeysToPersist.includes(uri_constants["g" /* QUERY_DURATION */]) && duration || undefined), Object(defineProperty["a" /* default */])(_ref2, uri_constants["k" /* QUERY_TRANSPORT */], criteriaKeysToPersist.includes(uri_constants["k" /* QUERY_TRANSPORT */]) && departureCity !== 'NO' && departureCity || undefined), Object(defineProperty["a" /* default */])(_ref2, uri_constants["h" /* QUERY_KIDS */], criteriaKeysToPersist.includes(uri_constants["h" /* QUERY_KIDS */]) && kids.length > 0 && Object(facetingUtils["h" /* serializeKidsToQueryParam */])({
      kids: kids,
      kidsValidationState: kidsValidationState
    }) || undefined), _ref2;
  };

  var persistCriteriaInUrl = function persistCriteriaInUrl(options) {
    // NOTE: URI.setQuery() does not remove existing queries
    var queryParams = computeQueryParamsForUrl(options);
    var searchPageUrl = props.uri.clone().hash(null).setQuery(queryParams);
    redirectUtils["a" /* default */].redirectTo()(searchPageUrl, {
      shallow: true
    });
  };

  var isInitialMount = Object(react["useRef"])(true);
  Object(react["useEffect"])(function () {
    if (isInitialMount.current) {
      isInitialMount.current = false;

      if (currentUrlHasNoQueryParams()) {
        persistCriteriaInUrl({
          criteriaKeysToPersist: [uri_constants["f" /* QUERY_DEPARTURE_DATE */], uri_constants["g" /* QUERY_DURATION */], uri_constants["k" /* QUERY_TRANSPORT */], uri_constants["h" /* QUERY_KIDS */]]
        });
      }
    } else {
      persistCriteriaInUrl({
        criteriaKeysToPersist: FACET_QUERY_PARAMS
      });
    }
  }, [props.departureDate, props.duration, props.departureCity, props.kids]);
};
// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/faceting/kidsValidationStateUtils.js
var kidsValidationStateUtils = __webpack_require__("cGFA");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-form/PriceRemoteForm.jsx


var PriceRemoteForm_jsx = react_default.a.createElement;

function PriceRemoteForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PriceRemoteForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PriceRemoteForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PriceRemoteForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







































 // TODO: A sortir dans un fichier, mutaliser avec SearchForm

var PriceRemoteForm_SubmitButton = function SubmitButton(_ref) {
  var label = _ref.label,
      isStickyAndIsDesktop = _ref.isStickyAndIsDesktop;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var stickyAndDesktopWidth = isStickyAndIsDesktop ? 180 : 250;
  var width = isDesktop ? stickyAndDesktopWidth : '100%';
  return PriceRemoteForm_jsx(Button["a" /* Button */], {
    className: "flex flex-1 justify-center items-center px-1 lg:px-0 max-w-full",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].SUCCESS,
    colorBorder: colors["a" /* COLORS */].SUCCESS,
    minWidth: "initial",
    size: "large",
    style: {
      minWidth: 80,
      height: 52,
      width: width
    },
    type: "submit"
  }, label && Object(string_util["f" /* truncate */])(label, 40) || PriceRemoteForm_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS
  }));
};

var PriceRemoteForm_selector = function selector(state) {
  return {
    adults: Object(storeHelper["a" /* getAdults */])(state),
    adultsNumber: Object(storeHelper["b" /* getAdultsNumber */])(state),
    departureCity: Object(tripCriteria_selector["a" /* getDepartureCity */])(state),
    departureDate: Object(tripCriteria_selector["b" /* getDepartureDate */])(state),
    duration: Object(tripCriteria_selector["c" /* getTripDuration */])(state),
    initialDuration: Object(calendar_selector["h" /* getInitialDuration */])(state),
    kids: Object(storeHelper["c" /* getKids */])(state),
    kidsValidationState: Object(lodash["get"])(state, 'faceting.kidsValidationState'),
    prices: Object(calendar_selector["i" /* getPricesByDays */])(state)
  };
};

var PriceRemoteForm_PriceRemoteForm = function PriceRemoteForm(_ref2) {
  var className = _ref2.className,
      departureCities = _ref2.departureCities,
      initialTransport = _ref2.initialTransport,
      isJoyview = _ref2.isJoyview,
      isStickyAndIsDesktop = _ref2.isStickyAndIsDesktop,
      productId = _ref2.productId,
      urgentisationRate = _ref2.urgentisationRate;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);

  var _useContext2 = Object(react["useContext"])(PriceRemoteContext),
      priceRemoteContext = _useContext2[0],
      setPriceRemoteContext = _useContext2[1];

  var _useContext3 = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext3[0];

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var _useSelector = Object(es["e" /* useSelector */])(PriceRemoteForm_selector),
      adults = _useSelector.adults,
      adultsNumber = _useSelector.adultsNumber,
      departureCity = _useSelector.departureCity,
      departureDate = _useSelector.departureDate,
      duration = _useSelector.duration,
      initialDuration = _useSelector.initialDuration,
      kids = _useSelector.kids,
      kidsValidationState = _useSelector.kidsValidationState,
      prices = _useSelector.prices;

  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var track = Object(useTracking["a" /* useTracking */])();
  var isReadyForBookingEngine = criteriaContext.criteriaWhenIsSet && criteriaContext.criteriaWhoIsSet && criteriaContext.criteriaTransportIsSet;
  var uri = Object(uriUtils["c" /* convertLocationToURI */])(location);
  useSetUrlWithFacetings_useSetUrlWithFacetings({
    adultsNumber: adultsNumber,
    departureCity: departureCity,
    departureDate: departureDate,
    duration: duration,
    kids: kids,
    kidsValidationState: kidsValidationState,
    uri: uri
  });

  var changeCity = function changeCity(value) {
    var sendGAEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    dispatchCriteriaDisplayContext({
      type: CriteriaDisplayContext["a" /* ACTIONS */].CLOSE_CRITERIA,
      payload: 'criteriaTransport'
    });
    dispatch(Object(facetingSearch_action["a" /* changeDepartureCity */])(value));

    if (sendGAEvent) {
      track({
        actionGA: 'priceBar',
        labelGA: "departureCity_".concat(value),
        categoryGA: pageContext.pageId
      });
    }
  };

  Object(react["useEffect"])(function () {
    var isDepartureCityAvailable = departureCities.find(function (_ref3) {
      var value = _ref3.value;
      return value === departureCity;
    });

    if (initialTransport && (!departureCity || !isDepartureCityAvailable)) {
      changeCity(initialTransport, initialTransport !== faceting_constants["i" /* DEFAULT_DEPARTURE_CITY_VALUE */]);
    }
  }, [initialTransport]);
  Object(react["useEffect"])(function () {
    dispatch(fetchCalendar({
      resortId: productId,
      duration: duration || initialDuration || duration_constants["b" /* DEFAULT_TRIP_DURATION */],
      transport: departureCity || initialTransport,
      urgentisationRate: urgentisationRate
    }, appContext));
  }, [departureCity, productId]);
  var availableDurations = useAvailableDurations_useAvailableDurations({
    initialTransport: initialTransport,
    productId: productId
  });
  Object(react["useEffect"])(function () {
    // Clean departureDate and duration if they are incompatibles
    if (departureDate && duration && availableDurations && availableDurations.length > 0 && !availableDurations.includes(duration)) {
      dispatch(Object(facetingSearch_action["h" /* resetCalendarCriteria */])());
    }
  }, [departureDate, duration, availableDurations]);

  var handleMandatoryFields = function handleMandatoryFields() {
    if (!departureDate || !duration) {
      setPriceRemoteContext({
        isCompact: false
      });
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWhen'
      });
    } else if (!criteriaContext.criteriaWhoIsSet) {
      var validationState = Object(kidsValidationStateUtils["e" /* invalidateNotValidatedKids */])(kidsValidationState);
      dispatch(Object(facetingSearch_action["n" /* setKidsValidationState */])(validationState));
      setPriceRemoteContext({
        isCompact: false
      });
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
    }

    if (!departureCity) {
      changeCity(faceting_constants["i" /* DEFAULT_DEPARTURE_CITY_VALUE */]);
    }
  };

  var onSubmit = function onSubmit(event) {
    if (event) {
      event.preventDefault();
    }

    handleMandatoryFields();
    track({
      actionGA: 'priceBar',
      labelGA: "".concat(isReadyForBookingEngine ? 'continue' : 'organise_your_holiday'),
      categoryGA: pageContext.pageId
    });

    if (isReadyForBookingEngine) {
      var departureCityOption = departureCities.find(function (city) {
        return city.value === departureCity;
      });
      var trackingParams = {
        departureCityName: departureCityOption ? departureCityOption.label : undefined,
        shouldTrackTransport: true
      };
      var newArrivalDate = Object(apiDate["l" /* timestampToApiDate */])(departureDate);

      var fetchParams = PriceRemoteForm_objectSpread(PriceRemoteForm_objectSpread({}, newArrivalDate ? {
        newArrivalDate: newArrivalDate
      } : null), {}, {
        departureCity: departureCity,
        duration: duration || 7,
        globalLoaderLabel: Object(src_i18n["f" /* t */])('booking.form.proposalsLoaderLabel'),
        isJoyView: isJoyview,
        productId: productId,
        bookingEngineEntry: booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE
      }, Object(sellerUtils["g" /* isSeller */])(appContext) ? Object(ContactInfoUtils["f" /* getAllAttendeesIds */])({
        adults: adults,
        kids: kids
      }) : null);

      dispatch(Object(proposals_action["j" /* fetchProposalsAndRedirect */])(fetchParams, trackingParams, appContext, location));
    }
  };

  Object(react["useEffect"])(function () {
    setPriceRemoteContext({
      submitPriceRemoteForm: onSubmit
    });
  }, [isReadyForBookingEngine]);
  return PriceRemoteForm_jsx("form", {
    className: className,
    id: PRICE_REMOTE_FORM_ID,
    onSubmit: onSubmit
  }, PriceRemoteForm_jsx(SiteContainer["a" /* SiteContainer */], null, PriceRemoteForm_jsx("div", null, PriceRemoteForm_jsx("div", {
    className: "lg:flex lg:flex-row"
  }, PriceRemoteForm_jsx("div", {
    className: classnames_default()({
      'flex -mx-1 lg:mx-0 lg:flex-2': !priceRemoteContext.isCompact,
      hidden: priceRemoteContext.isCompact
    })
  }, PriceRemoteForm_jsx("div", {
    className: "flex-1 lg:mr-2 px-1 lg:px-0",
    "data-testid": "search-form-criteria-when"
  }, PriceRemoteForm_jsx(CriteriaWhen["a" /* CriteriaWhen */], {
    durationOptions: (availableDurations === null || availableDurations === void 0 ? void 0 : availableDurations.length) ? availableDurations : [],
    prices: prices,
    productId: productId
  })), PriceRemoteForm_jsx("div", {
    className: "flex-1 lg:mx-2 px-1 lg:px-0",
    "data-testid": "search-form-criteria-who"
  }, PriceRemoteForm_jsx(CriteriaWho["a" /* CriteriaWho */], {
    hasChildcareSwitch: false,
    isKidBirthdateRequired: true
  })), PriceRemoteForm_jsx("div", {
    className: "flex-1 lg:mx-2 px-1 lg:px-0",
    "data-testid": "search-form-criteria-transport"
  }, PriceRemoteForm_jsx(CriteriaTransport["a" /* CriteriaTransport */], {
    departureCitiesOptions: departureCities
  }))), PriceRemoteForm_jsx("div", {
    className: "mt-2 lg:mt-0 lg:ml-2 max-w-full"
  }, PriceRemoteForm_jsx(PriceRemoteForm_SubmitButton, {
    label: isReadyForBookingEngine ? Object(src_i18n["f" /* t */])('common.continue') : Object(src_i18n["f" /* t */])('priceRemote.priceRemoteButton'),
    isStickyAndIsDesktop: isStickyAndIsDesktop
  }))))));
};
// EXTERNAL MODULE: ./src/hooks/use-debounce/useDebounce.js
var useDebounce = __webpack_require__("ngAq");

// EXTERNAL MODULE: /home/circleci/project/node_modules/reselect/lib/index.js
var reselect_lib = __webpack_require__("hqKg");

// CONCATENATED MODULE: ./src/client/store/price-remote/priceRemote.selector.js
var priceRemote_selector_priceRemoteSelector = function priceRemoteSelector(_ref) {
  var priceRemote = _ref.priceRemote;
  return priceRemote || {};
};
// CONCATENATED MODULE: ./src/client/store/price-remote/price-of-stay/priceOfStay.selector.js



var priceOfStaySelector = Object(reselect_lib["createSelector"])(priceRemote_selector_priceRemoteSelector, function (_ref) {
  var data = _ref.priceOfStay.data;
  return data;
});
var proposalsSelector = Object(reselect_lib["createSelector"])(priceOfStaySelector, function (_ref2) {
  var proposals = _ref2.proposals;
  return proposals || {};
});
var priceOfStayIsLoadingSelector = Object(reselect_lib["createSelector"])(calendar_selector["c" /* getCalendarLoading */], priceRemote_selector_priceRemoteSelector, function (state) {
  return state.priceTicket.isLoading;
}, function (calendarIsLoading, _ref3, priceTicketIsLoading) {
  var _ref3$priceOfStay = _ref3.priceOfStay,
      priceOfStay = _ref3$priceOfStay.data,
      priceOfStayIsLoading = _ref3$priceOfStay.isLoading,
      lastRequestId = _ref3$priceOfStay.lastRequestId;
  return !priceOfStay && (calendarIsLoading || priceTicketIsLoading) || lastRequestId !== -1 && priceOfStayIsLoading;
});
// EXTERNAL MODULE: ./src/client/store/priceTicket/constants.js
var priceTicket_constants = __webpack_require__("0OJc");

// CONCATENATED MODULE: ./src/client/store/priceTicket/priceTicket.actions.js



function priceTicketRequest(_ref) {
  var appContext = _ref.appContext,
      duration = _ref.duration,
      forceAdultPerTrip = _ref.forceAdultPerTrip,
      location = _ref.location,
      productId = _ref.productId,
      transport = _ref.transport;
  return Object(createAction["a" /* createOptimisticAction */])(priceTicket_constants["a" /* default */], {}, {
    optimist: true,
    promise: fetchPrice({
      appContext: appContext,
      duration: duration,
      forceAdultPerTrip: forceAdultPerTrip,
      location: location,
      productId: productId,
      transport: transport
    })
  });
}
// CONCATENATED MODULE: ./src/client/store/price-remote/price-of-stay/priceOfStay.helper.js


function priceOfStay_helper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceOfStay_helper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceOfStay_helper_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceOfStay_helper_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var priceOfStay_helper_getChildrenBirthdates = function getChildrenBirthdates(_ref) {
  var _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids;
  return (// $FlowFixMe flow could not predict value after a filter and a map
    kids.filter(function (_ref2) {
      var birthdate = _ref2.birthdate;
      return !!birthdate;
    }).map(function (kid) {
      return Object(dateUtils["c" /* formatTimestampDate */])(kid.birthdate, apiDate["a" /* API_DATE_FORMAT */]);
    })
  );
};

var getNumberAttendees = function getNumberAttendees(_ref3) {
  var _ref3$adults = _ref3.adults,
      adults = _ref3$adults === void 0 ? [] : _ref3$adults,
      _ref3$kids = _ref3.kids,
      kids = _ref3$kids === void 0 ? [] : _ref3$kids;
  var kidsWithBirthdates = kids.filter(function (_ref4) {
    var birthdate = _ref4.birthdate;
    return !!birthdate;
  });
  return adults.length + kidsWithBirthdates.length;
};

var priceOfStay_helper_fetchPriceOfStay = function fetchPriceOfStay(appContext, searchCriteria) {
  var productId = searchCriteria.productId,
      departureDate = searchCriteria.departureDate,
      duration = searchCriteria.duration,
      departureCity = searchCriteria.departureCity,
      offerName = searchCriteria.offerName;
  var numberAttendees = getNumberAttendees(searchCriteria);

  var args = priceOfStay_helper_objectSpread(priceOfStay_helper_objectSpread(priceOfStay_helper_objectSpread(priceOfStay_helper_objectSpread({
    productId: productId,
    departureDate: Object(dateUtils["c" /* formatTimestampDate */])(departureDate, apiDate["a" /* API_DATE_FORMAT */]),
    duration: duration
  }, numberAttendees && {
    numberAttendees: numberAttendees
  }), numberAttendees && {
    childrenBirthdates: priceOfStay_helper_getChildrenBirthdates(searchCriteria)
  }), departureCity !== faceting_constants["i" /* DEFAULT_DEPARTURE_CITY_VALUE */] && {
    departureCity: departureCity
  }), offerName && {
    offerName: dist["url"].decodePath(offerName)
  });

  var argsString = Object(graphql["a" /* buildArgs */])(args);
  var query = "query {\n      priceOfStay(".concat(argsString, ") {\n        ... on ErrorsPriceOfStayType {\n          errors {\n            errorCode\n            errorDescription\n            errorValue\n          }\n        }\n        ... on PriceOfStayType {\n          accommodationId\n          accommodationLabel\n          bestPrice {\n            value\n            formattedValue\n          }\n          currency\n          includesChildcare\n          includesTransportation\n          initialPrice {\n            value\n            formattedValue\n          }\n          resource\n          unit {\n            id\n            label\n          }\n          offerColor\n          productId\n        }\n      }\n    }");
  return graphqlClient["a" /* default */].runQuery(query, appContext, {
    requestName: requestDictionary["Dd" /* STATE_PRODUCT_PRICE_OF_STAY */]
  });
};
// EXTERNAL MODULE: ./src/client/store/price-remote/constants.js
var price_remote_constants = __webpack_require__("GZgf");

// CONCATENATED MODULE: ./src/client/store/price-remote/price-of-stay/priceOfStay.actions.js



var priceOfStay_actions_getPriceOfStay = function getPriceOfStay(appContext, searchCriteria) {
  return Object(createAction["a" /* createOptimisticAction */])(price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */], {}, {
    optimist: true,
    promise: priceOfStay_helper_fetchPriceOfStay(appContext, searchCriteria)
  });
};
var priceOfStay_actions_resetPriceOfStay = function resetPriceOfStay() {
  return Object(createAction["b" /* default */])(price_remote_constants["c" /* RESET_PRICE_OF_STAY */]);
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-of-stay/PriceOfStay.jsx

var PriceOfStay_jsx = react_default.a.createElement;

function PriceOfStay_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PriceOfStay_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PriceOfStay_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PriceOfStay_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























var PriceOfStay_PriceOfStay = function PriceOfStay(_ref) {
  var productId = _ref.productId;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);

  var _useContext = Object(react["useContext"])(PriceRemoteContext),
      _useContext$ = _useContext[0],
      isDetailOpened = _useContext$.isDetailOpened,
      isJoyview = _useContext$.isJoyview,
      isCompact = _useContext$.isCompact,
      isOverrideSticky = _useContext$.isOverrideSticky,
      submitPriceRemoteForm = _useContext$.submitPriceRemoteForm,
      setPriceRemoteContext = _useContext[1];

  var _useContext2 = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isAppMounted = _useContext2.isAppMounted;

  var track = Object(useTracking["a" /* useTracking */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var adults = Object(es["e" /* useSelector */])(storeHelper["a" /* getAdults */]);
  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var departureDateIsBookable = Object(es["e" /* useSelector */])(calendar_selector["g" /* getDepartureDateBookable */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var basePrice = Object(es["e" /* useSelector */])(function (state) {
    return state.priceTicket.price;
  });

  var _useSelector = Object(es["e" /* useSelector */])(function (state) {
    return {
      priceOfStay: priceOfStaySelector(state),
      priceOfStayError: state.priceRemote.priceOfStay.error
    };
  }),
      priceOfStay = _useSelector.priceOfStay,
      priceOfStayError = _useSelector.priceOfStayError;

  var priceOfStayIsLoading = Object(es["e" /* useSelector */])(priceOfStayIsLoadingSelector);
  var isLoading = priceOfStayIsLoading || !isAppMounted;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var offerName = location.queryParams.offer; // Fixme: refactor kids and adults reducers so that their state does not change unnecessarily

  var debouncedSearchCriteria = Object(useDebounce["a" /* useDebounce */])([departureDate, departureCity, duration, JSON.stringify(kids), JSON.stringify(adults), productId], 500);
  Object(react["useEffect"])(function () {
    dispatch(priceTicketRequest({
      appContext: appContext,
      location: location,
      productId: productId,
      transport: departureCity || 'NO'
    }));
  }, [productId, departureCity]);
  Object(react["useEffect"])(function () {
    var searchCriteria = PriceOfStay_objectSpread(PriceOfStay_objectSpread(PriceOfStay_objectSpread({
      productId: productId,
      departureDate: departureDate,
      departureCity: departureCity,
      duration: duration
    }, kids ? {
      kids: kids
    } : null), adults ? {
      adults: adults
    } : null), {}, {
      offerName: offerName
    });

    if (departureDate && duration && departureCity) {
      dispatch(priceOfStay_actions_getPriceOfStay(appContext, searchCriteria));
    }
  }, debouncedSearchCriteria);
  Object(react["useEffect"])(function () {
    if (priceOfStay) {
      track({
        actionGA: "realPriceDisplay_".concat(priceOfStay.resource),
        categoryGA: pageContext.pageType,
        labelGA: pageContext.pageMeta.resortId,
        resortAdult: adults.length,
        resortChildren: kids.length,
        resortCode: pageContext.pageMeta.resortId,
        resortDepartureCityCode: departureCity,
        resortDepartureDate: Object(dateUtils["c" /* formatTimestampDate */])(departureDate, 'YYYYMMDD'),
        resortNightNumber: duration,
        resortTotalParticipant: adults.length + kids.length,
        valueGA: priceOfStay.bestPrice.value
      });
    }
  }, [priceOfStay]);
  Object(react["useEffect"])(function () {
    if (priceOfStayError) {
      track({
        event: 'eventGA',
        actionGA: 'errorPriceRemote',
        categoryGA: pageContext.pageType,
        labelGA: pageContext.pageMeta.resortId,
        nonInteraction: '0'
      });
    }
  }, [priceOfStayError]);
  Object(react["useEffect"])(function () {
    if (priceOfStay) {
      setPriceRemoteContext({
        isTotalPrice: !!priceOfStay
      });
    }
  }, [priceOfStay]);

  if (!isLoading && departureDateIsBookable && priceOfStayError) {
    var btnCls = classnames_default()('reset-button text-success underline md:rtl:ml-1 font-bold', {
      block: isCompact || isOverrideSticky
    });
    var errorValue = priceOfStayError[0].errorValue;
    var ctaLabelKey = errorValue === 'priceRemote.notAvailableTransportation' || errorValue === 'priceRemote.errors.noTransport' ? 'priceRemote.notAvailableCTATransportation' : 'priceRemote.notAvailableCTA';
    return PriceOfStay_jsx("div", {
      className: "flex flex-col lg:flex-row justify-center text-center items-center md:justify-end lg:mlx-10"
    }, PriceOfStay_jsx("span", {
      className: "text-orange font-bold"
    }, Object(src_i18n["f" /* t */])(errorValue)), PriceOfStay_jsx("button", {
      className: btnCls,
      onClick: submitPriceRemoteForm,
      type: "button"
    }, Object(src_i18n["f" /* t */])(ctaLabelKey)));
  }

  return PriceOfStay_jsx("div", {
    className: "lg:flex"
  }, !isJoyview ? PriceOfStay_jsx("div", {
    className: "hidden lg:flex lg:items-center"
  }, PriceOfStay_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].ALL_INCLUSIVE,
    width: "1.5rem"
  }), PriceOfStay_jsx("div", {
    className: "font-brand text-blue text-md ml-2 rtl:ml-2"
  }, Object(src_i18n["f" /* t */])('common.allInclusive'))) : null, isLoading ? PriceOfStay_jsx("div", {
    className: "flex justify-center items-center md:justify-end lg:mx-10"
  }, PriceOfStay_jsx(Spinner["a" /* Spinner */], {
    size: "small"
  })) : null, !isLoading && priceOfStay && PriceOfStay_jsx(Price["a" /* Price */], {
    bestPrice: priceOfStay.bestPrice,
    className: "lg:mx-10",
    color: isJoyview ? colors["a" /* COLORS */].WATER_GREEN : colors["a" /* COLORS */].BLUE,
    currency: priceOfStay.currency,
    initialPrice: priceOfStay.initialPrice,
    onClick: function onClick() {
      setPriceRemoteContext({
        isDetailOpened: !isDetailOpened
      });
    },
    theme: "remote",
    unit: priceOfStay.unit.label,
    hasAsterisk: false
  }), !isLoading && !priceOfStay && basePrice && PriceOfStay_jsx("div", {
    className: "flex justify-center lg:mx-10"
  }, basePrice.bestPrice && PriceOfStay_jsx("span", {
    className: "flex items-center font-sans font-bold text-sm text-blue px-2"
  }, Object(src_i18n["f" /* t */])('price.format.from')), PriceOfStay_jsx(Price["a" /* Price */], {
    bestPrice: basePrice.bestPrice,
    currency: basePrice.currency,
    color: isJoyview ? colors["a" /* COLORS */].WATER_GREEN : colors["a" /* COLORS */].BLUE,
    initialPrice: basePrice.initialPrice,
    onClick: function onClick() {
      setPriceRemoteContext({
        isDetailOpened: !isDetailOpened
      });
    },
    theme: "remote",
    unit: basePrice.unit
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product-banner/ProductBanner.jsx
var ProductBanner = __webpack_require__("SUcU");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-ticket/PriceRemoteTicket.jsx
var PriceRemoteTicket_jsx = react_default.a.createElement;




var PriceRemoteTicket_PriceRemoteTicket = function PriceRemoteTicket(_ref) {
  var className = _ref.className,
      product = _ref.product;
  return PriceRemoteTicket_jsx("div", {
    className: classnames_default()(className, 'flex flex-grow justify-between')
  }, PriceRemoteTicket_jsx(ProductBanner["a" /* ProductBanner */], {
    product: product
  }), PriceRemoteTicket_jsx("div", {
    className: "text-center w-full lg:w-auto lg:text-right lg:flex lg:flex-shrink-0 lg:items-center"
  }, PriceRemoteTicket_jsx(PriceOfStay_PriceOfStay, {
    productId: product.id
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-content/PriceRemoteContent.jsx

var PriceRemoteContent_jsx = react_default.a.createElement;







var PriceRemoteContent_PriceRemoteContent = function PriceRemoteContent(_ref) {
  var product = _ref.product,
      isSticky = _ref.isSticky,
      bookingCriteria = _ref.bookingCriteria,
      classNames = _ref.classNames,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      urgentisationRate = _ref.urgentisationRate;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var _useContext2 = Object(react["useContext"])(PriceRemoteContext),
      isCompact = _useContext2[0].isCompact;

  var isCompactAndIsDesktop = isCompact && isDesktop;
  var isNotCompactAndIsDesktop = !isCompact && isDesktop;
  var isStickyAndIsMobile = isSticky && !isDesktop;
  var isStickyAndIsDesktop = isSticky && isDesktop;
  var isStickyAndIsNotCompact = isSticky && !isCompact;
  var isLongResortTitle = product.name && product.name.length > 45 && isDesktop;

  var departureCities = Object(toConsumableArray["a" /* default */])(bookingCriteria.departureCities || []);

  if (departureCities.length > 0) {
    var departureCityPlaceholder = {
      value: '',
      label: Object(src_i18n["f" /* t */])('faceting.transport.selectPlaceholder')
    };
    departureCities = [departureCityPlaceholder].concat(Object(toConsumableArray["a" /* default */])(departureCities));
  }

  return PriceRemoteContent_jsx("div", {
    className: classNames,
    style: style
  }, PriceRemoteContent_jsx(PriceRemoteTicket_PriceRemoteTicket, {
    className: classnames_default()({
      'mb-2 lg:mb-3': isStickyAndIsNotCompact || !isSticky,
      'mb-0': isStickyAndIsMobile,
      'w-full': isNotCompactAndIsDesktop || !isDesktop
    }),
    product: product
  }), PriceRemoteContent_jsx(PriceRemoteForm_PriceRemoteForm, {
    className: classnames_default()({
      'w-full fadeIn': isNotCompactAndIsDesktop || !isDesktop,
      'flex items-center': isCompactAndIsDesktop,
      'm-auto': isLongResortTitle
    }),
    departureCities: departureCities,
    initialTransport: bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.initialTransport,
    isJoyview: product.isJoyview,
    isStickyAndIsDesktop: isStickyAndIsDesktop,
    productId: product.id,
    urgentisationRate: urgentisationRate
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product-services/product-service/ProductService.jsx
var ProductService = __webpack_require__("9OZL");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-service-list/PriceRemoteServiceList.jsx
var PriceRemoteServiceList_jsx = react_default.a.createElement;



var PriceRemoteServiceList_PriceRemoteServiceList = function PriceRemoteServiceList(_ref) {
  var services = _ref.services,
      isDesktop = _ref.isDesktop;
  return PriceRemoteServiceList_jsx("div", {
    className: classnames_default()('text-base', {
      'w-1/2 px-5': isDesktop,
      'w-full': !isDesktop
    })
  }, services.map(function (service) {
    return PriceRemoteServiceList_jsx(ProductService["a" /* ProductService */], {
      key: service.label,
      service: service
    });
  }), !isDesktop ? PriceRemoteServiceList_jsx("div", {
    style: {
      height: '40px'
    }
  }) : null);
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-details/PriceRemoteDetails.jsx

var PriceRemoteDetails_jsx = react_default.a.createElement;










var PriceRemoteDetails_PriceRemoteDetails = function PriceRemoteDetails(_ref) {
  var allInclusiveServices = _ref.allInclusiveServices,
      isLoading = _ref.isLoading,
      isSticky = _ref.isSticky;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react["useContext"])(PriceRemoteContext),
      priceRemoteContext = _useContext[0],
      setPriceRemoteContext = _useContext[1];

  Object(react["useEffect"])(function () {
    if (allInclusiveServices && allInclusiveServices.length > 0 && isDesktop) {
      setPriceRemoteContext({
        isDetailOpened: true
      });
    }
  }, [allInclusiveServices.map(function (_ref2) {
    var label = _ref2.label;
    return label;
  }).join('|'), isSticky]);
  var trackingData = {
    event: 'eventGA',
    categoryGA: 'resort',
    actionGA: 'priceBar',
    labelGA: 'checkPrices',
    valueGA: '0',
    nonInteraction: '0'
  };
  var linkToCalendar = Object(src_i18n["f" /* t */])('priceRemote.linkToCalendar');
  var splitServices = allInclusiveServices && allInclusiveServices.length > 0 ? Object(lodash["chunk"])(Object(toConsumableArray["a" /* default */])(allInclusiveServices), Object(lodash["ceil"])(allInclusiveServices.length / 2)) : [];
  return PriceRemoteDetails_jsx(react_collapse_lib["Collapse"], {
    className: "px-5",
    isOpened: priceRemoteContext.isDetailOpened
  }, PriceRemoteDetails_jsx("div", {
    className: classnames_default()('absolute', {
      'rtl:right-0 mt-1': isDesktop,
      'flex w-full mt-10 justify-center': !isDesktop
    })
  }, !(priceRemoteContext.isDetailOpened || isSticky) && linkToCalendar && PriceRemoteDetails_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "bg-transparent text-center text-blue underline text-base font-bold",
    trackingData: trackingData,
    url: "#booking"
  }, linkToCalendar)), priceRemoteContext.isTotalPrice && PriceRemoteDetails_jsx("div", {
    className: "text-base text-blue font-bold text-center pt-4 pb-1 lg:pt-2"
  }, Object(src_i18n["f" /* t */])('priceRemote.priceForAll')), PriceRemoteDetails_jsx("div", {
    className: classnames_default()('flex flex-wrap pb-4 lg:pb-8 transition-opacity', {
      'opacity-25': isLoading
    }),
    "data-testid": "price-remote-details-container"
  }, splitServices[0] ? PriceRemoteDetails_jsx(PriceRemoteServiceList_PriceRemoteServiceList, {
    isDesktop: isDesktop,
    services: splitServices[0]
  }) : null, splitServices[1] ? PriceRemoteDetails_jsx(PriceRemoteServiceList_PriceRemoteServiceList, {
    isDesktop: isDesktop,
    services: splitServices[1]
  }) : null));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-details-layer/PriceRemoteDetailsLayer.jsx
var PriceRemoteDetailsLayer_jsx = react_default.a.createElement;










var REMOTE_HEIGHT = '250px';
var PriceRemoteDetailsLayer_PriceRemoteDetailsLayer = function PriceRemoteDetailsLayer(_ref) {
  var allInclusiveServices = _ref.allInclusiveServices,
      closeLabel = _ref.closeLabel,
      isLoading = _ref.isLoading,
      onBack = _ref.onBack,
      nameRender = _ref.nameRender,
      children = _ref.children;

  var _useContext = Object(react["useContext"])(PriceRemoteContext),
      isTotalPrice = _useContext[0].isTotalPrice,
      setPriceRemoteContext = _useContext[1];

  Object(react["useEffect"])(function () {
    setPriceRemoteContext({
      isInLayer: true
    });
    return function () {
      setPriceRemoteContext({
        isInLayer: false
      });
    };
  }, []);
  var layerHeaderTitle = Object(src_i18n["f" /* t */])('priceRemote.openAllInclusiveDetails');
  return PriceRemoteDetailsLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: layerHeaderTitle,
    ariaLabelledby: identifiers_constants["o" /* ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS */],
    buttonLeft: {
      label: Object(src_i18n["f" /* t */])('common.backNavigation'),
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      onClick: onBack
    },
    closeLabel: closeLabel,
    hasAnimateEnter: true,
    header: PriceRemoteDetailsLayer_jsx("span", {
      id: identifiers_constants["o" /* ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS */],
      className: "w-full text-center block"
    }, layerHeaderTitle),
    onClose: onBack,
    portalName: nameRender || Portal_constants["c" /* BEFORE_APP */]
  }, PriceRemoteDetailsLayer_jsx("div", {
    className: classnames_default()('flex flex-col px-5 items-center scroll-y transition-opacity', {
      'opacity-25': isLoading
    }),
    style: {
      height: "calc(100% - (".concat(REMOTE_HEIGHT, " - 60px))")
    },
    "data-testid": "price-remote-details-layer-container"
  }, isTotalPrice ? PriceRemoteDetailsLayer_jsx("div", {
    className: "text-base text-blue font-bold text-center pt-4 pb-1 lg:pt-2"
  }, Object(src_i18n["f" /* t */])('priceRemote.priceForAll')) : null, allInclusiveServices && allInclusiveServices.length > 0 ? PriceRemoteDetailsLayer_jsx(PriceRemoteServiceList_PriceRemoteServiceList, {
    services: allInclusiveServices,
    isDesktop: false
  }) : PriceRemoteDetailsLayer_jsx(Spinner["a" /* Spinner */], {
    size: "small"
  })), children);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-title-button/PriceRemoteTitleButton.jsx

var PriceRemoteTitleButton_jsx = react_default.a.createElement;








var PriceRemoteTitleButton_PriceRemoteTitleButton = function PriceRemoteTitleButton(_ref) {
  var handleClick = _ref.handleClick,
      isCollapsed = _ref.isCollapsed,
      isDesktop = _ref.isDesktop,
      _ref$isSticky = _ref.isSticky,
      isSticky = _ref$isSticky === void 0 ? false : _ref$isSticky;

  var _useContext = Object(react["useContext"])(PriceRemoteContext),
      isJoyview = _useContext[0].isJoyview;

  var buttonLabel = isCollapsed ? Object(src_i18n["f" /* t */])('priceRemote.closeAllInclusiveDetails') : Object(src_i18n["f" /* t */])('priceRemote.openAllInclusiveDetails');
  var color = isJoyview ? colors["a" /* COLORS */].WATER_GREEN : colors["a" /* COLORS */].BLUE;
  return isSticky && !isDesktop ? PriceRemoteTitleButton_jsx("button", {
    className: "bg-transparent text-center text-".concat(color, " underline text-base font-bold pt-1 pb-2"),
    onClick: handleClick,
    type: "button"
  }, buttonLabel, PriceRemoteTitleButton_jsx(Icon["a" /* Icon */], {
    className: classnames_default()('text-blue rtl:ml-2 transition-transform', Object(defineProperty["a" /* default */])({}, 'rotate-180', isCollapsed)),
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.625rem"
  })) : PriceRemoteTitleButton_jsx(StripButton["a" /* StripButton */], {
    className: "font-bold text-center text-".concat(color, " text-sm underline"),
    height: 30,
    onClick: handleClick,
    orientation: isSticky && isDesktop ? 'top' : 'bottom'
  }, PriceRemoteTitleButton_jsx("div", {
    className: "flex items-center text-base"
  }, buttonLabel, PriceRemoteTitleButton_jsx("div", {
    className: classnames_default()('rtl:ml-2', Object(defineProperty["a" /* default */])({}, 'rotate-180', isSticky && isDesktop))
  }, PriceRemoteTitleButton_jsx(Icon["a" /* Icon */], {
    className: classnames_default()('text-blue transition-transform', Object(defineProperty["a" /* default */])({}, 'rotate-180', isCollapsed)),
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    width: "0.625rem"
  }))));
};
// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.helper.js



var allInclusiveServices_helper_fetchAllInclusiveServices = function fetchAllInclusiveServices(appContext, criteria) {
  var allInclusiveServicesArgs = Object(graphql["a" /* buildArgs */])(criteria);
  var query = "query {\n      allInclusiveServices(".concat(allInclusiveServicesArgs, ") {\n        description\n        icon\n        label\n        type\n      }\n    }\n  ");
  return graphqlClient["a" /* default */].runQuery(query, appContext, {
    requestName: requestDictionary["Ad" /* STATE_PRODUCT_ALL_INCLUSIVE_SERVICES */]
  });
};
// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.actions.js



var allInclusiveServices_actions_getAllInclusiveServices = function getAllInclusiveServices(appContext, criteria) {
  return Object(createAction["a" /* createOptimisticAction */])(price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */], {}, {
    optimist: true,
    promise: allInclusiveServices_helper_fetchAllInclusiveServices(appContext, criteria)
  });
};
// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.selector.js


var allInclusiveServicesSelector = Object(reselect_lib["createSelector"])(priceRemote_selector_priceRemoteSelector, function (_ref) {
  var data = _ref.allInclusiveServices.data;
  return data;
});
// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/PriceRemote.jsx

var PriceRemote_jsx = react_default.a.createElement;

























var ALL_INCLUSIVE_SERVICES_TYPES = dist["constants"].ALL_INCLUSIVE_SERVICES_TYPES;
var PriceRemote_PriceRemote = function PriceRemote(_ref) {
  var bookingCriteria = _ref.bookingCriteria,
      isSticky = _ref.isSticky,
      product = _ref.product,
      urgentisationRate = _ref.urgentisationRate;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var _useContext2 = Object(react["useContext"])(PriceRemoteContext),
      isDetailOpened = _useContext2[0].isDetailOpened,
      setPriceRemoteContext = _useContext2[1];

  var _useContext3 = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext3[0],
      setCriteriaContext = _useContext3[1];

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 1),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0];

  var dispatch = Object(es["d" /* useDispatch */])();
  var allInclusiveServices = Object(es["e" /* useSelector */])(allInclusiveServicesSelector);
  var allInclusiveServicesIsLoading = Object(es["e" /* useSelector */])(function (state) {
    return state.priceRemote.allInclusiveServices.isLoading;
  });
  var adultsNumber = Object(es["e" /* useSelector */])(function (state) {
    return state.tripInformation.adults.length;
  });

  var _useSelector = Object(es["e" /* useSelector */])(function (state) {
    var _state$priceRemote$pr = state.priceRemote.priceOfStay,
        priceOfStayData = _state$priceRemote$pr.data,
        priceOfStayIsLoading = _state$priceRemote$pr.isLoading;
    return {
      priceOfStay: priceOfStayData || {},
      priceIsLoading: !priceOfStayData && Object(calendar_selector["c" /* getCalendarLoading */])(state) || priceOfStayData && priceOfStayIsLoading
    };
  }),
      priceOfStay = _useSelector.priceOfStay,
      priceIsLoading = _useSelector.priceIsLoading;

  var filteredAllInclusiveServices = criteriaContext ? allInclusiveServices.filter(function (_ref2) {
    var type = _ref2.type;

    switch (type) {
      case ALL_INCLUSIVE_SERVICES_TYPES.TRANSPORT:
        return criteriaContext.criteriaTransportIsSet;

      case ALL_INCLUSIVE_SERVICES_TYPES.CHILDCARE:
        return criteriaContext.criteriaWhoIsSet;

      default:
        return true;
    }
  }) : allInclusiveServices;
  var isStickyAndIsMobile = isSticky && !isDesktop;
  var isStickyAndIsDesktop = isSticky && isDesktop;
  var isJoyView = product.isJoyview;
  Object(react["useEffect"])(function () {
    setPriceRemoteContext({
      isJoyview: isJoyView
    });
    setCriteriaContext({
      isJoyview: isJoyView
    });
  }, [isJoyView]);
  Object(react["useEffect"])(function () {
    setPriceRemoteContext({
      isCompact: isSticky && !isDetailOpened
    });
  }, [isSticky, isDetailOpened]);
  Object(react["useEffect"])(function () {
    if (isSticky && isDesktop) {
      setPriceRemoteContext({
        isDetailOpened: !isSticky
      });
    }
  }, [isSticky]);
  Object(react["useEffect"])(function () {
    if (!adultsNumber) {
      dispatch(Object(adults_action["b" /* setAdultsNumber */])(adults_constants["a" /* DEFAULT_ADULTS_NB */]));
    }

    return function () {
      dispatch(priceOfStay_actions_resetPriceOfStay());
    };
  }, []);
  Object(react["useEffect"])(function () {
    var isOpen = criteriaDisplayContext.criteriaWhenIsOpen || criteriaDisplayContext.criteriaWhoIsOpen || criteriaDisplayContext.criteriaTransportIsOpen;
    setPriceRemoteContext({
      isOverrideSticky: !isOpen
    });

    if (isOpen) {
      Object(scrollToElement["a" /* scrollToElement */])('.PriceRemoteStickyWrapper-initialPosition');
    }
  }, [criteriaDisplayContext.criteriaWhenIsOpen, criteriaDisplayContext.criteriaWhoIsOpen, criteriaDisplayContext.criteriaTransportIsOpen]);
  Object(react["useEffect"])(function () {
    if (product.id && (priceOfStay.productId === product.id || !priceIsLoading && !priceOfStay.productId)) {
      dispatch(allInclusiveServices_actions_getAllInclusiveServices(appContext, {
        accommodationId: priceOfStay.accommodationId,
        accommodationLabel: priceOfStay.accommodationLabel,
        productId: product.id,
        includesTransportation: priceOfStay.includesTransportation,
        includesChildcare: priceOfStay.includesChildcare
      }));
    }
  }, [priceOfStay.accommodationId, priceOfStay.accommodationLabel, priceOfStay.includesTransportation, priceOfStay.includesChildcare, product.id, priceIsLoading]);
  var isLoading = priceIsLoading || allInclusiveServicesIsLoading;
  return PriceRemote_jsx(SiteContainer["a" /* SiteContainer */], {
    className: classnames_default()({
      'mb-2 mt-8': isStickyAndIsDesktop,
      'slideInBottom border-t-1 border-gray-light bg-white': isStickyAndIsMobile
    })
  }, PriceRemote_jsx("div", {
    className: classnames_default()('bg-white relative', {
      'border-1 rounded-small shadow-sm': !isStickyAndIsMobile
    })
  }, PriceRemote_jsx(react["Fragment"], null, PriceRemote_jsx(PriceRemoteContent_PriceRemoteContent, {
    bookingCriteria: bookingCriteria,
    classNames: classnames_default()('flex-wrap p-1 lg:p-3 lg:flex', {
      'p-2': !isDesktop && !isSticky,
      flex: !isDesktop && !isDetailOpened,
      'lg:flex-no-wrap': isSticky && !isDetailOpened
    }),
    isSticky: isSticky,
    product: product,
    urgentisationRate: urgentisationRate
  }), isDesktop && isDetailOpened ? PriceRemote_jsx(PriceRemoteDetails_PriceRemoteDetails, {
    allInclusiveServices: filteredAllInclusiveServices,
    isSticky: isSticky,
    isLoading: isLoading
  }) : null, PriceRemote_jsx("div", {
    className: classnames_default()('flex items-center justify-center', {
      'absolute left-1/2 -translate-x-50': !isSticky || isSticky && isDesktop,
      'bottom-full': isSticky && isDesktop
    })
  }, PriceRemote_jsx(PriceRemoteTitleButton_PriceRemoteTitleButton, {
    isCollapsed: isDetailOpened,
    isDesktop: isDesktop,
    isJoyview: isJoyView,
    isSticky: isSticky,
    handleClick: function handleClick() {
      if (!isDetailOpened && !isSticky) {
        Object(scrollToElement["a" /* scrollToElement */])('.PriceRemoteStickyWrapper-initialPosition');
      }

      setPriceRemoteContext({
        isDetailOpened: !isDetailOpened
      });
    }
  }))), !isDesktop && isDetailOpened ? PriceRemote_jsx(PriceRemoteDetailsLayer_PriceRemoteDetailsLayer, {
    allInclusiveServices: filteredAllInclusiveServices,
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    isLoading: isLoading,
    nameRender: Portal_constants["b" /* AFTER_APP */],
    onBack: function onBack() {
      return setPriceRemoteContext({
        isDetailOpened: false
      });
    }
  }, PriceRemote_jsx(CriteriaDisplayContext["b" /* CriteriaDisplayProvider */], null, PriceRemote_jsx(PriceRemoteContent_PriceRemoteContent, {
    bookingCriteria: bookingCriteria,
    classNames: "py-5 bg-white w-full mt-auto",
    isSticky: isSticky,
    product: product,
    urgentisationRate: urgentisationRate
  }))) : null, PriceRemote_jsx("div", {
    className: "absolute flex w-full mt-10 justify-center lg:block lg:w-auto lg:rtl:right-0 lg:mt-1"
  }, !(isDetailOpened || isSticky) && PriceRemote_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "bg-transparent text-center text-blue underline text-base font-bold",
    trackingData: {
      event: 'eventGA',
      categoryGA: 'resort',
      actionGA: 'priceBar',
      labelGA: 'checkPrices',
      valueGA: '0',
      nonInteraction: '0'
    },
    url: "#booking"
  }, Object(src_i18n["f" /* t */])('priceRemote.linkToCalendar')))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/PriceRemoteStickyWrapper.jsx

var PriceRemoteStickyWrapper_jsx = react_default.a.createElement;










var PriceRemoteStickyWrapper_PriceRemoteStickyWrapper = function PriceRemoteStickyWrapper(_ref) {
  var bookingCriteria = _ref.bookingCriteria,
      product = _ref.product,
      urgentisationRate = _ref.urgentisationRate;

  var _useState = Object(react["useState"])(false),
      isSticky = _useState[0],
      setIsSticky = _useState[1];

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var bottomBoundary = '.PriceTicket-sticky-beacon';

  var onStateChange = function onStateChange(status) {
    setIsSticky(status.status !== react_stickynode_default.a.STATUS_ORIGINAL);
  };

  var isPriceRemoteEnabled = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('priceRemote.enabled');

  if (!isPriceRemoteEnabled) {
    return null;
  }

  return PriceRemoteStickyWrapper_jsx(PriceRemoteContext_PriceRemoteContextProvider, null, PriceRemoteStickyWrapper_jsx(CriteriaContext["b" /* CriteriaContextProvider */], {
    value: {
      layerButtonLabel: Object(src_i18n["f" /* t */])('booking.editCriteria.validateCriteria'),
      trackingActionName: 'priceBar'
    }
  }, PriceRemoteStickyWrapper_jsx("div", {
    className: isSticky ? 'PriceRemoteStickyWrapper--isSticky' : null
  }, PriceRemoteStickyWrapper_jsx("div", {
    className: "".concat(PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME, " -mt-2 pb-2")
  }), PriceRemoteStickyWrapper_jsx(PriceRemoteContext.Consumer, null, function (_ref2) {
    var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 1),
        _ref3$ = _ref3[0],
        isOverrideSticky = _ref3$.isOverrideSticky,
        isDetailOpened = _ref3$.isDetailOpened;

    return PriceRemoteStickyWrapper_jsx(react_stickynode_default.a, {
      activeClass: "sticky-bottom",
      bottomBoundary: bottomBoundary,
      enabled: isOverrideSticky,
      innerZ: isOverrideSticky && !isDetailOpened ? 2 : 6,
      onStateChange: onStateChange,
      releasedClass: "sticky-bottom-released"
    }, PriceRemoteStickyWrapper_jsx(CriteriaDisplayContext["b" /* CriteriaDisplayProvider */], null, PriceRemoteStickyWrapper_jsx(PriceRemote_PriceRemote, {
      bookingCriteria: bookingCriteria,
      isSticky: isSticky,
      product: product,
      urgentisationRate: urgentisationRate
    })));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-price-remote-line/ProductPriceRemoteLine.jsx
var ProductPriceRemoteLine_jsx = react_default.a.createElement;





var ProductPriceRemoteLine_ProductPriceRemoteLine = function ProductPriceRemoteLine(_ref) {
  var bookingCriteria = _ref.bookingCriteria,
      product = _ref.product,
      config = _ref.config;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  var isEnabled = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('priceRemote.enabled');

  if (!product || !bookingCriteria || !isEnabled) {
    return null;
  }

  Object(src_i18n["a" /* addTranslationKeys */])(config);
  var urgentisationRate = config.booking.priceCalendar.offers.urgentisation.rateToDisplay;
  return ProductPriceRemoteLine_jsx("div", {
    className: "Line Line-PriceRemote mb-16 lg:mb-10",
    "data-testid": "Line-ProductPriceRemote"
  }, ProductPriceRemoteLine_jsx(PriceRemoteStickyWrapper_PriceRemoteStickyWrapper, {
    bookingCriteria: bookingCriteria,
    product: product,
    urgentisationRate: urgentisationRate
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-price-remote/productPriceRemote.resolver.js
var productPriceRemote_resolver = __webpack_require__("+82i");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-price-remote/productPriceRemote.descriptor.js



var productPriceRemoteDescriptor = {
  name: constants["lb" /* RESORT_PRICE_REMOTE */],
  component: ProductPriceRemoteLine_ProductPriceRemoteLine,
  resolve: productPriceRemote_resolver["a" /* productPriceRemoteResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/productQuotationForm.constants.js
var QUOTATION_FORM_SECTION_ID = 'quotation-form-section';
var QUOTATION_FORM_ID = 'product-quotation-form';
var productQuotationForm_constants_MAX_FORM_ADULTS = 6;
var productQuotationForm_constants_MAX_FORM_KIDS = 6;
var MAX_FORM_TEENS = 6;
var productQuotationForm_constants_MIN_FORM_ADULTS = 1;
var productQuotationForm_constants_MIN_FORM_KIDS = 0;
var MIN_FORM_TEENS = 1;
var NO_VALUE = 'NO';
var RANGE_ESCAPADE = 'escapade';
// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket/priceTicket.mapper.js


function priceTicket_mapper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceTicket_mapper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceTicket_mapper_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceTicket_mapper_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var priceTicket_mapper_PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var priceTicket_mapper_getPriceTicketButton = function getPriceTicketButton(product) {
  var props = {
    children: Object(src_i18n["f" /* t */])('productPriceTicketLine.seeAllPrices'),
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    iconLeft: {
      name: icons["a" /* ICONS */].DATE
    },
    url: '#booking',
    trackingData: {
      actionGA: 'priceBar',
      labelGA: 'checkPrices'
    }
  };

  switch (product.type) {
    case priceTicket_mapper_PRODUCT_TYPES.TOUR:
      return priceTicket_mapper_objectSpread(priceTicket_mapper_objectSpread({}, props), {}, {
        iconLeft: null,
        children: Object(src_i18n["f" /* t */])('productPriceTicketLine.askForQuotation'),
        url: "#".concat(QUOTATION_FORM_SECTION_ID)
      });

    case priceTicket_mapper_PRODUCT_TYPES.CRUISE:
      return priceTicket_mapper_objectSpread(priceTicket_mapper_objectSpread({}, props), {}, {
        iconLeft: null,
        children: Object(src_i18n["f" /* t */])('productPriceTicketLine.book')
      });

    default:
      return props;
  }
};
var getPriceTicketSubtitle = function getPriceTicketSubtitle(product, cruise) {
  var _product$destination = product.destination,
      destination = _product$destination === void 0 ? {} : _product$destination,
      _product$type = product.type,
      type = _product$type === void 0 ? '' : _product$type;

  switch (type) {
    case priceTicket_mapper_PRODUCT_TYPES.CRUISE:
      return (cruise === null || cruise === void 0 ? void 0 : cruise.fromToDestination) || '';

    default:
      return destination.country || '';
  }
};
var priceTicket_mapper_getPriceTicketInfo = function getPriceTicketInfo(_ref) {
  var type = _ref.type;

  switch (type) {
    case priceTicket_mapper_PRODUCT_TYPES.TOUR:
      return {};

    case priceTicket_mapper_PRODUCT_TYPES.JOYVIEW:
      return {
        iconName: icons["a" /* ICONS */].ACCOMODATIONS,
        label: Object(src_i18n["f" /* t */])('resort.startingPrice.roomOnly')
      };

    default:
      return {
        iconName: icons["a" /* ICONS */].ALL_INCLUSIVE,
        label: Object(src_i18n["f" /* t */])('resort.startingPrice.allInclusive')
      };
  }
};

var getPriceTicketItem = function getPriceTicketItem(item) {
  return item.longDesc || item.shortDesc ? item : null;
};

var priceTicket_mapper_getPriceTicketItems = function getPriceTicketItems(_ref2) {
  var _price$termsAndCondit, _price$termsAndCondit2, _price$termsAndCondit3, _price$termsAndCondit4, _price$termsAndCondit5, _price$termsAndCondit6;

  var product = _ref2.product,
      price = _ref2.price,
      fromStore = _ref2.fromStore;
  var type = product.type;
  var duration = fromStore.duration || product.duration || '';
  /* departureDate */

  var departureDateValue = fromStore.departureDate ? moment_default()(fromStore.departureDate).format(apiDate["a" /* API_DATE_FORMAT */]) : ((_price$termsAndCondit = price.termsAndConditions) === null || _price$termsAndCondit === void 0 ? void 0 : _price$termsAndCondit.departureDate) || 0;
  var longDateFormat = Object(src_i18n["f" /* t */])('productPriceTicketLine.departureDateFormat');
  var shortDateFormat = Object(src_i18n["f" /* t */])('productPriceTicketLine.condensedDepartureDateFormat');
  var dValue = moment_default()(departureDateValue, 'YYYYMMDD');
  var departureDate = type !== priceTicket_mapper_PRODUCT_TYPES.TOUR ? getPriceTicketItem({
    iconName: icons["a" /* ICONS */].DATE,
    label: Object(src_i18n["f" /* t */])('productPriceTicketLine.departureDateLabel'),
    longDesc: "".concat(dValue.format(longDateFormat), " - ").concat(moment_default()(dValue).add(((_price$termsAndCondit2 = price.termsAndConditions) === null || _price$termsAndCondit2 === void 0 ? void 0 : _price$termsAndCondit2.duration) || 0, 'days').format(longDateFormat)),
    shortDesc: "".concat(dValue.format(shortDateFormat), " - ").concat(moment_default()(dValue).add(((_price$termsAndCondit3 = price.termsAndConditions) === null || _price$termsAndCondit3 === void 0 ? void 0 : _price$termsAndCondit3.duration) || 0, 'days').format(shortDateFormat))
  }) : null;
  /* duration */

  var durationTour = type === priceTicket_mapper_PRODUCT_TYPES.TOUR ? getPriceTicketItem({
    iconName: icons["a" /* ICONS */].DURATION,
    longDesc: duration,
    shortDesc: duration
  }) : null;
  /* transport */

  var departureCityName = fromStore.departureCity || ((_price$termsAndCondit4 = price.termsAndConditions) === null || _price$termsAndCondit4 === void 0 ? void 0 : (_price$termsAndCondit5 = _price$termsAndCondit4.departureCity) === null || _price$termsAndCondit5 === void 0 ? void 0 : _price$termsAndCondit5.name);
  var transport = departureCityName && departureCityName !== 'NO' ? getPriceTicketItem({
    iconName: icons["a" /* ICONS */].TRANSPORT,
    label: Object(src_i18n["f" /* t */])('productPriceTicketLine.departureCityLabel'),
    longDesc: departureCityName
  }) : getPriceTicketItem({
    iconName: icons["a" /* ICONS */].NO_TRANSPORT,
    label: Object(src_i18n["f" /* t */])('productPriceTicketLine.departureCityLabel'),
    longDesc: Object(src_i18n["f" /* t */])('booking.form.withoutTransport')
  });
  /* accommodations */
  // const key =
  //   parseInt(fromStore.duration, 10) === 1
  //     ? 'faceting.when.durationSingular'
  //     : 'faceting.when.durationPlural';
  // const priceDurationFormatted = fromStore.duration
  //   ? messageFormat(t(key)).format({
  //       n: fromStore.duration,
  //     })
  //   : price.termsAndConditions?.durationFormatted;
  // const displayedDuration = type === PRODUCT_TYPES.CRUISE ? duration : priceDurationFormatted;
  // const accommodations =
  //   type !== PRODUCT_TYPES.TOUR
  //     ? getPriceTicketItem({
  //         iconName: ICONS.ACCOMODATIONS,
  //         label: displayedDuration,
  //         longDesc: price.termsAndConditions?.accommodationComfortLabel,
  //       })
  //     : null;

  /* persons */

  var numberOfAdults = fromStore.adultsNumber || Number((_price$termsAndCondit6 = price.termsAndConditions) === null || _price$termsAndCondit6 === void 0 ? void 0 : _price$termsAndCondit6.numberOfAdults) || 0;
  var personLabel = numberOfAdults > 1 ? Object(src_i18n["f" /* t */])('productPriceTicketLine.adults') : Object(src_i18n["f" /* t */])('productPriceTicketLine.adult');
  var persons = getPriceTicketItem({
    iconName: icons["a" /* ICONS */].USERS,
    label: numberOfAdults.toString(),
    longDesc: [numberOfAdults.toString(), personLabel].join(' ').trim(),
    shortDesc: numberOfAdults.toString()
  });
  return [departureDate, durationTour, persons, transport].filter(Boolean);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/block-link/BlockLink.jsx
var BlockLink = __webpack_require__("Onl6");

// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket-large/PriceTicketLarge.jsx


var PriceTicketLarge_jsx = react_default.a.createElement;






















var PriceTicketLarge_ICONS_HEIGHT = 50;
var PriceTicketLarge_PriceTicketLarge = function PriceTicketLarge(_ref) {
  var _ref$allInclusiveServ = _ref.allInclusiveServices,
      allInclusiveServices = _ref$allInclusiveServ === void 0 ? [] : _ref$allInclusiveServ,
      button = _ref.button,
      badgeIcon = _ref.badgeIcon,
      className = _ref.className,
      _ref$hasCallCenter = _ref.hasCallCenter,
      hasCallCenter = _ref$hasCallCenter === void 0 ? false : _ref$hasCallCenter,
      _ref$hasECLogo = _ref.hasECLogo,
      hasECLogo = _ref$hasECLogo === void 0 ? false : _ref$hasECLogo,
      info = _ref.info,
      _ref$isLite = _ref.isLite,
      isLite = _ref$isLite === void 0 ? false : _ref$isLite,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      price = _ref.price,
      staticPrice = _ref.staticPrice,
      subtitle = _ref.subtitle,
      title = _ref.title,
      travelAdvisorConfig = _ref.travelAdvisorConfig,
      _ref$fromPriceTicketC = _ref.fromPriceTicketCustom,
      fromPriceTicketCustom = _ref$fromPriceTicketC === void 0 ? false : _ref$fromPriceTicketC;

  var _useState = Object(react["useState"])(false),
      isDetailOpened = _useState[0],
      setIsDetailOpened = _useState[1];

  Object(react["useEffect"])(function () {
    setIsDetailOpened(false);
  }, [isLite]);

  if (!title) {
    return null;
  }

  var hasDetail = !isLite && !hasCallCenter && (!Object(lodash["isEmpty"])(items) || !Object(lodash["isEmpty"])(info));
  var scroll = button && button.url && /^(#|\.)/.test(button.url) ? function () {
    return Object(scrollToElement["a" /* scrollToElement */])(button.url, 500);
  } : lodash["noop"];
  var splitServices = allInclusiveServices && allInclusiveServices.length > 0 ? Object(lodash["chunk"])(Object(toConsumableArray["a" /* default */])(allInclusiveServices), Object(lodash["ceil"])(allInclusiveServices.length / 2)) : [];
  return PriceTicketLarge_jsx("div", {
    className: classnames_default()(className, 'fadeInLong relative', {
      'mb-2': isLite
    }),
    "data-testid": "PriceTicketLarge"
  }, PriceTicketLarge_jsx(SiteContainer["a" /* SiteContainer */], null, PriceTicketLarge_jsx("div", {
    className: classnames_default()('bg-white border-1 relative rounded-small shadow-sm', {
      'flex items-center justify-center opacity-75': isLoading
    }),
    style: {
      minHeight: MIN_HEIGHT
    }
  }, isLoading ? PriceTicketLarge_jsx(Spinner["a" /* Spinner */], {
    size: "small",
    color: colors["a" /* COLORS */].BLUE
  }) : PriceTicketLarge_jsx(react["Fragment"], null, PriceTicketLarge_jsx("div", {
    className: "flex items-center p-2"
  }, PriceTicketLarge_jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({}, badgeIcon, {
    className: "flex-shrink-0 rounded-tiny",
    size: PriceTicketLarge_ICONS_HEIGHT
  })), hasECLogo && (badgeIcon === null || badgeIcon === void 0 ? void 0 : badgeIcon.iconName) && PriceTicketLarge_jsx("span", {
    className: "font-brand mx-1 text-base"
  }, "&"), hasECLogo && PriceTicketLarge_jsx(ECBadge["a" /* ECBadge */], {
    height: PriceTicketLarge_ICONS_HEIGHT,
    iconWidth: "80%"
  }), PriceTicketLarge_jsx("div", {
    className: "flex-auto mx-3"
  }, PriceTicketLarge_jsx(Title["a" /* Title */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 1,
    theme: "none"
  }, PriceTicketLarge_jsx("div", {
    className: "font-brand font-normal leading-tight text-xl",
    "data-testid": "priceTicket-title"
  }, title), PriceTicketLarge_jsx("div", {
    className: "font-sans font-bold leading-tight uppercase text-md",
    "data-testid": "priceTicket-subtitle"
  }, subtitle))), !Object(lodash["isEmpty"])(info) && PriceTicketLarge_jsx("div", {
    className: "flex items-center px-2",
    "data-testid": "PriceTicketLarge-info"
  }, PriceTicketLarge_jsx(Icon["a" /* Icon */], {
    className: "-mt-1",
    color: colors["a" /* COLORS */].BLUE,
    name: info.iconName,
    width: "1.2rem"
  }), PriceTicketLarge_jsx("span", {
    className: "font-brand mx-2 text-blue text-md"
  }, info.label)), !hasCallCenter && !Object(lodash["isEmpty"])(price) && PriceTicketLarge_jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({}, price, {
    className: "flex items-center px-2 w-1/4",
    from: Object(src_i18n["f" /* t */])('price.format.from'),
    hasInitialPrice: false,
    instead: Object(src_i18n["f" /* t */])('price.format.instead'),
    theme: "remote"
  })), staticPrice && PriceTicketLarge_jsx(TemplateString["a" /* TemplateString */], {
    className: "text-gray-darker text-base font-sans leading-one",
    valuesClassName: {
      amount: 'text-2xl underline font-brand leading-tight'
    },
    template: staticPrice.price,
    values: {
      amount: staticPrice.amount
    }
  }), hasCallCenter && travelAdvisorConfig && PriceTicketLarge_jsx(BlockLink["a" /* BlockLink */], {
    className: classnames_default()('mx-5 text-gray-darker', {
      'sr-only opacity-0 pointer-events-none': isLite
    }),
    icon: icons["a" /* ICONS */].PHONE_BUBBLE,
    texts: travelAdvisorConfig.text,
    url: travelAdvisorConfig.href
  }), (fromPriceTicketCustom || isLite || hasCallCenter) && PriceTicketLarge_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, button, {
    className: "rtl:ml-5"
  }))), hasDetail && PriceTicketLarge_jsx("div", {
    className: "border-t-1 flex items-center justify-between p-2"
  }, PriceTicketLarge_jsx("div", {
    className: "font-bold font-sans text-blue text-md w-1/4"
  }, Object(src_i18n["f" /* t */])('productPriceTicketLine.startingPriceCriteriaLabel', {}, '')), PriceTicketLarge_jsx("div", {
    className: "flex flex-1 items-stretch"
  }, items.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label,
        longDesc = _ref2.longDesc;
    return PriceTicketLarge_jsx(DynamicLink["a" /* default */], {
      className: "flex flex-1 items-center px-2",
      "data-testid": "PriceTicketLarge-item",
      key: iconName,
      url: button === null || button === void 0 ? void 0 : button.url
    }, PriceTicketLarge_jsx(Icon["a" /* Icon */], {
      className: "flex-shrink-0",
      color: colors["a" /* COLORS */].BLUE,
      name: iconName,
      width: "1rem",
      title: label
    }), PriceTicketLarge_jsx("div", {
      className: "font-sans rtl:ml-2 text-base text-gray-medium-dark"
    }, longDesc));
  })), PriceTicketLarge_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, button, {
    className: "w-1/4",
    size: "large",
    onClick: scroll
  }))), !!(allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.length) && PriceTicketLarge_jsx(react["Fragment"], null, isDetailOpened && PriceTicketLarge_jsx(react_collapse_lib["Collapse"], {
    isOpened: isDetailOpened
  }, PriceTicketLarge_jsx("div", {
    className: "border-t-1 border-gray-light flex flex-wrap"
  }, splitServices[0] ? PriceTicketLarge_jsx(PriceRemoteServiceList_PriceRemoteServiceList, {
    isDesktop: true,
    services: splitServices[0]
  }) : null, splitServices[1] ? PriceTicketLarge_jsx(PriceRemoteServiceList_PriceRemoteServiceList, {
    isDesktop: true,
    services: splitServices[1]
  }) : null)), PriceTicketLarge_jsx("div", {
    className: classnames_default()('absolute flex items-center justify-center left-1/2 -translate-x-50', {
      '-mt-px': !isLite,
      'bottom-full -mb-px': isLite
    })
  }, PriceTicketLarge_jsx(PriceRemoteTitleButton_PriceRemoteTitleButton, {
    handleClick: function handleClick() {
      return setIsDetailOpened(!isDetailOpened);
    },
    isCollapsed: isDetailOpened,
    isDesktop: true,
    isSticky: isLite
  })))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket-narrow/PriceTicketNarrow.jsx

var PriceTicketNarrow_jsx = react_default.a.createElement;



















var PriceTicketNarrow_PriceTicketNarrow = function PriceTicketNarrow(_ref) {
  var _ref$allInclusiveServ = _ref.allInclusiveServices,
      allInclusiveServices = _ref$allInclusiveServ === void 0 ? [] : _ref$allInclusiveServ,
      className = _ref.className,
      button = _ref.button,
      hasCallCenter = _ref.hasCallCenter,
      isLite = _ref.isLite,
      isLoading = _ref.isLoading,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      price = _ref.price,
      staticPrice = _ref.staticPrice,
      travelAdvisorConfig = _ref.travelAdvisorConfig;

  var _useState = Object(react["useState"])(false),
      isDetailOpened = _useState[0],
      setIsDetailOpened = _useState[1];

  var hasPrice = !hasCallCenter && !Object(lodash["isEmpty"])(price);
  var hasBlockLink = hasCallCenter && !isLite;
  var scroll = button && button.url && /^(#|\.)/.test(button.url) ? function () {
    return Object(scrollToElement["a" /* scrollToElement */])(button.url, 500);
  } : lodash["noop"];
  return PriceTicketNarrow_jsx("div", {
    className: classnames_default()(className, {
      'opacity-75': isLoading,
      fadeInLong: !isLite,
      slideInBottom: isLite
    }),
    "data-testid": "PriceTicketNarrow",
    style: {
      minHeight: MIN_HEIGHT
    }
  }, PriceTicketNarrow_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: isLite
  }, PriceTicketNarrow_jsx("div", {
    className: classnames_default()('bg-white border-t-1 flex flex-col items-center', {
      'border-1 rounded-small shadow-sm': !isLite
    })
  }, isLoading ? PriceTicketNarrow_jsx(Spinner["a" /* Spinner */], {
    className: "p-2",
    size: "small",
    color: colors["a" /* COLORS */].BLUE
  }) : PriceTicketNarrow_jsx(react["Fragment"], null, hasBlockLink && travelAdvisorConfig && PriceTicketNarrow_jsx(BlockLink["a" /* BlockLink */], {
    className: "m-2 text-gray-darker",
    icon: icons["a" /* ICONS */].PHONE_BUBBLE,
    texts: travelAdvisorConfig.text,
    url: travelAdvisorConfig.href
  }), hasPrice && PriceTicketNarrow_jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({}, price, {
    className: "m-2",
    from: Object(src_i18n["f" /* t */])('price.format.from'),
    hasInitialPrice: false,
    instead: Object(src_i18n["f" /* t */])('price.format.instead'),
    theme: "remote"
  })), staticPrice && PriceTicketNarrow_jsx(TemplateString["a" /* TemplateString */], {
    className: "block px-9 pb-5 text-center text-gray-darker text-base font-sans leading-one",
    valuesClassName: {
      amount: 'text-2xl underline font-brand leading-tight'
    },
    template: staticPrice.price,
    values: {
      amount: staticPrice.amount
    }
  }), PriceTicketNarrow_jsx("div", {
    className: classnames_default()('p-2 w-full', {
      'border-t-1': !isLite
    })
  }, !isLite && !hasCallCenter && !!items.length && PriceTicketNarrow_jsx(react["Fragment"], null, PriceTicketNarrow_jsx("div", {
    className: "font-bold font-sans text-blue text-center text-sm"
  }, Object(src_i18n["f" /* t */])('productPriceTicketLine.startingPriceCriteriaLabel', {}, '')), PriceTicketNarrow_jsx("ul", {
    className: "reset-list flex mb-2 text-sm"
  }, items.map(function (item) {
    return PriceTicketNarrow_jsx("li", {
      className: "flex-1",
      "data-testid": "PriceTicketNarrow-item",
      key: item.iconName
    }, PriceTicketNarrow_jsx(DynamicLink["a" /* default */], {
      className: "flex items-center justify-center text-gray-medium-dark",
      url: button === null || button === void 0 ? void 0 : button.url
    }, PriceTicketNarrow_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-2",
      color: colors["a" /* COLORS */].BLUE,
      name: item.iconName,
      width: "1.25rem"
    }), item.shortDesc));
  }))), PriceTicketNarrow_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, button, {
    className: "w-full",
    size: "large",
    onClick: scroll
  }))), !!(allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.length) && PriceTicketNarrow_jsx(react["Fragment"], null, isDetailOpened && PriceTicketNarrow_jsx(PriceRemoteDetailsLayer_PriceRemoteDetailsLayer, {
    allInclusiveServices: allInclusiveServices,
    closeLabel: Object(src_i18n["f" /* t */])('common.close'),
    isLoading: isLoading,
    nameRender: Portal_constants["b" /* AFTER_APP */],
    onBack: function onBack() {
      return setIsDetailOpened(false);
    }
  }), PriceTicketNarrow_jsx("div", {
    className: classnames_default()('absolute flex items-center justify-center left-1/2 -translate-x-50', {
      '-mt-px top-full': !isLite,
      'bottom-full -mb-px': isLite
    })
  }, PriceTicketNarrow_jsx(PriceRemoteTitleButton_PriceRemoteTitleButton, {
    handleClick: function handleClick() {
      return setIsDetailOpened(!isDetailOpened);
    },
    isCollapsed: isDetailOpened,
    isDesktop: true,
    isSticky: isLite
  })))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket/PriceTicketContentWrapper.jsx

var PriceTicketContentWrapper_jsx = react_default.a.createElement;












var PriceTicketContentWrapper_PriceTicketContentWrapper = function PriceTicketContentWrapper(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(false),
      isSticky = _useState[0],
      setIsSticky = _useState[1];

  var onStateChange = function onStateChange(status) {
    setIsSticky(status.status !== react_stickynode_default.a.STATUS_ORIGINAL);
  };

  return PriceTicketContentWrapper_jsx(react["Fragment"], null, PriceTicketContentWrapper_jsx(SiteContainer["a" /* SiteContainer */], null, Object(sellerUtils["g" /* isSeller */])(appContext) && PriceTicketContentWrapper_jsx("button", {
    className: "flex items-center mb-3 text-turquoise",
    "data-testid": "PriceTicketBackToSearch",
    onClick: history.back,
    type: "button"
  }, PriceTicketContentWrapper_jsx(Icon["a" /* Icon */], {
    className: "-scale-x-1 mr-1",
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.9rem"
  }), Object(src_i18n["f" /* t */])('common.comparator.backToSearch'))), PriceTicketContentWrapper_jsx(react_stickynode_default.a, {
    activeClass: "sticky-bottom",
    bottomBoundary: ".PriceTicket-sticky-beacon",
    innerZ: 6,
    onStateChange: onStateChange,
    releasedClass: "sticky-bottom-released"
  }, isDesktop ? PriceTicketContentWrapper_jsx(PriceTicketLarge_PriceTicketLarge, Object(esm_extends["a" /* default */])({}, props, {
    isLite: isSticky
  })) : PriceTicketContentWrapper_jsx(PriceTicketNarrow_PriceTicketNarrow, Object(esm_extends["a" /* default */])({}, props, {
    isLite: isSticky
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket/PriceTicket.jsx
var PriceTicket_jsx = react_default.a.createElement;














var PriceTicket_PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var MIN_HEIGHT = '4.25rem';
var PriceTicket_PriceTicket = function PriceTicket(_ref) {
  var _price$termsAndCondit3;

  var cruise = _ref.cruise,
      product = _ref.product,
      travelAdvisorConfig = _ref.travelAdvisorConfig;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var isLoading = Object(es["e" /* useSelector */])(function (state) {
    return state.priceTicket.isLoading;
  });
  var price = Object(es["e" /* useSelector */])(function (state) {
    return state.priceTicket.price;
  });
  var allInclusiveServices = Object(es["e" /* useSelector */])(allInclusiveServicesSelector);
  var dispatch = Object(es["d" /* useDispatch */])();
  Object(react["useEffect"])(function () {
    dispatch(priceTicketRequest({
      appContext: appContext,
      location: location,
      productId: product.id
    }));
  }, [product.id]);
  Object(react["useEffect"])(function () {
    var _price$termsAndCondit;

    if (product.id && product.id === (price === null || price === void 0 ? void 0 : (_price$termsAndCondit = price.termsAndConditions) === null || _price$termsAndCondit === void 0 ? void 0 : _price$termsAndCondit.productId)) {
      var _price$termsAndCondit2;

      dispatch(allInclusiveServices_actions_getAllInclusiveServices(appContext, {
        productId: product.id,
        accommodationId: price.termsAndConditions.accommodationId,
        includesTransportation: !!((_price$termsAndCondit2 = price.termsAndConditions.departureCity) === null || _price$termsAndCondit2 === void 0 ? void 0 : _price$termsAndCondit2.value)
      }));
    }
  }, [product.id === (price === null || price === void 0 ? void 0 : (_price$termsAndCondit3 = price.termsAndConditions) === null || _price$termsAndCondit3 === void 0 ? void 0 : _price$termsAndCondit3.productId)]);
  var fromStore = {
    adultsNumber: Object(es["e" /* useSelector */])(storeHelper["b" /* getAdultsNumber */]),
    departureCity: Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]),
    departureDate: Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]),
    duration: Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */])
  };
  return PriceTicket_jsx(PriceTicketContentWrapper_PriceTicketContentWrapper, {
    allInclusiveServices: [PriceTicket_PRODUCT_TYPES.SUMMER_CAMP, PriceTicket_PRODUCT_TYPES.TOUR].includes(product.type) ? [] : allInclusiveServices,
    badgeIcon: Object(product_utils["d" /* getProductBadgeIcon */])(product),
    button: priceTicket_mapper_getPriceTicketButton(product),
    hasCallCenter: !Object(price_util["d" /* hasAtLeastOnePrice */])(price),
    hasECLogo: product.isExplicitEC,
    info: priceTicket_mapper_getPriceTicketInfo(product),
    isLoading: isLoading,
    items: priceTicket_mapper_getPriceTicketItems({
      fromStore: fromStore,
      price: price,
      product: product
    }),
    price: price,
    subtitle: getPriceTicketSubtitle(product, cruise),
    title: product.name,
    travelAdvisorConfig: travelAdvisorConfig
  });
};
// CONCATENATED MODULE: ./src/client/components/lines/product-price-ticket-line/ProductPriceTicketLine.jsx


var ProductPriceTicketLine_jsx = react_default.a.createElement;

function ProductPriceTicketLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductPriceTicketLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductPriceTicketLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductPriceTicketLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var ProductPriceTicketLine_DATE_FORMAT = 'D MMMM YYYY';
var ProductPriceTicketLine_ProductPriceTicketLine = function ProductPriceTicketLine(_ref) {
  var adult = _ref.adult,
      adults = _ref.adults,
      askForQuotation = _ref.askForQuotation,
      book = _ref.book,
      collapseLabels = _ref.collapseLabels,
      condensedDepartureDateFormat = _ref.condensedDepartureDateFormat,
      config = _ref.config,
      cruise = _ref.cruise,
      departureCityLabel = _ref.departureCityLabel,
      _ref$departureDateFor = _ref.departureDateFormat,
      departureDateFormat = _ref$departureDateFor === void 0 ? ProductPriceTicketLine_DATE_FORMAT : _ref$departureDateFor,
      departureDateLabel = _ref.departureDateLabel,
      durationPlaceholder = _ref.durationPlaceholder,
      fromToPlaceholder = _ref.fromToPlaceholder,
      product = _ref.product,
      seeAllPrices = _ref.seeAllPrices,
      startingPriceCriteriaLabel = _ref.startingPriceCriteriaLabel;

  if (!product) {
    return null;
  }

  var travelAdvisor = config.travelAdvisor,
      i18nConfig = Object(objectWithoutProperties["a" /* default */])(config, ["travelAdvisor"]);

  Object(src_i18n["a" /* addTranslationKeys */])(ProductPriceTicketLine_objectSpread(ProductPriceTicketLine_objectSpread({}, i18nConfig), {}, {
    productPriceTicketLine: {
      adult: adult,
      adults: adults,
      askForQuotation: askForQuotation,
      book: book,
      collapseLabels: collapseLabels,
      condensedDepartureDateFormat: condensedDepartureDateFormat,
      departureCityLabel: departureCityLabel,
      departureDateFormat: departureDateFormat,
      departureDateLabel: departureDateLabel,
      durationPlaceholder: durationPlaceholder,
      fromToPlaceholder: fromToPlaceholder,
      seeAllPrices: seeAllPrices,
      startingPriceCriteriaLabel: startingPriceCriteriaLabel
    }
  }));
  return ProductPriceTicketLine_jsx("div", {
    className: "Line Line-PriceTicket",
    "data-testid": "Line-ProductPriceTicket"
  }, ProductPriceTicketLine_jsx(PriceTicket_PriceTicket, {
    cruise: cruise,
    product: product,
    travelAdvisorConfig: travelAdvisor
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-price-ticket/productPriceTicket.resolver.js
var productPriceTicket_resolver = __webpack_require__("3FxL");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-price-ticket/productPriceTicket.descriptor.js



var productPriceTicketDescriptor = {
  name: constants["mb" /* RESORT_PRICE_TICKET */],
  component: ProductPriceTicketLine_ProductPriceTicketLine,
  resolve: productPriceTicket_resolver["a" /* productPriceTicketResolver */].resolve
};
// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// CONCATENATED MODULE: ./src/client/components/lines/product-price-ticket-custom/ProductPriceTicketCustom.jsx

var ProductPriceTicketCustom_jsx = react_default.a.createElement;

function ProductPriceTicketCustom_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductPriceTicketCustom_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductPriceTicketCustom_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductPriceTicketCustom_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var ProductPriceTicketCustom_ProductPriceTicketCustom = function ProductPriceTicketCustom(_ref) {
  var getAQuoteCTA = _ref.getAQuoteCTA,
      getAQuoteURL = _ref.getAQuoteURL,
      price = _ref.price,
      amount = _ref.amount,
      resort = _ref.resort,
      config = _ref.config;

  var _useContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageType = _useContext.pageType;

  var _useContext2 = Object(react["useContext"])(ReactAppContext["a" /* default */]),
      locale = _useContext2.locale;

  Object(src_i18n["a" /* addTranslationKeys */])(ProductPriceTicketCustom_objectSpread(ProductPriceTicketCustom_objectSpread({}, config), {}, {
    productPriceTicketMiceLine: {
      getAQuoteCTA: getAQuoteCTA,
      getAQuoteURL: getAQuoteURL,
      price: price,
      amount: amount
    }
  })); // Replace comma because users can use either 1234,56 or 1234.56 format

  var amountAsNumber = Number(amount.replace(/,/g, '.'));
  var staticPrice = price && amount && !Number.isNaN(amountAsNumber) ? {
    price: price,
    amount: Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(amountAsNumber, locale)
  } : undefined;
  var priceTicketContentProps = {
    title: resort.name,
    subtitle: getPriceTicketSubtitle(resort),
    badgeIcon: Object(product_utils["d" /* getProductBadgeIcon */])(resort),
    button: {
      children: getAQuoteCTA,
      colorBg: colors["a" /* COLORS */].BOOKING,
      colorBorder: colors["a" /* COLORS */].BOOKING,
      url: getAQuoteURL,
      trackingData: {
        actionGA: 'priceBar',
        labelGA: 'getAQuote',
        categoryGA: pageType
      }
    },
    hasECLogo: resort.isExplicitEC,
    staticPrice: staticPrice,
    fromPriceTicketCustom: true
  };
  return ProductPriceTicketCustom_jsx("div", {
    className: "Line Line-PriceTicketCustom"
  }, ProductPriceTicketCustom_jsx(PriceTicketContentWrapper_PriceTicketContentWrapper, priceTicketContentProps));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-price-ticket-custom/productPriceTicketCustom.resolver.js
var productPriceTicketCustom_resolver = __webpack_require__("m4Zw");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-price-ticket-custom/productPriceTicketCustom.descriptor.js




var productPriceTicketCustomDescriptor = {
  name: constants["Q" /* PRODUCT_PRICE_TICKET_CUSTOM */],
  component: ProductPriceTicketCustom_ProductPriceTicketCustom,
  resolve: productPriceTicketCustom_resolver["a" /* productPriceTicketCustomResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/productQuotationForm.utils.js




function productQuotationForm_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function productQuotationForm_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      productQuotationForm_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      productQuotationForm_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var productQuotationForm_utils_getInitialFormValues = function getInitialFormValues(_ref) {
  var extensionOptions = _ref.extensionOptions,
      isEscapade = _ref.isEscapade,
      isSummerCamp = _ref.isSummerCamp;
  return productQuotationForm_utils_objectSpread(productQuotationForm_utils_objectSpread(productQuotationForm_utils_objectSpread({
    adultsNumber: isSummerCamp ? MIN_FORM_TEENS.toString() : productQuotationForm_constants_MIN_FORM_ADULTS.toString(),
    comment: '',
    departureCity: '',
    departureDate: isEscapade ? {
      from: null,
      to: null
    } : ''
  }, extensionOptions.length > 0 ? {
    extension: ''
  } : null), isSummerCamp ? null : {
    kidsNumber: productQuotationForm_constants_MIN_FORM_KIDS.toString()
  }), {}, {
    optinEmail: false,
    traveler: {
      civility: '',
      email: '',
      firstName: '',
      lastName: '',
      phone: ''
    }
  });
}; // Set form schema

var productQuotationForm_utils_getFormSchema = function getFormSchema(t, _ref2) {
  var civilityOptions = _ref2.civilityOptions,
      departureCityOptions = _ref2.departureCityOptions,
      departureDateOptions = _ref2.departureDateOptions,
      extensionOptions = _ref2.extensionOptions,
      isEscapade = _ref2.isEscapade,
      isSummerCamp = _ref2.isSummerCamp;
  var fistNameSchema = lib["string"]().required(t('productQuotationForm.coordinates.firstName')).max(20, t('productQuotationForm.coordinates.firstName'));
  var lastNameSchema = lib["string"]().required(t('productQuotationForm.coordinates.lastName')).max(30, t('productQuotationForm.coordinates.lastName'));
  return lib["object"]().shape(productQuotationForm_utils_objectSpread(productQuotationForm_utils_objectSpread(productQuotationForm_utils_objectSpread({
    adultsNumber: lib["string"]().required(),
    comment: lib["string"](),
    departureCity: lib["mixed"]().oneOf(departureCityOptions.map(function (c) {
      return c.value;
    })).required(),
    departureDate: isEscapade ? lib["object"]().shape({
      from: lib["date"](),
      to: lib["date"]().nullable()
    }).required() : lib["mixed"]().oneOf(departureDateOptions.map(function (d) {
      return d.value;
    })).required()
  }, extensionOptions.length > 0 ? {
    extension: lib["mixed"]().oneOf(extensionOptions.map(function (e) {
      return e.value;
    })).required()
  } : null), isSummerCamp ? null : {
    kidsNumber: lib["string"]().required()
  }), {}, {
    optinEmail: lib["boolean"](),
    traveler: lib["object"]().shape({
      civility: lib["mixed"]().oneOf(civilityOptions.map(function (c) {
        return c.value;
      })).required(),
      email: lib["string"]().email(t('productQuotationForm.coordinates.email')).required(t('productQuotationForm.coordinates.email')),
      firstName: fistNameSchema,
      lastName: lastNameSchema,
      phone: lib["string"]().required(t('productQuotationForm.coordinates.phoneNumber')).matches(/^(\+[1-9]|0)?\d{1,14}$/, {
        excludeEmptyString: true,
        message: t('productQuotationForm.coordinates.phoneNumber')
      })
    })
  }));
}; // Submit form

var productQuotationForm_utils_FORM_STATUS = {
  NEW: 'new',
  SUCCESS: 'success',
  ERROR: 'error'
};

var productQuotationForm_utils_getFormattedDepartureDate = function getFormattedDepartureDate(date) {
  return typeof date === 'string' ? date : Object(apiDate["j" /* momentToApiDate */])(moment_default()(date.from || Date.now()));
};

var productQuotationForm_utils_getProductQuotationFormMutation = function getProductQuotationFormMutation(values, product) {
  var adultsNumber = values.adultsNumber,
      _values$kidsNumber = values.kidsNumber,
      kidsNumber = _values$kidsNumber === void 0 ? 0 : _values$kidsNumber,
      comment = values.comment,
      departureCity = values.departureCity,
      departureDate = values.departureDate,
      _values$extension = values.extension,
      extension = _values$extension === void 0 ? '' : _values$extension,
      optinEmail = values.optinEmail,
      traveler = values.traveler;
  var productId = product.productId,
      productLabel = product.productLabel,
      productRangeLabel = product.productRangeLabel;
  var civility = traveler.civility,
      email = traveler.email,
      firstName = traveler.firstName,
      lastName = traveler.lastName,
      phone = traveler.phone;
  var formattedDepartureDate = productQuotationForm_utils_getFormattedDepartureDate(departureDate);
  return "mutation {\n    productRequest(\n      adultsCount: ".concat(parseInt(adultsNumber, 10), "\n      childrenCount: ").concat(parseInt(kidsNumber, 10), "\n      contact: {\n        civility: \"").concat(civility, "\"\n        firstName: \"").concat(firstName, "\"\n        lastName: \"").concat(lastName, "\"\n        email: \"").concat(email, "\"\n        mobile: \"").concat(phone, "\"\n      }\n      customerComment: ").concat(Object(graphql["e" /* graphqlifyString */])(comment), "\n      departureCity: \"").concat(departureCity || NO_VALUE, "\"\n      departureDate: \"").concat(formattedDepartureDate, "\"\n      extensionName: \"").concat(extension, "\"\n      productId: \"").concat(productId, "\"\n      productLabel: \"").concat(productLabel, "\"\n      productRangeLabel: \"").concat(productRangeLabel, "\"\n      optinEmail: ").concat(optinEmail.toString(), "\n    ) {\n      statusCode\n    }\n  }");
};
var getNewsletterSubscriptionMutation = function getNewsletterSubscriptionMutation(values, newsletterId) {
  var _values$traveler = values.traveler,
      civility = _values$traveler.civility,
      email = _values$traveler.email,
      firstName = _values$traveler.firstName,
      lastName = _values$traveler.lastName;
  return "mutation {\n    subscription (\n      civility: \"".concat(civility, "\"\n      email: \"").concat(email, "\"\n      firstName: \"").concat(firstName, "\"\n      isSubscription: true\n      lastName: \"").concat(lastName, "\"\n      newsletterSubscriptions : [\"").concat(newsletterId, "\"]\n      unicodeFirstName: \"").concat(firstName, "\"\n      unicodeLastName: \"").concat(lastName, "\"\n    ) {\n      id\n      neolaneId\n    }\n  }");
};
var productQuotationForm_utils_handleSubmit = /*#__PURE__*/function () {
  var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values, params) {
    var actions, appContext, isSummerCamp, product, quotation, trackingData, productQuotationFormMutation, _ref4, productRequest, pageType, adultsNumber, kidsNumber, hasNoTransport, formattedDepartureDate;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            actions = params.actions, appContext = params.appContext, isSummerCamp = params.isSummerCamp, product = params.product, quotation = params.quotation, trackingData = params.trackingData;
            actions.setSubmitting(true);
            productQuotationFormMutation = productQuotationForm_utils_getProductQuotationFormMutation(values, product);
            _context.prev = 3;
            _context.next = 6;
            return graphqlClient["a" /* default */].runNoCacheQuery(productQuotationFormMutation, appContext, {
              requestName: requestDictionary["Nd" /* WIDGET_QUOTATION_FORM_SUBMIT */]
            });

          case 6:
            _ref4 = _context.sent;
            productRequest = _ref4.productRequest;

            if (productRequest.statusCode === 500) {
              actions.setStatus(productQuotationForm_utils_objectSpread({
                state: productQuotationForm_utils_FORM_STATUS.ERROR
              }, quotation.error));
            } else {
              if (isSummerCamp) {
                pageType = 'landing';
                tracking_api["b" /* setDataLayer */]({
                  actionGA: 'SummerCamp',
                  categoryGA: pageType,
                  labelGA: 'CTASendQuote',
                  siteSection: Object(utils["d" /* getSiteSection */])({
                    pageType: pageType
                  })
                }, appContext);
              }

              actions.setStatus(productQuotationForm_utils_objectSpread({
                state: productQuotationForm_utils_FORM_STATUS.SUCCESS
              }, quotation.success));
            }

            if (!isSummerCamp) {
              adultsNumber = parseInt(values.adultsNumber, 10);
              kidsNumber = parseInt(values.kidsNumber, 10);
              hasNoTransport = values.departureCity === '' || values.departureCity === 'NO';
              formattedDepartureDate = productQuotationForm_utils_getFormattedDepartureDate(values.departureDate);
              tracking_api["b" /* setDataLayer */](productQuotationForm_utils_objectSpread(productQuotationForm_utils_objectSpread({}, trackingData), {}, {
                resortAdult: adultsNumber,
                resortChildren: kidsNumber,
                resortDepartureCityCode: hasNoTransport ? 'without transport' : values.departureCity,
                resortDepartureDate: formattedDepartureDate,
                resortTotalParticipant: adultsNumber + kidsNumber,
                resortTransport: hasNoTransport ? 'without transport' : 'with transport'
              }), appContext);
            }

            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](3);
            actions.setStatus(productQuotationForm_utils_objectSpread({
              state: productQuotationForm_utils_FORM_STATUS.ERROR
            }, quotation.error));

          case 15:
            _context.prev = 15;
            actions.setSubmitting(false);
            return _context.finish(15);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 12, 15, 18]]);
  }));

  return function handleSubmit(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/ProductQuotationForm.jsx

var ProductQuotationForm_jsx = react_default.a.createElement;















var FormFieldNote = function FormFieldNote(_ref) {
  var note = _ref.note;
  return ProductQuotationForm_jsx("span", {
    className: "mt-1 text-sm text-gray-medium"
  }, note);
};

function ProductQuotationForm(_ref2) {
  var adultsOptions = _ref2.adultsOptions,
      ageIndicationAdults = _ref2.ageIndicationAdults,
      ageIndicationKids = _ref2.ageIndicationKids,
      availableDatesIndication = _ref2.availableDatesIndication,
      civilityOptions = _ref2.civilityOptions,
      dateFormat = _ref2.dateFormat,
      departureCityOptions = _ref2.departureCityOptions,
      departureDateOptions = _ref2.departureDateOptions,
      departureDateEnd = _ref2.departureDateEnd,
      departureDateStart = _ref2.departureDateStart,
      extensionOptions = _ref2.extensionOptions,
      footnotes = _ref2.footnotes,
      isEscapade = _ref2.isEscapade,
      isSummerCamp = _ref2.isSummerCamp,
      kidsOptions = _ref2.kidsOptions,
      newsletter = _ref2.newsletter,
      newsletterOptins = _ref2.newsletterOptins;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      isSubmitting = _useFormikContext.isSubmitting,
      isValid = _useFormikContext.isValid,
      status = _useFormikContext.status;

  var optinEmail = newsletterOptins.optinEmail,
      optinProfile = newsletterOptins.optinProfile;
  return ProductQuotationForm_jsx(formik_esm["c" /* Form */], {
    id: QUOTATION_FORM_ID,
    "data-testid": QUOTATION_FORM_ID
  }, ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mt-8 mb-1 px-2",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 2,
    theme: "title-sans-4"
  }, Object(src_i18n["f" /* t */])('productQuotationForm.title')), ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mt-8 mb-1 px-2",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["f" /* t */])('productQuotationForm.criteria.title')), ProductQuotationForm_jsx("div", {
    className: "flex flex-wrap"
  }, ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, isEscapade ? ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-date-field",
    dateFormat: dateFormat,
    hideErrorMessage: true,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('productQuotationForm.criteria.dateLabel'),
    maxDate: departureDateEnd,
    minDate: departureDateStart,
    name: "departureDate",
    placeholder: Object(src_i18n["f" /* t */])('productQuotationForm.criteria.datePlaceholder'),
    type: "datepicker"
  }) : ProductQuotationForm_jsx(react["Fragment"], null, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-date-field",
    hideErrorMessage: true,
    isDisabled: departureDateOptions.length === 0,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('productQuotationForm.criteria.dateLabel'),
    name: "departureDate",
    options: departureDateOptions,
    placeholder: Object(src_i18n["f" /* t */])('productQuotationForm.criteria.datePlaceholder'),
    type: "select"
  }), departureDateOptions.length === 0 && ProductQuotationForm_jsx("span", {
    className: "flex items-center text-sm mt-1 text-blue"
  }, ProductQuotationForm_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-1",
    name: icons["a" /* ICONS */].WARNING,
    width: ".75rem"
  }), availableDatesIndication))), extensionOptions.length > 0 && ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "extension-field",
    hideErrorMessage: true,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('productQuotationForm.criteria.extensionLabel'),
    name: "extension",
    options: extensionOptions,
    placeholder: Object(src_i18n["f" /* t */])('productQuotationForm.criteria.extensionPlaceholder'),
    type: "select"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-city-field",
    hideErrorMessage: true,
    isRequired: true,
    label: Object(src_i18n["f" /* t */])('productQuotationForm.criteria.transportationLabel'),
    name: "departureCity",
    options: departureCityOptions,
    placeholder: Object(src_i18n["f" /* t */])('productQuotationForm.criteria.transportationPlaceholder'),
    type: "select"
  }))), ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mt-8 mb-1 px-2",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["f" /* t */])('productQuotationForm.pax.title')), ProductQuotationForm_jsx("div", {
    className: "flex flex-wrap"
  }, ProductQuotationForm_jsx("p", {
    className: "w-full mt-2 mb-0 px-2 text-base font-bold"
  }, Object(src_i18n["f" /* t */])('productQuotationForm.pax.paxLabel'), '*'), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "adults-number-field",
    hideErrorMessage: true,
    name: "adultsNumber",
    options: adultsOptions,
    type: "select"
  }), ProductQuotationForm_jsx(FormFieldNote, {
    note: ageIndicationAdults
  })), !isSummerCamp && ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "kids-number-field",
    hideErrorMessage: true,
    name: "kidsNumber",
    options: kidsOptions,
    type: "select"
  }), ProductQuotationForm_jsx(FormFieldNote, {
    note: ageIndicationKids
  }))), ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mt-8 mb-1 px-2",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["f" /* t */])('productQuotationForm.coordinates.title')), ProductQuotationForm_jsx("div", {
    className: "flex flex-wrap"
  }, ProductQuotationForm_jsx("p", {
    className: "w-full mt-2 mb-0 px-2 text-base font-bold"
  }, Object(src_i18n["f" /* t */])('productQuotationForm.coordinates.informationLabel')), ProductQuotationForm_jsx("div", {
    className: "w-full"
  }, ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-civility-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.civility",
    options: civilityOptions,
    placeholder: Object(src_i18n["f" /* t */])('productQuotationForm.coordinates.civility'),
    type: "select"
  }))), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-firstName-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.firstName",
    placeholder: "".concat(Object(src_i18n["f" /* t */])('productQuotationForm.coordinates.firstName'), " *"),
    type: "text"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-lastName-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.lastName",
    placeholder: "".concat(Object(src_i18n["f" /* t */])('productQuotationForm.coordinates.lastName'), " *"),
    type: "text"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-email-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.email",
    placeholder: "".concat(Object(src_i18n["f" /* t */])('productQuotationForm.coordinates.email'), " *"),
    type: "text"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-phone-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.phone",
    placeholder: "".concat(Object(src_i18n["f" /* t */])('productQuotationForm.coordinates.phoneNumber'), " *"),
    type: "text"
  })), optinEmail && ProductQuotationForm_jsx("div", {
    className: "w-full p-2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-3",
    dataTestId: "optin-email-field",
    label: newsletter.description || optinEmail.title,
    name: "optinEmail",
    optimized: true,
    type: "checkbox"
  }), optinEmail && optinEmail.description && ProductQuotationForm_jsx(Text["a" /* Text */], {
    className: "mt-4",
    theme: "text-sans-2",
    text: optinEmail.description
  }), optinProfile && optinProfile.description && ProductQuotationForm_jsx(Text["a" /* Text */], {
    className: "mt-4",
    theme: "text-sans-2",
    text: optinProfile.description
  }))), ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mt-8 mb-1 px-2",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["f" /* t */])('productQuotationForm.specialRequest.title')), ProductQuotationForm_jsx("div", {
    className: "w-full p-2"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "comment-field",
    name: "comment",
    placeholder: Object(src_i18n["f" /* t */])('productQuotationForm.specialRequest.placeholder'),
    type: "textarea"
  })), ProductQuotationForm_jsx("div", {
    className: classnames_default()('mt-8 px-2', {
      'text-right': status.state === productQuotationForm_utils_FORM_STATUS.NEW,
      'flex justify-center': status.state !== productQuotationForm_utils_FORM_STATUS.NEW
    })
  }, status.state === productQuotationForm_utils_FORM_STATUS.NEW ? ProductQuotationForm_jsx(react["Fragment"], null, ProductQuotationForm_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BLUE,
    colorBorder: colors["a" /* COLORS */].BLUE,
    dataTestId: "product-quotation-submit",
    isDisabled: !isValid,
    isLoading: isSubmitting,
    type: "submit"
  }, Object(src_i18n["f" /* t */])('productQuotationForm.quotation.buttonLabel')), footnotes.length > 0 && ProductQuotationForm_jsx("div", {
    className: "leading-normal py-3 max-w-full text-base text-gray-darker"
  }, footnotes.map(function (note) {
    return ProductQuotationForm_jsx("p", {
      className: "my-0",
      key: note
    }, note);
  }))) : ProductQuotationForm_jsx(Confirmation["a" /* Confirmation */], Object(esm_extends["a" /* default */])({}, status, {
    status: status.state
  }))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/ProductQuotationFormContainer.jsx


var ProductQuotationFormContainer_jsx = react_default.a.createElement;






function ProductQuotationFormContainer(_ref) {
  var adultsOptions = _ref.adultsOptions,
      ageIndicationAdults = _ref.ageIndicationAdults,
      ageIndicationKids = _ref.ageIndicationKids,
      availableDatesIndication = _ref.availableDatesIndication,
      civilityOptions = _ref.civilityOptions,
      dateFormat = _ref.dateFormat,
      departureCityOptions = _ref.departureCityOptions,
      departureDateOptions = _ref.departureDateOptions,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      extensionOptions = _ref.extensionOptions,
      footnotes = _ref.footnotes,
      isEscapade = _ref.isEscapade,
      isSummerCamp = _ref.isSummerCamp,
      kidsOptions = _ref.kidsOptions,
      newsletter = _ref.newsletter,
      newsletterOptins = _ref.newsletterOptins,
      product = _ref.product,
      quotation = _ref.quotation,
      trackingData = _ref.trackingData;
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);
  return ProductQuotationFormContainer_jsx(formik_esm["d" /* Formik */], {
    initialStatus: {
      state: productQuotationForm_utils_FORM_STATUS.NEW
    },
    initialValues: productQuotationForm_utils_getInitialFormValues({
      extensionOptions: extensionOptions,
      isSummerCamp: isSummerCamp,
      isEscapade: isEscapade
    }),
    validateOnMount: true,
    validationSchema: productQuotationForm_utils_getFormSchema(src_i18n["f" /* t */], {
      civilityOptions: civilityOptions,
      departureCityOptions: departureCityOptions,
      departureDateOptions: departureDateOptions,
      extensionOptions: extensionOptions,
      isEscapade: isEscapade,
      isSummerCamp: isSummerCamp,
      locale: appContext.locale
    }),
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values, actions) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return productQuotationForm_utils_handleSubmit(values, {
                  actions: actions,
                  appContext: appContext,
                  isSummerCamp: isSummerCamp,
                  newsletter: newsletter,
                  product: product,
                  quotation: quotation,
                  trackingData: trackingData
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, ProductQuotationFormContainer_jsx(ProductQuotationForm, {
    adultsOptions: adultsOptions,
    ageIndicationAdults: ageIndicationAdults,
    ageIndicationKids: ageIndicationKids,
    availableDatesIndication: availableDatesIndication,
    civilityOptions: civilityOptions,
    dateFormat: dateFormat,
    departureCityOptions: departureCityOptions,
    departureDateOptions: departureDateOptions,
    departureDateEnd: departureDateEnd,
    departureDateStart: departureDateStart,
    extensionOptions: extensionOptions,
    footnotes: footnotes,
    isEscapade: isEscapade,
    isSummerCamp: isSummerCamp,
    kidsOptions: kidsOptions,
    newsletter: newsletter,
    newsletterOptins: newsletterOptins
  }));
}
// CONCATENATED MODULE: ./src/client/components/lines/product-quotation-form-line/ProductQuotationFormLine.jsx
var ProductQuotationFormLine_jsx = react_default.a.createElement;










var ProductQuotationFormLine_PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var SUMMER_CAMP_AVAILABLE_DATES = [{
  value: '20210626'
}, {
  value: '20210703'
}, {
  value: '20210710'
}];
function ProductQuotationFormLine(props) {
  var _price$initialPrice, _price$initialPrice2;

  var bookingCriteria = props.bookingCriteria,
      civilities = props.civilities,
      coordinates = props.coordinates,
      criteria = props.criteria,
      legalInformations = props.legalInformations,
      newsletter = props.newsletter,
      pax = props.pax,
      price = props.price,
      product = props.product,
      quotation = props.quotation,
      specialRequest = props.specialRequest,
      stopover = props.stopover,
      title = props.title,
      tour = props.tour;
  Object(src_i18n["a" /* addTranslationKeys */])({
    productQuotationForm: {
      coordinates: coordinates,
      criteria: criteria,
      pax: pax,
      quotation: quotation,
      specialRequest: specialRequest,
      title: title
    }
  });
  var productType = product.type;
  var isEscapade = product.rangeId === RANGE_ESCAPADE;
  var isSummerCamp = productType === ProductQuotationFormLine_PRODUCT_TYPES.SUMMER_CAMP;
  var tourDuration = parseInt((stopover === null || stopover === void 0 ? void 0 : stopover.tour.duration) || '0', 10);
  var extensionName = (stopover === null || stopover === void 0 ? void 0 : stopover.extension.title) || '';
  var extensionOptions = []; // The API returns an empty string when no extension is available

  if (extensionName.length > 0) {
    extensionOptions.push({
      value: NO_VALUE,
      name: criteria.noExtension
    }, {
      value: extensionName,
      name: extensionName
    });
    tourDuration += parseInt((stopover === null || stopover === void 0 ? void 0 : stopover.extension.duration) || '0', 10);
  }

  var departureCityOptions = bookingCriteria.departureCities; // The API returns this array when no transport is available:
  // [{value : "NO", name : "No Transport"}]

  if (departureCityOptions.length === 1 && departureCityOptions[0].value === NO_VALUE) {
    departureCityOptions = [];
  }

  var availableDatesIndication = pax.noMoreAvailableDates;
  var ageIndicationAdults = isSummerCamp ? pax.kidsAgeIndicationSummerCamp : pax.adultAgeIndication;
  var ageIndicationKids = isEscapade ? pax.kidsAgeIndicationEscapade : pax.kidsAgeIndicationTour;
  var departureDateStart = new Date(criteria.departureDateStart);
  var departureDateEnd = new Date(criteria.departureDateEnd);
  var adultsOptions = isSummerCamp ? getChildrenOptions(pax.teensChoices, MIN_FORM_TEENS, MAX_FORM_TEENS).map(function (_ref) {
    var label = _ref.label,
        value = _ref.value;
    return {
      name: label,
      value: value.toString()
    };
  }) : getAdultsOptions(pax.adultsChoices, productQuotationForm_constants_MIN_FORM_ADULTS, productQuotationForm_constants_MAX_FORM_ADULTS).map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return {
      name: label,
      value: value.toString()
    };
  });
  var kidsOptions = getChildrenOptions(pax.kidsChoices, productQuotationForm_constants_MIN_FORM_KIDS, productQuotationForm_constants_MAX_FORM_KIDS).map(function (_ref3) {
    var label = _ref3.label,
        value = _ref3.value;
    return {
      name: label,
      value: value.toString()
    };
  });
  var newsletterOptins = PrebookingFormLine_utils_getNewsletterOptins(legalInformations.newsletterOptins || []);
  var trackingData = {
    actionGA: 'accommodation',
    categoryGA: 'bookingEngineEntry',
    labelGA: 'accommodation',
    basePriceAccommodation: (price === null || price === void 0 ? void 0 : (_price$initialPrice = price.initialPrice) === null || _price$initialPrice === void 0 ? void 0 : _price$initialPrice.value) || null,
    resortCode: product.productId,
    resortDefaultPrice: (price === null || price === void 0 ? void 0 : (_price$initialPrice2 = price.initialPrice) === null || _price$initialPrice2 === void 0 ? void 0 : _price$initialPrice2.value) || null,
    resortNightNumber: tourDuration,
    resortSeasonType: product.seasonName,
    resortUrlImage: product.image,
    siteSection: tracking_constants["a" /* BE */]
  };
  return ProductQuotationFormLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: QUOTATION_FORM_SECTION_ID,
    dataTestId: QUOTATION_FORM_SECTION_ID,
    className: "Line"
  }, ProductQuotationFormLine_jsx("div", {
    className: "PriceTicket-sticky-beacon"
  }), ProductQuotationFormLine_jsx(ProductQuotationFormContainer, {
    adultsOptions: adultsOptions,
    ageIndicationAdults: ageIndicationAdults,
    ageIndicationKids: ageIndicationKids,
    availableDatesIndication: availableDatesIndication,
    civilityOptions: (civilities === null || civilities === void 0 ? void 0 : civilities.adult) || [],
    dateFormat: criteria.dateFormat,
    departureCityOptions: departureCityOptions,
    departureDateEnd: departureDateEnd,
    departureDateOptions: // TODO: this is done for ODR purpose to do remove this when
    // the summer camp date are set
    isSummerCamp ? SUMMER_CAMP_AVAILABLE_DATES.map(function (_ref4) {
      var value = _ref4.value;
      return {
        name: Object(apiDate["h" /* momentFromApiDate */])(value).format(criteria.dateFormat),
        value: value
      };
    }) : tour.availableDates.map(function (_ref5) {
      var name = _ref5.name,
          value = _ref5.value;
      return {
        name: name,
        value: value.toString()
      };
    }),
    departureDateStart: departureDateStart,
    extensionOptions: extensionOptions,
    footnotes: quotation.indication,
    isEscapade: isEscapade,
    isSummerCamp: isSummerCamp,
    kidsOptions: kidsOptions,
    newsletter: newsletter,
    newsletterOptins: newsletterOptins,
    product: product,
    quotation: {
      success: quotation.success,
      error: quotation.error
    },
    trackingData: trackingData
  }));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-quotation-form/productQuotationForm.resolver.js
var productQuotationForm_resolver = __webpack_require__("aFmo");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-quotation-form/productQuotationForm.descriptor.js



var productQuotationFormDescriptor = {
  name: constants["Y" /* QUOTATION_FORM */],
  component: ProductQuotationFormLine,
  resolve: productQuotationForm_resolver["a" /* productQuotationFormResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-recommendations-line/ProductRecommendationsLine.jsx
var ProductRecommendationsLine_jsx = react_default.a.createElement;









var ProductRecommendationsLine_ProductRecommendationsLine = function ProductRecommendationsLine(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  if (Object(sellerUtils["g" /* isSeller */])(appContext)) {
    return null;
  }

  var _props$config = props.config,
      config = _props$config === void 0 ? {} : _props$config,
      _props$recommendation = props.recommendations;
  _props$recommendation = _props$recommendation === void 0 ? {
    products: []
  } : _props$recommendation;
  var products = _props$recommendation.products;
  var recommendedProducts = products.map(function (product) {
    return Object(redux["d" /* compose */])(Product_mapper["c" /* getProductProps */], Product_mapper["d" /* setProductHref */])({
      config: config,
      product: product
    });
  });
  var seeMore = {
    color: colors["a" /* COLORS */].GRAY,
    label: config.resort.moreResultsLabels.buttonLabel,
    text: config.resort.moreResultsLabels.label
  };
  var title = config.common.recommendedResorts;
  return ProductRecommendationsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, ProductRecommendationsLine_jsx(ProductsGrid["a" /* ProductsGrid */], {
    hasSeeMore: true,
    isSynchronousGrid: true,
    lineName: constants["nb" /* RESORT_RECOMMENDATIONS */],
    products: recommendedProducts,
    seeMore: seeMore,
    title: title
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-recommendations/productRecommendations.resolver.js
var productRecommendations_resolver = __webpack_require__("/KRb");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-recommendations/productRecommendations.descriptor.js



var productRecommendationsDescriptor = {
  name: constants["nb" /* RESORT_RECOMMENDATIONS */],
  component: ProductRecommendationsLine_ProductRecommendationsLine,
  resolve: productRecommendations_resolver["a" /* productRecommendationsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-teaser/ProductTeaser.jsx

var ProductTeaser_jsx = react_default.a.createElement;





var ProductTeaser_ProductTeaser = function ProductTeaser(_ref) {
  var card = _ref.card,
      product = _ref.product;

  if (Object(lodash["isEmpty"])(card)) {
    return null;
  }

  return ProductTeaser_jsx("div", {
    className: "flex flex-wrap -mx-px10"
  }, ProductTeaser_jsx("div", {
    className: Object(lodash["isEmpty"])(product) ? 'px-px10 w-full' : 'px-px10 pb-px10 sm:pb-0 sm:mb-0 w-full sm:w-2/3 lg:3/4'
  }, ProductTeaser_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({
    layout: Card_constants["d" /* INLINE_1 */]
  }, card))), !Object(lodash["isEmpty"])(product) && ProductTeaser_jsx("div", {
    className: "px-px10 pt-px10 sm:pt-0 w-full sm:w-1/3 lg:1/4"
  }, ProductTeaser_jsx(Product["a" /* Product */], product)));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-related-products-line/ProductRelatedProductsLine.jsx
var ProductRelatedProductsLine_jsx = react_default.a.createElement;







var ProductRelatedProductsLine_ProductRelatedProductsLine = function ProductRelatedProductsLine(_ref) {
  var _product$relatedProdu;

  var config = _ref.config,
      product = _ref.product,
      title = _ref.title;

  if (!((_product$relatedProdu = product.relatedProducts) === null || _product$relatedProdu === void 0 ? void 0 : _product$relatedProdu.length)) {
    return null;
  }

  return ProductRelatedProductsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-RelatedProducts"
  }, ProductRelatedProductsLine_jsx(LineTitle["a" /* LineTitle */], null, title), product.relatedProducts.map(function (relatedProduct, index) {
    var card = {
      color: colors["a" /* COLORS */].BLUE,
      heading: {
        iconName: relatedProduct.resortId.toLowerCase(),
        title: relatedProduct.name
      },
      link: {
        url: relatedProduct.href
      },
      text: {
        text: relatedProduct.title
      }
    };
    return ProductRelatedProductsLine_jsx("article", {
      key: relatedProduct.id,
      className: "Line Line-ProductTeaser"
    }, ProductRelatedProductsLine_jsx(ProductTeaser_ProductTeaser, {
      card: card,
      index: index,
      lineName: constants["Z" /* RELATED_PRODUCTS */],
      product: Object(Product_mapper["c" /* getProductProps */])({
        config: config,
        product: relatedProduct
      })
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-related-products/productRelatedProducts.resolver.js
var productRelatedProducts_resolver = __webpack_require__("4HxW");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-related-products/productRelatedProducts.descriptor.js



var productRelatedProductsDescriptor = {
  name: constants["Z" /* RELATED_PRODUCTS */],
  component: ProductRelatedProductsLine_ProductRelatedProductsLine,
  resolve: productRelatedProducts_resolver["a" /* productRelatedProductsResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-restaurants/productRestaurants.resolver.js
var productRestaurants_resolver = __webpack_require__("WUtx");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-restaurants/productRestaurants.descriptor.js


var productRestaurants_descriptor_jsx = react["createElement"];

function productRestaurants_descriptor_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function productRestaurants_descriptor_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      productRestaurants_descriptor_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      productRestaurants_descriptor_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var productRestaurants_descriptor_ProductRestaurantsLine = function ProductRestaurantsLine(_ref) {
  var _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      _ref$restaurants = _ref.restaurants,
      introduction = _ref$restaurants.introduction,
      _ref$restaurants$rest = _ref$restaurants.restaurantsList,
      restaurantsList = _ref$restaurants$rest === void 0 ? [] : _ref$restaurants$rest,
      title = _ref.title;
  var intros = introduction ? [{
    description: introduction.description
  }] : [];
  var list = restaurantsList.map(function (restaurant) {
    var _restaurant$images = Object(slicedToArray["a" /* default */])(restaurant.images, 1),
        image = _restaurant$images[0];

    return productRestaurants_descriptor_objectSpread(productRestaurants_descriptor_objectSpread({}, restaurant), {}, {
      image: image
    });
  });
  return productRestaurants_descriptor_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, productRestaurants_descriptor_jsx(LineTitle["a" /* LineTitle */], null, title), productRestaurants_descriptor_jsx(ProductCatering_ProductCatering, {
    productCateringTitle: title,
    intros: intros,
    list: list,
    seeLessLabel: config.common.loadLess,
    seeMoreLabel: config.common.viewMore
  }));
};

var productRestaurantsDescriptor = {
  name: constants["ob" /* RESORT_RESTAURANTS */],
  component: productRestaurants_descriptor_ProductRestaurantsLine,
  resolve: productRestaurants_resolver["a" /* productRestaurantsResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-seo-title/productSEOTitle.resolver.js
var productSEOTitle_resolver = __webpack_require__("1I7E");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-seo-title/productSEOTitle.descriptor.js

var productSEOTitle_descriptor_jsx = react_default.a.createElement;




var productSEOTitleDescriptor = {
  name: constants["pb" /* RESORT_SEO */],
  // eslint-disable-next-line clubmed/no-fake-component
  component: function component(_ref) {
    var title = _ref.title,
        meta = _ref.meta,
        script = _ref.script;
    return productSEOTitle_descriptor_jsx(head_default.a, null, productSEOTitle_descriptor_jsx("title", {
      key: "title"
    }, title), meta.map(function (_ref2) {
      var content = _ref2.content,
          key = _ref2.key,
          name = _ref2.name,
          property = _ref2.property;
      return productSEOTitle_descriptor_jsx("meta", Object(esm_extends["a" /* default */])({
        key: key || name || property
      }, property ? {
        property: property
      } : {
        name: name
      }, {
        content: content
      }));
    }), script.map(function (_ref3) {
      var type = _ref3.type,
          innerHTML = _ref3.innerHTML;
      return productSEOTitle_descriptor_jsx("script", {
        key: "product-seo-title-ld-json",
        type: type // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: innerHTML
        }
      });
    }));
  },
  props: productSEOTitle_resolver["a" /* productSEOTitleResolver */].props,
  resolve: productSEOTitle_resolver["a" /* productSEOTitleResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-services/ProductServices.jsx
var ProductServices_jsx = react_default.a.createElement;





var ProductServices_ProductServices = function ProductServices(_ref) {
  var allInclusiveServices = _ref.allInclusiveServices,
      config = _ref.config;
  Object(src_i18n["a" /* addTranslationKeys */])(config);
  var style = '.ProductServices-serviceContainer:last-child .border-b-1 {border-width: 0;} @media (min-width: 64.01em) {.ProductServices-serviceContainer:nth-last-child(-n+2) .border-b-1 {border-width: 0}}';

  if (allInclusiveServices.length === 0) {
    return null;
  }

  return ProductServices_jsx("div", {
    className: "border-1 pt-6 px-5 lg:px-10 rounded-tiny border-gray-medium"
  }, ProductServices_jsx("style", {
    dangerouslySetInnerHTML: {
      __html: style
    }
  }), ProductServices_jsx("div", {
    className: "text-blue font-brand flex justify-center items-center text-2xl"
  }, ProductServices_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ALL_INCLUSIVE,
    width: "calc(27rem / 16)"
  }), ProductServices_jsx("span", {
    className: "rtl:ml-3 leading-one"
  }, Object(src_i18n["f" /* t */])('common.allInclusive'))), ProductServices_jsx("div", {
    className: "flex flex-wrap justify-between md:py-3 ProductServices-list"
  }, allInclusiveServices.map(function (service, index) {
    return ProductServices_jsx("div", {
      className: "w-full lg:w-12/25 ProductServices-serviceContainer",
      key: service.label
    }, ProductServices_jsx(ProductService["a" /* ProductService */], {
      service: service,
      disableBorder: index === allInclusiveServices.length - 1
    }));
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-services-line/ProductServicesLine.jsx

var ProductServicesLine_jsx = react_default.a.createElement;



function ProductServicesLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  return ProductServicesLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line mb-16 lg:mb-10"
  }, ProductServicesLine_jsx(ProductServices_ProductServices, props));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-services/productServices.resolver.js
var productServices_resolver = __webpack_require__("/0L0");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-services/productServices.descriptor.js



var productServicesDescriptor = {
  name: constants["R" /* PRODUCT_SERVICES */],
  component: ProductServicesLine,
  resolve: productServices_resolver["a" /* productServicesResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-signatures/ProductSignatures.jsx
var ProductSignatures_jsx = react_default.a.createElement;



var ProductSignatures_ProductSignatures = function ProductSignatures(_ref) {
  var imageSrc = _ref.imageSrc,
      header = _ref.header,
      text = _ref.text,
      tail = _ref.tail;

  if (!text) {
    return null;
  }

  return ProductSignatures_jsx("article", {
    className: "relative inset-border-after",
    style: {
      padding: '7vw 30px'
    }
  }, ProductSignatures_jsx("div", {
    className: "bg-deepBlue rounded-tiny absolute inset-0"
  }, ProductSignatures_jsx("div", {
    className: "h-full relative opacity-50 image-responsive-cell overflow-y-hidden"
  }, ProductSignatures_jsx(Image["a" /* default */], {
    imageUrl: imageSrc,
    className: "absolute inset-center",
    ratioKey: ratios_utils["a" /* default */].L
  }))), ProductSignatures_jsx("div", {
    style: {
      minHeight: '120px'
    },
    className: "relative text-base font-brand flex flex-col items-center justify-between text-center text-white"
  }, ProductSignatures_jsx("div", null, header), ProductSignatures_jsx("div", {
    className: "text-2xl sm:text-7xl"
  }, text), ProductSignatures_jsx("div", {
    className: "font-sans"
  }, tail)));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-signatures-line/ProductSignaturesLine.jsx

var ProductSignaturesLine_jsx = react_default.a.createElement;



function ProductSignaturesLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  return ProductSignaturesLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, ProductSignaturesLine_jsx(ProductSignatures_ProductSignatures, props));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-signatures/productSignatures.descriptor.jsx


var productSignaturesDescriptor = {
  name: constants["S" /* PRODUCT_SIGNATURES */],
  component: ProductSignaturesLine
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-space-introduction/ProductSpaceIntroduction.jsx
var ProductSpaceIntroduction_jsx = react_default.a.createElement;












function ProductSpaceIntroduction(_ref) {
  var imageSrc = _ref.imageSrc,
      text = _ref.text,
      title = _ref.title,
      link = _ref.link;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!title) {
    return null;
  }

  var logo = ProductSpaceIntroduction_jsx("div", {
    className: "md:text-initial"
  }, ProductSpaceIntroduction_jsx(Icon["a" /* Icon */], {
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED_EXCLUSIVE,
    width: "calc(160rem / 16)"
  }));

  var content = ProductSpaceIntroduction_jsx(react["Fragment"], null, ProductSpaceIntroduction_jsx(Title["a" /* Title */], {
    className: "mb-5",
    theme: "title-serif-2",
    color: colors["a" /* COLORS */].WHITE
  }, Object(string_util["f" /* truncate */])(title, 50)), ProductSpaceIntroduction_jsx(TextSeeMore["a" /* TextSeeMore */], {
    color: colors["a" /* COLORS */].WHITE,
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: true,
    seeLessLabel: Object(src_i18n["f" /* t */])('common.loadLess'),
    seeMoreLabel: Object(src_i18n["f" /* t */])('common.viewMore'),
    seeMoreSize: 80,
    seeMoreTheme: "deepBlue",
    text: text,
    theme: "text-sans-3"
  }));

  var image = ProductSpaceIntroduction_jsx(Image["a" /* default */], {
    imageUrl: imageSrc,
    className: "rounded-tiny overflow-hidden inset-border-after--large",
    ratioKey: ratios_utils["a" /* default */].R_13_BY_12
  });

  var spaceLink = link ? ProductSpaceIntroduction_jsx(DynamicLink["a" /* default */], {
    url: link.url,
    className: "block mt-6 text-white underline"
  }, link.text) : null;
  return isTablet ? ProductSpaceIntroduction_jsx("article", {
    className: "font-serif",
    style: {
      margin: '100px 0 75px'
    }
  }, ProductSpaceIntroduction_jsx("div", {
    className: "flex bg-deepBlue rounded-tiny"
  }, ProductSpaceIntroduction_jsx("div", {
    className: "w-1/2 p-5 lg:p-10 xl:p-20 xl:rtl:pr-30 text-white"
  }, ProductSpaceIntroduction_jsx("div", {
    className: "mb-8 text-white text-center"
  }, logo), " ", content, " ", spaceLink), ProductSpaceIntroduction_jsx("div", {
    className: "h-full relative w-12/25 -my-9 self-center image-responsive-cell"
  }, image))) : ProductSpaceIntroduction_jsx("article", {
    className: "font-serif"
  }, ProductSpaceIntroduction_jsx("div", {
    className: "relative image-responsive-cell"
  }, image), ProductSpaceIntroduction_jsx("div", {
    className: "bg-deepBlue rounded-tiny px-6 py-10 text-center font-serif"
  }, ProductSpaceIntroduction_jsx("div", {
    className: "sm:inline-block mb-8 text-white text-center"
  }, logo), content, spaceLink));
}
// CONCATENATED MODULE: ./src/client/components/lines/product-space-introduction-line/ProductSpaceIntroductionLine.jsx

var ProductSpaceIntroductionLine_jsx = react_default.a.createElement;




function ProductSpaceIntroductionLine(_ref) {
  var config = _ref.config,
      id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["config", "id"]);

  Object(src_i18n["a" /* addTranslationKeys */])(config);
  return ProductSpaceIntroductionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line",
    size: "medium"
  }, ProductSpaceIntroductionLine_jsx(ProductSpaceIntroduction, props));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-space-introduction/productSpaceIntroduction.resolver.js
var productSpaceIntroduction_resolver = __webpack_require__("bLh8");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-space-introduction/productSpaceIntroduction.descriptor.js



var productSpaceIntroductionDescriptor = {
  name: constants["T" /* PRODUCT_SPACE_INTRODUCTION */],
  component: ProductSpaceIntroductionLine,
  resolver: productSpaceIntroduction_resolver["a" /* productSpaceIntroductionResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-strengths/ProductStrengths.jsx


var ProductStrengths_jsx = react_default.a.createElement;








var ProductStrengths_ProductStrengths = function ProductStrengths(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])();

  if (!items.length) {
    return null;
  }

  var content = ProductStrengths_jsx("div", {
    className: classnames_default()(className, 'flex flex-wrap -mx-2')
  }, items.map(function (_ref2, idx) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref2$color,
        iconName = _ref2.iconName,
        label = _ref2.label,
        trackingData = _ref2.trackingData,
        url = _ref2.url;
    var TagName = url ? DynamicLink["a" /* default */] : 'div';
    return ProductStrengths_jsx(react["Fragment"], {
      key: label
    }, !!idx && ProductStrengths_jsx("span", {
      className: "fadeInLong hidden sm:block font-serif mt-3 opacity-50 text-gray-light text-7xl"
    }, "/"), ProductStrengths_jsx(TagName, Object(esm_extends["a" /* default */])({
      className: classnames_default()("w-1/2 sm:w-auto sm:flex-1 max-w-1/2 flex flex-col items-center p-2 text-".concat(color, " text-sm sm:text-base text-center"), Object(defineProperty["a" /* default */])({}, "focus:text-".concat(color, "-active hover:text-").concat(color, "-active transition-color"), url)),
      onClick: trackingData ? function () {
        return track(trackingData);
      } : undefined
    }, url ? {
      url: url
    } : null), ProductStrengths_jsx(Icon["a" /* Icon */], {
      className: "mb-2 sm:mb-3",
      name: iconName,
      width: "3.75rem"
    }), ProductStrengths_jsx("span", {
      className: classnames_default()('block w-full', {
        'font-serif': isExclusiveCollection
      })
    }, label)));
  }));

  return isTablet ? content : ProductStrengths_jsx(SeeMore["a" /* SeeMore */], {
    classNameButton: "text-center",
    isCollapseEnabled: true,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: 150
  }, content);
};
// CONCATENATED MODULE: ./src/client/components/lines/product-strengths-line/ProductStrengthsLine.jsx

var ProductStrengthsLine_jsx = react_default.a.createElement;

function ProductStrengthsLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductStrengthsLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductStrengthsLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductStrengthsLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var ProductStrengthsLine_ProductStrengthsLine = function ProductStrengthsLine(_ref) {
  var _ref$config$common = _ref.config.common,
      loadLess = _ref$config$common.loadLess,
      loadMore = _ref$config$common.loadMore,
      id = _ref.id,
      items = _ref.items,
      isExclusiveCollection = _ref.isExclusiveCollection,
      _ref$resort = _ref.resort;
  _ref$resort = _ref$resort === void 0 ? {} : _ref$resort;
  var isProductExclusiveCollection = _ref$resort.isExclusiveCollection,
      isJoyview = _ref$resort.isJoyview,
      title = _ref.title;

  if (Object(lodash["isEmpty"])(items)) {
    return null;
  }

  var isEC = isProductExclusiveCollection || isExclusiveCollection;
  var colorBlue = isEC ? colors["a" /* COLORS */].DEEP_BLUE : colors["a" /* COLORS */].BLUE;
  var color = isJoyview ? colors["a" /* COLORS */].WATER_GREEN : colorBlue;
  var filledItems = items.map(function (item) {
    return ProductStrengthsLine_objectSpread(ProductStrengthsLine_objectSpread({}, item), {}, {
      color: color,
      trackingData: {
        actionGA: 'productStrenghtsBanner',
        labelGA: item.label
      }
    });
  });
  return ProductStrengthsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductStrengthsLine_jsx(LineTitle["a" /* LineTitle */], {
    color: color,
    isExclusiveCollection: isEC
  }, title), ProductStrengthsLine_jsx(ProductStrengths_ProductStrengths, {
    isExclusiveCollection: isEC,
    items: filledItems,
    seeLessLabel: loadLess,
    seeMoreLabel: loadMore
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-strengths/productStrengths.resolver.js
var productStrengths_resolver = __webpack_require__("jVcT");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-strengths/productStrengths.descriptor.js



var productStrengthsDescriptor = {
  name: constants["V" /* PRODUCT_STRENGTHS */],
  component: ProductStrengthsLine_ProductStrengthsLine,
  resolve: productStrengths_resolver["a" /* productStrengthsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-summary-line/ProductSummaryLine.jsx
var ProductSummaryLine_jsx = react_default.a.createElement;




var ProductSummaryLine_ProductSummaryLine = function ProductSummaryLine(_ref) {
  var _product$resortId;

  var id = _ref.id,
      color = _ref.color,
      config = _ref.config,
      product = _ref.product;
  return ProductSummaryLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductSummaryLine_jsx(ProductTeaser_ProductTeaser, {
    card: {
      heading: {
        iconName: product === null || product === void 0 ? void 0 : (_product$resortId = product.resortId) === null || _product$resortId === void 0 ? void 0 : _product$resortId.toLowerCase(),
        title: product === null || product === void 0 ? void 0 : product.name
      },
      link: {
        url: product === null || product === void 0 ? void 0 : product.href
      },
      text: {
        text: product === null || product === void 0 ? void 0 : product.title
      },
      color: color
    },
    product: Object(Product_mapper["c" /* getProductProps */])({
      config: config,
      product: product
    })
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-summary/productSummary.resolver.js
var productSummary_resolver = __webpack_require__("kawP");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-summary/productSummary.descriptor.js



var productSummaryDescriptor = {
  name: constants["rb" /* RESORT_SUMMARY */],
  component: ProductSummaryLine_ProductSummaryLine,
  resolve: productSummary_resolver["a" /* productSummaryResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/frameworks/content-slideshow/ContentSlideShow.jsx
var ContentSlideShow_jsx = react_default.a.createElement;





function ContentSlideShow(props) {
  var children = props.children,
      className = props.className;
  if (!react["Children"].count(children)) return null;
  return ContentSlideShow_jsx(SliderHandler["a" /* SliderHandler */], {
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: children
  }, function (_ref) {
    var hasControls = _ref.hasControls,
        isNextControlDisabled = _ref.isNextControlDisabled,
        isPreviousControlDisabled = _ref.isPreviousControlDisabled,
        itemsNode = _ref.itemsNode,
        onNext = _ref.onNext,
        onPrevious = _ref.onPrevious;
    return ContentSlideShow_jsx("div", {
      className: classnames_default()(className, 'flex items-center justify-center')
    }, hasControls && ContentSlideShow_jsx(ArrowButton["a" /* ArrowButton */], {
      className: classnames_default()('flex-none rtl:mr-4 shadow-sm', {
        invisible: isPreviousControlDisabled
      }),
      isDisabled: isPreviousControlDisabled,
      label: Object(src_i18n["f" /* t */])('common.previous'),
      onClick: onPrevious
    }), itemsNode, hasControls && ContentSlideShow_jsx(ArrowButton["a" /* ArrowButton */], {
      className: classnames_default()('flex-none rtl:ml-4 shadow-sm', {
        invisible: isNextControlDisabled
      }),
      isDisabled: isNextControlDisabled,
      label: Object(src_i18n["f" /* t */])('common.next'),
      onClick: onNext,
      rotation: 180
    }));
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-awards/TripAdvisorAwards.jsx
var TripAdvisorAwards_jsx = react_default.a.createElement;




function TripAdvisorAwards(props) {
  var _props$awards = props.awards,
      awards = _props$awards === void 0 ? [] : _props$awards,
      className = props.className;
  if (Object(lodash["isEmpty"])(awards)) return null;
  return TripAdvisorAwards_jsx("section", {
    className: className
  }, TripAdvisorAwards_jsx(ContentSlideShow, null, awards.map(function (_ref) {
    var altMsg = _ref.altMsg,
        imageUrl = _ref.imageUrl;
    return imageUrl ? TripAdvisorAwards_jsx("article", {
      className: "leading-none overflow-hidden px-1 text-center",
      key: imageUrl
    }, TripAdvisorAwards_jsx(Image["a" /* default */], {
      altMsg: altMsg,
      className: "mx-auto",
      dontChangeAnything: true,
      imageUrl: imageUrl,
      style: {
        maxHeight: 'calc(140rem / 16)'
      }
    })) : null;
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-ratings/TripAdvisorRatings.jsx

var TripAdvisorRatings_jsx = react_default.a.createElement;



function TripAdvisorRatings(props) {
  var className = props.className,
      counterLabel = props.counterLabel,
      counterUnit = props.counterUnit,
      counterValue = props.counterValue,
      _props$image = props.image,
      image = _props$image === void 0 ? {} : _props$image,
      _props$subratings = props.subratings,
      subratings = _props$subratings === void 0 ? [] : _props$subratings;
  if (Object(lodash["isEmpty"])(subratings)) return null;
  return TripAdvisorRatings_jsx("section", {
    className: className
  }, TripAdvisorRatings_jsx("div", {
    className: "flex items-center justify-center"
  }, !Object(lodash["isEmpty"])(image) ? TripAdvisorRatings_jsx(Image["a" /* default */], Object(esm_extends["a" /* default */])({
    className: "my-1",
    dontChangeAnything: true
  }, image)) : null, TripAdvisorRatings_jsx("span", null, "\xA0"), TripAdvisorRatings_jsx("p", {
    className: "reset-paragraph text-base"
  }, counterLabel, TripAdvisorRatings_jsx("span", null, " "), TripAdvisorRatings_jsx("span", {
    style: {
      color: '#429E96'
    }
  }, [counterValue, counterUnit].join(' ')))), TripAdvisorRatings_jsx("ul", {
    style: {
      width: 'calc(290rem / 16)'
    },
    className: "reset-list mt-8 mx-auto px-1"
  }, subratings.map(function (_ref) {
    var localizedName = _ref.localizedName,
        ratingImageUrl = _ref.ratingImageUrl,
        value = _ref.value;
    if (Object(lodash["isEmpty"])(subratings[0])) return null;
    return TripAdvisorRatings_jsx("li", {
      key: localizedName,
      className: "mt-1 mx-auto flex items-center justify-between w-full"
    }, TripAdvisorRatings_jsx("span", {
      className: "leading-one rtl:pr-1"
    }, localizedName), TripAdvisorRatings_jsx("span", {
      className: "leading-none",
      style: {
        width: '5rem'
      }
    }, TripAdvisorRatings_jsx(Image["a" /* default */], {
      className: "w-full",
      altMsg: value,
      dontChangeAnything: true,
      imageUrl: ratingImageUrl,
      mandatoryWidthAndHeight: {
        w: 80,
        h: 17
      },
      style: {
        maxHeight: '1rem',
        width: '100%'
      }
    })));
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-reviews/TripAdvisorReviews.jsx
var TripAdvisorReviews_jsx = react_default.a.createElement;







function TripAdvisorReviews(props) {
  var className = props.className,
      _props$maxLengthOfRev = props.maxLengthOfReview,
      maxLengthOfReview = _props$maxLengthOfRev === void 0 ? 255 : _props$maxLengthOfRev,
      _props$reviews = props.reviews,
      reviews = _props$reviews === void 0 ? [] : _props$reviews;
  if (Object(lodash["isEmpty"])(reviews)) return null;
  return TripAdvisorReviews_jsx("section", {
    className: className
  }, TripAdvisorReviews_jsx(ContentSlideShow, null, reviews.map(function (_ref) {
    var datetime = _ref.datetime,
        rating = _ref.rating,
        ratingImageUrl = _ref.ratingImageUrl,
        _ref$authors = _ref.authors,
        authors = _ref$authors === void 0 ? [] : _ref$authors,
        date = _ref.date,
        text = _ref.text,
        title = _ref.title,
        url = _ref.url;
    if (Object(lodash["isEmpty"])(text)) return null;
    return TripAdvisorReviews_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      trackingData: {
        categoryGA: 'resort',
        actionGA: 'practicalInfos',
        labelGA: 'tripAdvisorReviews'
      },
      className: "block text-inherit",
      key: url,
      target: "_blank",
      url: url
    }, TripAdvisorReviews_jsx("blockquote", {
      cite: url,
      className: "m-0"
    }, title && TripAdvisorReviews_jsx("p", {
      className: "reset-paragraph font-bold mb-2",
      title: title
    }, title), TripAdvisorReviews_jsx("div", {
      className: "flex mb-3"
    }, TripAdvisorReviews_jsx(Image["a" /* default */], {
      className: "block mb-1",
      altMsg: rating,
      dontChangeAnything: true,
      imageUrl: ratingImageUrl
    }), TripAdvisorReviews_jsx("time", {
      dateTime: datetime,
      className: "rtl:ml-4 text-sm"
    }, date)), text && TripAdvisorReviews_jsx("p", {
      className: "reset-paragraph mb-3 decorator-quote",
      title: text
    }, Object(string_util["f" /* truncate */])(text, maxLengthOfReview)), TripAdvisorReviews_jsx("small", {
      className: "block text-sm"
    }, TripAdvisorReviews_jsx("span", null, authors.map(function (author) {
      return TripAdvisorReviews_jsx("span", {
        key: author,
        "data-testid": "TripAdvisorReviewsAuthor"
      }, author, TripAdvisorReviews_jsx("br", null));
    })))));
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-large/TripAdvisorLarge.jsx

var TripAdvisorLarge_jsx = react_default.a.createElement;






function TripAdvisorLarge(props) {
  var _props$awards = props.awards,
      awards = _props$awards === void 0 ? [] : _props$awards,
      className = props.className,
      _props$ratings = props.ratings,
      ratings = _props$ratings === void 0 ? {} : _props$ratings,
      reviews = props.reviews;
  if (Object(lodash["isEmpty"])(awards) && Object(lodash["isEmpty"])(ratings.subratings) && Object(lodash["isEmpty"])(reviews)) return null;
  var classes = 'flex items-center justify-center mx-2 p-4 w-1/3 rounded-tiny border-1 border-gray-light';
  return TripAdvisorLarge_jsx("section", {
    className: classnames_default()(className, 'flex justify-center -mx-2 pb-3')
  }, !Object(lodash["isEmpty"])(ratings.subratings) && TripAdvisorLarge_jsx("div", {
    className: classes,
    style: {
      width: '23.75rem'
    }
  }, TripAdvisorLarge_jsx(TripAdvisorRatings, Object(esm_extends["a" /* default */])({
    className: "max-w-full w-full"
  }, ratings, {
    subratings: ratings.subratings
  }))), !Object(lodash["isEmpty"])(reviews) && TripAdvisorLarge_jsx("div", {
    className: classnames_default()(classes, 'flex-1')
  }, TripAdvisorLarge_jsx(TripAdvisorReviews, {
    className: "max-w-full w-full",
    maxLengthOfReview: 150 // $FlowFixMe
    ,
    reviews: reviews
  })), !Object(lodash["isEmpty"])(awards) && TripAdvisorLarge_jsx("div", {
    className: classes,
    style: {
      width: '17.5rem'
    }
  }, TripAdvisorLarge_jsx(TripAdvisorAwards, {
    className: "max-w-full w-full",
    awards: awards
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-narrow/TripAdvisorNarrow.jsx

var TripAdvisorNarrow_jsx = react_default.a.createElement;






function TripAdvisorNarrow(props) {
  var _props$awards = props.awards,
      awards = _props$awards === void 0 ? [] : _props$awards,
      awardsLabel = props.awardsLabel,
      className = props.className,
      _props$ratings = props.ratings,
      ratings = _props$ratings === void 0 ? {} : _props$ratings,
      ratingsLabel = props.ratingsLabel,
      reviews = props.reviews,
      reviewsLabel = props.reviewsLabel;

  var _useState = Object(react["useState"])(0),
      position = _useState[0],
      setPosition = _useState[1];

  var hasAwards = !Object(lodash["isEmpty"])(awards);
  var hasRatings = !Object(lodash["isEmpty"])(ratings.subratings);
  var hasReviews = !Object(lodash["isEmpty"])(reviews);
  if (!hasAwards && !hasRatings && !hasReviews) return null;
  var items = [];
  var nav = [];

  if (hasReviews) {
    items.push(TripAdvisorNarrow_jsx(TripAdvisorReviews, {
      key: "reviews",
      className: "w-full" // $FlowFixMe
      ,
      reviews: reviews,
      maxLengthOfReview: 150
    }));
    nav.push(reviewsLabel);
  }

  if (hasRatings) {
    items.push(TripAdvisorNarrow_jsx(TripAdvisorRatings, Object(esm_extends["a" /* default */])({}, ratings, {
      key: "ratings",
      className: "w-full",
      subratings: ratings.subratings
    })));
    nav.push(ratingsLabel);
  }

  if (hasAwards) {
    items.push(TripAdvisorNarrow_jsx(TripAdvisorAwards, {
      key: "awards",
      className: "w-full self-center",
      awards: awards
    }));
    nav.push(awardsLabel);
  }

  return TripAdvisorNarrow_jsx("section", {
    className: classnames_default()(className, 'mx-auto'),
    style: {
      maxWidth: '37.5rem'
    }
  }, TripAdvisorNarrow_jsx("div", {
    className: "border-1 border-gray-light rounded-tiny overflow-hidden"
  }, TripAdvisorNarrow_jsx("div", {
    className: "flex transition-transform",
    style: {
      transform: "translate(".concat(position * -100, "%, 0)")
    }
  }, items.map(function (item, idx) {
    return TripAdvisorNarrow_jsx("div", {
      key: idx,
      "aria-hidden": position !== idx,
      className: classnames_default()('max-w-full min-w-full overflow-hidden p-3 flex', {
        invisible: position !== idx
      })
    }, item);
  }))), TripAdvisorNarrow_jsx("div", {
    className: "flex relative"
  }, TripAdvisorNarrow_jsx("div", {
    className: "absolute arrow-up arrow-white arrow-bg arrow-bg-blue border-t-1 border-blue",
    style: {
      width: "".concat(100 / nav.length, "%"),
      margin: "0 ".concat(100 / nav.length * position, "%"),
      transition: 'all .25s ease-in .2s'
    }
  }), nav.map(function (button, idx) {
    return TripAdvisorNarrow_jsx("button", {
      className: classnames_default()('reset-button flex-1 font-bold py-5 text-base text-center', {
        'text-gray-medium': idx !== position
      }, {
        'text-turquoise': idx === position
      }),
      onClick: function onClick() {
        return setPosition(idx);
      },
      type: "button",
      key: button
    }, TripAdvisorNarrow_jsx("span", {
      className: classnames_default()('px-2 block', {
        'rtl:border-l-1': idx > 0
      })
    }, button));
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor/TripAdvisor.jsx
var TripAdvisor_jsx = react_default.a.createElement;




function TripAdvisor(props) {
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  return isDesktop ? TripAdvisor_jsx(TripAdvisorLarge, props) : TripAdvisor_jsx(TripAdvisorNarrow, props);
}
// CONCATENATED MODULE: ./src/client/components/lines/product-tripadvisor-line/ProductTripAdvisorLine.jsx
var ProductTripAdvisorLine_jsx = react_default.a.createElement;







var ProductTripAdvisorLine_ProductTripAdvisorLine = function ProductTripAdvisorLine(props) {
  var tripadvisor = props.tripadvisor;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!tripadvisor || !tripadvisor.tripAdvisorUrl) {
    return null;
  }

  var awards = tripadvisor.awards.map(function (_ref) {
    var displayName = _ref.displayName,
        _ref$images = _ref.images,
        images = _ref$images === void 0 ? {} : _ref$images;
    return {
      altMsg: displayName,
      imageUrl: images.large
    };
  });
  var awardsLabel = props.awards;
  var ratings = {
    counterLabel: props.basedOn,
    counterUnit: props.reviews,
    counterValue: tripadvisor.numReviews,
    image: {
      altMsg: tripadvisor.rating,
      imageUrl: tripadvisor.ratingImageUrl
    },
    subratings: tripadvisor.subratings,
    title: props.ratingTitle
  };
  var ratingsLabel = props.ratings;
  var reviews = tripadvisor.reviews.map(function (review) {
    return {
      authors: review.reviewAuthor,
      date: review.reviewDate,
      datetime: review.publishedDate,
      rating: review.rating,
      ratingImageUrl: review.ratingImageUrl,
      text: review.text,
      title: review.title,
      url: review.url
    };
  });
  var reviewsLabel = props.reviews;
  var tripAdvisorUrl = tripadvisor.tripAdvisorUrl;
  var tripAdvisorLineTitle = props.tripAdvisorLineTitle,
      tripAdvisorViewMoreLabel = props.tripAdvisorViewMoreLabel;
  return ProductTripAdvisorLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: "tripadvisor"
  }, ProductTripAdvisorLine_jsx("div", {
    className: "relative"
  }, ProductTripAdvisorLine_jsx(LineTitle["a" /* LineTitle */], null, tripAdvisorLineTitle), isDesktop ? ProductTripAdvisorLine_jsx(TextLink["a" /* TextLink */], {
    className: "absolute rtl:right-0 top-0",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    iconRightName: null,
    label: tripAdvisorViewMoreLabel,
    theme: "simple",
    url: tripAdvisorUrl,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'practicalInfos',
      labelGA: 'tripAdvisorSeeMore'
    }
  }) : null), ProductTripAdvisorLine_jsx(TripAdvisor, {
    awards: awards,
    awardsLabel: awardsLabel,
    ratings: ratings,
    ratingsLabel: ratingsLabel,
    reviews: reviews,
    reviewsLabel: reviewsLabel
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-tripadvisor/productTripadvisor.resolver.js
var productTripadvisor_resolver = __webpack_require__("ODPy");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-tripadvisor/productTripadvisor.descriptor.js



var productTripadvisorDescriptor = {
  name: constants["tb" /* RESORT_TRIPADVISOR */],
  component: ProductTripAdvisorLine_ProductTripAdvisorLine,
  resolve: productTripadvisor_resolver["a" /* productTripadvisorResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-wellness-line/ProductWellnessLine.jsx

var ProductWellnessLine_jsx = react_default.a.createElement;

function ProductWellnessLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductWellnessLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductWellnessLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductWellnessLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var ProductWellnessLine_ProductWellnessLine = function ProductWellnessLine(props) {
  var _props$config$common = props.config.common,
      loadLess = _props$config$common.loadLess,
      onDemandService = _props$config$common.onDemandService,
      scrollBackward = _props$config$common.scrollBackward,
      scrollForward = _props$config$common.scrollForward,
      viewMore = _props$config$common.viewMore,
      id = props.id,
      _props$resort = props.resort,
      wellness = _props$resort.categories.wellness,
      _props$resort$wellnes = _props$resort.wellnessActivitiesIntroduction,
      wellnessActivitiesIntroduction = _props$resort$wellnes === void 0 ? {} : _props$resort$wellnes;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var appContext = Object(react["useContext"])(ReactAppContext["a" /* default */]);

  var fetchActivityServices = function fetchActivityServices(_ref) {
    var productId = _ref.productId,
        activityId = _ref.activityId;
    var query = Object(productFeatures_queries["e" /* productWellnessDetailQuery */])(productId, activityId, {
      lineProps: props,
      urlParams: location.urlParams
    });
    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["Md" /* WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES */]
    }).then(function (data) {
      Object(src_i18n["a" /* addTranslationKeys */])(data.config);
      return {
        productActivities: ProductWellnessLine_objectSpread(ProductWellnessLine_objectSpread({}, data.productActivities), {}, {
          includedServices: data.includedServices,
          onDemandServices: data.onDemandServices
        })
      };
    });
  };

  var introduction = {
    seeLessLabel: loadLess,
    seeMoreLabel: viewMore,
    text: wellnessActivitiesIntroduction.description,
    title: wellnessActivitiesIntroduction.shortDescription
  };
  var productActivitiesCategories = wellness && wellness.filter(function (_ref2) {
    var _ref2$activities = _ref2.activities,
        activities = _ref2$activities === void 0 ? [] : _ref2$activities;
    return activities.length;
  });
  var productCategories = mapCategories({
    fetchActivityServices: fetchActivityServices,
    hasBanner: false,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].WELLNESS,
    notIncludedMessage: onDemandService,
    productActivitiesCategories: productActivitiesCategories,
    productFeaturesLineData: props
  });
  return ProductWellnessLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductWellnessLine_jsx(ProductFeatures_ProductFeatures, {
    categories: productCategories,
    introduction: introduction,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].WELLNESS,
    queryLayer: "productWellnessLayer",
    renderDetail: function renderDetail(data) {
      return ProductWellnessLine_jsx(ProductFeatureDetail, data);
    },
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-wellness/productWellness.resolver.js
var productWellness_resolver = __webpack_require__("i0/9");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-wellness/productWellness.descriptor.js



var productWellnessDescriptor = {
  name: constants["X" /* PRODUCT_WELLNESS */],
  component: ProductWellnessLine_ProductWellnessLine,
  resolve: productWellness_resolver["a" /* productWellnessResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-wellness-legacy/ProductWellnessLegacy.jsx

var ProductWellnessLegacy_jsx = react_default.a.createElement;












function getYearsOld(activity) {
  if (activity.adultsOnly) {
    return Object(src_i18n["f" /* t */])('productWellness.ages.adultsOnly');
  }

  if (activity.ageInMonths && activity.ageInMonths.min) {
    return Object(src_i18n["f" /* t */])('productWellness.year', {
      count: Math.floor(activity.ageInMonths.min / 12)
    });
  }

  return Object(src_i18n["f" /* t */])('productWellness.ages.all');
}

function ActivityComponent(_ref) {
  var activity = _ref.activity,
      index = _ref.index,
      length = _ref.length;
  return ProductWellnessLegacy_jsx("article", {
    "data-testid": "ProductWellness-activity"
  }, activity.image && ProductWellnessLegacy_jsx("div", {
    "data-testid": "ProductWellnessImageActivity"
  }, ProductWellnessLegacy_jsx(Image["a" /* default */], {
    imageUrl: activity.image,
    ratioKey: ratios_utils["a" /* default */].M
  })), activity.name && ProductWellnessLegacy_jsx(Title["a" /* Title */], {
    className: "mb-2",
    hLevel: 3,
    theme: "title-sans-3"
  }, activity.name, ProductWellnessLegacy_jsx("small", {
    className: "rtl:ml-1 font-normal text-sm"
  }, activity.duration)), ProductWellnessLegacy_jsx(Tag["a" /* Tag */], Object(esm_extends["a" /* default */])({
    color: activity.included ? colors["a" /* COLORS */].KIWI : colors["a" /* COLORS */].AMBER
  }, activity.included ? {
    iconRight: icons["a" /* ICONS */].CHECK
  } : null, {
    label: activity.included ? Object(src_i18n["f" /* t */])('productWellness.included') : Object(src_i18n["f" /* t */])('productWellness.onDemand'),
    theme: "outlined"
  })), ProductWellnessLegacy_jsx("div", {
    className: "text-1"
  }, ProductWellnessLegacy_jsx("p", null, ProductWellnessLegacy_jsx("strong", null, Object(src_i18n["f" /* t */])('productWellness.ages.label')), " : ", ProductWellnessLegacy_jsx("span", null, getYearsOld(activity)))), ProductWellnessLegacy_jsx(Text["a" /* Text */], {
    text: activity.description
  }), index < length - 1 && ProductWellnessLegacy_jsx("hr", {
    className: "block border-0 border-solid border-gray-light border-t-1 h-px my-4 mx-0 p-0"
  }));
}

function getTabsItems() {
  var prestations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return prestations.map(function (_ref2, index) {
    var activities = _ref2.activities,
        id = _ref2.id,
        name = _ref2.name;
    return {
      header: {
        title: name
      },
      content: [ProductWellnessLegacy_jsx("section", {
        "data-testid": "ProductWellness-prestation",
        className: "py-5",
        key: id || index
      }, activities.map(function (activity, activityIndex) {
        return activity && ProductWellnessLegacy_jsx(ActivityComponent, {
          activity: activity,
          index: activityIndex,
          key: activity.id,
          length: activities.length
        });
      }))]
    };
  });
}

function ProductWellnessLegacy(props) {
  var logo = props.activities.logo;
  return ProductWellnessLegacy_jsx("div", {
    className: "pt-10 pb-8 sm:flex sm:items-start"
  }, ProductWellnessLegacy_jsx(Title["a" /* Title */], {
    className: "sm:w-1/5 mb-5",
    hLevel: 3,
    theme: "title-sans-2"
  }, Object(src_i18n["f" /* t */])('productWellness.title')), ProductWellnessLegacy_jsx("div", {
    className: "sm:w-4/5 sm:px-5"
  }, ProductWellnessLegacy_jsx("div", {
    className: "sm:flex items-start pb-5"
  }, ProductWellnessLegacy_jsx("div", null, ProductWellnessLegacy_jsx(Text["a" /* Text */], {
    text: Object(lodash["get"])(props, 'activities.description', '')
  }), !!Object(lodash["get"])(props, 'activities.equipments', []).length && ProductWellnessLegacy_jsx(react["Fragment"], null, ProductWellnessLegacy_jsx(Title["a" /* Title */], {
    className: "mt-2",
    hLevel: 4,
    theme: "title-sans-3"
  }, Object(src_i18n["f" /* t */])('productWellness.equipements')), ProductWellnessLegacy_jsx("ul", {
    className: "reset-list mt-2 text-base sm:colum-count-2"
  }, props.activities && props.activities.equipments.map(function (_ref3) {
    var name = _ref3.name;
    return ProductWellnessLegacy_jsx("li", {
      "data-testid": "WellnessIntroductionItem",
      className: "list-disc",
      key: name
    }, name);
  })))), !!logo && ProductWellnessLegacy_jsx("div", {
    "data-testid": "ProductWellnessLogo"
  }, ProductWellnessLegacy_jsx(Image["a" /* default */], {
    className: "mt-5 sm:w-1/5",
    dontChangeAnything: true,
    imageUrl: logo
  }))), ProductWellnessLegacy_jsx(ResponsiveTabs["a" /* ResponsiveTabs */], {
    areAllCollapsable: true,
    items: getTabsItems(props.prestations),
    expandIconName: icons["a" /* ICONS */].PLUS
  }), ProductWellnessLegacy_jsx(Text["a" /* Text */], {
    text: Object(lodash["get"])(props, 'activities.footnotes', ''),
    theme: "text-sans-2"
  })));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-wellness-legacy/productWellnessLegacy.resolver.js
var productWellnessLegacy_resolver = __webpack_require__("+IAy");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-wellness-legacy/productWellnessLegacy.descriptor.js

var productWellnessLegacy_descriptor_jsx = react["createElement"];







var productWellnessLegacy_descriptor_ProductWellnessLegacyLine = function ProductWellnessLegacyLine(props) {
  var _props$spa = Object(slicedToArray["a" /* default */])(props.spa, 1),
      spa = _props$spa[0],
      _props$spaDetail = props.spaDetail,
      spaDetail = _props$spaDetail === void 0 ? [] : _props$spaDetail;

  Object(src_i18n["a" /* addTranslationKeys */])({
    productWellness: {
      title: props.title,
      onDemand: props.onDemand,
      included: props.included,
      equipements: props.spaEquipmentTitle,
      ages: {
        label: props.age,
        adultsOnly: props.adultsOnly,
        all: props.allAges
      },
      year: props.config.common.participants.year
    }
  });

  if (!spa) {
    return null;
  }

  var prestations = spaDetail.filter(function (prestation) {
    var _prestation$activitie;

    return (prestation === null || prestation === void 0 ? void 0 : (_prestation$activitie = prestation.activities) === null || _prestation$activitie === void 0 ? void 0 : _prestation$activitie.length) > 0;
  });

  var _spa$activities = Object(slicedToArray["a" /* default */])(spa.activities, 1),
      _spa$activities$ = _spa$activities[0],
      activities = _spa$activities$ === void 0 ? {} : _spa$activities$;

  return productWellnessLegacy_descriptor_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, productWellnessLegacy_descriptor_jsx(ProductWellnessLegacy, {
    activities: activities,
    prestations: prestations
  }));
};

var productWellnessLegacyDescriptor = {
  name: constants["ub" /* RESORT_WELLNESS */],
  component: productWellnessLegacy_descriptor_ProductWellnessLegacyLine,
  props: productWellnessLegacy_resolver["a" /* productWellnessLegacyResolver */].props,
  resolve: productWellnessLegacy_resolver["a" /* productWellnessLegacyResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/tour-information/TourInformation.jsx
var TourInformation_jsx = react_default.a.createElement;



function TourInformation(_ref) {
  var infos = _ref.infos;
  return TourInformation_jsx("div", {
    className: "flex flex-wrap -m-2"
  }, infos.map(function (_ref2) {
    var items = _ref2.items,
        text = _ref2.text,
        title = _ref2.title;
    return TourInformation_jsx("div", {
      className: "w-full sm:w-1/2 p-2",
      key: title
    }, TourInformation_jsx(Title["a" /* Title */], {
      className: "mb-3",
      theme: "title-sans-2"
    }, title), items && TourInformation_jsx("ul", {
      className: "reset-list leading-normal text-base text-gray-darker"
    }, items.map(function (item) {
      return TourInformation_jsx("li", {
        className: "list-disc py-1",
        key: item
      }, item);
    })), text && TourInformation_jsx(Text["a" /* Text */], {
      text: text
    }));
  }));
}
// CONCATENATED MODULE: ./src/client/components/lines/tour-introduction-line/TourIntroductionLine.jsx
var TourIntroductionLine_jsx = react_default.a.createElement;



var TourIntroductionLine_TourIntroductionLine = function TourIntroductionLine(_ref) {
  var highlightTitle = _ref.highlightTitle,
      resort = _ref.resort,
      roadmapTitle = _ref.roadmapTitle;
  var details = resort.details,
      strengths = resort.strengths;
  var infos = [];

  if (details && details.length) {
    infos.push({
      title: roadmapTitle,
      items: details
    });
  }

  if (strengths && strengths.length) {
    infos.push({
      title: highlightTitle,
      items: strengths
    });
  }

  if (!infos.length) {
    return null;
  }

  return TourIntroductionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, TourIntroductionLine_jsx(TourInformation, {
    infos: infos
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/tour-introduction/tourIntroduction.resolver.js
var tourIntroduction_resolver = __webpack_require__("klIi");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tour-introduction/tourIntroduction.descriptor.js



var tourIntroductionDescriptor = {
  name: constants["Gb" /* TOUR_INTRODUCTION */],
  component: TourIntroductionLine_TourIntroductionLine,
  resolve: tourIntroduction_resolver["a" /* tourIntroductionResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/tour-practical-information-line/TourPracticalInformationLine.jsx
var TourPracticalInformationLine_jsx = react_default.a.createElement;



var TourPracticalInformationLine_TourPracticalInformationLine = function TourPracticalInformationLine(props) {
  var _props$resort$practic = props.resort.practicalInformation,
      includedInPackage = _props$resort$practic.includedInPackage,
      excludedInPackage = _props$resort$practic.excludedInPackage,
      healthFormalities = _props$resort$practic.healthFormalities,
      passportAndVisas = _props$resort$practic.passportAndVisas,
      immigrationFormalities = props.immigrationFormalities,
      healthFormalitiesTitle = props.healthFormalities,
      includedInTour = props.includedInTour,
      notIncludedInTour = props.notIncludedInTour;
  var infos = [];

  if (includedInPackage && includedInPackage.length) {
    infos.push({
      title: includedInTour,
      items: includedInPackage
    });
  }

  if (excludedInPackage && excludedInPackage.length) {
    infos.push({
      title: notIncludedInTour,
      items: excludedInPackage
    });
  }

  if (passportAndVisas) {
    infos.push({
      title: immigrationFormalities,
      text: passportAndVisas
    });
  }

  if (healthFormalities) {
    infos.push({
      title: healthFormalitiesTitle,
      text: healthFormalities
    });
  }

  if (!infos.length) {
    return null;
  }

  return TourPracticalInformationLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, TourPracticalInformationLine_jsx(TourInformation, {
    infos: infos
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/tour-practical-information/tourPracticalInformation.resolver.js
var tourPracticalInformation_resolver = __webpack_require__("v7Z5");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tour-practical-information/tourPracticalInformation.descriptor.js



var tourPracticalInformationDescriptor = {
  name: constants["Hb" /* TOUR_PRACTICAL_INFORMATION */],
  component: TourPracticalInformationLine_TourPracticalInformationLine,
  resolve: tourPracticalInformation_resolver["a" /* tourPracticalInformationResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/tour-program-line/TourProgramLine.jsx

var TourProgramLine_jsx = react_default.a.createElement;



function TourProgramLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  var _props$stopover = props.stopover,
      stopover = _props$stopover === void 0 ? {} : _props$stopover;
  var _stopover$tour = stopover.tour,
      tour = _stopover$tour === void 0 ? {} : _stopover$tour,
      _stopover$extension = stopover.extension,
      extension = _stopover$extension === void 0 ? {} : _stopover$extension;
  return TourProgramLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, TourProgramLine_jsx(ProductProgram, {
    isDetailed: props.isDetailed,
    extension: {
      title: extension.title,
      subtitle: extension.duration,
      stops: extension.stops
    },
    program: {
      title: tour.title,
      subtitle: tour.duration,
      stops: tour.stops
    }
  }));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/tour-program/tourProgram.resolver.js
var tourProgram_resolver = __webpack_require__("pUua");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tour-program/tourProgram.descriptor.js



var tourProgramDescriptor = {
  name: constants["Ib" /* TOUR_PROGRAM */],
  component: TourProgramLine,
  resolve: tourProgram_resolver["a" /* tourProgramResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/descriptors.js
/* layout lines */

/* common lines */




































/* home lines : homepage recommended */



/* country lines : webedia countryId needed */





/* offer lines : offerId needed */




/* cruise lines : resortId/productId needed (only cruise ID) */


 // no ID needed but commonly on cruise page

/* product lines : resortId/productId needed */





























 // no ID but commonly on product page

 // no ID but commonly on product page

 // no ID but commonly on product page






/* tour lines : resortId/productId needed (only tour ID) */




var descriptors = [allInclusivePushDescriptor, brandPromiseDescriptor, checklistDescriptor, countryEventsDescriptor, countryInfosDescriptor, countryIntroductionDescriptor, countryPoiDescriptor, crisisAlertDescriptor, cruiseBookingDescriptor, cruiseProgramDescriptor, destinationsDescriptor, downloadLinksListDescriptor, editorialFoldingBlockDescriptor, eventFormDescriptor, buttonTicketDescriptor, highlightDescriptor, immersiveDescriptor, instagramDescriptor, lastSeenProductsDescriptor, mediaTextHorizontalDescriptor, mediaTextVerticalDescriptor, mediaThumbnailDescriptor, navigationTabDescriptor, navigationTabsDescriptor, offerDescriptionDescriptor, offerLegalInformationDescriptor, offerSEODescriptor, offersGridDescriptor, offersPushDescriptor, pageTrackingDescriptor, prebookingFormDescriptor, productAccessAndMapDescriptor, productAccommodationsDescriptor, productAccommodationsExclusiveCollectionDescriptor, productActivitiesDescriptor, productBarsDescriptor, productBookingBEDescriptor, productBreadcrumbDescriptor, productChildcaresDescriptor, productCommunityQuestionsDescriptor, productDestinationDescriptor, productExclusiveCollectionSpaceDescriptor, productFlashInfoDescriptor, productGoogleStreetViewDescriptor, productImageMapDescriptor, productImmersiveDescriptor, productInformationSummaryDescriptor, productInstagramDescriptor, productIntroductionDescriptor, productMeetingRoomInfoDescriptor, productMultimediaDescriptor, productMustTryExperiencesDescriptor, productPriceRemoteDescriptor, productPriceTicketDescriptor, productPriceTicketCustomDescriptor, productRecommendationsDescriptor, productRelatedProductsDescriptor, productRestaurantsDescriptor, productSEOTitleDescriptor, productServicesDescriptor, productsFiltersDescriptor, productsGridDescriptor, productQuotationFormDescriptor, productSignaturesDescriptor, productSpaceIntroductionDescriptor, productStrengthsDescriptor, productSummaryDescriptor, productTagsDescriptor, productTripadvisorDescriptor, productWellnessDescriptor, productWellnessLegacyDescriptor, sectionDescriptor, sectionsDescriptor, smartFaqDescriptor, submissionStatusDescriptor, tabDescriptor, tabsDescriptor, teaserCardsDescriptor, testABDescriptor, textDescriptor, thematicDescriptor, titleAndTextDescriptor, tourIntroductionDescriptor, tourPracticalInformationDescriptor, tourProgramDescriptor, tripadvisorTestimonyDescriptor, videoDescriptor];
var descriptorsLibrary = descriptors.reduce(function (acc, descriptor) {
  if (acc[descriptor.name]) {
    throw new Error("A descriptor named ".concat(descriptor.name, " is already set."));
  }

  acc[descriptor.name] = descriptor;
  return acc;
}, {});
// EXTERNAL MODULE: ./src/client/context/ErrorBoundary.jsx
var ErrorBoundary = __webpack_require__("oG87");

// CONCATENATED MODULE: ./src/client/components/frameworks/line/Line.jsx


var Line_jsx = react_default.a.createElement;



function Line(_ref) {
  var id = _ref.id,
      component = _ref.component,
      name = _ref.name,
      _ref$props = _ref.props,
      _ref$props$lines = _ref$props.lines,
      lines = _ref$props$lines === void 0 ? [] : _ref$props$lines,
      props = Object(objectWithoutProperties["a" /* default */])(_ref$props, ["lines"]);

  // A Line can have nested lines. The root Line, the one in `DynamicPage.jsx` doesn't match to a
  // component, the component is just used for the recursion
  var Component = // When coming from the standard lines process (formatLinesForLineComponent of DynamicPage)
  // there is not component wired to a line, we retrieve the corresponding component from its name
  // But some lines (editorialFoldingBlock for instance) directly render lines themselves, and
  // pass a component prop, which then takes priority
  component || descriptorsLibrary[name] && descriptorsLibrary[name].component || null;

  if (Component) {
    return Line_jsx(ErrorBoundary["a" /* ErrorBoundary */], {
      key: id
    }, Line_jsx(Component, Object(esm_extends["a" /* default */])({}, props, {
      lines: lines
    }), lines.map(Line)));
  }

  return lines.length > 0 ? Line_jsx(react["Fragment"], {
    key: id
  }, lines.map(Line)) : null;
}

/***/ }),

/***/ "yfdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductPriceModal_ProductPriceModal; });

// EXTERNAL MODULE: /home/circleci/project/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.utils.js

var ProductPriceModal_utils_getLabel = function getLabel(_ref) {
  var isJoyview = _ref.isJoyview,
      isTour = _ref.isTour;

  if (isTour) {
    return '';
  }

  return isJoyview ? Object(i18n["f" /* t */])('resort.startingPrice.roomOnly') : Object(i18n["f" /* t */])('resort.startingPrice.allInclusive');
};
// EXTERNAL MODULE: /home/circleci/project/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /home/circleci/project/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// CONCATENATED MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx


var __jsx = react_default.a.createElement;

var ClickOutside_ClickOutside = function ClickOutside(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$shard = _ref.shard,
      shard = _ref$shard === void 0 ? {} : _ref$shard,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "onClick", "shard"]);

  var ref = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var current = ref.current;
      var shardElement = shard.current;
      var clickedElement = e.target;

      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return __jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    className: className,
    ref: ref
  }), children);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.themes.js
var themes = {
  "default": {
    thContent: 'arrow-down arrow-large arrow-white bg-white filter-drop-shadow-after mb-5 rounded-tiny shadow-md'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx
var PopOver_jsx = react_default.a.createElement;







var PopOver_PopOver = function PopOver(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      _onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useState = Object(react["useState"])(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!react["Children"].count(children)) {
    return null;
  }

  var thContent = themes[theme].thContent;
  return PopOver_jsx("div", {
    className: classnames_default()(className, 'relative')
  }, PopOver_jsx("button", {
    className: "reset-button w-full",
    "data-testid": "PopOver-button",
    onClick: function onClick(e) {
      e.preventDefault();
      setIsVisible(!isVisible);
      !isVisible && _onClick && _onClick(e);
    },
    type: "button"
  }, children), isVisible && PopOver_jsx(react["Fragment"], null, isDesktop ? PopOver_jsx(ClickOutside_ClickOutside, {
    className: "absolute bottom-full fadeIn inset-x-0 -mb-1",
    onClick: function onClick() {
      return setIsVisible(false);
    }
  }, PopOver_jsx("div", {
    className: thContent
  }, content)) : PopOver_jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    closeLabel: Object(i18n["f" /* t */])('common.close'),
    onClose: function onClose(e) {
      e.preventDefault();
      setIsVisible(false);
    },
    size: "small"
  }, content)));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx
var ProductPriceModal_jsx = react_default.a.createElement;




var ProductPriceModal_ProductPriceModal = function ProductPriceModal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      city = _ref.city,
      endDate = _ref.endDate,
      _ref$hasTransport = _ref.hasTransport,
      hasTransport = _ref$hasTransport === void 0 ? false : _ref$hasTransport,
      _ref$isCruise = _ref.isCruise,
      isCruise = _ref$isCruise === void 0 ? false : _ref$isCruise,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$isTour = _ref.isTour,
      isTour = _ref$isTour === void 0 ? false : _ref$isTour,
      onClick = _ref.onClick,
      onClickButton = _ref.onClickButton,
      startDate = _ref.startDate,
      unit = _ref.unit;

  if (!react["Children"].count(children)) {
    return null;
  }

  return ProductPriceModal_jsx(PopOver_PopOver, {
    ariaLabel: ProductPriceModal_utils_getLabel({
      isJoyview: isJoyview,
      isTour: isTour
    }),
    className: className,
    content: ProductPriceModal_jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
      city: city,
      endDate: endDate,
      hasTransport: hasTransport,
      isCruise: isCruise,
      isJoyview: isJoyview,
      isTour: isTour,
      onClick: onClickButton,
      startDate: startDate,
      unit: unit
    }),
    onClick: onClick
  }, children);
};

/***/ }),

/***/ "z8xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PLANE; });
/* unused harmony export TRAIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getFindSectionTransportTypeFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getClassLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDiffAbsoluteDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getWayLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getMinBaggageWeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatConnectionLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return hasOnlyPlanes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return tripsHaveSchedules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return transformMinutesInHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getTransportIcon; });
/* unused harmony export hasCancellationPolicy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCancellationPolicyDescription; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("oL6k");







var BOAT = 'BOAT';
var PLANE = 'PLANE';
var TRAIN = 'TRAIN';
var TRANSPORT_CLASS_TO_I18N = {
  '1CL': 'firstClassLabel',
  '2Cl': 'secondClassLabel',
  BUS: 'businessClassLabel',
  DIV: 'economyClassLabel',
  DIB: 'emeraldClassLabel',
  'EC+': 'alizeeClassLabel',
  ECO: 'economyClassLabel',
  FIR: 'firstClassLabel',
  PRC: 'premiumClassLabel',
  PRE: 'premiumClassLabel'
};

function getDiffAbsoluteDays(fromDate, toDate) {
  var fromMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* momentFromApiDate */ "h"])(fromDate);
  var toMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* momentFromApiDate */ "h"])(toDate);

  if (fromMoment.isValid() && toMoment.isValid()) {
    return toMoment.diff(fromMoment, 'days');
  }

  return null;
}

function formatTime(time, format) {
  var renderedTime = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_5__[/* momentFromApiTime */ "i"])(time).format(format);
  return renderedTime !== 'Invalid date' ? renderedTime : null;
}

function getWayLabel(i18n, way) {
  if (way === 'INBOUND') return i18n.common.transport.inboundLabel;
  if (way === 'OUTBOUND') return i18n.common.transport.outboundLabel;
  return null;
}

function getMinBaggageWeight(sections) {
  if (Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(sections)) {
    return {};
  } // $FlowFixMe


  var minBaggageWeightForSection = sections.reduce(function (a, b) {
    if (!Object(lodash__WEBPACK_IMPORTED_MODULE_0__["has"])(a, 'transport.baggage.weight')) {
      return b;
    }

    if (!Object(lodash__WEBPACK_IMPORTED_MODULE_0__["has"])(b, 'transport.baggage.weight')) {
      return a;
    }

    var baggageWeightA = a.transport.baggage.weight ? Number(a.transport.baggage.weight.replace(/(\d+).*/, '$1')) : NaN;
    var baggageWeightB = b.transport.baggage.weight ? Number(b.transport.baggage.weight.replace(/(\d+).*/, '$1')) : NaN;

    if (!baggageWeightA || !baggageWeightB) {
      return null;
    }

    return baggageWeightA < baggageWeightB ? a : b;
  });
  return minBaggageWeightForSection ? minBaggageWeightForSection.transport.baggage : {};
}

function formatConnectionLabel(label, duration) {
  var durationAsNumber = duration ? +duration : 0;
  var durationFormated = moment__WEBPACK_IMPORTED_MODULE_1___default.a.utc(moment__WEBPACK_IMPORTED_MODULE_1___default.a.duration(durationAsNumber, 'minutes').asMilliseconds());
  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["messageFormat"])('{label} {duration}').format({
    label: label,
    duration: "".concat(durationFormated.format('HH'), "h").concat(durationFormated.format('mm'))
  });
}

function getStep(i18n) {
  var timeFormat = i18n.common.timeFormat;
  var transportConnectionLabel = i18n.common.transport.connection;
  return function (step) {
    var connectionDuration = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'connectionDurationInMin');
    var stopOverDuration = Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'stopDurationInMin');
    var information = !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(stopOverDuration) || !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(connectionDuration) ? formatConnectionLabel(transportConnectionLabel, stopOverDuration || connectionDuration) : null;
    return {
      id: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.reference'),
      type: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.type'),
      information: information,
      operator: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.label'),
      operatorId: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.id'),
      operatorLogo: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'transport.companyOperator.logo'),
      start: {
        label: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.airportLabel'),
        time: formatTime(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.time'), timeFormat),
        date: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'departure.date')
      },
      end: {
        label: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.airportLabel'),
        time: formatTime(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.time'), timeFormat),
        date: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'arrival.date')
      },
      technicalStops: Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(step, 'technicalStops')
    };
  };
}

function hasBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.every(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'transport.type') === BOAT;
  });
}

function hasTrain(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'transport.type') === TRAIN;
  });
}

function hasOnlyPlanes(inboundFlight, outboundFlight) {
  return !(hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) || hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections')) || hasBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) || hasBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections')));
}

function getTransportIcon(inboundFlight, outboundFlight) {
  var isTrain = hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) && hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));

  if (isTrain) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].TRAIN;
  }

  var isBoat = hasBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) && hasBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));

  if (isBoat) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].BOAT;
  }

  return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].TRANSPORT;
}

function tripHasSchedules(travelSections) {
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(travelSections) ? (travelSections || []).some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'arrival.time') || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(section, 'departure.time');
  }) : false;
}

function tripsHaveSchedules(inboundFlight, outboundFlight) {
  return tripHasSchedules(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(inboundFlight, 'travelSections')) || tripHasSchedules(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(outboundFlight, 'travelSections'));
}

function transformMinutesInHours(minutes) {
  var numberMinutes = Number(minutes); // TODO cms translate h & m

  return Math.floor(numberMinutes / 60) + ' h ' + (numberMinutes % 60).toString().padStart(2, '0') + ' min';
}

function hasCancellationPolicy(transport) {
  var _transport$inbound, _transport$inbound2, _transport$outbound; // in case of AlternativeTransport


  if ((_transport$inbound = transport.inbound) === null || _transport$inbound === void 0 ? void 0 : _transport$inbound.hasOwnProperty('transportInfo')) {
    var _transport$inbound$jo;

    return (// $FlowFixMe at this point it's an AlternativeTransport object
      Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "u"])(((_transport$inbound$jo = transport.inbound.journey) === null || _transport$inbound$jo === void 0 ? void 0 : _transport$inbound$jo.cancellationPolicyType) || '') || // $FlowFixMe at this point it's an AlternativeTransport object
      transport.outboundList.some(function (outbound) {
        var _outbound$journey;

        return (// $FlowFixMe at this point it's an AlternativeTransport object
          Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "u"])(((_outbound$journey = outbound.journey) === null || _outbound$journey === void 0 ? void 0 : _outbound$journey.cancellationPolicyType) || '')
        );
      })
    );
  } // in case of Transport


  return (// $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "u"])(((_transport$inbound2 = transport.inbound) === null || _transport$inbound2 === void 0 ? void 0 : _transport$inbound2.cancellationPolicyType) || '') || // $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_6__[/* isCharterFlight */ "u"])(((_transport$outbound = transport.outbound) === null || _transport$outbound === void 0 ? void 0 : _transport$outbound.cancellationPolicyType) || '')
  );
} // TODO: check business rule


var getCancellationPolicy = function getCancellationPolicy(transport) {
  var _transport$inbound3, _transport$inbound4, _transport$outbound2; // in case of AlternativeTransport


  if ((_transport$inbound3 = transport.inbound) === null || _transport$inbound3 === void 0 ? void 0 : _transport$inbound3.hasOwnProperty('transportInfo')) {
    var _transport$inbound$jo2;

    return (// $FlowFixMe at this point it's an AlternativeTransport object
      ((_transport$inbound$jo2 = transport.inbound.journey) === null || _transport$inbound$jo2 === void 0 ? void 0 : _transport$inbound$jo2.cancellationPolicyType) || // $FlowFixMe at this point it's an AlternativeTransport object
      transport.outboundList.find(function (outbound) {
        var _outbound$journey2;

        return !!((_outbound$journey2 = outbound.journey) === null || _outbound$journey2 === void 0 ? void 0 : _outbound$journey2.cancellationPolicyType);
      })
    );
  } // in case of Transport
  // $FlowFixMe at this point it's an Transport object


  return ((_transport$inbound4 = transport.inbound) === null || _transport$inbound4 === void 0 ? void 0 : _transport$inbound4.cancellationPolicyType) || ((_transport$outbound2 = transport.outbound) === null || _transport$outbound2 === void 0 ? void 0 : _transport$outbound2.cancellationPolicyType);
};

var getCancellationPolicyDescription = function getCancellationPolicyDescription(transport, i18n) {
  if (hasCancellationPolicy(transport)) {
    var _i18n$bookingProcess$;

    var cancellationPolicy = getCancellationPolicy(transport);
    return (_i18n$bookingProcess$ = i18n.bookingProcess.find(function (legalInformation) {
      return legalInformation.id === cancellationPolicy;
    })) === null || _i18n$bookingProcess$ === void 0 ? void 0 : _i18n$bookingProcess$.description;
  }
};

var getFindSectionTransportTypeFn = function getFindSectionTransportTypeFn(transportType) {
  return function (_ref) {
    var type = _ref.transport.type;
    return type === transportType;
  };
};
var getClassLabel = function getClassLabel(_ref2) {
  var transportType = _ref2.transportType,
      travelSections = _ref2.travelSections,
      inboundCriteria = _ref2.inboundCriteria;
  var transportClass = (inboundCriteria === null || inboundCriteria === void 0 ? void 0 : inboundCriteria.flightClass) || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(transportType ? travelSections.find(getFindSectionTransportTypeFn(transportType)) : travelSections[0], 'transport.class');

  if (!TRANSPORT_CLASS_TO_I18N[transportClass]) {
    return null;
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* t */ "f"])("common.transport.transportClass.".concat(TRANSPORT_CLASS_TO_I18N[transportClass]));
};


/***/ }),

/***/ "zCbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_PREFIX_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTrackingTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCityName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSummer; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wgY5");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("829J");



var WITH_TRANSPORT = 'with Transport';
var WITHOUT_TRANSPORT = 'without Transport';
var NO_DEPARTURE_CITY = 'NO';
var TRACKING_PREFIX_MAPPING = {
  ACTIVITIES: 'activities',
  CHILDCARE: 'childcare',
  WELLNESS: 'wellness'
};
function getTrackingTransport(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? WITH_TRANSPORT : WITHOUT_TRANSPORT;
}
function getDepartureCityCode(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityCode : WITHOUT_TRANSPORT;
}
function getDepartureCityName(departureCityCode, departureCityName) {
  return departureCityName && departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_0__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityName : '';
}
function isSummer(date) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["inRange"])(Number(moment__WEBPACK_IMPORTED_MODULE_1___default()(date).format('MMDD')), _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__[/* SUMMER_DATE_START */ "x"], _client_tracking_constants__WEBPACK_IMPORTED_MODULE_2__[/* SUMMER_DATE_END */ "w"]);
}

/***/ }),

/***/ "zjgX":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dZwK");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "zwLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPLECategoryGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPLEPaymentConfirmationSiteSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSearchMappedTypeForLabelGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSiteSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return noCase; });
/* unused harmony export pascalCase */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("829J");



var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["b2cPagesService"].PAGE_TYPES;
function getPLECategoryGA(isUserQuickLogged) {
  return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE_QUICK */ "n"] : _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE */ "l"];
}
function getPLEPaymentConfirmationSiteSection(_ref) {
  var isOption = _ref.isOption,
      isUserQuickLogged = _ref.isUserQuickLogged;

  if (isOption) {
    return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE_QUICK_OPTION */ "o"] : _constants__WEBPACK_IMPORTED_MODULE_2__[/* PLE_OPTION */ "m"];
  } else {
    return getPLECategoryGA(isUserQuickLogged);
  }
}
function getSearchMappedTypeForLabelGA(type) {
  return _constants__WEBPACK_IMPORTED_MODULE_2__[/* SEARCH_LABEL_GA_MAP */ "r"][type || 'none'];
}
function getSiteSection(_ref2) {
  var _ref2$isOption = _ref2.isOption,
      isOption = _ref2$isOption === void 0 ? false : _ref2$isOption,
      _ref2$isUserQuickLogg = _ref2.isUserQuickLogged,
      isUserQuickLogged = _ref2$isUserQuickLogg === void 0 ? false : _ref2$isUserQuickLogg,
      pageType = _ref2.pageType;

  switch (pageType) {
    case PAGE_TYPES.DESTINATION_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.DESTINATION));

    case PAGE_TYPES.HOME_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.HOME));

    case PAGE_TYPES.LANDING_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.LANDING));

    case PAGE_TYPES.RESORT_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.RESORT));

    case PAGE_TYPES.PREBOOKING:
      var siteSection = pageType.split('-')[0];
      return "Shopping_".concat(pascalCase(siteSection));

    case _constants__WEBPACK_IMPORTED_MODULE_2__[/* STATIC_PAGE_TYPES */ "v"].BE:
      return _constants__WEBPACK_IMPORTED_MODULE_2__[/* BE */ "a"];

    case _constants__WEBPACK_IMPORTED_MODULE_2__[/* STATIC_PAGE_TYPES */ "v"].PLE:
      return getPLECategoryGA(isUserQuickLogged);

    case _constants__WEBPACK_IMPORTED_MODULE_2__[/* STATIC_PAGE_TYPES */ "v"].PLE_PAYMENT_CONFIRMATION:
      return getPLEPaymentConfirmationSiteSection({
        isOption: isOption,
        isUserQuickLogged: isUserQuickLogged
      });

    default:
      return "Shopping_".concat(pascalCase(pageType));
  }
}
function noCase(string) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["flow"])(lodash__WEBPACK_IMPORTED_MODULE_0__["startCase"], lodash__WEBPACK_IMPORTED_MODULE_0__["toLower"])(string);
}
function pascalCase(string) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["flow"])(lodash__WEBPACK_IMPORTED_MODULE_0__["camelCase"], lodash__WEBPACK_IMPORTED_MODULE_0__["upperFirst"])(string);
}

/***/ })

},[["BFzD",1,2,3,5,0,4,6,7,8,9,10,12,11,13,14,17,15,16,19,18,20,22,21,24,23]]]);